var ColoroutineStudioBundle = (function(exports) {
  "use strict";var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

  var _DesignCanvas_instances, fitObject_fn, bind_fn, updateCenterGuides_fn, drawCenterGuides_fn, clearCenterGuides_fn, record_fn, restore_fn, emitChange_fn, emitSelection_fn, _Product3DPreview_instances, loadGLTFProduct_fn, selectDecalTarget_fn, addDecalOverlay_fn, addSmartSurfaceOverlay_fn, addFittedApparelOverlay_fn, cloneBaseMaterial_fn, addPrintOverlay_fn, printMaterial_fn, createProceduralProduct_fn, applyCamera_fn, positionGround_fn, apparel_fn, garmentBodyGeometry_fn, curvedPanel_fn, wrapPanel_fn, surfaceTexture_fn, lights_fn, ground_fn, clearProduct_fn, disposeObject_fn, _ProjectStore_instances, read_fn, write_fn, _StudioAPI_instances, request_fn, _StudioLocalizer_instances, translateTextNode_fn, translateElement_fn, _ColoroutineAIStudio_instances, render_fn, bind_fn2, onClick_fn, onChange_fn, onInput_fn, modeNav_fn, modeLabel_fn, creativeTitle_fn, creativeBody_fn, resultsHTML_fn, inspectorHTML_fn, layersHTML_fn, prominentEditToolsHTML_fn, textToolsHTML_fn, editToolsHTML_fn, shareModalHTML_fn, projectOptions_fn, workbenchHTML_fn, preflightChecks_fn, preflightHTML_fn, highTicketHTML_fn, updatePreflight_fn, setMode_fn, setProduct_fn, setColor_fn, setSize_fn, setFace_fn, setView_fn, refresh3D_fn, updateProductStage_fn, updatePrintArea_fn, refreshInspector_fn, renderLayers_fn, renderEditTools_fn, updateQuality_fn, generate_fn, loadInspirations_fn, setActiveObjectColor_fn, addTextFromInput_fn, applyTextPreset_fn, applyTextEffect_fn, setTextHexColor_fn, setActiveTextStyle_fn, quickGenerateStart_fn, quickUploadStart_fn, quickTextStart_fn, removeSelectedBackground_fn, useGenerated_fn, useInspiration_fn, addUploadedFile_fn, setReference_fn, sceneKey_fn, saveCurrentScene_fn, scheduleSave_fn, loadCurrentScene_fn, selectProject_fn, newProject_fn, addToCart_fn, setQuantity_fn, setZoom_fn, clearDesign_fn, download_fn, exportProofPackage_fn, requestProof_fn, buildProofPackage_fn, renderProofImage_fn, proofMetadata_fn, downloadJSON_fn, downloadDataUrl_fn, focusLayers_fn, focusPreflight_fn, toggleDebugMapping_fn, exportProject_fn, focusWorkflowTarget_fn, syncProductContext_fn, updateWorkflow_fn, friendlyError_fn, openShare_fn, closeShare_fn, updateShareFormat_fn, updateShareView_fn, syncShareViewControls_fn, renderShareImage_fn, update3DDesignSnapshot_fn, designSnapshotCanvas_fn, publishShare_fn, downloadShare_fn, copyShare_fn, nativeShare_fn, togglePanel_fn, toggleTheme_fn, setLocale_fn, checkService_fn, loadCatalog_fn, setBusy_fn, toast_fn;
  const styles = '@import url("https://fonts.googleapis.com/css2?family=Baloo+2:wght@700;800&family=Bungee&family=Fredoka:wght@600;700&family=Lilita+One&family=Lily+Script+One&family=Noto+Sans+SC:wght@500;700;800&family=Noto+Serif+SC:wght@600;700&family=Pacifico&family=ZCOOL+XiaoWei&display=swap");\n\n:host {\n  --bg: var(--studio-background, rgb(var(--color-background, 255,255,255)));\n  --panel: color-mix(in srgb,var(--bg) 96%,#fff);\n  --panel-2: color-mix(in srgb,var(--bg) 92%,#121212 8%);\n  --panel-3: color-mix(in srgb,var(--bg) 86%,#121212 14%);\n  --line: rgba(18,18,18,.10);\n  --line-strong: rgba(18,18,18,.20);\n  --text: var(--studio-text, rgb(var(--color-foreground, 18,18,18)));\n  --muted: rgba(18,18,18,.62);\n  --muted-2: rgba(18,18,18,.42);\n  --accent: var(--studio-accent, rgb(var(--color-button, 18,18,18)));\n  --accent-contrast: var(--studio-accent-contrast, rgb(var(--color-button-text, 255,255,255)));\n  --accent-2: color-mix(in srgb,var(--accent) 82%,#fff);\n  --accent-soft: color-mix(in srgb,var(--accent) 8%,transparent);\n  --canvas: #f3f0e9;\n  --success: #267451;\n  --warning: #a86a16;\n  --danger: #b42318;\n  --font-body: "Archivo", "Noto Sans SC", "PingFang SC", system-ui, sans-serif;\n  --font-display: "Newsreader", "Noto Serif SC", Georgia, serif;\n  display: block;\n  min-height: 760px;\n  color: var(--text);\n  font-family: var(--font-body);\n  font-size: 14px;\n  line-height: 1.45;\n  text-align: left;\n  background: transparent;\n}\n\n:host([theme="dark"]) {\n  --bg: #111111;\n  --panel: #171717;\n  --panel-2: #202020;\n  --panel-3: #2b2b2b;\n  --line: rgba(255,255,255,.10);\n  --line-strong: rgba(255,255,255,.19);\n  --text: #f7f6f2;\n  --muted: rgba(255,255,255,.62);\n  --muted-2: rgba(255,255,255,.42);\n  --accent: #f7f6f2;\n  --accent-contrast: #121212;\n  --accent-soft: rgba(255,255,255,.08);\n  --canvas: #ded9cf;\n  --success: #72c6a1;\n  --warning: #f0ba69;\n  --danger: #ff7373;\n}\n\n* { box-sizing: border-box; }\nbutton, input, textarea, select { font: inherit; color: inherit; }\nbutton { border: 0; }\n.icon { display: inline-block; flex: 0 0 auto; }\n.studio { min-height:100vh; background:var(--bg); color:var(--text); overflow:hidden; }\n:host([embedded]) { min-height:var(--studio-min-height,760px); }\n:host([embedded]) .studio { min-height:var(--studio-min-height,760px); max-width:var(--studio-max-width,1600px); margin:0 auto; border:1px solid var(--line); border-radius:var(--studio-radius,12px); }\n:host([embedded]) .topbar { top:var(--studio-sticky-offset,0px); }\n:host([embedded]) .sidebar,:host([embedded]) .inspector { top:calc(var(--studio-sticky-offset,0px) + 74px); height:calc(100dvh - var(--studio-sticky-offset,0px) - 74px); }\n:host([embedded]) .theme-toggle { display:none; }\n\n.topbar {\n  height: 74px; display: grid; grid-template-columns: 336px minmax(260px,1fr) auto;\n  align-items:center; border-bottom:1px solid var(--line); background:color-mix(in srgb,var(--panel) 94%,transparent);\n  position:sticky; top:0; z-index:30; backdrop-filter:blur(18px); box-shadow:0 1px 0 rgba(255,255,255,.45) inset;\n}\n.brand { height: 100%; display: flex; align-items: center; gap: 12px; padding: 0 22px; border-right: 1px solid var(--line); }\n.brand-mark { width:38px; height:38px; border-radius:6px; color:var(--accent-contrast); display:grid; place-items:center; background:var(--accent); box-shadow:0 7px 18px rgba(18,18,18,.16); }\n.brand-title { font-weight: 700; font-size: 15px; letter-spacing: -.01em; }\n.brand-subtitle { color: var(--muted); font-size: 10px; letter-spacing: .18em; margin-top: 2px; }\n.project-title { min-width: 0; padding: 0 24px; }\n.project-title small { display: block; color: var(--accent); text-transform: uppercase; letter-spacing:.17em; font-size:9px; font-weight:700; }\n.project-name-row { display:flex; gap:8px; align-items:center; margin-top:5px; }\n.project-name { font-size: 17px; font-weight: 650; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; }\n.save-state { display:flex; align-items:center; gap:5px; color:var(--muted); font-size:11px; }\n.save-state::before { content:""; width:6px; height:6px; border-radius:50%; background:var(--success); }\n.metrics { display:flex; align-items:stretch; height:100%; }\n.metric { min-width:120px; padding:16px 19px; border-left:1px solid var(--line); display:flex; flex-direction:column; justify-content:center; }\n.metric-label { color:var(--muted); font-size:10px; white-space:nowrap; }\n.metric-value { font-size:16px; font-weight:700; margin-top:3px; }\n.metric-value.accent { color:var(--text); }\n.top-actions { display:flex; gap:7px; padding:0 16px; }\n.locale-control { height:34px; display:flex; align-items:center; gap:6px; padding:0 5px 0 9px; border:1px solid var(--line); border-radius:8px; background:var(--panel-2); color:var(--muted); }\n.locale-control > span { font-size:9px; font-weight:700; letter-spacing:.04em; text-transform:uppercase; }\n.locale-control select { min-width:48px; height:26px; padding:0 20px 0 7px; border:0; outline:0; border-radius:6px; color:var(--text); background:var(--panel); font:inherit; font-size:10px; font-weight:700; cursor:pointer; }\n\n.layout { display:grid; grid-template-columns:240px minmax(560px,1fr) 330px; min-height:calc(100vh - 74px); }\n.sidebar, .inspector { background:var(--panel); position:sticky; top:74px; height:calc(100vh - 74px); overflow:auto; scrollbar-width:thin; scrollbar-color:var(--line-strong) transparent; }\n.sidebar { border-right:1px solid var(--line); display:flex; flex-direction:column; }\n.inspector { border-left:1px solid var(--line); padding:18px; }\n.project-box { padding:18px 16px 16px; border-bottom:1px solid var(--line); }\n.section-eyebrow { display:flex; align-items:center; justify-content:space-between; color:var(--muted); font-size:10px; font-weight:700; letter-spacing:.11em; text-transform:uppercase; margin-bottom:9px; }\n.project-select { width:100%; border:1px solid var(--line-strong); background:var(--bg); border-radius:8px; padding:10px 34px 10px 12px; appearance:none; background-image:linear-gradient(45deg,transparent 50%,var(--muted) 50%),linear-gradient(135deg,var(--muted) 50%,transparent 50%); background-position:calc(100% - 16px) 50%,calc(100% - 11px) 50%; background-size:5px 5px; background-repeat:no-repeat; }\n.connection { padding:16px; border-bottom:1px solid var(--line); display:flex; gap:9px; align-items:center; }\n.status-dot { width:8px; height:8px; border-radius:50%; background:var(--warning); box-shadow:0 0 0 5px color-mix(in srgb,var(--warning) 12%,transparent); }\n.status-dot.online { background:var(--success); box-shadow:0 0 0 5px color-mix(in srgb,var(--success) 12%,transparent); }\n.connection strong { display:block; font-size:12px; }\n.connection span { color:var(--muted); font-size:10px; }\n.nav-label { padding:18px 17px 8px; color:var(--muted-2); font-size:9px; font-weight:700; letter-spacing:.17em; text-transform:uppercase; }\n.nav { padding:0 9px; display:grid; gap:4px; }\n.nav-item { width:100%; min-height:54px; display:grid; grid-template-columns:30px 1fr; align-items:center; text-align:left; padding:8px 11px; border-radius:9px; background:transparent; color:var(--muted); cursor:pointer; transition:.18s ease; border:1px solid transparent; }\n.nav-item:hover { color:var(--text); background:var(--panel-2); }\n.nav-item.active { color:var(--text); background:var(--accent-soft); border-color:color-mix(in srgb,var(--accent) 35%,transparent); }\n.nav-item.active .nav-index { color:var(--accent); }\n.nav-index { font-size:10px; color:var(--muted-2); }\n.nav-copy strong { display:block; font-size:12px; font-weight:600; }\n.nav-copy small { display:block; color:var(--muted); font-size:9px; margin-top:1px; }\n.nav-secondary { margin-top:auto; padding-bottom:12px; }\n.nav-secondary .nav-item { position:relative; }\n.sidebar-foot { padding:14px 16px; color:var(--muted-2); font-size:10px; border-top:1px solid var(--line); display:flex; align-items:center; gap:7px; }\n\n.main { min-width:0; padding:28px clamp(22px,3vw,48px) 56px; overflow:hidden; }\n.main-head { display:flex; align-items:end; justify-content:space-between; gap:20px; margin-bottom:18px; }\n.kicker { color:var(--accent); font-size:10px; font-weight:700; letter-spacing:.18em; text-transform:uppercase; }\nh1 { font-family:var(--font-display); font-size:clamp(34px,3vw,48px); font-weight:400; letter-spacing:-.035em; line-height:1.02; margin:7px 0 0; }\n.main-head p { margin:6px 0 0; color:var(--muted); font-size:12px; }\n.main-head-actions { display:flex; align-items:center; justify-content:flex-end; gap:8px; flex-wrap:wrap; }\n.product-chip { min-height:44px; padding:6px 11px; display:flex; align-items:center; gap:9px; text-align:left; color:var(--text); background:var(--panel); border:1px solid var(--line-strong); border-radius:10px; cursor:pointer; }\n.product-chip span { display:grid; line-height:1.15; }\n.product-chip strong { font-size:11px; font-weight:650; }\n.product-chip small { margin-top:3px; color:var(--muted); font-size:8px; white-space:nowrap; }\n.mode-badge { padding:6px 10px; background:var(--accent-soft); color:var(--text); border:1px solid var(--line); border-radius:999px; font-size:10px; white-space:nowrap; }\n\n.workflow { display:grid; grid-template-columns:repeat(4,minmax(0,1fr)); gap:8px; margin-bottom:16px; position:relative; }\n.workflow > i { display:none; }\n.workflow-step { min-height:64px; padding:10px 12px; display:grid; grid-template-columns:27px 1fr; gap:9px; align-items:center; text-align:left; color:var(--muted); background:var(--panel); border:1px solid var(--line); border-radius:10px; cursor:pointer; transition:.18s ease; }\n.workflow-step > span { width:25px; height:25px; display:grid; place-items:center; border:1px solid var(--line-strong); border-radius:50%; font-size:9px; font-weight:700; }\n.workflow-step strong,.workflow-step small { display:block; }\n.workflow-step strong { color:var(--text); font-size:10px; font-weight:650; }\n.workflow-step small { margin-top:2px; color:var(--muted); font-size:8px; line-height:1.25; }\n.workflow-step:hover,.workflow-step.active { border-color:var(--accent); box-shadow:inset 0 0 0 1px var(--accent); }\n.workflow-step.active { background:var(--accent-soft); }\n.workflow-step.done > span { color:var(--accent-contrast); background:var(--accent); border-color:var(--accent); }\n\n.workbench-shell {\n  margin-bottom: 14px;\n  padding: 12px;\n  border: 1px solid color-mix(in srgb,var(--accent) 24%,var(--line));\n  border-radius: 14px;\n  background:\n    radial-gradient(circle at 0 0, color-mix(in srgb,var(--accent) 10%,transparent), transparent 36%),\n    linear-gradient(135deg, var(--panel), color-mix(in srgb,var(--panel-2) 84%,var(--accent-soft)));\n  box-shadow: 0 14px 34px rgba(18,18,18,.06);\n}\n.workbench-title {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 10px;\n  color: var(--muted);\n  font-size: 10px;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n}\n.workbench-title strong {\n  color: var(--text);\n  font-weight: 650;\n  letter-spacing: 0;\n  text-transform: none;\n}\n.workbench-steps {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n.workbench-step {\n  min-height: 74px;\n  display: grid;\n  grid-template-columns: 30px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: 9px;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  background: color-mix(in srgb,var(--bg) 76%,transparent);\n  color: var(--muted);\n  text-align: left;\n  cursor: pointer;\n  transition: .18s ease;\n}\n.workbench-step:hover {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb,var(--accent) 42%,var(--line));\n}\n.workbench-step > span {\n  grid-row: 1 / span 2;\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 1px solid var(--line-strong);\n  font-size: 10px;\n  font-weight: 750;\n}\n.workbench-step strong {\n  color: var(--text);\n  font-size: 12px;\n  line-height: 1.1;\n}\n.workbench-step small {\n  margin-top: 4px;\n  color: var(--muted);\n  font-size: 9px;\n  line-height: 1.25;\n}\n.workbench-step.done {\n  border-color: color-mix(in srgb,var(--success) 46%,var(--line));\n  background: color-mix(in srgb,var(--success) 8%,var(--bg));\n}\n.workbench-step.done > span {\n  color: var(--accent-contrast);\n  border-color: var(--success);\n  background: var(--success);\n}\n\n.quick-start { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:8px; margin-bottom:14px; transition:.18s ease; }\n.quick-start.hidden { display:none; }\n.quick-card { min-height:70px; padding:11px 12px; display:grid; grid-template-columns:30px 1fr; gap:10px; align-items:center; border:1px solid var(--line); border-radius:12px; color:var(--text); background:linear-gradient(135deg,var(--panel),color-mix(in srgb,var(--panel) 72%,var(--bg))); text-align:left; cursor:pointer; box-shadow:0 10px 24px rgba(18,18,18,.04); transition:.18s ease; }\n.quick-card:hover { transform:translateY(-2px); border-color:color-mix(in srgb,var(--accent) 44%,transparent); box-shadow:0 14px 34px rgba(18,18,18,.09); }\n.quick-card svg { width:30px; height:30px; padding:7px; border-radius:10px; color:var(--accent-contrast); background:var(--accent); }\n.quick-card strong { display:block; font-size:12px; line-height:1.18; }\n.quick-card strong,\n.workbench-step strong,\n.nav-copy strong {\n  min-width: 0;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n}\n.quick-card small { display:block; margin-top:4px; color:var(--muted); font-size:9px; line-height:1.35; }\n.quick-card-ai { background:radial-gradient(circle at 12% 8%,rgba(255,255,255,.95),transparent 34%),linear-gradient(135deg,color-mix(in srgb,#fff2d8 70%,var(--panel)),var(--panel)); border-color:color-mix(in srgb,#c84f3d 34%,var(--line)); }\n\n.creative-panel { background:var(--panel); border:1px solid var(--line); border-radius:12px; overflow:hidden; margin-bottom:16px; box-shadow:0 10px 32px rgba(18,18,18,.05); }\n.creative-title { height:48px; padding:0 16px; display:flex; align-items:center; justify-content:space-between; border-bottom:1px solid var(--line); }\n.creative-title strong { display:flex; align-items:center; gap:8px; font-size:12px; }\n.creative-body { padding:14px 16px 16px; }\n.prompt-row { display:grid; grid-template-columns:1fr auto; gap:10px; align-items:end; }\n.prompt-wrap { border:1px solid var(--line-strong); background:var(--bg); border-radius:9px; overflow:hidden; transition:.18s; }\n.prompt-wrap:focus-within { border-color:color-mix(in srgb,var(--accent) 65%,transparent); box-shadow:0 0 0 3px var(--accent-soft); }\ntextarea { width:100%; min-height:86px; max-height:180px; resize:vertical; border:0; outline:0; padding:12px 13px 4px; background:transparent; font-size:13px; }\n.prompt-meta { display:flex; justify-content:space-between; align-items:center; padding:4px 10px 9px; color:var(--muted-2); font-size:9px; }\n.background-toggle { margin-top:9px; min-height:42px; display:flex; align-items:center; gap:10px; padding:8px 10px; border:1px solid var(--line); border-radius:9px; background:var(--panel-2); cursor:pointer; }\n.background-toggle input { width:16px; height:16px; accent-color:var(--accent); }\n.background-toggle span { display:block; min-width:0; }\n.background-toggle strong { display:block; color:var(--text); font-size:10px; line-height:1.25; }\n.background-toggle small { display:block; margin-top:2px; color:var(--muted); font-size:9px; line-height:1.25; }\n.background-toggle:has(input:checked) { border-color:color-mix(in srgb,var(--accent) 48%,transparent); background:var(--accent-soft); }\n.quick-styles { display:flex; flex-wrap:wrap; gap:6px; margin-top:10px; }\n.style-chip { border:1px solid var(--line); background:var(--panel-2); color:var(--muted); padding:5px 9px; border-radius:999px; font-size:10px; cursor:pointer; }\n.style-chip:hover,.style-chip.active { color:var(--text); border-color:color-mix(in srgb,var(--accent) 45%,transparent); background:var(--accent-soft); }\n.upload-zone { min-height:112px; border:1px dashed var(--line-strong); border-radius:10px; background:var(--bg); display:grid; place-items:center; text-align:center; padding:16px; cursor:pointer; transition:.18s; }\n.upload-zone:hover,.upload-zone.dragging { border-color:var(--accent); background:var(--accent-soft); }\n.upload-zone strong { display:block; margin-top:7px; font-size:12px; }\n.upload-zone span { color:var(--muted); font-size:10px; }\n.reference-grid { display:grid; grid-template-columns:150px 1fr; gap:14px; }\n.reference-thumb { width:100%; aspect-ratio:1; object-fit:contain; border-radius:8px; background:var(--bg); }\n.inspiration-grid,.results-grid { display:grid; grid-template-columns:repeat(4,minmax(90px,1fr)); gap:9px; }\n.inspiration-card,.result-card { position:relative; aspect-ratio:1; border:1px solid var(--line); background:var(--bg); border-radius:9px; padding:0; overflow:hidden; cursor:pointer; }\n.inspiration-card img,.result-card img { width:100%; height:100%; object-fit:contain; display:block; transition:.25s; }\n.inspiration-card:hover img,.result-card:hover img { transform:scale(1.035); }\n.result-card span { position:absolute; left:7px; bottom:7px; background:rgba(10,11,14,.75); color:white; padding:3px 6px; border-radius:4px; font-size:9px; backdrop-filter:blur(8px); }\n.inspiration-card-rich { aspect-ratio:auto; min-height:172px; display:grid; grid-template-rows:minmax(112px,1fr) auto; text-align:left; }\n.inspiration-card-rich img { height:128px; padding:8px; }\n.inspiration-copy { display:block; padding:9px 10px 10px; border-top:1px solid var(--line); background:color-mix(in srgb,var(--panel) 92%,transparent); }\n.inspiration-copy strong { display:block; color:var(--text); font-size:11px; line-height:1.2; }\n.inspiration-copy small { display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; margin-top:4px; color:var(--muted); font-size:9px; line-height:1.35; }\n.creative-empty { color:var(--muted); font-size:11px; }\n.brand-type-sample { margin-bottom:10px; padding:14px 15px; border:1px solid color-mix(in srgb,#c84f3d 42%,var(--line)); border-radius:14px; background:radial-gradient(circle at 15% 12%,rgba(255,255,255,.92),transparent 34%),linear-gradient(135deg,#fff2d8,color-mix(in srgb,var(--panel) 68%,#f6d56f 16%)); box-shadow:inset 0 -12px 26px rgba(184,74,58,.10),0 12px 28px rgba(184,74,58,.08); }\n.brand-type-sample span { display:block; color:#c84f3d; font-family:"Lily Script One","Pacifico","Baloo 2","Noto Sans SC",cursive; font-size:clamp(34px,4.8vw,52px); font-weight:400; line-height:.86; letter-spacing:.01em; -webkit-text-stroke:1.8px #fff8ec; text-shadow:4px 4px 0 rgba(48,70,60,.16),-3px 6px 0 rgba(184,74,58,.18),0 10px 18px rgba(18,18,18,.10); transform:rotate(-2deg); transform-origin:left center; }\n.brand-type-sample small { display:block; margin-top:7px; color:rgba(18,18,18,.62); font-size:10px; letter-spacing:.08em; }\n.editor-add-row { display:flex; gap:8px; flex-wrap:wrap; }\n.text-field { border:1px solid var(--line-strong); background:var(--bg); border-radius:8px; padding:10px 11px; outline:0; min-width:220px; }\n.text-add-row .text-field { flex:1 1 240px; }\n\n.stage-card { background:var(--panel); border:1px solid var(--line); border-radius:12px; overflow:hidden; box-shadow:0 10px 32px rgba(18,18,18,.04); }\n.toolbar { min-height:52px; padding:8px 12px; display:flex; align-items:center; justify-content:space-between; gap:12px; border-bottom:1px solid var(--line); }\n.toolbar-group { display:flex; gap:4px; align-items:center; }\n.toolbar-divider { height:24px; width:1px; background:var(--line); margin:0 4px; }\n.tool-button { width:34px; height:34px; display:grid; place-items:center; border-radius:7px; background:transparent; color:var(--muted); cursor:pointer; }\n.tool-button:hover { background:var(--panel-3); color:var(--text); }\n.tool-button:disabled { opacity:.28; cursor:not-allowed; }\n.segmented { display:flex; background:var(--bg); border:1px solid var(--line); border-radius:8px; padding:3px; }\n.segmented button { height:28px; min-width:50px; border-radius:6px; background:transparent; color:var(--muted); cursor:pointer; font-size:10px; display:flex; align-items:center; justify-content:center; gap:5px; }\n.segmented button.active { color:var(--text); background:var(--panel-3); box-shadow:0 3px 9px rgba(0,0,0,.14); }\n.stage { min-height:520px; height:min(62vw,680px); max-height:720px; position:relative; display:grid; place-items:center; background-color:var(--canvas); background-image:radial-gradient(rgba(18,18,18,.10) .7px,transparent .7px); background-size:15px 15px; overflow:hidden; }\n.product-stage { position:relative; height:90%; aspect-ratio:360/540; display:grid; place-items:center; transition:.2s; }\n.product-art { position:absolute; inset:0; width:100%; height:100%; }\n.product-art svg,.product-art img { width:100%; height:100%; display:block; object-fit:contain; }\n.print-area { position:absolute; left:var(--pa-l); top:var(--pa-t); width:var(--pa-w); height:var(--pa-h); outline:1px dashed rgba(66,57,50,.38); box-shadow:0 0 0 1px rgba(255,255,255,.15) inset; }\n.print-area::before { content:"PRINT AREA"; position:absolute; left:50%; top:-17px; transform:translateX(-50%); color:rgba(50,43,38,.55); font-size:7px; letter-spacing:.16em; white-space:nowrap; }\n.product-stage.debug-mapping .print-area {\n  outline: 2px solid #ff7a7a;\n  box-shadow: 0 0 0 999px rgba(255,122,122,.09), 0 0 0 1px rgba(255,255,255,.72) inset;\n}\n.product-stage.debug-mapping .print-area::after {\n  content: "";\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(90deg, transparent calc(50% - .5px), rgba(255,122,122,.65) 50%, transparent calc(50% + .5px)),\n    linear-gradient(0deg, transparent calc(50% - .5px), rgba(255,122,122,.65) 50%, transparent calc(50% + .5px)),\n    repeating-linear-gradient(90deg, rgba(255,122,122,.14) 0 1px, transparent 1px 12.5%),\n    repeating-linear-gradient(0deg, rgba(255,122,122,.14) 0 1px, transparent 1px 12.5%);\n  pointer-events: none;\n}\n.print-area .canvas-container { width:100%!important; height:100%!important; }\n.print-area canvas { width:100%!important; height:100%!important; }\n.three-stage { position:absolute; inset:0; display:none; }\n.three-stage.active { display:block; }\n.three-stage canvas { display:block; width:100%!important; height:100%!important; }\n.stage-helper { position:absolute; z-index:3; left:14px; bottom:14px; max-width:270px; padding:10px 12px; display:grid; grid-template-columns:20px 1fr; gap:8px; color:#24221f; background:rgba(255,255,255,.80); border:1px solid rgba(18,18,18,.12); border-radius:10px; box-shadow:0 8px 28px rgba(18,18,18,.10); backdrop-filter:blur(10px); pointer-events:none; transition:.18s ease; }\n.stage-helper.hidden { opacity:0; transform:translateY(5px); }\n.stage-helper strong,.stage-helper span { display:block; }\n.stage-helper strong { font-size:10px; }\n.stage-helper span { margin-top:2px; font-size:8px; color:rgba(18,18,18,.58); }\n.three-stage.model-loading::after { content:"正在加载 3D 模型…"; position:absolute; inset:0; display:grid; place-items:center; color:#5f5852; font-size:11px; background:rgba(242,238,231,.72); backdrop-filter:blur(4px); z-index:4; }\n.empty-stage-actions { position:absolute; z-index:4; left:50%; bottom:18px; transform:translateX(-50%); display:flex; gap:7px; padding:6px; border:1px solid rgba(18,18,18,.10); border-radius:999px; background:rgba(255,255,255,.82); backdrop-filter:blur(14px); box-shadow:0 12px 34px rgba(18,18,18,.12); transition:.18s ease; }\n.empty-stage-actions.hidden { opacity:0; pointer-events:none; transform:translate(-50%,5px); }\n.empty-stage-actions button { min-height:30px; padding:0 10px; display:flex; align-items:center; gap:5px; border-radius:999px; color:#24221f; background:rgba(255,255,255,.74); border:1px solid rgba(18,18,18,.09); font-size:10px; cursor:pointer; white-space:nowrap; }\n.empty-stage-actions button:hover { color:var(--accent-contrast); background:var(--accent); }\n.beta-tag { position:absolute; top:14px; left:14px; z-index:2; color:#554f49; background:rgba(255,255,255,.6); backdrop-filter:blur(8px); border:1px solid rgba(60,50,45,.1); border-radius:99px; padding:5px 8px; font-size:9px; }\n.zoom-controls { position:absolute; z-index:3; right:13px; bottom:13px; display:flex; align-items:center; border:1px solid rgba(50,43,38,.14); background:rgba(255,255,255,.72); backdrop-filter:blur(10px); border-radius:8px; color:#4f4945; overflow:hidden; }\n.zoom-controls button { width:31px; height:30px; color:inherit; background:transparent; cursor:pointer; }\n.zoom-controls span { min-width:43px; text-align:center; font-size:9px; }\n.stage-foot { min-height:48px; padding:8px 13px; display:flex; align-items:center; justify-content:space-between; color:var(--muted); font-size:10px; border-top:1px solid var(--line); }\n.stage-status { display:flex; align-items:center; gap:12px; min-width:0; }\n.mapping-pill { display:flex; align-items:center; gap:6px; color:var(--success); white-space:nowrap; }\n.mapping-pill::before { content:""; width:7px; height:7px; border-radius:50%; background:var(--success); box-shadow:0 0 0 3px color-mix(in srgb,var(--success) 12%,transparent); }\n.mapping-pill.mapping-error { color:var(--danger); }\n.mapping-pill.mapping-error::before { background:var(--danger); box-shadow:none; }\n.quality-pill { display:flex; align-items:center; gap:6px; }\n.quality-pill::before { content:""; width:7px; height:7px; border-radius:50%; background:var(--muted); }\n.quality-pill.great::before { background:var(--success); }\n.quality-pill.ok::before { background:var(--warning); }\n.quality-pill.low::before { background:var(--danger); }\n\n.inspector-card { border:1px solid var(--line); background:var(--panel-2); border-radius:11px; margin-bottom:12px; overflow:hidden; }\n.inspector-title { display:flex; align-items:center; justify-content:space-between; padding:13px 14px; border-bottom:1px solid var(--line); }\n.inspector-title strong { display:flex; align-items:center; gap:7px; font-size:12px; }\n.inspector-body { padding:13px 14px; }\n.field { margin-bottom:14px; }\n.field:last-child { margin-bottom:0; }\n.field-label { display:flex; align-items:center; justify-content:space-between; color:var(--muted); font-size:10px; margin-bottom:7px; }\n.field-label strong { color:var(--text); font-weight:500; }\n.select { width:100%; border:1px solid var(--line-strong); background:var(--bg); border-radius:8px; padding:9px 32px 9px 10px; appearance:none; outline:0; background-image:linear-gradient(45deg,transparent 50%,var(--muted) 50%),linear-gradient(135deg,var(--muted) 50%,transparent 50%); background-position:calc(100% - 15px) 50%,calc(100% - 10px) 50%; background-size:5px 5px; background-repeat:no-repeat; font-size:11px; }\n.swatches { display:flex; flex-wrap:wrap; gap:7px; }\n.swatch { width:28px; height:28px; padding:0; border-radius:50%; background:var(--swatch); border:2px solid var(--panel-2); outline:1px solid var(--line-strong); cursor:pointer; position:relative; }\n.swatch.active { outline:2px solid var(--accent); outline-offset:2px; }\n.options { display:flex; flex-wrap:wrap; gap:6px; }\n.option { min-width:39px; height:30px; padding:0 9px; border:1px solid var(--line); color:var(--muted); background:var(--bg); border-radius:7px; font-size:10px; cursor:pointer; }\n.option:hover,.option.active { border-color:var(--accent); color:var(--text); background:var(--accent-soft); }\n.stepper { display:grid; grid-template-columns:32px 1fr 32px; border:1px solid var(--line-strong); border-radius:8px; overflow:hidden; }\n.stepper button { background:var(--bg); color:var(--muted); cursor:pointer; }\n.stepper output { text-align:center; padding:7px; background:var(--bg); border-left:1px solid var(--line); border-right:1px solid var(--line); font-size:11px; }\n.quality-panel { display:grid; grid-template-columns:48px 1fr; gap:10px; align-items:center; }\n.quality-score { width:46px; height:46px; display:grid; place-items:center; border-radius:50%; border:3px solid var(--muted-2); font-size:10px; font-weight:700; }\n.quality-score.great { border-color:var(--success); color:var(--success); }\n.quality-score.ok { border-color:var(--warning); color:var(--warning); }\n.quality-score.low { border-color:var(--danger); color:var(--danger); }\n.quality-copy strong { display:block; font-size:11px; }\n.quality-copy span { color:var(--muted); font-size:9px; }\n.preflight-card {\n  border-color: color-mix(in srgb,var(--success) 30%,var(--line));\n  background: linear-gradient(180deg, color-mix(in srgb,var(--success) 6%,var(--panel-2)), var(--panel-2));\n}\n.preflight-status {\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 9px;\n  border: 1px solid var(--line);\n  color: var(--muted);\n}\n.preflight-status.ready { color: var(--success); border-color: color-mix(in srgb,var(--success) 45%,var(--line)); }\n.preflight-status.review { color: var(--warning); border-color: color-mix(in srgb,var(--warning) 42%,var(--line)); }\n.preflight-status.blocked { color: var(--danger); border-color: color-mix(in srgb,var(--danger) 42%,var(--line)); }\n.preflight-summary {\n  padding: 11px;\n  border: 1px solid var(--line);\n  border-radius: 11px;\n  background: var(--bg);\n}\n.preflight-summary b,\n.preflight-summary span {\n  display: block;\n}\n.preflight-summary b {\n  font-size: 12px;\n}\n.preflight-summary span {\n  margin-top: 4px;\n  color: var(--muted);\n  font-size: 9px;\n  line-height: 1.35;\n}\n.preflight-list {\n  display: grid;\n  gap: 7px;\n  margin-top: 10px;\n}\n.preflight-item {\n  display: grid;\n  grid-template-columns: 22px 1fr;\n  gap: 8px;\n  align-items: center;\n  padding: 8px;\n  border: 1px solid var(--line);\n  border-radius: 9px;\n  background: color-mix(in srgb,var(--bg) 72%,transparent);\n}\n.preflight-item i {\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  color: var(--muted);\n  background: var(--panel);\n}\n.preflight-item.ok i { color: var(--accent-contrast); background: var(--success); }\n.preflight-item.warn i { color: var(--accent-contrast); background: var(--warning); }\n.preflight-item.bad i { color: var(--accent-contrast); background: var(--danger); }\n.preflight-item strong,\n.preflight-item small {\n  display: block;\n}\n.preflight-item strong {\n  font-size: 10px;\n}\n.preflight-item small {\n  margin-top: 2px;\n  color: var(--muted);\n  font-size: 8px;\n  line-height: 1.25;\n}\n.preflight-actions {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 7px;\n  margin-top: 10px;\n}\n.high-ticket-card {\n  border-color: color-mix(in srgb,#b84a3a 34%,var(--line));\n  background:\n    radial-gradient(circle at 0 0, rgba(255,242,216,.72), transparent 42%),\n    linear-gradient(180deg, color-mix(in srgb,var(--panel-2) 78%,#fff2d8), var(--panel-2));\n}\n.high-ticket-body {\n  display: grid;\n  gap: 10px;\n}\n.proof-summary {\n  padding: 10px;\n  border: 1px solid color-mix(in srgb,#b84a3a 24%,var(--line));\n  border-radius: 11px;\n  background: color-mix(in srgb,var(--bg) 82%,#fff2d8);\n}\n.proof-summary b,\n.proof-summary span {\n  display: block;\n}\n.proof-summary b {\n  color: var(--text);\n  font-size: 11px;\n  letter-spacing: .02em;\n}\n.proof-summary span {\n  margin-top: 4px;\n  color: var(--muted);\n  font-size: 9px;\n  line-height: 1.35;\n}\n.proof-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 6px;\n}\n.proof-grid span {\n  padding: 8px 9px;\n  border: 1px solid var(--line);\n  border-radius: 9px;\n  background: color-mix(in srgb,var(--bg) 70%,transparent);\n}\n.proof-grid strong,\n.proof-grid small {\n  display: block;\n}\n.proof-grid strong {\n  font-size: 10px;\n}\n.proof-grid small {\n  margin-top: 2px;\n  color: var(--muted);\n  font-size: 8px;\n  line-height: 1.28;\n}\n.layers { display:grid; gap:5px; max-height:180px; overflow:auto; }\n.layer { display:grid; grid-template-columns:25px 1fr 26px 26px; align-items:center; min-height:36px; border:1px solid transparent; border-radius:7px; padding:0 3px 0 7px; color:var(--muted); background:var(--bg); cursor:pointer; }\n.layer.selected { border-color:color-mix(in srgb,var(--accent) 45%,transparent); color:var(--text); }\n.layer-name { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-size:10px; }\n.layer-type { color:var(--muted-2); }\n.layer button { width:25px; height:25px; background:transparent; color:var(--muted-2); display:grid; place-items:center; cursor:pointer; }\n.empty-layers { color:var(--muted-2); font-size:10px; padding:12px 0; text-align:center; }\n.edit-tools { display:grid; gap:12px; }\n.edit-tools-card { border-color:color-mix(in srgb,var(--accent) 34%,var(--line)); background:linear-gradient(180deg,color-mix(in srgb,var(--accent-soft) 64%,var(--panel)) 0%,var(--panel-2) 58%); box-shadow:0 14px 36px rgba(18,18,18,.08); }\n.edit-tools-title { background:color-mix(in srgb,var(--accent-soft) 62%,transparent); }\n.edit-tools-state { padding:4px 7px; border-radius:999px; color:var(--text); background:var(--panel); border:1px solid color-mix(in srgb,var(--accent) 30%,transparent); font-size:9px; }\n.edit-tool-hero { display:grid; grid-template-columns:34px 1fr; gap:10px; align-items:center; padding:11px; border:1px solid color-mix(in srgb,var(--accent) 32%,transparent); border-radius:11px; background:linear-gradient(135deg,var(--panel),color-mix(in srgb,var(--accent-soft) 72%,var(--panel))); }\n.edit-tool-hero-icon { width:34px; height:34px; display:grid; place-items:center; border-radius:10px; color:var(--accent-contrast); background:var(--accent); box-shadow:0 8px 18px rgba(18,18,18,.14); }\n.edit-tool-hero strong { display:block; font-size:11px; line-height:1.28; }\n.edit-tool-hero small { display:block; margin-top:3px; color:var(--muted); font-size:9px; line-height:1.35; }\n.tool-block { padding:10px; border:1px solid var(--line); border-radius:9px; background:var(--bg); }\n.tool-block-featured { padding:11px; border-color:color-mix(in srgb,var(--accent) 26%,var(--line)); background:color-mix(in srgb,var(--panel) 72%,var(--bg)); }\n.tool-block.disabled { opacity:.58; }\n.text-tool-block { display:grid; gap:10px; border-color:color-mix(in srgb,#b84a3a 34%,var(--line)); background:linear-gradient(160deg,color-mix(in srgb,#fff7ea 42%,var(--bg)),var(--bg)); }\n:host([theme="dark"]) .text-tool-block { background:linear-gradient(160deg,rgba(184,74,58,.16),var(--bg)); }\n.text-tool-block.disabled .text-editor-input,\n.text-tool-block.disabled .font-preset-grid,\n.text-tool-block.disabled .text-effect-grid,\n.text-tool-block.disabled .text-control-grid,\n.text-tool-block.disabled .text-align-row,\n.text-tool-block.disabled .fine-print {\n  display: none;\n}\n.text-editor-input { width:100%; min-height:62px; max-height:118px; padding:10px 11px; border:1px solid var(--line-strong); border-radius:9px; background:var(--panel); outline:0; resize:vertical; font-size:12px; }\n.text-editor-input:focus { border-color:color-mix(in srgb,var(--accent) 58%,transparent); box-shadow:0 0 0 3px var(--accent-soft); }\n.font-preset-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:7px; }\n.font-preset { min-height:88px; padding:9px; border:1px solid var(--line); border-radius:10px; background:var(--panel); color:var(--muted); text-align:left; cursor:pointer; transition:.18s ease; overflow:hidden; }\n.font-preset:hover,.font-preset.active { color:var(--text); border-color:color-mix(in srgb,var(--accent) 48%,transparent); background:var(--accent-soft); transform:translateY(-1px); }\n.font-preset span { display:block; margin-bottom:5px; color:var(--text); font-size:23px; line-height:1; letter-spacing:.03em; white-space:nowrap; }\n.font-preset[data-value="coloroutine-bloom"] { background:radial-gradient(circle at 20% 10%,rgba(255,255,255,.96),transparent 36%),linear-gradient(135deg,#fff2d8,var(--panel)); border-color:color-mix(in srgb,#c84f3d 48%,var(--line)); }\n.font-preset[data-value="coloroutine-bloom"] span { color:#c84f3d; font-family:"Lily Script One","Pacifico","Baloo 2","Noto Sans SC",cursive!important; font-size:31px; font-weight:400; letter-spacing:.01em; -webkit-text-stroke:1px #fff8ec; text-shadow:3px 3px 0 rgba(48,70,60,.16),-2px 4px 0 rgba(184,74,58,.18); transform:rotate(-3deg); transform-origin:left center; }\n.font-preset[data-value="coloroutine-soft"] span { font-family:"Fredoka","Baloo 2","Arial Rounded MT Bold","Noto Sans SC",sans-serif!important; font-size:26px; font-weight:700; -webkit-text-stroke:.7px #fff; text-shadow:2px 2px 0 rgba(184,74,58,.14); }\n.font-preset[data-value="pacifico"] span { font-family:"Pacifico","Lily Script One","Noto Sans SC",cursive!important; color:#2f5f53; font-size:27px; font-weight:400; -webkit-text-stroke:.6px #fff7e7; text-shadow:2px 3px 0 rgba(18,18,18,.16); }\n.font-preset[data-value="bungee"] span { font-family:"Bungee","Arial Black","Noto Sans SC",sans-serif!important; color:#121212; font-size:22px; font-weight:400; -webkit-text-stroke:.8px #f6d56f; text-shadow:3px 3px 0 rgba(184,74,58,.28); }\n.font-preset[data-value="lilita"] span { font-family:"Lilita One","Fredoka","Noto Sans SC",sans-serif!important; color:#7aa6ff; font-size:28px; font-weight:400; -webkit-text-stroke:.9px #fff; text-shadow:2px 3px 0 rgba(48,70,60,.18); }\n.font-preset[data-value="noto-serif"] span { font-family:"Noto Serif SC",Georgia,serif!important; font-size:24px; font-weight:700; letter-spacing:.02em; }\n.font-preset[data-value="zcool"] span { font-family:"ZCOOL XiaoWei","Noto Serif SC",serif!important; color:#30463c; font-size:27px; font-weight:400; letter-spacing:.04em; }\n.font-preset strong { display:block; font-size:10px; line-height:1.2; }\n.font-preset small { display:block; margin-top:2px; color:var(--muted); font-size:8px; line-height:1.25; }\n.text-effect-grid { display:grid; grid-template-columns:repeat(5,minmax(0,1fr)); gap:6px; }\n.text-effect { min-height:48px; padding:6px 5px; border:1px solid var(--line); border-radius:9px; background:var(--panel); color:var(--muted); cursor:pointer; transition:.18s ease; }\n.text-effect:hover,.text-effect.active { color:var(--text); border-color:color-mix(in srgb,#c84f3d 45%,var(--accent)); background:linear-gradient(135deg,color-mix(in srgb,#fff1dc 52%,var(--panel)),var(--panel)); transform:translateY(-1px); }\n.text-effect span { display:block; font-size:11px; font-weight:750; line-height:1.1; }\n.text-effect small { display:block; margin-top:3px; font-size:8px; color:var(--muted); line-height:1.15; }\n.text-control-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:8px; }\n.text-control-grid label { display:grid; gap:5px; min-width:0; color:var(--muted); font-size:9px; }\n.text-control-grid label span { display:flex; justify-content:space-between; gap:8px; }\n.text-control-grid b { color:var(--text); font-weight:650; }\n.text-control-grid input[type="color"] { width:100%; height:32px; padding:2px; border:1px solid var(--line-strong); border-radius:8px; background:var(--panel); cursor:pointer; }\n.hex-color-field { grid-template-columns:32px minmax(0,1fr); align-items:center; }\n.hex-color-field span { grid-column:1 / -1; }\n.hex-color-field input[type="color"] { width:32px; }\n.hex-color-field input[type="text"] { min-width:0; height:32px; padding:0 8px; border:1px solid var(--line-strong); border-radius:8px; background:var(--panel); color:var(--text); font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace; font-size:10px; text-transform:uppercase; }\n.hex-color-field input[type="text"]:focus { outline:0; border-color:color-mix(in srgb,var(--accent) 58%,transparent); box-shadow:0 0 0 3px var(--accent-soft); }\n.text-control-grid input[type="range"] { width:100%; accent-color:var(--accent); }\n.text-align-row { display:flex; gap:6px; }\n.text-align-row .option { flex:1; }\n.color-tool-row { display:flex; align-items:center; gap:7px; flex-wrap:wrap; }\n.color-tool-row input[type="color"] { width:36px; height:30px; padding:2px; border:1px solid var(--line-strong); border-radius:7px; background:var(--panel); cursor:pointer; }\n.color-tool-row input[type="color"]:disabled { cursor:not-allowed; opacity:.45; }\n.color-picker-cta { min-height:60px; display:grid; grid-template-columns:44px 1fr; gap:10px; align-items:center; margin-top:8px; padding:9px; border:1px solid var(--line-strong); border-radius:10px; background:var(--bg); cursor:pointer; transition:.18s ease; }\n.color-picker-cta:hover { transform:translateY(-1px); border-color:color-mix(in srgb,var(--accent) 45%,transparent); box-shadow:0 9px 22px rgba(18,18,18,.10); }\n.color-picker-cta.disabled { cursor:not-allowed; }\n.color-picker-cta input[type="color"] { position:absolute; opacity:0; pointer-events:none; width:1px; height:1px; }\n.color-picker-preview { width:44px; height:44px; border-radius:11px; background:var(--picked); border:2px solid var(--panel); outline:1px solid var(--line-strong); box-shadow:inset 0 0 0 1px rgba(255,255,255,.38); }\n.color-picker-cta strong { display:block; color:var(--text); font-size:12px; }\n.color-picker-cta small { display:block; margin-top:3px; color:var(--muted); font-size:9px; line-height:1.3; }\n.prominent-swatches { margin-top:9px; }\n.prominent-swatches .mini-swatch { width:30px; height:30px; }\n.mini-swatch { width:26px; height:26px; border-radius:50%; background:var(--swatch); border:2px solid var(--panel); outline:1px solid var(--line-strong); cursor:pointer; }\n.mini-swatch:disabled { cursor:not-allowed; opacity:.45; }\n.remove-bg-cta { margin-top:8px; min-height:50px; border-radius:9px; box-shadow:0 10px 24px rgba(18,18,18,.16); }\n.remove-bg-cta:disabled { opacity:.52; box-shadow:none; cursor:not-allowed; }\n.order-summary { padding:14px; border-top:1px solid var(--line); }\n.price-row { display:flex; align-items:flex-end; justify-content:space-between; margin-bottom:11px; }\n.price-row span { color:var(--muted); font-size:10px; }\n.price-row strong { font-size:22px; letter-spacing:-.03em; }\n.fine-print { color:var(--muted-2); font-size:9px; line-height:1.45; margin-top:8px; }\n\n.button { min-height:38px; padding:0 14px; display:inline-flex; align-items:center; justify-content:center; gap:7px; border-radius:6px; font-size:11px; font-weight:600; cursor:pointer; transition:.18s; white-space:nowrap; }\n.button-primary { color:var(--accent-contrast); background:var(--accent); box-shadow:0 7px 18px rgba(18,18,18,.13); }\n.button-primary:hover { transform:translateY(-1px); filter:brightness(1.12); box-shadow:0 9px 22px rgba(18,18,18,.19); }\n.button-primary:disabled { opacity:.55; transform:none; cursor:not-allowed; }\n.button-secondary { color:var(--text); background:var(--panel-3); border:1px solid var(--line); }\n.button-ghost { color:var(--muted); background:transparent; border:1px solid var(--line); }\n.button-wide { width:100%; min-height:46px; font-size:12px; }\n.icon-button { width:32px; height:32px; display:grid; place-items:center; border-radius:7px; color:var(--muted); background:var(--panel-2); cursor:pointer; }\n.mobile-menu,.mobile-inspector,.sidebar-close { display:none; }\n.loading { position:relative; pointer-events:none; }\n.loading::after { content:""; width:13px; height:13px; border:2px solid rgba(255,255,255,.38); border-top-color:white; border-radius:50%; animation:spin .7s linear infinite; }\n.loading .button-label { display:none; }\n@keyframes spin { to { transform:rotate(360deg); } }\n\n.toast-stack { position:fixed; z-index:100; right:18px; bottom:18px; width:min(340px,calc(100vw - 36px)); display:grid; gap:8px; }\n.toast { background:#272a31; color:#fff; border:1px solid rgba(255,255,255,.13); border-radius:10px; padding:11px 13px; box-shadow:0 18px 55px rgba(0,0,0,.33); display:grid; grid-template-columns:20px 1fr; gap:8px; font-size:11px; animation:toast-in .22s ease; }\n.toast.error { border-left:3px solid var(--danger); }\n.toast.success { border-left:3px solid var(--success); }\n@keyframes toast-in { from { opacity:0; transform:translateY(8px); } }\n\n.share-modal { position:fixed; inset:0; z-index:90; display:none; place-items:center; padding:24px; background:rgba(5,6,9,.76); backdrop-filter:blur(12px); }\n.share-modal.open { display:grid; }\n.share-dialog { width:min(1040px,100%); max-height:min(840px,calc(100vh - 34px)); overflow:auto; border:1px solid var(--line-strong); border-radius:17px; background:var(--panel); box-shadow:0 35px 110px rgba(0,0,0,.58); }\n.share-head { display:flex; align-items:flex-start; justify-content:space-between; gap:20px; padding:20px 22px; border-bottom:1px solid var(--line); }\n.share-head h2 { margin:5px 0 2px; font-family:var(--font-display); font-size:28px; font-weight:400; letter-spacing:-.025em; }\n.share-head p { margin:0; color:var(--muted); font-size:10px; }\n.share-layout { display:grid; grid-template-columns:330px 1fr; min-height:540px; }\n.share-controls { padding:20px; border-right:1px solid var(--line); }\n.share-view-options { display:grid; grid-template-columns:1fr 1fr; gap:7px; margin-bottom:16px; }\n.share-view { min-height:55px; display:flex; align-items:center; justify-content:center; gap:8px; border:1px solid var(--line); border-radius:8px; background:var(--bg); color:var(--muted); cursor:pointer; }\n.share-view span { display:grid; text-align:left; font-size:11px; line-height:1.15; }\n.share-view small { margin-top:3px; color:var(--muted); font-size:8px; font-weight:500; }\n.share-view.active { border-color:var(--accent); color:var(--text); background:var(--accent-soft); box-shadow:inset 0 0 0 1px color-mix(in srgb,var(--accent) 22%,transparent); }\n.share-format-options { display:grid; grid-template-columns:repeat(3,1fr); gap:6px; }\n.share-format { min-height:56px; border:1px solid var(--line); border-radius:8px; background:var(--bg); color:var(--muted); font-size:12px; cursor:pointer; }\n.share-format small { font-size:8px; }\n.share-format.active { border-color:var(--accent); color:var(--text); background:var(--accent-soft); }\n.share-feature { display:grid; grid-template-columns:24px 1fr; gap:8px; padding:12px 0; border-top:1px solid var(--line); }\n.share-feature:first-of-type { margin-top:16px; }\n.share-feature strong { display:block; font-size:10px; }\n.share-feature span { display:block; color:var(--muted); font-size:9px; margin-top:2px; }\n.share-actions { display:grid; grid-template-columns:1fr 1fr; gap:7px; margin-top:8px; }\n.share-link-box { display:none; grid-template-columns:1fr auto; gap:6px; margin-top:9px; }\n.share-link-box.active { display:grid; }\n.share-link-box input { min-width:0; border:1px solid var(--line-strong); background:var(--bg); border-radius:7px; padding:8px; color:var(--muted); font-size:9px; }\n.share-preview-wrap { min-height:540px; display:grid; place-items:center; padding:24px; background:#ece9e2; position:relative; overflow:hidden; }\n.share-preview-wrap::before { content:""; position:absolute; width:280px; height:280px; border-radius:50%; background:rgba(18,18,18,.07); filter:blur(65px); right:-80px; top:-80px; }\n.share-preview-wrap img { position:relative; z-index:1; display:block; max-width:100%; max-height:650px; object-fit:contain; border-radius:10px; box-shadow:0 25px 70px rgba(0,0,0,.38); }\n.share-preview-loading { color:var(--muted); font-size:10px; }\n.share-preview-loading[hidden] { display:none; }\n\n@media (min-width: 1181px) {\n  :host([embedded]) .studio {\n    max-width: min(var(--studio-max-width, 1760px), calc(100vw - 24px));\n  }\n\n  .topbar {\n    height: 64px;\n    grid-template-columns: 286px minmax(240px, 1fr) auto;\n  }\n\n  .brand { padding: 0 18px; }\n  .brand-mark { width: 34px; height: 34px; }\n  .metric { min-width: 104px; padding: 12px 15px; }\n\n  .layout {\n    grid-template-columns: minmax(760px, 1fr) 322px;\n    grid-template-rows: auto minmax(0, 1fr);\n    grid-template-areas:\n      "tools tools"\n      "work inspector";\n    min-height: calc(100vh - 64px);\n  }\n\n  .sidebar {\n    grid-area: tools;\n    position: sticky;\n    top: 64px;\n    z-index: 24;\n    height: auto;\n    min-height: 74px;\n    overflow: visible;\n    display: grid;\n    grid-template-columns: minmax(210px, 260px) minmax(180px, 230px) minmax(460px, 1fr) minmax(290px, auto);\n    gap: 10px;\n    align-items: stretch;\n    padding: 10px 14px;\n    border-right: 0;\n    border-bottom: 1px solid var(--line);\n    background:\n      linear-gradient(90deg, color-mix(in srgb,var(--panel) 98%,#fff), color-mix(in srgb,var(--panel) 92%,#121212 3%));\n    box-shadow: 0 10px 30px rgba(18,18,18,.045);\n  }\n\n  :host([embedded]) .sidebar {\n    top: calc(var(--studio-sticky-offset,0px) + 64px);\n    height: auto;\n  }\n\n  .project-box,\n  .connection,\n  .nav-secondary,\n  .sidebar-foot {\n    border: 1px solid var(--line);\n    border-radius: 12px;\n    background: color-mix(in srgb,var(--bg) 70%,transparent);\n  }\n\n  .project-box {\n    padding: 10px;\n    display: grid;\n    align-content: center;\n  }\n\n  .project-box .section-eyebrow,\n  .nav-label {\n    display: none;\n  }\n\n  .project-select {\n    min-height: 42px;\n    border-radius: 10px;\n  }\n\n  .connection {\n    padding: 10px 12px;\n    min-height: 52px;\n  }\n\n  .nav {\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  .nav-item {\n    min-height: 52px;\n    grid-template-columns: 24px 1fr;\n    padding: 8px 9px;\n    border-color: var(--line);\n    background: var(--bg);\n  }\n\n  .nav-copy strong { font-size: 11px; }\n  .nav-copy small { font-size: 8px; }\n\n  .nav-secondary {\n    margin: 0;\n    padding: 0;\n  }\n\n  .nav-secondary .nav {\n    height: 100%;\n    grid-template-columns: repeat(6, minmax(76px, 1fr));\n  }\n\n  .nav-secondary .nav-item {\n    height: 100%;\n  }\n\n  .sidebar-foot {\n    display: none;\n  }\n\n  .main {\n    grid-area: work;\n    min-height: 0;\n    padding: 22px 20px 34px;\n    display: grid;\n    grid-template-columns: minmax(310px, 390px) minmax(500px, 1fr);\n    grid-template-rows: auto auto minmax(0, 1fr);\n    gap: 14px;\n    align-items: start;\n    overflow: visible;\n  }\n\n  .main-head {\n    grid-column: 1 / -1;\n    margin-bottom: 0;\n  }\n\n  h1 {\n    font-size: clamp(28px, 2.2vw, 40px);\n  }\n\n  .workflow {\n    grid-column: 1 / -1;\n    margin-bottom: 0;\n  }\n\n  .workflow-step {\n    min-height: 54px;\n    padding: 8px 10px;\n  }\n\n  .creative-panel {\n    grid-column: 1;\n    margin-bottom: 0;\n    position: sticky;\n    top: calc(var(--studio-sticky-offset,0px) + 158px);\n    max-height: calc(100vh - var(--studio-sticky-offset,0px) - 178px);\n    overflow: auto;\n  }\n\n  .creative-title {\n    height: 44px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: var(--panel);\n  }\n\n  .prompt-row,\n  .reference-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .prompt-row .button,\n  .reference-grid .button {\n    width: 100%;\n  }\n\n  textarea {\n    min-height: 104px;\n  }\n\n  .quick-styles {\n    gap: 5px;\n  }\n\n  .style-chip {\n    padding: 5px 8px;\n  }\n\n  .inspiration-grid,\n  .results-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .stage-card {\n    grid-column: 2;\n    min-height: 0;\n  }\n\n  .stage {\n    min-height: 560px;\n    height: min(66vh, 760px);\n    max-height: none;\n  }\n\n  .inspector {\n    grid-area: inspector;\n    top: calc(var(--studio-sticky-offset,0px) + 138px);\n    height: calc(100vh - var(--studio-sticky-offset,0px) - 138px);\n    padding: 14px;\n  }\n}\n\n@media (max-width: 1180px) {\n  .topbar { grid-template-columns:256px 1fr auto; }\n  .brand { padding:0 16px; }\n  .metric:nth-child(-n+2) { display:none; }\n  .layout { grid-template-columns:216px minmax(480px,1fr) 300px; }\n  .inspector { padding:12px; }\n  .main { padding-left:20px; padding-right:20px; }\n}\n\n@media (max-width: 930px) {\n  :host { min-height:640px; }\n  .topbar { height:62px; grid-template-columns:1fr auto; }\n  .brand { border:0; }\n  .brand-subtitle,.project-title,.metrics { display:none; }\n  .mobile-menu { display:grid; }\n  .sidebar-close { display:grid; }\n  .layout { grid-template-columns:1fr; min-height:calc(100vh - 62px); }\n  .sidebar { position:fixed; z-index:60; top:0; bottom:0; left:0; height:100vh; width:min(290px,84vw); transform:translateX(-102%); box-shadow:20px 0 60px rgba(0,0,0,.35); transition:.22s ease; }\n  .sidebar.open { transform:translateX(0); }\n  .inspector { position:fixed; z-index:55; top:auto; left:0; right:0; bottom:0; width:100%; height:min(78vh,680px); transform:translateY(102%); border-left:0; border-top:1px solid var(--line); border-radius:18px 18px 0 0; box-shadow:0 -20px 70px rgba(0,0,0,.4); transition:.22s ease; }\n  .inspector.open { transform:translateY(0); }\n  .mobile-inspector { display:inline-flex; }\n  .main { padding:18px 14px 84px; }\n  .main-head { align-items:start; }\n  h1 { font-size:27px; }\n  .stage { min-height:430px; height:68vh; max-height:620px; }\n  .mobile-bar { position:fixed; z-index:40; left:0; right:0; bottom:0; padding:10px 12px max(10px,env(safe-area-inset-bottom)); background:color-mix(in srgb,var(--panel) 94%,transparent); border-top:1px solid var(--line); backdrop-filter:blur(16px); display:grid; grid-template-columns:auto 1fr; gap:8px; }\n  .share-layout { grid-template-columns:1fr; }\n  .share-controls { border-right:0; border-bottom:1px solid var(--line); }\n  .share-preview-wrap { min-height:420px; }\n  :host([embedded]) .sidebar { top:0; height:100dvh; }\n  :host([embedded]) .inspector { top:auto; height:min(78dvh,680px); }\n}\n\n@media (min-width: 931px) { .mobile-bar { display:none; } }\n\n@media (max-width: 620px) {\n  .brand-title { font-size:13px; }\n  .brand-mark { width:34px; height:34px; }\n  .top-actions { padding-right:10px; }\n  .locale-control { padding:0 3px; }\n  .locale-control > span { display:none; }\n  .locale-control select { min-width:48px; padding-left:6px; }\n  .top-actions .theme-toggle { display:none; }\n  .main-head p,.mode-badge { display:none; }\n  .main-head { display:grid; }\n  .main-head-actions { justify-content:flex-start; }\n  .product-chip { width:100%; justify-content:space-between; }\n  h1 { font-size:23px; }\n  .workflow { grid-template-columns:repeat(4,minmax(164px,1fr)); overflow-x:auto; padding-bottom:4px; scroll-snap-type:x proximity; scrollbar-width:thin; }\n  .workflow-step { scroll-snap-align:start; }\n  .workbench-shell { padding: 10px; margin-bottom: 10px; }\n  .workbench-title { align-items: flex-start; flex-direction: column; gap: 3px; }\n  .workbench-steps { grid-template-columns: repeat(4, minmax(150px, 1fr)); overflow-x: auto; padding-bottom: 4px; scrollbar-width: thin; }\n  .workbench-step { min-height: 64px; scroll-snap-align: start; }\n  .workbench-step small { display: none; }\n  .creative-body { padding:12px; }\n  .prompt-row { grid-template-columns:1fr; }\n  .prompt-row .button { width:100%; }\n  .reference-grid { grid-template-columns:1fr; }\n  .reference-thumb { height:130px; aspect-ratio:auto; }\n  .inspiration-grid,.results-grid { grid-template-columns:repeat(2,1fr); }\n  .toolbar { align-items:flex-start; }\n  .toolbar-group:nth-child(1) .tool-button:nth-of-type(n+5) { display:none; }\n  .stage { min-height:390px; height:62vh; }\n  .product-stage { height:88%; }\n  .stage-foot { align-items:flex-start; gap:8px; }\n  .stage-status { align-items:flex-start; flex-direction:column; gap:5px; }\n  .stage-foot > span:last-child { display:none; }\n  .share-modal { padding:0; }\n  .share-dialog { max-height:100vh; height:100vh; border-radius:0; }\n  .share-head { padding:15px; }\n  .share-head h2 { font-size:18px; }\n  .share-controls { padding:15px; }\n  .share-preview-wrap { min-height:360px; padding:14px; }\n}\n\n/* Responsive cockpit refinements: keep core Studio actions visible without constant page scrolling. */\n@media (min-width: 1181px) {\n  :host([embedded]) {\n    --studio-viewport-fit: 78dvh;\n  }\n  :host([embedded]) .studio {\n    min-height: 640px;\n    height: var(--studio-viewport-fit);\n  }\n  .topbar { height: 60px; }\n  .layout {\n    grid-template-columns: minmax(700px, 1fr) 304px;\n    min-height: calc(100vh - 60px);\n  }\n  :host([embedded]) .layout {\n    min-height: calc(78dvh - 60px);\n  }\n  .sidebar {\n    top: 60px;\n    min-height: 56px;\n    grid-template-columns: minmax(176px, 230px) minmax(138px, 186px) minmax(360px, 1fr) auto;\n    gap: 8px;\n    padding: 7px 12px;\n  }\n  :host([embedded]) .sidebar { top: calc(var(--studio-sticky-offset,0px) + 60px); }\n  .project-box { padding: 7px 9px; }\n  .project-select { min-height: 36px; padding-top: 8px; padding-bottom: 8px; }\n  .connection { min-height: 42px; padding: 7px 9px; }\n  .connection span { display:none; }\n  .nav { gap: 6px; }\n  .nav-item {\n    min-height: 40px;\n    grid-template-columns: 22px 1fr;\n    padding: 6px 8px;\n  }\n  .nav-index { width: 22px; height: 22px; }\n  .nav-copy strong { font-size: 10.5px; }\n  .nav-copy small { display: none; }\n  .nav-secondary {\n    align-self: stretch;\n    padding: 0;\n  }\n  .nav-secondary .nav {\n    grid-template-columns: repeat(6, 38px);\n    height: 100%;\n    gap: 6px;\n    justify-content: end;\n    padding: 0;\n  }\n  .nav-secondary .nav-item {\n    width: 38px;\n    min-height: 38px;\n    grid-template-columns: 1fr;\n    place-items: center;\n    padding: 0;\n  }\n  .nav-secondary .nav-index {\n    width: 26px;\n    height: 26px;\n    display: grid;\n    place-items: center;\n  }\n  .nav-secondary .nav-copy {\n    display: none;\n  }\n  .nav-secondary .nav-item:hover::after {\n    content: attr(aria-label);\n    position: absolute;\n    right: 0;\n    top: calc(100% + 7px);\n    z-index: 40;\n    min-width: max-content;\n    padding: 5px 7px;\n    color: var(--accent-contrast);\n    background: var(--accent);\n    border-radius: 7px;\n    font-size: 10px;\n    box-shadow: 0 8px 20px rgba(18,18,18,.18);\n  }\n  .main {\n    padding: 10px 14px 16px;\n    grid-template-columns: minmax(260px, 326px) minmax(520px, 1fr);\n    grid-template-rows: auto minmax(0, 1fr);\n    gap: 10px;\n  }\n  .quick-start {\n    grid-column: 1;\n    grid-row: 1;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 6px;\n    margin-bottom: 0;\n  }\n  .quick-card {\n    min-height: 42px;\n    grid-template-columns: 24px 1fr;\n    padding: 7px 8px;\n  }\n  .quick-card svg { width:24px; height:24px; padding:5px; }\n  .quick-card strong { font-size: 10px; }\n  .quick-card small { display:none; }\n  .workbench-shell {\n    grid-column: 2;\n    grid-row: 1;\n    margin-bottom: 0;\n    padding: 7px 9px;\n    border-radius: 12px;\n    box-shadow: none;\n  }\n  .workbench-title {\n    margin-bottom: 6px;\n    font-size: 8px;\n  }\n  .workbench-title span { display:none; }\n  .workbench-steps {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 6px;\n  }\n  .workbench-step {\n    min-height: 34px;\n    grid-template-columns: 20px 1fr;\n    gap: 6px;\n    padding: 5px 7px;\n    border-radius: 9px;\n  }\n  .workbench-step > span {\n    width: 18px;\n    height: 18px;\n    font-size: 8px;\n  }\n  .workbench-step strong { font-size: 9px; }\n  .workbench-step small { display:none; }\n  .main-head { display: none; }\n  .workflow { display:none; }\n  .creative-panel {\n    grid-row: 2;\n    top: calc(var(--studio-sticky-offset,0px) + 122px);\n    max-height: calc(100vh - var(--studio-sticky-offset,0px) - 138px);\n  }\n  .creative-title { height: 40px; }\n  .creative-body { padding: 10px; }\n  textarea { min-height: 86px; }\n  .stage-card { grid-row: 2; }\n  .stage {\n    min-height: 0;\n    height: clamp(390px, calc(100vh - var(--studio-sticky-offset,0px) - 202px), 640px);\n  }\n  :host([embedded]) .stage {\n    height: clamp(340px, calc(78dvh - 280px), 500px);\n  }\n  .stage-foot {\n    min-height: 32px;\n    padding: 5px 10px;\n    font-size: 9px;\n  }\n  .stage-foot > span:last-child { display:none; }\n  .inspector {\n    top: calc(var(--studio-sticky-offset,0px) + 112px);\n    height: calc(100vh - var(--studio-sticky-offset,0px) - 112px);\n    padding: 8px;\n  }\n  :host([embedded]) .inspector {\n    height: calc(78dvh - 112px);\n  }\n  .inspector-card { margin-bottom: 7px; border-radius: 10px; }\n  .inspector-title { padding: 8px 10px; }\n  .inspector-title strong { font-size: 11px; }\n  .inspector-body { padding: 9px 10px; }\n  .field { margin-bottom: 8px; }\n  .layers { max-height: 104px; }\n  .brand-type-sample { min-height: 74px; }\n  .brand-type-sample span { font-size: 31px; }\n  .text-tool-block { gap: 8px; }\n  .font-preset { min-height: 68px; padding: 8px; }\n  .text-effect-button { min-height: 50px; padding: 7px 5px; }\n}\n\n@media (max-width: 1180px) and (min-width: 931px) {\n  .main { padding: 16px; }\n  .main-head { margin-bottom: 12px; }\n  .main-head p { display: none; }\n  h1 { font-size: 26px; }\n  .workflow {\n    gap: 8px;\n    margin-bottom: 12px;\n  }\n  .workflow i { display: none; }\n  .workflow-step {\n    min-height: 46px;\n    padding: 8px 9px;\n  }\n  .workflow-step small { display: none; }\n  .creative-body,\n  .inspector-body { padding: 10px; }\n  .stage {\n    min-height: 0;\n    height: clamp(430px, 58vh, 620px);\n  }\n  .layers { max-height: 120px; }\n}\n\n@media (max-width: 930px) {\n  .main {\n    padding: 10px 10px 78px;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n    min-width: 0;\n    max-width: 100%;\n  }\n  .main > * {\n    min-width: 0;\n    max-width: 100%;\n  }\n  .quick-start {\n    order: 2;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    overflow-x: auto;\n    margin-bottom: 0;\n    padding-bottom: 2px;\n    scroll-snap-type: x proximity;\n  }\n  .workbench-shell {\n    order: 1;\n    margin-bottom: 0;\n  }\n  .quick-card {\n    min-height: 58px;\n    grid-template-columns: 27px 1fr;\n    padding: 9px 10px;\n    scroll-snap-align: start;\n    min-width: 0;\n  }\n  .quick-card svg { width:27px; height:27px; padding:6px; }\n  .quick-card small { display:none; }\n  .main-head {\n    display: none;\n  }\n  .main-head p { display: none; }\n  h1 {\n    font-size: 22px;\n    margin-top: 4px;\n  }\n  .workflow {\n    display: none;\n  }\n  .workflow i { display: none; }\n  .workflow-step {\n    min-height: 42px;\n    padding: 7px 9px;\n    scroll-snap-align: start;\n  }\n  .workflow-step small { display: none; }\n  .creative-panel {\n    order: 3;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    margin-bottom: 0;\n    max-height: min(36dvh, 300px);\n    overflow: auto;\n  }\n  .creative-title {\n    height: 40px;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: var(--panel);\n  }\n  .creative-body { padding: 10px; }\n  textarea { min-height: 82px; }\n  .stage {\n    width: 100%;\n    min-height: 0;\n    height: clamp(330px, 48dvh, 520px);\n    max-height: 520px;\n  }\n  .stage-card,\n  .toolbar,\n  .toolbar-group {\n    min-width: 0;\n    max-width: 100%;\n  }\n  .toolbar {\n    flex-wrap: wrap;\n  }\n  .stage-card {\n    order: 4;\n  }\n  .empty-stage-actions { bottom: 12px; max-width: calc(100% - 20px); overflow-x: auto; }\n  .stage-helper { display: none; }\n  .stage-foot {\n    min-height: 34px;\n    padding: 6px 10px;\n  }\n  .inspector {\n    height: min(72dvh, 620px);\n    padding: 10px;\n  }\n  :host([embedded]) .inspector { height: min(72dvh, 620px); }\n  .mobile-bar {\n    grid-template-columns: 1fr 1fr 1.2fr;\n    gap: 7px;\n  }\n  .mobile-bar:not(.mobile-bar-modern) { display: none; }\n  .button {\n    min-height: 36px;\n    padding: 0 10px;\n  }\n}\n\n@media (max-width: 620px) {\n  .workflow { grid-template-columns: repeat(4, minmax(112px, 1fr)); }\n  .product-chip small { display: none; }\n  .creative-panel { max-height: min(39dvh, 286px); }\n  .brand-type-sample { display: none; }\n  .stage {\n    min-height: 0;\n    height: clamp(300px, 45dvh, 430px);\n  }\n  .product-stage { height: 88%; }\n  .font-preset-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .text-effect-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .text-control-grid { grid-template-columns: 1fr; }\n  .hex-color-field { grid-template-columns: 34px minmax(0, 1fr); }\n  .mobile-bar .button-label { white-space: normal; }\n}\n\n/* Mobile flow: keep the full workflow and the primary AI action in the page flow. */\n@media (max-width: 620px) {\n  :host([embedded]) .main {\n    gap: 8px;\n    padding: 8px 8px 76px;\n  }\n\n  :host([embedded]) .workbench-shell { padding: 8px; }\n\n  :host([embedded]) .workbench-title {\n    min-width: 0;\n    margin-bottom: 6px;\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n    font-size: 8px;\n  }\n\n  :host([embedded]) .workbench-title span { display: none; }\n\n  :host([embedded]) .workbench-title strong {\n    min-width: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  :host([embedded]) .workbench-steps {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 5px;\n    overflow: visible;\n    padding-bottom: 0;\n  }\n\n  :host([embedded]) .workbench-step {\n    min-width: 0;\n    min-height: 54px;\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    place-items: center;\n    gap: 3px;\n    padding: 6px 3px;\n    overflow: hidden;\n    text-align: center;\n  }\n\n  :host([embedded]) .workbench-step > span {\n    grid-row: auto;\n    width: 22px;\n    height: 22px;\n    font-size: 8px;\n  }\n\n  :host([embedded]) .workbench-step strong {\n    max-width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 9px;\n  }\n\n  :host([embedded]) .quick-start {\n    gap: 5px;\n    overflow: visible;\n    padding-bottom: 0;\n  }\n\n  :host([embedded]) .quick-card {\n    min-height: 48px;\n    grid-template-columns: 24px minmax(0, 1fr);\n    gap: 6px;\n    padding: 7px;\n  }\n\n  :host([embedded]) .quick-card svg {\n    width: 24px;\n    height: 24px;\n    padding: 5px;\n  }\n\n  :host([embedded]) .quick-card strong {\n    font-size: 10px;\n    line-height: 1.15;\n    display: -webkit-box;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n  }\n\n  :host([embedded]) .creative-panel {\n    max-height: none;\n    overflow: visible;\n  }\n\n  :host([embedded]) .creative-title {\n    height: 38px;\n    position: static;\n    padding-inline: 11px;\n  }\n\n  :host([embedded]) .creative-body { padding: 8px; }\n  :host([embedded]) .prompt-row { gap: 8px; }\n\n  :host([embedded]) textarea {\n    min-height: 62px;\n    max-height: 100px;\n    padding: 9px 10px 2px;\n  }\n\n  :host([embedded]) .prompt-meta { padding: 3px 8px 7px; }\n  :host([embedded]) .prompt-meta span:first-child { display: none; }\n  :host([embedded]) .prompt-meta span:last-child { margin-left: auto; }\n\n  :host([embedded]) .background-toggle {\n    min-height: 40px;\n    margin-top: 7px;\n    padding: 7px 9px;\n  }\n\n  :host([embedded]) .background-toggle small { display: none; }\n\n  :host([embedded]) .quick-styles {\n    margin-top: 7px;\n    flex-wrap: nowrap;\n    gap: 5px;\n    overflow-x: auto;\n    padding-bottom: 2px;\n    scrollbar-width: thin;\n  }\n\n  :host([embedded]) .style-chip {\n    flex: 0 0 auto;\n    min-height: 34px;\n    padding: 6px 10px;\n  }\n\n  :host([embedded]) .prompt-row > .button { min-height: 44px; }\n\n  :host([embedded]) .tool-button,\n  :host([embedded]) .icon-button,\n  :host([embedded]) .zoom-controls button {\n    min-width: 40px;\n    min-height: 40px;\n  }\n\n  :host([embedded]) .segmented button {\n    min-width: 52px;\n    height: 40px;\n  }\n\n  :host([embedded]) .swatch,\n  :host([embedded]) .option {\n    min-width: 40px;\n    min-height: 40px;\n  }\n}\n\n/* Fixed-ratio desktop workbench: 2500 x 1300 design frame, scaled to the storefront viewport. */\n@media (min-width: 1181px) {\n  :host([embedded]) {\n    --studio-frame-w: 2500;\n    --studio-frame-h: 1300;\n    --studio-frame-ratio: 1.9230769231;\n    --studio-frame-max-width: min(var(--studio-max-width, 1600px), calc(100vw - 24px), calc((100dvh - 24px) * var(--studio-frame-ratio)));\n    min-height: 0;\n  }\n\n  :host([embedded]) .studio {\n    width: var(--studio-frame-max-width);\n    max-width: var(--studio-frame-max-width);\n    min-height: 0;\n    height: auto;\n    aspect-ratio: 2500 / 1300;\n    overflow: hidden;\n    container-type: inline-size;\n  }\n\n  :host([embedded]) .topbar {\n    height: clamp(46px, 4.7cqw, 60px);\n    grid-template-columns: minmax(214px, 17.5%) minmax(300px, 1fr) auto;\n  }\n\n  :host([embedded]) .brand {\n    gap: clamp(7px, .7cqw, 12px);\n    padding-inline: clamp(10px, 1.1cqw, 18px);\n  }\n\n  :host([embedded]) .brand-mark {\n    width: clamp(28px, 2.6cqw, 34px);\n    height: clamp(28px, 2.6cqw, 34px);\n  }\n\n  :host([embedded]) .brand-title { font-size: clamp(12px, 1cqw, 15px); }\n  :host([embedded]) .brand-subtitle { font-size: clamp(8px, .64cqw, 10px); }\n  :host([embedded]) .top-actions { gap: clamp(4px, .45cqw, 7px); padding-inline: clamp(8px, 1cqw, 16px); }\n  :host([embedded]) .metric { min-width: clamp(76px, 7.2cqw, 104px); padding: clamp(8px, .9cqw, 12px) clamp(9px, 1cqw, 15px); }\n  :host([embedded]) .metric-label { font-size: clamp(8px, .65cqw, 10px); }\n  :host([embedded]) .metric-value { font-size: clamp(12px, 1.15cqw, 16px); }\n\n  :host([embedded]) .layout {\n    height: calc(100% - clamp(46px, 4.7cqw, 60px));\n    min-height: 0;\n    grid-template-columns: minmax(620px, 1fr) clamp(268px, 23.4%, 304px);\n    grid-template-rows: clamp(48px, 5cqw, 60px) minmax(0, 1fr);\n  }\n\n  :host([embedded]) .sidebar {\n    min-height: 0;\n    height: 100%;\n    grid-template-columns: minmax(160px, 18%) minmax(118px, 14%) minmax(300px, 1fr) auto;\n    gap: clamp(5px, .55cqw, 8px);\n    padding: clamp(5px, .55cqw, 7px) clamp(8px, .95cqw, 12px);\n  }\n\n  :host([embedded]) .project-box { padding: clamp(5px, .55cqw, 7px) clamp(7px, .72cqw, 9px); }\n  :host([embedded]) .project-select { min-height: clamp(30px, 2.8cqw, 36px); font-size: clamp(10px, .78cqw, 12px); }\n  :host([embedded]) .connection { min-height: clamp(34px, 3.25cqw, 42px); padding: clamp(5px, .55cqw, 7px) clamp(7px, .72cqw, 9px); }\n  :host([embedded]) .connection strong { font-size: clamp(9px, .8cqw, 12px); }\n\n  :host([embedded]) .nav {\n    gap: clamp(4px, .45cqw, 6px);\n  }\n\n  :host([embedded]) .nav-item {\n    min-height: clamp(34px, 3.1cqw, 40px);\n    grid-template-columns: clamp(18px, 1.7cqw, 22px) 1fr;\n    padding: clamp(4px, .48cqw, 6px) clamp(6px, .65cqw, 8px);\n  }\n\n  :host([embedded]) .nav-index {\n    width: clamp(18px, 1.7cqw, 22px);\n    height: clamp(18px, 1.7cqw, 22px);\n  }\n\n  :host([embedded]) .nav-copy strong { font-size: clamp(9px, .82cqw, 10.5px); }\n\n  :host([embedded]) .nav-secondary .nav {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n    width: min(100%, 258px);\n    gap: clamp(3px, .34cqw, 5px);\n  }\n\n  :host([embedded]) .nav-secondary .nav-item {\n    width: 100%;\n    min-width: 0;\n    min-height: clamp(30px, 2.75cqw, 36px);\n    grid-template-columns: 1fr;\n    padding: 0;\n    place-items: center;\n  }\n\n  :host([embedded]) .nav-secondary .nav-index {\n    width: clamp(20px, 1.85cqw, 24px);\n    height: clamp(20px, 1.85cqw, 24px);\n    margin: auto;\n  }\n\n  :host([embedded]) .main {\n    height: 100%;\n    min-height: 0;\n    padding: clamp(7px, .78cqw, 10px) clamp(10px, 1.05cqw, 14px) clamp(10px, 1.15cqw, 16px);\n    grid-template-columns: minmax(260px, 28%) minmax(470px, 1fr);\n    grid-template-rows: auto auto minmax(0, 1fr);\n    gap: clamp(7px, .75cqw, 10px);\n    overflow: hidden;\n  }\n\n  :host([embedded]) .main-head,\n  :host([embedded]) .workflow {\n    display: none;\n  }\n\n  :host([embedded]) .workbench-shell {\n    grid-column: 1;\n    grid-row: 1;\n    min-height: 0;\n    margin-bottom: 0;\n    padding: clamp(5px, .55cqw, 7px) clamp(7px, .72cqw, 9px);\n    border-radius: 12px;\n    box-shadow: none;\n  }\n\n  :host([embedded]) .workbench-title {\n    margin-bottom: clamp(3px, .45cqw, 6px);\n    font-size: clamp(7px, .6cqw, 8px);\n    min-width: 0;\n  }\n\n  :host([embedded]) .workbench-title span {\n    display: none;\n  }\n\n  :host([embedded]) .workbench-title strong {\n    min-width: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  :host([embedded]) .workbench-steps {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: clamp(4px, .45cqw, 6px);\n  }\n\n  :host([embedded]) .workbench-step {\n    min-height: clamp(36px, 3.45cqw, 44px);\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    place-items: center;\n    gap: clamp(2px, .25cqw, 4px);\n    padding: clamp(4px, .42cqw, 5px) clamp(3px, .38cqw, 5px);\n    border-radius: 9px;\n    overflow: hidden;\n    text-align: center;\n  }\n\n  :host([embedded]) .workbench-step > span {\n    width: clamp(15px, 1.4cqw, 18px);\n    height: clamp(15px, 1.4cqw, 18px);\n    font-size: clamp(7px, .6cqw, 8px);\n  }\n\n  :host([embedded]) .workbench-step strong {\n    font-size: clamp(8px, .72cqw, 9px);\n    max-width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.05;\n  }\n\n  :host([embedded]) .workbench-step small {\n    display: none;\n  }\n\n  :host([embedded]) .quick-card {\n    min-height: clamp(34px, 3.25cqw, 42px);\n    grid-template-columns: clamp(20px, 1.9cqw, 24px) 1fr;\n    gap: clamp(5px, .58cqw, 8px);\n    padding: clamp(5px, .55cqw, 7px) clamp(6px, .65cqw, 8px);\n  }\n\n  :host([embedded]) .quick-card svg {\n    width: clamp(20px, 1.9cqw, 24px);\n    height: clamp(20px, 1.9cqw, 24px);\n    padding: clamp(4px, .42cqw, 5px);\n  }\n\n  :host([embedded]) .quick-card strong { font-size: clamp(8px, .76cqw, 10px); }\n\n  :host([embedded]) .quick-start {\n    grid-column: 1;\n    grid-row: 2;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: clamp(4px, .45cqw, 6px);\n    margin-bottom: 0;\n  }\n\n  :host([embedded]) .creative-panel,\n  :host([embedded]) .stage-card {\n    min-height: 0;\n    height: 100%;\n    overflow: hidden;\n  }\n\n  :host([embedded]) .creative-panel {\n    grid-column: 1;\n    grid-row: 3;\n    max-height: none;\n  }\n\n  :host([embedded]) .creative-title {\n    height: clamp(34px, 3.1cqw, 40px);\n    padding-inline: clamp(10px, 1.05cqw, 16px);\n  }\n\n  :host([embedded]) .creative-body {\n    height: calc(100% - clamp(34px, 3.1cqw, 40px));\n    padding: clamp(7px, .78cqw, 10px);\n    overflow: auto;\n  }\n\n  :host([embedded]) textarea {\n    min-height: clamp(68px, 6.6cqw, 86px);\n    max-height: clamp(108px, 10cqw, 150px);\n  }\n\n  :host([embedded]) .quick-styles {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    padding-bottom: 2px;\n    scrollbar-width: thin;\n  }\n\n  :host([embedded]) .style-chip { flex: 0 0 auto; }\n\n  :host([embedded]) .stage-card {\n    grid-column: 2;\n    grid-row: 1 / span 3;\n    display: flex;\n    flex-direction: column;\n  }\n\n  :host([embedded]) .toolbar {\n    min-height: clamp(36px, 3.7cqw, 46px);\n    padding: clamp(5px, .55cqw, 8px) clamp(8px, .92cqw, 12px);\n  }\n\n  :host([embedded]) .tool-button {\n    width: clamp(28px, 2.65cqw, 34px);\n    height: clamp(28px, 2.65cqw, 34px);\n  }\n\n  :host([embedded]) .segmented button {\n    height: clamp(24px, 2.15cqw, 28px);\n    min-width: clamp(42px, 3.85cqw, 50px);\n    font-size: clamp(8px, .72cqw, 10px);\n  }\n\n  :host([embedded]) .stage {\n    flex: 1 1 auto;\n    min-height: 0;\n    height: auto;\n    max-height: none;\n  }\n\n  :host([embedded]) .product-stage {\n    height: 88%;\n  }\n\n  :host([embedded]) .stage-helper {\n    left: clamp(8px, .95cqw, 14px);\n    bottom: clamp(8px, .95cqw, 14px);\n    max-width: clamp(210px, 20cqw, 270px);\n    padding: clamp(7px, .78cqw, 10px) clamp(8px, .92cqw, 12px);\n  }\n\n  :host([embedded]) .empty-stage-actions {\n    bottom: clamp(9px, 1.1cqw, 18px);\n  }\n\n  :host([embedded]) .empty-stage-actions button {\n    min-height: clamp(24px, 2.3cqw, 30px);\n    padding-inline: clamp(7px, .78cqw, 10px);\n    font-size: clamp(8px, .72cqw, 10px);\n  }\n\n  :host([embedded]) .stage-foot {\n    flex: 0 0 auto;\n    min-height: clamp(26px, 2.55cqw, 32px);\n    padding: clamp(4px, .42cqw, 5px) clamp(7px, .78cqw, 10px);\n    font-size: clamp(8px, .68cqw, 9px);\n  }\n\n  :host([embedded]) .inspector {\n    height: 100%;\n    min-height: 0;\n    padding: clamp(6px, .65cqw, 8px);\n    overflow: auto;\n  }\n\n  :host([embedded]) .inspector-card {\n    margin-bottom: clamp(5px, .55cqw, 7px);\n  }\n\n  :host([embedded]) .preflight-summary,\n  :host([embedded]) .proof-summary {\n    padding: clamp(7px, .7cqw, 9px);\n  }\n\n  :host([embedded]) .preflight-summary span,\n  :host([embedded]) .proof-summary span,\n  :host([embedded]) .proof-grid small {\n    font-size: clamp(7px, .62cqw, 8px);\n  }\n\n  :host([embedded]) .preflight-list {\n    gap: clamp(4px, .45cqw, 6px);\n  }\n\n  :host([embedded]) .preflight-item {\n    grid-template-columns: clamp(18px, 1.75cqw, 21px) 1fr;\n    gap: clamp(5px, .52cqw, 7px);\n    padding: clamp(5px, .52cqw, 7px);\n  }\n\n  :host([embedded]) .preflight-item i {\n    width: clamp(18px, 1.75cqw, 21px);\n    height: clamp(18px, 1.75cqw, 21px);\n  }\n\n  :host([embedded]) .preflight-item strong,\n  :host([embedded]) .proof-grid strong {\n    font-size: clamp(8px, .72cqw, 9px);\n  }\n\n  :host([embedded]) .proof-grid {\n    gap: clamp(4px, .45cqw, 6px);\n  }\n\n  :host([embedded]) .proof-grid span {\n    padding: clamp(5px, .52cqw, 7px);\n  }\n\n  :host([embedded]) .high-ticket-body {\n    gap: clamp(6px, .65cqw, 8px);\n  }\n\n  :host([embedded]) .text-tool-block.disabled .text-editor-input,\n  :host([embedded]) .text-tool-block.disabled .font-preset-grid,\n  :host([embedded]) .text-tool-block.disabled .text-effect-grid,\n  :host([embedded]) .text-tool-block.disabled .text-control-grid,\n  :host([embedded]) .text-tool-block.disabled .text-align-row,\n  :host([embedded]) .text-tool-block.disabled .fine-print {\n    display: none;\n  }\n\n  :host([embedded]) .text-tool-block.disabled {\n    min-height: 0;\n  }\n\n  :host([embedded]) .font-preset {\n    min-height: clamp(54px, 5.2cqw, 68px);\n  }\n\n  :host([embedded]) .inspector-title {\n    padding: clamp(6px, .65cqw, 8px) clamp(7px, .82cqw, 10px);\n  }\n\n  :host([embedded]) .inspector-title strong { font-size: clamp(9px, .82cqw, 11px); }\n  :host([embedded]) .inspector-body { padding: clamp(7px, .78cqw, 9px) clamp(7px, .82cqw, 10px); }\n  :host([embedded]) .field { margin-bottom: clamp(6px, .65cqw, 8px); }\n  :host([embedded]) .button {\n    min-height: clamp(30px, 2.95cqw, 38px);\n    padding-inline: clamp(9px, .95cqw, 14px);\n    font-size: clamp(9px, .82cqw, 11px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,*::before,*::after { scroll-behavior:auto!important; animation-duration:.01ms!important; transition-duration:.01ms!important; }\n}\n';
  const paths = {
    upload: '<path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5"/><path d="M5 15v4h14v-4"/>',
    sparkles: '<path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3Z"/><path d="m18.5 14 .7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3Z"/><path d="m5 14 .8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8L5 14Z"/>',
    image: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m21 15-5-5L5 20"/>',
    bulb: '<path d="M9 18h6M10 22h4"/><path d="M8.4 15.1A7 7 0 1 1 15.6 15c-.9.7-1.4 1.7-1.6 3h-4c-.2-1.2-.7-2.2-1.6-2.9Z"/>',
    type: '<path d="M5 6V4h14v2M12 4v16M8 20h8"/>',
    layers: '<path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 12 9 5 9-5M3 16l9 5 9-5"/>',
    settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1a1.7 1.7 0 0 0 1.9.3A1.7 1.7 0 0 0 10 3V2.8h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z"/>',
    undo: '<path d="M9 7 4 12l5 5"/><path d="M5 12h8a6 6 0 0 1 6 6"/>',
    redo: '<path d="m15 7 5 5-5 5"/><path d="M19 12h-8a6 6 0 0 0-6 6"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    trash: '<path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6"/>',
    center: '<path d="M12 2v20M2 12h20"/><rect x="6" y="6" width="12" height="12" rx="2"/>',
    fit: '<path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"/>',
    chevron: '<path d="m8 10 4 4 4-4"/>',
    cube: '<path d="m12 2 9 5-9 5-9-5 9-5Z"/><path d="m3 7 9 5v10l-9-5V7ZM21 7l-9 5v10l9-5V7Z"/>',
    monitor: '<rect x="3" y="4" width="18" height="14" rx="2"/><path d="M8 22h8M12 18v4"/>',
    menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
    close: '<path d="m5 5 14 14M19 5 5 19"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    check: '<path d="m5 12 4 4L19 6"/>',
    arrow: '<path d="M5 12h14M14 7l5 5-5 5"/>',
    save: '<path d="M5 3h12l2 2v16H5V3Z"/><path d="M8 3v6h8V3M8 21v-7h8v7"/>',
    eye: '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/><circle cx="12" cy="12" r="2.5"/>',
    lock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
    unlock: '<rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 7.5-2"/>',
    refresh: '<path d="M20 6v5h-5M4 18v-5h5"/><path d="M6.1 8A7 7 0 0 1 18 7l2 4M18 16a7 7 0 0 1-12 1l-2-4"/>',
    external: '<path d="M14 4h6v6M20 4l-9 9"/><path d="M19 13v7H4V5h7"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/>',
    warning: '<path d="M10.3 3.5 2.5 19a2 2 0 0 0 1.8 3h15.4a2 2 0 0 0 1.8-3L13.7 3.5a2 2 0 0 0-3.4 0Z"/><path d="M12 9v5M12 18h.01"/>',
    cart: '<path d="M3 4h2l2 12h10l3-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/>',
    shirt: '<path d="m8 4 4 2 4-2 5 3-3 5-2-1v10H8V11l-2 1-3-5 5-3Z"/>',
    folder: '<path d="M3 6h7l2 2h9v11H3V6Z"/>',
    download: '<path d="M12 3v12m0 0 4-4m-4 4-4-4M4 21h16"/>'
  };
  function icon(name, size = 18) {
    return `<svg class="icon" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] || paths.info}</svg>`;
  }
  const PRODUCTS = [
    {
      id: "tshirt",
      name: "Canvas Tee 270 重磅 T 恤",
      shortName: "T 恤",
      category: "服饰",
      type: "apparel",
      price: 169,
      colors: [["bone", "#e9e4da", "骨白"], ["black", "#1c1d20", "黑色"], ["navy", "#222b42", "海军蓝"], ["rose", "#bd7779", "烟粉"]],
      sizes: ["XS", "S", "M", "L", "XL", "2XL"],
      faces: ["front", "back"],
      physical: { widthIn: 12, heightIn: 16 },
      target: { width: 3600, height: 4800 },
      previewAspect: 1,
      listingUrl: "https://coloroutine.com/products/tee01",
      shopify: { handle: "tee01", variantMap: {} },
      mockupsByColor: colorMockups("tshirt", ["bone", "black", "navy", "rose"]),
      model3d: pixal3DModel("pixal3d/tshirt-bone-pixal3d.glb", {
        camera: { y: -0.05, z: 7.7 },
        projection: { width: 0.72, height: 0.72, offsetY: -0.02, depth: 0.34, surfaceStrength: 0.72, reliefClamp: 0.09 },
        fallbackAsset: "tshirt-production.glb"
      })
    },
    {
      id: "hoodie",
      name: "450g 重磅落肩连帽卫衣",
      shortName: "Hoodie",
      category: "服饰",
      type: "apparel",
      price: 329,
      colors: [["oat", "#d8d0c1", "燕麦"], ["black", "#202124", "黑色"], ["forest", "#30463c", "森林绿"], ["lavender", "#8d84a4", "薰衣草"]],
      sizes: ["S", "M", "L", "XL", "2XL"],
      faces: ["front", "back"],
      physical: { widthIn: 12, heightIn: 14 },
      target: { width: 3600, height: 4200 },
      previewAspect: 800 / 870,
      listingUrl: "https://coloroutine.com/products/heavyweight-soft-fleece-hoodie",
      shopify: { handle: "heavyweight-soft-fleece-hoodie", variantMap: {} },
      mockupsByColor: colorMockups("hoodie", ["oat", "black", "forest", "lavender"]),
      model3d: pixal3DModel("pixal3d/hoodie-oat-pixal3d.glb", {
        camera: { y: 0.04, z: 7.9 },
        projection: { width: 0.66, height: 0.6, offsetY: 0.02, depth: 0.34, surfaceFit: "continuous", surfaceStrength: 0.58, reliefClamp: 0.075 },
        fallbackAsset: "hoodie-production.glb"
      })
    },
    {
      id: "mug",
      name: "400ml 弧形陶瓷杯",
      shortName: "马克杯",
      category: "家居",
      type: "mug",
      price: 109,
      colors: [["white", "#f6f3eb", "白色"], ["black", "#242527", "黑色"], ["coral", "#d96862", "珊瑚红"]],
      sizes: ["11 oz", "15 oz"],
      faces: ["wrap"],
      physical: { widthIn: 8.5, heightIn: 3.5 },
      target: { width: 2550, height: 1050 },
      previewAspect: 1,
      listingUrl: "https://coloroutine.com/products/400-arc-custom-mug",
      shopify: { handle: "400-arc-custom-mug", variantMap: {} },
      mockupsByColor: { white: { wrap: { asset: "mug-white.webp" } } },
      model3d: pixal3DModel("pixal3d/mug-white-pixal3d.glb", {
        camera: { y: 0.14, z: 7.2 },
        projection: { width: 0.62, height: 0.52, offsetX: -0.08, offsetY: -0.02, depth: 0.38, surfaceStrength: 0.82, reliefClamp: 0.11 },
        faceRotationY: { wrap: 0 },
        environmentIntensity: 0.9
      })
    },
    {
      id: "phone-case",
      name: "防摔手机壳",
      shortName: "手机壳",
      category: "配件",
      type: "phone",
      price: 149,
      colors: [["clear", "#e7e9e8", "透明"], ["black", "#242527", "黑色"], ["sand", "#c5b7a3", "砂岩"]],
      sizes: ["iPhone 16", "iPhone 16 Pro", "iPhone 16 Pro Max"],
      faces: ["front"],
      physical: { widthIn: 2.8, heightIn: 5.8 },
      target: { width: 1400, height: 2900 }
    },
    {
      id: "tote",
      name: "杜邦纸质感托特包",
      shortName: "托特包",
      category: "配件",
      type: "tote",
      price: 139,
      colors: [["natural", "#d7ccb8", "原色"], ["black", "#242527", "黑色"], ["olive", "#686a50", "橄榄绿"]],
      sizes: ["标准款"],
      faces: ["front", "back"],
      physical: { widthIn: 10, heightIn: 12 },
      target: { width: 3e3, height: 3600 },
      previewAspect: 1,
      listingUrl: "https://coloroutine.com/products/custom-dupont-paper-tote-bag",
      shopify: { handle: "custom-dupont-paper-tote-bag", variantMap: {} },
      mockupsByColor: colorMockups("tote", ["natural", "black", "olive"]),
      model3d: pixal3DModel("pixal3d/tote-natural-pixal3d.glb", {
        camera: { y: -0.08, z: 7.8 },
        projection: { width: 0.72, height: 0.6, offsetY: -0.1, depth: 0.3, surfaceStrength: 0.7, reliefClamp: 0.085 }
      })
    },
    {
      id: "magnet",
      name: "定制冰箱贴",
      shortName: "冰箱贴",
      category: "家居",
      type: "magnet",
      price: 49,
      colors: [["white", "#f5f2ea", "白底"]],
      sizes: ["圆形 58 mm", "方形 60 mm"],
      faces: ["front"],
      physical: { widthIn: 2.3, heightIn: 2.3 },
      target: { width: 900, height: 900 }
    }
  ];
  Object.fromEntries(PRODUCTS.map((product) => [product.id, product]));
  const FACE_LABELS = { front: "正面", back: "背面", wrap: "环绕面" };
  function hydrateProductAssets(products, assetMap = {}, base = "/product-mockups/", modelAssetMap = {}, modelBase = "/product-models/") {
    return products.map((product) => {
      const modelAsset = product.model3d?.asset || "";
      const hydrated = {
        ...product,
        mockupsByColor: {},
        model3d: product.model3d ? {
          ...product.model3d,
          url: product.model3d.url || (modelAsset ? modelAssetMap[modelAsset] || `${modelBase}${modelAsset}` : "")
        } : void 0
      };
      for (const [colorId, faces] of Object.entries(product.mockupsByColor || {})) {
        hydrated.mockupsByColor[colorId] = Object.fromEntries(Object.entries(faces).map(([face, item]) => {
          const asset = item.asset || "";
          return [face, { ...item, url: item.url || assetMap[asset] || `${base}${asset}` }];
        }));
      }
      return hydrated;
    });
  }
  function getProductColor(product, colorId) {
    return product.colors.find(([id]) => id === colorId) || product.colors[0];
  }
  function formatMoney(amount, currency = "HKD") {
    return new Intl.NumberFormat("zh-HK", { style: "currency", currency, maximumFractionDigits: 0 }).format(amount);
  }
  function normalizeVariantMap(raw) {
    if (!raw) return {};
    if (typeof raw === "object") return raw;
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  function colorMockups(prefix, colorIds) {
    return Object.fromEntries(colorIds.map((colorId) => [colorId, { front: { asset: `${prefix}-${colorId}.webp` } }]));
  }
  function pixal3DModel(asset, options = {}) {
    const projection = options.projection || {};
    return {
      asset,
      fallbackAsset: options.fallbackAsset || "",
      format: "glb",
      autoFit: true,
      projection: {
        mode: "decal",
        width: projection.width ?? 0.42,
        height: projection.height ?? 0.46,
        offsetX: projection.offsetX ?? 0,
        offsetY: projection.offsetY ?? 0,
        depth: projection.depth ?? 0.28,
        rotation: projection.rotation ?? 0,
        surfaceFit: projection.surfaceFit || "continuous",
        surfaceStrength: projection.surfaceStrength ?? 1,
        reliefClamp: projection.reliefClamp ?? 0.12
      },
      faceRotationY: options.faceRotationY || { front: 0, back: Math.PI },
      // DecalGeometry uses bottom-left UVs while the editable Canvas uses a
      // top-left origin. Flip the uploaded canvas so top stays top on the model.
      texture: { flipY: options.texture?.flipY ?? true, flipX: options.texture?.flipX ?? false, rotation: options.texture?.rotation ?? 0 },
      transform: { scale: 1, x: 0, y: 0, z: 0, rotationX: 0, rotationY: 0, rotationZ: 0 },
      tintBaseMaterial: true,
      source: { engine: "Pixal3D", profile: "int8-lowvram", textureResolution: 2048 },
      environmentIntensity: options.environmentIntensity ?? 0.78,
      fallback: true,
      camera: { x: 0, y: options.camera?.y ?? 0, z: options.camera?.z ?? 7.7, targetX: 0, targetY: options.camera?.targetY ?? 0, targetZ: 0 }
    };
  }
  function designAspect(product) {
    return product.physical.widthIn / product.physical.heightIn;
  }
  function displayedPrintAspect(product, area2) {
    const previewAspect = product.previewAspect || 360 / 540;
    return previewAspect * area2.width / area2.height;
  }
  function mappingError(product, area2) {
    return Math.abs(displayedPrintAspect(product, area2) / designAspect(product) - 1);
  }
  function calibratePrintArea(product, area2) {
    const previewAspect = product.previewAspect || 360 / 540;
    const targetAspect = designAspect(product);
    const source = {
      left: Number(area2?.left) || 0,
      top: Number(area2?.top) || 0,
      width: Math.max(1, Number(area2?.width) || 1),
      height: Math.max(1, Number(area2?.height) || 1)
    };
    let width = Math.min(100, source.width);
    let height = previewAspect * width / targetAspect;
    if (height > 100) {
      height = 100;
      width = targetAspect * height / previewAspect;
    }
    const centerX = source.left + source.width / 2;
    const centerY = source.top + source.height / 2;
    return {
      left: Math.max(0, Math.min(100 - width, centerX - width / 2)),
      top: Math.max(0, Math.min(100 - height, centerY - height / 2)),
      width,
      height
    };
  }
  function mappedSurfaceSize(product, height) {
    return { width: height * designAspect(product), height };
  }
  function mappedWrapAngle(product, height, radius) {
    return Math.min(Math.PI * 2 - 0.12, Math.max(0.4, height * designAspect(product) / radius));
  }
  function createMappedDesignCanvas(sourceCanvas, product) {
    const aspect2 = designAspect(product);
    const sourceWidth = Math.max(1, sourceCanvas?.width || 1);
    const sourceHeight = Math.max(1, sourceCanvas?.height || 1);
    const longEdge = Math.min(2048, Math.max(1024, sourceWidth, sourceHeight));
    const width = aspect2 >= 1 ? longEdge : Math.max(1, Math.round(longEdge * aspect2));
    const height = aspect2 >= 1 ? Math.max(1, Math.round(longEdge / aspect2)) : longEdge;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, width, height);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.drawImage(sourceCanvas, 0, 0, sourceWidth, sourceHeight, 0, 0, width, height);
    return canvas;
  }
  function shirtPath(hoodie = false) {
    return hoodie ? "M214 62c30 4 49 16 66 35l65 28-41 88-38-22v289H94V191l-38 22-41-88 65-28c17-19 36-31 66-35 7 28 61 28 68 0Z" : "M146 54c10 26 58 26 68 0l78 30 57 72-57 53-31-32v303H99V177l-31 32-57-53 57-72 78-30Z";
  }
  function productSvg(product, color, face = "front") {
    const customMockup = productMockupURL(product, color, face);
    if (customMockup) return `<img src="${escapeAttribute(customMockup)}" alt="${escapeAttribute(product.name)} ${face}" crossorigin="anonymous" />`;
    const fill = color?.[1] || "#e9e4da";
    const stroke = isDark(fill) ? "#585b62" : "#c4bdb1";
    const shadow = "rgba(0,0,0,.20)";
    if (product.type === "apparel") {
      const hoodie = product.id === "hoodie";
      return `<svg viewBox="0 0 360 540" role="img" aria-label="${product.name}${face === "back" ? "背面" : "正面"}">
      <defs><filter id="s"><feDropShadow dx="0" dy="12" stdDeviation="12" flood-color="${shadow}"/></filter><linearGradient id="g" x1="0" x2="1"><stop stop-color="${shade(fill, -8)}"/><stop offset=".48" stop-color="${fill}"/><stop offset="1" stop-color="${shade(fill, -12)}"/></linearGradient></defs>
      <path d="${shirtPath(hoodie)}" fill="url(#g)" stroke="${stroke}" stroke-width="2" filter="url(#s)"/>
      ${hoodie ? `<path d="M126 82c4-43 24-61 54-61s50 18 54 61c-22 31-86 31-108 0Z" fill="${shade(fill, -14)}" stroke="${stroke}"/><path d="M112 372h136v58H112z" fill="none" stroke="${stroke}" opacity=".65"/><path d="M180 106v272" stroke="${stroke}" opacity=".35"/>` : `<path d="M146 55c6 35 62 35 68 0" fill="none" stroke="${stroke}" stroke-width="3"/>`}
      <path d="M100 177 83 424M260 177l17 247" fill="none" stroke="${stroke}" opacity=".28"/>
    </svg>`;
    }
    if (product.type === "mug") {
      return `<svg viewBox="0 0 420 430" role="img" aria-label="${product.name}"><defs><filter id="s"><feDropShadow dy="14" stdDeviation="11" flood-color="${shadow}"/></filter><linearGradient id="g"><stop stop-color="${shade(fill, -8)}"/><stop offset=".5" stop-color="${fill}"/><stop offset="1" stop-color="${shade(fill, -16)}"/></linearGradient></defs><path d="M105 92h202v257c0 31-38 52-101 52s-101-21-101-52V92Z" fill="url(#g)" stroke="${stroke}" stroke-width="2" filter="url(#s)"/><ellipse cx="206" cy="92" rx="101" ry="28" fill="${shade(fill, -18)}" stroke="${stroke}" stroke-width="2"/><ellipse cx="206" cy="95" rx="85" ry="19" fill="#25262b"/><path d="M307 143h28c51 0 64 43 58 82-7 43-32 77-86 70v-42c30 4 43-8 47-33 4-24-4-39-28-39h-19" fill="none" stroke="${fill}" stroke-width="28"/><path d="M307 143h28c51 0 64 43 58 82-7 43-32 77-86 70" fill="none" stroke="${stroke}" stroke-width="2"/></svg>`;
    }
    if (product.type === "phone") {
      return `<svg viewBox="0 0 340 570" role="img" aria-label="${product.name}"><defs><filter id="s"><feDropShadow dy="14" stdDeviation="12" flood-color="${shadow}"/></filter><linearGradient id="g" x2="1" y2="1"><stop stop-color="${shade(fill, 8)}"/><stop offset="1" stop-color="${shade(fill, -15)}"/></linearGradient></defs><rect x="58" y="20" width="224" height="520" rx="45" fill="url(#g)" stroke="${stroke}" stroke-width="4" filter="url(#s)"/><rect x="76" y="39" width="188" height="482" rx="32" fill="${fill}" opacity=".76"/><rect x="82" y="46" width="82" height="101" rx="26" fill="${shade(fill, -25)}" opacity=".88"/><circle cx="108" cy="76" r="17" fill="#191a1e"/><circle cx="139" cy="111" r="17" fill="#191a1e"/><circle cx="106" cy="126" r="7" fill="#d8d2c3"/></svg>`;
    }
    if (product.type === "tote") {
      return `<svg viewBox="0 0 380 520" role="img" aria-label="${product.name}"><defs><filter id="s"><feDropShadow dy="14" stdDeviation="12" flood-color="${shadow}"/></filter><linearGradient id="g" x2="1"><stop stop-color="${shade(fill, -8)}"/><stop offset=".5" stop-color="${fill}"/><stop offset="1" stop-color="${shade(fill, -10)}"/></linearGradient></defs><path d="M72 133h236l28 344H44l28-344Z" fill="url(#g)" stroke="${stroke}" stroke-width="2" filter="url(#s)"/><path d="M111 155c0-77 25-118 79-118s79 41 79 118" fill="none" stroke="${shade(fill, -12)}" stroke-width="20"/><path d="M111 155c0-77 25-118 79-118s79 41 79 118" fill="none" stroke="${stroke}" stroke-width="2"/><path d="M72 133h236" stroke="${stroke}" opacity=".7"/></svg>`;
    }
    return `<svg viewBox="0 0 400 430" role="img" aria-label="${product.name}"><defs><filter id="s"><feDropShadow dy="18" stdDeviation="13" flood-color="${shadow}"/></filter><radialGradient id="g"><stop offset=".75" stop-color="${fill}"/><stop offset="1" stop-color="${shade(fill, -18)}"/></radialGradient></defs><circle cx="200" cy="205" r="152" fill="url(#g)" stroke="${stroke}" stroke-width="5" filter="url(#s)"/><circle cx="200" cy="205" r="140" fill="none" stroke="${shade(fill, -12)}" stroke-width="2"/></svg>`;
  }
  function productPrintArea(product, face = "front") {
    const map = {
      tshirt: { left: 32, top: 27, width: 36, height: 48 },
      hoodie: { left: 33, top: 27, width: 34, height: 36.48 },
      mug: { left: 21, top: 38, width: 58, height: 23.88 },
      "phone-case": { left: 28, top: 24, width: 44, height: 60.8 },
      tote: { left: 30, top: 42, width: 40, height: 48 },
      magnet: { left: 26, top: 27, width: 48, height: 32 }
    };
    return calibratePrintArea(product, product.printAreas?.[face] || map[product.id] || map.tshirt);
  }
  function productMockupURL(product, color, face = "front") {
    const colorId = color?.[0];
    const colorMockups2 = product.mockupsByColor?.[colorId];
    const colorItem = colorMockups2?.[face] || (face === "front" || face === "wrap" ? colorMockups2?.front || colorMockups2?.wrap : null);
    if (colorItem?.url) return colorItem.url;
    const customItem = product.mockups?.[face] || (face === "front" || face === "wrap" ? product.mockups?.front || product.mockups?.wrap : null);
    return customItem?.url || "";
  }
  function escapeAttribute(value = "") {
    return String(value).replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
  }
  function isDark(hex) {
    const [r2, g2, b2] = hexToRgb(hex);
    return (r2 * 299 + g2 * 587 + b2 * 114) / 1e3 < 125;
  }
  function shade(hex, amount) {
    const [r2, g2, b2] = hexToRgb(hex).map((value) => Math.max(0, Math.min(255, value + amount)));
    return `rgb(${r2},${g2},${b2})`;
  }
  function hexToRgb(hex) {
    const normalized = hex.replace("#", "");
    if (normalized.length !== 6) return [220, 220, 220];
    return [0, 2, 4].map((offset) => parseInt(normalized.slice(offset, offset + 2), 16));
  }
  var e = Object.defineProperty, t = (t2, n2) => {
    let r2 = {};
    for (var i2 in t2) e(r2, i2, { get: t2[i2], enumerable: true });
    return e(r2, Symbol.toStringTag, { value: `Module` }), r2;
  };
  function n(e2) {
    return n = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(e3) {
      return typeof e3;
    } : function(e3) {
      return e3 && typeof Symbol == `function` && e3.constructor === Symbol && e3 !== Symbol.prototype ? `symbol` : typeof e3;
    }, n(e2);
  }
  function r(e2) {
    var t2 = (function(e3, t3) {
      if (n(e3) != `object` || !e3) return e3;
      var r2 = e3[Symbol.toPrimitive];
      if (r2 !== void 0) {
        var i2 = r2.call(e3, t3);
        if (n(i2) != `object`) return i2;
        throw TypeError(`@@toPrimitive must return a primitive value.`);
      }
      return (t3 === `string` ? String : Number)(e3);
    })(e2, `string`);
    return n(t2) == `symbol` ? t2 : t2 + ``;
  }
  function i(e2, t2, n2) {
    return (t2 = r(t2)) in e2 ? Object.defineProperty(e2, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e2[t2] = n2, e2;
  }
  var a = class {
    constructor() {
      i(this, `browserShadowBlurConstant`, 1), i(this, `DPI`, 96), i(this, `devicePixelRatio`, typeof window < `u` ? window.devicePixelRatio : 1), i(this, `perfLimitSizeTotal`, 2097152), i(this, `maxCacheSideLimit`, 4096), i(this, `minCacheSideLimit`, 256), i(this, `disableStyleCopyPaste`, false), i(this, `enableGLFiltering`, true), i(this, `textureSize`, 4096), i(this, `forceGLPutImageData`, false), i(this, `cachesBoundsOfCurve`, false), i(this, `fontPaths`, {}), i(this, `NUM_FRACTION_DIGITS`, 4);
    }
  };
  const o = new class extends a {
    constructor(e2) {
      super(), this.configure(e2);
    }
    configure(e2 = {}) {
      Object.assign(this, e2);
    }
    addFonts(e2 = {}) {
      this.fontPaths = { ...this.fontPaths, ...e2 };
    }
    removeFonts(e2 = []) {
      e2.forEach((e3) => {
        delete this.fontPaths[e3];
      });
    }
    clearFonts() {
      this.fontPaths = {};
    }
    restoreDefaults(e2) {
      let t2 = new a(), n2 = (e2 == null ? void 0 : e2.reduce((e3, n3) => (e3[n3] = t2[n3], e3), {})) || t2;
      this.configure(n2);
    }
  }(), s = (e2, ...t2) => console[e2](`fabric`, ...t2);
  var c = class extends Error {
    constructor(e2, t2) {
      super(`fabric: ${e2}`, t2);
    }
  }, l = class extends c {
    constructor(e2) {
      super(`${e2} 'options.signal' is in 'aborted' state`);
    }
  }, u = class {
  }, d = class extends u {
    testPrecision(e2, t2) {
      let n2 = `precision ${t2} float;
void main(){}`, r2 = e2.createShader(e2.FRAGMENT_SHADER);
      return !!r2 && (e2.shaderSource(r2, n2), e2.compileShader(r2), !!e2.getShaderParameter(r2, e2.COMPILE_STATUS));
    }
    queryWebGL(e2) {
      let t2 = e2.getContext(`webgl`);
      t2 && (this.maxTextureSize = t2.getParameter(t2.MAX_TEXTURE_SIZE), this.GLPrecision = [`highp`, `mediump`, `lowp`].find((e3) => this.testPrecision(t2, e3)), t2.getExtension(`WEBGL_lose_context`).loseContext(), s(`log`, `WebGL: max texture size ${this.maxTextureSize}`));
    }
    isSupported(e2) {
      return !!this.maxTextureSize && this.maxTextureSize >= e2;
    }
  };
  const f = {};
  let p;
  const h = () => p || (p = { document, window, isTouchSupported: `ontouchstart` in window || `ontouchstart` in document || window && window.navigator && window.navigator.maxTouchPoints > 0, WebGLProbe: new d(), dispose() {
  }, copyPasteData: f }), g = () => h().document, _ = () => h().window, v = () => {
    var e2;
    return Math.max((e2 = o.devicePixelRatio) == null ? _().devicePixelRatio : e2, 1);
  }, y = new class {
    constructor() {
      i(this, `boundsOfCurveCache`, {}), this.charWidthsCache = /* @__PURE__ */ new Map();
    }
    getFontCache({ fontFamily: e2, fontStyle: t2, fontWeight: n2 }) {
      e2 = e2.toLowerCase();
      let r2 = this.charWidthsCache;
      r2.has(e2) || r2.set(e2, /* @__PURE__ */ new Map());
      let i2 = r2.get(e2), a2 = `${t2.toLowerCase()}_${(n2 + ``).toLowerCase()}`;
      return i2.has(a2) || i2.set(a2, /* @__PURE__ */ new Map()), i2.get(a2);
    }
    clearFontCache(e2) {
      e2 ? this.charWidthsCache.delete((e2 || ``).toLowerCase()) : this.charWidthsCache = /* @__PURE__ */ new Map();
    }
    limitDimsByArea(e2) {
      let { perfLimitSizeTotal: t2 } = o, n2 = Math.sqrt(t2 * e2);
      return [Math.floor(n2), Math.floor(t2 / n2)];
    }
  }(), b = `7.4.0`;
  function x() {
  }
  const S = Math.PI / 2, C = Math.PI / 4, w = 2 * Math.PI, ee = Math.PI / 180, T = Object.freeze([1, 0, 0, 1, 0, 0]), E = `center`, D = `left`, O = `bottom`, k = `right`, te = `none`, ne = /\r?\n/, re = `moving`, ie = `scaling`, ae = `rotating`, oe = `rotate`, A = `skewing`, se = `resizing`, ce = `modifyPoly`, le = `changed`, ue = `scale`, de = `scaleX`, fe = `scaleY`, pe = `skewX`, me = `skewY`, j = `fill`, he = `stroke`, ge = `modified`, _e = `normal`, ve = `json`, M = new class {
    constructor() {
      this[ve] = /* @__PURE__ */ new Map(), this.svg = /* @__PURE__ */ new Map();
    }
    has(e2) {
      return this[ve].has(e2);
    }
    getClass(e2) {
      let t2 = this[ve].get(e2);
      if (!t2) throw new c(`No class registered for ${e2}`);
      return t2;
    }
    setClass(e2, t2) {
      t2 ? this[ve].set(t2, e2) : (this[ve].set(e2.type, e2), this[ve].set(e2.type.toLowerCase(), e2));
    }
    getSVGClass(e2) {
      return this.svg.get(e2);
    }
    setSVGClass(e2, t2) {
      this.svg.set(t2 == null ? e2.type.toLowerCase() : t2, e2);
    }
  }(), ye = new class extends Array {
    remove(e2) {
      let t2 = this.indexOf(e2);
      t2 > -1 && this.splice(t2, 1);
    }
    cancelAll() {
      let e2 = this.splice(0);
      return e2.forEach((e3) => e3.abort()), e2;
    }
    cancelByCanvas(e2) {
      if (!e2) return [];
      let t2 = this.filter((t3) => {
        var n2;
        return t3.target === e2 || typeof t3.target == `object` && ((n2 = t3.target) == null ? void 0 : n2.canvas) === e2;
      });
      return t2.forEach((e3) => e3.abort()), t2;
    }
    cancelByTarget(e2) {
      if (!e2) return [];
      let t2 = this.filter((t3) => t3.target === e2);
      return t2.forEach((e3) => e3.abort()), t2;
    }
  }();
  var be = class {
    constructor() {
      i(this, `__eventListeners`, {});
    }
    on(e2, t2) {
      if (this.__eventListeners || (this.__eventListeners = {}), typeof e2 == `object`) return Object.entries(e2).forEach(([e3, t3]) => {
        this.on(e3, t3);
      }), () => this.off(e2);
      if (t2) {
        let n2 = e2;
        return this.__eventListeners[n2] || (this.__eventListeners[n2] = []), this.__eventListeners[n2].push(t2), () => this.off(n2, t2);
      }
      return () => false;
    }
    once(e2, t2) {
      if (typeof e2 == `object`) {
        let t3 = [];
        return Object.entries(e2).forEach(([e3, n2]) => {
          t3.push(this.once(e3, n2));
        }), () => t3.forEach((e3) => e3());
      }
      if (t2) {
        let n2 = this.on(e2, function(...e3) {
          t2.call(this, ...e3), n2();
        });
        return n2;
      }
      return () => false;
    }
    _removeEventListener(e2, t2) {
      if (this.__eventListeners[e2]) if (t2) {
        let n2 = this.__eventListeners[e2], r2 = n2.indexOf(t2);
        r2 > -1 && n2.splice(r2, 1);
      } else this.__eventListeners[e2] = [];
    }
    off(e2, t2) {
      if (this.__eventListeners) if (e2 === void 0) for (let e3 in this.__eventListeners) this._removeEventListener(e3);
      else typeof e2 == `object` ? Object.entries(e2).forEach(([e3, t3]) => {
        this._removeEventListener(e3, t3);
      }) : this._removeEventListener(e2, t2);
    }
    fire(e2, t2) {
      var n2;
      if (!this.__eventListeners) return;
      let r2 = (n2 = this.__eventListeners[e2]) == null ? void 0 : n2.concat();
      if (r2) for (let e3 = 0; e3 < r2.length; e3++) r2[e3].call(this, t2 || {});
    }
  };
  const xe = (e2, t2) => {
    let n2 = e2.indexOf(t2);
    return n2 !== -1 && e2.splice(n2, 1), e2;
  }, Se = (e2) => {
    if (e2 === 0) return 1;
    switch (Math.abs(e2) / S) {
      case 1:
      case 3:
        return 0;
      case 2:
        return -1;
    }
    return Math.cos(e2);
  }, Ce = (e2) => {
    if (e2 === 0) return 0;
    let t2 = e2 / S, n2 = Math.sign(e2);
    switch (t2) {
      case 1:
        return n2;
      case 2:
        return 0;
      case 3:
        return -n2;
    }
    return Math.sin(e2);
  };
  var N = class e2 {
    constructor(e3 = 0, t2 = 0) {
      typeof e3 == `object` ? (this.x = e3.x, this.y = e3.y) : (this.x = e3, this.y = t2);
    }
    add(t2) {
      return new e2(this.x + t2.x, this.y + t2.y);
    }
    addEquals(e3) {
      return this.x += e3.x, this.y += e3.y, this;
    }
    scalarAdd(t2) {
      return new e2(this.x + t2, this.y + t2);
    }
    scalarAddEquals(e3) {
      return this.x += e3, this.y += e3, this;
    }
    subtract(t2) {
      return new e2(this.x - t2.x, this.y - t2.y);
    }
    subtractEquals(e3) {
      return this.x -= e3.x, this.y -= e3.y, this;
    }
    scalarSubtract(t2) {
      return new e2(this.x - t2, this.y - t2);
    }
    scalarSubtractEquals(e3) {
      return this.x -= e3, this.y -= e3, this;
    }
    multiply(t2) {
      return new e2(this.x * t2.x, this.y * t2.y);
    }
    scalarMultiply(t2) {
      return new e2(this.x * t2, this.y * t2);
    }
    scalarMultiplyEquals(e3) {
      return this.x *= e3, this.y *= e3, this;
    }
    divide(t2) {
      return new e2(this.x / t2.x, this.y / t2.y);
    }
    scalarDivide(t2) {
      return new e2(this.x / t2, this.y / t2);
    }
    scalarDivideEquals(e3) {
      return this.x /= e3, this.y /= e3, this;
    }
    eq(e3) {
      return this.x === e3.x && this.y === e3.y;
    }
    lt(e3) {
      return this.x < e3.x && this.y < e3.y;
    }
    lte(e3) {
      return this.x <= e3.x && this.y <= e3.y;
    }
    gt(e3) {
      return this.x > e3.x && this.y > e3.y;
    }
    gte(e3) {
      return this.x >= e3.x && this.y >= e3.y;
    }
    lerp(t2, n2 = 0.5) {
      return n2 = Math.max(Math.min(1, n2), 0), new e2(this.x + (t2.x - this.x) * n2, this.y + (t2.y - this.y) * n2);
    }
    distanceFrom(e3) {
      let t2 = this.x - e3.x, n2 = this.y - e3.y;
      return Math.sqrt(t2 * t2 + n2 * n2);
    }
    midPointFrom(e3) {
      return this.lerp(e3);
    }
    min(t2) {
      return new e2(Math.min(this.x, t2.x), Math.min(this.y, t2.y));
    }
    max(t2) {
      return new e2(Math.max(this.x, t2.x), Math.max(this.y, t2.y));
    }
    toString() {
      return `${this.x},${this.y}`;
    }
    setXY(e3, t2) {
      return this.x = e3, this.y = t2, this;
    }
    setX(e3) {
      return this.x = e3, this;
    }
    setY(e3) {
      return this.y = e3, this;
    }
    setFromPoint(e3) {
      return this.x = e3.x, this.y = e3.y, this;
    }
    swap(e3) {
      let t2 = this.x, n2 = this.y;
      this.x = e3.x, this.y = e3.y, e3.x = t2, e3.y = n2;
    }
    clone() {
      return new e2(this.x, this.y);
    }
    rotate(t2, n2 = we) {
      let r2 = Ce(t2), i2 = Se(t2), a2 = this.subtract(n2);
      return new e2(a2.x * i2 - a2.y * r2, a2.x * r2 + a2.y * i2).add(n2);
    }
    transform(t2, n2 = false) {
      return new e2(t2[0] * this.x + t2[2] * this.y + (n2 ? 0 : t2[4]), t2[1] * this.x + t2[3] * this.y + (n2 ? 0 : t2[5]));
    }
  };
  const we = new N(0, 0), Te = (e2) => !!e2 && Array.isArray(e2._objects);
  function Ee(e2) {
    class t2 extends e2 {
      constructor(...e3) {
        super(...e3), i(this, `_objects`, []);
      }
      _onObjectAdded(e3) {
      }
      _onObjectRemoved(e3) {
      }
      _onStackOrderChanged(e3) {
      }
      add(...e3) {
        let t3 = this._objects.push(...e3);
        return e3.forEach((e4) => this._onObjectAdded(e4)), t3;
      }
      insertAt(e3, ...t3) {
        return this._objects.splice(e3, 0, ...t3), t3.forEach((e4) => this._onObjectAdded(e4)), this._objects.length;
      }
      remove(...e3) {
        let t3 = this._objects, n2 = [];
        return e3.forEach((e4) => {
          let r2 = t3.indexOf(e4);
          r2 !== -1 && (t3.splice(r2, 1), n2.push(e4), this._onObjectRemoved(e4));
        }), n2;
      }
      forEachObject(e3) {
        this.getObjects().forEach((t3, n2, r2) => e3(t3, n2, r2));
      }
      getObjects(...e3) {
        return e3.length === 0 ? [...this._objects] : this._objects.filter((t3) => t3.isType(...e3));
      }
      item(e3) {
        return this._objects[e3];
      }
      isEmpty() {
        return this._objects.length === 0;
      }
      size() {
        return this._objects.length;
      }
      contains(e3, n2) {
        return !!this._objects.includes(e3) || !!n2 && this._objects.some((n3) => n3 instanceof t2 && n3.contains(e3, true));
      }
      complexity() {
        return this._objects.reduce((e3, t3) => e3 += t3.complexity ? t3.complexity() : 0, 0);
      }
      sendObjectToBack(e3) {
        return !(!e3 || e3 === this._objects[0]) && (xe(this._objects, e3), this._objects.unshift(e3), this._onStackOrderChanged(e3), true);
      }
      bringObjectToFront(e3) {
        return !(!e3 || e3 === this._objects[this._objects.length - 1]) && (xe(this._objects, e3), this._objects.push(e3), this._onStackOrderChanged(e3), true);
      }
      sendObjectBackwards(e3, t3) {
        if (!e3) return false;
        let n2 = this._objects.indexOf(e3);
        if (n2 !== 0) {
          let r2 = this.findNewLowerIndex(e3, n2, t3);
          return xe(this._objects, e3), this._objects.splice(r2, 0, e3), this._onStackOrderChanged(e3), true;
        }
        return false;
      }
      bringObjectForward(e3, t3) {
        if (!e3) return false;
        let n2 = this._objects.indexOf(e3);
        if (n2 !== this._objects.length - 1) {
          let r2 = this.findNewUpperIndex(e3, n2, t3);
          return xe(this._objects, e3), this._objects.splice(r2, 0, e3), this._onStackOrderChanged(e3), true;
        }
        return false;
      }
      moveObjectTo(e3, t3) {
        return e3 !== this._objects[t3] && (xe(this._objects, e3), this._objects.splice(t3, 0, e3), this._onStackOrderChanged(e3), true);
      }
      findNewLowerIndex(e3, t3, n2) {
        let r2;
        if (n2) {
          r2 = t3;
          for (let n3 = t3 - 1; n3 >= 0; --n3) if (e3.isOverlapping(this._objects[n3])) {
            r2 = n3;
            break;
          }
        } else r2 = t3 - 1;
        return r2;
      }
      findNewUpperIndex(e3, t3, n2) {
        let r2;
        if (n2) {
          r2 = t3;
          for (let n3 = t3 + 1; n3 < this._objects.length; ++n3) if (e3.isOverlapping(this._objects[n3])) {
            r2 = n3;
            break;
          }
        } else r2 = t3 + 1;
        return r2;
      }
      collectObjects({ left: e3, top: t3, width: n2, height: r2 }, { includeIntersecting: i2 = true } = {}) {
        let a2 = [], o2 = new N(e3, t3), s2 = o2.add(new N(n2, r2));
        for (let e4 = this._objects.length - 1; e4 >= 0; e4--) {
          let t4 = this._objects[e4];
          t4.selectable && t4.visible && (i2 && t4.intersectsWithRect(o2, s2) || t4.isContainedWithinRect(o2, s2) || i2 && t4.containsPoint(o2) || i2 && t4.containsPoint(s2)) && a2.push(t4);
        }
        return a2;
      }
    }
    return t2;
  }
  var De = class extends be {
    _setOptions(e2 = {}) {
      for (let t2 in e2) this.set(t2, e2[t2]);
    }
    _setObject(e2) {
      for (let t2 in e2) this._set(t2, e2[t2]);
    }
    set(e2, t2) {
      return typeof e2 == `object` ? this._setObject(e2) : this._set(e2, t2), this;
    }
    _set(e2, t2) {
      this[e2] = t2;
    }
    toggle(e2) {
      let t2 = this.get(e2);
      return typeof t2 == `boolean` && this.set(e2, !t2), this;
    }
    get(e2) {
      return this[e2];
    }
  };
  function Oe(e2) {
    return _().requestAnimationFrame(e2);
  }
  function ke(e2) {
    return _().cancelAnimationFrame(e2);
  }
  let Ae = 0;
  const je = () => Ae++, P = () => {
    let e2 = g().createElement(`canvas`);
    if (!e2 || e2.getContext === void 0) throw new c("Failed to create `canvas` element");
    return e2;
  }, Me = () => g().createElement(`img`), Ne = (e2) => {
    var t2;
    let n2 = F(e2);
    return (t2 = n2.getContext(`2d`)) == null || t2.drawImage(e2, 0, 0), n2;
  }, F = (e2) => {
    let t2 = P();
    return t2.width = e2.width, t2.height = e2.height, t2;
  }, Pe = (e2, t2, n2) => e2.toDataURL(`image/${t2}`, n2), Fe = (e2, t2, n2) => new Promise((r2, i2) => {
    e2.toBlob(r2, `image/${t2}`, n2);
  }), I = (e2) => e2 * ee, Ie = (e2) => e2 / ee, Le = (e2) => e2.every((e3, t2) => e3 === T[t2]), L = (e2, t2, n2) => new N(e2).transform(t2, n2), R = (e2) => {
    let t2 = 1 / (e2[0] * e2[3] - e2[1] * e2[2]), n2 = [t2 * e2[3], -t2 * e2[1], -t2 * e2[2], t2 * e2[0], 0, 0], { x: r2, y: i2 } = new N(e2[4], e2[5]).transform(n2, true);
    return n2[4] = -r2, n2[5] = -i2, n2;
  }, z = (e2, t2, n2) => [e2[0] * t2[0] + e2[2] * t2[1], e2[1] * t2[0] + e2[3] * t2[1], e2[0] * t2[2] + e2[2] * t2[3], e2[1] * t2[2] + e2[3] * t2[3], n2 ? 0 : e2[0] * t2[4] + e2[2] * t2[5] + e2[4], n2 ? 0 : e2[1] * t2[4] + e2[3] * t2[5] + e2[5]], Re = (e2, t2) => e2.reduceRight((e3, n2) => n2 && e3 ? z(n2, e3, t2) : n2 || e3, void 0) || T.concat(), ze = ([e2, t2]) => Math.atan2(t2, e2), Be = ([e2, t2]) => Math.sqrt(e2 * e2 + t2 * t2), Ve = ([, , e2, t2]) => Math.sqrt(e2 * e2 + t2 * t2), He = (e2) => {
    let t2 = ze(e2), n2 = e2[0] ** 2 + e2[1] ** 2, r2 = Math.sqrt(n2), i2 = (e2[0] * e2[3] - e2[2] * e2[1]) / r2, a2 = Math.atan2(e2[0] * e2[2] + e2[1] * e2[3], n2);
    return { angle: Ie(t2), scaleX: r2, scaleY: i2, skewX: Ie(a2), skewY: 0, translateX: e2[4] || 0, translateY: e2[5] || 0 };
  }, Ue = (e2, t2 = 0) => [1, 0, 0, 1, e2, t2];
  function We({ angle: e2 = 0 } = {}, { x: t2 = 0, y: n2 = 0 } = {}) {
    let r2 = I(e2), i2 = Se(r2), a2 = Ce(r2);
    return [i2, a2, -a2, i2, t2 ? t2 - (i2 * t2 - a2 * n2) : 0, n2 ? n2 - (a2 * t2 + i2 * n2) : 0];
  }
  const Ge = (e2, t2 = e2) => [e2, 0, 0, t2, 0, 0], Ke = (e2) => Math.tan(I(e2)), qe = (e2) => [1, 0, Ke(e2), 1, 0, 0], Je = (e2) => [1, Ke(e2), 0, 1, 0, 0], Ye = ({ scaleX: e2 = 1, scaleY: t2 = 1, flipX: n2 = false, flipY: r2 = false, skewX: i2 = 0, skewY: a2 = 0 }) => {
    let o2 = Ge(n2 ? -e2 : e2, r2 ? -t2 : t2);
    return i2 && (o2 = z(o2, qe(i2), true)), a2 && (o2 = z(o2, Je(a2), true)), o2;
  }, Xe = (e2) => {
    let { translateX: t2 = 0, translateY: n2 = 0, angle: r2 = 0 } = e2, i2 = Ue(t2, n2);
    r2 && (i2 = z(i2, We({ angle: r2 })));
    let a2 = Ye(e2);
    return Le(a2) || (i2 = z(i2, a2)), i2;
  }, Ze = (e2, { signal: t2, crossOrigin: n2 = null } = {}) => new Promise(function(r2, i2) {
    if (t2 && t2.aborted) return i2(new l(`loadImage`));
    let a2 = Me(), o2;
    t2 && (o2 = function(e3) {
      a2.src = ``, i2(e3);
    }, t2.addEventListener(`abort`, o2, { once: true }));
    let s2 = function() {
      a2.onload = a2.onerror = null, o2 && (t2 == null || t2.removeEventListener(`abort`, o2)), r2(a2);
    };
    e2 ? (a2.onload = s2, a2.onerror = function() {
      o2 && (t2 == null || t2.removeEventListener(`abort`, o2)), i2(new c(`Error loading ${a2.src}`));
    }, n2 && (a2.crossOrigin = n2), a2.src = e2) : s2();
  }), Qe = (e2, { signal: t2, reviver: n2 = x } = {}) => new Promise((r2, i2) => {
    let a2 = [];
    t2 && t2.addEventListener(`abort`, i2, { once: true }), Promise.allSettled(e2.map((e3) => M.getClass(e3.type).fromObject(e3, { signal: t2 }))).then(async (t3) => {
      for (let [r3, i3] of t3.entries()) if (i3.status === `fulfilled` && (await n2(e2[r3], i3.value), a2.push(i3.value)), i3.status === `rejected`) {
        let t4 = await n2(e2[r3], void 0, i3.reason);
        t4 && a2.push(t4);
      }
      r2(a2);
    }).catch((e3) => {
      a2.forEach((e4) => {
        e4.dispose && e4.dispose();
      }), i2(e3);
    }).finally(() => {
      t2 && t2.removeEventListener(`abort`, i2);
    });
  }), $e = (e2, { signal: t2 } = {}) => new Promise((n2, r2) => {
    let i2 = [];
    t2 && t2.addEventListener(`abort`, r2, { once: true });
    let a2 = Object.values(e2).map((e3) => e3 && e3.type && M.has(e3.type) ? Qe([e3], { signal: t2 }).then(([e4]) => (i2.push(e4), e4)) : e3), o2 = Object.keys(e2);
    Promise.all(a2).then((e3) => e3.reduce((e4, t3, n3) => (e4[o2[n3]] = t3, e4), {})).then(n2).catch((e3) => {
      i2.forEach((e4) => {
        e4.dispose && e4.dispose();
      }), r2(e3);
    }).finally(() => {
      t2 && t2.removeEventListener(`abort`, r2);
    });
  }), et = (e2, t2 = []) => t2.reduce((t3, n2) => (n2 in e2 && (t3[n2] = e2[n2]), t3), {}), tt = (e2, t2) => Object.keys(e2).reduce((n2, r2) => (t2(e2[r2], r2, e2) && (n2[r2] = e2[r2]), n2), {}), B = (e2, t2) => parseFloat(Number(e2).toFixed(t2)), nt = (e2) => `matrix(` + e2.map((e3) => B(e3, o.NUM_FRACTION_DIGITS)).join(` `) + `)`, V = (e2) => !!e2 && e2.toLive !== void 0, rt = (e2) => !!e2 && typeof e2.toObject == `function`, it = (e2) => !!e2 && e2.offsetX !== void 0 && `source` in e2, at = (e2) => !!e2 && `multiSelectionStacking` in e2;
  function ot(e2) {
    let t2 = e2 && H(e2), n2 = 0, r2 = 0;
    if (!e2 || !t2) return { left: n2, top: r2 };
    let i2 = e2, a2 = t2.documentElement, o2 = t2.body || { scrollLeft: 0, scrollTop: 0 };
    for (; i2 && (i2.parentNode || i2.host) && (i2 = i2.parentNode || i2.host, i2 === t2 ? (n2 = o2.scrollLeft || a2.scrollLeft || 0, r2 = o2.scrollTop || a2.scrollTop || 0) : (n2 += i2.scrollLeft || 0, r2 += i2.scrollTop || 0), i2.nodeType !== 1 || i2.style.position !== `fixed`); ) ;
    return { left: n2, top: r2 };
  }
  const H = (e2) => e2.ownerDocument || null, st = (e2) => {
    var t2;
    return ((t2 = e2.ownerDocument) == null ? void 0 : t2.defaultView) || null;
  }, ct = (e2, t2, { width: n2, height: r2 }, i2 = 1) => {
    e2.width = n2, e2.height = r2, i2 > 1 && (e2.setAttribute(`width`, (n2 * i2).toString()), e2.setAttribute(`height`, (r2 * i2).toString()), t2.scale(i2, i2));
  }, lt = (e2, { width: t2, height: n2 }) => {
    t2 && (e2.style.width = typeof t2 == `number` ? `${t2}px` : t2), n2 && (e2.style.height = typeof n2 == `number` ? `${n2}px` : n2);
  };
  function ut(e2) {
    return e2.onselectstart !== void 0 && (e2.onselectstart = () => false), e2.style.userSelect = te, e2;
  }
  var dt = class {
    constructor(e2) {
      i(this, `_originalCanvasStyle`, void 0), i(this, `lower`, void 0);
      let t2 = this.createLowerCanvas(e2);
      this.lower = { el: t2, ctx: t2.getContext(`2d`) };
    }
    createLowerCanvas(e2) {
      let t2 = (n2 = e2) && n2.getContext !== void 0 ? e2 : e2 && g().getElementById(e2) || P();
      var n2;
      if (t2.hasAttribute(`data-fabric`)) throw new c(`Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?`);
      return this._originalCanvasStyle = t2.style.cssText, t2.setAttribute(`data-fabric`, `main`), t2.classList.add(`lower-canvas`), t2;
    }
    cleanupDOM({ width: e2, height: t2 }) {
      let { el: n2 } = this.lower;
      n2.classList.remove(`lower-canvas`), n2.removeAttribute(`data-fabric`), n2.setAttribute(`width`, `${e2}`), n2.setAttribute(`height`, `${t2}`), n2.style.cssText = this._originalCanvasStyle || ``, this._originalCanvasStyle = void 0;
    }
    setDimensions(e2, t2) {
      let { el: n2, ctx: r2 } = this.lower;
      ct(n2, r2, e2, t2);
    }
    setCSSDimensions(e2) {
      lt(this.lower.el, e2);
    }
    calcOffset() {
      return (function(e2) {
        var t2;
        let n2 = e2 && H(e2), r2 = { left: 0, top: 0 };
        if (!n2) return r2;
        let i2 = ((t2 = st(e2)) == null ? void 0 : t2.getComputedStyle(e2, null)) || {};
        r2.left += parseInt(i2.borderLeftWidth, 10) || 0, r2.top += parseInt(i2.borderTopWidth, 10) || 0, r2.left += parseInt(i2.paddingLeft, 10) || 0, r2.top += parseInt(i2.paddingTop, 10) || 0;
        let a2 = { left: 0, top: 0 }, o2 = n2.documentElement;
        e2.getBoundingClientRect !== void 0 && (a2 = e2.getBoundingClientRect());
        let s2 = ot(e2);
        return { left: a2.left + s2.left - (o2.clientLeft || 0) + r2.left, top: a2.top + s2.top - (o2.clientTop || 0) + r2.top };
      })(this.lower.el);
    }
    dispose() {
      h().dispose(this.lower.el), delete this.lower;
    }
  };
  const ft = { backgroundVpt: true, backgroundColor: ``, overlayVpt: true, overlayColor: ``, includeDefaultValues: true, svgViewportTransformation: true, renderOnAddRemove: true, skipOffscreen: true, enableRetinaScaling: true, imageSmoothingEnabled: true, controlsAboveOverlay: false, allowTouchScrolling: false, viewportTransform: [...T], patternQuality: `best` };
  var pt = t({ capitalize: () => mt, escapeXml: () => U, graphemeSplit: () => gt });
  const mt = (e2, t2 = false) => `${e2.charAt(0).toUpperCase()}${t2 ? e2.slice(1) : e2.slice(1).toLowerCase()}`, U = (e2) => e2.toString().replace(/&/g, `&amp;`).replace(/"/g, `&quot;`).replace(/'/g, `&apos;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`);
  let ht;
  const gt = (e2) => {
    if (ht || ht || (ht = `Intl` in _() && `Segmenter` in Intl && new Intl.Segmenter(void 0, { granularity: `grapheme` })), ht) {
      let t2 = ht.segment(e2);
      return Array.from(t2).map(({ segment: e3 }) => e3);
    }
    return _t(e2);
  }, _t = (e2) => {
    let t2 = [];
    for (let n2, r2 = 0; r2 < e2.length; r2++) false !== (n2 = vt(e2, r2)) && t2.push(n2);
    return t2;
  }, vt = (e2, t2) => {
    let n2 = e2.charCodeAt(t2);
    if (isNaN(n2)) return ``;
    if (n2 < 55296 || n2 > 57343) return e2.charAt(t2);
    if (55296 <= n2 && n2 <= 56319) {
      if (e2.length <= t2 + 1) throw `High surrogate without following low surrogate`;
      let n3 = e2.charCodeAt(t2 + 1);
      if (56320 > n3 || n3 > 57343) throw `High surrogate without following low surrogate`;
      return e2.charAt(t2) + e2.charAt(t2 + 1);
    }
    if (t2 === 0) throw `Low surrogate without preceding high surrogate`;
    let r2 = e2.charCodeAt(t2 - 1);
    if (55296 > r2 || r2 > 56319) throw `Low surrogate without preceding high surrogate`;
    return false;
  };
  var yt = class e2 extends Ee(De) {
    get lowerCanvasEl() {
      var e3;
      return (e3 = this.elements.lower) == null ? void 0 : e3.el;
    }
    get contextContainer() {
      var e3;
      return (e3 = this.elements.lower) == null ? void 0 : e3.ctx;
    }
    static getDefaults() {
      return e2.ownDefaults;
    }
    constructor(e3, t2 = {}) {
      super(), Object.assign(this, this.constructor.getDefaults()), this.set(t2), this.initElements(e3), this._setDimensionsImpl({ width: this.width || this.elements.lower.el.width || 0, height: this.height || this.elements.lower.el.height || 0 }), this.skipControlsDrawing = false, this.viewportTransform = [...this.viewportTransform], this.calcViewportBoundaries();
    }
    initElements(e3) {
      this.elements = new dt(e3);
    }
    add(...e3) {
      let t2 = super.add(...e3);
      return e3.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), t2;
    }
    insertAt(e3, ...t2) {
      let n2 = super.insertAt(e3, ...t2);
      return t2.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), n2;
    }
    remove(...e3) {
      let t2 = super.remove(...e3);
      return t2.length > 0 && this.renderOnAddRemove && this.requestRenderAll(), t2;
    }
    _onObjectAdded(e3) {
      e3.canvas && e3.canvas !== this && (s(`warn`, `Canvas is trying to add an object that belongs to a different canvas.
Resulting to default behavior: removing object from previous canvas and adding to new canvas`), e3.canvas.remove(e3)), e3._set(`canvas`, this), e3.setCoords(), this.fire(`object:added`, { target: e3 }), e3.fire(`added`, { target: this });
    }
    _onObjectRemoved(e3) {
      e3._set(`canvas`, void 0), this.fire(`object:removed`, { target: e3 }), e3.fire(`removed`, { target: this });
    }
    _onStackOrderChanged() {
      this.renderOnAddRemove && this.requestRenderAll();
    }
    getRetinaScaling() {
      return this.enableRetinaScaling ? v() : 1;
    }
    calcOffset() {
      return this._offset = this.elements.calcOffset();
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    _setDimensionsImpl(e3, { cssOnly: t2 = false, backstoreOnly: n2 = false } = {}) {
      if (!t2) {
        let t3 = { width: this.width, height: this.height, ...e3 };
        this.elements.setDimensions(t3, this.getRetinaScaling()), this.hasLostContext = true, this.width = t3.width, this.height = t3.height;
      }
      n2 || this.elements.setCSSDimensions(e3), this.calcOffset();
    }
    setDimensions(e3, t2) {
      this._setDimensionsImpl(e3, t2), t2 && t2.cssOnly || this.requestRenderAll();
    }
    getZoom() {
      return Be(this.viewportTransform);
    }
    setViewportTransform(e3) {
      this.viewportTransform = e3, this.calcViewportBoundaries(), this.renderOnAddRemove && this.requestRenderAll();
    }
    zoomToPoint(e3, t2) {
      let n2 = e3, r2 = [...this.viewportTransform], i2 = L(e3, R(r2));
      r2[0] = t2, r2[3] = t2;
      let a2 = L(i2, r2);
      r2[4] += n2.x - a2.x, r2[5] += n2.y - a2.y, this.setViewportTransform(r2);
    }
    setZoom(e3) {
      this.zoomToPoint(new N(0, 0), e3);
    }
    absolutePan(e3) {
      let t2 = [...this.viewportTransform];
      return t2[4] = -e3.x, t2[5] = -e3.y, this.setViewportTransform(t2);
    }
    relativePan(e3) {
      return this.absolutePan(new N(-e3.x - this.viewportTransform[4], -e3.y - this.viewportTransform[5]));
    }
    getElement() {
      return this.elements.lower.el;
    }
    clearContext(e3) {
      e3.clearRect(0, 0, this.width, this.height);
    }
    getContext() {
      return this.elements.lower.ctx;
    }
    clear() {
      this.remove(...this.getObjects()), this.backgroundImage = void 0, this.overlayImage = void 0, this.backgroundColor = ``, this.overlayColor = ``, this.clearContext(this.getContext()), this.fire(`canvas:cleared`), this.renderOnAddRemove && this.requestRenderAll();
    }
    renderAll() {
      this.cancelRequestedRender(), this.destroyed || this.renderCanvas(this.getContext(), this._objects);
    }
    renderAndReset() {
      this.nextRenderHandle = 0, this.renderAll();
    }
    requestRenderAll() {
      this.nextRenderHandle || this.disposed || this.destroyed || (this.nextRenderHandle = Oe(() => this.renderAndReset()));
    }
    calcViewportBoundaries() {
      let e3 = this.width, t2 = this.height, n2 = R(this.viewportTransform), r2 = L({ x: 0, y: 0 }, n2), i2 = L({ x: e3, y: t2 }, n2), a2 = r2.min(i2), o2 = r2.max(i2);
      return this.vptCoords = { tl: a2, tr: new N(o2.x, a2.y), bl: new N(a2.x, o2.y), br: o2 };
    }
    cancelRequestedRender() {
      this.nextRenderHandle && (ke(this.nextRenderHandle), this.nextRenderHandle = 0);
    }
    drawControls(e3) {
    }
    renderCanvas(e3, t2) {
      if (this.destroyed) return;
      let n2 = this.viewportTransform, r2 = this.clipPath;
      this.calcViewportBoundaries(), this.clearContext(e3), e3.imageSmoothingEnabled = this.imageSmoothingEnabled, e3.patternQuality = this.patternQuality, this.fire(`before:render`, { ctx: e3 }), this._renderBackground(e3), e3.save(), e3.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), this._renderObjects(e3, t2), e3.restore(), this.controlsAboveOverlay || this.skipControlsDrawing || this.drawControls(e3), r2 && (r2._set(`canvas`, this), r2.shouldCache(), r2._transformDone = true, r2.renderCache({ forClipping: true }), this.drawClipPathOnCanvas(e3, r2)), this._renderOverlay(e3), this.controlsAboveOverlay && !this.skipControlsDrawing && this.drawControls(e3), this.fire(`after:render`, { ctx: e3 }), this.__cleanupTask && (this.__cleanupTask(), this.__cleanupTask = void 0);
    }
    drawClipPathOnCanvas(e3, t2) {
      let n2 = this.viewportTransform;
      e3.save(), e3.transform(...n2), e3.globalCompositeOperation = `destination-in`, t2.transform(e3), e3.scale(1 / t2.zoomX, 1 / t2.zoomY), e3.drawImage(t2._cacheCanvas, -t2.cacheTranslationX, -t2.cacheTranslationY), e3.restore();
    }
    _renderObjects(e3, t2) {
      for (let n2 = 0, r2 = t2.length; n2 < r2; ++n2) t2[n2] && t2[n2].render(e3);
    }
    _renderBackgroundOrOverlay(e3, t2) {
      let n2 = this[`${t2}Color`], r2 = this[`${t2}Image`], i2 = this.viewportTransform, a2 = this[`${t2}Vpt`];
      if (!n2 && !r2) return;
      let o2 = V(n2);
      if (n2) {
        if (e3.save(), e3.beginPath(), e3.moveTo(0, 0), e3.lineTo(this.width, 0), e3.lineTo(this.width, this.height), e3.lineTo(0, this.height), e3.closePath(), e3.fillStyle = o2 ? n2.toLive(e3) : n2, a2 && e3.transform(...i2), o2) {
          e3.transform(1, 0, 0, 1, n2.offsetX || 0, n2.offsetY || 0);
          let t3 = n2.gradientTransform || n2.patternTransform;
          t3 && e3.transform(...t3);
        }
        e3.fill(), e3.restore();
      }
      if (r2) {
        e3.save();
        let { skipOffscreen: t3 } = this;
        this.skipOffscreen = a2, a2 && e3.transform(...i2), r2.render(e3), this.skipOffscreen = t3, e3.restore();
      }
    }
    _renderBackground(e3) {
      this._renderBackgroundOrOverlay(e3, `background`);
    }
    _renderOverlay(e3) {
      this._renderBackgroundOrOverlay(e3, `overlay`);
    }
    getCenterPoint() {
      return new N(this.width / 2, this.height / 2);
    }
    centerObjectH(e3) {
      return this._centerObject(e3, new N(this.getCenterPoint().x, e3.getCenterPoint().y));
    }
    centerObjectV(e3) {
      return this._centerObject(e3, new N(e3.getCenterPoint().x, this.getCenterPoint().y));
    }
    centerObject(e3) {
      return this._centerObject(e3, this.getCenterPoint());
    }
    viewportCenterObject(e3) {
      return this._centerObject(e3, this.getVpCenter());
    }
    viewportCenterObjectH(e3) {
      return this._centerObject(e3, new N(this.getVpCenter().x, e3.getCenterPoint().y));
    }
    viewportCenterObjectV(e3) {
      return this._centerObject(e3, new N(e3.getCenterPoint().x, this.getVpCenter().y));
    }
    getVpCenter() {
      return L(this.getCenterPoint(), R(this.viewportTransform));
    }
    _centerObject(e3, t2) {
      e3.setXY(t2, E, E), e3.setCoords(), this.renderOnAddRemove && this.requestRenderAll();
    }
    toDatalessJSON(e3) {
      return this.toDatalessObject(e3);
    }
    toObject(e3) {
      return this._toObjectMethod(`toObject`, e3);
    }
    toJSON() {
      return this.toObject();
    }
    toDatalessObject(e3) {
      return this._toObjectMethod(`toDatalessObject`, e3);
    }
    _toObjectMethod(e3, t2) {
      let n2 = this.clipPath, r2 = n2 && !n2.excludeFromExport ? this._toObject(n2, e3, t2) : null;
      return { version: b, ...et(this, t2), objects: this._objects.filter((e4) => !e4.excludeFromExport).map((n3) => this._toObject(n3, e3, t2)), ...this.__serializeBgOverlay(e3, t2), ...r2 ? { clipPath: r2 } : null };
    }
    _toObject(e3, t2, n2) {
      let r2;
      this.includeDefaultValues || (r2 = e3.includeDefaultValues, e3.includeDefaultValues = false);
      let i2 = e3[t2](n2);
      return this.includeDefaultValues || (e3.includeDefaultValues = !!r2), i2;
    }
    __serializeBgOverlay(e3, t2) {
      let n2 = {}, r2 = this.backgroundImage, i2 = this.overlayImage, a2 = this.backgroundColor, o2 = this.overlayColor;
      return V(a2) ? a2.excludeFromExport || (n2.background = a2.toObject(t2)) : a2 && (n2.background = a2), V(o2) ? o2.excludeFromExport || (n2.overlay = o2.toObject(t2)) : o2 && (n2.overlay = o2), r2 && !r2.excludeFromExport && (n2.backgroundImage = this._toObject(r2, e3, t2)), i2 && !i2.excludeFromExport && (n2.overlayImage = this._toObject(i2, e3, t2)), n2;
    }
    toSVG(e3 = {}, t2) {
      e3.reviver = t2;
      let n2 = [];
      var r2;
      return (this._setSVGPreamble(n2, e3), this._setSVGHeader(n2, e3), this.clipPath) && n2.push(`<g clip-path="url(#${U((r2 = this.clipPath.clipPathId) == null ? `` : r2)})" >
`), this._setSVGBgOverlayColor(n2, `background`), this._setSVGBgOverlayImage(n2, `backgroundImage`, t2), this._setSVGObjects(n2, t2), this.clipPath && n2.push(`</g>
`), this._setSVGBgOverlayColor(n2, `overlay`), this._setSVGBgOverlayImage(n2, `overlayImage`, t2), n2.push(`</svg>`), n2.join(``);
    }
    _setSVGPreamble(e3, t2) {
      t2.suppressPreamble || e3.push(`<?xml version="1.0" encoding="`, t2.encoding || `UTF-8`, `" standalone="no" ?>
`, `<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" `, `"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
`);
    }
    _setSVGHeader(e3, t2) {
      let n2 = t2.width || `${this.width}`, r2 = t2.height || `${this.height}`, i2 = o.NUM_FRACTION_DIGITS, a2 = t2.viewBox, s2;
      if (a2) s2 = `viewBox="${a2.x} ${a2.y} ${a2.width} ${a2.height}" `;
      else if (this.svgViewportTransformation) {
        let e4 = this.viewportTransform;
        s2 = `viewBox="${B(-e4[4] / e4[0], i2)} ${B(-e4[5] / e4[3], i2)} ${B(this.width / e4[0], i2)} ${B(this.height / e4[3], i2)}" `;
      } else s2 = `viewBox="0 0 ${this.width} ${this.height}" `;
      e3.push(`<svg `, `xmlns="http://www.w3.org/2000/svg" `, `xmlns:xlink="http://www.w3.org/1999/xlink" `, `version="1.1" `, `width="`, n2, `" `, `height="`, r2, `" `, s2, `xml:space="preserve">
`, `<desc>Created with Fabric.js `, b, `</desc>
`, `<defs>
`, this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(t2), `</defs>
`);
    }
    createSVGClipPathMarkup(e3) {
      let t2 = this.clipPath;
      return t2 ? (t2.clipPathId = `CLIPPATH_${je()}`, `<clipPath id="${t2.clipPathId}" >
${t2.toClipPathSVG(e3.reviver)}</clipPath>
`) : ``;
    }
    createSVGRefElementsMarkup() {
      return [`background`, `overlay`].map((e3) => {
        let t2 = this[`${e3}Color`];
        if (V(t2)) {
          let n2 = this[`${e3}Vpt`], r2 = this.viewportTransform, i2 = { isType: () => false, width: this.width / (n2 ? r2[0] : 1), height: this.height / (n2 ? r2[3] : 1) };
          return t2.toSVG(i2, { additionalTransform: n2 ? nt(r2) : `` });
        }
      }).join(``);
    }
    createSVGFontFacesMarkup() {
      let e3 = [], t2 = {}, n2 = o.fontPaths;
      this._objects.forEach(function t3(n3) {
        e3.push(n3), Te(n3) && n3._objects.forEach(t3);
      }), e3.forEach((e4) => {
        if (!(r3 = e4) || typeof r3._renderText != `function`) return;
        var r3;
        let { styles: i2, fontFamily: a2 } = e4;
        !t2[a2] && n2[a2] && (t2[a2] = true, i2 && Object.values(i2).forEach((e5) => {
          Object.values(e5).forEach(({ fontFamily: e6 = `` }) => {
            !t2[e6] && n2[e6] && (t2[e6] = true);
          });
        }));
      });
      let r2 = Object.keys(t2).map((e4) => `		@font-face {
			font-family: '${e4}';
			src: url('${n2[e4]}');
		}
`).join(``);
      return r2 ? `	<style type="text/css"><![CDATA[
${r2}]]></style>
` : ``;
    }
    _setSVGObjects(e3, t2) {
      this.forEachObject((n2) => {
        n2.excludeFromExport || this._setSVGObject(e3, n2, t2);
      });
    }
    _setSVGObject(e3, t2, n2) {
      e3.push(t2.toSVG(n2));
    }
    _setSVGBgOverlayImage(e3, t2, n2) {
      let r2 = this[t2];
      r2 && !r2.excludeFromExport && r2.toSVG && e3.push(r2.toSVG(n2));
    }
    _setSVGBgOverlayColor(e3, t2) {
      let n2 = this[`${t2}Color`];
      if (n2) if (V(n2)) {
        let r2 = n2.repeat || ``, i2 = this.width, a2 = this.height, o2 = this[`${t2}Vpt`] ? nt(R(this.viewportTransform)) : ``;
        e3.push(`<rect transform="${o2} translate(${i2 / 2},${a2 / 2})" x="${n2.offsetX - i2 / 2}" y="${n2.offsetY - a2 / 2}" width="${r2 !== `repeat-y` && r2 !== `no-repeat` || !it(n2) ? i2 : n2.source.width}" height="${r2 !== `repeat-x` && r2 !== `no-repeat` || !it(n2) ? a2 : n2.source.height}" fill="url(#SVGID_${n2.id})"></rect>
`);
      } else e3.push(`<rect x="0" y="0" width="100%" height="100%" `, `fill="`, n2, `"`, `></rect>
`);
    }
    loadFromJSON(e3, t2, { signal: n2 } = {}) {
      if (!e3) return Promise.reject(new c("`json` is undefined"));
      let { objects: r2 = [], ...i2 } = typeof e3 == `string` ? JSON.parse(e3) : e3, { backgroundImage: a2, background: o2, overlayImage: s2, overlay: l2, clipPath: u2 } = i2, d2 = this.renderOnAddRemove;
      return this.renderOnAddRemove = false, Promise.all([Qe(r2, { reviver: t2, signal: n2 }), $e({ backgroundImage: a2, backgroundColor: o2, overlayImage: s2, overlayColor: l2, clipPath: u2 }, { signal: n2 })]).then(([e4, t3]) => (this.clear(), this.add(...e4), this.set(i2), this.set(t3), this.renderOnAddRemove = d2, this));
    }
    clone(e3) {
      let t2 = this.toObject(e3);
      return this.cloneWithoutData().loadFromJSON(t2);
    }
    cloneWithoutData() {
      let e3 = F(this);
      return new this.constructor(e3);
    }
    toDataURL(e3 = {}) {
      let { format: t2 = `png`, quality: n2 = 1, multiplier: r2 = 1, enableRetinaScaling: i2 = false } = e3, a2 = r2 * (i2 ? this.getRetinaScaling() : 1);
      return Pe(this.toCanvasElement(a2, e3), t2, n2);
    }
    toBlob(e3 = {}) {
      let { format: t2 = `png`, quality: n2 = 1, multiplier: r2 = 1, enableRetinaScaling: i2 = false } = e3, a2 = r2 * (i2 ? this.getRetinaScaling() : 1);
      return Fe(this.toCanvasElement(a2, e3), t2, n2);
    }
    toCanvasElement(e3 = 1, { width: t2, height: n2, left: r2, top: i2, filter: a2 } = {}) {
      let o2 = (t2 || this.width) * e3, s2 = (n2 || this.height) * e3, c2 = this.getZoom(), l2 = this.width, u2 = this.height, d2 = this.skipControlsDrawing, f2 = c2 * e3, p2 = this.viewportTransform, m = [f2, 0, 0, f2, (p2[4] - (r2 || 0)) * e3, (p2[5] - (i2 || 0)) * e3], h2 = this.enableRetinaScaling, g2 = F({ width: o2, height: s2 }), _2 = a2 ? this._objects.filter((e4) => a2(e4)) : this._objects;
      return this.enableRetinaScaling = false, this.viewportTransform = m, this.width = o2, this.height = s2, this.skipControlsDrawing = true, this.calcViewportBoundaries(), this.renderCanvas(g2.getContext(`2d`), _2), this.viewportTransform = p2, this.width = l2, this.height = u2, this.calcViewportBoundaries(), this.enableRetinaScaling = h2, this.skipControlsDrawing = d2, g2;
    }
    dispose() {
      return !this.disposed && this.elements.cleanupDOM({ width: this.width, height: this.height }), ye.cancelByCanvas(this), this.disposed = true, new Promise((e3, t2) => {
        let n2 = () => {
          this.destroy(), e3(true);
        };
        n2.kill = t2, this.__cleanupTask && this.__cleanupTask.kill(`aborted`), this.destroyed ? e3(false) : this.nextRenderHandle ? this.__cleanupTask = n2 : n2();
      });
    }
    destroy() {
      this.destroyed = true, this.cancelRequestedRender(), this.forEachObject((e3) => e3.dispose()), this._objects = [], this.backgroundImage && this.backgroundImage.dispose(), this.backgroundImage = void 0, this.overlayImage && this.overlayImage.dispose(), this.overlayImage = void 0, this.elements.dispose();
    }
    toString() {
      return `#<Canvas (${this.complexity()}): { objects: ${this._objects.length} }>`;
    }
  };
  i(yt, `ownDefaults`, ft);
  const bt = [`touchstart`, `touchmove`, `touchend`], xt = (e2) => {
    let t2 = ot(e2.target), n2 = (function(e3) {
      let t3 = e3.changedTouches;
      return t3 && t3[0] ? t3[0] : e3;
    })(e2);
    return new N(n2.clientX + t2.left, n2.clientY + t2.top);
  }, St = (e2) => bt.includes(e2.type) || e2.pointerType === `touch`, Ct = (e2) => {
    e2.preventDefault(), e2.stopPropagation();
  }, wt = (e2) => {
    let t2 = 0, n2 = 0, r2 = 0, i2 = 0;
    for (let a2 = 0, o2 = e2.length; a2 < o2; a2++) {
      let { x: o3, y: s2 } = e2[a2];
      (o3 > r2 || !a2) && (r2 = o3), (o3 < t2 || !a2) && (t2 = o3), (s2 > i2 || !a2) && (i2 = s2), (s2 < n2 || !a2) && (n2 = s2);
    }
    return { left: t2, top: n2, width: r2 - t2, height: i2 - n2 };
  }, Tt = (e2, t2) => {
    Dt(e2, z(R(t2), e2.calcOwnMatrix()));
  }, Et = (e2, t2) => Dt(e2, z(t2, e2.calcOwnMatrix())), Dt = (e2, t2) => {
    let { translateX: n2, translateY: r2, scaleX: i2, scaleY: a2, ...o2 } = He(t2), s2 = new N(n2, r2);
    e2.flipX = false, e2.flipY = false, Object.assign(e2, o2), e2.set({ scaleX: i2, scaleY: a2 }), e2.setPositionByOrigin(s2, E, E);
  }, Ot = (e2) => {
    e2.scaleX = 1, e2.scaleY = 1, e2.skewX = 0, e2.skewY = 0, e2.flipX = false, e2.flipY = false, e2.rotate(0);
  }, kt = (e2) => ({ scaleX: e2.scaleX, scaleY: e2.scaleY, skewX: e2.skewX, skewY: e2.skewY, angle: e2.angle, left: e2.left, flipX: e2.flipX, flipY: e2.flipY, top: e2.top }), At = (e2, t2, n2) => {
    let r2 = e2 / 2, i2 = t2 / 2, a2 = wt([new N(-r2, -i2), new N(r2, -i2), new N(-r2, i2), new N(r2, i2)].map((e3) => e3.transform(n2)));
    return new N(a2.width, a2.height);
  }, jt = (e2 = T, t2 = T) => z(R(t2), e2), Mt = (e2, t2 = T, n2 = T) => e2.transform(jt(t2, n2)), Nt = (e2, t2 = T, n2 = T) => e2.transform(jt(t2, n2), true), Pt = (e2, t2, n2) => {
    let r2 = jt(t2, n2);
    return Dt(e2, z(r2, e2.calcOwnMatrix())), r2;
  }, Ft = { left: -0.5, top: -0.5, center: 0, bottom: 0.5, right: 0.5 }, W = (e2) => typeof e2 == `string` ? Ft[e2] : e2 - 0.5, It = new N(1, 0), Lt = new N(), Rt = (e2, t2) => e2.rotate(t2), zt = (e2, t2) => new N(t2).subtract(e2), Bt = (e2) => e2.distanceFrom(Lt), Vt = (e2, t2) => Math.atan2(Gt(e2, t2), Kt(e2, t2)), Ht = (e2) => Vt(It, e2), Ut = (e2) => e2.eq(Lt) ? e2 : e2.scalarDivide(Bt(e2)), Wt = (e2, t2 = true) => Ut(new N(-e2.y, e2.x).scalarMultiply(t2 ? 1 : -1)), Gt = (e2, t2) => e2.x * t2.y - e2.y * t2.x, Kt = (e2, t2) => e2.x * t2.x + e2.y * t2.y, qt = (e2, t2, n2) => {
    if (e2.eq(t2) || e2.eq(n2)) return true;
    let r2 = Gt(t2, n2), i2 = Gt(t2, e2), a2 = Gt(n2, e2);
    return r2 >= 0 ? i2 >= 0 && a2 <= 0 : !(i2 <= 0 && a2 >= 0);
  }, Jt = `not-allowed`;
  function Yt(e2) {
    return W(e2.originX) === W(`center`) && W(e2.originY) === W(`center`);
  }
  function Xt(e2) {
    return 0.5 - W(e2);
  }
  const Zt = (e2, t2) => e2[t2], Qt = (e2, t2, n2, r2) => ({ e: e2, transform: t2, pointer: new N(n2, r2) });
  function $t(e2, t2, n2) {
    let r2 = n2, i2 = Ht(zt(Mt(e2.getCenterPoint(), e2.canvas.viewportTransform, void 0), r2)) + w;
    return Math.round(i2 % w / C);
  }
  function en({ target: e2, corner: t2 }, n2, r2, i2, a2) {
    var o2;
    let s2 = e2.controls[t2], c2 = ((o2 = e2.canvas) == null ? void 0 : o2.getZoom()) || 1, l2 = e2.padding / c2, u2 = (function(e3, t3, n3, r3) {
      let i3 = e3.getRelativeCenterPoint(), a3 = n3 !== void 0 && r3 !== void 0 ? e3.translateToGivenOrigin(i3, E, E, n3, r3) : new N(e3.left, e3.top);
      return (e3.angle ? t3.rotate(-I(e3.angle), i3) : t3).subtract(a3);
    })(e2, new N(i2, a2), n2, r2);
    return u2.x >= l2 && (u2.x -= l2), u2.x <= -l2 && (u2.x += l2), u2.y >= l2 && (u2.y -= l2), u2.y <= l2 && (u2.y += l2), u2.x -= s2.offsetX, u2.y -= s2.offsetY, u2;
  }
  const tn = new RegExp(String.raw`[\0-\x1F\x7F;<>\\]|\/\*|\*\/|url\s*\(|expression\s*\(|(?:java|vb)script\s*:|data\s*:|@import\b`, `iu`), nn = (e2) => typeof e2 == `string` && e2.trim().length > 0 && !tn.test(e2), rn = (e2, t2 = ``) => {
    let n2 = Number(e2);
    return Number.isFinite(n2) ? `${n2}` : t2;
  }, an = (e2, t2 = ``) => typeof e2 == `string` && nn(e2) ? e2 : t2, on = (e2) => e2.replace(/\s+/g, ` `), sn = { aliceblue: `#F0F8FF`, antiquewhite: `#FAEBD7`, aqua: `#0FF`, aquamarine: `#7FFFD4`, azure: `#F0FFFF`, beige: `#F5F5DC`, bisque: `#FFE4C4`, black: `#000`, blanchedalmond: `#FFEBCD`, blue: `#00F`, blueviolet: `#8A2BE2`, brown: `#A52A2A`, burlywood: `#DEB887`, cadetblue: `#5F9EA0`, chartreuse: `#7FFF00`, chocolate: `#D2691E`, coral: `#FF7F50`, cornflowerblue: `#6495ED`, cornsilk: `#FFF8DC`, crimson: `#DC143C`, cyan: `#0FF`, darkblue: `#00008B`, darkcyan: `#008B8B`, darkgoldenrod: `#B8860B`, darkgray: `#A9A9A9`, darkgrey: `#A9A9A9`, darkgreen: `#006400`, darkkhaki: `#BDB76B`, darkmagenta: `#8B008B`, darkolivegreen: `#556B2F`, darkorange: `#FF8C00`, darkorchid: `#9932CC`, darkred: `#8B0000`, darksalmon: `#E9967A`, darkseagreen: `#8FBC8F`, darkslateblue: `#483D8B`, darkslategray: `#2F4F4F`, darkslategrey: `#2F4F4F`, darkturquoise: `#00CED1`, darkviolet: `#9400D3`, deeppink: `#FF1493`, deepskyblue: `#00BFFF`, dimgray: `#696969`, dimgrey: `#696969`, dodgerblue: `#1E90FF`, firebrick: `#B22222`, floralwhite: `#FFFAF0`, forestgreen: `#228B22`, fuchsia: `#F0F`, gainsboro: `#DCDCDC`, ghostwhite: `#F8F8FF`, gold: `#FFD700`, goldenrod: `#DAA520`, gray: `#808080`, grey: `#808080`, green: `#008000`, greenyellow: `#ADFF2F`, honeydew: `#F0FFF0`, hotpink: `#FF69B4`, indianred: `#CD5C5C`, indigo: `#4B0082`, ivory: `#FFFFF0`, khaki: `#F0E68C`, lavender: `#E6E6FA`, lavenderblush: `#FFF0F5`, lawngreen: `#7CFC00`, lemonchiffon: `#FFFACD`, lightblue: `#ADD8E6`, lightcoral: `#F08080`, lightcyan: `#E0FFFF`, lightgoldenrodyellow: `#FAFAD2`, lightgray: `#D3D3D3`, lightgrey: `#D3D3D3`, lightgreen: `#90EE90`, lightpink: `#FFB6C1`, lightsalmon: `#FFA07A`, lightseagreen: `#20B2AA`, lightskyblue: `#87CEFA`, lightslategray: `#789`, lightslategrey: `#789`, lightsteelblue: `#B0C4DE`, lightyellow: `#FFFFE0`, lime: `#0F0`, limegreen: `#32CD32`, linen: `#FAF0E6`, magenta: `#F0F`, maroon: `#800000`, mediumaquamarine: `#66CDAA`, mediumblue: `#0000CD`, mediumorchid: `#BA55D3`, mediumpurple: `#9370DB`, mediumseagreen: `#3CB371`, mediumslateblue: `#7B68EE`, mediumspringgreen: `#00FA9A`, mediumturquoise: `#48D1CC`, mediumvioletred: `#C71585`, midnightblue: `#191970`, mintcream: `#F5FFFA`, mistyrose: `#FFE4E1`, moccasin: `#FFE4B5`, navajowhite: `#FFDEAD`, navy: `#000080`, oldlace: `#FDF5E6`, olive: `#808000`, olivedrab: `#6B8E23`, orange: `#FFA500`, orangered: `#FF4500`, orchid: `#DA70D6`, palegoldenrod: `#EEE8AA`, palegreen: `#98FB98`, paleturquoise: `#AFEEEE`, palevioletred: `#DB7093`, papayawhip: `#FFEFD5`, peachpuff: `#FFDAB9`, peru: `#CD853F`, pink: `#FFC0CB`, plum: `#DDA0DD`, powderblue: `#B0E0E6`, purple: `#800080`, rebeccapurple: `#639`, red: `#F00`, rosybrown: `#BC8F8F`, royalblue: `#4169E1`, saddlebrown: `#8B4513`, salmon: `#FA8072`, sandybrown: `#F4A460`, seagreen: `#2E8B57`, seashell: `#FFF5EE`, sienna: `#A0522D`, silver: `#C0C0C0`, skyblue: `#87CEEB`, slateblue: `#6A5ACD`, slategray: `#708090`, slategrey: `#708090`, snow: `#FFFAFA`, springgreen: `#00FF7F`, steelblue: `#4682B4`, tan: `#D2B48C`, teal: `#008080`, thistle: `#D8BFD8`, tomato: `#FF6347`, turquoise: `#40E0D0`, violet: `#EE82EE`, wheat: `#F5DEB3`, white: `#FFF`, whitesmoke: `#F5F5F5`, yellow: `#FF0`, yellowgreen: `#9ACD32` }, cn = (e2, t2, n2) => (n2 < 0 && (n2 += 1), n2 > 1 && --n2, n2 < 1 / 6 ? e2 + 6 * (t2 - e2) * n2 : n2 < 0.5 ? t2 : n2 < 2 / 3 ? e2 + (t2 - e2) * (2 / 3 - n2) * 6 : e2), ln = (e2, t2, n2, r2) => {
    e2 /= 255, t2 /= 255, n2 /= 255;
    let i2 = Math.max(e2, t2, n2), a2 = Math.min(e2, t2, n2), o2, s2, c2 = (i2 + a2) / 2;
    if (i2 === a2) o2 = s2 = 0;
    else {
      let r3 = i2 - a2;
      switch (s2 = c2 > 0.5 ? r3 / (2 - i2 - a2) : r3 / (i2 + a2), i2) {
        case e2:
          o2 = (t2 - n2) / r3 + (t2 < n2 ? 6 : 0);
          break;
        case t2:
          o2 = (n2 - e2) / r3 + 2;
          break;
        case n2:
          o2 = (e2 - t2) / r3 + 4;
      }
      o2 /= 6;
    }
    return [Math.round(360 * o2), Math.round(100 * s2), Math.round(100 * c2), r2];
  }, un = (e2 = `1`) => parseFloat(e2) / (e2.endsWith(`%`) ? 100 : 1), dn = (e2) => Math.min(Math.round(e2), 255).toString(16).toUpperCase().padStart(2, `0`), fn = ([e2, t2, n2, r2 = 1]) => {
    let i2 = Math.round(0.3 * e2 + 0.59 * t2 + 0.11 * n2);
    return [i2, i2, i2, r2];
  };
  var G = class e2 {
    constructor(t2) {
      if (i(this, `isUnrecognised`, false), t2) if (t2 instanceof e2) this.setSource([...t2._source]);
      else if (Array.isArray(t2)) {
        let [e3, n2, r2, i2 = 1] = t2;
        this.setSource([e3, n2, r2, i2]);
      } else this.setSource(this._tryParsingColor(t2));
      else this.setSource([0, 0, 0, 1]);
    }
    _tryParsingColor(t2) {
      return (t2 = t2.toLowerCase()) in sn && (t2 = sn[t2]), t2 === `transparent` ? [255, 255, 255, 0] : e2.sourceFromHex(t2) || e2.sourceFromRgb(t2) || e2.sourceFromHsl(t2) || (this.isUnrecognised = true) && [0, 0, 0, 1];
    }
    getSource() {
      return this._source;
    }
    setSource(e3) {
      this._source = e3;
    }
    toRgb() {
      let [e3, t2, n2] = this.getSource();
      return `rgb(${e3},${t2},${n2})`;
    }
    toRgba() {
      return `rgba(${this.getSource().join(`,`)})`;
    }
    toHsl() {
      let [e3, t2, n2] = ln(...this.getSource());
      return `hsl(${e3},${t2}%,${n2}%)`;
    }
    toHsla() {
      let [e3, t2, n2, r2] = ln(...this.getSource());
      return `hsla(${e3},${t2}%,${n2}%,${r2})`;
    }
    toHex() {
      return this.toHexa().slice(0, 6);
    }
    toHexa() {
      let [e3, t2, n2, r2] = this.getSource();
      return `${dn(e3)}${dn(t2)}${dn(n2)}${dn(Math.round(255 * r2))}`;
    }
    getAlpha() {
      return this.getSource()[3];
    }
    setAlpha(e3) {
      return this._source[3] = e3, this;
    }
    toGrayscale() {
      return this.setSource(fn(this.getSource())), this;
    }
    toBlackWhite(e3) {
      let [t2, , , n2] = fn(this.getSource()), r2 = t2 < (e3 || 127) ? 0 : 255;
      return this.setSource([r2, r2, r2, n2]), this;
    }
    overlayWith(t2) {
      t2 instanceof e2 || (t2 = new e2(t2));
      let n2 = this.getSource(), r2 = t2.getSource(), [i2, a2, o2] = n2.map((e3, t3) => Math.round(0.5 * e3 + 0.5 * r2[t3]));
      return this.setSource([i2, a2, o2, n2[3]]), this;
    }
    static fromRgb(t2) {
      return e2.fromRgba(t2);
    }
    static fromRgba(t2) {
      return new e2(e2.sourceFromRgb(t2));
    }
    static sourceFromRgb(e3) {
      let t2 = on(e3).match(/^rgba?\(\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d{0,3}(?:\.\d+)?%?)\s?)?\)$/i);
      if (t2) {
        let [e4, n2, r2] = t2.slice(1, 4).map((e5) => {
          let t3 = parseFloat(e5);
          return e5.endsWith(`%`) ? Math.round(2.55 * t3) : t3;
        });
        return [e4, n2, r2, un(t2[4])];
      }
    }
    static fromHsl(t2) {
      return e2.fromHsla(t2);
    }
    static fromHsla(t2) {
      return new e2(e2.sourceFromHsl(t2));
    }
    static sourceFromHsl(t2) {
      let n2 = on(t2).match(/^hsla?\(\s?([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d*(?:\.\d+)?%?)\s?)?\)$/i);
      if (!n2) return;
      let r2 = (e2.parseAngletoDegrees(n2[1]) % 360 + 360) % 360 / 360, i2 = parseFloat(n2[2]) / 100, a2 = parseFloat(n2[3]) / 100, o2, s2, c2;
      if (i2 === 0) o2 = s2 = c2 = a2;
      else {
        let e3 = a2 <= 0.5 ? a2 * (i2 + 1) : a2 + i2 - a2 * i2, t3 = 2 * a2 - e3;
        o2 = cn(t3, e3, r2 + 1 / 3), s2 = cn(t3, e3, r2), c2 = cn(t3, e3, r2 - 1 / 3);
      }
      return [Math.round(255 * o2), Math.round(255 * s2), Math.round(255 * c2), un(n2[4])];
    }
    static fromHex(t2) {
      return new e2(e2.sourceFromHex(t2));
    }
    static sourceFromHex(e3) {
      if (e3.match(/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i)) {
        let t2 = e3.slice(e3.indexOf(`#`) + 1), n2;
        n2 = t2.length <= 4 ? t2.split(``).map((e4) => e4 + e4) : t2.match(/.{2}/g);
        let [r2, i2, a2, o2 = 255] = n2.map((e4) => parseInt(e4, 16));
        return [r2, i2, a2, o2 / 255];
      }
    }
    static parseAngletoDegrees(e3) {
      let t2 = e3.toLowerCase(), n2 = parseFloat(t2);
      return t2.includes(`rad`) ? Ie(n2) : t2.includes(`turn`) ? 360 * n2 : n2;
    }
  };
  const pn = (e2) => {
    let t2 = [`instantiated_by_use`, `style`, `id`, `class`];
    switch (e2) {
      case `linearGradient`:
        return t2.concat([`x1`, `y1`, `x2`, `y2`, `gradientUnits`, `gradientTransform`]);
      case `radialGradient`:
        return t2.concat([`gradientUnits`, `gradientTransform`, `cx`, `cy`, `r`, `fx`, `fy`, `fr`]);
      case `stop`:
        return t2.concat([`offset`, `stop-color`, `stop-opacity`]);
    }
    return t2;
  }, K = (e2, t2 = 16) => {
    let n2 = /\D{0,2}$/.exec(e2), r2 = parseFloat(e2), i2 = o.DPI;
    switch (n2 == null ? void 0 : n2[0]) {
      case `mm`:
        return r2 * i2 / 25.4;
      case `cm`:
        return r2 * i2 / 2.54;
      case `in`:
        return r2 * i2;
      case `pt`:
        return r2 * i2 / 72;
      case `pc`:
        return r2 * i2 / 72 * 12;
      case `em`:
        return r2 * t2;
      default:
        return r2;
    }
  }, mn = (e2) => {
    let [t2, n2] = e2.trim().split(` `), [r2, i2] = (a2 = t2) && a2 !== `none` ? [a2.slice(1, 4), a2.slice(5, 8)] : a2 === `none` ? [a2, a2] : [`Mid`, `Mid`];
    var a2;
    return { meetOrSlice: n2 || `meet`, alignX: r2, alignY: i2 };
  }, hn = (e2, t2, n2 = true) => {
    let r2, i2;
    if (t2) if (t2.toLive) r2 = `url(#SVGID_${U(t2.id)})`;
    else {
      let e3 = String(t2);
      if (nn(e3)) {
        let t3 = new G(e3), n3 = t3.getAlpha();
        r2 = t3.toRgb(), n3 !== 1 && (i2 = n3.toString());
      } else r2 = new G(`black`).toRgb();
    }
    else r2 = `none`;
    return n2 ? `${e2}: ${r2}; ${i2 ? `${e2}-opacity: ${i2}; ` : ``}` : `${e2}="${r2}" ${i2 ? `${e2}-opacity="${i2}" ` : ``}`;
  };
  var gn = class {
    getSvgStyles(e2) {
      let t2 = this.fillRule == null ? `nonzero` : an(this.fillRule), n2 = this.strokeWidth == null ? `0` : rn(this.strokeWidth), r2 = this.strokeDashArray == null ? te : this.strokeDashArray.every((e3) => Number.isFinite(Number(e3))) ? this.strokeDashArray.join(` `) : ``, i2 = this.strokeDashOffset == null ? `0` : rn(this.strokeDashOffset), a2 = this.strokeLineCap == null ? `butt` : an(this.strokeLineCap), o2 = this.strokeLineJoin == null ? `miter` : an(this.strokeLineJoin), s2 = this.strokeMiterLimit == null ? `4` : rn(this.strokeMiterLimit), c2 = this.opacity == null ? `1` : rn(this.opacity), l2 = this.visible ? `` : ` visibility: hidden;`, u2 = e2 ? `` : this.getSvgFilter(), d2 = hn(j, this.fill);
      return [hn(he, this.stroke), n2 ? `stroke-width: ${n2}; ` : ``, r2 ? `stroke-dasharray: ${r2}; ` : ``, a2 ? `stroke-linecap: ${a2}; ` : ``, i2 ? `stroke-dashoffset: ${i2}; ` : ``, o2 ? `stroke-linejoin: ${o2}; ` : ``, s2 ? `stroke-miterlimit: ${s2}; ` : ``, d2, t2 ? `fill-rule: ${t2}; ` : ``, c2 ? `opacity: ${c2};` : ``, u2, l2].map((e3) => U(e3)).join(``);
    }
    getSvgFilter() {
      return this.shadow ? `filter: url(#SVGID_${U(this.shadow.id)});` : ``;
    }
    getSvgCommons() {
      return [this.id ? `id="${U(String(this.id))}" ` : ``, this.clipPath ? `clip-path="url(#${U(this.clipPath.clipPathId)})" ` : ``].join(``);
    }
    getSvgTransform(e2, t2 = ``) {
      return `transform="${nt(e2 ? this.calcTransformMatrix() : this.calcOwnMatrix())}${t2}" `;
    }
    _toSVG(e2) {
      return [``];
    }
    toSVG(e2) {
      return this._createBaseSVGMarkup(this._toSVG(e2), { reviver: e2 });
    }
    toClipPathSVG(e2) {
      return `	` + this._createBaseClipPathSVGMarkup(this._toSVG(e2), { reviver: e2 });
    }
    _createBaseClipPathSVGMarkup(e2, { reviver: t2, additionalTransform: n2 = `` } = {}) {
      let r2 = [this.getSvgTransform(true, n2), this.getSvgCommons()].join(``), i2 = e2.indexOf(`COMMON_PARTS`);
      return e2[i2] = r2, t2 ? t2(e2.join(``)) : e2.join(``);
    }
    _createBaseSVGMarkup(e2, { noStyle: t2, reviver: n2, withShadow: r2, additionalTransform: i2 } = {}) {
      let a2 = t2 ? `` : `style="${this.getSvgStyles()}" `, o2 = r2 ? `style="${this.getSvgFilter()}" ` : ``, s2 = this.clipPath, c2 = this.strokeUniform ? `vector-effect="non-scaling-stroke" ` : ``, l2 = s2 && s2.absolutePositioned, u2 = this.stroke, d2 = this.fill, f2 = this.shadow, p2 = [], m = e2.indexOf(`COMMON_PARTS`), h2;
      return s2 && (s2.clipPathId = `CLIPPATH_${je()}`, h2 = `<clipPath id="${s2.clipPathId}" >
${s2.toClipPathSVG(n2)}</clipPath>
`), l2 && p2.push(`<g `, o2, this.getSvgCommons(), ` >
`), p2.push(`<g `, this.getSvgTransform(false), l2 ? `` : o2 + this.getSvgCommons(), ` >
`), e2[m] = [a2, c2, t2 ? `` : this.addPaintOrder(), ` `, i2 ? `transform="${i2}" ` : ``].join(``), V(d2) && p2.push(d2.toSVG(this)), V(u2) && p2.push(u2.toSVG(this)), f2 && p2.push(f2.toSVG(this)), s2 && p2.push(h2), p2.push(e2.join(``)), p2.push(`</g>
`), l2 && p2.push(`</g>
`), n2 ? n2(p2.join(``)) : p2.join(``);
    }
    addPaintOrder() {
      return this.paintFirst === `fill` ? `` : ` paint-order="${U(this.paintFirst)}" `;
    }
  };
  function _n(e2) {
    return RegExp(`^(` + e2.join(`|`) + `)\\b`, `i`);
  }
  const vn = `textDecorationThickness`, yn = `textDecorationColor`, bn = [`fontSize`, `fontWeight`, `fontFamily`, `fontStyle`], xn = [`underline`, `overline`, `linethrough`], Sn = [...bn, `lineHeight`, `text`, `charSpacing`, `textAlign`, `styles`, `path`, `pathStartOffset`, `pathSide`, `pathAlign`], Cn = [...Sn, ...xn, `textBackgroundColor`, `direction`, vn, yn], wn = [...bn, ...xn, he, `strokeWidth`, j, `deltaY`, `textBackgroundColor`, vn, yn], Tn = { _reNewline: ne, _reSpacesAndTabs: /[ \t\r]/g, _reSpaceAndTab: /[ \t\r]/, _reWords: /\S+/g, fontSize: 40, fontWeight: _e, fontFamily: `Times New Roman`, underline: false, overline: false, linethrough: false, textAlign: D, fontStyle: _e, lineHeight: 1.16, textBackgroundColor: ``, stroke: null, shadow: null, path: void 0, pathStartOffset: 0, pathSide: D, pathAlign: `baseline`, charSpacing: 0, deltaY: 0, direction: `ltr`, CACHE_FONT_SIZE: 400, MIN_TEXT_WIDTH: 2, superscript: { size: 0.6, baseline: -0.35 }, subscript: { size: 0.6, baseline: 0.11 }, _fontSizeFraction: 0.222, offsets: { underline: 0.1, linethrough: -0.28167, overline: -0.81333 }, _fontSizeMult: 1.13, [vn]: 66.667 }, En = `justify`, Dn = String.raw`[-+]?(?:\d*\.\d+|\d+\.?)(?:[eE][-+]?\d+)?`, An = RegExp(`(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(` + Dn + `(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|` + Dn + `))?\\s+(.*)`), jn = { cx: D, x: D, r: `radius`, cy: `top`, y: `top`, display: `visible`, visibility: `visible`, transform: `transformMatrix`, "fill-opacity": `fillOpacity`, "fill-rule": `fillRule`, "font-family": `fontFamily`, "font-size": `fontSize`, "font-style": `fontStyle`, "font-weight": `fontWeight`, "letter-spacing": `charSpacing`, "paint-order": `paintFirst`, "stroke-dasharray": `strokeDashArray`, "stroke-dashoffset": `strokeDashOffset`, "stroke-linecap": `strokeLineCap`, "stroke-linejoin": `strokeLineJoin`, "stroke-miterlimit": `strokeMiterLimit`, "stroke-opacity": `strokeOpacity`, "stroke-width": `strokeWidth`, "text-decoration": `textDecoration`, "text-anchor": `textAnchor`, opacity: `opacity`, "clip-path": `clipPath`, "clip-rule": `clipRule`, "vector-effect": `strokeUniform`, "image-rendering": `imageSmoothing`, "text-decoration-thickness": vn, "text-decoration-color": yn }, Mn = `font-size`, Nn = `clip-path`;
  _n([`path`, `circle`, `polygon`, `polyline`, `ellipse`, `rect`, `line`, `image`, `text`]);
  _n([`symbol`, `image`, `marker`, `pattern`, `view`, `svg`]);
  const In = _n([`symbol`, `g`, `a`, `svg`, `clipPath`, `defs`]), Rn = `(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?`, zn = RegExp(`(?:\\s|^)` + Rn + Rn + `(` + Dn + `?(?:px)?)?(?:\\s?|$)(?:$|\\s)`);
  var Bn = class e2 {
    constructor(t2 = {}) {
      let n2 = typeof t2 == `string` ? e2.parseShadow(t2) : t2;
      Object.assign(this, e2.ownDefaults, n2), this.id = je();
    }
    static parseShadow(e3) {
      let t2 = e3.trim(), [, n2 = 0, r2 = 0, i2 = 0] = (zn.exec(t2) || []).map((e4) => parseFloat(e4) || 0);
      return { color: (t2.replace(zn, ``) || `rgb(0,0,0)`).trim(), offsetX: n2, offsetY: r2, blur: i2 };
    }
    toString() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join(`px `);
    }
    toSVG(e3) {
      let t2 = Rt(new N(this.offsetX, this.offsetY), I(-e3.angle)), n2 = o.NUM_FRACTION_DIGITS, r2 = new G(this.color), i2 = 40, a2 = 40;
      return e3.width && e3.height && (i2 = 100 * B((Math.abs(t2.x) + this.blur) / e3.width, n2) + 20, a2 = 100 * B((Math.abs(t2.y) + this.blur) / e3.height, n2) + 20), e3.flipX && (t2.x *= -1), e3.flipY && (t2.y *= -1), `<filter id="SVGID_${U(this.id)}" y="-${a2}%" height="${100 + 2 * a2}%" x="-${i2}%" width="${100 + 2 * i2}%" >
	<feGaussianBlur in="SourceAlpha" stdDeviation="${B(this.blur ? this.blur / 2 : 0, n2)}"></feGaussianBlur>
	<feOffset dx="${B(t2.x, n2)}" dy="${B(t2.y, n2)}" result="oBlur" ></feOffset>
	<feFlood flood-color="${r2.toRgb()}" flood-opacity="${r2.getAlpha()}"/>
	<feComposite in2="oBlur" operator="in" />
	<feMerge>
		<feMergeNode></feMergeNode>
		<feMergeNode in="SourceGraphic"></feMergeNode>
	</feMerge>
</filter>
`;
    }
    toObject() {
      let t2 = { color: this.color, blur: this.blur, offsetX: this.offsetX, offsetY: this.offsetY, affectStroke: this.affectStroke, nonScaling: this.nonScaling, type: this.constructor.type }, n2 = e2.ownDefaults;
      return this.includeDefaultValues ? t2 : tt(t2, (e3, t3) => e3 !== n2[t3]);
    }
    static async fromObject(e3) {
      return new this(e3);
    }
  };
  i(Bn, `ownDefaults`, { color: `rgb(0,0,0)`, blur: 0, offsetX: 0, offsetY: 0, affectStroke: false, includeDefaultValues: true, nonScaling: false }), i(Bn, `type`, `shadow`), M.setClass(Bn, `shadow`);
  const Vn = (e2, t2, n2) => Math.max(e2, Math.min(t2, n2)), Hn = [`top`, D, de, fe, `flipX`, `flipY`, `originX`, `originY`, `angle`, `opacity`, `globalCompositeOperation`, `shadow`, `visible`, pe, me], Un = [j, he, `strokeWidth`, `strokeDashArray`, `width`, `height`, `paintFirst`, `strokeUniform`, `strokeLineCap`, `strokeDashOffset`, `strokeLineJoin`, `strokeMiterLimit`, `backgroundColor`, `clipPath`], Wn = { top: 0, left: 0, width: 0, height: 0, angle: 0, flipX: false, flipY: false, scaleX: 1, scaleY: 1, minScaleLimit: 0, skewX: 0, skewY: 0, originX: E, originY: E, strokeWidth: 1, strokeUniform: false, padding: 0, opacity: 1, paintFirst: j, fill: `rgb(0,0,0)`, fillRule: `nonzero`, stroke: null, strokeDashArray: null, strokeDashOffset: 0, strokeLineCap: `butt`, strokeLineJoin: `miter`, strokeMiterLimit: 4, globalCompositeOperation: `source-over`, backgroundColor: ``, shadow: null, visible: true, includeDefaultValues: true, excludeFromExport: false, objectCaching: true, clipPath: void 0, inverted: false, absolutePositioned: false, centeredRotation: true, centeredScaling: false, dirty: true };
  var Gn = t({ defaultEasing: () => Jn, easeInBack: () => gr, easeInBounce: () => br, easeInCirc: () => ur, easeInCubic: () => Yn, easeInElastic: () => pr, easeInExpo: () => sr, easeInOutBack: () => vr, easeInOutBounce: () => xr, easeInOutCirc: () => fr, easeInOutCubic: () => Zn, easeInOutElastic: () => hr, easeInOutExpo: () => lr, easeInOutQuad: () => wr, easeInOutQuart: () => er, easeInOutQuint: () => rr, easeInOutSine: () => or, easeInQuad: () => Sr, easeInQuart: () => Qn, easeInQuint: () => tr, easeInSine: () => ir, easeOutBack: () => _r, easeOutBounce: () => yr, easeOutCirc: () => dr, easeOutCubic: () => Xn, easeOutElastic: () => mr, easeOutExpo: () => cr, easeOutQuad: () => Cr, easeOutQuart: () => $n, easeOutQuint: () => nr, easeOutSine: () => ar });
  const Kn = (e2, t2, n2, r2) => (e2 < Math.abs(t2) ? (e2 = t2, r2 = n2 / 4) : r2 = t2 === 0 && e2 === 0 ? n2 / w * Math.asin(1) : n2 / w * Math.asin(t2 / e2), { a: e2, c: t2, p: n2, s: r2 }), qn = (e2, t2, n2, r2, i2) => e2 * 2 ** (10 * --r2) * Math.sin((r2 * i2 - t2) * w / n2), Jn = (e2, t2, n2, r2) => -n2 * Math.cos(e2 / r2 * S) + n2 + t2, Yn = (e2, t2, n2, r2) => n2 * (e2 / r2) ** 3 + t2, Xn = (e2, t2, n2, r2) => n2 * ((e2 / r2 - 1) ** 3 + 1) + t2, Zn = (e2, t2, n2, r2) => (e2 /= r2 / 2) < 1 ? n2 / 2 * e2 ** 3 + t2 : n2 / 2 * ((e2 - 2) ** 3 + 2) + t2, Qn = (e2, t2, n2, r2) => n2 * (e2 /= r2) * e2 ** 3 + t2, $n = (e2, t2, n2, r2) => -n2 * ((e2 = e2 / r2 - 1) * e2 ** 3 - 1) + t2, er = (e2, t2, n2, r2) => (e2 /= r2 / 2) < 1 ? n2 / 2 * e2 ** 4 + t2 : -n2 / 2 * ((e2 -= 2) * e2 ** 3 - 2) + t2, tr = (e2, t2, n2, r2) => n2 * (e2 / r2) ** 5 + t2, nr = (e2, t2, n2, r2) => n2 * ((e2 / r2 - 1) ** 5 + 1) + t2, rr = (e2, t2, n2, r2) => (e2 /= r2 / 2) < 1 ? n2 / 2 * e2 ** 5 + t2 : n2 / 2 * ((e2 - 2) ** 5 + 2) + t2, ir = (e2, t2, n2, r2) => -n2 * Math.cos(e2 / r2 * S) + n2 + t2, ar = (e2, t2, n2, r2) => n2 * Math.sin(e2 / r2 * S) + t2, or = (e2, t2, n2, r2) => -n2 / 2 * (Math.cos(Math.PI * e2 / r2) - 1) + t2, sr = (e2, t2, n2, r2) => e2 === 0 ? t2 : n2 * 2 ** (10 * (e2 / r2 - 1)) + t2, cr = (e2, t2, n2, r2) => e2 === r2 ? t2 + n2 : n2 * -(2 ** (-10 * e2 / r2) + 1) + t2, lr = (e2, t2, n2, r2) => e2 === 0 ? t2 : e2 === r2 ? t2 + n2 : (e2 /= r2 / 2) < 1 ? n2 / 2 * 2 ** (10 * (e2 - 1)) + t2 : n2 / 2 * -(2 ** (-10 * (e2 - 1)) + 2) + t2, ur = (e2, t2, n2, r2) => -n2 * (Math.sqrt(1 - (e2 /= r2) * e2) - 1) + t2, dr = (e2, t2, n2, r2) => n2 * Math.sqrt(1 - (e2 = e2 / r2 - 1) * e2) + t2, fr = (e2, t2, n2, r2) => (e2 /= r2 / 2) < 1 ? -n2 / 2 * (Math.sqrt(1 - e2 ** 2) - 1) + t2 : n2 / 2 * (Math.sqrt(1 - (e2 -= 2) * e2) + 1) + t2, pr = (e2, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e2 === 0) return t2;
    if ((e2 /= r2) === 1) return t2 + n2;
    a2 || (a2 = 0.3 * r2);
    let { a: o2, s: s2, p: c2 } = Kn(i2, n2, a2, 1.70158);
    return -qn(o2, s2, c2, e2, r2) + t2;
  }, mr = (e2, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e2 === 0) return t2;
    if ((e2 /= r2) === 1) return t2 + n2;
    a2 || (a2 = 0.3 * r2);
    let { a: o2, s: s2, p: c2, c: l2 } = Kn(i2, n2, a2, 1.70158);
    return o2 * 2 ** (-10 * e2) * Math.sin((e2 * r2 - s2) * w / c2) + l2 + t2;
  }, hr = (e2, t2, n2, r2) => {
    let i2 = n2, a2 = 0;
    if (e2 === 0) return t2;
    if ((e2 /= r2 / 2) == 2) return t2 + n2;
    a2 || (a2 = 0.3 * 1.5 * r2);
    let { a: o2, s: s2, p: c2, c: l2 } = Kn(i2, n2, a2, 1.70158);
    return e2 < 1 ? -0.5 * qn(o2, s2, c2, e2, r2) + t2 : o2 * 2 ** (-10 * --e2) * Math.sin((e2 * r2 - s2) * w / c2) * 0.5 + l2 + t2;
  }, gr = (e2, t2, n2, r2, i2 = 1.70158) => n2 * (e2 /= r2) * e2 * ((i2 + 1) * e2 - i2) + t2, _r = (e2, t2, n2, r2, i2 = 1.70158) => n2 * ((e2 = e2 / r2 - 1) * e2 * ((i2 + 1) * e2 + i2) + 1) + t2, vr = (e2, t2, n2, r2, i2 = 1.70158) => (e2 /= r2 / 2) < 1 ? n2 / 2 * (e2 * e2 * ((1 + (i2 *= 1.525)) * e2 - i2)) + t2 : n2 / 2 * ((e2 -= 2) * e2 * ((1 + (i2 *= 1.525)) * e2 + i2) + 2) + t2, yr = (e2, t2, n2, r2) => (e2 /= r2) < 1 / 2.75 ? n2 * (7.5625 * e2 * e2) + t2 : e2 < 2 / 2.75 ? n2 * (7.5625 * (e2 -= 1.5 / 2.75) * e2 + 0.75) + t2 : e2 < 2.5 / 2.75 ? n2 * (7.5625 * (e2 -= 2.25 / 2.75) * e2 + 0.9375) + t2 : n2 * (7.5625 * (e2 -= 2.625 / 2.75) * e2 + 0.984375) + t2, br = (e2, t2, n2, r2) => n2 - yr(r2 - e2, 0, n2, r2) + t2, xr = (e2, t2, n2, r2) => e2 < r2 / 2 ? 0.5 * br(2 * e2, 0, n2, r2) + t2 : 0.5 * yr(2 * e2 - r2, 0, n2, r2) + 0.5 * n2 + t2, Sr = (e2, t2, n2, r2) => n2 * (e2 /= r2) * e2 + t2, Cr = (e2, t2, n2, r2) => -n2 * (e2 /= r2) * (e2 - 2) + t2, wr = (e2, t2, n2, r2) => (e2 /= r2 / 2) < 1 ? n2 / 2 * e2 ** 2 + t2 : -n2 / 2 * (--e2 * (e2 - 2) - 1) + t2, Tr = () => false;
  var Er = class {
    constructor({ startValue: e2, byValue: t2, duration: n2 = 500, delay: r2 = 0, easing: a2 = Jn, onStart: o2 = x, onChange: s2 = x, onComplete: c2 = x, abort: l2 = Tr, target: u2 }) {
      i(this, `_state`, `pending`), i(this, `durationProgress`, 0), i(this, `valueProgress`, 0), this.tick = this.tick.bind(this), this.duration = n2, this.delay = r2, this.easing = a2, this._onStart = o2, this._onChange = s2, this._onComplete = c2, this._abort = l2, this.target = u2, this.startValue = e2, this.byValue = t2, this.value = this.startValue, this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
    get state() {
      return this._state;
    }
    isDone() {
      return this._state === `aborted` || this._state === `completed`;
    }
    start() {
      let e2 = (e3) => {
        this._state === `pending` && (this.startTime = e3 || +/* @__PURE__ */ new Date(), this._state = `running`, this._onStart(), this.tick(this.startTime));
      };
      this.register(), this.delay > 0 ? this.timeout = _().setTimeout(() => Oe(e2), this.delay) : Oe(e2);
    }
    tick(e2) {
      let t2 = (e2 || +/* @__PURE__ */ new Date()) - this.startTime, n2 = Math.min(t2, this.duration);
      this.durationProgress = n2 / this.duration;
      let { value: r2, valueProgress: i2 } = this.calculate(n2);
      this.value = Object.freeze(r2), this.valueProgress = i2, this._state !== `aborted` && (this._abort(this.value, this.valueProgress, this.durationProgress) ? (this._state = `aborted`, this.unregister()) : t2 >= this.duration ? (this.durationProgress = this.valueProgress = 1, this._onChange(this.endValue, this.valueProgress, this.durationProgress), this._state = `completed`, this._onComplete(this.endValue, this.valueProgress, this.durationProgress), this.unregister(), this.timeout = null) : (this._onChange(this.value, this.valueProgress, this.durationProgress), Oe(this.tick)));
    }
    register() {
      ye.push(this);
    }
    unregister() {
      ye.remove(this);
    }
    abort() {
      this._state = `aborted`, this.unregister(), this.timeout && _().clearTimeout(this.timeout);
    }
  }, Dr = class extends Er {
    constructor({ startValue: e2 = 0, endValue: t2 = 100, ...n2 }) {
      super({ ...n2, startValue: e2, byValue: t2 - e2 });
    }
    calculate(e2) {
      let t2 = this.easing(e2, this.startValue, this.byValue, this.duration);
      return { value: t2, valueProgress: Math.abs((t2 - this.startValue) / this.byValue) };
    }
  }, Or = class extends Er {
    constructor({ startValue: e2 = [0], endValue: t2 = [100], ...n2 }) {
      super({ ...n2, startValue: e2, byValue: t2.map((t3, n3) => t3 - e2[n3]) });
    }
    calculate(e2) {
      let t2 = this.startValue.map((t3, n2) => this.easing(e2, t3, this.byValue[n2], this.duration, n2));
      return { value: t2, valueProgress: Math.abs((t2[0] - this.startValue[0]) / this.byValue[0]) };
    }
  };
  const kr = (e2, t2, n2, r2) => t2 + n2 * (1 - Math.cos(e2 / r2 * S)), Ar = (e2) => e2 && ((t2, n2, r2) => e2(new G(t2).toRgba(), n2, r2));
  var jr = class extends Er {
    constructor({ startValue: e2, endValue: t2, easing: n2 = kr, onChange: r2, onComplete: i2, abort: a2, ...o2 }) {
      let s2 = new G(e2).getSource(), c2 = new G(t2).getSource();
      super({ ...o2, startValue: s2, byValue: c2.map((e3, t3) => e3 - s2[t3]), easing: n2, onChange: Ar(r2), onComplete: Ar(i2), abort: Ar(a2) });
    }
    calculate(e2) {
      let [t2, n2, r2, i2] = this.startValue.map((t3, n3) => this.easing(e2, t3, this.byValue[n3], this.duration, n3)), a2 = [...[t2, n2, r2].map(Math.round), Vn(0, i2, 1)];
      return { value: a2, valueProgress: a2.map((e3, t3) => this.byValue[t3] === 0 ? 0 : Math.abs((e3 - this.startValue[t3]) / this.byValue[t3])).find((e3) => e3 !== 0) || 0 };
    }
  };
  function Mr(e2) {
    let t2 = ((e3) => Array.isArray(e3.startValue) || Array.isArray(e3.endValue))(e2) ? new Or(e2) : new Dr(e2);
    return t2.start(), t2;
  }
  function Nr(e2) {
    let t2 = new jr(e2);
    return t2.start(), t2;
  }
  var Pr = class e2 {
    constructor(e3) {
      this.status = e3, this.points = [];
    }
    includes(e3) {
      return this.points.some((t2) => t2.eq(e3));
    }
    append(...e3) {
      return this.points = this.points.concat(e3.filter((e4) => !this.includes(e4))), this;
    }
    static isPointContained(e3, t2, n2, r2 = false) {
      if (t2.eq(n2)) return e3.eq(t2);
      if (t2.x === n2.x) return e3.x === t2.x && (r2 || e3.y >= Math.min(t2.y, n2.y) && e3.y <= Math.max(t2.y, n2.y));
      if (t2.y === n2.y) return e3.y === t2.y && (r2 || e3.x >= Math.min(t2.x, n2.x) && e3.x <= Math.max(t2.x, n2.x));
      {
        let i2 = zt(t2, n2), a2 = zt(t2, e3).divide(i2);
        return r2 ? Math.abs(a2.x) === Math.abs(a2.y) : a2.x === a2.y && a2.x >= 0 && a2.x <= 1;
      }
    }
    static isPointInPolygon(e3, t2) {
      let n2 = new N(e3).setX(Math.min(e3.x - 1, ...t2.map((e4) => e4.x))), r2 = 0;
      for (let i2 = 0; i2 < t2.length; i2++) {
        let a2 = this.intersectSegmentSegment(t2[i2], t2[(i2 + 1) % t2.length], e3, n2);
        if (a2.includes(e3)) return true;
        r2 += Number(a2.status === `Intersection`);
      }
      return r2 % 2 == 1;
    }
    static intersectLineLine(t2, n2, r2, i2, a2 = true, o2 = true) {
      let s2 = n2.x - t2.x, c2 = n2.y - t2.y, l2 = i2.x - r2.x, u2 = i2.y - r2.y, d2 = t2.x - r2.x, f2 = t2.y - r2.y, p2 = l2 * f2 - u2 * d2, m = s2 * f2 - c2 * d2, h2 = u2 * s2 - l2 * c2;
      if (h2 !== 0) {
        let n3 = p2 / h2, r3 = m / h2;
        return (a2 || 0 <= n3 && n3 <= 1) && (o2 || 0 <= r3 && r3 <= 1) ? new e2(`Intersection`).append(new N(t2.x + n3 * s2, t2.y + n3 * c2)) : new e2();
      }
      return new e2(p2 === 0 || m === 0 ? a2 || o2 || e2.isPointContained(t2, r2, i2) || e2.isPointContained(n2, r2, i2) || e2.isPointContained(r2, t2, n2) || e2.isPointContained(i2, t2, n2) ? `Coincident` : void 0 : `Parallel`);
    }
    static intersectSegmentLine(t2, n2, r2, i2) {
      return e2.intersectLineLine(t2, n2, r2, i2, false, true);
    }
    static intersectSegmentSegment(t2, n2, r2, i2) {
      return e2.intersectLineLine(t2, n2, r2, i2, false, false);
    }
    static intersectLinePolygon(t2, n2, r2, i2 = true) {
      let a2 = new e2(), o2 = r2.length;
      for (let s2, c2, l2, u2 = 0; u2 < o2; u2++) {
        if (s2 = r2[u2], c2 = r2[(u2 + 1) % o2], l2 = e2.intersectLineLine(t2, n2, s2, c2, i2, false), l2.status === `Coincident`) return l2;
        a2.append(...l2.points);
      }
      return a2.points.length > 0 && (a2.status = `Intersection`), a2;
    }
    static intersectSegmentPolygon(t2, n2, r2) {
      return e2.intersectLinePolygon(t2, n2, r2, false);
    }
    static intersectPolygonPolygon(t2, n2) {
      let r2 = new e2(), i2 = t2.length, a2 = [];
      for (let o2 = 0; o2 < i2; o2++) {
        let s2 = t2[o2], c2 = t2[(o2 + 1) % i2], l2 = e2.intersectSegmentPolygon(s2, c2, n2);
        l2.status === `Coincident` ? (a2.push(l2), r2.append(s2, c2)) : r2.append(...l2.points);
      }
      return a2.length > 0 && a2.length === t2.length ? new e2(`Coincident`) : (r2.points.length > 0 && (r2.status = `Intersection`), r2);
    }
    static intersectPolygonRectangle(t2, n2, r2) {
      let i2 = n2.min(r2), a2 = n2.max(r2), o2 = new N(a2.x, i2.y), s2 = new N(i2.x, a2.y);
      return e2.intersectPolygonPolygon(t2, [i2, o2, a2, s2]);
    }
  }, Fr = class extends De {
    getX() {
      return this.getXY().x;
    }
    setX(e2) {
      this.setXY(this.getXY().setX(e2));
    }
    getY() {
      return this.getXY().y;
    }
    setY(e2) {
      this.setXY(this.getXY().setY(e2));
    }
    getRelativeX() {
      return this.left;
    }
    setRelativeX(e2) {
      this.left = e2;
    }
    getRelativeY() {
      return this.top;
    }
    setRelativeY(e2) {
      this.top = e2;
    }
    getXY() {
      let e2 = this.getRelativeXY();
      return this.group ? L(e2, this.group.calcTransformMatrix()) : e2;
    }
    setXY(e2, t2, n2) {
      this.group && (e2 = L(e2, R(this.group.calcTransformMatrix()))), this.setRelativeXY(e2, t2, n2);
    }
    getRelativeXY() {
      return new N(this.left, this.top);
    }
    setRelativeXY(e2, t2 = this.originX, n2 = this.originY) {
      this.setPositionByOrigin(e2, t2, n2);
    }
    isStrokeAccountedForInDimensions() {
      return false;
    }
    getCoords() {
      let { tl: e2, tr: t2, br: n2, bl: r2 } = this.aCoords || (this.aCoords = this.calcACoords()), i2 = [e2, t2, n2, r2];
      if (this.group) {
        let e3 = this.group.calcTransformMatrix();
        return i2.map((t3) => L(t3, e3));
      }
      return i2;
    }
    intersectsWithRect(e2, t2) {
      return Pr.intersectPolygonRectangle(this.getCoords(), e2, t2).status === `Intersection`;
    }
    intersectsWithObject(e2) {
      let t2 = Pr.intersectPolygonPolygon(this.getCoords(), e2.getCoords());
      return t2.status === `Intersection` || t2.status === `Coincident` || e2.isContainedWithinObject(this) || this.isContainedWithinObject(e2);
    }
    isContainedWithinObject(e2) {
      return this.getCoords().every((t2) => e2.containsPoint(t2));
    }
    isContainedWithinRect(e2, t2) {
      let { left: n2, top: r2, width: i2, height: a2 } = this.getBoundingRect();
      return n2 >= e2.x && n2 + i2 <= t2.x && r2 >= e2.y && r2 + a2 <= t2.y;
    }
    isOverlapping(e2) {
      return this.intersectsWithObject(e2) || this.isContainedWithinObject(e2) || e2.isContainedWithinObject(this);
    }
    containsPoint(e2) {
      return Pr.isPointInPolygon(e2, this.getCoords());
    }
    isOnScreen() {
      if (!this.canvas) return false;
      let { tl: e2, br: t2 } = this.canvas.vptCoords;
      return !!this.getCoords().some((n2) => n2.x <= t2.x && n2.x >= e2.x && n2.y <= t2.y && n2.y >= e2.y) || !!this.intersectsWithRect(e2, t2) || this.containsPoint(e2.midPointFrom(t2));
    }
    isPartiallyOnScreen() {
      if (!this.canvas) return false;
      let { tl: e2, br: t2 } = this.canvas.vptCoords;
      return !!this.intersectsWithRect(e2, t2) || this.getCoords().every((n2) => (n2.x >= t2.x || n2.x <= e2.x) && (n2.y >= t2.y || n2.y <= e2.y)) && this.containsPoint(e2.midPointFrom(t2));
    }
    getBoundingRect() {
      return wt(this.getCoords());
    }
    getScaledWidth() {
      return this._getTransformedDimensions().x;
    }
    getScaledHeight() {
      return this._getTransformedDimensions().y;
    }
    scale(e2) {
      this._set(de, e2), this._set(fe, e2), this.setCoords();
    }
    scaleToWidth(e2) {
      let t2 = this.getBoundingRect().width / this.getScaledWidth();
      return this.scale(e2 / this.width / t2);
    }
    scaleToHeight(e2) {
      let t2 = this.getBoundingRect().height / this.getScaledHeight();
      return this.scale(e2 / this.height / t2);
    }
    getCanvasRetinaScaling() {
      var e2;
      return ((e2 = this.canvas) == null ? void 0 : e2.getRetinaScaling()) || 1;
    }
    getTotalAngle() {
      return this.group ? Ie(ze(this.calcTransformMatrix())) : this.angle;
    }
    getViewportTransform() {
      var e2;
      return ((e2 = this.canvas) == null ? void 0 : e2.viewportTransform) || T.concat();
    }
    calcACoords() {
      let e2 = We({ angle: this.angle }), { x: t2, y: n2 } = this.getRelativeCenterPoint(), r2 = z(Ue(t2, n2), e2), i2 = this._getTransformedDimensions(), a2 = i2.x / 2, o2 = i2.y / 2;
      return { tl: L({ x: -a2, y: -o2 }, r2), tr: L({ x: a2, y: -o2 }, r2), bl: L({ x: -a2, y: o2 }, r2), br: L({ x: a2, y: o2 }, r2) };
    }
    setCoords() {
      this.aCoords = this.calcACoords();
    }
    transformMatrixKey(e2 = false) {
      let t2 = [];
      return !e2 && this.group && (t2 = this.group.transformMatrixKey(e2)), t2.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, W(this.originX), W(this.originY)), t2;
    }
    calcTransformMatrix(e2 = false) {
      let t2 = this.calcOwnMatrix();
      if (e2 || !this.group) return t2;
      let n2 = this.transformMatrixKey(e2), r2 = this.matrixCache;
      return r2 && r2.key.every((e3, t3) => e3 === n2[t3]) ? r2.value : (this.group && (t2 = z(this.group.calcTransformMatrix(false), t2)), this.matrixCache = { key: n2, value: t2 }, t2);
    }
    calcOwnMatrix() {
      let e2 = this.transformMatrixKey(true), t2 = this.ownMatrixCache;
      if (t2 && t2.key.every((t3, n3) => t3 === e2[n3])) return t2.value;
      let n2 = this.getRelativeCenterPoint(), r2 = Xe({ angle: this.angle, translateX: n2.x, translateY: n2.y, scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, flipX: this.flipX, flipY: this.flipY });
      return this.ownMatrixCache = { key: e2, value: r2 }, r2;
    }
    _getNonTransformedDimensions() {
      return new N(this.width, this.height).scalarAdd(this.strokeWidth);
    }
    _calculateCurrentDimensions(e2) {
      var t2;
      let n2 = (t2 = this.canvas) == null ? void 0 : t2.viewportTransform, r2 = this._getTransformedDimensions(e2);
      return n2 ? r2.multiply(new N(Be(n2), Ve(n2))).scalarAdd(2 * this.padding) : r2.scalarAdd(2 * this.padding);
    }
    _getTransformedDimensions(e2 = {}) {
      let t2 = { scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, width: this.width, height: this.height, strokeWidth: this.strokeWidth, ...e2 }, n2 = t2.strokeWidth, r2 = n2, i2 = 0;
      this.strokeUniform && (r2 = 0, i2 = n2);
      let a2 = t2.width + r2, o2 = t2.height + r2, s2;
      return s2 = t2.skewX === 0 && t2.skewY === 0 ? new N(a2 * t2.scaleX, o2 * t2.scaleY) : At(a2, o2, Ye(t2)), s2.scalarAdd(i2);
    }
    translateToGivenOrigin(e2, t2, n2, r2, i2) {
      let a2 = e2.x, o2 = e2.y, s2 = W(r2) - W(t2), c2 = W(i2) - W(n2);
      if (s2 || c2) {
        let e3 = this._getTransformedDimensions();
        a2 += s2 * e3.x, o2 += c2 * e3.y;
      }
      return new N(a2, o2);
    }
    translateToCenterPoint(e2, t2, n2) {
      if (t2 === `center` && n2 === `center`) return e2;
      let r2 = this.translateToGivenOrigin(e2, t2, n2, E, E);
      return this.angle ? r2.rotate(I(this.angle), e2) : r2;
    }
    translateToOriginPoint(e2, t2, n2) {
      let r2 = this.translateToGivenOrigin(e2, E, E, t2, n2);
      return this.angle ? r2.rotate(I(this.angle), e2) : r2;
    }
    getCenterPoint() {
      let e2 = this.getRelativeCenterPoint();
      return this.group ? L(e2, this.group.calcTransformMatrix()) : e2;
    }
    getRelativeCenterPoint() {
      return this.translateToCenterPoint(new N(this.left, this.top), this.originX, this.originY);
    }
    getPointByOrigin(e2, t2) {
      return this.getPositionByOrigin(e2, t2);
    }
    getPositionByOrigin(e2, t2) {
      return this.translateToOriginPoint(this.getRelativeCenterPoint(), e2, t2);
    }
    setPositionByOrigin(e2, t2, n2) {
      let r2 = this.translateToCenterPoint(e2, t2, n2), i2 = this.translateToOriginPoint(r2, this.originX, this.originY);
      this.set({ left: i2.x, top: i2.y });
    }
    _getLeftTopCoords() {
      return this.getPositionByOrigin(D, `top`);
    }
    positionByLeftTop(e2) {
      return this.setPositionByOrigin(e2, D, `top`);
    }
  }, Ir = class e2 extends Fr {
    static getDefaults() {
      return e2.ownDefaults;
    }
    get type() {
      let e3 = this.constructor.type;
      return e3 === `FabricObject` ? `object` : e3.toLowerCase();
    }
    set type(e3) {
      s(`warn`, `Setting type has no effect`, e3);
    }
    constructor(t2) {
      super(), i(this, `_cacheContext`, null), Object.assign(this, e2.ownDefaults), this.setOptions(t2);
    }
    _createCacheCanvas() {
      this._cacheCanvas = P(), this._cacheContext = this._cacheCanvas.getContext(`2d`), this._updateCacheCanvas(), this.dirty = true;
    }
    _limitCacheSize(e3) {
      let t2 = e3.width, n2 = e3.height, r2 = o.maxCacheSideLimit, i2 = o.minCacheSideLimit;
      if (t2 <= r2 && n2 <= r2 && t2 * n2 <= o.perfLimitSizeTotal) return t2 < i2 && (e3.width = i2), n2 < i2 && (e3.height = i2), e3;
      let a2 = t2 / n2, [s2, c2] = y.limitDimsByArea(a2), l2 = Vn(i2, s2, r2), u2 = Vn(i2, c2, r2);
      return t2 > l2 && (e3.zoomX /= t2 / l2, e3.width = l2, e3.capped = true), n2 > u2 && (e3.zoomY /= n2 / u2, e3.height = u2, e3.capped = true), e3;
    }
    _getCacheCanvasDimensions() {
      let e3 = this.getTotalObjectScaling(), t2 = this._getTransformedDimensions({ skewX: 0, skewY: 0 }), n2 = t2.x * e3.x / this.scaleX, r2 = t2.y * e3.y / this.scaleY;
      return { width: Math.ceil(n2 + 2), height: Math.ceil(r2 + 2), zoomX: e3.x, zoomY: e3.y, x: n2, y: r2 };
    }
    _updateCacheCanvas() {
      let e3 = this._cacheCanvas, t2 = this._cacheContext, { width: n2, height: r2, zoomX: i2, zoomY: a2, x: o2, y: s2 } = this._limitCacheSize(this._getCacheCanvasDimensions()), c2 = n2 !== e3.width || r2 !== e3.height, l2 = this.zoomX !== i2 || this.zoomY !== a2;
      if (!e3 || !t2) return false;
      if (c2 || l2) {
        n2 !== e3.width || r2 !== e3.height ? (e3.width = n2, e3.height = r2) : (t2.setTransform(1, 0, 0, 1, 0, 0), t2.clearRect(0, 0, e3.width, e3.height));
        let c3 = o2 / 2, l3 = s2 / 2;
        return this.cacheTranslationX = Math.round(e3.width / 2 - c3) + c3, this.cacheTranslationY = Math.round(e3.height / 2 - l3) + l3, t2.translate(this.cacheTranslationX, this.cacheTranslationY), t2.scale(i2, a2), this.zoomX = i2, this.zoomY = a2, true;
      }
      return false;
    }
    setOptions(e3 = {}) {
      this._setOptions(e3);
    }
    transform(e3) {
      let t2 = this.group && !this.group._transformDone || this.group && this.canvas && e3 === this.canvas.contextTop, n2 = this.calcTransformMatrix(!t2);
      e3.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]);
    }
    getObjectScaling() {
      if (!this.group) return new N(Math.abs(this.scaleX), Math.abs(this.scaleY));
      let e3 = He(this.calcTransformMatrix());
      return new N(Math.abs(e3.scaleX), Math.abs(e3.scaleY));
    }
    getTotalObjectScaling() {
      let e3 = this.getObjectScaling();
      if (this.canvas) {
        let t2 = this.canvas.getZoom(), n2 = this.getCanvasRetinaScaling();
        return e3.scalarMultiply(t2 * n2);
      }
      return e3;
    }
    getObjectOpacity() {
      let e3 = this.opacity;
      return this.group && (e3 *= this.group.getObjectOpacity()), e3;
    }
    _constrainScale(e3) {
      return Math.abs(e3) < this.minScaleLimit ? e3 < 0 ? -this.minScaleLimit : this.minScaleLimit : e3 === 0 ? 1e-4 : e3;
    }
    _set(e3, t2) {
      e3 !== `scaleX` && e3 !== `scaleY` || (t2 = this._constrainScale(t2)), e3 === `scaleX` && t2 < 0 ? (this.flipX = !this.flipX, t2 *= -1) : e3 === `scaleY` && t2 < 0 ? (this.flipY = !this.flipY, t2 *= -1) : e3 !== `shadow` || !t2 || t2 instanceof Bn || (t2 = new Bn(t2));
      let n2 = this[e3] !== t2;
      return this[e3] = t2, n2 && this.constructor.cacheProperties.includes(e3) && (this.dirty = true), this.parent && (this.dirty || n2 && this.constructor.stateProperties.includes(e3)) && this.parent._set(`dirty`, true), this;
    }
    isNotVisible() {
      return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }
    render(e3) {
      this.isNotVisible() || this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (e3.save(), this._setupCompositeOperation(e3), this.drawSelectionBackground(e3), this.transform(e3), this._setOpacity(e3), this._setShadow(e3), this.shouldCache() ? (this.renderCache(), this.drawCacheOnCanvas(e3)) : (this._removeCacheCanvas(), this.drawObject(e3, false, {}), this.dirty = false), e3.restore());
    }
    drawSelectionBackground(e3) {
    }
    renderCache(e3) {
      if (e3 = e3 || {}, this._cacheCanvas && this._cacheContext || this._createCacheCanvas(), this.isCacheDirty() && this._cacheContext) {
        let { zoomX: t2, zoomY: n2, cacheTranslationX: r2, cacheTranslationY: i2 } = this, { width: a2, height: o2 } = this._cacheCanvas;
        this.drawObject(this._cacheContext, e3.forClipping, { zoomX: t2, zoomY: n2, cacheTranslationX: r2, cacheTranslationY: i2, width: a2, height: o2, parentClipPaths: [] }), this.dirty = false;
      }
    }
    _removeCacheCanvas() {
      this._cacheCanvas = void 0, this._cacheContext = null;
    }
    hasStroke() {
      return !!this.stroke && this.stroke !== `transparent` && this.strokeWidth !== 0;
    }
    hasFill() {
      return !!this.fill && this.fill !== `transparent`;
    }
    needsItsOwnCache() {
      return !!(this.paintFirst === `stroke` && this.hasFill() && this.hasStroke() && this.shadow) || !!this.clipPath;
    }
    shouldCache() {
      return this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache(), this.ownCaching;
    }
    willDrawShadow() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }
    drawClipPathOnCache(e3, t2, n2) {
      e3.save(), t2.inverted ? e3.globalCompositeOperation = `destination-out` : e3.globalCompositeOperation = `destination-in`, e3.setTransform(1, 0, 0, 1, 0, 0), e3.drawImage(n2, 0, 0), e3.restore();
    }
    drawObject(e3, t2, n2) {
      let r2 = this.fill, i2 = this.stroke;
      t2 ? (this.fill = `black`, this.stroke = ``, this._setClippingProperties(e3)) : this._renderBackground(e3), this.fire(`before:render`, { ctx: e3 }), this._render(e3), this._drawClipPath(e3, this.clipPath, n2), this.fill = r2, this.stroke = i2;
    }
    createClipPathLayer(e3, t2) {
      let n2 = F(t2), r2 = n2.getContext(`2d`);
      if (r2.translate(t2.cacheTranslationX, t2.cacheTranslationY), r2.scale(t2.zoomX, t2.zoomY), e3._cacheCanvas = n2, t2.parentClipPaths.forEach((e4) => {
        e4.transform(r2);
      }), t2.parentClipPaths.push(e3), e3.absolutePositioned) {
        let e4 = R(this.calcTransformMatrix());
        r2.transform(e4[0], e4[1], e4[2], e4[3], e4[4], e4[5]);
      }
      return e3.transform(r2), e3.drawObject(r2, true, t2), n2;
    }
    _drawClipPath(e3, t2, n2) {
      if (!t2) return;
      t2._transformDone = true;
      let r2 = this.createClipPathLayer(t2, n2);
      this.drawClipPathOnCache(e3, t2, r2);
    }
    drawCacheOnCanvas(e3) {
      e3.scale(1 / this.zoomX, 1 / this.zoomY), e3.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }
    isCacheDirty(e3 = false) {
      if (this.isNotVisible()) return false;
      let t2 = this._cacheCanvas, n2 = this._cacheContext;
      return !(!t2 || !n2 || e3 || !this._updateCacheCanvas()) || !!(this.dirty || this.clipPath && this.clipPath.absolutePositioned) && (t2 && n2 && !e3 && (n2.save(), n2.setTransform(1, 0, 0, 1, 0, 0), n2.clearRect(0, 0, t2.width, t2.height), n2.restore()), true);
    }
    _renderBackground(e3) {
      if (!this.backgroundColor) return;
      let t2 = this._getNonTransformedDimensions();
      e3.fillStyle = this.backgroundColor, e3.fillRect(-t2.x / 2, -t2.y / 2, t2.x, t2.y), this._removeShadow(e3);
    }
    _setOpacity(e3) {
      this.group && !this.group._transformDone ? e3.globalAlpha = this.getObjectOpacity() : e3.globalAlpha *= this.opacity;
    }
    _setStrokeStyles(e3, t2) {
      let n2 = t2.stroke;
      n2 && (e3.lineWidth = t2.strokeWidth, e3.lineCap = t2.strokeLineCap, e3.lineDashOffset = t2.strokeDashOffset, e3.lineJoin = t2.strokeLineJoin, e3.miterLimit = t2.strokeMiterLimit, V(n2) ? n2.gradientUnits === `percentage` || n2.gradientTransform || n2.patternTransform ? this._applyPatternForTransformedGradient(e3, n2) : (e3.strokeStyle = n2.toLive(e3), this._applyPatternGradientTransform(e3, n2)) : e3.strokeStyle = t2.stroke);
    }
    _setFillStyles(e3, { fill: t2 }) {
      t2 && (V(t2) ? (e3.fillStyle = t2.toLive(e3), this._applyPatternGradientTransform(e3, t2)) : e3.fillStyle = t2);
    }
    _setClippingProperties(e3) {
      e3.globalAlpha = 1, e3.strokeStyle = `transparent`, e3.fillStyle = `#000000`;
    }
    _setLineDash(e3, t2) {
      t2 && t2.length !== 0 && e3.setLineDash(t2);
    }
    _setShadow(e3) {
      if (!this.shadow) return;
      let t2 = this.shadow, n2 = this.canvas, r2 = this.getCanvasRetinaScaling(), [i2, , , a2] = (n2 == null ? void 0 : n2.viewportTransform) || T, s2 = i2 * r2, c2 = a2 * r2, l2 = t2.nonScaling ? new N(1, 1) : this.getObjectScaling();
      e3.shadowColor = t2.color, e3.shadowBlur = t2.blur * o.browserShadowBlurConstant * (s2 + c2) * (l2.x + l2.y) / 4, e3.shadowOffsetX = t2.offsetX * s2 * l2.x, e3.shadowOffsetY = t2.offsetY * c2 * l2.y;
    }
    _removeShadow(e3) {
      this.shadow && (e3.shadowColor = ``, e3.shadowBlur = e3.shadowOffsetX = e3.shadowOffsetY = 0);
    }
    _applyPatternGradientTransform(e3, t2) {
      if (!V(t2)) return { offsetX: 0, offsetY: 0 };
      let n2 = t2.gradientTransform || t2.patternTransform, r2 = -this.width / 2 + t2.offsetX || 0, i2 = -this.height / 2 + t2.offsetY || 0;
      return t2.gradientUnits === `percentage` ? e3.transform(this.width, 0, 0, this.height, r2, i2) : e3.transform(1, 0, 0, 1, r2, i2), n2 && e3.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), { offsetX: r2, offsetY: i2 };
    }
    _renderPaintInOrder(e3) {
      this.paintFirst === `stroke` ? (this._renderStroke(e3), this._renderFill(e3)) : (this._renderFill(e3), this._renderStroke(e3));
    }
    _render(e3) {
    }
    _renderFill(e3) {
      this.fill && (e3.save(), this._setFillStyles(e3, this), this.fillRule === `evenodd` ? e3.fill(`evenodd`) : e3.fill(), e3.restore());
    }
    _renderStroke(e3) {
      if (this.stroke && this.strokeWidth !== 0) {
        if (this.shadow && !this.shadow.affectStroke && this._removeShadow(e3), e3.save(), this.strokeUniform) {
          let t2 = this.getObjectScaling();
          e3.scale(1 / t2.x, 1 / t2.y);
        }
        this._setLineDash(e3, this.strokeDashArray), this._setStrokeStyles(e3, this), e3.stroke(), e3.restore();
      }
    }
    _applyPatternForTransformedGradient(e3, t2) {
      var n2;
      let r2 = this._limitCacheSize(this._getCacheCanvasDimensions()), i2 = this.getCanvasRetinaScaling(), a2 = r2.x / this.scaleX / i2, o2 = r2.y / this.scaleY / i2, s2 = F({ width: Math.ceil(a2), height: Math.ceil(o2) }), c2 = s2.getContext(`2d`);
      c2 && (c2.beginPath(), c2.moveTo(0, 0), c2.lineTo(a2, 0), c2.lineTo(a2, o2), c2.lineTo(0, o2), c2.closePath(), c2.translate(a2 / 2, o2 / 2), c2.scale(r2.zoomX / this.scaleX / i2, r2.zoomY / this.scaleY / i2), this._applyPatternGradientTransform(c2, t2), c2.fillStyle = t2.toLive(e3), c2.fill(), e3.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2), e3.scale(i2 * this.scaleX / r2.zoomX, i2 * this.scaleY / r2.zoomY), e3.strokeStyle = (n2 = c2.createPattern(s2, `no-repeat`)) == null ? `` : n2);
    }
    _findCenterFromElement() {
      return new N(this.left + this.width / 2, this.top + this.height / 2);
    }
    clone(e3) {
      let t2 = this.toObject(e3);
      return this.constructor.fromObject(t2);
    }
    cloneAsImage(e3) {
      let t2 = this.toCanvasElement(e3);
      return new (M.getClass(`image`))(t2);
    }
    toCanvasElement(e3 = {}) {
      let t2 = kt(this), n2 = this.group, r2 = this.shadow, i2 = Math.abs, a2 = e3.enableRetinaScaling ? v() : 1, o2 = (e3.multiplier || 1) * a2, s2 = e3.canvasProvider || ((e4) => new yt(e4, { enableRetinaScaling: false, renderOnAddRemove: false, skipOffscreen: false }));
      delete this.group, e3.withoutTransform && Ot(this), e3.withoutShadow && (this.shadow = null), e3.viewportTransform && Pt(this, this.getViewportTransform()), this.setCoords();
      let c2 = P(), l2 = this.getBoundingRect(), u2 = this.shadow, d2 = new N();
      if (u2) {
        let e4 = u2.blur, t3 = u2.nonScaling ? new N(1, 1) : this.getObjectScaling();
        d2.x = 2 * Math.round(i2(u2.offsetX) + e4) * i2(t3.x), d2.y = 2 * Math.round(i2(u2.offsetY) + e4) * i2(t3.y);
      }
      let f2 = l2.width + d2.x, p2 = l2.height + d2.y;
      c2.width = Math.ceil(f2), c2.height = Math.ceil(p2);
      let m = s2(c2);
      e3.format === `jpeg` && (m.backgroundColor = `#fff`), this.setPositionByOrigin(new N(m.width / 2, m.height / 2), E, E);
      let h2 = this.canvas;
      m._objects = [this], this.set(`canvas`, m), this.setCoords();
      let g2 = m.toCanvasElement(o2 || 1, e3);
      return this.set(`canvas`, h2), this.shadow = r2, n2 && (this.group = n2), this.set(t2), this.setCoords(), m._objects = [], m.destroy(), g2;
    }
    toDataURL(e3 = {}) {
      return Pe(this.toCanvasElement(e3), e3.format || `png`, e3.quality || 1);
    }
    toBlob(e3 = {}) {
      return Fe(this.toCanvasElement(e3), e3.format || `png`, e3.quality || 1);
    }
    isType(...e3) {
      return e3.includes(this.constructor.type) || e3.includes(this.type);
    }
    complexity() {
      return 1;
    }
    toJSON() {
      return this.toObject();
    }
    rotate(e3) {
      let { centeredRotation: t2, originX: n2, originY: r2 } = this;
      if (t2) {
        let { x: e4, y: t3 } = this.getRelativeCenterPoint();
        this.originX = E, this.originY = E, this.left = e4, this.top = t3;
      }
      if (this.set(`angle`, e3), t2) {
        let { x: e4, y: t3 } = this.getPositionByOrigin(n2, r2);
        this.left = e4, this.top = t3, this.originX = n2, this.originY = r2;
      }
    }
    setOnGroup() {
    }
    _setupCompositeOperation(e3) {
      this.globalCompositeOperation && (e3.globalCompositeOperation = this.globalCompositeOperation);
    }
    dispose() {
      ye.cancelByTarget(this), this.off(), this._set(`canvas`, void 0), this._cacheCanvas && h().dispose(this._cacheCanvas), this._cacheCanvas = void 0, this._cacheContext = null;
    }
    animate(e3, t2) {
      return Object.entries(e3).reduce((e4, [n2, r2]) => (e4[n2] = this._animate(n2, r2, t2), e4), {});
    }
    _animate(e3, t2, n2 = {}) {
      let r2 = e3.split(`.`), i2 = this.constructor.colorProperties.includes(r2[r2.length - 1]), { abort: a2, startValue: o2, onChange: s2, onComplete: c2 } = n2, l2 = { ...n2, target: this, startValue: o2 == null ? r2.reduce((e4, t3) => e4[t3], this) : o2, endValue: t2, abort: a2 == null ? void 0 : a2.bind(this), onChange: (e4, t3, n3) => {
        r2.reduce((t4, n4, i3) => (i3 === r2.length - 1 && (t4[n4] = e4), t4[n4]), this), s2 && s2(e4, t3, n3);
      }, onComplete: (e4, t3, n3) => {
        this.setCoords(), c2 && c2(e4, t3, n3);
      } };
      return i2 ? Nr(l2) : Mr(l2);
    }
    isDescendantOf(e3) {
      let { parent: t2, group: n2 } = this;
      return t2 === e3 || n2 === e3 || !!t2 && t2.isDescendantOf(e3) || !!n2 && n2 !== t2 && n2.isDescendantOf(e3);
    }
    getAncestors() {
      let e3 = [], t2 = this;
      do
        t2 = t2.parent, t2 && e3.push(t2);
      while (t2);
      return e3;
    }
    findCommonAncestors(e3) {
      if (this === e3) return { fork: [], otherFork: [], common: [this, ...this.getAncestors()] };
      let t2 = this.getAncestors(), n2 = e3.getAncestors();
      if (t2.length === 0 && n2.length > 0 && this === n2[n2.length - 1]) return { fork: [], otherFork: [e3, ...n2.slice(0, n2.length - 1)], common: [this] };
      for (let r2, i2 = 0; i2 < t2.length; i2++) {
        if (r2 = t2[i2], r2 === e3) return { fork: [this, ...t2.slice(0, i2)], otherFork: [], common: t2.slice(i2) };
        for (let a2 = 0; a2 < n2.length; a2++) {
          if (this === n2[a2]) return { fork: [], otherFork: [e3, ...n2.slice(0, a2)], common: [this, ...t2] };
          if (r2 === n2[a2]) return { fork: [this, ...t2.slice(0, i2)], otherFork: [e3, ...n2.slice(0, a2)], common: t2.slice(i2) };
        }
      }
      return { fork: [this, ...t2], otherFork: [e3, ...n2], common: [] };
    }
    hasCommonAncestors(e3) {
      let t2 = this.findCommonAncestors(e3);
      return t2 && !!t2.common.length;
    }
    isInFrontOf(e3) {
      if (this === e3) return;
      let t2 = this.findCommonAncestors(e3);
      if (t2.fork.includes(e3)) return true;
      if (t2.otherFork.includes(this)) return false;
      let n2 = t2.common[0] || this.canvas;
      if (!n2) return;
      let r2 = t2.fork.pop(), i2 = t2.otherFork.pop(), a2 = n2._objects.indexOf(r2), o2 = n2._objects.indexOf(i2);
      return a2 > -1 && a2 > o2;
    }
    toObject(t2 = []) {
      let n2 = t2.concat(e2.customProperties, this.constructor.customProperties || []), r2, i2 = o.NUM_FRACTION_DIGITS, { clipPath: a2, fill: s2, stroke: c2, shadow: l2, strokeDashArray: u2, left: d2, top: f2, originX: p2, originY: m, width: h2, height: g2, strokeWidth: _2, strokeLineCap: v2, strokeDashOffset: y2, strokeLineJoin: x2, strokeUniform: S2, strokeMiterLimit: C2, scaleX: w2, scaleY: ee2, angle: T2, flipX: E2, flipY: D2, opacity: O2, visible: k2, backgroundColor: te2, fillRule: ne2, paintFirst: re2, globalCompositeOperation: ie2, skewX: ae2, skewY: oe2 } = this;
      a2 && !a2.excludeFromExport && (r2 = a2.toObject(n2.concat(`inverted`, `absolutePositioned`)));
      let A2 = (e3) => B(e3, i2), se2 = { ...et(this, n2), type: this.constructor.type, version: b, originX: p2, originY: m, left: A2(d2), top: A2(f2), width: A2(h2), height: A2(g2), fill: rt(s2) ? s2.toObject() : s2, stroke: rt(c2) ? c2.toObject() : c2, strokeWidth: A2(_2), strokeDashArray: u2 && u2.concat(), strokeLineCap: v2, strokeDashOffset: y2, strokeLineJoin: x2, strokeUniform: S2, strokeMiterLimit: A2(C2), scaleX: A2(w2), scaleY: A2(ee2), angle: A2(T2), flipX: E2, flipY: D2, opacity: A2(O2), shadow: l2 && l2.toObject(), visible: k2, backgroundColor: te2, fillRule: ne2, paintFirst: re2, globalCompositeOperation: ie2, skewX: A2(ae2), skewY: A2(oe2), ...r2 ? { clipPath: r2 } : null };
      return this.includeDefaultValues ? se2 : this._removeDefaultValues(se2);
    }
    toDatalessObject(e3) {
      return this.toObject(e3);
    }
    _removeDefaultValues(e3) {
      let t2 = this.constructor.getDefaults(), n2 = Object.keys(t2).length > 0 ? t2 : Object.getPrototypeOf(this);
      return tt(e3, (e4, t3) => {
        if (t3 === `left` || t3 === `top` || t3 === `type`) return true;
        let r2 = n2[t3];
        return e4 !== r2 && !(Array.isArray(e4) && Array.isArray(r2) && e4.length === 0 && r2.length === 0);
      });
    }
    toString() {
      return `#<${this.constructor.type}>`;
    }
    static _fromObject({ type: e3, ...t2 }, { extraParam: n2, ...r2 } = {}) {
      return $e(t2, r2).then((e4) => n2 ? (delete e4[n2], new this(t2[n2], e4)) : new this(e4));
    }
    static fromObject(e3, t2) {
      return this._fromObject(e3, t2);
    }
  };
  i(Ir, `stateProperties`, Hn), i(Ir, `cacheProperties`, Un), i(Ir, `ownDefaults`, Wn), i(Ir, `type`, `FabricObject`), i(Ir, `colorProperties`, [j, he, `backgroundColor`]), i(Ir, `customProperties`, []), M.setClass(Ir), M.setClass(Ir, `object`);
  const Lr = (e2, t2) => {
    var n2;
    let { transform: { target: r2 } } = t2;
    (n2 = r2.canvas) == null || n2.fire(`object:${e2}`, { ...t2, target: r2 }), r2.fire(e2, t2);
  }, Rr = (e2, t2, n2) => (r2, i2, a2, o2) => {
    let s2 = t2(r2, i2, a2, o2);
    return s2 && Lr(e2, { ...Qt(r2, i2, a2, o2), ...n2 }), s2;
  };
  function zr(e2) {
    return (t2, n2, r2, i2) => {
      let { target: a2, originX: o2, originY: s2 } = n2, c2 = a2.getPositionByOrigin(o2, s2), l2 = e2(t2, n2, r2, i2);
      return a2.setPositionByOrigin(c2, n2.originX, n2.originY), l2;
    };
  }
  const Br = (e2, t2, n2, r2) => (i2, a2, o2, s2) => {
    let c2 = en(a2, a2.originX, a2.originY, o2, s2)[n2], l2 = W(a2[t2]);
    if (l2 === 0 || l2 > 0 && c2 < 0 || l2 < 0 && c2 > 0) {
      let { target: t3 } = a2, n3 = t3.strokeWidth / (t3.strokeUniform ? t3[r2] : 1), i3 = Yt(a2) ? 2 : 1, o3 = t3[e2], s3 = Math.abs(c2 * i3 / t3[r2]) - n3;
      return t3.set(e2, Math.max(s3, 1)), o3 !== t3[e2];
    }
    return false;
  }, Vr = Br(`width`, `originX`, `x`, `scaleX`), Hr = Br(`height`, `originY`, `y`, `scaleY`), Ur = Rr(se, zr(Vr)), Wr = Rr(se, zr(Hr));
  function Gr(e2, t2, n2, r2, i2) {
    e2.save();
    let { stroke: a2, xSize: o2, ySize: s2, opName: c2 } = this.commonRenderProps(e2, t2, n2, i2, r2), l2 = o2;
    o2 > s2 ? e2.scale(1, s2 / o2) : s2 > o2 && (l2 = s2, e2.scale(o2 / s2, 1)), e2.beginPath(), e2.arc(0, 0, l2 / 2, 0, w, false), e2[c2](), a2 && e2.stroke(), e2.restore();
  }
  function Kr(e2, t2, n2, r2, i2) {
    e2.save();
    let { stroke: a2, xSize: o2, ySize: s2, opName: c2 } = this.commonRenderProps(e2, t2, n2, i2, r2), l2 = o2 / 2, u2 = s2 / 2;
    e2[`${c2}Rect`](-l2, -u2, o2, s2), a2 && e2.strokeRect(-l2, -u2, o2, s2), e2.restore();
  }
  var q = class {
    constructor(e2) {
      i(this, `visible`, true), i(this, `actionName`, ue), i(this, `angle`, 0), i(this, `x`, 0), i(this, `y`, 0), i(this, `offsetX`, 0), i(this, `offsetY`, 0), i(this, `sizeX`, 0), i(this, `sizeY`, 0), i(this, `touchSizeX`, 0), i(this, `touchSizeY`, 0), i(this, `cursorStyle`, `crosshair`), i(this, `withConnection`, false), Object.assign(this, e2);
    }
    getTransformAnchorPoint() {
      var e2;
      return (e2 = this.transformAnchorPoint) == null ? new N(0.5 - this.x, 0.5 - this.y) : e2;
    }
    shouldActivate(e2, t2, n2, { tl: r2, tr: i2, br: a2, bl: o2 }) {
      var s2;
      return ((s2 = t2.canvas) == null ? void 0 : s2.getActiveObject()) === t2 && t2.isControlVisible(e2) && Pr.isPointInPolygon(n2, [r2, i2, a2, o2]);
    }
    getActionHandler(e2, t2, n2) {
      return this.actionHandler;
    }
    getMouseDownHandler(e2, t2, n2) {
      return this.mouseDownHandler;
    }
    getMouseUpHandler(e2, t2, n2) {
      return this.mouseUpHandler;
    }
    cursorStyleHandler(e2, t2, n2, r2) {
      return t2.cursorStyle;
    }
    getActionName(e2, t2, n2) {
      return t2.actionName;
    }
    getVisibility(e2, t2) {
      var n2, r2;
      return (n2 = (r2 = e2._controlsVisibility) == null ? void 0 : r2[t2]) == null ? this.visible : n2;
    }
    setVisibility(e2, t2, n2) {
      this.visible = e2;
    }
    positionHandler(e2, t2, n2, r2) {
      return new N(this.x * e2.x + this.offsetX, this.y * e2.y + this.offsetY).transform(t2);
    }
    calcCornerCoords(e2, t2, n2, r2, i2, a2) {
      let o2 = Re([Ue(n2, r2), We({ angle: e2 }), Ge((i2 ? this.touchSizeX : this.sizeX) || t2, (i2 ? this.touchSizeY : this.sizeY) || t2)]);
      return { tl: new N(-0.5, -0.5).transform(o2), tr: new N(0.5, -0.5).transform(o2), br: new N(0.5, 0.5).transform(o2), bl: new N(-0.5, 0.5).transform(o2) };
    }
    commonRenderProps(e2, t2, n2, r2, i2 = {}) {
      let { cornerSize: a2, cornerColor: o2, transparentCorners: s2, cornerStrokeColor: c2 } = i2, l2 = a2 || r2.cornerSize, u2 = this.sizeX || l2, d2 = this.sizeY || l2, f2 = s2 === void 0 ? r2.transparentCorners : s2, p2 = f2 ? he : j, m = c2 || r2.cornerStrokeColor, h2 = !f2 && !!m;
      return e2.fillStyle = o2 || r2.cornerColor || ``, e2.strokeStyle = m || ``, e2.translate(t2, n2), e2.rotate(I(r2.getTotalAngle())), { stroke: h2, xSize: u2, ySize: d2, transparentCorners: f2, opName: p2 };
    }
    render(e2, t2, n2, r2, i2) {
      ((r2 = r2 || {}).cornerStyle || i2.cornerStyle) === `circle` ? Gr.call(this, e2, t2, n2, r2, i2) : Kr.call(this, e2, t2, n2, r2, i2);
    }
  };
  const qr = (e2, t2, n2) => n2.lockRotation ? Jt : t2.cursorStyle, Jr = Rr(ae, zr((e2, { target: t2, ex: n2, ey: r2, theta: i2, originX: a2, originY: o2 }, s2, c2) => {
    let l2 = t2.getPositionByOrigin(a2, o2);
    if (Zt(t2, `lockRotation`)) return false;
    let u2 = Math.atan2(r2 - l2.y, n2 - l2.x), d2 = Ie(Math.atan2(c2 - l2.y, s2 - l2.x) - u2 + i2);
    if (t2.snapAngle && t2.snapAngle > 0) {
      let e3 = t2.snapAngle, n3 = t2.snapThreshold || e3, r3 = Math.ceil(d2 / e3) * e3, i3 = Math.floor(d2 / e3) * e3;
      Math.abs(d2 - i3) < n3 ? d2 = i3 : Math.abs(d2 - r3) < n3 && (d2 = r3);
    }
    d2 < 0 && (d2 = 360 + d2), d2 %= 360;
    let f2 = t2.angle !== d2;
    return t2.angle = d2, f2;
  }));
  function Yr(e2, t2) {
    let n2 = t2.canvas, r2 = e2[n2.uniScaleKey];
    return n2.uniformScaling && !r2 || !n2.uniformScaling && r2;
  }
  function Xr(e2, t2, n2) {
    let r2 = Zt(e2, `lockScalingX`), i2 = Zt(e2, `lockScalingY`);
    if (r2 && i2 || !t2 && (r2 || i2) && n2 || r2 && t2 === `x` || i2 && t2 === `y`) return true;
    let { width: a2, height: o2, strokeWidth: s2 } = e2;
    return a2 === 0 && s2 === 0 && t2 !== `y` || o2 === 0 && s2 === 0 && t2 !== `x`;
  }
  const Zr = [`e`, `se`, `s`, `sw`, `w`, `nw`, `n`, `ne`, `e`], Qr = (e2, t2, n2, r2) => {
    let i2 = Yr(e2, n2);
    return Xr(n2, t2.x !== 0 && t2.y === 0 ? `x` : t2.x === 0 && t2.y !== 0 ? `y` : ``, i2) ? Jt : `${Zr[$t(n2, 0, r2)]}-resize`;
  };
  function $r(e2, t2, n2, r2, i2 = {}) {
    let a2 = t2.target, o2 = i2.by, s2 = Yr(e2, a2), c2, l2, u2, d2, f2, p2;
    if (Xr(a2, o2, s2)) return false;
    if (t2.gestureScale) l2 = t2.scaleX * t2.gestureScale, u2 = t2.scaleY * t2.gestureScale;
    else {
      if (c2 = en(t2, t2.originX, t2.originY, n2, r2), f2 = o2 === `y` ? 1 : Math.sign(c2.x || t2.signX || 1), p2 = o2 === `x` ? 1 : Math.sign(c2.y || t2.signY || 1), t2.signX || (t2.signX = f2), t2.signY || (t2.signY = p2), Zt(a2, `lockScalingFlip`) && (t2.signX !== f2 || t2.signY !== p2)) return false;
      if (d2 = a2._getTransformedDimensions(), s2 && !o2) {
        let e3 = Math.abs(c2.x) + Math.abs(c2.y), { original: n3 } = t2, r3 = e3 / (Math.abs(d2.x * n3.scaleX / a2.scaleX) + Math.abs(d2.y * n3.scaleY / a2.scaleY));
        l2 = n3.scaleX * r3, u2 = n3.scaleY * r3;
      } else l2 = Math.abs(c2.x * a2.scaleX / d2.x), u2 = Math.abs(c2.y * a2.scaleY / d2.y);
      Yt(t2) && (l2 *= 2, u2 *= 2), t2.signX !== f2 && o2 !== `y` && (t2.originX = Xt(t2.originX), l2 *= -1, t2.signX = f2), t2.signY !== p2 && o2 !== `x` && (t2.originY = Xt(t2.originY), u2 *= -1, t2.signY = p2);
    }
    let m = a2.scaleX, h2 = a2.scaleY;
    return o2 ? (o2 === `x` && a2.set(`scaleX`, l2), o2 === `y` && a2.set(`scaleY`, u2)) : (!Zt(a2, `lockScalingX`) && a2.set(`scaleX`, l2), !Zt(a2, `lockScalingY`) && a2.set(`scaleY`, u2)), m !== a2.scaleX || h2 !== a2.scaleY;
  }
  const ei = Rr(ie, zr((e2, t2, n2, r2) => $r(e2, t2, n2, r2))), ti = Rr(ie, zr((e2, t2, n2, r2) => $r(e2, t2, n2, r2, { by: `x` }))), ni = Rr(ie, zr((e2, t2, n2, r2) => $r(e2, t2, n2, r2, { by: `y` }))), ri = { x: { counterAxis: `y`, scale: de, skew: pe, lockSkewing: `lockSkewingX`, origin: `originX`, flip: `flipX` }, y: { counterAxis: `x`, scale: fe, skew: me, lockSkewing: `lockSkewingY`, origin: `originY`, flip: `flipY` } }, ii = [`ns`, `nesw`, `ew`, `nwse`], ai = (e2, t2, n2, r2) => t2.x !== 0 && Zt(n2, `lockSkewingY`) || t2.y !== 0 && Zt(n2, `lockSkewingX`) ? Jt : `${ii[$t(n2, 0, r2) % 4]}-resize`;
  function oi(e2, t2, n2, r2, i2) {
    let { target: a2 } = n2, { counterAxis: o2, origin: s2, lockSkewing: c2, skew: l2, flip: u2 } = ri[e2];
    if (Zt(a2, c2)) return false;
    let { origin: d2, flip: f2 } = ri[o2], p2 = W(n2[d2]) * (a2[f2] ? -1 : 1), m = -Math.sign(p2) * (a2[u2] ? -1 : 1), h2 = -(a2[l2] === 0 && en(n2, `center`, `center`, r2, i2)[e2] > 0 || a2[l2] > 0 ? 1 : -1) * m * 0.5 + 0.5;
    return Rr(A, zr((t3, n3, r3, i3) => (function(e3, { target: t4, ex: n4, ey: r4, skewingSide: i4, ...a3 }, o3) {
      let { skew: s3 } = ri[e3], c3 = o3.subtract(new N(n4, r4)).divide(new N(t4.scaleX, t4.scaleY))[e3], l3 = t4[s3], u3 = a3[s3], d3 = Math.tan(I(u3)), f3 = e3 === `y` ? t4._getTransformedDimensions({ scaleX: 1, scaleY: 1, skewX: 0 }).x : t4._getTransformedDimensions({ scaleX: 1, scaleY: 1 }).y, p3 = 2 * c3 * i4 / Math.max(f3, 1) + d3, m2 = Ie(Math.atan(p3));
      t4.set(s3, m2);
      let h3 = l3 !== t4[s3];
      if (h3 && e3 === `y`) {
        let { skewX: e4, scaleX: n5 } = t4, r5 = t4._getTransformedDimensions({ skewY: l3 }), i5 = t4._getTransformedDimensions(), a4 = e4 === 0 ? 1 : r5.x / i5.x;
        a4 !== 1 && t4.set(`scaleX`, a4 * n5);
      }
      return h3;
    })(e2, n3, new N(r3, i3))))(t2, { ...n2, [s2]: h2, skewingSide: m }, r2, i2);
  }
  const si = (e2, t2, n2, r2) => oi(`x`, e2, t2, n2, r2), ci = (e2, t2, n2, r2) => oi(`y`, e2, t2, n2, r2);
  function li(e2, t2) {
    return e2[t2.canvas.altActionKey];
  }
  const ui = (e2, t2, n2) => {
    let r2 = li(e2, n2);
    return t2.x === 0 ? r2 ? pe : fe : t2.y === 0 ? r2 ? me : de : ``;
  }, di = (e2, t2, n2, r2) => li(e2, n2) ? ai(0, t2, n2, r2) : Qr(e2, t2, n2, r2), fi = (e2, t2, n2, r2) => li(e2, t2.target) ? ci(e2, t2, n2, r2) : ti(e2, t2, n2, r2), pi = (e2, t2, n2, r2) => li(e2, t2.target) ? si(e2, t2, n2, r2) : ni(e2, t2, n2, r2), mi = () => ({ ml: new q({ x: -0.5, y: 0, cursorStyleHandler: di, actionHandler: fi, getActionName: ui }), mr: new q({ x: 0.5, y: 0, cursorStyleHandler: di, actionHandler: fi, getActionName: ui }), mb: new q({ x: 0, y: 0.5, cursorStyleHandler: di, actionHandler: pi, getActionName: ui }), mt: new q({ x: 0, y: -0.5, cursorStyleHandler: di, actionHandler: pi, getActionName: ui }), tl: new q({ x: -0.5, y: -0.5, cursorStyleHandler: Qr, actionHandler: ei }), tr: new q({ x: 0.5, y: -0.5, cursorStyleHandler: Qr, actionHandler: ei }), bl: new q({ x: -0.5, y: 0.5, cursorStyleHandler: Qr, actionHandler: ei }), br: new q({ x: 0.5, y: 0.5, cursorStyleHandler: Qr, actionHandler: ei }), mtr: new q({ x: 0, y: -0.5, actionHandler: Jr, cursorStyleHandler: qr, offsetY: -40, withConnection: true, actionName: oe }) }), hi = () => ({ mr: new q({ x: 0.5, y: 0, actionHandler: Ur, cursorStyleHandler: di, actionName: se }), ml: new q({ x: -0.5, y: 0, actionHandler: Ur, cursorStyleHandler: di, actionName: se }) }), gi = () => ({ ...mi(), ...hi() });
  var _i = class e2 extends Ir {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, this.constructor.createControls(), e2.ownDefaults), this.setOptions(t2);
    }
    static createControls() {
      return { controls: mi() };
    }
    _updateCacheCanvas() {
      let e3 = this.canvas;
      if (this.noScaleCache && e3 && e3._currentTransform) {
        let t2 = e3._currentTransform, n2 = t2.target, r2 = t2.action;
        if (this === n2 && r2 && r2.startsWith(`scale`)) return false;
      }
      return super._updateCacheCanvas();
    }
    getActiveControl() {
      let e3 = this.__corner;
      return e3 ? { key: e3, control: this.controls[e3], coord: this.oCoords[e3] } : void 0;
    }
    findControl(e3, t2 = false) {
      if (!this.hasControls || !this.canvas) return;
      this.__corner = void 0;
      let n2 = Object.entries(this.oCoords);
      for (let r2 = n2.length - 1; r2 >= 0; r2--) {
        let [i2, a2] = n2[r2], o2 = this.controls[i2];
        if (o2.shouldActivate(i2, this, e3, t2 ? a2.touchCorner : a2.corner)) return this.__corner = i2, { key: i2, control: o2, coord: this.oCoords[i2] };
      }
    }
    calcOCoords() {
      let e3 = this.getViewportTransform(), t2 = Be(e3), n2 = Ve(e3), r2 = this.getCenterPoint(), i2 = z(z(e3, z(Ue(r2.x, r2.y), We({ angle: this.getTotalAngle() - (this.group && this.flipX ? 180 : 0) }))), [1 / t2, 0, 0, 1 / n2, 0, 0]), a2 = this.group ? He(this.calcTransformMatrix()) : void 0;
      a2 && (a2.scaleX = Math.abs(a2.scaleX), a2.scaleY = Math.abs(a2.scaleY));
      let o2 = this._calculateCurrentDimensions(a2), s2 = {};
      return this.forEachControl((e4, t3) => {
        let n3 = e4.positionHandler(o2, i2, this, e4);
        s2[t3] = Object.assign(n3, this._calcCornerCoords(e4, n3));
      }), s2;
    }
    _calcCornerCoords(e3, t2) {
      let n2 = this.getTotalAngle();
      return { corner: e3.calcCornerCoords(n2, this.cornerSize, t2.x, t2.y, false, this), touchCorner: e3.calcCornerCoords(n2, this.touchCornerSize, t2.x, t2.y, true, this) };
    }
    setCoords() {
      super.setCoords(), this.canvas && (this.oCoords = this.calcOCoords());
    }
    forEachControl(e3) {
      for (let t2 in this.controls) e3(this.controls[t2], t2, this);
    }
    drawSelectionBackground(e3) {
      if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
      e3.save();
      let t2 = this.getRelativeCenterPoint(), n2 = this._calculateCurrentDimensions(), r2 = this.getViewportTransform();
      e3.translate(t2.x, t2.y), e3.scale(1 / r2[0], 1 / r2[3]), e3.rotate(I(this.angle)), e3.fillStyle = this.selectionBackgroundColor, e3.fillRect(-n2.x / 2, -n2.y / 2, n2.x, n2.y), e3.restore();
    }
    strokeBorders(e3, t2) {
      e3.strokeRect(-t2.x / 2, -t2.y / 2, t2.x, t2.y);
    }
    _drawBorders(e3, t2, n2 = {}) {
      let r2 = { hasControls: this.hasControls, borderColor: this.borderColor, borderDashArray: this.borderDashArray, ...n2 };
      e3.save(), e3.strokeStyle = r2.borderColor, this._setLineDash(e3, r2.borderDashArray), this.strokeBorders(e3, t2), r2.hasControls && this.drawControlsConnectingLines(e3, t2), e3.restore();
    }
    _renderControls(e3, t2 = {}) {
      let { hasBorders: n2, hasControls: r2 } = this, i2 = { hasBorders: n2, hasControls: r2, ...t2 }, a2 = this.getViewportTransform(), o2 = i2.hasBorders, s2 = i2.hasControls, c2 = He(z(a2, this.calcTransformMatrix()));
      e3.save(), e3.translate(c2.translateX, c2.translateY), e3.lineWidth = this.borderScaleFactor, this.group === this.parent && (e3.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1), this.flipX && (c2.angle -= 180);
      let l2 = ze(a2);
      e3.rotate(this.group ? I(c2.angle) : I(this.angle) + l2), o2 && this.drawBorders(e3, c2, t2), s2 && this.drawControls(e3, t2), e3.restore();
    }
    drawBorders(e3, t2, n2) {
      let r2;
      if (n2 && n2.forActiveSelection || this.group) {
        let e4 = At(this.width, this.height, Ye(t2)), n3 = this.isStrokeAccountedForInDimensions() ? we : (this.strokeUniform ? new N().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : new N(t2.scaleX, t2.scaleY)).scalarMultiply(this.strokeWidth);
        r2 = e4.add(n3).scalarAdd(this.borderScaleFactor).scalarAdd(2 * this.padding);
      } else r2 = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
      this._drawBorders(e3, r2, n2);
    }
    drawControlsConnectingLines(e3, t2) {
      let n2 = false;
      e3.beginPath(), this.forEachControl((r2, i2) => {
        r2.withConnection && r2.getVisibility(this, i2) && (n2 = true, e3.moveTo(r2.x * t2.x, r2.y * t2.y), e3.lineTo(r2.x * t2.x + r2.offsetX, r2.y * t2.y + r2.offsetY));
      }), n2 && e3.stroke();
    }
    drawControls(e3, t2 = {}) {
      e3.save();
      let n2 = this.getCanvasRetinaScaling(), { cornerStrokeColor: r2, cornerDashArray: i2, cornerColor: a2 } = this, o2 = { cornerStrokeColor: r2, cornerDashArray: i2, cornerColor: a2, ...t2 };
      e3.setTransform(n2, 0, 0, n2, 0, 0), e3.strokeStyle = e3.fillStyle = o2.cornerColor, this.transparentCorners || (e3.strokeStyle = o2.cornerStrokeColor), this._setLineDash(e3, o2.cornerDashArray), this.forEachControl((t3, n3) => {
        if (t3.getVisibility(this, n3)) {
          let r3 = this.oCoords[n3];
          t3.render(e3, r3.x, r3.y, o2, this);
        }
      }), e3.restore();
    }
    isControlVisible(e3) {
      return this.controls[e3] && this.controls[e3].getVisibility(this, e3);
    }
    setControlVisible(e3, t2) {
      this._controlsVisibility || (this._controlsVisibility = {}), this._controlsVisibility[e3] = t2;
    }
    setControlsVisibility(e3 = {}) {
      Object.entries(e3).forEach(([e4, t2]) => this.setControlVisible(e4, t2));
    }
    clearContextTop(e3) {
      if (!this.canvas) return;
      let t2 = this.canvas.contextTop;
      if (!t2) return;
      let n2 = this.canvas.viewportTransform;
      t2.save(), t2.transform(n2[0], n2[1], n2[2], n2[3], n2[4], n2[5]), this.transform(t2);
      let r2 = this.width + 4, i2 = this.height + 4;
      return t2.clearRect(-r2 / 2, -i2 / 2, r2, i2), e3 || t2.restore(), t2;
    }
    onDeselect(e3) {
      return false;
    }
    onSelect(e3) {
      return false;
    }
    shouldStartDragging(e3) {
      return false;
    }
    onDragStart(e3) {
      return false;
    }
    canDrop(e3) {
      return false;
    }
    renderDragSourceEffect(e3) {
    }
    renderDropTargetEffect(e3) {
    }
  };
  function vi(e2, t2) {
    return t2.forEach((t3) => {
      Object.getOwnPropertyNames(t3.prototype).forEach((n2) => {
        n2 !== `constructor` && Object.defineProperty(e2.prototype, n2, Object.getOwnPropertyDescriptor(t3.prototype, n2) || /* @__PURE__ */ Object.create(null));
      });
    }), e2;
  }
  i(_i, `ownDefaults`, { noScaleCache: true, lockMovementX: false, lockMovementY: false, lockRotation: false, lockScalingX: false, lockScalingY: false, lockSkewingX: false, lockSkewingY: false, lockScalingFlip: false, cornerSize: 13, touchCornerSize: 24, transparentCorners: true, cornerColor: `rgb(178,204,255)`, cornerStrokeColor: ``, cornerStyle: `rect`, cornerDashArray: null, hasControls: true, borderColor: `rgb(178,204,255)`, borderDashArray: null, borderOpacityWhenMoving: 0.4, borderScaleFactor: 1, hasBorders: true, selectionBackgroundColor: ``, selectable: true, evented: true, perPixelTargetFind: false, activeOn: `down`, hoverCursor: null, moveCursor: null });
  var J = class extends _i {
  };
  vi(J, [gn]), M.setClass(J), M.setClass(J, `object`);
  const yi = (e2, t2, n2, r2) => {
    let i2 = 2 * (r2 = Math.round(r2)) + 1, { data: a2 } = e2.getImageData(t2 - r2, n2 - r2, i2, i2);
    for (let e3 = 3; e3 < a2.length; e3 += 4) if (a2[e3] > 0) return false;
    return true;
  };
  var bi = class {
    constructor(e2) {
      this.options = e2, this.strokeProjectionMagnitude = this.options.strokeWidth / 2, this.scale = new N(this.options.scaleX, this.options.scaleY), this.strokeUniformScalar = this.options.strokeUniform ? new N(1 / this.options.scaleX, 1 / this.options.scaleY) : new N(1, 1);
    }
    createSideVector(e2, t2) {
      let n2 = zt(e2, t2);
      return this.options.strokeUniform ? n2.multiply(this.scale) : n2;
    }
    projectOrthogonally(e2, t2, n2) {
      return this.applySkew(e2.add(this.calcOrthogonalProjection(e2, t2, n2)));
    }
    isSkewed() {
      return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(e2) {
      let t2 = new N(e2);
      return t2.y += t2.x * Math.tan(I(this.options.skewY)), t2.x += t2.y * Math.tan(I(this.options.skewX)), t2;
    }
    scaleUnitVector(e2, t2) {
      return e2.multiply(this.strokeUniformScalar).scalarMultiply(t2);
    }
  };
  const xi = new N();
  var Si = class e2 extends bi {
    static getOrthogonalRotationFactor(e3, t2) {
      let n2 = t2 ? Vt(e3, t2) : Ht(e3);
      return Math.abs(n2) < S ? -1 : 1;
    }
    constructor(e3, t2, n2, r2) {
      super(r2), i(this, `AB`, void 0), i(this, `AC`, void 0), i(this, `alpha`, void 0), i(this, `bisector`, void 0), this.A = new N(e3), this.B = new N(t2), this.C = new N(n2), this.AB = this.createSideVector(this.A, this.B), this.AC = this.createSideVector(this.A, this.C), this.alpha = Vt(this.AB, this.AC), this.bisector = Ut(Rt(this.AB.eq(xi) ? this.AC : this.AB, this.alpha / 2));
    }
    calcOrthogonalProjection(t2, n2, r2 = this.strokeProjectionMagnitude) {
      let i2 = Wt(this.createSideVector(t2, n2)), a2 = e2.getOrthogonalRotationFactor(i2, this.bisector);
      return this.scaleUnitVector(i2, r2 * a2);
    }
    projectBevel() {
      let e3 = [];
      return (this.alpha % w === 0 ? [this.B] : [this.B, this.C]).forEach((t2) => {
        e3.push(this.projectOrthogonally(this.A, t2)), e3.push(this.projectOrthogonally(this.A, t2, -this.strokeProjectionMagnitude));
      }), e3;
    }
    projectMiter() {
      let e3 = [], t2 = Math.abs(this.alpha), n2 = 1 / Math.sin(t2 / 2), r2 = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * n2), i2 = this.options.strokeUniform ? Bt(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
      return Bt(r2) / this.strokeProjectionMagnitude <= i2 && e3.push(this.applySkew(this.A.add(r2))), e3.push(...this.projectBevel()), e3;
    }
    projectRoundNoSkew(t2, n2) {
      let r2 = [], i2 = new N(e2.getOrthogonalRotationFactor(this.bisector), e2.getOrthogonalRotationFactor(new N(this.bisector.y, this.bisector.x)));
      return [new N(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(i2), new N(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(i2)].forEach((e3) => {
        qt(e3, t2, n2) && r2.push(this.A.add(e3));
      }), r2;
    }
    projectRoundWithSkew(e3, t2) {
      let n2 = [], { skewX: r2, skewY: i2, scaleX: a2, scaleY: o2, strokeUniform: s2 } = this.options, c2 = new N(Math.tan(I(r2)), Math.tan(I(i2))), l2 = this.strokeProjectionMagnitude, u2 = s2 ? l2 / o2 / Math.sqrt(1 / o2 ** 2 + 1 / a2 ** 2 * c2.y ** 2) : l2 / Math.sqrt(1 + c2.y ** 2), d2 = new N(Math.sqrt(Math.max(l2 ** 2 - u2 ** 2, 0)), u2), f2 = s2 ? l2 / Math.sqrt(1 + c2.x ** 2 * (1 / o2) ** 2 / (1 / a2 + 1 / a2 * c2.x * c2.y) ** 2) : l2 / Math.sqrt(1 + c2.x ** 2 / (1 + c2.x * c2.y) ** 2), p2 = new N(f2, Math.sqrt(Math.max(l2 ** 2 - f2 ** 2, 0)));
      return [p2, p2.scalarMultiply(-1), d2, d2.scalarMultiply(-1)].map((e4) => this.applySkew(s2 ? e4.multiply(this.strokeUniformScalar) : e4)).forEach((r3) => {
        qt(r3, e3, t2) && n2.push(this.applySkew(this.A).add(r3));
      }), n2;
    }
    projectRound() {
      let e3 = [];
      e3.push(...this.projectBevel());
      let t2 = this.alpha % w === 0, n2 = this.applySkew(this.A), r2 = e3[t2 ? 0 : 2].subtract(n2), i2 = e3[+!!t2].subtract(n2), a2 = Gt(r2, t2 ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1))) > 0, o2 = a2 ? r2 : i2, s2 = a2 ? i2 : r2;
      return this.isSkewed() ? e3.push(...this.projectRoundWithSkew(o2, s2)) : e3.push(...this.projectRoundNoSkew(o2, s2)), e3;
    }
    projectPoints() {
      switch (this.options.strokeLineJoin) {
        case `miter`:
          return this.projectMiter();
        case `round`:
          return this.projectRound();
        default:
          return this.projectBevel();
      }
    }
    project() {
      return this.projectPoints().map((e3) => ({ originPoint: this.A, projectedPoint: e3, angle: this.alpha, bisector: this.bisector }));
    }
  }, Ci = class extends bi {
    constructor(e2, t2, n2) {
      super(n2), this.A = new N(e2), this.T = new N(t2);
    }
    calcOrthogonalProjection(e2, t2, n2 = this.strokeProjectionMagnitude) {
      let r2 = this.createSideVector(e2, t2);
      return this.scaleUnitVector(Wt(r2), n2);
    }
    projectButt() {
      return [this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude), this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)];
    }
    projectRound() {
      let e2 = [];
      if (!this.isSkewed() && this.A.eq(this.T)) {
        let t2 = new N(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        e2.push(this.applySkew(this.A.add(t2)), this.applySkew(this.A.subtract(t2)));
      } else e2.push(...new Si(this.A, this.T, this.T, this.options).projectRound());
      return e2;
    }
    projectSquare() {
      let e2 = [];
      if (this.A.eq(this.T)) {
        let t2 = new N(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        e2.push(this.A.add(t2), this.A.subtract(t2));
      } else {
        let t2 = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude), n2 = this.scaleUnitVector(Ut(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude), r2 = this.A.add(n2);
        e2.push(r2.add(t2), r2.subtract(t2));
      }
      return e2.map((e3) => this.applySkew(e3));
    }
    projectPoints() {
      switch (this.options.strokeLineCap) {
        case `round`:
          return this.projectRound();
        case `square`:
          return this.projectSquare();
        default:
          return this.projectButt();
      }
    }
    project() {
      return this.projectPoints().map((e2) => ({ originPoint: this.A, projectedPoint: e2 }));
    }
  };
  const wi = (e2, t2, n2 = false) => {
    let r2 = [];
    if (e2.length === 0) return r2;
    let i2 = e2.reduce((e3, t3) => (e3[e3.length - 1].eq(t3) || e3.push(new N(t3)), e3), [new N(e2[0])]);
    if (i2.length === 1) n2 = true;
    else if (!n2) {
      let e3 = i2[0], t3 = ((e4, t4) => {
        for (let n3 = e4.length - 1; n3 >= 0; n3--) if (t4(e4[n3], n3, e4)) return n3;
        return -1;
      })(i2, (t4) => !t4.eq(e3));
      i2.splice(t3 + 1);
    }
    return i2.forEach((e3, i3, a2) => {
      let o2, s2;
      i3 === 0 ? (s2 = a2[1], o2 = n2 ? e3 : a2[a2.length - 1]) : i3 === a2.length - 1 ? (o2 = a2[i3 - 1], s2 = n2 ? e3 : a2[0]) : (o2 = a2[i3 - 1], s2 = a2[i3 + 1]), n2 && a2.length === 1 ? r2.push(...new Ci(e3, e3, t2).project()) : !n2 || i3 !== 0 && i3 !== a2.length - 1 ? r2.push(...new Si(e3, o2, s2, t2).project()) : r2.push(...new Ci(e3, i3 === 0 ? s2 : o2, t2).project());
    }), r2;
  }, Ti = (e2) => {
    let t2 = {};
    return Object.keys(e2).forEach((n2) => {
      t2[n2] = {}, Object.keys(e2[n2]).forEach((r2) => {
        t2[n2][r2] = { ...e2[n2][r2] };
      });
    }), t2;
  }, Ei = (e2, t2, n2 = false) => e2.fill !== t2.fill || e2.stroke !== t2.stroke || e2.strokeWidth !== t2.strokeWidth || e2.fontSize !== t2.fontSize || e2.fontFamily !== t2.fontFamily || e2.fontWeight !== t2.fontWeight || e2.fontStyle !== t2.fontStyle || e2.textDecorationThickness !== t2.textDecorationThickness || e2.textDecorationColor !== t2.textDecorationColor || e2.textBackgroundColor !== t2.textBackgroundColor || e2.deltaY !== t2.deltaY || n2 && (e2.overline !== t2.overline || e2.underline !== t2.underline || e2.linethrough !== t2.linethrough), Di = (e2, t2) => {
    let n2 = t2.split(`
`), r2 = [], i2 = -1, a2 = {};
    e2 = Ti(e2);
    for (let t3 = 0; t3 < n2.length; t3++) {
      let o2 = gt(n2[t3]);
      if (e2[t3]) for (let n3 = 0; n3 < o2.length; n3++) {
        i2++;
        let o3 = e2[t3][n3];
        o3 && Object.keys(o3).length > 0 && (Ei(a2, o3, true) ? r2.push({ start: i2, end: i2 + 1, style: o3 }) : r2[r2.length - 1].end++), a2 = o3 || {};
      }
      else i2 += o2.length, a2 = {};
    }
    return r2;
  }, Oi = (e2, t2) => {
    if (!Array.isArray(e2)) return Ti(e2);
    let n2 = t2.split(ne), r2 = {}, i2 = -1, a2 = 0;
    for (let t3 = 0; t3 < n2.length; t3++) {
      let o2 = gt(n2[t3]);
      for (let n3 = 0; n3 < o2.length; n3++) i2++, e2[a2] && e2[a2].start <= i2 && i2 < e2[a2].end && (r2[t3] = r2[t3] || {}, r2[t3][n3] = { ...e2[a2].style }, i2 === e2[a2].end - 1 && a2++);
    }
    return r2;
  }, ki = [`display`, `transform`, j, `fill-opacity`, `fill-rule`, `opacity`, he, `stroke-dasharray`, `stroke-linecap`, `stroke-dashoffset`, `stroke-linejoin`, `stroke-miterlimit`, `stroke-opacity`, `stroke-width`, `id`, `paint-order`, `vector-effect`, `instantiated_by_use`, `clip-path`];
  function Ai(e2, t2) {
    let n2 = e2.nodeName, r2 = e2.getAttribute(`class`), i2 = e2.getAttribute(`id`), a2 = `(?![a-zA-Z\\-]+)`, o2;
    if (o2 = RegExp(`^` + n2, `i`), t2 = t2.replace(o2, ``), i2 && t2.length && (o2 = RegExp(`#` + i2 + a2, `i`), t2 = t2.replace(o2, ``)), r2 && t2.length) {
      let e3 = r2.split(` `);
      for (let n3 = e3.length; n3--; ) o2 = RegExp(`\\.` + e3[n3] + a2, `i`), t2 = t2.replace(o2, ``);
    }
    return t2.length === 0;
  }
  function ji(e2, t2) {
    let n2 = true, r2 = Ai(e2, t2.pop());
    return r2 && t2.length && (n2 = (function(e3, t3) {
      let n3, r3 = true;
      for (; e3.parentElement && e3.parentElement.nodeType === 1 && t3.length; ) r3 && (n3 = t3.pop()), r3 = Ai(e3 = e3.parentElement, n3);
      return t3.length === 0;
    })(e2, t2)), r2 && n2 && t2.length === 0;
  }
  function Mi(e2, t2 = {}) {
    let n2 = {};
    for (let r2 in t2) ji(e2, r2.split(` `)) && (n2 = { ...n2, ...t2[r2] });
    return n2;
  }
  const Ni = (e2) => {
    var t2;
    return (t2 = jn[e2]) == null ? e2 : t2;
  }, Pi = RegExp(`(${Dn})`, `gi`), Y = `(${Dn})`, Fi = String.raw`(skewX)\(${Y}\)`, Ii = String.raw`(skewY)\(${Y}\)`, Li = String.raw`(rotate)\(${Y}(?: ${Y} ${Y})?\)`, Ri = String.raw`(scale)\(${Y}(?: ${Y})?\)`, zi = String.raw`(translate)\(${Y}(?: ${Y})?\)`, Bi = `(?:${String.raw`(matrix)\(${Y} ${Y} ${Y} ${Y} ${Y} ${Y}\)`}|${zi}|${Li}|${Ri}|${Fi}|${Ii})`, Vi = `(?:${Bi}*)`, Hi = String.raw`^\s*(?:${Vi}?)\s*$`, Ui = new RegExp(Hi), Wi = new RegExp(Bi), Gi = new RegExp(Bi, `g`);
  function Ki(e2) {
    let t2 = [];
    if (!(e2 = ((e3) => on(e3.replace(Pi, ` $1 `).replace(/,/gi, ` `)))(e2).replace(/\s*([()])\s*/gi, `$1`)) || e2 && !Ui.test(e2)) return [...T];
    for (let n2 of e2.matchAll(Gi)) {
      let e3 = Wi.exec(n2[0]);
      if (!e3) continue;
      let r2 = T, [, i2, ...a2] = e3.filter((e4) => !!e4), [o2, s2, c2, l2, u2, d2] = a2.map((e4) => parseFloat(e4));
      switch (i2) {
        case `translate`:
          r2 = Ue(o2, s2);
          break;
        case oe:
          r2 = We({ angle: o2 }, { x: s2, y: c2 });
          break;
        case ue:
          r2 = Ge(o2, s2);
          break;
        case pe:
          r2 = qe(o2);
          break;
        case me:
          r2 = Je(o2);
          break;
        case `matrix`:
          r2 = [o2, s2, c2, l2, u2, d2];
      }
      t2.push(r2);
    }
    return Re(t2);
  }
  function qi(e2, t2, n2, r2) {
    let i2 = Array.isArray(t2), a2, o2 = t2;
    if (e2 !== `fill` && e2 !== `stroke` || t2 !== `none`) {
      if (e2 === `strokeUniform`) return t2 === `non-scaling-stroke`;
      if (e2 === `strokeDashArray`) o2 = t2 === `none` ? null : t2.replace(/,/g, ` `).split(/\s+/).map(parseFloat);
      else if (e2 === `transformMatrix`) o2 = n2 && n2.transformMatrix ? z(n2.transformMatrix, Ki(t2)) : Ki(t2);
      else if (e2 === `visible`) o2 = t2 !== `none` && t2 !== `hidden`, n2 && false === n2.visible && (o2 = false);
      else if (e2 === `opacity`) o2 = parseFloat(t2), n2 && n2.opacity !== void 0 && (o2 *= n2.opacity);
      else if (e2 === `textAnchor`) o2 = t2 === `start` ? D : t2 === `end` ? k : E;
      else if (e2 === `charSpacing` || e2 === `textDecorationThickness`) a2 = K(t2, r2) / r2 * 1e3;
      else if (e2 === `paintFirst`) {
        let e3 = t2.indexOf(j), n3 = t2.indexOf(he);
        o2 = j, (e3 > -1 && n3 > -1 && n3 < e3 || e3 === -1 && n3 > -1) && (o2 = he);
      } else {
        if (e2 === `href` || e2 === `xlink:href` || e2 === `font` || e2 === `id`) return t2;
        if (e2 === `imageSmoothing`) return t2 === `optimizeQuality`;
        a2 = i2 ? t2.map(K) : K(t2, r2);
      }
    } else o2 = ``;
    return !i2 && isNaN(a2) ? o2 : a2;
  }
  function Ji(e2, t2) {
    e2.replace(/;\s*$/, ``).split(`;`).forEach((e3) => {
      if (!e3) return;
      let [n2, r2] = e3.split(`:`);
      t2[n2.trim().toLowerCase()] = r2.trim();
    });
  }
  function Yi(e2) {
    let t2 = {}, n2 = e2.getAttribute(`style`);
    return n2 && (typeof n2 == `string` ? Ji(n2, t2) : (function(e3, t3) {
      Object.entries(e3).forEach(([e4, n3]) => {
        n3 !== void 0 && (t3[e4.toLowerCase()] = n3);
      });
    })(n2, t2)), t2;
  }
  const Xi = { stroke: `strokeOpacity`, fill: `fillOpacity` };
  function Zi(e2, t2, n2) {
    if (!e2) return {};
    let r2, i2 = {}, a2 = 16;
    e2.parentNode && In.test(e2.parentNode.nodeName) && (i2 = Zi(e2.parentElement, t2, n2), i2.fontSize && (r2 = a2 = K(i2.fontSize)));
    let o2 = { ...t2.reduce((t3, n3) => {
      let r3 = e2.getAttribute(n3);
      return r3 && (t3[n3] = r3), t3;
    }, {}), ...Mi(e2, n2), ...Yi(e2) };
    o2[`clip-path`] && e2.setAttribute(Nn, o2[Nn]), o2[`font-size`] && (r2 = K(o2[Mn], a2), o2[Mn] = `${r2}`);
    let s2 = {};
    for (let e3 in o2) {
      let t3 = Ni(e3);
      s2[t3] = qi(t3, o2[e3], i2, r2);
    }
    s2 && s2.font && (function(e3, t3) {
      let n3 = e3.match(An);
      if (!n3) return;
      let r3 = n3[1], i3 = n3[3], a3 = n3[4], o3 = n3[5], s3 = n3[6];
      r3 && (t3.fontStyle = r3), i3 && (t3.fontWeight = isNaN(parseFloat(i3)) ? i3 : parseFloat(i3)), a3 && (t3.fontSize = K(a3)), s3 && (t3.fontFamily = s3), o3 && (t3.lineHeight = o3 === `normal` ? 1 : o3);
    })(s2.font, s2);
    let c2 = { ...i2, ...s2 };
    return In.test(e2.nodeName) ? c2 : (function(e3) {
      let t3 = J.getDefaults();
      return Object.entries(Xi).forEach(([n3, r3]) => {
        if (e3[r3] === void 0 || e3[n3] === ``) return;
        if (e3[n3] === void 0) {
          if (!t3[n3]) return;
          e3[n3] = t3[n3];
        }
        if (e3[n3].indexOf(`url(`) === 0) return;
        let i3 = new G(e3[n3]);
        e3[n3] = i3.setAlpha(B(i3.getAlpha() * e3[r3], 2)).toRgba();
      }), e3;
    })(c2);
  }
  const Qi = [`rx`, `ry`];
  var $i = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(t2), this._initRxRy();
    }
    _initRxRy() {
      let { rx: e3, ry: t2 } = this;
      e3 && !t2 ? this.ry = e3 : t2 && !e3 && (this.rx = t2);
    }
    _render(e3) {
      let { width: t2, height: n2 } = this, r2 = -t2 / 2, i2 = -n2 / 2, a2 = this.rx ? Math.min(this.rx, t2 / 2) : 0, o2 = this.ry ? Math.min(this.ry, n2 / 2) : 0, s2 = a2 !== 0 || o2 !== 0;
      e3.beginPath(), e3.moveTo(r2 + a2, i2), e3.lineTo(r2 + t2 - a2, i2), s2 && e3.bezierCurveTo(r2 + t2 - 0.4477152502 * a2, i2, r2 + t2, i2 + 0.4477152502 * o2, r2 + t2, i2 + o2), e3.lineTo(r2 + t2, i2 + n2 - o2), s2 && e3.bezierCurveTo(r2 + t2, i2 + n2 - 0.4477152502 * o2, r2 + t2 - 0.4477152502 * a2, i2 + n2, r2 + t2 - a2, i2 + n2), e3.lineTo(r2 + a2, i2 + n2), s2 && e3.bezierCurveTo(r2 + 0.4477152502 * a2, i2 + n2, r2, i2 + n2 - 0.4477152502 * o2, r2, i2 + n2 - o2), e3.lineTo(r2, i2 + o2), s2 && e3.bezierCurveTo(r2, i2 + 0.4477152502 * o2, r2 + 0.4477152502 * a2, i2, r2 + a2, i2), e3.closePath(), this._renderPaintInOrder(e3);
    }
    toObject(e3 = []) {
      return super.toObject([...Qi, ...e3]);
    }
    _toSVG() {
      let { width: e3, height: t2, rx: n2, ry: r2 } = this;
      return [`<rect `, `COMMON_PARTS`, `x="${-e3 / 2}" y="${-t2 / 2}" rx="${U(n2)}" ry="${U(r2)}" width="${U(e3)}" height="${U(t2)}" />
`];
    }
    static async fromElement(e3, t2, n2) {
      let { left: r2 = 0, top: i2 = 0, width: a2 = 0, height: o2 = 0, visible: s2 = true, ...c2 } = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return new this({ ...t2, ...c2, left: r2, top: i2, width: a2, height: o2, visible: !!(s2 && a2 && o2) });
    }
  };
  i($i, `type`, `Rect`), i($i, `cacheProperties`, [...Un, ...Qi]), i($i, `ownDefaults`, { rx: 0, ry: 0 }), i($i, `ATTRIBUTE_NAMES`, [...ki, `x`, `y`, `rx`, `ry`, `width`, `height`]), M.setClass($i), M.setSVGClass($i);
  const ea = `initialization`, ta = `added`, na = (e2, t2) => {
    let { strokeUniform: n2, strokeWidth: r2, width: i2, height: a2, group: o2 } = t2, s2 = o2 && o2 !== e2 ? jt(o2.calcTransformMatrix(), e2.calcTransformMatrix()) : null, c2 = s2 ? t2.getRelativeCenterPoint().transform(s2) : t2.getRelativeCenterPoint(), l2 = !t2.isStrokeAccountedForInDimensions(), u2 = n2 && l2 ? Nt(new N(r2, r2), void 0, e2.calcTransformMatrix()) : we, d2 = !n2 && l2 ? r2 : 0, f2 = At(i2 + d2, a2 + d2, Re([s2, t2.calcOwnMatrix()], true)).add(u2).scalarDivide(2);
    return [c2.subtract(f2), c2.add(f2)];
  };
  var ra = class {
    calcLayoutResult(e2, t2) {
      if (this.shouldPerformLayout(e2)) return this.calcBoundingBox(t2, e2);
    }
    shouldPerformLayout({ type: e2, prevStrategy: t2, strategy: n2 }) {
      return e2 === `initialization` || e2 === `imperative` || !!t2 && n2 !== t2;
    }
    shouldLayoutClipPath({ type: e2, target: { clipPath: t2 } }) {
      return e2 !== `initialization` && t2 && !t2.absolutePositioned;
    }
    getInitialSize(e2, t2) {
      return t2.size;
    }
    calcBoundingBox(e2, t2) {
      let { type: n2, target: r2 } = t2;
      if (n2 === `imperative` && t2.overrides) return t2.overrides;
      if (e2.length === 0) return;
      let { left: i2, top: a2, width: o2, height: s2 } = wt(e2.map((e3) => na(r2, e3)).reduce((e3, t3) => e3.concat(t3), [])), c2 = new N(o2, s2), l2 = new N(i2, a2).add(c2.scalarDivide(2));
      if (n2 === `initialization`) {
        let e3 = this.getInitialSize(t2, { size: c2, center: l2 });
        return { center: l2, relativeCorrection: new N(0, 0), size: e3 };
      }
      return { center: l2.transform(r2.calcOwnMatrix()), size: c2 };
    }
  };
  i(ra, `type`, `strategy`);
  var ia = class extends ra {
    shouldPerformLayout(e2) {
      return true;
    }
  };
  i(ia, `type`, `fit-content`), M.setClass(ia);
  const aa = `layoutManager`;
  var oa = class {
    constructor(e2 = new ia()) {
      i(this, `strategy`, void 0), this.strategy = e2, this._subscriptions = /* @__PURE__ */ new Map();
    }
    performLayout(e2) {
      let t2 = { bubbles: true, strategy: this.strategy, ...e2, prevStrategy: this._prevLayoutStrategy, stopPropagation() {
        this.bubbles = false;
      } };
      this.onBeforeLayout(t2);
      let n2 = this.getLayoutResult(t2);
      n2 && this.commitLayout(t2, n2), this.onAfterLayout(t2, n2), this._prevLayoutStrategy = t2.strategy;
    }
    attachHandlers(e2, t2) {
      let { target: n2 } = t2;
      return [ge, re, se, ae, ie, A, le, ce, `modifyPath`].map((t3) => e2.on(t3, (e3) => this.performLayout(t3 === `modified` ? { type: `object_modified`, trigger: t3, e: e3, target: n2 } : { type: `object_modifying`, trigger: t3, e: e3, target: n2 })));
    }
    subscribe(e2, t2) {
      this.unsubscribe(e2, t2);
      let n2 = this.attachHandlers(e2, t2);
      this._subscriptions.set(e2, n2);
    }
    unsubscribe(e2, t2) {
      (this._subscriptions.get(e2) || []).forEach((e3) => e3()), this._subscriptions.delete(e2);
    }
    unsubscribeTargets(e2) {
      e2.targets.forEach((t2) => this.unsubscribe(t2, e2));
    }
    subscribeTargets(e2) {
      e2.targets.forEach((t2) => this.subscribe(t2, e2));
    }
    onBeforeLayout(e2) {
      let { target: t2, type: n2 } = e2, { canvas: r2 } = t2;
      if (n2 === `initialization` || n2 === `added` ? this.subscribeTargets(e2) : n2 === `removed` && this.unsubscribeTargets(e2), t2.fire(`layout:before`, { context: e2 }), r2 && r2.fire(`object:layout:before`, { target: t2, context: e2 }), n2 === `imperative` && e2.deep) {
        let { strategy: n3, ...r3 } = e2;
        t2.forEachObject((e3) => e3.layoutManager && e3.layoutManager.performLayout({ ...r3, bubbles: false, target: e3 }));
      }
    }
    getLayoutResult(e2) {
      let { target: t2, strategy: n2, type: r2 } = e2, i2 = n2.calcLayoutResult(e2, t2.getObjects());
      if (!i2) return;
      let a2 = r2 === `initialization` ? new N() : t2.getRelativeCenterPoint(), { center: o2, correction: s2 = new N(), relativeCorrection: c2 = new N() } = i2;
      return { result: i2, prevCenter: a2, nextCenter: o2, offset: a2.subtract(o2).add(s2).transform(r2 === `initialization` ? T : R(t2.calcOwnMatrix()), true).add(c2) };
    }
    commitLayout(e2, t2) {
      let { target: n2 } = e2, { result: { size: r2 }, nextCenter: i2 } = t2;
      var a2, o2;
      n2.set({ width: r2.x, height: r2.y }), this.layoutObjects(e2, t2), e2.type === `initialization` ? n2.set({ left: (a2 = e2.x) == null ? i2.x + r2.x * W(n2.originX) : a2, top: (o2 = e2.y) == null ? i2.y + r2.y * W(n2.originY) : o2 }) : (n2.setPositionByOrigin(i2, E, E), n2.setCoords(), n2.set(`dirty`, true));
    }
    layoutObjects(e2, t2) {
      let { target: n2 } = e2;
      n2.forEachObject((r2) => {
        r2.group === n2 && this.layoutObject(e2, t2, r2);
      }), e2.strategy.shouldLayoutClipPath(e2) && this.layoutObject(e2, t2, n2.clipPath);
    }
    layoutObject(e2, { offset: t2 }, n2) {
      n2.set({ left: n2.left + t2.x, top: n2.top + t2.y });
    }
    onAfterLayout(e2, t2) {
      let { target: n2, strategy: r2, bubbles: i2, prevStrategy: a2, ...o2 } = e2, { canvas: s2 } = n2;
      n2.fire(`layout:after`, { context: e2, result: t2 }), s2 && s2.fire(`object:layout:after`, { context: e2, result: t2, target: n2 });
      let c2 = n2.parent;
      i2 && c2 != null && c2.layoutManager && ((o2.path || (o2.path = [])).push(n2), c2.layoutManager.performLayout({ ...o2, target: c2 })), n2.set(`dirty`, true);
    }
    dispose() {
      let { _subscriptions: e2 } = this;
      e2.forEach((e3) => e3.forEach((e4) => e4())), e2.clear();
    }
    toObject() {
      return { type: aa, strategy: this.strategy.constructor.type };
    }
    toJSON() {
      return this.toObject();
    }
  };
  M.setClass(oa, aa);
  var sa = class extends oa {
    performLayout() {
    }
  }, ca = class e2 extends Ee(J) {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), i(this, `_activeObjects`, []), i(this, `__objectSelectionTracker`, void 0), i(this, `__objectSelectionDisposer`, void 0), Object.assign(this, e2.ownDefaults), this.setOptions(n2), this.groupInit(t2, n2);
    }
    groupInit(e3, t2) {
      var n2;
      this._objects = [...e3], this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true), this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false), this.forEachObject((e4) => {
        this.enterGroup(e4, false);
      }), this.layoutManager = (n2 = t2.layoutManager) == null ? new oa() : n2, this.layoutManager.performLayout({ type: ea, target: this, targets: [...e3], x: t2.left, y: t2.top });
    }
    canEnterGroup(e3) {
      return e3 === this || this.isDescendantOf(e3) ? (s(`error`, `Group: circular object trees are not supported, this call has no effect`), false) : this._objects.indexOf(e3) === -1 || (s(`error`, `Group: duplicate objects are not supported inside group, this call has no effect`), false);
    }
    _filterObjectsBeforeEnteringGroup(e3) {
      return e3.filter((e4, t2, n2) => this.canEnterGroup(e4) && n2.indexOf(e4) === t2);
    }
    add(...e3) {
      let t2 = this._filterObjectsBeforeEnteringGroup(e3), n2 = super.add(...t2);
      return this._onAfterObjectsChange(ta, t2), n2;
    }
    insertAt(e3, ...t2) {
      let n2 = this._filterObjectsBeforeEnteringGroup(t2), r2 = super.insertAt(e3, ...n2);
      return this._onAfterObjectsChange(ta, n2), r2;
    }
    remove(...e3) {
      let t2 = super.remove(...e3);
      return this._onAfterObjectsChange(`removed`, t2), t2;
    }
    _onObjectAdded(e3) {
      this.enterGroup(e3, true), this.fire(`object:added`, { target: e3 }), e3.fire(`added`, { target: this });
    }
    _onObjectRemoved(e3, t2) {
      this.exitGroup(e3, t2), this.fire(`object:removed`, { target: e3 }), e3.fire(`removed`, { target: this });
    }
    _onAfterObjectsChange(e3, t2) {
      this.layoutManager.performLayout({ type: e3, targets: t2, target: this });
    }
    _onStackOrderChanged() {
      this._set(`dirty`, true);
    }
    _set(e3, t2) {
      let n2 = this[e3];
      return super._set(e3, t2), e3 === `canvas` && n2 !== t2 && (this._objects || []).forEach((n3) => {
        n3._set(e3, t2);
      }), this;
    }
    _shouldSetNestedCoords() {
      return this.subTargetCheck;
    }
    removeAll() {
      return this._activeObjects = [], this.remove(...this._objects);
    }
    __objectSelectionMonitor(e3, { target: t2 }) {
      let n2 = this._activeObjects;
      if (e3) n2.push(t2), this._set(`dirty`, true);
      else if (n2.length > 0) {
        let e4 = n2.indexOf(t2);
        e4 > -1 && (n2.splice(e4, 1), this._set(`dirty`, true));
      }
    }
    _watchObject(e3, t2) {
      e3 && this._watchObject(false, t2), e3 ? (t2.on(`selected`, this.__objectSelectionTracker), t2.on(`deselected`, this.__objectSelectionDisposer)) : (t2.off(`selected`, this.__objectSelectionTracker), t2.off(`deselected`, this.__objectSelectionDisposer));
    }
    enterGroup(e3, t2) {
      e3.group && e3.group.remove(e3), e3._set(`parent`, this), this._enterGroup(e3, t2);
    }
    _enterGroup(e3, t2) {
      t2 && Dt(e3, z(R(this.calcTransformMatrix()), e3.calcTransformMatrix())), this._shouldSetNestedCoords() && e3.setCoords(), e3._set(`group`, this), e3._set(`canvas`, this.canvas), this._watchObject(true, e3);
      let n2 = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
      n2 && (n2 === e3 || e3.isDescendantOf(n2)) && this._activeObjects.push(e3);
    }
    exitGroup(e3, t2) {
      this._exitGroup(e3, t2), e3._set(`parent`, void 0), e3._set(`canvas`, void 0);
    }
    _exitGroup(e3, t2) {
      e3._set(`group`, void 0), t2 || (Dt(e3, z(this.calcTransformMatrix(), e3.calcTransformMatrix())), e3.setCoords()), this._watchObject(false, e3);
      let n2 = this._activeObjects.length > 0 ? this._activeObjects.indexOf(e3) : -1;
      n2 > -1 && this._activeObjects.splice(n2, 1);
    }
    shouldCache() {
      let e3 = J.prototype.shouldCache.call(this);
      if (e3) {
        for (let e4 = 0; e4 < this._objects.length; e4++) if (this._objects[e4].willDrawShadow()) return this.ownCaching = false, false;
      }
      return e3;
    }
    willDrawShadow() {
      if (super.willDrawShadow()) return true;
      for (let e3 = 0; e3 < this._objects.length; e3++) if (this._objects[e3].willDrawShadow()) return true;
      return false;
    }
    isOnACache() {
      return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }
    drawObject(e3, t2, n2) {
      this._renderBackground(e3);
      for (let t3 = 0; t3 < this._objects.length; t3++) {
        var r2;
        let n3 = this._objects[t3];
        (r2 = this.canvas) != null && r2.preserveObjectStacking && n3.group !== this ? (e3.save(), e3.transform(...R(this.calcTransformMatrix())), n3.render(e3), e3.restore()) : n3.group === this && n3.render(e3);
      }
      this._drawClipPath(e3, this.clipPath, n2);
    }
    setCoords() {
      super.setCoords(), this._shouldSetNestedCoords() && this.forEachObject((e3) => e3.setCoords());
    }
    triggerLayout(e3 = {}) {
      this.layoutManager.performLayout({ target: this, type: `imperative`, ...e3 });
    }
    render(e3) {
      this._transformDone = true, super.render(e3), this._transformDone = false;
    }
    __serializeObjects(e3, t2) {
      let n2 = this.includeDefaultValues;
      return this._objects.filter(function(e4) {
        return !e4.excludeFromExport;
      }).map(function(r2) {
        let i2 = r2.includeDefaultValues;
        r2.includeDefaultValues = n2;
        let a2 = r2[e3 || `toObject`](t2);
        return r2.includeDefaultValues = i2, a2;
      });
    }
    toObject(e3 = []) {
      let t2 = this.layoutManager.toObject();
      return { ...super.toObject([`subTargetCheck`, `interactive`, ...e3]), ...t2.strategy !== `fit-content` || this.includeDefaultValues ? { layoutManager: t2 } : {}, objects: this.__serializeObjects(`toObject`, e3) };
    }
    toString() {
      return `#<Group: (${this.complexity()})>`;
    }
    dispose() {
      this.layoutManager.unsubscribeTargets({ targets: this.getObjects(), target: this }), this._activeObjects = [], this.forEachObject((e3) => {
        this._watchObject(false, e3), e3.dispose();
      }), super.dispose();
    }
    _createSVGBgRect(e3) {
      if (!this.backgroundColor) return ``;
      let t2 = $i.prototype._toSVG.call(this), n2 = t2.indexOf(`COMMON_PARTS`);
      t2[n2] = `for="group" `;
      let r2 = t2.join(``);
      return e3 ? e3(r2) : r2;
    }
    _toSVG(e3) {
      let t2 = [`<g `, `COMMON_PARTS`, ` >
`], n2 = this._createSVGBgRect(e3);
      n2 && t2.push(`		`, n2);
      for (let n3 = 0; n3 < this._objects.length; n3++) t2.push(`		`, this._objects[n3].toSVG(e3));
      return t2.push(`</g>
`), t2;
    }
    getSvgStyles() {
      let e3 = this.opacity !== void 0 && this.opacity !== 1 ? `opacity: ${U(this.opacity)};` : ``, t2 = this.visible ? `` : ` visibility: hidden;`;
      return [e3, this.getSvgFilter(), t2].join(``);
    }
    toClipPathSVG(e3) {
      let t2 = [], n2 = this._createSVGBgRect(e3);
      n2 && t2.push(`	`, n2);
      for (let n3 = 0; n3 < this._objects.length; n3++) t2.push(`	`, this._objects[n3].toClipPathSVG(e3));
      return this._createBaseClipPathSVGMarkup(t2, { reviver: e3 });
    }
    static fromObject({ type: e3, objects: t2 = [], layoutManager: n2, ...r2 }, i2) {
      return Promise.all([Qe(t2, i2), $e(r2, i2)]).then(([e4, t3]) => {
        let i3 = new this(e4, { ...r2, ...t3, layoutManager: new sa() });
        return i3.layoutManager = n2 ? new (M.getClass(n2.type))(new (M.getClass(n2.strategy))()) : new oa(), i3.layoutManager.subscribeTargets({ type: ea, target: i3, targets: i3.getObjects() }), i3.setCoords(), i3;
      });
    }
  };
  i(ca, `type`, `Group`), i(ca, `ownDefaults`, { strokeWidth: 0, subTargetCheck: false, interactive: false }), M.setClass(ca);
  const la = (e2, t2) => e2 && e2.length === 1 ? e2[0] : new ca(e2, t2), ua = (e2, t2) => Math.min(t2.width / e2.width, t2.height / e2.height), da = (e2, t2) => Math.max(t2.width / e2.width, t2.height / e2.height), fa = `\\s*,?\\s*`, pa = `${fa}(${Dn})`, ma = `${pa}${pa}${pa}${fa}([01])${fa}([01])${pa}${pa}`, ha = { m: `l`, M: `L` }, ga = (e2, t2, n2, r2, i2, a2, o2, s2, c2, l2, u2) => {
    let d2 = Se(e2), f2 = Ce(e2), p2 = Se(t2), m = Ce(t2), h2 = n2 * i2 * p2 - r2 * a2 * m + o2, g2 = r2 * i2 * p2 + n2 * a2 * m + s2;
    return [`C`, l2 + c2 * (-n2 * i2 * f2 - r2 * a2 * d2), u2 + c2 * (-r2 * i2 * f2 + n2 * a2 * d2), h2 + c2 * (n2 * i2 * m + r2 * a2 * p2), g2 + c2 * (r2 * i2 * m - n2 * a2 * p2), h2, g2];
  }, _a = (e2, t2, n2, r2) => {
    let i2 = Math.atan2(t2, e2), a2 = Math.atan2(r2, n2);
    return a2 >= i2 ? a2 - i2 : 2 * Math.PI - (i2 - a2);
  };
  function va(e2, t2, n2, r2, i2, a2, s2, c2) {
    let l2;
    if (o.cachesBoundsOfCurve && (l2 = [...arguments].join(), y.boundsOfCurveCache[l2])) return y.boundsOfCurveCache[l2];
    let u2 = Math.sqrt, d2 = Math.abs, f2 = [], p2 = [[0, 0], [0, 0]], m = 6 * e2 - 12 * n2 + 6 * i2, h2 = -3 * e2 + 9 * n2 - 9 * i2 + 3 * s2, g2 = 3 * n2 - 3 * e2;
    for (let e3 = 0; e3 < 2; ++e3) {
      if (e3 > 0 && (m = 6 * t2 - 12 * r2 + 6 * a2, h2 = -3 * t2 + 9 * r2 - 9 * a2 + 3 * c2, g2 = 3 * r2 - 3 * t2), d2(h2) < 1e-12) {
        if (d2(m) < 1e-12) continue;
        let e4 = -g2 / m;
        0 < e4 && e4 < 1 && f2.push(e4);
        continue;
      }
      let n3 = m * m - 4 * g2 * h2;
      if (n3 < 0) continue;
      let i3 = u2(n3), o2 = (-m + i3) / (2 * h2);
      0 < o2 && o2 < 1 && f2.push(o2);
      let s3 = (-m - i3) / (2 * h2);
      0 < s3 && s3 < 1 && f2.push(s3);
    }
    let _2 = f2.length, v2 = _2, b2 = Sa(e2, t2, n2, r2, i2, a2, s2, c2);
    for (; _2--; ) {
      let { x: e3, y: t3 } = b2(f2[_2]);
      p2[0][_2] = e3, p2[1][_2] = t3;
    }
    p2[0][v2] = e2, p2[1][v2] = t2, p2[0][v2 + 1] = s2, p2[1][v2 + 1] = c2;
    let x2 = [new N(Math.min(...p2[0]), Math.min(...p2[1])), new N(Math.max(...p2[0]), Math.max(...p2[1]))];
    return o.cachesBoundsOfCurve && (y.boundsOfCurveCache[l2] = x2), x2;
  }
  const ya = (e2, t2, [n2, r2, i2, a2, o2, s2, c2, l2]) => {
    let u2 = ((e3, t3, n3, r3, i3, a3, o3) => {
      if (n3 === 0 || r3 === 0) return [];
      let s3 = 0, c3 = 0, l3 = 0, u3 = Math.PI, d2 = o3 * ee, f2 = Ce(d2), p2 = Se(d2), m = 0.5 * (-p2 * e3 - f2 * t3), h2 = 0.5 * (-p2 * t3 + f2 * e3), g2 = n3 ** 2, _2 = r3 ** 2, v2 = h2 ** 2, y2 = m ** 2, b2 = g2 * _2 - g2 * v2 - _2 * y2, x2 = Math.abs(n3), S2 = Math.abs(r3);
      if (b2 < 0) {
        let e4 = Math.sqrt(1 - b2 / (g2 * _2));
        x2 *= e4, S2 *= e4;
      } else l3 = (i3 === a3 ? -1 : 1) * Math.sqrt(b2 / (g2 * v2 + _2 * y2));
      let C2 = l3 * x2 * h2 / S2, w2 = -l3 * S2 * m / x2, T2 = p2 * C2 - f2 * w2 + 0.5 * e3, E2 = f2 * C2 + p2 * w2 + 0.5 * t3, D2 = _a(1, 0, (m - C2) / x2, (h2 - w2) / S2), O2 = _a((m - C2) / x2, (h2 - w2) / S2, (-m - C2) / x2, (-h2 - w2) / S2);
      a3 === 0 && O2 > 0 ? O2 -= 2 * u3 : a3 === 1 && O2 < 0 && (O2 += 2 * u3);
      let k2 = Math.ceil(Math.abs(O2 / u3 * 2)), te2 = [], ne2 = O2 / k2, re2 = 8 / 3 * Math.sin(ne2 / 4) * Math.sin(ne2 / 4) / Math.sin(ne2 / 2), ie2 = D2 + ne2;
      for (let e4 = 0; e4 < k2; e4++) te2[e4] = ga(D2, ie2, p2, f2, x2, S2, T2, E2, re2, s3, c3), s3 = te2[e4][5], c3 = te2[e4][6], D2 = ie2, ie2 += ne2;
      return te2;
    })(c2 - e2, l2 - t2, r2, i2, o2, s2, a2);
    for (let n3 = 0, r3 = u2.length; n3 < r3; n3++) u2[n3][1] += e2, u2[n3][2] += t2, u2[n3][3] += e2, u2[n3][4] += t2, u2[n3][5] += e2, u2[n3][6] += t2;
    return u2;
  }, ba = (e2) => {
    let t2 = 0, n2 = 0, r2 = 0, i2 = 0, a2 = [], o2, s2 = 0, c2 = 0;
    for (let l2 of e2) {
      let e3 = [...l2], u2;
      switch (e3[0]) {
        case `l`:
          e3[1] += t2, e3[2] += n2;
        case `L`:
          t2 = e3[1], n2 = e3[2], u2 = [`L`, t2, n2];
          break;
        case `h`:
          e3[1] += t2;
        case `H`:
          t2 = e3[1], u2 = [`L`, t2, n2];
          break;
        case `v`:
          e3[1] += n2;
        case `V`:
          n2 = e3[1], u2 = [`L`, t2, n2];
          break;
        case `m`:
          e3[1] += t2, e3[2] += n2;
        case `M`:
          t2 = e3[1], n2 = e3[2], r2 = e3[1], i2 = e3[2], u2 = [`M`, t2, n2];
          break;
        case `c`:
          e3[1] += t2, e3[2] += n2, e3[3] += t2, e3[4] += n2, e3[5] += t2, e3[6] += n2;
        case `C`:
          s2 = e3[3], c2 = e3[4], t2 = e3[5], n2 = e3[6], u2 = [`C`, e3[1], e3[2], s2, c2, t2, n2];
          break;
        case `s`:
          e3[1] += t2, e3[2] += n2, e3[3] += t2, e3[4] += n2;
        case `S`:
          o2 === `C` ? (s2 = 2 * t2 - s2, c2 = 2 * n2 - c2) : (s2 = t2, c2 = n2), t2 = e3[3], n2 = e3[4], u2 = [`C`, s2, c2, e3[1], e3[2], t2, n2], s2 = u2[3], c2 = u2[4];
          break;
        case `q`:
          e3[1] += t2, e3[2] += n2, e3[3] += t2, e3[4] += n2;
        case `Q`:
          s2 = e3[1], c2 = e3[2], t2 = e3[3], n2 = e3[4], u2 = [`Q`, s2, c2, t2, n2];
          break;
        case `t`:
          e3[1] += t2, e3[2] += n2;
        case `T`:
          o2 === `Q` ? (s2 = 2 * t2 - s2, c2 = 2 * n2 - c2) : (s2 = t2, c2 = n2), t2 = e3[1], n2 = e3[2], u2 = [`Q`, s2, c2, t2, n2];
          break;
        case `a`:
          e3[6] += t2, e3[7] += n2;
        case `A`:
          ya(t2, n2, e3).forEach((e4) => a2.push(e4)), t2 = e3[6], n2 = e3[7];
          break;
        case `z`:
        case `Z`:
          t2 = r2, n2 = i2, u2 = [`Z`];
      }
      u2 ? (a2.push(u2), o2 = u2[0]) : o2 = ``;
    }
    return a2;
  }, xa = (e2, t2, n2, r2) => Math.sqrt((n2 - e2) ** 2 + (r2 - t2) ** 2), Sa = (e2, t2, n2, r2, i2, a2, o2, s2) => (c2) => {
    let l2 = c2 ** 3, u2 = ((e3) => 3 * e3 ** 2 * (1 - e3))(c2), d2 = ((e3) => 3 * e3 * (1 - e3) ** 2)(c2), f2 = ((e3) => (1 - e3) ** 3)(c2);
    return new N(o2 * l2 + i2 * u2 + n2 * d2 + e2 * f2, s2 * l2 + a2 * u2 + r2 * d2 + t2 * f2);
  }, Ca = (e2) => e2 ** 2, wa = (e2) => 2 * e2 * (1 - e2), Ta = (e2) => (1 - e2) ** 2, Ea = (e2, t2, n2, r2, i2, a2, o2, s2) => (c2) => {
    let l2 = Ca(c2), u2 = wa(c2), d2 = Ta(c2), f2 = 3 * (d2 * (n2 - e2) + u2 * (i2 - n2) + l2 * (o2 - i2)), p2 = 3 * (d2 * (r2 - t2) + u2 * (a2 - r2) + l2 * (s2 - a2));
    return Math.atan2(p2, f2);
  }, Da = (e2, t2, n2, r2, i2, a2) => (o2) => {
    let s2 = Ca(o2), c2 = wa(o2), l2 = Ta(o2);
    return new N(i2 * s2 + n2 * c2 + e2 * l2, a2 * s2 + r2 * c2 + t2 * l2);
  }, Oa = (e2, t2, n2, r2, i2, a2) => (o2) => {
    let s2 = 1 - o2, c2 = 2 * (s2 * (n2 - e2) + o2 * (i2 - n2)), l2 = 2 * (s2 * (r2 - t2) + o2 * (a2 - r2));
    return Math.atan2(l2, c2);
  }, ka = (e2, t2, n2) => {
    let r2 = new N(t2, n2), i2 = 0;
    for (let t3 = 1; t3 <= 100; t3 += 1) {
      let n3 = e2(t3 / 100);
      i2 += xa(r2.x, r2.y, n3.x, n3.y), r2 = n3;
    }
    return i2;
  }, Aa = (e2, t2) => {
    let n2, r2 = 0, i2 = 0, a2 = { x: e2.x, y: e2.y }, o2 = { ...a2 }, s2 = 0.01, c2 = 0, l2 = e2.iterator, u2 = e2.angleFinder;
    for (; i2 < t2 && s2 > 1e-4; ) o2 = l2(r2), c2 = r2, n2 = xa(a2.x, a2.y, o2.x, o2.y), n2 + i2 > t2 ? (r2 -= s2, s2 /= 2) : (a2 = o2, r2 += s2, i2 += n2);
    return { ...o2, angle: u2(c2) };
  }, ja = (e2) => {
    let t2, n2, r2 = 0, i2 = 0, a2 = 0, o2 = 0, s2 = 0, c2 = [];
    for (let l2 of e2) {
      let e3 = { x: i2, y: a2, command: l2[0], length: 0 };
      switch (l2[0]) {
        case `M`:
          n2 = e3, n2.x = o2 = i2 = l2[1], n2.y = s2 = a2 = l2[2];
          break;
        case `L`:
          n2 = e3, n2.length = xa(i2, a2, l2[1], l2[2]), i2 = l2[1], a2 = l2[2];
          break;
        case `C`:
          t2 = Sa(i2, a2, l2[1], l2[2], l2[3], l2[4], l2[5], l2[6]), n2 = e3, n2.iterator = t2, n2.angleFinder = Ea(i2, a2, l2[1], l2[2], l2[3], l2[4], l2[5], l2[6]), n2.length = ka(t2, i2, a2), i2 = l2[5], a2 = l2[6];
          break;
        case `Q`:
          t2 = Da(i2, a2, l2[1], l2[2], l2[3], l2[4]), n2 = e3, n2.iterator = t2, n2.angleFinder = Oa(i2, a2, l2[1], l2[2], l2[3], l2[4]), n2.length = ka(t2, i2, a2), i2 = l2[3], a2 = l2[4];
          break;
        case `Z`:
          n2 = e3, n2.destX = o2, n2.destY = s2, n2.length = xa(i2, a2, o2, s2), i2 = o2, a2 = s2;
      }
      r2 += n2.length, c2.push(n2);
    }
    return c2.push({ length: r2, x: i2, y: a2 }), c2;
  }, Ma = (e2, t2, n2 = ja(e2)) => {
    let r2 = 0;
    for (; t2 - n2[r2].length > 0 && r2 < n2.length - 2; ) t2 -= n2[r2].length, r2++;
    let i2 = n2[r2], a2 = t2 / i2.length, o2 = e2[r2];
    switch (i2.command) {
      case `M`:
        return { x: i2.x, y: i2.y, angle: 0 };
      case `Z`:
        return { ...new N(i2.x, i2.y).lerp(new N(i2.destX, i2.destY), a2), angle: Math.atan2(i2.destY - i2.y, i2.destX - i2.x) };
      case `L`:
        return { ...new N(i2.x, i2.y).lerp(new N(o2[1], o2[2]), a2), angle: Math.atan2(o2[2] - i2.y, o2[1] - i2.x) };
      case `C`:
      case `Q`:
        return Aa(i2, t2);
    }
  }, Na = RegExp(`[mzlhvcsqta][^mzlhvcsqta]*`, `gi`), Pa = new RegExp(ma, `g`), Fa = new RegExp(Dn, `gi`), Ia = { m: 2, l: 2, h: 1, v: 1, c: 6, s: 4, q: 4, t: 2, a: 7 }, La = (e2) => {
    var t2;
    let n2 = [], r2 = (t2 = e2.match(Na)) == null ? [] : t2;
    for (let e3 of r2) {
      let t3 = e3[0];
      if (t3 === `z` || t3 === `Z`) {
        n2.push([t3]);
        continue;
      }
      let r3 = Ia[t3.toLowerCase()], i2 = [];
      if (t3 === `a` || t3 === `A`) {
        let t4;
        for (Pa.lastIndex = 0; t4 = Pa.exec(e3); ) i2.push(...t4.slice(1));
      } else i2 = e3.match(Fa) || [];
      for (let e4 = 0; e4 < i2.length; e4 += r3) {
        let a2 = Array(r3), o2 = ha[t3];
        a2[0] = e4 > 0 && o2 ? o2 : t3;
        for (let t4 = 0; t4 < r3; t4++) a2[t4 + 1] = parseFloat(i2[e4 + t4]);
        n2.push(a2);
      }
    }
    return n2;
  }, Ra = (e2, t2 = 0) => {
    let n2 = new N(e2[0]), r2 = new N(e2[1]), i2 = 1, a2 = 0, o2 = [], s2 = e2.length, c2 = s2 > 2, l2;
    for (c2 && (i2 = e2[2].x < r2.x ? -1 : e2[2].x === r2.x ? 0 : 1, a2 = e2[2].y < r2.y ? -1 : e2[2].y === r2.y ? 0 : 1), o2.push([`M`, n2.x - i2 * t2, n2.y - a2 * t2]), l2 = 1; l2 < s2; l2++) {
      if (!n2.eq(r2)) {
        let e3 = n2.midPointFrom(r2);
        o2.push([`Q`, n2.x, n2.y, e3.x, e3.y]);
      }
      n2 = e2[l2], l2 + 1 < e2.length && (r2 = e2[l2 + 1]);
    }
    return c2 && (i2 = n2.x > e2[l2 - 2].x ? 1 : n2.x === e2[l2 - 2].x ? 0 : -1, a2 = n2.y > e2[l2 - 2].y ? 1 : n2.y === e2[l2 - 2].y ? 0 : -1), o2.push([`L`, n2.x + i2 * t2, n2.y + a2 * t2]), o2;
  }, za = (e2, t2, n2) => (n2 && (t2 = z(t2, [1, 0, 0, 1, -n2.x, -n2.y])), e2.map((e3) => {
    let n3 = [...e3];
    for (let r2 = 1; r2 < e3.length - 1; r2 += 2) {
      let { x: i2, y: a2 } = L({ x: e3[r2], y: e3[r2 + 1] }, t2);
      n3[r2] = i2, n3[r2 + 1] = a2;
    }
    return n3;
  })), Ba = (e2, t2) => {
    let n2 = 2 * Math.PI / e2, r2 = -S;
    e2 % 2 == 0 && (r2 += n2 / 2);
    let i2 = Array(e2 + 1);
    for (let a2 = 0; a2 < e2; a2++) {
      let e3 = a2 * n2 + r2, { x: o2, y: s2 } = new N(Se(e3), Ce(e3)).scalarMultiply(t2);
      i2[a2] = [a2 === 0 ? `M` : `L`, o2, s2];
    }
    return i2[e2] = [`Z`], i2;
  }, Va = (e2, t2) => e2.map((e3) => e3.map((e4, n2) => n2 === 0 || t2 === void 0 ? e4 : B(e4, t2)).join(` `)).join(` `), Ha = (e2, t2) => {
    var n2;
    let r2 = e2, i2 = t2;
    r2.inverted && !i2.inverted && (r2 = t2, i2 = e2), Pt(i2, (n2 = i2.group) == null ? void 0 : n2.calcTransformMatrix(), r2.calcTransformMatrix());
    let a2 = r2.inverted && i2.inverted;
    return a2 && (r2.inverted = i2.inverted = false), new ca([r2], { clipPath: i2, inverted: a2 });
  }, Ua = (e2, t2) => Math.floor(Math.random() * (t2 - e2 + 1)) + e2, Wa = (e2, t2) => {
    let n2 = e2._findCenterFromElement();
    e2.transformMatrix && (((e3) => {
      if (e3.transformMatrix) {
        let { scaleX: t3, scaleY: n3, angle: r2, skewX: i2 } = He(e3.transformMatrix);
        e3.flipX = false, e3.flipY = false, e3.set(de, t3), e3.set(fe, n3), e3.angle = r2, e3.skewX = i2, e3.skewY = 0;
      }
    })(e2), n2 = n2.transform(e2.transformMatrix)), delete e2.transformMatrix, t2 && (e2.scaleX *= t2.scaleX, e2.scaleY *= t2.scaleY, e2.cropX = t2.cropX, e2.cropY = t2.cropY, n2.x += t2.offsetLeft, n2.y += t2.offsetTop, e2.width = t2.width, e2.height = t2.height), e2.setPositionByOrigin(n2, E, E);
  };
  t({ addTransformToObject: () => Et, animate: () => Mr, animateColor: () => Nr, applyTransformToObject: () => Dt, calcAngleBetweenVectors: () => Vt, calcDimensionsMatrix: () => Ye, calcPlaneChangeMatrix: () => jt, calcVectorRotation: () => Ht, cancelAnimFrame: () => ke, capValue: () => Vn, composeMatrix: () => Xe, copyCanvasElement: () => Ne, cos: () => Se, createCanvasElement: () => P, createImage: () => Me, createRotateMatrix: () => We, createScaleMatrix: () => Ge, createSkewXMatrix: () => qe, createSkewYMatrix: () => Je, createTranslateMatrix: () => Ue, createVector: () => zt, crossProduct: () => Gt, degreesToRadians: () => I, dotProduct: () => Kt, ease: () => Gn, enlivenObjectEnlivables: () => $e, enlivenObjects: () => Qe, findScaleToCover: () => da, findScaleToFit: () => ua, getBoundsOfCurve: () => va, getOrthonormalVector: () => Wt, getPathSegmentsInfo: () => ja, getPointOnPath: () => Ma, getPointer: () => xt, getRandomInt: () => Ua, getRegularPolygonPath: () => Ba, getSmoothPathFromPoints: () => Ra, getSvgAttributes: () => pn, getUnitVector: () => Ut, groupSVGElements: () => la, hasStyleChanged: () => Ei, invertTransform: () => R, isBetweenVectors: () => qt, isIdentityMatrix: () => Le, isTouchEvent: () => St, isTransparent: () => yi, joinPath: () => Va, loadImage: () => Ze, magnitude: () => Bt, makeBoundingBoxFromPoints: () => wt, makePathSimpler: () => ba, matrixToSVG: () => nt, mergeClipPaths: () => Ha, multiplyTransformMatrices: () => z, multiplyTransformMatrixArray: () => Re, parsePath: () => La, parsePreserveAspectRatioAttribute: () => mn, parseUnit: () => K, pick: () => et, projectStrokeOnPoints: () => wi, qrDecompose: () => He, radiansToDegrees: () => Ie, removeFromArray: () => xe, removeTransformFromObject: () => Tt, removeTransformMatrixForSvgParsing: () => Wa, requestAnimFrame: () => Oe, resetObjectTransform: () => Ot, rotateVector: () => Rt, saveObjectTransform: () => kt, sendObjectToPlane: () => Pt, sendPointToPlane: () => Mt, sendVectorToPlane: () => Nt, sin: () => Ce, sizeAfterTransform: () => At, string: () => pt, stylesFromArray: () => Oi, stylesToArray: () => Di, toBlob: () => Fe, toDataURL: () => Pe, toFixed: () => B, transformPath: () => za, transformPoint: () => L });
  function Ka(e2, t2) {
    let n2 = e2.style;
    n2 && Object.entries(t2).forEach(([e3, t3]) => n2.setProperty(e3, t3));
  }
  var qa = class extends dt {
    constructor(e2, { allowTouchScrolling: t2 = false, containerClass: n2 = `` } = {}) {
      super(e2), i(this, `upper`, void 0), i(this, `container`, void 0);
      let { el: r2 } = this.lower, a2 = this.createUpperCanvas();
      this.upper = { el: a2, ctx: a2.getContext(`2d`) }, this.applyCanvasStyle(r2, { allowTouchScrolling: t2 }), this.applyCanvasStyle(a2, { allowTouchScrolling: t2, styles: { position: `absolute`, left: `0`, top: `0` } });
      let o2 = this.createContainerElement();
      o2.classList.add(n2), r2.parentNode && r2.parentNode.replaceChild(o2, r2), o2.append(r2, a2), this.container = o2;
    }
    createUpperCanvas() {
      let { el: e2 } = this.lower, t2 = P();
      return t2.className = e2.className, t2.classList.remove(`lower-canvas`), t2.classList.add(`upper-canvas`), t2.setAttribute(`data-fabric`, `top`), t2.style.cssText = e2.style.cssText, t2.setAttribute(`draggable`, `true`), t2;
    }
    createContainerElement() {
      let e2 = g().createElement(`div`);
      return e2.setAttribute(`data-fabric`, `wrapper`), Ka(e2, { position: `relative` }), ut(e2), e2;
    }
    applyCanvasStyle(e2, t2) {
      let { styles: n2, allowTouchScrolling: r2 } = t2;
      Ka(e2, { ...n2, "touch-action": r2 ? `manipulation` : te }), ut(e2);
    }
    setDimensions(e2, t2) {
      super.setDimensions(e2, t2);
      let { el: n2, ctx: r2 } = this.upper;
      ct(n2, r2, e2, t2);
    }
    setCSSDimensions(e2) {
      super.setCSSDimensions(e2), lt(this.upper.el, e2), lt(this.container, e2);
    }
    cleanupDOM(e2) {
      let t2 = this.container, { el: n2 } = this.lower, { el: r2 } = this.upper;
      super.cleanupDOM(e2), t2.removeChild(r2), t2.removeChild(n2), t2.parentNode && t2.parentNode.replaceChild(n2, t2);
    }
    dispose() {
      super.dispose(), h().dispose(this.upper.el), delete this.upper, delete this.container;
    }
  };
  const Ja = (e2, t2, n2, r2) => {
    let { target: i2, offsetX: a2, offsetY: o2 } = t2, s2 = n2 - a2, c2 = r2 - o2, l2 = !Zt(i2, `lockMovementX`) && i2.left !== s2, u2 = !Zt(i2, `lockMovementY`) && i2.top !== c2;
    return l2 && i2.set(`left`, s2), u2 && i2.set(`top`, c2), (l2 || u2) && Lr(re, Qt(e2, t2, n2, r2)), l2 || u2;
  }, Ya = ce, Xa = (e2) => function(t2, n2, r2) {
    let { points: i2, pathOffset: a2 } = r2;
    return new N(i2[e2]).subtract(a2).transform(z(r2.getViewportTransform(), r2.calcTransformMatrix()));
  }, Za = (e2, t2, n2, r2) => {
    let { target: i2, pointIndex: a2 } = t2, o2 = i2, s2 = Mt(new N(n2, r2), void 0, o2.calcOwnMatrix());
    return o2.points[a2] = s2.add(o2.pathOffset), o2.setDimensions(), o2.set(`dirty`, true), true;
  }, Qa = (e2, t2) => function(n2, r2, i2, a2) {
    let o2 = r2.target, s2 = new N(o2.points[(e2 > 0 ? e2 : o2.points.length) - 1]), c2 = s2.subtract(o2.pathOffset).transform(o2.calcOwnMatrix()), l2 = t2(n2, { ...r2, pointIndex: e2 }, i2, a2), u2 = s2.subtract(o2.pathOffset).transform(o2.calcOwnMatrix()).subtract(c2);
    return o2.left -= u2.x, o2.top -= u2.y, l2;
  }, $a = (e2) => Rr(Ya, Qa(e2, Za));
  function eo(e2, t2 = {}) {
    let n2 = {};
    for (let r2 = 0; r2 < (typeof e2 == `number` ? e2 : e2.points.length); r2++) n2[`p${r2}`] = new q({ actionName: Ya, positionHandler: Xa(r2), actionHandler: $a(r2), ...t2 });
    return n2;
  }
  const to = (e2, t2, n2) => {
    let { path: r2, pathOffset: i2 } = e2, a2 = r2[t2];
    return new N(a2[n2] - i2.x, a2[n2 + 1] - i2.y).transform(z(e2.getViewportTransform(), e2.calcTransformMatrix()));
  };
  function no(e2, t2, n2) {
    let { commandIndex: r2, pointIndex: i2 } = this;
    return to(n2, r2, i2);
  }
  function ro(e2, t2, n2, r2) {
    let { target: i2 } = t2, { commandIndex: a2, pointIndex: o2 } = this, s2 = ((e3, t3, n3, r3, i3) => {
      let { path: a3, pathOffset: o3 } = e3, s3 = a3[(r3 > 0 ? r3 : a3.length) - 1], c2 = new N(s3[i3], s3[i3 + 1]), l2 = c2.subtract(o3).transform(e3.calcOwnMatrix()), u2 = Mt(new N(t3, n3), void 0, e3.calcOwnMatrix());
      a3[r3][i3] = u2.x + o3.x, a3[r3][i3 + 1] = u2.y + o3.y, e3.setDimensions();
      let d2 = c2.subtract(e3.pathOffset).transform(e3.calcOwnMatrix()).subtract(l2);
      return e3.left -= d2.x, e3.top -= d2.y, e3.set(`dirty`, true), true;
    })(i2, n2, r2, a2, o2);
    return Lr(this.actionName, { ...Qt(e2, t2, n2, r2), commandIndex: a2, pointIndex: o2 }), s2;
  }
  var io = class extends q {
    constructor(e2) {
      super(e2);
    }
    render(e2, t2, n2, r2, i2) {
      let a2 = { ...r2, cornerColor: this.controlFill, cornerStrokeColor: this.controlStroke, transparentCorners: !this.controlFill };
      super.render(e2, t2, n2, a2, i2);
    }
  }, ao = class extends io {
    constructor(e2) {
      super(e2);
    }
    render(e2, t2, n2, r2, i2) {
      let { path: a2 } = i2, { commandIndex: o2, pointIndex: s2, connectToCommandIndex: c2, connectToPointIndex: l2 } = this;
      e2.save(), e2.strokeStyle = this.controlStroke, this.connectionDashArray && e2.setLineDash(this.connectionDashArray);
      let [u2] = a2[o2], d2 = to(i2, c2, l2);
      if (u2 === `Q`) {
        let r3 = to(i2, o2, s2 + 2);
        e2.moveTo(r3.x, r3.y), e2.lineTo(t2, n2);
      } else e2.moveTo(t2, n2);
      e2.lineTo(d2.x, d2.y), e2.stroke(), e2.restore(), super.render(e2, t2, n2, r2, i2);
    }
  };
  const oo = (e2, t2, n2, r2, i2, a2) => new (n2 ? ao : io)({ commandIndex: e2, pointIndex: t2, actionName: `modifyPath`, positionHandler: no, actionHandler: ro, connectToCommandIndex: i2, connectToPointIndex: a2, ...r2, ...n2 ? r2.controlPointStyle : r2.pointStyle });
  function so(e2, t2 = {}) {
    let n2 = {}, r2 = `M`;
    return e2.path.forEach((e3, i2) => {
      let a2 = e3[0];
      switch (a2 !== `Z` && (n2[`c_${i2}_${a2}`] = oo(i2, e3.length - 2, false, t2)), a2) {
        case `C`:
          n2[`c_${i2}_C_CP_1`] = oo(i2, 1, true, t2, i2 - 1, /* @__PURE__ */ ((e4) => e4 === `C` ? 5 : e4 === `Q` ? 3 : 1)(r2)), n2[`c_${i2}_C_CP_2`] = oo(i2, 3, true, t2, i2, 5);
          break;
        case `Q`:
          n2[`c_${i2}_Q_CP_1`] = oo(i2, 1, true, t2, i2, 3);
      }
      r2 = a2;
    }), n2;
  }
  t({ changeHeight: () => Wr, changeObjectHeight: () => Hr, changeObjectWidth: () => Vr, changeWidth: () => Ur, createObjectDefaultControls: () => mi, createPathControls: () => so, createPolyActionHandler: () => $a, createPolyControls: () => eo, createPolyPositionHandler: () => Xa, createResizeControls: () => hi, createTextboxDefaultControls: () => gi, dragHandler: () => Ja, factoryPolyActionHandler: () => Qa, getLocalPoint: () => en, polyActionHandler: () => Za, renderCircleControl: () => Gr, renderSquareControl: () => Kr, rotationStyleHandler: () => qr, rotationWithSnapping: () => Jr, scaleCursorStyleHandler: () => Qr, scaleOrSkewActionName: () => ui, scaleSkewCursorStyleHandler: () => di, scalingEqually: () => ei, scalingX: () => ti, scalingXOrSkewingY: () => fi, scalingY: () => ni, scalingYOrSkewingX: () => pi, skewCursorStyleHandler: () => ai, skewHandlerX: () => si, skewHandlerY: () => ci, wrapWithFireEvent: () => Rr, wrapWithFixedAnchor: () => zr });
  var lo = class e2 extends yt {
    constructor(...e3) {
      super(...e3), i(this, `_hoveredTargets`, []), i(this, `_currentTransform`, null), i(this, `_groupSelector`, null), i(this, `contextTopDirty`, false);
    }
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    get upperCanvasEl() {
      var e3;
      return (e3 = this.elements.upper) == null ? void 0 : e3.el;
    }
    get contextTop() {
      var e3;
      return (e3 = this.elements.upper) == null ? void 0 : e3.ctx;
    }
    get wrapperEl() {
      return this.elements.container;
    }
    initElements(e3) {
      this.elements = new qa(e3, { allowTouchScrolling: this.allowTouchScrolling, containerClass: this.containerClass }), this._createCacheCanvas();
    }
    _onObjectAdded(e3) {
      this._objectsToRender = void 0, super._onObjectAdded(e3);
    }
    _onObjectRemoved(e3) {
      this._objectsToRender = void 0, e3 === this._activeObject && (this.fire(`before:selection:cleared`, { deselected: [e3] }), this._discardActiveObject(), this.fire(`selection:cleared`, { deselected: [e3] }), e3.fire(`deselected`, { target: e3 })), e3 === this._hoveredTarget && (this._hoveredTarget = void 0, this._hoveredTargets = []), super._onObjectRemoved(e3);
    }
    _onStackOrderChanged() {
      this._objectsToRender = void 0, super._onStackOrderChanged();
    }
    _chooseObjectsToRender() {
      let e3 = this._activeObject;
      return !this.preserveObjectStacking && e3 ? this._objects.filter((t2) => !t2.group && t2 !== e3).concat(e3) : this._objects;
    }
    renderAll() {
      this.cancelRequestedRender(), this.destroyed || (!this.contextTopDirty || this._groupSelector || this.isDrawingMode || (this.clearContext(this.contextTop), this.contextTopDirty = false), this.hasLostContext && (this.renderTopLayer(this.contextTop), this.hasLostContext = false), !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender()), this.renderCanvas(this.getContext(), this._objectsToRender));
    }
    renderTopLayer(e3) {
      e3.save(), this.isDrawingMode && this._isCurrentlyDrawing && (this.freeDrawingBrush && this.freeDrawingBrush._render(), this.contextTopDirty = true), this.selection && this._groupSelector && (this._drawSelection(e3), this.contextTopDirty = true), e3.restore();
    }
    renderTop() {
      let e3 = this.contextTop;
      this.clearContext(e3), this.renderTopLayer(e3), this.fire(`after:render`, { ctx: e3 });
    }
    setTargetFindTolerance(e3) {
      e3 = Math.round(e3), this.targetFindTolerance = e3;
      let t2 = this.getRetinaScaling(), n2 = Math.ceil((2 * e3 + 1) * t2);
      this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = n2, this.pixelFindContext.scale(t2, t2);
    }
    isTargetTransparent(e3, t2, n2) {
      let r2 = this.targetFindTolerance, i2 = this.pixelFindContext;
      this.clearContext(i2), i2.save(), i2.translate(-t2 + r2, -n2 + r2), i2.transform(...this.viewportTransform);
      let a2 = e3.selectionBackgroundColor;
      e3.selectionBackgroundColor = ``, e3.render(i2), e3.selectionBackgroundColor = a2, i2.restore();
      let o2 = Math.round(r2 * this.getRetinaScaling());
      return yi(i2, o2, o2, o2);
    }
    _isSelectionKeyPressed(e3) {
      let t2 = this.selectionKey;
      return !!t2 && (Array.isArray(t2) ? !!t2.find((t3) => !!t3 && true === e3[t3]) : e3[t2]);
    }
    _shouldClearSelection(e3, t2) {
      let n2 = this.getActiveObjects(), r2 = this._activeObject;
      return !!(!t2 || t2 && r2 && n2.length > 1 && n2.indexOf(t2) === -1 && r2 !== t2 && !this._isSelectionKeyPressed(e3) || t2 && !t2.evented || t2 && !t2.selectable && r2 && r2 !== t2);
    }
    _shouldCenterTransform(e3, t2, n2) {
      if (!e3) return;
      let r2;
      return t2 === `scale` || t2 === `scaleX` || t2 === `scaleY` || t2 === `resizing` ? r2 = this.centeredScaling || e3.centeredScaling : t2 === `rotate` && (r2 = this.centeredRotation || e3.centeredRotation), r2 ? !n2 : n2;
    }
    _getOriginFromCorner(e3, t2) {
      let n2 = t2 ? e3.controls[t2].getTransformAnchorPoint() : { x: e3.originX, y: e3.originY };
      return t2 ? ([`ml`, `tl`, `bl`].includes(t2) ? n2.x = k : [`mr`, `tr`, `br`].includes(t2) && (n2.x = D), [`tl`, `mt`, `tr`].includes(t2) ? n2.y = O : [`bl`, `mb`, `br`].includes(t2) && (n2.y = `top`), n2) : n2;
    }
    _setupCurrentTransform(e3, t2, n2) {
      var r2;
      let i2 = t2.group ? Mt(this.getScenePoint(e3), void 0, t2.group.calcTransformMatrix()) : this.getScenePoint(e3), { key: a2 = ``, control: o2 } = t2.getActiveControl() || {}, s2 = n2 && o2 ? (r2 = o2.getActionHandler(e3, t2, o2)) == null ? void 0 : r2.bind(o2) : Ja, c2 = ((e4, t3, n3, r3) => {
        if (!t3 || !e4) return `drag`;
        let i3 = r3.controls[t3];
        return i3.getActionName(n3, i3, r3);
      })(n2, a2, e3, t2), l2 = e3[this.centeredKey], u2 = this._shouldCenterTransform(t2, c2, l2) ? { x: E, y: E } : this._getOriginFromCorner(t2, a2), { scaleX: d2, scaleY: f2, skewX: p2, skewY: m, left: h2, top: g2, angle: _2, width: v2, height: y2, cropX: b2, cropY: x2 } = t2, S2 = { target: t2, action: c2, actionHandler: s2, actionPerformed: false, corner: a2, scaleX: d2, scaleY: f2, skewX: p2, skewY: m, offsetX: i2.x - h2, offsetY: i2.y - g2, originX: u2.x, originY: u2.y, ex: i2.x, ey: i2.y, lastX: i2.x, lastY: i2.y, theta: I(_2), width: v2, height: y2, shiftKey: e3.shiftKey, altKey: l2, original: { ...kt(t2), originX: u2.x, originY: u2.y, cropX: b2, cropY: x2 } };
      this._currentTransform = S2, this.fire(`before:transform`, { e: e3, transform: S2 });
    }
    setCursor(e3) {
      this.upperCanvasEl.style.cursor = e3;
    }
    _drawSelection(e3) {
      let { x: t2, y: n2, deltaX: r2, deltaY: i2 } = this._groupSelector, a2 = new N(t2, n2).transform(this.viewportTransform), o2 = new N(t2 + r2, n2 + i2).transform(this.viewportTransform), s2 = this.selectionLineWidth / 2, c2 = Math.min(a2.x, o2.x), l2 = Math.min(a2.y, o2.y), u2 = Math.max(a2.x, o2.x), d2 = Math.max(a2.y, o2.y);
      this.selectionColor && (e3.fillStyle = this.selectionColor, e3.fillRect(c2, l2, u2 - c2, d2 - l2)), this.selectionLineWidth && this.selectionBorderColor && (e3.lineWidth = this.selectionLineWidth, e3.strokeStyle = this.selectionBorderColor, c2 += s2, l2 += s2, u2 -= s2, d2 -= s2, J.prototype._setLineDash.call(this, e3, this.selectionDashArray), e3.strokeRect(c2, l2, u2 - c2, d2 - l2));
    }
    findTarget(e3) {
      if (this._targetInfo) return this._targetInfo;
      if (this.skipTargetFind) return { subTargets: [], currentSubTargets: [] };
      let t2 = this.getScenePoint(e3), n2 = this._activeObject, r2 = this.getActiveObjects(), i2 = this.searchPossibleTargets(this._objects, t2), { subTargets: a2, container: o2, target: s2 } = i2, c2 = { ...i2, currentSubTargets: a2, currentContainer: o2, currentTarget: s2 };
      if (!n2) return c2;
      let l2 = { ...this.searchPossibleTargets([n2], t2), currentSubTargets: a2, currentContainer: o2, currentTarget: s2 };
      return n2.findControl(this.getViewportPoint(e3), St(e3)) ? { ...l2, target: n2 } : l2.target && (r2.length > 1 || !this.preserveObjectStacking || this.preserveObjectStacking && e3[this.altSelectionKey]) ? l2 : c2;
    }
    _pointIsInObjectSelectionArea(e3, t2) {
      let n2 = e3.getCoords(), r2 = this.getZoom(), i2 = e3.padding / r2;
      if (i2) {
        let [e4, t3, r3, a2] = n2, o2 = Math.atan2(t3.y - e4.y, t3.x - e4.x), s2 = Se(o2) * i2, c2 = Ce(o2) * i2, l2 = s2 + c2, u2 = s2 - c2;
        n2 = [new N(e4.x - u2, e4.y - l2), new N(t3.x + l2, t3.y - u2), new N(r3.x + u2, r3.y + l2), new N(a2.x - l2, a2.y + u2)];
      }
      return Pr.isPointInPolygon(t2, n2);
    }
    _checkTarget(e3, t2) {
      if (e3 && e3.visible && e3.evented && this._pointIsInObjectSelectionArea(e3, t2)) {
        if (!this.perPixelTargetFind && !e3.perPixelTargetFind || e3.isEditing) return true;
        {
          let n2 = t2.transform(this.viewportTransform);
          if (!this.isTargetTransparent(e3, n2.x, n2.y)) return true;
        }
      }
      return false;
    }
    _searchPossibleTargets(e3, t2, n2) {
      let r2 = e3.length;
      for (; r2--; ) {
        let i2 = e3[r2];
        if (this._checkTarget(i2, t2)) {
          if (Te(i2) && i2.subTargetCheck) {
            let { target: e4 } = this._searchPossibleTargets(i2._objects, t2, n2);
            e4 && n2.push(e4);
          }
          return { target: i2, subTargets: n2 };
        }
      }
      return { subTargets: [] };
    }
    searchPossibleTargets(e3, t2) {
      let n2 = this._searchPossibleTargets(e3, t2, []);
      n2.container = n2.target;
      let { container: r2, subTargets: i2 } = n2;
      if (r2 && Te(r2) && r2.interactive && i2[0]) {
        for (let e4 = i2.length - 1; e4 > 0; e4--) {
          let t3 = i2[e4];
          if (!Te(t3) || !t3.interactive) return n2.target = t3, n2;
        }
        return n2.target = i2[0], n2;
      }
      return n2;
    }
    getViewportPoint(e3) {
      return this._viewportPoint ? this._viewportPoint : this._getPointerImpl(e3, true);
    }
    getScenePoint(e3) {
      return this._scenePoint ? this._scenePoint : this._getPointerImpl(e3);
    }
    _getPointerImpl(e3, t2 = false) {
      let n2 = this.upperCanvasEl, r2 = n2.getBoundingClientRect(), i2 = xt(e3), a2 = r2.width || 0, o2 = r2.height || 0;
      a2 && o2 || (`top` in r2 && `bottom` in r2 && (o2 = Math.abs(r2.top - r2.bottom)), `right` in r2 && `left` in r2 && (a2 = Math.abs(r2.right - r2.left))), this.calcOffset(), i2.x -= this._offset.left, i2.y -= this._offset.top, t2 || (i2 = Mt(i2, void 0, this.viewportTransform));
      let s2 = this.getRetinaScaling();
      s2 !== 1 && (i2.x /= s2, i2.y /= s2);
      let c2 = a2 === 0 || o2 === 0 ? new N(1, 1) : new N(n2.width / a2, n2.height / o2);
      return i2.multiply(c2);
    }
    _setDimensionsImpl(e3, t2) {
      this._resetTransformEventData(), super._setDimensionsImpl(e3, t2), this._isCurrentlyDrawing && this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
    }
    _createCacheCanvas() {
      this.pixelFindCanvasEl = P(), this.pixelFindContext = this.pixelFindCanvasEl.getContext(`2d`, { willReadFrequently: true }), this.setTargetFindTolerance(this.targetFindTolerance);
    }
    getTopContext() {
      return this.elements.upper.ctx;
    }
    getSelectionContext() {
      return this.elements.upper.ctx;
    }
    getSelectionElement() {
      return this.elements.upper.el;
    }
    getActiveObject() {
      return this._activeObject;
    }
    getActiveObjects() {
      let e3 = this._activeObject;
      return at(e3) ? e3.getObjects() : e3 ? [e3] : [];
    }
    _fireSelectionEvents(e3, t2) {
      let n2 = false, r2 = false, i2 = this.getActiveObjects(), a2 = [], o2 = [];
      e3.forEach((e4) => {
        i2.includes(e4) || (n2 = true, e4.fire(`deselected`, { e: t2, target: e4 }), o2.push(e4));
      }), i2.forEach((r3) => {
        e3.includes(r3) || (n2 = true, r3.fire(`selected`, { e: t2, target: r3 }), a2.push(r3));
      }), e3.length > 0 && i2.length > 0 ? (r2 = true, n2 && this.fire(`selection:updated`, { e: t2, selected: a2, deselected: o2 })) : i2.length > 0 ? (r2 = true, this.fire(`selection:created`, { e: t2, selected: a2 })) : e3.length > 0 && (r2 = true, this.fire(`selection:cleared`, { e: t2, deselected: o2 })), r2 && (this._objectsToRender = void 0);
    }
    setActiveObject(e3, t2) {
      let n2 = this.getActiveObjects(), r2 = this._setActiveObject(e3, t2);
      return this._fireSelectionEvents(n2, t2), r2;
    }
    _setActiveObject(e3, t2) {
      let n2 = this._activeObject;
      return n2 !== e3 && !(!this._discardActiveObject(t2, e3) && this._activeObject) && !e3.onSelect({ e: t2 }) && (this._activeObject = e3, at(e3) && n2 !== e3 && e3.set(`canvas`, this), e3.setCoords(), true);
    }
    _discardActiveObject(e3, t2) {
      let n2 = this._activeObject;
      return !!n2 && !n2.onDeselect({ e: e3, object: t2 }) && (this._currentTransform && this._currentTransform.target === n2 && this.endCurrentTransform(e3), at(n2) && n2 === this._hoveredTarget && (this._hoveredTarget = void 0), this._activeObject = void 0, true);
    }
    discardActiveObject(e3) {
      let t2 = this.getActiveObjects(), n2 = this.getActiveObject();
      t2.length && this.fire(`before:selection:cleared`, { e: e3, deselected: [n2] });
      let r2 = this._discardActiveObject(e3);
      return this._fireSelectionEvents(t2, e3), r2;
    }
    endCurrentTransform(e3) {
      let t2 = this._currentTransform;
      this._finalizeCurrentTransform(e3), t2 && t2.target && (t2.target.isMoving = false), this._currentTransform = null;
    }
    _finalizeCurrentTransform(e3) {
      let t2 = this._currentTransform, n2 = t2.target, r2 = { e: e3, target: n2, transform: t2, action: t2.action };
      n2._scaling && (n2._scaling = false), n2.setCoords(), t2.actionPerformed && (this.fire(`object:modified`, r2), n2.fire(ge, r2));
    }
    setViewportTransform(e3) {
      super.setViewportTransform(e3);
      let t2 = this._activeObject;
      t2 && t2.setCoords();
    }
    destroy() {
      let e3 = this._activeObject;
      at(e3) && (e3.removeAll(), e3.dispose()), delete this._activeObject, super.destroy(), this.pixelFindContext = null, this.pixelFindCanvasEl = void 0;
    }
    clear() {
      this.discardActiveObject(), this._activeObject = void 0, this.clearContext(this.contextTop), super.clear();
    }
    drawControls(e3) {
      let t2 = this._activeObject;
      t2 && t2._renderControls(e3);
    }
    _toObject(e3, t2, n2) {
      let r2 = this._realizeGroupTransformOnObject(e3), i2 = super._toObject(e3, t2, n2);
      return e3.set(r2), i2;
    }
    _realizeGroupTransformOnObject(e3) {
      let { group: t2 } = e3;
      if (t2 && at(t2) && this._activeObject === t2) {
        let n2 = et(e3, [`angle`, `flipX`, `flipY`, D, de, fe, pe, me, `top`]);
        return Et(e3, t2.calcOwnMatrix()), n2;
      }
      return {};
    }
    _setSVGObject(e3, t2, n2) {
      let r2 = this._realizeGroupTransformOnObject(t2);
      super._setSVGObject(e3, t2, n2), t2.set(r2);
    }
  };
  i(lo, `ownDefaults`, { uniformScaling: true, uniScaleKey: `shiftKey`, centeredScaling: false, centeredRotation: false, centeredKey: `altKey`, altActionKey: `shiftKey`, selection: true, selectionKey: `shiftKey`, selectionColor: `rgba(100, 100, 255, 0.3)`, selectionDashArray: [], selectionBorderColor: `rgba(255, 255, 255, 0.3)`, selectionLineWidth: 1, selectionFullyContained: false, hoverCursor: `move`, moveCursor: `move`, defaultCursor: `default`, freeDrawingCursor: `crosshair`, notAllowedCursor: `not-allowed`, perPixelTargetFind: false, targetFindTolerance: 0, skipTargetFind: false, stopContextMenu: true, fireRightClick: true, fireMiddleClick: true, enablePointerEvents: false, containerClass: `canvas-container`, preserveObjectStacking: true });
  var uo = class {
    constructor(e2) {
      i(this, `targets`, []), i(this, `__disposer`, void 0);
      let t2 = () => {
        let { hiddenTextarea: t3 } = e2.getActiveObject() || {};
        t3 && t3.focus();
      }, n2 = e2.upperCanvasEl;
      n2.addEventListener(`click`, t2), this.__disposer = () => n2.removeEventListener(`click`, t2);
    }
    exitTextEditing() {
      this.target = void 0, this.targets.forEach((e2) => {
        e2.isEditing && e2.exitEditing();
      });
    }
    add(e2) {
      this.targets.push(e2);
    }
    remove(e2) {
      this.unregister(e2), xe(this.targets, e2);
    }
    register(e2) {
      this.target = e2;
    }
    unregister(e2) {
      e2 === this.target && (this.target = void 0);
    }
    onMouseMove(e2) {
      var t2;
      (t2 = this.target) != null && t2.isEditing && this.target.updateSelectionOnMouseMove(e2);
    }
    clear() {
      this.targets = [], this.target = void 0;
    }
    dispose() {
      this.clear(), this.__disposer(), delete this.__disposer;
    }
  };
  const X = { passive: false }, fo = (e2, t2) => ({ viewportPoint: e2.getViewportPoint(t2), scenePoint: e2.getScenePoint(t2) }), po = (e2, ...t2) => e2.addEventListener(...t2), Z = (e2, ...t2) => e2.removeEventListener(...t2), mo = { mouse: { in: `over`, out: `out`, targetIn: `mouseover`, targetOut: `mouseout`, canvasIn: `mouse:over`, canvasOut: `mouse:out` }, drag: { in: `enter`, out: `leave`, targetIn: `dragenter`, targetOut: `dragleave`, canvasIn: `drag:enter`, canvasOut: `drag:leave` } };
  var ho = class extends lo {
    constructor(e2, t2 = {}) {
      super(e2, t2), i(this, `_isClick`, void 0), i(this, `textEditingManager`, new uo(this)), [`_onMouseDown`, `_onTouchStart`, `_onMouseMove`, `_onMouseUp`, `_onTouchEnd`, `_onResize`, `_onMouseWheel`, `_onMouseOut`, `_onMouseEnter`, `_onContextMenu`, `_onClick`, `_onDragStart`, `_onDragEnd`, `_onDragProgress`, `_onDragOver`, `_onDragEnter`, `_onDragLeave`, `_onDrop`].forEach((e3) => {
        this[e3] = this[e3].bind(this);
      }), this.addOrRemove(po);
    }
    _getEventPrefix() {
      return this.enablePointerEvents ? `pointer` : `mouse`;
    }
    addOrRemove(e2, t2 = false) {
      let n2 = this.upperCanvasEl, r2 = this._getEventPrefix();
      e2(st(n2), `resize`, this._onResize), e2(n2, r2 + `down`, this._onMouseDown), e2(n2, `${r2}move`, this._onMouseMove, X), e2(n2, `${r2}out`, this._onMouseOut), e2(n2, `${r2}enter`, this._onMouseEnter), e2(n2, `wheel`, this._onMouseWheel, { passive: false }), e2(n2, `contextmenu`, this._onContextMenu), t2 || (e2(n2, `click`, this._onClick), e2(n2, `dblclick`, this._onClick)), e2(n2, `dragstart`, this._onDragStart), e2(n2, `dragend`, this._onDragEnd), e2(n2, `dragover`, this._onDragOver), e2(n2, `dragenter`, this._onDragEnter), e2(n2, `dragleave`, this._onDragLeave), e2(n2, `drop`, this._onDrop), this.enablePointerEvents || e2(n2, `touchstart`, this._onTouchStart, X);
    }
    removeListeners() {
      this.addOrRemove(Z);
      let e2 = this._getEventPrefix(), t2 = H(this.upperCanvasEl);
      Z(t2, `${e2}up`, this._onMouseUp), Z(t2, `touchend`, this._onTouchEnd, X), Z(t2, `${e2}move`, this._onMouseMove, X), Z(t2, `touchmove`, this._onMouseMove, X), clearTimeout(this._willAddMouseDown);
    }
    _onMouseWheel(e2) {
      this._cacheTransformEventData(e2), this._handleEvent(e2, `wheel`), this._resetTransformEventData();
    }
    _onMouseOut(e2) {
      let t2 = this._hoveredTarget, n2 = { e: e2, ...fo(this, e2) };
      this.fire(`mouse:out`, { ...n2, target: t2 }), this._hoveredTarget = void 0, t2 && t2.fire(`mouseout`, { ...n2 }), this._hoveredTargets.forEach((e3) => {
        this.fire(`mouse:out`, { ...n2, target: e3 }), e3 && e3.fire(`mouseout`, { ...n2 });
      }), this._hoveredTargets = [];
    }
    _onMouseEnter(e2) {
      let { target: t2 } = this.findTarget(e2);
      this._currentTransform || t2 || (this.fire(`mouse:over`, { e: e2, ...fo(this, e2) }), this._hoveredTarget = void 0, this._hoveredTargets = []);
    }
    _onDragStart(e2) {
      this._isClick = false;
      let t2 = this.getActiveObject();
      if (t2 && t2.onDragStart(e2)) {
        this._dragSource = t2;
        let n2 = { e: e2, target: t2 };
        this.fire(`dragstart`, n2), t2.fire(`dragstart`, n2), po(this.upperCanvasEl, `drag`, this._onDragProgress);
        return;
      }
      Ct(e2);
    }
    _renderDragEffects(e2, t2, n2) {
      let r2 = false, i2 = this._dropTarget;
      i2 && i2 !== t2 && i2 !== n2 && (i2.clearContextTop(), r2 = true), t2 == null || t2.clearContextTop(), n2 !== t2 && (n2 == null || n2.clearContextTop());
      let a2 = this.contextTop;
      a2.save(), a2.transform(...this.viewportTransform), t2 && (a2.save(), t2.transform(a2), t2.renderDragSourceEffect(e2), a2.restore(), r2 = true), n2 && (a2.save(), n2.transform(a2), n2.renderDropTargetEffect(e2), a2.restore(), r2 = true), a2.restore(), r2 && (this.contextTopDirty = true);
    }
    _onDragEnd(e2) {
      let { currentSubTargets: t2 } = this.findTarget(e2), n2 = !!e2.dataTransfer && e2.dataTransfer.dropEffect !== `none`, r2 = n2 ? this._activeObject : void 0, i2 = { e: e2, target: this._dragSource, subTargets: t2, dragSource: this._dragSource, didDrop: n2, dropTarget: r2 };
      Z(this.upperCanvasEl, `drag`, this._onDragProgress), this.fire(`dragend`, i2), this._dragSource && this._dragSource.fire(`dragend`, i2), delete this._dragSource, this._onMouseUp(e2);
    }
    _onDragProgress(e2) {
      let t2 = { e: e2, target: this._dragSource, dragSource: this._dragSource, dropTarget: this._draggedoverTarget };
      this.fire(`drag`, t2), this._dragSource && this._dragSource.fire(`drag`, t2);
    }
    _onDragOver(e2) {
      let t2 = `dragover`, { currentContainer: n2, currentSubTargets: r2 } = this.findTarget(e2), i2 = this._dragSource, a2 = { e: e2, target: n2, subTargets: r2, dragSource: i2, canDrop: false, dropTarget: void 0 }, o2;
      this.fire(t2, a2), this._fireEnterLeaveEvents(e2, n2, a2), n2 && (n2.canDrop(e2) && (o2 = n2), n2.fire(t2, a2));
      for (let n3 = 0; n3 < r2.length; n3++) {
        let i3 = r2[n3];
        i3.canDrop(e2) && (o2 = i3), i3.fire(t2, a2);
      }
      this._renderDragEffects(e2, i2, o2), this._dropTarget = o2;
    }
    _onDragEnter(e2) {
      let { currentContainer: t2, currentSubTargets: n2 } = this.findTarget(e2), r2 = { e: e2, target: t2, subTargets: n2, dragSource: this._dragSource };
      this.fire(`dragenter`, r2), this._fireEnterLeaveEvents(e2, t2, r2);
    }
    _onDragLeave(e2) {
      let { currentSubTargets: t2 } = this.findTarget(e2), n2 = { e: e2, target: this._draggedoverTarget, subTargets: t2, dragSource: this._dragSource };
      this.fire(`dragleave`, n2), this._fireEnterLeaveEvents(e2, void 0, n2), this._renderDragEffects(e2, this._dragSource), this._dropTarget = void 0, this._hoveredTargets = [];
    }
    _onDrop(e2) {
      let { currentContainer: t2, currentSubTargets: n2 } = this.findTarget(e2), r2 = this._basicEventHandler(`drop:before`, { e: e2, target: t2, subTargets: n2, dragSource: this._dragSource, ...fo(this, e2) });
      r2.didDrop = false, r2.dropTarget = void 0, this._basicEventHandler(`drop`, r2), this.fire(`drop:after`, r2);
    }
    _onContextMenu(e2) {
      let { target: t2, subTargets: n2 } = this.findTarget(e2), r2 = this._basicEventHandler(`contextmenu:before`, { e: e2, target: t2, subTargets: n2 });
      return this.stopContextMenu && Ct(e2), this._basicEventHandler(`contextmenu`, r2), false;
    }
    _onClick(e2) {
      let t2 = e2.detail;
      t2 > 3 || t2 < 2 || (this._cacheTransformEventData(e2), t2 == 2 && e2.type === `dblclick` && this._handleEvent(e2, `dblclick`), t2 == 3 && this._handleEvent(e2, `tripleclick`), this._resetTransformEventData());
    }
    fireEventFromPointerEvent(e2, t2, n2, r2 = {}) {
      this._cacheTransformEventData(e2);
      let { target: i2, subTargets: a2 } = this.findTarget(e2), o2 = { e: e2, target: i2, subTargets: a2, ...fo(this, e2), transform: this._currentTransform, ...r2 };
      this.fire(t2, o2), i2 && i2.fire(n2, o2);
      for (let e3 = 0; e3 < a2.length; e3++) a2[e3] !== i2 && a2[e3].fire(n2, o2);
      this._resetTransformEventData();
    }
    getPointerId(e2) {
      let t2 = e2.changedTouches;
      return t2 ? t2[0] && t2[0].identifier : this.enablePointerEvents ? e2.pointerId : -1;
    }
    _isMainEvent(e2) {
      return true === e2.isPrimary || false !== e2.isPrimary && (e2.type === `touchend` && e2.touches.length === 0 || !e2.changedTouches || e2.changedTouches[0].identifier === this.mainTouchId);
    }
    _onTouchStart(e2) {
      this._cacheTransformEventData(e2);
      let t2 = !this.allowTouchScrolling, n2 = this._activeObject;
      this.mainTouchId === void 0 && (this.mainTouchId = this.getPointerId(e2)), this.__onMouseDown(e2);
      let { target: r2 } = this.findTarget(e2);
      (this.isDrawingMode || n2 && r2 === n2) && (t2 = true), t2 && e2.preventDefault();
      let i2 = this.upperCanvasEl, a2 = this._getEventPrefix(), o2 = H(i2);
      po(o2, `touchend`, this._onTouchEnd, X), t2 && po(o2, `touchmove`, this._onMouseMove, X), Z(i2, `${a2}down`, this._onMouseDown), this._resetTransformEventData();
    }
    _onMouseDown(e2) {
      this._cacheTransformEventData(e2), this.__onMouseDown(e2);
      let t2 = this.upperCanvasEl, n2 = this._getEventPrefix();
      Z(t2, `${n2}move`, this._onMouseMove, X);
      let r2 = H(t2);
      po(r2, `${n2}up`, this._onMouseUp), po(r2, `${n2}move`, this._onMouseMove, X), this._resetTransformEventData();
    }
    _onTouchEnd(e2) {
      if (e2.touches.length > 0) return;
      this._cacheTransformEventData(e2), this.__onMouseUp(e2), this._resetTransformEventData(), delete this.mainTouchId;
      let t2 = this._getEventPrefix(), n2 = H(this.upperCanvasEl);
      Z(n2, `touchend`, this._onTouchEnd, X), Z(n2, `touchmove`, this._onMouseMove, X), this._willAddMouseDown && clearTimeout(this._willAddMouseDown), this._willAddMouseDown = setTimeout(() => {
        po(this.upperCanvasEl, `${t2}down`, this._onMouseDown), this._willAddMouseDown = 0;
      }, 400);
    }
    _onMouseUp(e2) {
      this._cacheTransformEventData(e2), this.__onMouseUp(e2);
      let t2 = this.upperCanvasEl, n2 = this._getEventPrefix();
      if (this._isMainEvent(e2)) {
        let e3 = H(this.upperCanvasEl);
        Z(e3, `${n2}up`, this._onMouseUp), Z(e3, `${n2}move`, this._onMouseMove, X), po(t2, `${n2}move`, this._onMouseMove, X);
      }
      this._resetTransformEventData();
    }
    _onMouseMove(e2) {
      this._cacheTransformEventData(e2);
      let t2 = this.getActiveObject();
      !this.allowTouchScrolling && (!t2 || !t2.shouldStartDragging(e2)) && e2.preventDefault && e2.preventDefault(), this.__onMouseMove(e2), this._resetTransformEventData();
    }
    _onResize() {
      this.calcOffset(), this._resetTransformEventData();
    }
    _shouldRender(e2) {
      let t2 = this.getActiveObject();
      return !!t2 != !!e2 || t2 && e2 && t2 !== e2;
    }
    __onMouseUp(e2) {
      var t2;
      this._handleEvent(e2, `up:before`);
      let n2 = this._currentTransform, r2 = this._isClick, { target: i2 } = this.findTarget(e2), { button: a2 } = e2;
      if (a2) return void ((this.fireMiddleClick && a2 === 1 || this.fireRightClick && a2 === 2) && this._handleEvent(e2, `up`));
      if (this.isDrawingMode && this._isCurrentlyDrawing) return void this._onMouseUpInDrawingMode(e2);
      if (!this._isMainEvent(e2)) return;
      let o2, s2, c2 = false;
      if (n2 && (this._finalizeCurrentTransform(e2), c2 = n2.actionPerformed), !r2) {
        let t3 = i2 === this._activeObject;
        this.handleSelection(e2), c2 || (c2 = this._shouldRender(i2) || !t3 && i2 === this._activeObject);
      }
      if (i2) {
        let { key: t3, control: r3 } = i2.findControl(this.getViewportPoint(e2), St(e2)) || {};
        if (s2 = t3, i2.selectable && i2 !== this._activeObject && i2.activeOn === `up`) this.setActiveObject(i2, e2), c2 = true;
        else if (r3) {
          let t4 = r3.getMouseUpHandler(e2, i2, r3);
          t4 && (o2 = this.getScenePoint(e2), t4.call(r3, e2, n2, o2.x, o2.y));
        }
        i2.isMoving = false;
      }
      if (n2 && (n2.target !== i2 || n2.corner !== s2)) {
        let t3 = n2.target && n2.target.controls[n2.corner], r3 = t3 && t3.getMouseUpHandler(e2, n2.target, t3);
        o2 = o2 || this.getScenePoint(e2), r3 && r3.call(t3, e2, n2, o2.x, o2.y);
      }
      this._setCursorFromEvent(e2, i2), this._handleEvent(e2, `up`), this._groupSelector = null, this._currentTransform = null, i2 && (i2.__corner = void 0), c2 ? this.requestRenderAll() : r2 || (t2 = this._activeObject) != null && t2.isEditing || this.renderTop();
    }
    _basicEventHandler(e2, t2) {
      let { target: n2, subTargets: r2 = [] } = t2;
      this.fire(e2, t2), n2 && n2.fire(e2, t2);
      for (let i2 = 0; i2 < r2.length; i2++) r2[i2] !== n2 && r2[i2].fire(e2, t2);
      return t2;
    }
    _handleEvent(e2, t2, n2) {
      let { target: r2, subTargets: i2 } = this.findTarget(e2), a2 = { e: e2, target: r2, subTargets: i2, ...fo(this, e2), transform: this._currentTransform, ...t2 === `down:before` || t2 === `down` ? n2 : {} };
      t2 !== `up:before` && t2 !== `up` || (a2.isClick = this._isClick), this.fire(`mouse:${t2}`, a2), r2 && r2.fire(`mouse${t2}`, a2);
      for (let e3 = 0; e3 < i2.length; e3++) i2[e3] !== r2 && i2[e3].fire(`mouse${t2}`, a2);
    }
    _onMouseDownInDrawingMode(e2) {
      this._isCurrentlyDrawing = true, this.getActiveObject() && (this.discardActiveObject(e2), this.requestRenderAll());
      let t2 = this.getScenePoint(e2);
      this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(t2, { e: e2, pointer: t2 }), this._handleEvent(e2, `down`, { alreadySelected: false });
    }
    _onMouseMoveInDrawingMode(e2) {
      if (this._isCurrentlyDrawing) {
        let t2 = this.getScenePoint(e2);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(t2, { e: e2, pointer: t2 });
      }
      this.setCursor(this.freeDrawingCursor), this._handleEvent(e2, `move`);
    }
    _onMouseUpInDrawingMode(e2) {
      let t2 = this.getScenePoint(e2);
      this.freeDrawingBrush ? this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({ e: e2, pointer: t2 }) : this._isCurrentlyDrawing = false, this._handleEvent(e2, `up`);
    }
    __onMouseDown(e2) {
      this._isClick = true, this._handleEvent(e2, `down:before`);
      let { target: t2 } = this.findTarget(e2), n2 = !!t2 && t2 === this._activeObject, { button: r2 } = e2;
      if (r2) return void ((this.fireMiddleClick && r2 === 1 || this.fireRightClick && r2 === 2) && this._handleEvent(e2, `down`, { alreadySelected: n2 }));
      if (this.isDrawingMode) return void this._onMouseDownInDrawingMode(e2);
      if (!this._isMainEvent(e2) || this._currentTransform) return;
      let i2 = this._shouldRender(t2), a2 = false;
      if (this.handleMultiSelection(e2, t2) ? (t2 = this._activeObject, a2 = true, i2 = true) : this._shouldClearSelection(e2, t2) && this.discardActiveObject(e2), this.selection && (!t2 || !t2.selectable && !t2.isEditing && t2 !== this._activeObject)) {
        let t3 = this.getScenePoint(e2);
        this._groupSelector = { x: t3.x, y: t3.y, deltaY: 0, deltaX: 0 };
      }
      if (n2 = !!t2 && t2 === this._activeObject, t2) {
        t2.selectable && t2.activeOn === `down` && this.setActiveObject(t2, e2);
        let r3 = t2.findControl(this.getViewportPoint(e2), St(e2));
        if (t2 === this._activeObject && (r3 || !a2)) {
          this._setupCurrentTransform(e2, t2, n2);
          let i3 = r3 ? r3.control : void 0, a3 = this.getScenePoint(e2), o2 = i3 && i3.getMouseDownHandler(e2, t2, i3);
          o2 && o2.call(i3, e2, this._currentTransform, a3.x, a3.y);
        }
      }
      i2 && (this._objectsToRender = void 0), this._handleEvent(e2, `down`, { alreadySelected: n2 }), i2 && this.requestRenderAll();
    }
    _resetTransformEventData() {
      this._targetInfo = this._viewportPoint = this._scenePoint = void 0;
    }
    _cacheTransformEventData(e2) {
      this._resetTransformEventData(), this._viewportPoint = this.getViewportPoint(e2), this._scenePoint = Mt(this._viewportPoint, void 0, this.viewportTransform), this._targetInfo = this.findTarget(e2), this._currentTransform && (this._targetInfo.target = this._currentTransform.target);
    }
    __onMouseMove(e2) {
      if (this._isClick = false, this._handleEvent(e2, `move:before`), this.isDrawingMode) return void this._onMouseMoveInDrawingMode(e2);
      if (!this._isMainEvent(e2)) return;
      let t2 = this._groupSelector;
      if (t2) {
        let n2 = this.getScenePoint(e2);
        t2.deltaX = n2.x - t2.x, t2.deltaY = n2.y - t2.y, this.renderTop();
      } else if (this._currentTransform) this._transformObject(e2);
      else {
        let { target: t3 } = this.findTarget(e2);
        this._setCursorFromEvent(e2, t3), this._fireOverOutEvents(e2, t3);
      }
      this.textEditingManager.onMouseMove(e2), this._handleEvent(e2, `move`);
    }
    _fireOverOutEvents(e2, t2) {
      let { _hoveredTarget: n2, _hoveredTargets: r2 } = this, { subTargets: i2, currentTarget: a2 } = this.findTarget(e2), o2 = Math.max(r2.length, i2.length);
      this.fireSyntheticInOutEvents(`mouse`, { e: e2, target: t2, oldTarget: n2, actualTarget: a2, oldActualTarget: this._hoveredActualTarget, fireCanvas: true });
      for (let a3 = 0; a3 < o2; a3++) i2[a3] === t2 || r2[a3] && r2[a3] === n2 || this.fireSyntheticInOutEvents(`mouse`, { e: e2, target: i2[a3], oldTarget: r2[a3] });
      this._hoveredActualTarget = a2, this._hoveredTarget = t2, this._hoveredTargets = i2;
    }
    _fireEnterLeaveEvents(e2, t2, n2) {
      let r2 = this._draggedoverTarget, i2 = this._hoveredTargets, { subTargets: a2 } = this.findTarget(e2), o2 = Math.max(i2.length, a2.length);
      this.fireSyntheticInOutEvents(`drag`, { ...n2, target: t2, oldTarget: r2, fireCanvas: true });
      for (let e3 = 0; e3 < o2; e3++) this.fireSyntheticInOutEvents(`drag`, { ...n2, target: a2[e3], oldTarget: i2[e3] });
      this._draggedoverTarget = t2;
    }
    fireSyntheticInOutEvents(e2, { target: t2, oldTarget: n2, actualTarget: r2, oldActualTarget: i2, fireCanvas: a2, e: o2, ...s2 }) {
      let { targetIn: c2, targetOut: l2, canvasIn: u2, canvasOut: d2 } = mo[e2], f2 = n2 !== t2, p2 = i2 !== r2, m = t2 && f2, h2 = r2 && p2, g2 = n2 && f2, _2 = i2 && p2, v2 = { ...s2, e: o2, ...fo(this, o2) }, y2 = { ...v2, target: n2, nextTarget: t2, actualTarget: i2, nextActualTarget: r2 };
      (g2 || _2) && a2 && this.fire(d2, y2), g2 && n2.fire(l2, y2), _2 && n2 !== i2 && i2.fire(l2, y2);
      let b2 = { ...v2, target: t2, previousTarget: n2, actualTarget: r2, previousActualTarget: i2 };
      (m || h2) && a2 && this.fire(u2, b2), m && t2.fire(c2, b2), h2 && r2 !== t2 && r2.fire(c2, b2);
    }
    _transformObject(e2) {
      let t2 = this.getScenePoint(e2), n2 = this._currentTransform, r2 = n2.target, i2 = r2.group ? Mt(t2, void 0, r2.group.calcTransformMatrix()) : t2;
      n2.shiftKey = e2.shiftKey, n2.altKey = !!this.centeredKey && e2[this.centeredKey], this._performTransformAction(e2, n2, i2), n2.actionPerformed && this.requestRenderAll();
    }
    _performTransformAction(e2, t2, n2) {
      let { action: r2, actionHandler: i2, target: a2 } = t2, o2 = !!i2 && i2(e2, t2, n2.x, n2.y);
      o2 && a2.setCoords(), r2 === `drag` && o2 && (t2.target.isMoving = true, this.setCursor(t2.target.moveCursor || this.moveCursor)), t2.actionPerformed = t2.actionPerformed || o2;
    }
    _setCursorFromEvent(e2, t2) {
      if (!t2) return void this.setCursor(this.defaultCursor);
      let n2 = t2.hoverCursor || this.hoverCursor, r2 = at(this._activeObject) ? this._activeObject : null, i2 = (!r2 || t2.group !== r2) && t2.findControl(this.getViewportPoint(e2));
      if (i2) {
        let { control: n3, coord: r3 } = i2;
        this.setCursor(n3.cursorStyleHandler(e2, n3, t2, r3));
      } else {
        if (t2.subTargetCheck) {
          let { subTargets: t3 } = this.findTarget(e2);
          t3.concat().reverse().forEach((e3) => {
            n2 = e3.hoverCursor || n2;
          });
        }
        this.setCursor(n2);
      }
    }
    handleMultiSelection(e2, t2) {
      let n2 = this._activeObject, r2 = at(n2);
      if (n2 && this._isSelectionKeyPressed(e2) && this.selection && t2 && t2.selectable && (n2 !== t2 || r2) && (r2 || !t2.isDescendantOf(n2) && !n2.isDescendantOf(t2)) && !t2.onSelect({ e: e2 }) && !n2.getActiveControl()) {
        if (r2) {
          let r3 = n2.getObjects(), i2 = [];
          if (t2 === n2) {
            let n3 = this.getScenePoint(e2), a2 = this.searchPossibleTargets(r3, n3);
            if (a2.target ? (t2 = a2.target, i2 = a2.subTargets) : (a2 = this.searchPossibleTargets(this._objects, n3), t2 = a2.target, i2 = a2.subTargets), !t2 || !t2.selectable) return false;
          }
          t2.group === n2 ? (n2.remove(t2), this._hoveredTarget = t2, this._hoveredTargets = i2, n2.size() === 1 && this._setActiveObject(n2.item(0), e2)) : (n2.multiSelectAdd(t2), this._hoveredTarget = n2, this._hoveredTargets = i2), this._fireSelectionEvents(r3, e2);
        } else {
          n2.isEditing && n2.exitEditing();
          let r3 = new (M.getClass(`ActiveSelection`))([], { canvas: this });
          r3.multiSelectAdd(n2, t2), this._hoveredTarget = r3, this._setActiveObject(r3, e2), this._fireSelectionEvents([n2], e2);
        }
        return true;
      }
      return false;
    }
    handleSelection(e2) {
      if (!this.selection || !this._groupSelector) return false;
      let { x: t2, y: n2, deltaX: r2, deltaY: i2 } = this._groupSelector, a2 = new N(t2, n2), o2 = a2.add(new N(r2, i2)), s2 = a2.min(o2), c2 = a2.max(o2).subtract(s2), l2 = this.collectObjects({ left: s2.x, top: s2.y, width: c2.x, height: c2.y }, { includeIntersecting: !this.selectionFullyContained }), u2 = a2.eq(o2) ? l2[0] ? [l2[0]] : [] : l2.length > 1 ? l2.filter((t3) => !t3.onSelect({ e: e2 })).reverse() : l2;
      if (u2.length === 1) this.setActiveObject(u2[0], e2);
      else if (u2.length > 1) {
        let t3 = M.getClass(`ActiveSelection`);
        this.setActiveObject(new t3(u2, { canvas: this }), e2);
      }
      return this._groupSelector = null, true;
    }
    toCanvasElement(e2 = 1, t2) {
      let { upper: n2 } = this.elements;
      n2.ctx = void 0;
      let r2 = super.toCanvasElement(e2, t2);
      return n2.ctx = n2.el.getContext(`2d`), r2;
    }
    clear() {
      this.textEditingManager.clear(), super.clear();
    }
    destroy() {
      this.removeListeners(), this.textEditingManager.dispose(), super.destroy();
    }
  };
  const go = { x1: 0, y1: 0, x2: 0, y2: 0 }, _o = { ...go, r1: 0, r2: 0 }, vo = (e2, t2) => isNaN(e2) && typeof t2 == `number` ? t2 : e2;
  function yo(e2) {
    return e2 && /%$/.test(e2) && Number.isFinite(parseFloat(e2));
  }
  function bo(e2, t2) {
    return Vn(0, vo(typeof e2 == `number` ? e2 : typeof e2 == `string` ? parseFloat(e2) / (yo(e2) ? 100 : 1) : NaN, t2), 1);
  }
  const xo = /\s*;\s*/, So = /\s*:\s*/;
  function Co(e2, t2) {
    let n2, r2, i2 = e2.getAttribute(`style`);
    if (i2) {
      let e3 = i2.split(xo);
      e3[e3.length - 1] === `` && e3.pop();
      for (let t3 = e3.length; t3--; ) {
        let [i3, a3] = e3[t3].split(So).map((e4) => e4.trim());
        i3 === `stop-color` ? n2 = a3 : i3 === `stop-opacity` && (r2 = a3);
      }
    }
    n2 = n2 || e2.getAttribute(`stop-color`) || `rgb(0,0,0)`, r2 = vo(parseFloat(r2 || e2.getAttribute(`stop-opacity`) || ``), 1);
    let a2 = new G(n2);
    return a2.setAlpha(a2.getAlpha() * r2 * t2), { offset: bo(e2.getAttribute(`offset`), 0), color: a2.toRgba() };
  }
  function wo(e2, t2) {
    let n2 = [], r2 = e2.getElementsByTagName(`stop`), i2 = bo(t2, 1);
    for (let e3 = r2.length; e3--; ) n2.push(Co(r2[e3], i2));
    return n2;
  }
  function To(e2) {
    return e2.nodeName === `linearGradient` || e2.nodeName === `LINEARGRADIENT` ? `linear` : `radial`;
  }
  function Eo(e2) {
    return e2.getAttribute(`gradientUnits`) === `userSpaceOnUse` ? `pixels` : `percentage`;
  }
  function Do(e2, t2) {
    return e2.getAttribute(t2);
  }
  function Oo(e2, t2) {
    return (function(e3, { width: t3, height: n2, gradientUnits: r2 }) {
      let i2;
      return Object.entries(e3).reduce((e4, [a2, o2]) => {
        if (o2 === `Infinity`) i2 = 1;
        else if (o2 === `-Infinity`) i2 = 0;
        else {
          let e5 = typeof o2 == `string`;
          i2 = e5 ? parseFloat(o2) : o2, e5 && yo(o2) && (i2 *= 0.01, r2 === `pixels` && (a2 !== `x1` && a2 !== `x2` && a2 !== `r2` || (i2 *= t3), a2 !== `y1` && a2 !== `y2` || (i2 *= n2)));
        }
        return e4[a2] = i2, e4;
      }, {});
    })(To(e2) === `linear` ? (function(e3) {
      return { x1: Do(e3, `x1`) || 0, y1: Do(e3, `y1`) || 0, x2: Do(e3, `x2`) || `100%`, y2: Do(e3, `y2`) || 0 };
    })(e2) : (function(e3) {
      return { x1: Do(e3, `fx`) || Do(e3, `cx`) || `50%`, y1: Do(e3, `fy`) || Do(e3, `cy`) || `50%`, r1: 0, x2: Do(e3, `cx`) || `50%`, y2: Do(e3, `cy`) || `50%`, r2: Do(e3, `r`) || `50%` };
    })(e2), { ...t2, gradientUnits: Eo(e2) });
  }
  var ko = class {
    constructor(e2) {
      let { type: t2 = `linear`, gradientUnits: n2 = `pixels`, coords: r2 = {}, colorStops: i2 = [], offsetX: a2 = 0, offsetY: o2 = 0, gradientTransform: s2, id: c2 } = e2 || {};
      Object.assign(this, { type: t2, gradientUnits: n2, coords: { ...t2 === `radial` ? _o : go, ...r2 }, colorStops: i2, offsetX: a2, offsetY: o2, gradientTransform: s2, id: c2 ? `${c2}_${je()}` : je() });
    }
    addColorStop(e2) {
      for (let t2 in e2) this.colorStops.push({ offset: parseFloat(t2), color: e2[t2] });
      return this;
    }
    toObject(e2) {
      return { ...et(this, e2), type: this.type, coords: { ...this.coords }, colorStops: this.colorStops.map((e3) => ({ ...e3 })), offsetX: this.offsetX, offsetY: this.offsetY, gradientUnits: this.gradientUnits, gradientTransform: this.gradientTransform ? [...this.gradientTransform] : void 0 };
    }
    toSVG(e2, { additionalTransform: t2 } = {}) {
      let n2 = [], r2 = this.gradientTransform ? this.gradientTransform.concat() : T.concat(), i2 = this.gradientUnits === `pixels` ? `userSpaceOnUse` : `objectBoundingBox`, a2 = this.colorStops.map((e3) => ({ ...e3 })).sort((e3, t3) => e3.offset - t3.offset), o2 = -this.offsetX, s2 = -this.offsetY;
      var c2;
      i2 === `objectBoundingBox` ? (o2 /= e2.width, s2 /= e2.height) : (o2 += e2.width / 2, s2 += e2.height / 2), (c2 = e2) && typeof c2._renderPathCommands == `function` && this.gradientUnits !== `percentage` && (o2 -= e2.pathOffset.x, s2 -= e2.pathOffset.y), r2[4] -= o2, r2[5] -= s2;
      let l2 = [`id="SVGID_${U(String(this.id))}"`, `gradientUnits="${i2}"`, `gradientTransform="${t2 ? t2 + ` ` : ``}${nt(r2)}"`, ``].join(` `), u2 = (e3) => parseFloat(String(e3));
      if (this.type === `linear`) {
        let { x1: e3, y1: t3, x2: r3, y2: i3 } = this.coords, a3 = u2(e3), o3 = u2(t3), s3 = u2(r3), c3 = u2(i3);
        n2.push(`<linearGradient `, l2, ` x1="`, a3, `" y1="`, o3, `" x2="`, s3, `" y2="`, c3, `">
`);
      } else if (this.type === `radial`) {
        let { x1: e3, y1: t3, x2: r3, y2: i3, r1: o3, r2: s3 } = this.coords, c3 = u2(e3), d2 = u2(t3), f2 = u2(r3), p2 = u2(i3), m = u2(o3), h2 = u2(s3), g2 = m > h2;
        n2.push(`<radialGradient `, l2, ` cx="`, g2 ? c3 : f2, `" cy="`, g2 ? d2 : p2, `" r="`, g2 ? m : h2, `" fx="`, g2 ? f2 : c3, `" fy="`, g2 ? p2 : d2, `">
`), g2 && (a2.reverse(), a2.forEach((e4) => {
          e4.offset = 1 - e4.offset;
        }));
        let _2 = Math.min(m, h2);
        if (_2 > 0) {
          let e4 = _2 / Math.max(m, h2);
          a2.forEach((t4) => {
            t4.offset += e4 * (1 - t4.offset);
          });
        }
      }
      return a2.forEach(({ color: e3, offset: t3 }) => {
        let r3 = String(e3), i3 = nn(r3) ? r3 : new G(r3).toRgba();
        n2.push(`<stop offset="${100 * t3}%" style="stop-color:${U(i3)};"/>
`);
      }), n2.push(this.type === `linear` ? `</linearGradient>` : `</radialGradient>`, `
`), n2.join(``);
    }
    toLive(e2) {
      let { x1: t2, y1: n2, x2: r2, y2: i2, r1: a2, r2: o2 } = this.coords, s2 = this.type === `linear` ? e2.createLinearGradient(t2, n2, r2, i2) : e2.createRadialGradient(t2, n2, a2, r2, i2, o2);
      return this.colorStops.forEach(({ color: e3, offset: t3 }) => {
        s2.addColorStop(t3, e3);
      }), s2;
    }
    static async fromObject(e2) {
      let { colorStops: t2, gradientTransform: n2 } = e2;
      return new this({ ...e2, colorStops: t2 ? t2.map((e3) => ({ ...e3 })) : void 0, gradientTransform: n2 ? [...n2] : void 0 });
    }
    static fromElement(e2, t2, n2) {
      let r2 = Eo(e2), i2 = t2._findCenterFromElement();
      return new this({ id: e2.getAttribute(`id`) || void 0, type: To(e2), coords: Oo(e2, { width: n2.viewBoxWidth || n2.width, height: n2.viewBoxHeight || n2.height }), colorStops: wo(e2, n2.opacity), gradientUnits: r2, gradientTransform: Ki(e2.getAttribute(`gradientTransform`) || ``), ...r2 === `pixels` ? { offsetX: t2.width / 2 - i2.x, offsetY: t2.height / 2 - i2.y } : { offsetX: 0, offsetY: 0 } });
    }
  };
  i(ko, `type`, `Gradient`), M.setClass(ko, `gradient`), M.setClass(ko, `linear`), M.setClass(ko, `radial`);
  var Ao = class {
    get type() {
      return `pattern`;
    }
    set type(e2) {
      s(`warn`, `Setting type has no effect`, e2);
    }
    constructor(e2) {
      i(this, `repeat`, `repeat`), i(this, `offsetX`, 0), i(this, `offsetY`, 0), i(this, `crossOrigin`, ``), this.id = je(), Object.assign(this, e2);
    }
    isImageSource() {
      return !!this.source && typeof this.source.src == `string`;
    }
    isCanvasSource() {
      return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
      return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : ``;
    }
    toLive(e2) {
      return this.source && (!this.isImageSource() || this.source.complete && this.source.naturalWidth !== 0 && this.source.naturalHeight !== 0) ? e2.createPattern(this.source, this.repeat) : null;
    }
    toObject(e2 = []) {
      let { repeat: t2, crossOrigin: n2 } = this;
      return { ...et(this, e2), type: `pattern`, source: this.sourceToString(), repeat: t2, crossOrigin: n2, offsetX: B(this.offsetX, o.NUM_FRACTION_DIGITS), offsetY: B(this.offsetY, o.NUM_FRACTION_DIGITS), patternTransform: this.patternTransform ? [...this.patternTransform] : null };
    }
    toSVG({ width: e2, height: t2 }) {
      let { source: n2, repeat: r2, id: i2 } = this, a2 = vo(this.offsetX / e2, 0), o2 = vo(this.offsetY / t2, 0), s2 = r2 === `repeat-y` || r2 === `no-repeat` ? 1 + Math.abs(a2 || 0) : vo(n2.width / e2, 0), c2 = r2 === `repeat-x` || r2 === `no-repeat` ? 1 + Math.abs(o2 || 0) : vo(n2.height / t2, 0);
      return [`<pattern id="SVGID_${U(i2)}" x="${a2}" y="${o2}" width="${s2}" height="${c2}">`, `<image x="0" y="0" width="${n2.width}" height="${n2.height}" xlink:href="${U(this.sourceToString())}"></image>`, `</pattern>`, ``].join(`
`);
    }
    static async fromObject({ type: e2, source: t2, patternTransform: n2, ...r2 }, i2) {
      let a2 = await Ze(t2, { ...i2, crossOrigin: r2.crossOrigin });
      return new this({ ...r2, patternTransform: n2 && n2.slice(0), source: a2 });
    }
  };
  i(Ao, `type`, `Pattern`), M.setClass(Ao), M.setClass(Ao, `pattern`);
  var Mo = class e2 extends J {
    constructor(t2, { path: n2, left: r2, top: i2, ...a2 } = {}) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(a2), this._setPath(t2 || [], true), typeof r2 == `number` && this.set(`left`, r2), typeof i2 == `number` && this.set(`top`, i2);
    }
    _setPath(e3, t2) {
      this.path = ba(Array.isArray(e3) ? e3 : La(e3)), this.setBoundingBox(t2);
    }
    _findCenterFromElement() {
      let e3 = this._calcBoundsFromPath();
      return new N(e3.left + e3.width / 2, e3.top + e3.height / 2);
    }
    _renderPathCommands(e3) {
      let t2 = -this.pathOffset.x, n2 = -this.pathOffset.y;
      e3.beginPath();
      for (let r2 of this.path) switch (r2[0]) {
        case `L`:
          e3.lineTo(r2[1] + t2, r2[2] + n2);
          break;
        case `M`:
          e3.moveTo(r2[1] + t2, r2[2] + n2);
          break;
        case `C`:
          e3.bezierCurveTo(r2[1] + t2, r2[2] + n2, r2[3] + t2, r2[4] + n2, r2[5] + t2, r2[6] + n2);
          break;
        case `Q`:
          e3.quadraticCurveTo(r2[1] + t2, r2[2] + n2, r2[3] + t2, r2[4] + n2);
          break;
        case `Z`:
          e3.closePath();
      }
    }
    _render(e3) {
      this._renderPathCommands(e3), this._renderPaintInOrder(e3);
    }
    toString() {
      return `#<Path (${this.complexity()}): { "top": ${this.top}, "left": ${this.left} }>`;
    }
    toObject(e3 = []) {
      return { ...super.toObject(e3), path: this.path.map((e4) => e4.slice()) };
    }
    toDatalessObject(e3 = []) {
      let t2 = this.toObject(e3);
      return this.sourcePath && (delete t2.path, t2.sourcePath = this.sourcePath), t2;
    }
    _toSVG() {
      return [`<path `, `COMMON_PARTS`, `d="${Va(this.path, o.NUM_FRACTION_DIGITS)}" stroke-linecap="round" />
`];
    }
    _getOffsetTransform() {
      let e3 = o.NUM_FRACTION_DIGITS;
      return ` translate(${B(-this.pathOffset.x, e3)}, ${B(-this.pathOffset.y, e3)})`;
    }
    toClipPathSVG(e3) {
      let t2 = this._getOffsetTransform();
      return `	` + this._createBaseClipPathSVGMarkup(this._toSVG(), { reviver: e3, additionalTransform: t2 });
    }
    toSVG(e3) {
      let t2 = this._getOffsetTransform();
      return this._createBaseSVGMarkup(this._toSVG(), { reviver: e3, additionalTransform: t2 });
    }
    complexity() {
      return this.path.length;
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(e3) {
      let { width: t2, height: n2, pathOffset: r2 } = this._calcDimensions();
      this.set({ width: t2, height: n2, pathOffset: r2 }), e3 && this.setPositionByOrigin(r2, `center`, `center`);
    }
    _calcBoundsFromPath() {
      let e3 = [], t2 = 0, n2 = 0, r2 = 0, i2 = 0;
      for (let a2 of this.path) switch (a2[0]) {
        case `L`:
          r2 = a2[1], i2 = a2[2], e3.push({ x: t2, y: n2 }, { x: r2, y: i2 });
          break;
        case `M`:
          r2 = a2[1], i2 = a2[2], t2 = r2, n2 = i2;
          break;
        case `C`:
          e3.push(...va(r2, i2, a2[1], a2[2], a2[3], a2[4], a2[5], a2[6])), r2 = a2[5], i2 = a2[6];
          break;
        case `Q`:
          e3.push(...va(r2, i2, a2[1], a2[2], a2[1], a2[2], a2[3], a2[4])), r2 = a2[3], i2 = a2[4];
          break;
        case `Z`:
          r2 = t2, i2 = n2;
      }
      return wt(e3);
    }
    _calcDimensions() {
      let e3 = this._calcBoundsFromPath();
      return { ...e3, pathOffset: new N(e3.left + e3.width / 2, e3.top + e3.height / 2) };
    }
    static fromObject(e3) {
      return this._fromObject(e3, { extraParam: `path` });
    }
    static async fromElement(e3, t2, n2) {
      let { d: r2, ...i2 } = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return new this(r2, { ...i2, ...t2, left: void 0, top: void 0 });
    }
  };
  i(Mo, `type`, `Path`), i(Mo, `cacheProperties`, [...Un, `path`, `fillRule`]), i(Mo, `ATTRIBUTE_NAMES`, [...ki, `d`]), M.setClass(Mo), M.setSVGClass(Mo);
  const Po = [`radius`, `startAngle`, `endAngle`, `counterClockwise`];
  var Fo = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(t2);
    }
    _set(e3, t2) {
      return super._set(e3, t2), e3 === `radius` && this.setRadius(t2), this;
    }
    _render(e3) {
      e3.beginPath(), e3.arc(0, 0, this.radius, I(this.startAngle), I(this.endAngle), this.counterClockwise), this._renderPaintInOrder(e3);
    }
    getRadiusX() {
      return this.get(`radius`) * this.get(de);
    }
    getRadiusY() {
      return this.get(`radius`) * this.get(fe);
    }
    setRadius(e3) {
      this.radius = e3, this.set({ width: 2 * e3, height: 2 * e3 });
    }
    toObject(e3 = []) {
      return super.toObject([...Po, ...e3]);
    }
    _toSVG() {
      let { radius: e3, startAngle: t2, endAngle: n2 } = this, r2 = (n2 - t2) % 360;
      if (r2 === 0) return [`<circle `, `COMMON_PARTS`, `cx="0" cy="0" `, `r="`, `${U(e3)}`, `" />
`];
      {
        let i2 = I(t2), a2 = I(n2), o2 = Se(i2) * e3, s2 = Ce(i2) * e3, c2 = Se(a2) * e3, l2 = Ce(a2) * e3;
        return [`<path d="M ${o2} ${s2} A ${e3} ${e3} 0 ${+(r2 > 180)} ${+!this.counterClockwise} ${c2} ${l2}" `, `COMMON_PARTS`, ` />
`];
      }
    }
    static async fromElement(e3, t2, n2) {
      let { left: r2 = 0, top: i2 = 0, radius: a2 = 0, ...o2 } = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return new this({ ...o2, radius: a2, left: r2 - a2, top: i2 - a2 });
    }
    static fromObject(e3) {
      return super._fromObject(e3);
    }
  };
  i(Fo, `type`, `Circle`), i(Fo, `cacheProperties`, [...Un, ...Po]), i(Fo, `ownDefaults`, { radius: 0, startAngle: 0, endAngle: 360, counterClockwise: false }), i(Fo, `ATTRIBUTE_NAMES`, [`cx`, `cy`, `r`, ...ki]), M.setClass(Fo), M.setSVGClass(Fo);
  const zo = [`x1`, `x2`, `y1`, `y2`];
  var Bo = class e2 extends J {
    constructor([t2, n2, r2, i2] = [0, 0, 0, 0], a2 = {}) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(a2), this.x1 = t2, this.x2 = r2, this.y1 = n2, this.y2 = i2, this._setWidthHeight();
      let { left: o2, top: s2 } = a2;
      typeof o2 == `number` && this.set(`left`, o2), typeof s2 == `number` && this.set(`top`, s2);
    }
    _setWidthHeight() {
      let { x1: e3, y1: t2, x2: n2, y2: r2 } = this;
      this.width = Math.abs(n2 - e3), this.height = Math.abs(r2 - t2);
      let { left: i2, top: a2, width: o2, height: s2 } = wt([{ x: e3, y: t2 }, { x: n2, y: r2 }]), c2 = new N(i2 + o2 / 2, a2 + s2 / 2);
      this.setPositionByOrigin(c2, E, E);
    }
    _set(e3, t2) {
      return super._set(e3, t2), zo.includes(e3) && this._setWidthHeight(), this;
    }
    _render(e3) {
      e3.beginPath();
      let t2 = this.calcLinePoints();
      e3.moveTo(t2.x1, t2.y1), e3.lineTo(t2.x2, t2.y2), e3.lineWidth = this.strokeWidth;
      let n2 = e3.strokeStyle;
      var r2;
      V(this.stroke) ? e3.strokeStyle = this.stroke.toLive(e3) : e3.strokeStyle = (r2 = this.stroke) == null ? e3.fillStyle : r2, this.stroke && this._renderStroke(e3), e3.strokeStyle = n2;
    }
    _findCenterFromElement() {
      return new N((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }
    toObject(e3 = []) {
      return { ...super.toObject(e3), ...this.calcLinePoints() };
    }
    _getNonTransformedDimensions() {
      let e3 = super._getNonTransformedDimensions();
      return this.strokeLineCap === `butt` && (this.width === 0 && (e3.y -= this.strokeWidth), this.height === 0 && (e3.x -= this.strokeWidth)), e3;
    }
    calcLinePoints() {
      let { x1: e3, x2: t2, y1: n2, y2: r2, width: i2, height: a2 } = this, o2 = e3 <= t2 ? -0.5 : 0.5, s2 = n2 <= r2 ? -0.5 : 0.5;
      return { x1: o2 * i2, x2: o2 * -i2, y1: s2 * a2, y2: s2 * -a2 };
    }
    _toSVG() {
      let { x1: e3, x2: t2, y1: n2, y2: r2 } = this.calcLinePoints();
      return [`<line `, `COMMON_PARTS`, `x1="${e3}" y1="${n2}" x2="${t2}" y2="${r2}" />
`];
    }
    static async fromElement(e3, t2, n2) {
      let { x1: r2 = 0, y1: i2 = 0, x2: a2 = 0, y2: o2 = 0, ...s2 } = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return new this([r2, i2, a2, o2], s2);
    }
    static fromObject({ x1: e3, y1: t2, x2: n2, y2: r2, ...i2 }) {
      return this._fromObject({ ...i2, points: [e3, t2, n2, r2] }, { extraParam: `points` });
    }
  };
  i(Bo, `type`, `Line`), i(Bo, `cacheProperties`, [...Un, ...zo]), i(Bo, `ATTRIBUTE_NAMES`, ki.concat(zo)), M.setClass(Bo), M.setSVGClass(Bo);
  var Vo = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(t2);
    }
    _render(e3) {
      let t2 = this.width / 2, n2 = this.height / 2;
      e3.beginPath(), e3.moveTo(-t2, n2), e3.lineTo(0, -n2), e3.lineTo(t2, n2), e3.closePath(), this._renderPaintInOrder(e3);
    }
    _toSVG() {
      let e3 = this.width / 2, t2 = this.height / 2;
      return [`<polygon `, `COMMON_PARTS`, `points="`, `${-e3} ${t2},0 ${-t2},${e3} ${t2}`, `" />`];
    }
  };
  i(Vo, `type`, `Triangle`), i(Vo, `ownDefaults`, { width: 100, height: 100 }), M.setClass(Vo), M.setSVGClass(Vo);
  const Ho = [`rx`, `ry`];
  var Uo = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(t2);
    }
    _set(e3, t2) {
      switch (super._set(e3, t2), e3) {
        case `rx`:
          this.rx = t2, this.set(`width`, 2 * t2);
          break;
        case `ry`:
          this.ry = t2, this.set(`height`, 2 * t2);
      }
      return this;
    }
    getRx() {
      return this.get(`rx`) * this.get(de);
    }
    getRy() {
      return this.get(`ry`) * this.get(fe);
    }
    toObject(e3 = []) {
      return super.toObject([...Ho, ...e3]);
    }
    _toSVG() {
      return [`<ellipse `, `COMMON_PARTS`, `cx="0" cy="0" rx="${U(this.rx)}" ry="${U(this.ry)}" />
`];
    }
    _render(e3) {
      e3.beginPath(), e3.save(), e3.transform(1, 0, 0, this.ry / this.rx, 0, 0), e3.arc(0, 0, this.rx, 0, w, false), e3.restore(), this._renderPaintInOrder(e3);
    }
    static async fromElement(e3, t2, n2) {
      let r2 = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return r2.left = (r2.left || 0) - r2.rx, r2.top = (r2.top || 0) - r2.ry, new this(r2);
    }
  };
  i(Uo, `type`, `Ellipse`), i(Uo, `cacheProperties`, [...Un, ...Ho]), i(Uo, `ownDefaults`, { rx: 0, ry: 0 }), i(Uo, `ATTRIBUTE_NAMES`, [...ki, `cx`, `cy`, `rx`, `ry`]), M.setClass(Uo), M.setSVGClass(Uo);
  const Wo = { exactBoundingBox: false };
  var Go = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), i(this, `strokeDiff`, void 0), Object.assign(this, e2.ownDefaults), this.setOptions(n2), this.points = t2;
      let { left: r2, top: a2 } = n2;
      this.initialized = true, this.setBoundingBox(true), typeof r2 == `number` && this.set(`left`, r2), typeof a2 == `number` && this.set(`top`, a2);
    }
    isOpen() {
      return true;
    }
    _projectStrokeOnPoints(e3) {
      return wi(this.points, e3, this.isOpen());
    }
    _calcDimensions(e3) {
      e3 = { scaleX: this.scaleX, scaleY: this.scaleY, skewX: this.skewX, skewY: this.skewY, strokeLineCap: this.strokeLineCap, strokeLineJoin: this.strokeLineJoin, strokeMiterLimit: this.strokeMiterLimit, strokeUniform: this.strokeUniform, strokeWidth: this.strokeWidth, ...e3 || {} };
      let t2 = this.exactBoundingBox ? this._projectStrokeOnPoints(e3).map((e4) => e4.projectedPoint) : this.points;
      if (t2.length === 0) return { left: 0, top: 0, width: 0, height: 0, pathOffset: new N(), strokeOffset: new N(), strokeDiff: new N() };
      let n2 = wt(t2), r2 = Ye({ ...e3, scaleX: 1, scaleY: 1 }), i2 = wt(this.points.map((e4) => L(e4, r2, true))), a2 = new N(this.scaleX, this.scaleY), o2 = n2.left + n2.width / 2, s2 = n2.top + n2.height / 2;
      return this.exactBoundingBox && (o2 -= s2 * Math.tan(I(this.skewX)), s2 -= o2 * Math.tan(I(this.skewY))), { ...n2, pathOffset: new N(o2, s2), strokeOffset: new N(i2.left, i2.top).subtract(new N(n2.left, n2.top)).multiply(a2), strokeDiff: new N(n2.width, n2.height).subtract(new N(i2.width, i2.height)).multiply(a2) };
    }
    _findCenterFromElement() {
      let e3 = wt(this.points);
      return new N(e3.left + e3.width / 2, e3.top + e3.height / 2);
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(e3) {
      let { left: t2, top: n2, width: r2, height: i2, pathOffset: a2, strokeOffset: o2, strokeDiff: s2 } = this._calcDimensions();
      this.set({ width: r2, height: i2, pathOffset: a2, strokeOffset: o2, strokeDiff: s2 }), e3 && this.setPositionByOrigin(new N(t2 + r2 / 2, n2 + i2 / 2), `center`, `center`);
    }
    isStrokeAccountedForInDimensions() {
      return this.exactBoundingBox;
    }
    _getNonTransformedDimensions() {
      return this.exactBoundingBox ? new N(this.width, this.height) : super._getNonTransformedDimensions();
    }
    _getTransformedDimensions(e3 = {}) {
      if (this.exactBoundingBox) {
        let a2;
        if (Object.keys(e3).some((e4) => this.strokeUniform || this.constructor.layoutProperties.includes(e4))) {
          var t2, n2;
          let { width: r3, height: i3 } = this._calcDimensions(e3);
          a2 = new N((t2 = e3.width) == null ? r3 : t2, (n2 = e3.height) == null ? i3 : n2);
        } else {
          var r2, i2;
          a2 = new N((r2 = e3.width) == null ? this.width : r2, (i2 = e3.height) == null ? this.height : i2);
        }
        return a2.multiply(new N(e3.scaleX || this.scaleX, e3.scaleY || this.scaleY));
      }
      return super._getTransformedDimensions(e3);
    }
    _set(e3, t2) {
      let n2 = this.initialized && this[e3] !== t2, r2 = super._set(e3, t2);
      return this.exactBoundingBox && n2 && ((e3 === `scaleX` || e3 === `scaleY`) && this.strokeUniform && this.constructor.layoutProperties.includes(`strokeUniform`) || this.constructor.layoutProperties.includes(e3)) && this.setDimensions(), r2;
    }
    toObject(e3 = []) {
      return { ...super.toObject(e3), points: this.points.map(({ x: e4, y: t2 }) => ({ x: e4, y: t2 })) };
    }
    _toSVG() {
      let e3 = this.pathOffset.x, t2 = this.pathOffset.y, n2 = o.NUM_FRACTION_DIGITS, r2 = this.points.map(({ x: r3, y: i2 }) => `${B(r3 - e3, n2)},${B(i2 - t2, n2)}`).join(` `);
      return [`<${U(this.constructor.type).toLowerCase()} `, `COMMON_PARTS`, `points="${r2}" />
`];
    }
    _render(e3) {
      let t2 = this.points.length, n2 = this.pathOffset.x, r2 = this.pathOffset.y;
      if (t2 && !isNaN(this.points[t2 - 1].y)) {
        e3.beginPath(), e3.moveTo(this.points[0].x - n2, this.points[0].y - r2);
        for (let i2 = 0; i2 < t2; i2++) {
          let t3 = this.points[i2];
          e3.lineTo(t3.x - n2, t3.y - r2);
        }
        !this.isOpen() && e3.closePath(), this._renderPaintInOrder(e3);
      }
    }
    complexity() {
      return this.points.length;
    }
    static async fromElement(e3, t2, n2) {
      let r2 = (function(e4) {
        if (!e4) return [];
        let t3 = e4.replace(/,/g, ` `).trim().split(/\s+/), n3 = [];
        for (let e5 = 0; e5 < t3.length; e5 += 2) n3.push({ x: parseFloat(t3[e5]), y: parseFloat(t3[e5 + 1]) });
        return n3;
      })(e3.getAttribute(`points`)), { left: i2, top: a2, ...o2 } = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return new this(r2, { ...o2, ...t2 });
    }
    static fromObject(e3) {
      return this._fromObject(e3, { extraParam: `points` });
    }
  };
  i(Go, `ownDefaults`, Wo), i(Go, `type`, `Polyline`), i(Go, `layoutProperties`, [pe, me, `strokeLineCap`, `strokeLineJoin`, `strokeMiterLimit`, `strokeWidth`, `strokeUniform`, `points`]), i(Go, `cacheProperties`, [...Un, `points`]), i(Go, `ATTRIBUTE_NAMES`, [...ki]), M.setClass(Go), M.setSVGClass(Go);
  var Ko = class extends Go {
    isOpen() {
      return false;
    }
  };
  i(Ko, `ownDefaults`, Wo), i(Ko, `type`, `Polygon`), M.setClass(Ko), M.setSVGClass(Ko);
  var qo = class extends J {
    isEmptyStyles(e2) {
      if (!this.styles || e2 !== void 0 && !this.styles[e2]) return true;
      let t2 = e2 === void 0 ? this.styles : { line: this.styles[e2] };
      for (let e3 in t2) for (let n2 in t2[e3]) for (let r2 in t2[e3][n2]) return false;
      return true;
    }
    styleHas(e2, t2) {
      if (!this.styles || t2 !== void 0 && !this.styles[t2]) return false;
      let n2 = t2 === void 0 ? this.styles : { 0: this.styles[t2] };
      for (let t3 in n2) for (let r2 in n2[t3]) if (n2[t3][r2][e2] !== void 0) return true;
      return false;
    }
    cleanStyle(e2) {
      if (!this.styles) return false;
      let t2 = this.styles, n2, r2, i2 = 0, a2 = true, o2 = 0;
      for (let o3 in t2) {
        n2 = 0;
        for (let s2 in t2[o3]) {
          let c2 = t2[o3][s2] || {};
          i2++, c2[e2] === void 0 ? a2 = false : (r2 ? c2[e2] !== r2 && (a2 = false) : r2 = c2[e2], c2[e2] === this[e2] && delete c2[e2]), Object.keys(c2).length === 0 ? delete t2[o3][s2] : n2++;
        }
        n2 === 0 && delete t2[o3];
      }
      for (let e3 = 0; e3 < this._textLines.length; e3++) o2 += this._textLines[e3].length;
      a2 && i2 === o2 && (this[e2] = r2, this.removeStyle(e2));
    }
    removeStyle(e2) {
      if (!this.styles) return;
      let t2 = this.styles, n2, r2, i2;
      for (r2 in t2) {
        for (i2 in n2 = t2[r2], n2) delete n2[i2][e2], Object.keys(n2[i2]).length === 0 && delete n2[i2];
        Object.keys(n2).length === 0 && delete t2[r2];
      }
    }
    _extendStyles(e2, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e2);
      this._getLineStyle(n2) || this._setLineStyle(n2);
      let i2 = tt({ ...this._getStyleDeclaration(n2, r2), ...t2 }, (e3) => e3 !== void 0);
      this._setStyleDeclaration(n2, r2, i2);
    }
    getSelectionStyles(e2, t2, n2) {
      let r2 = [];
      for (let i2 = e2; i2 < (t2 || e2); i2++) r2.push(this.getStyleAtPosition(i2, n2));
      return r2;
    }
    getStyleAtPosition(e2, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e2);
      return t2 ? this.getCompleteStyleDeclaration(n2, r2) : this._getStyleDeclaration(n2, r2);
    }
    setSelectionStyles(e2, t2, n2) {
      for (let r2 = t2; r2 < (n2 || t2); r2++) this._extendStyles(r2, e2);
      this._forceClearCache = true;
    }
    _getStyleDeclaration(e2, t2) {
      var n2;
      let r2 = this.styles && this.styles[e2];
      return r2 && (n2 = r2[t2]) != null ? n2 : {};
    }
    getCompleteStyleDeclaration(e2, t2) {
      return { ...et(this, this.constructor._styleProperties), ...this._getStyleDeclaration(e2, t2) };
    }
    _setStyleDeclaration(e2, t2, n2) {
      this.styles[e2][t2] = n2;
    }
    _deleteStyleDeclaration(e2, t2) {
      delete this.styles[e2][t2];
    }
    _getLineStyle(e2) {
      return !!this.styles[e2];
    }
    _setLineStyle(e2) {
      this.styles[e2] = {};
    }
    _deleteLineStyle(e2) {
      delete this.styles[e2];
    }
  };
  i(qo, `_styleProperties`, wn);
  const Jo = /  +/g, Yo = /"/g;
  function Xo(e2, t2, n2, r2, i2) {
    return `		${((e3, { left: t3, top: n3, width: r3, height: i3 }, a2 = o.NUM_FRACTION_DIGITS) => {
      let s2 = hn(j, e3, false), [c2, l2, u2, d2] = [t3, n3, r3, i3].map((e4) => B(e4, a2));
      return `<rect ${s2} x="${c2}" y="${l2}" width="${u2}" height="${d2}"></rect>`;
    })(e2, { left: t2, top: n2, width: r2, height: i2 })}
`;
  }
  let Zo;
  var Q = class e2 extends qo {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2, n2) {
      super(), i(this, `__charBounds`, []), Object.assign(this, e2.ownDefaults), this.setOptions(n2), this.styles || (this.styles = {}), this.text = t2, this.initialized = true, this.path && this.setPathInfo(), this.initDimensions(), this.setCoords();
    }
    setPathInfo() {
      let e3 = this.path;
      e3 && (e3.segmentsInfo = ja(e3.path));
    }
    _splitText() {
      let e3 = this._splitTextIntoLines(this.text);
      return this.textLines = e3.lines, this._textLines = e3.graphemeLines, this._unwrappedTextLines = e3._unwrappedLines, this._text = e3.graphemeText, e3;
    }
    initDimensions() {
      this._splitText(), this._clearCache(), this.dirty = true, this.path ? (this.width = this.path.width, this.height = this.path.height) : (this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH, this.height = this.calcTextHeight()), this.textAlign.includes(`justify`) && this.enlargeSpaces();
    }
    enlargeSpaces() {
      let e3, t2, n2, r2, i2, a2, o2;
      for (let s2 = 0, c2 = this._textLines.length; s2 < c2; s2++) if ((this.textAlign === `justify` || s2 !== c2 - 1 && !this.isEndOfWrapping(s2)) && (r2 = 0, i2 = this._textLines[s2], t2 = this.getLineWidth(s2), t2 < this.width && (o2 = this.textLines[s2].match(this._reSpacesAndTabs)))) {
        n2 = o2.length, e3 = (this.width - t2) / n2;
        for (let t3 = 0; t3 <= i2.length; t3++) a2 = this.__charBounds[s2][t3], this._reSpaceAndTab.test(i2[t3]) ? (a2.width += e3, a2.kernedWidth += e3, a2.left += r2, r2 += e3) : a2.left += r2;
      }
    }
    isEndOfWrapping(e3) {
      return e3 === this._textLines.length - 1;
    }
    missingNewlineOffset(e3) {
      return 1;
    }
    get2DCursorLocation(e3, t2) {
      let n2 = t2 ? this._unwrappedTextLines : this._textLines, r2;
      for (r2 = 0; r2 < n2.length; r2++) {
        if (e3 <= n2[r2].length) return { lineIndex: r2, charIndex: e3 };
        e3 -= n2[r2].length + this.missingNewlineOffset(r2, t2);
      }
      return { lineIndex: r2 - 1, charIndex: n2[r2 - 1].length < e3 ? n2[r2 - 1].length : e3 };
    }
    toString() {
      return `#<Text (${this.complexity()}): { "text": "${this.text}", "fontFamily": "${this.fontFamily}" }>`;
    }
    _getCacheCanvasDimensions() {
      let e3 = super._getCacheCanvasDimensions(), t2 = this.fontSize;
      return e3.width += t2 * e3.zoomX, e3.height += t2 * e3.zoomY, e3;
    }
    _render(e3) {
      let t2 = this.path;
      t2 && !t2.isNotVisible() && t2._render(e3), this._setTextStyles(e3), this._renderTextLinesBackground(e3), this._renderTextDecoration(e3, `underline`), this._renderText(e3), this._renderTextDecoration(e3, `overline`), this._renderTextDecoration(e3, `linethrough`);
    }
    _renderText(e3) {
      this.paintFirst === `stroke` ? (this._renderTextStroke(e3), this._renderTextFill(e3)) : (this._renderTextFill(e3), this._renderTextStroke(e3));
    }
    _setTextStyles(e3, t2, n2) {
      if (e3.textBaseline = `alphabetic`, this.path) switch (this.pathAlign) {
        case E:
          e3.textBaseline = `middle`;
          break;
        case `ascender`:
          e3.textBaseline = `top`;
          break;
        case `descender`:
          e3.textBaseline = O;
      }
      e3.font = this._getFontDeclaration(t2, n2);
    }
    calcTextWidth() {
      let e3 = this.getLineWidth(0);
      for (let t2 = 1, n2 = this._textLines.length; t2 < n2; t2++) {
        let n3 = this.getLineWidth(t2);
        n3 > e3 && (e3 = n3);
      }
      return e3;
    }
    _renderTextLine(e3, t2, n2, r2, i2, a2) {
      this._renderChars(e3, t2, n2, r2, i2, a2);
    }
    _renderTextLinesBackground(e3) {
      if (!this.textBackgroundColor && !this.styleHas(`textBackgroundColor`)) return;
      let t2 = e3.fillStyle, n2 = this._getLeftOffset(), r2 = this._getTopOffset();
      for (let t3 = 0, i2 = this._textLines.length; t3 < i2; t3++) {
        let i3 = this.getHeightOfLine(t3);
        if (!this.textBackgroundColor && !this.styleHas(`textBackgroundColor`, t3)) {
          r2 += i3;
          continue;
        }
        let a2 = this._textLines[t3].length, o2 = this._getLineLeftOffset(t3), s2, c2, l2 = 0, u2 = 0, d2 = this.getValueOfPropertyAt(t3, 0, `textBackgroundColor`), f2 = this.getHeightOfLineImpl(t3);
        for (let i4 = 0; i4 < a2; i4++) {
          let a3 = this.__charBounds[t3][i4];
          c2 = this.getValueOfPropertyAt(t3, i4, `textBackgroundColor`), this.path ? (e3.save(), e3.translate(a3.renderLeft, a3.renderTop), e3.rotate(a3.angle), e3.fillStyle = c2, c2 && e3.fillRect(-a3.width / 2, -f2 * (1 - this._fontSizeFraction), a3.width, f2), e3.restore()) : c2 === d2 ? l2 += a3.kernedWidth : (s2 = n2 + o2 + u2, this.direction === `rtl` && (s2 = this.width - s2 - l2), e3.fillStyle = d2, d2 && e3.fillRect(s2, r2, l2, f2), u2 = a3.left, l2 = a3.width, d2 = c2);
        }
        c2 && !this.path && (s2 = n2 + o2 + u2, this.direction === `rtl` && (s2 = this.width - s2 - l2), e3.fillStyle = c2, e3.fillRect(s2, r2, l2, f2)), r2 += i3;
      }
      e3.fillStyle = t2, this._removeShadow(e3);
    }
    _measureChar(e3, t2, n2, r2) {
      let i2 = y.getFontCache(t2), a2 = this._getFontDeclaration(t2), o2 = n2 ? n2 + e3 : e3, s2 = n2 && a2 === this._getFontDeclaration(r2), c2 = t2.fontSize / this.CACHE_FONT_SIZE, l2, u2, d2, f2;
      if (n2 && i2.has(n2) && (d2 = i2.get(n2)), i2.has(e3) && (f2 = l2 = i2.get(e3)), s2 && i2.has(o2) && (u2 = i2.get(o2), f2 = u2 - d2), l2 === void 0 || d2 === void 0 || u2 === void 0) {
        let r3 = (Zo || (Zo = F({ width: 0, height: 0 }).getContext(`2d`)), Zo);
        this._setTextStyles(r3, t2, true), l2 === void 0 && (f2 = l2 = r3.measureText(e3).width, i2.set(e3, l2)), d2 === void 0 && s2 && n2 && (d2 = r3.measureText(n2).width, i2.set(n2, d2)), s2 && u2 === void 0 && (u2 = r3.measureText(o2).width, i2.set(o2, u2), f2 = u2 - d2);
      }
      return { width: l2 * c2, kernedWidth: f2 * c2 };
    }
    getHeightOfChar(e3, t2) {
      return this.getValueOfPropertyAt(e3, t2, `fontSize`);
    }
    measureLine(e3) {
      let t2 = this._measureLine(e3);
      return this.charSpacing !== 0 && (t2.width -= this._getWidthOfCharSpacing()), t2.width < 0 && (t2.width = 0), t2;
    }
    _measureLine(e3) {
      let t2, n2, r2 = 0, i2 = this.pathSide === k, a2 = this.path, o2 = this._textLines[e3], s2 = o2.length, c2 = Array(s2);
      this.__charBounds[e3] = c2;
      for (let i3 = 0; i3 < s2; i3++) {
        let a3 = o2[i3];
        n2 = this._getGraphemeBox(a3, e3, i3, t2), c2[i3] = n2, r2 += n2.kernedWidth, t2 = a3;
      }
      if (c2[s2] = { left: n2 ? n2.left + n2.width : 0, width: 0, kernedWidth: 0, height: this.fontSize, deltaY: 0 }, a2 && a2.segmentsInfo) {
        let e4 = 0, t3 = a2.segmentsInfo[a2.segmentsInfo.length - 1].length;
        switch (this.textAlign) {
          case D:
            e4 = i2 ? t3 - r2 : 0;
            break;
          case E:
            e4 = (t3 - r2) / 2;
            break;
          case k:
            e4 = i2 ? 0 : t3 - r2;
        }
        e4 += this.pathStartOffset * (i2 ? -1 : 1);
        for (let r3 = i2 ? s2 - 1 : 0; i2 ? r3 >= 0 : r3 < s2; i2 ? r3-- : r3++) n2 = c2[r3], e4 > t3 ? e4 %= t3 : e4 < 0 && (e4 += t3), this._setGraphemeOnPath(e4, n2), e4 += n2.kernedWidth;
      }
      return { width: r2, numOfSpaces: 0 };
    }
    _setGraphemeOnPath(e3, t2) {
      let n2 = e3 + t2.kernedWidth / 2, r2 = this.path, i2 = Ma(r2.path, n2, r2.segmentsInfo);
      t2.renderLeft = i2.x - r2.pathOffset.x, t2.renderTop = i2.y - r2.pathOffset.y, t2.angle = i2.angle + (this.pathSide === `right` ? Math.PI : 0);
    }
    _getGraphemeBox(e3, t2, n2, r2, i2) {
      let a2 = this.getCompleteStyleDeclaration(t2, n2), o2 = r2 ? this.getCompleteStyleDeclaration(t2, n2 - 1) : {}, s2 = this._measureChar(e3, a2, r2, o2), c2, l2 = s2.kernedWidth, u2 = s2.width;
      this.charSpacing !== 0 && (c2 = this._getWidthOfCharSpacing(), u2 += c2, l2 += c2);
      let d2 = { width: u2, left: 0, height: a2.fontSize, kernedWidth: l2, deltaY: a2.deltaY };
      if (n2 > 0 && !i2) {
        let e4 = this.__charBounds[t2][n2 - 1];
        d2.left = e4.left + e4.width + s2.kernedWidth - s2.width;
      }
      return d2;
    }
    getHeightOfLineImpl(e3) {
      let t2 = this.__lineHeights;
      if (t2[e3]) return t2[e3];
      let n2 = this.getHeightOfChar(e3, 0);
      for (let t3 = 1, r2 = this._textLines[e3].length; t3 < r2; t3++) n2 = Math.max(this.getHeightOfChar(e3, t3), n2);
      return t2[e3] = n2 * this._fontSizeMult;
    }
    getHeightOfLine(e3) {
      return this.getHeightOfLineImpl(e3) * this.lineHeight;
    }
    calcTextHeight() {
      let e3 = 0;
      for (let t2 = 0, n2 = this._textLines.length; t2 < n2; t2++) e3 += t2 === n2 - 1 ? this.getHeightOfLineImpl(t2) : this.getHeightOfLine(t2);
      return e3;
    }
    _getLeftOffset() {
      return this.direction === `ltr` ? -this.width / 2 : this.width / 2;
    }
    _getTopOffset() {
      return -this.height / 2;
    }
    _renderTextCommon(e3, t2) {
      e3.save();
      let n2 = 0, r2 = this._getLeftOffset(), i2 = this._getTopOffset();
      for (let a2 = 0, o2 = this._textLines.length; a2 < o2; a2++) this._renderTextLine(t2, e3, this._textLines[a2], r2 + this._getLineLeftOffset(a2), i2 + n2 + this.getHeightOfLineImpl(a2), a2), n2 += this.getHeightOfLine(a2);
      e3.restore();
    }
    _renderTextFill(e3) {
      (this.fill || this.styleHas(`fill`)) && this._renderTextCommon(e3, `fillText`);
    }
    _renderTextStroke(e3) {
      (this.stroke && this.strokeWidth !== 0 || !this.isEmptyStyles()) && (this.shadow && !this.shadow.affectStroke && this._removeShadow(e3), e3.save(), this._setLineDash(e3, this.strokeDashArray), e3.beginPath(), this._renderTextCommon(e3, `strokeText`), e3.closePath(), e3.restore());
    }
    _renderChars(e3, t2, n2, r2, i2, a2) {
      let o2 = this.textAlign.includes(En), s2 = this.path, c2 = !o2 && this.charSpacing === 0 && this.isEmptyStyles(a2) && !s2, l2 = this.direction === `ltr`, u2 = this.direction === `ltr` ? 1 : -1, d2 = t2.direction, f2, p2, m, h2, g2, _2 = ``, v2 = 0;
      if (t2.save(), d2 !== this.direction && (t2.canvas.setAttribute(`dir`, l2 ? `ltr` : `rtl`), t2.direction = l2 ? `ltr` : `rtl`, t2.textAlign = l2 ? D : k), i2 -= this.getHeightOfLineImpl(a2) * this._fontSizeFraction, c2) return this._renderChar(e3, t2, a2, 0, n2.join(``), r2, i2), void t2.restore();
      for (let c3 = 0, l3 = n2.length - 1; c3 <= l3; c3++) h2 = c3 === l3 || this.charSpacing || s2, _2 += n2[c3], m = this.__charBounds[a2][c3], v2 === 0 ? (r2 += u2 * (m.kernedWidth - m.width), v2 += m.width) : v2 += m.kernedWidth, o2 && !h2 && this._reSpaceAndTab.test(n2[c3]) && (h2 = true), h2 || (f2 = f2 || this.getCompleteStyleDeclaration(a2, c3), p2 = this.getCompleteStyleDeclaration(a2, c3 + 1), h2 = Ei(f2, p2, false)), h2 && (s2 ? (t2.save(), t2.translate(m.renderLeft, m.renderTop), t2.rotate(m.angle), this._renderChar(e3, t2, a2, c3, _2, -v2 / 2, 0), t2.restore()) : (g2 = r2, this._renderChar(e3, t2, a2, c3, _2, g2, i2)), _2 = ``, f2 = p2, r2 += u2 * v2, v2 = 0);
      t2.restore();
    }
    _applyPatternGradientTransformText(e3) {
      let t2 = this.width + this.strokeWidth, n2 = this.height + this.strokeWidth, r2 = F({ width: t2, height: n2 }), i2 = r2.getContext(`2d`);
      return r2.width = t2, r2.height = n2, i2.beginPath(), i2.moveTo(0, 0), i2.lineTo(t2, 0), i2.lineTo(t2, n2), i2.lineTo(0, n2), i2.closePath(), i2.translate(t2 / 2, n2 / 2), i2.fillStyle = e3.toLive(i2), this._applyPatternGradientTransform(i2, e3), i2.fill(), i2.createPattern(r2, `no-repeat`);
    }
    handleFiller(e3, t2, n2) {
      let r2, i2;
      return V(n2) ? n2.gradientUnits === `percentage` || n2.gradientTransform || n2.patternTransform ? (r2 = -this.width / 2, i2 = -this.height / 2, e3.translate(r2, i2), e3[t2] = this._applyPatternGradientTransformText(n2), { offsetX: r2, offsetY: i2 }) : (e3[t2] = n2.toLive(e3), this._applyPatternGradientTransform(e3, n2)) : (e3[t2] = n2, { offsetX: 0, offsetY: 0 });
    }
    _setStrokeStyles(e3, { stroke: t2, strokeWidth: n2 }) {
      return e3.lineWidth = n2, e3.lineCap = this.strokeLineCap, e3.lineDashOffset = this.strokeDashOffset, e3.lineJoin = this.strokeLineJoin, e3.miterLimit = this.strokeMiterLimit, this.handleFiller(e3, `strokeStyle`, t2);
    }
    _setFillStyles(e3, { fill: t2 }) {
      return this.handleFiller(e3, `fillStyle`, t2);
    }
    _renderChar(e3, t2, n2, r2, i2, a2, o2) {
      let s2 = this._getStyleDeclaration(n2, r2), c2 = this.getCompleteStyleDeclaration(n2, r2), l2 = e3 === `fillText` && c2.fill, u2 = e3 === `strokeText` && c2.stroke && c2.strokeWidth;
      if (u2 || l2) {
        if (t2.save(), t2.font = this._getFontDeclaration(c2), s2.textBackgroundColor && this._removeShadow(t2), s2.deltaY && (o2 += s2.deltaY), l2) {
          let e4 = this._setFillStyles(t2, c2);
          t2.fillText(i2, a2 - e4.offsetX, o2 - e4.offsetY);
        }
        if (u2) {
          let e4 = this._setStrokeStyles(t2, c2);
          t2.strokeText(i2, a2 - e4.offsetX, o2 - e4.offsetY);
        }
        t2.restore();
      }
    }
    setSuperscript(e3, t2) {
      this._setScript(e3, t2, this.superscript);
    }
    setSubscript(e3, t2) {
      this._setScript(e3, t2, this.subscript);
    }
    _setScript(e3, t2, n2) {
      let r2 = this.get2DCursorLocation(e3, true), i2 = this.getValueOfPropertyAt(r2.lineIndex, r2.charIndex, `fontSize`), a2 = this.getValueOfPropertyAt(r2.lineIndex, r2.charIndex, `deltaY`), o2 = { fontSize: i2 * n2.size, deltaY: a2 + i2 * n2.baseline };
      this.setSelectionStyles(o2, e3, t2);
    }
    _getLineLeftOffset(e3) {
      let t2 = this.getLineWidth(e3), n2 = this.width - t2, r2 = this.textAlign, i2 = this.direction, a2 = this.isEndOfWrapping(e3), o2 = 0;
      return r2 === `justify` || r2 === `justify-center` && !a2 || r2 === `justify-right` && !a2 || r2 === `justify-left` && !a2 ? 0 : (r2 === `center` && (o2 = n2 / 2), r2 === `right` && (o2 = n2), r2 === `justify-center` && (o2 = n2 / 2), r2 === `justify-right` && (o2 = n2), i2 === `rtl` && (r2 === `right` || r2 === `justify-right` ? o2 = 0 : r2 === `left` || r2 === `justify-left` ? o2 = -n2 : r2 !== `center` && r2 !== `justify-center` || (o2 = -n2 / 2)), o2);
    }
    _clearCache() {
      this._forceClearCache = false, this.__lineWidths = [], this.__lineHeights = [], this.__charBounds = [];
    }
    getLineWidth(e3) {
      if (this.__lineWidths[e3] !== void 0) return this.__lineWidths[e3];
      let { width: t2 } = this.measureLine(e3);
      return this.__lineWidths[e3] = t2, t2;
    }
    _getWidthOfCharSpacing() {
      return this.charSpacing === 0 ? 0 : this.fontSize * this.charSpacing / 1e3;
    }
    getValueOfPropertyAt(e3, t2, n2) {
      var r2;
      return (r2 = this._getStyleDeclaration(e3, t2)[n2]) == null ? this[n2] : r2;
    }
    _renderTextDecoration(e3, t2) {
      if (!this[t2] && !this.styleHas(t2)) return;
      let n2 = this._getTopOffset(), r2 = this._getLeftOffset(), i2 = this.path, a2 = this._getWidthOfCharSpacing(), o2 = t2 === `linethrough` ? 0.5 : +(t2 === `overline`), s2 = this.offsets[t2];
      for (let c2 = 0, l2 = this._textLines.length; c2 < l2; c2++) {
        let l3 = this.getHeightOfLine(c2);
        if (!this[t2] && !this.styleHas(t2, c2)) {
          n2 += l3;
          continue;
        }
        let u2 = this._textLines[c2], d2 = l3 / this.lineHeight, f2 = this._getLineLeftOffset(c2), p2, m = 0, h2 = 0, g2 = this.getValueOfPropertyAt(c2, 0, t2), _2 = this.getValueOfPropertyAt(c2, 0, j), v2 = this.getValueOfPropertyAt(c2, 0, `textDecorationColor`) || _2, y2 = this.getValueOfPropertyAt(c2, 0, vn), b2 = g2, x2 = v2, S2 = y2, C2 = n2 + d2 * (1 - this._fontSizeFraction), w2 = this.getHeightOfChar(c2, 0), ee2 = this.getValueOfPropertyAt(c2, 0, `deltaY`);
        for (let n3 = 0, a3 = u2.length; n3 < a3; n3++) {
          let a4 = this.__charBounds[c2][n3];
          b2 = this.getValueOfPropertyAt(c2, n3, t2), p2 = this.getValueOfPropertyAt(c2, n3, j), x2 = this.getValueOfPropertyAt(c2, n3, `textDecorationColor`) || p2, S2 = this.getValueOfPropertyAt(c2, n3, vn);
          let l4 = this.getHeightOfChar(c2, n3), u3 = this.getValueOfPropertyAt(c2, n3, `deltaY`);
          if (i2 && b2 && p2) {
            let t3 = this.fontSize * S2 / 1e3;
            e3.save(), e3.fillStyle = x2, e3.translate(a4.renderLeft, a4.renderTop), e3.rotate(a4.angle), e3.fillRect(-a4.kernedWidth / 2, s2 * l4 + u3 - o2 * t3, a4.kernedWidth, t3), e3.restore();
          } else if ((b2 !== g2 || p2 !== _2 || x2 !== v2 || l4 !== w2 || S2 !== y2 || u3 !== ee2) && h2 > 0) {
            let t3 = this.fontSize * y2 / 1e3, n4 = r2 + f2 + m;
            this.direction === `rtl` && (n4 = this.width - n4 - h2), g2 && v2 && y2 && (e3.fillStyle = v2, e3.fillRect(n4, C2 + s2 * w2 + ee2 - o2 * t3, h2, t3)), m = a4.left, h2 = a4.width, g2 = b2, v2 = x2, y2 = S2, _2 = p2, w2 = l4, ee2 = u3;
          } else h2 += a4.kernedWidth;
        }
        let T2 = r2 + f2 + m;
        this.direction === `rtl` && (T2 = this.width - T2 - h2), e3.fillStyle = x2;
        let E2 = this.fontSize * S2 / 1e3;
        b2 && x2 && S2 && e3.fillRect(T2, C2 + s2 * w2 + ee2 - o2 * E2, h2 - a2, E2), n2 += l3;
      }
      this._removeShadow(e3);
    }
    _getFontDeclaration({ fontFamily: t2 = this.fontFamily, fontStyle: n2 = this.fontStyle, fontWeight: r2 = this.fontWeight, fontSize: i2 = this.fontSize } = {}, a2) {
      let o2 = t2.includes(`'`) || t2.includes(`"`) || t2.includes(`,`) || e2.genericFonts.includes(t2.toLowerCase()) ? t2 : `"${t2}"`;
      return [n2, r2, `${a2 ? this.CACHE_FONT_SIZE : i2}px`, o2].join(` `);
    }
    render(e3) {
      this.visible && (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen() || (this._forceClearCache && this.initDimensions(), super.render(e3)));
    }
    graphemeSplit(e3) {
      return gt(e3);
    }
    _splitTextIntoLines(e3) {
      let t2 = e3.split(this._reNewline), n2 = Array(t2.length), r2 = [`
`], i2 = [];
      for (let e4 = 0; e4 < t2.length; e4++) n2[e4] = this.graphemeSplit(t2[e4]), i2 = i2.concat(n2[e4], r2);
      return i2.pop(), { _unwrappedLines: n2, lines: t2, graphemeText: i2, graphemeLines: n2 };
    }
    toObject(e3 = []) {
      return { ...super.toObject([...Cn, ...e3]), styles: Di(this.styles, this.text), ...this.path ? { path: this.path.toObject() } : {} };
    }
    set(e3, t2) {
      let { textLayoutProperties: n2 } = this.constructor;
      super.set(e3, t2);
      let r2 = false, i2 = false;
      if (typeof e3 == `object`) for (let t3 in e3) t3 === `path` && this.setPathInfo(), r2 = r2 || n2.includes(t3), i2 = i2 || t3 === `path`;
      else r2 = n2.includes(e3), i2 = e3 === `path`;
      return i2 && this.setPathInfo(), r2 && this.initialized && (this.initDimensions(), this.setCoords()), this;
    }
    complexity() {
      return 1;
    }
    static async fromElement(t2, n2, r2) {
      let i2 = Zi(t2, e2.ATTRIBUTE_NAMES, r2), { textAnchor: a2 = D, textDecoration: o2 = ``, dx: s2 = 0, dy: c2 = 0, top: l2 = 0, left: u2 = 0, fontSize: d2 = 16, strokeWidth: f2 = 1, ...p2 } = { ...n2, ...i2 }, m = new this(on(t2.textContent || ``).trim(), { left: u2 + s2, top: l2 + c2, underline: o2.includes(`underline`), overline: o2.includes(`overline`), linethrough: o2.includes(`line-through`), strokeWidth: 0, fontSize: d2, ...p2 }), h2 = m.getScaledHeight() / m.height, g2 = ((m.height + m.strokeWidth) * m.lineHeight - m.height) * h2, _2 = m.getScaledHeight() + g2, v2 = 0;
      return a2 === `center` && (v2 = m.getScaledWidth() / 2), a2 === `right` && (v2 = m.getScaledWidth()), m.set({ left: m.left - v2, top: m.top - (_2 - m.fontSize * (0.07 + m._fontSizeFraction)) / m.lineHeight, strokeWidth: f2 }), m;
    }
    static fromObject(e3) {
      return this._fromObject({ ...e3, styles: Oi(e3.styles || {}, e3.text) }, { extraParam: `text` });
    }
  };
  i(Q, `textLayoutProperties`, Sn), i(Q, `cacheProperties`, [...Un, ...Cn]), i(Q, `ownDefaults`, Tn), i(Q, `type`, `Text`), i(Q, `genericFonts`, [`serif`, `sans-serif`, `monospace`, `cursive`, `fantasy`, `system-ui`, `ui-serif`, `ui-sans-serif`, `ui-monospace`, `ui-rounded`, `math`, `emoji`, `fangsong`]), i(Q, `ATTRIBUTE_NAMES`, ki.concat(`x`, `y`, `dx`, `dy`, `font-family`, `font-style`, `font-weight`, `font-size`, `letter-spacing`, `text-decoration`, `text-decoration-thickness`, `text-decoration-color`, `text-anchor`)), vi(Q, [class extends gn {
    _toSVG() {
      let e2 = this._getSVGLeftTopOffsets(), t2 = this._getSVGTextAndBg(e2.textTop, e2.textLeft);
      return this._wrapSVGTextAndBg(t2);
    }
    toSVG(e2) {
      let t2 = this._createBaseSVGMarkup(this._toSVG(), { reviver: e2, noStyle: true, withShadow: true }), n2 = this.path;
      return n2 ? t2 + n2._createBaseSVGMarkup(n2._toSVG(), { reviver: e2, withShadow: true, additionalTransform: nt(this.calcOwnMatrix()) }) : t2;
    }
    _getSVGLeftTopOffsets() {
      return { textLeft: -this.width / 2, textTop: -this.height / 2, lineTop: this.getHeightOfLine(0) };
    }
    _wrapSVGTextAndBg({ textBgRects: e2, textSpans: t2 }) {
      let n2 = this.getSvgTextDecoration(this);
      return [e2.join(``), `		<text xml:space="preserve" `, `font-family="${U(this.fontFamily.replace(Yo, `'`))}" `, `font-size="${U(this.fontSize)}" `, this.fontStyle ? `font-style="${U(this.fontStyle)}" ` : ``, this.fontWeight ? `font-weight="${U(this.fontWeight)}" ` : ``, n2 ? `text-decoration="${n2}" ` : ``, this.direction === `rtl` ? `direction="rtl" ` : ``, `style="`, this.getSvgStyles(true), `"`, this.addPaintOrder(), ` >`, t2.join(``), `</text>
`];
    }
    _getSVGTextAndBg(e2, t2) {
      let n2 = [], r2 = [], i2, a2 = e2;
      this.backgroundColor && r2.push(Xo(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
      for (let e3 = 0, o2 = this._textLines.length; e3 < o2; e3++) i2 = this._getLineLeftOffset(e3), this.direction === `rtl` && (i2 += this.width), (this.textBackgroundColor || this.styleHas(`textBackgroundColor`, e3)) && this._setSVGTextLineBg(r2, e3, t2 + i2, a2), this._setSVGTextLineText(n2, e3, t2 + i2, a2), a2 += this.getHeightOfLine(e3);
      return { textSpans: n2, textBgRects: r2 };
    }
    _createTextCharSpan(e2, t2, n2, r2, i2) {
      let a2 = o.NUM_FRACTION_DIGITS, s2 = this.getSvgSpanStyles(t2, e2 !== e2.trim() || !!e2.match(Jo)), c2 = s2 ? `style="${s2}"` : ``, l2 = t2.deltaY, u2 = l2 ? ` dy="${B(l2, a2)}" ` : ``, { angle: d2, renderLeft: f2, renderTop: p2, width: m } = i2, h2 = ``;
      if (f2 !== void 0) {
        let e3 = m / 2;
        d2 && (h2 = ` rotate="${B(Ie(d2), a2)}"`);
        let t3 = We({ angle: Ie(d2) });
        t3[4] = f2, t3[5] = p2;
        let i3 = new N(-e3, 0).transform(t3);
        n2 = i3.x, r2 = i3.y;
      }
      return `<tspan x="${B(n2, a2)}" y="${B(r2, a2)}" ${u2}${h2}${c2}>${U(e2)}</tspan>`;
    }
    _setSVGTextLineText(e2, t2, n2, r2) {
      let i2 = this.getHeightOfLine(t2), a2 = this.textAlign.includes(En), o2 = this._textLines[t2], s2, c2, l2, u2, d2, f2 = ``, p2 = 0;
      r2 += i2 * (1 - this._fontSizeFraction) / this.lineHeight;
      for (let i3 = 0, m = o2.length - 1; i3 <= m; i3++) d2 = i3 === m || this.charSpacing || this.path, f2 += o2[i3], l2 = this.__charBounds[t2][i3], p2 === 0 ? (n2 += l2.kernedWidth - l2.width, p2 += l2.width) : p2 += l2.kernedWidth, a2 && !d2 && this._reSpaceAndTab.test(o2[i3]) && (d2 = true), d2 || (s2 = s2 || this.getCompleteStyleDeclaration(t2, i3), c2 = this.getCompleteStyleDeclaration(t2, i3 + 1), d2 = Ei(s2, c2, true)), d2 && (u2 = this._getStyleDeclaration(t2, i3), e2.push(this._createTextCharSpan(f2, u2, n2, r2, l2)), f2 = ``, s2 = c2, this.direction === `rtl` ? n2 -= p2 : n2 += p2, p2 = 0);
    }
    _setSVGTextLineBg(e2, t2, n2, r2) {
      let i2 = this._textLines[t2], a2 = this.getHeightOfLine(t2) / this.lineHeight, o2, s2 = 0, c2 = 0, l2 = this.getValueOfPropertyAt(t2, 0, `textBackgroundColor`);
      for (let u2 = 0; u2 < i2.length; u2++) {
        let { left: i3, width: d2, kernedWidth: f2 } = this.__charBounds[t2][u2];
        o2 = this.getValueOfPropertyAt(t2, u2, `textBackgroundColor`), o2 === l2 ? s2 += f2 : (l2 && e2.push(Xo(l2, n2 + c2, r2, s2, a2)), c2 = i3, s2 = d2, l2 = o2);
      }
      o2 && e2.push(Xo(l2, n2 + c2, r2, s2, a2));
    }
    getSvgStyles(e2) {
      let t2 = nn(this.textDecorationColor) ? ` text-decoration-color: ${U(this[yn])};` : ``;
      return `${super.getSvgStyles(e2)} text-decoration-thickness: ${B(this.textDecorationThickness * this.getObjectScaling().y / 10, o.NUM_FRACTION_DIGITS)}%;${t2} white-space: pre;`;
    }
    getSvgSpanStyles(e2, t2) {
      let { fontFamily: n2, strokeWidth: r2, stroke: i2, fill: a2, fontSize: s2, fontStyle: c2, fontWeight: l2, textDecorationThickness: u2, textDecorationColor: d2, linethrough: f2, overline: p2, underline: m } = e2, h2 = this.getSvgTextDecoration({ underline: m == null ? this.underline : m, overline: p2 == null ? this.overline : p2, linethrough: f2 == null ? this.linethrough : f2 }), g2 = u2 || this.textDecorationThickness, _2 = d2 || this.textDecorationColor, v2 = rn(r2), y2 = an(n2), b2 = rn(s2), x2 = an(c2), S2 = rn(l2) || an(l2), C2 = an(_2);
      return [i2 ? hn(he, i2) : ``, v2 ? `stroke-width: ${U(v2)}; ` : ``, y2 ? `font-family: ${y2.includes(`'`) || y2.includes(`"`) ? U(y2) : `'${U(y2)}'`}; ` : ``, b2 ? `font-size: ${U(b2)}px; ` : ``, x2 ? `font-style: ${U(x2)}; ` : ``, S2 ? `font-weight: ${U(S2)}; ` : ``, h2 ? `text-decoration: ${h2}; text-decoration-thickness: ${B(g2 * this.getObjectScaling().y / 10, o.NUM_FRACTION_DIGITS)}%;${C2 ? ` text-decoration-color: ${U(C2)};` : ``} ` : ``, a2 ? hn(j, a2) : ``, t2 ? `white-space: pre; ` : ``].join(``);
    }
    getSvgTextDecoration(e2) {
      return [`overline`, `underline`, `line-through`].filter((t2) => e2[t2.replace(`-`, ``)]).join(` `);
    }
  }]), M.setClass(Q), M.setSVGClass(Q);
  var Qo = class {
    constructor(e2) {
      i(this, `target`, void 0), i(this, `__mouseDownInPlace`, false), i(this, `__dragStartFired`, false), i(this, `__isDraggingOver`, false), i(this, `__dragStartSelection`, void 0), i(this, `__dragImageDisposer`, void 0), i(this, `_dispose`, void 0), this.target = e2;
      let t2 = [this.target.on(`dragenter`, this.dragEnterHandler.bind(this)), this.target.on(`dragover`, this.dragOverHandler.bind(this)), this.target.on(`dragleave`, this.dragLeaveHandler.bind(this)), this.target.on(`dragend`, this.dragEndHandler.bind(this)), this.target.on(`drop`, this.dropHandler.bind(this))];
      this._dispose = () => {
        t2.forEach((e3) => e3()), this._dispose = void 0;
      };
    }
    isPointerOverSelection(e2) {
      let t2 = this.target, n2 = t2.getSelectionStartFromPointer(e2);
      return t2.isEditing && n2 >= t2.selectionStart && n2 <= t2.selectionEnd && t2.selectionStart < t2.selectionEnd;
    }
    start(e2) {
      return this.__mouseDownInPlace = this.isPointerOverSelection(e2);
    }
    isActive() {
      return this.__mouseDownInPlace;
    }
    end(e2) {
      let t2 = this.isActive();
      return t2 && !this.__dragStartFired && (this.target.setCursorByClick(e2), this.target.initDelayedCursor(true)), this.__mouseDownInPlace = false, this.__dragStartFired = false, this.__isDraggingOver = false, t2;
    }
    getDragStartSelection() {
      return this.__dragStartSelection;
    }
    setDragImage(e2, { selectionStart: t2, selectionEnd: n2 }) {
      var r2;
      let i2 = this.target, a2 = i2.canvas, o2 = new N(i2.flipX ? -1 : 1, i2.flipY ? -1 : 1), s2 = i2._getCursorBoundaries(t2), c2 = new N(s2.left + s2.leftOffset, s2.top + s2.topOffset).multiply(o2).transform(i2.calcTransformMatrix()), l2 = a2.getScenePoint(e2).subtract(c2), u2 = i2.getCanvasRetinaScaling(), d2 = i2.getBoundingRect(), f2 = c2.subtract(new N(d2.left, d2.top)), p2 = a2.viewportTransform, m = f2.add(l2).transform(p2, true), h2 = i2.backgroundColor, g2 = Ti(i2.styles);
      i2.backgroundColor = ``;
      let _2 = { stroke: `transparent`, fill: `transparent`, textBackgroundColor: `transparent` };
      i2.setSelectionStyles(_2, 0, t2), i2.setSelectionStyles(_2, n2, i2.text.length), i2.dirty = true;
      let v2 = i2.toCanvasElement({ enableRetinaScaling: a2.enableRetinaScaling, viewportTransform: true });
      i2.backgroundColor = h2, i2.styles = g2, i2.dirty = true, Ka(v2, { position: `fixed`, left: -v2.width + `px`, border: te, width: v2.width / u2 + `px`, height: v2.height / u2 + `px` }), this.__dragImageDisposer && this.__dragImageDisposer(), this.__dragImageDisposer = () => {
        v2.remove();
      }, H(e2.target || this.target.hiddenTextarea).body.appendChild(v2), (r2 = e2.dataTransfer) == null || r2.setDragImage(v2, m.x, m.y);
    }
    onDragStart(e2) {
      this.__dragStartFired = true;
      let t2 = this.target, n2 = this.isActive();
      if (n2 && e2.dataTransfer) {
        let n3 = this.__dragStartSelection = { selectionStart: t2.selectionStart, selectionEnd: t2.selectionEnd }, r2 = t2._text.slice(n3.selectionStart, n3.selectionEnd).join(``), i2 = { text: t2.text, value: r2, ...n3 };
        e2.dataTransfer.setData(`text/plain`, r2), e2.dataTransfer.setData(`application/fabric`, JSON.stringify({ value: r2, styles: t2.getSelectionStyles(n3.selectionStart, n3.selectionEnd, true) })), e2.dataTransfer.effectAllowed = `copyMove`, this.setDragImage(e2, i2);
      }
      return t2.abortCursorAnimation(), n2;
    }
    canDrop(e2) {
      if (this.target.editable && !this.target.getActiveControl() && !e2.defaultPrevented) {
        if (this.isActive() && this.__dragStartSelection) {
          let t2 = this.target.getSelectionStartFromPointer(e2), n2 = this.__dragStartSelection;
          return t2 < n2.selectionStart || t2 > n2.selectionEnd;
        }
        return true;
      }
      return false;
    }
    targetCanDrop(e2) {
      return this.target.canDrop(e2);
    }
    dragEnterHandler({ e: e2 }) {
      let t2 = this.targetCanDrop(e2);
      !this.__isDraggingOver && t2 && (this.__isDraggingOver = true);
    }
    dragOverHandler(e2) {
      let { e: t2 } = e2, n2 = this.targetCanDrop(t2);
      !this.__isDraggingOver && n2 ? this.__isDraggingOver = true : this.__isDraggingOver && !n2 && (this.__isDraggingOver = false), this.__isDraggingOver && (t2.preventDefault(), e2.canDrop = true, e2.dropTarget = this.target);
    }
    dragLeaveHandler() {
      (this.__isDraggingOver || this.isActive()) && (this.__isDraggingOver = false);
    }
    dropHandler(e2) {
      var t2;
      let { e: n2 } = e2, r2 = n2.defaultPrevented;
      this.__isDraggingOver = false, n2.preventDefault();
      let i2 = (t2 = n2.dataTransfer) == null ? void 0 : t2.getData(`text/plain`);
      if (i2 && !r2) {
        let t3 = this.target, r3 = t3.canvas, a2 = t3.getSelectionStartFromPointer(n2), { styles: o2 } = n2.dataTransfer.types.includes(`application/fabric`) ? JSON.parse(n2.dataTransfer.getData(`application/fabric`)) : {}, s2 = i2[Math.max(0, i2.length - 1)];
        if (this.__dragStartSelection) {
          let e3 = this.__dragStartSelection.selectionStart, n3 = this.__dragStartSelection.selectionEnd;
          a2 > e3 && a2 <= n3 ? a2 = e3 : a2 > n3 && (a2 -= n3 - e3), t3.removeChars(e3, n3), delete this.__dragStartSelection;
        }
        t3._reNewline.test(s2) && (t3._reNewline.test(t3._text[a2]) || a2 === t3._text.length) && (i2 = i2.trimEnd()), e2.didDrop = true, e2.dropTarget = t3, t3.insertChars(i2, o2, a2), r3.setActiveObject(t3), t3.enterEditing(n2), t3.selectionStart = Math.min(a2 + 0, t3._text.length), t3.selectionEnd = Math.min(t3.selectionStart + i2.length, t3._text.length), t3.hiddenTextarea.value = t3.text, t3._updateTextarea(), t3.hiddenTextarea.focus(), t3.fire(le, { index: a2 + 0, action: `drop` }), r3.fire(`text:changed`, { target: t3 }), r3.contextTopDirty = true, r3.requestRenderAll();
      }
    }
    dragEndHandler({ e: e2 }) {
      if (this.isActive() && this.__dragStartFired && this.__dragStartSelection) {
        var t2;
        let n2 = this.target, r2 = this.target.canvas, { selectionStart: i2, selectionEnd: a2 } = this.__dragStartSelection, o2 = ((t2 = e2.dataTransfer) == null ? void 0 : t2.dropEffect) || `none`;
        o2 === `none` ? (n2.selectionStart = i2, n2.selectionEnd = a2, n2._updateTextarea(), n2.hiddenTextarea.focus()) : (n2.clearContextTop(), o2 === `move` && (n2.removeChars(i2, a2), n2.selectionStart = n2.selectionEnd = i2, n2.hiddenTextarea && (n2.hiddenTextarea.value = n2.text), n2._updateTextarea(), n2.fire(le, { index: i2, action: `dragend` }), r2.fire(`text:changed`, { target: n2 }), r2.requestRenderAll()), n2.exitEditing());
      }
      this.__dragImageDisposer && this.__dragImageDisposer(), delete this.__dragImageDisposer, delete this.__dragStartSelection, this.__isDraggingOver = false;
    }
    dispose() {
      this._dispose && this._dispose();
    }
  };
  const $o = /[ \n\.,;!\?\-]/;
  var es = class extends Q {
    constructor(...e2) {
      super(...e2), i(this, `_currentCursorOpacity`, 1);
    }
    initBehavior() {
      this._tick = this._tick.bind(this), this._onTickComplete = this._onTickComplete.bind(this), this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(e2) {
      return this.isEditing && this.exitEditing(), this.selected = false, super.onDeselect(e2);
    }
    _animateCursor({ toValue: e2, duration: t2, delay: n2, onComplete: r2 }) {
      return Mr({ startValue: this._currentCursorOpacity, endValue: e2, duration: t2, delay: n2, onComplete: r2, abort: () => !this.canvas || this.selectionStart !== this.selectionEnd, onChange: (e3) => {
        this._currentCursorOpacity = e3, this.renderCursorOrSelection();
      } });
    }
    _tick(e2) {
      this._currentTickState = this._animateCursor({ toValue: 0, duration: this.cursorDuration / 2, delay: Math.max(e2 || 0, 100), onComplete: this._onTickComplete });
    }
    _onTickComplete() {
      var e2;
      (e2 = this._currentTickCompleteState) == null || e2.abort(), this._currentTickCompleteState = this._animateCursor({ toValue: 1, duration: this.cursorDuration, onComplete: this._tick });
    }
    initDelayedCursor(e2) {
      this.abortCursorAnimation(), this._tick(e2 ? 0 : this.cursorDelay);
    }
    abortCursorAnimation() {
      let e2 = false;
      [this._currentTickState, this._currentTickCompleteState].forEach((t2) => {
        t2 && !t2.isDone() && (e2 = true, t2.abort());
      }), this._currentCursorOpacity = 1, e2 && this.clearContextTop();
    }
    restartCursorIfNeeded() {
      [this._currentTickState, this._currentTickCompleteState].some((e2) => !e2 || e2.isDone()) && this.initDelayedCursor();
    }
    selectAll() {
      return this.selectionStart = 0, this.selectionEnd = this._text.length, this._fireSelectionChanged(), this._updateTextarea(), this;
    }
    cmdAll() {
      this.selectAll(), this.renderCursorOrSelection();
    }
    getSelectedText() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join(``);
    }
    findWordBoundaryLeft(e2) {
      let t2 = 0, n2 = e2 - 1;
      if (this._reSpace.test(this._text[n2])) for (; this._reSpace.test(this._text[n2]); ) t2++, n2--;
      for (; /\S/.test(this._text[n2]) && n2 > -1; ) t2++, n2--;
      return e2 - t2;
    }
    findWordBoundaryRight(e2) {
      let t2 = 0, n2 = e2;
      if (this._reSpace.test(this._text[n2])) for (; this._reSpace.test(this._text[n2]); ) t2++, n2++;
      for (; /\S/.test(this._text[n2]) && n2 < this._text.length; ) t2++, n2++;
      return e2 + t2;
    }
    findLineBoundaryLeft(e2) {
      let t2 = 0, n2 = e2 - 1;
      for (; !/\n/.test(this._text[n2]) && n2 > -1; ) t2++, n2--;
      return e2 - t2;
    }
    findLineBoundaryRight(e2) {
      let t2 = 0, n2 = e2;
      for (; !/\n/.test(this._text[n2]) && n2 < this._text.length; ) t2++, n2++;
      return e2 + t2;
    }
    searchWordBoundary(e2, t2) {
      let n2 = this._text, r2 = e2 > 0 && this._reSpace.test(n2[e2]) && (t2 === -1 || !ne.test(n2[e2 - 1])) ? e2 - 1 : e2, i2 = n2[r2];
      for (; r2 > 0 && r2 < n2.length && !$o.test(i2); ) r2 += t2, i2 = n2[r2];
      return t2 === -1 && $o.test(i2) && r2++, r2;
    }
    selectWord(e2) {
      var t2;
      e2 = (t2 = e2) == null ? this.selectionStart : t2;
      let n2 = this.searchWordBoundary(e2, -1), r2 = Math.max(n2, this.searchWordBoundary(e2, 1));
      this.selectionStart = n2, this.selectionEnd = r2, this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection();
    }
    selectLine(e2) {
      var t2;
      e2 = (t2 = e2) == null ? this.selectionStart : t2;
      let n2 = this.findLineBoundaryLeft(e2), r2 = this.findLineBoundaryRight(e2);
      this.selectionStart = n2, this.selectionEnd = r2, this._fireSelectionChanged(), this._updateTextarea();
    }
    enterEditing(e2) {
      !this.isEditing && this.editable && (this.enterEditingImpl(), this.fire(`editing:entered`, e2 ? { e: e2 } : void 0), this._fireSelectionChanged(), this.canvas && (this.canvas.fire(`text:editing:entered`, { target: this, e: e2 }), this.canvas.requestRenderAll()));
    }
    enterEditingImpl() {
      this.canvas && (this.canvas.calcOffset(), this.canvas.textEditingManager.exitTextEditing()), this.isEditing = true, this.initHiddenTextarea(), this.hiddenTextarea.focus(), this.hiddenTextarea.value = this.text, this._updateTextarea(), this._saveEditingProps(), this._setEditingProps(), this._textBeforeEdit = this.text, this._tick();
    }
    updateSelectionOnMouseMove(e2) {
      if (this.getActiveControl()) return;
      let t2 = this.hiddenTextarea;
      H(t2).activeElement !== t2 && t2.focus();
      let n2 = this.getSelectionStartFromPointer(e2), r2 = this.selectionStart, i2 = this.selectionEnd;
      (n2 === this.__selectionStartOnMouseDown && r2 !== i2 || r2 !== n2 && i2 !== n2) && (n2 > this.__selectionStartOnMouseDown ? (this.selectionStart = this.__selectionStartOnMouseDown, this.selectionEnd = n2) : (this.selectionStart = n2, this.selectionEnd = this.__selectionStartOnMouseDown), this.selectionStart === r2 && this.selectionEnd === i2 || (this._fireSelectionChanged(), this._updateTextarea(), this.renderCursorOrSelection()));
    }
    _setEditingProps() {
      this.hoverCursor = `text`, this.canvas && (this.canvas.defaultCursor = this.canvas.moveCursor = `text`), this.borderColor = this.editingBorderColor, this.hasControls = this.selectable = false, this.lockMovementX = this.lockMovementY = true;
    }
    fromStringToGraphemeSelection(e2, t2, n2) {
      let r2 = n2.slice(0, e2), i2 = this.graphemeSplit(r2).length;
      if (e2 === t2) return { selectionStart: i2, selectionEnd: i2 };
      let a2 = n2.slice(e2, t2);
      return { selectionStart: i2, selectionEnd: i2 + this.graphemeSplit(a2).length };
    }
    fromGraphemeToStringSelection(e2, t2, n2) {
      let r2 = n2.slice(0, e2).join(``).length;
      return e2 === t2 ? { selectionStart: r2, selectionEnd: r2 } : { selectionStart: r2, selectionEnd: r2 + n2.slice(e2, t2).join(``).length };
    }
    _updateTextarea() {
      if (this.cursorOffsetCache = {}, this.hiddenTextarea) {
        if (!this.inCompositionMode) {
          let e2 = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
          this.hiddenTextarea.selectionStart = e2.selectionStart, this.hiddenTextarea.selectionEnd = e2.selectionEnd;
        }
        this.updateTextareaPosition();
      }
    }
    updateFromTextArea() {
      let { hiddenTextarea: e2, direction: t2, textAlign: n2, inCompositionMode: r2 } = this;
      if (!e2) return;
      let i2 = n2 === `justify` ? t2 === `ltr` ? D : k : n2.replace(`justify-`, ``), a2 = this.getPositionByOrigin(i2, `top`);
      this.cursorOffsetCache = {}, this.text = e2.value, this.set(`dirty`, true), this.initDimensions(), this.setPositionByOrigin(a2, i2, `top`), this.setCoords();
      let o2 = this.fromStringToGraphemeSelection(e2.selectionStart, e2.selectionEnd, e2.value);
      this.selectionEnd = this.selectionStart = o2.selectionEnd, r2 || (this.selectionStart = o2.selectionStart), this.updateTextareaPosition();
    }
    updateTextareaPosition() {
      if (this.selectionStart === this.selectionEnd) {
        let e2 = this._calcTextareaPosition();
        this.hiddenTextarea.style.left = e2.left, this.hiddenTextarea.style.top = e2.top;
      }
    }
    _calcTextareaPosition() {
      if (!this.canvas) return { left: `1px`, top: `1px` };
      let e2 = this.inCompositionMode ? this.compositionStart : this.selectionStart, t2 = this._getCursorBoundaries(e2), n2 = this.get2DCursorLocation(e2), r2 = n2.lineIndex, i2 = n2.charIndex, a2 = this.getValueOfPropertyAt(r2, i2, `fontSize`) * this.lineHeight, o2 = t2.leftOffset, s2 = this.getCanvasRetinaScaling(), c2 = this.canvas.upperCanvasEl, l2 = c2.width / s2, u2 = c2.height / s2, d2 = l2 - a2, f2 = u2 - a2, p2 = new N(t2.left + o2, t2.top + t2.topOffset + a2).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new N(c2.clientWidth / l2, c2.clientHeight / u2));
      return p2.x < 0 && (p2.x = 0), p2.x > d2 && (p2.x = d2), p2.y < 0 && (p2.y = 0), p2.y > f2 && (p2.y = f2), p2.x += this.canvas._offset.left, p2.y += this.canvas._offset.top, { left: `${p2.x}px`, top: `${p2.y}px`, fontSize: `${a2}px`, charHeight: a2 };
    }
    _saveEditingProps() {
      this._savedProps = { hasControls: this.hasControls, borderColor: this.borderColor, lockMovementX: this.lockMovementX, lockMovementY: this.lockMovementY, hoverCursor: this.hoverCursor, selectable: this.selectable, defaultCursor: this.canvas && this.canvas.defaultCursor, moveCursor: this.canvas && this.canvas.moveCursor };
    }
    _restoreEditingProps() {
      this._savedProps && (this.hoverCursor = this._savedProps.hoverCursor, this.hasControls = this._savedProps.hasControls, this.borderColor = this._savedProps.borderColor, this.selectable = this._savedProps.selectable, this.lockMovementX = this._savedProps.lockMovementX, this.lockMovementY = this._savedProps.lockMovementY, this.canvas && (this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor, this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor), delete this._savedProps);
    }
    exitEditingImpl() {
      let e2 = this.hiddenTextarea;
      this.selected = false, this.isEditing = false, e2 && (e2.blur && e2.blur(), e2.parentNode && e2.parentNode.removeChild(e2)), this.hiddenTextarea = null, this.abortCursorAnimation(), this.selectionStart !== this.selectionEnd && this.clearContextTop(), this.selectionEnd = this.selectionStart, this._restoreEditingProps(), this._forceClearCache && (this.initDimensions(), this.setCoords());
    }
    exitEditing() {
      let e2 = this._textBeforeEdit !== this.text;
      return this.exitEditingImpl(), this.fire(`editing:exited`), e2 && this.fire(`modified`), this.canvas && (this.canvas.fire(`text:editing:exited`, { target: this }), e2 && this.canvas.fire(`object:modified`, { target: this })), this;
    }
    _removeExtraneousStyles() {
      for (let e2 in this.styles) this._textLines[e2] || delete this.styles[e2];
    }
    removeStyleFromTo(e2, t2) {
      let { lineIndex: n2, charIndex: r2 } = this.get2DCursorLocation(e2, true), { lineIndex: i2, charIndex: a2 } = this.get2DCursorLocation(t2, true);
      if (n2 !== i2) {
        if (this.styles[n2]) for (let e3 = r2; e3 < this._unwrappedTextLines[n2].length; e3++) delete this.styles[n2][e3];
        if (this.styles[i2]) for (let e3 = a2; e3 < this._unwrappedTextLines[i2].length; e3++) {
          let t3 = this.styles[i2][e3];
          t3 && (this.styles[n2] || (this.styles[n2] = {}), this.styles[n2][r2 + e3 - a2] = t3);
        }
        for (let e3 = n2 + 1; e3 <= i2; e3++) delete this.styles[e3];
        this.shiftLineStyles(i2, n2 - i2);
      } else if (this.styles[n2]) {
        let e3 = this.styles[n2], t3 = a2 - r2;
        for (let t4 = r2; t4 < a2; t4++) delete e3[t4];
        for (let r3 in this.styles[n2]) {
          let n3 = parseInt(r3, 10);
          n3 >= a2 && (e3[n3 - t3] = e3[r3], delete e3[r3]);
        }
      }
    }
    shiftLineStyles(e2, t2) {
      let n2 = Object.assign({}, this.styles);
      for (let r2 in this.styles) {
        let i2 = parseInt(r2, 10);
        i2 > e2 && (this.styles[i2 + t2] = n2[i2], n2[i2 - t2] || delete this.styles[i2]);
      }
    }
    insertNewlineStyleObject(e2, t2, n2, r2) {
      let i2 = {}, a2 = this._unwrappedTextLines[e2].length, o2 = a2 === t2, s2 = false;
      n2 || (n2 = 1), this.shiftLineStyles(e2, n2);
      let c2 = this.styles[e2] ? this.styles[e2][t2 === 0 ? t2 : t2 - 1] : void 0;
      for (let n3 in this.styles[e2]) {
        let r3 = parseInt(n3, 10);
        r3 >= t2 && (s2 = true, i2[r3 - t2] = this.styles[e2][n3], o2 && t2 === 0 || delete this.styles[e2][n3]);
      }
      let l2 = false;
      for (s2 && !o2 && (this.styles[e2 + n2] = i2, l2 = true), (l2 || a2 > t2) && n2--; n2 > 0; ) r2 && r2[n2 - 1] ? this.styles[e2 + n2] = { 0: { ...r2[n2 - 1] } } : c2 ? this.styles[e2 + n2] = { 0: { ...c2 } } : delete this.styles[e2 + n2], n2--;
      this._forceClearCache = true;
    }
    insertCharStyleObject(e2, t2, n2, r2) {
      this.styles || (this.styles = {});
      let i2 = this.styles[e2], a2 = i2 ? { ...i2 } : {};
      n2 || (n2 = 1);
      for (let e3 in a2) {
        let r3 = parseInt(e3, 10);
        r3 >= t2 && (i2[r3 + n2] = a2[r3], a2[r3 - n2] || delete i2[r3]);
      }
      if (this._forceClearCache = true, r2) {
        for (; n2--; ) Object.keys(r2[n2]).length && (this.styles[e2] || (this.styles[e2] = {}), this.styles[e2][t2 + n2] = { ...r2[n2] });
        return;
      }
      if (!i2) return;
      let o2 = i2[t2 ? t2 - 1 : 1];
      for (; o2 && n2--; ) this.styles[e2][t2 + n2] = { ...o2 };
    }
    insertNewStyleBlock(e2, t2, n2) {
      let r2 = this.get2DCursorLocation(t2, true), i2 = [0], a2, o2 = 0;
      for (let t3 = 0; t3 < e2.length; t3++) e2[t3] === `
` ? (o2++, i2[o2] = 0) : i2[o2]++;
      for (i2[0] > 0 && (this.insertCharStyleObject(r2.lineIndex, r2.charIndex, i2[0], n2), n2 = n2 && n2.slice(i2[0] + 1)), o2 && this.insertNewlineStyleObject(r2.lineIndex, r2.charIndex + i2[0], o2), a2 = 1; a2 < o2; a2++) i2[a2] > 0 ? this.insertCharStyleObject(r2.lineIndex + a2, 0, i2[a2], n2) : n2 && this.styles[r2.lineIndex + a2] && n2[0] && (this.styles[r2.lineIndex + a2][0] = n2[0]), n2 = n2 && n2.slice(i2[a2] + 1);
      i2[a2] > 0 && this.insertCharStyleObject(r2.lineIndex + a2, 0, i2[a2], n2);
    }
    removeChars(e2, t2 = e2 + 1) {
      this.removeStyleFromTo(e2, t2), this._text.splice(e2, t2 - e2), this.text = this._text.join(``), this.set(`dirty`, true), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
    }
    insertChars(e2, t2, n2, r2 = n2) {
      r2 > n2 && this.removeStyleFromTo(n2, r2);
      let i2 = this.graphemeSplit(e2);
      this.insertNewStyleBlock(i2, n2, t2), this._text = [...this._text.slice(0, n2), ...i2, ...this._text.slice(r2)], this.text = this._text.join(``), this.set(`dirty`, true), this.initDimensions(), this.setCoords(), this._removeExtraneousStyles();
    }
    setSelectionStartEndWithShift(e2, t2, n2) {
      n2 <= e2 ? (t2 === e2 ? this._selectionDirection = D : this._selectionDirection === `right` && (this._selectionDirection = D, this.selectionEnd = e2), this.selectionStart = n2) : n2 > e2 && n2 < t2 ? this._selectionDirection === `right` ? this.selectionEnd = n2 : this.selectionStart = n2 : (t2 === e2 ? this._selectionDirection = k : this._selectionDirection === `left` && (this._selectionDirection = k, this.selectionStart = t2), this.selectionEnd = n2);
    }
  }, ts = class extends es {
    initHiddenTextarea() {
      let e2 = this.canvas && H(this.canvas.getElement()) || g(), t2 = e2.createElement(`textarea`);
      Object.entries({ autocapitalize: `off`, autocorrect: `off`, autocomplete: `off`, spellcheck: `false`, "data-fabric": `textarea`, wrap: `off`, name: `fabricTextarea` }).map(([e3, n3]) => t2.setAttribute(e3, n3));
      let { top: n2, left: r2, fontSize: i2 } = this._calcTextareaPosition();
      t2.style.cssText = `position: absolute; top: ${n2}; left: ${r2}; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ${i2};`, (this.hiddenTextareaContainer || e2.body).appendChild(t2), Object.entries({ blur: `blur`, keydown: `onKeyDown`, keyup: `onKeyUp`, input: `onInput`, copy: `copy`, cut: `copy`, paste: `paste`, compositionstart: `onCompositionStart`, compositionupdate: `onCompositionUpdate`, compositionend: `onCompositionEnd` }).map(([e3, n3]) => t2.addEventListener(e3, this[n3].bind(this))), this.hiddenTextarea = t2;
    }
    blur() {
      this.abortCursorAnimation();
    }
    onKeyDown(e2) {
      if (!this.isEditing) return;
      let t2 = this.direction === `rtl` ? this.keysMapRtl : this.keysMap;
      if (e2.keyCode in t2) this[t2[e2.keyCode]](e2);
      else {
        if (!(e2.keyCode in this.ctrlKeysMapDown) || !e2.ctrlKey && !e2.metaKey) return;
        this[this.ctrlKeysMapDown[e2.keyCode]](e2);
      }
      e2.stopImmediatePropagation(), e2.preventDefault(), e2.keyCode >= 33 && e2.keyCode <= 40 ? (this.inCompositionMode = false, this.clearContextTop(), this.renderCursorOrSelection()) : this.canvas && this.canvas.requestRenderAll();
    }
    onKeyUp(e2) {
      !this.isEditing || this._copyDone || this.inCompositionMode ? this._copyDone = false : e2.keyCode in this.ctrlKeysMapUp && (e2.ctrlKey || e2.metaKey) && (this[this.ctrlKeysMapUp[e2.keyCode]](e2), e2.stopImmediatePropagation(), e2.preventDefault(), this.canvas && this.canvas.requestRenderAll());
    }
    onInput(e2) {
      let t2 = this.fromPaste, { value: n2, selectionStart: r2, selectionEnd: i2 } = this.hiddenTextarea;
      if (this.fromPaste = false, e2 && e2.stopPropagation(), !this.isEditing) return;
      let a2 = () => {
        this.updateFromTextArea(), this.fire(le), this.canvas && (this.canvas.fire(`text:changed`, { target: this }), this.canvas.requestRenderAll());
      };
      if (this.hiddenTextarea.value === ``) return this.styles = {}, void a2();
      let s2 = this._splitTextIntoLines(n2).graphemeText, c2 = this._text.length, l2 = s2.length, u2 = this.selectionStart, d2 = this.selectionEnd, f2 = u2 !== d2, p2, m, g2, _2, v2 = l2 - c2, y2 = this.fromStringToGraphemeSelection(r2, i2, n2), b2 = u2 > y2.selectionStart;
      f2 ? (m = this._text.slice(u2, d2), v2 += d2 - u2) : l2 < c2 && (m = b2 ? this._text.slice(d2 + v2, d2) : this._text.slice(u2, u2 - v2));
      let x2 = s2.slice(y2.selectionEnd - v2, y2.selectionEnd);
      if (m && m.length && (x2.length && (p2 = this.getSelectionStyles(u2, u2 + 1, false), p2 = x2.map(() => p2[0])), f2 ? (g2 = u2, _2 = d2) : b2 ? (g2 = d2 - m.length, _2 = d2) : (g2 = d2, _2 = d2 + m.length), this.removeStyleFromTo(g2, _2)), x2.length) {
        let { copyPasteData: e3 } = h();
        t2 && x2.join(``) === e3.copiedText && !o.disableStyleCopyPaste && (p2 = e3.copiedTextStyle), this.insertNewStyleBlock(x2, u2, p2);
      }
      a2();
    }
    onCompositionStart() {
      this.inCompositionMode = true;
    }
    onCompositionEnd() {
      this.inCompositionMode = false;
    }
    onCompositionUpdate({ target: e2 }) {
      let { selectionStart: t2, selectionEnd: n2 } = e2;
      this.compositionStart = t2, this.compositionEnd = n2, this.updateTextareaPosition();
    }
    copy() {
      if (this.selectionStart === this.selectionEnd) return;
      let { copyPasteData: e2 } = h();
      e2.copiedText = this.getSelectedText(), o.disableStyleCopyPaste ? e2.copiedTextStyle = void 0 : e2.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true), this._copyDone = true;
    }
    paste() {
      this.fromPaste = true;
    }
    _getWidthBeforeCursor(e2, t2) {
      let n2, r2 = this._getLineLeftOffset(e2);
      return t2 > 0 && (n2 = this.__charBounds[e2][t2 - 1], r2 += n2.left + n2.width), r2;
    }
    getDownCursorOffset(e2, t2) {
      let n2 = this._getSelectionForOffset(e2, t2), r2 = this.get2DCursorLocation(n2), i2 = r2.lineIndex;
      if (i2 === this._textLines.length - 1 || e2.metaKey || e2.keyCode === 34) return this._text.length - n2;
      let a2 = r2.charIndex, o2 = this._getWidthBeforeCursor(i2, a2), s2 = this._getIndexOnLine(i2 + 1, o2);
      return this._textLines[i2].slice(a2).length + s2 + 1 + this.missingNewlineOffset(i2);
    }
    _getSelectionForOffset(e2, t2) {
      return e2.shiftKey && this.selectionStart !== this.selectionEnd && t2 ? this.selectionEnd : this.selectionStart;
    }
    getUpCursorOffset(e2, t2) {
      let n2 = this._getSelectionForOffset(e2, t2), r2 = this.get2DCursorLocation(n2), i2 = r2.lineIndex;
      if (i2 === 0 || e2.metaKey || e2.keyCode === 33) return -n2;
      let a2 = r2.charIndex, o2 = this._getWidthBeforeCursor(i2, a2), s2 = this._getIndexOnLine(i2 - 1, o2), c2 = this._textLines[i2].slice(0, a2), l2 = this.missingNewlineOffset(i2 - 1);
      return -this._textLines[i2 - 1].length + s2 - c2.length + (1 - l2);
    }
    _getIndexOnLine(e2, t2) {
      let n2 = this._textLines[e2], r2, i2, a2 = this._getLineLeftOffset(e2), o2 = 0;
      for (let s2 = 0, c2 = n2.length; s2 < c2; s2++) if (r2 = this.__charBounds[e2][s2].width, a2 += r2, a2 > t2) {
        i2 = true;
        let e3 = a2 - r2, n3 = a2, c3 = Math.abs(e3 - t2);
        o2 = Math.abs(n3 - t2) < c3 ? s2 : s2 - 1;
        break;
      }
      return i2 || (o2 = n2.length - 1), o2;
    }
    moveCursorDown(e2) {
      this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorUpOrDown(`Down`, e2);
    }
    moveCursorUp(e2) {
      this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorUpOrDown(`Up`, e2);
    }
    _moveCursorUpOrDown(e2, t2) {
      let n2 = this[`get${e2}CursorOffset`](t2, this._selectionDirection === k);
      if (t2.shiftKey ? this.moveCursorWithShift(n2) : this.moveCursorWithoutShift(n2), n2 !== 0) {
        let e3 = this.text.length;
        this.selectionStart = Vn(0, this.selectionStart, e3), this.selectionEnd = Vn(0, this.selectionEnd, e3), this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea();
      }
    }
    moveCursorWithShift(e2) {
      let t2 = this._selectionDirection === `left` ? this.selectionStart + e2 : this.selectionEnd + e2;
      return this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, t2), e2 !== 0;
    }
    moveCursorWithoutShift(e2) {
      return e2 < 0 ? (this.selectionStart += e2, this.selectionEnd = this.selectionStart) : (this.selectionEnd += e2, this.selectionStart = this.selectionEnd), e2 !== 0;
    }
    moveCursorLeft(e2) {
      this.selectionStart === 0 && this.selectionEnd === 0 || this._moveCursorLeftOrRight(`Left`, e2);
    }
    _move(e2, t2, n2) {
      let r2;
      if (e2.altKey) r2 = this[`findWordBoundary${n2}`](this[t2]);
      else {
        if (!e2.metaKey && e2.keyCode !== 35 && e2.keyCode !== 36) return this[t2] += n2 === `Left` ? -1 : 1, true;
        r2 = this[`findLineBoundary${n2}`](this[t2]);
      }
      return r2 !== void 0 && this[t2] !== r2 && (this[t2] = r2, true);
    }
    _moveLeft(e2, t2) {
      return this._move(e2, t2, `Left`);
    }
    _moveRight(e2, t2) {
      return this._move(e2, t2, `Right`);
    }
    moveCursorLeftWithoutShift(e2) {
      let t2 = true;
      return this._selectionDirection = D, this.selectionEnd === this.selectionStart && this.selectionStart !== 0 && (t2 = this._moveLeft(e2, `selectionStart`)), this.selectionEnd = this.selectionStart, t2;
    }
    moveCursorLeftWithShift(e2) {
      return this._selectionDirection === `right` && this.selectionStart !== this.selectionEnd ? this._moveLeft(e2, `selectionEnd`) : this.selectionStart === 0 ? void 0 : (this._selectionDirection = D, this._moveLeft(e2, `selectionStart`));
    }
    moveCursorRight(e2) {
      this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length || this._moveCursorLeftOrRight(`Right`, e2);
    }
    _moveCursorLeftOrRight(e2, t2) {
      let n2 = `moveCursor${e2}${t2.shiftKey ? `WithShift` : `WithoutShift`}`;
      this._currentCursorOpacity = 1, this[n2](t2) && (this.abortCursorAnimation(), this.initDelayedCursor(), this._fireSelectionChanged(), this._updateTextarea());
    }
    moveCursorRightWithShift(e2) {
      return this._selectionDirection === `left` && this.selectionStart !== this.selectionEnd ? this._moveRight(e2, `selectionStart`) : this.selectionEnd === this._text.length ? void 0 : (this._selectionDirection = k, this._moveRight(e2, `selectionEnd`));
    }
    moveCursorRightWithoutShift(e2) {
      let t2 = true;
      return this._selectionDirection = k, this.selectionStart === this.selectionEnd ? (t2 = this._moveRight(e2, `selectionStart`), this.selectionEnd = this.selectionStart) : this.selectionStart = this.selectionEnd, t2;
    }
  };
  const ns = (e2) => !!e2.button;
  var rs = class extends ts {
    constructor(...e2) {
      super(...e2), i(this, `draggableTextDelegate`, void 0);
    }
    initBehavior() {
      this.on(`mousedown`, this._mouseDownHandler), this.on(`mouseup`, this.mouseUpHandler), this.on(`mousedblclick`, this.doubleClickHandler), this.on(`mousetripleclick`, this.tripleClickHandler), this.draggableTextDelegate = new Qo(this), super.initBehavior();
    }
    shouldStartDragging() {
      return this.draggableTextDelegate.isActive();
    }
    onDragStart(e2) {
      return this.draggableTextDelegate.onDragStart(e2);
    }
    canDrop(e2) {
      return this.draggableTextDelegate.canDrop(e2);
    }
    doubleClickHandler(e2) {
      this.isEditing && (this.selectWord(this.getSelectionStartFromPointer(e2.e)), this.renderCursorOrSelection());
    }
    tripleClickHandler(e2) {
      this.isEditing && (this.selectLine(this.getSelectionStartFromPointer(e2.e)), this.renderCursorOrSelection());
    }
    _mouseDownHandler({ e: e2, alreadySelected: t2 }) {
      this.canvas && this.editable && !ns(e2) && !this.getActiveControl() && (this.draggableTextDelegate.start(e2) || (this.canvas.textEditingManager.register(this), t2 && (this.inCompositionMode = false, this.setCursorByClick(e2)), this.isEditing && (this.__selectionStartOnMouseDown = this.selectionStart, this.selectionStart === this.selectionEnd && this.abortCursorAnimation(), this.renderCursorOrSelection()), this.selected || (this.selected = t2 || this.isEditing)));
    }
    mouseUpHandler({ e: e2, transform: t2 }) {
      let n2 = this.draggableTextDelegate.end(e2);
      if (this.canvas) {
        this.canvas.textEditingManager.unregister(this);
        let e3 = this.canvas._activeObject;
        if (e3 && e3 !== this) return;
      }
      !this.editable || this.group && !this.group.interactive || t2 && t2.actionPerformed || ns(e2) || n2 || this.selected && !this.getActiveControl() && (this.enterEditing(e2), this.selectionStart === this.selectionEnd ? this.initDelayedCursor(true) : this.renderCursorOrSelection());
    }
    setCursorByClick(e2) {
      let t2 = this.getSelectionStartFromPointer(e2), n2 = this.selectionStart, r2 = this.selectionEnd;
      e2.shiftKey ? this.setSelectionStartEndWithShift(n2, r2, t2) : (this.selectionStart = t2, this.selectionEnd = t2), this.isEditing && (this._fireSelectionChanged(), this._updateTextarea());
    }
    getSelectionStartFromPointer(e2) {
      let t2 = this.canvas.getScenePoint(e2).transform(R(this.calcTransformMatrix())).add(new N(-this._getLeftOffset(), -this._getTopOffset())), n2 = 0, r2 = 0, i2 = 0;
      for (let e3 = 0; e3 < this._textLines.length && n2 <= t2.y; e3++) n2 += this.getHeightOfLine(e3), i2 = e3, e3 > 0 && (r2 += this._textLines[e3 - 1].length + this.missingNewlineOffset(e3 - 1));
      let a2 = Math.abs(this._getLineLeftOffset(i2)), o2 = this._textLines[i2].length, s2 = this.__charBounds[i2];
      for (let e3 = 0; e3 < o2; e3++) {
        let n3 = a2 + s2[e3].kernedWidth;
        if (t2.x <= n3) {
          Math.abs(t2.x - n3) <= Math.abs(t2.x - a2) && r2++;
          break;
        }
        a2 = n3, r2++;
      }
      return Math.min(this.flipX ? o2 - r2 : r2, this._text.length);
    }
  };
  const is = `moveCursorUp`, as = `moveCursorDown`, os = `moveCursorLeft`, ss = `moveCursorRight`, cs = `exitEditing`, ls = (e2, t2) => {
    let n2 = t2.getRetinaScaling();
    e2.setTransform(n2, 0, 0, n2, 0, 0);
    let r2 = t2.viewportTransform;
    e2.transform(r2[0], r2[1], r2[2], r2[3], r2[4], r2[5]);
  }, us = { selectionStart: 0, selectionEnd: 0, selectionColor: `rgba(17,119,255,0.3)`, isEditing: false, editable: true, editingBorderColor: `rgba(102,153,255,0.25)`, cursorWidth: 2, cursorColor: ``, cursorDelay: 1e3, cursorDuration: 600, caching: true, hiddenTextareaContainer: null, keysMap: { 9: cs, 27: cs, 33: is, 34: as, 35: ss, 36: os, 37: os, 38: is, 39: ss, 40: as }, keysMapRtl: { 9: cs, 27: cs, 33: is, 34: as, 35: os, 36: ss, 37: ss, 38: is, 39: os, 40: as }, ctrlKeysMapDown: { 65: `cmdAll` }, ctrlKeysMapUp: { 67: `copy`, 88: `cut` }, _selectionDirection: null, _reSpace: /\s|\r?\n/, inCompositionMode: false };
  var ds = class e2 extends rs {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    get type() {
      let e3 = super.type;
      return e3 === `itext` ? `i-text` : e3;
    }
    constructor(t2, n2) {
      super(t2, { ...e2.ownDefaults, ...n2 }), this.initBehavior();
    }
    _set(e3, t2) {
      return this.isEditing && this._savedProps && e3 in this._savedProps ? (this._savedProps[e3] = t2, this) : (e3 === `canvas` && (this.canvas instanceof ho && this.canvas.textEditingManager.remove(this), t2 instanceof ho && t2.textEditingManager.add(this)), super._set(e3, t2));
    }
    setSelectionStart(e3) {
      e3 = Math.max(e3, 0), this._updateAndFire(`selectionStart`, e3);
    }
    setSelectionEnd(e3) {
      e3 = Math.min(e3, this.text.length), this._updateAndFire(`selectionEnd`, e3);
    }
    _updateAndFire(e3, t2) {
      this[e3] !== t2 && (this._fireSelectionChanged(), this[e3] = t2), this._updateTextarea();
    }
    _fireSelectionChanged() {
      this.fire(`selection:changed`), this.canvas && this.canvas.fire(`text:selection:changed`, { target: this });
    }
    initDimensions() {
      this.isEditing && this.initDelayedCursor(), super.initDimensions();
    }
    getSelectionStyles(e3 = this.selectionStart || 0, t2 = this.selectionEnd, n2) {
      return super.getSelectionStyles(e3, t2, n2);
    }
    setSelectionStyles(e3, t2 = this.selectionStart || 0, n2 = this.selectionEnd) {
      return super.setSelectionStyles(e3, t2, n2);
    }
    get2DCursorLocation(e3 = this.selectionStart, t2) {
      return super.get2DCursorLocation(e3, t2);
    }
    render(e3) {
      super.render(e3), this.cursorOffsetCache = {}, this.renderCursorOrSelection();
    }
    toCanvasElement(e3) {
      let t2 = this.isEditing;
      this.isEditing = false;
      let n2 = super.toCanvasElement(e3);
      return this.isEditing = t2, n2;
    }
    renderCursorOrSelection() {
      if (!this.isEditing || !this.canvas) return;
      let e3 = this.clearContextTop(true);
      if (!e3) return;
      let t2 = this._getCursorBoundaries(), n2 = this.findAncestorsWithClipPath(), r2 = n2.length > 0, i2, a2 = e3;
      if (r2) {
        i2 = F(e3.canvas), a2 = i2.getContext(`2d`), ls(a2, this.canvas);
        let t3 = this.calcTransformMatrix();
        a2.transform(t3[0], t3[1], t3[2], t3[3], t3[4], t3[5]);
      }
      if (this.selectionStart !== this.selectionEnd || this.inCompositionMode ? this.renderSelection(a2, t2) : this.renderCursor(a2, t2), r2) for (let t3 of n2) {
        let n3 = t3.clipPath, r3 = F(e3.canvas), i3 = r3.getContext(`2d`);
        if (ls(i3, this.canvas), !n3.absolutePositioned) {
          let e4 = t3.calcTransformMatrix();
          i3.transform(e4[0], e4[1], e4[2], e4[3], e4[4], e4[5]);
        }
        n3.transform(i3), n3.drawObject(i3, true, {}), this.drawClipPathOnCache(a2, n3, r3);
      }
      r2 && (e3.setTransform(1, 0, 0, 1, 0, 0), e3.drawImage(i2, 0, 0)), this.canvas.contextTopDirty = true, e3.restore();
    }
    findAncestorsWithClipPath() {
      let e3 = [], t2 = this;
      for (; t2; ) t2.clipPath && e3.push(t2), t2 = t2.parent;
      return e3;
    }
    _getCursorBoundaries(e3 = this.selectionStart, t2) {
      let n2 = this._getLeftOffset(), r2 = this._getTopOffset(), i2 = this._getCursorBoundariesOffsets(e3, t2);
      return { left: n2, top: r2, leftOffset: i2.left, topOffset: i2.top };
    }
    _getCursorBoundariesOffsets(e3, t2) {
      return t2 ? this.__getCursorBoundariesOffsets(e3) : this.cursorOffsetCache && `top` in this.cursorOffsetCache ? this.cursorOffsetCache : this.cursorOffsetCache = this.__getCursorBoundariesOffsets(e3);
    }
    __getCursorBoundariesOffsets(e3) {
      let t2 = 0, n2 = 0, { charIndex: r2, lineIndex: i2 } = this.get2DCursorLocation(e3), { textAlign: a2, direction: o2 } = this;
      for (let e4 = 0; e4 < i2; e4++) t2 += this.getHeightOfLine(e4);
      let s2 = this._getLineLeftOffset(i2), c2 = this.__charBounds[i2][r2];
      c2 && (n2 = c2.left), this.charSpacing !== 0 && r2 === this._textLines[i2].length && (n2 -= this._getWidthOfCharSpacing());
      let l2 = s2 + (n2 > 0 ? n2 : 0);
      return o2 === `rtl` && (a2 === `right` || a2 === `justify` || a2 === `justify-right` ? l2 *= -1 : a2 === `left` || a2 === `justify-left` ? l2 = s2 - (n2 > 0 ? n2 : 0) : a2 !== `center` && a2 !== `justify-center` || (l2 = s2 - (n2 > 0 ? n2 : 0))), { top: t2, left: l2 };
    }
    renderCursorAt(e3) {
      this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(e3, true), e3);
    }
    renderCursor(e3, t2) {
      this._renderCursor(e3, t2, this.selectionStart);
    }
    getCursorRenderingData(e3 = this.selectionStart, t2 = this._getCursorBoundaries(e3)) {
      let n2 = this.get2DCursorLocation(e3), r2 = n2.lineIndex, i2 = n2.charIndex > 0 ? n2.charIndex - 1 : 0, a2 = this.getValueOfPropertyAt(r2, i2, `fontSize`), o2 = this.getObjectScaling().x * this.canvas.getZoom(), s2 = this.cursorWidth / o2, c2 = this.getValueOfPropertyAt(r2, i2, `deltaY`), l2 = t2.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(r2) / this.lineHeight - a2 * (1 - this._fontSizeFraction);
      return { color: this.cursorColor || this.getValueOfPropertyAt(r2, i2, `fill`), opacity: this._currentCursorOpacity, left: t2.left + t2.leftOffset - s2 / 2, top: l2 + t2.top + c2, width: s2, height: a2 };
    }
    _renderCursor(e3, t2, n2) {
      let { color: r2, opacity: i2, left: a2, top: o2, width: s2, height: c2 } = this.getCursorRenderingData(n2, t2);
      e3.fillStyle = r2, e3.globalAlpha = i2, e3.fillRect(a2, o2, s2, c2);
    }
    renderSelection(e3, t2) {
      let n2 = { selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd };
      this._renderSelection(e3, n2, t2);
    }
    renderDragSourceEffect() {
      let e3 = this.draggableTextDelegate.getDragStartSelection();
      this._renderSelection(this.canvas.contextTop, e3, this._getCursorBoundaries(e3.selectionStart, true));
    }
    renderDropTargetEffect(e3) {
      let t2 = this.getSelectionStartFromPointer(e3);
      this.renderCursorAt(t2);
    }
    _renderSelection(e3, t2, n2) {
      let { textAlign: r2, direction: i2 } = this, a2 = t2.selectionStart, o2 = t2.selectionEnd, s2 = r2.includes(En), c2 = this.get2DCursorLocation(a2), l2 = this.get2DCursorLocation(o2), u2 = c2.lineIndex, d2 = l2.lineIndex, f2 = c2.charIndex < 0 ? 0 : c2.charIndex, p2 = l2.charIndex < 0 ? 0 : l2.charIndex;
      for (let t3 = u2; t3 <= d2; t3++) {
        let a3 = this._getLineLeftOffset(t3) || 0, o3 = this.getHeightOfLine(t3), c3 = 0, l3 = 0;
        if (t3 === u2 && (c3 = this.__charBounds[u2][f2].left), t3 >= u2 && t3 < d2) l3 = s2 && !this.isEndOfWrapping(t3) ? this.width : this.getLineWidth(t3) || 5;
        else if (t3 === d2) if (p2 === 0) l3 = this.__charBounds[d2][p2].left;
        else {
          let e4 = this._getWidthOfCharSpacing();
          l3 = this.__charBounds[d2][p2 - 1].left + this.__charBounds[d2][p2 - 1].width - e4;
        }
        let m = o3;
        (this.lineHeight < 1 || t3 === d2 && this.lineHeight > 1) && (o3 /= this.lineHeight);
        let h2 = n2.left + a3 + c3, g2 = o3, _2 = 0, v2 = l3 - c3;
        this.inCompositionMode ? (e3.fillStyle = this.compositionColor || `black`, g2 = 1, _2 = o3) : e3.fillStyle = this.selectionColor, i2 === `rtl` && (r2 === `right` || r2 === `justify` || r2 === `justify-right` ? h2 = this.width - h2 - v2 : r2 === `left` || r2 === `justify-left` ? h2 = n2.left + a3 - l3 : r2 !== `center` && r2 !== `justify-center` || (h2 = n2.left + a3 - l3)), e3.fillRect(h2, n2.top + n2.topOffset + _2, v2, g2), n2.topOffset += m;
      }
    }
    getCurrentCharFontSize() {
      let e3 = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(e3.l, e3.c, `fontSize`);
    }
    getCurrentCharColor() {
      let e3 = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(e3.l, e3.c, j);
    }
    _getCurrentCharIndex() {
      let e3 = this.get2DCursorLocation(this.selectionStart, true), t2 = e3.charIndex > 0 ? e3.charIndex - 1 : 0;
      return { l: e3.lineIndex, c: t2 };
    }
    dispose() {
      this.exitEditingImpl(), this.draggableTextDelegate.dispose(), super.dispose();
    }
  };
  i(ds, `ownDefaults`, us), i(ds, `type`, `IText`), M.setClass(ds), M.setClass(ds, `i-text`);
  var fs = class e2 extends ds {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2, n2) {
      super(t2, { ...e2.ownDefaults, ...n2 });
    }
    static createControls() {
      return { controls: gi() };
    }
    initDimensions() {
      this.initialized && (this.isEditing && this.initDelayedCursor(), this._clearCache(), this.dynamicMinWidth = 0, this._styleMap = this._generateStyleMap(this._splitText()), this.dynamicMinWidth > this.width && this._set(`width`, this.dynamicMinWidth), this.textAlign.includes(`justify`) && this.enlargeSpaces(), this.height = this.calcTextHeight());
    }
    _generateStyleMap(e3) {
      let t2 = 0, n2 = 0, r2 = 0, i2 = {};
      for (let a2 = 0; a2 < e3.graphemeLines.length; a2++) e3.graphemeText[r2] === `
` && a2 > 0 ? (n2 = 0, r2++, t2++) : !this.splitByGrapheme && this._reSpaceAndTab.test(e3.graphemeText[r2]) && a2 > 0 && (n2++, r2++), i2[a2] = { line: t2, offset: n2 }, r2 += e3.graphemeLines[a2].length, n2 += e3.graphemeLines[a2].length;
      return i2;
    }
    styleHas(e3, t2) {
      if (this._styleMap && !this.isWrapping) {
        let e4 = this._styleMap[t2];
        e4 && (t2 = e4.line);
      }
      return super.styleHas(e3, t2);
    }
    isEmptyStyles(e3) {
      if (!this.styles) return true;
      let t2, n2, r2 = 0, i2 = false, a2 = this._styleMap[e3], o2 = this._styleMap[e3 + 1];
      a2 && (e3 = a2.line, r2 = a2.offset), o2 && (t2 = o2.line, i2 = t2 === e3, n2 = o2.offset);
      let s2 = e3 === void 0 ? this.styles : { line: this.styles[e3] };
      for (let e4 in s2) for (let t3 in s2[e4]) {
        let a3 = parseInt(t3, 10);
        if (a3 >= r2 && (!i2 || a3 < n2)) for (let n3 in s2[e4][t3]) return false;
      }
      return true;
    }
    _getStyleDeclaration(e3, t2) {
      if (this._styleMap && !this.isWrapping) {
        let n2 = this._styleMap[e3];
        if (!n2) return {};
        e3 = n2.line, t2 = n2.offset + t2;
      }
      return super._getStyleDeclaration(e3, t2);
    }
    _setStyleDeclaration(e3, t2, n2) {
      let r2 = this._styleMap[e3];
      super._setStyleDeclaration(r2.line, r2.offset + t2, n2);
    }
    _deleteStyleDeclaration(e3, t2) {
      let n2 = this._styleMap[e3];
      super._deleteStyleDeclaration(n2.line, n2.offset + t2);
    }
    _getLineStyle(e3) {
      let t2 = this._styleMap[e3];
      return !!this.styles[t2.line];
    }
    _setLineStyle(e3) {
      let t2 = this._styleMap[e3];
      super._setLineStyle(t2.line);
    }
    _wrapText(e3, t2) {
      this.isWrapping = true;
      let n2 = this.getGraphemeDataForRender(e3), r2 = [];
      for (let e4 = 0; e4 < n2.wordsData.length; e4++) r2.push(...this._wrapLine(e4, t2, n2));
      return this.isWrapping = false, r2;
    }
    getGraphemeDataForRender(e3) {
      let t2 = this.splitByGrapheme, n2 = t2 ? `` : ` `, r2 = 0;
      return { wordsData: e3.map((e4, i2) => {
        let a2 = 0, o2 = t2 ? this.graphemeSplit(e4) : this.wordSplit(e4);
        return o2.length === 0 ? [{ word: [], width: 0 }] : o2.map((e5) => {
          let o3 = t2 ? [e5] : this.graphemeSplit(e5), s2 = this._measureWord(o3, i2, a2);
          return r2 = Math.max(s2, r2), a2 += o3.length + n2.length, { word: o3, width: s2 };
        });
      }), largestWordWidth: r2 };
    }
    _measureWord(e3, t2, n2 = 0) {
      let r2, i2 = 0;
      for (let a2 = 0, o2 = e3.length; a2 < o2; a2++) i2 += this._getGraphemeBox(e3[a2], t2, a2 + n2, r2, true).kernedWidth, r2 = e3[a2];
      return i2;
    }
    wordSplit(e3) {
      return e3.split(this._wordJoiners);
    }
    _wrapLine(e3, t2, { largestWordWidth: n2, wordsData: r2 }, i2 = 0) {
      let a2 = this._getWidthOfCharSpacing(), o2 = this.splitByGrapheme, s2 = [], c2 = o2 ? `` : ` `, l2 = 0, u2 = [], d2 = 0, f2 = 0, p2 = true;
      t2 -= i2;
      let m = Math.max(t2, n2, this.dynamicMinWidth), h2 = r2[e3], g2;
      for (g2 = 0; g2 < h2.length; g2++) {
        let { word: t3, width: n3 } = h2[g2];
        d2 += t3.length, l2 += f2 + n3 - a2, l2 > m && !p2 ? (s2.push(u2), u2 = [], l2 = n3, p2 = true) : l2 += a2, p2 || o2 || u2.push(c2), u2 = u2.concat(t3), f2 = o2 ? 0 : this._measureWord([c2], e3, d2), d2++, p2 = false;
      }
      return g2 && s2.push(u2), n2 + i2 > this.dynamicMinWidth && (this.dynamicMinWidth = n2 - a2 + i2), s2;
    }
    isEndOfWrapping(e3) {
      return !this._styleMap[e3 + 1] || this._styleMap[e3 + 1].line !== this._styleMap[e3].line;
    }
    missingNewlineOffset(e3, t2) {
      return this.splitByGrapheme && !t2 ? +!!this.isEndOfWrapping(e3) : 1;
    }
    _splitTextIntoLines(e3) {
      let t2 = super._splitTextIntoLines(e3), n2 = this._wrapText(t2.lines, this.width), r2 = Array(n2.length);
      for (let e4 = 0; e4 < n2.length; e4++) r2[e4] = n2[e4].join(``);
      return t2.lines = r2, t2.graphemeLines = n2, t2;
    }
    getMinWidth() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
      let e3 = /* @__PURE__ */ new Map();
      for (let t2 in this._styleMap) {
        let n2 = parseInt(t2, 10);
        if (this._textLines[n2]) {
          let n3 = this._styleMap[t2].line;
          e3.set(`${n3}`, true);
        }
      }
      for (let t2 in this.styles) e3.has(t2) || delete this.styles[t2];
    }
    toObject(e3 = []) {
      return super.toObject([`minWidth`, `splitByGrapheme`, ...e3]);
    }
  };
  i(fs, `type`, `Textbox`), i(fs, `textLayoutProperties`, [...ds.textLayoutProperties, `width`]), i(fs, `ownDefaults`, { minWidth: 20, dynamicMinWidth: 2, lockScalingFlip: true, noScaleCache: false, _wordJoiners: /[ \t\r]/, splitByGrapheme: false }), M.setClass(fs);
  var ps = class extends ra {
    shouldPerformLayout(e2) {
      return !!e2.target.clipPath && super.shouldPerformLayout(e2);
    }
    shouldLayoutClipPath() {
      return false;
    }
    calcLayoutResult(e2, t2) {
      let { target: n2 } = e2, { clipPath: r2, group: i2 } = n2;
      if (!r2 || !this.shouldPerformLayout(e2)) return;
      let { width: a2, height: o2 } = wt(na(n2, r2)), s2 = new N(a2, o2);
      if (r2.absolutePositioned) return { center: Mt(r2.getRelativeCenterPoint(), void 0, i2 ? i2.calcTransformMatrix() : void 0), size: s2 };
      {
        let i3 = r2.getRelativeCenterPoint().transform(n2.calcOwnMatrix(), true);
        if (this.shouldPerformLayout(e2)) {
          let { center: n3 = new N(), correction: r3 = new N() } = this.calcBoundingBox(t2, e2) || {};
          return { center: n3.add(i3), correction: r3.subtract(i3), size: s2 };
        }
        return { center: n2.getRelativeCenterPoint().add(i3), size: s2 };
      }
    }
  };
  i(ps, `type`, `clip-path`), M.setClass(ps);
  var ms = class extends ra {
    getInitialSize({ target: e2 }, { size: t2 }) {
      return new N(e2.width || t2.x, e2.height || t2.y);
    }
  };
  i(ms, `type`, `fixed`), M.setClass(ms);
  var hs = class extends oa {
    subscribeTargets(e2) {
      let t2 = e2.target;
      e2.targets.reduce((e3, t3) => (t3.parent && e3.add(t3.parent), e3), /* @__PURE__ */ new Set()).forEach((e3) => {
        e3.layoutManager.subscribeTargets({ target: e3, targets: [t2] });
      });
    }
    unsubscribeTargets(e2) {
      let t2 = e2.target, n2 = t2.getObjects();
      e2.targets.reduce((e3, t3) => (t3.parent && e3.add(t3.parent), e3), /* @__PURE__ */ new Set()).forEach((e3) => {
        !n2.some((t3) => t3.parent === e3) && e3.layoutManager.unsubscribeTargets({ target: e3, targets: [t2] });
      });
    }
  }, gs = class e2 extends ca {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2 = [], n2 = {}) {
      super(), Object.assign(this, e2.ownDefaults), this.setOptions(n2);
      let { left: r2, top: i2, layoutManager: a2 } = n2;
      this.groupInit(t2, { left: r2, top: i2, layoutManager: a2 == null ? new hs() : a2 });
    }
    _shouldSetNestedCoords() {
      return true;
    }
    __objectSelectionMonitor() {
    }
    multiSelectAdd(...e3) {
      this.multiSelectionStacking === `selection-order` ? this.add(...e3) : e3.forEach((e4) => {
        let t2 = this._objects.findIndex((t3) => t3.isInFrontOf(e4)), n2 = t2 === -1 ? this.size() : t2;
        this.insertAt(n2, e4);
      });
    }
    canEnterGroup(e3) {
      return this.getObjects().some((t2) => t2.isDescendantOf(e3) || e3.isDescendantOf(t2)) ? (s(`error`, `ActiveSelection: circular object trees are not supported, this call has no effect`), false) : super.canEnterGroup(e3);
    }
    enterGroup(e3, t2) {
      e3.parent && e3.parent === e3.group ? e3.parent._exitGroup(e3) : e3.group && e3.parent !== e3.group && e3.group.remove(e3), this._enterGroup(e3, t2);
    }
    exitGroup(e3, t2) {
      this._exitGroup(e3, t2), e3.parent && e3.parent._enterGroup(e3, true);
    }
    _onAfterObjectsChange(e3, t2) {
      super._onAfterObjectsChange(e3, t2);
      let n2 = /* @__PURE__ */ new Set();
      t2.forEach((e4) => {
        let { parent: t3 } = e4;
        t3 && n2.add(t3);
      }), e3 === `removed` ? n2.forEach((e4) => {
        e4._onAfterObjectsChange(ta, t2);
      }) : n2.forEach((e4) => {
        e4._set(`dirty`, true);
      });
    }
    onDeselect() {
      return this.removeAll(), false;
    }
    toString() {
      return `#<ActiveSelection: (${this.complexity()})>`;
    }
    shouldCache() {
      return false;
    }
    isOnACache() {
      return false;
    }
    _renderControls(e3, t2, n2) {
      e3.save(), e3.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      let r2 = { hasControls: false, ...n2, forActiveSelection: true };
      for (let t3 = 0; t3 < this._objects.length; t3++) this._objects[t3]._renderControls(e3, r2);
      super._renderControls(e3, t2), e3.restore();
    }
  };
  i(gs, `type`, `ActiveSelection`), i(gs, `ownDefaults`, { multiSelectionStacking: `canvas-stacking` }), M.setClass(gs), M.setClass(gs, `activeSelection`);
  var _s = class {
    constructor() {
      i(this, `resources`, {});
    }
    applyFilters(e2, t2, n2, r2, i2) {
      let a2 = i2.getContext(`2d`, { willReadFrequently: true, desynchronized: true });
      if (!a2) return;
      a2.drawImage(t2, 0, 0, n2, r2);
      let o2 = { sourceWidth: n2, sourceHeight: r2, imageData: a2.getImageData(0, 0, n2, r2), originalEl: t2, originalImageData: a2.getImageData(0, 0, n2, r2), canvasEl: i2, ctx: a2, filterBackend: this };
      e2.forEach((e3) => {
        e3.applyTo(o2);
      });
      let { imageData: s2 } = o2;
      return s2.width === n2 && s2.height === r2 || (i2.width = s2.width, i2.height = s2.height), a2.putImageData(s2, 0, 0), o2;
    }
  }, vs = class {
    constructor({ tileSize: e2 = o.textureSize } = {}) {
      i(this, `aPosition`, new Float32Array([0, 0, 0, 1, 1, 0, 1, 1])), i(this, `resources`, {}), this.tileSize = e2, this.setupGLContext(e2, e2), this.captureGPUInfo();
    }
    setupGLContext(e2, t2) {
      this.dispose(), this.createWebGLCanvas(e2, t2);
    }
    createWebGLCanvas(e2, t2) {
      let n2 = F({ width: e2, height: t2 }), r2 = n2.getContext(`webgl`, { alpha: true, premultipliedAlpha: false, depth: false, stencil: false, antialias: false });
      r2 && (r2.clearColor(0, 0, 0, 0), this.canvas = n2, this.gl = r2);
    }
    applyFilters(e2, t2, n2, r2, i2, a2) {
      let o2 = this.gl, s2 = i2.getContext(`2d`);
      if (!o2 || !s2) return;
      let c2;
      a2 && (c2 = this.getCachedTexture(a2, t2));
      let l2 = { originalWidth: t2.width || t2.naturalWidth || 0, originalHeight: t2.height || t2.naturalHeight || 0, sourceWidth: n2, sourceHeight: r2, destinationWidth: n2, destinationHeight: r2, context: o2, sourceTexture: this.createTexture(o2, n2, r2, c2 ? void 0 : t2), targetTexture: this.createTexture(o2, n2, r2), originalTexture: c2 || this.createTexture(o2, n2, r2, c2 ? void 0 : t2), passes: e2.length, webgl: true, aPosition: this.aPosition, programCache: this.programCache, pass: 0, filterBackend: this, targetCanvas: i2 }, u2 = o2.createFramebuffer();
      return o2.bindFramebuffer(o2.FRAMEBUFFER, u2), e2.forEach((e3) => {
        e3 && e3.applyTo(l2);
      }), (function(e3) {
        let t3 = e3.targetCanvas, n3 = t3.width, r3 = t3.height, i3 = e3.destinationWidth, a3 = e3.destinationHeight;
        n3 === i3 && r3 === a3 || (t3.width = i3, t3.height = a3);
      })(l2), this.copyGLTo2D(o2, l2), o2.bindTexture(o2.TEXTURE_2D, null), o2.deleteTexture(l2.sourceTexture), o2.deleteTexture(l2.targetTexture), o2.deleteFramebuffer(u2), s2.setTransform(1, 0, 0, 1, 0, 0), l2;
    }
    dispose() {
      this.canvas && (this.canvas = null, this.gl = null), this.clearWebGLCaches();
    }
    clearWebGLCaches() {
      this.programCache = {}, this.textureCache = {};
    }
    createTexture(e2, t2, n2, r2, i2) {
      let { NEAREST: a2, TEXTURE_2D: o2, RGBA: s2, UNSIGNED_BYTE: c2, CLAMP_TO_EDGE: l2, TEXTURE_MAG_FILTER: u2, TEXTURE_MIN_FILTER: d2, TEXTURE_WRAP_S: f2, TEXTURE_WRAP_T: p2 } = e2, m = e2.createTexture();
      return e2.bindTexture(o2, m), e2.texParameteri(o2, u2, i2 || a2), e2.texParameteri(o2, d2, i2 || a2), e2.texParameteri(o2, f2, l2), e2.texParameteri(o2, p2, l2), r2 ? e2.texImage2D(o2, 0, s2, s2, c2, r2) : e2.texImage2D(o2, 0, s2, t2, n2, 0, s2, c2, null), m;
    }
    getCachedTexture(e2, t2, n2) {
      let { textureCache: r2 } = this;
      if (r2[e2]) return r2[e2];
      {
        let i2 = this.createTexture(this.gl, t2.width, t2.height, t2, n2);
        return i2 && (r2[e2] = i2), i2;
      }
    }
    evictCachesForKey(e2) {
      this.textureCache[e2] && (this.gl.deleteTexture(this.textureCache[e2]), delete this.textureCache[e2]);
    }
    copyGLTo2D(e2, t2) {
      let n2 = e2.canvas, r2 = t2.targetCanvas, i2 = r2.getContext(`2d`);
      if (!i2) return;
      i2.translate(0, r2.height), i2.scale(1, -1);
      let a2 = n2.height - r2.height;
      i2.drawImage(n2, 0, a2, r2.width, r2.height, 0, 0, r2.width, r2.height);
    }
    copyGLTo2DPutImageData(e2, t2) {
      let n2 = t2.targetCanvas.getContext(`2d`), r2 = t2.destinationWidth, i2 = t2.destinationHeight, a2 = r2 * i2 * 4;
      if (!n2) return;
      let o2 = new Uint8Array(this.imageBuffer, 0, a2), s2 = new Uint8ClampedArray(this.imageBuffer, 0, a2);
      e2.readPixels(0, 0, r2, i2, e2.RGBA, e2.UNSIGNED_BYTE, o2);
      let c2 = new ImageData(s2, r2, i2);
      n2.putImageData(c2, 0, 0);
    }
    captureGPUInfo() {
      if (this.gpuInfo) return this.gpuInfo;
      let e2 = this.gl, t2 = { renderer: ``, vendor: `` };
      if (!e2) return t2;
      let n2 = e2.getExtension(`WEBGL_debug_renderer_info`);
      if (n2) {
        let r2 = e2.getParameter(n2.UNMASKED_RENDERER_WEBGL), i2 = e2.getParameter(n2.UNMASKED_VENDOR_WEBGL);
        r2 && (t2.renderer = r2.toLowerCase()), i2 && (t2.vendor = i2.toLowerCase());
      }
      return this.gpuInfo = t2, t2;
    }
  };
  let ys;
  function bs() {
    let { WebGLProbe: e2 } = h();
    return e2.queryWebGL(P()), o.enableGLFiltering && e2.isSupported(o.textureSize) ? new vs({ tileSize: o.textureSize }) : new _s();
  }
  function xs(e2 = true) {
    return !ys && e2 && (ys = bs()), ys;
  }
  const Cs = [`cropX`, `cropY`];
  var ws = class e2 extends J {
    static getDefaults() {
      return { ...super.getDefaults(), ...e2.ownDefaults };
    }
    constructor(t2, n2) {
      super(), i(this, `_lastScaleX`, 1), i(this, `_lastScaleY`, 1), i(this, `_filterScalingX`, 1), i(this, `_filterScalingY`, 1), this.filters = [], Object.assign(this, e2.ownDefaults), this.setOptions(n2), this.cacheKey = `texture${je()}`, this.setElement(typeof t2 == `string` ? (this.canvas && H(this.canvas.getElement()) || g()).getElementById(t2) : t2, n2);
    }
    getElement() {
      return this._element;
    }
    setElement(e3, t2 = {}) {
      this.removeTexture(this.cacheKey), this.removeTexture(`${this.cacheKey}_filtered`), this._element = e3, this._originalElement = e3, this._setWidthHeight(t2), this.filters.length !== 0 && this.applyFilters(), this.resizeFilter && this.applyResizeFilters();
    }
    removeTexture(e3) {
      let t2 = xs(false);
      t2 instanceof vs && t2.evictCachesForKey(e3);
    }
    dispose() {
      super.dispose(), this.removeTexture(this.cacheKey), this.removeTexture(`${this.cacheKey}_filtered`), this._cacheContext = null, [`_originalElement`, `_element`, `_filteredEl`, `_cacheCanvas`].forEach((e3) => {
        let t2 = this[e3];
        t2 && h().dispose(t2), this[e3] = void 0;
      });
    }
    getCrossOrigin() {
      return this._originalElement && (this._originalElement.crossOrigin || null);
    }
    getOriginalSize() {
      let e3 = this.getElement();
      return e3 ? { width: e3.naturalWidth || e3.width, height: e3.naturalHeight || e3.height } : { width: 0, height: 0 };
    }
    _stroke(e3) {
      if (!this.stroke || this.strokeWidth === 0) return;
      let t2 = this.width / 2, n2 = this.height / 2;
      e3.beginPath(), e3.moveTo(-t2, -n2), e3.lineTo(t2, -n2), e3.lineTo(t2, n2), e3.lineTo(-t2, n2), e3.lineTo(-t2, -n2), e3.closePath();
    }
    toObject(e3 = []) {
      let t2 = [];
      return this.filters.forEach((e4) => {
        e4 && t2.push(e4.toObject());
      }), { ...super.toObject([...Cs, ...e3]), src: this.getSrc(), crossOrigin: this.getCrossOrigin(), filters: t2, ...this.resizeFilter ? { resizeFilter: this.resizeFilter.toObject() } : {} };
    }
    hasCrop() {
      return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }
    _toSVG() {
      let e3 = [], t2 = this._element, n2 = -this.width / 2, r2 = -this.height / 2, i2 = [], a2 = [], o2 = ``, s2 = ``;
      if (!t2) return [];
      if (this.hasCrop()) {
        let e4 = je();
        i2.push(`<clipPath id="imageCrop_` + e4 + `">
`, `	<rect x="` + n2 + `" y="` + r2 + `" width="` + U(this.width) + `" height="` + U(this.height) + `" />
`, `</clipPath>
`), o2 = ` clip-path="url(#imageCrop_` + e4 + `)" `;
      }
      if (this.imageSmoothing || (s2 = ` image-rendering="optimizeSpeed"`), e3.push(`	<image `, `COMMON_PARTS`, `xlink:href="${U(this.getSrc(true))}" x="${n2 - this.cropX}" y="${r2 - this.cropY}" width="${t2.width || t2.naturalWidth}" height="${t2.height || t2.naturalHeight}"${s2}${o2}></image>
`), this.stroke || this.strokeDashArray) {
        let e4 = this.fill;
        this.fill = null, a2 = [`	<rect x="${n2}" y="${r2}" width="${U(this.width)}" height="${U(this.height)}" style="${this.getSvgStyles()}" />
`], this.fill = e4;
      }
      return i2 = this.paintFirst === `fill` ? i2.concat(e3, a2) : i2.concat(a2, e3), i2;
    }
    getSrc(e3) {
      let t2 = e3 ? this._element : this._originalElement;
      return t2 ? t2.toDataURL ? t2.toDataURL() : this.srcFromAttribute ? t2.getAttribute(`src`) || `` : t2.src : this.src || ``;
    }
    getSvgSrc(e3) {
      return this.getSrc(e3);
    }
    setSrc(e3, { crossOrigin: t2, signal: n2 } = {}) {
      return Ze(e3, { crossOrigin: t2, signal: n2 }).then((e4) => {
        t2 !== void 0 && this.set({ crossOrigin: t2 }), this.setElement(e4);
      });
    }
    toString() {
      return `#<Image: { src: "${this.getSrc()}" }>`;
    }
    applyResizeFilters() {
      let e3 = this.resizeFilter, t2 = this.minimumScaleTrigger, n2 = this.getTotalObjectScaling(), r2 = n2.x, i2 = n2.y, a2 = this._filteredEl || this._originalElement;
      if (this.group && this.set(`dirty`, true), !e3 || r2 > t2 && i2 > t2) return this._element = a2, this._filterScalingX = 1, this._filterScalingY = 1, this._lastScaleX = r2, void (this._lastScaleY = i2);
      let o2 = F(a2), { width: s2, height: c2 } = a2;
      this._element = o2, this._lastScaleX = e3.scaleX = r2, this._lastScaleY = e3.scaleY = i2, xs().applyFilters([e3], a2, s2, c2, this._element), this._filterScalingX = o2.width / this._originalElement.width, this._filterScalingY = o2.height / this._originalElement.height;
    }
    applyFilters(e3 = this.filters || []) {
      if (e3 = e3.filter((e4) => e4 && !e4.isNeutralState()), this.set(`dirty`, true), this.removeTexture(`${this.cacheKey}_filtered`), e3.length === 0) return this._element = this._originalElement, this._filteredEl = void 0, this._filterScalingX = 1, void (this._filterScalingY = 1);
      let t2 = this._originalElement, n2 = t2.naturalWidth || t2.width, r2 = t2.naturalHeight || t2.height;
      if (this._element === this._originalElement) {
        let e4 = F({ width: n2, height: r2 });
        this._element = e4, this._filteredEl = e4;
      } else this._filteredEl && (this._element = this._filteredEl, this._filteredEl.getContext(`2d`).clearRect(0, 0, n2, r2), this._lastScaleX = 1, this._lastScaleY = 1);
      xs().applyFilters(e3, this._originalElement, n2, r2, this._element, this.cacheKey), this._originalElement.width === this._element.width && this._originalElement.height === this._element.height || (this._filterScalingX = this._element.width / this._originalElement.width, this._filterScalingY = this._element.height / this._originalElement.height);
    }
    _render(e3) {
      e3.imageSmoothingEnabled = this.imageSmoothing, true !== this.isMoving && this.resizeFilter && this._needsResize() && this.applyResizeFilters(), this._stroke(e3), this._renderPaintInOrder(e3);
    }
    drawCacheOnCanvas(e3) {
      e3.imageSmoothingEnabled = this.imageSmoothing, super.drawCacheOnCanvas(e3);
    }
    shouldCache() {
      return this.needsItsOwnCache();
    }
    _renderFill(e3) {
      let t2 = this._element;
      if (!t2) return;
      let n2 = this._filterScalingX, r2 = this._filterScalingY, i2 = this.width, a2 = this.height, o2 = Math.max(this.cropX, 0), s2 = Math.max(this.cropY, 0), c2 = t2.naturalWidth || t2.width, l2 = t2.naturalHeight || t2.height, u2 = o2 * n2, d2 = s2 * r2, f2 = Math.min(i2 * n2, c2 - u2), p2 = Math.min(a2 * r2, l2 - d2), m = -i2 / 2, h2 = -a2 / 2, g2 = Math.min(i2, c2 / n2 - o2), _2 = Math.min(a2, l2 / r2 - s2);
      t2 && e3.drawImage(t2, u2, d2, f2, p2, m, h2, g2, _2);
    }
    _needsResize() {
      let e3 = this.getTotalObjectScaling();
      return e3.x !== this._lastScaleX || e3.y !== this._lastScaleY;
    }
    _resetWidthHeight() {
      this.set(this.getOriginalSize());
    }
    _setWidthHeight({ width: e3, height: t2 } = {}) {
      let n2 = this.getOriginalSize();
      this.width = e3 || n2.width, this.height = t2 || n2.height;
    }
    parsePreserveAspectRatioAttribute() {
      let e3 = mn(this.preserveAspectRatio || ``), t2 = this.width, n2 = this.height, r2 = { width: t2, height: n2 }, i2, a2 = this._element.width, o2 = this._element.height, s2 = 1, c2 = 1, l2 = 0, u2 = 0, d2 = 0, f2 = 0;
      return !e3 || e3.alignX === `none` && e3.alignY === `none` ? (s2 = t2 / a2, c2 = n2 / o2) : (e3.meetOrSlice === `meet` && (s2 = c2 = ua(this._element, r2), i2 = (t2 - a2 * s2) / 2, e3.alignX === `Min` && (l2 = -i2), e3.alignX === `Max` && (l2 = i2), i2 = (n2 - o2 * c2) / 2, e3.alignY === `Min` && (u2 = -i2), e3.alignY === `Max` && (u2 = i2)), e3.meetOrSlice === `slice` && (s2 = c2 = da(this._element, r2), i2 = a2 - t2 / s2, e3.alignX === `Mid` && (d2 = i2 / 2), e3.alignX === `Max` && (d2 = i2), i2 = o2 - n2 / c2, e3.alignY === `Mid` && (f2 = i2 / 2), e3.alignY === `Max` && (f2 = i2), a2 = t2 / s2, o2 = n2 / c2)), { width: a2, height: o2, scaleX: s2, scaleY: c2, offsetLeft: l2, offsetTop: u2, cropX: d2, cropY: f2 };
    }
    static fromObject({ filters: e3, resizeFilter: t2, src: n2, crossOrigin: r2, type: i2, ...a2 }, o2) {
      return Promise.all([Ze(n2, { ...o2, crossOrigin: r2 }), e3 && Qe(e3, o2), t2 ? Qe([t2], o2) : [], $e(a2, o2)]).then(([e4, t3 = [], [r3], i3 = {}]) => new this(e4, { ...a2, src: n2, filters: t3, resizeFilter: r3, ...i3 }));
    }
    static fromURL(e3, { crossOrigin: t2 = null, signal: n2 } = {}, r2) {
      return Ze(e3, { crossOrigin: t2, signal: n2 }).then((e4) => new this(e4, r2));
    }
    static async fromElement(e3, t2 = {}, n2) {
      let r2 = Zi(e3, this.ATTRIBUTE_NAMES, n2);
      return this.fromURL(r2[`xlink:href`] || r2.href, t2, r2).catch((e4) => (s(`log`, `Unable to parse Image`, e4), null));
    }
  };
  i(ws, `type`, `Image`), i(ws, `cacheProperties`, [...Un, ...Cs]), i(ws, `ownDefaults`, { strokeWidth: 0, srcFromAttribute: false, minimumScaleTrigger: 0.5, cropX: 0, cropY: 0, imageSmoothing: true }), i(ws, `ATTRIBUTE_NAMES`, [...ki, `x`, `y`, `width`, `height`, `preserveAspectRatio`, `xlink:href`, `href`, `crossOrigin`, `image-rendering`]), M.setClass(ws), M.setSVGClass(ws);
  _n([`pattern`, `defs`, `symbol`, `metadata`, `clipPath`, `mask`, `desc`]);
  const zs = (e2) => e2.webgl !== void 0, Vs = `precision highp float`, Hs = `
    ${Vs};
    varying vec2 vTexCoord;
    uniform sampler2D uTexture;
    void main() {
      gl_FragColor = texture2D(uTexture, vTexCoord);
    }`, Us = new RegExp(Vs, `g`);
  var $ = class {
    get type() {
      return this.constructor.type;
    }
    constructor({ type: e2, ...t2 } = {}) {
      Object.assign(this, this.constructor.defaults, t2);
    }
    getFragmentSource() {
      return Hs;
    }
    getVertexSource() {
      return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    void main() {
      vTexCoord = aPosition;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }`;
    }
    createProgram(e2, t2 = this.getFragmentSource(), n2 = this.getVertexSource()) {
      let { WebGLProbe: { GLPrecision: r2 = `highp` } } = h();
      r2 !== `highp` && (t2 = t2.replace(Us, Vs.replace(`highp`, r2)));
      let i2 = e2.createShader(e2.VERTEX_SHADER), a2 = e2.createShader(e2.FRAGMENT_SHADER), o2 = e2.createProgram();
      if (!i2 || !a2 || !o2) throw new c(`Vertex, fragment shader or program creation error`);
      if (e2.shaderSource(i2, n2), e2.compileShader(i2), !e2.getShaderParameter(i2, e2.COMPILE_STATUS)) throw new c(`Vertex shader compile error for ${this.type}: ${e2.getShaderInfoLog(i2)}`);
      if (e2.shaderSource(a2, t2), e2.compileShader(a2), !e2.getShaderParameter(a2, e2.COMPILE_STATUS)) throw new c(`Fragment shader compile error for ${this.type}: ${e2.getShaderInfoLog(a2)}`);
      if (e2.attachShader(o2, i2), e2.attachShader(o2, a2), e2.linkProgram(o2), !e2.getProgramParameter(o2, e2.LINK_STATUS)) throw new c(`Shader link error for "${this.type}" ${e2.getProgramInfoLog(o2)}`);
      let s2 = this.getUniformLocations(e2, o2) || {};
      return s2.uStepW = e2.getUniformLocation(o2, `uStepW`), s2.uStepH = e2.getUniformLocation(o2, `uStepH`), { program: o2, attributeLocations: this.getAttributeLocations(e2, o2), uniformLocations: s2 };
    }
    getAttributeLocations(e2, t2) {
      return { aPosition: e2.getAttribLocation(t2, `aPosition`) };
    }
    getUniformLocations(e2, t2) {
      let n2 = this.constructor.uniformLocations, r2 = {};
      for (let i2 = 0; i2 < n2.length; i2++) r2[n2[i2]] = e2.getUniformLocation(t2, n2[i2]);
      return r2;
    }
    sendAttributeData(e2, t2, n2) {
      let r2 = t2.aPosition, i2 = e2.createBuffer();
      e2.bindBuffer(e2.ARRAY_BUFFER, i2), e2.enableVertexAttribArray(r2), e2.vertexAttribPointer(r2, 2, e2.FLOAT, false, 0, 0), e2.bufferData(e2.ARRAY_BUFFER, n2, e2.STATIC_DRAW);
    }
    _setupFrameBuffer(e2) {
      let t2 = e2.context;
      if (e2.passes > 1) {
        let n2 = e2.destinationWidth, r2 = e2.destinationHeight;
        e2.sourceWidth === n2 && e2.sourceHeight === r2 || (t2.deleteTexture(e2.targetTexture), e2.targetTexture = e2.filterBackend.createTexture(t2, n2, r2)), t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e2.targetTexture, 0);
      } else t2.bindFramebuffer(t2.FRAMEBUFFER, null), t2.finish();
    }
    _swapTextures(e2) {
      e2.passes--, e2.pass++;
      let t2 = e2.targetTexture;
      e2.targetTexture = e2.sourceTexture, e2.sourceTexture = t2;
    }
    isNeutralState(e2) {
      return false;
    }
    applyTo(e2) {
      zs(e2) ? (this._setupFrameBuffer(e2), this.applyToWebGL(e2), this._swapTextures(e2)) : this.applyTo2d(e2);
    }
    applyTo2d(e2) {
    }
    getCacheKey() {
      return this.type;
    }
    retrieveShader(e2) {
      let t2 = this.getCacheKey();
      return e2.programCache[t2] || (e2.programCache[t2] = this.createProgram(e2.context)), e2.programCache[t2];
    }
    applyToWebGL(e2) {
      let t2 = e2.context, n2 = this.retrieveShader(e2);
      e2.pass === 0 && e2.originalTexture ? t2.bindTexture(t2.TEXTURE_2D, e2.originalTexture) : t2.bindTexture(t2.TEXTURE_2D, e2.sourceTexture), t2.useProgram(n2.program), this.sendAttributeData(t2, n2.attributeLocations, e2.aPosition), t2.uniform1f(n2.uniformLocations.uStepW, 1 / e2.sourceWidth), t2.uniform1f(n2.uniformLocations.uStepH, 1 / e2.sourceHeight), this.sendUniformData(t2, n2.uniformLocations), t2.viewport(0, 0, e2.destinationWidth, e2.destinationHeight), t2.drawArrays(t2.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(e2, t2, n2) {
      e2.activeTexture(n2), e2.bindTexture(e2.TEXTURE_2D, t2), e2.activeTexture(e2.TEXTURE0);
    }
    unbindAdditionalTexture(e2, t2) {
      e2.activeTexture(t2), e2.bindTexture(e2.TEXTURE_2D, null), e2.activeTexture(e2.TEXTURE0);
    }
    sendUniformData(e2, t2) {
    }
    createHelpLayer(e2) {
      if (!e2.helpLayer) {
        let { sourceWidth: t2, sourceHeight: n2 } = e2;
        e2.helpLayer = F({ width: t2, height: n2 });
      }
    }
    toObject() {
      let e2 = Object.keys(this.constructor.defaults || {});
      return { type: this.type, ...e2.reduce((e3, t2) => (e3[t2] = this[t2], e3), {}) };
    }
    toJSON() {
      return this.toObject();
    }
    static async fromObject({ type: e2, ...t2 }, n2) {
      return new this(t2);
    }
  };
  i($, `type`, `BaseFilter`), i($, `uniformLocations`, []);
  const Ws = { multiply: `gl_FragColor.rgb *= uColor.rgb;
`, screen: `gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);
`, add: `gl_FragColor.rgb += uColor.rgb;
`, difference: `gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);
`, subtract: `gl_FragColor.rgb -= uColor.rgb;
`, lighten: `gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);
`, darken: `gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);
`, exclusion: `gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);
`, overlay: `
    if (uColor.r < 0.5) {
      gl_FragColor.r *= 2.0 * uColor.r;
    } else {
      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);
    }
    if (uColor.g < 0.5) {
      gl_FragColor.g *= 2.0 * uColor.g;
    } else {
      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);
    }
    if (uColor.b < 0.5) {
      gl_FragColor.b *= 2.0 * uColor.b;
    } else {
      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);
    }
    `, tint: `
    gl_FragColor.rgb *= (1.0 - uColor.a);
    gl_FragColor.rgb += uColor.rgb;
    ` };
  var Gs = class extends $ {
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec4 uColor;
      varying vec2 vTexCoord;
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        gl_FragColor = color;
        if (color.a > 0.0) {
          ${Ws[this.mode]}
        }
      }
      `;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = new G(this.color).getSource(), n2 = this.alpha, r2 = t2[0] * n2, i2 = t2[1] * n2, a2 = t2[2] * n2, o2 = 1 - n2;
      for (let t3 = 0; t3 < e2.length; t3 += 4) {
        let n3 = e2[t3], s2 = e2[t3 + 1], c2 = e2[t3 + 2], l2, u2, d2;
        switch (this.mode) {
          case `multiply`:
            l2 = n3 * r2 / 255, u2 = s2 * i2 / 255, d2 = c2 * a2 / 255;
            break;
          case `screen`:
            l2 = 255 - (255 - n3) * (255 - r2) / 255, u2 = 255 - (255 - s2) * (255 - i2) / 255, d2 = 255 - (255 - c2) * (255 - a2) / 255;
            break;
          case `add`:
            l2 = n3 + r2, u2 = s2 + i2, d2 = c2 + a2;
            break;
          case `difference`:
            l2 = Math.abs(n3 - r2), u2 = Math.abs(s2 - i2), d2 = Math.abs(c2 - a2);
            break;
          case `subtract`:
            l2 = n3 - r2, u2 = s2 - i2, d2 = c2 - a2;
            break;
          case `darken`:
            l2 = Math.min(n3, r2), u2 = Math.min(s2, i2), d2 = Math.min(c2, a2);
            break;
          case `lighten`:
            l2 = Math.max(n3, r2), u2 = Math.max(s2, i2), d2 = Math.max(c2, a2);
            break;
          case `overlay`:
            l2 = r2 < 128 ? 2 * n3 * r2 / 255 : 255 - 2 * (255 - n3) * (255 - r2) / 255, u2 = i2 < 128 ? 2 * s2 * i2 / 255 : 255 - 2 * (255 - s2) * (255 - i2) / 255, d2 = a2 < 128 ? 2 * c2 * a2 / 255 : 255 - 2 * (255 - c2) * (255 - a2) / 255;
            break;
          case `exclusion`:
            l2 = r2 + n3 - 2 * r2 * n3 / 255, u2 = i2 + s2 - 2 * i2 * s2 / 255, d2 = a2 + c2 - 2 * a2 * c2 / 255;
            break;
          case `tint`:
            l2 = r2 + n3 * o2, u2 = i2 + s2 * o2, d2 = a2 + c2 * o2;
        }
        e2[t3] = l2, e2[t3 + 1] = u2, e2[t3 + 2] = d2;
      }
    }
    sendUniformData(e2, t2) {
      let n2 = new G(this.color).getSource();
      n2[0] = this.alpha * n2[0] / 255, n2[1] = this.alpha * n2[1] / 255, n2[2] = this.alpha * n2[2] / 255, n2[3] = this.alpha, e2.uniform4fv(t2.uColor, n2);
    }
  };
  i(Gs, `defaults`, { color: `#F95C63`, mode: `multiply`, alpha: 1 }), i(Gs, `type`, `BlendColor`), i(Gs, `uniformLocations`, [`uColor`]), M.setClass(Gs);
  const Ks = { multiply: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.rgba *= color2.rgba;
      gl_FragColor = color;
    }
    `, mask: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform sampler2D uImage;
    uniform vec4 uColor;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      vec4 color2 = texture2D(uImage, vTexCoord2);
      color.a = color2.a;
      gl_FragColor = color;
    }
    ` };
  var qs = class extends $ {
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return Ks[this.mode];
    }
    getVertexSource() {
      return `
    attribute vec2 aPosition;
    varying vec2 vTexCoord;
    varying vec2 vTexCoord2;
    uniform mat3 uTransformMatrix;
    void main() {
      vTexCoord = aPosition;
      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;
      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);
    }
    `;
    }
    applyToWebGL(e2) {
      let t2 = e2.context, n2 = this.createTexture(e2.filterBackend, this.image);
      this.bindAdditionalTexture(t2, n2, t2.TEXTURE1), super.applyToWebGL(e2), this.unbindAdditionalTexture(t2, t2.TEXTURE1);
    }
    createTexture(e2, t2) {
      return e2.getCachedTexture(t2.cacheKey, t2.getElement());
    }
    calculateMatrix() {
      let e2 = this.image, { width: t2, height: n2 } = e2.getElement();
      return [1 / e2.scaleX, 0, 0, 0, 1 / e2.scaleY, 0, -e2.left / t2, -e2.top / n2, 1];
    }
    applyTo2d({ imageData: { data: e2, width: t2, height: n2 }, filterBackend: { resources: r2 } }) {
      let i2 = this.image;
      r2.blendImage || (r2.blendImage = P());
      let a2 = r2.blendImage, o2 = a2.getContext(`2d`);
      a2.width !== t2 || a2.height !== n2 ? (a2.width = t2, a2.height = n2) : o2.clearRect(0, 0, t2, n2), o2.setTransform(i2.scaleX, 0, 0, i2.scaleY, i2.left, i2.top), o2.drawImage(i2.getElement(), 0, 0, t2, n2);
      let s2 = o2.getImageData(0, 0, t2, n2).data;
      for (let t3 = 0; t3 < e2.length; t3 += 4) {
        let n3 = e2[t3], r3 = e2[t3 + 1], i3 = e2[t3 + 2], a3 = e2[t3 + 3], o3 = s2[t3], c2 = s2[t3 + 1], l2 = s2[t3 + 2], u2 = s2[t3 + 3];
        switch (this.mode) {
          case `multiply`:
            e2[t3] = n3 * o3 / 255, e2[t3 + 1] = r3 * c2 / 255, e2[t3 + 2] = i3 * l2 / 255, e2[t3 + 3] = a3 * u2 / 255;
            break;
          case `mask`:
            e2[t3 + 3] = u2;
        }
      }
    }
    sendUniformData(e2, t2) {
      let n2 = this.calculateMatrix();
      e2.uniform1i(t2.uImage, 1), e2.uniformMatrix3fv(t2.uTransformMatrix, false, n2);
    }
    toObject() {
      return { ...super.toObject(), image: this.image && this.image.toObject() };
    }
    static async fromObject({ type: e2, image: t2, ...n2 }, r2) {
      return ws.fromObject(t2, r2).then((e3) => new this({ ...n2, image: e3 }));
    }
  };
  i(qs, `type`, `BlendImage`), i(qs, `defaults`, { mode: `multiply`, alpha: 1 }), i(qs, `uniformLocations`, [`uTransformMatrix`, `uImage`]), M.setClass(qs);
  var Js = class extends $ {
    getFragmentSource() {
      return `
    precision highp float;
    uniform sampler2D uTexture;
    uniform vec2 uDelta;
    varying vec2 vTexCoord;
    const float nSamples = 15.0;
    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);
    float random(vec3 scale) {
      /* use the fragment position for a different seed per-pixel */
      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);
    }
    void main() {
      vec4 color = vec4(0.0);
      float totalC = 0.0;
      float totalA = 0.0;
      float offset = random(v3offset);
      for (float t = -nSamples; t <= nSamples; t++) {
        float percent = (t + offset - 0.5) / nSamples;
        vec4 sample = texture2D(uTexture, vTexCoord + uDelta * percent);
        float weight = 1.0 - abs(percent);
        float alpha = weight * sample.a;
        color.rgb += sample.rgb * alpha;
        color.a += alpha;
        totalA += weight;
        totalC += alpha;
      }
      gl_FragColor.rgb = color.rgb / totalC;
      gl_FragColor.a = color.a / totalA;
    }
  `;
    }
    applyTo(e2) {
      zs(e2) ? (this.aspectRatio = e2.sourceWidth / e2.sourceHeight, e2.passes++, this._setupFrameBuffer(e2), this.horizontal = true, this.applyToWebGL(e2), this._swapTextures(e2), this._setupFrameBuffer(e2), this.horizontal = false, this.applyToWebGL(e2), this._swapTextures(e2)) : this.applyTo2d(e2);
    }
    applyTo2d({ imageData: { data: e2, width: t2, height: n2 } }) {
      this.aspectRatio = t2 / n2, this.horizontal = true;
      let r2 = this.getBlurValue() * t2, i2 = new Uint8ClampedArray(e2), a2 = 4 * t2;
      for (let t3 = 0; t3 < e2.length; t3 += 4) {
        let n3 = 0, o2 = 0, s2 = 0, c2 = 0, l2 = 0, u2 = t3 - t3 % a2, d2 = u2 + a2;
        for (let i3 = -14; i3 < 15; i3++) {
          let a3 = i3 / 15, f2 = 4 * Math.floor(r2 * a3), p2 = 1 - Math.abs(a3), m = t3 + f2;
          m < u2 ? m = u2 : m > d2 && (m = d2);
          let h2 = e2[m + 3] * p2;
          n3 += e2[m] * h2, o2 += e2[m + 1] * h2, s2 += e2[m + 2] * h2, c2 += h2, l2 += p2;
        }
        i2[t3] = n3 / c2, i2[t3 + 1] = o2 / c2, i2[t3 + 2] = s2 / c2, i2[t3 + 3] = c2 / l2;
      }
      this.horizontal = false, r2 = this.getBlurValue() * n2;
      for (let t3 = 0; t3 < i2.length; t3 += 4) {
        let n3 = 0, o2 = 0, s2 = 0, c2 = 0, l2 = 0, u2 = t3 % a2, d2 = i2.length - a2 + u2;
        for (let e3 = -14; e3 < 15; e3++) {
          let f2 = e3 / 15, p2 = Math.floor(r2 * f2) * a2, m = 1 - Math.abs(f2), h2 = t3 + p2;
          h2 < u2 ? h2 = u2 : h2 > d2 && (h2 = d2);
          let g2 = i2[h2 + 3] * m;
          n3 += i2[h2] * g2, o2 += i2[h2 + 1] * g2, s2 += i2[h2 + 2] * g2, c2 += g2, l2 += m;
        }
        e2[t3] = n3 / c2, e2[t3 + 1] = o2 / c2, e2[t3 + 2] = s2 / c2, e2[t3 + 3] = c2 / l2;
      }
    }
    sendUniformData(e2, t2) {
      let n2 = this.chooseRightDelta();
      e2.uniform2fv(t2.uDelta, n2);
    }
    isNeutralState() {
      return this.blur === 0;
    }
    getBlurValue() {
      let e2 = 1, { horizontal: t2, aspectRatio: n2 } = this;
      return t2 ? n2 > 1 && (e2 = 1 / n2) : n2 < 1 && (e2 = n2), e2 * this.blur * 0.12;
    }
    chooseRightDelta() {
      let e2 = this.getBlurValue();
      return this.horizontal ? [e2, 0] : [0, e2];
    }
  };
  i(Js, `type`, `Blur`), i(Js, `defaults`, { blur: 0 }), i(Js, `uniformLocations`, [`uDelta`]), M.setClass(Js);
  var Ys = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBrightness;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += uBrightness;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = Math.round(255 * this.brightness);
      for (let n2 = 0; n2 < e2.length; n2 += 4) e2[n2] += t2, e2[n2 + 1] += t2, e2[n2 + 2] += t2;
    }
    isNeutralState() {
      return this.brightness === 0;
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uBrightness, this.brightness);
    }
  };
  i(Ys, `type`, `Brightness`), i(Ys, `defaults`, { brightness: 0 }), i(Ys, `uniformLocations`, [`uBrightness`]), M.setClass(Ys);
  const Xs = { matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], colorsOnly: true };
  var Zs = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  varying vec2 vTexCoord;
  uniform mat4 uColorMatrix;
  uniform vec4 uConstants;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color *= uColorMatrix;
    color += uConstants;
    gl_FragColor = color;
  }`;
    }
    applyTo2d(e2) {
      let t2 = e2.imageData.data, n2 = this.matrix, r2 = this.colorsOnly;
      for (let e3 = 0; e3 < t2.length; e3 += 4) {
        let i2 = t2[e3], a2 = t2[e3 + 1], o2 = t2[e3 + 2];
        if (t2[e3] = i2 * n2[0] + a2 * n2[1] + o2 * n2[2] + 255 * n2[4], t2[e3 + 1] = i2 * n2[5] + a2 * n2[6] + o2 * n2[7] + 255 * n2[9], t2[e3 + 2] = i2 * n2[10] + a2 * n2[11] + o2 * n2[12] + 255 * n2[14], !r2) {
          let r3 = t2[e3 + 3];
          t2[e3] += r3 * n2[3], t2[e3 + 1] += r3 * n2[8], t2[e3 + 2] += r3 * n2[13], t2[e3 + 3] = i2 * n2[15] + a2 * n2[16] + o2 * n2[17] + r3 * n2[18] + 255 * n2[19];
        }
      }
    }
    sendUniformData(e2, t2) {
      let n2 = this.matrix, r2 = [n2[0], n2[1], n2[2], n2[3], n2[5], n2[6], n2[7], n2[8], n2[10], n2[11], n2[12], n2[13], n2[15], n2[16], n2[17], n2[18]], i2 = [n2[4], n2[9], n2[14], n2[19]];
      e2.uniformMatrix4fv(t2.uColorMatrix, false, r2), e2.uniform4fv(t2.uConstants, i2);
    }
    toObject() {
      return { ...super.toObject(), matrix: [...this.matrix] };
    }
  };
  function Qs(e2, t2) {
    var n2;
    let r2 = (i(n2 = class extends Zs {
      toObject() {
        return { type: this.type, colorsOnly: this.colorsOnly };
      }
    }, `type`, e2), i(n2, `defaults`, { colorsOnly: false, matrix: t2 }), n2);
    return M.setClass(r2, e2), r2;
  }
  i(Zs, `type`, `ColorMatrix`), i(Zs, `defaults`, Xs), i(Zs, `uniformLocations`, [`uColorMatrix`, `uConstants`]), M.setClass(Zs);
  const $s = Qs(`Brownie`, [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0]), ec = Qs(`Vintage`, [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0]), tc = Qs(`Kodachrome`, [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0]), nc = Qs(`Technicolor`, [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.2311, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0]), rc = Qs(`Polaroid`, [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0]), ic = Qs(`Sepia`, [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0]), ac = Qs(`BlackWhite`, [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]);
  var oc = class extends $ {
    constructor(e2 = {}) {
      super(e2), this.subFilters = e2.subFilters || [];
    }
    applyTo(e2) {
      zs(e2) && (e2.passes += this.subFilters.length - 1), this.subFilters.forEach((t2) => {
        t2.applyTo(e2);
      });
    }
    toObject() {
      return { type: this.type, subFilters: this.subFilters.map((e2) => e2.toObject()) };
    }
    isNeutralState() {
      return !this.subFilters.some((e2) => !e2.isNeutralState());
    }
    static fromObject(e2, t2) {
      return Promise.all((e2.subFilters || []).map((e3) => M.getClass(e3.type).fromObject(e3, t2))).then((e3) => new this({ subFilters: e3 }));
    }
  };
  i(oc, `type`, `Composed`), M.setClass(oc);
  var sc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uContrast;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));
    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;
    gl_FragColor = color;
  }`;
    }
    isNeutralState() {
      return this.contrast === 0;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = Math.floor(255 * this.contrast), n2 = 259 * (t2 + 255) / (255 * (259 - t2));
      for (let t3 = 0; t3 < e2.length; t3 += 4) e2[t3] = n2 * (e2[t3] - 128) + 128, e2[t3 + 1] = n2 * (e2[t3 + 1] - 128) + 128, e2[t3 + 2] = n2 * (e2[t3 + 2] - 128) + 128;
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uContrast, this.contrast);
    }
  };
  i(sc, `type`, `Contrast`), i(sc, `defaults`, { contrast: 0 }), i(sc, `uniformLocations`, [`uContrast`]), M.setClass(sc);
  const cc = { Convolute_3_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_3_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[9];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 3.0; h+=1.0) {
        for (float w = 0.0; w < 3.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_5_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_5_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[25];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 5.0; h+=1.0) {
        for (float w = 0.0; w < 5.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_7_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_7_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[49];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 7.0; h+=1.0) {
        for (float w = 0.0; w < 7.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    `, Convolute_9_1: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 0);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];
        }
      }
      gl_FragColor = color;
    }
    `, Convolute_9_0: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[81];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = vec4(0, 0, 0, 1);
      for (float h = 0.0; h < 9.0; h+=1.0) {
        for (float w = 0.0; w < 9.0; w+=1.0) {
          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));
          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];
        }
      }
      float alpha = texture2D(uTexture, vTexCoord).a;
      gl_FragColor = color;
      gl_FragColor.a = alpha;
    }
    ` };
  var lc = class extends $ {
    getCacheKey() {
      return `${this.type}_${Math.sqrt(this.matrix.length)}_${+!!this.opaque}`;
    }
    getFragmentSource() {
      return cc[this.getCacheKey()];
    }
    applyTo2d(e2) {
      let t2 = e2.imageData, n2 = t2.data, r2 = this.matrix, i2 = Math.round(Math.sqrt(r2.length)), a2 = Math.floor(i2 / 2), o2 = t2.width, s2 = t2.height, c2 = e2.ctx.createImageData(o2, s2), l2 = c2.data, u2 = +!!this.opaque, d2, f2, p2, m, h2, g2, _2, v2, y2, b2, x2, S2, C2;
      for (x2 = 0; x2 < s2; x2++) for (b2 = 0; b2 < o2; b2++) {
        for (h2 = 4 * (x2 * o2 + b2), d2 = 0, f2 = 0, p2 = 0, m = 0, C2 = 0; C2 < i2; C2++) for (S2 = 0; S2 < i2; S2++) _2 = x2 + C2 - a2, g2 = b2 + S2 - a2, _2 < 0 || _2 >= s2 || g2 < 0 || g2 >= o2 || (v2 = 4 * (_2 * o2 + g2), y2 = r2[C2 * i2 + S2], d2 += n2[v2] * y2, f2 += n2[v2 + 1] * y2, p2 += n2[v2 + 2] * y2, u2 || (m += n2[v2 + 3] * y2));
        l2[h2] = d2, l2[h2 + 1] = f2, l2[h2 + 2] = p2, l2[h2 + 3] = u2 ? n2[h2 + 3] : m;
      }
      e2.imageData = c2;
    }
    sendUniformData(e2, t2) {
      e2.uniform1fv(t2.uMatrix, this.matrix);
    }
    toObject() {
      return { ...super.toObject(), opaque: this.opaque, matrix: [...this.matrix] };
    }
  };
  i(lc, `type`, `Convolute`), i(lc, `defaults`, { opaque: false, matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0] }), i(lc, `uniformLocations`, [`uMatrix`, `uOpaque`, `uHalfSize`, `uSize`]), M.setClass(lc);
  const uc = `Gamma`;
  var dc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform vec3 uGamma;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    vec3 correction = (1.0 / uGamma);
    color.r = pow(color.r, correction.r);
    color.g = pow(color.g, correction.g);
    color.b = pow(color.b, correction.b);
    gl_FragColor = color;
    gl_FragColor.rgb *= color.a;
  }
`;
    }
    constructor(e2 = {}) {
      super(e2), this.gamma = e2.gamma || this.constructor.defaults.gamma.concat();
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = this.gamma, n2 = 1 / t2[0], r2 = 1 / t2[1], i2 = 1 / t2[2];
      this.rgbValues || (this.rgbValues = { r: new Uint8Array(256), g: new Uint8Array(256), b: new Uint8Array(256) });
      let a2 = this.rgbValues;
      for (let e3 = 0; e3 < 256; e3++) a2.r[e3] = 255 * (e3 / 255) ** n2, a2.g[e3] = 255 * (e3 / 255) ** r2, a2.b[e3] = 255 * (e3 / 255) ** i2;
      for (let t3 = 0; t3 < e2.length; t3 += 4) e2[t3] = a2.r[e2[t3]], e2[t3 + 1] = a2.g[e2[t3 + 1]], e2[t3 + 2] = a2.b[e2[t3 + 2]];
    }
    sendUniformData(e2, t2) {
      e2.uniform3fv(t2.uGamma, this.gamma);
    }
    isNeutralState() {
      let { gamma: e2 } = this;
      return e2[0] === 1 && e2[1] === 1 && e2[2] === 1;
    }
    toObject() {
      return { type: uc, gamma: this.gamma.concat() };
    }
  };
  i(dc, `type`, uc), i(dc, `defaults`, { gamma: [1, 1, 1] }), i(dc, `uniformLocations`, [`uGamma`]), M.setClass(dc);
  const fc = { average: `
    precision highp float;
    uniform sampler2D uTexture;
    varying vec2 vTexCoord;
    void main() {
      vec4 color = texture2D(uTexture, vTexCoord);
      float average = (color.r + color.b + color.g) / 3.0;
      gl_FragColor = vec4(average, average, average, color.a);
    }
    `, lightness: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    `, luminosity: `
    precision highp float;
    uniform sampler2D uTexture;
    uniform int uMode;
    varying vec2 vTexCoord;
    void main() {
      vec4 col = texture2D(uTexture, vTexCoord);
      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;
      gl_FragColor = vec4(average, average, average, col.a);
    }
    ` };
  var pc = class extends $ {
    applyTo2d({ imageData: { data: e2 } }) {
      for (let t2, n2 = 0; n2 < e2.length; n2 += 4) {
        let r2 = e2[n2], i2 = e2[n2 + 1], a2 = e2[n2 + 2];
        switch (this.mode) {
          case `average`:
            t2 = (r2 + i2 + a2) / 3;
            break;
          case `lightness`:
            t2 = (Math.min(r2, i2, a2) + Math.max(r2, i2, a2)) / 2;
            break;
          case `luminosity`:
            t2 = 0.21 * r2 + 0.72 * i2 + 0.07 * a2;
        }
        e2[n2 + 2] = e2[n2 + 1] = e2[n2] = t2;
      }
    }
    getCacheKey() {
      return `${this.type}_${this.mode}`;
    }
    getFragmentSource() {
      return fc[this.mode];
    }
    sendUniformData(e2, t2) {
      e2.uniform1i(t2.uMode, 1);
    }
    isNeutralState() {
      return false;
    }
  };
  i(pc, `type`, `Grayscale`), i(pc, `defaults`, { mode: `average` }), i(pc, `uniformLocations`, [`uMode`]), M.setClass(pc);
  const mc = { ...Xs, rotation: 0 };
  var hc = class extends Zs {
    calculateMatrix() {
      let e2 = this.rotation * Math.PI, t2 = Se(e2), n2 = Ce(e2), r2 = 1 / 3, i2 = Math.sqrt(r2) * n2, a2 = 1 - t2;
      this.matrix = [t2 + a2 / 3, r2 * a2 - i2, r2 * a2 + i2, 0, 0, r2 * a2 + i2, t2 + r2 * a2, r2 * a2 - i2, 0, 0, r2 * a2 - i2, r2 * a2 + i2, t2 + r2 * a2, 0, 0, 0, 0, 0, 1, 0];
    }
    isNeutralState() {
      return this.rotation === 0;
    }
    applyTo(e2) {
      this.calculateMatrix(), super.applyTo(e2);
    }
    toObject() {
      return { type: this.type, rotation: this.rotation };
    }
  };
  i(hc, `type`, `HueRotation`), i(hc, `defaults`, mc), M.setClass(hc);
  var gc = class extends $ {
    applyTo2d({ imageData: { data: e2 } }) {
      for (let t2 = 0; t2 < e2.length; t2 += 4) e2[t2] = 255 - e2[t2], e2[t2 + 1] = 255 - e2[t2 + 1], e2[t2 + 2] = 255 - e2[t2 + 2], this.alpha && (e2[t2 + 3] = 255 - e2[t2 + 3]);
    }
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform int uInvert;
  uniform int uAlpha;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    if (uInvert == 1) {
      if (uAlpha == 1) {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);
      } else {
        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);
      }
    } else {
      gl_FragColor = color;
    }
  }
`;
    }
    isNeutralState() {
      return !this.invert;
    }
    sendUniformData(e2, t2) {
      e2.uniform1i(t2.uInvert, Number(this.invert)), e2.uniform1i(t2.uAlpha, Number(this.alpha));
    }
  };
  i(gc, `type`, `Invert`), i(gc, `defaults`, { alpha: false, invert: true }), i(gc, `uniformLocations`, [`uInvert`, `uAlpha`]), M.setClass(gc);
  var _c = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uStepH;
  uniform float uNoise;
  uniform float uSeed;
  varying vec2 vTexCoord;
  float rand(vec2 co, float seed, float vScale) {
    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);
  }
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = this.noise;
      for (let n2 = 0; n2 < e2.length; n2 += 4) {
        let r2 = (0.5 - Math.random()) * t2;
        e2[n2] += r2, e2[n2 + 1] += r2, e2[n2 + 2] += r2;
      }
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uNoise, this.noise / 255), e2.uniform1f(t2.uSeed, Math.random());
    }
    isNeutralState() {
      return this.noise === 0;
    }
  };
  i(_c, `type`, `Noise`), i(_c, `defaults`, { noise: 0 }), i(_c, `uniformLocations`, [`uNoise`, `uSeed`]), M.setClass(_c);
  var vc = class extends $ {
    applyTo2d({ imageData: { data: e2, width: t2, height: n2 } }) {
      for (let r2 = 0; r2 < n2; r2 += this.blocksize) for (let i2 = 0; i2 < t2; i2 += this.blocksize) {
        let a2 = 4 * r2 * t2 + 4 * i2, o2 = e2[a2], s2 = e2[a2 + 1], c2 = e2[a2 + 2], l2 = e2[a2 + 3];
        for (let a3 = r2; a3 < Math.min(r2 + this.blocksize, n2); a3++) for (let n3 = i2; n3 < Math.min(i2 + this.blocksize, t2); n3++) {
          let r3 = 4 * a3 * t2 + 4 * n3;
          e2[r3] = o2, e2[r3 + 1] = s2, e2[r3 + 2] = c2, e2[r3 + 3] = l2;
        }
      }
    }
    isNeutralState() {
      return this.blocksize === 1;
    }
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uBlocksize;
  uniform float uStepW;
  uniform float uStepH;
  varying vec2 vTexCoord;
  void main() {
    float blockW = uBlocksize * uStepW;
    float blockH = uBlocksize * uStepH;
    int posX = int(vTexCoord.x / blockW);
    int posY = int(vTexCoord.y / blockH);
    float fposX = float(posX);
    float fposY = float(posY);
    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);
    vec4 color = texture2D(uTexture, squareCoords);
    gl_FragColor = color;
  }
`;
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uBlocksize, this.blocksize);
    }
  };
  i(vc, `type`, `Pixelate`), i(vc, `defaults`, { blocksize: 4 }), i(vc, `uniformLocations`, [`uBlocksize`]), M.setClass(vc);
  var yc = class extends $ {
    getFragmentSource() {
      return `
precision highp float;
uniform sampler2D uTexture;
uniform vec4 uLow;
uniform vec4 uHigh;
varying vec2 vTexCoord;
void main() {
  gl_FragColor = texture2D(uTexture, vTexCoord);
  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {
    gl_FragColor.a = 0.0;
  }
}
`;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = 255 * this.distance, n2 = new G(this.color).getSource(), r2 = [n2[0] - t2, n2[1] - t2, n2[2] - t2], i2 = [n2[0] + t2, n2[1] + t2, n2[2] + t2];
      for (let t3 = 0; t3 < e2.length; t3 += 4) {
        let n3 = e2[t3], a2 = e2[t3 + 1], o2 = e2[t3 + 2];
        n3 > r2[0] && a2 > r2[1] && o2 > r2[2] && n3 < i2[0] && a2 < i2[1] && o2 < i2[2] && (e2[t3 + 3] = 0);
      }
    }
    sendUniformData(e2, t2) {
      let n2 = new G(this.color).getSource(), r2 = this.distance, i2 = [0 + n2[0] / 255 - r2, 0 + n2[1] / 255 - r2, 0 + n2[2] / 255 - r2, 1], a2 = [n2[0] / 255 + r2, n2[1] / 255 + r2, n2[2] / 255 + r2, 1];
      e2.uniform4fv(t2.uLow, i2), e2.uniform4fv(t2.uHigh, a2);
    }
  };
  i(yc, `type`, `RemoveColor`), i(yc, `defaults`, { color: `#FFFFFF`, distance: 0.02, useAlpha: false }), i(yc, `uniformLocations`, [`uLow`, `uHigh`]), M.setClass(yc);
  var bc = class extends $ {
    sendUniformData(e2, t2) {
      e2.uniform2fv(t2.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]), e2.uniform1fv(t2.uTaps, this.taps);
    }
    getFilterWindow() {
      let e2 = this.tempScale;
      return Math.ceil(this.lanczosLobes / e2);
    }
    getCacheKey() {
      let e2 = this.getFilterWindow();
      return `${this.type}_${e2}`;
    }
    getFragmentSource() {
      let e2 = this.getFilterWindow();
      return this.generateShader(e2);
    }
    getTaps() {
      let e2 = this.lanczosCreate(this.lanczosLobes), t2 = this.tempScale, n2 = this.getFilterWindow(), r2 = Array(n2);
      for (let i2 = 1; i2 <= n2; i2++) r2[i2 - 1] = e2(i2 * t2);
      return r2;
    }
    generateShader(e2) {
      let t2 = Array(e2);
      for (let n2 = 1; n2 <= e2; n2++) t2[n2 - 1] = `${n2}.0 * uDelta`;
      return `
      precision highp float;
      uniform sampler2D uTexture;
      uniform vec2 uDelta;
      varying vec2 vTexCoord;
      uniform float uTaps[${e2}];
      void main() {
        vec4 color = texture2D(uTexture, vTexCoord);
        float sum = 1.0;
        ${t2.map((e3, t3) => `
              color += texture2D(uTexture, vTexCoord + ${e3}) * uTaps[${t3}] + texture2D(uTexture, vTexCoord - ${e3}) * uTaps[${t3}];
              sum += 2.0 * uTaps[${t3}];
            `).join(`
`)}
        gl_FragColor = color / sum;
      }
    `;
    }
    applyToForWebgl(e2) {
      e2.passes++, this.width = e2.sourceWidth, this.horizontal = true, this.dW = Math.round(this.width * this.scaleX), this.dH = e2.sourceHeight, this.tempScale = this.dW / this.width, this.taps = this.getTaps(), e2.destinationWidth = this.dW, super.applyTo(e2), e2.sourceWidth = e2.destinationWidth, this.height = e2.sourceHeight, this.horizontal = false, this.dH = Math.round(this.height * this.scaleY), this.tempScale = this.dH / this.height, this.taps = this.getTaps(), e2.destinationHeight = this.dH, super.applyTo(e2), e2.sourceHeight = e2.destinationHeight;
    }
    applyTo(e2) {
      zs(e2) ? this.applyToForWebgl(e2) : this.applyTo2d(e2);
    }
    isNeutralState() {
      return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(e2) {
      return (t2) => {
        if (t2 >= e2 || t2 <= -e2) return 0;
        if (t2 < 11920929e-14 && t2 > -11920929e-14) return 1;
        let n2 = (t2 *= Math.PI) / e2;
        return Math.sin(t2) / t2 * Math.sin(n2) / n2;
      };
    }
    applyTo2d(e2) {
      let t2 = e2.imageData, n2 = this.scaleX, r2 = this.scaleY;
      this.rcpScaleX = 1 / n2, this.rcpScaleY = 1 / r2;
      let i2 = t2.width, a2 = t2.height, o2 = Math.round(i2 * n2), s2 = Math.round(a2 * r2), c2;
      c2 = this.resizeType === `sliceHack` ? this.sliceByTwo(e2, i2, a2, o2, s2) : this.resizeType === `hermite` ? this.hermiteFastResize(e2, i2, a2, o2, s2) : this.resizeType === `bilinear` ? this.bilinearFiltering(e2, i2, a2, o2, s2) : this.resizeType === `lanczos` ? this.lanczosResize(e2, i2, a2, o2, s2) : new ImageData(o2, s2), e2.imageData = c2;
    }
    sliceByTwo(e2, t2, n2, r2, i2) {
      let a2 = e2.imageData, o2 = 0.5, s2 = false, c2 = false, l2 = t2 * o2, u2 = n2 * o2, d2 = e2.filterBackend.resources, f2 = 0, p2 = 0, m = t2, h2 = 0;
      d2.sliceByTwo || (d2.sliceByTwo = P());
      let g2 = d2.sliceByTwo;
      (g2.width < 1.5 * t2 || g2.height < n2) && (g2.width = 1.5 * t2, g2.height = n2);
      let _2 = g2.getContext(`2d`);
      for (_2.clearRect(0, 0, 1.5 * t2, n2), _2.putImageData(a2, 0, 0), r2 = Math.floor(r2), i2 = Math.floor(i2); !s2 || !c2; ) t2 = l2, n2 = u2, r2 < Math.floor(l2 * o2) ? l2 = Math.floor(l2 * o2) : (l2 = r2, s2 = true), i2 < Math.floor(u2 * o2) ? u2 = Math.floor(u2 * o2) : (u2 = i2, c2 = true), _2.drawImage(g2, f2, p2, t2, n2, m, h2, l2, u2), f2 = m, p2 = h2, h2 += u2;
      return _2.getImageData(f2, p2, r2, i2);
    }
    lanczosResize(e2, t2, n2, r2, i2) {
      let a2 = e2.imageData.data, o2 = e2.ctx.createImageData(r2, i2), s2 = o2.data, c2 = this.lanczosCreate(this.lanczosLobes), l2 = this.rcpScaleX, u2 = this.rcpScaleY, d2 = 2 / this.rcpScaleX, f2 = 2 / this.rcpScaleY, p2 = Math.ceil(l2 * this.lanczosLobes / 2), m = Math.ceil(u2 * this.lanczosLobes / 2), h2 = {}, g2 = { x: 0, y: 0 }, _2 = { x: 0, y: 0 };
      return (function e3(v2) {
        let y2, b2, x2, S2, C2, w2, ee2, T2, E2, D2, O2;
        for (g2.x = (v2 + 0.5) * l2, _2.x = Math.floor(g2.x), y2 = 0; y2 < i2; y2++) {
          for (g2.y = (y2 + 0.5) * u2, _2.y = Math.floor(g2.y), C2 = 0, w2 = 0, ee2 = 0, T2 = 0, E2 = 0, b2 = _2.x - p2; b2 <= _2.x + p2; b2++) if (!(b2 < 0 || b2 >= t2)) {
            D2 = Math.floor(1e3 * Math.abs(b2 - g2.x)), h2[D2] || (h2[D2] = {});
            for (let e4 = _2.y - m; e4 <= _2.y + m; e4++) e4 < 0 || e4 >= n2 || (O2 = Math.floor(1e3 * Math.abs(e4 - g2.y)), h2[D2][O2] || (h2[D2][O2] = c2(Math.sqrt((D2 * d2) ** 2 + (O2 * f2) ** 2) / 1e3)), x2 = h2[D2][O2], x2 > 0 && (S2 = 4 * (e4 * t2 + b2), C2 += x2, w2 += x2 * a2[S2], ee2 += x2 * a2[S2 + 1], T2 += x2 * a2[S2 + 2], E2 += x2 * a2[S2 + 3]));
          }
          S2 = 4 * (y2 * r2 + v2), s2[S2] = w2 / C2, s2[S2 + 1] = ee2 / C2, s2[S2 + 2] = T2 / C2, s2[S2 + 3] = E2 / C2;
        }
        return ++v2 < r2 ? e3(v2) : o2;
      })(0);
    }
    bilinearFiltering(e2, t2, n2, r2, i2) {
      let a2, o2, s2, c2, l2, u2, d2, f2, p2, m, h2, g2, _2, v2 = 0, y2 = this.rcpScaleX, b2 = this.rcpScaleY, x2 = 4 * (t2 - 1), S2 = e2.imageData.data, C2 = e2.ctx.createImageData(r2, i2), w2 = C2.data;
      for (d2 = 0; d2 < i2; d2++) for (f2 = 0; f2 < r2; f2++) for (l2 = Math.floor(y2 * f2), u2 = Math.floor(b2 * d2), p2 = y2 * f2 - l2, m = b2 * d2 - u2, _2 = 4 * (u2 * t2 + l2), h2 = 0; h2 < 4; h2++) a2 = S2[_2 + h2], o2 = S2[_2 + 4 + h2], s2 = S2[_2 + x2 + h2], c2 = S2[_2 + x2 + 4 + h2], g2 = a2 * (1 - p2) * (1 - m) + o2 * p2 * (1 - m) + s2 * m * (1 - p2) + c2 * p2 * m, w2[v2++] = g2;
      return C2;
    }
    hermiteFastResize(e2, t2, n2, r2, i2) {
      let a2 = this.rcpScaleX, o2 = this.rcpScaleY, s2 = Math.ceil(a2 / 2), c2 = Math.ceil(o2 / 2), l2 = e2.imageData.data, u2 = e2.ctx.createImageData(r2, i2), d2 = u2.data;
      for (let e3 = 0; e3 < i2; e3++) for (let n3 = 0; n3 < r2; n3++) {
        let i3 = 4 * (n3 + e3 * r2), u3, f2 = 0, p2 = 0, m = 0, h2 = 0, g2 = 0, _2 = 0, v2 = (e3 + 0.5) * o2;
        for (let r3 = Math.floor(e3 * o2); r3 < (e3 + 1) * o2; r3++) {
          let e4 = Math.abs(v2 - (r3 + 0.5)) / c2, i4 = (n3 + 0.5) * a2, o3 = e4 * e4;
          for (let e5 = Math.floor(n3 * a2); e5 < (n3 + 1) * a2; e5++) {
            let n4 = Math.abs(i4 - (e5 + 0.5)) / s2, a3 = Math.sqrt(o3 + n4 * n4);
            a3 > 1 && a3 < -1 || (u3 = 2 * a3 * a3 * a3 - 3 * a3 * a3 + 1, u3 > 0 && (n4 = 4 * (e5 + r3 * t2), _2 += u3 * l2[n4 + 3], p2 += u3, l2[n4 + 3] < 255 && (u3 = u3 * l2[n4 + 3] / 250), m += u3 * l2[n4], h2 += u3 * l2[n4 + 1], g2 += u3 * l2[n4 + 2], f2 += u3));
          }
        }
        d2[i3] = m / f2, d2[i3 + 1] = h2 / f2, d2[i3 + 2] = g2 / f2, d2[i3 + 3] = _2 / p2;
      }
      return u2;
    }
  };
  i(bc, `type`, `Resize`), i(bc, `defaults`, { resizeType: `hermite`, scaleX: 1, scaleY: 1, lanczosLobes: 3 }), i(bc, `uniformLocations`, [`uDelta`, `uTaps`]), M.setClass(bc);
  var xc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uSaturation;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float rgMax = max(color.r, color.g);
    float rgbMax = max(rgMax, color.b);
    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;
    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;
    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = -this.saturation;
      for (let n2 = 0; n2 < e2.length; n2 += 4) {
        let r2 = e2[n2], i2 = e2[n2 + 1], a2 = e2[n2 + 2], o2 = Math.max(r2, i2, a2);
        e2[n2] += o2 === r2 ? 0 : (o2 - r2) * t2, e2[n2 + 1] += o2 === i2 ? 0 : (o2 - i2) * t2, e2[n2 + 2] += o2 === a2 ? 0 : (o2 - a2) * t2;
      }
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uSaturation, -this.saturation);
    }
    isNeutralState() {
      return this.saturation === 0;
    }
  };
  i(xc, `type`, `Saturation`), i(xc, `defaults`, { saturation: 0 }), i(xc, `uniformLocations`, [`uSaturation`]), M.setClass(xc);
  var Sc = class extends $ {
    getFragmentSource() {
      return `
  precision highp float;
  uniform sampler2D uTexture;
  uniform float uVibrance;
  varying vec2 vTexCoord;
  void main() {
    vec4 color = texture2D(uTexture, vTexCoord);
    float max = max(color.r, max(color.g, color.b));
    float avg = (color.r + color.g + color.b) / 3.0;
    float amt = (abs(max - avg) * 2.0) * uVibrance;
    color.r += max != color.r ? (max - color.r) * amt : 0.00;
    color.g += max != color.g ? (max - color.g) * amt : 0.00;
    color.b += max != color.b ? (max - color.b) * amt : 0.00;
    gl_FragColor = color;
  }
`;
    }
    applyTo2d({ imageData: { data: e2 } }) {
      let t2 = -this.vibrance;
      for (let n2 = 0; n2 < e2.length; n2 += 4) {
        let r2 = e2[n2], i2 = e2[n2 + 1], a2 = e2[n2 + 2], o2 = Math.max(r2, i2, a2), s2 = (r2 + i2 + a2) / 3, c2 = 2 * Math.abs(o2 - s2) / 255 * t2;
        e2[n2] += o2 === r2 ? 0 : (o2 - r2) * c2, e2[n2 + 1] += o2 === i2 ? 0 : (o2 - i2) * c2, e2[n2 + 2] += o2 === a2 ? 0 : (o2 - a2) * c2;
      }
    }
    sendUniformData(e2, t2) {
      e2.uniform1f(t2.uVibrance, -this.vibrance);
    }
    isNeutralState() {
      return this.vibrance === 0;
    }
  };
  i(Sc, `type`, `Vibrance`), i(Sc, `defaults`, { vibrance: 0 }), i(Sc, `uniformLocations`, [`uVibrance`]), M.setClass(Sc);
  t({ BaseFilter: () => $, BlackWhite: () => ac, BlendColor: () => Gs, BlendImage: () => qs, Blur: () => Js, Brightness: () => Ys, Brownie: () => $s, ColorMatrix: () => Zs, Composed: () => oc, Contrast: () => sc, Convolute: () => lc, Gamma: () => dc, Grayscale: () => pc, HueRotation: () => hc, Invert: () => gc, Kodachrome: () => tc, Noise: () => _c, Pixelate: () => vc, Polaroid: () => rc, RemoveColor: () => yc, Resize: () => bc, Saturation: () => xc, Sepia: () => ic, Technicolor: () => nc, Vibrance: () => Sc, Vintage: () => ec });
  const CENTER_SNAP_THRESHOLD = 7;
  function resolveCenterAlignment(point, canvasSize, threshold = CENTER_SNAP_THRESHOLD) {
    const centerX = Number(canvasSize?.width || 0) / 2;
    const centerY = Number(canvasSize?.height || 0) / 2;
    const sourceX = Number(point?.x || 0);
    const sourceY = Number(point?.y || 0);
    const vertical = Math.abs(sourceX - centerX) <= threshold;
    const horizontal = Math.abs(sourceY - centerY) <= threshold;
    return {
      vertical,
      horizontal,
      x: vertical ? centerX : sourceX,
      y: horizontal ? centerY : sourceY,
      centerX,
      centerY
    };
  }
  J.customProperties = ["assetId", "assetName", "sourceWidth", "sourceHeight", "kind", "originalSource", "fontPreset", "textEffect", "paintFirst", "strokeLineJoin"];
  class DesignCanvas extends EventTarget {
    constructor(element, product) {
      super();
      __privateAdd(this, _DesignCanvas_instances);
      this.canvas = new ho(element, {
        preserveObjectStacking: true,
        selection: true,
        backgroundColor: "transparent"
      });
      this.product = product;
      this.history = [];
      this.future = [];
      this.restoring = false;
      this.saveTimer = null;
      this.guideTimer = null;
      this.centerGuides = { vertical: false, horizontal: false };
      this.setProduct(product);
      __privateMethod(this, _DesignCanvas_instances, bind_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
    }
    setProduct(product) {
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
      this.product = product;
      const width = 720;
      const height = Math.round(width * product.physical.heightIn / product.physical.widthIn);
      this.canvas.setDimensions({ width, height });
      this.canvas.requestRenderAll();
    }
    async addImage(source, meta = {}) {
      const loadOptions = String(source).startsWith("data:") ? {} : { crossOrigin: "anonymous" };
      const image = await ws.fromURL(source, loadOptions);
      image.set({
        assetId: meta.assetId || crypto.randomUUID(),
        assetName: meta.assetName || "设计图片",
        sourceWidth: meta.sourceWidth || image.width,
        sourceHeight: meta.sourceHeight || image.height,
        kind: meta.kind || "image",
        originalSource: source,
        transparentCorners: false,
        cornerColor: "#121212",
        cornerStrokeColor: "#ffffff",
        borderColor: "#121212",
        cornerSize: 12
      });
      __privateMethod(this, _DesignCanvas_instances, fitObject_fn).call(this, image, 0.72);
      this.canvas.add(image);
      this.canvas.setActiveObject(image);
      this.canvas.requestRenderAll();
      return image;
    }
    addText(text = "COLOROUTINE", style = {}) {
      const object = new fs(text, {
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
        originX: "center",
        originY: "center",
        width: this.canvas.width * 0.68,
        fontSize: 64,
        fontFamily: "Arial, sans-serif",
        fontWeight: 700,
        textAlign: "center",
        fill: "#17181c",
        stroke: "",
        strokeWidth: 0,
        shadow: null,
        paintFirst: "fill",
        strokeLineJoin: "round",
        charSpacing: 0,
        lineHeight: 1.08,
        assetName: "文字图层",
        kind: "text",
        textEffect: "none",
        ...normalizeTextStyle(style),
        transparentCorners: false,
        cornerColor: "#121212",
        borderColor: "#121212"
      });
      this.canvas.add(object);
      this.canvas.setActiveObject(object);
      this.canvas.requestRenderAll();
      object.enterEditing();
      object.selectAll();
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
    }
    addShape() {
      const object = new $i({
        left: this.canvas.width / 2,
        top: this.canvas.height / 2,
        originX: "center",
        originY: "center",
        width: 220,
        height: 220,
        rx: 36,
        ry: 36,
        fill: "#121212",
        assetName: "色块",
        kind: "shape",
        transparentCorners: false,
        cornerColor: "#121212",
        borderColor: "#ffffff"
      });
      this.canvas.add(object);
      this.canvas.setActiveObject(object);
      this.canvas.requestRenderAll();
    }
    setActiveColor(color) {
      const active = this.canvas.getActiveObject();
      if (!active || !/^#[0-9a-f]{6}$/i.test(String(color))) return false;
      if (active.type === "textbox" || active.kind === "text") active.set("fill", color);
      else if (active.kind === "shape" || active.type === "rect") active.set("fill", color);
      else return false;
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this, false, "edit");
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
      return true;
    }
    getActiveColor() {
      const active = this.canvas.getActiveObject();
      const fill = typeof active?.fill === "string" ? active.fill : "";
      return /^#[0-9a-f]{6}$/i.test(fill) ? fill : "#121212";
    }
    setActiveTextStyle(style = {}) {
      const active = this.canvas.getActiveObject();
      if (!isTextObject(active)) return false;
      const patch = normalizeTextStyle(style);
      if ("text" in style) patch.text = String(style.text || "").slice(0, 120) || "COLOROUTINE";
      if (!Object.keys(patch).length) return false;
      active.set(patch);
      if (patch.text) active.set("assetName", patch.text.slice(0, 28));
      active.setCoords();
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this, false, "edit");
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
      return true;
    }
    getActiveTextStyle() {
      const active = this.canvas.getActiveObject();
      if (!isTextObject(active)) return null;
      return {
        text: active.text || "",
        fontPreset: active.fontPreset || "",
        textEffect: active.textEffect || "none",
        fontFamily: active.fontFamily || "Arial, sans-serif",
        fontSize: Math.round(Number(active.fontSize) || 64),
        fontWeight: String(active.fontWeight || 700),
        textAlign: active.textAlign || "center",
        fill: normalizeColor(active.fill, "#17181c"),
        stroke: normalizeColor(active.stroke, "#ffffff"),
        strokeWidth: Number(active.strokeWidth) || 0,
        shadow: typeof active.shadow === "string" ? active.shadow : "",
        paintFirst: active.paintFirst || "fill",
        strokeLineJoin: active.strokeLineJoin || "round",
        charSpacing: Math.round(Number(active.charSpacing) || 0),
        lineHeight: Number(active.lineHeight) || 1.08
      };
    }
    getActiveKind() {
      const active = this.canvas.getActiveObject();
      return active?.kind || active?.type || "";
    }
    async removeBackgroundFromActive({ tolerance = 28 } = {}) {
      const active = this.canvas.getActiveObject();
      if (!active || active.kind !== "image") return false;
      const source = active.originalSource || active.getSrc?.();
      if (!source) return false;
      const image = await loadBrowserImage(source);
      const canvas = document.createElement("canvas");
      const width = Math.max(1, image.naturalWidth || active.sourceWidth || active.width);
      const height = Math.max(1, image.naturalHeight || active.sourceHeight || active.height);
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext("2d", { willReadFrequently: true });
      context.drawImage(image, 0, 0, width, height);
      removeCornerBackground(context, width, height, tolerance);
      const dataUrl = canvas.toDataURL("image/png");
      const replacement = await ws.fromURL(dataUrl);
      replacement.set({
        ...active.toObject(["assetId", "assetName", "sourceWidth", "sourceHeight", "kind"]),
        originalSource: dataUrl,
        left: active.left,
        top: active.top,
        scaleX: active.scaleX,
        scaleY: active.scaleY,
        angle: active.angle,
        skewX: active.skewX,
        skewY: active.skewY,
        flipX: active.flipX,
        flipY: active.flipY,
        originX: active.originX,
        originY: active.originY,
        transparentCorners: false,
        cornerColor: "#121212",
        cornerStrokeColor: "#ffffff",
        borderColor: "#121212",
        cornerSize: 12
      });
      const objects = this.canvas.getObjects();
      const index = objects.indexOf(active);
      this.canvas.remove(active);
      this.canvas.insertAt(index, replacement);
      this.canvas.setActiveObject(replacement);
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this, false, "edit");
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
      return true;
    }
    async duplicate() {
      const active = this.canvas.getActiveObject();
      if (!active) return;
      const cloned = await active.clone();
      cloned.set({ left: active.left + 28, top: active.top + 28, assetId: crypto.randomUUID(), assetName: `${active.assetName || "图层"} 副本` });
      this.canvas.add(cloned);
      this.canvas.setActiveObject(cloned);
      this.canvas.requestRenderAll();
    }
    remove() {
      const objects = this.canvas.getActiveObjects();
      objects.forEach((object) => this.canvas.remove(object));
      this.canvas.discardActiveObject();
      this.canvas.requestRenderAll();
    }
    center() {
      const active = this.canvas.getActiveObject();
      if (!active) return;
      this.canvas.centerObject(active);
      active.setCoords();
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, updateCenterGuides_fn).call(this, active);
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this, 420);
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
    }
    fit() {
      const active = this.canvas.getActiveObject();
      if (!active) return;
      __privateMethod(this, _DesignCanvas_instances, fitObject_fn).call(this, active, 0.86);
      active.setCoords();
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, updateCenterGuides_fn).call(this, active);
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this, 420);
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
    }
    bringForward() {
      const active = this.canvas.getActiveObject();
      if (active) {
        this.canvas.bringObjectForward(active);
        __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      }
    }
    sendBackward() {
      const active = this.canvas.getActiveObject();
      if (active) {
        this.canvas.sendObjectBackwards(active);
        __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      }
    }
    async undo() {
      if (this.history.length < 2) return;
      this.future.push(this.history.pop());
      await __privateMethod(this, _DesignCanvas_instances, restore_fn).call(this, this.history.at(-1));
    }
    async redo() {
      const state = this.future.pop();
      if (!state) return;
      this.history.push(state);
      await __privateMethod(this, _DesignCanvas_instances, restore_fn).call(this, state);
    }
    serialize() {
      return this.canvas.toJSON(["assetId", "assetName", "sourceWidth", "sourceHeight", "kind", "originalSource", "fontPreset", "textEffect", "paintFirst", "strokeLineJoin"]);
    }
    async load(json) {
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
      this.restoring = true;
      await this.canvas.loadFromJSON(json || { objects: [] });
      this.canvas.requestRenderAll();
      this.restoring = false;
      this.history = [];
      this.future = [];
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this, false, "load");
    }
    clear() {
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
      this.canvas.clear();
      this.canvas.backgroundColor = "transparent";
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
    }
    dataURL(multiplier = 1) {
      const active = this.canvas.getActiveObject();
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
      const dataUrl = this.canvas.toDataURL({ format: "png", multiplier, enableRetinaScaling: false });
      if (active) this.canvas.setActiveObject(active);
      this.canvas.renderAll();
      return dataUrl;
    }
    getQuality() {
      const images = this.canvas.getObjects().filter((object) => object.kind === "image" && object.sourceWidth);
      if (!images.length) return { level: "empty", dpi: null, label: "尚未添加图片" };
      const dpis = images.map((object) => {
        const usedInches = object.getScaledWidth() / this.canvas.width * this.product.physical.widthIn;
        return Math.round(object.sourceWidth / Math.max(usedInches, 0.1));
      });
      const dpi = Math.min(...dpis);
      if (dpi >= 250) return { level: "great", dpi, label: "印刷质量优秀" };
      if (dpi >= 150) return { level: "ok", dpi, label: "印刷质量合格" };
      return { level: "low", dpi, label: "分辨率偏低" };
    }
    getLayers() {
      return this.canvas.getObjects().map((object, index) => ({
        index,
        id: object.assetId || `layer-${index}`,
        name: object.assetName || (object.type === "textbox" ? "文字" : "图层"),
        type: object.kind || object.type,
        visible: object.visible !== false,
        locked: !object.selectable,
        selected: this.canvas.getActiveObject() === object
      })).reverse();
    }
    selectLayer(reversedIndex) {
      const objects = this.canvas.getObjects();
      const object = objects[objects.length - 1 - reversedIndex];
      if (!object) return;
      this.canvas.setActiveObject(object);
      this.canvas.requestRenderAll();
    }
    toggleLayer(reversedIndex, key) {
      const objects = this.canvas.getObjects();
      const object = objects[objects.length - 1 - reversedIndex];
      if (!object) return;
      if (key === "visible") object.set("visible", !object.visible);
      if (key === "locked") object.set({ selectable: !object.selectable, evented: !object.evented });
      this.canvas.requestRenderAll();
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
    }
    dispose() {
      clearTimeout(this.saveTimer);
      clearTimeout(this.guideTimer);
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
      this.canvas.dispose();
    }
  }
  _DesignCanvas_instances = new WeakSet();
  fitObject_fn = function(object, ratio) {
    const scale = Math.min(this.canvas.width * ratio / object.width, this.canvas.height * ratio / object.height);
    object.scale(scale);
    object.set({ left: this.canvas.width / 2, top: this.canvas.height / 2, originX: "center", originY: "center" });
  };
  bind_fn = function() {
    const changed = () => {
      if (this.restoring) return;
      __privateMethod(this, _DesignCanvas_instances, record_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this);
    };
    this.canvas.on("object:added", changed);
    this.canvas.on("object:removed", changed);
    this.canvas.on("object:modified", changed);
    this.canvas.on("object:moving", (event) => __privateMethod(this, _DesignCanvas_instances, updateCenterGuides_fn).call(this, event.target, true));
    this.canvas.on("object:scaling", (event) => __privateMethod(this, _DesignCanvas_instances, updateCenterGuides_fn).call(this, event.target));
    this.canvas.on("object:rotating", (event) => __privateMethod(this, _DesignCanvas_instances, updateCenterGuides_fn).call(this, event.target));
    this.canvas.on("mouse:up", () => __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this, 180));
    this.canvas.on("text:changed", () => {
      __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this, true);
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
    });
    this.canvas.on("selection:created", () => __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this));
    this.canvas.on("selection:updated", () => __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this));
    this.canvas.on("selection:cleared", () => {
      __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
      __privateMethod(this, _DesignCanvas_instances, emitSelection_fn).call(this);
    });
  };
  updateCenterGuides_fn = function(target, snap = false) {
    if (!target) return __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this);
    clearTimeout(this.guideTimer);
    const alignment = resolveCenterAlignment(target.getCenterPoint(), { width: this.canvas.width, height: this.canvas.height });
    if (snap && (alignment.vertical || alignment.horizontal)) {
      target.setPositionByOrigin(new N(alignment.x, alignment.y), "center", "center");
      target.setCoords();
    }
    this.centerGuides = { vertical: alignment.vertical, horizontal: alignment.horizontal };
    __privateMethod(this, _DesignCanvas_instances, drawCenterGuides_fn).call(this);
  };
  drawCenterGuides_fn = function() {
    const context = this.canvas.getTopContext();
    const guideElement = this.canvas.getSelectionElement();
    this.canvas.clearContext(context);
    const guideNames = [this.centerGuides.vertical && "vertical", this.centerGuides.horizontal && "horizontal"].filter(Boolean);
    if (!guideNames.length) {
      guideElement.removeAttribute("data-center-guides");
      return;
    }
    guideElement.dataset.centerGuides = guideNames.join(" ");
    const centerX = this.canvas.width / 2;
    const centerY = this.canvas.height / 2;
    const drawAxes = () => {
      if (this.centerGuides.vertical) {
        context.beginPath();
        context.moveTo(centerX, 0);
        context.lineTo(centerX, this.canvas.height);
        context.stroke();
      }
      if (this.centerGuides.horizontal) {
        context.beginPath();
        context.moveTo(0, centerY);
        context.lineTo(this.canvas.width, centerY);
        context.stroke();
      }
    };
    context.save();
    context.setLineDash([12, 8]);
    context.strokeStyle = "rgba(255,255,255,.92)";
    context.lineWidth = 5;
    drawAxes();
    context.strokeStyle = "rgba(18,18,18,.88)";
    context.lineWidth = 2.4;
    drawAxes();
    if (this.centerGuides.vertical && this.centerGuides.horizontal) {
      context.setLineDash([]);
      context.fillStyle = "#ffffff";
      context.beginPath();
      context.arc(centerX, centerY, 6, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = "#121212";
      context.beginPath();
      context.arc(centerX, centerY, 3.5, 0, Math.PI * 2);
      context.fill();
    }
    context.restore();
  };
  clearCenterGuides_fn = function(delay = 0) {
    clearTimeout(this.guideTimer);
    if (delay) {
      this.guideTimer = setTimeout(() => __privateMethod(this, _DesignCanvas_instances, clearCenterGuides_fn).call(this), delay);
      return;
    }
    this.centerGuides = { vertical: false, horizontal: false };
    if (!this.canvas?.getTopContext) return;
    this.canvas.getSelectionElement().removeAttribute("data-center-guides");
    this.canvas.clearContext(this.canvas.getTopContext());
    this.canvas.requestRenderAll();
  };
  record_fn = function() {
    if (this.restoring) return;
    const state = JSON.stringify(this.serialize());
    if (this.history.at(-1) === state) return;
    this.history.push(state);
    if (this.history.length > 40) this.history.shift();
    this.future = [];
    this.dispatchEvent(new CustomEvent("history", { detail: { canUndo: this.history.length > 1, canRedo: this.future.length > 0 } }));
  };
  restore_fn = async function(state) {
    this.restoring = true;
    await this.canvas.loadFromJSON(state);
    this.canvas.requestRenderAll();
    this.restoring = false;
    this.dispatchEvent(new CustomEvent("history", { detail: { canUndo: this.history.length > 1, canRedo: this.future.length > 0 } }));
    __privateMethod(this, _DesignCanvas_instances, emitChange_fn).call(this);
  };
  emitChange_fn = function(debounce = false, reason = "edit") {
    clearTimeout(this.saveTimer);
    this.saveTimer = setTimeout(() => {
      this.dispatchEvent(new CustomEvent("change", { detail: { layers: this.getLayers(), quality: this.getQuality(), reason } }));
    }, debounce ? 320 : 30);
  };
  emitSelection_fn = function() {
    this.dispatchEvent(new CustomEvent("selection", { detail: { object: this.canvas.getActiveObject(), layers: this.getLayers(), activeKind: this.getActiveKind(), activeColor: this.getActiveColor(), activeText: this.getActiveTextStyle() } }));
  };
  function isTextObject(object) {
    return Boolean(object && (object.type === "textbox" || object.kind === "text"));
  }
  function normalizeTextStyle(style = {}) {
    const patch = {};
    if ("fontPreset" in style) patch.fontPreset = String(style.fontPreset || "");
    if ("textEffect" in style) patch.textEffect = String(style.textEffect || "none");
    if ("fontFamily" in style) patch.fontFamily = String(style.fontFamily || "Arial, sans-serif").slice(0, 160);
    if ("fontWeight" in style) patch.fontWeight = String(style.fontWeight || 700);
    if ("textAlign" in style && ["left", "center", "right", "justify"].includes(style.textAlign)) patch.textAlign = style.textAlign;
    if ("fill" in style) patch.fill = normalizeColor(style.fill, "#17181c");
    if ("stroke" in style) patch.stroke = normalizeColor(style.stroke, "");
    if ("shadow" in style) patch.shadow = String(style.shadow || "");
    if ("fontSize" in style) patch.fontSize = clampNumber(style.fontSize, 14, 180, 64);
    if ("strokeWidth" in style) patch.strokeWidth = clampNumber(style.strokeWidth, 0, 8, 0);
    if ("paintFirst" in style && ["fill", "stroke"].includes(style.paintFirst)) patch.paintFirst = style.paintFirst;
    if ("strokeLineJoin" in style && ["miter", "round", "bevel"].includes(style.strokeLineJoin)) patch.strokeLineJoin = style.strokeLineJoin;
    if ("charSpacing" in style) patch.charSpacing = clampNumber(style.charSpacing, -80, 280, 0);
    if ("lineHeight" in style) patch.lineHeight = clampNumber(style.lineHeight, 0.75, 2.4, 1.08);
    return patch;
  }
  function normalizeColor(value, fallback) {
    const color = String(value || "");
    return /^#[0-9a-f]{6}$/i.test(color) ? color : fallback;
  }
  function clampNumber(value, min, max, fallback) {
    const number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    return Math.max(min, Math.min(max, number));
  }
  function loadBrowserImage(source) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      if (!String(source).startsWith("data:")) image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("无法读取当前图层图片。"));
      image.src = source;
    });
  }
  function removeCornerBackground(context, width, height, tolerance) {
    const imageData = context.getImageData(0, 0, width, height);
    const { data } = imageData;
    const samples = [
      pixelAt(data, width, 0, 0),
      pixelAt(data, width, width - 1, 0),
      pixelAt(data, width, 0, height - 1),
      pixelAt(data, width, width - 1, height - 1)
    ];
    const background = samples.reduce((best, sample) => sample.a > best.a ? sample : best, samples[0]);
    const maxDistance = Math.max(8, Number(tolerance) || 28);
    for (let offset = 0; offset < data.length; offset += 4) {
      const distance = Math.hypot(data[offset] - background.r, data[offset + 1] - background.g, data[offset + 2] - background.b);
      if (distance > maxDistance) continue;
      const fade = Math.max(0, Math.min(1, distance / maxDistance));
      data[offset + 3] = Math.round(data[offset + 3] * fade);
    }
    context.putImageData(imageData, 0, 0);
  }
  function pixelAt(data, width, x2, y2) {
    const offset = (y2 * width + x2) * 4;
    return { r: data[offset], g: data[offset + 1], b: data[offset + 2], a: data[offset + 3] };
  }
  const REVISION = "178";
  const MOUSE = { ROTATE: 0, DOLLY: 1, PAN: 2 };
  const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
  const CullFaceNone = 0;
  const CullFaceBack = 1;
  const CullFaceFront = 2;
  const PCFShadowMap = 1;
  const PCFSoftShadowMap = 2;
  const VSMShadowMap = 3;
  const FrontSide = 0;
  const BackSide = 1;
  const DoubleSide = 2;
  const NoBlending = 0;
  const NormalBlending = 1;
  const AdditiveBlending = 2;
  const SubtractiveBlending = 3;
  const MultiplyBlending = 4;
  const CustomBlending = 5;
  const AddEquation = 100;
  const SubtractEquation = 101;
  const ReverseSubtractEquation = 102;
  const MinEquation = 103;
  const MaxEquation = 104;
  const ZeroFactor = 200;
  const OneFactor = 201;
  const SrcColorFactor = 202;
  const OneMinusSrcColorFactor = 203;
  const SrcAlphaFactor = 204;
  const OneMinusSrcAlphaFactor = 205;
  const DstAlphaFactor = 206;
  const OneMinusDstAlphaFactor = 207;
  const DstColorFactor = 208;
  const OneMinusDstColorFactor = 209;
  const SrcAlphaSaturateFactor = 210;
  const ConstantColorFactor = 211;
  const OneMinusConstantColorFactor = 212;
  const ConstantAlphaFactor = 213;
  const OneMinusConstantAlphaFactor = 214;
  const NeverDepth = 0;
  const AlwaysDepth = 1;
  const LessDepth = 2;
  const LessEqualDepth = 3;
  const EqualDepth = 4;
  const GreaterEqualDepth = 5;
  const GreaterDepth = 6;
  const NotEqualDepth = 7;
  const MultiplyOperation = 0;
  const MixOperation = 1;
  const AddOperation = 2;
  const NoToneMapping = 0;
  const LinearToneMapping = 1;
  const ReinhardToneMapping = 2;
  const CineonToneMapping = 3;
  const ACESFilmicToneMapping = 4;
  const CustomToneMapping = 5;
  const AgXToneMapping = 6;
  const NeutralToneMapping = 7;
  const AttachedBindMode = "attached";
  const DetachedBindMode = "detached";
  const UVMapping = 300;
  const CubeReflectionMapping = 301;
  const CubeRefractionMapping = 302;
  const EquirectangularReflectionMapping = 303;
  const EquirectangularRefractionMapping = 304;
  const CubeUVReflectionMapping = 306;
  const RepeatWrapping = 1e3;
  const ClampToEdgeWrapping = 1001;
  const MirroredRepeatWrapping = 1002;
  const NearestFilter = 1003;
  const NearestMipmapNearestFilter = 1004;
  const NearestMipmapLinearFilter = 1005;
  const LinearFilter = 1006;
  const LinearMipmapNearestFilter = 1007;
  const LinearMipmapLinearFilter = 1008;
  const UnsignedByteType = 1009;
  const ByteType = 1010;
  const ShortType = 1011;
  const UnsignedShortType = 1012;
  const IntType = 1013;
  const UnsignedIntType = 1014;
  const FloatType = 1015;
  const HalfFloatType = 1016;
  const UnsignedShort4444Type = 1017;
  const UnsignedShort5551Type = 1018;
  const UnsignedInt248Type = 1020;
  const UnsignedInt5999Type = 35902;
  const AlphaFormat = 1021;
  const RGBFormat = 1022;
  const RGBAFormat = 1023;
  const DepthFormat = 1026;
  const DepthStencilFormat = 1027;
  const RedFormat = 1028;
  const RedIntegerFormat = 1029;
  const RGFormat = 1030;
  const RGIntegerFormat = 1031;
  const RGBAIntegerFormat = 1033;
  const RGB_S3TC_DXT1_Format = 33776;
  const RGBA_S3TC_DXT1_Format = 33777;
  const RGBA_S3TC_DXT3_Format = 33778;
  const RGBA_S3TC_DXT5_Format = 33779;
  const RGB_PVRTC_4BPPV1_Format = 35840;
  const RGB_PVRTC_2BPPV1_Format = 35841;
  const RGBA_PVRTC_4BPPV1_Format = 35842;
  const RGBA_PVRTC_2BPPV1_Format = 35843;
  const RGB_ETC1_Format = 36196;
  const RGB_ETC2_Format = 37492;
  const RGBA_ETC2_EAC_Format = 37496;
  const RGBA_ASTC_4x4_Format = 37808;
  const RGBA_ASTC_5x4_Format = 37809;
  const RGBA_ASTC_5x5_Format = 37810;
  const RGBA_ASTC_6x5_Format = 37811;
  const RGBA_ASTC_6x6_Format = 37812;
  const RGBA_ASTC_8x5_Format = 37813;
  const RGBA_ASTC_8x6_Format = 37814;
  const RGBA_ASTC_8x8_Format = 37815;
  const RGBA_ASTC_10x5_Format = 37816;
  const RGBA_ASTC_10x6_Format = 37817;
  const RGBA_ASTC_10x8_Format = 37818;
  const RGBA_ASTC_10x10_Format = 37819;
  const RGBA_ASTC_12x10_Format = 37820;
  const RGBA_ASTC_12x12_Format = 37821;
  const RGBA_BPTC_Format = 36492;
  const RGB_BPTC_SIGNED_Format = 36494;
  const RGB_BPTC_UNSIGNED_Format = 36495;
  const RED_RGTC1_Format = 36283;
  const SIGNED_RED_RGTC1_Format = 36284;
  const RED_GREEN_RGTC2_Format = 36285;
  const SIGNED_RED_GREEN_RGTC2_Format = 36286;
  const InterpolateDiscrete = 2300;
  const InterpolateLinear = 2301;
  const InterpolateSmooth = 2302;
  const ZeroCurvatureEnding = 2400;
  const ZeroSlopeEnding = 2401;
  const WrapAroundEnding = 2402;
  const NormalAnimationBlendMode = 2500;
  const TrianglesDrawMode = 0;
  const TriangleStripDrawMode = 1;
  const TriangleFanDrawMode = 2;
  const BasicDepthPacking = 3200;
  const RGBADepthPacking = 3201;
  const TangentSpaceNormalMap = 0;
  const ObjectSpaceNormalMap = 1;
  const NoColorSpace = "";
  const SRGBColorSpace = "srgb";
  const LinearSRGBColorSpace = "srgb-linear";
  const LinearTransfer = "linear";
  const SRGBTransfer = "srgb";
  const KeepStencilOp = 7680;
  const AlwaysStencilFunc = 519;
  const NeverCompare = 512;
  const LessCompare = 513;
  const EqualCompare = 514;
  const LessEqualCompare = 515;
  const GreaterCompare = 516;
  const NotEqualCompare = 517;
  const GreaterEqualCompare = 518;
  const AlwaysCompare = 519;
  const StaticDrawUsage = 35044;
  const GLSL3 = "300 es";
  const WebGLCoordinateSystem = 2e3;
  const WebGPUCoordinateSystem = 2001;
  class EventDispatcher {
    /**
     * Adds the given event listener to the given event type.
     *
     * @param {string} type - The type of event to listen to.
     * @param {Function} listener - The function that gets called when the event is fired.
     */
    addEventListener(type, listener) {
      if (this._listeners === void 0) this._listeners = {};
      const listeners = this._listeners;
      if (listeners[type] === void 0) {
        listeners[type] = [];
      }
      if (listeners[type].indexOf(listener) === -1) {
        listeners[type].push(listener);
      }
    }
    /**
     * Returns `true` if the given event listener has been added to the given event type.
     *
     * @param {string} type - The type of event.
     * @param {Function} listener - The listener to check.
     * @return {boolean} Whether the given event listener has been added to the given event type.
     */
    hasEventListener(type, listener) {
      const listeners = this._listeners;
      if (listeners === void 0) return false;
      return listeners[type] !== void 0 && listeners[type].indexOf(listener) !== -1;
    }
    /**
     * Removes the given event listener from the given event type.
     *
     * @param {string} type - The type of event.
     * @param {Function} listener - The listener to remove.
     */
    removeEventListener(type, listener) {
      const listeners = this._listeners;
      if (listeners === void 0) return;
      const listenerArray = listeners[type];
      if (listenerArray !== void 0) {
        const index = listenerArray.indexOf(listener);
        if (index !== -1) {
          listenerArray.splice(index, 1);
        }
      }
    }
    /**
     * Dispatches an event object.
     *
     * @param {Object} event - The event that gets fired.
     */
    dispatchEvent(event) {
      const listeners = this._listeners;
      if (listeners === void 0) return;
      const listenerArray = listeners[event.type];
      if (listenerArray !== void 0) {
        event.target = this;
        const array = listenerArray.slice(0);
        for (let i2 = 0, l2 = array.length; i2 < l2; i2++) {
          array[i2].call(this, event);
        }
        event.target = null;
      }
    }
  }
  const _lut = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0a", "0b", "0c", "0d", "0e", "0f", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1a", "1b", "1c", "1d", "1e", "1f", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2a", "2b", "2c", "2d", "2e", "2f", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3a", "3b", "3c", "3d", "3e", "3f", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4a", "4b", "4c", "4d", "4e", "4f", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5a", "5b", "5c", "5d", "5e", "5f", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6a", "6b", "6c", "6d", "6e", "6f", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7a", "7b", "7c", "7d", "7e", "7f", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8a", "8b", "8c", "8d", "8e", "8f", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9a", "9b", "9c", "9d", "9e", "9f", "a0", "a1", "a2", "a3", "a4", "a5", "a6", "a7", "a8", "a9", "aa", "ab", "ac", "ad", "ae", "af", "b0", "b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8", "b9", "ba", "bb", "bc", "bd", "be", "bf", "c0", "c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8", "c9", "ca", "cb", "cc", "cd", "ce", "cf", "d0", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "da", "db", "dc", "dd", "de", "df", "e0", "e1", "e2", "e3", "e4", "e5", "e6", "e7", "e8", "e9", "ea", "eb", "ec", "ed", "ee", "ef", "f0", "f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "fa", "fb", "fc", "fd", "fe", "ff"];
  let _seed = 1234567;
  const DEG2RAD = Math.PI / 180;
  const RAD2DEG = 180 / Math.PI;
  function generateUUID() {
    const d0 = Math.random() * 4294967295 | 0;
    const d1 = Math.random() * 4294967295 | 0;
    const d2 = Math.random() * 4294967295 | 0;
    const d3 = Math.random() * 4294967295 | 0;
    const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
    return uuid.toLowerCase();
  }
  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }
  function euclideanModulo(n2, m) {
    return (n2 % m + m) % m;
  }
  function mapLinear(x2, a1, a2, b1, b2) {
    return b1 + (x2 - a1) * (b2 - b1) / (a2 - a1);
  }
  function inverseLerp(x2, y2, value) {
    if (x2 !== y2) {
      return (value - x2) / (y2 - x2);
    } else {
      return 0;
    }
  }
  function lerp(x2, y2, t2) {
    return (1 - t2) * x2 + t2 * y2;
  }
  function damp(x2, y2, lambda, dt2) {
    return lerp(x2, y2, 1 - Math.exp(-lambda * dt2));
  }
  function pingpong(x2, length = 1) {
    return length - Math.abs(euclideanModulo(x2, length * 2) - length);
  }
  function smoothstep(x2, min, max) {
    if (x2 <= min) return 0;
    if (x2 >= max) return 1;
    x2 = (x2 - min) / (max - min);
    return x2 * x2 * (3 - 2 * x2);
  }
  function smootherstep(x2, min, max) {
    if (x2 <= min) return 0;
    if (x2 >= max) return 1;
    x2 = (x2 - min) / (max - min);
    return x2 * x2 * x2 * (x2 * (x2 * 6 - 15) + 10);
  }
  function randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
  }
  function randFloat(low, high) {
    return low + Math.random() * (high - low);
  }
  function randFloatSpread(range) {
    return range * (0.5 - Math.random());
  }
  function seededRandom(s2) {
    if (s2 !== void 0) _seed = s2;
    let t2 = _seed += 1831565813;
    t2 = Math.imul(t2 ^ t2 >>> 15, t2 | 1);
    t2 ^= t2 + Math.imul(t2 ^ t2 >>> 7, t2 | 61);
    return ((t2 ^ t2 >>> 14) >>> 0) / 4294967296;
  }
  function degToRad(degrees) {
    return degrees * DEG2RAD;
  }
  function radToDeg(radians) {
    return radians * RAD2DEG;
  }
  function isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
  }
  function ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
  }
  function floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
  }
  function setQuaternionFromProperEuler(q2, a2, b2, c2, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c22 = cos(b2 / 2);
    const s2 = sin(b2 / 2);
    const c13 = cos((a2 + c2) / 2);
    const s13 = sin((a2 + c2) / 2);
    const c1_3 = cos((a2 - c2) / 2);
    const s1_3 = sin((a2 - c2) / 2);
    const c3_1 = cos((c2 - a2) / 2);
    const s3_1 = sin((c2 - a2) / 2);
    switch (order) {
      case "XYX":
        q2.set(c22 * s13, s2 * c1_3, s2 * s1_3, c22 * c13);
        break;
      case "YZY":
        q2.set(s2 * s1_3, c22 * s13, s2 * c1_3, c22 * c13);
        break;
      case "ZXZ":
        q2.set(s2 * c1_3, s2 * s1_3, c22 * s13, c22 * c13);
        break;
      case "XZX":
        q2.set(c22 * s13, s2 * s3_1, s2 * c3_1, c22 * c13);
        break;
      case "YXY":
        q2.set(s2 * c3_1, c22 * s13, s2 * s3_1, c22 * c13);
        break;
      case "ZYZ":
        q2.set(s2 * s3_1, s2 * c3_1, c22 * s13, c22 * c13);
        break;
      default:
        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
  }
  function denormalize(value, array) {
    switch (array.constructor) {
      case Float32Array:
        return value;
      case Uint32Array:
        return value / 4294967295;
      case Uint16Array:
        return value / 65535;
      case Uint8Array:
        return value / 255;
      case Int32Array:
        return Math.max(value / 2147483647, -1);
      case Int16Array:
        return Math.max(value / 32767, -1);
      case Int8Array:
        return Math.max(value / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  function normalize(value, array) {
    switch (array.constructor) {
      case Float32Array:
        return value;
      case Uint32Array:
        return Math.round(value * 4294967295);
      case Uint16Array:
        return Math.round(value * 65535);
      case Uint8Array:
        return Math.round(value * 255);
      case Int32Array:
        return Math.round(value * 2147483647);
      case Int16Array:
        return Math.round(value * 32767);
      case Int8Array:
        return Math.round(value * 127);
      default:
        throw new Error("Invalid component type.");
    }
  }
  const MathUtils = {
    DEG2RAD,
    RAD2DEG,
    /**
     * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
     * (universally unique identifier).
     *
     * @static
     * @method
     * @return {string} The UUID.
     */
    generateUUID,
    /**
     * Clamps the given value between min and max.
     *
     * @static
     * @method
     * @param {number} value - The value to clamp.
     * @param {number} min - The min value.
     * @param {number} max - The max value.
     * @return {number} The clamped value.
     */
    clamp,
    /**
     * Computes the Euclidean modulo of the given parameters that
     * is `( ( n % m ) + m ) % m`.
     *
     * @static
     * @method
     * @param {number} n - The first parameter.
     * @param {number} m - The second parameter.
     * @return {number} The Euclidean modulo.
     */
    euclideanModulo,
    /**
     * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
     * for the given value.
     *
     * @static
     * @method
     * @param {number} x - The value to be mapped.
     * @param {number} a1 - Minimum value for range A.
     * @param {number} a2 - Maximum value for range A.
     * @param {number} b1 - Minimum value for range B.
     * @param {number} b2 - Maximum value for range B.
     * @return {number} The mapped value.
     */
    mapLinear,
    /**
     * Returns the percentage in the closed interval `[0, 1]` of the given value
     * between the start and end point.
     *
     * @static
     * @method
     * @param {number} x - The start point
     * @param {number} y - The end point.
     * @param {number} value - A value between start and end.
     * @return {number} The interpolation factor.
     */
    inverseLerp,
    /**
     * Returns a value linearly interpolated from two known points based on the given interval -
     * `t = 0` will return `x` and `t = 1` will return `y`.
     *
     * @static
     * @method
     * @param {number} x - The start point
     * @param {number} y - The end point.
     * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
     * @return {number} The interpolated value.
     */
    lerp,
    /**
     * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
     * time to maintain frame rate independent movement. For details, see
     * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
     *
     * @static
     * @method
     * @param {number} x - The current point.
     * @param {number} y - The target point.
     * @param {number} lambda - A higher lambda value will make the movement more sudden,
     * and a lower value will make the movement more gradual.
     * @param {number} dt - Delta time in seconds.
     * @return {number} The interpolated value.
     */
    damp,
    /**
     * Returns a value that alternates between `0` and the given `length` parameter.
     *
     * @static
     * @method
     * @param {number} x - The value to pingpong.
     * @param {number} [length=1] - The positive value the function will pingpong to.
     * @return {number} The alternated value.
     */
    pingpong,
    /**
     * Returns a value in the range `[0,1]` that represents the percentage that `x` has
     * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
     * the `min` and `max`.
     *
     * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
     *
     * @static
     * @method
     * @param {number} x - The value to evaluate based on its position between min and max.
     * @param {number} min - The min value. Any x value below min will be `0`.
     * @param {number} max - The max value. Any x value above max will be `1`.
     * @return {number} The alternated value.
     */
    smoothstep,
    /**
     * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
     * that has zero 1st and 2nd order derivatives at x=0 and x=1.
     *
     * @static
     * @method
     * @param {number} x - The value to evaluate based on its position between min and max.
     * @param {number} min - The min value. Any x value below min will be `0`.
     * @param {number} max - The max value. Any x value above max will be `1`.
     * @return {number} The alternated value.
     */
    smootherstep,
    /**
     * Returns a random integer from `<low, high>` interval.
     *
     * @static
     * @method
     * @param {number} low - The lower value boundary.
     * @param {number} high - The upper value boundary
     * @return {number} A random integer.
     */
    randInt,
    /**
     * Returns a random float from `<low, high>` interval.
     *
     * @static
     * @method
     * @param {number} low - The lower value boundary.
     * @param {number} high - The upper value boundary
     * @return {number} A random float.
     */
    randFloat,
    /**
     * Returns a random integer from `<-range/2, range/2>` interval.
     *
     * @static
     * @method
     * @param {number} range - Defines the value range.
     * @return {number} A random float.
     */
    randFloatSpread,
    /**
     * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
     *
     * @static
     * @method
     * @param {number} [s] - The integer seed.
     * @return {number} A random float.
     */
    seededRandom,
    /**
     * Converts degrees to radians.
     *
     * @static
     * @method
     * @param {number} degrees - A value in degrees.
     * @return {number} The converted value in radians.
     */
    degToRad,
    /**
     * Converts radians to degrees.
     *
     * @static
     * @method
     * @param {number} radians - A value in radians.
     * @return {number} The converted value in degrees.
     */
    radToDeg,
    /**
     * Returns `true` if the given number is a power of two.
     *
     * @static
     * @method
     * @param {number} value - The value to check.
     * @return {boolean} Whether the given number is a power of two or not.
     */
    isPowerOfTwo,
    /**
     * Returns the smallest power of two that is greater than or equal to the given number.
     *
     * @static
     * @method
     * @param {number} value - The value to find a POT for.
     * @return {number} The smallest power of two that is greater than or equal to the given number.
     */
    ceilPowerOfTwo,
    /**
     * Returns the largest power of two that is less than or equal to the given number.
     *
     * @static
     * @method
     * @param {number} value - The value to find a POT for.
     * @return {number} The largest power of two that is less than or equal to the given number.
     */
    floorPowerOfTwo,
    /**
     * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
     * defined by the given angles and order.
     *
     * Rotations are applied to the axes in the order specified by order:
     * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
     *
     * @static
     * @method
     * @param {Quaternion} q - The quaternion to set.
     * @param {number} a - The rotation applied to the first axis, in radians.
     * @param {number} b - The rotation applied to the second axis, in radians.
     * @param {number} c - The rotation applied to the third axis, in radians.
     * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
     */
    setQuaternionFromProperEuler,
    /**
     * Normalizes the given value according to the given typed array.
     *
     * @static
     * @method
     * @param {number} value - The float value in the range `[0,1]` to normalize.
     * @param {TypedArray} array - The typed array that defines the data type of the value.
     * @return {number} The normalize value.
     */
    normalize,
    /**
     * Denormalizes the given value according to the given typed array.
     *
     * @static
     * @method
     * @param {number} value - The value to denormalize.
     * @param {TypedArray} array - The typed array that defines the data type of the value.
     * @return {number} The denormalize (float) value in the range `[0,1]`.
     */
    denormalize
  };
  class Vector2 {
    /**
     * Constructs a new 2D vector.
     *
     * @param {number} [x=0] - The x value of this vector.
     * @param {number} [y=0] - The y value of this vector.
     */
    constructor(x2 = 0, y2 = 0) {
      Vector2.prototype.isVector2 = true;
      this.x = x2;
      this.y = y2;
    }
    /**
     * Alias for {@link Vector2#x}.
     *
     * @type {number}
     */
    get width() {
      return this.x;
    }
    set width(value) {
      this.x = value;
    }
    /**
     * Alias for {@link Vector2#y}.
     *
     * @type {number}
     */
    get height() {
      return this.y;
    }
    set height(value) {
      this.y = value;
    }
    /**
     * Sets the vector components.
     *
     * @param {number} x - The value of the x component.
     * @param {number} y - The value of the y component.
     * @return {Vector2} A reference to this vector.
     */
    set(x2, y2) {
      this.x = x2;
      this.y = y2;
      return this;
    }
    /**
     * Sets the vector components to the same value.
     *
     * @param {number} scalar - The value to set for all vector components.
     * @return {Vector2} A reference to this vector.
     */
    setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      return this;
    }
    /**
     * Sets the vector's x component to the given value
     *
     * @param {number} x - The value to set.
     * @return {Vector2} A reference to this vector.
     */
    setX(x2) {
      this.x = x2;
      return this;
    }
    /**
     * Sets the vector's y component to the given value
     *
     * @param {number} y - The value to set.
     * @return {Vector2} A reference to this vector.
     */
    setY(y2) {
      this.y = y2;
      return this;
    }
    /**
     * Allows to set a vector component with an index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y.
     * @param {number} value - The value to set.
     * @return {Vector2} A reference to this vector.
     */
    setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;
        case 1:
          this.y = value;
          break;
        default:
          throw new Error("index is out of range: " + index);
      }
      return this;
    }
    /**
     * Returns the value of the vector component which matches the given index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y.
     * @return {number} A vector component value.
     */
    getComponent(index) {
      switch (index) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        default:
          throw new Error("index is out of range: " + index);
      }
    }
    /**
     * Returns a new vector with copied values from this instance.
     *
     * @return {Vector2} A clone of this instance.
     */
    clone() {
      return new this.constructor(this.x, this.y);
    }
    /**
     * Copies the values of the given vector to this instance.
     *
     * @param {Vector2} v - The vector to copy.
     * @return {Vector2} A reference to this vector.
     */
    copy(v2) {
      this.x = v2.x;
      this.y = v2.y;
      return this;
    }
    /**
     * Adds the given vector to this instance.
     *
     * @param {Vector2} v - The vector to add.
     * @return {Vector2} A reference to this vector.
     */
    add(v2) {
      this.x += v2.x;
      this.y += v2.y;
      return this;
    }
    /**
     * Adds the given scalar value to all components of this instance.
     *
     * @param {number} s - The scalar to add.
     * @return {Vector2} A reference to this vector.
     */
    addScalar(s2) {
      this.x += s2;
      this.y += s2;
      return this;
    }
    /**
     * Adds the given vectors and stores the result in this instance.
     *
     * @param {Vector2} a - The first vector.
     * @param {Vector2} b - The second vector.
     * @return {Vector2} A reference to this vector.
     */
    addVectors(a2, b2) {
      this.x = a2.x + b2.x;
      this.y = a2.y + b2.y;
      return this;
    }
    /**
     * Adds the given vector scaled by the given factor to this instance.
     *
     * @param {Vector2} v - The vector.
     * @param {number} s - The factor that scales `v`.
     * @return {Vector2} A reference to this vector.
     */
    addScaledVector(v2, s2) {
      this.x += v2.x * s2;
      this.y += v2.y * s2;
      return this;
    }
    /**
     * Subtracts the given vector from this instance.
     *
     * @param {Vector2} v - The vector to subtract.
     * @return {Vector2} A reference to this vector.
     */
    sub(v2) {
      this.x -= v2.x;
      this.y -= v2.y;
      return this;
    }
    /**
     * Subtracts the given scalar value from all components of this instance.
     *
     * @param {number} s - The scalar to subtract.
     * @return {Vector2} A reference to this vector.
     */
    subScalar(s2) {
      this.x -= s2;
      this.y -= s2;
      return this;
    }
    /**
     * Subtracts the given vectors and stores the result in this instance.
     *
     * @param {Vector2} a - The first vector.
     * @param {Vector2} b - The second vector.
     * @return {Vector2} A reference to this vector.
     */
    subVectors(a2, b2) {
      this.x = a2.x - b2.x;
      this.y = a2.y - b2.y;
      return this;
    }
    /**
     * Multiplies the given vector with this instance.
     *
     * @param {Vector2} v - The vector to multiply.
     * @return {Vector2} A reference to this vector.
     */
    multiply(v2) {
      this.x *= v2.x;
      this.y *= v2.y;
      return this;
    }
    /**
     * Multiplies the given scalar value with all components of this instance.
     *
     * @param {number} scalar - The scalar to multiply.
     * @return {Vector2} A reference to this vector.
     */
    multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    }
    /**
     * Divides this instance by the given vector.
     *
     * @param {Vector2} v - The vector to divide.
     * @return {Vector2} A reference to this vector.
     */
    divide(v2) {
      this.x /= v2.x;
      this.y /= v2.y;
      return this;
    }
    /**
     * Divides this vector by the given scalar.
     *
     * @param {number} scalar - The scalar to divide.
     * @return {Vector2} A reference to this vector.
     */
    divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
    /**
     * Multiplies this vector (with an implicit 1 as the 3rd component) by
     * the given 3x3 matrix.
     *
     * @param {Matrix3} m - The matrix to apply.
     * @return {Vector2} A reference to this vector.
     */
    applyMatrix3(m) {
      const x2 = this.x, y2 = this.y;
      const e2 = m.elements;
      this.x = e2[0] * x2 + e2[3] * y2 + e2[6];
      this.y = e2[1] * x2 + e2[4] * y2 + e2[7];
      return this;
    }
    /**
     * If this vector's x or y value is greater than the given vector's x or y
     * value, replace that value with the corresponding min value.
     *
     * @param {Vector2} v - The vector.
     * @return {Vector2} A reference to this vector.
     */
    min(v2) {
      this.x = Math.min(this.x, v2.x);
      this.y = Math.min(this.y, v2.y);
      return this;
    }
    /**
     * If this vector's x or y value is less than the given vector's x or y
     * value, replace that value with the corresponding max value.
     *
     * @param {Vector2} v - The vector.
     * @return {Vector2} A reference to this vector.
     */
    max(v2) {
      this.x = Math.max(this.x, v2.x);
      this.y = Math.max(this.y, v2.y);
      return this;
    }
    /**
     * If this vector's x or y value is greater than the max vector's x or y
     * value, it is replaced by the corresponding value.
     * If this vector's x or y value is less than the min vector's x or y value,
     * it is replaced by the corresponding value.
     *
     * @param {Vector2} min - The minimum x and y values.
     * @param {Vector2} max - The maximum x and y values in the desired range.
     * @return {Vector2} A reference to this vector.
     */
    clamp(min, max) {
      this.x = clamp(this.x, min.x, max.x);
      this.y = clamp(this.y, min.y, max.y);
      return this;
    }
    /**
     * If this vector's x or y values are greater than the max value, they are
     * replaced by the max value.
     * If this vector's x or y values are less than the min value, they are
     * replaced by the min value.
     *
     * @param {number} minVal - The minimum value the components will be clamped to.
     * @param {number} maxVal - The maximum value the components will be clamped to.
     * @return {Vector2} A reference to this vector.
     */
    clampScalar(minVal, maxVal) {
      this.x = clamp(this.x, minVal, maxVal);
      this.y = clamp(this.y, minVal, maxVal);
      return this;
    }
    /**
     * If this vector's length is greater than the max value, it is replaced by
     * the max value.
     * If this vector's length is less than the min value, it is replaced by the
     * min value.
     *
     * @param {number} min - The minimum value the vector length will be clamped to.
     * @param {number} max - The maximum value the vector length will be clamped to.
     * @return {Vector2} A reference to this vector.
     */
    clampLength(min, max) {
      const length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
     * The components of this vector are rounded down to the nearest integer value.
     *
     * @return {Vector2} A reference to this vector.
     */
    floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      return this;
    }
    /**
     * The components of this vector are rounded up to the nearest integer value.
     *
     * @return {Vector2} A reference to this vector.
     */
    ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      return this;
    }
    /**
     * The components of this vector are rounded to the nearest integer value
     *
     * @return {Vector2} A reference to this vector.
     */
    round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      return this;
    }
    /**
     * The components of this vector are rounded towards zero (up if negative,
     * down if positive) to an integer value.
     *
     * @return {Vector2} A reference to this vector.
     */
    roundToZero() {
      this.x = Math.trunc(this.x);
      this.y = Math.trunc(this.y);
      return this;
    }
    /**
     * Inverts this vector - i.e. sets x = -x and y = -y.
     *
     * @return {Vector2} A reference to this vector.
     */
    negate() {
      this.x = -this.x;
      this.y = -this.y;
      return this;
    }
    /**
     * Calculates the dot product of the given vector with this instance.
     *
     * @param {Vector2} v - The vector to compute the dot product with.
     * @return {number} The result of the dot product.
     */
    dot(v2) {
      return this.x * v2.x + this.y * v2.y;
    }
    /**
     * Calculates the cross product of the given vector with this instance.
     *
     * @param {Vector2} v - The vector to compute the cross product with.
     * @return {number} The result of the cross product.
     */
    cross(v2) {
      return this.x * v2.y - this.y * v2.x;
    }
    /**
     * Computes the square of the Euclidean length (straight-line length) from
     * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
     * compare the length squared instead as it is slightly more efficient to calculate.
     *
     * @return {number} The square length of this vector.
     */
    lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
    /**
     * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
     *
     * @return {number} The length of this vector.
     */
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
     * Computes the Manhattan length of this vector.
     *
     * @return {number} The length of this vector.
     */
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
     * Converts this vector to a unit vector - that is, sets it equal to a vector
     * with the same direction as this one, but with a vector length of `1`.
     *
     * @return {Vector2} A reference to this vector.
     */
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    /**
     * Computes the angle in radians of this vector with respect to the positive x-axis.
     *
     * @return {number} The angle in radians.
     */
    angle() {
      const angle = Math.atan2(-this.y, -this.x) + Math.PI;
      return angle;
    }
    /**
     * Returns the angle between the given vector and this instance in radians.
     *
     * @param {Vector2} v - The vector to compute the angle with.
     * @return {number} The angle in radians.
     */
    angleTo(v2) {
      const denominator = Math.sqrt(this.lengthSq() * v2.lengthSq());
      if (denominator === 0) return Math.PI / 2;
      const theta = this.dot(v2) / denominator;
      return Math.acos(clamp(theta, -1, 1));
    }
    /**
     * Computes the distance from the given vector to this instance.
     *
     * @param {Vector2} v - The vector to compute the distance to.
     * @return {number} The distance.
     */
    distanceTo(v2) {
      return Math.sqrt(this.distanceToSquared(v2));
    }
    /**
     * Computes the squared distance from the given vector to this instance.
     * If you are just comparing the distance with another distance, you should compare
     * the distance squared instead as it is slightly more efficient to calculate.
     *
     * @param {Vector2} v - The vector to compute the squared distance to.
     * @return {number} The squared distance.
     */
    distanceToSquared(v2) {
      const dx = this.x - v2.x, dy = this.y - v2.y;
      return dx * dx + dy * dy;
    }
    /**
     * Computes the Manhattan distance from the given vector to this instance.
     *
     * @param {Vector2} v - The vector to compute the Manhattan distance to.
     * @return {number} The Manhattan distance.
     */
    manhattanDistanceTo(v2) {
      return Math.abs(this.x - v2.x) + Math.abs(this.y - v2.y);
    }
    /**
     * Sets this vector to a vector with the same direction as this one, but
     * with the specified length.
     *
     * @param {number} length - The new length of this vector.
     * @return {Vector2} A reference to this vector.
     */
    setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
    /**
     * Linearly interpolates between the given vector and this instance, where
     * alpha is the percent distance along the line - alpha = 0 will be this
     * vector, and alpha = 1 will be the given one.
     *
     * @param {Vector2} v - The vector to interpolate towards.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector2} A reference to this vector.
     */
    lerp(v2, alpha) {
      this.x += (v2.x - this.x) * alpha;
      this.y += (v2.y - this.y) * alpha;
      return this;
    }
    /**
     * Linearly interpolates between the given vectors, where alpha is the percent
     * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
     * be the second one. The result is stored in this instance.
     *
     * @param {Vector2} v1 - The first vector.
     * @param {Vector2} v2 - The second vector.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector2} A reference to this vector.
     */
    lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      return this;
    }
    /**
     * Returns `true` if this vector is equal with the given one.
     *
     * @param {Vector2} v - The vector to test for equality.
     * @return {boolean} Whether this vector is equal with the given one.
     */
    equals(v2) {
      return v2.x === this.x && v2.y === this.y;
    }
    /**
     * Sets this vector's x value to be `array[ offset ]` and y
     * value to be `array[ offset + 1 ]`.
     *
     * @param {Array<number>} array - An array holding the vector component values.
     * @param {number} [offset=0] - The offset into the array.
     * @return {Vector2} A reference to this vector.
     */
    fromArray(array, offset = 0) {
      this.x = array[offset];
      this.y = array[offset + 1];
      return this;
    }
    /**
     * Writes the components of this vector to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the vector components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The vector components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this.x;
      array[offset + 1] = this.y;
      return array;
    }
    /**
     * Sets the components of this vector from the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
     * @param {number} index - The index into the attribute.
     * @return {Vector2} A reference to this vector.
     */
    fromBufferAttribute(attribute, index) {
      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      return this;
    }
    /**
     * Rotates this vector around the given center by the given angle.
     *
     * @param {Vector2} center - The point around which to rotate.
     * @param {number} angle - The angle to rotate, in radians.
     * @return {Vector2} A reference to this vector.
     */
    rotateAround(center, angle) {
      const c2 = Math.cos(angle), s2 = Math.sin(angle);
      const x2 = this.x - center.x;
      const y2 = this.y - center.y;
      this.x = x2 * c2 - y2 * s2 + center.x;
      this.y = x2 * s2 + y2 * c2 + center.y;
      return this;
    }
    /**
     * Sets each component of this vector to a pseudo-random value between `0` and
     * `1`, excluding `1`.
     *
     * @return {Vector2} A reference to this vector.
     */
    random() {
      this.x = Math.random();
      this.y = Math.random();
      return this;
    }
    *[Symbol.iterator]() {
      yield this.x;
      yield this.y;
    }
  }
  class Quaternion {
    /**
     * Constructs a new quaternion.
     *
     * @param {number} [x=0] - The x value of this quaternion.
     * @param {number} [y=0] - The y value of this quaternion.
     * @param {number} [z=0] - The z value of this quaternion.
     * @param {number} [w=1] - The w value of this quaternion.
     */
    constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 1) {
      this.isQuaternion = true;
      this._x = x2;
      this._y = y2;
      this._z = z2;
      this._w = w2;
    }
    /**
     * Interpolates between two quaternions via SLERP. This implementation assumes the
     * quaternion data are managed  in flat arrays.
     *
     * @param {Array<number>} dst - The destination array.
     * @param {number} dstOffset - An offset into the destination array.
     * @param {Array<number>} src0 - The source array of the first quaternion.
     * @param {number} srcOffset0 - An offset into the first source array.
     * @param {Array<number>} src1 -  The source array of the second quaternion.
     * @param {number} srcOffset1 - An offset into the second source array.
     * @param {number} t - The interpolation factor in the range `[0,1]`.
     * @see {@link Quaternion#slerp}
     */
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t2) {
      let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
      const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
      if (t2 === 0) {
        dst[dstOffset + 0] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
        return;
      }
      if (t2 === 1) {
        dst[dstOffset + 0] = x1;
        dst[dstOffset + 1] = y1;
        dst[dstOffset + 2] = z1;
        dst[dstOffset + 3] = w1;
        return;
      }
      if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
        let s2 = 1 - t2;
        const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
        if (sqrSin > Number.EPSILON) {
          const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
          s2 = Math.sin(s2 * len) / sin;
          t2 = Math.sin(t2 * len) / sin;
        }
        const tDir = t2 * dir;
        x0 = x0 * s2 + x1 * tDir;
        y0 = y0 * s2 + y1 * tDir;
        z0 = z0 * s2 + z1 * tDir;
        w0 = w0 * s2 + w1 * tDir;
        if (s2 === 1 - t2) {
          const f2 = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
          x0 *= f2;
          y0 *= f2;
          z0 *= f2;
          w0 *= f2;
        }
      }
      dst[dstOffset] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
    }
    /**
     * Multiplies two quaternions. This implementation assumes the quaternion data are managed
     * in flat arrays.
     *
     * @param {Array<number>} dst - The destination array.
     * @param {number} dstOffset - An offset into the destination array.
     * @param {Array<number>} src0 - The source array of the first quaternion.
     * @param {number} srcOffset0 - An offset into the first source array.
     * @param {Array<number>} src1 -  The source array of the second quaternion.
     * @param {number} srcOffset1 - An offset into the second source array.
     * @return {Array<number>} The destination array.
     * @see {@link Quaternion#multiplyQuaternions}.
     */
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
      const x0 = src0[srcOffset0];
      const y0 = src0[srcOffset0 + 1];
      const z0 = src0[srcOffset0 + 2];
      const w0 = src0[srcOffset0 + 3];
      const x1 = src1[srcOffset1];
      const y1 = src1[srcOffset1 + 1];
      const z1 = src1[srcOffset1 + 2];
      const w1 = src1[srcOffset1 + 3];
      dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
      dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
      dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
      dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
      return dst;
    }
    /**
     * The x value of this quaternion.
     *
     * @type {number}
     * @default 0
     */
    get x() {
      return this._x;
    }
    set x(value) {
      this._x = value;
      this._onChangeCallback();
    }
    /**
     * The y value of this quaternion.
     *
     * @type {number}
     * @default 0
     */
    get y() {
      return this._y;
    }
    set y(value) {
      this._y = value;
      this._onChangeCallback();
    }
    /**
     * The z value of this quaternion.
     *
     * @type {number}
     * @default 0
     */
    get z() {
      return this._z;
    }
    set z(value) {
      this._z = value;
      this._onChangeCallback();
    }
    /**
     * The w value of this quaternion.
     *
     * @type {number}
     * @default 1
     */
    get w() {
      return this._w;
    }
    set w(value) {
      this._w = value;
      this._onChangeCallback();
    }
    /**
     * Sets the quaternion components.
     *
     * @param {number} x - The x value of this quaternion.
     * @param {number} y - The y value of this quaternion.
     * @param {number} z - The z value of this quaternion.
     * @param {number} w - The w value of this quaternion.
     * @return {Quaternion} A reference to this quaternion.
     */
    set(x2, y2, z2, w2) {
      this._x = x2;
      this._y = y2;
      this._z = z2;
      this._w = w2;
      this._onChangeCallback();
      return this;
    }
    /**
     * Returns a new quaternion with copied values from this instance.
     *
     * @return {Quaternion} A clone of this instance.
     */
    clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
     * Copies the values of the given quaternion to this instance.
     *
     * @param {Quaternion} quaternion - The quaternion to copy.
     * @return {Quaternion} A reference to this quaternion.
     */
    copy(quaternion) {
      this._x = quaternion.x;
      this._y = quaternion.y;
      this._z = quaternion.z;
      this._w = quaternion.w;
      this._onChangeCallback();
      return this;
    }
    /**
     * Sets this quaternion from the rotation specified by the given
     * Euler angles.
     *
     * @param {Euler} euler - The Euler angles.
     * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
     * @return {Quaternion} A reference to this quaternion.
     */
    setFromEuler(euler, update = true) {
      const x2 = euler._x, y2 = euler._y, z2 = euler._z, order = euler._order;
      const cos = Math.cos;
      const sin = Math.sin;
      const c1 = cos(x2 / 2);
      const c2 = cos(y2 / 2);
      const c3 = cos(z2 / 2);
      const s1 = sin(x2 / 2);
      const s2 = sin(y2 / 2);
      const s3 = sin(z2 / 2);
      switch (order) {
        case "XYZ":
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "YXZ":
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
        case "ZXY":
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "ZYX":
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
        case "YZX":
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "XZY":
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
        default:
          console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
      }
      if (update === true) this._onChangeCallback();
      return this;
    }
    /**
     * Sets this quaternion from the given axis and angle.
     *
     * @param {Vector3} axis - The normalized axis.
     * @param {number} angle - The angle in radians.
     * @return {Quaternion} A reference to this quaternion.
     */
    setFromAxisAngle(axis, angle) {
      const halfAngle = angle / 2, s2 = Math.sin(halfAngle);
      this._x = axis.x * s2;
      this._y = axis.y * s2;
      this._z = axis.z * s2;
      this._w = Math.cos(halfAngle);
      this._onChangeCallback();
      return this;
    }
    /**
     * Sets this quaternion from the given rotation matrix.
     *
     * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
     * @return {Quaternion} A reference to this quaternion.
     */
    setFromRotationMatrix(m) {
      const te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10], trace = m11 + m22 + m33;
      if (trace > 0) {
        const s2 = 0.5 / Math.sqrt(trace + 1);
        this._w = 0.25 / s2;
        this._x = (m32 - m23) * s2;
        this._y = (m13 - m31) * s2;
        this._z = (m21 - m12) * s2;
      } else if (m11 > m22 && m11 > m33) {
        const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
        this._w = (m32 - m23) / s2;
        this._x = 0.25 * s2;
        this._y = (m12 + m21) / s2;
        this._z = (m13 + m31) / s2;
      } else if (m22 > m33) {
        const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
        this._w = (m13 - m31) / s2;
        this._x = (m12 + m21) / s2;
        this._y = 0.25 * s2;
        this._z = (m23 + m32) / s2;
      } else {
        const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
        this._w = (m21 - m12) / s2;
        this._x = (m13 + m31) / s2;
        this._y = (m23 + m32) / s2;
        this._z = 0.25 * s2;
      }
      this._onChangeCallback();
      return this;
    }
    /**
     * Sets this quaternion to the rotation required to rotate the direction vector
     * `vFrom` to the direction vector `vTo`.
     *
     * @param {Vector3} vFrom - The first (normalized) direction vector.
     * @param {Vector3} vTo - The second (normalized) direction vector.
     * @return {Quaternion} A reference to this quaternion.
     */
    setFromUnitVectors(vFrom, vTo) {
      let r2 = vFrom.dot(vTo) + 1;
      if (r2 < 1e-8) {
        r2 = 0;
        if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
          this._x = -vFrom.y;
          this._y = vFrom.x;
          this._z = 0;
          this._w = r2;
        } else {
          this._x = 0;
          this._y = -vFrom.z;
          this._z = vFrom.y;
          this._w = r2;
        }
      } else {
        this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
        this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
        this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
        this._w = r2;
      }
      return this.normalize();
    }
    /**
     * Returns the angle between this quaternion and the given one in radians.
     *
     * @param {Quaternion} q - The quaternion to compute the angle with.
     * @return {number} The angle in radians.
     */
    angleTo(q2) {
      return 2 * Math.acos(Math.abs(clamp(this.dot(q2), -1, 1)));
    }
    /**
     * Rotates this quaternion by a given angular step to the given quaternion.
     * The method ensures that the final quaternion will not overshoot `q`.
     *
     * @param {Quaternion} q - The target quaternion.
     * @param {number} step - The angular step in radians.
     * @return {Quaternion} A reference to this quaternion.
     */
    rotateTowards(q2, step) {
      const angle = this.angleTo(q2);
      if (angle === 0) return this;
      const t2 = Math.min(1, step / angle);
      this.slerp(q2, t2);
      return this;
    }
    /**
     * Sets this quaternion to the identity quaternion; that is, to the
     * quaternion that represents "no rotation".
     *
     * @return {Quaternion} A reference to this quaternion.
     */
    identity() {
      return this.set(0, 0, 0, 1);
    }
    /**
     * Inverts this quaternion via {@link Quaternion#conjugate}. The
     * quaternion is assumed to have unit length.
     *
     * @return {Quaternion} A reference to this quaternion.
     */
    invert() {
      return this.conjugate();
    }
    /**
     * Returns the rotational conjugate of this quaternion. The conjugate of a
     * quaternion represents the same rotation in the opposite direction about
     * the rotational axis.
     *
     * @return {Quaternion} A reference to this quaternion.
     */
    conjugate() {
      this._x *= -1;
      this._y *= -1;
      this._z *= -1;
      this._onChangeCallback();
      return this;
    }
    /**
     * Calculates the dot product of this quaternion and the given one.
     *
     * @param {Quaternion} v - The quaternion to compute the dot product with.
     * @return {number} The result of the dot product.
     */
    dot(v2) {
      return this._x * v2._x + this._y * v2._y + this._z * v2._z + this._w * v2._w;
    }
    /**
     * Computes the squared Euclidean length (straight-line length) of this quaternion,
     * considered as a 4 dimensional vector. This can be useful if you are comparing the
     * lengths of two quaternions, as this is a slightly more efficient calculation than
     * {@link Quaternion#length}.
     *
     * @return {number} The squared Euclidean length.
     */
    lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
     * Computes the Euclidean length (straight-line length) of this quaternion,
     * considered as a 4 dimensional vector.
     *
     * @return {number} The Euclidean length.
     */
    length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
     * Normalizes this quaternion - that is, calculated the quaternion that performs
     * the same rotation as this one, but has a length equal to `1`.
     *
     * @return {Quaternion} A reference to this quaternion.
     */
    normalize() {
      let l2 = this.length();
      if (l2 === 0) {
        this._x = 0;
        this._y = 0;
        this._z = 0;
        this._w = 1;
      } else {
        l2 = 1 / l2;
        this._x = this._x * l2;
        this._y = this._y * l2;
        this._z = this._z * l2;
        this._w = this._w * l2;
      }
      this._onChangeCallback();
      return this;
    }
    /**
     * Multiplies this quaternion by the given one.
     *
     * @param {Quaternion} q - The quaternion.
     * @return {Quaternion} A reference to this quaternion.
     */
    multiply(q2) {
      return this.multiplyQuaternions(this, q2);
    }
    /**
     * Pre-multiplies this quaternion by the given one.
     *
     * @param {Quaternion} q - The quaternion.
     * @return {Quaternion} A reference to this quaternion.
     */
    premultiply(q2) {
      return this.multiplyQuaternions(q2, this);
    }
    /**
     * Multiplies the given quaternions and stores the result in this instance.
     *
     * @param {Quaternion} a - The first quaternion.
     * @param {Quaternion} b - The second quaternion.
     * @return {Quaternion} A reference to this quaternion.
     */
    multiplyQuaternions(a2, b2) {
      const qax = a2._x, qay = a2._y, qaz = a2._z, qaw = a2._w;
      const qbx = b2._x, qby = b2._y, qbz = b2._z, qbw = b2._w;
      this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
      this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
      this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
      this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
      this._onChangeCallback();
      return this;
    }
    /**
     * Performs a spherical linear interpolation between quaternions.
     *
     * @param {Quaternion} qb - The target quaternion.
     * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
     * @return {Quaternion} A reference to this quaternion.
     */
    slerp(qb, t2) {
      if (t2 === 0) return this;
      if (t2 === 1) return this.copy(qb);
      const x2 = this._x, y2 = this._y, z2 = this._z, w2 = this._w;
      let cosHalfTheta = w2 * qb._w + x2 * qb._x + y2 * qb._y + z2 * qb._z;
      if (cosHalfTheta < 0) {
        this._w = -qb._w;
        this._x = -qb._x;
        this._y = -qb._y;
        this._z = -qb._z;
        cosHalfTheta = -cosHalfTheta;
      } else {
        this.copy(qb);
      }
      if (cosHalfTheta >= 1) {
        this._w = w2;
        this._x = x2;
        this._y = y2;
        this._z = z2;
        return this;
      }
      const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
      if (sqrSinHalfTheta <= Number.EPSILON) {
        const s2 = 1 - t2;
        this._w = s2 * w2 + t2 * this._w;
        this._x = s2 * x2 + t2 * this._x;
        this._y = s2 * y2 + t2 * this._y;
        this._z = s2 * z2 + t2 * this._z;
        this.normalize();
        return this;
      }
      const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
      const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
      const ratioA = Math.sin((1 - t2) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t2 * halfTheta) / sinHalfTheta;
      this._w = w2 * ratioA + this._w * ratioB;
      this._x = x2 * ratioA + this._x * ratioB;
      this._y = y2 * ratioA + this._y * ratioB;
      this._z = z2 * ratioA + this._z * ratioB;
      this._onChangeCallback();
      return this;
    }
    /**
     * Performs a spherical linear interpolation between the given quaternions
     * and stores the result in this quaternion.
     *
     * @param {Quaternion} qa - The source quaternion.
     * @param {Quaternion} qb - The target quaternion.
     * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
     * @return {Quaternion} A reference to this quaternion.
     */
    slerpQuaternions(qa2, qb, t2) {
      return this.copy(qa2).slerp(qb, t2);
    }
    /**
     * Sets this quaternion to a uniformly random, normalized quaternion.
     *
     * @return {Quaternion} A reference to this quaternion.
     */
    random() {
      const theta1 = 2 * Math.PI * Math.random();
      const theta2 = 2 * Math.PI * Math.random();
      const x0 = Math.random();
      const r1 = Math.sqrt(1 - x0);
      const r2 = Math.sqrt(x0);
      return this.set(
        r1 * Math.sin(theta1),
        r1 * Math.cos(theta1),
        r2 * Math.sin(theta2),
        r2 * Math.cos(theta2)
      );
    }
    /**
     * Returns `true` if this quaternion is equal with the given one.
     *
     * @param {Quaternion} quaternion - The quaternion to test for equality.
     * @return {boolean} Whether this quaternion is equal with the given one.
     */
    equals(quaternion) {
      return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
     * Sets this quaternion's components from the given array.
     *
     * @param {Array<number>} array - An array holding the quaternion component values.
     * @param {number} [offset=0] - The offset into the array.
     * @return {Quaternion} A reference to this quaternion.
     */
    fromArray(array, offset = 0) {
      this._x = array[offset];
      this._y = array[offset + 1];
      this._z = array[offset + 2];
      this._w = array[offset + 3];
      this._onChangeCallback();
      return this;
    }
    /**
     * Writes the components of this quaternion to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The quaternion components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this._x;
      array[offset + 1] = this._y;
      array[offset + 2] = this._z;
      array[offset + 3] = this._w;
      return array;
    }
    /**
     * Sets the components of this quaternion from the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
     * @param {number} index - The index into the attribute.
     * @return {Quaternion} A reference to this quaternion.
     */
    fromBufferAttribute(attribute, index) {
      this._x = attribute.getX(index);
      this._y = attribute.getY(index);
      this._z = attribute.getZ(index);
      this._w = attribute.getW(index);
      this._onChangeCallback();
      return this;
    }
    /**
     * This methods defines the serialization result of this class. Returns the
     * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
     *
     * @return {Array<number>} The serialized quaternion.
     */
    toJSON() {
      return this.toArray();
    }
    _onChange(callback) {
      this._onChangeCallback = callback;
      return this;
    }
    _onChangeCallback() {
    }
    *[Symbol.iterator]() {
      yield this._x;
      yield this._y;
      yield this._z;
      yield this._w;
    }
  }
  class Vector3 {
    /**
     * Constructs a new 3D vector.
     *
     * @param {number} [x=0] - The x value of this vector.
     * @param {number} [y=0] - The y value of this vector.
     * @param {number} [z=0] - The z value of this vector.
     */
    constructor(x2 = 0, y2 = 0, z2 = 0) {
      Vector3.prototype.isVector3 = true;
      this.x = x2;
      this.y = y2;
      this.z = z2;
    }
    /**
     * Sets the vector components.
     *
     * @param {number} x - The value of the x component.
     * @param {number} y - The value of the y component.
     * @param {number} z - The value of the z component.
     * @return {Vector3} A reference to this vector.
     */
    set(x2, y2, z2) {
      if (z2 === void 0) z2 = this.z;
      this.x = x2;
      this.y = y2;
      this.z = z2;
      return this;
    }
    /**
     * Sets the vector components to the same value.
     *
     * @param {number} scalar - The value to set for all vector components.
     * @return {Vector3} A reference to this vector.
     */
    setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      this.z = scalar;
      return this;
    }
    /**
     * Sets the vector's x component to the given value
     *
     * @param {number} x - The value to set.
     * @return {Vector3} A reference to this vector.
     */
    setX(x2) {
      this.x = x2;
      return this;
    }
    /**
     * Sets the vector's y component to the given value
     *
     * @param {number} y - The value to set.
     * @return {Vector3} A reference to this vector.
     */
    setY(y2) {
      this.y = y2;
      return this;
    }
    /**
     * Sets the vector's z component to the given value
     *
     * @param {number} z - The value to set.
     * @return {Vector3} A reference to this vector.
     */
    setZ(z2) {
      this.z = z2;
      return this;
    }
    /**
     * Allows to set a vector component with an index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
     * @param {number} value - The value to set.
     * @return {Vector3} A reference to this vector.
     */
    setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;
        case 1:
          this.y = value;
          break;
        case 2:
          this.z = value;
          break;
        default:
          throw new Error("index is out of range: " + index);
      }
      return this;
    }
    /**
     * Returns the value of the vector component which matches the given index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
     * @return {number} A vector component value.
     */
    getComponent(index) {
      switch (index) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        case 2:
          return this.z;
        default:
          throw new Error("index is out of range: " + index);
      }
    }
    /**
     * Returns a new vector with copied values from this instance.
     *
     * @return {Vector3} A clone of this instance.
     */
    clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
    /**
     * Copies the values of the given vector to this instance.
     *
     * @param {Vector3} v - The vector to copy.
     * @return {Vector3} A reference to this vector.
     */
    copy(v2) {
      this.x = v2.x;
      this.y = v2.y;
      this.z = v2.z;
      return this;
    }
    /**
     * Adds the given vector to this instance.
     *
     * @param {Vector3} v - The vector to add.
     * @return {Vector3} A reference to this vector.
     */
    add(v2) {
      this.x += v2.x;
      this.y += v2.y;
      this.z += v2.z;
      return this;
    }
    /**
     * Adds the given scalar value to all components of this instance.
     *
     * @param {number} s - The scalar to add.
     * @return {Vector3} A reference to this vector.
     */
    addScalar(s2) {
      this.x += s2;
      this.y += s2;
      this.z += s2;
      return this;
    }
    /**
     * Adds the given vectors and stores the result in this instance.
     *
     * @param {Vector3} a - The first vector.
     * @param {Vector3} b - The second vector.
     * @return {Vector3} A reference to this vector.
     */
    addVectors(a2, b2) {
      this.x = a2.x + b2.x;
      this.y = a2.y + b2.y;
      this.z = a2.z + b2.z;
      return this;
    }
    /**
     * Adds the given vector scaled by the given factor to this instance.
     *
     * @param {Vector3|Vector4} v - The vector.
     * @param {number} s - The factor that scales `v`.
     * @return {Vector3} A reference to this vector.
     */
    addScaledVector(v2, s2) {
      this.x += v2.x * s2;
      this.y += v2.y * s2;
      this.z += v2.z * s2;
      return this;
    }
    /**
     * Subtracts the given vector from this instance.
     *
     * @param {Vector3} v - The vector to subtract.
     * @return {Vector3} A reference to this vector.
     */
    sub(v2) {
      this.x -= v2.x;
      this.y -= v2.y;
      this.z -= v2.z;
      return this;
    }
    /**
     * Subtracts the given scalar value from all components of this instance.
     *
     * @param {number} s - The scalar to subtract.
     * @return {Vector3} A reference to this vector.
     */
    subScalar(s2) {
      this.x -= s2;
      this.y -= s2;
      this.z -= s2;
      return this;
    }
    /**
     * Subtracts the given vectors and stores the result in this instance.
     *
     * @param {Vector3} a - The first vector.
     * @param {Vector3} b - The second vector.
     * @return {Vector3} A reference to this vector.
     */
    subVectors(a2, b2) {
      this.x = a2.x - b2.x;
      this.y = a2.y - b2.y;
      this.z = a2.z - b2.z;
      return this;
    }
    /**
     * Multiplies the given vector with this instance.
     *
     * @param {Vector3} v - The vector to multiply.
     * @return {Vector3} A reference to this vector.
     */
    multiply(v2) {
      this.x *= v2.x;
      this.y *= v2.y;
      this.z *= v2.z;
      return this;
    }
    /**
     * Multiplies the given scalar value with all components of this instance.
     *
     * @param {number} scalar - The scalar to multiply.
     * @return {Vector3} A reference to this vector.
     */
    multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      this.z *= scalar;
      return this;
    }
    /**
     * Multiplies the given vectors and stores the result in this instance.
     *
     * @param {Vector3} a - The first vector.
     * @param {Vector3} b - The second vector.
     * @return {Vector3} A reference to this vector.
     */
    multiplyVectors(a2, b2) {
      this.x = a2.x * b2.x;
      this.y = a2.y * b2.y;
      this.z = a2.z * b2.z;
      return this;
    }
    /**
     * Applies the given Euler rotation to this vector.
     *
     * @param {Euler} euler - The Euler angles.
     * @return {Vector3} A reference to this vector.
     */
    applyEuler(euler) {
      return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
    }
    /**
     * Applies a rotation specified by an axis and an angle to this vector.
     *
     * @param {Vector3} axis - A normalized vector representing the rotation axis.
     * @param {number} angle - The angle in radians.
     * @return {Vector3} A reference to this vector.
     */
    applyAxisAngle(axis, angle) {
      return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
     * Multiplies this vector with the given 3x3 matrix.
     *
     * @param {Matrix3} m - The 3x3 matrix.
     * @return {Vector3} A reference to this vector.
     */
    applyMatrix3(m) {
      const x2 = this.x, y2 = this.y, z2 = this.z;
      const e2 = m.elements;
      this.x = e2[0] * x2 + e2[3] * y2 + e2[6] * z2;
      this.y = e2[1] * x2 + e2[4] * y2 + e2[7] * z2;
      this.z = e2[2] * x2 + e2[5] * y2 + e2[8] * z2;
      return this;
    }
    /**
     * Multiplies this vector by the given normal matrix and normalizes
     * the result.
     *
     * @param {Matrix3} m - The normal matrix.
     * @return {Vector3} A reference to this vector.
     */
    applyNormalMatrix(m) {
      return this.applyMatrix3(m).normalize();
    }
    /**
     * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
     * divides by perspective.
     *
     * @param {Matrix4} m - The matrix to apply.
     * @return {Vector3} A reference to this vector.
     */
    applyMatrix4(m) {
      const x2 = this.x, y2 = this.y, z2 = this.z;
      const e2 = m.elements;
      const w2 = 1 / (e2[3] * x2 + e2[7] * y2 + e2[11] * z2 + e2[15]);
      this.x = (e2[0] * x2 + e2[4] * y2 + e2[8] * z2 + e2[12]) * w2;
      this.y = (e2[1] * x2 + e2[5] * y2 + e2[9] * z2 + e2[13]) * w2;
      this.z = (e2[2] * x2 + e2[6] * y2 + e2[10] * z2 + e2[14]) * w2;
      return this;
    }
    /**
     * Applies the given Quaternion to this vector.
     *
     * @param {Quaternion} q - The Quaternion.
     * @return {Vector3} A reference to this vector.
     */
    applyQuaternion(q2) {
      const vx = this.x, vy = this.y, vz = this.z;
      const qx = q2.x, qy = q2.y, qz = q2.z, qw = q2.w;
      const tx = 2 * (qy * vz - qz * vy);
      const ty = 2 * (qz * vx - qx * vz);
      const tz = 2 * (qx * vy - qy * vx);
      this.x = vx + qw * tx + qy * tz - qz * ty;
      this.y = vy + qw * ty + qz * tx - qx * tz;
      this.z = vz + qw * tz + qx * ty - qy * tx;
      return this;
    }
    /**
     * Projects this vector from world space into the camera's normalized
     * device coordinate (NDC) space.
     *
     * @param {Camera} camera - The camera.
     * @return {Vector3} A reference to this vector.
     */
    project(camera) {
      return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
     * Unprojects this vector from the camera's normalized device coordinate (NDC)
     * space into world space.
     *
     * @param {Camera} camera - The camera.
     * @return {Vector3} A reference to this vector.
     */
    unproject(camera) {
      return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
     * Transforms the direction of this vector by a matrix (the upper left 3 x 3
     * subset of the given 4x4 matrix and then normalizes the result.
     *
     * @param {Matrix4} m - The matrix.
     * @return {Vector3} A reference to this vector.
     */
    transformDirection(m) {
      const x2 = this.x, y2 = this.y, z2 = this.z;
      const e2 = m.elements;
      this.x = e2[0] * x2 + e2[4] * y2 + e2[8] * z2;
      this.y = e2[1] * x2 + e2[5] * y2 + e2[9] * z2;
      this.z = e2[2] * x2 + e2[6] * y2 + e2[10] * z2;
      return this.normalize();
    }
    /**
     * Divides this instance by the given vector.
     *
     * @param {Vector3} v - The vector to divide.
     * @return {Vector3} A reference to this vector.
     */
    divide(v2) {
      this.x /= v2.x;
      this.y /= v2.y;
      this.z /= v2.z;
      return this;
    }
    /**
     * Divides this vector by the given scalar.
     *
     * @param {number} scalar - The scalar to divide.
     * @return {Vector3} A reference to this vector.
     */
    divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
    /**
     * If this vector's x, y or z value is greater than the given vector's x, y or z
     * value, replace that value with the corresponding min value.
     *
     * @param {Vector3} v - The vector.
     * @return {Vector3} A reference to this vector.
     */
    min(v2) {
      this.x = Math.min(this.x, v2.x);
      this.y = Math.min(this.y, v2.y);
      this.z = Math.min(this.z, v2.z);
      return this;
    }
    /**
     * If this vector's x, y or z value is less than the given vector's x, y or z
     * value, replace that value with the corresponding max value.
     *
     * @param {Vector3} v - The vector.
     * @return {Vector3} A reference to this vector.
     */
    max(v2) {
      this.x = Math.max(this.x, v2.x);
      this.y = Math.max(this.y, v2.y);
      this.z = Math.max(this.z, v2.z);
      return this;
    }
    /**
     * If this vector's x, y or z value is greater than the max vector's x, y or z
     * value, it is replaced by the corresponding value.
     * If this vector's x, y or z value is less than the min vector's x, y or z value,
     * it is replaced by the corresponding value.
     *
     * @param {Vector3} min - The minimum x, y and z values.
     * @param {Vector3} max - The maximum x, y and z values in the desired range.
     * @return {Vector3} A reference to this vector.
     */
    clamp(min, max) {
      this.x = clamp(this.x, min.x, max.x);
      this.y = clamp(this.y, min.y, max.y);
      this.z = clamp(this.z, min.z, max.z);
      return this;
    }
    /**
     * If this vector's x, y or z values are greater than the max value, they are
     * replaced by the max value.
     * If this vector's x, y or z values are less than the min value, they are
     * replaced by the min value.
     *
     * @param {number} minVal - The minimum value the components will be clamped to.
     * @param {number} maxVal - The maximum value the components will be clamped to.
     * @return {Vector3} A reference to this vector.
     */
    clampScalar(minVal, maxVal) {
      this.x = clamp(this.x, minVal, maxVal);
      this.y = clamp(this.y, minVal, maxVal);
      this.z = clamp(this.z, minVal, maxVal);
      return this;
    }
    /**
     * If this vector's length is greater than the max value, it is replaced by
     * the max value.
     * If this vector's length is less than the min value, it is replaced by the
     * min value.
     *
     * @param {number} min - The minimum value the vector length will be clamped to.
     * @param {number} max - The maximum value the vector length will be clamped to.
     * @return {Vector3} A reference to this vector.
     */
    clampLength(min, max) {
      const length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
     * The components of this vector are rounded down to the nearest integer value.
     *
     * @return {Vector3} A reference to this vector.
     */
    floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      this.z = Math.floor(this.z);
      return this;
    }
    /**
     * The components of this vector are rounded up to the nearest integer value.
     *
     * @return {Vector3} A reference to this vector.
     */
    ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      this.z = Math.ceil(this.z);
      return this;
    }
    /**
     * The components of this vector are rounded to the nearest integer value
     *
     * @return {Vector3} A reference to this vector.
     */
    round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      this.z = Math.round(this.z);
      return this;
    }
    /**
     * The components of this vector are rounded towards zero (up if negative,
     * down if positive) to an integer value.
     *
     * @return {Vector3} A reference to this vector.
     */
    roundToZero() {
      this.x = Math.trunc(this.x);
      this.y = Math.trunc(this.y);
      this.z = Math.trunc(this.z);
      return this;
    }
    /**
     * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
     *
     * @return {Vector3} A reference to this vector.
     */
    negate() {
      this.x = -this.x;
      this.y = -this.y;
      this.z = -this.z;
      return this;
    }
    /**
     * Calculates the dot product of the given vector with this instance.
     *
     * @param {Vector3} v - The vector to compute the dot product with.
     * @return {number} The result of the dot product.
     */
    dot(v2) {
      return this.x * v2.x + this.y * v2.y + this.z * v2.z;
    }
    // TODO lengthSquared?
    /**
     * Computes the square of the Euclidean length (straight-line length) from
     * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
     * compare the length squared instead as it is slightly more efficient to calculate.
     *
     * @return {number} The square length of this vector.
     */
    lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
     * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
     *
     * @return {number} The length of this vector.
     */
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
     * Computes the Manhattan length of this vector.
     *
     * @return {number} The length of this vector.
     */
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
     * Converts this vector to a unit vector - that is, sets it equal to a vector
     * with the same direction as this one, but with a vector length of `1`.
     *
     * @return {Vector3} A reference to this vector.
     */
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    /**
     * Sets this vector to a vector with the same direction as this one, but
     * with the specified length.
     *
     * @param {number} length - The new length of this vector.
     * @return {Vector3} A reference to this vector.
     */
    setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
    /**
     * Linearly interpolates between the given vector and this instance, where
     * alpha is the percent distance along the line - alpha = 0 will be this
     * vector, and alpha = 1 will be the given one.
     *
     * @param {Vector3} v - The vector to interpolate towards.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector3} A reference to this vector.
     */
    lerp(v2, alpha) {
      this.x += (v2.x - this.x) * alpha;
      this.y += (v2.y - this.y) * alpha;
      this.z += (v2.z - this.z) * alpha;
      return this;
    }
    /**
     * Linearly interpolates between the given vectors, where alpha is the percent
     * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
     * be the second one. The result is stored in this instance.
     *
     * @param {Vector3} v1 - The first vector.
     * @param {Vector3} v2 - The second vector.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector3} A reference to this vector.
     */
    lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      this.z = v1.z + (v2.z - v1.z) * alpha;
      return this;
    }
    /**
     * Calculates the cross product of the given vector with this instance.
     *
     * @param {Vector3} v - The vector to compute the cross product with.
     * @return {Vector3} The result of the cross product.
     */
    cross(v2) {
      return this.crossVectors(this, v2);
    }
    /**
     * Calculates the cross product of the given vectors and stores the result
     * in this instance.
     *
     * @param {Vector3} a - The first vector.
     * @param {Vector3} b - The second vector.
     * @return {Vector3} A reference to this vector.
     */
    crossVectors(a2, b2) {
      const ax = a2.x, ay = a2.y, az = a2.z;
      const bx = b2.x, by = b2.y, bz = b2.z;
      this.x = ay * bz - az * by;
      this.y = az * bx - ax * bz;
      this.z = ax * by - ay * bx;
      return this;
    }
    /**
     * Projects this vector onto the given one.
     *
     * @param {Vector3} v - The vector to project to.
     * @return {Vector3} A reference to this vector.
     */
    projectOnVector(v2) {
      const denominator = v2.lengthSq();
      if (denominator === 0) return this.set(0, 0, 0);
      const scalar = v2.dot(this) / denominator;
      return this.copy(v2).multiplyScalar(scalar);
    }
    /**
     * Projects this vector onto a plane by subtracting this
     * vector projected onto the plane's normal from this vector.
     *
     * @param {Vector3} planeNormal - The plane normal.
     * @return {Vector3} A reference to this vector.
     */
    projectOnPlane(planeNormal) {
      _vector$c.copy(this).projectOnVector(planeNormal);
      return this.sub(_vector$c);
    }
    /**
     * Reflects this vector off a plane orthogonal to the given normal vector.
     *
     * @param {Vector3} normal - The (normalized) normal vector.
     * @return {Vector3} A reference to this vector.
     */
    reflect(normal) {
      return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
     * Returns the angle between the given vector and this instance in radians.
     *
     * @param {Vector3} v - The vector to compute the angle with.
     * @return {number} The angle in radians.
     */
    angleTo(v2) {
      const denominator = Math.sqrt(this.lengthSq() * v2.lengthSq());
      if (denominator === 0) return Math.PI / 2;
      const theta = this.dot(v2) / denominator;
      return Math.acos(clamp(theta, -1, 1));
    }
    /**
     * Computes the distance from the given vector to this instance.
     *
     * @param {Vector3} v - The vector to compute the distance to.
     * @return {number} The distance.
     */
    distanceTo(v2) {
      return Math.sqrt(this.distanceToSquared(v2));
    }
    /**
     * Computes the squared distance from the given vector to this instance.
     * If you are just comparing the distance with another distance, you should compare
     * the distance squared instead as it is slightly more efficient to calculate.
     *
     * @param {Vector3} v - The vector to compute the squared distance to.
     * @return {number} The squared distance.
     */
    distanceToSquared(v2) {
      const dx = this.x - v2.x, dy = this.y - v2.y, dz = this.z - v2.z;
      return dx * dx + dy * dy + dz * dz;
    }
    /**
     * Computes the Manhattan distance from the given vector to this instance.
     *
     * @param {Vector3} v - The vector to compute the Manhattan distance to.
     * @return {number} The Manhattan distance.
     */
    manhattanDistanceTo(v2) {
      return Math.abs(this.x - v2.x) + Math.abs(this.y - v2.y) + Math.abs(this.z - v2.z);
    }
    /**
     * Sets the vector components from the given spherical coordinates.
     *
     * @param {Spherical} s - The spherical coordinates.
     * @return {Vector3} A reference to this vector.
     */
    setFromSpherical(s2) {
      return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
    }
    /**
     * Sets the vector components from the given spherical coordinates.
     *
     * @param {number} radius - The radius.
     * @param {number} phi - The phi angle in radians.
     * @param {number} theta - The theta angle in radians.
     * @return {Vector3} A reference to this vector.
     */
    setFromSphericalCoords(radius, phi, theta) {
      const sinPhiRadius = Math.sin(phi) * radius;
      this.x = sinPhiRadius * Math.sin(theta);
      this.y = Math.cos(phi) * radius;
      this.z = sinPhiRadius * Math.cos(theta);
      return this;
    }
    /**
     * Sets the vector components from the given cylindrical coordinates.
     *
     * @param {Cylindrical} c - The cylindrical coordinates.
     * @return {Vector3} A reference to this vector.
     */
    setFromCylindrical(c2) {
      return this.setFromCylindricalCoords(c2.radius, c2.theta, c2.y);
    }
    /**
     * Sets the vector components from the given cylindrical coordinates.
     *
     * @param {number} radius - The radius.
     * @param {number} theta - The theta angle in radians.
     * @param {number} y - The y value.
     * @return {Vector3} A reference to this vector.
     */
    setFromCylindricalCoords(radius, theta, y2) {
      this.x = radius * Math.sin(theta);
      this.y = y2;
      this.z = radius * Math.cos(theta);
      return this;
    }
    /**
     * Sets the vector components to the position elements of the
     * given transformation matrix.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @return {Vector3} A reference to this vector.
     */
    setFromMatrixPosition(m) {
      const e2 = m.elements;
      this.x = e2[12];
      this.y = e2[13];
      this.z = e2[14];
      return this;
    }
    /**
     * Sets the vector components to the scale elements of the
     * given transformation matrix.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @return {Vector3} A reference to this vector.
     */
    setFromMatrixScale(m) {
      const sx = this.setFromMatrixColumn(m, 0).length();
      const sy = this.setFromMatrixColumn(m, 1).length();
      const sz = this.setFromMatrixColumn(m, 2).length();
      this.x = sx;
      this.y = sy;
      this.z = sz;
      return this;
    }
    /**
     * Sets the vector components from the specified matrix column.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @param {number} index - The column index.
     * @return {Vector3} A reference to this vector.
     */
    setFromMatrixColumn(m, index) {
      return this.fromArray(m.elements, index * 4);
    }
    /**
     * Sets the vector components from the specified matrix column.
     *
     * @param {Matrix3} m - The 3x3 matrix.
     * @param {number} index - The column index.
     * @return {Vector3} A reference to this vector.
     */
    setFromMatrix3Column(m, index) {
      return this.fromArray(m.elements, index * 3);
    }
    /**
     * Sets the vector components from the given Euler angles.
     *
     * @param {Euler} e - The Euler angles to set.
     * @return {Vector3} A reference to this vector.
     */
    setFromEuler(e2) {
      this.x = e2._x;
      this.y = e2._y;
      this.z = e2._z;
      return this;
    }
    /**
     * Sets the vector components from the RGB components of the
     * given color.
     *
     * @param {Color} c - The color to set.
     * @return {Vector3} A reference to this vector.
     */
    setFromColor(c2) {
      this.x = c2.r;
      this.y = c2.g;
      this.z = c2.b;
      return this;
    }
    /**
     * Returns `true` if this vector is equal with the given one.
     *
     * @param {Vector3} v - The vector to test for equality.
     * @return {boolean} Whether this vector is equal with the given one.
     */
    equals(v2) {
      return v2.x === this.x && v2.y === this.y && v2.z === this.z;
    }
    /**
     * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
     * and z value to be `array[ offset + 2 ]`.
     *
     * @param {Array<number>} array - An array holding the vector component values.
     * @param {number} [offset=0] - The offset into the array.
     * @return {Vector3} A reference to this vector.
     */
    fromArray(array, offset = 0) {
      this.x = array[offset];
      this.y = array[offset + 1];
      this.z = array[offset + 2];
      return this;
    }
    /**
     * Writes the components of this vector to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the vector components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The vector components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this.x;
      array[offset + 1] = this.y;
      array[offset + 2] = this.z;
      return array;
    }
    /**
     * Sets the components of this vector from the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
     * @param {number} index - The index into the attribute.
     * @return {Vector3} A reference to this vector.
     */
    fromBufferAttribute(attribute, index) {
      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      this.z = attribute.getZ(index);
      return this;
    }
    /**
     * Sets each component of this vector to a pseudo-random value between `0` and
     * `1`, excluding `1`.
     *
     * @return {Vector3} A reference to this vector.
     */
    random() {
      this.x = Math.random();
      this.y = Math.random();
      this.z = Math.random();
      return this;
    }
    /**
     * Sets this vector to a uniformly random point on a unit sphere.
     *
     * @return {Vector3} A reference to this vector.
     */
    randomDirection() {
      const theta = Math.random() * Math.PI * 2;
      const u2 = Math.random() * 2 - 1;
      const c2 = Math.sqrt(1 - u2 * u2);
      this.x = c2 * Math.cos(theta);
      this.y = u2;
      this.z = c2 * Math.sin(theta);
      return this;
    }
    *[Symbol.iterator]() {
      yield this.x;
      yield this.y;
      yield this.z;
    }
  }
  const _vector$c = /* @__PURE__ */ new Vector3();
  const _quaternion$4 = /* @__PURE__ */ new Quaternion();
  class Matrix3 {
    /**
     * Constructs a new 3x3 matrix. The arguments are supposed to be
     * in row-major order. If no arguments are provided, the constructor
     * initializes the matrix as an identity matrix.
     *
     * @param {number} [n11] - 1-1 matrix element.
     * @param {number} [n12] - 1-2 matrix element.
     * @param {number} [n13] - 1-3 matrix element.
     * @param {number} [n21] - 2-1 matrix element.
     * @param {number} [n22] - 2-2 matrix element.
     * @param {number} [n23] - 2-3 matrix element.
     * @param {number} [n31] - 3-1 matrix element.
     * @param {number} [n32] - 3-2 matrix element.
     * @param {number} [n33] - 3-3 matrix element.
     */
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
      Matrix3.prototype.isMatrix3 = true;
      this.elements = [
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ];
      if (n11 !== void 0) {
        this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
      }
    }
    /**
     * Sets the elements of the matrix.The arguments are supposed to be
     * in row-major order.
     *
     * @param {number} [n11] - 1-1 matrix element.
     * @param {number} [n12] - 1-2 matrix element.
     * @param {number} [n13] - 1-3 matrix element.
     * @param {number} [n21] - 2-1 matrix element.
     * @param {number} [n22] - 2-2 matrix element.
     * @param {number} [n23] - 2-3 matrix element.
     * @param {number} [n31] - 3-1 matrix element.
     * @param {number} [n32] - 3-2 matrix element.
     * @param {number} [n33] - 3-3 matrix element.
     * @return {Matrix3} A reference to this matrix.
     */
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
      const te2 = this.elements;
      te2[0] = n11;
      te2[1] = n21;
      te2[2] = n31;
      te2[3] = n12;
      te2[4] = n22;
      te2[5] = n32;
      te2[6] = n13;
      te2[7] = n23;
      te2[8] = n33;
      return this;
    }
    /**
     * Sets this matrix to the 3x3 identity matrix.
     *
     * @return {Matrix3} A reference to this matrix.
     */
    identity() {
      this.set(
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Copies the values of the given matrix to this instance.
     *
     * @param {Matrix3} m - The matrix to copy.
     * @return {Matrix3} A reference to this matrix.
     */
    copy(m) {
      const te2 = this.elements;
      const me2 = m.elements;
      te2[0] = me2[0];
      te2[1] = me2[1];
      te2[2] = me2[2];
      te2[3] = me2[3];
      te2[4] = me2[4];
      te2[5] = me2[5];
      te2[6] = me2[6];
      te2[7] = me2[7];
      te2[8] = me2[8];
      return this;
    }
    /**
     * Extracts the basis of this matrix into the three axis vectors provided.
     *
     * @param {Vector3} xAxis - The basis's x axis.
     * @param {Vector3} yAxis - The basis's y axis.
     * @param {Vector3} zAxis - The basis's z axis.
     * @return {Matrix3} A reference to this matrix.
     */
    extractBasis(xAxis, yAxis, zAxis) {
      xAxis.setFromMatrix3Column(this, 0);
      yAxis.setFromMatrix3Column(this, 1);
      zAxis.setFromMatrix3Column(this, 2);
      return this;
    }
    /**
     * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @return {Matrix3} A reference to this matrix.
     */
    setFromMatrix4(m) {
      const me2 = m.elements;
      this.set(
        me2[0],
        me2[4],
        me2[8],
        me2[1],
        me2[5],
        me2[9],
        me2[2],
        me2[6],
        me2[10]
      );
      return this;
    }
    /**
     * Post-multiplies this matrix by the given 3x3 matrix.
     *
     * @param {Matrix3} m - The matrix to multiply with.
     * @return {Matrix3} A reference to this matrix.
     */
    multiply(m) {
      return this.multiplyMatrices(this, m);
    }
    /**
     * Pre-multiplies this matrix by the given 3x3 matrix.
     *
     * @param {Matrix3} m - The matrix to multiply with.
     * @return {Matrix3} A reference to this matrix.
     */
    premultiply(m) {
      return this.multiplyMatrices(m, this);
    }
    /**
     * Multiples the given 3x3 matrices and stores the result
     * in this matrix.
     *
     * @param {Matrix3} a - The first matrix.
     * @param {Matrix3} b - The second matrix.
     * @return {Matrix3} A reference to this matrix.
     */
    multiplyMatrices(a2, b2) {
      const ae2 = a2.elements;
      const be2 = b2.elements;
      const te2 = this.elements;
      const a11 = ae2[0], a12 = ae2[3], a13 = ae2[6];
      const a21 = ae2[1], a22 = ae2[4], a23 = ae2[7];
      const a31 = ae2[2], a32 = ae2[5], a33 = ae2[8];
      const b11 = be2[0], b12 = be2[3], b13 = be2[6];
      const b21 = be2[1], b22 = be2[4], b23 = be2[7];
      const b31 = be2[2], b32 = be2[5], b33 = be2[8];
      te2[0] = a11 * b11 + a12 * b21 + a13 * b31;
      te2[3] = a11 * b12 + a12 * b22 + a13 * b32;
      te2[6] = a11 * b13 + a12 * b23 + a13 * b33;
      te2[1] = a21 * b11 + a22 * b21 + a23 * b31;
      te2[4] = a21 * b12 + a22 * b22 + a23 * b32;
      te2[7] = a21 * b13 + a22 * b23 + a23 * b33;
      te2[2] = a31 * b11 + a32 * b21 + a33 * b31;
      te2[5] = a31 * b12 + a32 * b22 + a33 * b32;
      te2[8] = a31 * b13 + a32 * b23 + a33 * b33;
      return this;
    }
    /**
     * Multiplies every component of the matrix by the given scalar.
     *
     * @param {number} s - The scalar.
     * @return {Matrix3} A reference to this matrix.
     */
    multiplyScalar(s2) {
      const te2 = this.elements;
      te2[0] *= s2;
      te2[3] *= s2;
      te2[6] *= s2;
      te2[1] *= s2;
      te2[4] *= s2;
      te2[7] *= s2;
      te2[2] *= s2;
      te2[5] *= s2;
      te2[8] *= s2;
      return this;
    }
    /**
     * Computes and returns the determinant of this matrix.
     *
     * @return {number} The determinant.
     */
    determinant() {
      const te2 = this.elements;
      const a2 = te2[0], b2 = te2[1], c2 = te2[2], d2 = te2[3], e2 = te2[4], f2 = te2[5], g2 = te2[6], h2 = te2[7], i2 = te2[8];
      return a2 * e2 * i2 - a2 * f2 * h2 - b2 * d2 * i2 + b2 * f2 * g2 + c2 * d2 * h2 - c2 * e2 * g2;
    }
    /**
     * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
     * You can not invert with a determinant of zero. If you attempt this, the method produces
     * a zero matrix instead.
     *
     * @return {Matrix3} A reference to this matrix.
     */
    invert() {
      const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n12 = te2[3], n22 = te2[4], n32 = te2[5], n13 = te2[6], n23 = te2[7], n33 = te2[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
      if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      const detInv = 1 / det;
      te2[0] = t11 * detInv;
      te2[1] = (n31 * n23 - n33 * n21) * detInv;
      te2[2] = (n32 * n21 - n31 * n22) * detInv;
      te2[3] = t12 * detInv;
      te2[4] = (n33 * n11 - n31 * n13) * detInv;
      te2[5] = (n31 * n12 - n32 * n11) * detInv;
      te2[6] = t13 * detInv;
      te2[7] = (n21 * n13 - n23 * n11) * detInv;
      te2[8] = (n22 * n11 - n21 * n12) * detInv;
      return this;
    }
    /**
     * Transposes this matrix in place.
     *
     * @return {Matrix3} A reference to this matrix.
     */
    transpose() {
      let tmp2;
      const m = this.elements;
      tmp2 = m[1];
      m[1] = m[3];
      m[3] = tmp2;
      tmp2 = m[2];
      m[2] = m[6];
      m[6] = tmp2;
      tmp2 = m[5];
      m[5] = m[7];
      m[7] = tmp2;
      return this;
    }
    /**
     * Computes the normal matrix which is the inverse transpose of the upper
     * left 3x3 portion of the given 4x4 matrix.
     *
     * @param {Matrix4} matrix4 - The 4x4 matrix.
     * @return {Matrix3} A reference to this matrix.
     */
    getNormalMatrix(matrix4) {
      return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
     * Transposes this matrix into the supplied array, and returns itself unchanged.
     *
     * @param {Array<number>} r - An array to store the transposed matrix elements.
     * @return {Matrix3} A reference to this matrix.
     */
    transposeIntoArray(r2) {
      const m = this.elements;
      r2[0] = m[0];
      r2[1] = m[3];
      r2[2] = m[6];
      r2[3] = m[1];
      r2[4] = m[4];
      r2[5] = m[7];
      r2[6] = m[2];
      r2[7] = m[5];
      r2[8] = m[8];
      return this;
    }
    /**
     * Sets the UV transform matrix from offset, repeat, rotation, and center.
     *
     * @param {number} tx - Offset x.
     * @param {number} ty - Offset y.
     * @param {number} sx - Repeat x.
     * @param {number} sy - Repeat y.
     * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
     * @param {number} cx - Center x of rotation.
     * @param {number} cy - Center y of rotation
     * @return {Matrix3} A reference to this matrix.
     */
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
      const c2 = Math.cos(rotation);
      const s2 = Math.sin(rotation);
      this.set(
        sx * c2,
        sx * s2,
        -sx * (c2 * cx + s2 * cy) + cx + tx,
        -sy * s2,
        sy * c2,
        -sy * (-s2 * cx + c2 * cy) + cy + ty,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Scales this matrix with the given scalar values.
     *
     * @param {number} sx - The amount to scale in the X axis.
     * @param {number} sy - The amount to scale in the Y axis.
     * @return {Matrix3} A reference to this matrix.
     */
    scale(sx, sy) {
      this.premultiply(_m3.makeScale(sx, sy));
      return this;
    }
    /**
     * Rotates this matrix by the given angle.
     *
     * @param {number} theta - The rotation in radians.
     * @return {Matrix3} A reference to this matrix.
     */
    rotate(theta) {
      this.premultiply(_m3.makeRotation(-theta));
      return this;
    }
    /**
     * Translates this matrix by the given scalar values.
     *
     * @param {number} tx - The amount to translate in the X axis.
     * @param {number} ty - The amount to translate in the Y axis.
     * @return {Matrix3} A reference to this matrix.
     */
    translate(tx, ty) {
      this.premultiply(_m3.makeTranslation(tx, ty));
      return this;
    }
    // for 2D Transforms
    /**
     * Sets this matrix as a 2D translation transform.
     *
     * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
     * @param {number} y - The amount to translate in the Y axis.
     * @return {Matrix3} A reference to this matrix.
     */
    makeTranslation(x2, y2) {
      if (x2.isVector2) {
        this.set(
          1,
          0,
          x2.x,
          0,
          1,
          x2.y,
          0,
          0,
          1
        );
      } else {
        this.set(
          1,
          0,
          x2,
          0,
          1,
          y2,
          0,
          0,
          1
        );
      }
      return this;
    }
    /**
     * Sets this matrix as a 2D rotational transformation.
     *
     * @param {number} theta - The rotation in radians.
     * @return {Matrix3} A reference to this matrix.
     */
    makeRotation(theta) {
      const c2 = Math.cos(theta);
      const s2 = Math.sin(theta);
      this.set(
        c2,
        -s2,
        0,
        s2,
        c2,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a 2D scale transform.
     *
     * @param {number} x - The amount to scale in the X axis.
     * @param {number} y - The amount to scale in the Y axis.
     * @return {Matrix3} A reference to this matrix.
     */
    makeScale(x2, y2) {
      this.set(
        x2,
        0,
        0,
        0,
        y2,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Returns `true` if this matrix is equal with the given one.
     *
     * @param {Matrix3} matrix - The matrix to test for equality.
     * @return {boolean} Whether this matrix is equal with the given one.
     */
    equals(matrix) {
      const te2 = this.elements;
      const me2 = matrix.elements;
      for (let i2 = 0; i2 < 9; i2++) {
        if (te2[i2] !== me2[i2]) return false;
      }
      return true;
    }
    /**
     * Sets the elements of the matrix from the given array.
     *
     * @param {Array<number>} array - The matrix elements in column-major order.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Matrix3} A reference to this matrix.
     */
    fromArray(array, offset = 0) {
      for (let i2 = 0; i2 < 9; i2++) {
        this.elements[i2] = array[i2 + offset];
      }
      return this;
    }
    /**
     * Writes the elements of this matrix to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The matrix elements in column-major order.
     */
    toArray(array = [], offset = 0) {
      const te2 = this.elements;
      array[offset] = te2[0];
      array[offset + 1] = te2[1];
      array[offset + 2] = te2[2];
      array[offset + 3] = te2[3];
      array[offset + 4] = te2[4];
      array[offset + 5] = te2[5];
      array[offset + 6] = te2[6];
      array[offset + 7] = te2[7];
      array[offset + 8] = te2[8];
      return array;
    }
    /**
     * Returns a matrix with copied values from this instance.
     *
     * @return {Matrix3} A clone of this instance.
     */
    clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }
  const _m3 = /* @__PURE__ */ new Matrix3();
  function arrayNeedsUint32(array) {
    for (let i2 = array.length - 1; i2 >= 0; --i2) {
      if (array[i2] >= 65535) return true;
    }
    return false;
  }
  function createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
  }
  function createCanvasElement() {
    const canvas = createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
  }
  const _cache = {};
  function warnOnce(message) {
    if (message in _cache) return;
    _cache[message] = true;
    console.warn(message);
  }
  function probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
      function probe() {
        switch (gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)) {
          case gl.WAIT_FAILED:
            reject();
            break;
          case gl.TIMEOUT_EXPIRED:
            setTimeout(probe, interval);
            break;
          default:
            resolve();
        }
      }
      setTimeout(probe, interval);
    });
  }
  function toNormalizedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
  }
  function toReversedProjectionMatrix(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    if (isPerspectiveMatrix) {
      m[10] = -m[10] - 1;
      m[14] = -m[14];
    } else {
      m[10] = -m[10];
      m[14] = -m[14] + 1;
    }
  }
  const LINEAR_REC709_TO_XYZ = /* @__PURE__ */ new Matrix3().set(
    0.4123908,
    0.3575843,
    0.1804808,
    0.212639,
    0.7151687,
    0.0721923,
    0.0193308,
    0.1191948,
    0.9505322
  );
  const XYZ_TO_LINEAR_REC709 = /* @__PURE__ */ new Matrix3().set(
    3.2409699,
    -1.5373832,
    -0.4986108,
    -0.9692436,
    1.8759675,
    0.0415551,
    0.0556301,
    -0.203977,
    1.0569715
  );
  function createColorManagement() {
    const ColorManagement2 = {
      enabled: true,
      workingColorSpace: LinearSRGBColorSpace,
      /**
       * Implementations of supported color spaces.
       *
       * Required:
       *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
       *	- whitePoint: reference white [ x y ]
       *	- transfer: transfer function (pre-defined)
       *	- toXYZ: Matrix3 RGB to XYZ transform
       *	- fromXYZ: Matrix3 XYZ to RGB transform
       *	- luminanceCoefficients: RGB luminance coefficients
       *
       * Optional:
       *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
       *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
       *
       * Reference:
       * - https://www.russellcottrell.com/photo/matrixCalculator.htm
       */
      spaces: {},
      convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
          return color;
        }
        if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
          color.r = SRGBToLinear(color.r);
          color.g = SRGBToLinear(color.g);
          color.b = SRGBToLinear(color.b);
        }
        if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
          color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
          color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
        }
        if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
          color.r = LinearToSRGB(color.r);
          color.g = LinearToSRGB(color.g);
          color.b = LinearToSRGB(color.b);
        }
        return color;
      },
      workingToColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
      },
      colorSpaceToWorking: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
      },
      getPrimaries: function(colorSpace) {
        return this.spaces[colorSpace].primaries;
      },
      getTransfer: function(colorSpace) {
        if (colorSpace === NoColorSpace) return LinearTransfer;
        return this.spaces[colorSpace].transfer;
      },
      getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
        return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
      },
      define: function(colorSpaces) {
        Object.assign(this.spaces, colorSpaces);
      },
      // Internal APIs
      _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
        return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
      },
      _getDrawingBufferColorSpace: function(colorSpace) {
        return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
      },
      _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
        return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
      },
      // Deprecated
      fromWorkingColorSpace: function(color, targetColorSpace) {
        warnOnce("THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().");
        return ColorManagement2.workingToColorSpace(color, targetColorSpace);
      },
      toWorkingColorSpace: function(color, sourceColorSpace) {
        warnOnce("THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().");
        return ColorManagement2.colorSpaceToWorking(color, sourceColorSpace);
      }
    };
    const REC709_PRIMARIES = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06];
    const REC709_LUMINANCE_COEFFICIENTS = [0.2126, 0.7152, 0.0722];
    const D65 = [0.3127, 0.329];
    ColorManagement2.define({
      [LinearSRGBColorSpace]: {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: LinearTransfer,
        toXYZ: LINEAR_REC709_TO_XYZ,
        fromXYZ: XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        workingColorSpaceConfig: { unpackColorSpace: SRGBColorSpace },
        outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
      },
      [SRGBColorSpace]: {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: SRGBTransfer,
        toXYZ: LINEAR_REC709_TO_XYZ,
        fromXYZ: XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        outputColorSpaceConfig: { drawingBufferColorSpace: SRGBColorSpace }
      }
    });
    return ColorManagement2;
  }
  const ColorManagement = /* @__PURE__ */ createColorManagement();
  function SRGBToLinear(c2) {
    return c2 < 0.04045 ? c2 * 0.0773993808 : Math.pow(c2 * 0.9478672986 + 0.0521327014, 2.4);
  }
  function LinearToSRGB(c2) {
    return c2 < 31308e-7 ? c2 * 12.92 : 1.055 * Math.pow(c2, 0.41666) - 0.055;
  }
  let _canvas;
  class ImageUtils {
    /**
     * Returns a data URI containing a representation of the given image.
     *
     * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
     * @param {string} [type='image/png'] - Indicates the image format.
     * @return {string} The data URI.
     */
    static getDataURL(image, type = "image/png") {
      if (/^data:/i.test(image.src)) {
        return image.src;
      }
      if (typeof HTMLCanvasElement === "undefined") {
        return image.src;
      }
      let canvas;
      if (image instanceof HTMLCanvasElement) {
        canvas = image;
      } else {
        if (_canvas === void 0) _canvas = createElementNS("canvas");
        _canvas.width = image.width;
        _canvas.height = image.height;
        const context = _canvas.getContext("2d");
        if (image instanceof ImageData) {
          context.putImageData(image, 0, 0);
        } else {
          context.drawImage(image, 0, 0, image.width, image.height);
        }
        canvas = _canvas;
      }
      return canvas.toDataURL(type);
    }
    /**
     * Converts the given sRGB image data to linear color space.
     *
     * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
     * @return {HTMLCanvasElement|Object} The converted image.
     */
    static sRGBToLinear(image) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
        const canvas = createElementNS("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        const imageData = context.getImageData(0, 0, image.width, image.height);
        const data = imageData.data;
        for (let i2 = 0; i2 < data.length; i2++) {
          data[i2] = SRGBToLinear(data[i2] / 255) * 255;
        }
        context.putImageData(imageData, 0, 0);
        return canvas;
      } else if (image.data) {
        const data = image.data.slice(0);
        for (let i2 = 0; i2 < data.length; i2++) {
          if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) {
            data[i2] = Math.floor(SRGBToLinear(data[i2] / 255) * 255);
          } else {
            data[i2] = SRGBToLinear(data[i2]);
          }
        }
        return {
          data,
          width: image.width,
          height: image.height
        };
      } else {
        console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
        return image;
      }
    }
  }
  let _sourceId = 0;
  class Source {
    /**
     * Constructs a new video texture.
     *
     * @param {any} [data=null] - The data definition of a texture.
     */
    constructor(data = null) {
      this.isSource = true;
      Object.defineProperty(this, "id", { value: _sourceId++ });
      this.uuid = generateUUID();
      this.data = data;
      this.dataReady = true;
      this.version = 0;
    }
    getSize(target) {
      const data = this.data;
      if (data instanceof HTMLVideoElement) {
        target.set(data.videoWidth, data.videoHeight);
      } else if (data !== null) {
        target.set(data.width, data.height, data.depth || 0);
      } else {
        target.set(0, 0, 0);
      }
      return target;
    }
    /**
     * When the property is set to `true`, the engine allocates the memory
     * for the texture (if necessary) and triggers the actual texture upload
     * to the GPU next time the source is used.
     *
     * @type {boolean}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      if (value === true) this.version++;
    }
    /**
     * Serializes the source into JSON.
     *
     * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized source.
     * @see {@link ObjectLoader#parse}
     */
    toJSON(meta) {
      const isRootObject = meta === void 0 || typeof meta === "string";
      if (!isRootObject && meta.images[this.uuid] !== void 0) {
        return meta.images[this.uuid];
      }
      const output = {
        uuid: this.uuid,
        url: ""
      };
      const data = this.data;
      if (data !== null) {
        let url;
        if (Array.isArray(data)) {
          url = [];
          for (let i2 = 0, l2 = data.length; i2 < l2; i2++) {
            if (data[i2].isDataTexture) {
              url.push(serializeImage(data[i2].image));
            } else {
              url.push(serializeImage(data[i2]));
            }
          }
        } else {
          url = serializeImage(data);
        }
        output.url = url;
      }
      if (!isRootObject) {
        meta.images[this.uuid] = output;
      }
      return output;
    }
  }
  function serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
      return ImageUtils.getDataURL(image);
    } else {
      if (image.data) {
        return {
          data: Array.from(image.data),
          width: image.width,
          height: image.height,
          type: image.data.constructor.name
        };
      } else {
        console.warn("THREE.Texture: Unable to serialize Texture.");
        return {};
      }
    }
  }
  let _textureId = 0;
  const _tempVec3 = /* @__PURE__ */ new Vector3();
  class Texture extends EventDispatcher {
    /**
     * Constructs a new texture.
     *
     * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
     * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
     * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
     * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
     * @param {number} [magFilter=LinearFilter] - The mag filter value.
     * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
     * @param {number} [format=RGBAFormat] - The texture format.
     * @param {number} [type=UnsignedByteType] - The texture type.
     * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
     * @param {string} [colorSpace=NoColorSpace] - The color space.
     */
    constructor(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace) {
      super();
      this.isTexture = true;
      Object.defineProperty(this, "id", { value: _textureId++ });
      this.uuid = generateUUID();
      this.name = "";
      this.source = new Source(image);
      this.mipmaps = [];
      this.mapping = mapping;
      this.channel = 0;
      this.wrapS = wrapS;
      this.wrapT = wrapT;
      this.magFilter = magFilter;
      this.minFilter = minFilter;
      this.anisotropy = anisotropy;
      this.format = format;
      this.internalFormat = null;
      this.type = type;
      this.offset = new Vector2(0, 0);
      this.repeat = new Vector2(1, 1);
      this.center = new Vector2(0, 0);
      this.rotation = 0;
      this.matrixAutoUpdate = true;
      this.matrix = new Matrix3();
      this.generateMipmaps = true;
      this.premultiplyAlpha = false;
      this.flipY = true;
      this.unpackAlignment = 4;
      this.colorSpace = colorSpace;
      this.userData = {};
      this.updateRanges = [];
      this.version = 0;
      this.onUpdate = null;
      this.renderTarget = null;
      this.isRenderTargetTexture = false;
      this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
      this.pmremVersion = 0;
    }
    /**
     * The width of the texture in pixels.
     */
    get width() {
      return this.source.getSize(_tempVec3).x;
    }
    /**
     * The height of the texture in pixels.
     */
    get height() {
      return this.source.getSize(_tempVec3).y;
    }
    /**
     * The depth of the texture in pixels.
     */
    get depth() {
      return this.source.getSize(_tempVec3).z;
    }
    /**
     * The image object holding the texture data.
     *
     * @type {?Object}
     */
    get image() {
      return this.source.data;
    }
    set image(value = null) {
      this.source.data = value;
    }
    /**
     * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
     * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
     */
    updateMatrix() {
      this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
     * Adds a range of data in the data texture to be updated on the GPU.
     *
     * @param {number} start - Position at which to start update.
     * @param {number} count - The number of components to update.
     */
    addUpdateRange(start, count) {
      this.updateRanges.push({ start, count });
    }
    /**
     * Clears the update ranges.
     */
    clearUpdateRanges() {
      this.updateRanges.length = 0;
    }
    /**
     * Returns a new texture with copied values from this instance.
     *
     * @return {Texture} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given texture to this instance.
     *
     * @param {Texture} source - The texture to copy.
     * @return {Texture} A reference to this instance.
     */
    copy(source) {
      this.name = source.name;
      this.source = source.source;
      this.mipmaps = source.mipmaps.slice(0);
      this.mapping = source.mapping;
      this.channel = source.channel;
      this.wrapS = source.wrapS;
      this.wrapT = source.wrapT;
      this.magFilter = source.magFilter;
      this.minFilter = source.minFilter;
      this.anisotropy = source.anisotropy;
      this.format = source.format;
      this.internalFormat = source.internalFormat;
      this.type = source.type;
      this.offset.copy(source.offset);
      this.repeat.copy(source.repeat);
      this.center.copy(source.center);
      this.rotation = source.rotation;
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      this.matrix.copy(source.matrix);
      this.generateMipmaps = source.generateMipmaps;
      this.premultiplyAlpha = source.premultiplyAlpha;
      this.flipY = source.flipY;
      this.unpackAlignment = source.unpackAlignment;
      this.colorSpace = source.colorSpace;
      this.renderTarget = source.renderTarget;
      this.isRenderTargetTexture = source.isRenderTargetTexture;
      this.isArrayTexture = source.isArrayTexture;
      this.userData = JSON.parse(JSON.stringify(source.userData));
      this.needsUpdate = true;
      return this;
    }
    /**
     * Sets this texture's properties based on `values`.
     * @param {Object} values - A container with texture parameters.
     */
    setValues(values) {
      for (const key in values) {
        const newValue = values[key];
        if (newValue === void 0) {
          console.warn(`THREE.Texture.setValues(): parameter '${key}' has value of undefined.`);
          continue;
        }
        const currentValue = this[key];
        if (currentValue === void 0) {
          console.warn(`THREE.Texture.setValues(): property '${key}' does not exist.`);
          continue;
        }
        if (currentValue && newValue && (currentValue.isVector2 && newValue.isVector2)) {
          currentValue.copy(newValue);
        } else if (currentValue && newValue && (currentValue.isVector3 && newValue.isVector3)) {
          currentValue.copy(newValue);
        } else if (currentValue && newValue && (currentValue.isMatrix3 && newValue.isMatrix3)) {
          currentValue.copy(newValue);
        } else {
          this[key] = newValue;
        }
      }
    }
    /**
     * Serializes the texture into JSON.
     *
     * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized texture.
     * @see {@link ObjectLoader#parse}
     */
    toJSON(meta) {
      const isRootObject = meta === void 0 || typeof meta === "string";
      if (!isRootObject && meta.textures[this.uuid] !== void 0) {
        return meta.textures[this.uuid];
      }
      const output = {
        metadata: {
          version: 4.7,
          type: "Texture",
          generator: "Texture.toJSON"
        },
        uuid: this.uuid,
        name: this.name,
        image: this.source.toJSON(meta).uuid,
        mapping: this.mapping,
        channel: this.channel,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        internalFormat: this.internalFormat,
        type: this.type,
        colorSpace: this.colorSpace,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        generateMipmaps: this.generateMipmaps,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };
      if (Object.keys(this.userData).length > 0) output.userData = this.userData;
      if (!isRootObject) {
        meta.textures[this.uuid] = output;
      }
      return output;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     *
     * @fires Texture#dispose
     */
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
    /**
     * Transforms the given uv vector with the textures uv transformation matrix.
     *
     * @param {Vector2} uv - The uv vector.
     * @return {Vector2} The transformed uv vector.
     */
    transformUv(uv) {
      if (this.mapping !== UVMapping) return uv;
      uv.applyMatrix3(this.matrix);
      if (uv.x < 0 || uv.x > 1) {
        switch (this.wrapS) {
          case RepeatWrapping:
            uv.x = uv.x - Math.floor(uv.x);
            break;
          case ClampToEdgeWrapping:
            uv.x = uv.x < 0 ? 0 : 1;
            break;
          case MirroredRepeatWrapping:
            if (Math.abs(Math.floor(uv.x) % 2) === 1) {
              uv.x = Math.ceil(uv.x) - uv.x;
            } else {
              uv.x = uv.x - Math.floor(uv.x);
            }
            break;
        }
      }
      if (uv.y < 0 || uv.y > 1) {
        switch (this.wrapT) {
          case RepeatWrapping:
            uv.y = uv.y - Math.floor(uv.y);
            break;
          case ClampToEdgeWrapping:
            uv.y = uv.y < 0 ? 0 : 1;
            break;
          case MirroredRepeatWrapping:
            if (Math.abs(Math.floor(uv.y) % 2) === 1) {
              uv.y = Math.ceil(uv.y) - uv.y;
            } else {
              uv.y = uv.y - Math.floor(uv.y);
            }
            break;
        }
      }
      if (this.flipY) {
        uv.y = 1 - uv.y;
      }
      return uv;
    }
    /**
     * Setting this property to `true` indicates the engine the texture
     * must be updated in the next render. This triggers a texture upload
     * to the GPU and ensures correct texture parameter configuration.
     *
     * @type {boolean}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      if (value === true) {
        this.version++;
        this.source.needsUpdate = true;
      }
    }
    /**
     * Setting this property to `true` indicates the engine the PMREM
     * must be regenerated.
     *
     * @type {boolean}
     * @default false
     * @param {boolean} value
     */
    set needsPMREMUpdate(value) {
      if (value === true) {
        this.pmremVersion++;
      }
    }
  }
  Texture.DEFAULT_IMAGE = null;
  Texture.DEFAULT_MAPPING = UVMapping;
  Texture.DEFAULT_ANISOTROPY = 1;
  class Vector4 {
    /**
     * Constructs a new 4D vector.
     *
     * @param {number} [x=0] - The x value of this vector.
     * @param {number} [y=0] - The y value of this vector.
     * @param {number} [z=0] - The z value of this vector.
     * @param {number} [w=1] - The w value of this vector.
     */
    constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 1) {
      Vector4.prototype.isVector4 = true;
      this.x = x2;
      this.y = y2;
      this.z = z2;
      this.w = w2;
    }
    /**
     * Alias for {@link Vector4#z}.
     *
     * @type {number}
     */
    get width() {
      return this.z;
    }
    set width(value) {
      this.z = value;
    }
    /**
     * Alias for {@link Vector4#w}.
     *
     * @type {number}
     */
    get height() {
      return this.w;
    }
    set height(value) {
      this.w = value;
    }
    /**
     * Sets the vector components.
     *
     * @param {number} x - The value of the x component.
     * @param {number} y - The value of the y component.
     * @param {number} z - The value of the z component.
     * @param {number} w - The value of the w component.
     * @return {Vector4} A reference to this vector.
     */
    set(x2, y2, z2, w2) {
      this.x = x2;
      this.y = y2;
      this.z = z2;
      this.w = w2;
      return this;
    }
    /**
     * Sets the vector components to the same value.
     *
     * @param {number} scalar - The value to set for all vector components.
     * @return {Vector4} A reference to this vector.
     */
    setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      this.z = scalar;
      this.w = scalar;
      return this;
    }
    /**
     * Sets the vector's x component to the given value
     *
     * @param {number} x - The value to set.
     * @return {Vector4} A reference to this vector.
     */
    setX(x2) {
      this.x = x2;
      return this;
    }
    /**
     * Sets the vector's y component to the given value
     *
     * @param {number} y - The value to set.
     * @return {Vector4} A reference to this vector.
     */
    setY(y2) {
      this.y = y2;
      return this;
    }
    /**
     * Sets the vector's z component to the given value
     *
     * @param {number} z - The value to set.
     * @return {Vector4} A reference to this vector.
     */
    setZ(z2) {
      this.z = z2;
      return this;
    }
    /**
     * Sets the vector's w component to the given value
     *
     * @param {number} w - The value to set.
     * @return {Vector4} A reference to this vector.
     */
    setW(w2) {
      this.w = w2;
      return this;
    }
    /**
     * Allows to set a vector component with an index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y,
     * `2` equals to z, `3` equals to w.
     * @param {number} value - The value to set.
     * @return {Vector4} A reference to this vector.
     */
    setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;
        case 1:
          this.y = value;
          break;
        case 2:
          this.z = value;
          break;
        case 3:
          this.w = value;
          break;
        default:
          throw new Error("index is out of range: " + index);
      }
      return this;
    }
    /**
     * Returns the value of the vector component which matches the given index.
     *
     * @param {number} index - The component index. `0` equals to x, `1` equals to y,
     * `2` equals to z, `3` equals to w.
     * @return {number} A vector component value.
     */
    getComponent(index) {
      switch (index) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        case 2:
          return this.z;
        case 3:
          return this.w;
        default:
          throw new Error("index is out of range: " + index);
      }
    }
    /**
     * Returns a new vector with copied values from this instance.
     *
     * @return {Vector4} A clone of this instance.
     */
    clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
     * Copies the values of the given vector to this instance.
     *
     * @param {Vector3|Vector4} v - The vector to copy.
     * @return {Vector4} A reference to this vector.
     */
    copy(v2) {
      this.x = v2.x;
      this.y = v2.y;
      this.z = v2.z;
      this.w = v2.w !== void 0 ? v2.w : 1;
      return this;
    }
    /**
     * Adds the given vector to this instance.
     *
     * @param {Vector4} v - The vector to add.
     * @return {Vector4} A reference to this vector.
     */
    add(v2) {
      this.x += v2.x;
      this.y += v2.y;
      this.z += v2.z;
      this.w += v2.w;
      return this;
    }
    /**
     * Adds the given scalar value to all components of this instance.
     *
     * @param {number} s - The scalar to add.
     * @return {Vector4} A reference to this vector.
     */
    addScalar(s2) {
      this.x += s2;
      this.y += s2;
      this.z += s2;
      this.w += s2;
      return this;
    }
    /**
     * Adds the given vectors and stores the result in this instance.
     *
     * @param {Vector4} a - The first vector.
     * @param {Vector4} b - The second vector.
     * @return {Vector4} A reference to this vector.
     */
    addVectors(a2, b2) {
      this.x = a2.x + b2.x;
      this.y = a2.y + b2.y;
      this.z = a2.z + b2.z;
      this.w = a2.w + b2.w;
      return this;
    }
    /**
     * Adds the given vector scaled by the given factor to this instance.
     *
     * @param {Vector4} v - The vector.
     * @param {number} s - The factor that scales `v`.
     * @return {Vector4} A reference to this vector.
     */
    addScaledVector(v2, s2) {
      this.x += v2.x * s2;
      this.y += v2.y * s2;
      this.z += v2.z * s2;
      this.w += v2.w * s2;
      return this;
    }
    /**
     * Subtracts the given vector from this instance.
     *
     * @param {Vector4} v - The vector to subtract.
     * @return {Vector4} A reference to this vector.
     */
    sub(v2) {
      this.x -= v2.x;
      this.y -= v2.y;
      this.z -= v2.z;
      this.w -= v2.w;
      return this;
    }
    /**
     * Subtracts the given scalar value from all components of this instance.
     *
     * @param {number} s - The scalar to subtract.
     * @return {Vector4} A reference to this vector.
     */
    subScalar(s2) {
      this.x -= s2;
      this.y -= s2;
      this.z -= s2;
      this.w -= s2;
      return this;
    }
    /**
     * Subtracts the given vectors and stores the result in this instance.
     *
     * @param {Vector4} a - The first vector.
     * @param {Vector4} b - The second vector.
     * @return {Vector4} A reference to this vector.
     */
    subVectors(a2, b2) {
      this.x = a2.x - b2.x;
      this.y = a2.y - b2.y;
      this.z = a2.z - b2.z;
      this.w = a2.w - b2.w;
      return this;
    }
    /**
     * Multiplies the given vector with this instance.
     *
     * @param {Vector4} v - The vector to multiply.
     * @return {Vector4} A reference to this vector.
     */
    multiply(v2) {
      this.x *= v2.x;
      this.y *= v2.y;
      this.z *= v2.z;
      this.w *= v2.w;
      return this;
    }
    /**
     * Multiplies the given scalar value with all components of this instance.
     *
     * @param {number} scalar - The scalar to multiply.
     * @return {Vector4} A reference to this vector.
     */
    multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      this.z *= scalar;
      this.w *= scalar;
      return this;
    }
    /**
     * Multiplies this vector with the given 4x4 matrix.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @return {Vector4} A reference to this vector.
     */
    applyMatrix4(m) {
      const x2 = this.x, y2 = this.y, z2 = this.z, w2 = this.w;
      const e2 = m.elements;
      this.x = e2[0] * x2 + e2[4] * y2 + e2[8] * z2 + e2[12] * w2;
      this.y = e2[1] * x2 + e2[5] * y2 + e2[9] * z2 + e2[13] * w2;
      this.z = e2[2] * x2 + e2[6] * y2 + e2[10] * z2 + e2[14] * w2;
      this.w = e2[3] * x2 + e2[7] * y2 + e2[11] * z2 + e2[15] * w2;
      return this;
    }
    /**
     * Divides this instance by the given vector.
     *
     * @param {Vector4} v - The vector to divide.
     * @return {Vector4} A reference to this vector.
     */
    divide(v2) {
      this.x /= v2.x;
      this.y /= v2.y;
      this.z /= v2.z;
      this.w /= v2.w;
      return this;
    }
    /**
     * Divides this vector by the given scalar.
     *
     * @param {number} scalar - The scalar to divide.
     * @return {Vector4} A reference to this vector.
     */
    divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
    /**
     * Sets the x, y and z components of this
     * vector to the quaternion's axis and w to the angle.
     *
     * @param {Quaternion} q - The Quaternion to set.
     * @return {Vector4} A reference to this vector.
     */
    setAxisAngleFromQuaternion(q2) {
      this.w = 2 * Math.acos(q2.w);
      const s2 = Math.sqrt(1 - q2.w * q2.w);
      if (s2 < 1e-4) {
        this.x = 1;
        this.y = 0;
        this.z = 0;
      } else {
        this.x = q2.x / s2;
        this.y = q2.y / s2;
        this.z = q2.z / s2;
      }
      return this;
    }
    /**
     * Sets the x, y and z components of this
     * vector to the axis of rotation and w to the angle.
     *
     * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
     * @return {Vector4} A reference to this vector.
     */
    setAxisAngleFromRotationMatrix(m) {
      let angle, x2, y2, z2;
      const epsilon = 0.01, epsilon2 = 0.1, te2 = m.elements, m11 = te2[0], m12 = te2[4], m13 = te2[8], m21 = te2[1], m22 = te2[5], m23 = te2[9], m31 = te2[2], m32 = te2[6], m33 = te2[10];
      if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
        if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
          this.set(1, 0, 0, 0);
          return this;
        }
        angle = Math.PI;
        const xx = (m11 + 1) / 2;
        const yy = (m22 + 1) / 2;
        const zz = (m33 + 1) / 2;
        const xy = (m12 + m21) / 4;
        const xz = (m13 + m31) / 4;
        const yz = (m23 + m32) / 4;
        if (xx > yy && xx > zz) {
          if (xx < epsilon) {
            x2 = 0;
            y2 = 0.707106781;
            z2 = 0.707106781;
          } else {
            x2 = Math.sqrt(xx);
            y2 = xy / x2;
            z2 = xz / x2;
          }
        } else if (yy > zz) {
          if (yy < epsilon) {
            x2 = 0.707106781;
            y2 = 0;
            z2 = 0.707106781;
          } else {
            y2 = Math.sqrt(yy);
            x2 = xy / y2;
            z2 = yz / y2;
          }
        } else {
          if (zz < epsilon) {
            x2 = 0.707106781;
            y2 = 0.707106781;
            z2 = 0;
          } else {
            z2 = Math.sqrt(zz);
            x2 = xz / z2;
            y2 = yz / z2;
          }
        }
        this.set(x2, y2, z2, angle);
        return this;
      }
      let s2 = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
      if (Math.abs(s2) < 1e-3) s2 = 1;
      this.x = (m32 - m23) / s2;
      this.y = (m13 - m31) / s2;
      this.z = (m21 - m12) / s2;
      this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
      return this;
    }
    /**
     * Sets the vector components to the position elements of the
     * given transformation matrix.
     *
     * @param {Matrix4} m - The 4x4 matrix.
     * @return {Vector4} A reference to this vector.
     */
    setFromMatrixPosition(m) {
      const e2 = m.elements;
      this.x = e2[12];
      this.y = e2[13];
      this.z = e2[14];
      this.w = e2[15];
      return this;
    }
    /**
     * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
     * value, replace that value with the corresponding min value.
     *
     * @param {Vector4} v - The vector.
     * @return {Vector4} A reference to this vector.
     */
    min(v2) {
      this.x = Math.min(this.x, v2.x);
      this.y = Math.min(this.y, v2.y);
      this.z = Math.min(this.z, v2.z);
      this.w = Math.min(this.w, v2.w);
      return this;
    }
    /**
     * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
     * value, replace that value with the corresponding max value.
     *
     * @param {Vector4} v - The vector.
     * @return {Vector4} A reference to this vector.
     */
    max(v2) {
      this.x = Math.max(this.x, v2.x);
      this.y = Math.max(this.y, v2.y);
      this.z = Math.max(this.z, v2.z);
      this.w = Math.max(this.w, v2.w);
      return this;
    }
    /**
     * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
     * value, it is replaced by the corresponding value.
     * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
     * it is replaced by the corresponding value.
     *
     * @param {Vector4} min - The minimum x, y and z values.
     * @param {Vector4} max - The maximum x, y and z values in the desired range.
     * @return {Vector4} A reference to this vector.
     */
    clamp(min, max) {
      this.x = clamp(this.x, min.x, max.x);
      this.y = clamp(this.y, min.y, max.y);
      this.z = clamp(this.z, min.z, max.z);
      this.w = clamp(this.w, min.w, max.w);
      return this;
    }
    /**
     * If this vector's x, y, z or w values are greater than the max value, they are
     * replaced by the max value.
     * If this vector's x, y, z or w values are less than the min value, they are
     * replaced by the min value.
     *
     * @param {number} minVal - The minimum value the components will be clamped to.
     * @param {number} maxVal - The maximum value the components will be clamped to.
     * @return {Vector4} A reference to this vector.
     */
    clampScalar(minVal, maxVal) {
      this.x = clamp(this.x, minVal, maxVal);
      this.y = clamp(this.y, minVal, maxVal);
      this.z = clamp(this.z, minVal, maxVal);
      this.w = clamp(this.w, minVal, maxVal);
      return this;
    }
    /**
     * If this vector's length is greater than the max value, it is replaced by
     * the max value.
     * If this vector's length is less than the min value, it is replaced by the
     * min value.
     *
     * @param {number} min - The minimum value the vector length will be clamped to.
     * @param {number} max - The maximum value the vector length will be clamped to.
     * @return {Vector4} A reference to this vector.
     */
    clampLength(min, max) {
      const length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
     * The components of this vector are rounded down to the nearest integer value.
     *
     * @return {Vector4} A reference to this vector.
     */
    floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      this.z = Math.floor(this.z);
      this.w = Math.floor(this.w);
      return this;
    }
    /**
     * The components of this vector are rounded up to the nearest integer value.
     *
     * @return {Vector4} A reference to this vector.
     */
    ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      this.z = Math.ceil(this.z);
      this.w = Math.ceil(this.w);
      return this;
    }
    /**
     * The components of this vector are rounded to the nearest integer value
     *
     * @return {Vector4} A reference to this vector.
     */
    round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      this.z = Math.round(this.z);
      this.w = Math.round(this.w);
      return this;
    }
    /**
     * The components of this vector are rounded towards zero (up if negative,
     * down if positive) to an integer value.
     *
     * @return {Vector4} A reference to this vector.
     */
    roundToZero() {
      this.x = Math.trunc(this.x);
      this.y = Math.trunc(this.y);
      this.z = Math.trunc(this.z);
      this.w = Math.trunc(this.w);
      return this;
    }
    /**
     * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
     *
     * @return {Vector4} A reference to this vector.
     */
    negate() {
      this.x = -this.x;
      this.y = -this.y;
      this.z = -this.z;
      this.w = -this.w;
      return this;
    }
    /**
     * Calculates the dot product of the given vector with this instance.
     *
     * @param {Vector4} v - The vector to compute the dot product with.
     * @return {number} The result of the dot product.
     */
    dot(v2) {
      return this.x * v2.x + this.y * v2.y + this.z * v2.z + this.w * v2.w;
    }
    /**
     * Computes the square of the Euclidean length (straight-line length) from
     * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
     * compare the length squared instead as it is slightly more efficient to calculate.
     *
     * @return {number} The square length of this vector.
     */
    lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
     * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
     *
     * @return {number} The length of this vector.
     */
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
     * Computes the Manhattan length of this vector.
     *
     * @return {number} The length of this vector.
     */
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
     * Converts this vector to a unit vector - that is, sets it equal to a vector
     * with the same direction as this one, but with a vector length of `1`.
     *
     * @return {Vector4} A reference to this vector.
     */
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    /**
     * Sets this vector to a vector with the same direction as this one, but
     * with the specified length.
     *
     * @param {number} length - The new length of this vector.
     * @return {Vector4} A reference to this vector.
     */
    setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
    /**
     * Linearly interpolates between the given vector and this instance, where
     * alpha is the percent distance along the line - alpha = 0 will be this
     * vector, and alpha = 1 will be the given one.
     *
     * @param {Vector4} v - The vector to interpolate towards.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector4} A reference to this vector.
     */
    lerp(v2, alpha) {
      this.x += (v2.x - this.x) * alpha;
      this.y += (v2.y - this.y) * alpha;
      this.z += (v2.z - this.z) * alpha;
      this.w += (v2.w - this.w) * alpha;
      return this;
    }
    /**
     * Linearly interpolates between the given vectors, where alpha is the percent
     * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
     * be the second one. The result is stored in this instance.
     *
     * @param {Vector4} v1 - The first vector.
     * @param {Vector4} v2 - The second vector.
     * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
     * @return {Vector4} A reference to this vector.
     */
    lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      this.z = v1.z + (v2.z - v1.z) * alpha;
      this.w = v1.w + (v2.w - v1.w) * alpha;
      return this;
    }
    /**
     * Returns `true` if this vector is equal with the given one.
     *
     * @param {Vector4} v - The vector to test for equality.
     * @return {boolean} Whether this vector is equal with the given one.
     */
    equals(v2) {
      return v2.x === this.x && v2.y === this.y && v2.z === this.z && v2.w === this.w;
    }
    /**
     * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
     * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
     *
     * @param {Array<number>} array - An array holding the vector component values.
     * @param {number} [offset=0] - The offset into the array.
     * @return {Vector4} A reference to this vector.
     */
    fromArray(array, offset = 0) {
      this.x = array[offset];
      this.y = array[offset + 1];
      this.z = array[offset + 2];
      this.w = array[offset + 3];
      return this;
    }
    /**
     * Writes the components of this vector to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the vector components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The vector components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this.x;
      array[offset + 1] = this.y;
      array[offset + 2] = this.z;
      array[offset + 3] = this.w;
      return array;
    }
    /**
     * Sets the components of this vector from the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
     * @param {number} index - The index into the attribute.
     * @return {Vector4} A reference to this vector.
     */
    fromBufferAttribute(attribute, index) {
      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      this.z = attribute.getZ(index);
      this.w = attribute.getW(index);
      return this;
    }
    /**
     * Sets each component of this vector to a pseudo-random value between `0` and
     * `1`, excluding `1`.
     *
     * @return {Vector4} A reference to this vector.
     */
    random() {
      this.x = Math.random();
      this.y = Math.random();
      this.z = Math.random();
      this.w = Math.random();
      return this;
    }
    *[Symbol.iterator]() {
      yield this.x;
      yield this.y;
      yield this.z;
      yield this.w;
    }
  }
  class RenderTarget extends EventDispatcher {
    /**
     * Render target options.
     *
     * @typedef {Object} RenderTarget~Options
     * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
     * @property {number} [magFilter=LinearFilter] - The mag filter.
     * @property {number} [minFilter=LinearFilter] - The min filter.
     * @property {number} [format=RGBAFormat] - The texture format.
     * @property {number} [type=UnsignedByteType] - The texture type.
     * @property {?string} [internalFormat=null] - The texture's internal format.
     * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
     * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
     * @property {number} [anisotropy=1] - The texture's anisotropy value.
     * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
     * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
     * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
     * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
     * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
     * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
     * @property {number} [samples=0] - The MSAA samples count.
     * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
     * @property {number} [depth=1] - The texture depth.
     * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
     */
    /**
     * Constructs a new render target.
     *
     * @param {number} [width=1] - The width of the render target.
     * @param {number} [height=1] - The height of the render target.
     * @param {RenderTarget~Options} [options] - The configuration object.
     */
    constructor(width = 1, height = 1, options = {}) {
      super();
      options = Object.assign({
        generateMipmaps: false,
        internalFormat: null,
        minFilter: LinearFilter,
        depthBuffer: true,
        stencilBuffer: false,
        resolveDepthBuffer: true,
        resolveStencilBuffer: true,
        depthTexture: null,
        samples: 0,
        count: 1,
        depth: 1,
        multiview: false
      }, options);
      this.isRenderTarget = true;
      this.width = width;
      this.height = height;
      this.depth = options.depth;
      this.scissor = new Vector4(0, 0, width, height);
      this.scissorTest = false;
      this.viewport = new Vector4(0, 0, width, height);
      const image = { width, height, depth: options.depth };
      const texture = new Texture(image);
      this.textures = [];
      const count = options.count;
      for (let i2 = 0; i2 < count; i2++) {
        this.textures[i2] = texture.clone();
        this.textures[i2].isRenderTargetTexture = true;
        this.textures[i2].renderTarget = this;
      }
      this._setTextureOptions(options);
      this.depthBuffer = options.depthBuffer;
      this.stencilBuffer = options.stencilBuffer;
      this.resolveDepthBuffer = options.resolveDepthBuffer;
      this.resolveStencilBuffer = options.resolveStencilBuffer;
      this._depthTexture = null;
      this.depthTexture = options.depthTexture;
      this.samples = options.samples;
      this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
      const values = {
        minFilter: LinearFilter,
        generateMipmaps: false,
        flipY: false,
        internalFormat: null
      };
      if (options.mapping !== void 0) values.mapping = options.mapping;
      if (options.wrapS !== void 0) values.wrapS = options.wrapS;
      if (options.wrapT !== void 0) values.wrapT = options.wrapT;
      if (options.wrapR !== void 0) values.wrapR = options.wrapR;
      if (options.magFilter !== void 0) values.magFilter = options.magFilter;
      if (options.minFilter !== void 0) values.minFilter = options.minFilter;
      if (options.format !== void 0) values.format = options.format;
      if (options.type !== void 0) values.type = options.type;
      if (options.anisotropy !== void 0) values.anisotropy = options.anisotropy;
      if (options.colorSpace !== void 0) values.colorSpace = options.colorSpace;
      if (options.flipY !== void 0) values.flipY = options.flipY;
      if (options.generateMipmaps !== void 0) values.generateMipmaps = options.generateMipmaps;
      if (options.internalFormat !== void 0) values.internalFormat = options.internalFormat;
      for (let i2 = 0; i2 < this.textures.length; i2++) {
        const texture = this.textures[i2];
        texture.setValues(values);
      }
    }
    /**
     * The texture representing the default color attachment.
     *
     * @type {Texture}
     */
    get texture() {
      return this.textures[0];
    }
    set texture(value) {
      this.textures[0] = value;
    }
    set depthTexture(current) {
      if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
      if (current !== null) current.renderTarget = this;
      this._depthTexture = current;
    }
    /**
     * Instead of saving the depth in a renderbuffer, a texture
     * can be used instead which is useful for further processing
     * e.g. in context of post-processing.
     *
     * @type {?DepthTexture}
     * @default null
     */
    get depthTexture() {
      return this._depthTexture;
    }
    /**
     * Sets the size of this render target.
     *
     * @param {number} width - The width.
     * @param {number} height - The height.
     * @param {number} [depth=1] - The depth.
     */
    setSize(width, height, depth = 1) {
      if (this.width !== width || this.height !== height || this.depth !== depth) {
        this.width = width;
        this.height = height;
        this.depth = depth;
        for (let i2 = 0, il = this.textures.length; i2 < il; i2++) {
          this.textures[i2].image.width = width;
          this.textures[i2].image.height = height;
          this.textures[i2].image.depth = depth;
          this.textures[i2].isArrayTexture = this.textures[i2].image.depth > 1;
        }
        this.dispose();
      }
      this.viewport.set(0, 0, width, height);
      this.scissor.set(0, 0, width, height);
    }
    /**
     * Returns a new render target with copied values from this instance.
     *
     * @return {RenderTarget} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the settings of the given render target. This is a structural copy so
     * no resources are shared between render targets after the copy. That includes
     * all MRT textures and the depth texture.
     *
     * @param {RenderTarget} source - The render target to copy.
     * @return {RenderTarget} A reference to this instance.
     */
    copy(source) {
      this.width = source.width;
      this.height = source.height;
      this.depth = source.depth;
      this.scissor.copy(source.scissor);
      this.scissorTest = source.scissorTest;
      this.viewport.copy(source.viewport);
      this.textures.length = 0;
      for (let i2 = 0, il = source.textures.length; i2 < il; i2++) {
        this.textures[i2] = source.textures[i2].clone();
        this.textures[i2].isRenderTargetTexture = true;
        this.textures[i2].renderTarget = this;
        const image = Object.assign({}, source.textures[i2].image);
        this.textures[i2].source = new Source(image);
      }
      this.depthBuffer = source.depthBuffer;
      this.stencilBuffer = source.stencilBuffer;
      this.resolveDepthBuffer = source.resolveDepthBuffer;
      this.resolveStencilBuffer = source.resolveStencilBuffer;
      if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
      this.samples = source.samples;
      return this;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     *
     * @fires RenderTarget#dispose
     */
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
  }
  class WebGLRenderTarget extends RenderTarget {
    /**
     * Constructs a new 3D render target.
     *
     * @param {number} [width=1] - The width of the render target.
     * @param {number} [height=1] - The height of the render target.
     * @param {RenderTarget~Options} [options] - The configuration object.
     */
    constructor(width = 1, height = 1, options = {}) {
      super(width, height, options);
      this.isWebGLRenderTarget = true;
    }
  }
  class DataArrayTexture extends Texture {
    /**
     * Constructs a new data array texture.
     *
     * @param {?TypedArray} [data=null] - The buffer data.
     * @param {number} [width=1] - The width of the texture.
     * @param {number} [height=1] - The height of the texture.
     * @param {number} [depth=1] - The depth of the texture.
     */
    constructor(data = null, width = 1, height = 1, depth = 1) {
      super(null);
      this.isDataArrayTexture = true;
      this.image = { data, width, height, depth };
      this.magFilter = NearestFilter;
      this.minFilter = NearestFilter;
      this.wrapR = ClampToEdgeWrapping;
      this.generateMipmaps = false;
      this.flipY = false;
      this.unpackAlignment = 1;
      this.layerUpdates = /* @__PURE__ */ new Set();
    }
    /**
     * Describes that a specific layer of the texture needs to be updated.
     * Normally when {@link Texture#needsUpdate} is set to `true`, the
     * entire data texture array is sent to the GPU. Marking specific
     * layers will only transmit subsets of all mipmaps associated with a
     * specific depth in the array which is often much more performant.
     *
     * @param {number} layerIndex - The layer index that should be updated.
     */
    addLayerUpdate(layerIndex) {
      this.layerUpdates.add(layerIndex);
    }
    /**
     * Resets the layer updates registry.
     */
    clearLayerUpdates() {
      this.layerUpdates.clear();
    }
  }
  class Data3DTexture extends Texture {
    /**
     * Constructs a new data array texture.
     *
     * @param {?TypedArray} [data=null] - The buffer data.
     * @param {number} [width=1] - The width of the texture.
     * @param {number} [height=1] - The height of the texture.
     * @param {number} [depth=1] - The depth of the texture.
     */
    constructor(data = null, width = 1, height = 1, depth = 1) {
      super(null);
      this.isData3DTexture = true;
      this.image = { data, width, height, depth };
      this.magFilter = NearestFilter;
      this.minFilter = NearestFilter;
      this.wrapR = ClampToEdgeWrapping;
      this.generateMipmaps = false;
      this.flipY = false;
      this.unpackAlignment = 1;
    }
  }
  class Box3 {
    /**
     * Constructs a new bounding box.
     *
     * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
     * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
     */
    constructor(min = new Vector3(Infinity, Infinity, Infinity), max = new Vector3(-Infinity, -Infinity, -Infinity)) {
      this.isBox3 = true;
      this.min = min;
      this.max = max;
    }
    /**
     * Sets the lower and upper boundaries of this box.
     * Please note that this method only copies the values from the given objects.
     *
     * @param {Vector3} min - The lower boundary of the box.
     * @param {Vector3} max - The upper boundary of the box.
     * @return {Box3} A reference to this bounding box.
     */
    set(min, max) {
      this.min.copy(min);
      this.max.copy(max);
      return this;
    }
    /**
     * Sets the upper and lower bounds of this box so it encloses the position data
     * in the given array.
     *
     * @param {Array<number>} array - An array holding 3D position data.
     * @return {Box3} A reference to this bounding box.
     */
    setFromArray(array) {
      this.makeEmpty();
      for (let i2 = 0, il = array.length; i2 < il; i2 += 3) {
        this.expandByPoint(_vector$b.fromArray(array, i2));
      }
      return this;
    }
    /**
     * Sets the upper and lower bounds of this box so it encloses the position data
     * in the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
     * @return {Box3} A reference to this bounding box.
     */
    setFromBufferAttribute(attribute) {
      this.makeEmpty();
      for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
        this.expandByPoint(_vector$b.fromBufferAttribute(attribute, i2));
      }
      return this;
    }
    /**
     * Sets the upper and lower bounds of this box so it encloses the position data
     * in the given array.
     *
     * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
     * @return {Box3} A reference to this bounding box.
     */
    setFromPoints(points) {
      this.makeEmpty();
      for (let i2 = 0, il = points.length; i2 < il; i2++) {
        this.expandByPoint(points[i2]);
      }
      return this;
    }
    /**
     * Centers this box on the given center vector and sets this box's width, height and
     * depth to the given size values.
     *
     * @param {Vector3} center - The center of the box.
     * @param {Vector3} size - The x, y and z dimensions of the box.
     * @return {Box3} A reference to this bounding box.
     */
    setFromCenterAndSize(center, size) {
      const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
      this.min.copy(center).sub(halfSize);
      this.max.copy(center).add(halfSize);
      return this;
    }
    /**
     * Computes the world-axis-aligned bounding box for the given 3D object
     * (including its children), accounting for the object's, and children's,
     * world transforms. The function may result in a larger box than strictly necessary.
     *
     * @param {Object3D} object - The 3D object to compute the bounding box for.
     * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
     * world-axis-aligned bounding box at the expense of more computation.
     * @return {Box3} A reference to this bounding box.
     */
    setFromObject(object, precise = false) {
      this.makeEmpty();
      return this.expandByObject(object, precise);
    }
    /**
     * Returns a new box with copied values from this instance.
     *
     * @return {Box3} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given box to this instance.
     *
     * @param {Box3} box - The box to copy.
     * @return {Box3} A reference to this bounding box.
     */
    copy(box) {
      this.min.copy(box.min);
      this.max.copy(box.max);
      return this;
    }
    /**
     * Makes this box empty which means in encloses a zero space in 3D.
     *
     * @return {Box3} A reference to this bounding box.
     */
    makeEmpty() {
      this.min.x = this.min.y = this.min.z = Infinity;
      this.max.x = this.max.y = this.max.z = -Infinity;
      return this;
    }
    /**
     * Returns true if this box includes zero points within its bounds.
     * Note that a box with equal lower and upper bounds still includes one
     * point, the one both bounds share.
     *
     * @return {boolean} Whether this box is empty or not.
     */
    isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
     * Returns the center point of this box.
     *
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The center point.
     */
    getCenter(target) {
      return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
     * Returns the dimensions of this box.
     *
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The size.
     */
    getSize(target) {
      return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
     * Expands the boundaries of this box to include the given point.
     *
     * @param {Vector3} point - The point that should be included by the bounding box.
     * @return {Box3} A reference to this bounding box.
     */
    expandByPoint(point) {
      this.min.min(point);
      this.max.max(point);
      return this;
    }
    /**
     * Expands this box equilaterally by the given vector. The width of this
     * box will be expanded by the x component of the vector in both
     * directions. The height of this box will be expanded by the y component of
     * the vector in both directions. The depth of this box will be
     * expanded by the z component of the vector in both directions.
     *
     * @param {Vector3} vector - The vector that should expand the bounding box.
     * @return {Box3} A reference to this bounding box.
     */
    expandByVector(vector) {
      this.min.sub(vector);
      this.max.add(vector);
      return this;
    }
    /**
     * Expands each dimension of the box by the given scalar. If negative, the
     * dimensions of the box will be contracted.
     *
     * @param {number} scalar - The scalar value that should expand the bounding box.
     * @return {Box3} A reference to this bounding box.
     */
    expandByScalar(scalar) {
      this.min.addScalar(-scalar);
      this.max.addScalar(scalar);
      return this;
    }
    /**
     * Expands the boundaries of this box to include the given 3D object and
     * its children, accounting for the object's, and children's, world
     * transforms. The function may result in a larger box than strictly
     * necessary (unless the precise parameter is set to true).
     *
     * @param {Object3D} object - The 3D object that should expand the bounding box.
     * @param {boolean} precise - If set to `true`, the method expands the bounding box
     * as little as necessary at the expense of more computation.
     * @return {Box3} A reference to this bounding box.
     */
    expandByObject(object, precise = false) {
      object.updateWorldMatrix(false, false);
      const geometry = object.geometry;
      if (geometry !== void 0) {
        const positionAttribute = geometry.getAttribute("position");
        if (precise === true && positionAttribute !== void 0 && object.isInstancedMesh !== true) {
          for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2++) {
            if (object.isMesh === true) {
              object.getVertexPosition(i2, _vector$b);
            } else {
              _vector$b.fromBufferAttribute(positionAttribute, i2);
            }
            _vector$b.applyMatrix4(object.matrixWorld);
            this.expandByPoint(_vector$b);
          }
        } else {
          if (object.boundingBox !== void 0) {
            if (object.boundingBox === null) {
              object.computeBoundingBox();
            }
            _box$4.copy(object.boundingBox);
          } else {
            if (geometry.boundingBox === null) {
              geometry.computeBoundingBox();
            }
            _box$4.copy(geometry.boundingBox);
          }
          _box$4.applyMatrix4(object.matrixWorld);
          this.union(_box$4);
        }
      }
      const children = object.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        this.expandByObject(children[i2], precise);
      }
      return this;
    }
    /**
     * Returns `true` if the given point lies within or on the boundaries of this box.
     *
     * @param {Vector3} point - The point to test.
     * @return {boolean} Whether the bounding box contains the given point or not.
     */
    containsPoint(point) {
      return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
     * Returns `true` if this bounding box includes the entirety of the given bounding box.
     * If this box and the given one are identical, this function also returns `true`.
     *
     * @param {Box3} box - The bounding box to test.
     * @return {boolean} Whether the bounding box contains the given bounding box or not.
     */
    containsBox(box) {
      return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
     * Returns a point as a proportion of this box's width, height and depth.
     *
     * @param {Vector3} point - A point in 3D space.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} A point as a proportion of this box's width, height and depth.
     */
    getParameter(point, target) {
      return target.set(
        (point.x - this.min.x) / (this.max.x - this.min.x),
        (point.y - this.min.y) / (this.max.y - this.min.y),
        (point.z - this.min.z) / (this.max.z - this.min.z)
      );
    }
    /**
     * Returns `true` if the given bounding box intersects with this bounding box.
     *
     * @param {Box3} box - The bounding box to test.
     * @return {boolean} Whether the given bounding box intersects with this bounding box.
     */
    intersectsBox(box) {
      return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
     * Returns `true` if the given bounding sphere intersects with this bounding box.
     *
     * @param {Sphere} sphere - The bounding sphere to test.
     * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
     */
    intersectsSphere(sphere) {
      this.clampPoint(sphere.center, _vector$b);
      return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
     * Returns `true` if the given plane intersects with this bounding box.
     *
     * @param {Plane} plane - The plane to test.
     * @return {boolean} Whether the given plane intersects with this bounding box.
     */
    intersectsPlane(plane) {
      let min, max;
      if (plane.normal.x > 0) {
        min = plane.normal.x * this.min.x;
        max = plane.normal.x * this.max.x;
      } else {
        min = plane.normal.x * this.max.x;
        max = plane.normal.x * this.min.x;
      }
      if (plane.normal.y > 0) {
        min += plane.normal.y * this.min.y;
        max += plane.normal.y * this.max.y;
      } else {
        min += plane.normal.y * this.max.y;
        max += plane.normal.y * this.min.y;
      }
      if (plane.normal.z > 0) {
        min += plane.normal.z * this.min.z;
        max += plane.normal.z * this.max.z;
      } else {
        min += plane.normal.z * this.max.z;
        max += plane.normal.z * this.min.z;
      }
      return min <= -plane.constant && max >= -plane.constant;
    }
    /**
     * Returns `true` if the given triangle intersects with this bounding box.
     *
     * @param {Triangle} triangle - The triangle to test.
     * @return {boolean} Whether the given triangle intersects with this bounding box.
     */
    intersectsTriangle(triangle) {
      if (this.isEmpty()) {
        return false;
      }
      this.getCenter(_center);
      _extents.subVectors(this.max, _center);
      _v0$2.subVectors(triangle.a, _center);
      _v1$7.subVectors(triangle.b, _center);
      _v2$4.subVectors(triangle.c, _center);
      _f0.subVectors(_v1$7, _v0$2);
      _f1.subVectors(_v2$4, _v1$7);
      _f2.subVectors(_v0$2, _v2$4);
      let axes = [
        0,
        -_f0.z,
        _f0.y,
        0,
        -_f1.z,
        _f1.y,
        0,
        -_f2.z,
        _f2.y,
        _f0.z,
        0,
        -_f0.x,
        _f1.z,
        0,
        -_f1.x,
        _f2.z,
        0,
        -_f2.x,
        -_f0.y,
        _f0.x,
        0,
        -_f1.y,
        _f1.x,
        0,
        -_f2.y,
        _f2.x,
        0
      ];
      if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
        return false;
      }
      axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
      if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {
        return false;
      }
      _triangleNormal.crossVectors(_f0, _f1);
      axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
      return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
    }
    /**
     * Clamps the given point within the bounds of this box.
     *
     * @param {Vector3} point - The point to clamp.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The clamped point.
     */
    clampPoint(point, target) {
      return target.copy(point).clamp(this.min, this.max);
    }
    /**
     * Returns the euclidean distance from any edge of this box to the specified point. If
     * the given point lies inside of this box, the distance will be `0`.
     *
     * @param {Vector3} point - The point to compute the distance to.
     * @return {number} The euclidean distance.
     */
    distanceToPoint(point) {
      return this.clampPoint(point, _vector$b).distanceTo(point);
    }
    /**
     * Returns a bounding sphere that encloses this bounding box.
     *
     * @param {Sphere} target - The target sphere that is used to store the method's result.
     * @return {Sphere} The bounding sphere that encloses this bounding box.
     */
    getBoundingSphere(target) {
      if (this.isEmpty()) {
        target.makeEmpty();
      } else {
        this.getCenter(target.center);
        target.radius = this.getSize(_vector$b).length() * 0.5;
      }
      return target;
    }
    /**
     * Computes the intersection of this bounding box and the given one, setting the upper
     * bound of this box to the lesser of the two boxes' upper bounds and the
     * lower bound of this box to the greater of the two boxes' lower bounds. If
     * there's no overlap, makes this box empty.
     *
     * @param {Box3} box - The bounding box to intersect with.
     * @return {Box3} A reference to this bounding box.
     */
    intersect(box) {
      this.min.max(box.min);
      this.max.min(box.max);
      if (this.isEmpty()) this.makeEmpty();
      return this;
    }
    /**
     * Computes the union of this box and another and the given one, setting the upper
     * bound of this box to the greater of the two boxes' upper bounds and the
     * lower bound of this box to the lesser of the two boxes' lower bounds.
     *
     * @param {Box3} box - The bounding box that will be unioned with this instance.
     * @return {Box3} A reference to this bounding box.
     */
    union(box) {
      this.min.min(box.min);
      this.max.max(box.max);
      return this;
    }
    /**
     * Transforms this bounding box by the given 4x4 transformation matrix.
     *
     * @param {Matrix4} matrix - The transformation matrix.
     * @return {Box3} A reference to this bounding box.
     */
    applyMatrix4(matrix) {
      if (this.isEmpty()) return this;
      _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix);
      _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix);
      _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix);
      _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix);
      _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix);
      _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix);
      _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix);
      _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix);
      this.setFromPoints(_points);
      return this;
    }
    /**
     * Adds the given offset to both the upper and lower bounds of this bounding box,
     * effectively moving it in 3D space.
     *
     * @param {Vector3} offset - The offset that should be used to translate the bounding box.
     * @return {Box3} A reference to this bounding box.
     */
    translate(offset) {
      this.min.add(offset);
      this.max.add(offset);
      return this;
    }
    /**
     * Returns `true` if this bounding box is equal with the given one.
     *
     * @param {Box3} box - The box to test for equality.
     * @return {boolean} Whether this bounding box is equal with the given one.
     */
    equals(box) {
      return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
     * Returns a serialized structure of the bounding box.
     *
     * @return {Object} Serialized structure with fields representing the object state.
     */
    toJSON() {
      return {
        min: this.min.toArray(),
        max: this.max.toArray()
      };
    }
    /**
     * Returns a serialized structure of the bounding box.
     *
     * @param {Object} json - The serialized json to set the box from.
     * @return {Box3} A reference to this bounding box.
     */
    fromJSON(json) {
      this.min.fromArray(json.min);
      this.max.fromArray(json.max);
      return this;
    }
  }
  const _points = [
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3(),
    /* @__PURE__ */ new Vector3()
  ];
  const _vector$b = /* @__PURE__ */ new Vector3();
  const _box$4 = /* @__PURE__ */ new Box3();
  const _v0$2 = /* @__PURE__ */ new Vector3();
  const _v1$7 = /* @__PURE__ */ new Vector3();
  const _v2$4 = /* @__PURE__ */ new Vector3();
  const _f0 = /* @__PURE__ */ new Vector3();
  const _f1 = /* @__PURE__ */ new Vector3();
  const _f2 = /* @__PURE__ */ new Vector3();
  const _center = /* @__PURE__ */ new Vector3();
  const _extents = /* @__PURE__ */ new Vector3();
  const _triangleNormal = /* @__PURE__ */ new Vector3();
  const _testAxis = /* @__PURE__ */ new Vector3();
  function satForAxes(axes, v0, v1, v2, extents) {
    for (let i2 = 0, j2 = axes.length - 3; i2 <= j2; i2 += 3) {
      _testAxis.fromArray(axes, i2);
      const r2 = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
      const p0 = v0.dot(_testAxis);
      const p1 = v1.dot(_testAxis);
      const p2 = v2.dot(_testAxis);
      if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r2) {
        return false;
      }
    }
    return true;
  }
  const _box$3 = /* @__PURE__ */ new Box3();
  const _v1$6 = /* @__PURE__ */ new Vector3();
  const _v2$3 = /* @__PURE__ */ new Vector3();
  class Sphere {
    /**
     * Constructs a new sphere.
     *
     * @param {Vector3} [center=(0,0,0)] - The center of the sphere
     * @param {number} [radius=-1] - The radius of the sphere.
     */
    constructor(center = new Vector3(), radius = -1) {
      this.isSphere = true;
      this.center = center;
      this.radius = radius;
    }
    /**
     * Sets the sphere's components by copying the given values.
     *
     * @param {Vector3} center - The center.
     * @param {number} radius - The radius.
     * @return {Sphere} A reference to this sphere.
     */
    set(center, radius) {
      this.center.copy(center);
      this.radius = radius;
      return this;
    }
    /**
     * Computes the minimum bounding sphere for list of points.
     * If the optional center point is given, it is used as the sphere's
     * center. Otherwise, the center of the axis-aligned bounding box
     * encompassing the points is calculated.
     *
     * @param {Array<Vector3>} points - A list of points in 3D space.
     * @param {Vector3} [optionalCenter] - The center of the sphere.
     * @return {Sphere} A reference to this sphere.
     */
    setFromPoints(points, optionalCenter) {
      const center = this.center;
      if (optionalCenter !== void 0) {
        center.copy(optionalCenter);
      } else {
        _box$3.setFromPoints(points).getCenter(center);
      }
      let maxRadiusSq = 0;
      for (let i2 = 0, il = points.length; i2 < il; i2++) {
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i2]));
      }
      this.radius = Math.sqrt(maxRadiusSq);
      return this;
    }
    /**
     * Copies the values of the given sphere to this instance.
     *
     * @param {Sphere} sphere - The sphere to copy.
     * @return {Sphere} A reference to this sphere.
     */
    copy(sphere) {
      this.center.copy(sphere.center);
      this.radius = sphere.radius;
      return this;
    }
    /**
     * Returns `true` if the sphere is empty (the radius set to a negative number).
     *
     * Spheres with a radius of `0` contain only their center point and are not
     * considered to be empty.
     *
     * @return {boolean} Whether this sphere is empty or not.
     */
    isEmpty() {
      return this.radius < 0;
    }
    /**
     * Makes this sphere empty which means in encloses a zero space in 3D.
     *
     * @return {Sphere} A reference to this sphere.
     */
    makeEmpty() {
      this.center.set(0, 0, 0);
      this.radius = -1;
      return this;
    }
    /**
     * Returns `true` if this sphere contains the given point inclusive of
     * the surface of the sphere.
     *
     * @param {Vector3} point - The point to check.
     * @return {boolean} Whether this sphere contains the given point or not.
     */
    containsPoint(point) {
      return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
     * Returns the closest distance from the boundary of the sphere to the
     * given point. If the sphere contains the point, the distance will
     * be negative.
     *
     * @param {Vector3} point - The point to compute the distance to.
     * @return {number} The distance to the point.
     */
    distanceToPoint(point) {
      return point.distanceTo(this.center) - this.radius;
    }
    /**
     * Returns `true` if this sphere intersects with the given one.
     *
     * @param {Sphere} sphere - The sphere to test.
     * @return {boolean} Whether this sphere intersects with the given one or not.
     */
    intersectsSphere(sphere) {
      const radiusSum = this.radius + sphere.radius;
      return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
     * Returns `true` if this sphere intersects with the given box.
     *
     * @param {Box3} box - The box to test.
     * @return {boolean} Whether this sphere intersects with the given box or not.
     */
    intersectsBox(box) {
      return box.intersectsSphere(this);
    }
    /**
     * Returns `true` if this sphere intersects with the given plane.
     *
     * @param {Plane} plane - The plane to test.
     * @return {boolean} Whether this sphere intersects with the given plane or not.
     */
    intersectsPlane(plane) {
      return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
     * Clamps a point within the sphere. If the point is outside the sphere, it
     * will clamp it to the closest point on the edge of the sphere. Points
     * already inside the sphere will not be affected.
     *
     * @param {Vector3} point - The plane to clamp.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The clamped point.
     */
    clampPoint(point, target) {
      const deltaLengthSq = this.center.distanceToSquared(point);
      target.copy(point);
      if (deltaLengthSq > this.radius * this.radius) {
        target.sub(this.center).normalize();
        target.multiplyScalar(this.radius).add(this.center);
      }
      return target;
    }
    /**
     * Returns a bounding box that encloses this sphere.
     *
     * @param {Box3} target - The target box that is used to store the method's result.
     * @return {Box3} The bounding box that encloses this sphere.
     */
    getBoundingBox(target) {
      if (this.isEmpty()) {
        target.makeEmpty();
        return target;
      }
      target.set(this.center, this.center);
      target.expandByScalar(this.radius);
      return target;
    }
    /**
     * Transforms this sphere with the given 4x4 transformation matrix.
     *
     * @param {Matrix4} matrix - The transformation matrix.
     * @return {Sphere} A reference to this sphere.
     */
    applyMatrix4(matrix) {
      this.center.applyMatrix4(matrix);
      this.radius = this.radius * matrix.getMaxScaleOnAxis();
      return this;
    }
    /**
     * Translates the sphere's center by the given offset.
     *
     * @param {Vector3} offset - The offset.
     * @return {Sphere} A reference to this sphere.
     */
    translate(offset) {
      this.center.add(offset);
      return this;
    }
    /**
     * Expands the boundaries of this sphere to include the given point.
     *
     * @param {Vector3} point - The point to include.
     * @return {Sphere} A reference to this sphere.
     */
    expandByPoint(point) {
      if (this.isEmpty()) {
        this.center.copy(point);
        this.radius = 0;
        return this;
      }
      _v1$6.subVectors(point, this.center);
      const lengthSq = _v1$6.lengthSq();
      if (lengthSq > this.radius * this.radius) {
        const length = Math.sqrt(lengthSq);
        const delta = (length - this.radius) * 0.5;
        this.center.addScaledVector(_v1$6, delta / length);
        this.radius += delta;
      }
      return this;
    }
    /**
     * Expands this sphere to enclose both the original sphere and the given sphere.
     *
     * @param {Sphere} sphere - The sphere to include.
     * @return {Sphere} A reference to this sphere.
     */
    union(sphere) {
      if (sphere.isEmpty()) {
        return this;
      }
      if (this.isEmpty()) {
        this.copy(sphere);
        return this;
      }
      if (this.center.equals(sphere.center) === true) {
        this.radius = Math.max(this.radius, sphere.radius);
      } else {
        _v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
        this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));
        this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
      }
      return this;
    }
    /**
     * Returns `true` if this sphere is equal with the given one.
     *
     * @param {Sphere} sphere - The sphere to test for equality.
     * @return {boolean} Whether this bounding sphere is equal with the given one.
     */
    equals(sphere) {
      return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
     * Returns a new sphere with copied values from this instance.
     *
     * @return {Sphere} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Returns a serialized structure of the bounding sphere.
     *
     * @return {Object} Serialized structure with fields representing the object state.
     */
    toJSON() {
      return {
        radius: this.radius,
        center: this.center.toArray()
      };
    }
    /**
     * Returns a serialized structure of the bounding sphere.
     *
     * @param {Object} json - The serialized json to set the sphere from.
     * @return {Box3} A reference to this bounding sphere.
     */
    fromJSON(json) {
      this.radius = json.radius;
      this.center.fromArray(json.center);
      return this;
    }
  }
  const _vector$a = /* @__PURE__ */ new Vector3();
  const _segCenter = /* @__PURE__ */ new Vector3();
  const _segDir = /* @__PURE__ */ new Vector3();
  const _diff = /* @__PURE__ */ new Vector3();
  const _edge1 = /* @__PURE__ */ new Vector3();
  const _edge2 = /* @__PURE__ */ new Vector3();
  const _normal$1 = /* @__PURE__ */ new Vector3();
  class Ray {
    /**
     * Constructs a new ray.
     *
     * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
     * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
     */
    constructor(origin = new Vector3(), direction = new Vector3(0, 0, -1)) {
      this.origin = origin;
      this.direction = direction;
    }
    /**
     * Sets the ray's components by copying the given values.
     *
     * @param {Vector3} origin - The origin.
     * @param {Vector3} direction - The direction.
     * @return {Ray} A reference to this ray.
     */
    set(origin, direction) {
      this.origin.copy(origin);
      this.direction.copy(direction);
      return this;
    }
    /**
     * Copies the values of the given ray to this instance.
     *
     * @param {Ray} ray - The ray to copy.
     * @return {Ray} A reference to this ray.
     */
    copy(ray) {
      this.origin.copy(ray.origin);
      this.direction.copy(ray.direction);
      return this;
    }
    /**
     * Returns a vector that is located at a given distance along this ray.
     *
     * @param {number} t - The distance along the ray to retrieve a position for.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} A position on the ray.
     */
    at(t2, target) {
      return target.copy(this.origin).addScaledVector(this.direction, t2);
    }
    /**
     * Adjusts the direction of the ray to point at the given vector in world space.
     *
     * @param {Vector3} v - The target position.
     * @return {Ray} A reference to this ray.
     */
    lookAt(v2) {
      this.direction.copy(v2).sub(this.origin).normalize();
      return this;
    }
    /**
     * Shift the origin of this ray along its direction by the given distance.
     *
     * @param {number} t - The distance along the ray to interpolate.
     * @return {Ray} A reference to this ray.
     */
    recast(t2) {
      this.origin.copy(this.at(t2, _vector$a));
      return this;
    }
    /**
     * Returns the point along this ray that is closest to the given point.
     *
     * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The closest point on this ray.
     */
    closestPointToPoint(point, target) {
      target.subVectors(point, this.origin);
      const directionDistance = target.dot(this.direction);
      if (directionDistance < 0) {
        return target.copy(this.origin);
      }
      return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
     * Returns the distance of the closest approach between this ray and the given point.
     *
     * @param {Vector3} point - A point in 3D space to compute the distance to.
     * @return {number} The distance.
     */
    distanceToPoint(point) {
      return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
     * Returns the squared distance of the closest approach between this ray and the given point.
     *
     * @param {Vector3} point - A point in 3D space to compute the distance to.
     * @return {number} The squared distance.
     */
    distanceSqToPoint(point) {
      const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
      if (directionDistance < 0) {
        return this.origin.distanceToSquared(point);
      }
      _vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
      return _vector$a.distanceToSquared(point);
    }
    /**
     * Returns the squared distance between this ray and the given line segment.
     *
     * @param {Vector3} v0 - The start point of the line segment.
     * @param {Vector3} v1 - The end point of the line segment.
     * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
     * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
     * @return {number} The squared distance.
     */
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
      _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
      _segDir.copy(v1).sub(v0).normalize();
      _diff.copy(this.origin).sub(_segCenter);
      const segExtent = v0.distanceTo(v1) * 0.5;
      const a01 = -this.direction.dot(_segDir);
      const b0 = _diff.dot(this.direction);
      const b1 = -_diff.dot(_segDir);
      const c2 = _diff.lengthSq();
      const det = Math.abs(1 - a01 * a01);
      let s0, s1, sqrDist, extDet;
      if (det > 0) {
        s0 = a01 * b1 - b0;
        s1 = a01 * b0 - b1;
        extDet = segExtent * det;
        if (s0 >= 0) {
          if (s1 >= -extDet) {
            if (s1 <= extDet) {
              const invDet = 1 / det;
              s0 *= invDet;
              s1 *= invDet;
              sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c2;
            } else {
              s1 = segExtent;
              s0 = Math.max(0, -(a01 * s1 + b0));
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
            }
          } else {
            s1 = -segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        } else {
          if (s1 <= -extDet) {
            s0 = Math.max(0, -(-a01 * segExtent + b0));
            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          } else if (s1 <= extDet) {
            s0 = 0;
            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = s1 * (s1 + 2 * b1) + c2;
          } else {
            s0 = Math.max(0, -(a01 * segExtent + b0));
            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        }
      } else {
        s1 = a01 > 0 ? -segExtent : segExtent;
        s0 = Math.max(0, -(a01 * s1 + b0));
        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
      }
      if (optionalPointOnRay) {
        optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
      }
      if (optionalPointOnSegment) {
        optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
      }
      return sqrDist;
    }
    /**
     * Intersects this ray with the given sphere, returning the intersection
     * point or `null` if there is no intersection.
     *
     * @param {Sphere} sphere - The sphere to intersect.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The intersection point.
     */
    intersectSphere(sphere, target) {
      _vector$a.subVectors(sphere.center, this.origin);
      const tca = _vector$a.dot(this.direction);
      const d2 = _vector$a.dot(_vector$a) - tca * tca;
      const radius2 = sphere.radius * sphere.radius;
      if (d2 > radius2) return null;
      const thc = Math.sqrt(radius2 - d2);
      const t0 = tca - thc;
      const t1 = tca + thc;
      if (t1 < 0) return null;
      if (t0 < 0) return this.at(t1, target);
      return this.at(t0, target);
    }
    /**
     * Returns `true` if this ray intersects with the given sphere.
     *
     * @param {Sphere} sphere - The sphere to intersect.
     * @return {boolean} Whether this ray intersects with the given sphere or not.
     */
    intersectsSphere(sphere) {
      if (sphere.radius < 0) return false;
      return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
     * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
     * does not intersect with the plane.
     *
     * @param {Plane} plane - The plane to compute the distance to.
     * @return {?number} Whether this ray intersects with the given sphere or not.
     */
    distanceToPlane(plane) {
      const denominator = plane.normal.dot(this.direction);
      if (denominator === 0) {
        if (plane.distanceToPoint(this.origin) === 0) {
          return 0;
        }
        return null;
      }
      const t2 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
      return t2 >= 0 ? t2 : null;
    }
    /**
     * Intersects this ray with the given plane, returning the intersection
     * point or `null` if there is no intersection.
     *
     * @param {Plane} plane - The plane to intersect.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The intersection point.
     */
    intersectPlane(plane, target) {
      const t2 = this.distanceToPlane(plane);
      if (t2 === null) {
        return null;
      }
      return this.at(t2, target);
    }
    /**
     * Returns `true` if this ray intersects with the given plane.
     *
     * @param {Plane} plane - The plane to intersect.
     * @return {boolean} Whether this ray intersects with the given plane or not.
     */
    intersectsPlane(plane) {
      const distToPoint = plane.distanceToPoint(this.origin);
      if (distToPoint === 0) {
        return true;
      }
      const denominator = plane.normal.dot(this.direction);
      if (denominator * distToPoint < 0) {
        return true;
      }
      return false;
    }
    /**
     * Intersects this ray with the given bounding box, returning the intersection
     * point or `null` if there is no intersection.
     *
     * @param {Box3} box - The box to intersect.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The intersection point.
     */
    intersectBox(box, target) {
      let tmin, tmax, tymin, tymax, tzmin, tzmax;
      const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
      const origin = this.origin;
      if (invdirx >= 0) {
        tmin = (box.min.x - origin.x) * invdirx;
        tmax = (box.max.x - origin.x) * invdirx;
      } else {
        tmin = (box.max.x - origin.x) * invdirx;
        tmax = (box.min.x - origin.x) * invdirx;
      }
      if (invdiry >= 0) {
        tymin = (box.min.y - origin.y) * invdiry;
        tymax = (box.max.y - origin.y) * invdiry;
      } else {
        tymin = (box.max.y - origin.y) * invdiry;
        tymax = (box.min.y - origin.y) * invdiry;
      }
      if (tmin > tymax || tymin > tmax) return null;
      if (tymin > tmin || isNaN(tmin)) tmin = tymin;
      if (tymax < tmax || isNaN(tmax)) tmax = tymax;
      if (invdirz >= 0) {
        tzmin = (box.min.z - origin.z) * invdirz;
        tzmax = (box.max.z - origin.z) * invdirz;
      } else {
        tzmin = (box.max.z - origin.z) * invdirz;
        tzmax = (box.min.z - origin.z) * invdirz;
      }
      if (tmin > tzmax || tzmin > tmax) return null;
      if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
      if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
      if (tmax < 0) return null;
      return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
     * Returns `true` if this ray intersects with the given box.
     *
     * @param {Box3} box - The box to intersect.
     * @return {boolean} Whether this ray intersects with the given box or not.
     */
    intersectsBox(box) {
      return this.intersectBox(box, _vector$a) !== null;
    }
    /**
     * Intersects this ray with the given triangle, returning the intersection
     * point or `null` if there is no intersection.
     *
     * @param {Vector3} a - The first vertex of the triangle.
     * @param {Vector3} b - The second vertex of the triangle.
     * @param {Vector3} c - The third vertex of the triangle.
     * @param {boolean} backfaceCulling - Whether to use backface culling or not.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The intersection point.
     */
    intersectTriangle(a2, b2, c2, backfaceCulling, target) {
      _edge1.subVectors(b2, a2);
      _edge2.subVectors(c2, a2);
      _normal$1.crossVectors(_edge1, _edge2);
      let DdN = this.direction.dot(_normal$1);
      let sign2;
      if (DdN > 0) {
        if (backfaceCulling) return null;
        sign2 = 1;
      } else if (DdN < 0) {
        sign2 = -1;
        DdN = -DdN;
      } else {
        return null;
      }
      _diff.subVectors(this.origin, a2);
      const DdQxE2 = sign2 * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
      if (DdQxE2 < 0) {
        return null;
      }
      const DdE1xQ = sign2 * this.direction.dot(_edge1.cross(_diff));
      if (DdE1xQ < 0) {
        return null;
      }
      if (DdQxE2 + DdE1xQ > DdN) {
        return null;
      }
      const QdN = -sign2 * _diff.dot(_normal$1);
      if (QdN < 0) {
        return null;
      }
      return this.at(QdN / DdN, target);
    }
    /**
     * Transforms this ray with the given 4x4 transformation matrix.
     *
     * @param {Matrix4} matrix4 - The transformation matrix.
     * @return {Ray} A reference to this ray.
     */
    applyMatrix4(matrix4) {
      this.origin.applyMatrix4(matrix4);
      this.direction.transformDirection(matrix4);
      return this;
    }
    /**
     * Returns `true` if this ray is equal with the given one.
     *
     * @param {Ray} ray - The ray to test for equality.
     * @return {boolean} Whether this ray is equal with the given one.
     */
    equals(ray) {
      return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
     * Returns a new ray with copied values from this instance.
     *
     * @return {Ray} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
  }
  class Matrix4 {
    /**
     * Constructs a new 4x4 matrix. The arguments are supposed to be
     * in row-major order. If no arguments are provided, the constructor
     * initializes the matrix as an identity matrix.
     *
     * @param {number} [n11] - 1-1 matrix element.
     * @param {number} [n12] - 1-2 matrix element.
     * @param {number} [n13] - 1-3 matrix element.
     * @param {number} [n14] - 1-4 matrix element.
     * @param {number} [n21] - 2-1 matrix element.
     * @param {number} [n22] - 2-2 matrix element.
     * @param {number} [n23] - 2-3 matrix element.
     * @param {number} [n24] - 2-4 matrix element.
     * @param {number} [n31] - 3-1 matrix element.
     * @param {number} [n32] - 3-2 matrix element.
     * @param {number} [n33] - 3-3 matrix element.
     * @param {number} [n34] - 3-4 matrix element.
     * @param {number} [n41] - 4-1 matrix element.
     * @param {number} [n42] - 4-2 matrix element.
     * @param {number} [n43] - 4-3 matrix element.
     * @param {number} [n44] - 4-4 matrix element.
     */
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
      Matrix4.prototype.isMatrix4 = true;
      this.elements = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ];
      if (n11 !== void 0) {
        this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
      }
    }
    /**
     * Sets the elements of the matrix.The arguments are supposed to be
     * in row-major order.
     *
     * @param {number} [n11] - 1-1 matrix element.
     * @param {number} [n12] - 1-2 matrix element.
     * @param {number} [n13] - 1-3 matrix element.
     * @param {number} [n14] - 1-4 matrix element.
     * @param {number} [n21] - 2-1 matrix element.
     * @param {number} [n22] - 2-2 matrix element.
     * @param {number} [n23] - 2-3 matrix element.
     * @param {number} [n24] - 2-4 matrix element.
     * @param {number} [n31] - 3-1 matrix element.
     * @param {number} [n32] - 3-2 matrix element.
     * @param {number} [n33] - 3-3 matrix element.
     * @param {number} [n34] - 3-4 matrix element.
     * @param {number} [n41] - 4-1 matrix element.
     * @param {number} [n42] - 4-2 matrix element.
     * @param {number} [n43] - 4-3 matrix element.
     * @param {number} [n44] - 4-4 matrix element.
     * @return {Matrix4} A reference to this matrix.
     */
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
      const te2 = this.elements;
      te2[0] = n11;
      te2[4] = n12;
      te2[8] = n13;
      te2[12] = n14;
      te2[1] = n21;
      te2[5] = n22;
      te2[9] = n23;
      te2[13] = n24;
      te2[2] = n31;
      te2[6] = n32;
      te2[10] = n33;
      te2[14] = n34;
      te2[3] = n41;
      te2[7] = n42;
      te2[11] = n43;
      te2[15] = n44;
      return this;
    }
    /**
     * Sets this matrix to the 4x4 identity matrix.
     *
     * @return {Matrix4} A reference to this matrix.
     */
    identity() {
      this.set(
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Returns a matrix with copied values from this instance.
     *
     * @return {Matrix4} A clone of this instance.
     */
    clone() {
      return new Matrix4().fromArray(this.elements);
    }
    /**
     * Copies the values of the given matrix to this instance.
     *
     * @param {Matrix4} m - The matrix to copy.
     * @return {Matrix4} A reference to this matrix.
     */
    copy(m) {
      const te2 = this.elements;
      const me2 = m.elements;
      te2[0] = me2[0];
      te2[1] = me2[1];
      te2[2] = me2[2];
      te2[3] = me2[3];
      te2[4] = me2[4];
      te2[5] = me2[5];
      te2[6] = me2[6];
      te2[7] = me2[7];
      te2[8] = me2[8];
      te2[9] = me2[9];
      te2[10] = me2[10];
      te2[11] = me2[11];
      te2[12] = me2[12];
      te2[13] = me2[13];
      te2[14] = me2[14];
      te2[15] = me2[15];
      return this;
    }
    /**
     * Copies the translation component of the given matrix
     * into this matrix's translation component.
     *
     * @param {Matrix4} m - The matrix to copy the translation component.
     * @return {Matrix4} A reference to this matrix.
     */
    copyPosition(m) {
      const te2 = this.elements, me2 = m.elements;
      te2[12] = me2[12];
      te2[13] = me2[13];
      te2[14] = me2[14];
      return this;
    }
    /**
     * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
     *
     * @param {Matrix3} m - The 3x3 matrix.
     * @return {Matrix4} A reference to this matrix.
     */
    setFromMatrix3(m) {
      const me2 = m.elements;
      this.set(
        me2[0],
        me2[3],
        me2[6],
        0,
        me2[1],
        me2[4],
        me2[7],
        0,
        me2[2],
        me2[5],
        me2[8],
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Extracts the basis of this matrix into the three axis vectors provided.
     *
     * @param {Vector3} xAxis - The basis's x axis.
     * @param {Vector3} yAxis - The basis's y axis.
     * @param {Vector3} zAxis - The basis's z axis.
     * @return {Matrix4} A reference to this matrix.
     */
    extractBasis(xAxis, yAxis, zAxis) {
      xAxis.setFromMatrixColumn(this, 0);
      yAxis.setFromMatrixColumn(this, 1);
      zAxis.setFromMatrixColumn(this, 2);
      return this;
    }
    /**
     * Sets the given basis vectors to this matrix.
     *
     * @param {Vector3} xAxis - The basis's x axis.
     * @param {Vector3} yAxis - The basis's y axis.
     * @param {Vector3} zAxis - The basis's z axis.
     * @return {Matrix4} A reference to this matrix.
     */
    makeBasis(xAxis, yAxis, zAxis) {
      this.set(
        xAxis.x,
        yAxis.x,
        zAxis.x,
        0,
        xAxis.y,
        yAxis.y,
        zAxis.y,
        0,
        xAxis.z,
        yAxis.z,
        zAxis.z,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Extracts the rotation component of the given matrix
     * into this matrix's rotation component.
     *
     * Note: This method does not support reflection matrices.
     *
     * @param {Matrix4} m - The matrix.
     * @return {Matrix4} A reference to this matrix.
     */
    extractRotation(m) {
      const te2 = this.elements;
      const me2 = m.elements;
      const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
      const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
      const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
      te2[0] = me2[0] * scaleX;
      te2[1] = me2[1] * scaleX;
      te2[2] = me2[2] * scaleX;
      te2[3] = 0;
      te2[4] = me2[4] * scaleY;
      te2[5] = me2[5] * scaleY;
      te2[6] = me2[6] * scaleY;
      te2[7] = 0;
      te2[8] = me2[8] * scaleZ;
      te2[9] = me2[9] * scaleZ;
      te2[10] = me2[10] * scaleZ;
      te2[11] = 0;
      te2[12] = 0;
      te2[13] = 0;
      te2[14] = 0;
      te2[15] = 1;
      return this;
    }
    /**
     * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
     * the rotation specified by the given Euler angles. The rest of
     * the matrix is set to the identity. Depending on the {@link Euler#order},
     * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
     * for a complete list.
     *
     * @param {Euler} euler - The Euler angles.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationFromEuler(euler) {
      const te2 = this.elements;
      const x2 = euler.x, y2 = euler.y, z2 = euler.z;
      const a2 = Math.cos(x2), b2 = Math.sin(x2);
      const c2 = Math.cos(y2), d2 = Math.sin(y2);
      const e2 = Math.cos(z2), f2 = Math.sin(z2);
      if (euler.order === "XYZ") {
        const ae2 = a2 * e2, af = a2 * f2, be2 = b2 * e2, bf = b2 * f2;
        te2[0] = c2 * e2;
        te2[4] = -c2 * f2;
        te2[8] = d2;
        te2[1] = af + be2 * d2;
        te2[5] = ae2 - bf * d2;
        te2[9] = -b2 * c2;
        te2[2] = bf - ae2 * d2;
        te2[6] = be2 + af * d2;
        te2[10] = a2 * c2;
      } else if (euler.order === "YXZ") {
        const ce2 = c2 * e2, cf = c2 * f2, de2 = d2 * e2, df = d2 * f2;
        te2[0] = ce2 + df * b2;
        te2[4] = de2 * b2 - cf;
        te2[8] = a2 * d2;
        te2[1] = a2 * f2;
        te2[5] = a2 * e2;
        te2[9] = -b2;
        te2[2] = cf * b2 - de2;
        te2[6] = df + ce2 * b2;
        te2[10] = a2 * c2;
      } else if (euler.order === "ZXY") {
        const ce2 = c2 * e2, cf = c2 * f2, de2 = d2 * e2, df = d2 * f2;
        te2[0] = ce2 - df * b2;
        te2[4] = -a2 * f2;
        te2[8] = de2 + cf * b2;
        te2[1] = cf + de2 * b2;
        te2[5] = a2 * e2;
        te2[9] = df - ce2 * b2;
        te2[2] = -a2 * d2;
        te2[6] = b2;
        te2[10] = a2 * c2;
      } else if (euler.order === "ZYX") {
        const ae2 = a2 * e2, af = a2 * f2, be2 = b2 * e2, bf = b2 * f2;
        te2[0] = c2 * e2;
        te2[4] = be2 * d2 - af;
        te2[8] = ae2 * d2 + bf;
        te2[1] = c2 * f2;
        te2[5] = bf * d2 + ae2;
        te2[9] = af * d2 - be2;
        te2[2] = -d2;
        te2[6] = b2 * c2;
        te2[10] = a2 * c2;
      } else if (euler.order === "YZX") {
        const ac2 = a2 * c2, ad = a2 * d2, bc2 = b2 * c2, bd = b2 * d2;
        te2[0] = c2 * e2;
        te2[4] = bd - ac2 * f2;
        te2[8] = bc2 * f2 + ad;
        te2[1] = f2;
        te2[5] = a2 * e2;
        te2[9] = -b2 * e2;
        te2[2] = -d2 * e2;
        te2[6] = ad * f2 + bc2;
        te2[10] = ac2 - bd * f2;
      } else if (euler.order === "XZY") {
        const ac2 = a2 * c2, ad = a2 * d2, bc2 = b2 * c2, bd = b2 * d2;
        te2[0] = c2 * e2;
        te2[4] = -f2;
        te2[8] = d2 * e2;
        te2[1] = ac2 * f2 + bd;
        te2[5] = a2 * e2;
        te2[9] = ad * f2 - bc2;
        te2[2] = bc2 * f2 - ad;
        te2[6] = b2 * e2;
        te2[10] = bd * f2 + ac2;
      }
      te2[3] = 0;
      te2[7] = 0;
      te2[11] = 0;
      te2[12] = 0;
      te2[13] = 0;
      te2[14] = 0;
      te2[15] = 1;
      return this;
    }
    /**
     * Sets the rotation component of this matrix to the rotation specified by
     * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
     * The rest of the matrix is set to the identity.
     *
     * @param {Quaternion} q - The Quaternion.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationFromQuaternion(q2) {
      return this.compose(_zero, q2, _one);
    }
    /**
     * Sets the rotation component of the transformation matrix, looking from `eye` towards
     * `target`, and oriented by the up-direction.
     *
     * @param {Vector3} eye - The eye vector.
     * @param {Vector3} target - The target vector.
     * @param {Vector3} up - The up vector.
     * @return {Matrix4} A reference to this matrix.
     */
    lookAt(eye, target, up) {
      const te2 = this.elements;
      _z.subVectors(eye, target);
      if (_z.lengthSq() === 0) {
        _z.z = 1;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
      if (_x.lengthSq() === 0) {
        if (Math.abs(up.z) === 1) {
          _z.x += 1e-4;
        } else {
          _z.z += 1e-4;
        }
        _z.normalize();
        _x.crossVectors(up, _z);
      }
      _x.normalize();
      _y.crossVectors(_z, _x);
      te2[0] = _x.x;
      te2[4] = _y.x;
      te2[8] = _z.x;
      te2[1] = _x.y;
      te2[5] = _y.y;
      te2[9] = _z.y;
      te2[2] = _x.z;
      te2[6] = _y.z;
      te2[10] = _z.z;
      return this;
    }
    /**
     * Post-multiplies this matrix by the given 4x4 matrix.
     *
     * @param {Matrix4} m - The matrix to multiply with.
     * @return {Matrix4} A reference to this matrix.
     */
    multiply(m) {
      return this.multiplyMatrices(this, m);
    }
    /**
     * Pre-multiplies this matrix by the given 4x4 matrix.
     *
     * @param {Matrix4} m - The matrix to multiply with.
     * @return {Matrix4} A reference to this matrix.
     */
    premultiply(m) {
      return this.multiplyMatrices(m, this);
    }
    /**
     * Multiples the given 4x4 matrices and stores the result
     * in this matrix.
     *
     * @param {Matrix4} a - The first matrix.
     * @param {Matrix4} b - The second matrix.
     * @return {Matrix4} A reference to this matrix.
     */
    multiplyMatrices(a2, b2) {
      const ae2 = a2.elements;
      const be2 = b2.elements;
      const te2 = this.elements;
      const a11 = ae2[0], a12 = ae2[4], a13 = ae2[8], a14 = ae2[12];
      const a21 = ae2[1], a22 = ae2[5], a23 = ae2[9], a24 = ae2[13];
      const a31 = ae2[2], a32 = ae2[6], a33 = ae2[10], a34 = ae2[14];
      const a41 = ae2[3], a42 = ae2[7], a43 = ae2[11], a44 = ae2[15];
      const b11 = be2[0], b12 = be2[4], b13 = be2[8], b14 = be2[12];
      const b21 = be2[1], b22 = be2[5], b23 = be2[9], b24 = be2[13];
      const b31 = be2[2], b32 = be2[6], b33 = be2[10], b34 = be2[14];
      const b41 = be2[3], b42 = be2[7], b43 = be2[11], b44 = be2[15];
      te2[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
      te2[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
      te2[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
      te2[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
      te2[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
      te2[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
      te2[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
      te2[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
      te2[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
      te2[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
      te2[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
      te2[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
      te2[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
      te2[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
      te2[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
      te2[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
      return this;
    }
    /**
     * Multiplies every component of the matrix by the given scalar.
     *
     * @param {number} s - The scalar.
     * @return {Matrix4} A reference to this matrix.
     */
    multiplyScalar(s2) {
      const te2 = this.elements;
      te2[0] *= s2;
      te2[4] *= s2;
      te2[8] *= s2;
      te2[12] *= s2;
      te2[1] *= s2;
      te2[5] *= s2;
      te2[9] *= s2;
      te2[13] *= s2;
      te2[2] *= s2;
      te2[6] *= s2;
      te2[10] *= s2;
      te2[14] *= s2;
      te2[3] *= s2;
      te2[7] *= s2;
      te2[11] *= s2;
      te2[15] *= s2;
      return this;
    }
    /**
     * Computes and returns the determinant of this matrix.
     *
     * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
     *
     * @return {number} The determinant.
     */
    determinant() {
      const te2 = this.elements;
      const n11 = te2[0], n12 = te2[4], n13 = te2[8], n14 = te2[12];
      const n21 = te2[1], n22 = te2[5], n23 = te2[9], n24 = te2[13];
      const n31 = te2[2], n32 = te2[6], n33 = te2[10], n34 = te2[14];
      const n41 = te2[3], n42 = te2[7], n43 = te2[11], n44 = te2[15];
      return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    /**
     * Transposes this matrix in place.
     *
     * @return {Matrix4} A reference to this matrix.
     */
    transpose() {
      const te2 = this.elements;
      let tmp2;
      tmp2 = te2[1];
      te2[1] = te2[4];
      te2[4] = tmp2;
      tmp2 = te2[2];
      te2[2] = te2[8];
      te2[8] = tmp2;
      tmp2 = te2[6];
      te2[6] = te2[9];
      te2[9] = tmp2;
      tmp2 = te2[3];
      te2[3] = te2[12];
      te2[12] = tmp2;
      tmp2 = te2[7];
      te2[7] = te2[13];
      te2[13] = tmp2;
      tmp2 = te2[11];
      te2[11] = te2[14];
      te2[14] = tmp2;
      return this;
    }
    /**
     * Sets the position component for this matrix from the given vector,
     * without affecting the rest of the matrix.
     *
     * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
     * @param {number} y - The y component of the vector.
     * @param {number} z - The z component of the vector.
     * @return {Matrix4} A reference to this matrix.
     */
    setPosition(x2, y2, z2) {
      const te2 = this.elements;
      if (x2.isVector3) {
        te2[12] = x2.x;
        te2[13] = x2.y;
        te2[14] = x2.z;
      } else {
        te2[12] = x2;
        te2[13] = y2;
        te2[14] = z2;
      }
      return this;
    }
    /**
     * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
     * You can not invert with a determinant of zero. If you attempt this, the method produces
     * a zero matrix instead.
     *
     * @return {Matrix4} A reference to this matrix.
     */
    invert() {
      const te2 = this.elements, n11 = te2[0], n21 = te2[1], n31 = te2[2], n41 = te2[3], n12 = te2[4], n22 = te2[5], n32 = te2[6], n42 = te2[7], n13 = te2[8], n23 = te2[9], n33 = te2[10], n43 = te2[11], n14 = te2[12], n24 = te2[13], n34 = te2[14], n44 = te2[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
      const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
      if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      const detInv = 1 / det;
      te2[0] = t11 * detInv;
      te2[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
      te2[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
      te2[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
      te2[4] = t12 * detInv;
      te2[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
      te2[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
      te2[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
      te2[8] = t13 * detInv;
      te2[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
      te2[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
      te2[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
      te2[12] = t14 * detInv;
      te2[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
      te2[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
      te2[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
      return this;
    }
    /**
     * Multiplies the columns of this matrix by the given vector.
     *
     * @param {Vector3} v - The scale vector.
     * @return {Matrix4} A reference to this matrix.
     */
    scale(v2) {
      const te2 = this.elements;
      const x2 = v2.x, y2 = v2.y, z2 = v2.z;
      te2[0] *= x2;
      te2[4] *= y2;
      te2[8] *= z2;
      te2[1] *= x2;
      te2[5] *= y2;
      te2[9] *= z2;
      te2[2] *= x2;
      te2[6] *= y2;
      te2[10] *= z2;
      te2[3] *= x2;
      te2[7] *= y2;
      te2[11] *= z2;
      return this;
    }
    /**
     * Gets the maximum scale value of the three axes.
     *
     * @return {number} The maximum scale.
     */
    getMaxScaleOnAxis() {
      const te2 = this.elements;
      const scaleXSq = te2[0] * te2[0] + te2[1] * te2[1] + te2[2] * te2[2];
      const scaleYSq = te2[4] * te2[4] + te2[5] * te2[5] + te2[6] * te2[6];
      const scaleZSq = te2[8] * te2[8] + te2[9] * te2[9] + te2[10] * te2[10];
      return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
     * Sets this matrix as a translation transform from the given vector.
     *
     * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
     * @param {number} y - The amount to translate in the Y axis.
     * @param {number} z - The amount to translate in the z axis.
     * @return {Matrix4} A reference to this matrix.
     */
    makeTranslation(x2, y2, z2) {
      if (x2.isVector3) {
        this.set(
          1,
          0,
          0,
          x2.x,
          0,
          1,
          0,
          x2.y,
          0,
          0,
          1,
          x2.z,
          0,
          0,
          0,
          1
        );
      } else {
        this.set(
          1,
          0,
          0,
          x2,
          0,
          1,
          0,
          y2,
          0,
          0,
          1,
          z2,
          0,
          0,
          0,
          1
        );
      }
      return this;
    }
    /**
     * Sets this matrix as a rotational transformation around the X axis by
     * the given angle.
     *
     * @param {number} theta - The rotation in radians.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationX(theta) {
      const c2 = Math.cos(theta), s2 = Math.sin(theta);
      this.set(
        1,
        0,
        0,
        0,
        0,
        c2,
        -s2,
        0,
        0,
        s2,
        c2,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a rotational transformation around the Y axis by
     * the given angle.
     *
     * @param {number} theta - The rotation in radians.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationY(theta) {
      const c2 = Math.cos(theta), s2 = Math.sin(theta);
      this.set(
        c2,
        0,
        s2,
        0,
        0,
        1,
        0,
        0,
        -s2,
        0,
        c2,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a rotational transformation around the Z axis by
     * the given angle.
     *
     * @param {number} theta - The rotation in radians.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationZ(theta) {
      const c2 = Math.cos(theta), s2 = Math.sin(theta);
      this.set(
        c2,
        -s2,
        0,
        0,
        s2,
        c2,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a rotational transformation around the given axis by
     * the given angle.
     *
     * This is a somewhat controversial but mathematically sound alternative to
     * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
     *
     * @param {Vector3} axis - The normalized rotation axis.
     * @param {number} angle - The rotation in radians.
     * @return {Matrix4} A reference to this matrix.
     */
    makeRotationAxis(axis, angle) {
      const c2 = Math.cos(angle);
      const s2 = Math.sin(angle);
      const t2 = 1 - c2;
      const x2 = axis.x, y2 = axis.y, z2 = axis.z;
      const tx = t2 * x2, ty = t2 * y2;
      this.set(
        tx * x2 + c2,
        tx * y2 - s2 * z2,
        tx * z2 + s2 * y2,
        0,
        tx * y2 + s2 * z2,
        ty * y2 + c2,
        ty * z2 - s2 * x2,
        0,
        tx * z2 - s2 * y2,
        ty * z2 + s2 * x2,
        t2 * z2 * z2 + c2,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a scale transformation.
     *
     * @param {number} x - The amount to scale in the X axis.
     * @param {number} y - The amount to scale in the Y axis.
     * @param {number} z - The amount to scale in the Z axis.
     * @return {Matrix4} A reference to this matrix.
     */
    makeScale(x2, y2, z2) {
      this.set(
        x2,
        0,
        0,
        0,
        0,
        y2,
        0,
        0,
        0,
        0,
        z2,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix as a shear transformation.
     *
     * @param {number} xy - The amount to shear X by Y.
     * @param {number} xz - The amount to shear X by Z.
     * @param {number} yx - The amount to shear Y by X.
     * @param {number} yz - The amount to shear Y by Z.
     * @param {number} zx - The amount to shear Z by X.
     * @param {number} zy - The amount to shear Z by Y.
     * @return {Matrix4} A reference to this matrix.
     */
    makeShear(xy, xz, yx, yz, zx, zy) {
      this.set(
        1,
        yx,
        zx,
        0,
        xy,
        1,
        zy,
        0,
        xz,
        yz,
        1,
        0,
        0,
        0,
        0,
        1
      );
      return this;
    }
    /**
     * Sets this matrix to the transformation composed of the given position,
     * rotation (Quaternion) and scale.
     *
     * @param {Vector3} position - The position vector.
     * @param {Quaternion} quaternion - The rotation as a Quaternion.
     * @param {Vector3} scale - The scale vector.
     * @return {Matrix4} A reference to this matrix.
     */
    compose(position, quaternion, scale) {
      const te2 = this.elements;
      const x2 = quaternion._x, y2 = quaternion._y, z2 = quaternion._z, w2 = quaternion._w;
      const x22 = x2 + x2, y22 = y2 + y2, z22 = z2 + z2;
      const xx = x2 * x22, xy = x2 * y22, xz = x2 * z22;
      const yy = y2 * y22, yz = y2 * z22, zz = z2 * z22;
      const wx = w2 * x22, wy = w2 * y22, wz = w2 * z22;
      const sx = scale.x, sy = scale.y, sz = scale.z;
      te2[0] = (1 - (yy + zz)) * sx;
      te2[1] = (xy + wz) * sx;
      te2[2] = (xz - wy) * sx;
      te2[3] = 0;
      te2[4] = (xy - wz) * sy;
      te2[5] = (1 - (xx + zz)) * sy;
      te2[6] = (yz + wx) * sy;
      te2[7] = 0;
      te2[8] = (xz + wy) * sz;
      te2[9] = (yz - wx) * sz;
      te2[10] = (1 - (xx + yy)) * sz;
      te2[11] = 0;
      te2[12] = position.x;
      te2[13] = position.y;
      te2[14] = position.z;
      te2[15] = 1;
      return this;
    }
    /**
     * Decomposes this matrix into its position, rotation and scale components
     * and provides the result in the given objects.
     *
     * Note: Not all matrices are decomposable in this way. For example, if an
     * object has a non-uniformly scaled parent, then the object's world matrix
     * may not be decomposable, and this method may not be appropriate.
     *
     * @param {Vector3} position - The position vector.
     * @param {Quaternion} quaternion - The rotation as a Quaternion.
     * @param {Vector3} scale - The scale vector.
     * @return {Matrix4} A reference to this matrix.
     */
    decompose(position, quaternion, scale) {
      const te2 = this.elements;
      let sx = _v1$5.set(te2[0], te2[1], te2[2]).length();
      const sy = _v1$5.set(te2[4], te2[5], te2[6]).length();
      const sz = _v1$5.set(te2[8], te2[9], te2[10]).length();
      const det = this.determinant();
      if (det < 0) sx = -sx;
      position.x = te2[12];
      position.y = te2[13];
      position.z = te2[14];
      _m1$2.copy(this);
      const invSX = 1 / sx;
      const invSY = 1 / sy;
      const invSZ = 1 / sz;
      _m1$2.elements[0] *= invSX;
      _m1$2.elements[1] *= invSX;
      _m1$2.elements[2] *= invSX;
      _m1$2.elements[4] *= invSY;
      _m1$2.elements[5] *= invSY;
      _m1$2.elements[6] *= invSY;
      _m1$2.elements[8] *= invSZ;
      _m1$2.elements[9] *= invSZ;
      _m1$2.elements[10] *= invSZ;
      quaternion.setFromRotationMatrix(_m1$2);
      scale.x = sx;
      scale.y = sy;
      scale.z = sz;
      return this;
    }
    /**
      	 * Creates a perspective projection matrix. This is used internally by
      	 * {@link PerspectiveCamera#updateProjectionMatrix}.
    
      	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
      	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
      	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
      	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
      	 * @param {number} near - The distance from the camera to the near plane.
      	 * @param {number} far - The distance from the camera to the far plane.
      	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
      	 * @return {Matrix4} A reference to this matrix.
      	 */
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
      const te2 = this.elements;
      const x2 = 2 * near / (right - left);
      const y2 = 2 * near / (top - bottom);
      const a2 = (right + left) / (right - left);
      const b2 = (top + bottom) / (top - bottom);
      let c2, d2;
      if (coordinateSystem === WebGLCoordinateSystem) {
        c2 = -(far + near) / (far - near);
        d2 = -2 * far * near / (far - near);
      } else if (coordinateSystem === WebGPUCoordinateSystem) {
        c2 = -far / (far - near);
        d2 = -far * near / (far - near);
      } else {
        throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
      }
      te2[0] = x2;
      te2[4] = 0;
      te2[8] = a2;
      te2[12] = 0;
      te2[1] = 0;
      te2[5] = y2;
      te2[9] = b2;
      te2[13] = 0;
      te2[2] = 0;
      te2[6] = 0;
      te2[10] = c2;
      te2[14] = d2;
      te2[3] = 0;
      te2[7] = 0;
      te2[11] = -1;
      te2[15] = 0;
      return this;
    }
    /**
      	 * Creates a orthographic projection matrix. This is used internally by
      	 * {@link OrthographicCamera#updateProjectionMatrix}.
    
      	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
      	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
      	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
      	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
      	 * @param {number} near - The distance from the camera to the near plane.
      	 * @param {number} far - The distance from the camera to the far plane.
      	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
      	 * @return {Matrix4} A reference to this matrix.
      	 */
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem) {
      const te2 = this.elements;
      const w2 = 1 / (right - left);
      const h2 = 1 / (top - bottom);
      const p2 = 1 / (far - near);
      const x2 = (right + left) * w2;
      const y2 = (top + bottom) * h2;
      let z2, zInv;
      if (coordinateSystem === WebGLCoordinateSystem) {
        z2 = (far + near) * p2;
        zInv = -2 * p2;
      } else if (coordinateSystem === WebGPUCoordinateSystem) {
        z2 = near * p2;
        zInv = -1 * p2;
      } else {
        throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
      }
      te2[0] = 2 * w2;
      te2[4] = 0;
      te2[8] = 0;
      te2[12] = -x2;
      te2[1] = 0;
      te2[5] = 2 * h2;
      te2[9] = 0;
      te2[13] = -y2;
      te2[2] = 0;
      te2[6] = 0;
      te2[10] = zInv;
      te2[14] = -z2;
      te2[3] = 0;
      te2[7] = 0;
      te2[11] = 0;
      te2[15] = 1;
      return this;
    }
    /**
     * Returns `true` if this matrix is equal with the given one.
     *
     * @param {Matrix4} matrix - The matrix to test for equality.
     * @return {boolean} Whether this matrix is equal with the given one.
     */
    equals(matrix) {
      const te2 = this.elements;
      const me2 = matrix.elements;
      for (let i2 = 0; i2 < 16; i2++) {
        if (te2[i2] !== me2[i2]) return false;
      }
      return true;
    }
    /**
     * Sets the elements of the matrix from the given array.
     *
     * @param {Array<number>} array - The matrix elements in column-major order.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Matrix4} A reference to this matrix.
     */
    fromArray(array, offset = 0) {
      for (let i2 = 0; i2 < 16; i2++) {
        this.elements[i2] = array[i2 + offset];
      }
      return this;
    }
    /**
     * Writes the elements of this matrix to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The matrix elements in column-major order.
     */
    toArray(array = [], offset = 0) {
      const te2 = this.elements;
      array[offset] = te2[0];
      array[offset + 1] = te2[1];
      array[offset + 2] = te2[2];
      array[offset + 3] = te2[3];
      array[offset + 4] = te2[4];
      array[offset + 5] = te2[5];
      array[offset + 6] = te2[6];
      array[offset + 7] = te2[7];
      array[offset + 8] = te2[8];
      array[offset + 9] = te2[9];
      array[offset + 10] = te2[10];
      array[offset + 11] = te2[11];
      array[offset + 12] = te2[12];
      array[offset + 13] = te2[13];
      array[offset + 14] = te2[14];
      array[offset + 15] = te2[15];
      return array;
    }
  }
  const _v1$5 = /* @__PURE__ */ new Vector3();
  const _m1$2 = /* @__PURE__ */ new Matrix4();
  const _zero = /* @__PURE__ */ new Vector3(0, 0, 0);
  const _one = /* @__PURE__ */ new Vector3(1, 1, 1);
  const _x = /* @__PURE__ */ new Vector3();
  const _y = /* @__PURE__ */ new Vector3();
  const _z = /* @__PURE__ */ new Vector3();
  const _matrix$2 = /* @__PURE__ */ new Matrix4();
  const _quaternion$3 = /* @__PURE__ */ new Quaternion();
  class Euler {
    /**
     * Constructs a new euler instance.
     *
     * @param {number} [x=0] - The angle of the x axis in radians.
     * @param {number} [y=0] - The angle of the y axis in radians.
     * @param {number} [z=0] - The angle of the z axis in radians.
     * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
     */
    constructor(x2 = 0, y2 = 0, z2 = 0, order = Euler.DEFAULT_ORDER) {
      this.isEuler = true;
      this._x = x2;
      this._y = y2;
      this._z = z2;
      this._order = order;
    }
    /**
     * The angle of the x axis in radians.
     *
     * @type {number}
     * @default 0
     */
    get x() {
      return this._x;
    }
    set x(value) {
      this._x = value;
      this._onChangeCallback();
    }
    /**
     * The angle of the y axis in radians.
     *
     * @type {number}
     * @default 0
     */
    get y() {
      return this._y;
    }
    set y(value) {
      this._y = value;
      this._onChangeCallback();
    }
    /**
     * The angle of the z axis in radians.
     *
     * @type {number}
     * @default 0
     */
    get z() {
      return this._z;
    }
    set z(value) {
      this._z = value;
      this._onChangeCallback();
    }
    /**
     * A string representing the order that the rotations are applied.
     *
     * @type {string}
     * @default 'XYZ'
     */
    get order() {
      return this._order;
    }
    set order(value) {
      this._order = value;
      this._onChangeCallback();
    }
    /**
     * Sets the Euler components.
     *
     * @param {number} x - The angle of the x axis in radians.
     * @param {number} y - The angle of the y axis in radians.
     * @param {number} z - The angle of the z axis in radians.
     * @param {string} [order] - A string representing the order that the rotations are applied.
     * @return {Euler} A reference to this Euler instance.
     */
    set(x2, y2, z2, order = this._order) {
      this._x = x2;
      this._y = y2;
      this._z = z2;
      this._order = order;
      this._onChangeCallback();
      return this;
    }
    /**
     * Returns a new Euler instance with copied values from this instance.
     *
     * @return {Euler} A clone of this instance.
     */
    clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
     * Copies the values of the given Euler instance to this instance.
     *
     * @param {Euler} euler - The Euler instance to copy.
     * @return {Euler} A reference to this Euler instance.
     */
    copy(euler) {
      this._x = euler._x;
      this._y = euler._y;
      this._z = euler._z;
      this._order = euler._order;
      this._onChangeCallback();
      return this;
    }
    /**
     * Sets the angles of this Euler instance from a pure rotation matrix.
     *
     * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
     * @param {string} [order] - A string representing the order that the rotations are applied.
     * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
     * @return {Euler} A reference to this Euler instance.
     */
    setFromRotationMatrix(m, order = this._order, update = true) {
      const te2 = m.elements;
      const m11 = te2[0], m12 = te2[4], m13 = te2[8];
      const m21 = te2[1], m22 = te2[5], m23 = te2[9];
      const m31 = te2[2], m32 = te2[6], m33 = te2[10];
      switch (order) {
        case "XYZ":
          this._y = Math.asin(clamp(m13, -1, 1));
          if (Math.abs(m13) < 0.9999999) {
            this._x = Math.atan2(-m23, m33);
            this._z = Math.atan2(-m12, m11);
          } else {
            this._x = Math.atan2(m32, m22);
            this._z = 0;
          }
          break;
        case "YXZ":
          this._x = Math.asin(-clamp(m23, -1, 1));
          if (Math.abs(m23) < 0.9999999) {
            this._y = Math.atan2(m13, m33);
            this._z = Math.atan2(m21, m22);
          } else {
            this._y = Math.atan2(-m31, m11);
            this._z = 0;
          }
          break;
        case "ZXY":
          this._x = Math.asin(clamp(m32, -1, 1));
          if (Math.abs(m32) < 0.9999999) {
            this._y = Math.atan2(-m31, m33);
            this._z = Math.atan2(-m12, m22);
          } else {
            this._y = 0;
            this._z = Math.atan2(m21, m11);
          }
          break;
        case "ZYX":
          this._y = Math.asin(-clamp(m31, -1, 1));
          if (Math.abs(m31) < 0.9999999) {
            this._x = Math.atan2(m32, m33);
            this._z = Math.atan2(m21, m11);
          } else {
            this._x = 0;
            this._z = Math.atan2(-m12, m22);
          }
          break;
        case "YZX":
          this._z = Math.asin(clamp(m21, -1, 1));
          if (Math.abs(m21) < 0.9999999) {
            this._x = Math.atan2(-m23, m22);
            this._y = Math.atan2(-m31, m11);
          } else {
            this._x = 0;
            this._y = Math.atan2(m13, m33);
          }
          break;
        case "XZY":
          this._z = Math.asin(-clamp(m12, -1, 1));
          if (Math.abs(m12) < 0.9999999) {
            this._x = Math.atan2(m32, m22);
            this._y = Math.atan2(m13, m11);
          } else {
            this._x = Math.atan2(-m23, m33);
            this._y = 0;
          }
          break;
        default:
          console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
      }
      this._order = order;
      if (update === true) this._onChangeCallback();
      return this;
    }
    /**
     * Sets the angles of this Euler instance from a normalized quaternion.
     *
     * @param {Quaternion} q - A normalized Quaternion.
     * @param {string} [order] - A string representing the order that the rotations are applied.
     * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
     * @return {Euler} A reference to this Euler instance.
     */
    setFromQuaternion(q2, order, update) {
      _matrix$2.makeRotationFromQuaternion(q2);
      return this.setFromRotationMatrix(_matrix$2, order, update);
    }
    /**
     * Sets the angles of this Euler instance from the given vector.
     *
     * @param {Vector3} v - The vector.
     * @param {string} [order] - A string representing the order that the rotations are applied.
     * @return {Euler} A reference to this Euler instance.
     */
    setFromVector3(v2, order = this._order) {
      return this.set(v2.x, v2.y, v2.z, order);
    }
    /**
     * Resets the euler angle with a new order by creating a quaternion from this
     * euler angle and then setting this euler angle with the quaternion and the
     * new order.
     *
     * Warning: This discards revolution information.
     *
     * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
     * @return {Euler} A reference to this Euler instance.
     */
    reorder(newOrder) {
      _quaternion$3.setFromEuler(this);
      return this.setFromQuaternion(_quaternion$3, newOrder);
    }
    /**
     * Returns `true` if this Euler instance is equal with the given one.
     *
     * @param {Euler} euler - The Euler instance to test for equality.
     * @return {boolean} Whether this Euler instance is equal with the given one.
     */
    equals(euler) {
      return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
     * Sets this Euler instance's components to values from the given array. The first three
     * entries of the array are assign to the x,y and z components. An optional fourth entry
     * defines the Euler order.
     *
     * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
     * @return {Euler} A reference to this Euler instance.
     */
    fromArray(array) {
      this._x = array[0];
      this._y = array[1];
      this._z = array[2];
      if (array[3] !== void 0) this._order = array[3];
      this._onChangeCallback();
      return this;
    }
    /**
     * Writes the components of this Euler instance to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number,number,number,string>} The Euler components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this._x;
      array[offset + 1] = this._y;
      array[offset + 2] = this._z;
      array[offset + 3] = this._order;
      return array;
    }
    _onChange(callback) {
      this._onChangeCallback = callback;
      return this;
    }
    _onChangeCallback() {
    }
    *[Symbol.iterator]() {
      yield this._x;
      yield this._y;
      yield this._z;
      yield this._order;
    }
  }
  Euler.DEFAULT_ORDER = "XYZ";
  class Layers {
    /**
     * Constructs a new layers instance, with membership
     * initially set to layer `0`.
     */
    constructor() {
      this.mask = 1 | 0;
    }
    /**
     * Sets membership to the given layer, and remove membership all other layers.
     *
     * @param {number} layer - The layer to set.
     */
    set(layer) {
      this.mask = (1 << layer | 0) >>> 0;
    }
    /**
     * Adds membership of the given layer.
     *
     * @param {number} layer - The layer to enable.
     */
    enable(layer) {
      this.mask |= 1 << layer | 0;
    }
    /**
     * Adds membership to all layers.
     */
    enableAll() {
      this.mask = 4294967295 | 0;
    }
    /**
     * Toggles the membership of the given layer.
     *
     * @param {number} layer - The layer to toggle.
     */
    toggle(layer) {
      this.mask ^= 1 << layer | 0;
    }
    /**
     * Removes membership of the given layer.
     *
     * @param {number} layer - The layer to enable.
     */
    disable(layer) {
      this.mask &= ~(1 << layer | 0);
    }
    /**
     * Removes the membership from all layers.
     */
    disableAll() {
      this.mask = 0;
    }
    /**
     * Returns `true` if this and the given layers object have at least one
     * layer in common.
     *
     * @param {Layers} layers - The layers to test.
     * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
     */
    test(layers) {
      return (this.mask & layers.mask) !== 0;
    }
    /**
     * Returns `true` if the given layer is enabled.
     *
     * @param {number} layer - The layer to test.
     * @return {boolean } Whether the given layer is enabled or not.
     */
    isEnabled(layer) {
      return (this.mask & (1 << layer | 0)) !== 0;
    }
  }
  let _object3DId = 0;
  const _v1$4 = /* @__PURE__ */ new Vector3();
  const _q1 = /* @__PURE__ */ new Quaternion();
  const _m1$1$1 = /* @__PURE__ */ new Matrix4();
  const _target = /* @__PURE__ */ new Vector3();
  const _position$3 = /* @__PURE__ */ new Vector3();
  const _scale$2 = /* @__PURE__ */ new Vector3();
  const _quaternion$2 = /* @__PURE__ */ new Quaternion();
  const _xAxis = /* @__PURE__ */ new Vector3(1, 0, 0);
  const _yAxis = /* @__PURE__ */ new Vector3(0, 1, 0);
  const _zAxis = /* @__PURE__ */ new Vector3(0, 0, 1);
  const _addedEvent = { type: "added" };
  const _removedEvent = { type: "removed" };
  const _childaddedEvent = { type: "childadded", child: null };
  const _childremovedEvent = { type: "childremoved", child: null };
  class Object3D extends EventDispatcher {
    /**
     * Constructs a new 3D object.
     */
    constructor() {
      super();
      this.isObject3D = true;
      Object.defineProperty(this, "id", { value: _object3DId++ });
      this.uuid = generateUUID();
      this.name = "";
      this.type = "Object3D";
      this.parent = null;
      this.children = [];
      this.up = Object3D.DEFAULT_UP.clone();
      const position = new Vector3();
      const rotation = new Euler();
      const quaternion = new Quaternion();
      const scale = new Vector3(1, 1, 1);
      function onRotationChange() {
        quaternion.setFromEuler(rotation, false);
      }
      function onQuaternionChange() {
        rotation.setFromQuaternion(quaternion, void 0, false);
      }
      rotation._onChange(onRotationChange);
      quaternion._onChange(onQuaternionChange);
      Object.defineProperties(this, {
        /**
         * Represents the object's local position.
         *
         * @name Object3D#position
         * @type {Vector3}
         * @default (0,0,0)
         */
        position: {
          configurable: true,
          enumerable: true,
          value: position
        },
        /**
         * Represents the object's local rotation as Euler angles, in radians.
         *
         * @name Object3D#rotation
         * @type {Euler}
         * @default (0,0,0)
         */
        rotation: {
          configurable: true,
          enumerable: true,
          value: rotation
        },
        /**
         * Represents the object's local rotation as Quaternions.
         *
         * @name Object3D#quaternion
         * @type {Quaternion}
         */
        quaternion: {
          configurable: true,
          enumerable: true,
          value: quaternion
        },
        /**
         * Represents the object's local scale.
         *
         * @name Object3D#scale
         * @type {Vector3}
         * @default (1,1,1)
         */
        scale: {
          configurable: true,
          enumerable: true,
          value: scale
        },
        /**
         * Represents the object's model-view matrix.
         *
         * @name Object3D#modelViewMatrix
         * @type {Matrix4}
         */
        modelViewMatrix: {
          value: new Matrix4()
        },
        /**
         * Represents the object's normal matrix.
         *
         * @name Object3D#normalMatrix
         * @type {Matrix3}
         */
        normalMatrix: {
          value: new Matrix3()
        }
      });
      this.matrix = new Matrix4();
      this.matrixWorld = new Matrix4();
      this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
      this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE;
      this.matrixWorldNeedsUpdate = false;
      this.layers = new Layers();
      this.visible = true;
      this.castShadow = false;
      this.receiveShadow = false;
      this.frustumCulled = true;
      this.renderOrder = 0;
      this.animations = [];
      this.customDepthMaterial = void 0;
      this.customDistanceMaterial = void 0;
      this.userData = {};
    }
    /**
     * A callback that is executed immediately before a 3D object is rendered to a shadow map.
     *
     * @param {Renderer|WebGLRenderer} renderer - The renderer.
     * @param {Object3D} object - The 3D object.
     * @param {Camera} camera - The camera that is used to render the scene.
     * @param {Camera} shadowCamera - The shadow camera.
     * @param {BufferGeometry} geometry - The 3D object's geometry.
     * @param {Material} depthMaterial - The depth material.
     * @param {Object} group - The geometry group data.
     */
    onBeforeShadow() {
    }
    /**
     * A callback that is executed immediately after a 3D object is rendered to a shadow map.
     *
     * @param {Renderer|WebGLRenderer} renderer - The renderer.
     * @param {Object3D} object - The 3D object.
     * @param {Camera} camera - The camera that is used to render the scene.
     * @param {Camera} shadowCamera - The shadow camera.
     * @param {BufferGeometry} geometry - The 3D object's geometry.
     * @param {Material} depthMaterial - The depth material.
     * @param {Object} group - The geometry group data.
     */
    onAfterShadow() {
    }
    /**
     * A callback that is executed immediately before a 3D object is rendered.
     *
     * @param {Renderer|WebGLRenderer} renderer - The renderer.
     * @param {Object3D} object - The 3D object.
     * @param {Camera} camera - The camera that is used to render the scene.
     * @param {BufferGeometry} geometry - The 3D object's geometry.
     * @param {Material} material - The 3D object's material.
     * @param {Object} group - The geometry group data.
     */
    onBeforeRender() {
    }
    /**
     * A callback that is executed immediately after a 3D object is rendered.
     *
     * @param {Renderer|WebGLRenderer} renderer - The renderer.
     * @param {Object3D} object - The 3D object.
     * @param {Camera} camera - The camera that is used to render the scene.
     * @param {BufferGeometry} geometry - The 3D object's geometry.
     * @param {Material} material - The 3D object's material.
     * @param {Object} group - The geometry group data.
     */
    onAfterRender() {
    }
    /**
     * Applies the given transformation matrix to the object and updates the object's position,
     * rotation and scale.
     *
     * @param {Matrix4} matrix - The transformation matrix.
     */
    applyMatrix4(matrix) {
      if (this.matrixAutoUpdate) this.updateMatrix();
      this.matrix.premultiply(matrix);
      this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
     * Applies a rotation represented by given the quaternion to the 3D object.
     *
     * @param {Quaternion} q - The quaternion.
     * @return {Object3D} A reference to this instance.
     */
    applyQuaternion(q2) {
      this.quaternion.premultiply(q2);
      return this;
    }
    /**
     * Sets the given rotation represented as an axis/angle couple to the 3D object.
     *
     * @param {Vector3} axis - The (normalized) axis vector.
     * @param {number} angle - The angle in radians.
     */
    setRotationFromAxisAngle(axis, angle) {
      this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
     * Sets the given rotation represented as Euler angles to the 3D object.
     *
     * @param {Euler} euler - The Euler angles.
     */
    setRotationFromEuler(euler) {
      this.quaternion.setFromEuler(euler, true);
    }
    /**
     * Sets the given rotation represented as rotation matrix to the 3D object.
     *
     * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
     * a pure rotation matrix (i.e, unscaled).
     */
    setRotationFromMatrix(m) {
      this.quaternion.setFromRotationMatrix(m);
    }
    /**
     * Sets the given rotation represented as a Quaternion to the 3D object.
     *
     * @param {Quaternion} q - The Quaternion
     */
    setRotationFromQuaternion(q2) {
      this.quaternion.copy(q2);
    }
    /**
     * Rotates the 3D object along an axis in local space.
     *
     * @param {Vector3} axis - The (normalized) axis vector.
     * @param {number} angle - The angle in radians.
     * @return {Object3D} A reference to this instance.
     */
    rotateOnAxis(axis, angle) {
      _q1.setFromAxisAngle(axis, angle);
      this.quaternion.multiply(_q1);
      return this;
    }
    /**
     * Rotates the 3D object along an axis in world space.
     *
     * @param {Vector3} axis - The (normalized) axis vector.
     * @param {number} angle - The angle in radians.
     * @return {Object3D} A reference to this instance.
     */
    rotateOnWorldAxis(axis, angle) {
      _q1.setFromAxisAngle(axis, angle);
      this.quaternion.premultiply(_q1);
      return this;
    }
    /**
     * Rotates the 3D object around its X axis in local space.
     *
     * @param {number} angle - The angle in radians.
     * @return {Object3D} A reference to this instance.
     */
    rotateX(angle) {
      return this.rotateOnAxis(_xAxis, angle);
    }
    /**
     * Rotates the 3D object around its Y axis in local space.
     *
     * @param {number} angle - The angle in radians.
     * @return {Object3D} A reference to this instance.
     */
    rotateY(angle) {
      return this.rotateOnAxis(_yAxis, angle);
    }
    /**
     * Rotates the 3D object around its Z axis in local space.
     *
     * @param {number} angle - The angle in radians.
     * @return {Object3D} A reference to this instance.
     */
    rotateZ(angle) {
      return this.rotateOnAxis(_zAxis, angle);
    }
    /**
     * Translate the 3D object by a distance along the given axis in local space.
     *
     * @param {Vector3} axis - The (normalized) axis vector.
     * @param {number} distance - The distance in world units.
     * @return {Object3D} A reference to this instance.
     */
    translateOnAxis(axis, distance) {
      _v1$4.copy(axis).applyQuaternion(this.quaternion);
      this.position.add(_v1$4.multiplyScalar(distance));
      return this;
    }
    /**
     * Translate the 3D object by a distance along its X-axis in local space.
     *
     * @param {number} distance - The distance in world units.
     * @return {Object3D} A reference to this instance.
     */
    translateX(distance) {
      return this.translateOnAxis(_xAxis, distance);
    }
    /**
     * Translate the 3D object by a distance along its Y-axis in local space.
     *
     * @param {number} distance - The distance in world units.
     * @return {Object3D} A reference to this instance.
     */
    translateY(distance) {
      return this.translateOnAxis(_yAxis, distance);
    }
    /**
     * Translate the 3D object by a distance along its Z-axis in local space.
     *
     * @param {number} distance - The distance in world units.
     * @return {Object3D} A reference to this instance.
     */
    translateZ(distance) {
      return this.translateOnAxis(_zAxis, distance);
    }
    /**
     * Converts the given vector from this 3D object's local space to world space.
     *
     * @param {Vector3} vector - The vector to convert.
     * @return {Vector3} The converted vector.
     */
    localToWorld(vector) {
      this.updateWorldMatrix(true, false);
      return vector.applyMatrix4(this.matrixWorld);
    }
    /**
     * Converts the given vector from this 3D object's word space to local space.
     *
     * @param {Vector3} vector - The vector to convert.
     * @return {Vector3} The converted vector.
     */
    worldToLocal(vector) {
      this.updateWorldMatrix(true, false);
      return vector.applyMatrix4(_m1$1$1.copy(this.matrixWorld).invert());
    }
    /**
     * Rotates the object to face a point in world space.
     *
     * This method does not support objects having non-uniformly-scaled parent(s).
     *
     * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
     * @param {number} [y] - The y coordinate in world space.
     * @param {number} [z] - The z coordinate in world space.
     */
    lookAt(x2, y2, z2) {
      if (x2.isVector3) {
        _target.copy(x2);
      } else {
        _target.set(x2, y2, z2);
      }
      const parent = this.parent;
      this.updateWorldMatrix(true, false);
      _position$3.setFromMatrixPosition(this.matrixWorld);
      if (this.isCamera || this.isLight) {
        _m1$1$1.lookAt(_position$3, _target, this.up);
      } else {
        _m1$1$1.lookAt(_target, _position$3, this.up);
      }
      this.quaternion.setFromRotationMatrix(_m1$1$1);
      if (parent) {
        _m1$1$1.extractRotation(parent.matrixWorld);
        _q1.setFromRotationMatrix(_m1$1$1);
        this.quaternion.premultiply(_q1.invert());
      }
    }
    /**
     * Adds the given 3D object as a child to this 3D object. An arbitrary number of
     * objects may be added. Any current parent on an object passed in here will be
     * removed, since an object can have at most one parent.
     *
     * @fires Object3D#added
     * @fires Object3D#childadded
     * @param {Object3D} object - The 3D object to add.
     * @return {Object3D} A reference to this instance.
     */
    add(object) {
      if (arguments.length > 1) {
        for (let i2 = 0; i2 < arguments.length; i2++) {
          this.add(arguments[i2]);
        }
        return this;
      }
      if (object === this) {
        console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
        return this;
      }
      if (object && object.isObject3D) {
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.dispatchEvent(_addedEvent);
        _childaddedEvent.child = object;
        this.dispatchEvent(_childaddedEvent);
        _childaddedEvent.child = null;
      } else {
        console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
      }
      return this;
    }
    /**
     * Removes the given 3D object as child from this 3D object.
     * An arbitrary number of objects may be removed.
     *
     * @fires Object3D#removed
     * @fires Object3D#childremoved
     * @param {Object3D} object - The 3D object to remove.
     * @return {Object3D} A reference to this instance.
     */
    remove(object) {
      if (arguments.length > 1) {
        for (let i2 = 0; i2 < arguments.length; i2++) {
          this.remove(arguments[i2]);
        }
        return this;
      }
      const index = this.children.indexOf(object);
      if (index !== -1) {
        object.parent = null;
        this.children.splice(index, 1);
        object.dispatchEvent(_removedEvent);
        _childremovedEvent.child = object;
        this.dispatchEvent(_childremovedEvent);
        _childremovedEvent.child = null;
      }
      return this;
    }
    /**
     * Removes this 3D object from its current parent.
     *
     * @fires Object3D#removed
     * @fires Object3D#childremoved
     * @return {Object3D} A reference to this instance.
     */
    removeFromParent() {
      const parent = this.parent;
      if (parent !== null) {
        parent.remove(this);
      }
      return this;
    }
    /**
     * Removes all child objects.
     *
     * @fires Object3D#removed
     * @fires Object3D#childremoved
     * @return {Object3D} A reference to this instance.
     */
    clear() {
      return this.remove(...this.children);
    }
    /**
     * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
     * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
     *
     * @fires Object3D#added
     * @fires Object3D#childadded
     * @param {Object3D} object - The 3D object to attach.
     * @return {Object3D} A reference to this instance.
     */
    attach(object) {
      this.updateWorldMatrix(true, false);
      _m1$1$1.copy(this.matrixWorld).invert();
      if (object.parent !== null) {
        object.parent.updateWorldMatrix(true, false);
        _m1$1$1.multiply(object.parent.matrixWorld);
      }
      object.applyMatrix4(_m1$1$1);
      object.removeFromParent();
      object.parent = this;
      this.children.push(object);
      object.updateWorldMatrix(false, true);
      object.dispatchEvent(_addedEvent);
      _childaddedEvent.child = object;
      this.dispatchEvent(_childaddedEvent);
      _childaddedEvent.child = null;
      return this;
    }
    /**
     * Searches through the 3D object and its children, starting with the 3D object
     * itself, and returns the first with a matching ID.
     *
     * @param {number} id - The id.
     * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
     */
    getObjectById(id) {
      return this.getObjectByProperty("id", id);
    }
    /**
     * Searches through the 3D object and its children, starting with the 3D object
     * itself, and returns the first with a matching name.
     *
     * @param {string} name - The name.
     * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
     */
    getObjectByName(name) {
      return this.getObjectByProperty("name", name);
    }
    /**
     * Searches through the 3D object and its children, starting with the 3D object
     * itself, and returns the first with a matching property value.
     *
     * @param {string} name - The name of the property.
     * @param {any} value - The value.
     * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
     */
    getObjectByProperty(name, value) {
      if (this[name] === value) return this;
      for (let i2 = 0, l2 = this.children.length; i2 < l2; i2++) {
        const child = this.children[i2];
        const object = child.getObjectByProperty(name, value);
        if (object !== void 0) {
          return object;
        }
      }
      return void 0;
    }
    /**
     * Searches through the 3D object and its children, starting with the 3D object
     * itself, and returns all 3D objects with a matching property value.
     *
     * @param {string} name - The name of the property.
     * @param {any} value - The value.
     * @param {Array<Object3D>} result - The method stores the result in this array.
     * @return {Array<Object3D>} The found 3D objects.
     */
    getObjectsByProperty(name, value, result = []) {
      if (this[name] === value) result.push(this);
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].getObjectsByProperty(name, value, result);
      }
      return result;
    }
    /**
     * Returns a vector representing the position of the 3D object in world space.
     *
     * @param {Vector3} target - The target vector the result is stored to.
     * @return {Vector3} The 3D object's position in world space.
     */
    getWorldPosition(target) {
      this.updateWorldMatrix(true, false);
      return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
     * Returns a Quaternion representing the position of the 3D object in world space.
     *
     * @param {Quaternion} target - The target Quaternion the result is stored to.
     * @return {Quaternion} The 3D object's rotation in world space.
     */
    getWorldQuaternion(target) {
      this.updateWorldMatrix(true, false);
      this.matrixWorld.decompose(_position$3, target, _scale$2);
      return target;
    }
    /**
     * Returns a vector representing the scale of the 3D object in world space.
     *
     * @param {Vector3} target - The target vector the result is stored to.
     * @return {Vector3} The 3D object's scale in world space.
     */
    getWorldScale(target) {
      this.updateWorldMatrix(true, false);
      this.matrixWorld.decompose(_position$3, _quaternion$2, target);
      return target;
    }
    /**
     * Returns a vector representing the ("look") direction of the 3D object in world space.
     *
     * @param {Vector3} target - The target vector the result is stored to.
     * @return {Vector3} The 3D object's direction in world space.
     */
    getWorldDirection(target) {
      this.updateWorldMatrix(true, false);
      const e2 = this.matrixWorld.elements;
      return target.set(e2[8], e2[9], e2[10]).normalize();
    }
    /**
     * Abstract method to get intersections between a casted ray and this
     * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
     * implement this method in order to use raycasting.
     *
     * @abstract
     * @param {Raycaster} raycaster - The raycaster.
     * @param {Array<Object>} intersects - An array holding the result of the method.
     */
    raycast() {
    }
    /**
     * Executes the callback on this 3D object and all descendants.
     *
     * Note: Modifying the scene graph inside the callback is discouraged.
     *
     * @param {Function} callback - A callback function that allows to process the current 3D object.
     */
    traverse(callback) {
      callback(this);
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].traverse(callback);
      }
    }
    /**
     * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
     * Descendants of invisible 3D objects are not traversed.
     *
     * Note: Modifying the scene graph inside the callback is discouraged.
     *
     * @param {Function} callback - A callback function that allows to process the current 3D object.
     */
    traverseVisible(callback) {
      if (this.visible === false) return;
      callback(this);
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].traverseVisible(callback);
      }
    }
    /**
     * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
     *
     * Note: Modifying the scene graph inside the callback is discouraged.
     *
     * @param {Function} callback - A callback function that allows to process the current 3D object.
     */
    traverseAncestors(callback) {
      const parent = this.parent;
      if (parent !== null) {
        callback(parent);
        parent.traverseAncestors(callback);
      }
    }
    /**
     * Updates the transformation matrix in local space by computing it from the current
     * position, rotation and scale values.
     */
    updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale);
      this.matrixWorldNeedsUpdate = true;
    }
    /**
     * Updates the transformation matrix in world space of this 3D objects and its descendants.
     *
     * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
     * local space. The computation of the local and world matrix can be controlled with the
     * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
     * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
     *
     * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
     * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
     */
    updateMatrixWorld(force) {
      if (this.matrixAutoUpdate) this.updateMatrix();
      if (this.matrixWorldNeedsUpdate || force) {
        if (this.matrixWorldAutoUpdate === true) {
          if (this.parent === null) {
            this.matrixWorld.copy(this.matrix);
          } else {
            this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
          }
        }
        this.matrixWorldNeedsUpdate = false;
        force = true;
      }
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        const child = children[i2];
        child.updateMatrixWorld(force);
      }
    }
    /**
     * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
     * update of ancestor and descendant nodes.
     *
     * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
     * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
     */
    updateWorldMatrix(updateParents, updateChildren) {
      const parent = this.parent;
      if (updateParents === true && parent !== null) {
        parent.updateWorldMatrix(true, false);
      }
      if (this.matrixAutoUpdate) this.updateMatrix();
      if (this.matrixWorldAutoUpdate === true) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
      }
      if (updateChildren === true) {
        const children = this.children;
        for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
          const child = children[i2];
          child.updateWorldMatrix(false, true);
        }
      }
    }
    /**
     * Serializes the 3D object into JSON.
     *
     * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized 3D object.
     * @see {@link ObjectLoader#parse}
     */
    toJSON(meta) {
      const isRootObject = meta === void 0 || typeof meta === "string";
      const output = {};
      if (isRootObject) {
        meta = {
          geometries: {},
          materials: {},
          textures: {},
          images: {},
          shapes: {},
          skeletons: {},
          animations: {},
          nodes: {}
        };
        output.metadata = {
          version: 4.7,
          type: "Object",
          generator: "Object3D.toJSON"
        };
      }
      const object = {};
      object.uuid = this.uuid;
      object.type = this.type;
      if (this.name !== "") object.name = this.name;
      if (this.castShadow === true) object.castShadow = true;
      if (this.receiveShadow === true) object.receiveShadow = true;
      if (this.visible === false) object.visible = false;
      if (this.frustumCulled === false) object.frustumCulled = false;
      if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
      if (Object.keys(this.userData).length > 0) object.userData = this.userData;
      object.layers = this.layers.mask;
      object.matrix = this.matrix.toArray();
      object.up = this.up.toArray();
      if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
      if (this.isInstancedMesh) {
        object.type = "InstancedMesh";
        object.count = this.count;
        object.instanceMatrix = this.instanceMatrix.toJSON();
        if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
      }
      if (this.isBatchedMesh) {
        object.type = "BatchedMesh";
        object.perObjectFrustumCulled = this.perObjectFrustumCulled;
        object.sortObjects = this.sortObjects;
        object.drawRanges = this._drawRanges;
        object.reservedRanges = this._reservedRanges;
        object.geometryInfo = this._geometryInfo.map((info) => ({
          ...info,
          boundingBox: info.boundingBox ? info.boundingBox.toJSON() : void 0,
          boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : void 0
        }));
        object.instanceInfo = this._instanceInfo.map((info) => ({ ...info }));
        object.availableInstanceIds = this._availableInstanceIds.slice();
        object.availableGeometryIds = this._availableGeometryIds.slice();
        object.nextIndexStart = this._nextIndexStart;
        object.nextVertexStart = this._nextVertexStart;
        object.geometryCount = this._geometryCount;
        object.maxInstanceCount = this._maxInstanceCount;
        object.maxVertexCount = this._maxVertexCount;
        object.maxIndexCount = this._maxIndexCount;
        object.geometryInitialized = this._geometryInitialized;
        object.matricesTexture = this._matricesTexture.toJSON(meta);
        object.indirectTexture = this._indirectTexture.toJSON(meta);
        if (this._colorsTexture !== null) {
          object.colorsTexture = this._colorsTexture.toJSON(meta);
        }
        if (this.boundingSphere !== null) {
          object.boundingSphere = this.boundingSphere.toJSON();
        }
        if (this.boundingBox !== null) {
          object.boundingBox = this.boundingBox.toJSON();
        }
      }
      function serialize(library, element) {
        if (library[element.uuid] === void 0) {
          library[element.uuid] = element.toJSON(meta);
        }
        return element.uuid;
      }
      if (this.isScene) {
        if (this.background) {
          if (this.background.isColor) {
            object.background = this.background.toJSON();
          } else if (this.background.isTexture) {
            object.background = this.background.toJSON(meta).uuid;
          }
        }
        if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {
          object.environment = this.environment.toJSON(meta).uuid;
        }
      } else if (this.isMesh || this.isLine || this.isPoints) {
        object.geometry = serialize(meta.geometries, this.geometry);
        const parameters = this.geometry.parameters;
        if (parameters !== void 0 && parameters.shapes !== void 0) {
          const shapes = parameters.shapes;
          if (Array.isArray(shapes)) {
            for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
              const shape = shapes[i2];
              serialize(meta.shapes, shape);
            }
          } else {
            serialize(meta.shapes, shapes);
          }
        }
      }
      if (this.isSkinnedMesh) {
        object.bindMode = this.bindMode;
        object.bindMatrix = this.bindMatrix.toArray();
        if (this.skeleton !== void 0) {
          serialize(meta.skeletons, this.skeleton);
          object.skeleton = this.skeleton.uuid;
        }
      }
      if (this.material !== void 0) {
        if (Array.isArray(this.material)) {
          const uuids = [];
          for (let i2 = 0, l2 = this.material.length; i2 < l2; i2++) {
            uuids.push(serialize(meta.materials, this.material[i2]));
          }
          object.material = uuids;
        } else {
          object.material = serialize(meta.materials, this.material);
        }
      }
      if (this.children.length > 0) {
        object.children = [];
        for (let i2 = 0; i2 < this.children.length; i2++) {
          object.children.push(this.children[i2].toJSON(meta).object);
        }
      }
      if (this.animations.length > 0) {
        object.animations = [];
        for (let i2 = 0; i2 < this.animations.length; i2++) {
          const animation = this.animations[i2];
          object.animations.push(serialize(meta.animations, animation));
        }
      }
      if (isRootObject) {
        const geometries = extractFromCache(meta.geometries);
        const materials = extractFromCache(meta.materials);
        const textures = extractFromCache(meta.textures);
        const images = extractFromCache(meta.images);
        const shapes = extractFromCache(meta.shapes);
        const skeletons = extractFromCache(meta.skeletons);
        const animations = extractFromCache(meta.animations);
        const nodes = extractFromCache(meta.nodes);
        if (geometries.length > 0) output.geometries = geometries;
        if (materials.length > 0) output.materials = materials;
        if (textures.length > 0) output.textures = textures;
        if (images.length > 0) output.images = images;
        if (shapes.length > 0) output.shapes = shapes;
        if (skeletons.length > 0) output.skeletons = skeletons;
        if (animations.length > 0) output.animations = animations;
        if (nodes.length > 0) output.nodes = nodes;
      }
      output.object = object;
      return output;
      function extractFromCache(cache) {
        const values = [];
        for (const key in cache) {
          const data = cache[key];
          delete data.metadata;
          values.push(data);
        }
        return values;
      }
    }
    /**
     * Returns a new 3D object with copied values from this instance.
     *
     * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
     * @return {Object3D} A clone of this instance.
     */
    clone(recursive) {
      return new this.constructor().copy(this, recursive);
    }
    /**
     * Copies the values of the given 3D object to this instance.
     *
     * @param {Object3D} source - The 3D object to copy.
     * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
     * @return {Object3D} A reference to this instance.
     */
    copy(source, recursive = true) {
      this.name = source.name;
      this.up.copy(source.up);
      this.position.copy(source.position);
      this.rotation.order = source.rotation.order;
      this.quaternion.copy(source.quaternion);
      this.scale.copy(source.scale);
      this.matrix.copy(source.matrix);
      this.matrixWorld.copy(source.matrixWorld);
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
      this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
      this.layers.mask = source.layers.mask;
      this.visible = source.visible;
      this.castShadow = source.castShadow;
      this.receiveShadow = source.receiveShadow;
      this.frustumCulled = source.frustumCulled;
      this.renderOrder = source.renderOrder;
      this.animations = source.animations.slice();
      this.userData = JSON.parse(JSON.stringify(source.userData));
      if (recursive === true) {
        for (let i2 = 0; i2 < source.children.length; i2++) {
          const child = source.children[i2];
          this.add(child.clone());
        }
      }
      return this;
    }
  }
  Object3D.DEFAULT_UP = /* @__PURE__ */ new Vector3(0, 1, 0);
  Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
  Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
  const _v0$1 = /* @__PURE__ */ new Vector3();
  const _v1$3 = /* @__PURE__ */ new Vector3();
  const _v2$2 = /* @__PURE__ */ new Vector3();
  const _v3$2 = /* @__PURE__ */ new Vector3();
  const _vab = /* @__PURE__ */ new Vector3();
  const _vac = /* @__PURE__ */ new Vector3();
  const _vbc = /* @__PURE__ */ new Vector3();
  const _vap = /* @__PURE__ */ new Vector3();
  const _vbp = /* @__PURE__ */ new Vector3();
  const _vcp = /* @__PURE__ */ new Vector3();
  const _v40 = /* @__PURE__ */ new Vector4();
  const _v41 = /* @__PURE__ */ new Vector4();
  const _v42 = /* @__PURE__ */ new Vector4();
  class Triangle {
    /**
     * Constructs a new triangle.
     *
     * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
     * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
     * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
     */
    constructor(a2 = new Vector3(), b2 = new Vector3(), c2 = new Vector3()) {
      this.a = a2;
      this.b = b2;
      this.c = c2;
    }
    /**
     * Computes the normal vector of a triangle.
     *
     * @param {Vector3} a - The first corner of the triangle.
     * @param {Vector3} b - The second corner of the triangle.
     * @param {Vector3} c - The third corner of the triangle.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The triangle's normal.
     */
    static getNormal(a2, b2, c2, target) {
      target.subVectors(c2, b2);
      _v0$1.subVectors(a2, b2);
      target.cross(_v0$1);
      const targetLengthSq = target.lengthSq();
      if (targetLengthSq > 0) {
        return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
      }
      return target.set(0, 0, 0);
    }
    /**
     * Computes a barycentric coordinates from the given vector.
     * Returns `null` if the triangle is degenerate.
     *
     * @param {Vector3} point - A point in 3D space.
     * @param {Vector3} a - The first corner of the triangle.
     * @param {Vector3} b - The second corner of the triangle.
     * @param {Vector3} c - The third corner of the triangle.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The barycentric coordinates for the given point
     */
    static getBarycoord(point, a2, b2, c2, target) {
      _v0$1.subVectors(c2, a2);
      _v1$3.subVectors(b2, a2);
      _v2$2.subVectors(point, a2);
      const dot00 = _v0$1.dot(_v0$1);
      const dot01 = _v0$1.dot(_v1$3);
      const dot02 = _v0$1.dot(_v2$2);
      const dot11 = _v1$3.dot(_v1$3);
      const dot12 = _v1$3.dot(_v2$2);
      const denom = dot00 * dot11 - dot01 * dot01;
      if (denom === 0) {
        target.set(0, 0, 0);
        return null;
      }
      const invDenom = 1 / denom;
      const u2 = (dot11 * dot02 - dot01 * dot12) * invDenom;
      const v2 = (dot00 * dot12 - dot01 * dot02) * invDenom;
      return target.set(1 - u2 - v2, v2, u2);
    }
    /**
     * Returns `true` if the given point, when projected onto the plane of the
     * triangle, lies within the triangle.
     *
     * @param {Vector3} point - The point in 3D space to test.
     * @param {Vector3} a - The first corner of the triangle.
     * @param {Vector3} b - The second corner of the triangle.
     * @param {Vector3} c - The third corner of the triangle.
     * @return {boolean} Whether the given point, when projected onto the plane of the
     * triangle, lies within the triangle or not.
     */
    static containsPoint(point, a2, b2, c2) {
      if (this.getBarycoord(point, a2, b2, c2, _v3$2) === null) {
        return false;
      }
      return _v3$2.x >= 0 && _v3$2.y >= 0 && _v3$2.x + _v3$2.y <= 1;
    }
    /**
     * Computes the value barycentrically interpolated for the given point on the
     * triangle. Returns `null` if the triangle is degenerate.
     *
     * @param {Vector3} point - Position of interpolated point.
     * @param {Vector3} p1 - The first corner of the triangle.
     * @param {Vector3} p2 - The second corner of the triangle.
     * @param {Vector3} p3 - The third corner of the triangle.
     * @param {Vector3} v1 - Value to interpolate of first vertex.
     * @param {Vector3} v2 - Value to interpolate of second vertex.
     * @param {Vector3} v3 - Value to interpolate of third vertex.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The interpolated value.
     */
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
      if (this.getBarycoord(point, p1, p2, p3, _v3$2) === null) {
        target.x = 0;
        target.y = 0;
        if ("z" in target) target.z = 0;
        if ("w" in target) target.w = 0;
        return null;
      }
      target.setScalar(0);
      target.addScaledVector(v1, _v3$2.x);
      target.addScaledVector(v2, _v3$2.y);
      target.addScaledVector(v3, _v3$2.z);
      return target;
    }
    /**
     * Computes the value barycentrically interpolated for the given attribute and indices.
     *
     * @param {BufferAttribute} attr - The attribute to interpolate.
     * @param {number} i1 - Index of first vertex.
     * @param {number} i2 - Index of second vertex.
     * @param {number} i3 - Index of third vertex.
     * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The interpolated attribute value.
     */
    static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
      _v40.setScalar(0);
      _v41.setScalar(0);
      _v42.setScalar(0);
      _v40.fromBufferAttribute(attr, i1);
      _v41.fromBufferAttribute(attr, i2);
      _v42.fromBufferAttribute(attr, i3);
      target.setScalar(0);
      target.addScaledVector(_v40, barycoord.x);
      target.addScaledVector(_v41, barycoord.y);
      target.addScaledVector(_v42, barycoord.z);
      return target;
    }
    /**
     * Returns `true` if the triangle is oriented towards the given direction.
     *
     * @param {Vector3} a - The first corner of the triangle.
     * @param {Vector3} b - The second corner of the triangle.
     * @param {Vector3} c - The third corner of the triangle.
     * @param {Vector3} direction - The (normalized) direction vector.
     * @return {boolean} Whether the triangle is oriented towards the given direction or not.
     */
    static isFrontFacing(a2, b2, c2, direction) {
      _v0$1.subVectors(c2, b2);
      _v1$3.subVectors(a2, b2);
      return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
     * Sets the triangle's vertices by copying the given values.
     *
     * @param {Vector3} a - The first corner of the triangle.
     * @param {Vector3} b - The second corner of the triangle.
     * @param {Vector3} c - The third corner of the triangle.
     * @return {Triangle} A reference to this triangle.
     */
    set(a2, b2, c2) {
      this.a.copy(a2);
      this.b.copy(b2);
      this.c.copy(c2);
      return this;
    }
    /**
     * Sets the triangle's vertices by copying the given array values.
     *
     * @param {Array<Vector3>} points - An array with 3D points.
     * @param {number} i0 - The array index representing the first corner of the triangle.
     * @param {number} i1 - The array index representing the second corner of the triangle.
     * @param {number} i2 - The array index representing the third corner of the triangle.
     * @return {Triangle} A reference to this triangle.
     */
    setFromPointsAndIndices(points, i0, i1, i2) {
      this.a.copy(points[i0]);
      this.b.copy(points[i1]);
      this.c.copy(points[i2]);
      return this;
    }
    /**
     * Sets the triangle's vertices by copying the given attribute values.
     *
     * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
     * @param {number} i0 - The attribute index representing the first corner of the triangle.
     * @param {number} i1 - The attribute index representing the second corner of the triangle.
     * @param {number} i2 - The attribute index representing the third corner of the triangle.
     * @return {Triangle} A reference to this triangle.
     */
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
      this.a.fromBufferAttribute(attribute, i0);
      this.b.fromBufferAttribute(attribute, i1);
      this.c.fromBufferAttribute(attribute, i2);
      return this;
    }
    /**
     * Returns a new triangle with copied values from this instance.
     *
     * @return {Triangle} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given triangle to this instance.
     *
     * @param {Triangle} triangle - The triangle to copy.
     * @return {Triangle} A reference to this triangle.
     */
    copy(triangle) {
      this.a.copy(triangle.a);
      this.b.copy(triangle.b);
      this.c.copy(triangle.c);
      return this;
    }
    /**
     * Computes the area of the triangle.
     *
     * @return {number} The triangle's area.
     */
    getArea() {
      _v0$1.subVectors(this.c, this.b);
      _v1$3.subVectors(this.a, this.b);
      return _v0$1.cross(_v1$3).length() * 0.5;
    }
    /**
     * Computes the midpoint of the triangle.
     *
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The triangle's midpoint.
     */
    getMidpoint(target) {
      return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
     * Computes the normal of the triangle.
     *
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The triangle's normal.
     */
    getNormal(target) {
      return Triangle.getNormal(this.a, this.b, this.c, target);
    }
    /**
     * Computes a plane the triangle lies within.
     *
     * @param {Plane} target - The target vector that is used to store the method's result.
     * @return {Plane} The plane the triangle lies within.
     */
    getPlane(target) {
      return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
     * Computes a barycentric coordinates from the given vector.
     * Returns `null` if the triangle is degenerate.
     *
     * @param {Vector3} point - A point in 3D space.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The barycentric coordinates for the given point
     */
    getBarycoord(point, target) {
      return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
     * Computes the value barycentrically interpolated for the given point on the
     * triangle. Returns `null` if the triangle is degenerate.
     *
     * @param {Vector3} point - Position of interpolated point.
     * @param {Vector3} v1 - Value to interpolate of first vertex.
     * @param {Vector3} v2 - Value to interpolate of second vertex.
     * @param {Vector3} v3 - Value to interpolate of third vertex.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The interpolated value.
     */
    getInterpolation(point, v1, v2, v3, target) {
      return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
     * Returns `true` if the given point, when projected onto the plane of the
     * triangle, lies within the triangle.
     *
     * @param {Vector3} point - The point in 3D space to test.
     * @return {boolean} Whether the given point, when projected onto the plane of the
     * triangle, lies within the triangle or not.
     */
    containsPoint(point) {
      return Triangle.containsPoint(point, this.a, this.b, this.c);
    }
    /**
     * Returns `true` if the triangle is oriented towards the given direction.
     *
     * @param {Vector3} direction - The (normalized) direction vector.
     * @return {boolean} Whether the triangle is oriented towards the given direction or not.
     */
    isFrontFacing(direction) {
      return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
     * Returns `true` if this triangle intersects with the given box.
     *
     * @param {Box3} box - The box to intersect.
     * @return {boolean} Whether this triangle intersects with the given box or not.
     */
    intersectsBox(box) {
      return box.intersectsTriangle(this);
    }
    /**
     * Returns the closest point on the triangle to the given point.
     *
     * @param {Vector3} p - The point to compute the closest point for.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The closest point on the triangle.
     */
    closestPointToPoint(p2, target) {
      const a2 = this.a, b2 = this.b, c2 = this.c;
      let v2, w2;
      _vab.subVectors(b2, a2);
      _vac.subVectors(c2, a2);
      _vap.subVectors(p2, a2);
      const d1 = _vab.dot(_vap);
      const d2 = _vac.dot(_vap);
      if (d1 <= 0 && d2 <= 0) {
        return target.copy(a2);
      }
      _vbp.subVectors(p2, b2);
      const d3 = _vab.dot(_vbp);
      const d4 = _vac.dot(_vbp);
      if (d3 >= 0 && d4 <= d3) {
        return target.copy(b2);
      }
      const vc2 = d1 * d4 - d3 * d2;
      if (vc2 <= 0 && d1 >= 0 && d3 <= 0) {
        v2 = d1 / (d1 - d3);
        return target.copy(a2).addScaledVector(_vab, v2);
      }
      _vcp.subVectors(p2, c2);
      const d5 = _vab.dot(_vcp);
      const d6 = _vac.dot(_vcp);
      if (d6 >= 0 && d5 <= d6) {
        return target.copy(c2);
      }
      const vb = d5 * d2 - d1 * d6;
      if (vb <= 0 && d2 >= 0 && d6 <= 0) {
        w2 = d2 / (d2 - d6);
        return target.copy(a2).addScaledVector(_vac, w2);
      }
      const va2 = d3 * d6 - d5 * d4;
      if (va2 <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
        _vbc.subVectors(c2, b2);
        w2 = (d4 - d3) / (d4 - d3 + (d5 - d6));
        return target.copy(b2).addScaledVector(_vbc, w2);
      }
      const denom = 1 / (va2 + vb + vc2);
      v2 = vb * denom;
      w2 = vc2 * denom;
      return target.copy(a2).addScaledVector(_vab, v2).addScaledVector(_vac, w2);
    }
    /**
     * Returns `true` if this triangle is equal with the given one.
     *
     * @param {Triangle} triangle - The triangle to test for equality.
     * @return {boolean} Whether this triangle is equal with the given one.
     */
    equals(triangle) {
      return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
  }
  const _colorKeywords = {
    "aliceblue": 15792383,
    "antiquewhite": 16444375,
    "aqua": 65535,
    "aquamarine": 8388564,
    "azure": 15794175,
    "beige": 16119260,
    "bisque": 16770244,
    "black": 0,
    "blanchedalmond": 16772045,
    "blue": 255,
    "blueviolet": 9055202,
    "brown": 10824234,
    "burlywood": 14596231,
    "cadetblue": 6266528,
    "chartreuse": 8388352,
    "chocolate": 13789470,
    "coral": 16744272,
    "cornflowerblue": 6591981,
    "cornsilk": 16775388,
    "crimson": 14423100,
    "cyan": 65535,
    "darkblue": 139,
    "darkcyan": 35723,
    "darkgoldenrod": 12092939,
    "darkgray": 11119017,
    "darkgreen": 25600,
    "darkgrey": 11119017,
    "darkkhaki": 12433259,
    "darkmagenta": 9109643,
    "darkolivegreen": 5597999,
    "darkorange": 16747520,
    "darkorchid": 10040012,
    "darkred": 9109504,
    "darksalmon": 15308410,
    "darkseagreen": 9419919,
    "darkslateblue": 4734347,
    "darkslategray": 3100495,
    "darkslategrey": 3100495,
    "darkturquoise": 52945,
    "darkviolet": 9699539,
    "deeppink": 16716947,
    "deepskyblue": 49151,
    "dimgray": 6908265,
    "dimgrey": 6908265,
    "dodgerblue": 2003199,
    "firebrick": 11674146,
    "floralwhite": 16775920,
    "forestgreen": 2263842,
    "fuchsia": 16711935,
    "gainsboro": 14474460,
    "ghostwhite": 16316671,
    "gold": 16766720,
    "goldenrod": 14329120,
    "gray": 8421504,
    "green": 32768,
    "greenyellow": 11403055,
    "grey": 8421504,
    "honeydew": 15794160,
    "hotpink": 16738740,
    "indianred": 13458524,
    "indigo": 4915330,
    "ivory": 16777200,
    "khaki": 15787660,
    "lavender": 15132410,
    "lavenderblush": 16773365,
    "lawngreen": 8190976,
    "lemonchiffon": 16775885,
    "lightblue": 11393254,
    "lightcoral": 15761536,
    "lightcyan": 14745599,
    "lightgoldenrodyellow": 16448210,
    "lightgray": 13882323,
    "lightgreen": 9498256,
    "lightgrey": 13882323,
    "lightpink": 16758465,
    "lightsalmon": 16752762,
    "lightseagreen": 2142890,
    "lightskyblue": 8900346,
    "lightslategray": 7833753,
    "lightslategrey": 7833753,
    "lightsteelblue": 11584734,
    "lightyellow": 16777184,
    "lime": 65280,
    "limegreen": 3329330,
    "linen": 16445670,
    "magenta": 16711935,
    "maroon": 8388608,
    "mediumaquamarine": 6737322,
    "mediumblue": 205,
    "mediumorchid": 12211667,
    "mediumpurple": 9662683,
    "mediumseagreen": 3978097,
    "mediumslateblue": 8087790,
    "mediumspringgreen": 64154,
    "mediumturquoise": 4772300,
    "mediumvioletred": 13047173,
    "midnightblue": 1644912,
    "mintcream": 16121850,
    "mistyrose": 16770273,
    "moccasin": 16770229,
    "navajowhite": 16768685,
    "navy": 128,
    "oldlace": 16643558,
    "olive": 8421376,
    "olivedrab": 7048739,
    "orange": 16753920,
    "orangered": 16729344,
    "orchid": 14315734,
    "palegoldenrod": 15657130,
    "palegreen": 10025880,
    "paleturquoise": 11529966,
    "palevioletred": 14381203,
    "papayawhip": 16773077,
    "peachpuff": 16767673,
    "peru": 13468991,
    "pink": 16761035,
    "plum": 14524637,
    "powderblue": 11591910,
    "purple": 8388736,
    "rebeccapurple": 6697881,
    "red": 16711680,
    "rosybrown": 12357519,
    "royalblue": 4286945,
    "saddlebrown": 9127187,
    "salmon": 16416882,
    "sandybrown": 16032864,
    "seagreen": 3050327,
    "seashell": 16774638,
    "sienna": 10506797,
    "silver": 12632256,
    "skyblue": 8900331,
    "slateblue": 6970061,
    "slategray": 7372944,
    "slategrey": 7372944,
    "snow": 16775930,
    "springgreen": 65407,
    "steelblue": 4620980,
    "tan": 13808780,
    "teal": 32896,
    "thistle": 14204888,
    "tomato": 16737095,
    "turquoise": 4251856,
    "violet": 15631086,
    "wheat": 16113331,
    "white": 16777215,
    "whitesmoke": 16119285,
    "yellow": 16776960,
    "yellowgreen": 10145074
  };
  const _hslA = { h: 0, s: 0, l: 0 };
  const _hslB = { h: 0, s: 0, l: 0 };
  function hue2rgb(p2, q2, t2) {
    if (t2 < 0) t2 += 1;
    if (t2 > 1) t2 -= 1;
    if (t2 < 1 / 6) return p2 + (q2 - p2) * 6 * t2;
    if (t2 < 1 / 2) return q2;
    if (t2 < 2 / 3) return p2 + (q2 - p2) * 6 * (2 / 3 - t2);
    return p2;
  }
  class Color {
    /**
     * Constructs a new color.
     *
     * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
     * and that method is used throughout the rest of the documentation.
     *
     * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
     * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
     * @param {number} [g] - The green component.
     * @param {number} [b] - The blue component.
     */
    constructor(r2, g2, b2) {
      this.isColor = true;
      this.r = 1;
      this.g = 1;
      this.b = 1;
      return this.set(r2, g2, b2);
    }
    /**
     * Sets the colors's components from the given values.
     *
     * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
     * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
     * @param {number} [g] - The green component.
     * @param {number} [b] - The blue component.
     * @return {Color} A reference to this color.
     */
    set(r2, g2, b2) {
      if (g2 === void 0 && b2 === void 0) {
        const value = r2;
        if (value && value.isColor) {
          this.copy(value);
        } else if (typeof value === "number") {
          this.setHex(value);
        } else if (typeof value === "string") {
          this.setStyle(value);
        }
      } else {
        this.setRGB(r2, g2, b2);
      }
      return this;
    }
    /**
     * Sets the colors's components to the given scalar value.
     *
     * @param {number} scalar - The scalar value.
     * @return {Color} A reference to this color.
     */
    setScalar(scalar) {
      this.r = scalar;
      this.g = scalar;
      this.b = scalar;
      return this;
    }
    /**
     * Sets this color from a hexadecimal value.
     *
     * @param {number} hex - The hexadecimal value.
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {Color} A reference to this color.
     */
    setHex(hex, colorSpace = SRGBColorSpace) {
      hex = Math.floor(hex);
      this.r = (hex >> 16 & 255) / 255;
      this.g = (hex >> 8 & 255) / 255;
      this.b = (hex & 255) / 255;
      ColorManagement.colorSpaceToWorking(this, colorSpace);
      return this;
    }
    /**
     * Sets this color from RGB values.
     *
     * @param {number} r - Red channel value between `0.0` and `1.0`.
     * @param {number} g - Green channel value between `0.0` and `1.0`.
     * @param {number} b - Blue channel value between `0.0` and `1.0`.
     * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
     * @return {Color} A reference to this color.
     */
    setRGB(r2, g2, b2, colorSpace = ColorManagement.workingColorSpace) {
      this.r = r2;
      this.g = g2;
      this.b = b2;
      ColorManagement.colorSpaceToWorking(this, colorSpace);
      return this;
    }
    /**
     * Sets this color from RGB values.
     *
     * @param {number} h - Hue value between `0.0` and `1.0`.
     * @param {number} s - Saturation value between `0.0` and `1.0`.
     * @param {number} l - Lightness value between `0.0` and `1.0`.
     * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
     * @return {Color} A reference to this color.
     */
    setHSL(h2, s2, l2, colorSpace = ColorManagement.workingColorSpace) {
      h2 = euclideanModulo(h2, 1);
      s2 = clamp(s2, 0, 1);
      l2 = clamp(l2, 0, 1);
      if (s2 === 0) {
        this.r = this.g = this.b = l2;
      } else {
        const p2 = l2 <= 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
        const q2 = 2 * l2 - p2;
        this.r = hue2rgb(q2, p2, h2 + 1 / 3);
        this.g = hue2rgb(q2, p2, h2);
        this.b = hue2rgb(q2, p2, h2 - 1 / 3);
      }
      ColorManagement.colorSpaceToWorking(this, colorSpace);
      return this;
    }
    /**
     * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
     * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
     * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
     * all 140 color names are supported).
     *
     * @param {string} style - Color as a CSS-style string.
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {Color} A reference to this color.
     */
    setStyle(style, colorSpace = SRGBColorSpace) {
      function handleAlpha(string) {
        if (string === void 0) return;
        if (parseFloat(string) < 1) {
          console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
      }
      let m;
      if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
        let color;
        const name = m[1];
        const components = m[2];
        switch (name) {
          case "rgb":
          case "rgba":
            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              handleAlpha(color[4]);
              return this.setRGB(
                Math.min(255, parseInt(color[1], 10)) / 255,
                Math.min(255, parseInt(color[2], 10)) / 255,
                Math.min(255, parseInt(color[3], 10)) / 255,
                colorSpace
              );
            }
            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              handleAlpha(color[4]);
              return this.setRGB(
                Math.min(100, parseInt(color[1], 10)) / 100,
                Math.min(100, parseInt(color[2], 10)) / 100,
                Math.min(100, parseInt(color[3], 10)) / 100,
                colorSpace
              );
            }
            break;
          case "hsl":
          case "hsla":
            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              handleAlpha(color[4]);
              return this.setHSL(
                parseFloat(color[1]) / 360,
                parseFloat(color[2]) / 100,
                parseFloat(color[3]) / 100,
                colorSpace
              );
            }
            break;
          default:
            console.warn("THREE.Color: Unknown color model " + style);
        }
      } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
        const hex = m[1];
        const size = hex.length;
        if (size === 3) {
          return this.setRGB(
            parseInt(hex.charAt(0), 16) / 15,
            parseInt(hex.charAt(1), 16) / 15,
            parseInt(hex.charAt(2), 16) / 15,
            colorSpace
          );
        } else if (size === 6) {
          return this.setHex(parseInt(hex, 16), colorSpace);
        } else {
          console.warn("THREE.Color: Invalid hex color " + style);
        }
      } else if (style && style.length > 0) {
        return this.setColorName(style, colorSpace);
      }
      return this;
    }
    /**
     * Sets this color from a color name. Faster than {@link Color#setStyle} if
     * you don't need the other CSS-style formats.
     *
     * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
     * ```js
     * Color.NAMES.aliceblue // returns 0xF0F8FF
     * ```
     *
     * @param {string} style - The color name.
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {Color} A reference to this color.
     */
    setColorName(style, colorSpace = SRGBColorSpace) {
      const hex = _colorKeywords[style.toLowerCase()];
      if (hex !== void 0) {
        this.setHex(hex, colorSpace);
      } else {
        console.warn("THREE.Color: Unknown color " + style);
      }
      return this;
    }
    /**
     * Returns a new color with copied values from this instance.
     *
     * @return {Color} A clone of this instance.
     */
    clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
    /**
     * Copies the values of the given color to this instance.
     *
     * @param {Color} color - The color to copy.
     * @return {Color} A reference to this color.
     */
    copy(color) {
      this.r = color.r;
      this.g = color.g;
      this.b = color.b;
      return this;
    }
    /**
     * Copies the given color into this color, and then converts this color from
     * `SRGBColorSpace` to `LinearSRGBColorSpace`.
     *
     * @param {Color} color - The color to copy/convert.
     * @return {Color} A reference to this color.
     */
    copySRGBToLinear(color) {
      this.r = SRGBToLinear(color.r);
      this.g = SRGBToLinear(color.g);
      this.b = SRGBToLinear(color.b);
      return this;
    }
    /**
     * Copies the given color into this color, and then converts this color from
     * `LinearSRGBColorSpace` to `SRGBColorSpace`.
     *
     * @param {Color} color - The color to copy/convert.
     * @return {Color} A reference to this color.
     */
    copyLinearToSRGB(color) {
      this.r = LinearToSRGB(color.r);
      this.g = LinearToSRGB(color.g);
      this.b = LinearToSRGB(color.b);
      return this;
    }
    /**
     * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
     *
     * @return {Color} A reference to this color.
     */
    convertSRGBToLinear() {
      this.copySRGBToLinear(this);
      return this;
    }
    /**
     * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
     *
     * @return {Color} A reference to this color.
     */
    convertLinearToSRGB() {
      this.copyLinearToSRGB(this);
      return this;
    }
    /**
     * Returns the hexadecimal value of this color.
     *
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {number} The hexadecimal value.
     */
    getHex(colorSpace = SRGBColorSpace) {
      ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
      return Math.round(clamp(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp(_color.g * 255, 0, 255)) * 256 + Math.round(clamp(_color.b * 255, 0, 255));
    }
    /**
     * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
     *
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {string} The hexadecimal value as a string.
     */
    getHexString(colorSpace = SRGBColorSpace) {
      return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
     * Converts the colors RGB values into the HSL format and stores them into the
     * given target object.
     *
     * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
     * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
     * @return {{h:number,s:number,l:number}} The HSL representation of this color.
     */
    getHSL(target, colorSpace = ColorManagement.workingColorSpace) {
      ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
      const r2 = _color.r, g2 = _color.g, b2 = _color.b;
      const max = Math.max(r2, g2, b2);
      const min = Math.min(r2, g2, b2);
      let hue, saturation;
      const lightness = (min + max) / 2;
      if (min === max) {
        hue = 0;
        saturation = 0;
      } else {
        const delta = max - min;
        saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
        switch (max) {
          case r2:
            hue = (g2 - b2) / delta + (g2 < b2 ? 6 : 0);
            break;
          case g2:
            hue = (b2 - r2) / delta + 2;
            break;
          case b2:
            hue = (r2 - g2) / delta + 4;
            break;
        }
        hue /= 6;
      }
      target.h = hue;
      target.s = saturation;
      target.l = lightness;
      return target;
    }
    /**
     * Returns the RGB values of this color and stores them into the given target object.
     *
     * @param {Color} target - The target color that is used to store the method's result.
     * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
     * @return {Color} The RGB representation of this color.
     */
    getRGB(target, colorSpace = ColorManagement.workingColorSpace) {
      ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
      target.r = _color.r;
      target.g = _color.g;
      target.b = _color.b;
      return target;
    }
    /**
     * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
     *
     * @param {string} [colorSpace=SRGBColorSpace] - The color space.
     * @return {string} The CSS representation of this color.
     */
    getStyle(colorSpace = SRGBColorSpace) {
      ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
      const r2 = _color.r, g2 = _color.g, b2 = _color.b;
      if (colorSpace !== SRGBColorSpace) {
        return `color(${colorSpace} ${r2.toFixed(3)} ${g2.toFixed(3)} ${b2.toFixed(3)})`;
      }
      return `rgb(${Math.round(r2 * 255)},${Math.round(g2 * 255)},${Math.round(b2 * 255)})`;
    }
    /**
     * Adds the given HSL values to this color's values.
     * Internally, this converts the color's RGB values to HSL, adds HSL
     * and then converts the color back to RGB.
     *
     * @param {number} h - Hue value between `0.0` and `1.0`.
     * @param {number} s - Saturation value between `0.0` and `1.0`.
     * @param {number} l - Lightness value between `0.0` and `1.0`.
     * @return {Color} A reference to this color.
     */
    offsetHSL(h2, s2, l2) {
      this.getHSL(_hslA);
      return this.setHSL(_hslA.h + h2, _hslA.s + s2, _hslA.l + l2);
    }
    /**
     * Adds the RGB values of the given color to the RGB values of this color.
     *
     * @param {Color} color - The color to add.
     * @return {Color} A reference to this color.
     */
    add(color) {
      this.r += color.r;
      this.g += color.g;
      this.b += color.b;
      return this;
    }
    /**
     * Adds the RGB values of the given colors and stores the result in this instance.
     *
     * @param {Color} color1 - The first color.
     * @param {Color} color2 - The second color.
     * @return {Color} A reference to this color.
     */
    addColors(color1, color2) {
      this.r = color1.r + color2.r;
      this.g = color1.g + color2.g;
      this.b = color1.b + color2.b;
      return this;
    }
    /**
     * Adds the given scalar value to the RGB values of this color.
     *
     * @param {number} s - The scalar to add.
     * @return {Color} A reference to this color.
     */
    addScalar(s2) {
      this.r += s2;
      this.g += s2;
      this.b += s2;
      return this;
    }
    /**
     * Subtracts the RGB values of the given color from the RGB values of this color.
     *
     * @param {Color} color - The color to subtract.
     * @return {Color} A reference to this color.
     */
    sub(color) {
      this.r = Math.max(0, this.r - color.r);
      this.g = Math.max(0, this.g - color.g);
      this.b = Math.max(0, this.b - color.b);
      return this;
    }
    /**
     * Multiplies the RGB values of the given color with the RGB values of this color.
     *
     * @param {Color} color - The color to multiply.
     * @return {Color} A reference to this color.
     */
    multiply(color) {
      this.r *= color.r;
      this.g *= color.g;
      this.b *= color.b;
      return this;
    }
    /**
     * Multiplies the given scalar value with the RGB values of this color.
     *
     * @param {number} s - The scalar to multiply.
     * @return {Color} A reference to this color.
     */
    multiplyScalar(s2) {
      this.r *= s2;
      this.g *= s2;
      this.b *= s2;
      return this;
    }
    /**
     * Linearly interpolates this color's RGB values toward the RGB values of the
     * given color. The alpha argument can be thought of as the ratio between
     * the two colors, where `0.0` is this color and `1.0` is the first argument.
     *
     * @param {Color} color - The color to converge on.
     * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
     * @return {Color} A reference to this color.
     */
    lerp(color, alpha) {
      this.r += (color.r - this.r) * alpha;
      this.g += (color.g - this.g) * alpha;
      this.b += (color.b - this.b) * alpha;
      return this;
    }
    /**
     * Linearly interpolates between the given colors and stores the result in this instance.
     * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
     * is the first and `1.0` is the second color.
     *
     * @param {Color} color1 - The first color.
     * @param {Color} color2 - The second color.
     * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
     * @return {Color} A reference to this color.
     */
    lerpColors(color1, color2, alpha) {
      this.r = color1.r + (color2.r - color1.r) * alpha;
      this.g = color1.g + (color2.g - color1.g) * alpha;
      this.b = color1.b + (color2.b - color1.b) * alpha;
      return this;
    }
    /**
     * Linearly interpolates this color's HSL values toward the HSL values of the
     * given color. It differs from {@link Color#lerp} by not interpolating straight
     * from one color to the other, but instead going through all the hues in between
     * those two colors. The alpha argument can be thought of as the ratio between
     * the two colors, where 0.0 is this color and 1.0 is the first argument.
     *
     * @param {Color} color - The color to converge on.
     * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
     * @return {Color} A reference to this color.
     */
    lerpHSL(color, alpha) {
      this.getHSL(_hslA);
      color.getHSL(_hslB);
      const h2 = lerp(_hslA.h, _hslB.h, alpha);
      const s2 = lerp(_hslA.s, _hslB.s, alpha);
      const l2 = lerp(_hslA.l, _hslB.l, alpha);
      this.setHSL(h2, s2, l2);
      return this;
    }
    /**
     * Sets the color's RGB components from the given 3D vector.
     *
     * @param {Vector3} v - The vector to set.
     * @return {Color} A reference to this color.
     */
    setFromVector3(v2) {
      this.r = v2.x;
      this.g = v2.y;
      this.b = v2.z;
      return this;
    }
    /**
     * Transforms this color with the given 3x3 matrix.
     *
     * @param {Matrix3} m - The matrix.
     * @return {Color} A reference to this color.
     */
    applyMatrix3(m) {
      const r2 = this.r, g2 = this.g, b2 = this.b;
      const e2 = m.elements;
      this.r = e2[0] * r2 + e2[3] * g2 + e2[6] * b2;
      this.g = e2[1] * r2 + e2[4] * g2 + e2[7] * b2;
      this.b = e2[2] * r2 + e2[5] * g2 + e2[8] * b2;
      return this;
    }
    /**
     * Returns `true` if this color is equal with the given one.
     *
     * @param {Color} c - The color to test for equality.
     * @return {boolean} Whether this bounding color is equal with the given one.
     */
    equals(c2) {
      return c2.r === this.r && c2.g === this.g && c2.b === this.b;
    }
    /**
     * Sets this color's RGB components from the given array.
     *
     * @param {Array<number>} array - An array holding the RGB values.
     * @param {number} [offset=0] - The offset into the array.
     * @return {Color} A reference to this color.
     */
    fromArray(array, offset = 0) {
      this.r = array[offset];
      this.g = array[offset + 1];
      this.b = array[offset + 2];
      return this;
    }
    /**
     * Writes the RGB components of this color to the given array. If no array is provided,
     * the method returns a new instance.
     *
     * @param {Array<number>} [array=[]] - The target array holding the color components.
     * @param {number} [offset=0] - Index of the first element in the array.
     * @return {Array<number>} The color components.
     */
    toArray(array = [], offset = 0) {
      array[offset] = this.r;
      array[offset + 1] = this.g;
      array[offset + 2] = this.b;
      return array;
    }
    /**
     * Sets the components of this color from the given buffer attribute.
     *
     * @param {BufferAttribute} attribute - The buffer attribute holding color data.
     * @param {number} index - The index into the attribute.
     * @return {Color} A reference to this color.
     */
    fromBufferAttribute(attribute, index) {
      this.r = attribute.getX(index);
      this.g = attribute.getY(index);
      this.b = attribute.getZ(index);
      return this;
    }
    /**
     * This methods defines the serialization result of this class. Returns the color
     * as a hexadecimal value.
     *
     * @return {number} The hexadecimal value.
     */
    toJSON() {
      return this.getHex();
    }
    *[Symbol.iterator]() {
      yield this.r;
      yield this.g;
      yield this.b;
    }
  }
  const _color = /* @__PURE__ */ new Color();
  Color.NAMES = _colorKeywords;
  let _materialId = 0;
  class Material extends EventDispatcher {
    /**
     * Constructs a new material.
     */
    constructor() {
      super();
      this.isMaterial = true;
      Object.defineProperty(this, "id", { value: _materialId++ });
      this.uuid = generateUUID();
      this.name = "";
      this.type = "Material";
      this.blending = NormalBlending;
      this.side = FrontSide;
      this.vertexColors = false;
      this.opacity = 1;
      this.transparent = false;
      this.alphaHash = false;
      this.blendSrc = SrcAlphaFactor;
      this.blendDst = OneMinusSrcAlphaFactor;
      this.blendEquation = AddEquation;
      this.blendSrcAlpha = null;
      this.blendDstAlpha = null;
      this.blendEquationAlpha = null;
      this.blendColor = new Color(0, 0, 0);
      this.blendAlpha = 0;
      this.depthFunc = LessEqualDepth;
      this.depthTest = true;
      this.depthWrite = true;
      this.stencilWriteMask = 255;
      this.stencilFunc = AlwaysStencilFunc;
      this.stencilRef = 0;
      this.stencilFuncMask = 255;
      this.stencilFail = KeepStencilOp;
      this.stencilZFail = KeepStencilOp;
      this.stencilZPass = KeepStencilOp;
      this.stencilWrite = false;
      this.clippingPlanes = null;
      this.clipIntersection = false;
      this.clipShadows = false;
      this.shadowSide = null;
      this.colorWrite = true;
      this.precision = null;
      this.polygonOffset = false;
      this.polygonOffsetFactor = 0;
      this.polygonOffsetUnits = 0;
      this.dithering = false;
      this.alphaToCoverage = false;
      this.premultipliedAlpha = false;
      this.forceSinglePass = false;
      this.allowOverride = true;
      this.visible = true;
      this.toneMapped = true;
      this.userData = {};
      this.version = 0;
      this._alphaTest = 0;
    }
    /**
     * Sets the alpha value to be used when running an alpha test. The material
     * will not be rendered if the opacity is lower than this value.
     *
     * @type {number}
     * @readonly
     * @default 0
     */
    get alphaTest() {
      return this._alphaTest;
    }
    set alphaTest(value) {
      if (this._alphaTest > 0 !== value > 0) {
        this.version++;
      }
      this._alphaTest = value;
    }
    /**
     * An optional callback that is executed immediately before the material is used to render a 3D object.
     *
     * This method can only be used when rendering with {@link WebGLRenderer}.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Scene} scene - The scene.
     * @param {Camera} camera - The camera that is used to render the scene.
     * @param {BufferGeometry} geometry - The 3D object's geometry.
     * @param {Object3D} object - The 3D object.
     * @param {Object} group - The geometry group data.
     */
    onBeforeRender() {
    }
    /**
     * An optional callback that is executed immediately before the shader
     * program is compiled. This function is called with the shader source code
     * as a parameter. Useful for the modification of built-in materials.
     *
     * This method can only be used when rendering with {@link WebGLRenderer}. The
     * recommended approach when customizing materials is to use `WebGPURenderer` with the new
     * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
     *
     * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
     * @param {WebGLRenderer} renderer - A reference to the renderer.
     */
    onBeforeCompile() {
    }
    /**
     * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
     * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
     * shader or recompile the shader for this material as needed.
     *
     * This method can only be used when rendering with {@link WebGLRenderer}.
     *
     * @return {string} The custom program cache key.
     */
    customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
    /**
     * This method can be used to set default values from parameter objects.
     * It is a generic implementation so it can be used with different types
     * of materials.
     *
     * @param {Object} [values] - The material values to set.
     */
    setValues(values) {
      if (values === void 0) return;
      for (const key in values) {
        const newValue = values[key];
        if (newValue === void 0) {
          console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
          continue;
        }
        const currentValue = this[key];
        if (currentValue === void 0) {
          console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
          continue;
        }
        if (currentValue && currentValue.isColor) {
          currentValue.set(newValue);
        } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
          currentValue.copy(newValue);
        } else {
          this[key] = newValue;
        }
      }
    }
    /**
     * Serializes the material into JSON.
     *
     * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized material.
     * @see {@link ObjectLoader#parse}
     */
    toJSON(meta) {
      const isRootObject = meta === void 0 || typeof meta === "string";
      if (isRootObject) {
        meta = {
          textures: {},
          images: {}
        };
      }
      const data = {
        metadata: {
          version: 4.7,
          type: "Material",
          generator: "Material.toJSON"
        }
      };
      data.uuid = this.uuid;
      data.type = this.type;
      if (this.name !== "") data.name = this.name;
      if (this.color && this.color.isColor) data.color = this.color.getHex();
      if (this.roughness !== void 0) data.roughness = this.roughness;
      if (this.metalness !== void 0) data.metalness = this.metalness;
      if (this.sheen !== void 0) data.sheen = this.sheen;
      if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
      if (this.sheenRoughness !== void 0) data.sheenRoughness = this.sheenRoughness;
      if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
      if (this.emissiveIntensity !== void 0 && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
      if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
      if (this.specularIntensity !== void 0) data.specularIntensity = this.specularIntensity;
      if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
      if (this.shininess !== void 0) data.shininess = this.shininess;
      if (this.clearcoat !== void 0) data.clearcoat = this.clearcoat;
      if (this.clearcoatRoughness !== void 0) data.clearcoatRoughness = this.clearcoatRoughness;
      if (this.clearcoatMap && this.clearcoatMap.isTexture) {
        data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
      }
      if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
        data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
      }
      if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
        data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
        data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
      }
      if (this.dispersion !== void 0) data.dispersion = this.dispersion;
      if (this.iridescence !== void 0) data.iridescence = this.iridescence;
      if (this.iridescenceIOR !== void 0) data.iridescenceIOR = this.iridescenceIOR;
      if (this.iridescenceThicknessRange !== void 0) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
      if (this.iridescenceMap && this.iridescenceMap.isTexture) {
        data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
      }
      if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {
        data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
      }
      if (this.anisotropy !== void 0) data.anisotropy = this.anisotropy;
      if (this.anisotropyRotation !== void 0) data.anisotropyRotation = this.anisotropyRotation;
      if (this.anisotropyMap && this.anisotropyMap.isTexture) {
        data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
      }
      if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
      if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
      if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
      if (this.lightMap && this.lightMap.isTexture) {
        data.lightMap = this.lightMap.toJSON(meta).uuid;
        data.lightMapIntensity = this.lightMapIntensity;
      }
      if (this.aoMap && this.aoMap.isTexture) {
        data.aoMap = this.aoMap.toJSON(meta).uuid;
        data.aoMapIntensity = this.aoMapIntensity;
      }
      if (this.bumpMap && this.bumpMap.isTexture) {
        data.bumpMap = this.bumpMap.toJSON(meta).uuid;
        data.bumpScale = this.bumpScale;
      }
      if (this.normalMap && this.normalMap.isTexture) {
        data.normalMap = this.normalMap.toJSON(meta).uuid;
        data.normalMapType = this.normalMapType;
        data.normalScale = this.normalScale.toArray();
      }
      if (this.displacementMap && this.displacementMap.isTexture) {
        data.displacementMap = this.displacementMap.toJSON(meta).uuid;
        data.displacementScale = this.displacementScale;
        data.displacementBias = this.displacementBias;
      }
      if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
      if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
      if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
      if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
      if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
      if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
      if (this.envMap && this.envMap.isTexture) {
        data.envMap = this.envMap.toJSON(meta).uuid;
        if (this.combine !== void 0) data.combine = this.combine;
      }
      if (this.envMapRotation !== void 0) data.envMapRotation = this.envMapRotation.toArray();
      if (this.envMapIntensity !== void 0) data.envMapIntensity = this.envMapIntensity;
      if (this.reflectivity !== void 0) data.reflectivity = this.reflectivity;
      if (this.refractionRatio !== void 0) data.refractionRatio = this.refractionRatio;
      if (this.gradientMap && this.gradientMap.isTexture) {
        data.gradientMap = this.gradientMap.toJSON(meta).uuid;
      }
      if (this.transmission !== void 0) data.transmission = this.transmission;
      if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
      if (this.thickness !== void 0) data.thickness = this.thickness;
      if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
      if (this.attenuationDistance !== void 0 && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
      if (this.attenuationColor !== void 0) data.attenuationColor = this.attenuationColor.getHex();
      if (this.size !== void 0) data.size = this.size;
      if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
      if (this.sizeAttenuation !== void 0) data.sizeAttenuation = this.sizeAttenuation;
      if (this.blending !== NormalBlending) data.blending = this.blending;
      if (this.side !== FrontSide) data.side = this.side;
      if (this.vertexColors === true) data.vertexColors = true;
      if (this.opacity < 1) data.opacity = this.opacity;
      if (this.transparent === true) data.transparent = true;
      if (this.blendSrc !== SrcAlphaFactor) data.blendSrc = this.blendSrc;
      if (this.blendDst !== OneMinusSrcAlphaFactor) data.blendDst = this.blendDst;
      if (this.blendEquation !== AddEquation) data.blendEquation = this.blendEquation;
      if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
      if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
      if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
      if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
      if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
      if (this.depthFunc !== LessEqualDepth) data.depthFunc = this.depthFunc;
      if (this.depthTest === false) data.depthTest = this.depthTest;
      if (this.depthWrite === false) data.depthWrite = this.depthWrite;
      if (this.colorWrite === false) data.colorWrite = this.colorWrite;
      if (this.stencilWriteMask !== 255) data.stencilWriteMask = this.stencilWriteMask;
      if (this.stencilFunc !== AlwaysStencilFunc) data.stencilFunc = this.stencilFunc;
      if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
      if (this.stencilFuncMask !== 255) data.stencilFuncMask = this.stencilFuncMask;
      if (this.stencilFail !== KeepStencilOp) data.stencilFail = this.stencilFail;
      if (this.stencilZFail !== KeepStencilOp) data.stencilZFail = this.stencilZFail;
      if (this.stencilZPass !== KeepStencilOp) data.stencilZPass = this.stencilZPass;
      if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
      if (this.rotation !== void 0 && this.rotation !== 0) data.rotation = this.rotation;
      if (this.polygonOffset === true) data.polygonOffset = true;
      if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
      if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
      if (this.linewidth !== void 0 && this.linewidth !== 1) data.linewidth = this.linewidth;
      if (this.dashSize !== void 0) data.dashSize = this.dashSize;
      if (this.gapSize !== void 0) data.gapSize = this.gapSize;
      if (this.scale !== void 0) data.scale = this.scale;
      if (this.dithering === true) data.dithering = true;
      if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
      if (this.alphaHash === true) data.alphaHash = true;
      if (this.alphaToCoverage === true) data.alphaToCoverage = true;
      if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
      if (this.forceSinglePass === true) data.forceSinglePass = true;
      if (this.wireframe === true) data.wireframe = true;
      if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
      if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
      if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
      if (this.flatShading === true) data.flatShading = true;
      if (this.visible === false) data.visible = false;
      if (this.toneMapped === false) data.toneMapped = false;
      if (this.fog === false) data.fog = false;
      if (Object.keys(this.userData).length > 0) data.userData = this.userData;
      function extractFromCache(cache) {
        const values = [];
        for (const key in cache) {
          const data2 = cache[key];
          delete data2.metadata;
          values.push(data2);
        }
        return values;
      }
      if (isRootObject) {
        const textures = extractFromCache(meta.textures);
        const images = extractFromCache(meta.images);
        if (textures.length > 0) data.textures = textures;
        if (images.length > 0) data.images = images;
      }
      return data;
    }
    /**
     * Returns a new material with copied values from this instance.
     *
     * @return {Material} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given material to this instance.
     *
     * @param {Material} source - The material to copy.
     * @return {Material} A reference to this instance.
     */
    copy(source) {
      this.name = source.name;
      this.blending = source.blending;
      this.side = source.side;
      this.vertexColors = source.vertexColors;
      this.opacity = source.opacity;
      this.transparent = source.transparent;
      this.blendSrc = source.blendSrc;
      this.blendDst = source.blendDst;
      this.blendEquation = source.blendEquation;
      this.blendSrcAlpha = source.blendSrcAlpha;
      this.blendDstAlpha = source.blendDstAlpha;
      this.blendEquationAlpha = source.blendEquationAlpha;
      this.blendColor.copy(source.blendColor);
      this.blendAlpha = source.blendAlpha;
      this.depthFunc = source.depthFunc;
      this.depthTest = source.depthTest;
      this.depthWrite = source.depthWrite;
      this.stencilWriteMask = source.stencilWriteMask;
      this.stencilFunc = source.stencilFunc;
      this.stencilRef = source.stencilRef;
      this.stencilFuncMask = source.stencilFuncMask;
      this.stencilFail = source.stencilFail;
      this.stencilZFail = source.stencilZFail;
      this.stencilZPass = source.stencilZPass;
      this.stencilWrite = source.stencilWrite;
      const srcPlanes = source.clippingPlanes;
      let dstPlanes = null;
      if (srcPlanes !== null) {
        const n2 = srcPlanes.length;
        dstPlanes = new Array(n2);
        for (let i2 = 0; i2 !== n2; ++i2) {
          dstPlanes[i2] = srcPlanes[i2].clone();
        }
      }
      this.clippingPlanes = dstPlanes;
      this.clipIntersection = source.clipIntersection;
      this.clipShadows = source.clipShadows;
      this.shadowSide = source.shadowSide;
      this.colorWrite = source.colorWrite;
      this.precision = source.precision;
      this.polygonOffset = source.polygonOffset;
      this.polygonOffsetFactor = source.polygonOffsetFactor;
      this.polygonOffsetUnits = source.polygonOffsetUnits;
      this.dithering = source.dithering;
      this.alphaTest = source.alphaTest;
      this.alphaHash = source.alphaHash;
      this.alphaToCoverage = source.alphaToCoverage;
      this.premultipliedAlpha = source.premultipliedAlpha;
      this.forceSinglePass = source.forceSinglePass;
      this.visible = source.visible;
      this.toneMapped = source.toneMapped;
      this.userData = JSON.parse(JSON.stringify(source.userData));
      return this;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     *
     * @fires Material#dispose
     */
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
    /**
     * Setting this property to `true` indicates the engine the material
     * needs to be recompiled.
     *
     * @type {boolean}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      if (value === true) this.version++;
    }
  }
  class MeshBasicMaterial extends Material {
    /**
     * Constructs a new mesh basic material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isMeshBasicMaterial = true;
      this.type = "MeshBasicMaterial";
      this.color = new Color(16777215);
      this.map = null;
      this.lightMap = null;
      this.lightMapIntensity = 1;
      this.aoMap = null;
      this.aoMapIntensity = 1;
      this.specularMap = null;
      this.alphaMap = null;
      this.envMap = null;
      this.envMapRotation = new Euler();
      this.combine = MultiplyOperation;
      this.reflectivity = 1;
      this.refractionRatio = 0.98;
      this.wireframe = false;
      this.wireframeLinewidth = 1;
      this.wireframeLinecap = "round";
      this.wireframeLinejoin = "round";
      this.fog = true;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.color.copy(source.color);
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.specularMap = source.specularMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.envMapRotation.copy(source.envMapRotation);
      this.combine = source.combine;
      this.reflectivity = source.reflectivity;
      this.refractionRatio = source.refractionRatio;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.fog = source.fog;
      return this;
    }
  }
  const _vector$9 = /* @__PURE__ */ new Vector3();
  const _vector2$1 = /* @__PURE__ */ new Vector2();
  let _id$2 = 0;
  class BufferAttribute {
    /**
     * Constructs a new buffer attribute.
     *
     * @param {TypedArray} array - The array holding the attribute data.
     * @param {number} itemSize - The item size.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     */
    constructor(array, itemSize, normalized = false) {
      if (Array.isArray(array)) {
        throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
      }
      this.isBufferAttribute = true;
      Object.defineProperty(this, "id", { value: _id$2++ });
      this.name = "";
      this.array = array;
      this.itemSize = itemSize;
      this.count = array !== void 0 ? array.length / itemSize : 0;
      this.normalized = normalized;
      this.usage = StaticDrawUsage;
      this.updateRanges = [];
      this.gpuType = FloatType;
      this.version = 0;
    }
    /**
     * A callback function that is executed after the renderer has transferred the attribute
     * array data to the GPU.
     */
    onUploadCallback() {
    }
    /**
     * Flag to indicate that this attribute has changed and should be re-sent to
     * the GPU. Set this to `true` when you modify the value of the array.
     *
     * @type {number}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      if (value === true) this.version++;
    }
    /**
     * Sets the usage of this buffer attribute.
     *
     * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
     * @return {BufferAttribute} A reference to this buffer attribute.
     */
    setUsage(value) {
      this.usage = value;
      return this;
    }
    /**
     * Adds a range of data in the data array to be updated on the GPU.
     *
     * @param {number} start - Position at which to start update.
     * @param {number} count - The number of components to update.
     */
    addUpdateRange(start, count) {
      this.updateRanges.push({ start, count });
    }
    /**
     * Clears the update ranges.
     */
    clearUpdateRanges() {
      this.updateRanges.length = 0;
    }
    /**
     * Copies the values of the given buffer attribute to this instance.
     *
     * @param {BufferAttribute} source - The buffer attribute to copy.
     * @return {BufferAttribute} A reference to this instance.
     */
    copy(source) {
      this.name = source.name;
      this.array = new source.array.constructor(source.array);
      this.itemSize = source.itemSize;
      this.count = source.count;
      this.normalized = source.normalized;
      this.usage = source.usage;
      this.gpuType = source.gpuType;
      return this;
    }
    /**
     * Copies a vector from the given buffer attribute to this one. The start
     * and destination position in the attribute buffers are represented by the
     * given indices.
     *
     * @param {number} index1 - The destination index into this buffer attribute.
     * @param {BufferAttribute} attribute - The buffer attribute to copy from.
     * @param {number} index2 - The source index into the given buffer attribute.
     * @return {BufferAttribute} A reference to this instance.
     */
    copyAt(index1, attribute, index2) {
      index1 *= this.itemSize;
      index2 *= attribute.itemSize;
      for (let i2 = 0, l2 = this.itemSize; i2 < l2; i2++) {
        this.array[index1 + i2] = attribute.array[index2 + i2];
      }
      return this;
    }
    /**
     * Copies the given array data into this buffer attribute.
     *
     * @param {(TypedArray|Array)} array - The array to copy.
     * @return {BufferAttribute} A reference to this instance.
     */
    copyArray(array) {
      this.array.set(array);
      return this;
    }
    /**
     * Applies the given 3x3 matrix to the given attribute. Works with
     * item size `2` and `3`.
     *
     * @param {Matrix3} m - The matrix to apply.
     * @return {BufferAttribute} A reference to this instance.
     */
    applyMatrix3(m) {
      if (this.itemSize === 2) {
        for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
          _vector2$1.fromBufferAttribute(this, i2);
          _vector2$1.applyMatrix3(m);
          this.setXY(i2, _vector2$1.x, _vector2$1.y);
        }
      } else if (this.itemSize === 3) {
        for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
          _vector$9.fromBufferAttribute(this, i2);
          _vector$9.applyMatrix3(m);
          this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
        }
      }
      return this;
    }
    /**
     * Applies the given 4x4 matrix to the given attribute. Only works with
     * item size `3`.
     *
     * @param {Matrix4} m - The matrix to apply.
     * @return {BufferAttribute} A reference to this instance.
     */
    applyMatrix4(m) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.applyMatrix4(m);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
      return this;
    }
    /**
     * Applies the given 3x3 normal matrix to the given attribute. Only works with
     * item size `3`.
     *
     * @param {Matrix3} m - The normal matrix to apply.
     * @return {BufferAttribute} A reference to this instance.
     */
    applyNormalMatrix(m) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.applyNormalMatrix(m);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
      return this;
    }
    /**
     * Applies the given 4x4 matrix to the given attribute. Only works with
     * item size `3` and with direction vectors.
     *
     * @param {Matrix4} m - The matrix to apply.
     * @return {BufferAttribute} A reference to this instance.
     */
    transformDirection(m) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.transformDirection(m);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
      return this;
    }
    /**
     * Sets the given array data in the buffer attribute.
     *
     * @param {(TypedArray|Array)} value - The array data to set.
     * @param {number} [offset=0] - The offset in this buffer attribute's array.
     * @return {BufferAttribute} A reference to this instance.
     */
    set(value, offset = 0) {
      this.array.set(value, offset);
      return this;
    }
    /**
     * Returns the given component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} component - The component index.
     * @return {number} The returned value.
     */
    getComponent(index, component) {
      let value = this.array[index * this.itemSize + component];
      if (this.normalized) value = denormalize(value, this.array);
      return value;
    }
    /**
     * Sets the given value to the given component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} component - The component index.
     * @param {number} value - The value to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setComponent(index, component, value) {
      if (this.normalized) value = normalize(value, this.array);
      this.array[index * this.itemSize + component] = value;
      return this;
    }
    /**
     * Returns the x component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The x component.
     */
    getX(index) {
      let x2 = this.array[index * this.itemSize];
      if (this.normalized) x2 = denormalize(x2, this.array);
      return x2;
    }
    /**
     * Sets the x component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setX(index, x2) {
      if (this.normalized) x2 = normalize(x2, this.array);
      this.array[index * this.itemSize] = x2;
      return this;
    }
    /**
     * Returns the y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The y component.
     */
    getY(index) {
      let y2 = this.array[index * this.itemSize + 1];
      if (this.normalized) y2 = denormalize(y2, this.array);
      return y2;
    }
    /**
     * Sets the y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} y - The value to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setY(index, y2) {
      if (this.normalized) y2 = normalize(y2, this.array);
      this.array[index * this.itemSize + 1] = y2;
      return this;
    }
    /**
     * Returns the z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The z component.
     */
    getZ(index) {
      let z2 = this.array[index * this.itemSize + 2];
      if (this.normalized) z2 = denormalize(z2, this.array);
      return z2;
    }
    /**
     * Sets the z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} z - The value to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setZ(index, z2) {
      if (this.normalized) z2 = normalize(z2, this.array);
      this.array[index * this.itemSize + 2] = z2;
      return this;
    }
    /**
     * Returns the w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The w component.
     */
    getW(index) {
      let w2 = this.array[index * this.itemSize + 3];
      if (this.normalized) w2 = denormalize(w2, this.array);
      return w2;
    }
    /**
     * Sets the w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} w - The value to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setW(index, w2) {
      if (this.normalized) w2 = normalize(w2, this.array);
      this.array[index * this.itemSize + 3] = w2;
      return this;
    }
    /**
     * Sets the x and y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setXY(index, x2, y2) {
      index *= this.itemSize;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
      }
      this.array[index + 0] = x2;
      this.array[index + 1] = y2;
      return this;
    }
    /**
     * Sets the x, y and z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @param {number} z - The value for the z component to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setXYZ(index, x2, y2, z2) {
      index *= this.itemSize;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
        z2 = normalize(z2, this.array);
      }
      this.array[index + 0] = x2;
      this.array[index + 1] = y2;
      this.array[index + 2] = z2;
      return this;
    }
    /**
     * Sets the x, y, z and w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @param {number} z - The value for the z component to set.
     * @param {number} w - The value for the w component to set.
     * @return {BufferAttribute} A reference to this instance.
     */
    setXYZW(index, x2, y2, z2, w2) {
      index *= this.itemSize;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
        z2 = normalize(z2, this.array);
        w2 = normalize(w2, this.array);
      }
      this.array[index + 0] = x2;
      this.array[index + 1] = y2;
      this.array[index + 2] = z2;
      this.array[index + 3] = w2;
      return this;
    }
    /**
     * Sets the given callback function that is executed after the Renderer has transferred
     * the attribute array data to the GPU. Can be used to perform clean-up operations after
     * the upload when attribute data are not needed anymore on the CPU side.
     *
     * @param {Function} callback - The `onUpload()` callback.
     * @return {BufferAttribute} A reference to this instance.
     */
    onUpload(callback) {
      this.onUploadCallback = callback;
      return this;
    }
    /**
     * Returns a new buffer attribute with copied values from this instance.
     *
     * @return {BufferAttribute} A clone of this instance.
     */
    clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
     * Serializes the buffer attribute into JSON.
     *
     * @return {Object} A JSON object representing the serialized buffer attribute.
     */
    toJSON() {
      const data = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.from(this.array),
        normalized: this.normalized
      };
      if (this.name !== "") data.name = this.name;
      if (this.usage !== StaticDrawUsage) data.usage = this.usage;
      return data;
    }
  }
  class Uint16BufferAttribute extends BufferAttribute {
    /**
     * Constructs a new buffer attribute.
     *
     * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
     * @param {number} itemSize - The item size.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     */
    constructor(array, itemSize, normalized) {
      super(new Uint16Array(array), itemSize, normalized);
    }
  }
  class Uint32BufferAttribute extends BufferAttribute {
    /**
     * Constructs a new buffer attribute.
     *
     * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
     * @param {number} itemSize - The item size.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     */
    constructor(array, itemSize, normalized) {
      super(new Uint32Array(array), itemSize, normalized);
    }
  }
  class Float32BufferAttribute extends BufferAttribute {
    /**
     * Constructs a new buffer attribute.
     *
     * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
     * @param {number} itemSize - The item size.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     */
    constructor(array, itemSize, normalized) {
      super(new Float32Array(array), itemSize, normalized);
    }
  }
  let _id$1 = 0;
  const _m1$3 = /* @__PURE__ */ new Matrix4();
  const _obj = /* @__PURE__ */ new Object3D();
  const _offset = /* @__PURE__ */ new Vector3();
  const _box$2 = /* @__PURE__ */ new Box3();
  const _boxMorphTargets = /* @__PURE__ */ new Box3();
  const _vector$8 = /* @__PURE__ */ new Vector3();
  class BufferGeometry extends EventDispatcher {
    /**
     * Constructs a new geometry.
     */
    constructor() {
      super();
      this.isBufferGeometry = true;
      Object.defineProperty(this, "id", { value: _id$1++ });
      this.uuid = generateUUID();
      this.name = "";
      this.type = "BufferGeometry";
      this.index = null;
      this.indirect = null;
      this.attributes = {};
      this.morphAttributes = {};
      this.morphTargetsRelative = false;
      this.groups = [];
      this.boundingBox = null;
      this.boundingSphere = null;
      this.drawRange = { start: 0, count: Infinity };
      this.userData = {};
    }
    /**
     * Returns the index of this geometry.
     *
     * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
     */
    getIndex() {
      return this.index;
    }
    /**
     * Sets the given index to this geometry.
     *
     * @param {Array<number>|BufferAttribute} index - The index to set.
     * @return {BufferGeometry} A reference to this instance.
     */
    setIndex(index) {
      if (Array.isArray(index)) {
        this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
      } else {
        this.index = index;
      }
      return this;
    }
    /**
     * Sets the given indirect attribute to this geometry.
     *
     * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
     * @return {BufferGeometry} A reference to this instance.
     */
    setIndirect(indirect) {
      this.indirect = indirect;
      return this;
    }
    /**
     * Returns the indirect attribute of this geometry.
     *
     * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
     */
    getIndirect() {
      return this.indirect;
    }
    /**
     * Returns the buffer attribute for the given name.
     *
     * @param {string} name - The attribute name.
     * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
     * Returns `undefined` if not attribute has been found.
     */
    getAttribute(name) {
      return this.attributes[name];
    }
    /**
     * Sets the given attribute for the given name.
     *
     * @param {string} name - The attribute name.
     * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
     * @return {BufferGeometry} A reference to this instance.
     */
    setAttribute(name, attribute) {
      this.attributes[name] = attribute;
      return this;
    }
    /**
     * Deletes the attribute for the given name.
     *
     * @param {string} name - The attribute name to delete.
     * @return {BufferGeometry} A reference to this instance.
     */
    deleteAttribute(name) {
      delete this.attributes[name];
      return this;
    }
    /**
     * Returns `true` if this geometry has an attribute for the given name.
     *
     * @param {string} name - The attribute name.
     * @return {boolean} Whether this geometry has an attribute for the given name or not.
     */
    hasAttribute(name) {
      return this.attributes[name] !== void 0;
    }
    /**
     * Adds a group to this geometry.
     *
     * @param {number} start - The first element in this draw call. That is the first
     * vertex for non-indexed geometry, otherwise the first triangle index.
     * @param {number} count - Specifies how many vertices (or indices) are part of this group.
     * @param {number} [materialIndex=0] - The material array index to use.
     */
    addGroup(start, count, materialIndex = 0) {
      this.groups.push({
        start,
        count,
        materialIndex
      });
    }
    /**
     * Clears all groups.
     */
    clearGroups() {
      this.groups = [];
    }
    /**
     * Sets the draw range for this geometry.
     *
     * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
     * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
     * For indexed BufferGeometry, `count` is the number of indices to render.
     */
    setDrawRange(start, count) {
      this.drawRange.start = start;
      this.drawRange.count = count;
    }
    /**
     * Applies the given 4x4 transformation matrix to the geometry.
     *
     * @param {Matrix4} matrix - The matrix to apply.
     * @return {BufferGeometry} A reference to this instance.
     */
    applyMatrix4(matrix) {
      const position = this.attributes.position;
      if (position !== void 0) {
        position.applyMatrix4(matrix);
        position.needsUpdate = true;
      }
      const normal = this.attributes.normal;
      if (normal !== void 0) {
        const normalMatrix = new Matrix3().getNormalMatrix(matrix);
        normal.applyNormalMatrix(normalMatrix);
        normal.needsUpdate = true;
      }
      const tangent = this.attributes.tangent;
      if (tangent !== void 0) {
        tangent.transformDirection(matrix);
        tangent.needsUpdate = true;
      }
      if (this.boundingBox !== null) {
        this.computeBoundingBox();
      }
      if (this.boundingSphere !== null) {
        this.computeBoundingSphere();
      }
      return this;
    }
    /**
     * Applies the rotation represented by the Quaternion to the geometry.
     *
     * @param {Quaternion} q - The Quaternion to apply.
     * @return {BufferGeometry} A reference to this instance.
     */
    applyQuaternion(q2) {
      _m1$3.makeRotationFromQuaternion(q2);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Rotates the geometry about the X axis. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#rotation} for typical
     * real-time mesh rotation.
     *
     * @param {number} angle - The angle in radians.
     * @return {BufferGeometry} A reference to this instance.
     */
    rotateX(angle) {
      _m1$3.makeRotationX(angle);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Rotates the geometry about the Y axis. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#rotation} for typical
     * real-time mesh rotation.
     *
     * @param {number} angle - The angle in radians.
     * @return {BufferGeometry} A reference to this instance.
     */
    rotateY(angle) {
      _m1$3.makeRotationY(angle);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Rotates the geometry about the Z axis. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#rotation} for typical
     * real-time mesh rotation.
     *
     * @param {number} angle - The angle in radians.
     * @return {BufferGeometry} A reference to this instance.
     */
    rotateZ(angle) {
      _m1$3.makeRotationZ(angle);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Translates the geometry. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#position} for typical
     * real-time mesh rotation.
     *
     * @param {number} x - The x offset.
     * @param {number} y - The y offset.
     * @param {number} z - The z offset.
     * @return {BufferGeometry} A reference to this instance.
     */
    translate(x2, y2, z2) {
      _m1$3.makeTranslation(x2, y2, z2);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Scales the geometry. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#scale} for typical
     * real-time mesh rotation.
     *
     * @param {number} x - The x scale.
     * @param {number} y - The y scale.
     * @param {number} z - The z scale.
     * @return {BufferGeometry} A reference to this instance.
     */
    scale(x2, y2, z2) {
      _m1$3.makeScale(x2, y2, z2);
      this.applyMatrix4(_m1$3);
      return this;
    }
    /**
     * Rotates the geometry to face a point in 3D space. This is typically done as a one time
     * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
     * real-time mesh rotation.
     *
     * @param {Vector3} vector - The target point.
     * @return {BufferGeometry} A reference to this instance.
     */
    lookAt(vector) {
      _obj.lookAt(vector);
      _obj.updateMatrix();
      this.applyMatrix4(_obj.matrix);
      return this;
    }
    /**
     * Center the geometry based on its bounding box.
     *
     * @return {BufferGeometry} A reference to this instance.
     */
    center() {
      this.computeBoundingBox();
      this.boundingBox.getCenter(_offset).negate();
      this.translate(_offset.x, _offset.y, _offset.z);
      return this;
    }
    /**
     * Defines a geometry by creating a `position` attribute based on the given array of points. The array
     * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
     * set to `0`.
     *
     * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
     * data from the array. The length of the array must match the vertex count.
     *
     * @param {Array<Vector2>|Array<Vector3>} points - The points.
     * @return {BufferGeometry} A reference to this instance.
     */
    setFromPoints(points) {
      const positionAttribute = this.getAttribute("position");
      if (positionAttribute === void 0) {
        const position = [];
        for (let i2 = 0, l2 = points.length; i2 < l2; i2++) {
          const point = points[i2];
          position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new Float32BufferAttribute(position, 3));
      } else {
        const l2 = Math.min(points.length, positionAttribute.count);
        for (let i2 = 0; i2 < l2; i2++) {
          const point = points[i2];
          positionAttribute.setXYZ(i2, point.x, point.y, point.z || 0);
        }
        if (points.length > positionAttribute.count) {
          console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.");
        }
        positionAttribute.needsUpdate = true;
      }
      return this;
    }
    /**
     * Computes the bounding box of the geometry, and updates the `boundingBox` member.
     * The bounding box is not computed by the engine; it must be computed by your app.
     * You may need to recompute the bounding box if the geometry vertices are modified.
     */
    computeBoundingBox() {
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }
      const position = this.attributes.position;
      const morphAttributesPosition = this.morphAttributes.position;
      if (position && position.isGLBufferAttribute) {
        console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this);
        this.boundingBox.set(
          new Vector3(-Infinity, -Infinity, -Infinity),
          new Vector3(Infinity, Infinity, Infinity)
        );
        return;
      }
      if (position !== void 0) {
        this.boundingBox.setFromBufferAttribute(position);
        if (morphAttributesPosition) {
          for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
            const morphAttribute = morphAttributesPosition[i2];
            _box$2.setFromBufferAttribute(morphAttribute);
            if (this.morphTargetsRelative) {
              _vector$8.addVectors(this.boundingBox.min, _box$2.min);
              this.boundingBox.expandByPoint(_vector$8);
              _vector$8.addVectors(this.boundingBox.max, _box$2.max);
              this.boundingBox.expandByPoint(_vector$8);
            } else {
              this.boundingBox.expandByPoint(_box$2.min);
              this.boundingBox.expandByPoint(_box$2.max);
            }
          }
        }
      } else {
        this.boundingBox.makeEmpty();
      }
      if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
        console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
      }
    }
    /**
     * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
     * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
     * You may need to recompute the bounding sphere if the geometry vertices are modified.
     */
    computeBoundingSphere() {
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }
      const position = this.attributes.position;
      const morphAttributesPosition = this.morphAttributes.position;
      if (position && position.isGLBufferAttribute) {
        console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this);
        this.boundingSphere.set(new Vector3(), Infinity);
        return;
      }
      if (position) {
        const center = this.boundingSphere.center;
        _box$2.setFromBufferAttribute(position);
        if (morphAttributesPosition) {
          for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
            const morphAttribute = morphAttributesPosition[i2];
            _boxMorphTargets.setFromBufferAttribute(morphAttribute);
            if (this.morphTargetsRelative) {
              _vector$8.addVectors(_box$2.min, _boxMorphTargets.min);
              _box$2.expandByPoint(_vector$8);
              _vector$8.addVectors(_box$2.max, _boxMorphTargets.max);
              _box$2.expandByPoint(_vector$8);
            } else {
              _box$2.expandByPoint(_boxMorphTargets.min);
              _box$2.expandByPoint(_boxMorphTargets.max);
            }
          }
        }
        _box$2.getCenter(center);
        let maxRadiusSq = 0;
        for (let i2 = 0, il = position.count; i2 < il; i2++) {
          _vector$8.fromBufferAttribute(position, i2);
          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
        }
        if (morphAttributesPosition) {
          for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
            const morphAttribute = morphAttributesPosition[i2];
            const morphTargetsRelative = this.morphTargetsRelative;
            for (let j2 = 0, jl = morphAttribute.count; j2 < jl; j2++) {
              _vector$8.fromBufferAttribute(morphAttribute, j2);
              if (morphTargetsRelative) {
                _offset.fromBufferAttribute(position, j2);
                _vector$8.add(_offset);
              }
              maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
            }
          }
        }
        this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
        if (isNaN(this.boundingSphere.radius)) {
          console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
      }
    }
    /**
     * Calculates and adds a tangent attribute to this geometry.
     *
     * The computation is only supported for indexed geometries and if position, normal, and uv attributes
     * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
     * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
     */
    computeTangents() {
      const index = this.index;
      const attributes = this.attributes;
      if (index === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
        console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        return;
      }
      const positionAttribute = attributes.position;
      const normalAttribute = attributes.normal;
      const uvAttribute = attributes.uv;
      if (this.hasAttribute("tangent") === false) {
        this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * positionAttribute.count), 4));
      }
      const tangentAttribute = this.getAttribute("tangent");
      const tan1 = [], tan2 = [];
      for (let i2 = 0; i2 < positionAttribute.count; i2++) {
        tan1[i2] = new Vector3();
        tan2[i2] = new Vector3();
      }
      const vA = new Vector3(), vB = new Vector3(), vC = new Vector3(), uvA = new Vector2(), uvB = new Vector2(), uvC = new Vector2(), sdir = new Vector3(), tdir = new Vector3();
      function handleTriangle(a2, b2, c2) {
        vA.fromBufferAttribute(positionAttribute, a2);
        vB.fromBufferAttribute(positionAttribute, b2);
        vC.fromBufferAttribute(positionAttribute, c2);
        uvA.fromBufferAttribute(uvAttribute, a2);
        uvB.fromBufferAttribute(uvAttribute, b2);
        uvC.fromBufferAttribute(uvAttribute, c2);
        vB.sub(vA);
        vC.sub(vA);
        uvB.sub(uvA);
        uvC.sub(uvA);
        const r2 = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
        if (!isFinite(r2)) return;
        sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r2);
        tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r2);
        tan1[a2].add(sdir);
        tan1[b2].add(sdir);
        tan1[c2].add(sdir);
        tan2[a2].add(tdir);
        tan2[b2].add(tdir);
        tan2[c2].add(tdir);
      }
      let groups = this.groups;
      if (groups.length === 0) {
        groups = [{
          start: 0,
          count: index.count
        }];
      }
      for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
        const group = groups[i2];
        const start = group.start;
        const count = group.count;
        for (let j2 = start, jl = start + count; j2 < jl; j2 += 3) {
          handleTriangle(
            index.getX(j2 + 0),
            index.getX(j2 + 1),
            index.getX(j2 + 2)
          );
        }
      }
      const tmp2 = new Vector3(), tmp22 = new Vector3();
      const n2 = new Vector3(), n22 = new Vector3();
      function handleVertex(v2) {
        n2.fromBufferAttribute(normalAttribute, v2);
        n22.copy(n2);
        const t2 = tan1[v2];
        tmp2.copy(t2);
        tmp2.sub(n2.multiplyScalar(n2.dot(t2))).normalize();
        tmp22.crossVectors(n22, t2);
        const test = tmp22.dot(tan2[v2]);
        const w2 = test < 0 ? -1 : 1;
        tangentAttribute.setXYZW(v2, tmp2.x, tmp2.y, tmp2.z, w2);
      }
      for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
        const group = groups[i2];
        const start = group.start;
        const count = group.count;
        for (let j2 = start, jl = start + count; j2 < jl; j2 += 3) {
          handleVertex(index.getX(j2 + 0));
          handleVertex(index.getX(j2 + 1));
          handleVertex(index.getX(j2 + 2));
        }
      }
    }
    /**
     * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
     * each vertex normal to be the average of the face normals of the faces that share that vertex.
     * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
     * to be the same as the face normal.
     */
    computeVertexNormals() {
      const index = this.index;
      const positionAttribute = this.getAttribute("position");
      if (positionAttribute !== void 0) {
        let normalAttribute = this.getAttribute("normal");
        if (normalAttribute === void 0) {
          normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
          this.setAttribute("normal", normalAttribute);
        } else {
          for (let i2 = 0, il = normalAttribute.count; i2 < il; i2++) {
            normalAttribute.setXYZ(i2, 0, 0, 0);
          }
        }
        const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
        const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
        const cb = new Vector3(), ab = new Vector3();
        if (index) {
          for (let i2 = 0, il = index.count; i2 < il; i2 += 3) {
            const vA = index.getX(i2 + 0);
            const vB = index.getX(i2 + 1);
            const vC = index.getX(i2 + 2);
            pA.fromBufferAttribute(positionAttribute, vA);
            pB.fromBufferAttribute(positionAttribute, vB);
            pC.fromBufferAttribute(positionAttribute, vC);
            cb.subVectors(pC, pB);
            ab.subVectors(pA, pB);
            cb.cross(ab);
            nA.fromBufferAttribute(normalAttribute, vA);
            nB.fromBufferAttribute(normalAttribute, vB);
            nC.fromBufferAttribute(normalAttribute, vC);
            nA.add(cb);
            nB.add(cb);
            nC.add(cb);
            normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
            normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
            normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
          }
        } else {
          for (let i2 = 0, il = positionAttribute.count; i2 < il; i2 += 3) {
            pA.fromBufferAttribute(positionAttribute, i2 + 0);
            pB.fromBufferAttribute(positionAttribute, i2 + 1);
            pC.fromBufferAttribute(positionAttribute, i2 + 2);
            cb.subVectors(pC, pB);
            ab.subVectors(pA, pB);
            cb.cross(ab);
            normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
            normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
            normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
          }
        }
        this.normalizeNormals();
        normalAttribute.needsUpdate = true;
      }
    }
    /**
     * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
     * correct lighting on the geometry surfaces.
     */
    normalizeNormals() {
      const normals = this.attributes.normal;
      for (let i2 = 0, il = normals.count; i2 < il; i2++) {
        _vector$8.fromBufferAttribute(normals, i2);
        _vector$8.normalize();
        normals.setXYZ(i2, _vector$8.x, _vector$8.y, _vector$8.z);
      }
    }
    /**
     * Return a new non-index version of this indexed geometry. If the geometry
     * is already non-indexed, the method is a NOOP.
     *
     * @return {BufferGeometry} The non-indexed version of this indexed geometry.
     */
    toNonIndexed() {
      function convertBufferAttribute(attribute, indices2) {
        const array = attribute.array;
        const itemSize = attribute.itemSize;
        const normalized = attribute.normalized;
        const array2 = new array.constructor(indices2.length * itemSize);
        let index = 0, index2 = 0;
        for (let i2 = 0, l2 = indices2.length; i2 < l2; i2++) {
          if (attribute.isInterleavedBufferAttribute) {
            index = indices2[i2] * attribute.data.stride + attribute.offset;
          } else {
            index = indices2[i2] * itemSize;
          }
          for (let j2 = 0; j2 < itemSize; j2++) {
            array2[index2++] = array[index++];
          }
        }
        return new BufferAttribute(array2, itemSize, normalized);
      }
      if (this.index === null) {
        console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
        return this;
      }
      const geometry2 = new BufferGeometry();
      const indices = this.index.array;
      const attributes = this.attributes;
      for (const name in attributes) {
        const attribute = attributes[name];
        const newAttribute = convertBufferAttribute(attribute, indices);
        geometry2.setAttribute(name, newAttribute);
      }
      const morphAttributes = this.morphAttributes;
      for (const name in morphAttributes) {
        const morphArray = [];
        const morphAttribute = morphAttributes[name];
        for (let i2 = 0, il = morphAttribute.length; i2 < il; i2++) {
          const attribute = morphAttribute[i2];
          const newAttribute = convertBufferAttribute(attribute, indices);
          morphArray.push(newAttribute);
        }
        geometry2.morphAttributes[name] = morphArray;
      }
      geometry2.morphTargetsRelative = this.morphTargetsRelative;
      const groups = this.groups;
      for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
        const group = groups[i2];
        geometry2.addGroup(group.start, group.count, group.materialIndex);
      }
      return geometry2;
    }
    /**
     * Serializes the geometry into JSON.
     *
     * @return {Object} A JSON object representing the serialized geometry.
     */
    toJSON() {
      const data = {
        metadata: {
          version: 4.7,
          type: "BufferGeometry",
          generator: "BufferGeometry.toJSON"
        }
      };
      data.uuid = this.uuid;
      data.type = this.type;
      if (this.name !== "") data.name = this.name;
      if (Object.keys(this.userData).length > 0) data.userData = this.userData;
      if (this.parameters !== void 0) {
        const parameters = this.parameters;
        for (const key in parameters) {
          if (parameters[key] !== void 0) data[key] = parameters[key];
        }
        return data;
      }
      data.data = { attributes: {} };
      const index = this.index;
      if (index !== null) {
        data.data.index = {
          type: index.array.constructor.name,
          array: Array.prototype.slice.call(index.array)
        };
      }
      const attributes = this.attributes;
      for (const key in attributes) {
        const attribute = attributes[key];
        data.data.attributes[key] = attribute.toJSON(data.data);
      }
      const morphAttributes = {};
      let hasMorphAttributes = false;
      for (const key in this.morphAttributes) {
        const attributeArray = this.morphAttributes[key];
        const array = [];
        for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
          const attribute = attributeArray[i2];
          array.push(attribute.toJSON(data.data));
        }
        if (array.length > 0) {
          morphAttributes[key] = array;
          hasMorphAttributes = true;
        }
      }
      if (hasMorphAttributes) {
        data.data.morphAttributes = morphAttributes;
        data.data.morphTargetsRelative = this.morphTargetsRelative;
      }
      const groups = this.groups;
      if (groups.length > 0) {
        data.data.groups = JSON.parse(JSON.stringify(groups));
      }
      const boundingSphere = this.boundingSphere;
      if (boundingSphere !== null) {
        data.data.boundingSphere = boundingSphere.toJSON();
      }
      return data;
    }
    /**
     * Returns a new geometry with copied values from this instance.
     *
     * @return {BufferGeometry} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given geometry to this instance.
     *
     * @param {BufferGeometry} source - The geometry to copy.
     * @return {BufferGeometry} A reference to this instance.
     */
    copy(source) {
      this.index = null;
      this.attributes = {};
      this.morphAttributes = {};
      this.groups = [];
      this.boundingBox = null;
      this.boundingSphere = null;
      const data = {};
      this.name = source.name;
      const index = source.index;
      if (index !== null) {
        this.setIndex(index.clone());
      }
      const attributes = source.attributes;
      for (const name in attributes) {
        const attribute = attributes[name];
        this.setAttribute(name, attribute.clone(data));
      }
      const morphAttributes = source.morphAttributes;
      for (const name in morphAttributes) {
        const array = [];
        const morphAttribute = morphAttributes[name];
        for (let i2 = 0, l2 = morphAttribute.length; i2 < l2; i2++) {
          array.push(morphAttribute[i2].clone(data));
        }
        this.morphAttributes[name] = array;
      }
      this.morphTargetsRelative = source.morphTargetsRelative;
      const groups = source.groups;
      for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
        const group = groups[i2];
        this.addGroup(group.start, group.count, group.materialIndex);
      }
      const boundingBox = source.boundingBox;
      if (boundingBox !== null) {
        this.boundingBox = boundingBox.clone();
      }
      const boundingSphere = source.boundingSphere;
      if (boundingSphere !== null) {
        this.boundingSphere = boundingSphere.clone();
      }
      this.drawRange.start = source.drawRange.start;
      this.drawRange.count = source.drawRange.count;
      this.userData = source.userData;
      return this;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     *
     * @fires BufferGeometry#dispose
     */
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
  }
  const _inverseMatrix$3 = /* @__PURE__ */ new Matrix4();
  const _ray$3 = /* @__PURE__ */ new Ray();
  const _sphere$6 = /* @__PURE__ */ new Sphere();
  const _sphereHitAt = /* @__PURE__ */ new Vector3();
  const _vA$1 = /* @__PURE__ */ new Vector3();
  const _vB$1 = /* @__PURE__ */ new Vector3();
  const _vC$1 = /* @__PURE__ */ new Vector3();
  const _tempA = /* @__PURE__ */ new Vector3();
  const _morphA = /* @__PURE__ */ new Vector3();
  const _intersectionPoint = /* @__PURE__ */ new Vector3();
  const _intersectionPointWorld = /* @__PURE__ */ new Vector3();
  class Mesh extends Object3D {
    /**
     * Constructs a new mesh.
     *
     * @param {BufferGeometry} [geometry] - The mesh geometry.
     * @param {Material|Array<Material>} [material] - The mesh material.
     */
    constructor(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
      super();
      this.isMesh = true;
      this.type = "Mesh";
      this.geometry = geometry;
      this.material = material;
      this.morphTargetDictionary = void 0;
      this.morphTargetInfluences = void 0;
      this.count = 1;
      this.updateMorphTargets();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      if (source.morphTargetInfluences !== void 0) {
        this.morphTargetInfluences = source.morphTargetInfluences.slice();
      }
      if (source.morphTargetDictionary !== void 0) {
        this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
      }
      this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
      this.geometry = source.geometry;
      return this;
    }
    /**
     * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
     * to make sure existing morph targets can influence this 3D object.
     */
    updateMorphTargets() {
      const geometry = this.geometry;
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    }
    /**
     * Returns the local-space position of the vertex at the given index, taking into
     * account the current animation state of both morph targets and skinning.
     *
     * @param {number} index - The vertex index.
     * @param {Vector3} target - The target object that is used to store the method's result.
     * @return {Vector3} The vertex position in local space.
     */
    getVertexPosition(index, target) {
      const geometry = this.geometry;
      const position = geometry.attributes.position;
      const morphPosition = geometry.morphAttributes.position;
      const morphTargetsRelative = geometry.morphTargetsRelative;
      target.fromBufferAttribute(position, index);
      const morphInfluences = this.morphTargetInfluences;
      if (morphPosition && morphInfluences) {
        _morphA.set(0, 0, 0);
        for (let i2 = 0, il = morphPosition.length; i2 < il; i2++) {
          const influence = morphInfluences[i2];
          const morphAttribute = morphPosition[i2];
          if (influence === 0) continue;
          _tempA.fromBufferAttribute(morphAttribute, index);
          if (morphTargetsRelative) {
            _morphA.addScaledVector(_tempA, influence);
          } else {
            _morphA.addScaledVector(_tempA.sub(target), influence);
          }
        }
        target.add(_morphA);
      }
      return target;
    }
    /**
     * Computes intersection points between a casted ray and this line.
     *
     * @param {Raycaster} raycaster - The raycaster.
     * @param {Array<Object>} intersects - The target array that holds the intersection points.
     */
    raycast(raycaster, intersects2) {
      const geometry = this.geometry;
      const material = this.material;
      const matrixWorld = this.matrixWorld;
      if (material === void 0) return;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
      _sphere$6.copy(geometry.boundingSphere);
      _sphere$6.applyMatrix4(matrixWorld);
      _ray$3.copy(raycaster.ray).recast(raycaster.near);
      if (_sphere$6.containsPoint(_ray$3.origin) === false) {
        if (_ray$3.intersectSphere(_sphere$6, _sphereHitAt) === null) return;
        if (_ray$3.origin.distanceToSquared(_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
      }
      _inverseMatrix$3.copy(matrixWorld).invert();
      _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix$3);
      if (geometry.boundingBox !== null) {
        if (_ray$3.intersectsBox(geometry.boundingBox) === false) return;
      }
      this._computeIntersections(raycaster, intersects2, _ray$3);
    }
    _computeIntersections(raycaster, intersects2, rayLocalSpace) {
      let intersection;
      const geometry = this.geometry;
      const material = this.material;
      const index = geometry.index;
      const position = geometry.attributes.position;
      const uv = geometry.attributes.uv;
      const uv1 = geometry.attributes.uv1;
      const normal = geometry.attributes.normal;
      const groups = geometry.groups;
      const drawRange = geometry.drawRange;
      if (index !== null) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
            for (let j2 = start, jl = end; j2 < jl; j2 += 3) {
              const a2 = index.getX(j2);
              const b2 = index.getX(j2 + 1);
              const c2 = index.getX(j2 + 2);
              intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
              if (intersection) {
                intersection.faceIndex = Math.floor(j2 / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(index.count, drawRange.start + drawRange.count);
          for (let i2 = start, il = end; i2 < il; i2 += 3) {
            const a2 = index.getX(i2);
            const b2 = index.getX(i2 + 1);
            const c2 = index.getX(i2 + 2);
            intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(i2 / 3);
              intersects2.push(intersection);
            }
          }
        }
      } else if (position !== void 0) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start = Math.max(group.start, drawRange.start);
            const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
            for (let j2 = start, jl = end; j2 < jl; j2 += 3) {
              const a2 = j2;
              const b2 = j2 + 1;
              const c2 = j2 + 2;
              intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
              if (intersection) {
                intersection.faceIndex = Math.floor(j2 / 3);
                intersection.face.materialIndex = group.materialIndex;
                intersects2.push(intersection);
              }
            }
          }
        } else {
          const start = Math.max(0, drawRange.start);
          const end = Math.min(position.count, drawRange.start + drawRange.count);
          for (let i2 = start, il = end; i2 < il; i2 += 3) {
            const a2 = i2;
            const b2 = i2 + 1;
            const c2 = i2 + 2;
            intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
            if (intersection) {
              intersection.faceIndex = Math.floor(i2 / 3);
              intersects2.push(intersection);
            }
          }
        }
      }
    }
  }
  function checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect2;
    if (material.side === BackSide) {
      intersect2 = ray.intersectTriangle(pC, pB, pA, true, point);
    } else {
      intersect2 = ray.intersectTriangle(pA, pB, pC, material.side === FrontSide, point);
    }
    if (intersect2 === null) return null;
    _intersectionPointWorld.copy(point);
    _intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
      distance,
      point: _intersectionPointWorld.clone(),
      object
    };
  }
  function checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a2, b2, c2) {
    object.getVertexPosition(a2, _vA$1);
    object.getVertexPosition(b2, _vB$1);
    object.getVertexPosition(c2, _vC$1);
    const intersection = checkIntersection$1(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
    if (intersection) {
      const barycoord = new Vector3();
      Triangle.getBarycoord(_intersectionPoint, _vA$1, _vB$1, _vC$1, barycoord);
      if (uv) {
        intersection.uv = Triangle.getInterpolatedAttribute(uv, a2, b2, c2, barycoord, new Vector2());
      }
      if (uv1) {
        intersection.uv1 = Triangle.getInterpolatedAttribute(uv1, a2, b2, c2, barycoord, new Vector2());
      }
      if (normal) {
        intersection.normal = Triangle.getInterpolatedAttribute(normal, a2, b2, c2, barycoord, new Vector3());
        if (intersection.normal.dot(ray.direction) > 0) {
          intersection.normal.multiplyScalar(-1);
        }
      }
      const face = {
        a: a2,
        b: b2,
        c: c2,
        normal: new Vector3(),
        materialIndex: 0
      };
      Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
      intersection.face = face;
      intersection.barycoord = barycoord;
    }
    return intersection;
  }
  class BoxGeometry extends BufferGeometry {
    /**
     * Constructs a new box geometry.
     *
     * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
     * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
     * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
     * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
     * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
     * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
     */
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
      super();
      this.type = "BoxGeometry";
      this.parameters = {
        width,
        height,
        depth,
        widthSegments,
        heightSegments,
        depthSegments
      };
      const scope = this;
      widthSegments = Math.floor(widthSegments);
      heightSegments = Math.floor(heightSegments);
      depthSegments = Math.floor(depthSegments);
      const indices = [];
      const vertices = [];
      const normals = [];
      const uvs = [];
      let numberOfVertices = 0;
      let groupStart = 0;
      buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0);
      buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1);
      buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2);
      buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3);
      buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4);
      buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5);
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
      function buildPlane(u2, v2, w2, udir, vdir, width2, height2, depth2, gridX, gridY, materialIndex) {
        const segmentWidth = width2 / gridX;
        const segmentHeight = height2 / gridY;
        const widthHalf = width2 / 2;
        const heightHalf = height2 / 2;
        const depthHalf = depth2 / 2;
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        let vertexCounter = 0;
        let groupCount = 0;
        const vector = new Vector3();
        for (let iy = 0; iy < gridY1; iy++) {
          const y2 = iy * segmentHeight - heightHalf;
          for (let ix = 0; ix < gridX1; ix++) {
            const x2 = ix * segmentWidth - widthHalf;
            vector[u2] = x2 * udir;
            vector[v2] = y2 * vdir;
            vector[w2] = depthHalf;
            vertices.push(vector.x, vector.y, vector.z);
            vector[u2] = 0;
            vector[v2] = 0;
            vector[w2] = depth2 > 0 ? 1 : -1;
            normals.push(vector.x, vector.y, vector.z);
            uvs.push(ix / gridX);
            uvs.push(1 - iy / gridY);
            vertexCounter += 1;
          }
        }
        for (let iy = 0; iy < gridY; iy++) {
          for (let ix = 0; ix < gridX; ix++) {
            const a2 = numberOfVertices + ix + gridX1 * iy;
            const b2 = numberOfVertices + ix + gridX1 * (iy + 1);
            const c2 = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
            const d2 = numberOfVertices + (ix + 1) + gridX1 * iy;
            indices.push(a2, b2, d2);
            indices.push(b2, c2, d2);
            groupCount += 6;
          }
        }
        scope.addGroup(groupStart, groupCount, materialIndex);
        groupStart += groupCount;
        numberOfVertices += vertexCounter;
      }
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {BoxGeometry} A new instance.
     */
    static fromJSON(data) {
      return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
  }
  function cloneUniforms(src) {
    const dst = {};
    for (const u2 in src) {
      dst[u2] = {};
      for (const p2 in src[u2]) {
        const property = src[u2][p2];
        if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
          if (property.isRenderTargetTexture) {
            console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
            dst[u2][p2] = null;
          } else {
            dst[u2][p2] = property.clone();
          }
        } else if (Array.isArray(property)) {
          dst[u2][p2] = property.slice();
        } else {
          dst[u2][p2] = property;
        }
      }
    }
    return dst;
  }
  function mergeUniforms(uniforms) {
    const merged = {};
    for (let u2 = 0; u2 < uniforms.length; u2++) {
      const tmp2 = cloneUniforms(uniforms[u2]);
      for (const p2 in tmp2) {
        merged[p2] = tmp2[p2];
      }
    }
    return merged;
  }
  function cloneUniformsGroups(src) {
    const dst = [];
    for (let u2 = 0; u2 < src.length; u2++) {
      dst.push(src[u2].clone());
    }
    return dst;
  }
  function getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) {
      return renderer.outputColorSpace;
    }
    if (currentRenderTarget.isXRRenderTarget === true) {
      return currentRenderTarget.texture.colorSpace;
    }
    return ColorManagement.workingColorSpace;
  }
  const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
  var default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
  var default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
  class ShaderMaterial extends Material {
    /**
     * Constructs a new shader material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isShaderMaterial = true;
      this.type = "ShaderMaterial";
      this.defines = {};
      this.uniforms = {};
      this.uniformsGroups = [];
      this.vertexShader = default_vertex;
      this.fragmentShader = default_fragment;
      this.linewidth = 1;
      this.wireframe = false;
      this.wireframeLinewidth = 1;
      this.fog = false;
      this.lights = false;
      this.clipping = false;
      this.forceSinglePass = true;
      this.extensions = {
        clipCullDistance: false,
        // set to use vertex shader clipping
        multiDraw: false
        // set to use vertex shader multi_draw / enable gl_DrawID
      };
      this.defaultAttributeValues = {
        "color": [1, 1, 1],
        "uv": [0, 0],
        "uv1": [0, 0]
      };
      this.index0AttributeName = void 0;
      this.uniformsNeedUpdate = false;
      this.glslVersion = null;
      if (parameters !== void 0) {
        this.setValues(parameters);
      }
    }
    copy(source) {
      super.copy(source);
      this.fragmentShader = source.fragmentShader;
      this.vertexShader = source.vertexShader;
      this.uniforms = cloneUniforms(source.uniforms);
      this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
      this.defines = Object.assign({}, source.defines);
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.fog = source.fog;
      this.lights = source.lights;
      this.clipping = source.clipping;
      this.extensions = Object.assign({}, source.extensions);
      this.glslVersion = source.glslVersion;
      return this;
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      data.glslVersion = this.glslVersion;
      data.uniforms = {};
      for (const name in this.uniforms) {
        const uniform = this.uniforms[name];
        const value = uniform.value;
        if (value && value.isTexture) {
          data.uniforms[name] = {
            type: "t",
            value: value.toJSON(meta).uuid
          };
        } else if (value && value.isColor) {
          data.uniforms[name] = {
            type: "c",
            value: value.getHex()
          };
        } else if (value && value.isVector2) {
          data.uniforms[name] = {
            type: "v2",
            value: value.toArray()
          };
        } else if (value && value.isVector3) {
          data.uniforms[name] = {
            type: "v3",
            value: value.toArray()
          };
        } else if (value && value.isVector4) {
          data.uniforms[name] = {
            type: "v4",
            value: value.toArray()
          };
        } else if (value && value.isMatrix3) {
          data.uniforms[name] = {
            type: "m3",
            value: value.toArray()
          };
        } else if (value && value.isMatrix4) {
          data.uniforms[name] = {
            type: "m4",
            value: value.toArray()
          };
        } else {
          data.uniforms[name] = {
            value
          };
        }
      }
      if (Object.keys(this.defines).length > 0) data.defines = this.defines;
      data.vertexShader = this.vertexShader;
      data.fragmentShader = this.fragmentShader;
      data.lights = this.lights;
      data.clipping = this.clipping;
      const extensions = {};
      for (const key in this.extensions) {
        if (this.extensions[key] === true) extensions[key] = true;
      }
      if (Object.keys(extensions).length > 0) data.extensions = extensions;
      return data;
    }
  }
  class Camera extends Object3D {
    /**
     * Constructs a new camera.
     */
    constructor() {
      super();
      this.isCamera = true;
      this.type = "Camera";
      this.matrixWorldInverse = new Matrix4();
      this.projectionMatrix = new Matrix4();
      this.projectionMatrixInverse = new Matrix4();
      this.coordinateSystem = WebGLCoordinateSystem;
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.matrixWorldInverse.copy(source.matrixWorldInverse);
      this.projectionMatrix.copy(source.projectionMatrix);
      this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
      this.coordinateSystem = source.coordinateSystem;
      return this;
    }
    /**
     * Returns a vector representing the ("look") direction of the 3D object in world space.
     *
     * This method is overwritten since cameras have a different forward vector compared to other
     * 3D objects. A camera looks down its local, negative z-axis by default.
     *
     * @param {Vector3} target - The target vector the result is stored to.
     * @return {Vector3} The 3D object's direction in world space.
     */
    getWorldDirection(target) {
      return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
      super.updateMatrixWorld(force);
      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
      super.updateWorldMatrix(updateParents, updateChildren);
      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  const _v3$1 = /* @__PURE__ */ new Vector3();
  const _minTarget = /* @__PURE__ */ new Vector2();
  const _maxTarget = /* @__PURE__ */ new Vector2();
  class PerspectiveCamera extends Camera {
    /**
     * Constructs a new perspective camera.
     *
     * @param {number} [fov=50] - The vertical field of view.
     * @param {number} [aspect=1] - The aspect ratio.
     * @param {number} [near=0.1] - The camera's near plane.
     * @param {number} [far=2000] - The camera's far plane.
     */
    constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
      super();
      this.isPerspectiveCamera = true;
      this.type = "PerspectiveCamera";
      this.fov = fov2;
      this.zoom = 1;
      this.near = near;
      this.far = far;
      this.focus = 10;
      this.aspect = aspect2;
      this.view = null;
      this.filmGauge = 35;
      this.filmOffset = 0;
      this.updateProjectionMatrix();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.fov = source.fov;
      this.zoom = source.zoom;
      this.near = source.near;
      this.far = source.far;
      this.focus = source.focus;
      this.aspect = source.aspect;
      this.view = source.view === null ? null : Object.assign({}, source.view);
      this.filmGauge = source.filmGauge;
      this.filmOffset = source.filmOffset;
      return this;
    }
    /**
     * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
     *
     * The default film gauge is 35, so that the focal length can be specified for
     * a 35mm (full frame) camera.
     *
     * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
     */
    setFocalLength(focalLength) {
      const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
      this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
      this.updateProjectionMatrix();
    }
    /**
     * Returns the focal length from the current {@link PerspectiveCamera#fov} and
     * {@link PerspectiveCamera#filmGauge}.
     *
     * @return {number} The computed focal length.
     */
    getFocalLength() {
      const vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
      return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
     * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
     *
     * @return {number} The effective FOV.
     */
    getEffectiveFOV() {
      return RAD2DEG * 2 * Math.atan(
        Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom
      );
    }
    /**
     * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
     * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
     *
     * @return {number} The film width.
     */
    getFilmWidth() {
      return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
     * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
     * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
     *
     * @return {number} The film width.
     */
    getFilmHeight() {
      return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
     * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
     * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
     *
     * @param {number} distance - The viewing distance.
     * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
     * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
     */
    getViewBounds(distance, minTarget, maxTarget) {
      _v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
      minTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
      _v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
      maxTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
    }
    /**
     * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
     *
     * @param {number} distance - The viewing distance.
     * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
     * @returns {Vector2} The view size.
     */
    getViewSize(distance, target) {
      this.getViewBounds(distance, _minTarget, _maxTarget);
      return target.subVectors(_maxTarget, _minTarget);
    }
    /**
     * Sets an offset in a larger frustum. This is useful for multi-window or
     * multi-monitor/multi-machine setups.
     *
     * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
     * the monitors are in grid like this
     *```
     *   +---+---+---+
     *   | A | B | C |
     *   +---+---+---+
     *   | D | E | F |
     *   +---+---+---+
     *```
     * then for each monitor you would call it like this:
     *```js
     * const w = 1920;
     * const h = 1080;
     * const fullWidth = w * 3;
     * const fullHeight = h * 2;
     *
     * // --A--
     * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
     * // --B--
     * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
     * // --C--
     * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
     * // --D--
     * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
     * // --E--
     * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
     * // --F--
     * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
     * ```
     *
     * Note there is no reason monitors have to be the same size or in a grid.
     *
     * @param {number} fullWidth - The full width of multiview setup.
     * @param {number} fullHeight - The full height of multiview setup.
     * @param {number} x - The horizontal offset of the subcamera.
     * @param {number} y - The vertical offset of the subcamera.
     * @param {number} width - The width of subcamera.
     * @param {number} height - The height of subcamera.
     */
    setViewOffset(fullWidth, fullHeight, x2, y2, width, height) {
      this.aspect = fullWidth / fullHeight;
      if (this.view === null) {
        this.view = {
          enabled: true,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        };
      }
      this.view.enabled = true;
      this.view.fullWidth = fullWidth;
      this.view.fullHeight = fullHeight;
      this.view.offsetX = x2;
      this.view.offsetY = y2;
      this.view.width = width;
      this.view.height = height;
      this.updateProjectionMatrix();
    }
    /**
     * Removes the view offset from the projection matrix.
     */
    clearViewOffset() {
      if (this.view !== null) {
        this.view.enabled = false;
      }
      this.updateProjectionMatrix();
    }
    /**
     * Updates the camera's projection matrix. Must be called after any change of
     * camera properties.
     */
    updateProjectionMatrix() {
      const near = this.near;
      let top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
      let height = 2 * top;
      let width = this.aspect * height;
      let left = -0.5 * width;
      const view = this.view;
      if (this.view !== null && this.view.enabled) {
        const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
        left += view.offsetX * width / fullWidth;
        top -= view.offsetY * height / fullHeight;
        width *= view.width / fullWidth;
        height *= view.height / fullHeight;
      }
      const skew = this.filmOffset;
      if (skew !== 0) left += near * skew / this.getFilmWidth();
      this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      data.object.fov = this.fov;
      data.object.zoom = this.zoom;
      data.object.near = this.near;
      data.object.far = this.far;
      data.object.focus = this.focus;
      data.object.aspect = this.aspect;
      if (this.view !== null) data.object.view = Object.assign({}, this.view);
      data.object.filmGauge = this.filmGauge;
      data.object.filmOffset = this.filmOffset;
      return data;
    }
  }
  const fov = -90;
  const aspect = 1;
  class CubeCamera extends Object3D {
    /**
     * Constructs a new cube camera.
     *
     * @param {number} near - The camera's near plane.
     * @param {number} far - The camera's far plane.
     * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
     */
    constructor(near, far, renderTarget) {
      super();
      this.type = "CubeCamera";
      this.renderTarget = renderTarget;
      this.coordinateSystem = null;
      this.activeMipmapLevel = 0;
      const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
      cameraPX.layers = this.layers;
      this.add(cameraPX);
      const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
      cameraNX.layers = this.layers;
      this.add(cameraNX);
      const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
      cameraPY.layers = this.layers;
      this.add(cameraPY);
      const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
      cameraNY.layers = this.layers;
      this.add(cameraNY);
      const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
      cameraPZ.layers = this.layers;
      this.add(cameraPZ);
      const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
      cameraNZ.layers = this.layers;
      this.add(cameraNZ);
    }
    /**
     * Must be called when the coordinate system of the cube camera is changed.
     */
    updateCoordinateSystem() {
      const coordinateSystem = this.coordinateSystem;
      const cameras = this.children.concat();
      const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
      for (const camera of cameras) this.remove(camera);
      if (coordinateSystem === WebGLCoordinateSystem) {
        cameraPX.up.set(0, 1, 0);
        cameraPX.lookAt(1, 0, 0);
        cameraNX.up.set(0, 1, 0);
        cameraNX.lookAt(-1, 0, 0);
        cameraPY.up.set(0, 0, -1);
        cameraPY.lookAt(0, 1, 0);
        cameraNY.up.set(0, 0, 1);
        cameraNY.lookAt(0, -1, 0);
        cameraPZ.up.set(0, 1, 0);
        cameraPZ.lookAt(0, 0, 1);
        cameraNZ.up.set(0, 1, 0);
        cameraNZ.lookAt(0, 0, -1);
      } else if (coordinateSystem === WebGPUCoordinateSystem) {
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(-1, 0, 0);
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(1, 0, 0);
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(0, 1, 0);
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(0, -1, 0);
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(0, 0, 1);
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(0, 0, -1);
      } else {
        throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
      }
      for (const camera of cameras) {
        this.add(camera);
        camera.updateMatrixWorld();
      }
    }
    /**
     * Calling this method will render the given scene with the given renderer
     * into the cube render target of the camera.
     *
     * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
     * @param {Scene} scene - The scene to render.
     */
    update(renderer, scene) {
      if (this.parent === null) this.updateMatrixWorld();
      const { renderTarget, activeMipmapLevel } = this;
      if (this.coordinateSystem !== renderer.coordinateSystem) {
        this.coordinateSystem = renderer.coordinateSystem;
        this.updateCoordinateSystem();
      }
      const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
      const currentRenderTarget = renderer.getRenderTarget();
      const currentActiveCubeFace = renderer.getActiveCubeFace();
      const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
      const currentXrEnabled = renderer.xr.enabled;
      renderer.xr.enabled = false;
      const generateMipmaps = renderTarget.texture.generateMipmaps;
      renderTarget.texture.generateMipmaps = false;
      renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
      renderer.render(scene, cameraPX);
      renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
      renderer.render(scene, cameraNX);
      renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
      renderer.render(scene, cameraPY);
      renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
      renderer.render(scene, cameraNY);
      renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
      renderer.render(scene, cameraPZ);
      renderTarget.texture.generateMipmaps = generateMipmaps;
      renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
      renderer.render(scene, cameraNZ);
      renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
      renderer.xr.enabled = currentXrEnabled;
      renderTarget.texture.needsPMREMUpdate = true;
    }
  }
  class CubeTexture extends Texture {
    /**
     * Constructs a new cube texture.
     *
     * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
     * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
     * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
     * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
     * @param {number} [magFilter=LinearFilter] - The mag filter value.
     * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
     * @param {number} [format=RGBAFormat] - The texture format.
     * @param {number} [type=UnsignedByteType] - The texture type.
     * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
     * @param {string} [colorSpace=NoColorSpace] - The color space value.
     */
    constructor(images = [], mapping = CubeReflectionMapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace) {
      super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
      this.isCubeTexture = true;
      this.flipY = false;
    }
    /**
     * Alias for {@link CubeTexture#image}.
     *
     * @type {Array<Image>}
     */
    get images() {
      return this.image;
    }
    set images(value) {
      this.image = value;
    }
  }
  class WebGLCubeRenderTarget extends WebGLRenderTarget {
    /**
     * Constructs a new cube render target.
     *
     * @param {number} [size=1] - The size of the render target.
     * @param {RenderTarget~Options} [options] - The configuration object.
     */
    constructor(size = 1, options = {}) {
      super(size, size, options);
      this.isWebGLCubeRenderTarget = true;
      const image = { width: size, height: size, depth: 1 };
      const images = [image, image, image, image, image, image];
      this.texture = new CubeTexture(images);
      this._setTextureOptions(options);
      this.texture.isRenderTargetTexture = true;
    }
    /**
     * Converts the given equirectangular texture to a cube map.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {Texture} texture - The equirectangular texture.
     * @return {WebGLCubeRenderTarget} A reference to this cube render target.
     */
    fromEquirectangularTexture(renderer, texture) {
      this.texture.type = texture.type;
      this.texture.colorSpace = texture.colorSpace;
      this.texture.generateMipmaps = texture.generateMipmaps;
      this.texture.minFilter = texture.minFilter;
      this.texture.magFilter = texture.magFilter;
      const shader = {
        uniforms: {
          tEquirect: { value: null }
        },
        vertexShader: (
          /* glsl */
          `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
        ),
        fragmentShader: (
          /* glsl */
          `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        )
      };
      const geometry = new BoxGeometry(5, 5, 5);
      const material = new ShaderMaterial({
        name: "CubemapFromEquirect",
        uniforms: cloneUniforms(shader.uniforms),
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader,
        side: BackSide,
        blending: NoBlending
      });
      material.uniforms.tEquirect.value = texture;
      const mesh = new Mesh(geometry, material);
      const currentMinFilter = texture.minFilter;
      if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
      const camera = new CubeCamera(1, 10, this);
      camera.update(renderer, mesh);
      texture.minFilter = currentMinFilter;
      mesh.geometry.dispose();
      mesh.material.dispose();
      return this;
    }
    /**
     * Clears this cube render target.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
     * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
     * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
     */
    clear(renderer, color = true, depth = true, stencil = true) {
      const currentRenderTarget = renderer.getRenderTarget();
      for (let i2 = 0; i2 < 6; i2++) {
        renderer.setRenderTarget(this, i2);
        renderer.clear(color, depth, stencil);
      }
      renderer.setRenderTarget(currentRenderTarget);
    }
  }
  class Group extends Object3D {
    constructor() {
      super();
      this.isGroup = true;
      this.type = "Group";
    }
  }
  const _moveEvent = { type: "move" };
  class WebXRController {
    /**
     * Constructs a new XR controller.
     */
    constructor() {
      this._targetRay = null;
      this._grip = null;
      this._hand = null;
    }
    /**
     * Returns a group representing the hand space of the XR controller.
     *
     * @return {Group} A group representing the hand space of the XR controller.
     */
    getHandSpace() {
      if (this._hand === null) {
        this._hand = new Group();
        this._hand.matrixAutoUpdate = false;
        this._hand.visible = false;
        this._hand.joints = {};
        this._hand.inputState = { pinching: false };
      }
      return this._hand;
    }
    /**
     * Returns a group representing the target ray space of the XR controller.
     *
     * @return {Group} A group representing the target ray space of the XR controller.
     */
    getTargetRaySpace() {
      if (this._targetRay === null) {
        this._targetRay = new Group();
        this._targetRay.matrixAutoUpdate = false;
        this._targetRay.visible = false;
        this._targetRay.hasLinearVelocity = false;
        this._targetRay.linearVelocity = new Vector3();
        this._targetRay.hasAngularVelocity = false;
        this._targetRay.angularVelocity = new Vector3();
      }
      return this._targetRay;
    }
    /**
     * Returns a group representing the grip space of the XR controller.
     *
     * @return {Group} A group representing the grip space of the XR controller.
     */
    getGripSpace() {
      if (this._grip === null) {
        this._grip = new Group();
        this._grip.matrixAutoUpdate = false;
        this._grip.visible = false;
        this._grip.hasLinearVelocity = false;
        this._grip.linearVelocity = new Vector3();
        this._grip.hasAngularVelocity = false;
        this._grip.angularVelocity = new Vector3();
      }
      return this._grip;
    }
    /**
     * Dispatches the given event to the groups representing
     * the different coordinate spaces of the XR controller.
     *
     * @param {Object} event - The event to dispatch.
     * @return {WebXRController} A reference to this instance.
     */
    dispatchEvent(event) {
      if (this._targetRay !== null) {
        this._targetRay.dispatchEvent(event);
      }
      if (this._grip !== null) {
        this._grip.dispatchEvent(event);
      }
      if (this._hand !== null) {
        this._hand.dispatchEvent(event);
      }
      return this;
    }
    /**
     * Connects the controller with the given XR input source.
     *
     * @param {XRInputSource} inputSource - The input source.
     * @return {WebXRController} A reference to this instance.
     */
    connect(inputSource) {
      if (inputSource && inputSource.hand) {
        const hand = this._hand;
        if (hand) {
          for (const inputjoint of inputSource.hand.values()) {
            this._getHandJoint(hand, inputjoint);
          }
        }
      }
      this.dispatchEvent({ type: "connected", data: inputSource });
      return this;
    }
    /**
     * Disconnects the controller from the given XR input source.
     *
     * @param {XRInputSource} inputSource - The input source.
     * @return {WebXRController} A reference to this instance.
     */
    disconnect(inputSource) {
      this.dispatchEvent({ type: "disconnected", data: inputSource });
      if (this._targetRay !== null) {
        this._targetRay.visible = false;
      }
      if (this._grip !== null) {
        this._grip.visible = false;
      }
      if (this._hand !== null) {
        this._hand.visible = false;
      }
      return this;
    }
    /**
     * Updates the controller with the given input source, XR frame and reference space.
     * This updates the transformations of the groups that represent the different
     * coordinate systems of the controller.
     *
     * @param {XRInputSource} inputSource - The input source.
     * @param {XRFrame} frame - The XR frame.
     * @param {XRReferenceSpace} referenceSpace - The reference space.
     * @return {WebXRController} A reference to this instance.
     */
    update(inputSource, frame, referenceSpace) {
      let inputPose = null;
      let gripPose = null;
      let handPose = null;
      const targetRay = this._targetRay;
      const grip = this._grip;
      const hand = this._hand;
      if (inputSource && frame.session.visibilityState !== "visible-blurred") {
        if (hand && inputSource.hand) {
          handPose = true;
          for (const inputjoint of inputSource.hand.values()) {
            const jointPose = frame.getJointPose(inputjoint, referenceSpace);
            const joint = this._getHandJoint(hand, inputjoint);
            if (jointPose !== null) {
              joint.matrix.fromArray(jointPose.transform.matrix);
              joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
              joint.matrixWorldNeedsUpdate = true;
              joint.jointRadius = jointPose.radius;
            }
            joint.visible = jointPose !== null;
          }
          const indexTip = hand.joints["index-finger-tip"];
          const thumbTip = hand.joints["thumb-tip"];
          const distance = indexTip.position.distanceTo(thumbTip.position);
          const distanceToPinch = 0.02;
          const threshold = 5e-3;
          if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
            hand.inputState.pinching = false;
            this.dispatchEvent({
              type: "pinchend",
              handedness: inputSource.handedness,
              target: this
            });
          } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
            hand.inputState.pinching = true;
            this.dispatchEvent({
              type: "pinchstart",
              handedness: inputSource.handedness,
              target: this
            });
          }
        } else {
          if (grip !== null && inputSource.gripSpace) {
            gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
            if (gripPose !== null) {
              grip.matrix.fromArray(gripPose.transform.matrix);
              grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
              grip.matrixWorldNeedsUpdate = true;
              if (gripPose.linearVelocity) {
                grip.hasLinearVelocity = true;
                grip.linearVelocity.copy(gripPose.linearVelocity);
              } else {
                grip.hasLinearVelocity = false;
              }
              if (gripPose.angularVelocity) {
                grip.hasAngularVelocity = true;
                grip.angularVelocity.copy(gripPose.angularVelocity);
              } else {
                grip.hasAngularVelocity = false;
              }
            }
          }
        }
        if (targetRay !== null) {
          inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
          if (inputPose === null && gripPose !== null) {
            inputPose = gripPose;
          }
          if (inputPose !== null) {
            targetRay.matrix.fromArray(inputPose.transform.matrix);
            targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
            targetRay.matrixWorldNeedsUpdate = true;
            if (inputPose.linearVelocity) {
              targetRay.hasLinearVelocity = true;
              targetRay.linearVelocity.copy(inputPose.linearVelocity);
            } else {
              targetRay.hasLinearVelocity = false;
            }
            if (inputPose.angularVelocity) {
              targetRay.hasAngularVelocity = true;
              targetRay.angularVelocity.copy(inputPose.angularVelocity);
            } else {
              targetRay.hasAngularVelocity = false;
            }
            this.dispatchEvent(_moveEvent);
          }
        }
      }
      if (targetRay !== null) {
        targetRay.visible = inputPose !== null;
      }
      if (grip !== null) {
        grip.visible = gripPose !== null;
      }
      if (hand !== null) {
        hand.visible = handPose !== null;
      }
      return this;
    }
    /**
     * Returns a group representing the hand joint for the given input joint.
     *
     * @private
     * @param {Group} hand - The group representing the hand space.
     * @param {XRJointSpace} inputjoint - The hand joint data.
     * @return {Group} A group representing the hand joint for the given input joint.
     */
    _getHandJoint(hand, inputjoint) {
      if (hand.joints[inputjoint.jointName] === void 0) {
        const joint = new Group();
        joint.matrixAutoUpdate = false;
        joint.visible = false;
        hand.joints[inputjoint.jointName] = joint;
        hand.add(joint);
      }
      return hand.joints[inputjoint.jointName];
    }
  }
  class Scene extends Object3D {
    /**
     * Constructs a new scene.
     */
    constructor() {
      super();
      this.isScene = true;
      this.type = "Scene";
      this.background = null;
      this.environment = null;
      this.fog = null;
      this.backgroundBlurriness = 0;
      this.backgroundIntensity = 1;
      this.backgroundRotation = new Euler();
      this.environmentIntensity = 1;
      this.environmentRotation = new Euler();
      this.overrideMaterial = null;
      if (typeof __THREE_DEVTOOLS__ !== "undefined") {
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
      }
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      if (source.background !== null) this.background = source.background.clone();
      if (source.environment !== null) this.environment = source.environment.clone();
      if (source.fog !== null) this.fog = source.fog.clone();
      this.backgroundBlurriness = source.backgroundBlurriness;
      this.backgroundIntensity = source.backgroundIntensity;
      this.backgroundRotation.copy(source.backgroundRotation);
      this.environmentIntensity = source.environmentIntensity;
      this.environmentRotation.copy(source.environmentRotation);
      if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      return this;
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      if (this.fog !== null) data.object.fog = this.fog.toJSON();
      if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
      if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
      data.object.backgroundRotation = this.backgroundRotation.toArray();
      if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
      data.object.environmentRotation = this.environmentRotation.toArray();
      return data;
    }
  }
  class InterleavedBuffer {
    /**
     * Constructs a new interleaved buffer.
     *
     * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
     * @param {number} stride - The number of typed-array elements per vertex.
     */
    constructor(array, stride) {
      this.isInterleavedBuffer = true;
      this.array = array;
      this.stride = stride;
      this.count = array !== void 0 ? array.length / stride : 0;
      this.usage = StaticDrawUsage;
      this.updateRanges = [];
      this.version = 0;
      this.uuid = generateUUID();
    }
    /**
     * A callback function that is executed after the renderer has transferred the attribute array
     * data to the GPU.
     */
    onUploadCallback() {
    }
    /**
     * Flag to indicate that this attribute has changed and should be re-sent to
     * the GPU. Set this to `true` when you modify the value of the array.
     *
     * @type {number}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      if (value === true) this.version++;
    }
    /**
     * Sets the usage of this interleaved buffer.
     *
     * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
     * @return {InterleavedBuffer} A reference to this interleaved buffer.
     */
    setUsage(value) {
      this.usage = value;
      return this;
    }
    /**
     * Adds a range of data in the data array to be updated on the GPU.
     *
     * @param {number} start - Position at which to start update.
     * @param {number} count - The number of components to update.
     */
    addUpdateRange(start, count) {
      this.updateRanges.push({ start, count });
    }
    /**
     * Clears the update ranges.
     */
    clearUpdateRanges() {
      this.updateRanges.length = 0;
    }
    /**
     * Copies the values of the given interleaved buffer to this instance.
     *
     * @param {InterleavedBuffer} source - The interleaved buffer to copy.
     * @return {InterleavedBuffer} A reference to this instance.
     */
    copy(source) {
      this.array = new source.array.constructor(source.array);
      this.count = source.count;
      this.stride = source.stride;
      this.usage = source.usage;
      return this;
    }
    /**
     * Copies a vector from the given interleaved buffer to this one. The start
     * and destination position in the attribute buffers are represented by the
     * given indices.
     *
     * @param {number} index1 - The destination index into this interleaved buffer.
     * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
     * @param {number} index2 - The source index into the given interleaved buffer.
     * @return {InterleavedBuffer} A reference to this instance.
     */
    copyAt(index1, interleavedBuffer, index2) {
      index1 *= this.stride;
      index2 *= interleavedBuffer.stride;
      for (let i2 = 0, l2 = this.stride; i2 < l2; i2++) {
        this.array[index1 + i2] = interleavedBuffer.array[index2 + i2];
      }
      return this;
    }
    /**
     * Sets the given array data in the interleaved buffer.
     *
     * @param {(TypedArray|Array)} value - The array data to set.
     * @param {number} [offset=0] - The offset in this interleaved buffer's array.
     * @return {InterleavedBuffer} A reference to this instance.
     */
    set(value, offset = 0) {
      this.array.set(value, offset);
      return this;
    }
    /**
     * Returns a new interleaved buffer with copied values from this instance.
     *
     * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
     * @return {InterleavedBuffer} A clone of this instance.
     */
    clone(data) {
      if (data.arrayBuffers === void 0) {
        data.arrayBuffers = {};
      }
      if (this.array.buffer._uuid === void 0) {
        this.array.buffer._uuid = generateUUID();
      }
      if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
        data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
      }
      const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
      const ib = new this.constructor(array, this.stride);
      ib.setUsage(this.usage);
      return ib;
    }
    /**
     * Sets the given callback function that is executed after the Renderer has transferred
     * the array data to the GPU. Can be used to perform clean-up operations after
     * the upload when data are not needed anymore on the CPU side.
     *
     * @param {Function} callback - The `onUpload()` callback.
     * @return {InterleavedBuffer} A reference to this instance.
     */
    onUpload(callback) {
      this.onUploadCallback = callback;
      return this;
    }
    /**
     * Serializes the interleaved buffer into JSON.
     *
     * @param {Object} [data] - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized interleaved buffer.
     */
    toJSON(data) {
      if (data.arrayBuffers === void 0) {
        data.arrayBuffers = {};
      }
      if (this.array.buffer._uuid === void 0) {
        this.array.buffer._uuid = generateUUID();
      }
      if (data.arrayBuffers[this.array.buffer._uuid] === void 0) {
        data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
      }
      return {
        uuid: this.uuid,
        buffer: this.array.buffer._uuid,
        type: this.array.constructor.name,
        stride: this.stride
      };
    }
  }
  const _vector$7 = /* @__PURE__ */ new Vector3();
  class InterleavedBufferAttribute {
    /**
     * Constructs a new interleaved buffer attribute.
     *
     * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
     * @param {number} itemSize - The item size.
     * @param {number} offset - The attribute offset into the buffer.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     */
    constructor(interleavedBuffer, itemSize, offset, normalized = false) {
      this.isInterleavedBufferAttribute = true;
      this.name = "";
      this.data = interleavedBuffer;
      this.itemSize = itemSize;
      this.offset = offset;
      this.normalized = normalized;
    }
    /**
     * The item count of this buffer attribute.
     *
     * @type {number}
     * @readonly
     */
    get count() {
      return this.data.count;
    }
    /**
     * The array holding the interleaved buffer attribute data.
     *
     * @type {TypedArray}
     */
    get array() {
      return this.data.array;
    }
    /**
     * Flag to indicate that this attribute has changed and should be re-sent to
     * the GPU. Set this to `true` when you modify the value of the array.
     *
     * @type {number}
     * @default false
     * @param {boolean} value
     */
    set needsUpdate(value) {
      this.data.needsUpdate = value;
    }
    /**
     * Applies the given 4x4 matrix to the given attribute. Only works with
     * item size `3`.
     *
     * @param {Matrix4} m - The matrix to apply.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    applyMatrix4(m) {
      for (let i2 = 0, l2 = this.data.count; i2 < l2; i2++) {
        _vector$7.fromBufferAttribute(this, i2);
        _vector$7.applyMatrix4(m);
        this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
      }
      return this;
    }
    /**
     * Applies the given 3x3 normal matrix to the given attribute. Only works with
     * item size `3`.
     *
     * @param {Matrix3} m - The normal matrix to apply.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    applyNormalMatrix(m) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$7.fromBufferAttribute(this, i2);
        _vector$7.applyNormalMatrix(m);
        this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
      }
      return this;
    }
    /**
     * Applies the given 4x4 matrix to the given attribute. Only works with
     * item size `3` and with direction vectors.
     *
     * @param {Matrix4} m - The matrix to apply.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    transformDirection(m) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$7.fromBufferAttribute(this, i2);
        _vector$7.transformDirection(m);
        this.setXYZ(i2, _vector$7.x, _vector$7.y, _vector$7.z);
      }
      return this;
    }
    /**
     * Returns the given component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} component - The component index.
     * @return {number} The returned value.
     */
    getComponent(index, component) {
      let value = this.array[index * this.data.stride + this.offset + component];
      if (this.normalized) value = denormalize(value, this.array);
      return value;
    }
    /**
     * Sets the given value to the given component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} component - The component index.
     * @param {number} value - The value to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setComponent(index, component, value) {
      if (this.normalized) value = normalize(value, this.array);
      this.data.array[index * this.data.stride + this.offset + component] = value;
      return this;
    }
    /**
     * Sets the x component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setX(index, x2) {
      if (this.normalized) x2 = normalize(x2, this.array);
      this.data.array[index * this.data.stride + this.offset] = x2;
      return this;
    }
    /**
     * Sets the y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} y - The value to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setY(index, y2) {
      if (this.normalized) y2 = normalize(y2, this.array);
      this.data.array[index * this.data.stride + this.offset + 1] = y2;
      return this;
    }
    /**
     * Sets the z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} z - The value to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setZ(index, z2) {
      if (this.normalized) z2 = normalize(z2, this.array);
      this.data.array[index * this.data.stride + this.offset + 2] = z2;
      return this;
    }
    /**
     * Sets the w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} w - The value to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setW(index, w2) {
      if (this.normalized) w2 = normalize(w2, this.array);
      this.data.array[index * this.data.stride + this.offset + 3] = w2;
      return this;
    }
    /**
     * Returns the x component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The x component.
     */
    getX(index) {
      let x2 = this.data.array[index * this.data.stride + this.offset];
      if (this.normalized) x2 = denormalize(x2, this.array);
      return x2;
    }
    /**
     * Returns the y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The y component.
     */
    getY(index) {
      let y2 = this.data.array[index * this.data.stride + this.offset + 1];
      if (this.normalized) y2 = denormalize(y2, this.array);
      return y2;
    }
    /**
     * Returns the z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The z component.
     */
    getZ(index) {
      let z2 = this.data.array[index * this.data.stride + this.offset + 2];
      if (this.normalized) z2 = denormalize(z2, this.array);
      return z2;
    }
    /**
     * Returns the w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @return {number} The w component.
     */
    getW(index) {
      let w2 = this.data.array[index * this.data.stride + this.offset + 3];
      if (this.normalized) w2 = denormalize(w2, this.array);
      return w2;
    }
    /**
     * Sets the x and y component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setXY(index, x2, y2) {
      index = index * this.data.stride + this.offset;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
      }
      this.data.array[index + 0] = x2;
      this.data.array[index + 1] = y2;
      return this;
    }
    /**
     * Sets the x, y and z component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @param {number} z - The value for the z component to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setXYZ(index, x2, y2, z2) {
      index = index * this.data.stride + this.offset;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
        z2 = normalize(z2, this.array);
      }
      this.data.array[index + 0] = x2;
      this.data.array[index + 1] = y2;
      this.data.array[index + 2] = z2;
      return this;
    }
    /**
     * Sets the x, y, z and w component of the vector at the given index.
     *
     * @param {number} index - The index into the buffer attribute.
     * @param {number} x - The value for the x component to set.
     * @param {number} y - The value for the y component to set.
     * @param {number} z - The value for the z component to set.
     * @param {number} w - The value for the w component to set.
     * @return {InterleavedBufferAttribute} A reference to this instance.
     */
    setXYZW(index, x2, y2, z2, w2) {
      index = index * this.data.stride + this.offset;
      if (this.normalized) {
        x2 = normalize(x2, this.array);
        y2 = normalize(y2, this.array);
        z2 = normalize(z2, this.array);
        w2 = normalize(w2, this.array);
      }
      this.data.array[index + 0] = x2;
      this.data.array[index + 1] = y2;
      this.data.array[index + 2] = z2;
      this.data.array[index + 3] = w2;
      return this;
    }
    /**
     * Returns a new buffer attribute with copied values from this instance.
     *
     * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
     *
     * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
     * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
     */
    clone(data) {
      if (data === void 0) {
        console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
        const array = [];
        for (let i2 = 0; i2 < this.count; i2++) {
          const index = i2 * this.data.stride + this.offset;
          for (let j2 = 0; j2 < this.itemSize; j2++) {
            array.push(this.data.array[index + j2]);
          }
        }
        return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
      } else {
        if (data.interleavedBuffers === void 0) {
          data.interleavedBuffers = {};
        }
        if (data.interleavedBuffers[this.data.uuid] === void 0) {
          data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
        }
        return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
      }
    }
    /**
     * Serializes the buffer attribute into JSON.
     *
     * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
     *
     * @param {Object} [data] - An optional value holding meta information about the serialization.
     * @return {Object} A JSON object representing the serialized buffer attribute.
     */
    toJSON(data) {
      if (data === void 0) {
        console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
        const array = [];
        for (let i2 = 0; i2 < this.count; i2++) {
          const index = i2 * this.data.stride + this.offset;
          for (let j2 = 0; j2 < this.itemSize; j2++) {
            array.push(this.data.array[index + j2]);
          }
        }
        return {
          itemSize: this.itemSize,
          type: this.array.constructor.name,
          array,
          normalized: this.normalized
        };
      } else {
        if (data.interleavedBuffers === void 0) {
          data.interleavedBuffers = {};
        }
        if (data.interleavedBuffers[this.data.uuid] === void 0) {
          data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
        }
        return {
          isInterleavedBufferAttribute: true,
          itemSize: this.itemSize,
          data: this.data.uuid,
          offset: this.offset,
          normalized: this.normalized
        };
      }
    }
  }
  const _basePosition = /* @__PURE__ */ new Vector3();
  const _skinIndex = /* @__PURE__ */ new Vector4();
  const _skinWeight = /* @__PURE__ */ new Vector4();
  const _vector3 = /* @__PURE__ */ new Vector3();
  const _matrix4 = /* @__PURE__ */ new Matrix4();
  const _vertex = /* @__PURE__ */ new Vector3();
  const _sphere$5 = /* @__PURE__ */ new Sphere();
  const _inverseMatrix$2 = /* @__PURE__ */ new Matrix4();
  const _ray$2 = /* @__PURE__ */ new Ray();
  class SkinnedMesh extends Mesh {
    /**
     * Constructs a new skinned mesh.
     *
     * @param {BufferGeometry} [geometry] - The mesh geometry.
     * @param {Material|Array<Material>} [material] - The mesh material.
     */
    constructor(geometry, material) {
      super(geometry, material);
      this.isSkinnedMesh = true;
      this.type = "SkinnedMesh";
      this.bindMode = AttachedBindMode;
      this.bindMatrix = new Matrix4();
      this.bindMatrixInverse = new Matrix4();
      this.boundingBox = null;
      this.boundingSphere = null;
    }
    /**
     * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
     * The bounding box is not automatically computed by the engine; this method must be called by your app.
     * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
     * the current animation state.
     */
    computeBoundingBox() {
      const geometry = this.geometry;
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }
      this.boundingBox.makeEmpty();
      const positionAttribute = geometry.getAttribute("position");
      for (let i2 = 0; i2 < positionAttribute.count; i2++) {
        this.getVertexPosition(i2, _vertex);
        this.boundingBox.expandByPoint(_vertex);
      }
    }
    /**
     * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
     * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
     * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
     * per frame in order to reflect the current animation state.
     */
    computeBoundingSphere() {
      const geometry = this.geometry;
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }
      this.boundingSphere.makeEmpty();
      const positionAttribute = geometry.getAttribute("position");
      for (let i2 = 0; i2 < positionAttribute.count; i2++) {
        this.getVertexPosition(i2, _vertex);
        this.boundingSphere.expandByPoint(_vertex);
      }
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.bindMode = source.bindMode;
      this.bindMatrix.copy(source.bindMatrix);
      this.bindMatrixInverse.copy(source.bindMatrixInverse);
      this.skeleton = source.skeleton;
      if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
      if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
      return this;
    }
    raycast(raycaster, intersects2) {
      const material = this.material;
      const matrixWorld = this.matrixWorld;
      if (material === void 0) return;
      if (this.boundingSphere === null) this.computeBoundingSphere();
      _sphere$5.copy(this.boundingSphere);
      _sphere$5.applyMatrix4(matrixWorld);
      if (raycaster.ray.intersectsSphere(_sphere$5) === false) return;
      _inverseMatrix$2.copy(matrixWorld).invert();
      _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
      if (this.boundingBox !== null) {
        if (_ray$2.intersectsBox(this.boundingBox) === false) return;
      }
      this._computeIntersections(raycaster, intersects2, _ray$2);
    }
    getVertexPosition(index, target) {
      super.getVertexPosition(index, target);
      this.applyBoneTransform(index, target);
      return target;
    }
    /**
     * Binds the given skeleton to the skinned mesh.
     *
     * @param {Skeleton} skeleton - The skeleton to bind.
     * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
     * the skinned mesh's world matrix will be used instead.
     */
    bind(skeleton, bindMatrix) {
      this.skeleton = skeleton;
      if (bindMatrix === void 0) {
        this.updateMatrixWorld(true);
        this.skeleton.calculateInverses();
        bindMatrix = this.matrixWorld;
      }
      this.bindMatrix.copy(bindMatrix);
      this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
     * This method sets the skinned mesh in the rest pose).
     */
    pose() {
      this.skeleton.pose();
    }
    /**
     * Normalizes the skin weights which are defined as a buffer attribute
     * in the skinned mesh's geometry.
     */
    normalizeSkinWeights() {
      const vector = new Vector4();
      const skinWeight = this.geometry.attributes.skinWeight;
      for (let i2 = 0, l2 = skinWeight.count; i2 < l2; i2++) {
        vector.fromBufferAttribute(skinWeight, i2);
        const scale = 1 / vector.manhattanLength();
        if (scale !== Infinity) {
          vector.multiplyScalar(scale);
        } else {
          vector.set(1, 0, 0, 0);
        }
        skinWeight.setXYZW(i2, vector.x, vector.y, vector.z, vector.w);
      }
    }
    updateMatrixWorld(force) {
      super.updateMatrixWorld(force);
      if (this.bindMode === AttachedBindMode) {
        this.bindMatrixInverse.copy(this.matrixWorld).invert();
      } else if (this.bindMode === DetachedBindMode) {
        this.bindMatrixInverse.copy(this.bindMatrix).invert();
      } else {
        console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
      }
    }
    /**
     * Applies the bone transform associated with the given index to the given
     * vertex position. Returns the updated vector.
     *
     * @param {number} index - The vertex index.
     * @param {Vector3} target - The target object that is used to store the method's result.
     * the skinned mesh's world matrix will be used instead.
     * @return {Vector3} The updated vertex position.
     */
    applyBoneTransform(index, target) {
      const skeleton = this.skeleton;
      const geometry = this.geometry;
      _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
      _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
      _basePosition.copy(target).applyMatrix4(this.bindMatrix);
      target.set(0, 0, 0);
      for (let i2 = 0; i2 < 4; i2++) {
        const weight = _skinWeight.getComponent(i2);
        if (weight !== 0) {
          const boneIndex = _skinIndex.getComponent(i2);
          _matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
          target.addScaledVector(_vector3.copy(_basePosition).applyMatrix4(_matrix4), weight);
        }
      }
      return target.applyMatrix4(this.bindMatrixInverse);
    }
  }
  class Bone extends Object3D {
    /**
     * Constructs a new bone.
     */
    constructor() {
      super();
      this.isBone = true;
      this.type = "Bone";
    }
  }
  class DataTexture extends Texture {
    /**
     * Constructs a new data texture.
     *
     * @param {?TypedArray} [data=null] - The buffer data.
     * @param {number} [width=1] - The width of the texture.
     * @param {number} [height=1] - The height of the texture.
     * @param {number} [format=RGBAFormat] - The texture format.
     * @param {number} [type=UnsignedByteType] - The texture type.
     * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
     * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
     * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
     * @param {number} [magFilter=NearestFilter] - The mag filter value.
     * @param {number} [minFilter=NearestFilter] - The min filter value.
     * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
     * @param {string} [colorSpace=NoColorSpace] - The color space.
     */
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace) {
      super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
      this.isDataTexture = true;
      this.image = { data, width, height };
      this.generateMipmaps = false;
      this.flipY = false;
      this.unpackAlignment = 1;
    }
  }
  const _offsetMatrix = /* @__PURE__ */ new Matrix4();
  const _identityMatrix$1 = /* @__PURE__ */ new Matrix4();
  class Skeleton {
    /**
     * Constructs a new skeleton.
     *
     * @param {Array<Bone>} [bones] - An array of bones.
     * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
     * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
     */
    constructor(bones = [], boneInverses = []) {
      this.uuid = generateUUID();
      this.bones = bones.slice(0);
      this.boneInverses = boneInverses;
      this.boneMatrices = null;
      this.boneTexture = null;
      this.init();
    }
    /**
     * Initializes the skeleton. This method gets automatically called by the constructor
     * but depending on how the skeleton is created it might be necessary to call this method
     * manually.
     */
    init() {
      const bones = this.bones;
      const boneInverses = this.boneInverses;
      this.boneMatrices = new Float32Array(bones.length * 16);
      if (boneInverses.length === 0) {
        this.calculateInverses();
      } else {
        if (bones.length !== boneInverses.length) {
          console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
          this.boneInverses = [];
          for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
            this.boneInverses.push(new Matrix4());
          }
        }
      }
    }
    /**
     * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
     * and fills it with new matrices.
     */
    calculateInverses() {
      this.boneInverses.length = 0;
      for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
        const inverse = new Matrix4();
        if (this.bones[i2]) {
          inverse.copy(this.bones[i2].matrixWorld).invert();
        }
        this.boneInverses.push(inverse);
      }
    }
    /**
     * Resets the skeleton to the base pose.
     */
    pose() {
      for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
        const bone = this.bones[i2];
        if (bone) {
          bone.matrixWorld.copy(this.boneInverses[i2]).invert();
        }
      }
      for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
        const bone = this.bones[i2];
        if (bone) {
          if (bone.parent && bone.parent.isBone) {
            bone.matrix.copy(bone.parent.matrixWorld).invert();
            bone.matrix.multiply(bone.matrixWorld);
          } else {
            bone.matrix.copy(bone.matrixWorld);
          }
          bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
        }
      }
    }
    /**
     * Resets the skeleton to the base pose.
     */
    update() {
      const bones = this.bones;
      const boneInverses = this.boneInverses;
      const boneMatrices = this.boneMatrices;
      const boneTexture = this.boneTexture;
      for (let i2 = 0, il = bones.length; i2 < il; i2++) {
        const matrix = bones[i2] ? bones[i2].matrixWorld : _identityMatrix$1;
        _offsetMatrix.multiplyMatrices(matrix, boneInverses[i2]);
        _offsetMatrix.toArray(boneMatrices, i2 * 16);
      }
      if (boneTexture !== null) {
        boneTexture.needsUpdate = true;
      }
    }
    /**
     * Returns a new skeleton with copied values from this instance.
     *
     * @return {Skeleton} A clone of this instance.
     */
    clone() {
      return new Skeleton(this.bones, this.boneInverses);
    }
    /**
     * Computes a data texture for passing bone data to the vertex shader.
     *
     * @return {Skeleton} A reference of this instance.
     */
    computeBoneTexture() {
      let size = Math.sqrt(this.bones.length * 4);
      size = Math.ceil(size / 4) * 4;
      size = Math.max(size, 4);
      const boneMatrices = new Float32Array(size * size * 4);
      boneMatrices.set(this.boneMatrices);
      const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
      boneTexture.needsUpdate = true;
      this.boneMatrices = boneMatrices;
      this.boneTexture = boneTexture;
      return this;
    }
    /**
     * Searches through the skeleton's bone array and returns the first with a
     * matching name.
     *
     * @param {string} name - The name of the bone.
     * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
     */
    getBoneByName(name) {
      for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
        const bone = this.bones[i2];
        if (bone.name === name) {
          return bone;
        }
      }
      return void 0;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     */
    dispose() {
      if (this.boneTexture !== null) {
        this.boneTexture.dispose();
        this.boneTexture = null;
      }
    }
    /**
     * Setups the skeleton by the given JSON and bones.
     *
     * @param {Object} json - The skeleton as serialized JSON.
     * @param {Object<string, Bone>} bones - An array of bones.
     * @return {Skeleton} A reference of this instance.
     */
    fromJSON(json, bones) {
      this.uuid = json.uuid;
      for (let i2 = 0, l2 = json.bones.length; i2 < l2; i2++) {
        const uuid = json.bones[i2];
        let bone = bones[uuid];
        if (bone === void 0) {
          console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
          bone = new Bone();
        }
        this.bones.push(bone);
        this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i2]));
      }
      this.init();
      return this;
    }
    /**
     * Serializes the skeleton into JSON.
     *
     * @return {Object} A JSON object representing the serialized skeleton.
     * @see {@link ObjectLoader#parse}
     */
    toJSON() {
      const data = {
        metadata: {
          version: 4.7,
          type: "Skeleton",
          generator: "Skeleton.toJSON"
        },
        bones: [],
        boneInverses: []
      };
      data.uuid = this.uuid;
      const bones = this.bones;
      const boneInverses = this.boneInverses;
      for (let i2 = 0, l2 = bones.length; i2 < l2; i2++) {
        const bone = bones[i2];
        data.bones.push(bone.uuid);
        const boneInverse = boneInverses[i2];
        data.boneInverses.push(boneInverse.toArray());
      }
      return data;
    }
  }
  class InstancedBufferAttribute extends BufferAttribute {
    /**
     * Constructs a new instanced buffer attribute.
     *
     * @param {TypedArray} array - The array holding the attribute data.
     * @param {number} itemSize - The item size.
     * @param {boolean} [normalized=false] - Whether the data are normalized or not.
     * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
     */
    constructor(array, itemSize, normalized, meshPerAttribute = 1) {
      super(array, itemSize, normalized);
      this.isInstancedBufferAttribute = true;
      this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
      super.copy(source);
      this.meshPerAttribute = source.meshPerAttribute;
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.meshPerAttribute = this.meshPerAttribute;
      data.isInstancedBufferAttribute = true;
      return data;
    }
  }
  const _instanceLocalMatrix = /* @__PURE__ */ new Matrix4();
  const _instanceWorldMatrix = /* @__PURE__ */ new Matrix4();
  const _instanceIntersects = [];
  const _box3 = /* @__PURE__ */ new Box3();
  const _identity = /* @__PURE__ */ new Matrix4();
  const _mesh$1 = /* @__PURE__ */ new Mesh();
  const _sphere$4 = /* @__PURE__ */ new Sphere();
  class InstancedMesh extends Mesh {
    /**
     * Constructs a new instanced mesh.
     *
     * @param {BufferGeometry} [geometry] - The mesh geometry.
     * @param {Material|Array<Material>} [material] - The mesh material.
     * @param {number} count - The number of instances.
     */
    constructor(geometry, material, count) {
      super(geometry, material);
      this.isInstancedMesh = true;
      this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count * 16), 16);
      this.instanceColor = null;
      this.morphTexture = null;
      this.count = count;
      this.boundingBox = null;
      this.boundingSphere = null;
      for (let i2 = 0; i2 < count; i2++) {
        this.setMatrixAt(i2, _identity);
      }
    }
    /**
     * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
     * The bounding box is not automatically computed by the engine; this method must be called by your app.
     * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
     */
    computeBoundingBox() {
      const geometry = this.geometry;
      const count = this.count;
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }
      if (geometry.boundingBox === null) {
        geometry.computeBoundingBox();
      }
      this.boundingBox.makeEmpty();
      for (let i2 = 0; i2 < count; i2++) {
        this.getMatrixAt(i2, _instanceLocalMatrix);
        _box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix);
        this.boundingBox.union(_box3);
      }
    }
    /**
     * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
     * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
     * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
     */
    computeBoundingSphere() {
      const geometry = this.geometry;
      const count = this.count;
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }
      if (geometry.boundingSphere === null) {
        geometry.computeBoundingSphere();
      }
      this.boundingSphere.makeEmpty();
      for (let i2 = 0; i2 < count; i2++) {
        this.getMatrixAt(i2, _instanceLocalMatrix);
        _sphere$4.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix);
        this.boundingSphere.union(_sphere$4);
      }
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.instanceMatrix.copy(source.instanceMatrix);
      if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
      if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
      this.count = source.count;
      if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
      if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
      return this;
    }
    /**
     * Gets the color of the defined instance.
     *
     * @param {number} index - The instance index.
     * @param {Color} color - The target object that is used to store the method's result.
     */
    getColorAt(index, color) {
      color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
     * Gets the local transformation matrix of the defined instance.
     *
     * @param {number} index - The instance index.
     * @param {Matrix4} matrix - The target object that is used to store the method's result.
     */
    getMatrixAt(index, matrix) {
      matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
     * Gets the morph target weights of the defined instance.
     *
     * @param {number} index - The instance index.
     * @param {Mesh} object - The target object that is used to store the method's result.
     */
    getMorphAt(index, object) {
      const objectInfluences = object.morphTargetInfluences;
      const array = this.morphTexture.source.data.data;
      const len = objectInfluences.length + 1;
      const dataIndex = index * len + 1;
      for (let i2 = 0; i2 < objectInfluences.length; i2++) {
        objectInfluences[i2] = array[dataIndex + i2];
      }
    }
    raycast(raycaster, intersects2) {
      const matrixWorld = this.matrixWorld;
      const raycastTimes = this.count;
      _mesh$1.geometry = this.geometry;
      _mesh$1.material = this.material;
      if (_mesh$1.material === void 0) return;
      if (this.boundingSphere === null) this.computeBoundingSphere();
      _sphere$4.copy(this.boundingSphere);
      _sphere$4.applyMatrix4(matrixWorld);
      if (raycaster.ray.intersectsSphere(_sphere$4) === false) return;
      for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
        this.getMatrixAt(instanceId, _instanceLocalMatrix);
        _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
        _mesh$1.matrixWorld = _instanceWorldMatrix;
        _mesh$1.raycast(raycaster, _instanceIntersects);
        for (let i2 = 0, l2 = _instanceIntersects.length; i2 < l2; i2++) {
          const intersect2 = _instanceIntersects[i2];
          intersect2.instanceId = instanceId;
          intersect2.object = this;
          intersects2.push(intersect2);
        }
        _instanceIntersects.length = 0;
      }
    }
    /**
     * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
     * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
     *
     * @param {number} index - The instance index.
     * @param {Color} color - The instance color.
     */
    setColorAt(index, color) {
      if (this.instanceColor === null) {
        this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
      }
      color.toArray(this.instanceColor.array, index * 3);
    }
    /**
     * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
     * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
     *
     * @param {number} index - The instance index.
     * @param {Matrix4} matrix - The local transformation.
     */
    setMatrixAt(index, matrix) {
      matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
     * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
     * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
     *
     * @param {number} index - The instance index.
     * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
     * of a single instance.
     */
    setMorphAt(index, object) {
      const objectInfluences = object.morphTargetInfluences;
      const len = objectInfluences.length + 1;
      if (this.morphTexture === null) {
        this.morphTexture = new DataTexture(new Float32Array(len * this.count), len, this.count, RedFormat, FloatType);
      }
      const array = this.morphTexture.source.data.data;
      let morphInfluencesSum = 0;
      for (let i2 = 0; i2 < objectInfluences.length; i2++) {
        morphInfluencesSum += objectInfluences[i2];
      }
      const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      const dataIndex = len * index;
      array[dataIndex] = morphBaseInfluence;
      array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     */
    dispose() {
      this.dispatchEvent({ type: "dispose" });
      if (this.morphTexture !== null) {
        this.morphTexture.dispose();
        this.morphTexture = null;
      }
    }
  }
  const _vector1 = /* @__PURE__ */ new Vector3();
  const _vector2 = /* @__PURE__ */ new Vector3();
  const _normalMatrix = /* @__PURE__ */ new Matrix3();
  class Plane {
    /**
     * Constructs a new plane.
     *
     * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
     * @param {number} [constant=0] - The signed distance from the origin to the plane.
     */
    constructor(normal = new Vector3(1, 0, 0), constant = 0) {
      this.isPlane = true;
      this.normal = normal;
      this.constant = constant;
    }
    /**
     * Sets the plane components by copying the given values.
     *
     * @param {Vector3} normal - The normal.
     * @param {number} constant - The constant.
     * @return {Plane} A reference to this plane.
     */
    set(normal, constant) {
      this.normal.copy(normal);
      this.constant = constant;
      return this;
    }
    /**
     * Sets the plane components by defining `x`, `y`, `z` as the
     * plane normal and `w` as the constant.
     *
     * @param {number} x - The value for the normal's x component.
     * @param {number} y - The value for the normal's y component.
     * @param {number} z - The value for the normal's z component.
     * @param {number} w - The constant value.
     * @return {Plane} A reference to this plane.
     */
    setComponents(x2, y2, z2, w2) {
      this.normal.set(x2, y2, z2);
      this.constant = w2;
      return this;
    }
    /**
     * Sets the plane from the given normal and coplanar point (that is a point
     * that lies onto the plane).
     *
     * @param {Vector3} normal - The normal.
     * @param {Vector3} point - A coplanar point.
     * @return {Plane} A reference to this plane.
     */
    setFromNormalAndCoplanarPoint(normal, point) {
      this.normal.copy(normal);
      this.constant = -point.dot(this.normal);
      return this;
    }
    /**
     * Sets the plane from three coplanar points. The winding order is
     * assumed to be counter-clockwise, and determines the direction of
     * the plane normal.
     *
     * @param {Vector3} a - The first coplanar point.
     * @param {Vector3} b - The second coplanar point.
     * @param {Vector3} c - The third coplanar point.
     * @return {Plane} A reference to this plane.
     */
    setFromCoplanarPoints(a2, b2, c2) {
      const normal = _vector1.subVectors(c2, b2).cross(_vector2.subVectors(a2, b2)).normalize();
      this.setFromNormalAndCoplanarPoint(normal, a2);
      return this;
    }
    /**
     * Copies the values of the given plane to this instance.
     *
     * @param {Plane} plane - The plane to copy.
     * @return {Plane} A reference to this plane.
     */
    copy(plane) {
      this.normal.copy(plane.normal);
      this.constant = plane.constant;
      return this;
    }
    /**
     * Normalizes the plane normal and adjusts the constant accordingly.
     *
     * @return {Plane} A reference to this plane.
     */
    normalize() {
      const inverseNormalLength = 1 / this.normal.length();
      this.normal.multiplyScalar(inverseNormalLength);
      this.constant *= inverseNormalLength;
      return this;
    }
    /**
     * Negates both the plane normal and the constant.
     *
     * @return {Plane} A reference to this plane.
     */
    negate() {
      this.constant *= -1;
      this.normal.negate();
      return this;
    }
    /**
     * Returns the signed distance from the given point to this plane.
     *
     * @param {Vector3} point - The point to compute the distance for.
     * @return {number} The signed distance.
     */
    distanceToPoint(point) {
      return this.normal.dot(point) + this.constant;
    }
    /**
     * Returns the signed distance from the given sphere to this plane.
     *
     * @param {Sphere} sphere - The sphere to compute the distance for.
     * @return {number} The signed distance.
     */
    distanceToSphere(sphere) {
      return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
     * Projects a the given point onto the plane.
     *
     * @param {Vector3} point - The point to project.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The projected point on the plane.
     */
    projectPoint(point, target) {
      return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
     * Returns the intersection point of the passed line and the plane. Returns
     * `null` if the line does not intersect. Returns the line's starting point if
     * the line is coplanar with the plane.
     *
     * @param {Line3} line - The line to compute the intersection for.
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {?Vector3} The intersection point.
     */
    intersectLine(line, target) {
      const direction = line.delta(_vector1);
      const denominator = this.normal.dot(direction);
      if (denominator === 0) {
        if (this.distanceToPoint(line.start) === 0) {
          return target.copy(line.start);
        }
        return null;
      }
      const t2 = -(line.start.dot(this.normal) + this.constant) / denominator;
      if (t2 < 0 || t2 > 1) {
        return null;
      }
      return target.copy(line.start).addScaledVector(direction, t2);
    }
    /**
     * Returns `true` if the given line segment intersects with (passes through) the plane.
     *
     * @param {Line3} line - The line to test.
     * @return {boolean} Whether the given line segment intersects with the plane or not.
     */
    intersectsLine(line) {
      const startSign = this.distanceToPoint(line.start);
      const endSign = this.distanceToPoint(line.end);
      return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
     * Returns `true` if the given bounding box intersects with the plane.
     *
     * @param {Box3} box - The bounding box to test.
     * @return {boolean} Whether the given bounding box intersects with the plane or not.
     */
    intersectsBox(box) {
      return box.intersectsPlane(this);
    }
    /**
     * Returns `true` if the given bounding sphere intersects with the plane.
     *
     * @param {Sphere} sphere - The bounding sphere to test.
     * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
     */
    intersectsSphere(sphere) {
      return sphere.intersectsPlane(this);
    }
    /**
     * Returns a coplanar vector to the plane, by calculating the
     * projection of the normal at the origin onto the plane.
     *
     * @param {Vector3} target - The target vector that is used to store the method's result.
     * @return {Vector3} The coplanar point.
     */
    coplanarPoint(target) {
      return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
     * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
     *
     * The optional normal matrix can be pre-computed like so:
     * ```js
     * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
     * ```
     *
     * @param {Matrix4} matrix - The transformation matrix.
     * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
     * @return {Plane} A reference to this plane.
     */
    applyMatrix4(matrix, optionalNormalMatrix) {
      const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
      const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
      const normal = this.normal.applyMatrix3(normalMatrix).normalize();
      this.constant = -referencePoint.dot(normal);
      return this;
    }
    /**
     * Translates the plane by the distance defined by the given offset vector.
     * Note that this only affects the plane constant and will not affect the normal vector.
     *
     * @param {Vector3} offset - The offset vector.
     * @return {Plane} A reference to this plane.
     */
    translate(offset) {
      this.constant -= offset.dot(this.normal);
      return this;
    }
    /**
     * Returns `true` if this plane is equal with the given one.
     *
     * @param {Plane} plane - The plane to test for equality.
     * @return {boolean} Whether this plane is equal with the given one.
     */
    equals(plane) {
      return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
     * Returns a new plane with copied values from this instance.
     *
     * @return {Plane} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
  }
  const _sphere$3 = /* @__PURE__ */ new Sphere();
  const _defaultSpriteCenter = /* @__PURE__ */ new Vector2(0.5, 0.5);
  const _vector$6 = /* @__PURE__ */ new Vector3();
  class Frustum {
    /**
     * Constructs a new frustum.
     *
     * @param {Plane} [p0] - The first plane that encloses the frustum.
     * @param {Plane} [p1] - The second plane that encloses the frustum.
     * @param {Plane} [p2] - The third plane that encloses the frustum.
     * @param {Plane} [p3] - The fourth plane that encloses the frustum.
     * @param {Plane} [p4] - The fifth plane that encloses the frustum.
     * @param {Plane} [p5] - The sixth plane that encloses the frustum.
     */
    constructor(p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane()) {
      this.planes = [p0, p1, p2, p3, p4, p5];
    }
    /**
     * Sets the frustum planes by copying the given planes.
     *
     * @param {Plane} [p0] - The first plane that encloses the frustum.
     * @param {Plane} [p1] - The second plane that encloses the frustum.
     * @param {Plane} [p2] - The third plane that encloses the frustum.
     * @param {Plane} [p3] - The fourth plane that encloses the frustum.
     * @param {Plane} [p4] - The fifth plane that encloses the frustum.
     * @param {Plane} [p5] - The sixth plane that encloses the frustum.
     * @return {Frustum} A reference to this frustum.
     */
    set(p0, p1, p2, p3, p4, p5) {
      const planes = this.planes;
      planes[0].copy(p0);
      planes[1].copy(p1);
      planes[2].copy(p2);
      planes[3].copy(p3);
      planes[4].copy(p4);
      planes[5].copy(p5);
      return this;
    }
    /**
     * Copies the values of the given frustum to this instance.
     *
     * @param {Frustum} frustum - The frustum to copy.
     * @return {Frustum} A reference to this frustum.
     */
    copy(frustum) {
      const planes = this.planes;
      for (let i2 = 0; i2 < 6; i2++) {
        planes[i2].copy(frustum.planes[i2]);
      }
      return this;
    }
    /**
     * Sets the frustum planes from the given projection matrix.
     *
     * @param {Matrix4} m - The projection matrix.
     * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
     * @return {Frustum} A reference to this frustum.
     */
    setFromProjectionMatrix(m, coordinateSystem = WebGLCoordinateSystem) {
      const planes = this.planes;
      const me2 = m.elements;
      const me0 = me2[0], me1 = me2[1], me22 = me2[2], me3 = me2[3];
      const me4 = me2[4], me5 = me2[5], me6 = me2[6], me7 = me2[7];
      const me8 = me2[8], me9 = me2[9], me10 = me2[10], me11 = me2[11];
      const me12 = me2[12], me13 = me2[13], me14 = me2[14], me15 = me2[15];
      planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
      planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
      planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
      planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
      planes[4].setComponents(me3 - me22, me7 - me6, me11 - me10, me15 - me14).normalize();
      if (coordinateSystem === WebGLCoordinateSystem) {
        planes[5].setComponents(me3 + me22, me7 + me6, me11 + me10, me15 + me14).normalize();
      } else if (coordinateSystem === WebGPUCoordinateSystem) {
        planes[5].setComponents(me22, me6, me10, me14).normalize();
      } else {
        throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
      }
      return this;
    }
    /**
     * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
     *
     * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
     *
     * @param {Object3D} object - The 3D object to test.
     * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
     */
    intersectsObject(object) {
      if (object.boundingSphere !== void 0) {
        if (object.boundingSphere === null) object.computeBoundingSphere();
        _sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
      } else {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
      }
      return this.intersectsSphere(_sphere$3);
    }
    /**
     * Returns `true` if the given sprite is intersecting this frustum.
     *
     * @param {Sprite} sprite - The sprite to test.
     * @return {boolean} Whether the sprite is intersecting this frustum or not.
     */
    intersectsSprite(sprite) {
      _sphere$3.center.set(0, 0, 0);
      const offset = _defaultSpriteCenter.distanceTo(sprite.center);
      _sphere$3.radius = 0.7071067811865476 + offset;
      _sphere$3.applyMatrix4(sprite.matrixWorld);
      return this.intersectsSphere(_sphere$3);
    }
    /**
     * Returns `true` if the given bounding sphere is intersecting this frustum.
     *
     * @param {Sphere} sphere - The bounding sphere to test.
     * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
     */
    intersectsSphere(sphere) {
      const planes = this.planes;
      const center = sphere.center;
      const negRadius = -sphere.radius;
      for (let i2 = 0; i2 < 6; i2++) {
        const distance = planes[i2].distanceToPoint(center);
        if (distance < negRadius) {
          return false;
        }
      }
      return true;
    }
    /**
     * Returns `true` if the given bounding box is intersecting this frustum.
     *
     * @param {Box3} box - The bounding box to test.
     * @return {boolean} Whether the bounding box is intersecting this frustum or not.
     */
    intersectsBox(box) {
      const planes = this.planes;
      for (let i2 = 0; i2 < 6; i2++) {
        const plane = planes[i2];
        _vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
        _vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
        _vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
        if (plane.distanceToPoint(_vector$6) < 0) {
          return false;
        }
      }
      return true;
    }
    /**
     * Returns `true` if the given point lies within the frustum.
     *
     * @param {Vector3} point - The point to test.
     * @return {boolean} Whether the point lies within this frustum or not.
     */
    containsPoint(point) {
      const planes = this.planes;
      for (let i2 = 0; i2 < 6; i2++) {
        if (planes[i2].distanceToPoint(point) < 0) {
          return false;
        }
      }
      return true;
    }
    /**
     * Returns a new frustum with copied values from this instance.
     *
     * @return {Frustum} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
  }
  class LineBasicMaterial extends Material {
    /**
     * Constructs a new line basic material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isLineBasicMaterial = true;
      this.type = "LineBasicMaterial";
      this.color = new Color(16777215);
      this.map = null;
      this.linewidth = 1;
      this.linecap = "round";
      this.linejoin = "round";
      this.fog = true;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.color.copy(source.color);
      this.map = source.map;
      this.linewidth = source.linewidth;
      this.linecap = source.linecap;
      this.linejoin = source.linejoin;
      this.fog = source.fog;
      return this;
    }
  }
  const _vStart = /* @__PURE__ */ new Vector3();
  const _vEnd = /* @__PURE__ */ new Vector3();
  const _inverseMatrix$1 = /* @__PURE__ */ new Matrix4();
  const _ray$1 = /* @__PURE__ */ new Ray();
  const _sphere$1 = /* @__PURE__ */ new Sphere();
  const _intersectPointOnRay = /* @__PURE__ */ new Vector3();
  const _intersectPointOnSegment = /* @__PURE__ */ new Vector3();
  class Line extends Object3D {
    /**
     * Constructs a new line.
     *
     * @param {BufferGeometry} [geometry] - The line geometry.
     * @param {Material|Array<Material>} [material] - The line material.
     */
    constructor(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
      super();
      this.isLine = true;
      this.type = "Line";
      this.geometry = geometry;
      this.material = material;
      this.morphTargetDictionary = void 0;
      this.morphTargetInfluences = void 0;
      this.updateMorphTargets();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
      this.geometry = source.geometry;
      return this;
    }
    /**
     * Computes an array of distance values which are necessary for rendering dashed lines.
     * For each vertex in the geometry, the method calculates the cumulative length from the
     * current point to the very beginning of the line.
     *
     * @return {Line} A reference to this line.
     */
    computeLineDistances() {
      const geometry = this.geometry;
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [0];
        for (let i2 = 1, l2 = positionAttribute.count; i2 < l2; i2++) {
          _vStart.fromBufferAttribute(positionAttribute, i2 - 1);
          _vEnd.fromBufferAttribute(positionAttribute, i2);
          lineDistances[i2] = lineDistances[i2 - 1];
          lineDistances[i2] += _vStart.distanceTo(_vEnd);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
      return this;
    }
    /**
     * Computes intersection points between a casted ray and this line.
     *
     * @param {Raycaster} raycaster - The raycaster.
     * @param {Array<Object>} intersects - The target array that holds the intersection points.
     */
    raycast(raycaster, intersects2) {
      const geometry = this.geometry;
      const matrixWorld = this.matrixWorld;
      const threshold = raycaster.params.Line.threshold;
      const drawRange = geometry.drawRange;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
      _sphere$1.copy(geometry.boundingSphere);
      _sphere$1.applyMatrix4(matrixWorld);
      _sphere$1.radius += threshold;
      if (raycaster.ray.intersectsSphere(_sphere$1) === false) return;
      _inverseMatrix$1.copy(matrixWorld).invert();
      _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
      const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
      const localThresholdSq = localThreshold * localThreshold;
      const step = this.isLineSegments ? 2 : 1;
      const index = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
          const a2 = index.getX(i2);
          const b2 = index.getX(i2 + 1);
          const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a2, b2, i2);
          if (intersect2) {
            intersects2.push(intersect2);
          }
        }
        if (this.isLineLoop) {
          const a2 = index.getX(end - 1);
          const b2 = index.getX(start);
          const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a2, b2, end - 1);
          if (intersect2) {
            intersects2.push(intersect2);
          }
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end - 1; i2 < l2; i2 += step) {
          const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, i2, i2 + 1, i2);
          if (intersect2) {
            intersects2.push(intersect2);
          }
        }
        if (this.isLineLoop) {
          const intersect2 = checkIntersection(this, raycaster, _ray$1, localThresholdSq, end - 1, start, end - 1);
          if (intersect2) {
            intersects2.push(intersect2);
          }
        }
      }
    }
    /**
     * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
     * to make sure existing morph targets can influence this 3D object.
     */
    updateMorphTargets() {
      const geometry = this.geometry;
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    }
  }
  function checkIntersection(object, raycaster, ray, thresholdSq, a2, b2, i2) {
    const positionAttribute = object.geometry.attributes.position;
    _vStart.fromBufferAttribute(positionAttribute, a2);
    _vEnd.fromBufferAttribute(positionAttribute, b2);
    const distSq = ray.distanceSqToSegment(_vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    _intersectPointOnRay.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
      distance,
      // What do we want? intersection point on the ray or on the segment??
      // point: raycaster.ray.at( distance ),
      point: _intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
      index: i2,
      face: null,
      faceIndex: null,
      barycoord: null,
      object
    };
  }
  const _start = /* @__PURE__ */ new Vector3();
  const _end = /* @__PURE__ */ new Vector3();
  class LineSegments extends Line {
    /**
     * Constructs a new line segments.
     *
     * @param {BufferGeometry} [geometry] - The line geometry.
     * @param {Material|Array<Material>} [material] - The line material.
     */
    constructor(geometry, material) {
      super(geometry, material);
      this.isLineSegments = true;
      this.type = "LineSegments";
    }
    computeLineDistances() {
      const geometry = this.geometry;
      if (geometry.index === null) {
        const positionAttribute = geometry.attributes.position;
        const lineDistances = [];
        for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2 += 2) {
          _start.fromBufferAttribute(positionAttribute, i2);
          _end.fromBufferAttribute(positionAttribute, i2 + 1);
          lineDistances[i2] = i2 === 0 ? 0 : lineDistances[i2 - 1];
          lineDistances[i2 + 1] = lineDistances[i2] + _start.distanceTo(_end);
        }
        geometry.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
      return this;
    }
  }
  class LineLoop extends Line {
    /**
     * Constructs a new line loop.
     *
     * @param {BufferGeometry} [geometry] - The line geometry.
     * @param {Material|Array<Material>} [material] - The line material.
     */
    constructor(geometry, material) {
      super(geometry, material);
      this.isLineLoop = true;
      this.type = "LineLoop";
    }
  }
  class PointsMaterial extends Material {
    /**
     * Constructs a new points material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isPointsMaterial = true;
      this.type = "PointsMaterial";
      this.color = new Color(16777215);
      this.map = null;
      this.alphaMap = null;
      this.size = 1;
      this.sizeAttenuation = true;
      this.fog = true;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.color.copy(source.color);
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.size = source.size;
      this.sizeAttenuation = source.sizeAttenuation;
      this.fog = source.fog;
      return this;
    }
  }
  const _inverseMatrix = /* @__PURE__ */ new Matrix4();
  const _ray$4 = /* @__PURE__ */ new Ray();
  const _sphere = /* @__PURE__ */ new Sphere();
  const _position$2 = /* @__PURE__ */ new Vector3();
  class Points extends Object3D {
    /**
     * Constructs a new point cloud.
     *
     * @param {BufferGeometry} [geometry] - The points geometry.
     * @param {Material|Array<Material>} [material] - The points material.
     */
    constructor(geometry = new BufferGeometry(), material = new PointsMaterial()) {
      super();
      this.isPoints = true;
      this.type = "Points";
      this.geometry = geometry;
      this.material = material;
      this.morphTargetDictionary = void 0;
      this.morphTargetInfluences = void 0;
      this.updateMorphTargets();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
      this.geometry = source.geometry;
      return this;
    }
    /**
     * Computes intersection points between a casted ray and this point cloud.
     *
     * @param {Raycaster} raycaster - The raycaster.
     * @param {Array<Object>} intersects - The target array that holds the intersection points.
     */
    raycast(raycaster, intersects2) {
      const geometry = this.geometry;
      const matrixWorld = this.matrixWorld;
      const threshold = raycaster.params.Points.threshold;
      const drawRange = geometry.drawRange;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
      _sphere.copy(geometry.boundingSphere);
      _sphere.applyMatrix4(matrixWorld);
      _sphere.radius += threshold;
      if (raycaster.ray.intersectsSphere(_sphere) === false) return;
      _inverseMatrix.copy(matrixWorld).invert();
      _ray$4.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
      const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
      const localThresholdSq = localThreshold * localThreshold;
      const index = geometry.index;
      const attributes = geometry.attributes;
      const positionAttribute = attributes.position;
      if (index !== null) {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(index.count, drawRange.start + drawRange.count);
        for (let i2 = start, il = end; i2 < il; i2++) {
          const a2 = index.getX(i2);
          _position$2.fromBufferAttribute(positionAttribute, a2);
          testPoint(_position$2, a2, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      } else {
        const start = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start, l2 = end; i2 < l2; i2++) {
          _position$2.fromBufferAttribute(positionAttribute, i2);
          testPoint(_position$2, i2, localThresholdSq, matrixWorld, raycaster, intersects2, this);
        }
      }
    }
    /**
     * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
     * to make sure existing morph targets can influence this 3D object.
     */
    updateMorphTargets() {
      const geometry = this.geometry;
      const morphAttributes = geometry.morphAttributes;
      const keys = Object.keys(morphAttributes);
      if (keys.length > 0) {
        const morphAttribute = morphAttributes[keys[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m = 0, ml = morphAttribute.length; m < ml; m++) {
            const name = morphAttribute[m].name || String(m);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name] = m;
          }
        }
      }
    }
  }
  function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects2, object) {
    const rayPointDistanceSq = _ray$4.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
      const intersectPoint = new Vector3();
      _ray$4.closestPointToPoint(point, intersectPoint);
      intersectPoint.applyMatrix4(matrixWorld);
      const distance = raycaster.ray.origin.distanceTo(intersectPoint);
      if (distance < raycaster.near || distance > raycaster.far) return;
      intersects2.push({
        distance,
        distanceToRay: Math.sqrt(rayPointDistanceSq),
        point: intersectPoint,
        index,
        face: null,
        faceIndex: null,
        barycoord: null,
        object
      });
    }
  }
  class CanvasTexture extends Texture {
    /**
     * Constructs a new texture.
     *
     * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
     * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
     * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
     * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
     * @param {number} [magFilter=LinearFilter] - The mag filter value.
     * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
     * @param {number} [format=RGBAFormat] - The texture format.
     * @param {number} [type=UnsignedByteType] - The texture type.
     * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
     */
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
      super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
      this.isCanvasTexture = true;
      this.needsUpdate = true;
    }
  }
  class DepthTexture extends Texture {
    /**
     * Constructs a new depth texture.
     *
     * @param {number} width - The width of the texture.
     * @param {number} height - The height of the texture.
     * @param {number} [type=UnsignedIntType] - The texture type.
     * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
     * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
     * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
     * @param {number} [magFilter=LinearFilter] - The mag filter value.
     * @param {number} [minFilter=LinearFilter] - The min filter value.
     * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
     * @param {number} [format=DepthFormat] - The texture format.
     * @param {number} [depth=1] - The depth of the texture.
     */
    constructor(width, height, type = UnsignedIntType, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, format = DepthFormat, depth = 1) {
      if (format !== DepthFormat && format !== DepthStencilFormat) {
        throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
      }
      const image = { width, height, depth };
      super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
      this.isDepthTexture = true;
      this.flipY = false;
      this.generateMipmaps = false;
      this.compareFunction = null;
    }
    copy(source) {
      super.copy(source);
      this.source = new Source(Object.assign({}, source.image));
      this.compareFunction = source.compareFunction;
      return this;
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
      return data;
    }
  }
  class CircleGeometry extends BufferGeometry {
    /**
     * Constructs a new circle geometry.
     *
     * @param {number} [radius=1] - Radius of the circle.
     * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
     * @param {number} [thetaStart=0] - Start angle for first segment in radians.
     * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
     * of the circular sector in radians. The default value results in a complete circle.
     */
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2) {
      super();
      this.type = "CircleGeometry";
      this.parameters = {
        radius,
        segments,
        thetaStart,
        thetaLength
      };
      segments = Math.max(3, segments);
      const indices = [];
      const vertices = [];
      const normals = [];
      const uvs = [];
      const vertex2 = new Vector3();
      const uv = new Vector2();
      vertices.push(0, 0, 0);
      normals.push(0, 0, 1);
      uvs.push(0.5, 0.5);
      for (let s2 = 0, i2 = 3; s2 <= segments; s2++, i2 += 3) {
        const segment = thetaStart + s2 / segments * thetaLength;
        vertex2.x = radius * Math.cos(segment);
        vertex2.y = radius * Math.sin(segment);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, 0, 1);
        uv.x = (vertices[i2] / radius + 1) / 2;
        uv.y = (vertices[i2 + 1] / radius + 1) / 2;
        uvs.push(uv.x, uv.y);
      }
      for (let i2 = 1; i2 <= segments; i2++) {
        indices.push(i2, i2 + 1, 0);
      }
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {CircleGeometry} A new instance.
     */
    static fromJSON(data) {
      return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
  }
  class CylinderGeometry extends BufferGeometry {
    /**
     * Constructs a new cylinder geometry.
     *
     * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
     * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
     * @param {number} [height=1] - Height of the cylinder.
     * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
     * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
     * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
     * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
     * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
     * The default value results in a complete cylinder.
     */
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
      super();
      this.type = "CylinderGeometry";
      this.parameters = {
        radiusTop,
        radiusBottom,
        height,
        radialSegments,
        heightSegments,
        openEnded,
        thetaStart,
        thetaLength
      };
      const scope = this;
      radialSegments = Math.floor(radialSegments);
      heightSegments = Math.floor(heightSegments);
      const indices = [];
      const vertices = [];
      const normals = [];
      const uvs = [];
      let index = 0;
      const indexArray = [];
      const halfHeight = height / 2;
      let groupStart = 0;
      generateTorso();
      if (openEnded === false) {
        if (radiusTop > 0) generateCap(true);
        if (radiusBottom > 0) generateCap(false);
      }
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
      function generateTorso() {
        const normal = new Vector3();
        const vertex2 = new Vector3();
        let groupCount = 0;
        const slope = (radiusBottom - radiusTop) / height;
        for (let y2 = 0; y2 <= heightSegments; y2++) {
          const indexRow = [];
          const v2 = y2 / heightSegments;
          const radius = v2 * (radiusBottom - radiusTop) + radiusTop;
          for (let x2 = 0; x2 <= radialSegments; x2++) {
            const u2 = x2 / radialSegments;
            const theta = u2 * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            vertex2.x = radius * sinTheta;
            vertex2.y = -v2 * height + halfHeight;
            vertex2.z = radius * cosTheta;
            vertices.push(vertex2.x, vertex2.y, vertex2.z);
            normal.set(sinTheta, slope, cosTheta).normalize();
            normals.push(normal.x, normal.y, normal.z);
            uvs.push(u2, 1 - v2);
            indexRow.push(index++);
          }
          indexArray.push(indexRow);
        }
        for (let x2 = 0; x2 < radialSegments; x2++) {
          for (let y2 = 0; y2 < heightSegments; y2++) {
            const a2 = indexArray[y2][x2];
            const b2 = indexArray[y2 + 1][x2];
            const c2 = indexArray[y2 + 1][x2 + 1];
            const d2 = indexArray[y2][x2 + 1];
            if (radiusTop > 0 || y2 !== 0) {
              indices.push(a2, b2, d2);
              groupCount += 3;
            }
            if (radiusBottom > 0 || y2 !== heightSegments - 1) {
              indices.push(b2, c2, d2);
              groupCount += 3;
            }
          }
        }
        scope.addGroup(groupStart, groupCount, 0);
        groupStart += groupCount;
      }
      function generateCap(top) {
        const centerIndexStart = index;
        const uv = new Vector2();
        const vertex2 = new Vector3();
        let groupCount = 0;
        const radius = top === true ? radiusTop : radiusBottom;
        const sign2 = top === true ? 1 : -1;
        for (let x2 = 1; x2 <= radialSegments; x2++) {
          vertices.push(0, halfHeight * sign2, 0);
          normals.push(0, sign2, 0);
          uvs.push(0.5, 0.5);
          index++;
        }
        const centerIndexEnd = index;
        for (let x2 = 0; x2 <= radialSegments; x2++) {
          const u2 = x2 / radialSegments;
          const theta = u2 * thetaLength + thetaStart;
          const cosTheta = Math.cos(theta);
          const sinTheta = Math.sin(theta);
          vertex2.x = radius * sinTheta;
          vertex2.y = halfHeight * sign2;
          vertex2.z = radius * cosTheta;
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
          normals.push(0, sign2, 0);
          uv.x = cosTheta * 0.5 + 0.5;
          uv.y = sinTheta * 0.5 * sign2 + 0.5;
          uvs.push(uv.x, uv.y);
          index++;
        }
        for (let x2 = 0; x2 < radialSegments; x2++) {
          const c2 = centerIndexStart + x2;
          const i2 = centerIndexEnd + x2;
          if (top === true) {
            indices.push(i2, i2 + 1, c2);
          } else {
            indices.push(i2 + 1, i2, c2);
          }
          groupCount += 3;
        }
        scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
        groupStart += groupCount;
      }
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {CylinderGeometry} A new instance.
     */
    static fromJSON(data) {
      return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
  }
  class Curve {
    /**
     * Constructs a new curve.
     */
    constructor() {
      this.type = "Curve";
      this.arcLengthDivisions = 200;
      this.needsUpdate = false;
      this.cacheArcLengths = null;
    }
    /**
     * This method returns a vector in 2D or 3D space (depending on the curve definition)
     * for the given interpolation factor.
     *
     * @abstract
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
     * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
     */
    getPoint() {
      console.warn("THREE.Curve: .getPoint() not implemented.");
    }
    /**
     * This method returns a vector in 2D or 3D space (depending on the curve definition)
     * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
     * of the curve which equidistant samples.
     *
     * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
     * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
     */
    getPointAt(u2, optionalTarget) {
      const t2 = this.getUtoTmapping(u2);
      return this.getPoint(t2, optionalTarget);
    }
    /**
     * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
     * the curve shape.
     *
     * @param {number} [divisions=5] - The number of divisions.
     * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
     */
    getPoints(divisions = 5) {
      const points = [];
      for (let d2 = 0; d2 <= divisions; d2++) {
        points.push(this.getPoint(d2 / divisions));
      }
      return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
     * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
     * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
     * curve.
     *
     * @param {number} [divisions=5] - The number of divisions.
     * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
     */
    getSpacedPoints(divisions = 5) {
      const points = [];
      for (let d2 = 0; d2 <= divisions; d2++) {
        points.push(this.getPointAt(d2 / divisions));
      }
      return points;
    }
    /**
     * Returns the total arc length of the curve.
     *
     * @return {number} The length of the curve.
     */
    getLength() {
      const lengths = this.getLengths();
      return lengths[lengths.length - 1];
    }
    /**
     * Returns an array of cumulative segment lengths of the curve.
     *
     * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
     * @return {Array<number>} An array holding the cumulative segment lengths.
     */
    getLengths(divisions = this.arcLengthDivisions) {
      if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
        return this.cacheArcLengths;
      }
      this.needsUpdate = false;
      const cache = [];
      let current, last = this.getPoint(0);
      let sum = 0;
      cache.push(0);
      for (let p2 = 1; p2 <= divisions; p2++) {
        current = this.getPoint(p2 / divisions);
        sum += current.distanceTo(last);
        cache.push(sum);
        last = current;
      }
      this.cacheArcLengths = cache;
      return cache;
    }
    /**
     * Update the cumulative segment distance cache. The method must be called
     * every time curve parameters are changed. If an updated curve is part of a
     * composed curve like {@link CurvePath}, this method must be called on the
     * composed curve, too.
     */
    updateArcLengths() {
      this.needsUpdate = true;
      this.getLengths();
    }
    /**
     * Given an interpolation factor in the range `[0,1]`, this method returns an updated
     * interpolation factor in the same range that can be ued to sample equidistant points
     * from a curve.
     *
     * @param {number} u - The interpolation factor.
     * @param {?number} distance - An optional distance on the curve.
     * @return {number} The updated interpolation factor.
     */
    getUtoTmapping(u2, distance = null) {
      const arcLengths = this.getLengths();
      let i2 = 0;
      const il = arcLengths.length;
      let targetArcLength;
      if (distance) {
        targetArcLength = distance;
      } else {
        targetArcLength = u2 * arcLengths[il - 1];
      }
      let low = 0, high = il - 1, comparison;
      while (low <= high) {
        i2 = Math.floor(low + (high - low) / 2);
        comparison = arcLengths[i2] - targetArcLength;
        if (comparison < 0) {
          low = i2 + 1;
        } else if (comparison > 0) {
          high = i2 - 1;
        } else {
          high = i2;
          break;
        }
      }
      i2 = high;
      if (arcLengths[i2] === targetArcLength) {
        return i2 / (il - 1);
      }
      const lengthBefore = arcLengths[i2];
      const lengthAfter = arcLengths[i2 + 1];
      const segmentLength = lengthAfter - lengthBefore;
      const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
      const t2 = (i2 + segmentFraction) / (il - 1);
      return t2;
    }
    /**
     * Returns a unit vector tangent for the given interpolation factor.
     * If the derived curve does not implement its tangent derivation,
     * two points a small delta apart will be used to find its gradient
     * which seems to give a reasonable approximation.
     *
     * @param {number} t - The interpolation factor.
     * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
     * @return {(Vector2|Vector3)} The tangent vector.
     */
    getTangent(t2, optionalTarget) {
      const delta = 1e-4;
      let t1 = t2 - delta;
      let t22 = t2 + delta;
      if (t1 < 0) t1 = 0;
      if (t22 > 1) t22 = 1;
      const pt1 = this.getPoint(t1);
      const pt2 = this.getPoint(t22);
      const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
      tangent.copy(pt2).sub(pt1).normalize();
      return tangent;
    }
    /**
     * Same as {@link Curve#getTangent} but with equidistant samples.
     *
     * @param {number} u - The interpolation factor.
     * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
     * @return {(Vector2|Vector3)} The tangent vector.
     * @see {@link Curve#getPointAt}
     */
    getTangentAt(u2, optionalTarget) {
      const t2 = this.getUtoTmapping(u2);
      return this.getTangent(t2, optionalTarget);
    }
    /**
     * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
     * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
     *
     * @param {number} segments - The number of segments.
     * @param {boolean} [closed=false] - Whether the curve is closed or not.
     * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
     */
    computeFrenetFrames(segments, closed = false) {
      const normal = new Vector3();
      const tangents = [];
      const normals = [];
      const binormals = [];
      const vec = new Vector3();
      const mat = new Matrix4();
      for (let i2 = 0; i2 <= segments; i2++) {
        const u2 = i2 / segments;
        tangents[i2] = this.getTangentAt(u2, new Vector3());
      }
      normals[0] = new Vector3();
      binormals[0] = new Vector3();
      let min = Number.MAX_VALUE;
      const tx = Math.abs(tangents[0].x);
      const ty = Math.abs(tangents[0].y);
      const tz = Math.abs(tangents[0].z);
      if (tx <= min) {
        min = tx;
        normal.set(1, 0, 0);
      }
      if (ty <= min) {
        min = ty;
        normal.set(0, 1, 0);
      }
      if (tz <= min) {
        normal.set(0, 0, 1);
      }
      vec.crossVectors(tangents[0], normal).normalize();
      normals[0].crossVectors(tangents[0], vec);
      binormals[0].crossVectors(tangents[0], normals[0]);
      for (let i2 = 1; i2 <= segments; i2++) {
        normals[i2] = normals[i2 - 1].clone();
        binormals[i2] = binormals[i2 - 1].clone();
        vec.crossVectors(tangents[i2 - 1], tangents[i2]);
        if (vec.length() > Number.EPSILON) {
          vec.normalize();
          const theta = Math.acos(clamp(tangents[i2 - 1].dot(tangents[i2]), -1, 1));
          normals[i2].applyMatrix4(mat.makeRotationAxis(vec, theta));
        }
        binormals[i2].crossVectors(tangents[i2], normals[i2]);
      }
      if (closed === true) {
        let theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
        theta /= segments;
        if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
          theta = -theta;
        }
        for (let i2 = 1; i2 <= segments; i2++) {
          normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta * i2));
          binormals[i2].crossVectors(tangents[i2], normals[i2]);
        }
      }
      return {
        tangents,
        normals,
        binormals
      };
    }
    /**
     * Returns a new curve with copied values from this instance.
     *
     * @return {Curve} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Copies the values of the given curve to this instance.
     *
     * @param {Curve} source - The curve to copy.
     * @return {Curve} A reference to this curve.
     */
    copy(source) {
      this.arcLengthDivisions = source.arcLengthDivisions;
      return this;
    }
    /**
     * Serializes the curve into JSON.
     *
     * @return {Object} A JSON object representing the serialized curve.
     * @see {@link ObjectLoader#parse}
     */
    toJSON() {
      const data = {
        metadata: {
          version: 4.7,
          type: "Curve",
          generator: "Curve.toJSON"
        }
      };
      data.arcLengthDivisions = this.arcLengthDivisions;
      data.type = this.type;
      return data;
    }
    /**
     * Deserializes the curve from the given JSON.
     *
     * @param {Object} json - The JSON holding the serialized curve.
     * @return {Curve} A reference to this curve.
     */
    fromJSON(json) {
      this.arcLengthDivisions = json.arcLengthDivisions;
      return this;
    }
  }
  class EllipseCurve extends Curve {
    /**
     * Constructs a new ellipse curve.
     *
     * @param {number} [aX=0] - The X center of the ellipse.
     * @param {number} [aY=0] - The Y center of the ellipse.
     * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
     * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
     * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
     * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
     * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
     */
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
      super();
      this.isEllipseCurve = true;
      this.type = "EllipseCurve";
      this.aX = aX;
      this.aY = aY;
      this.xRadius = xRadius;
      this.yRadius = yRadius;
      this.aStartAngle = aStartAngle;
      this.aEndAngle = aEndAngle;
      this.aClockwise = aClockwise;
      this.aRotation = aRotation;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector2} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector2()) {
      const point = optionalTarget;
      const twoPi = Math.PI * 2;
      let deltaAngle = this.aEndAngle - this.aStartAngle;
      const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
      while (deltaAngle < 0) deltaAngle += twoPi;
      while (deltaAngle > twoPi) deltaAngle -= twoPi;
      if (deltaAngle < Number.EPSILON) {
        if (samePoints) {
          deltaAngle = 0;
        } else {
          deltaAngle = twoPi;
        }
      }
      if (this.aClockwise === true && !samePoints) {
        if (deltaAngle === twoPi) {
          deltaAngle = -twoPi;
        } else {
          deltaAngle = deltaAngle - twoPi;
        }
      }
      const angle = this.aStartAngle + t2 * deltaAngle;
      let x2 = this.aX + this.xRadius * Math.cos(angle);
      let y2 = this.aY + this.yRadius * Math.sin(angle);
      if (this.aRotation !== 0) {
        const cos = Math.cos(this.aRotation);
        const sin = Math.sin(this.aRotation);
        const tx = x2 - this.aX;
        const ty = y2 - this.aY;
        x2 = tx * cos - ty * sin + this.aX;
        y2 = tx * sin + ty * cos + this.aY;
      }
      return point.set(x2, y2);
    }
    copy(source) {
      super.copy(source);
      this.aX = source.aX;
      this.aY = source.aY;
      this.xRadius = source.xRadius;
      this.yRadius = source.yRadius;
      this.aStartAngle = source.aStartAngle;
      this.aEndAngle = source.aEndAngle;
      this.aClockwise = source.aClockwise;
      this.aRotation = source.aRotation;
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.aX = this.aX;
      data.aY = this.aY;
      data.xRadius = this.xRadius;
      data.yRadius = this.yRadius;
      data.aStartAngle = this.aStartAngle;
      data.aEndAngle = this.aEndAngle;
      data.aClockwise = this.aClockwise;
      data.aRotation = this.aRotation;
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.aX = json.aX;
      this.aY = json.aY;
      this.xRadius = json.xRadius;
      this.yRadius = json.yRadius;
      this.aStartAngle = json.aStartAngle;
      this.aEndAngle = json.aEndAngle;
      this.aClockwise = json.aClockwise;
      this.aRotation = json.aRotation;
      return this;
    }
  }
  class ArcCurve extends EllipseCurve {
    /**
     * Constructs a new arc curve.
     *
     * @param {number} [aX=0] - The X center of the ellipse.
     * @param {number} [aY=0] - The Y center of the ellipse.
     * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
     * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
     * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
     */
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
      super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
      this.isArcCurve = true;
      this.type = "ArcCurve";
    }
  }
  function CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    function init(x0, x1, t0, t1) {
      c0 = x0;
      c1 = t0;
      c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
      c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
      initCatmullRom: function(x0, x1, x2, x3, tension) {
        init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
      },
      initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
        let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
        let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
        t1 *= dt1;
        t2 *= dt1;
        init(x1, x2, t1, t2);
      },
      calc: function(t2) {
        const t22 = t2 * t2;
        const t3 = t22 * t2;
        return c0 + c1 * t2 + c2 * t22 + c3 * t3;
      }
    };
  }
  const tmp = /* @__PURE__ */ new Vector3();
  const px = /* @__PURE__ */ new CubicPoly();
  const py = /* @__PURE__ */ new CubicPoly();
  const pz = /* @__PURE__ */ new CubicPoly();
  class CatmullRomCurve3 extends Curve {
    /**
     * Constructs a new Catmull-Rom curve.
     *
     * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
     * @param {boolean} [closed=false] - Whether the curve is closed or not.
     * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
     * @param {number} [tension=0.5] - Tension of the curve.
     */
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5) {
      super();
      this.isCatmullRomCurve3 = true;
      this.type = "CatmullRomCurve3";
      this.points = points;
      this.closed = closed;
      this.curveType = curveType;
      this.tension = tension;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector3} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector3()) {
      const point = optionalTarget;
      const points = this.points;
      const l2 = points.length;
      const p2 = (l2 - (this.closed ? 0 : 1)) * t2;
      let intPoint = Math.floor(p2);
      let weight = p2 - intPoint;
      if (this.closed) {
        intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l2) + 1) * l2;
      } else if (weight === 0 && intPoint === l2 - 1) {
        intPoint = l2 - 2;
        weight = 1;
      }
      let p0, p3;
      if (this.closed || intPoint > 0) {
        p0 = points[(intPoint - 1) % l2];
      } else {
        tmp.subVectors(points[0], points[1]).add(points[0]);
        p0 = tmp;
      }
      const p1 = points[intPoint % l2];
      const p22 = points[(intPoint + 1) % l2];
      if (this.closed || intPoint + 2 < l2) {
        p3 = points[(intPoint + 2) % l2];
      } else {
        tmp.subVectors(points[l2 - 1], points[l2 - 2]).add(points[l2 - 1]);
        p3 = tmp;
      }
      if (this.curveType === "centripetal" || this.curveType === "chordal") {
        const pow = this.curveType === "chordal" ? 0.5 : 0.25;
        let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
        let dt1 = Math.pow(p1.distanceToSquared(p22), pow);
        let dt2 = Math.pow(p22.distanceToSquared(p3), pow);
        if (dt1 < 1e-4) dt1 = 1;
        if (dt0 < 1e-4) dt0 = dt1;
        if (dt2 < 1e-4) dt2 = dt1;
        px.initNonuniformCatmullRom(p0.x, p1.x, p22.x, p3.x, dt0, dt1, dt2);
        py.initNonuniformCatmullRom(p0.y, p1.y, p22.y, p3.y, dt0, dt1, dt2);
        pz.initNonuniformCatmullRom(p0.z, p1.z, p22.z, p3.z, dt0, dt1, dt2);
      } else if (this.curveType === "catmullrom") {
        px.initCatmullRom(p0.x, p1.x, p22.x, p3.x, this.tension);
        py.initCatmullRom(p0.y, p1.y, p22.y, p3.y, this.tension);
        pz.initCatmullRom(p0.z, p1.z, p22.z, p3.z, this.tension);
      }
      point.set(
        px.calc(weight),
        py.calc(weight),
        pz.calc(weight)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.points = [];
      for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
        const point = source.points[i2];
        this.points.push(point.clone());
      }
      this.closed = source.closed;
      this.curveType = source.curveType;
      this.tension = source.tension;
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.points = [];
      for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
        const point = this.points[i2];
        data.points.push(point.toArray());
      }
      data.closed = this.closed;
      data.curveType = this.curveType;
      data.tension = this.tension;
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.points = [];
      for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
        const point = json.points[i2];
        this.points.push(new Vector3().fromArray(point));
      }
      this.closed = json.closed;
      this.curveType = json.curveType;
      this.tension = json.tension;
      return this;
    }
  }
  function CatmullRom(t2, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t22 = t2 * t2;
    const t3 = t2 * t22;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t22 + v0 * t2 + p1;
  }
  function QuadraticBezierP0(t2, p2) {
    const k2 = 1 - t2;
    return k2 * k2 * p2;
  }
  function QuadraticBezierP1(t2, p2) {
    return 2 * (1 - t2) * t2 * p2;
  }
  function QuadraticBezierP2(t2, p2) {
    return t2 * t2 * p2;
  }
  function QuadraticBezier(t2, p0, p1, p2) {
    return QuadraticBezierP0(t2, p0) + QuadraticBezierP1(t2, p1) + QuadraticBezierP2(t2, p2);
  }
  function CubicBezierP0(t2, p2) {
    const k2 = 1 - t2;
    return k2 * k2 * k2 * p2;
  }
  function CubicBezierP1(t2, p2) {
    const k2 = 1 - t2;
    return 3 * k2 * k2 * t2 * p2;
  }
  function CubicBezierP2(t2, p2) {
    return 3 * (1 - t2) * t2 * t2 * p2;
  }
  function CubicBezierP3(t2, p2) {
    return t2 * t2 * t2 * p2;
  }
  function CubicBezier(t2, p0, p1, p2, p3) {
    return CubicBezierP0(t2, p0) + CubicBezierP1(t2, p1) + CubicBezierP2(t2, p2) + CubicBezierP3(t2, p3);
  }
  class CubicBezierCurve extends Curve {
    /**
     * Constructs a new Cubic Bezier curve.
     *
     * @param {Vector2} [v0] - The start point.
     * @param {Vector2} [v1] - The first control point.
     * @param {Vector2} [v2] - The second control point.
     * @param {Vector2} [v3] - The end point.
     */
    constructor(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2()) {
      super();
      this.isCubicBezierCurve = true;
      this.type = "CubicBezierCurve";
      this.v0 = v0;
      this.v1 = v1;
      this.v2 = v2;
      this.v3 = v3;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector2} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector2()) {
      const point = optionalTarget;
      const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
      point.set(
        CubicBezier(t2, v0.x, v1.x, v2.x, v3.x),
        CubicBezier(t2, v0.y, v1.y, v2.y, v3.y)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      this.v3.copy(source.v3);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      data.v3 = this.v3.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      this.v3.fromArray(json.v3);
      return this;
    }
  }
  class CubicBezierCurve3 extends Curve {
    /**
     * Constructs a new Cubic Bezier curve.
     *
     * @param {Vector3} [v0] - The start point.
     * @param {Vector3} [v1] - The first control point.
     * @param {Vector3} [v2] - The second control point.
     * @param {Vector3} [v3] - The end point.
     */
    constructor(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3()) {
      super();
      this.isCubicBezierCurve3 = true;
      this.type = "CubicBezierCurve3";
      this.v0 = v0;
      this.v1 = v1;
      this.v2 = v2;
      this.v3 = v3;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector3} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector3()) {
      const point = optionalTarget;
      const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
      point.set(
        CubicBezier(t2, v0.x, v1.x, v2.x, v3.x),
        CubicBezier(t2, v0.y, v1.y, v2.y, v3.y),
        CubicBezier(t2, v0.z, v1.z, v2.z, v3.z)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      this.v3.copy(source.v3);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      data.v3 = this.v3.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      this.v3.fromArray(json.v3);
      return this;
    }
  }
  class LineCurve extends Curve {
    /**
     * Constructs a new line curve.
     *
     * @param {Vector2} [v1] - The start point.
     * @param {Vector2} [v2] - The end point.
     */
    constructor(v1 = new Vector2(), v2 = new Vector2()) {
      super();
      this.isLineCurve = true;
      this.type = "LineCurve";
      this.v1 = v1;
      this.v2 = v2;
    }
    /**
     * Returns a point on the line.
     *
     * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
     * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector2} The position on the line.
     */
    getPoint(t2, optionalTarget = new Vector2()) {
      const point = optionalTarget;
      if (t2 === 1) {
        point.copy(this.v2);
      } else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t2).add(this.v1);
      }
      return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u2, optionalTarget) {
      return this.getPoint(u2, optionalTarget);
    }
    getTangent(t2, optionalTarget = new Vector2()) {
      return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u2, optionalTarget) {
      return this.getTangent(u2, optionalTarget);
    }
    copy(source) {
      super.copy(source);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }
  class LineCurve3 extends Curve {
    /**
     * Constructs a new line curve.
     *
     * @param {Vector3} [v1] - The start point.
     * @param {Vector3} [v2] - The end point.
     */
    constructor(v1 = new Vector3(), v2 = new Vector3()) {
      super();
      this.isLineCurve3 = true;
      this.type = "LineCurve3";
      this.v1 = v1;
      this.v2 = v2;
    }
    /**
     * Returns a point on the line.
     *
     * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
     * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector3} The position on the line.
     */
    getPoint(t2, optionalTarget = new Vector3()) {
      const point = optionalTarget;
      if (t2 === 1) {
        point.copy(this.v2);
      } else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t2).add(this.v1);
      }
      return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u2, optionalTarget) {
      return this.getPoint(u2, optionalTarget);
    }
    getTangent(t2, optionalTarget = new Vector3()) {
      return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u2, optionalTarget) {
      return this.getTangent(u2, optionalTarget);
    }
    copy(source) {
      super.copy(source);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }
  class QuadraticBezierCurve extends Curve {
    /**
     * Constructs a new Quadratic Bezier curve.
     *
     * @param {Vector2} [v0] - The start point.
     * @param {Vector2} [v1] - The control point.
     * @param {Vector2} [v2] - The end point.
     */
    constructor(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2()) {
      super();
      this.isQuadraticBezierCurve = true;
      this.type = "QuadraticBezierCurve";
      this.v0 = v0;
      this.v1 = v1;
      this.v2 = v2;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector2} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector2()) {
      const point = optionalTarget;
      const v0 = this.v0, v1 = this.v1, v2 = this.v2;
      point.set(
        QuadraticBezier(t2, v0.x, v1.x, v2.x),
        QuadraticBezier(t2, v0.y, v1.y, v2.y)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }
  class QuadraticBezierCurve3 extends Curve {
    /**
     * Constructs a new Quadratic Bezier curve.
     *
     * @param {Vector3} [v0] - The start point.
     * @param {Vector3} [v1] - The control point.
     * @param {Vector3} [v2] - The end point.
     */
    constructor(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3()) {
      super();
      this.isQuadraticBezierCurve3 = true;
      this.type = "QuadraticBezierCurve3";
      this.v0 = v0;
      this.v1 = v1;
      this.v2 = v2;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector3} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector3()) {
      const point = optionalTarget;
      const v0 = this.v0, v1 = this.v1, v2 = this.v2;
      point.set(
        QuadraticBezier(t2, v0.x, v1.x, v2.x),
        QuadraticBezier(t2, v0.y, v1.y, v2.y),
        QuadraticBezier(t2, v0.z, v1.z, v2.z)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }
  class SplineCurve extends Curve {
    /**
     * Constructs a new 2D spline curve.
     *
     * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
     */
    constructor(points = []) {
      super();
      this.isSplineCurve = true;
      this.type = "SplineCurve";
      this.points = points;
    }
    /**
     * Returns a point on the curve.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
     * @return {Vector2} The position on the curve.
     */
    getPoint(t2, optionalTarget = new Vector2()) {
      const point = optionalTarget;
      const points = this.points;
      const p2 = (points.length - 1) * t2;
      const intPoint = Math.floor(p2);
      const weight = p2 - intPoint;
      const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
      const p1 = points[intPoint];
      const p22 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
      const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
      point.set(
        CatmullRom(weight, p0.x, p1.x, p22.x, p3.x),
        CatmullRom(weight, p0.y, p1.y, p22.y, p3.y)
      );
      return point;
    }
    copy(source) {
      super.copy(source);
      this.points = [];
      for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
        const point = source.points[i2];
        this.points.push(point.clone());
      }
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.points = [];
      for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
        const point = this.points[i2];
        data.points.push(point.toArray());
      }
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.points = [];
      for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
        const point = json.points[i2];
        this.points.push(new Vector2().fromArray(point));
      }
      return this;
    }
  }
  var Curves = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    ArcCurve,
    CatmullRomCurve3,
    CubicBezierCurve,
    CubicBezierCurve3,
    EllipseCurve,
    LineCurve,
    LineCurve3,
    QuadraticBezierCurve,
    QuadraticBezierCurve3,
    SplineCurve
  });
  class CurvePath extends Curve {
    /**
     * Constructs a new curve path.
     */
    constructor() {
      super();
      this.type = "CurvePath";
      this.curves = [];
      this.autoClose = false;
    }
    /**
     * Adds a curve to this curve path.
     *
     * @param {Curve} curve - The curve to add.
     */
    add(curve) {
      this.curves.push(curve);
    }
    /**
     * Adds a line curve to close the path.
     *
     * @return {CurvePath} A reference to this curve path.
     */
    closePath() {
      const startPoint = this.curves[0].getPoint(0);
      const endPoint = this.curves[this.curves.length - 1].getPoint(1);
      if (!startPoint.equals(endPoint)) {
        const lineType = startPoint.isVector2 === true ? "LineCurve" : "LineCurve3";
        this.curves.push(new Curves[lineType](endPoint, startPoint));
      }
      return this;
    }
    /**
     * This method returns a vector in 2D or 3D space (depending on the curve definitions)
     * for the given interpolation factor.
     *
     * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
     * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
     * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
     */
    getPoint(t2, optionalTarget) {
      const d2 = t2 * this.getLength();
      const curveLengths = this.getCurveLengths();
      let i2 = 0;
      while (i2 < curveLengths.length) {
        if (curveLengths[i2] >= d2) {
          const diff = curveLengths[i2] - d2;
          const curve = this.curves[i2];
          const segmentLength = curve.getLength();
          const u2 = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
          return curve.getPointAt(u2, optionalTarget);
        }
        i2++;
      }
      return null;
    }
    getLength() {
      const lens = this.getCurveLengths();
      return lens[lens.length - 1];
    }
    updateArcLengths() {
      this.needsUpdate = true;
      this.cacheLengths = null;
      this.getCurveLengths();
    }
    /**
     * Returns list of cumulative curve lengths of the defined curves.
     *
     * @return {Array<number>} The curve lengths.
     */
    getCurveLengths() {
      if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
        return this.cacheLengths;
      }
      const lengths = [];
      let sums = 0;
      for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
        sums += this.curves[i2].getLength();
        lengths.push(sums);
      }
      this.cacheLengths = lengths;
      return lengths;
    }
    getSpacedPoints(divisions = 40) {
      const points = [];
      for (let i2 = 0; i2 <= divisions; i2++) {
        points.push(this.getPoint(i2 / divisions));
      }
      if (this.autoClose) {
        points.push(points[0]);
      }
      return points;
    }
    getPoints(divisions = 12) {
      const points = [];
      let last;
      for (let i2 = 0, curves = this.curves; i2 < curves.length; i2++) {
        const curve = curves[i2];
        const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
        const pts = curve.getPoints(resolution);
        for (let j2 = 0; j2 < pts.length; j2++) {
          const point = pts[j2];
          if (last && last.equals(point)) continue;
          points.push(point);
          last = point;
        }
      }
      if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
        points.push(points[0]);
      }
      return points;
    }
    copy(source) {
      super.copy(source);
      this.curves = [];
      for (let i2 = 0, l2 = source.curves.length; i2 < l2; i2++) {
        const curve = source.curves[i2];
        this.curves.push(curve.clone());
      }
      this.autoClose = source.autoClose;
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.autoClose = this.autoClose;
      data.curves = [];
      for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
        const curve = this.curves[i2];
        data.curves.push(curve.toJSON());
      }
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.autoClose = json.autoClose;
      this.curves = [];
      for (let i2 = 0, l2 = json.curves.length; i2 < l2; i2++) {
        const curve = json.curves[i2];
        this.curves.push(new Curves[curve.type]().fromJSON(curve));
      }
      return this;
    }
  }
  class Path extends CurvePath {
    /**
     * Constructs a new path.
     *
     * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
     */
    constructor(points) {
      super();
      this.type = "Path";
      this.currentPoint = new Vector2();
      if (points) {
        this.setFromPoints(points);
      }
    }
    /**
     * Creates a path from the given list of points. The points are added
     * to the path as instances of {@link LineCurve}.
     *
     * @param {Array<Vector2>} points - An array of 2D points.
     * @return {Path} A reference to this path.
     */
    setFromPoints(points) {
      this.moveTo(points[0].x, points[0].y);
      for (let i2 = 1, l2 = points.length; i2 < l2; i2++) {
        this.lineTo(points[i2].x, points[i2].y);
      }
      return this;
    }
    /**
     * Moves {@link Path#currentPoint} to the given point.
     *
     * @param {number} x - The x coordinate.
     * @param {number} y - The y coordinate.
     * @return {Path} A reference to this path.
     */
    moveTo(x2, y2) {
      this.currentPoint.set(x2, y2);
      return this;
    }
    /**
     * Adds an instance of {@link LineCurve} to the path by connecting
     * the current point with the given one.
     *
     * @param {number} x - The x coordinate of the end point.
     * @param {number} y - The y coordinate of the end point.
     * @return {Path} A reference to this path.
     */
    lineTo(x2, y2) {
      const curve = new LineCurve(this.currentPoint.clone(), new Vector2(x2, y2));
      this.curves.push(curve);
      this.currentPoint.set(x2, y2);
      return this;
    }
    /**
     * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
     * the current point with the given one.
     *
     * @param {number} aCPx - The x coordinate of the control point.
     * @param {number} aCPy - The y coordinate of the control point.
     * @param {number} aX - The x coordinate of the end point.
     * @param {number} aY - The y coordinate of the end point.
     * @return {Path} A reference to this path.
     */
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
      const curve = new QuadraticBezierCurve(
        this.currentPoint.clone(),
        new Vector2(aCPx, aCPy),
        new Vector2(aX, aY)
      );
      this.curves.push(curve);
      this.currentPoint.set(aX, aY);
      return this;
    }
    /**
     * Adds an instance of {@link CubicBezierCurve} to the path by connecting
     * the current point with the given one.
     *
     * @param {number} aCP1x - The x coordinate of the first control point.
     * @param {number} aCP1y - The y coordinate of the first control point.
     * @param {number} aCP2x - The x coordinate of the second control point.
     * @param {number} aCP2y - The y coordinate of the second control point.
     * @param {number} aX - The x coordinate of the end point.
     * @param {number} aY - The y coordinate of the end point.
     * @return {Path} A reference to this path.
     */
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
      const curve = new CubicBezierCurve(
        this.currentPoint.clone(),
        new Vector2(aCP1x, aCP1y),
        new Vector2(aCP2x, aCP2y),
        new Vector2(aX, aY)
      );
      this.curves.push(curve);
      this.currentPoint.set(aX, aY);
      return this;
    }
    /**
     * Adds an instance of {@link SplineCurve} to the path by connecting
     * the current point with the given list of points.
     *
     * @param {Array<Vector2>} pts - An array of points in 2D space.
     * @return {Path} A reference to this path.
     */
    splineThru(pts) {
      const npts = [this.currentPoint.clone()].concat(pts);
      const curve = new SplineCurve(npts);
      this.curves.push(curve);
      this.currentPoint.copy(pts[pts.length - 1]);
      return this;
    }
    /**
     * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
     * to the current point.
     *
     * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
     * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
     * @param {number} [aRadius=1] - The radius of the arc.
     * @param {number} [aStartAngle=0] - The start angle in radians.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
     * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
     * @return {Path} A reference to this path.
     */
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
      const x0 = this.currentPoint.x;
      const y0 = this.currentPoint.y;
      this.absarc(
        aX + x0,
        aY + y0,
        aRadius,
        aStartAngle,
        aEndAngle,
        aClockwise
      );
      return this;
    }
    /**
     * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
     *
     * @param {number} [aX=0] - The x coordinate of the center of the arc.
     * @param {number} [aY=0] - The y coordinate of the center of the arc.
     * @param {number} [aRadius=1] - The radius of the arc.
     * @param {number} [aStartAngle=0] - The start angle in radians.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
     * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
     * @return {Path} A reference to this path.
     */
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
      this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
      return this;
    }
    /**
     * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
     * to the current point
     *
     * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
     * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
     * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
     * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
     * @param {number} [aStartAngle=0] - The start angle in radians.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
     * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
     * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
     * @return {Path} A reference to this path.
     */
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
      const x0 = this.currentPoint.x;
      const y0 = this.currentPoint.y;
      this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
      return this;
    }
    /**
     * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
     *
     * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
     * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
     * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
     * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
     * @param {number} [aStartAngle=0] - The start angle in radians.
     * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
     * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
     * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
     * @return {Path} A reference to this path.
     */
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
      const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
      if (this.curves.length > 0) {
        const firstPoint = curve.getPoint(0);
        if (!firstPoint.equals(this.currentPoint)) {
          this.lineTo(firstPoint.x, firstPoint.y);
        }
      }
      this.curves.push(curve);
      const lastPoint = curve.getPoint(1);
      this.currentPoint.copy(lastPoint);
      return this;
    }
    copy(source) {
      super.copy(source);
      this.currentPoint.copy(source.currentPoint);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.currentPoint = this.currentPoint.toArray();
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.currentPoint.fromArray(json.currentPoint);
      return this;
    }
  }
  class Shape extends Path {
    /**
     * Constructs a new shape.
     *
     * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
     */
    constructor(points) {
      super(points);
      this.uuid = generateUUID();
      this.type = "Shape";
      this.holes = [];
    }
    /**
     * Returns an array representing each contour of the holes
     * as a list of 2D points.
     *
     * @param {number} divisions - The fineness of the result.
     * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
     */
    getPointsHoles(divisions) {
      const holesPts = [];
      for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
        holesPts[i2] = this.holes[i2].getPoints(divisions);
      }
      return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
     * Returns an object that holds contour data for the shape and its holes as
     * arrays of 2D points.
     *
     * @param {number} divisions - The fineness of the result.
     * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
     */
    extractPoints(divisions) {
      return {
        shape: this.getPoints(divisions),
        holes: this.getPointsHoles(divisions)
      };
    }
    copy(source) {
      super.copy(source);
      this.holes = [];
      for (let i2 = 0, l2 = source.holes.length; i2 < l2; i2++) {
        const hole = source.holes[i2];
        this.holes.push(hole.clone());
      }
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.uuid = this.uuid;
      data.holes = [];
      for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
        const hole = this.holes[i2];
        data.holes.push(hole.toJSON());
      }
      return data;
    }
    fromJSON(json) {
      super.fromJSON(json);
      this.uuid = json.uuid;
      this.holes = [];
      for (let i2 = 0, l2 = json.holes.length; i2 < l2; i2++) {
        const hole = json.holes[i2];
        this.holes.push(new Path().fromJSON(hole));
      }
      return this;
    }
  }
  function earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    if (data.length > 80 * dim) {
      minX = Infinity;
      minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;
      for (let i2 = dim; i2 < outerLen; i2 += dim) {
        const x2 = data[i2];
        const y2 = data[i2 + 1];
        if (x2 < minX) minX = x2;
        if (y2 < minY) minY = y2;
        if (x2 > maxX) maxX = x2;
        if (y2 > maxY) maxY = y2;
      }
      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
  }
  function linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === signedArea(data, start, end, dim) > 0) {
      for (let i2 = start; i2 < end; i2 += dim) last = insertNode(i2 / dim | 0, data[i2], data[i2 + 1], last);
    } else {
      for (let i2 = end - dim; i2 >= start; i2 -= dim) last = insertNode(i2 / dim | 0, data[i2], data[i2 + 1], last);
    }
    if (last && equals(last, last.next)) {
      removeNode(last);
      last = last.next;
    }
    return last;
  }
  function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p2 = start, again;
    do {
      again = false;
      if (!p2.steiner && (equals(p2, p2.next) || area(p2.prev, p2, p2.next) === 0)) {
        removeNode(p2);
        p2 = end = p2.prev;
        if (p2 === p2.next) break;
        again = true;
      } else {
        p2 = p2.next;
      }
    } while (again || p2 !== end);
    return end;
  }
  function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    while (ear.prev !== ear.next) {
      const prev = ear.prev;
      const next = ear.next;
      if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
        triangles.push(prev.i, ear.i, next.i);
        removeNode(ear);
        ear = next.next;
        stop = next.next;
        continue;
      }
      ear = next;
      if (ear === stop) {
        if (!pass) {
          earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
        } else if (pass === 1) {
          ear = cureLocalIntersections(filterPoints(ear), triangles);
          earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
        } else if (pass === 2) {
          splitEarcut(ear, triangles, dim, minX, minY, invSize);
        }
        break;
      }
    }
  }
  function isEar(ear) {
    const a2 = ear.prev, b2 = ear, c2 = ear.next;
    if (area(a2, b2, c2) >= 0) return false;
    const ax = a2.x, bx = b2.x, cx = c2.x, ay = a2.y, by = b2.y, cy = c2.y;
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p2 = c2.next;
    while (p2 !== a2) {
      if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
      p2 = p2.next;
    }
    return true;
  }
  function isEarHashed(ear, minX, minY, invSize) {
    const a2 = ear.prev, b2 = ear, c2 = ear.next;
    if (area(a2, b2, c2) >= 0) return false;
    const ax = a2.x, bx = b2.x, cx = c2.x, ay = a2.y, by = b2.y, cy = c2.y;
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    const minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
    let p2 = ear.prevZ, n2 = ear.nextZ;
    while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
      if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a2 && p2 !== c2 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
      p2 = p2.prevZ;
      if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a2 && n2 !== c2 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
      n2 = n2.nextZ;
    }
    while (p2 && p2.z >= minZ) {
      if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a2 && p2 !== c2 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0) return false;
      p2 = p2.prevZ;
    }
    while (n2 && n2.z <= maxZ) {
      if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a2 && n2 !== c2 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0) return false;
      n2 = n2.nextZ;
    }
    return true;
  }
  function cureLocalIntersections(start, triangles) {
    let p2 = start;
    do {
      const a2 = p2.prev, b2 = p2.next.next;
      if (!equals(a2, b2) && intersects(a2, p2, p2.next, b2) && locallyInside(a2, b2) && locallyInside(b2, a2)) {
        triangles.push(a2.i, p2.i, b2.i);
        removeNode(p2);
        removeNode(p2.next);
        p2 = start = b2;
      }
      p2 = p2.next;
    } while (p2 !== start);
    return filterPoints(p2);
  }
  function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    let a2 = start;
    do {
      let b2 = a2.next.next;
      while (b2 !== a2.prev) {
        if (a2.i !== b2.i && isValidDiagonal(a2, b2)) {
          let c2 = splitPolygon(a2, b2);
          a2 = filterPoints(a2, a2.next);
          c2 = filterPoints(c2, c2.next);
          earcutLinked(a2, triangles, dim, minX, minY, invSize, 0);
          earcutLinked(c2, triangles, dim, minX, minY, invSize, 0);
          return;
        }
        b2 = b2.next;
      }
      a2 = a2.next;
    } while (a2 !== start);
  }
  function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for (let i2 = 0, len = holeIndices.length; i2 < len; i2++) {
      const start = holeIndices[i2] * dim;
      const end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
      const list = linkedList(data, start, end, dim, false);
      if (list === list.next) list.steiner = true;
      queue.push(getLeftmost(list));
    }
    queue.sort(compareXYSlope);
    for (let i2 = 0; i2 < queue.length; i2++) {
      outerNode = eliminateHole(queue[i2], outerNode);
    }
    return outerNode;
  }
  function compareXYSlope(a2, b2) {
    let result = a2.x - b2.x;
    if (result === 0) {
      result = a2.y - b2.y;
      if (result === 0) {
        const aSlope = (a2.next.y - a2.y) / (a2.next.x - a2.x);
        const bSlope = (b2.next.y - b2.y) / (b2.next.x - b2.x);
        result = aSlope - bSlope;
      }
    }
    return result;
  }
  function eliminateHole(hole, outerNode) {
    const bridge = findHoleBridge(hole, outerNode);
    if (!bridge) {
      return outerNode;
    }
    const bridgeReverse = splitPolygon(bridge, hole);
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
  }
  function findHoleBridge(hole, outerNode) {
    let p2 = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    if (equals(hole, p2)) return p2;
    do {
      if (equals(hole, p2.next)) return p2.next;
      else if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
        const x2 = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
        if (x2 <= hx && x2 > qx) {
          qx = x2;
          m = p2.x < p2.next.x ? p2 : p2.next;
          if (x2 === hx) return m;
        }
      }
      p2 = p2.next;
    } while (p2 !== outerNode);
    if (!m) return null;
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p2 = m;
    do {
      if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
        const tan = Math.abs(hy - p2.y) / (hx - p2.x);
        if (locallyInside(p2, hole) && (tan < tanMin || tan === tanMin && (p2.x > m.x || p2.x === m.x && sectorContainsSector(m, p2)))) {
          m = p2;
          tanMin = tan;
        }
      }
      p2 = p2.next;
    } while (p2 !== stop);
    return m;
  }
  function sectorContainsSector(m, p2) {
    return area(m.prev, m, p2.prev) < 0 && area(p2.next, m, m.next) < 0;
  }
  function indexCurve(start, minX, minY, invSize) {
    let p2 = start;
    do {
      if (p2.z === 0) p2.z = zOrder(p2.x, p2.y, minX, minY, invSize);
      p2.prevZ = p2.prev;
      p2.nextZ = p2.next;
      p2 = p2.next;
    } while (p2 !== start);
    p2.prevZ.nextZ = null;
    p2.prevZ = null;
    sortLinked(p2);
  }
  function sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
      let p2 = list;
      let e2;
      list = null;
      let tail = null;
      numMerges = 0;
      while (p2) {
        numMerges++;
        let q2 = p2;
        let pSize = 0;
        for (let i2 = 0; i2 < inSize; i2++) {
          pSize++;
          q2 = q2.nextZ;
          if (!q2) break;
        }
        let qSize = inSize;
        while (pSize > 0 || qSize > 0 && q2) {
          if (pSize !== 0 && (qSize === 0 || !q2 || p2.z <= q2.z)) {
            e2 = p2;
            p2 = p2.nextZ;
            pSize--;
          } else {
            e2 = q2;
            q2 = q2.nextZ;
            qSize--;
          }
          if (tail) tail.nextZ = e2;
          else list = e2;
          e2.prevZ = tail;
          tail = e2;
        }
        p2 = q2;
      }
      tail.nextZ = null;
      inSize *= 2;
    } while (numMerges > 1);
    return list;
  }
  function zOrder(x2, y2, minX, minY, invSize) {
    x2 = (x2 - minX) * invSize | 0;
    y2 = (y2 - minY) * invSize | 0;
    x2 = (x2 | x2 << 8) & 16711935;
    x2 = (x2 | x2 << 4) & 252645135;
    x2 = (x2 | x2 << 2) & 858993459;
    x2 = (x2 | x2 << 1) & 1431655765;
    y2 = (y2 | y2 << 8) & 16711935;
    y2 = (y2 | y2 << 4) & 252645135;
    y2 = (y2 | y2 << 2) & 858993459;
    y2 = (y2 | y2 << 1) & 1431655765;
    return x2 | y2 << 1;
  }
  function getLeftmost(start) {
    let p2 = start, leftmost = start;
    do {
      if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y) leftmost = p2;
      p2 = p2.next;
    } while (p2 !== start);
    return leftmost;
  }
  function pointInTriangle(ax, ay, bx, by, cx, cy, px2, py2) {
    return (cx - px2) * (ay - py2) >= (ax - px2) * (cy - py2) && (ax - px2) * (by - py2) >= (bx - px2) * (ay - py2) && (bx - px2) * (cy - py2) >= (cx - px2) * (by - py2);
  }
  function pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px2, py2) {
    return !(ax === px2 && ay === py2) && pointInTriangle(ax, ay, bx, by, cx, cy, px2, py2);
  }
  function isValidDiagonal(a2, b2) {
    return a2.next.i !== b2.i && a2.prev.i !== b2.i && !intersectsPolygon(a2, b2) && // dones't intersect other edges
    (locallyInside(a2, b2) && locallyInside(b2, a2) && middleInside(a2, b2) && // locally visible
    (area(a2.prev, a2, b2.prev) || area(a2, b2.prev, b2)) || // does not create opposite-facing sectors
    equals(a2, b2) && area(a2.prev, a2, a2.next) > 0 && area(b2.prev, b2, b2.next) > 0);
  }
  function area(p2, q2, r2) {
    return (q2.y - p2.y) * (r2.x - q2.x) - (q2.x - p2.x) * (r2.y - q2.y);
  }
  function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
  }
  function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true;
    if (o1 === 0 && onSegment(p1, p2, q1)) return true;
    if (o2 === 0 && onSegment(p1, q2, q1)) return true;
    if (o3 === 0 && onSegment(p2, p1, q2)) return true;
    if (o4 === 0 && onSegment(p2, q1, q2)) return true;
    return false;
  }
  function onSegment(p2, q2, r2) {
    return q2.x <= Math.max(p2.x, r2.x) && q2.x >= Math.min(p2.x, r2.x) && q2.y <= Math.max(p2.y, r2.y) && q2.y >= Math.min(p2.y, r2.y);
  }
  function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
  }
  function intersectsPolygon(a2, b2) {
    let p2 = a2;
    do {
      if (p2.i !== a2.i && p2.next.i !== a2.i && p2.i !== b2.i && p2.next.i !== b2.i && intersects(p2, p2.next, a2, b2)) return true;
      p2 = p2.next;
    } while (p2 !== a2);
    return false;
  }
  function locallyInside(a2, b2) {
    return area(a2.prev, a2, a2.next) < 0 ? area(a2, b2, a2.next) >= 0 && area(a2, a2.prev, b2) >= 0 : area(a2, b2, a2.prev) < 0 || area(a2, a2.next, b2) < 0;
  }
  function middleInside(a2, b2) {
    let p2 = a2;
    let inside = false;
    const px2 = (a2.x + b2.x) / 2;
    const py2 = (a2.y + b2.y) / 2;
    do {
      if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
        inside = !inside;
      p2 = p2.next;
    } while (p2 !== a2);
    return inside;
  }
  function splitPolygon(a2, b2) {
    const a22 = createNode(a2.i, a2.x, a2.y), b22 = createNode(b2.i, b2.x, b2.y), an2 = a2.next, bp = b2.prev;
    a2.next = b2;
    b2.prev = a2;
    a22.next = an2;
    an2.prev = a22;
    b22.next = a22;
    a22.prev = b22;
    bp.next = b22;
    b22.prev = bp;
    return b22;
  }
  function insertNode(i2, x2, y2, last) {
    const p2 = createNode(i2, x2, y2);
    if (!last) {
      p2.prev = p2;
      p2.next = p2;
    } else {
      p2.next = last.next;
      p2.prev = last;
      last.next.prev = p2;
      last.next = p2;
    }
    return p2;
  }
  function removeNode(p2) {
    p2.next.prev = p2.prev;
    p2.prev.next = p2.next;
    if (p2.prevZ) p2.prevZ.nextZ = p2.nextZ;
    if (p2.nextZ) p2.nextZ.prevZ = p2.prevZ;
  }
  function createNode(i2, x2, y2) {
    return {
      i: i2,
      // vertex index in coordinates array
      x: x2,
      y: y2,
      // vertex coordinates
      prev: null,
      // previous and next vertex nodes in a polygon ring
      next: null,
      z: 0,
      // z-order curve value
      prevZ: null,
      // previous and next nodes in z-order
      nextZ: null,
      steiner: false
      // indicates whether this is a steiner point
    };
  }
  function signedArea(data, start, end, dim) {
    let sum = 0;
    for (let i2 = start, j2 = end - dim; i2 < end; i2 += dim) {
      sum += (data[j2] - data[i2]) * (data[i2 + 1] + data[j2 + 1]);
      j2 = i2;
    }
    return sum;
  }
  class Earcut {
    /**
     * Triangulates the given shape definition by returning an array of triangles.
     *
     * @param {Array<number>} data - An array with 2D points.
     * @param {Array<number>} holeIndices - An array with indices defining holes.
     * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
     * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
     * representing vertex indices.
     */
    static triangulate(data, holeIndices, dim = 2) {
      return earcut(data, holeIndices, dim);
    }
  }
  class ShapeUtils {
    /**
     * Calculate area of a ( 2D ) contour polygon.
     *
     * @param {Array<Vector2>} contour - An array of 2D points.
     * @return {number} The area.
     */
    static area(contour) {
      const n2 = contour.length;
      let a2 = 0;
      for (let p2 = n2 - 1, q2 = 0; q2 < n2; p2 = q2++) {
        a2 += contour[p2].x * contour[q2].y - contour[q2].x * contour[p2].y;
      }
      return a2 * 0.5;
    }
    /**
     * Returns `true` if the given contour uses a clockwise winding order.
     *
     * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
     * @return {boolean} Whether the given contour uses a clockwise winding order or not.
     */
    static isClockWise(pts) {
      return ShapeUtils.area(pts) < 0;
    }
    /**
     * Triangulates the given shape definition.
     *
     * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
     * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
     * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
     */
    static triangulateShape(contour, holes) {
      const vertices = [];
      const holeIndices = [];
      const faces = [];
      removeDupEndPts(contour);
      addContour(vertices, contour);
      let holeIndex = contour.length;
      holes.forEach(removeDupEndPts);
      for (let i2 = 0; i2 < holes.length; i2++) {
        holeIndices.push(holeIndex);
        holeIndex += holes[i2].length;
        addContour(vertices, holes[i2]);
      }
      const triangles = Earcut.triangulate(vertices, holeIndices);
      for (let i2 = 0; i2 < triangles.length; i2 += 3) {
        faces.push(triangles.slice(i2, i2 + 3));
      }
      return faces;
    }
  }
  function removeDupEndPts(points) {
    const l2 = points.length;
    if (l2 > 2 && points[l2 - 1].equals(points[0])) {
      points.pop();
    }
  }
  function addContour(vertices, contour) {
    for (let i2 = 0; i2 < contour.length; i2++) {
      vertices.push(contour[i2].x);
      vertices.push(contour[i2].y);
    }
  }
  class ExtrudeGeometry extends BufferGeometry {
    /**
     * Constructs a new extrude geometry.
     *
     * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
     * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
     */
    constructor(shapes = new Shape([new Vector2(0.5, 0.5), new Vector2(-0.5, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]), options = {}) {
      super();
      this.type = "ExtrudeGeometry";
      this.parameters = {
        shapes,
        options
      };
      shapes = Array.isArray(shapes) ? shapes : [shapes];
      const scope = this;
      const verticesArray = [];
      const uvArray = [];
      for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
        const shape = shapes[i2];
        addShape(shape);
      }
      this.setAttribute("position", new Float32BufferAttribute(verticesArray, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvArray, 2));
      this.computeVertexNormals();
      function addShape(shape) {
        const placeholder = [];
        const curveSegments = options.curveSegments !== void 0 ? options.curveSegments : 12;
        const steps = options.steps !== void 0 ? options.steps : 1;
        const depth = options.depth !== void 0 ? options.depth : 1;
        let bevelEnabled = options.bevelEnabled !== void 0 ? options.bevelEnabled : true;
        let bevelThickness = options.bevelThickness !== void 0 ? options.bevelThickness : 0.2;
        let bevelSize = options.bevelSize !== void 0 ? options.bevelSize : bevelThickness - 0.1;
        let bevelOffset = options.bevelOffset !== void 0 ? options.bevelOffset : 0;
        let bevelSegments = options.bevelSegments !== void 0 ? options.bevelSegments : 3;
        const extrudePath = options.extrudePath;
        const uvgen = options.UVGenerator !== void 0 ? options.UVGenerator : WorldUVGenerator;
        let extrudePts, extrudeByPath = false;
        let splineTube, binormal, normal, position2;
        if (extrudePath) {
          extrudePts = extrudePath.getSpacedPoints(steps);
          extrudeByPath = true;
          bevelEnabled = false;
          splineTube = extrudePath.computeFrenetFrames(steps, false);
          binormal = new Vector3();
          normal = new Vector3();
          position2 = new Vector3();
        }
        if (!bevelEnabled) {
          bevelSegments = 0;
          bevelThickness = 0;
          bevelSize = 0;
          bevelOffset = 0;
        }
        const shapePoints = shape.extractPoints(curveSegments);
        let vertices = shapePoints.shape;
        const holes = shapePoints.holes;
        const reverse = !ShapeUtils.isClockWise(vertices);
        if (reverse) {
          vertices = vertices.reverse();
          for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
            const ahole = holes[h2];
            if (ShapeUtils.isClockWise(ahole)) {
              holes[h2] = ahole.reverse();
            }
          }
        }
        function mergeOverlappingPoints(points) {
          const THRESHOLD = 1e-10;
          const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
          let prevPos = points[0];
          for (let i2 = 1; i2 <= points.length; i2++) {
            const currentIndex = i2 % points.length;
            const currentPos = points[currentIndex];
            const dx = currentPos.x - prevPos.x;
            const dy = currentPos.y - prevPos.y;
            const distSq = dx * dx + dy * dy;
            const scalingFactorSqrt = Math.max(
              Math.abs(currentPos.x),
              Math.abs(currentPos.y),
              Math.abs(prevPos.x),
              Math.abs(prevPos.y)
            );
            const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
            if (distSq <= thresholdSqScaled) {
              points.splice(currentIndex, 1);
              i2--;
              continue;
            }
            prevPos = currentPos;
          }
        }
        mergeOverlappingPoints(vertices);
        holes.forEach(mergeOverlappingPoints);
        const numHoles = holes.length;
        const contour = vertices;
        for (let h2 = 0; h2 < numHoles; h2++) {
          const ahole = holes[h2];
          vertices = vertices.concat(ahole);
        }
        function scalePt2(pt2, vec, size) {
          if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
          return pt2.clone().addScaledVector(vec, size);
        }
        const vlen = vertices.length;
        function getBevelVec(inPt, inPrev, inNext) {
          let v_trans_x, v_trans_y, shrink_by;
          const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
          const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
          const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
          const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
          if (Math.abs(collinear0) > Number.EPSILON) {
            const v_prev_len = Math.sqrt(v_prev_lensq);
            const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
            const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
            const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
            const ptNextShift_x = inNext.x - v_next_y / v_next_len;
            const ptNextShift_y = inNext.y + v_next_x / v_next_len;
            const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
            v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
            v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
            const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
            if (v_trans_lensq <= 2) {
              return new Vector2(v_trans_x, v_trans_y);
            } else {
              shrink_by = Math.sqrt(v_trans_lensq / 2);
            }
          } else {
            let direction_eq = false;
            if (v_prev_x > Number.EPSILON) {
              if (v_next_x > Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (v_prev_x < -Number.EPSILON) {
                if (v_next_x < -Number.EPSILON) {
                  direction_eq = true;
                }
              } else {
                if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                  direction_eq = true;
                }
              }
            }
            if (direction_eq) {
              v_trans_x = -v_prev_y;
              v_trans_y = v_prev_x;
              shrink_by = Math.sqrt(v_prev_lensq);
            } else {
              v_trans_x = v_prev_x;
              v_trans_y = v_prev_y;
              shrink_by = Math.sqrt(v_prev_lensq / 2);
            }
          }
          return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
        }
        const contourMovements = [];
        for (let i2 = 0, il = contour.length, j2 = il - 1, k2 = i2 + 1; i2 < il; i2++, j2++, k2++) {
          if (j2 === il) j2 = 0;
          if (k2 === il) k2 = 0;
          contourMovements[i2] = getBevelVec(contour[i2], contour[j2], contour[k2]);
        }
        const holesMovements = [];
        let oneHoleMovements, verticesMovements = contourMovements.concat();
        for (let h2 = 0, hl = numHoles; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = [];
          for (let i2 = 0, il = ahole.length, j2 = il - 1, k2 = i2 + 1; i2 < il; i2++, j2++, k2++) {
            if (j2 === il) j2 = 0;
            if (k2 === il) k2 = 0;
            oneHoleMovements[i2] = getBevelVec(ahole[i2], ahole[j2], ahole[k2]);
          }
          holesMovements.push(oneHoleMovements);
          verticesMovements = verticesMovements.concat(oneHoleMovements);
        }
        let faces;
        if (bevelSegments === 0) {
          faces = ShapeUtils.triangulateShape(contour, holes);
        } else {
          const contractedContourVertices = [];
          const expandedHoleVertices = [];
          for (let b2 = 0; b2 < bevelSegments; b2++) {
            const t2 = b2 / bevelSegments;
            const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
            const bs3 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
            for (let i2 = 0, il = contour.length; i2 < il; i2++) {
              const vert = scalePt2(contour[i2], contourMovements[i2], bs3);
              v2(vert.x, vert.y, -z2);
              if (t2 === 0) contractedContourVertices.push(vert);
            }
            for (let h2 = 0, hl = numHoles; h2 < hl; h2++) {
              const ahole = holes[h2];
              oneHoleMovements = holesMovements[h2];
              const oneHoleVertices = [];
              for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
                const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs3);
                v2(vert.x, vert.y, -z2);
                if (t2 === 0) oneHoleVertices.push(vert);
              }
              if (t2 === 0) expandedHoleVertices.push(oneHoleVertices);
            }
          }
          faces = ShapeUtils.triangulateShape(contractedContourVertices, expandedHoleVertices);
        }
        const flen = faces.length;
        const bs2 = bevelSize + bevelOffset;
        for (let i2 = 0; i2 < vlen; i2++) {
          const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs2) : vertices[i2];
          if (!extrudeByPath) {
            v2(vert.x, vert.y, 0);
          } else {
            normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
            position2.copy(extrudePts[0]).add(normal).add(binormal);
            v2(position2.x, position2.y, position2.z);
          }
        }
        for (let s2 = 1; s2 <= steps; s2++) {
          for (let i2 = 0; i2 < vlen; i2++) {
            const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs2) : vertices[i2];
            if (!extrudeByPath) {
              v2(vert.x, vert.y, depth / steps * s2);
            } else {
              normal.copy(splineTube.normals[s2]).multiplyScalar(vert.x);
              binormal.copy(splineTube.binormals[s2]).multiplyScalar(vert.y);
              position2.copy(extrudePts[s2]).add(normal).add(binormal);
              v2(position2.x, position2.y, position2.z);
            }
          }
        }
        for (let b2 = bevelSegments - 1; b2 >= 0; b2--) {
          const t2 = b2 / bevelSegments;
          const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
          const bs3 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
          for (let i2 = 0, il = contour.length; i2 < il; i2++) {
            const vert = scalePt2(contour[i2], contourMovements[i2], bs3);
            v2(vert.x, vert.y, depth + z2);
          }
          for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
            const ahole = holes[h2];
            oneHoleMovements = holesMovements[h2];
            for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
              const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs3);
              if (!extrudeByPath) {
                v2(vert.x, vert.y, depth + z2);
              } else {
                v2(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z2);
              }
            }
          }
        }
        buildLidFaces();
        buildSideFaces();
        function buildLidFaces() {
          const start = verticesArray.length / 3;
          if (bevelEnabled) {
            let layer = 0;
            let offset = vlen * layer;
            for (let i2 = 0; i2 < flen; i2++) {
              const face = faces[i2];
              f3(face[2] + offset, face[1] + offset, face[0] + offset);
            }
            layer = steps + bevelSegments * 2;
            offset = vlen * layer;
            for (let i2 = 0; i2 < flen; i2++) {
              const face = faces[i2];
              f3(face[0] + offset, face[1] + offset, face[2] + offset);
            }
          } else {
            for (let i2 = 0; i2 < flen; i2++) {
              const face = faces[i2];
              f3(face[2], face[1], face[0]);
            }
            for (let i2 = 0; i2 < flen; i2++) {
              const face = faces[i2];
              f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
            }
          }
          scope.addGroup(start, verticesArray.length / 3 - start, 0);
        }
        function buildSideFaces() {
          const start = verticesArray.length / 3;
          let layeroffset = 0;
          sidewalls(contour, layeroffset);
          layeroffset += contour.length;
          for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
            const ahole = holes[h2];
            sidewalls(ahole, layeroffset);
            layeroffset += ahole.length;
          }
          scope.addGroup(start, verticesArray.length / 3 - start, 1);
        }
        function sidewalls(contour2, layeroffset) {
          let i2 = contour2.length;
          while (--i2 >= 0) {
            const j2 = i2;
            let k2 = i2 - 1;
            if (k2 < 0) k2 = contour2.length - 1;
            for (let s2 = 0, sl = steps + bevelSegments * 2; s2 < sl; s2++) {
              const slen1 = vlen * s2;
              const slen2 = vlen * (s2 + 1);
              const a2 = layeroffset + j2 + slen1, b2 = layeroffset + k2 + slen1, c2 = layeroffset + k2 + slen2, d2 = layeroffset + j2 + slen2;
              f4(a2, b2, c2, d2);
            }
          }
        }
        function v2(x2, y2, z2) {
          placeholder.push(x2);
          placeholder.push(y2);
          placeholder.push(z2);
        }
        function f3(a2, b2, c2) {
          addVertex(a2);
          addVertex(b2);
          addVertex(c2);
          const nextIndex = verticesArray.length / 3;
          const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
          addUV(uvs[0]);
          addUV(uvs[1]);
          addUV(uvs[2]);
        }
        function f4(a2, b2, c2, d2) {
          addVertex(a2);
          addVertex(b2);
          addVertex(d2);
          addVertex(b2);
          addVertex(c2);
          addVertex(d2);
          const nextIndex = verticesArray.length / 3;
          const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
          addUV(uvs[0]);
          addUV(uvs[1]);
          addUV(uvs[3]);
          addUV(uvs[1]);
          addUV(uvs[2]);
          addUV(uvs[3]);
        }
        function addVertex(index) {
          verticesArray.push(placeholder[index * 3 + 0]);
          verticesArray.push(placeholder[index * 3 + 1]);
          verticesArray.push(placeholder[index * 3 + 2]);
        }
        function addUV(vector2) {
          uvArray.push(vector2.x);
          uvArray.push(vector2.y);
        }
      }
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      const shapes = this.parameters.shapes;
      const options = this.parameters.options;
      return toJSON$1(shapes, options, data);
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @param {Array<Shape>} shapes - An array of shapes.
     * @return {ExtrudeGeometry} A new instance.
     */
    static fromJSON(data, shapes) {
      const geometryShapes = [];
      for (let j2 = 0, jl = data.shapes.length; j2 < jl; j2++) {
        const shape = shapes[data.shapes[j2]];
        geometryShapes.push(shape);
      }
      const extrudePath = data.options.extrudePath;
      if (extrudePath !== void 0) {
        data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
      }
      return new ExtrudeGeometry(geometryShapes, data.options);
    }
  }
  const WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
      const a_x = vertices[indexA * 3];
      const a_y = vertices[indexA * 3 + 1];
      const b_x = vertices[indexB * 3];
      const b_y = vertices[indexB * 3 + 1];
      const c_x = vertices[indexC * 3];
      const c_y = vertices[indexC * 3 + 1];
      return [
        new Vector2(a_x, a_y),
        new Vector2(b_x, b_y),
        new Vector2(c_x, c_y)
      ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
      const a_x = vertices[indexA * 3];
      const a_y = vertices[indexA * 3 + 1];
      const a_z = vertices[indexA * 3 + 2];
      const b_x = vertices[indexB * 3];
      const b_y = vertices[indexB * 3 + 1];
      const b_z = vertices[indexB * 3 + 2];
      const c_x = vertices[indexC * 3];
      const c_y = vertices[indexC * 3 + 1];
      const c_z = vertices[indexC * 3 + 2];
      const d_x = vertices[indexD * 3];
      const d_y = vertices[indexD * 3 + 1];
      const d_z = vertices[indexD * 3 + 2];
      if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
        return [
          new Vector2(a_x, 1 - a_z),
          new Vector2(b_x, 1 - b_z),
          new Vector2(c_x, 1 - c_z),
          new Vector2(d_x, 1 - d_z)
        ];
      } else {
        return [
          new Vector2(a_y, 1 - a_z),
          new Vector2(b_y, 1 - b_z),
          new Vector2(c_y, 1 - c_z),
          new Vector2(d_y, 1 - d_z)
        ];
      }
    }
  };
  function toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) {
      for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
        const shape = shapes[i2];
        data.shapes.push(shape.uuid);
      }
    } else {
      data.shapes.push(shapes.uuid);
    }
    data.options = Object.assign({}, options);
    if (options.extrudePath !== void 0) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
  }
  class PlaneGeometry extends BufferGeometry {
    /**
     * Constructs a new plane geometry.
     *
     * @param {number} [width=1] - The width along the X axis.
     * @param {number} [height=1] - The height along the Y axis
     * @param {number} [widthSegments=1] - The number of segments along the X axis.
     * @param {number} [heightSegments=1] - The number of segments along the Y axis.
     */
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
      super();
      this.type = "PlaneGeometry";
      this.parameters = {
        width,
        height,
        widthSegments,
        heightSegments
      };
      const width_half = width / 2;
      const height_half = height / 2;
      const gridX = Math.floor(widthSegments);
      const gridY = Math.floor(heightSegments);
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      const segment_width = width / gridX;
      const segment_height = height / gridY;
      const indices = [];
      const vertices = [];
      const normals = [];
      const uvs = [];
      for (let iy = 0; iy < gridY1; iy++) {
        const y2 = iy * segment_height - height_half;
        for (let ix = 0; ix < gridX1; ix++) {
          const x2 = ix * segment_width - width_half;
          vertices.push(x2, -y2, 0);
          normals.push(0, 0, 1);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a2 = ix + gridX1 * iy;
          const b2 = ix + gridX1 * (iy + 1);
          const c2 = ix + 1 + gridX1 * (iy + 1);
          const d2 = ix + 1 + gridX1 * iy;
          indices.push(a2, b2, d2);
          indices.push(b2, c2, d2);
        }
      }
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {PlaneGeometry} A new instance.
     */
    static fromJSON(data) {
      return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
    }
  }
  class TorusGeometry extends BufferGeometry {
    /**
     * Constructs a new torus geometry.
     *
     * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
     * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
     * @param {number} [radialSegments=12] - The number of radial segments.
     * @param {number} [tubularSegments=48] - The number of tubular segments.
     * @param {number} [arc=Math.PI*2] - Central angle in radians.
     */
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2) {
      super();
      this.type = "TorusGeometry";
      this.parameters = {
        radius,
        tube,
        radialSegments,
        tubularSegments,
        arc
      };
      radialSegments = Math.floor(radialSegments);
      tubularSegments = Math.floor(tubularSegments);
      const indices = [];
      const vertices = [];
      const normals = [];
      const uvs = [];
      const center = new Vector3();
      const vertex2 = new Vector3();
      const normal = new Vector3();
      for (let j2 = 0; j2 <= radialSegments; j2++) {
        for (let i2 = 0; i2 <= tubularSegments; i2++) {
          const u2 = i2 / tubularSegments * arc;
          const v2 = j2 / radialSegments * Math.PI * 2;
          vertex2.x = (radius + tube * Math.cos(v2)) * Math.cos(u2);
          vertex2.y = (radius + tube * Math.cos(v2)) * Math.sin(u2);
          vertex2.z = tube * Math.sin(v2);
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
          center.x = radius * Math.cos(u2);
          center.y = radius * Math.sin(u2);
          normal.subVectors(vertex2, center).normalize();
          normals.push(normal.x, normal.y, normal.z);
          uvs.push(i2 / tubularSegments);
          uvs.push(j2 / radialSegments);
        }
      }
      for (let j2 = 1; j2 <= radialSegments; j2++) {
        for (let i2 = 1; i2 <= tubularSegments; i2++) {
          const a2 = (tubularSegments + 1) * j2 + i2 - 1;
          const b2 = (tubularSegments + 1) * (j2 - 1) + i2 - 1;
          const c2 = (tubularSegments + 1) * (j2 - 1) + i2;
          const d2 = (tubularSegments + 1) * j2 + i2;
          indices.push(a2, b2, d2);
          indices.push(b2, c2, d2);
        }
      }
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {TorusGeometry} A new instance.
     */
    static fromJSON(data) {
      return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
  }
  class TubeGeometry extends BufferGeometry {
    /**
     * Constructs a new tube geometry.
     *
     * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
     * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
     * @param {number} [radius=1] -The radius of the tube.
     * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
     * @param {boolean} [closed=false] - Whether the tube is closed or not.
     */
    constructor(path = new QuadraticBezierCurve3(new Vector3(-1, -1, 0), new Vector3(-1, 1, 0), new Vector3(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false) {
      super();
      this.type = "TubeGeometry";
      this.parameters = {
        path,
        tubularSegments,
        radius,
        radialSegments,
        closed
      };
      const frames = path.computeFrenetFrames(tubularSegments, closed);
      this.tangents = frames.tangents;
      this.normals = frames.normals;
      this.binormals = frames.binormals;
      const vertex2 = new Vector3();
      const normal = new Vector3();
      const uv = new Vector2();
      let P2 = new Vector3();
      const vertices = [];
      const normals = [];
      const uvs = [];
      const indices = [];
      generateBufferData();
      this.setIndex(indices);
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
      function generateBufferData() {
        for (let i2 = 0; i2 < tubularSegments; i2++) {
          generateSegment(i2);
        }
        generateSegment(closed === false ? tubularSegments : 0);
        generateUVs();
        generateIndices();
      }
      function generateSegment(i2) {
        P2 = path.getPointAt(i2 / tubularSegments, P2);
        const N2 = frames.normals[i2];
        const B2 = frames.binormals[i2];
        for (let j2 = 0; j2 <= radialSegments; j2++) {
          const v2 = j2 / radialSegments * Math.PI * 2;
          const sin = Math.sin(v2);
          const cos = -Math.cos(v2);
          normal.x = cos * N2.x + sin * B2.x;
          normal.y = cos * N2.y + sin * B2.y;
          normal.z = cos * N2.z + sin * B2.z;
          normal.normalize();
          normals.push(normal.x, normal.y, normal.z);
          vertex2.x = P2.x + radius * normal.x;
          vertex2.y = P2.y + radius * normal.y;
          vertex2.z = P2.z + radius * normal.z;
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
        }
      }
      function generateIndices() {
        for (let j2 = 1; j2 <= tubularSegments; j2++) {
          for (let i2 = 1; i2 <= radialSegments; i2++) {
            const a2 = (radialSegments + 1) * (j2 - 1) + (i2 - 1);
            const b2 = (radialSegments + 1) * j2 + (i2 - 1);
            const c2 = (radialSegments + 1) * j2 + i2;
            const d2 = (radialSegments + 1) * (j2 - 1) + i2;
            indices.push(a2, b2, d2);
            indices.push(b2, c2, d2);
          }
        }
      }
      function generateUVs() {
        for (let i2 = 0; i2 <= tubularSegments; i2++) {
          for (let j2 = 0; j2 <= radialSegments; j2++) {
            uv.x = i2 / tubularSegments;
            uv.y = j2 / radialSegments;
            uvs.push(uv.x, uv.y);
          }
        }
      }
    }
    copy(source) {
      super.copy(source);
      this.parameters = Object.assign({}, source.parameters);
      return this;
    }
    toJSON() {
      const data = super.toJSON();
      data.path = this.parameters.path.toJSON();
      return data;
    }
    /**
     * Factory method for creating an instance of this class from the given
     * JSON object.
     *
     * @param {Object} data - A JSON object representing the serialized geometry.
     * @return {TubeGeometry} A new instance.
     */
    static fromJSON(data) {
      return new TubeGeometry(
        new Curves[data.path.type]().fromJSON(data.path),
        data.tubularSegments,
        data.radius,
        data.radialSegments,
        data.closed
      );
    }
  }
  class ShadowMaterial extends Material {
    /**
     * Constructs a new shadow material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isShadowMaterial = true;
      this.type = "ShadowMaterial";
      this.color = new Color(0);
      this.transparent = true;
      this.fog = true;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.color.copy(source.color);
      this.fog = source.fog;
      return this;
    }
  }
  class MeshStandardMaterial extends Material {
    /**
     * Constructs a new mesh standard material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isMeshStandardMaterial = true;
      this.type = "MeshStandardMaterial";
      this.defines = { "STANDARD": "" };
      this.color = new Color(16777215);
      this.roughness = 1;
      this.metalness = 0;
      this.map = null;
      this.lightMap = null;
      this.lightMapIntensity = 1;
      this.aoMap = null;
      this.aoMapIntensity = 1;
      this.emissive = new Color(0);
      this.emissiveIntensity = 1;
      this.emissiveMap = null;
      this.bumpMap = null;
      this.bumpScale = 1;
      this.normalMap = null;
      this.normalMapType = TangentSpaceNormalMap;
      this.normalScale = new Vector2(1, 1);
      this.displacementMap = null;
      this.displacementScale = 1;
      this.displacementBias = 0;
      this.roughnessMap = null;
      this.metalnessMap = null;
      this.alphaMap = null;
      this.envMap = null;
      this.envMapRotation = new Euler();
      this.envMapIntensity = 1;
      this.wireframe = false;
      this.wireframeLinewidth = 1;
      this.wireframeLinecap = "round";
      this.wireframeLinejoin = "round";
      this.flatShading = false;
      this.fog = true;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.defines = { "STANDARD": "" };
      this.color.copy(source.color);
      this.roughness = source.roughness;
      this.metalness = source.metalness;
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.emissive.copy(source.emissive);
      this.emissiveMap = source.emissiveMap;
      this.emissiveIntensity = source.emissiveIntensity;
      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.roughnessMap = source.roughnessMap;
      this.metalnessMap = source.metalnessMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.envMapRotation.copy(source.envMapRotation);
      this.envMapIntensity = source.envMapIntensity;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.flatShading = source.flatShading;
      this.fog = source.fog;
      return this;
    }
  }
  class MeshPhysicalMaterial extends MeshStandardMaterial {
    /**
     * Constructs a new mesh physical material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isMeshPhysicalMaterial = true;
      this.defines = {
        "STANDARD": "",
        "PHYSICAL": ""
      };
      this.type = "MeshPhysicalMaterial";
      this.anisotropyRotation = 0;
      this.anisotropyMap = null;
      this.clearcoatMap = null;
      this.clearcoatRoughness = 0;
      this.clearcoatRoughnessMap = null;
      this.clearcoatNormalScale = new Vector2(1, 1);
      this.clearcoatNormalMap = null;
      this.ior = 1.5;
      Object.defineProperty(this, "reflectivity", {
        get: function() {
          return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
        },
        set: function(reflectivity) {
          this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
        }
      });
      this.iridescenceMap = null;
      this.iridescenceIOR = 1.3;
      this.iridescenceThicknessRange = [100, 400];
      this.iridescenceThicknessMap = null;
      this.sheenColor = new Color(0);
      this.sheenColorMap = null;
      this.sheenRoughness = 1;
      this.sheenRoughnessMap = null;
      this.transmissionMap = null;
      this.thickness = 0;
      this.thicknessMap = null;
      this.attenuationDistance = Infinity;
      this.attenuationColor = new Color(1, 1, 1);
      this.specularIntensity = 1;
      this.specularIntensityMap = null;
      this.specularColor = new Color(1, 1, 1);
      this.specularColorMap = null;
      this._anisotropy = 0;
      this._clearcoat = 0;
      this._dispersion = 0;
      this._iridescence = 0;
      this._sheen = 0;
      this._transmission = 0;
      this.setValues(parameters);
    }
    /**
     * The anisotropy strength.
     *
     * @type {number}
     * @default 0
     */
    get anisotropy() {
      return this._anisotropy;
    }
    set anisotropy(value) {
      if (this._anisotropy > 0 !== value > 0) {
        this.version++;
      }
      this._anisotropy = value;
    }
    /**
     * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
     * clear coat related properties to enable multilayer materials that have a
     * thin translucent layer over the base layer.
     *
     * @type {number}
     * @default 0
     */
    get clearcoat() {
      return this._clearcoat;
    }
    set clearcoat(value) {
      if (this._clearcoat > 0 !== value > 0) {
        this.version++;
      }
      this._clearcoat = value;
    }
    /**
     * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
     * the surface and the viewer, from `0.0` to `1.0`.
     *
     * @type {number}
     * @default 0
     */
    get iridescence() {
      return this._iridescence;
    }
    set iridescence(value) {
      if (this._iridescence > 0 !== value > 0) {
        this.version++;
      }
      this._iridescence = value;
    }
    /**
     * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
     * through a relatively clear volume. Any value zero or larger is valid, the typical range of
     * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
     *
     * @type {number}
     * @default 0
     */
    get dispersion() {
      return this._dispersion;
    }
    set dispersion(value) {
      if (this._dispersion > 0 !== value > 0) {
        this.version++;
      }
      this._dispersion = value;
    }
    /**
     * The intensity of the sheen layer, from `0.0` to `1.0`.
     *
     * @type {number}
     * @default 0
     */
    get sheen() {
      return this._sheen;
    }
    set sheen(value) {
      if (this._sheen > 0 !== value > 0) {
        this.version++;
      }
      this._sheen = value;
    }
    /**
     * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
     *
     * Thin, transparent or semitransparent, plastic or glass materials remain
     * largely reflective even if they are fully transmissive. The transmission
     * property can be used to model these materials.
     *
     * When transmission is non-zero, `opacity` should be  set to `1`.
     *
     * @type {number}
     * @default 0
     */
    get transmission() {
      return this._transmission;
    }
    set transmission(value) {
      if (this._transmission > 0 !== value > 0) {
        this.version++;
      }
      this._transmission = value;
    }
    copy(source) {
      super.copy(source);
      this.defines = {
        "STANDARD": "",
        "PHYSICAL": ""
      };
      this.anisotropy = source.anisotropy;
      this.anisotropyRotation = source.anisotropyRotation;
      this.anisotropyMap = source.anisotropyMap;
      this.clearcoat = source.clearcoat;
      this.clearcoatMap = source.clearcoatMap;
      this.clearcoatRoughness = source.clearcoatRoughness;
      this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
      this.clearcoatNormalMap = source.clearcoatNormalMap;
      this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
      this.dispersion = source.dispersion;
      this.ior = source.ior;
      this.iridescence = source.iridescence;
      this.iridescenceMap = source.iridescenceMap;
      this.iridescenceIOR = source.iridescenceIOR;
      this.iridescenceThicknessRange = [...source.iridescenceThicknessRange];
      this.iridescenceThicknessMap = source.iridescenceThicknessMap;
      this.sheen = source.sheen;
      this.sheenColor.copy(source.sheenColor);
      this.sheenColorMap = source.sheenColorMap;
      this.sheenRoughness = source.sheenRoughness;
      this.sheenRoughnessMap = source.sheenRoughnessMap;
      this.transmission = source.transmission;
      this.transmissionMap = source.transmissionMap;
      this.thickness = source.thickness;
      this.thicknessMap = source.thicknessMap;
      this.attenuationDistance = source.attenuationDistance;
      this.attenuationColor.copy(source.attenuationColor);
      this.specularIntensity = source.specularIntensity;
      this.specularIntensityMap = source.specularIntensityMap;
      this.specularColor.copy(source.specularColor);
      this.specularColorMap = source.specularColorMap;
      return this;
    }
  }
  class MeshDepthMaterial extends Material {
    /**
     * Constructs a new mesh depth material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isMeshDepthMaterial = true;
      this.type = "MeshDepthMaterial";
      this.depthPacking = BasicDepthPacking;
      this.map = null;
      this.alphaMap = null;
      this.displacementMap = null;
      this.displacementScale = 1;
      this.displacementBias = 0;
      this.wireframe = false;
      this.wireframeLinewidth = 1;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.depthPacking = source.depthPacking;
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      return this;
    }
  }
  class MeshDistanceMaterial extends Material {
    /**
     * Constructs a new mesh distance material.
     *
     * @param {Object} [parameters] - An object with one or more properties
     * defining the material's appearance. Any property of the material
     * (including any property from inherited materials) can be passed
     * in here. Color values can be passed any type of value accepted
     * by {@link Color#set}.
     */
    constructor(parameters) {
      super();
      this.isMeshDistanceMaterial = true;
      this.type = "MeshDistanceMaterial";
      this.map = null;
      this.alphaMap = null;
      this.displacementMap = null;
      this.displacementScale = 1;
      this.displacementBias = 0;
      this.setValues(parameters);
    }
    copy(source) {
      super.copy(source);
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      return this;
    }
  }
  function convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") {
      return new type(array);
    }
    return Array.prototype.slice.call(array);
  }
  function isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
  }
  function getKeyframeOrder(times) {
    function compareTime(i2, j2) {
      return times[i2] - times[j2];
    }
    const n2 = times.length;
    const result = new Array(n2);
    for (let i2 = 0; i2 !== n2; ++i2) result[i2] = i2;
    result.sort(compareTime);
    return result;
  }
  function sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
      const srcOffset = order[i2] * stride;
      for (let j2 = 0; j2 !== stride; ++j2) {
        result[dstOffset++] = values[srcOffset + j2];
      }
    }
    return result;
  }
  function flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i2 = 1, key = jsonKeys[0];
    while (key !== void 0 && key[valuePropertyName] === void 0) {
      key = jsonKeys[i2++];
    }
    if (key === void 0) return;
    let value = key[valuePropertyName];
    if (value === void 0) return;
    if (Array.isArray(value)) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values.push(...value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else if (value.toArray !== void 0) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          value.toArray(values, values.length);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values.push(value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    }
  }
  class Interpolant {
    /**
     * Constructs a new interpolant.
     *
     * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
     * @param {TypedArray} sampleValues - The sample values.
     * @param {number} sampleSize - The sample size
     * @param {TypedArray} [resultBuffer] - The result buffer.
     */
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      this.parameterPositions = parameterPositions;
      this._cachedIndex = 0;
      this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
      this.sampleValues = sampleValues;
      this.valueSize = sampleSize;
      this.settings = null;
      this.DefaultSettings_ = {};
    }
    /**
     * Evaluate the interpolant at position `t`.
     *
     * @param {number} t - The interpolation factor.
     * @return {TypedArray} The result buffer.
     */
    evaluate(t2) {
      const pp = this.parameterPositions;
      let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
      validate_interval: {
        seek: {
          let right;
          linear_scan: {
            forward_scan: if (!(t2 < t1)) {
              for (let giveUpAt = i1 + 2; ; ) {
                if (t1 === void 0) {
                  if (t2 < t0) break forward_scan;
                  i1 = pp.length;
                  this._cachedIndex = i1;
                  return this.copySampleValue_(i1 - 1);
                }
                if (i1 === giveUpAt) break;
                t0 = t1;
                t1 = pp[++i1];
                if (t2 < t1) {
                  break seek;
                }
              }
              right = pp.length;
              break linear_scan;
            }
            if (!(t2 >= t0)) {
              const t1global = pp[1];
              if (t2 < t1global) {
                i1 = 2;
                t0 = t1global;
              }
              for (let giveUpAt = i1 - 2; ; ) {
                if (t0 === void 0) {
                  this._cachedIndex = 0;
                  return this.copySampleValue_(0);
                }
                if (i1 === giveUpAt) break;
                t1 = t0;
                t0 = pp[--i1 - 1];
                if (t2 >= t0) {
                  break seek;
                }
              }
              right = i1;
              i1 = 0;
              break linear_scan;
            }
            break validate_interval;
          }
          while (i1 < right) {
            const mid = i1 + right >>> 1;
            if (t2 < pp[mid]) {
              right = mid;
            } else {
              i1 = mid + 1;
            }
          }
          t1 = pp[i1];
          t0 = pp[i1 - 1];
          if (t0 === void 0) {
            this._cachedIndex = 0;
            return this.copySampleValue_(0);
          }
          if (t1 === void 0) {
            i1 = pp.length;
            this._cachedIndex = i1;
            return this.copySampleValue_(i1 - 1);
          }
        }
        this._cachedIndex = i1;
        this.intervalChanged_(i1, t0, t1);
      }
      return this.interpolate_(i1, t0, t2, t1);
    }
    /**
     * Returns the interpolation settings.
     *
     * @return {Object} The interpolation settings.
     */
    getSettings_() {
      return this.settings || this.DefaultSettings_;
    }
    /**
     * Copies a sample value to the result buffer.
     *
     * @param {number} index - An index into the sample value buffer.
     * @return {TypedArray} The result buffer.
     */
    copySampleValue_(index) {
      const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
      for (let i2 = 0; i2 !== stride; ++i2) {
        result[i2] = values[offset + i2];
      }
      return result;
    }
    /**
     * Copies a sample value to the result buffer.
     *
     * @abstract
     * @param {number} i1 - An index into the sample value buffer.
     * @param {number} t0 - The previous interpolation factor.
     * @param {number} t - The current interpolation factor.
     * @param {number} t1 - The next interpolation factor.
     * @return {TypedArray} The result buffer.
     */
    interpolate_() {
      throw new Error("call to abstract method");
    }
    /**
     * Optional method that is executed when the interval has changed.
     *
     * @param {number} i1 - An index into the sample value buffer.
     * @param {number} t0 - The previous interpolation factor.
     * @param {number} t - The current interpolation factor.
     */
    intervalChanged_() {
    }
  }
  class CubicInterpolant extends Interpolant {
    /**
     * Constructs a new cubic interpolant.
     *
     * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
     * @param {TypedArray} sampleValues - The sample values.
     * @param {number} sampleSize - The sample size
     * @param {TypedArray} [resultBuffer] - The result buffer.
     */
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      super(parameterPositions, sampleValues, sampleSize, resultBuffer);
      this._weightPrev = -0;
      this._offsetPrev = -0;
      this._weightNext = -0;
      this._offsetNext = -0;
      this.DefaultSettings_ = {
        endingStart: ZeroCurvatureEnding,
        endingEnd: ZeroCurvatureEnding
      };
    }
    intervalChanged_(i1, t0, t1) {
      const pp = this.parameterPositions;
      let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
      if (tPrev === void 0) {
        switch (this.getSettings_().endingStart) {
          case ZeroSlopeEnding:
            iPrev = i1;
            tPrev = 2 * t0 - t1;
            break;
          case WrapAroundEnding:
            iPrev = pp.length - 2;
            tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
            break;
          default:
            iPrev = i1;
            tPrev = t1;
        }
      }
      if (tNext === void 0) {
        switch (this.getSettings_().endingEnd) {
          case ZeroSlopeEnding:
            iNext = i1;
            tNext = 2 * t1 - t0;
            break;
          case WrapAroundEnding:
            iNext = 1;
            tNext = t1 + pp[1] - pp[0];
            break;
          default:
            iNext = i1 - 1;
            tNext = t0;
        }
      }
      const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
      this._weightPrev = halfDt / (t0 - tPrev);
      this._weightNext = halfDt / (tNext - t1);
      this._offsetPrev = iPrev * stride;
      this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t2, t1) {
      const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p2 = (t2 - t0) / (t1 - t0), pp = p2 * p2, ppp = pp * p2;
      const sP = -wP * ppp + 2 * wP * pp - wP * p2;
      const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p2 + 1;
      const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p2;
      const sN = wN * ppp - wN * pp;
      for (let i2 = 0; i2 !== stride; ++i2) {
        result[i2] = sP * values[oP + i2] + s0 * values[o0 + i2] + s1 * values[o1 + i2] + sN * values[oN + i2];
      }
      return result;
    }
  }
  class LinearInterpolant extends Interpolant {
    /**
     * Constructs a new linear interpolant.
     *
     * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
     * @param {TypedArray} sampleValues - The sample values.
     * @param {number} sampleSize - The sample size
     * @param {TypedArray} [resultBuffer] - The result buffer.
     */
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t2, t1) {
      const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t2 - t0) / (t1 - t0), weight0 = 1 - weight1;
      for (let i2 = 0; i2 !== stride; ++i2) {
        result[i2] = values[offset0 + i2] * weight0 + values[offset1 + i2] * weight1;
      }
      return result;
    }
  }
  class DiscreteInterpolant extends Interpolant {
    /**
     * Constructs a new discrete interpolant.
     *
     * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
     * @param {TypedArray} sampleValues - The sample values.
     * @param {number} sampleSize - The sample size
     * @param {TypedArray} [resultBuffer] - The result buffer.
     */
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1) {
      return this.copySampleValue_(i1 - 1);
    }
  }
  class KeyframeTrack {
    /**
     * Constructs a new keyframe track.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
     */
    constructor(name, times, values, interpolation) {
      if (name === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
      if (times === void 0 || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
      this.name = name;
      this.times = convertArray(times, this.TimeBufferType);
      this.values = convertArray(values, this.ValueBufferType);
      this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
     * Converts the keyframe track to JSON.
     *
     * @static
     * @param {KeyframeTrack} track - The keyframe track to serialize.
     * @return {Object} The serialized keyframe track as JSON.
     */
    static toJSON(track) {
      const trackType = track.constructor;
      let json;
      if (trackType.toJSON !== this.toJSON) {
        json = trackType.toJSON(track);
      } else {
        json = {
          "name": track.name,
          "times": convertArray(track.times, Array),
          "values": convertArray(track.values, Array)
        };
        const interpolation = track.getInterpolation();
        if (interpolation !== track.DefaultInterpolation) {
          json.interpolation = interpolation;
        }
      }
      json.type = track.ValueTypeName;
      return json;
    }
    /**
     * Factory method for creating a new discrete interpolant.
     *
     * @static
     * @param {TypedArray} [result] - The result buffer.
     * @return {DiscreteInterpolant} The new interpolant.
     */
    InterpolantFactoryMethodDiscrete(result) {
      return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
     * Factory method for creating a new linear interpolant.
     *
     * @static
     * @param {TypedArray} [result] - The result buffer.
     * @return {LinearInterpolant} The new interpolant.
     */
    InterpolantFactoryMethodLinear(result) {
      return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
     * Factory method for creating a new smooth interpolant.
     *
     * @static
     * @param {TypedArray} [result] - The result buffer.
     * @return {CubicInterpolant} The new interpolant.
     */
    InterpolantFactoryMethodSmooth(result) {
      return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
     * Defines the interpolation factor method for this keyframe track.
     *
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
     * @return {KeyframeTrack} A reference to this keyframe track.
     */
    setInterpolation(interpolation) {
      let factoryMethod;
      switch (interpolation) {
        case InterpolateDiscrete:
          factoryMethod = this.InterpolantFactoryMethodDiscrete;
          break;
        case InterpolateLinear:
          factoryMethod = this.InterpolantFactoryMethodLinear;
          break;
        case InterpolateSmooth:
          factoryMethod = this.InterpolantFactoryMethodSmooth;
          break;
      }
      if (factoryMethod === void 0) {
        const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
        if (this.createInterpolant === void 0) {
          if (interpolation !== this.DefaultInterpolation) {
            this.setInterpolation(this.DefaultInterpolation);
          } else {
            throw new Error(message);
          }
        }
        console.warn("THREE.KeyframeTrack:", message);
        return this;
      }
      this.createInterpolant = factoryMethod;
      return this;
    }
    /**
     * Returns the current interpolation type.
     *
     * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
     */
    getInterpolation() {
      switch (this.createInterpolant) {
        case this.InterpolantFactoryMethodDiscrete:
          return InterpolateDiscrete;
        case this.InterpolantFactoryMethodLinear:
          return InterpolateLinear;
        case this.InterpolantFactoryMethodSmooth:
          return InterpolateSmooth;
      }
    }
    /**
     * Returns the value size.
     *
     * @return {number} The value size.
     */
    getValueSize() {
      return this.values.length / this.times.length;
    }
    /**
     * Moves all keyframes either forward or backward in time.
     *
     * @param {number} timeOffset - The offset to move the time values.
     * @return {KeyframeTrack} A reference to this keyframe track.
     */
    shift(timeOffset) {
      if (timeOffset !== 0) {
        const times = this.times;
        for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
          times[i2] += timeOffset;
        }
      }
      return this;
    }
    /**
     * Scale all keyframe times by a factor (useful for frame - seconds conversions).
     *
     * @param {number} timeScale - The time scale.
     * @return {KeyframeTrack} A reference to this keyframe track.
     */
    scale(timeScale) {
      if (timeScale !== 1) {
        const times = this.times;
        for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
          times[i2] *= timeScale;
        }
      }
      return this;
    }
    /**
     * Removes keyframes before and after animation without changing any values within the defined time range.
     *
     * Note: The method does not shift around keys to the start of the track time, because for interpolated
     * keys this will change their values
     *
     * @param {number} startTime - The start time.
     * @param {number} endTime - The end time.
     * @return {KeyframeTrack} A reference to this keyframe track.
     */
    trim(startTime, endTime) {
      const times = this.times, nKeys = times.length;
      let from = 0, to2 = nKeys - 1;
      while (from !== nKeys && times[from] < startTime) {
        ++from;
      }
      while (to2 !== -1 && times[to2] > endTime) {
        --to2;
      }
      ++to2;
      if (from !== 0 || to2 !== nKeys) {
        if (from >= to2) {
          to2 = Math.max(to2, 1);
          from = to2 - 1;
        }
        const stride = this.getValueSize();
        this.times = times.slice(from, to2);
        this.values = this.values.slice(from * stride, to2 * stride);
      }
      return this;
    }
    /**
     * Performs minimal validation on the keyframe track. Returns `true` if the values
     * are valid.
     *
     * @return {boolean} Whether the keyframes are valid or not.
     */
    validate() {
      let valid = true;
      const valueSize = this.getValueSize();
      if (valueSize - Math.floor(valueSize) !== 0) {
        console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
        valid = false;
      }
      const times = this.times, values = this.values, nKeys = times.length;
      if (nKeys === 0) {
        console.error("THREE.KeyframeTrack: Track is empty.", this);
        valid = false;
      }
      let prevTime = null;
      for (let i2 = 0; i2 !== nKeys; i2++) {
        const currTime = times[i2];
        if (typeof currTime === "number" && isNaN(currTime)) {
          console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
          valid = false;
          break;
        }
        if (prevTime !== null && prevTime > currTime) {
          console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
          valid = false;
          break;
        }
        prevTime = currTime;
      }
      if (values !== void 0) {
        if (isTypedArray(values)) {
          for (let i2 = 0, n2 = values.length; i2 !== n2; ++i2) {
            const value = values[i2];
            if (isNaN(value)) {
              console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
              valid = false;
              break;
            }
          }
        }
      }
      return valid;
    }
    /**
     * Optimizes this keyframe track by removing equivalent sequential keys (which are
     * common in morph target sequences).
     *
     * @return {AnimationClip} A reference to this animation clip.
     */
    optimize() {
      const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
      let writeIndex = 1;
      for (let i2 = 1; i2 < lastIndex; ++i2) {
        let keep = false;
        const time = times[i2];
        const timeNext = times[i2 + 1];
        if (time !== timeNext && (i2 !== 1 || time !== times[0])) {
          if (!smoothInterpolation) {
            const offset = i2 * stride, offsetP = offset - stride, offsetN = offset + stride;
            for (let j2 = 0; j2 !== stride; ++j2) {
              const value = values[offset + j2];
              if (value !== values[offsetP + j2] || value !== values[offsetN + j2]) {
                keep = true;
                break;
              }
            }
          } else {
            keep = true;
          }
        }
        if (keep) {
          if (i2 !== writeIndex) {
            times[writeIndex] = times[i2];
            const readOffset = i2 * stride, writeOffset = writeIndex * stride;
            for (let j2 = 0; j2 !== stride; ++j2) {
              values[writeOffset + j2] = values[readOffset + j2];
            }
          }
          ++writeIndex;
        }
      }
      if (lastIndex > 0) {
        times[writeIndex] = times[lastIndex];
        for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j2 = 0; j2 !== stride; ++j2) {
          values[writeOffset + j2] = values[readOffset + j2];
        }
        ++writeIndex;
      }
      if (writeIndex !== times.length) {
        this.times = times.slice(0, writeIndex);
        this.values = values.slice(0, writeIndex * stride);
      } else {
        this.times = times;
        this.values = values;
      }
      return this;
    }
    /**
     * Returns a new keyframe track with copied values from this instance.
     *
     * @return {KeyframeTrack} A clone of this instance.
     */
    clone() {
      const times = this.times.slice();
      const values = this.values.slice();
      const TypedKeyframeTrack = this.constructor;
      const track = new TypedKeyframeTrack(this.name, times, values);
      track.createInterpolant = this.createInterpolant;
      return track;
    }
  }
  KeyframeTrack.prototype.ValueTypeName = "";
  KeyframeTrack.prototype.TimeBufferType = Float32Array;
  KeyframeTrack.prototype.ValueBufferType = Float32Array;
  KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
  class BooleanKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new boolean keyframe track.
     *
     * This keyframe track type has no `interpolation` parameter because the
     * interpolation is always discrete.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     */
    constructor(name, times, values) {
      super(name, times, values);
    }
  }
  BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
  BooleanKeyframeTrack.prototype.ValueBufferType = Array;
  BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
  BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
  BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
  class ColorKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new color keyframe track.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
     */
    constructor(name, times, values, interpolation) {
      super(name, times, values, interpolation);
    }
  }
  ColorKeyframeTrack.prototype.ValueTypeName = "color";
  class NumberKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new number keyframe track.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
     */
    constructor(name, times, values, interpolation) {
      super(name, times, values, interpolation);
    }
  }
  NumberKeyframeTrack.prototype.ValueTypeName = "number";
  class QuaternionLinearInterpolant extends Interpolant {
    /**
     * Constructs a new SLERP interpolant.
     *
     * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
     * @param {TypedArray} sampleValues - The sample values.
     * @param {number} sampleSize - The sample size
     * @param {TypedArray} [resultBuffer] - The result buffer.
     */
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t2, t1) {
      const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t2 - t0) / (t1 - t0);
      let offset = i1 * stride;
      for (let end = offset + stride; offset !== end; offset += 4) {
        Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
      }
      return result;
    }
  }
  class QuaternionKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new Quaternion keyframe track.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
     */
    constructor(name, times, values, interpolation) {
      super(name, times, values, interpolation);
    }
    /**
     * Overwritten so the method returns Quaternion based interpolant.
     *
     * @static
     * @param {TypedArray} [result] - The result buffer.
     * @return {QuaternionLinearInterpolant} The new interpolant.
     */
    InterpolantFactoryMethodLinear(result) {
      return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
    }
  }
  QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
  QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
  class StringKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new string keyframe track.
     *
     * This keyframe track type has no `interpolation` parameter because the
     * interpolation is always discrete.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     */
    constructor(name, times, values) {
      super(name, times, values);
    }
  }
  StringKeyframeTrack.prototype.ValueTypeName = "string";
  StringKeyframeTrack.prototype.ValueBufferType = Array;
  StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
  StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
  StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
  class VectorKeyframeTrack extends KeyframeTrack {
    /**
     * Constructs a new vector keyframe track.
     *
     * @param {string} name - The keyframe track's name.
     * @param {Array<number>} times - A list of keyframe times.
     * @param {Array<number>} values - A list of keyframe values.
     * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
     */
    constructor(name, times, values, interpolation) {
      super(name, times, values, interpolation);
    }
  }
  VectorKeyframeTrack.prototype.ValueTypeName = "vector";
  class AnimationClip {
    /**
     * Constructs a new animation clip.
     *
     * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
     * use the static interface of this class for creating clips. In most cases though, animation clips
     * will automatically be created by loaders when importing animated 3D assets.
     *
     * @param {string} [name=''] - The clip's name.
     * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
     * the duration will be calculated from the passed keyframes.
     * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
     * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
     * is blended/combined when two or more animations are simultaneously played.
     */
    constructor(name = "", duration = -1, tracks = [], blendMode = NormalAnimationBlendMode) {
      this.name = name;
      this.tracks = tracks;
      this.duration = duration;
      this.blendMode = blendMode;
      this.uuid = generateUUID();
      if (this.duration < 0) {
        this.resetDuration();
      }
    }
    /**
     * Factory method for creating an animation clip from the given JSON.
     *
     * @static
     * @param {Object} json - The serialized animation clip.
     * @return {AnimationClip} The new animation clip.
     */
    static parse(json) {
      const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
      for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
        tracks.push(parseKeyframeTrack(jsonTracks[i2]).scale(frameTime));
      }
      const clip = new this(json.name, json.duration, tracks, json.blendMode);
      clip.uuid = json.uuid;
      return clip;
    }
    /**
     * Serializes the given animation clip into JSON.
     *
     * @static
     * @param {AnimationClip} clip - The animation clip to serialize.
     * @return {Object} The JSON object.
     */
    static toJSON(clip) {
      const tracks = [], clipTracks = clip.tracks;
      const json = {
        "name": clip.name,
        "duration": clip.duration,
        "tracks": tracks,
        "uuid": clip.uuid,
        "blendMode": clip.blendMode
      };
      for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
        tracks.push(KeyframeTrack.toJSON(clipTracks[i2]));
      }
      return json;
    }
    /**
     * Returns a new animation clip from the passed morph targets array of a
     * geometry, taking a name and the number of frames per second.
     *
     * Note: The fps parameter is required, but the animation speed can be
     * overridden via {@link AnimationAction#setDuration}.
     *
     * @static
     * @param {string} name - The name of the animation clip.
     * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
     * @param {number} fps - The Frames-Per-Second value.
     * @param {boolean} noLoop - Whether the clip should be no loop or not.
     * @return {AnimationClip} The new animation clip.
     */
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
      const numMorphTargets = morphTargetSequence.length;
      const tracks = [];
      for (let i2 = 0; i2 < numMorphTargets; i2++) {
        let times = [];
        let values = [];
        times.push(
          (i2 + numMorphTargets - 1) % numMorphTargets,
          i2,
          (i2 + 1) % numMorphTargets
        );
        values.push(0, 1, 0);
        const order = getKeyframeOrder(times);
        times = sortedArray(times, 1, order);
        values = sortedArray(values, 1, order);
        if (!noLoop && times[0] === 0) {
          times.push(numMorphTargets);
          values.push(values[0]);
        }
        tracks.push(
          new NumberKeyframeTrack(
            ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
            times,
            values
          ).scale(1 / fps)
        );
      }
      return new this(name, -1, tracks);
    }
    /**
     * Searches for an animation clip by name, taking as its first parameter
     * either an array of clips, or a mesh or geometry that contains an
     * array named "animations" property.
     *
     * @static
     * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
     * @param {string} name - The name to search for.
     * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
     */
    static findByName(objectOrClipArray, name) {
      let clipArray = objectOrClipArray;
      if (!Array.isArray(objectOrClipArray)) {
        const o2 = objectOrClipArray;
        clipArray = o2.geometry && o2.geometry.animations || o2.animations;
      }
      for (let i2 = 0; i2 < clipArray.length; i2++) {
        if (clipArray[i2].name === name) {
          return clipArray[i2];
        }
      }
      return null;
    }
    /**
     * Returns an array of new AnimationClips created from the morph target
     * sequences of a geometry, trying to sort morph target names into
     * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
     *
     * See {@link MD2Loader#parse} as an example for how the method should be used.
     *
     * @static
     * @param {Array<Object>} morphTargets - A sequence of morph targets.
     * @param {number} fps - The Frames-Per-Second value.
     * @param {boolean} noLoop - Whether the clip should be no loop or not.
     * @return {Array<AnimationClip>} An array of new animation clips.
     */
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
      const animationToMorphTargets = {};
      const pattern = /^([\w-]*?)([\d]+)$/;
      for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
        const morphTarget = morphTargets[i2];
        const parts = morphTarget.name.match(pattern);
        if (parts && parts.length > 1) {
          const name = parts[1];
          let animationMorphTargets = animationToMorphTargets[name];
          if (!animationMorphTargets) {
            animationToMorphTargets[name] = animationMorphTargets = [];
          }
          animationMorphTargets.push(morphTarget);
        }
      }
      const clips = [];
      for (const name in animationToMorphTargets) {
        clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
      }
      return clips;
    }
    /**
     * Parses the `animation.hierarchy` format and returns a new animation clip.
     *
     * @static
     * @deprecated since r175.
     * @param {Object} animation - A serialized animation clip as JSON.
     * @param {Array<Bones>} bones - An array of bones.
     * @return {?AnimationClip} The new animation clip.
     */
    static parseAnimation(animation, bones) {
      console.warn("THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185");
      if (!animation) {
        console.error("THREE.AnimationClip: No animation in JSONLoader data.");
        return null;
      }
      const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
        if (animationKeys.length !== 0) {
          const times = [];
          const values = [];
          flattenJSON(animationKeys, times, values, propertyName);
          if (times.length !== 0) {
            destTracks.push(new trackType(trackName, times, values));
          }
        }
      };
      const tracks = [];
      const clipName = animation.name || "default";
      const fps = animation.fps || 30;
      const blendMode = animation.blendMode;
      let duration = animation.length || -1;
      const hierarchyTracks = animation.hierarchy || [];
      for (let h2 = 0; h2 < hierarchyTracks.length; h2++) {
        const animationKeys = hierarchyTracks[h2].keys;
        if (!animationKeys || animationKeys.length === 0) continue;
        if (animationKeys[0].morphTargets) {
          const morphTargetNames = {};
          let k2;
          for (k2 = 0; k2 < animationKeys.length; k2++) {
            if (animationKeys[k2].morphTargets) {
              for (let m = 0; m < animationKeys[k2].morphTargets.length; m++) {
                morphTargetNames[animationKeys[k2].morphTargets[m]] = -1;
              }
            }
          }
          for (const morphTargetName in morphTargetNames) {
            const times = [];
            const values = [];
            for (let m = 0; m !== animationKeys[k2].morphTargets.length; ++m) {
              const animationKey = animationKeys[k2];
              times.push(animationKey.time);
              values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
            }
            tracks.push(new NumberKeyframeTrack(".morphTargetInfluence[" + morphTargetName + "]", times, values));
          }
          duration = morphTargetNames.length * fps;
        } else {
          const boneName = ".bones[" + bones[h2].name + "]";
          addNonemptyTrack(
            VectorKeyframeTrack,
            boneName + ".position",
            animationKeys,
            "pos",
            tracks
          );
          addNonemptyTrack(
            QuaternionKeyframeTrack,
            boneName + ".quaternion",
            animationKeys,
            "rot",
            tracks
          );
          addNonemptyTrack(
            VectorKeyframeTrack,
            boneName + ".scale",
            animationKeys,
            "scl",
            tracks
          );
        }
      }
      if (tracks.length === 0) {
        return null;
      }
      const clip = new this(clipName, duration, tracks, blendMode);
      return clip;
    }
    /**
     * Sets the duration of this clip to the duration of its longest keyframe track.
     *
     * @return {AnimationClip} A reference to this animation clip.
     */
    resetDuration() {
      const tracks = this.tracks;
      let duration = 0;
      for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
        const track = this.tracks[i2];
        duration = Math.max(duration, track.times[track.times.length - 1]);
      }
      this.duration = duration;
      return this;
    }
    /**
     * Trims all tracks to the clip's duration.
     *
     * @return {AnimationClip} A reference to this animation clip.
     */
    trim() {
      for (let i2 = 0; i2 < this.tracks.length; i2++) {
        this.tracks[i2].trim(0, this.duration);
      }
      return this;
    }
    /**
     * Performs minimal validation on each track in the clip. Returns `true` if all
     * tracks are valid.
     *
     * @return {boolean} Whether the clip's keyframes are valid or not.
     */
    validate() {
      let valid = true;
      for (let i2 = 0; i2 < this.tracks.length; i2++) {
        valid = valid && this.tracks[i2].validate();
      }
      return valid;
    }
    /**
     * Optimizes each track by removing equivalent sequential keys (which are
     * common in morph target sequences).
     *
     * @return {AnimationClip} A reference to this animation clip.
     */
    optimize() {
      for (let i2 = 0; i2 < this.tracks.length; i2++) {
        this.tracks[i2].optimize();
      }
      return this;
    }
    /**
     * Returns a new animation clip with copied values from this instance.
     *
     * @return {AnimationClip} A clone of this instance.
     */
    clone() {
      const tracks = [];
      for (let i2 = 0; i2 < this.tracks.length; i2++) {
        tracks.push(this.tracks[i2].clone());
      }
      return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    /**
     * Serializes this animation clip into JSON.
     *
     * @return {Object} The JSON object.
     */
    toJSON() {
      return this.constructor.toJSON(this);
    }
  }
  function getTrackTypeForValueTypeName(typeName) {
    switch (typeName.toLowerCase()) {
      case "scalar":
      case "double":
      case "float":
      case "number":
      case "integer":
        return NumberKeyframeTrack;
      case "vector":
      case "vector2":
      case "vector3":
      case "vector4":
        return VectorKeyframeTrack;
      case "color":
        return ColorKeyframeTrack;
      case "quaternion":
        return QuaternionKeyframeTrack;
      case "bool":
      case "boolean":
        return BooleanKeyframeTrack;
      case "string":
        return StringKeyframeTrack;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
  }
  function parseKeyframeTrack(json) {
    if (json.type === void 0) {
      throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    }
    const trackType = getTrackTypeForValueTypeName(json.type);
    if (json.times === void 0) {
      const times = [], values = [];
      flattenJSON(json.keys, times, values, "value");
      json.times = times;
      json.values = values;
    }
    if (trackType.parse !== void 0) {
      return trackType.parse(json);
    } else {
      return new trackType(json.name, json.times, json.values, json.interpolation);
    }
  }
  const Cache = {
    /**
     * Whether caching is enabled or not.
     *
     * @static
     * @type {boolean}
     * @default false
     */
    enabled: false,
    /**
     * A dictionary that holds cached files.
     *
     * @static
     * @type {Object<string,Object>}
     */
    files: {},
    /**
     * Adds a cache entry with a key to reference the file. If this key already
     * holds a file, it is overwritten.
     *
     * @static
     * @param {string} key - The key to reference the cached file.
     * @param {Object} file -  The file to be cached.
     */
    add: function(key, file) {
      if (this.enabled === false) return;
      this.files[key] = file;
    },
    /**
     * Gets the cached value for the given key.
     *
     * @static
     * @param {string} key - The key to reference the cached file.
     * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
     */
    get: function(key) {
      if (this.enabled === false) return;
      return this.files[key];
    },
    /**
     * Removes the cached file associated with the given key.
     *
     * @static
     * @param {string} key - The key to reference the cached file.
     */
    remove: function(key) {
      delete this.files[key];
    },
    /**
     * Remove all values from the cache.
     *
     * @static
     */
    clear: function() {
      this.files = {};
    }
  };
  class LoadingManager {
    /**
     * Constructs a new loading manager.
     *
     * @param {Function} [onLoad] - Executes when all items have been loaded.
     * @param {Function} [onProgress] - Executes when single items have been loaded.
     * @param {Function} [onError] - Executes when an error occurs.
     */
    constructor(onLoad, onProgress, onError) {
      const scope = this;
      let isLoading = false;
      let itemsLoaded = 0;
      let itemsTotal = 0;
      let urlModifier = void 0;
      const handlers = [];
      this.onStart = void 0;
      this.onLoad = onLoad;
      this.onProgress = onProgress;
      this.onError = onError;
      this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
          if (scope.onStart !== void 0) {
            scope.onStart(url, itemsLoaded, itemsTotal);
          }
        }
        isLoading = true;
      };
      this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== void 0) {
          scope.onProgress(url, itemsLoaded, itemsTotal);
        }
        if (itemsLoaded === itemsTotal) {
          isLoading = false;
          if (scope.onLoad !== void 0) {
            scope.onLoad();
          }
        }
      };
      this.itemError = function(url) {
        if (scope.onError !== void 0) {
          scope.onError(url);
        }
      };
      this.resolveURL = function(url) {
        if (urlModifier) {
          return urlModifier(url);
        }
        return url;
      };
      this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
      };
      this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
      };
      this.removeHandler = function(regex) {
        const index = handlers.indexOf(regex);
        if (index !== -1) {
          handlers.splice(index, 2);
        }
        return this;
      };
      this.getHandler = function(file) {
        for (let i2 = 0, l2 = handlers.length; i2 < l2; i2 += 2) {
          const regex = handlers[i2];
          const loader = handlers[i2 + 1];
          if (regex.global) regex.lastIndex = 0;
          if (regex.test(file)) {
            return loader;
          }
        }
        return null;
      };
    }
  }
  const DefaultLoadingManager = /* @__PURE__ */ new LoadingManager();
  class Loader {
    /**
     * Constructs a new loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
      this.crossOrigin = "anonymous";
      this.withCredentials = false;
      this.path = "";
      this.resourcePath = "";
      this.requestHeader = {};
    }
    /**
     * This method needs to be implemented by all concrete loaders. It holds the
     * logic for loading assets from the backend.
     *
     * @param {string} url - The path/URL of the file to be loaded.
     * @param {Function} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
     * @param {onErrorCallback} [onError] - Executed when errors occur.
     */
    load() {
    }
    /**
     * A async version of {@link Loader#load}.
     *
     * @param {string} url - The path/URL of the file to be loaded.
     * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
     * @return {Promise} A Promise that resolves when the asset has been loaded.
     */
    loadAsync(url, onProgress) {
      const scope = this;
      return new Promise(function(resolve, reject) {
        scope.load(url, resolve, onProgress, reject);
      });
    }
    /**
     * This method needs to be implemented by all concrete loaders. It holds the
     * logic for parsing the asset into three.js entities.
     *
     * @param {any} data - The data to parse.
     */
    parse() {
    }
    /**
     * Sets the `crossOrigin` String to implement CORS for loading the URL
     * from a different domain that allows CORS.
     *
     * @param {string} crossOrigin - The `crossOrigin` value.
     * @return {Loader} A reference to this instance.
     */
    setCrossOrigin(crossOrigin) {
      this.crossOrigin = crossOrigin;
      return this;
    }
    /**
     * Whether the XMLHttpRequest uses credentials such as cookies, authorization
     * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
     *
     * Note: This setting has no effect if you are loading files locally or from the same domain.
     *
     * @param {boolean} value - The `withCredentials` value.
     * @return {Loader} A reference to this instance.
     */
    setWithCredentials(value) {
      this.withCredentials = value;
      return this;
    }
    /**
     * Sets the base path for the asset.
     *
     * @param {string} path - The base path.
     * @return {Loader} A reference to this instance.
     */
    setPath(path) {
      this.path = path;
      return this;
    }
    /**
     * Sets the base path for dependent resources like textures.
     *
     * @param {string} resourcePath - The resource path.
     * @return {Loader} A reference to this instance.
     */
    setResourcePath(resourcePath) {
      this.resourcePath = resourcePath;
      return this;
    }
    /**
     * Sets the given request header.
     *
     * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
     * for configuring the HTTP request.
     * @return {Loader} A reference to this instance.
     */
    setRequestHeader(requestHeader) {
      this.requestHeader = requestHeader;
      return this;
    }
  }
  Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
  const loading = {};
  class HttpError extends Error {
    constructor(message, response) {
      super(message);
      this.response = response;
    }
  }
  class FileLoader extends Loader {
    /**
     * Constructs a new file loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      super(manager);
      this.mimeType = "";
      this.responseType = "";
    }
    /**
     * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
     *
     * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
     * @param {function(any)} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
     * @param {onErrorCallback} [onError] - Executed when errors occur.
     * @return {any|undefined} The cached resource if available.
     */
    load(url, onLoad, onProgress, onError) {
      if (url === void 0) url = "";
      if (this.path !== void 0) url = this.path + url;
      url = this.manager.resolveURL(url);
      const cached = Cache.get(`file:${url}`);
      if (cached !== void 0) {
        this.manager.itemStart(url);
        setTimeout(() => {
          if (onLoad) onLoad(cached);
          this.manager.itemEnd(url);
        }, 0);
        return cached;
      }
      if (loading[url] !== void 0) {
        loading[url].push({
          onLoad,
          onProgress,
          onError
        });
        return;
      }
      loading[url] = [];
      loading[url].push({
        onLoad,
        onProgress,
        onError
      });
      const req = new Request(url, {
        headers: new Headers(this.requestHeader),
        credentials: this.withCredentials ? "include" : "same-origin"
        // An abort controller could be added within a future PR
      });
      const mimeType = this.mimeType;
      const responseType = this.responseType;
      fetch(req).then((response) => {
        if (response.status === 200 || response.status === 0) {
          if (response.status === 0) {
            console.warn("THREE.FileLoader: HTTP Status 0 received.");
          }
          if (typeof ReadableStream === "undefined" || response.body === void 0 || response.body.getReader === void 0) {
            return response;
          }
          const callbacks = loading[url];
          const reader = response.body.getReader();
          const contentLength = response.headers.get("X-File-Size") || response.headers.get("Content-Length");
          const total = contentLength ? parseInt(contentLength) : 0;
          const lengthComputable = total !== 0;
          let loaded = 0;
          const stream = new ReadableStream({
            start(controller) {
              readData();
              function readData() {
                reader.read().then(({ done, value }) => {
                  if (done) {
                    controller.close();
                  } else {
                    loaded += value.byteLength;
                    const event = new ProgressEvent("progress", { lengthComputable, loaded, total });
                    for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
                      const callback = callbacks[i2];
                      if (callback.onProgress) callback.onProgress(event);
                    }
                    controller.enqueue(value);
                    readData();
                  }
                }, (e2) => {
                  controller.error(e2);
                });
              }
            }
          });
          return new Response(stream);
        } else {
          throw new HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }
      }).then((response) => {
        switch (responseType) {
          case "arraybuffer":
            return response.arrayBuffer();
          case "blob":
            return response.blob();
          case "document":
            return response.text().then((text) => {
              const parser = new DOMParser();
              return parser.parseFromString(text, mimeType);
            });
          case "json":
            return response.json();
          default:
            if (mimeType === "") {
              return response.text();
            } else {
              const re2 = /charset="?([^;"\s]*)"?/i;
              const exec = re2.exec(mimeType);
              const label = exec && exec[1] ? exec[1].toLowerCase() : void 0;
              const decoder = new TextDecoder(label);
              return response.arrayBuffer().then((ab) => decoder.decode(ab));
            }
        }
      }).then((data) => {
        Cache.add(`file:${url}`, data);
        const callbacks = loading[url];
        delete loading[url];
        for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
          const callback = callbacks[i2];
          if (callback.onLoad) callback.onLoad(data);
        }
      }).catch((err) => {
        const callbacks = loading[url];
        if (callbacks === void 0) {
          this.manager.itemError(url);
          throw err;
        }
        delete loading[url];
        for (let i2 = 0, il = callbacks.length; i2 < il; i2++) {
          const callback = callbacks[i2];
          if (callback.onError) callback.onError(err);
        }
        this.manager.itemError(url);
      }).finally(() => {
        this.manager.itemEnd(url);
      });
      this.manager.itemStart(url);
    }
    /**
     * Sets the expected response type.
     *
     * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
     * @return {FileLoader} A reference to this file loader.
     */
    setResponseType(value) {
      this.responseType = value;
      return this;
    }
    /**
     * Sets the expected mime type of the loaded file.
     *
     * @param {string} value - The mime type.
     * @return {FileLoader} A reference to this file loader.
     */
    setMimeType(value) {
      this.mimeType = value;
      return this;
    }
  }
  const _loading = /* @__PURE__ */ new WeakMap();
  class ImageLoader extends Loader {
    /**
     * Constructs a new image loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      super(manager);
    }
    /**
     * Starts loading from the given URL and passes the loaded image
     * to the `onLoad()` callback. The method also returns a new `Image` object which can
     * directly be used for texture creation. If you do it this way, the texture
     * may pop up in your scene once the respective loading process is finished.
     *
     * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
     * @param {function(Image)} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} onProgress - Unsupported in this loader.
     * @param {onErrorCallback} onError - Executed when errors occur.
     * @return {Image} The image.
     */
    load(url, onLoad, onProgress, onError) {
      if (this.path !== void 0) url = this.path + url;
      url = this.manager.resolveURL(url);
      const scope = this;
      const cached = Cache.get(`image:${url}`);
      if (cached !== void 0) {
        if (cached.complete === true) {
          scope.manager.itemStart(url);
          setTimeout(function() {
            if (onLoad) onLoad(cached);
            scope.manager.itemEnd(url);
          }, 0);
        } else {
          let arr = _loading.get(cached);
          if (arr === void 0) {
            arr = [];
            _loading.set(cached, arr);
          }
          arr.push({ onLoad, onError });
        }
        return cached;
      }
      const image = createElementNS("img");
      function onImageLoad() {
        removeEventListeners();
        if (onLoad) onLoad(this);
        const callbacks = _loading.get(this) || [];
        for (let i2 = 0; i2 < callbacks.length; i2++) {
          const callback = callbacks[i2];
          if (callback.onLoad) callback.onLoad(this);
        }
        _loading.delete(this);
        scope.manager.itemEnd(url);
      }
      function onImageError(event) {
        removeEventListeners();
        if (onError) onError(event);
        Cache.remove(`image:${url}`);
        const callbacks = _loading.get(this) || [];
        for (let i2 = 0; i2 < callbacks.length; i2++) {
          const callback = callbacks[i2];
          if (callback.onError) callback.onError(event);
        }
        _loading.delete(this);
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      }
      function removeEventListeners() {
        image.removeEventListener("load", onImageLoad, false);
        image.removeEventListener("error", onImageError, false);
      }
      image.addEventListener("load", onImageLoad, false);
      image.addEventListener("error", onImageError, false);
      if (url.slice(0, 5) !== "data:") {
        if (this.crossOrigin !== void 0) image.crossOrigin = this.crossOrigin;
      }
      Cache.add(`image:${url}`, image);
      scope.manager.itemStart(url);
      image.src = url;
      return image;
    }
  }
  class TextureLoader extends Loader {
    /**
     * Constructs a new texture loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      super(manager);
    }
    /**
     * Starts loading from the given URL and pass the fully loaded texture
     * to the `onLoad()` callback. The method also returns a new texture object which can
     * directly be used for material creation. If you do it this way, the texture
     * may pop up in your scene once the respective loading process is finished.
     *
     * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
     * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} onProgress - Unsupported in this loader.
     * @param {onErrorCallback} onError - Executed when errors occur.
     * @return {Texture} The texture.
     */
    load(url, onLoad, onProgress, onError) {
      const texture = new Texture();
      const loader = new ImageLoader(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      loader.setPath(this.path);
      loader.load(url, function(image) {
        texture.image = image;
        texture.needsUpdate = true;
        if (onLoad !== void 0) {
          onLoad(texture);
        }
      }, onProgress, onError);
      return texture;
    }
  }
  class Light extends Object3D {
    /**
     * Constructs a new light.
     *
     * @param {(number|Color|string)} [color=0xffffff] - The light's color.
     * @param {number} [intensity=1] - The light's strength/intensity.
     */
    constructor(color, intensity = 1) {
      super();
      this.isLight = true;
      this.type = "Light";
      this.color = new Color(color);
      this.intensity = intensity;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     */
    dispose() {
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.color.copy(source.color);
      this.intensity = source.intensity;
      return this;
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      data.object.color = this.color.getHex();
      data.object.intensity = this.intensity;
      if (this.groundColor !== void 0) data.object.groundColor = this.groundColor.getHex();
      if (this.distance !== void 0) data.object.distance = this.distance;
      if (this.angle !== void 0) data.object.angle = this.angle;
      if (this.decay !== void 0) data.object.decay = this.decay;
      if (this.penumbra !== void 0) data.object.penumbra = this.penumbra;
      if (this.shadow !== void 0) data.object.shadow = this.shadow.toJSON();
      if (this.target !== void 0) data.object.target = this.target.uuid;
      return data;
    }
  }
  class HemisphereLight extends Light {
    /**
     * Constructs a new hemisphere light.
     *
     * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
     * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
     * @param {number} [intensity=1] - The light's strength/intensity.
     */
    constructor(skyColor, groundColor, intensity) {
      super(skyColor, intensity);
      this.isHemisphereLight = true;
      this.type = "HemisphereLight";
      this.position.copy(Object3D.DEFAULT_UP);
      this.updateMatrix();
      this.groundColor = new Color(groundColor);
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.groundColor.copy(source.groundColor);
      return this;
    }
  }
  const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4();
  const _lightPositionWorld$1 = /* @__PURE__ */ new Vector3();
  const _lookTarget$1 = /* @__PURE__ */ new Vector3();
  class LightShadow {
    /**
     * Constructs a new light shadow.
     *
     * @param {Camera} camera - The light's view of the world.
     */
    constructor(camera) {
      this.camera = camera;
      this.intensity = 1;
      this.bias = 0;
      this.normalBias = 0;
      this.radius = 1;
      this.blurSamples = 8;
      this.mapSize = new Vector2(512, 512);
      this.mapType = UnsignedByteType;
      this.map = null;
      this.mapPass = null;
      this.matrix = new Matrix4();
      this.autoUpdate = true;
      this.needsUpdate = false;
      this._frustum = new Frustum();
      this._frameExtents = new Vector2(1, 1);
      this._viewportCount = 1;
      this._viewports = [
        new Vector4(0, 0, 1, 1)
      ];
    }
    /**
     * Used internally by the renderer to get the number of viewports that need
     * to be rendered for this shadow.
     *
     * @return {number} The viewport count.
     */
    getViewportCount() {
      return this._viewportCount;
    }
    /**
     * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
     *
     * @return {Frustum} The shadow camera frustum.
     */
    getFrustum() {
      return this._frustum;
    }
    /**
     * Update the matrices for the camera and shadow, used internally by the renderer.
     *
     * @param {Light} light - The light for which the shadow is being rendered.
     */
    updateMatrices(light) {
      const shadowCamera = this.camera;
      const shadowMatrix = this.matrix;
      _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
      shadowCamera.position.copy(_lightPositionWorld$1);
      _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
      shadowCamera.lookAt(_lookTarget$1);
      shadowCamera.updateMatrixWorld();
      _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
      this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
      shadowMatrix.set(
        0.5,
        0,
        0,
        0.5,
        0,
        0.5,
        0,
        0.5,
        0,
        0,
        0.5,
        0.5,
        0,
        0,
        0,
        1
      );
      shadowMatrix.multiply(_projScreenMatrix$1);
    }
    /**
     * Returns a viewport definition for the given viewport index.
     *
     * @param {number} viewportIndex - The viewport index.
     * @return {Vector4} The viewport.
     */
    getViewport(viewportIndex) {
      return this._viewports[viewportIndex];
    }
    /**
     * Returns the frame extends.
     *
     * @return {Vector2} The frame extends.
     */
    getFrameExtents() {
      return this._frameExtents;
    }
    /**
     * Frees the GPU-related resources allocated by this instance. Call this
     * method whenever this instance is no longer used in your app.
     */
    dispose() {
      if (this.map) {
        this.map.dispose();
      }
      if (this.mapPass) {
        this.mapPass.dispose();
      }
    }
    /**
     * Copies the values of the given light shadow instance to this instance.
     *
     * @param {LightShadow} source - The light shadow to copy.
     * @return {LightShadow} A reference to this light shadow instance.
     */
    copy(source) {
      this.camera = source.camera.clone();
      this.intensity = source.intensity;
      this.bias = source.bias;
      this.radius = source.radius;
      this.autoUpdate = source.autoUpdate;
      this.needsUpdate = source.needsUpdate;
      this.normalBias = source.normalBias;
      this.blurSamples = source.blurSamples;
      this.mapSize.copy(source.mapSize);
      return this;
    }
    /**
     * Returns a new light shadow instance with copied values from this instance.
     *
     * @return {LightShadow} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
    /**
     * Serializes the light shadow into JSON.
     *
     * @return {Object} A JSON object representing the serialized light shadow.
     * @see {@link ObjectLoader#parse}
     */
    toJSON() {
      const object = {};
      if (this.intensity !== 1) object.intensity = this.intensity;
      if (this.bias !== 0) object.bias = this.bias;
      if (this.normalBias !== 0) object.normalBias = this.normalBias;
      if (this.radius !== 1) object.radius = this.radius;
      if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
      object.camera = this.camera.toJSON(false).object;
      delete object.camera.matrix;
      return object;
    }
  }
  class SpotLightShadow extends LightShadow {
    /**
     * Constructs a new spot light shadow.
     */
    constructor() {
      super(new PerspectiveCamera(50, 1, 0.5, 500));
      this.isSpotLightShadow = true;
      this.focus = 1;
      this.aspect = 1;
    }
    updateMatrices(light) {
      const camera = this.camera;
      const fov2 = RAD2DEG * 2 * light.angle * this.focus;
      const aspect2 = this.mapSize.width / this.mapSize.height * this.aspect;
      const far = light.distance || camera.far;
      if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
        camera.fov = fov2;
        camera.aspect = aspect2;
        camera.far = far;
        camera.updateProjectionMatrix();
      }
      super.updateMatrices(light);
    }
    copy(source) {
      super.copy(source);
      this.focus = source.focus;
      return this;
    }
  }
  class SpotLight extends Light {
    /**
     * Constructs a new spot light.
     *
     * @param {(number|Color|string)} [color=0xffffff] - The light's color.
     * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
     * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
     * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
     * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
     * @param {number} [decay=2] - The amount the light dims along the distance of the light.
     */
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2) {
      super(color, intensity);
      this.isSpotLight = true;
      this.type = "SpotLight";
      this.position.copy(Object3D.DEFAULT_UP);
      this.updateMatrix();
      this.target = new Object3D();
      this.distance = distance;
      this.angle = angle;
      this.penumbra = penumbra;
      this.decay = decay;
      this.map = null;
      this.shadow = new SpotLightShadow();
    }
    /**
     * The light's power. Power is the luminous power of the light measured in lumens (lm).
     *  Changing the power will also change the light's intensity.
     *
     * @type {number}
     */
    get power() {
      return this.intensity * Math.PI;
    }
    set power(power) {
      this.intensity = power / Math.PI;
    }
    dispose() {
      this.shadow.dispose();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.distance = source.distance;
      this.angle = source.angle;
      this.penumbra = source.penumbra;
      this.decay = source.decay;
      this.target = source.target.clone();
      this.shadow = source.shadow.clone();
      return this;
    }
  }
  const _projScreenMatrix = /* @__PURE__ */ new Matrix4();
  const _lightPositionWorld = /* @__PURE__ */ new Vector3();
  const _lookTarget = /* @__PURE__ */ new Vector3();
  class PointLightShadow extends LightShadow {
    /**
     * Constructs a new point light shadow.
     */
    constructor() {
      super(new PerspectiveCamera(90, 1, 0.5, 500));
      this.isPointLightShadow = true;
      this._frameExtents = new Vector2(4, 2);
      this._viewportCount = 6;
      this._viewports = [
        // These viewports map a cube-map onto a 2D texture with the
        // following orientation:
        //
        //  xzXZ
        //   y Y
        //
        // X - Positive x direction
        // x - Negative x direction
        // Y - Positive y direction
        // y - Negative y direction
        // Z - Positive z direction
        // z - Negative z direction
        // positive X
        new Vector4(2, 1, 1, 1),
        // negative X
        new Vector4(0, 1, 1, 1),
        // positive Z
        new Vector4(3, 1, 1, 1),
        // negative Z
        new Vector4(1, 1, 1, 1),
        // positive Y
        new Vector4(3, 0, 1, 1),
        // negative Y
        new Vector4(1, 0, 1, 1)
      ];
      this._cubeDirections = [
        new Vector3(1, 0, 0),
        new Vector3(-1, 0, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1),
        new Vector3(0, 1, 0),
        new Vector3(0, -1, 0)
      ];
      this._cubeUps = [
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1)
      ];
    }
    /**
     * Update the matrices for the camera and shadow, used internally by the renderer.
     *
     * @param {Light} light - The light for which the shadow is being rendered.
     * @param {number} [viewportIndex=0] - The viewport index.
     */
    updateMatrices(light, viewportIndex = 0) {
      const camera = this.camera;
      const shadowMatrix = this.matrix;
      const far = light.distance || camera.far;
      if (far !== camera.far) {
        camera.far = far;
        camera.updateProjectionMatrix();
      }
      _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
      camera.position.copy(_lightPositionWorld);
      _lookTarget.copy(camera.position);
      _lookTarget.add(this._cubeDirections[viewportIndex]);
      camera.up.copy(this._cubeUps[viewportIndex]);
      camera.lookAt(_lookTarget);
      camera.updateMatrixWorld();
      shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
      _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
      this._frustum.setFromProjectionMatrix(_projScreenMatrix);
    }
  }
  class PointLight extends Light {
    /**
     * Constructs a new point light.
     *
     * @param {(number|Color|string)} [color=0xffffff] - The light's color.
     * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
     * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
     * @param {number} [decay=2] - The amount the light dims along the distance of the light.
     */
    constructor(color, intensity, distance = 0, decay = 2) {
      super(color, intensity);
      this.isPointLight = true;
      this.type = "PointLight";
      this.distance = distance;
      this.decay = decay;
      this.shadow = new PointLightShadow();
    }
    /**
     * The light's power. Power is the luminous power of the light measured in lumens (lm).
     * Changing the power will also change the light's intensity.
     *
     * @type {number}
     */
    get power() {
      return this.intensity * 4 * Math.PI;
    }
    set power(power) {
      this.intensity = power / (4 * Math.PI);
    }
    dispose() {
      this.shadow.dispose();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.distance = source.distance;
      this.decay = source.decay;
      this.shadow = source.shadow.clone();
      return this;
    }
  }
  class OrthographicCamera extends Camera {
    /**
     * Constructs a new orthographic camera.
     *
     * @param {number} [left=-1] - The left plane of the camera's frustum.
     * @param {number} [right=1] - The right plane of the camera's frustum.
     * @param {number} [top=1] - The top plane of the camera's frustum.
     * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
     * @param {number} [near=0.1] - The camera's near plane.
     * @param {number} [far=2000] - The camera's far plane.
     */
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
      super();
      this.isOrthographicCamera = true;
      this.type = "OrthographicCamera";
      this.zoom = 1;
      this.view = null;
      this.left = left;
      this.right = right;
      this.top = top;
      this.bottom = bottom;
      this.near = near;
      this.far = far;
      this.updateProjectionMatrix();
    }
    copy(source, recursive) {
      super.copy(source, recursive);
      this.left = source.left;
      this.right = source.right;
      this.top = source.top;
      this.bottom = source.bottom;
      this.near = source.near;
      this.far = source.far;
      this.zoom = source.zoom;
      this.view = source.view === null ? null : Object.assign({}, source.view);
      return this;
    }
    /**
     * Sets an offset in a larger frustum. This is useful for multi-window or
     * multi-monitor/multi-machine setups.
     *
     * @param {number} fullWidth - The full width of multiview setup.
     * @param {number} fullHeight - The full height of multiview setup.
     * @param {number} x - The horizontal offset of the subcamera.
     * @param {number} y - The vertical offset of the subcamera.
     * @param {number} width - The width of subcamera.
     * @param {number} height - The height of subcamera.
     * @see {@link PerspectiveCamera#setViewOffset}
     */
    setViewOffset(fullWidth, fullHeight, x2, y2, width, height) {
      if (this.view === null) {
        this.view = {
          enabled: true,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        };
      }
      this.view.enabled = true;
      this.view.fullWidth = fullWidth;
      this.view.fullHeight = fullHeight;
      this.view.offsetX = x2;
      this.view.offsetY = y2;
      this.view.width = width;
      this.view.height = height;
      this.updateProjectionMatrix();
    }
    /**
     * Removes the view offset from the projection matrix.
     */
    clearViewOffset() {
      if (this.view !== null) {
        this.view.enabled = false;
      }
      this.updateProjectionMatrix();
    }
    /**
     * Updates the camera's projection matrix. Must be called after any change of
     * camera properties.
     */
    updateProjectionMatrix() {
      const dx = (this.right - this.left) / (2 * this.zoom);
      const dy = (this.top - this.bottom) / (2 * this.zoom);
      const cx = (this.right + this.left) / 2;
      const cy = (this.top + this.bottom) / 2;
      let left = cx - dx;
      let right = cx + dx;
      let top = cy + dy;
      let bottom = cy - dy;
      if (this.view !== null && this.view.enabled) {
        const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
        const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
        left += scaleW * this.view.offsetX;
        right = left + scaleW * this.view.width;
        top -= scaleH * this.view.offsetY;
        bottom = top - scaleH * this.view.height;
      }
      this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
      const data = super.toJSON(meta);
      data.object.zoom = this.zoom;
      data.object.left = this.left;
      data.object.right = this.right;
      data.object.top = this.top;
      data.object.bottom = this.bottom;
      data.object.near = this.near;
      data.object.far = this.far;
      if (this.view !== null) data.object.view = Object.assign({}, this.view);
      return data;
    }
  }
  class DirectionalLightShadow extends LightShadow {
    /**
     * Constructs a new directional light shadow.
     */
    constructor() {
      super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
      this.isDirectionalLightShadow = true;
    }
  }
  class DirectionalLight extends Light {
    /**
     * Constructs a new directional light.
     *
     * @param {(number|Color|string)} [color=0xffffff] - The light's color.
     * @param {number} [intensity=1] - The light's strength/intensity.
     */
    constructor(color, intensity) {
      super(color, intensity);
      this.isDirectionalLight = true;
      this.type = "DirectionalLight";
      this.position.copy(Object3D.DEFAULT_UP);
      this.updateMatrix();
      this.target = new Object3D();
      this.shadow = new DirectionalLightShadow();
    }
    dispose() {
      this.shadow.dispose();
    }
    copy(source) {
      super.copy(source);
      this.target = source.target.clone();
      this.shadow = source.shadow.clone();
      return this;
    }
  }
  class LoaderUtils {
    /**
     * Extracts the base URL from the given URL.
     *
     * @param {string} url -The URL to extract the base URL from.
     * @return {string} The extracted base URL.
     */
    static extractUrlBase(url) {
      const index = url.lastIndexOf("/");
      if (index === -1) return "./";
      return url.slice(0, index + 1);
    }
    /**
     * Resolves relative URLs against the given path. Absolute paths, data urls,
     * and blob URLs will be returned as is. Invalid URLs will return an empty
     * string.
     *
     * @param {string} url -The URL to resolve.
     * @param {string} path - The base path for relative URLs to be resolved against.
     * @return {string} The resolved URL.
     */
    static resolveURL(url, path) {
      if (typeof url !== "string" || url === "") return "";
      if (/^https?:\/\//i.test(path) && /^\//.test(url)) {
        path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
      }
      if (/^(https?:)?\/\//i.test(url)) return url;
      if (/^data:.*,.*$/i.test(url)) return url;
      if (/^blob:.*$/i.test(url)) return url;
      return path + url;
    }
  }
  const _errorMap = /* @__PURE__ */ new WeakMap();
  class ImageBitmapLoader extends Loader {
    /**
     * Constructs a new image bitmap loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      super(manager);
      this.isImageBitmapLoader = true;
      if (typeof createImageBitmap === "undefined") {
        console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
      }
      if (typeof fetch === "undefined") {
        console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
      }
      this.options = { premultiplyAlpha: "none" };
    }
    /**
     * Sets the given loader options. The structure of the object must match the `options` parameter of
     * [createImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap}.
     *
     * @param {Object} options - The loader options to set.
     * @return {ImageBitmapLoader} A reference to this image bitmap loader.
     */
    setOptions(options) {
      this.options = options;
      return this;
    }
    /**
     * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
     *
     * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
     * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} onProgress - Unsupported in this loader.
     * @param {onErrorCallback} onError - Executed when errors occur.
     * @return {ImageBitmap|undefined} The image bitmap.
     */
    load(url, onLoad, onProgress, onError) {
      if (url === void 0) url = "";
      if (this.path !== void 0) url = this.path + url;
      url = this.manager.resolveURL(url);
      const scope = this;
      const cached = Cache.get(`image-bitmap:${url}`);
      if (cached !== void 0) {
        scope.manager.itemStart(url);
        if (cached.then) {
          cached.then((imageBitmap) => {
            if (_errorMap.has(cached) === true) {
              if (onError) onError(_errorMap.get(cached));
              scope.manager.itemError(url);
              scope.manager.itemEnd(url);
            } else {
              if (onLoad) onLoad(imageBitmap);
              scope.manager.itemEnd(url);
              return imageBitmap;
            }
          });
          return;
        }
        setTimeout(function() {
          if (onLoad) onLoad(cached);
          scope.manager.itemEnd(url);
        }, 0);
        return cached;
      }
      const fetchOptions = {};
      fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
      fetchOptions.headers = this.requestHeader;
      const promise = fetch(url, fetchOptions).then(function(res) {
        return res.blob();
      }).then(function(blob) {
        return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
      }).then(function(imageBitmap) {
        Cache.add(`image-bitmap:${url}`, imageBitmap);
        if (onLoad) onLoad(imageBitmap);
        scope.manager.itemEnd(url);
        return imageBitmap;
      }).catch(function(e2) {
        if (onError) onError(e2);
        _errorMap.set(promise, e2);
        Cache.remove(`image-bitmap:${url}`);
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      });
      Cache.add(`image-bitmap:${url}`, promise);
      scope.manager.itemStart(url);
    }
  }
  class ArrayCamera extends PerspectiveCamera {
    /**
     * Constructs a new array camera.
     *
     * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
     */
    constructor(array = []) {
      super();
      this.isArrayCamera = true;
      this.isMultiViewCamera = false;
      this.cameras = array;
    }
  }
  const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
  const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
  const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
  const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
  const _directoryRe = /* @__PURE__ */ /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
  const _nodeRe = /* @__PURE__ */ /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
  const _objectRe = /* @__PURE__ */ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
  const _propertyRe = /* @__PURE__ */ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
  const _trackRe = new RegExp(
    "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
  );
  const _supportedObjectNames = ["material", "materials", "bones", "map"];
  class Composite {
    constructor(targetGroup, path, optionalParsedPath) {
      const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
      this._targetGroup = targetGroup;
      this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
      this.bind();
      const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
      if (binding !== void 0) binding.getValue(array, offset);
    }
    setValue(array, offset) {
      const bindings = this._bindings;
      for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
        bindings[i2].setValue(array, offset);
      }
    }
    bind() {
      const bindings = this._bindings;
      for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
        bindings[i2].bind();
      }
    }
    unbind() {
      const bindings = this._bindings;
      for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
        bindings[i2].unbind();
      }
    }
  }
  class PropertyBinding {
    /**
     * Constructs a new property binding.
     *
     * @param {Object} rootNode - The root node.
     * @param {string} path - The path.
     * @param {?Object} [parsedPath] - The parsed path.
     */
    constructor(rootNode, path, parsedPath) {
      this.path = path;
      this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
      this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
      this.rootNode = rootNode;
      this.getValue = this._getValue_unbound;
      this.setValue = this._setValue_unbound;
    }
    /**
     * Factory method for creating a property binding from the given parameters.
     *
     * @static
     * @param {Object} root - The root node.
     * @param {string} path - The path.
     * @param {?Object} [parsedPath] - The parsed path.
     * @return {PropertyBinding|Composite} The created property binding or composite.
     */
    static create(root, path, parsedPath) {
      if (!(root && root.isAnimationObjectGroup)) {
        return new PropertyBinding(root, path, parsedPath);
      } else {
        return new PropertyBinding.Composite(root, path, parsedPath);
      }
    }
    /**
     * Replaces spaces with underscores and removes unsupported characters from
     * node names, to ensure compatibility with parseTrackName().
     *
     * @param {string} name - Node name to be sanitized.
     * @return {string} The sanitized node name.
     */
    static sanitizeNodeName(name) {
      return name.replace(/\s/g, "_").replace(_reservedRe, "");
    }
    /**
     * Parses the given track name (an object path to an animated property) and
     * returns an object with information about the path. Matches strings in the following forms:
     *
     * - nodeName.property
     * - nodeName.property[accessor]
     * - nodeName.material.property[accessor]
     * - uuid.property[accessor]
     * - uuid.objectName[objectIndex].propertyName[propertyIndex]
     * - parentName/nodeName.property
     * - parentName/parentName/nodeName.property[index]
     * - .bone[Armature.DEF_cog].position
     * - scene:helium_balloon_model:helium_balloon_model.position
     *
     * @static
     * @param {string} trackName - The track name to parse.
     * @return {Object} The parsed track name as an object.
     */
    static parseTrackName(trackName) {
      const matches = _trackRe.exec(trackName);
      if (matches === null) {
        throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
      }
      const results = {
        // directoryName: matches[ 1 ], // (tschw) currently unused
        nodeName: matches[2],
        objectName: matches[3],
        objectIndex: matches[4],
        propertyName: matches[5],
        // required
        propertyIndex: matches[6]
      };
      const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
      if (lastDot !== void 0 && lastDot !== -1) {
        const objectName = results.nodeName.substring(lastDot + 1);
        if (_supportedObjectNames.indexOf(objectName) !== -1) {
          results.nodeName = results.nodeName.substring(0, lastDot);
          results.objectName = objectName;
        }
      }
      if (results.propertyName === null || results.propertyName.length === 0) {
        throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
      }
      return results;
    }
    /**
     * Searches for a node in the hierarchy of the given root object by the given
     * node name.
     *
     * @static
     * @param {Object} root - The root object.
     * @param {string|number} nodeName - The name of the node.
     * @return {?Object} The found node. Returns `null` if no object was found.
     */
    static findNode(root, nodeName) {
      if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {
        return root;
      }
      if (root.skeleton) {
        const bone = root.skeleton.getBoneByName(nodeName);
        if (bone !== void 0) {
          return bone;
        }
      }
      if (root.children) {
        const searchNodeSubtree = function(children) {
          for (let i2 = 0; i2 < children.length; i2++) {
            const childNode = children[i2];
            if (childNode.name === nodeName || childNode.uuid === nodeName) {
              return childNode;
            }
            const result = searchNodeSubtree(childNode.children);
            if (result) return result;
          }
          return null;
        };
        const subTreeNode = searchNodeSubtree(root.children);
        if (subTreeNode) {
          return subTreeNode;
        }
      }
      return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {
    }
    _setValue_unavailable() {
    }
    // Getters
    _getValue_direct(buffer, offset) {
      buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
      const source = this.resolvedProperty;
      for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
        buffer[offset++] = source[i2];
      }
    }
    _getValue_arrayElement(buffer, offset) {
      buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
      this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
      this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
      this.targetObject[this.propertyName] = buffer[offset];
      this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
      this.targetObject[this.propertyName] = buffer[offset];
      this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
      const dest = this.resolvedProperty;
      for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
        dest[i2] = buffer[offset++];
      }
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
      const dest = this.resolvedProperty;
      for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
        dest[i2] = buffer[offset++];
      }
      this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
      const dest = this.resolvedProperty;
      for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
        dest[i2] = buffer[offset++];
      }
      this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
      this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
      this.resolvedProperty[this.propertyIndex] = buffer[offset];
      this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
      this.resolvedProperty[this.propertyIndex] = buffer[offset];
      this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
      this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
      this.resolvedProperty.fromArray(buffer, offset);
      this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
      this.resolvedProperty.fromArray(buffer, offset);
      this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
      this.bind();
      this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
      this.bind();
      this.setValue(sourceArray, offset);
    }
    /**
     * Creates a getter / setter pair for the property tracked by this binding.
     */
    bind() {
      let targetObject = this.node;
      const parsedPath = this.parsedPath;
      const objectName = parsedPath.objectName;
      const propertyName = parsedPath.propertyName;
      let propertyIndex = parsedPath.propertyIndex;
      if (!targetObject) {
        targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
        this.node = targetObject;
      }
      this.getValue = this._getValue_unavailable;
      this.setValue = this._setValue_unavailable;
      if (!targetObject) {
        console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
        return;
      }
      if (objectName) {
        let objectIndex = parsedPath.objectIndex;
        switch (objectName) {
          case "materials":
            if (!targetObject.material) {
              console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
              return;
            }
            if (!targetObject.material.materials) {
              console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
              return;
            }
            targetObject = targetObject.material.materials;
            break;
          case "bones":
            if (!targetObject.skeleton) {
              console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
              return;
            }
            targetObject = targetObject.skeleton.bones;
            for (let i2 = 0; i2 < targetObject.length; i2++) {
              if (targetObject[i2].name === objectIndex) {
                objectIndex = i2;
                break;
              }
            }
            break;
          case "map":
            if ("map" in targetObject) {
              targetObject = targetObject.map;
              break;
            }
            if (!targetObject.material) {
              console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
              return;
            }
            if (!targetObject.material.map) {
              console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
              return;
            }
            targetObject = targetObject.material.map;
            break;
          default:
            if (targetObject[objectName] === void 0) {
              console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
              return;
            }
            targetObject = targetObject[objectName];
        }
        if (objectIndex !== void 0) {
          if (targetObject[objectIndex] === void 0) {
            console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
            return;
          }
          targetObject = targetObject[objectIndex];
        }
      }
      const nodeProperty = targetObject[propertyName];
      if (nodeProperty === void 0) {
        const nodeName = parsedPath.nodeName;
        console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
        return;
      }
      let versioning = this.Versioning.None;
      this.targetObject = targetObject;
      if (targetObject.isMaterial === true) {
        versioning = this.Versioning.NeedsUpdate;
      } else if (targetObject.isObject3D === true) {
        versioning = this.Versioning.MatrixWorldNeedsUpdate;
      }
      let bindingType = this.BindingType.Direct;
      if (propertyIndex !== void 0) {
        if (propertyName === "morphTargetInfluences") {
          if (!targetObject.geometry) {
            console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
            return;
          }
          if (!targetObject.geometry.morphAttributes) {
            console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
            return;
          }
          if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
            propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
          }
        }
        bindingType = this.BindingType.ArrayElement;
        this.resolvedProperty = nodeProperty;
        this.propertyIndex = propertyIndex;
      } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
        bindingType = this.BindingType.HasFromToArray;
        this.resolvedProperty = nodeProperty;
      } else if (Array.isArray(nodeProperty)) {
        bindingType = this.BindingType.EntireArray;
        this.resolvedProperty = nodeProperty;
      } else {
        this.propertyName = propertyName;
      }
      this.getValue = this.GetterByBindingType[bindingType];
      this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
     * Unbinds the property.
     */
    unbind() {
      this.node = null;
      this.getValue = this._getValue_unbound;
      this.setValue = this._setValue_unbound;
    }
  }
  PropertyBinding.Composite = Composite;
  PropertyBinding.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
  };
  PropertyBinding.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
  };
  PropertyBinding.prototype.GetterByBindingType = [
    PropertyBinding.prototype._getValue_direct,
    PropertyBinding.prototype._getValue_array,
    PropertyBinding.prototype._getValue_arrayElement,
    PropertyBinding.prototype._getValue_toArray
  ];
  PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
    [
      // Direct
      PropertyBinding.prototype._setValue_direct,
      PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
      PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
      // EntireArray
      PropertyBinding.prototype._setValue_array,
      PropertyBinding.prototype._setValue_array_setNeedsUpdate,
      PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
      // ArrayElement
      PropertyBinding.prototype._setValue_arrayElement,
      PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
      PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
      // HasToFromArray
      PropertyBinding.prototype._setValue_fromArray,
      PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
      PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
  ];
  const _matrix = /* @__PURE__ */ new Matrix4();
  class Raycaster {
    /**
     * Constructs a new raycaster.
     *
     * @param {Vector3} origin - The origin vector where the ray casts from.
     * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
     * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
     * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
     */
    constructor(origin, direction, near = 0, far = Infinity) {
      this.ray = new Ray(origin, direction);
      this.near = near;
      this.far = far;
      this.camera = null;
      this.layers = new Layers();
      this.params = {
        Mesh: {},
        Line: { threshold: 1 },
        LOD: {},
        Points: { threshold: 1 },
        Sprite: {}
      };
    }
    /**
     * Updates the ray with a new origin and direction by copying the values from the arguments.
     *
     * @param {Vector3} origin - The origin vector where the ray casts from.
     * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
     */
    set(origin, direction) {
      this.ray.set(origin, direction);
    }
    /**
     * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
     *
     * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
     * X and Y components should be between `-1` and `1`.
     * @param {Camera} camera - The camera from which the ray should originate.
     */
    setFromCamera(coords, camera) {
      if (camera.isPerspectiveCamera) {
        this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
        this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
        this.camera = camera;
      } else if (camera.isOrthographicCamera) {
        this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
        this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
        this.camera = camera;
      } else {
        console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
      }
    }
    /**
     * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
     *
     * @param {WebXRController} controller - The controller to copy the position and direction from.
     * @return {Raycaster} A reference to this raycaster.
     */
    setFromXRController(controller) {
      _matrix.identity().extractRotation(controller.matrixWorld);
      this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
      this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix);
      return this;
    }
    /**
     * The intersection point of a raycaster intersection test.
     * @typedef {Object} Raycaster~Intersection
     * @property {number} distance - The distance from the ray's origin to the intersection point.
     * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
     * intersection to the nearest point on the ray. For other objects it will be `undefined`.
     * @property {Vector3} point - The intersection point, in world coordinates.
     * @property {Object} face - The face that has been intersected.
     * @property {number} faceIndex - The face index.
     * @property {Object3D} object - The 3D object that has been intersected.
     * @property {Vector2} uv - U,V coordinates at point of intersection.
     * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
     * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
     * @property {number} instanceId - The index number of the instance where the ray
     * intersects the {@link InstancedMesh}.
     */
    /**
     * Checks all intersection between the ray and the object with or without the
     * descendants. Intersections are returned sorted by distance, closest first.
     *
     * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
     * evaluating whether the ray intersects the object or not. This allows meshes to respond
     * differently to ray casting than lines or points.
     *
     * Note that for meshes, faces must be pointed towards the origin of the ray in order
     * to be detected; intersections of the ray passing through the back of a face will not
     * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
     * to `THREE.DoubleSide`.
     *
     * @param {Object3D} object - The 3D object to check for intersection with the ray.
     * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
     * Otherwise it only checks intersection with the object.
     * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
     * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
     */
    intersectObject(object, recursive = true, intersects2 = []) {
      intersect(object, this, intersects2, recursive);
      intersects2.sort(ascSort);
      return intersects2;
    }
    /**
     * Checks all intersection between the ray and the objects with or without
     * the descendants. Intersections are returned sorted by distance, closest first.
     *
     * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
     * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
     * Otherwise it only checks intersection with the object.
     * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
     * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
     */
    intersectObjects(objects, recursive = true, intersects2 = []) {
      for (let i2 = 0, l2 = objects.length; i2 < l2; i2++) {
        intersect(objects[i2], this, intersects2, recursive);
      }
      intersects2.sort(ascSort);
      return intersects2;
    }
  }
  function ascSort(a2, b2) {
    return a2.distance - b2.distance;
  }
  function intersect(object, raycaster, intersects2, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
      const result = object.raycast(raycaster, intersects2);
      if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
      const children = object.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        intersect(children[i2], raycaster, intersects2, true);
      }
    }
  }
  class Spherical {
    /**
     * Constructs a new spherical.
     *
     * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
     * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
     * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
     */
    constructor(radius = 1, phi = 0, theta = 0) {
      this.radius = radius;
      this.phi = phi;
      this.theta = theta;
    }
    /**
     * Sets the spherical components by copying the given values.
     *
     * @param {number} radius - The radius.
     * @param {number} phi - The polar angle.
     * @param {number} theta - The azimuthal angle.
     * @return {Spherical} A reference to this spherical.
     */
    set(radius, phi, theta) {
      this.radius = radius;
      this.phi = phi;
      this.theta = theta;
      return this;
    }
    /**
     * Copies the values of the given spherical to this instance.
     *
     * @param {Spherical} other - The spherical to copy.
     * @return {Spherical} A reference to this spherical.
     */
    copy(other) {
      this.radius = other.radius;
      this.phi = other.phi;
      this.theta = other.theta;
      return this;
    }
    /**
     * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
     * `0.000001`.
     *
     * @return {Spherical} A reference to this spherical.
     */
    makeSafe() {
      const EPS = 1e-6;
      this.phi = clamp(this.phi, EPS, Math.PI - EPS);
      return this;
    }
    /**
     * Sets the spherical components from the given vector which is assumed to hold
     * Cartesian coordinates.
     *
     * @param {Vector3} v - The vector to set.
     * @return {Spherical} A reference to this spherical.
     */
    setFromVector3(v2) {
      return this.setFromCartesianCoords(v2.x, v2.y, v2.z);
    }
    /**
     * Sets the spherical components from the given Cartesian coordinates.
     *
     * @param {number} x - The x value.
     * @param {number} y - The x value.
     * @param {number} z - The x value.
     * @return {Spherical} A reference to this spherical.
     */
    setFromCartesianCoords(x2, y2, z2) {
      this.radius = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
      if (this.radius === 0) {
        this.theta = 0;
        this.phi = 0;
      } else {
        this.theta = Math.atan2(x2, z2);
        this.phi = Math.acos(clamp(y2 / this.radius, -1, 1));
      }
      return this;
    }
    /**
     * Returns a new spherical with copied values from this instance.
     *
     * @return {Spherical} A clone of this instance.
     */
    clone() {
      return new this.constructor().copy(this);
    }
  }
  class Controls extends EventDispatcher {
    /**
     * Constructs a new controls instance.
     *
     * @param {Object3D} object - The object that is managed by the controls.
     * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
     */
    constructor(object, domElement = null) {
      super();
      this.object = object;
      this.domElement = domElement;
      this.enabled = true;
      this.state = -1;
      this.keys = {};
      this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null };
      this.touches = { ONE: null, TWO: null };
    }
    /**
     * Connects the controls to the DOM. This method has so called "side effects" since
     * it adds the module's event listeners to the DOM.
     *
     * @param {HTMLDOMElement} element - The DOM element to connect to.
     */
    connect(element) {
      if (element === void 0) {
        console.warn("THREE.Controls: connect() now requires an element.");
        return;
      }
      if (this.domElement !== null) this.disconnect();
      this.domElement = element;
    }
    /**
     * Disconnects the controls from the DOM.
     */
    disconnect() {
    }
    /**
     * Call this method if you no longer want use to the controls. It frees all internal
     * resources and removes all event listeners.
     */
    dispose() {
    }
    /**
     * Controls should implement this method if they have to update their internal state
     * per simulation step.
     *
     * @param {number} [delta] - The time delta in seconds.
     */
    update() {
    }
  }
  function getByteLength(width, height, format, type) {
    const typeByteLength = getTextureTypeByteLength(type);
    switch (format) {
      // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
      case AlphaFormat:
        return width * height;
      case RedFormat:
        return width * height / typeByteLength.components * typeByteLength.byteLength;
      case RedIntegerFormat:
        return width * height / typeByteLength.components * typeByteLength.byteLength;
      case RGFormat:
        return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
      case RGIntegerFormat:
        return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
      case RGBFormat:
        return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
      case RGBAFormat:
        return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
      case RGBAIntegerFormat:
        return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
      // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
      case RGB_S3TC_DXT1_Format:
      case RGBA_S3TC_DXT1_Format:
        return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
      case RGBA_S3TC_DXT3_Format:
      case RGBA_S3TC_DXT5_Format:
        return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
      // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
      case RGB_PVRTC_2BPPV1_Format:
      case RGBA_PVRTC_2BPPV1_Format:
        return Math.max(width, 16) * Math.max(height, 8) / 4;
      case RGB_PVRTC_4BPPV1_Format:
      case RGBA_PVRTC_4BPPV1_Format:
        return Math.max(width, 8) * Math.max(height, 8) / 2;
      // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
      case RGB_ETC1_Format:
      case RGB_ETC2_Format:
        return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
      case RGBA_ETC2_EAC_Format:
        return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
      // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
      case RGBA_ASTC_4x4_Format:
        return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
      case RGBA_ASTC_5x4_Format:
        return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
      case RGBA_ASTC_5x5_Format:
        return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
      case RGBA_ASTC_6x5_Format:
        return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
      case RGBA_ASTC_6x6_Format:
        return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
      case RGBA_ASTC_8x5_Format:
        return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
      case RGBA_ASTC_8x6_Format:
        return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
      case RGBA_ASTC_8x8_Format:
        return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
      case RGBA_ASTC_10x5_Format:
        return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
      case RGBA_ASTC_10x6_Format:
        return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
      case RGBA_ASTC_10x8_Format:
        return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
      case RGBA_ASTC_10x10_Format:
        return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
      case RGBA_ASTC_12x10_Format:
        return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
      case RGBA_ASTC_12x12_Format:
        return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
      // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
      case RGBA_BPTC_Format:
      case RGB_BPTC_SIGNED_Format:
      case RGB_BPTC_UNSIGNED_Format:
        return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
      // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
      case RED_RGTC1_Format:
      case SIGNED_RED_RGTC1_Format:
        return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
      case RED_GREEN_RGTC2_Format:
      case SIGNED_RED_GREEN_RGTC2_Format:
        return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(
      `Unable to determine texture byte length for ${format} format.`
    );
  }
  function getTextureTypeByteLength(type) {
    switch (type) {
      case UnsignedByteType:
      case ByteType:
        return { byteLength: 1, components: 1 };
      case UnsignedShortType:
      case ShortType:
      case HalfFloatType:
        return { byteLength: 2, components: 1 };
      case UnsignedShort4444Type:
      case UnsignedShort5551Type:
        return { byteLength: 2, components: 4 };
      case UnsignedIntType:
      case IntType:
      case FloatType:
        return { byteLength: 4, components: 1 };
      case UnsignedInt5999Type:
        return { byteLength: 4, components: 3 };
    }
    throw new Error(`Unknown texture type ${type}.`);
  }
  if (typeof __THREE_DEVTOOLS__ !== "undefined") {
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
      revision: REVISION
    } }));
  }
  if (typeof window !== "undefined") {
    if (window.__THREE__) {
      console.warn("WARNING: Multiple instances of Three.js being imported.");
    } else {
      window.__THREE__ = REVISION;
    }
  }
  function WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
      animationLoop(time, frame);
      requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
      start: function() {
        if (isAnimating === true) return;
        if (animationLoop === null) return;
        requestId = context.requestAnimationFrame(onAnimationFrame);
        isAnimating = true;
      },
      stop: function() {
        context.cancelAnimationFrame(requestId);
        isAnimating = false;
      },
      setAnimationLoop: function(callback) {
        animationLoop = callback;
      },
      setContext: function(value) {
        context = value;
      }
    };
  }
  function WebGLAttributes(gl) {
    const buffers = /* @__PURE__ */ new WeakMap();
    function createBuffer(attribute, bufferType) {
      const array = attribute.array;
      const usage = attribute.usage;
      const size = array.byteLength;
      const buffer = gl.createBuffer();
      gl.bindBuffer(bufferType, buffer);
      gl.bufferData(bufferType, array, usage);
      attribute.onUploadCallback();
      let type;
      if (array instanceof Float32Array) {
        type = gl.FLOAT;
      } else if (typeof Float16Array !== "undefined" && array instanceof Float16Array) {
        type = gl.HALF_FLOAT;
      } else if (array instanceof Uint16Array) {
        if (attribute.isFloat16BufferAttribute) {
          type = gl.HALF_FLOAT;
        } else {
          type = gl.UNSIGNED_SHORT;
        }
      } else if (array instanceof Int16Array) {
        type = gl.SHORT;
      } else if (array instanceof Uint32Array) {
        type = gl.UNSIGNED_INT;
      } else if (array instanceof Int32Array) {
        type = gl.INT;
      } else if (array instanceof Int8Array) {
        type = gl.BYTE;
      } else if (array instanceof Uint8Array) {
        type = gl.UNSIGNED_BYTE;
      } else if (array instanceof Uint8ClampedArray) {
        type = gl.UNSIGNED_BYTE;
      } else {
        throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
      }
      return {
        buffer,
        type,
        bytesPerElement: array.BYTES_PER_ELEMENT,
        version: attribute.version,
        size
      };
    }
    function updateBuffer(buffer, attribute, bufferType) {
      const array = attribute.array;
      const updateRanges = attribute.updateRanges;
      gl.bindBuffer(bufferType, buffer);
      if (updateRanges.length === 0) {
        gl.bufferSubData(bufferType, 0, array);
      } else {
        updateRanges.sort((a2, b2) => a2.start - b2.start);
        let mergeIndex = 0;
        for (let i2 = 1; i2 < updateRanges.length; i2++) {
          const previousRange = updateRanges[mergeIndex];
          const range = updateRanges[i2];
          if (range.start <= previousRange.start + previousRange.count + 1) {
            previousRange.count = Math.max(
              previousRange.count,
              range.start + range.count - previousRange.start
            );
          } else {
            ++mergeIndex;
            updateRanges[mergeIndex] = range;
          }
        }
        updateRanges.length = mergeIndex + 1;
        for (let i2 = 0, l2 = updateRanges.length; i2 < l2; i2++) {
          const range = updateRanges[i2];
          gl.bufferSubData(
            bufferType,
            range.start * array.BYTES_PER_ELEMENT,
            array,
            range.start,
            range.count
          );
        }
        attribute.clearUpdateRanges();
      }
      attribute.onUploadCallback();
    }
    function get(attribute) {
      if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
      return buffers.get(attribute);
    }
    function remove(attribute) {
      if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
      const data = buffers.get(attribute);
      if (data) {
        gl.deleteBuffer(data.buffer);
        buffers.delete(attribute);
      }
    }
    function update(attribute, bufferType) {
      if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
      if (attribute.isGLBufferAttribute) {
        const cached = buffers.get(attribute);
        if (!cached || cached.version < attribute.version) {
          buffers.set(attribute, {
            buffer: attribute.buffer,
            type: attribute.type,
            bytesPerElement: attribute.elementSize,
            version: attribute.version
          });
        }
        return;
      }
      const data = buffers.get(attribute);
      if (data === void 0) {
        buffers.set(attribute, createBuffer(attribute, bufferType));
      } else if (data.version < attribute.version) {
        if (data.size !== attribute.array.byteLength) {
          throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
        }
        updateBuffer(data.buffer, attribute, bufferType);
        data.version = attribute.version;
      }
    }
    return {
      get,
      remove,
      update
    };
  }
  var alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
  var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
  var alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
  var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
  var alphatest_fragment = "#ifdef USE_ALPHATEST\n	#ifdef ALPHA_TO_COVERAGE\n	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n	if ( diffuseColor.a == 0.0 ) discard;\n	#else\n	if ( diffuseColor.a < alphaTest ) discard;\n	#endif\n#endif";
  var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
  var aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
  var aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
  var batching_pars_vertex = "#ifdef USE_BATCHING\n	#if ! defined( GL_ANGLE_multi_draw )\n	#define gl_DrawID _gl_DrawID\n	uniform int _gl_DrawID;\n	#endif\n	uniform highp sampler2D batchingTexture;\n	uniform highp usampler2D batchingIdTexture;\n	mat4 getBatchingMatrix( const in float i ) {\n		int size = textureSize( batchingTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n	float getIndirectIndex( const in int i ) {\n		int size = textureSize( batchingIdTexture, 0 ).x;\n		int x = i % size;\n		int y = i / size;\n		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n	}\n#endif\n#ifdef USE_BATCHING_COLOR\n	uniform sampler2D batchingColorTexture;\n	vec3 getBatchingColor( const in float i ) {\n		int size = textureSize( batchingColorTexture, 0 ).x;\n		int j = int( i );\n		int x = j % size;\n		int y = j / size;\n		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n	}\n#endif";
  var batching_vertex = "#ifdef USE_BATCHING\n	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
  var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
  var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
  var bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
  var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
  var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
  var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#ifdef ALPHA_TO_COVERAGE\n		float distanceToPlane, distanceGradient;\n		float clipOpacity = 1.0;\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n			distanceGradient = fwidth( distanceToPlane ) / 2.0;\n			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			if ( clipOpacity == 0.0 ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			float unionClipOpacity = 1.0;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n				distanceGradient = fwidth( distanceToPlane ) / 2.0;\n				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n			}\n			#pragma unroll_loop_end\n			clipOpacity *= 1.0 - unionClipOpacity;\n		#endif\n		diffuseColor.a *= clipOpacity;\n		if ( diffuseColor.a == 0.0 ) discard;\n	#else\n		#pragma unroll_loop_start\n		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n		}\n		#pragma unroll_loop_end\n		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n			bool clipped = true;\n			#pragma unroll_loop_start\n			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n				plane = clippingPlanes[ i ];\n				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n			}\n			#pragma unroll_loop_end\n			if ( clipped ) discard;\n		#endif\n	#endif\n#endif";
  var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
  var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
  var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
  var color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
  var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
  var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	varying vec3 vColor;\n#endif";
  var color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n	vColor.xyz *= batchingColor.xyz;\n#endif";
  var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
  var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
  var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n	vec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n	mat3 bm = mat3( batchingMatrix );\n	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n	transformedNormal = bm * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = bm * transformedTangent;\n	#endif\n#endif\n#ifdef USE_INSTANCING\n	mat3 im = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n	transformedNormal = im * transformedNormal;\n	#ifdef USE_TANGENT\n		transformedTangent = im * transformedTangent;\n	#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
  var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
  var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
  var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n		emissiveColor = sRGBTransferEOTF( emissiveColor );\n	#endif\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
  var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
  var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
  var colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
  var envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
  var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	uniform mat3 envMapRotation;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
  var envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
  var envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
  var envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
  var fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
  var fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
  var fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
  var fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
  var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
  var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
  var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
  var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
  var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n	if ( cutoffDistance > 0.0 ) {\n		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n	}\n	return distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
  var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
  var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
  var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
  var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
  var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
  var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n	material.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	if( material.anisotropy == 0.0 ) {\n		anisotropyV = vec2( 1.0, 0.0 );\n	} else {\n		anisotropyV /= material.anisotropy;\n		material.anisotropy = saturate( material.anisotropy );\n	}\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
  var lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	float dispersion;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
  var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
  var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
  var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
  var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
  var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
  var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
  var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	vFragDepth = 1.0 + gl_Position.w;\n	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
  var map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
  var map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
  var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
  var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
  var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
  var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
  var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n	float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n	}\n#endif";
  var morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
  var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
  var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	#ifndef USE_INSTANCING_MORPH\n		uniform float morphTargetBaseInfluence;\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n	#endif\n	uniform sampler2DArray morphTargetsTexture;\n	uniform ivec2 morphTargetsTextureSize;\n	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n		int y = texelIndex / morphTargetsTextureSize.x;\n		int x = texelIndex - y * morphTargetsTextureSize.x;\n		ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n		return texelFetch( morphTargetsTexture, morphUV, 0 );\n	}\n#endif";
  var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n	}\n#endif";
  var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
  var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
  var normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
  var normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
  var normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
  var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
  var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
  var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
  var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
  var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
  var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
  var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n	if( v <= 0.0 )\n		return vec4( 0., 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec4( 1., 1., 1., 1. );\n	float vuf;\n	float af = modf( v * PackFactors.a, vuf );\n	float bf = modf( vuf * ShiftRight8, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n	if( v <= 0.0 )\n		return vec3( 0., 0., 0. );\n	if( v >= 1.0 )\n		return vec3( 1., 1., 1. );\n	float vuf;\n	float bf = modf( v * PackFactors.b, vuf );\n	float gf = modf( vuf * ShiftRight8, vuf );\n	return vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n	if( v <= 0.0 )\n		return vec2( 0., 0. );\n	if( v >= 1.0 )\n		return vec2( 1., 1. );\n	float vuf;\n	float gf = modf( v * 256., vuf );\n	return vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n	return dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
  var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
  var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n	mvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
  var dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
  var dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
  var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
  var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
  var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		float shadow = 1.0;\n		vec3 lightToPosition = shadowCoord.xyz;\n		\n		float lightToPositionLength = length( lightToPosition );\n		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;\n			vec3 bd3D = normalize( lightToPosition );\n			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n				shadow = (\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n				) * ( 1.0 / 9.0 );\n			#else\n				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n			#endif\n		}\n		return mix( 1.0, shadow, shadowIntensity );\n	}\n#endif";
  var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowIntensity;\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
  var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
  var shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
  var skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
  var skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	mat4 getBoneMatrix( const in float i ) {\n		int size = textureSize( boneTexture, 0 ).x;\n		int j = int( i ) * 4;\n		int x = j % size;\n		int y = j / size;\n		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n		return mat4( v1, v2, v3, v4 );\n	}\n#endif";
  var skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
  var skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
  var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
  var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
  var tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
  var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n	vec3( 1.6605, - 0.1246, - 0.0182 ),\n	vec3( - 0.5876, 1.1329, - 0.1006 ),\n	vec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n	vec3( 0.6274, 0.0691, 0.0164 ),\n	vec3( 0.3293, 0.9195, 0.0880 ),\n	vec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n	vec3 x2 = x * x;\n	vec3 x4 = x2 * x2;\n	return + 15.5 * x4 * x2\n		- 40.14 * x4 * x\n		+ 31.96 * x4\n		- 6.868 * x2 * x\n		+ 0.4298 * x2\n		+ 0.1191 * x\n		- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n	const mat3 AgXInsetMatrix = mat3(\n		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n	);\n	const mat3 AgXOutsetMatrix = mat3(\n		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n	);\n	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;\n	color *= toneMappingExposure;\n	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n	color = AgXInsetMatrix * color;\n	color = max( color, 1e-10 );	color = log2( color );\n	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n	color = clamp( color, 0.0, 1.0 );\n	color = agxDefaultContrastApprox( color );\n	color = AgXOutsetMatrix * color;\n	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n	color = clamp( color, 0.0, 1.0 );\n	return color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n	const float StartCompression = 0.8 - 0.04;\n	const float Desaturation = 0.15;\n	color *= toneMappingExposure;\n	float x = min( color.r, min( color.g, color.b ) );\n	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n	color -= offset;\n	float peak = max( color.r, max( color.g, color.b ) );\n	if ( peak < StartCompression ) return color;\n	float d = 1. - StartCompression;\n	float newPeak = 1. - d * d / ( peak + d - StartCompression );\n	color *= newPeak / peak;\n	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n	return mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
  var transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
  var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec4 transmittedLight;\n		vec3 transmittance;\n		#ifdef USE_DISPERSION\n			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n			for ( int i = 0; i < 3; i ++ ) {\n				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n				vec3 refractedRayExit = position + transmissionRay;\n				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n				vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n				refractionCoords += 1.0;\n				refractionCoords /= 2.0;\n				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n				transmittedLight[ i ] = transmissionSample[ i ];\n				transmittedLight.a += transmissionSample.a;\n				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n			}\n			transmittedLight.a /= 3.0;\n		#else\n			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n			vec3 refractedRayExit = position + transmissionRay;\n			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n			vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n			refractionCoords += 1.0;\n			refractionCoords /= 2.0;\n			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		#endif\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
  var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
  var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
  var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
  var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_BATCHING\n		worldPosition = batchingMatrix * worldPosition;\n	#endif\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
  const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
  const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
  const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
  const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
  const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
  const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
  const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
  const fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#elif DEPTH_PACKING == 3202\n		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n	#elif DEPTH_PACKING == 3203\n		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n	#endif\n}";
  const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <skinbase_vertex>\n	#include <morphinstance_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
  const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <clipping_planes_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
  const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
  const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
  const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
  const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
  const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
  const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
  const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
  const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
  const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
  const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
  const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
  const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n	uniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
  const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
  const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphinstance_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
  const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
  const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <batching_vertex>\n	#include <beginnormal_vertex>\n	#include <morphinstance_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
  const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
  const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix[ 3 ];\n	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
  const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
  const ShaderChunk = {
    alphahash_fragment,
    alphahash_pars_fragment,
    alphamap_fragment,
    alphamap_pars_fragment,
    alphatest_fragment,
    alphatest_pars_fragment,
    aomap_fragment,
    aomap_pars_fragment,
    batching_pars_vertex,
    batching_vertex,
    begin_vertex,
    beginnormal_vertex,
    bsdfs,
    iridescence_fragment,
    bumpmap_pars_fragment,
    clipping_planes_fragment,
    clipping_planes_pars_fragment,
    clipping_planes_pars_vertex,
    clipping_planes_vertex,
    color_fragment,
    color_pars_fragment,
    color_pars_vertex,
    color_vertex,
    common,
    cube_uv_reflection_fragment,
    defaultnormal_vertex,
    displacementmap_pars_vertex,
    displacementmap_vertex,
    emissivemap_fragment,
    emissivemap_pars_fragment,
    colorspace_fragment,
    colorspace_pars_fragment,
    envmap_fragment,
    envmap_common_pars_fragment,
    envmap_pars_fragment,
    envmap_pars_vertex,
    envmap_physical_pars_fragment,
    envmap_vertex,
    fog_vertex,
    fog_pars_vertex,
    fog_fragment,
    fog_pars_fragment,
    gradientmap_pars_fragment,
    lightmap_pars_fragment,
    lights_lambert_fragment,
    lights_lambert_pars_fragment,
    lights_pars_begin,
    lights_toon_fragment,
    lights_toon_pars_fragment,
    lights_phong_fragment,
    lights_phong_pars_fragment,
    lights_physical_fragment,
    lights_physical_pars_fragment,
    lights_fragment_begin,
    lights_fragment_maps,
    lights_fragment_end,
    logdepthbuf_fragment,
    logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex,
    logdepthbuf_vertex,
    map_fragment,
    map_pars_fragment,
    map_particle_fragment,
    map_particle_pars_fragment,
    metalnessmap_fragment,
    metalnessmap_pars_fragment,
    morphinstance_vertex,
    morphcolor_vertex,
    morphnormal_vertex,
    morphtarget_pars_vertex,
    morphtarget_vertex,
    normal_fragment_begin,
    normal_fragment_maps,
    normal_pars_fragment,
    normal_pars_vertex,
    normal_vertex,
    normalmap_pars_fragment,
    clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment,
    iridescence_pars_fragment,
    opaque_fragment,
    packing,
    premultiplied_alpha_fragment,
    project_vertex,
    dithering_fragment,
    dithering_pars_fragment,
    roughnessmap_fragment,
    roughnessmap_pars_fragment,
    shadowmap_pars_fragment,
    shadowmap_pars_vertex,
    shadowmap_vertex,
    shadowmask_pars_fragment,
    skinbase_vertex,
    skinning_pars_vertex,
    skinning_vertex,
    skinnormal_vertex,
    specularmap_fragment,
    specularmap_pars_fragment,
    tonemapping_fragment,
    tonemapping_pars_fragment,
    transmission_fragment,
    transmission_pars_fragment,
    uv_pars_fragment,
    uv_pars_vertex,
    uv_vertex,
    worldpos_vertex,
    background_vert: vertex$h,
    background_frag: fragment$h,
    backgroundCube_vert: vertex$g,
    backgroundCube_frag: fragment$g,
    cube_vert: vertex$f,
    cube_frag: fragment$f,
    depth_vert: vertex$e,
    depth_frag: fragment$e,
    distanceRGBA_vert: vertex$d,
    distanceRGBA_frag: fragment$d,
    equirect_vert: vertex$c,
    equirect_frag: fragment$c,
    linedashed_vert: vertex$b,
    linedashed_frag: fragment$b,
    meshbasic_vert: vertex$a,
    meshbasic_frag: fragment$a,
    meshlambert_vert: vertex$9,
    meshlambert_frag: fragment$9,
    meshmatcap_vert: vertex$8,
    meshmatcap_frag: fragment$8,
    meshnormal_vert: vertex$7,
    meshnormal_frag: fragment$7,
    meshphong_vert: vertex$6,
    meshphong_frag: fragment$6,
    meshphysical_vert: vertex$5,
    meshphysical_frag: fragment$5,
    meshtoon_vert: vertex$4,
    meshtoon_frag: fragment$4,
    points_vert: vertex$3,
    points_frag: fragment$3,
    shadow_vert: vertex$2,
    shadow_frag: fragment$2,
    sprite_vert: vertex$1,
    sprite_frag: fragment$1
  };
  const UniformsLib = {
    common: {
      diffuse: { value: /* @__PURE__ */ new Color(16777215) },
      opacity: { value: 1 },
      map: { value: null },
      mapTransform: { value: /* @__PURE__ */ new Matrix3() },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      alphaTest: { value: 0 }
    },
    specularmap: {
      specularMap: { value: null },
      specularMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    envmap: {
      envMap: { value: null },
      envMapRotation: { value: /* @__PURE__ */ new Matrix3() },
      flipEnvMap: { value: -1 },
      reflectivity: { value: 1 },
      // basic, lambert, phong
      ior: { value: 1.5 },
      // physical
      refractionRatio: { value: 0.98 }
      // basic, lambert, phong
    },
    aomap: {
      aoMap: { value: null },
      aoMapIntensity: { value: 1 },
      aoMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    lightmap: {
      lightMap: { value: null },
      lightMapIntensity: { value: 1 },
      lightMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    bumpmap: {
      bumpMap: { value: null },
      bumpMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      bumpScale: { value: 1 }
    },
    normalmap: {
      normalMap: { value: null },
      normalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      normalScale: { value: /* @__PURE__ */ new Vector2(1, 1) }
    },
    displacementmap: {
      displacementMap: { value: null },
      displacementMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      displacementScale: { value: 1 },
      displacementBias: { value: 0 }
    },
    emissivemap: {
      emissiveMap: { value: null },
      emissiveMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    metalnessmap: {
      metalnessMap: { value: null },
      metalnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    roughnessmap: {
      roughnessMap: { value: null },
      roughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    gradientmap: {
      gradientMap: { value: null }
    },
    fog: {
      fogDensity: { value: 25e-5 },
      fogNear: { value: 1 },
      fogFar: { value: 2e3 },
      fogColor: { value: /* @__PURE__ */ new Color(16777215) }
    },
    lights: {
      ambientLightColor: { value: [] },
      lightProbe: { value: [] },
      directionalLights: { value: [], properties: {
        direction: {},
        color: {}
      } },
      directionalLightShadows: { value: [], properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      } },
      directionalShadowMap: { value: [] },
      directionalShadowMatrix: { value: [] },
      spotLights: { value: [], properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      } },
      spotLightShadows: { value: [], properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      } },
      spotLightMap: { value: [] },
      spotShadowMap: { value: [] },
      spotLightMatrix: { value: [] },
      pointLights: { value: [], properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      } },
      pointLightShadows: { value: [], properties: {
        shadowIntensity: 1,
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      } },
      pointShadowMap: { value: [] },
      pointShadowMatrix: { value: [] },
      hemisphereLights: { value: [], properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      } },
      // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
      rectAreaLights: { value: [], properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      } },
      ltc_1: { value: null },
      ltc_2: { value: null }
    },
    points: {
      diffuse: { value: /* @__PURE__ */ new Color(16777215) },
      opacity: { value: 1 },
      size: { value: 1 },
      scale: { value: 1 },
      map: { value: null },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      alphaTest: { value: 0 },
      uvTransform: { value: /* @__PURE__ */ new Matrix3() }
    },
    sprite: {
      diffuse: { value: /* @__PURE__ */ new Color(16777215) },
      opacity: { value: 1 },
      center: { value: /* @__PURE__ */ new Vector2(0.5, 0.5) },
      rotation: { value: 0 },
      map: { value: null },
      mapTransform: { value: /* @__PURE__ */ new Matrix3() },
      alphaMap: { value: null },
      alphaMapTransform: { value: /* @__PURE__ */ new Matrix3() },
      alphaTest: { value: 0 }
    }
  };
  const ShaderLib = {
    basic: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.specularmap,
        UniformsLib.envmap,
        UniformsLib.aomap,
        UniformsLib.lightmap,
        UniformsLib.fog
      ]),
      vertexShader: ShaderChunk.meshbasic_vert,
      fragmentShader: ShaderChunk.meshbasic_frag
    },
    lambert: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.specularmap,
        UniformsLib.envmap,
        UniformsLib.aomap,
        UniformsLib.lightmap,
        UniformsLib.emissivemap,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        UniformsLib.fog,
        UniformsLib.lights,
        {
          emissive: { value: /* @__PURE__ */ new Color(0) }
        }
      ]),
      vertexShader: ShaderChunk.meshlambert_vert,
      fragmentShader: ShaderChunk.meshlambert_frag
    },
    phong: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.specularmap,
        UniformsLib.envmap,
        UniformsLib.aomap,
        UniformsLib.lightmap,
        UniformsLib.emissivemap,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        UniformsLib.fog,
        UniformsLib.lights,
        {
          emissive: { value: /* @__PURE__ */ new Color(0) },
          specular: { value: /* @__PURE__ */ new Color(1118481) },
          shininess: { value: 30 }
        }
      ]),
      vertexShader: ShaderChunk.meshphong_vert,
      fragmentShader: ShaderChunk.meshphong_frag
    },
    standard: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.envmap,
        UniformsLib.aomap,
        UniformsLib.lightmap,
        UniformsLib.emissivemap,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        UniformsLib.roughnessmap,
        UniformsLib.metalnessmap,
        UniformsLib.fog,
        UniformsLib.lights,
        {
          emissive: { value: /* @__PURE__ */ new Color(0) },
          roughness: { value: 1 },
          metalness: { value: 0 },
          envMapIntensity: { value: 1 }
        }
      ]),
      vertexShader: ShaderChunk.meshphysical_vert,
      fragmentShader: ShaderChunk.meshphysical_frag
    },
    toon: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.aomap,
        UniformsLib.lightmap,
        UniformsLib.emissivemap,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        UniformsLib.gradientmap,
        UniformsLib.fog,
        UniformsLib.lights,
        {
          emissive: { value: /* @__PURE__ */ new Color(0) }
        }
      ]),
      vertexShader: ShaderChunk.meshtoon_vert,
      fragmentShader: ShaderChunk.meshtoon_frag
    },
    matcap: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        UniformsLib.fog,
        {
          matcap: { value: null }
        }
      ]),
      vertexShader: ShaderChunk.meshmatcap_vert,
      fragmentShader: ShaderChunk.meshmatcap_frag
    },
    points: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.points,
        UniformsLib.fog
      ]),
      vertexShader: ShaderChunk.points_vert,
      fragmentShader: ShaderChunk.points_frag
    },
    dashed: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.fog,
        {
          scale: { value: 1 },
          dashSize: { value: 1 },
          totalSize: { value: 2 }
        }
      ]),
      vertexShader: ShaderChunk.linedashed_vert,
      fragmentShader: ShaderChunk.linedashed_frag
    },
    depth: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.displacementmap
      ]),
      vertexShader: ShaderChunk.depth_vert,
      fragmentShader: ShaderChunk.depth_frag
    },
    normal: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.bumpmap,
        UniformsLib.normalmap,
        UniformsLib.displacementmap,
        {
          opacity: { value: 1 }
        }
      ]),
      vertexShader: ShaderChunk.meshnormal_vert,
      fragmentShader: ShaderChunk.meshnormal_frag
    },
    sprite: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.sprite,
        UniformsLib.fog
      ]),
      vertexShader: ShaderChunk.sprite_vert,
      fragmentShader: ShaderChunk.sprite_frag
    },
    background: {
      uniforms: {
        uvTransform: { value: /* @__PURE__ */ new Matrix3() },
        t2D: { value: null },
        backgroundIntensity: { value: 1 }
      },
      vertexShader: ShaderChunk.background_vert,
      fragmentShader: ShaderChunk.background_frag
    },
    backgroundCube: {
      uniforms: {
        envMap: { value: null },
        flipEnvMap: { value: -1 },
        backgroundBlurriness: { value: 0 },
        backgroundIntensity: { value: 1 },
        backgroundRotation: { value: /* @__PURE__ */ new Matrix3() }
      },
      vertexShader: ShaderChunk.backgroundCube_vert,
      fragmentShader: ShaderChunk.backgroundCube_frag
    },
    cube: {
      uniforms: {
        tCube: { value: null },
        tFlip: { value: -1 },
        opacity: { value: 1 }
      },
      vertexShader: ShaderChunk.cube_vert,
      fragmentShader: ShaderChunk.cube_frag
    },
    equirect: {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: ShaderChunk.equirect_vert,
      fragmentShader: ShaderChunk.equirect_frag
    },
    distanceRGBA: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.common,
        UniformsLib.displacementmap,
        {
          referencePosition: { value: /* @__PURE__ */ new Vector3() },
          nearDistance: { value: 1 },
          farDistance: { value: 1e3 }
        }
      ]),
      vertexShader: ShaderChunk.distanceRGBA_vert,
      fragmentShader: ShaderChunk.distanceRGBA_frag
    },
    shadow: {
      uniforms: /* @__PURE__ */ mergeUniforms([
        UniformsLib.lights,
        UniformsLib.fog,
        {
          color: { value: /* @__PURE__ */ new Color(0) },
          opacity: { value: 1 }
        }
      ]),
      vertexShader: ShaderChunk.shadow_vert,
      fragmentShader: ShaderChunk.shadow_frag
    }
  };
  ShaderLib.physical = {
    uniforms: /* @__PURE__ */ mergeUniforms([
      ShaderLib.standard.uniforms,
      {
        clearcoat: { value: 0 },
        clearcoatMap: { value: null },
        clearcoatMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        clearcoatNormalMap: { value: null },
        clearcoatNormalMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        clearcoatNormalScale: { value: /* @__PURE__ */ new Vector2(1, 1) },
        clearcoatRoughness: { value: 0 },
        clearcoatRoughnessMap: { value: null },
        clearcoatRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        dispersion: { value: 0 },
        iridescence: { value: 0 },
        iridescenceMap: { value: null },
        iridescenceMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        iridescenceIOR: { value: 1.3 },
        iridescenceThicknessMinimum: { value: 100 },
        iridescenceThicknessMaximum: { value: 400 },
        iridescenceThicknessMap: { value: null },
        iridescenceThicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        sheen: { value: 0 },
        sheenColor: { value: /* @__PURE__ */ new Color(0) },
        sheenColorMap: { value: null },
        sheenColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        sheenRoughness: { value: 1 },
        sheenRoughnessMap: { value: null },
        sheenRoughnessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        transmission: { value: 0 },
        transmissionMap: { value: null },
        transmissionMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        transmissionSamplerSize: { value: /* @__PURE__ */ new Vector2() },
        transmissionSamplerMap: { value: null },
        thickness: { value: 0 },
        thicknessMap: { value: null },
        thicknessMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        attenuationDistance: { value: 0 },
        attenuationColor: { value: /* @__PURE__ */ new Color(0) },
        specularColor: { value: /* @__PURE__ */ new Color(1, 1, 1) },
        specularColorMap: { value: null },
        specularColorMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        specularIntensity: { value: 1 },
        specularIntensityMap: { value: null },
        specularIntensityMapTransform: { value: /* @__PURE__ */ new Matrix3() },
        anisotropyVector: { value: /* @__PURE__ */ new Vector2() },
        anisotropyMap: { value: null },
        anisotropyMapTransform: { value: /* @__PURE__ */ new Matrix3() }
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  };
  const _rgb = { r: 0, b: 0, g: 0 };
  const _e1$1 = /* @__PURE__ */ new Euler();
  const _m1$1 = /* @__PURE__ */ new Matrix4();
  function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new Color(0);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
      let background = scene.isScene === true ? scene.background : null;
      if (background && background.isTexture) {
        const usePMREM = scene.backgroundBlurriness > 0;
        background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
      }
      return background;
    }
    function render(scene) {
      let forceClear = false;
      const background = getBackground(scene);
      if (background === null) {
        setClear(clearColor, clearAlpha);
      } else if (background && background.isColor) {
        setClear(background, 1);
        forceClear = true;
      }
      const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
      if (environmentBlendMode === "additive") {
        state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
      } else if (environmentBlendMode === "alpha-blend") {
        state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
      }
      if (renderer.autoClear || forceClear) {
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
      }
    }
    function addToRenderList(renderList, scene) {
      const background = getBackground(scene);
      if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
        if (boxMesh === void 0) {
          boxMesh = new Mesh(
            new BoxGeometry(1, 1, 1),
            new ShaderMaterial({
              name: "BackgroundCubeMaterial",
              uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
              vertexShader: ShaderLib.backgroundCube.vertexShader,
              fragmentShader: ShaderLib.backgroundCube.fragmentShader,
              side: BackSide,
              depthTest: false,
              depthWrite: false,
              fog: false,
              allowOverride: false
            })
          );
          boxMesh.geometry.deleteAttribute("normal");
          boxMesh.geometry.deleteAttribute("uv");
          boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
            this.matrixWorld.copyPosition(camera.matrixWorld);
          };
          Object.defineProperty(boxMesh.material, "envMap", {
            get: function() {
              return this.uniforms.envMap.value;
            }
          });
          objects.update(boxMesh);
        }
        _e1$1.copy(scene.backgroundRotation);
        _e1$1.x *= -1;
        _e1$1.y *= -1;
        _e1$1.z *= -1;
        if (background.isCubeTexture && background.isRenderTargetTexture === false) {
          _e1$1.y *= -1;
          _e1$1.z *= -1;
        }
        boxMesh.material.uniforms.envMap.value = background;
        boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
        boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
        boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
        boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4(_m1$1.makeRotationFromEuler(_e1$1));
        boxMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
        if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
          boxMesh.material.needsUpdate = true;
          currentBackground = background;
          currentBackgroundVersion = background.version;
          currentTonemapping = renderer.toneMapping;
        }
        boxMesh.layers.enableAll();
        renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
      } else if (background && background.isTexture) {
        if (planeMesh === void 0) {
          planeMesh = new Mesh(
            new PlaneGeometry(2, 2),
            new ShaderMaterial({
              name: "BackgroundMaterial",
              uniforms: cloneUniforms(ShaderLib.background.uniforms),
              vertexShader: ShaderLib.background.vertexShader,
              fragmentShader: ShaderLib.background.fragmentShader,
              side: FrontSide,
              depthTest: false,
              depthWrite: false,
              fog: false,
              allowOverride: false
            })
          );
          planeMesh.geometry.deleteAttribute("normal");
          Object.defineProperty(planeMesh.material, "map", {
            get: function() {
              return this.uniforms.t2D.value;
            }
          });
          objects.update(planeMesh);
        }
        planeMesh.material.uniforms.t2D.value = background;
        planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
        planeMesh.material.toneMapped = ColorManagement.getTransfer(background.colorSpace) !== SRGBTransfer;
        if (background.matrixAutoUpdate === true) {
          background.updateMatrix();
        }
        planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
        if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
          planeMesh.material.needsUpdate = true;
          currentBackground = background;
          currentBackgroundVersion = background.version;
          currentTonemapping = renderer.toneMapping;
        }
        planeMesh.layers.enableAll();
        renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
      }
    }
    function setClear(color, alpha2) {
      color.getRGB(_rgb, getUnlitUniformColorSpace(renderer));
      state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha2, premultipliedAlpha);
    }
    function dispose() {
      if (boxMesh !== void 0) {
        boxMesh.geometry.dispose();
        boxMesh.material.dispose();
        boxMesh = void 0;
      }
      if (planeMesh !== void 0) {
        planeMesh.geometry.dispose();
        planeMesh.material.dispose();
        planeMesh = void 0;
      }
    }
    return {
      getClearColor: function() {
        return clearColor;
      },
      setClearColor: function(color, alpha2 = 1) {
        clearColor.set(color);
        clearAlpha = alpha2;
        setClear(clearColor, clearAlpha);
      },
      getClearAlpha: function() {
        return clearAlpha;
      },
      setClearAlpha: function(alpha2) {
        clearAlpha = alpha2;
        setClear(clearColor, clearAlpha);
      },
      render,
      addToRenderList,
      dispose
    };
  }
  function WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
      let updateBuffers = false;
      const state = getBindingState(geometry, program, material);
      if (currentState !== state) {
        currentState = state;
        bindVertexArrayObject(currentState.object);
      }
      updateBuffers = needsUpdate(object, geometry, program, index);
      if (updateBuffers) saveCache(object, geometry, program, index);
      if (index !== null) {
        attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
      }
      if (updateBuffers || forceUpdate) {
        forceUpdate = false;
        setupVertexAttributes(object, material, program, geometry);
        if (index !== null) {
          gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
      }
    }
    function createVertexArrayObject() {
      return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
      return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
      return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
      const wireframe = material.wireframe === true;
      let programMap = bindingStates[geometry.id];
      if (programMap === void 0) {
        programMap = {};
        bindingStates[geometry.id] = programMap;
      }
      let stateMap = programMap[program.id];
      if (stateMap === void 0) {
        stateMap = {};
        programMap[program.id] = stateMap;
      }
      let state = stateMap[wireframe];
      if (state === void 0) {
        state = createBindingState(createVertexArrayObject());
        stateMap[wireframe] = state;
      }
      return state;
    }
    function createBindingState(vao) {
      const newAttributes = [];
      const enabledAttributes = [];
      const attributeDivisors = [];
      for (let i2 = 0; i2 < maxVertexAttributes; i2++) {
        newAttributes[i2] = 0;
        enabledAttributes[i2] = 0;
        attributeDivisors[i2] = 0;
      }
      return {
        // for backward compatibility on non-VAO support browser
        geometry: null,
        program: null,
        wireframe: false,
        newAttributes,
        enabledAttributes,
        attributeDivisors,
        object: vao,
        attributes: {},
        index: null
      };
    }
    function needsUpdate(object, geometry, program, index) {
      const cachedAttributes = currentState.attributes;
      const geometryAttributes = geometry.attributes;
      let attributesNum = 0;
      const programAttributes = program.getAttributes();
      for (const name in programAttributes) {
        const programAttribute = programAttributes[name];
        if (programAttribute.location >= 0) {
          const cachedAttribute = cachedAttributes[name];
          let geometryAttribute = geometryAttributes[name];
          if (geometryAttribute === void 0) {
            if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
            if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
          }
          if (cachedAttribute === void 0) return true;
          if (cachedAttribute.attribute !== geometryAttribute) return true;
          if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
          attributesNum++;
        }
      }
      if (currentState.attributesNum !== attributesNum) return true;
      if (currentState.index !== index) return true;
      return false;
    }
    function saveCache(object, geometry, program, index) {
      const cache = {};
      const attributes2 = geometry.attributes;
      let attributesNum = 0;
      const programAttributes = program.getAttributes();
      for (const name in programAttributes) {
        const programAttribute = programAttributes[name];
        if (programAttribute.location >= 0) {
          let attribute = attributes2[name];
          if (attribute === void 0) {
            if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
            if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
          }
          const data = {};
          data.attribute = attribute;
          if (attribute && attribute.data) {
            data.data = attribute.data;
          }
          cache[name] = data;
          attributesNum++;
        }
      }
      currentState.attributes = cache;
      currentState.attributesNum = attributesNum;
      currentState.index = index;
    }
    function initAttributes() {
      const newAttributes = currentState.newAttributes;
      for (let i2 = 0, il = newAttributes.length; i2 < il; i2++) {
        newAttributes[i2] = 0;
      }
    }
    function enableAttribute(attribute) {
      enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
      const newAttributes = currentState.newAttributes;
      const enabledAttributes = currentState.enabledAttributes;
      const attributeDivisors = currentState.attributeDivisors;
      newAttributes[attribute] = 1;
      if (enabledAttributes[attribute] === 0) {
        gl.enableVertexAttribArray(attribute);
        enabledAttributes[attribute] = 1;
      }
      if (attributeDivisors[attribute] !== meshPerAttribute) {
        gl.vertexAttribDivisor(attribute, meshPerAttribute);
        attributeDivisors[attribute] = meshPerAttribute;
      }
    }
    function disableUnusedAttributes() {
      const newAttributes = currentState.newAttributes;
      const enabledAttributes = currentState.enabledAttributes;
      for (let i2 = 0, il = enabledAttributes.length; i2 < il; i2++) {
        if (enabledAttributes[i2] !== newAttributes[i2]) {
          gl.disableVertexAttribArray(i2);
          enabledAttributes[i2] = 0;
        }
      }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
      if (integer === true) {
        gl.vertexAttribIPointer(index, size, type, stride, offset);
      } else {
        gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
      }
    }
    function setupVertexAttributes(object, material, program, geometry) {
      initAttributes();
      const geometryAttributes = geometry.attributes;
      const programAttributes = program.getAttributes();
      const materialDefaultAttributeValues = material.defaultAttributeValues;
      for (const name in programAttributes) {
        const programAttribute = programAttributes[name];
        if (programAttribute.location >= 0) {
          let geometryAttribute = geometryAttributes[name];
          if (geometryAttribute === void 0) {
            if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
            if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
          }
          if (geometryAttribute !== void 0) {
            const normalized = geometryAttribute.normalized;
            const size = geometryAttribute.itemSize;
            const attribute = attributes.get(geometryAttribute);
            if (attribute === void 0) continue;
            const buffer = attribute.buffer;
            const type = attribute.type;
            const bytesPerElement = attribute.bytesPerElement;
            const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === IntType;
            if (geometryAttribute.isInterleavedBufferAttribute) {
              const data = geometryAttribute.data;
              const stride = data.stride;
              const offset = geometryAttribute.offset;
              if (data.isInstancedInterleavedBuffer) {
                for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                  enableAttributeAndDivisor(programAttribute.location + i2, data.meshPerAttribute);
                }
                if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                  geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                }
              } else {
                for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                  enableAttribute(programAttribute.location + i2);
                }
              }
              gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                vertexAttribPointer(
                  programAttribute.location + i2,
                  size / programAttribute.locationSize,
                  type,
                  normalized,
                  stride * bytesPerElement,
                  (offset + size / programAttribute.locationSize * i2) * bytesPerElement,
                  integer
                );
              }
            } else {
              if (geometryAttribute.isInstancedBufferAttribute) {
                for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                  enableAttributeAndDivisor(programAttribute.location + i2, geometryAttribute.meshPerAttribute);
                }
                if (object.isInstancedMesh !== true && geometry._maxInstanceCount === void 0) {
                  geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                }
              } else {
                for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                  enableAttribute(programAttribute.location + i2);
                }
              }
              gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                vertexAttribPointer(
                  programAttribute.location + i2,
                  size / programAttribute.locationSize,
                  type,
                  normalized,
                  size * bytesPerElement,
                  size / programAttribute.locationSize * i2 * bytesPerElement,
                  integer
                );
              }
            }
          } else if (materialDefaultAttributeValues !== void 0) {
            const value = materialDefaultAttributeValues[name];
            if (value !== void 0) {
              switch (value.length) {
                case 2:
                  gl.vertexAttrib2fv(programAttribute.location, value);
                  break;
                case 3:
                  gl.vertexAttrib3fv(programAttribute.location, value);
                  break;
                case 4:
                  gl.vertexAttrib4fv(programAttribute.location, value);
                  break;
                default:
                  gl.vertexAttrib1fv(programAttribute.location, value);
              }
            }
          }
        }
      }
      disableUnusedAttributes();
    }
    function dispose() {
      reset();
      for (const geometryId in bindingStates) {
        const programMap = bindingStates[geometryId];
        for (const programId in programMap) {
          const stateMap = programMap[programId];
          for (const wireframe in stateMap) {
            deleteVertexArrayObject(stateMap[wireframe].object);
            delete stateMap[wireframe];
          }
          delete programMap[programId];
        }
        delete bindingStates[geometryId];
      }
    }
    function releaseStatesOfGeometry(geometry) {
      if (bindingStates[geometry.id] === void 0) return;
      const programMap = bindingStates[geometry.id];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
      for (const geometryId in bindingStates) {
        const programMap = bindingStates[geometryId];
        if (programMap[program.id] === void 0) continue;
        const stateMap = programMap[program.id];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[program.id];
      }
    }
    function reset() {
      resetDefaultState();
      forceUpdate = true;
      if (currentState === defaultState) return;
      currentState = defaultState;
      bindVertexArrayObject(currentState.object);
    }
    function resetDefaultState() {
      defaultState.geometry = null;
      defaultState.program = null;
      defaultState.wireframe = false;
    }
    return {
      setup,
      reset,
      resetDefaultState,
      dispose,
      releaseStatesOfGeometry,
      releaseStatesOfProgram,
      initAttributes,
      enableAttribute,
      disableUnusedAttributes
    };
  }
  function WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
      mode = value;
    }
    function render(start, count) {
      gl.drawArrays(mode, start, count);
      info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
      if (primcount === 0) return;
      gl.drawArraysInstanced(mode, start, count, primcount);
      info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
      if (drawCount === 0) return;
      const extension = extensions.get("WEBGL_multi_draw");
      extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2];
      }
      info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
      if (drawCount === 0) return;
      const extension = extensions.get("WEBGL_multi_draw");
      if (extension === null) {
        for (let i2 = 0; i2 < starts.length; i2++) {
          renderInstances(starts[i2], counts[i2], primcount[i2]);
        }
      } else {
        extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
        let elementCount = 0;
        for (let i2 = 0; i2 < drawCount; i2++) {
          elementCount += counts[i2] * primcount[i2];
        }
        info.update(elementCount, mode, 1);
      }
    }
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
  }
  function WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
      if (maxAnisotropy !== void 0) return maxAnisotropy;
      if (extensions.has("EXT_texture_filter_anisotropic") === true) {
        const extension = extensions.get("EXT_texture_filter_anisotropic");
        maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      } else {
        maxAnisotropy = 0;
      }
      return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
      if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
        return false;
      }
      return true;
    }
    function textureTypeReadable(textureType) {
      const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float"));
      if (textureType !== UnsignedByteType && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
      textureType !== FloatType && !halfFloatSupportedByExt) {
        return false;
      }
      return true;
    }
    function getMaxPrecision(precision2) {
      if (precision2 === "highp") {
        if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) {
          return "highp";
        }
        precision2 = "mediump";
      }
      if (precision2 === "mediump") {
        if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) {
          return "mediump";
        }
      }
      return "lowp";
    }
    let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
      console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
      precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has("EXT_clip_control");
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
      isWebGL2: true,
      // keeping this for backwards compatibility
      getMaxAnisotropy,
      getMaxPrecision,
      textureFormatReadable,
      textureTypeReadable,
      precision,
      logarithmicDepthBuffer,
      reverseDepthBuffer,
      maxTextures,
      maxVertexTextures,
      maxTextureSize,
      maxCubemapSize,
      maxAttributes,
      maxVertexUniforms,
      maxVaryings,
      maxFragmentUniforms,
      vertexTextures,
      maxSamples
    };
  }
  function WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new Plane(), viewNormalMatrix = new Matrix3(), uniform = { value: null, needsUpdate: false };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
      const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
      // run another frame in order to reset the state:
      numGlobalPlanes !== 0 || localClippingEnabled;
      localClippingEnabled = enableLocalClipping;
      numGlobalPlanes = planes.length;
      return enabled;
    };
    this.beginShadows = function() {
      renderingShadows = true;
      projectPlanes(null);
    };
    this.endShadows = function() {
      renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
      globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
      const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
      const materialProperties = properties.get(material);
      if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
        if (renderingShadows) {
          projectPlanes(null);
        } else {
          resetGlobalState();
        }
      } else {
        const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
        let dstArray = materialProperties.clippingState || null;
        uniform.value = dstArray;
        dstArray = projectPlanes(planes, camera, lGlobal, useCache);
        for (let i2 = 0; i2 !== lGlobal; ++i2) {
          dstArray[i2] = globalState[i2];
        }
        materialProperties.clippingState = dstArray;
        this.numIntersection = clipIntersection ? this.numPlanes : 0;
        this.numPlanes += nGlobal;
      }
    };
    function resetGlobalState() {
      if (uniform.value !== globalState) {
        uniform.value = globalState;
        uniform.needsUpdate = numGlobalPlanes > 0;
      }
      scope.numPlanes = numGlobalPlanes;
      scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
      const nPlanes = planes !== null ? planes.length : 0;
      let dstArray = null;
      if (nPlanes !== 0) {
        dstArray = uniform.value;
        if (skipTransform !== true || dstArray === null) {
          const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
          viewNormalMatrix.getNormalMatrix(viewMatrix);
          if (dstArray === null || dstArray.length < flatSize) {
            dstArray = new Float32Array(flatSize);
          }
          for (let i2 = 0, i4 = dstOffset; i2 !== nPlanes; ++i2, i4 += 4) {
            plane.copy(planes[i2]).applyMatrix4(viewMatrix, viewNormalMatrix);
            plane.normal.toArray(dstArray, i4);
            dstArray[i4 + 3] = plane.constant;
          }
        }
        uniform.value = dstArray;
        uniform.needsUpdate = true;
      }
      scope.numPlanes = nPlanes;
      scope.numIntersection = 0;
      return dstArray;
    }
  }
  function WebGLCubeMaps(renderer) {
    let cubemaps = /* @__PURE__ */ new WeakMap();
    function mapTextureMapping(texture, mapping) {
      if (mapping === EquirectangularReflectionMapping) {
        texture.mapping = CubeReflectionMapping;
      } else if (mapping === EquirectangularRefractionMapping) {
        texture.mapping = CubeRefractionMapping;
      }
      return texture;
    }
    function get(texture) {
      if (texture && texture.isTexture) {
        const mapping = texture.mapping;
        if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
          if (cubemaps.has(texture)) {
            const cubemap = cubemaps.get(texture).texture;
            return mapTextureMapping(cubemap, texture.mapping);
          } else {
            const image = texture.image;
            if (image && image.height > 0) {
              const renderTarget = new WebGLCubeRenderTarget(image.height);
              renderTarget.fromEquirectangularTexture(renderer, texture);
              cubemaps.set(texture, renderTarget);
              texture.addEventListener("dispose", onTextureDispose);
              return mapTextureMapping(renderTarget.texture, texture.mapping);
            } else {
              return null;
            }
          }
        }
      }
      return texture;
    }
    function onTextureDispose(event) {
      const texture = event.target;
      texture.removeEventListener("dispose", onTextureDispose);
      const cubemap = cubemaps.get(texture);
      if (cubemap !== void 0) {
        cubemaps.delete(texture);
        cubemap.dispose();
      }
    }
    function dispose() {
      cubemaps = /* @__PURE__ */ new WeakMap();
    }
    return {
      get,
      dispose
    };
  }
  const LOD_MIN = 4;
  const EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
  const MAX_SAMPLES = 20;
  const _flatCamera = /* @__PURE__ */ new OrthographicCamera();
  const _clearColor = /* @__PURE__ */ new Color();
  let _oldTarget = null;
  let _oldActiveCubeFace = 0;
  let _oldActiveMipmapLevel = 0;
  let _oldXrEnabled = false;
  const PHI = (1 + Math.sqrt(5)) / 2;
  const INV_PHI = 1 / PHI;
  const _axisDirections = [
    /* @__PURE__ */ new Vector3(-PHI, INV_PHI, 0),
    /* @__PURE__ */ new Vector3(PHI, INV_PHI, 0),
    /* @__PURE__ */ new Vector3(-INV_PHI, 0, PHI),
    /* @__PURE__ */ new Vector3(INV_PHI, 0, PHI),
    /* @__PURE__ */ new Vector3(0, PHI, -INV_PHI),
    /* @__PURE__ */ new Vector3(0, PHI, INV_PHI),
    /* @__PURE__ */ new Vector3(-1, 1, -1),
    /* @__PURE__ */ new Vector3(1, 1, -1),
    /* @__PURE__ */ new Vector3(-1, 1, 1),
    /* @__PURE__ */ new Vector3(1, 1, 1)
  ];
  const _origin = /* @__PURE__ */ new Vector3();
  class PMREMGenerator {
    /**
     * Constructs a new PMREM generator.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     */
    constructor(renderer) {
      this._renderer = renderer;
      this._pingPongRenderTarget = null;
      this._lodMax = 0;
      this._cubeSize = 0;
      this._lodPlanes = [];
      this._sizeLods = [];
      this._sigmas = [];
      this._blurMaterial = null;
      this._cubemapMaterial = null;
      this._equirectMaterial = null;
      this._compileMaterial(this._blurMaterial);
    }
    /**
     * Generates a PMREM from a supplied Scene, which can be faster than using an
     * image if networking bandwidth is low. Optional sigma specifies a blur radius
     * in radians to be applied to the scene before PMREM generation. Optional near
     * and far planes ensure the scene is rendered in its entirety.
     *
     * @param {Scene} scene - The scene to be captured.
     * @param {number} [sigma=0] - The blur radius in radians.
     * @param {number} [near=0.1] - The near plane distance.
     * @param {number} [far=100] - The far plane distance.
     * @param {Object} [options={}] - The configuration options.
     * @param {number} [options.size=256] - The texture size of the PMREM.
     * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
     * @return {WebGLRenderTarget} The resulting PMREM.
     */
    fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
      const {
        size = 256,
        position = _origin
      } = options;
      _oldTarget = this._renderer.getRenderTarget();
      _oldActiveCubeFace = this._renderer.getActiveCubeFace();
      _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
      _oldXrEnabled = this._renderer.xr.enabled;
      this._renderer.xr.enabled = false;
      this._setSize(size);
      const cubeUVRenderTarget = this._allocateTargets();
      cubeUVRenderTarget.depthBuffer = true;
      this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
      if (sigma > 0) {
        this._blur(cubeUVRenderTarget, 0, 0, sigma);
      }
      this._applyPMREM(cubeUVRenderTarget);
      this._cleanup(cubeUVRenderTarget);
      return cubeUVRenderTarget;
    }
    /**
     * Generates a PMREM from an equirectangular texture, which can be either LDR
     * or HDR. The ideal input image size is 1k (1024 x 512),
     * as this matches best with the 256 x 256 cubemap output.
     *
     * @param {Texture} equirectangular - The equirectangular texture to be converted.
     * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
     * @return {WebGLRenderTarget} The resulting PMREM.
     */
    fromEquirectangular(equirectangular, renderTarget = null) {
      return this._fromTexture(equirectangular, renderTarget);
    }
    /**
     * Generates a PMREM from an cubemap texture, which can be either LDR
     * or HDR. The ideal input cube size is 256 x 256,
     * as this matches best with the 256 x 256 cubemap output.
     *
     * @param {Texture} cubemap - The cubemap texture to be converted.
     * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
     * @return {WebGLRenderTarget} The resulting PMREM.
     */
    fromCubemap(cubemap, renderTarget = null) {
      return this._fromTexture(cubemap, renderTarget);
    }
    /**
     * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
     * your texture's network fetch for increased concurrency.
     */
    compileCubemapShader() {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = _getCubemapMaterial();
        this._compileMaterial(this._cubemapMaterial);
      }
    }
    /**
     * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
     * your texture's network fetch for increased concurrency.
     */
    compileEquirectangularShader() {
      if (this._equirectMaterial === null) {
        this._equirectMaterial = _getEquirectMaterial();
        this._compileMaterial(this._equirectMaterial);
      }
    }
    /**
     * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
     * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
     * one of them will cause any others to also become unusable.
     */
    dispose() {
      this._dispose();
      if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
      if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
      this._lodMax = Math.floor(Math.log2(cubeSize));
      this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
      if (this._blurMaterial !== null) this._blurMaterial.dispose();
      if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
      for (let i2 = 0; i2 < this._lodPlanes.length; i2++) {
        this._lodPlanes[i2].dispose();
      }
    }
    _cleanup(outputTarget) {
      this._renderer.setRenderTarget(_oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel);
      this._renderer.xr.enabled = _oldXrEnabled;
      outputTarget.scissorTest = false;
      _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
      if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {
        this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
      } else {
        this._setSize(texture.image.width / 4);
      }
      _oldTarget = this._renderer.getRenderTarget();
      _oldActiveCubeFace = this._renderer.getActiveCubeFace();
      _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
      _oldXrEnabled = this._renderer.xr.enabled;
      this._renderer.xr.enabled = false;
      const cubeUVRenderTarget = renderTarget || this._allocateTargets();
      this._textureToCubeUV(texture, cubeUVRenderTarget);
      this._applyPMREM(cubeUVRenderTarget);
      this._cleanup(cubeUVRenderTarget);
      return cubeUVRenderTarget;
    }
    _allocateTargets() {
      const width = 3 * Math.max(this._cubeSize, 16 * 7);
      const height = 4 * this._cubeSize;
      const params = {
        magFilter: LinearFilter,
        minFilter: LinearFilter,
        generateMipmaps: false,
        type: HalfFloatType,
        format: RGBAFormat,
        colorSpace: LinearSRGBColorSpace,
        depthBuffer: false
      };
      const cubeUVRenderTarget = _createRenderTarget(width, height, params);
      if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
        if (this._pingPongRenderTarget !== null) {
          this._dispose();
        }
        this._pingPongRenderTarget = _createRenderTarget(width, height, params);
        const { _lodMax } = this;
        ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(_lodMax));
        this._blurMaterial = _getBlurShader(_lodMax, width, height);
      }
      return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
      const tmpMesh = new Mesh(this._lodPlanes[0], material);
      this._renderer.compile(tmpMesh, _flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
      const fov2 = 90;
      const aspect2 = 1;
      const cubeCamera = new PerspectiveCamera(fov2, aspect2, near, far);
      const upSign = [1, -1, 1, 1, 1, 1];
      const forwardSign = [1, 1, 1, -1, -1, -1];
      const renderer = this._renderer;
      const originalAutoClear = renderer.autoClear;
      const toneMapping = renderer.toneMapping;
      renderer.getClearColor(_clearColor);
      renderer.toneMapping = NoToneMapping;
      renderer.autoClear = false;
      const backgroundMaterial = new MeshBasicMaterial({
        name: "PMREM.Background",
        side: BackSide,
        depthWrite: false,
        depthTest: false
      });
      const backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
      let useSolidColor = false;
      const background = scene.background;
      if (background) {
        if (background.isColor) {
          backgroundMaterial.color.copy(background);
          scene.background = null;
          useSolidColor = true;
        }
      } else {
        backgroundMaterial.color.copy(_clearColor);
        useSolidColor = true;
      }
      for (let i2 = 0; i2 < 6; i2++) {
        const col = i2 % 3;
        if (col === 0) {
          cubeCamera.up.set(0, upSign[i2], 0);
          cubeCamera.position.set(position.x, position.y, position.z);
          cubeCamera.lookAt(position.x + forwardSign[i2], position.y, position.z);
        } else if (col === 1) {
          cubeCamera.up.set(0, 0, upSign[i2]);
          cubeCamera.position.set(position.x, position.y, position.z);
          cubeCamera.lookAt(position.x, position.y + forwardSign[i2], position.z);
        } else {
          cubeCamera.up.set(0, upSign[i2], 0);
          cubeCamera.position.set(position.x, position.y, position.z);
          cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i2]);
        }
        const size = this._cubeSize;
        _setViewport(cubeUVRenderTarget, col * size, i2 > 2 ? size : 0, size, size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        if (useSolidColor) {
          renderer.render(backgroundBox, cubeCamera);
        }
        renderer.render(scene, cubeCamera);
      }
      backgroundBox.geometry.dispose();
      backgroundBox.material.dispose();
      renderer.toneMapping = toneMapping;
      renderer.autoClear = originalAutoClear;
      scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
      const renderer = this._renderer;
      const isCubeTexture = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;
      if (isCubeTexture) {
        if (this._cubemapMaterial === null) {
          this._cubemapMaterial = _getCubemapMaterial();
        }
        this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
      } else {
        if (this._equirectMaterial === null) {
          this._equirectMaterial = _getEquirectMaterial();
        }
      }
      const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
      const mesh = new Mesh(this._lodPlanes[0], material);
      const uniforms = material.uniforms;
      uniforms["envMap"].value = texture;
      const size = this._cubeSize;
      _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
      renderer.setRenderTarget(cubeUVRenderTarget);
      renderer.render(mesh, _flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
      const renderer = this._renderer;
      const autoClear = renderer.autoClear;
      renderer.autoClear = false;
      const n2 = this._lodPlanes.length;
      for (let i2 = 1; i2 < n2; i2++) {
        const sigma = Math.sqrt(this._sigmas[i2] * this._sigmas[i2] - this._sigmas[i2 - 1] * this._sigmas[i2 - 1]);
        const poleAxis = _axisDirections[(n2 - i2 - 1) % _axisDirections.length];
        this._blur(cubeUVRenderTarget, i2 - 1, i2, sigma, poleAxis);
      }
      renderer.autoClear = autoClear;
    }
    /**
     * This is a two-pass Gaussian blur for a cubemap. Normally this is done
     * vertically and horizontally, but this breaks down on a cube. Here we apply
     * the blur latitudinally (around the poles), and then longitudinally (towards
     * the poles) to approximate the orthogonally-separable blur. It is least
     * accurate at the poles, but still does a decent job.
     *
     * @private
     * @param {WebGLRenderTarget} cubeUVRenderTarget
     * @param {number} lodIn
     * @param {number} lodOut
     * @param {number} sigma
     * @param {Vector3} [poleAxis]
     */
    _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
      const pingPongRenderTarget = this._pingPongRenderTarget;
      this._halfBlur(
        cubeUVRenderTarget,
        pingPongRenderTarget,
        lodIn,
        lodOut,
        sigma,
        "latitudinal",
        poleAxis
      );
      this._halfBlur(
        pingPongRenderTarget,
        cubeUVRenderTarget,
        lodOut,
        lodOut,
        sigma,
        "longitudinal",
        poleAxis
      );
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
      const renderer = this._renderer;
      const blurMaterial = this._blurMaterial;
      if (direction !== "latitudinal" && direction !== "longitudinal") {
        console.error(
          "blur direction must be either latitudinal or longitudinal!"
        );
      }
      const STANDARD_DEVIATIONS = 3;
      const blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
      const blurUniforms = blurMaterial.uniforms;
      const pixels = this._sizeLods[lodIn] - 1;
      const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
      const sigmaPixels = sigmaRadians / radiansPerPixel;
      const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
      if (samples > MAX_SAMPLES) {
        console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
      }
      const weights = [];
      let sum = 0;
      for (let i2 = 0; i2 < MAX_SAMPLES; ++i2) {
        const x3 = i2 / sigmaPixels;
        const weight = Math.exp(-x3 * x3 / 2);
        weights.push(weight);
        if (i2 === 0) {
          sum += weight;
        } else if (i2 < samples) {
          sum += 2 * weight;
        }
      }
      for (let i2 = 0; i2 < weights.length; i2++) {
        weights[i2] = weights[i2] / sum;
      }
      blurUniforms["envMap"].value = targetIn.texture;
      blurUniforms["samples"].value = samples;
      blurUniforms["weights"].value = weights;
      blurUniforms["latitudinal"].value = direction === "latitudinal";
      if (poleAxis) {
        blurUniforms["poleAxis"].value = poleAxis;
      }
      const { _lodMax } = this;
      blurUniforms["dTheta"].value = radiansPerPixel;
      blurUniforms["mipInt"].value = _lodMax - lodIn;
      const outputSize = this._sizeLods[lodOut];
      const x2 = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
      const y2 = 4 * (this._cubeSize - outputSize);
      _setViewport(targetOut, x2, y2, 3 * outputSize, 2 * outputSize);
      renderer.setRenderTarget(targetOut);
      renderer.render(blurMesh, _flatCamera);
    }
  }
  function _createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
    for (let i2 = 0; i2 < totalLods; i2++) {
      const sizeLod = Math.pow(2, lod);
      sizeLods.push(sizeLod);
      let sigma = 1 / sizeLod;
      if (i2 > lodMax - LOD_MIN) {
        sigma = EXTRA_LOD_SIGMA[i2 - lodMax + LOD_MIN - 1];
      } else if (i2 === 0) {
        sigma = 0;
      }
      sigmas.push(sigma);
      const texelSize = 1 / (sizeLod - 2);
      const min = -texelSize;
      const max = 1 + texelSize;
      const uv1 = [min, min, max, min, max, max, min, min, max, max, min, max];
      const cubeFaces = 6;
      const vertices = 6;
      const positionSize = 3;
      const uvSize = 2;
      const faceIndexSize = 1;
      const position = new Float32Array(positionSize * vertices * cubeFaces);
      const uv = new Float32Array(uvSize * vertices * cubeFaces);
      const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
      for (let face = 0; face < cubeFaces; face++) {
        const x2 = face % 3 * 2 / 3 - 1;
        const y2 = face > 2 ? 0 : -1;
        const coordinates = [
          x2,
          y2,
          0,
          x2 + 2 / 3,
          y2,
          0,
          x2 + 2 / 3,
          y2 + 1,
          0,
          x2,
          y2,
          0,
          x2 + 2 / 3,
          y2 + 1,
          0,
          x2,
          y2 + 1,
          0
        ];
        position.set(coordinates, positionSize * vertices * face);
        uv.set(uv1, uvSize * vertices * face);
        const fill = [face, face, face, face, face, face];
        faceIndex.set(fill, faceIndexSize * vertices * face);
      }
      const planes = new BufferGeometry();
      planes.setAttribute("position", new BufferAttribute(position, positionSize));
      planes.setAttribute("uv", new BufferAttribute(uv, uvSize));
      planes.setAttribute("faceIndex", new BufferAttribute(faceIndex, faceIndexSize));
      lodPlanes.push(planes);
      if (lod > LOD_MIN) {
        lod--;
      }
    }
    return { lodPlanes, sizeLods, sigmas };
  }
  function _createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new WebGLRenderTarget(width, height, params);
    cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
  }
  function _setViewport(target, x2, y2, width, height) {
    target.viewport.set(x2, y2, width, height);
    target.scissor.set(x2, y2, width, height);
  }
  function _getBlurShader(lodMax, width, height) {
    const weights = new Float32Array(MAX_SAMPLES);
    const poleAxis = new Vector3(0, 1, 0);
    const shaderMaterial = new ShaderMaterial({
      name: "SphericalGaussianBlur",
      defines: {
        "n": MAX_SAMPLES,
        "CUBEUV_TEXEL_WIDTH": 1 / width,
        "CUBEUV_TEXEL_HEIGHT": 1 / height,
        "CUBEUV_MAX_MIP": `${lodMax}.0`
      },
      uniforms: {
        "envMap": { value: null },
        "samples": { value: 1 },
        "weights": { value: weights },
        "latitudinal": { value: false },
        "dTheta": { value: 0 },
        "mipInt": { value: 0 },
        "poleAxis": { value: poleAxis }
      },
      vertexShader: _getCommonVertexShader(),
      fragmentShader: (
        /* glsl */
        `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
      ),
      blending: NoBlending,
      depthTest: false,
      depthWrite: false
    });
    return shaderMaterial;
  }
  function _getEquirectMaterial() {
    return new ShaderMaterial({
      name: "EquirectangularToCubeUV",
      uniforms: {
        "envMap": { value: null }
      },
      vertexShader: _getCommonVertexShader(),
      fragmentShader: (
        /* glsl */
        `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
      ),
      blending: NoBlending,
      depthTest: false,
      depthWrite: false
    });
  }
  function _getCubemapMaterial() {
    return new ShaderMaterial({
      name: "CubemapToCubeUV",
      uniforms: {
        "envMap": { value: null },
        "flipEnvMap": { value: -1 }
      },
      vertexShader: _getCommonVertexShader(),
      fragmentShader: (
        /* glsl */
        `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
      ),
      blending: NoBlending,
      depthTest: false,
      depthWrite: false
    });
  }
  function _getCommonVertexShader() {
    return (
      /* glsl */
      `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
    );
  }
  function WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = /* @__PURE__ */ new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
      if (texture && texture.isTexture) {
        const mapping = texture.mapping;
        const isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
        const isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
        if (isEquirectMap || isCubeMap) {
          let renderTarget = cubeUVmaps.get(texture);
          const currentPMREMVersion = renderTarget !== void 0 ? renderTarget.texture.pmremVersion : 0;
          if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
            if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
            renderTarget.texture.pmremVersion = texture.pmremVersion;
            cubeUVmaps.set(texture, renderTarget);
            return renderTarget.texture;
          } else {
            if (renderTarget !== void 0) {
              return renderTarget.texture;
            } else {
              const image = texture.image;
              if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
                renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                renderTarget.texture.pmremVersion = texture.pmremVersion;
                cubeUVmaps.set(texture, renderTarget);
                texture.addEventListener("dispose", onTextureDispose);
                return renderTarget.texture;
              } else {
                return null;
              }
            }
          }
        }
      }
      return texture;
    }
    function isCubeTextureComplete(image) {
      let count = 0;
      const length = 6;
      for (let i2 = 0; i2 < length; i2++) {
        if (image[i2] !== void 0) count++;
      }
      return count === length;
    }
    function onTextureDispose(event) {
      const texture = event.target;
      texture.removeEventListener("dispose", onTextureDispose);
      const cubemapUV = cubeUVmaps.get(texture);
      if (cubemapUV !== void 0) {
        cubeUVmaps.delete(texture);
        cubemapUV.dispose();
      }
    }
    function dispose() {
      cubeUVmaps = /* @__PURE__ */ new WeakMap();
      if (pmremGenerator !== null) {
        pmremGenerator.dispose();
        pmremGenerator = null;
      }
    }
    return {
      get,
      dispose
    };
  }
  function WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
      if (extensions[name] !== void 0) {
        return extensions[name];
      }
      let extension;
      switch (name) {
        case "WEBGL_depth_texture":
          extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
          break;
        case "EXT_texture_filter_anisotropic":
          extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
          break;
        case "WEBGL_compressed_texture_s3tc":
          extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
          break;
        case "WEBGL_compressed_texture_pvrtc":
          extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
          break;
        default:
          extension = gl.getExtension(name);
      }
      extensions[name] = extension;
      return extension;
    }
    return {
      has: function(name) {
        return getExtension(name) !== null;
      },
      init: function() {
        getExtension("EXT_color_buffer_float");
        getExtension("WEBGL_clip_cull_distance");
        getExtension("OES_texture_float_linear");
        getExtension("EXT_color_buffer_half_float");
        getExtension("WEBGL_multisampled_render_to_texture");
        getExtension("WEBGL_render_shared_exponent");
      },
      get: function(name) {
        const extension = getExtension(name);
        if (extension === null) {
          warnOnce("THREE.WebGLRenderer: " + name + " extension not supported.");
        }
        return extension;
      }
    };
  }
  function WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = /* @__PURE__ */ new WeakMap();
    function onGeometryDispose(event) {
      const geometry = event.target;
      if (geometry.index !== null) {
        attributes.remove(geometry.index);
      }
      for (const name in geometry.attributes) {
        attributes.remove(geometry.attributes[name]);
      }
      geometry.removeEventListener("dispose", onGeometryDispose);
      delete geometries[geometry.id];
      const attribute = wireframeAttributes.get(geometry);
      if (attribute) {
        attributes.remove(attribute);
        wireframeAttributes.delete(geometry);
      }
      bindingStates.releaseStatesOfGeometry(geometry);
      if (geometry.isInstancedBufferGeometry === true) {
        delete geometry._maxInstanceCount;
      }
      info.memory.geometries--;
    }
    function get(object, geometry) {
      if (geometries[geometry.id] === true) return geometry;
      geometry.addEventListener("dispose", onGeometryDispose);
      geometries[geometry.id] = true;
      info.memory.geometries++;
      return geometry;
    }
    function update(geometry) {
      const geometryAttributes = geometry.attributes;
      for (const name in geometryAttributes) {
        attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
      }
    }
    function updateWireframeAttribute(geometry) {
      const indices = [];
      const geometryIndex = geometry.index;
      const geometryPosition = geometry.attributes.position;
      let version = 0;
      if (geometryIndex !== null) {
        const array = geometryIndex.array;
        version = geometryIndex.version;
        for (let i2 = 0, l2 = array.length; i2 < l2; i2 += 3) {
          const a2 = array[i2 + 0];
          const b2 = array[i2 + 1];
          const c2 = array[i2 + 2];
          indices.push(a2, b2, b2, c2, c2, a2);
        }
      } else if (geometryPosition !== void 0) {
        const array = geometryPosition.array;
        version = geometryPosition.version;
        for (let i2 = 0, l2 = array.length / 3 - 1; i2 < l2; i2 += 3) {
          const a2 = i2 + 0;
          const b2 = i2 + 1;
          const c2 = i2 + 2;
          indices.push(a2, b2, b2, c2, c2, a2);
        }
      } else {
        return;
      }
      const attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
      attribute.version = version;
      const previousAttribute = wireframeAttributes.get(geometry);
      if (previousAttribute) attributes.remove(previousAttribute);
      wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
      const currentAttribute = wireframeAttributes.get(geometry);
      if (currentAttribute) {
        const geometryIndex = geometry.index;
        if (geometryIndex !== null) {
          if (currentAttribute.version < geometryIndex.version) {
            updateWireframeAttribute(geometry);
          }
        }
      } else {
        updateWireframeAttribute(geometry);
      }
      return wireframeAttributes.get(geometry);
    }
    return {
      get,
      update,
      getWireframeAttribute
    };
  }
  function WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
      mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
      type = value.type;
      bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
      gl.drawElements(mode, count, type, start * bytesPerElement);
      info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
      if (primcount === 0) return;
      gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
      info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
      if (drawCount === 0) return;
      const extension = extensions.get("WEBGL_multi_draw");
      extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
      let elementCount = 0;
      for (let i2 = 0; i2 < drawCount; i2++) {
        elementCount += counts[i2];
      }
      info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
      if (drawCount === 0) return;
      const extension = extensions.get("WEBGL_multi_draw");
      if (extension === null) {
        for (let i2 = 0; i2 < starts.length; i2++) {
          renderInstances(starts[i2] / bytesPerElement, counts[i2], primcount[i2]);
        }
      } else {
        extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
        let elementCount = 0;
        for (let i2 = 0; i2 < drawCount; i2++) {
          elementCount += counts[i2] * primcount[i2];
        }
        info.update(elementCount, mode, 1);
      }
    }
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
  }
  function WebGLInfo(gl) {
    const memory = {
      geometries: 0,
      textures: 0
    };
    const render = {
      frame: 0,
      calls: 0,
      triangles: 0,
      points: 0,
      lines: 0
    };
    function update(count, mode, instanceCount) {
      render.calls++;
      switch (mode) {
        case gl.TRIANGLES:
          render.triangles += instanceCount * (count / 3);
          break;
        case gl.LINES:
          render.lines += instanceCount * (count / 2);
          break;
        case gl.LINE_STRIP:
          render.lines += instanceCount * (count - 1);
          break;
        case gl.LINE_LOOP:
          render.lines += instanceCount * count;
          break;
        case gl.POINTS:
          render.points += instanceCount * count;
          break;
        default:
          console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
          break;
      }
    }
    function reset() {
      render.calls = 0;
      render.triangles = 0;
      render.points = 0;
      render.lines = 0;
    }
    return {
      memory,
      render,
      programs: null,
      autoReset: true,
      reset,
      update
    };
  }
  function WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = /* @__PURE__ */ new WeakMap();
    const morph = new Vector4();
    function update(object, geometry, program) {
      const objectInfluences = object.morphTargetInfluences;
      const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
      const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
      let entry = morphTextures.get(geometry);
      if (entry === void 0 || entry.count !== morphTargetsCount) {
        let disposeTexture = function() {
          texture.dispose();
          morphTextures.delete(geometry);
          geometry.removeEventListener("dispose", disposeTexture);
        };
        if (entry !== void 0) entry.texture.dispose();
        const hasMorphPosition = geometry.morphAttributes.position !== void 0;
        const hasMorphNormals = geometry.morphAttributes.normal !== void 0;
        const hasMorphColors = geometry.morphAttributes.color !== void 0;
        const morphTargets = geometry.morphAttributes.position || [];
        const morphNormals = geometry.morphAttributes.normal || [];
        const morphColors = geometry.morphAttributes.color || [];
        let vertexDataCount = 0;
        if (hasMorphPosition === true) vertexDataCount = 1;
        if (hasMorphNormals === true) vertexDataCount = 2;
        if (hasMorphColors === true) vertexDataCount = 3;
        let width = geometry.attributes.position.count * vertexDataCount;
        let height = 1;
        if (width > capabilities.maxTextureSize) {
          height = Math.ceil(width / capabilities.maxTextureSize);
          width = capabilities.maxTextureSize;
        }
        const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
        const texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
        texture.type = FloatType;
        texture.needsUpdate = true;
        const vertexDataStride = vertexDataCount * 4;
        for (let i2 = 0; i2 < morphTargetsCount; i2++) {
          const morphTarget = morphTargets[i2];
          const morphNormal = morphNormals[i2];
          const morphColor = morphColors[i2];
          const offset = width * height * 4 * i2;
          for (let j2 = 0; j2 < morphTarget.count; j2++) {
            const stride = j2 * vertexDataStride;
            if (hasMorphPosition === true) {
              morph.fromBufferAttribute(morphTarget, j2);
              buffer[offset + stride + 0] = morph.x;
              buffer[offset + stride + 1] = morph.y;
              buffer[offset + stride + 2] = morph.z;
              buffer[offset + stride + 3] = 0;
            }
            if (hasMorphNormals === true) {
              morph.fromBufferAttribute(morphNormal, j2);
              buffer[offset + stride + 4] = morph.x;
              buffer[offset + stride + 5] = morph.y;
              buffer[offset + stride + 6] = morph.z;
              buffer[offset + stride + 7] = 0;
            }
            if (hasMorphColors === true) {
              morph.fromBufferAttribute(morphColor, j2);
              buffer[offset + stride + 8] = morph.x;
              buffer[offset + stride + 9] = morph.y;
              buffer[offset + stride + 10] = morph.z;
              buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
            }
          }
        }
        entry = {
          count: morphTargetsCount,
          texture,
          size: new Vector2(width, height)
        };
        morphTextures.set(geometry, entry);
        geometry.addEventListener("dispose", disposeTexture);
      }
      if (object.isInstancedMesh === true && object.morphTexture !== null) {
        program.getUniforms().setValue(gl, "morphTexture", object.morphTexture, textures);
      } else {
        let morphInfluencesSum = 0;
        for (let i2 = 0; i2 < objectInfluences.length; i2++) {
          morphInfluencesSum += objectInfluences[i2];
        }
        const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
        program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
      }
      program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
      program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
    }
    return {
      update
    };
  }
  function WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = /* @__PURE__ */ new WeakMap();
    function update(object) {
      const frame = info.render.frame;
      const geometry = object.geometry;
      const buffergeometry = geometries.get(object, geometry);
      if (updateMap.get(buffergeometry) !== frame) {
        geometries.update(buffergeometry);
        updateMap.set(buffergeometry, frame);
      }
      if (object.isInstancedMesh) {
        if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) {
          object.addEventListener("dispose", onInstancedMeshDispose);
        }
        if (updateMap.get(object) !== frame) {
          attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
          if (object.instanceColor !== null) {
            attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
          }
          updateMap.set(object, frame);
        }
      }
      if (object.isSkinnedMesh) {
        const skeleton = object.skeleton;
        if (updateMap.get(skeleton) !== frame) {
          skeleton.update();
          updateMap.set(skeleton, frame);
        }
      }
      return buffergeometry;
    }
    function dispose() {
      updateMap = /* @__PURE__ */ new WeakMap();
    }
    function onInstancedMeshDispose(event) {
      const instancedMesh = event.target;
      instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
      attributes.remove(instancedMesh.instanceMatrix);
      if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
      update,
      dispose
    };
  }
  const emptyTexture = /* @__PURE__ */ new Texture();
  const emptyShadowTexture = /* @__PURE__ */ new DepthTexture(1, 1);
  const emptyArrayTexture = /* @__PURE__ */ new DataArrayTexture();
  const empty3dTexture = /* @__PURE__ */ new Data3DTexture();
  const emptyCubeTexture = /* @__PURE__ */ new CubeTexture();
  const arrayCacheF32 = [];
  const arrayCacheI32 = [];
  const mat4array = new Float32Array(16);
  const mat3array = new Float32Array(9);
  const mat2array = new Float32Array(4);
  function flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    const n2 = nBlocks * blockSize;
    let r2 = arrayCacheF32[n2];
    if (r2 === void 0) {
      r2 = new Float32Array(n2);
      arrayCacheF32[n2] = r2;
    }
    if (nBlocks !== 0) {
      firstElem.toArray(r2, 0);
      for (let i2 = 1, offset = 0; i2 !== nBlocks; ++i2) {
        offset += blockSize;
        array[i2].toArray(r2, offset);
      }
    }
    return r2;
  }
  function arraysEqual(a2, b2) {
    if (a2.length !== b2.length) return false;
    for (let i2 = 0, l2 = a2.length; i2 < l2; i2++) {
      if (a2[i2] !== b2[i2]) return false;
    }
    return true;
  }
  function copyArray(a2, b2) {
    for (let i2 = 0, l2 = b2.length; i2 < l2; i2++) {
      a2[i2] = b2[i2];
    }
  }
  function allocTexUnits(textures, n2) {
    let r2 = arrayCacheI32[n2];
    if (r2 === void 0) {
      r2 = new Int32Array(n2);
      arrayCacheI32[n2] = r2;
    }
    for (let i2 = 0; i2 !== n2; ++i2) {
      r2[i2] = textures.allocateTextureUnit();
    }
    return r2;
  }
  function setValueV1f(gl, v2) {
    const cache = this.cache;
    if (cache[0] === v2) return;
    gl.uniform1f(this.addr, v2);
    cache[0] = v2;
  }
  function setValueV2f(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y) {
        gl.uniform2f(this.addr, v2.x, v2.y);
        cache[0] = v2.x;
        cache[1] = v2.y;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform2fv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV3f(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z) {
        gl.uniform3f(this.addr, v2.x, v2.y, v2.z);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
      }
    } else if (v2.r !== void 0) {
      if (cache[0] !== v2.r || cache[1] !== v2.g || cache[2] !== v2.b) {
        gl.uniform3f(this.addr, v2.r, v2.g, v2.b);
        cache[0] = v2.r;
        cache[1] = v2.g;
        cache[2] = v2.b;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform3fv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV4f(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z || cache[3] !== v2.w) {
        gl.uniform4f(this.addr, v2.x, v2.y, v2.z, v2.w);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
        cache[3] = v2.w;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform4fv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueM2(gl, v2) {
    const cache = this.cache;
    const elements = v2.elements;
    if (elements === void 0) {
      if (arraysEqual(cache, v2)) return;
      gl.uniformMatrix2fv(this.addr, false, v2);
      copyArray(cache, v2);
    } else {
      if (arraysEqual(cache, elements)) return;
      mat2array.set(elements);
      gl.uniformMatrix2fv(this.addr, false, mat2array);
      copyArray(cache, elements);
    }
  }
  function setValueM3(gl, v2) {
    const cache = this.cache;
    const elements = v2.elements;
    if (elements === void 0) {
      if (arraysEqual(cache, v2)) return;
      gl.uniformMatrix3fv(this.addr, false, v2);
      copyArray(cache, v2);
    } else {
      if (arraysEqual(cache, elements)) return;
      mat3array.set(elements);
      gl.uniformMatrix3fv(this.addr, false, mat3array);
      copyArray(cache, elements);
    }
  }
  function setValueM4(gl, v2) {
    const cache = this.cache;
    const elements = v2.elements;
    if (elements === void 0) {
      if (arraysEqual(cache, v2)) return;
      gl.uniformMatrix4fv(this.addr, false, v2);
      copyArray(cache, v2);
    } else {
      if (arraysEqual(cache, elements)) return;
      mat4array.set(elements);
      gl.uniformMatrix4fv(this.addr, false, mat4array);
      copyArray(cache, elements);
    }
  }
  function setValueV1i(gl, v2) {
    const cache = this.cache;
    if (cache[0] === v2) return;
    gl.uniform1i(this.addr, v2);
    cache[0] = v2;
  }
  function setValueV2i(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y) {
        gl.uniform2i(this.addr, v2.x, v2.y);
        cache[0] = v2.x;
        cache[1] = v2.y;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform2iv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV3i(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z) {
        gl.uniform3i(this.addr, v2.x, v2.y, v2.z);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform3iv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV4i(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z || cache[3] !== v2.w) {
        gl.uniform4i(this.addr, v2.x, v2.y, v2.z, v2.w);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
        cache[3] = v2.w;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform4iv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV1ui(gl, v2) {
    const cache = this.cache;
    if (cache[0] === v2) return;
    gl.uniform1ui(this.addr, v2);
    cache[0] = v2;
  }
  function setValueV2ui(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y) {
        gl.uniform2ui(this.addr, v2.x, v2.y);
        cache[0] = v2.x;
        cache[1] = v2.y;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform2uiv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV3ui(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z) {
        gl.uniform3ui(this.addr, v2.x, v2.y, v2.z);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform3uiv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueV4ui(gl, v2) {
    const cache = this.cache;
    if (v2.x !== void 0) {
      if (cache[0] !== v2.x || cache[1] !== v2.y || cache[2] !== v2.z || cache[3] !== v2.w) {
        gl.uniform4ui(this.addr, v2.x, v2.y, v2.z, v2.w);
        cache[0] = v2.x;
        cache[1] = v2.y;
        cache[2] = v2.z;
        cache[3] = v2.w;
      }
    } else {
      if (arraysEqual(cache, v2)) return;
      gl.uniform4uiv(this.addr, v2);
      copyArray(cache, v2);
    }
  }
  function setValueT1(gl, v2, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
      gl.uniform1i(this.addr, unit);
      cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
      emptyShadowTexture.compareFunction = LessEqualCompare;
      emptyTexture2D = emptyShadowTexture;
    } else {
      emptyTexture2D = emptyTexture;
    }
    textures.setTexture2D(v2 || emptyTexture2D, unit);
  }
  function setValueT3D1(gl, v2, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
      gl.uniform1i(this.addr, unit);
      cache[0] = unit;
    }
    textures.setTexture3D(v2 || empty3dTexture, unit);
  }
  function setValueT6(gl, v2, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
      gl.uniform1i(this.addr, unit);
      cache[0] = unit;
    }
    textures.setTextureCube(v2 || emptyCubeTexture, unit);
  }
  function setValueT2DArray1(gl, v2, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
      gl.uniform1i(this.addr, unit);
      cache[0] = unit;
    }
    textures.setTexture2DArray(v2 || emptyArrayTexture, unit);
  }
  function getSingularSetter(type) {
    switch (type) {
      case 5126:
        return setValueV1f;
      // FLOAT
      case 35664:
        return setValueV2f;
      // _VEC2
      case 35665:
        return setValueV3f;
      // _VEC3
      case 35666:
        return setValueV4f;
      // _VEC4
      case 35674:
        return setValueM2;
      // _MAT2
      case 35675:
        return setValueM3;
      // _MAT3
      case 35676:
        return setValueM4;
      // _MAT4
      case 5124:
      case 35670:
        return setValueV1i;
      // INT, BOOL
      case 35667:
      case 35671:
        return setValueV2i;
      // _VEC2
      case 35668:
      case 35672:
        return setValueV3i;
      // _VEC3
      case 35669:
      case 35673:
        return setValueV4i;
      // _VEC4
      case 5125:
        return setValueV1ui;
      // UINT
      case 36294:
        return setValueV2ui;
      // _VEC2
      case 36295:
        return setValueV3ui;
      // _VEC3
      case 36296:
        return setValueV4ui;
      // _VEC4
      case 35678:
      // SAMPLER_2D
      case 36198:
      // SAMPLER_EXTERNAL_OES
      case 36298:
      // INT_SAMPLER_2D
      case 36306:
      // UNSIGNED_INT_SAMPLER_2D
      case 35682:
        return setValueT1;
      case 35679:
      // SAMPLER_3D
      case 36299:
      // INT_SAMPLER_3D
      case 36307:
        return setValueT3D1;
      case 35680:
      // SAMPLER_CUBE
      case 36300:
      // INT_SAMPLER_CUBE
      case 36308:
      // UNSIGNED_INT_SAMPLER_CUBE
      case 36293:
        return setValueT6;
      case 36289:
      // SAMPLER_2D_ARRAY
      case 36303:
      // INT_SAMPLER_2D_ARRAY
      case 36311:
      // UNSIGNED_INT_SAMPLER_2D_ARRAY
      case 36292:
        return setValueT2DArray1;
    }
  }
  function setValueV1fArray(gl, v2) {
    gl.uniform1fv(this.addr, v2);
  }
  function setValueV2fArray(gl, v2) {
    const data = flatten(v2, this.size, 2);
    gl.uniform2fv(this.addr, data);
  }
  function setValueV3fArray(gl, v2) {
    const data = flatten(v2, this.size, 3);
    gl.uniform3fv(this.addr, data);
  }
  function setValueV4fArray(gl, v2) {
    const data = flatten(v2, this.size, 4);
    gl.uniform4fv(this.addr, data);
  }
  function setValueM2Array(gl, v2) {
    const data = flatten(v2, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
  }
  function setValueM3Array(gl, v2) {
    const data = flatten(v2, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
  }
  function setValueM4Array(gl, v2) {
    const data = flatten(v2, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
  }
  function setValueV1iArray(gl, v2) {
    gl.uniform1iv(this.addr, v2);
  }
  function setValueV2iArray(gl, v2) {
    gl.uniform2iv(this.addr, v2);
  }
  function setValueV3iArray(gl, v2) {
    gl.uniform3iv(this.addr, v2);
  }
  function setValueV4iArray(gl, v2) {
    gl.uniform4iv(this.addr, v2);
  }
  function setValueV1uiArray(gl, v2) {
    gl.uniform1uiv(this.addr, v2);
  }
  function setValueV2uiArray(gl, v2) {
    gl.uniform2uiv(this.addr, v2);
  }
  function setValueV3uiArray(gl, v2) {
    gl.uniform3uiv(this.addr, v2);
  }
  function setValueV4uiArray(gl, v2) {
    gl.uniform4uiv(this.addr, v2);
  }
  function setValueT1Array(gl, v2, textures) {
    const cache = this.cache;
    const n2 = v2.length;
    const units = allocTexUnits(textures, n2);
    if (!arraysEqual(cache, units)) {
      gl.uniform1iv(this.addr, units);
      copyArray(cache, units);
    }
    for (let i2 = 0; i2 !== n2; ++i2) {
      textures.setTexture2D(v2[i2] || emptyTexture, units[i2]);
    }
  }
  function setValueT3DArray(gl, v2, textures) {
    const cache = this.cache;
    const n2 = v2.length;
    const units = allocTexUnits(textures, n2);
    if (!arraysEqual(cache, units)) {
      gl.uniform1iv(this.addr, units);
      copyArray(cache, units);
    }
    for (let i2 = 0; i2 !== n2; ++i2) {
      textures.setTexture3D(v2[i2] || empty3dTexture, units[i2]);
    }
  }
  function setValueT6Array(gl, v2, textures) {
    const cache = this.cache;
    const n2 = v2.length;
    const units = allocTexUnits(textures, n2);
    if (!arraysEqual(cache, units)) {
      gl.uniform1iv(this.addr, units);
      copyArray(cache, units);
    }
    for (let i2 = 0; i2 !== n2; ++i2) {
      textures.setTextureCube(v2[i2] || emptyCubeTexture, units[i2]);
    }
  }
  function setValueT2DArrayArray(gl, v2, textures) {
    const cache = this.cache;
    const n2 = v2.length;
    const units = allocTexUnits(textures, n2);
    if (!arraysEqual(cache, units)) {
      gl.uniform1iv(this.addr, units);
      copyArray(cache, units);
    }
    for (let i2 = 0; i2 !== n2; ++i2) {
      textures.setTexture2DArray(v2[i2] || emptyArrayTexture, units[i2]);
    }
  }
  function getPureArraySetter(type) {
    switch (type) {
      case 5126:
        return setValueV1fArray;
      // FLOAT
      case 35664:
        return setValueV2fArray;
      // _VEC2
      case 35665:
        return setValueV3fArray;
      // _VEC3
      case 35666:
        return setValueV4fArray;
      // _VEC4
      case 35674:
        return setValueM2Array;
      // _MAT2
      case 35675:
        return setValueM3Array;
      // _MAT3
      case 35676:
        return setValueM4Array;
      // _MAT4
      case 5124:
      case 35670:
        return setValueV1iArray;
      // INT, BOOL
      case 35667:
      case 35671:
        return setValueV2iArray;
      // _VEC2
      case 35668:
      case 35672:
        return setValueV3iArray;
      // _VEC3
      case 35669:
      case 35673:
        return setValueV4iArray;
      // _VEC4
      case 5125:
        return setValueV1uiArray;
      // UINT
      case 36294:
        return setValueV2uiArray;
      // _VEC2
      case 36295:
        return setValueV3uiArray;
      // _VEC3
      case 36296:
        return setValueV4uiArray;
      // _VEC4
      case 35678:
      // SAMPLER_2D
      case 36198:
      // SAMPLER_EXTERNAL_OES
      case 36298:
      // INT_SAMPLER_2D
      case 36306:
      // UNSIGNED_INT_SAMPLER_2D
      case 35682:
        return setValueT1Array;
      case 35679:
      // SAMPLER_3D
      case 36299:
      // INT_SAMPLER_3D
      case 36307:
        return setValueT3DArray;
      case 35680:
      // SAMPLER_CUBE
      case 36300:
      // INT_SAMPLER_CUBE
      case 36308:
      // UNSIGNED_INT_SAMPLER_CUBE
      case 36293:
        return setValueT6Array;
      case 36289:
      // SAMPLER_2D_ARRAY
      case 36303:
      // INT_SAMPLER_2D_ARRAY
      case 36311:
      // UNSIGNED_INT_SAMPLER_2D_ARRAY
      case 36292:
        return setValueT2DArrayArray;
    }
  }
  class SingleUniform {
    constructor(id, activeInfo, addr) {
      this.id = id;
      this.addr = addr;
      this.cache = [];
      this.type = activeInfo.type;
      this.setValue = getSingularSetter(activeInfo.type);
    }
  }
  class PureArrayUniform {
    constructor(id, activeInfo, addr) {
      this.id = id;
      this.addr = addr;
      this.cache = [];
      this.type = activeInfo.type;
      this.size = activeInfo.size;
      this.setValue = getPureArraySetter(activeInfo.type);
    }
  }
  class StructuredUniform {
    constructor(id) {
      this.id = id;
      this.seq = [];
      this.map = {};
    }
    setValue(gl, value, textures) {
      const seq = this.seq;
      for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
        const u2 = seq[i2];
        u2.setValue(gl, value[u2.id], textures);
      }
    }
  }
  const RePathPart = /(\w+)(\])?(\[|\.)?/g;
  function addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
  }
  function parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    RePathPart.lastIndex = 0;
    while (true) {
      const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
      let id = match[1];
      const idIsIndex = match[2] === "]", subscript = match[3];
      if (idIsIndex) id = id | 0;
      if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
        addUniform(container, subscript === void 0 ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
        break;
      } else {
        const map = container.map;
        let next = map[id];
        if (next === void 0) {
          next = new StructuredUniform(id);
          addUniform(container, next);
        }
        container = next;
      }
    }
  }
  class WebGLUniforms {
    constructor(gl, program) {
      this.seq = [];
      this.map = {};
      const n2 = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
      for (let i2 = 0; i2 < n2; ++i2) {
        const info = gl.getActiveUniform(program, i2), addr = gl.getUniformLocation(program, info.name);
        parseUniform(info, addr, this);
      }
    }
    setValue(gl, name, value, textures) {
      const u2 = this.map[name];
      if (u2 !== void 0) u2.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
      const v2 = object[name];
      if (v2 !== void 0) this.setValue(gl, name, v2);
    }
    static upload(gl, seq, values, textures) {
      for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
        const u2 = seq[i2], v2 = values[u2.id];
        if (v2.needsUpdate !== false) {
          u2.setValue(gl, v2.value, textures);
        }
      }
    }
    static seqWithValue(seq, values) {
      const r2 = [];
      for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
        const u2 = seq[i2];
        if (u2.id in values) r2.push(u2);
      }
      return r2;
    }
  }
  function WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
  }
  const COMPLETION_STATUS_KHR = 37297;
  let programIdCount = 0;
  function handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to2 = Math.min(errorLine + 6, lines.length);
    for (let i2 = from; i2 < to2; i2++) {
      const line = i2 + 1;
      lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i2]}`);
    }
    return lines2.join("\n");
  }
  const _m0 = /* @__PURE__ */ new Matrix3();
  function getEncodingComponents(colorSpace) {
    ColorManagement._getMatrix(_m0, ColorManagement.workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${_m0.elements.map((v2) => v2.toFixed(4))} )`;
    switch (ColorManagement.getTransfer(colorSpace)) {
      case LinearTransfer:
        return [encodingMatrix, "LinearTransferOETF"];
      case SRGBTransfer:
        return [encodingMatrix, "sRGBTransferOETF"];
      default:
        console.warn("THREE.WebGLProgram: Unsupported color space: ", colorSpace);
        return [encodingMatrix, "LinearTransferOETF"];
    }
  }
  function getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
      const errorLine = parseInt(errorMatches[1]);
      return type.toUpperCase() + "\n\n" + errors + "\n\n" + handleSource(gl.getShaderSource(shader), errorLine);
    } else {
      return errors;
    }
  }
  function getTexelEncodingFunction(functionName, colorSpace) {
    const components = getEncodingComponents(colorSpace);
    return [
      `vec4 ${functionName}( vec4 value ) {`,
      `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
      "}"
    ].join("\n");
  }
  function getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch (toneMapping) {
      case LinearToneMapping:
        toneMappingName = "Linear";
        break;
      case ReinhardToneMapping:
        toneMappingName = "Reinhard";
        break;
      case CineonToneMapping:
        toneMappingName = "Cineon";
        break;
      case ACESFilmicToneMapping:
        toneMappingName = "ACESFilmic";
        break;
      case AgXToneMapping:
        toneMappingName = "AgX";
        break;
      case NeutralToneMapping:
        toneMappingName = "Neutral";
        break;
      case CustomToneMapping:
        toneMappingName = "Custom";
        break;
      default:
        console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
        toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
  }
  const _v0 = /* @__PURE__ */ new Vector3();
  function getLuminanceFunction() {
    ColorManagement.getLuminanceCoefficients(_v0);
    const r2 = _v0.x.toFixed(4);
    const g2 = _v0.y.toFixed(4);
    const b2 = _v0.z.toFixed(4);
    return [
      "float luminance( const in vec3 rgb ) {",
      `	const vec3 weights = vec3( ${r2}, ${g2}, ${b2} );`,
      "	return dot( weights, rgb );",
      "}"
    ].join("\n");
  }
  function generateVertexExtensions(parameters) {
    const chunks = [
      parameters.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
      parameters.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
    ];
    return chunks.filter(filterEmptyLine).join("\n");
  }
  function generateDefines(defines) {
    const chunks = [];
    for (const name in defines) {
      const value = defines[name];
      if (value === false) continue;
      chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
  }
  function fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n2 = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for (let i2 = 0; i2 < n2; i2++) {
      const info = gl.getActiveAttrib(program, i2);
      const name = info.name;
      let locationSize = 1;
      if (info.type === gl.FLOAT_MAT2) locationSize = 2;
      if (info.type === gl.FLOAT_MAT3) locationSize = 3;
      if (info.type === gl.FLOAT_MAT4) locationSize = 4;
      attributes[name] = {
        type: info.type,
        location: gl.getAttribLocation(program, name),
        locationSize
      };
    }
    return attributes;
  }
  function filterEmptyLine(string) {
    return string !== "";
  }
  function replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
  }
  function replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
  }
  const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
  function resolveIncludes(string) {
    return string.replace(includePattern, includeReplacer);
  }
  const shaderChunkMap = /* @__PURE__ */ new Map();
  function includeReplacer(match, include) {
    let string = ShaderChunk[include];
    if (string === void 0) {
      const newInclude = shaderChunkMap.get(include);
      if (newInclude !== void 0) {
        string = ShaderChunk[newInclude];
        console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
      } else {
        throw new Error("Can not resolve #include <" + include + ">");
      }
    }
    return resolveIncludes(string);
  }
  const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
  function unrollLoops(string) {
    return string.replace(unrollLoopPattern, loopReplacer);
  }
  function loopReplacer(match, start, end, snippet) {
    let string = "";
    for (let i2 = parseInt(start); i2 < parseInt(end); i2++) {
      string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i2 + " ]").replace(/UNROLLED_LOOP_INDEX/g, i2);
    }
    return string;
  }
  function generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === "highp") {
      precisionstring += "\n#define HIGH_PRECISION";
    } else if (parameters.precision === "mediump") {
      precisionstring += "\n#define MEDIUM_PRECISION";
    } else if (parameters.precision === "lowp") {
      precisionstring += "\n#define LOW_PRECISION";
    }
    return precisionstring;
  }
  function generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === PCFShadowMap) {
      shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    } else if (parameters.shadowMapType === PCFSoftShadowMap) {
      shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    } else if (parameters.shadowMapType === VSMShadowMap) {
      shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    }
    return shadowMapTypeDefine;
  }
  function generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) {
      switch (parameters.envMapMode) {
        case CubeReflectionMapping:
        case CubeRefractionMapping:
          envMapTypeDefine = "ENVMAP_TYPE_CUBE";
          break;
        case CubeUVReflectionMapping:
          envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
          break;
      }
    }
    return envMapTypeDefine;
  }
  function generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) {
      switch (parameters.envMapMode) {
        case CubeRefractionMapping:
          envMapModeDefine = "ENVMAP_MODE_REFRACTION";
          break;
      }
    }
    return envMapModeDefine;
  }
  function generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) {
      switch (parameters.combine) {
        case MultiplyOperation:
          envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
          break;
        case MixOperation:
          envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
          break;
        case AddOperation:
          envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
          break;
      }
    }
    return envMapBlendingDefine;
  }
  function generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1 / imageHeight;
    const texelWidth = 1 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
    return { texelWidth, texelHeight, maxMip };
  }
  function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = generateCubeUVSize(parameters);
    const customVertexExtensions = generateVertexExtensions(parameters);
    const customDefines = generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
      prefixVertex = [
        "#define SHADER_TYPE " + parameters.shaderType,
        "#define SHADER_NAME " + parameters.shaderName,
        customDefines
      ].filter(filterEmptyLine).join("\n");
      if (prefixVertex.length > 0) {
        prefixVertex += "\n";
      }
      prefixFragment = [
        "#define SHADER_TYPE " + parameters.shaderType,
        "#define SHADER_NAME " + parameters.shaderName,
        customDefines
      ].filter(filterEmptyLine).join("\n");
      if (prefixFragment.length > 0) {
        prefixFragment += "\n";
      }
    } else {
      prefixVertex = [
        generatePrecision(parameters),
        "#define SHADER_TYPE " + parameters.shaderType,
        "#define SHADER_NAME " + parameters.shaderName,
        customDefines,
        parameters.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        parameters.batching ? "#define USE_BATCHING" : "",
        parameters.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        parameters.instancing ? "#define USE_INSTANCING" : "",
        parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        parameters.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
        parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
        parameters.map ? "#define USE_MAP" : "",
        parameters.envMap ? "#define USE_ENVMAP" : "",
        parameters.envMap ? "#define " + envMapModeDefine : "",
        parameters.lightMap ? "#define USE_LIGHTMAP" : "",
        parameters.aoMap ? "#define USE_AOMAP" : "",
        parameters.bumpMap ? "#define USE_BUMPMAP" : "",
        parameters.normalMap ? "#define USE_NORMALMAP" : "",
        parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
        parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        parameters.specularMap ? "#define USE_SPECULARMAP" : "",
        parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
        parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
        parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
        parameters.transmission ? "#define USE_TRANSMISSION" : "",
        parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        //
        parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
        parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
        parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
        parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
        parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
        parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
        parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
        parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
        parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
        parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
        parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
        parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
        parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
        parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
        parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
        parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
        parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
        parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
        parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
        parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
        parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
        parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
        parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
        //
        parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
        parameters.vertexColors ? "#define USE_COLOR" : "",
        parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        parameters.vertexUv1s ? "#define USE_UV1" : "",
        parameters.vertexUv2s ? "#define USE_UV2" : "",
        parameters.vertexUv3s ? "#define USE_UV3" : "",
        parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
        parameters.flatShading ? "#define FLAT_SHADED" : "",
        parameters.skinning ? "#define USE_SKINNING" : "",
        parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
        parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
        parameters.morphColors ? "#define USE_MORPHCOLORS" : "",
        parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
        parameters.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
        parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
        parameters.flipSided ? "#define FLIP_SIDED" : "",
        parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
        parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "	uniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "	attribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "	attribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "	attribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        "\n"
      ].filter(filterEmptyLine).join("\n");
      prefixFragment = [
        generatePrecision(parameters),
        "#define SHADER_TYPE " + parameters.shaderType,
        "#define SHADER_NAME " + parameters.shaderName,
        customDefines,
        parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
        parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
        parameters.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        parameters.map ? "#define USE_MAP" : "",
        parameters.matcap ? "#define USE_MATCAP" : "",
        parameters.envMap ? "#define USE_ENVMAP" : "",
        parameters.envMap ? "#define " + envMapTypeDefine : "",
        parameters.envMap ? "#define " + envMapModeDefine : "",
        parameters.envMap ? "#define " + envMapBlendingDefine : "",
        envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
        envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
        envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
        parameters.lightMap ? "#define USE_LIGHTMAP" : "",
        parameters.aoMap ? "#define USE_AOMAP" : "",
        parameters.bumpMap ? "#define USE_BUMPMAP" : "",
        parameters.normalMap ? "#define USE_NORMALMAP" : "",
        parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
        parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
        parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        parameters.dispersion ? "#define USE_DISPERSION" : "",
        parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
        parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        parameters.specularMap ? "#define USE_SPECULARMAP" : "",
        parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
        parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
        parameters.alphaTest ? "#define USE_ALPHATEST" : "",
        parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
        parameters.sheen ? "#define USE_SHEEN" : "",
        parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        parameters.transmission ? "#define USE_TRANSMISSION" : "",
        parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
        parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? "#define USE_COLOR" : "",
        parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        parameters.vertexUv1s ? "#define USE_UV1" : "",
        parameters.vertexUv2s ? "#define USE_UV2" : "",
        parameters.vertexUv3s ? "#define USE_UV3" : "",
        parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
        parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
        parameters.flatShading ? "#define FLAT_SHADED" : "",
        parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
        parameters.flipSided ? "#define FLIP_SIDED" : "",
        parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
        parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        parameters.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        parameters.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        parameters.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
        parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
        // this code is required here because it is used by the toneMapping() function defined below
        parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
        parameters.dithering ? "#define DITHERING" : "",
        parameters.opaque ? "#define OPAQUE" : "",
        ShaderChunk["colorspace_pars_fragment"],
        // this code is required here because it is used by the various encoding/decoding function defined below
        getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
        getLuminanceFunction(),
        parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
        "\n"
      ].filter(filterEmptyLine).join("\n");
    }
    vertexShader = resolveIncludes(vertexShader);
    vertexShader = replaceLightNums(vertexShader, parameters);
    vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = resolveIncludes(fragmentShader);
    fragmentShader = replaceLightNums(fragmentShader, parameters);
    fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = unrollLoops(vertexShader);
    fragmentShader = unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
      versionString = "#version 300 es\n";
      prefixVertex = [
        customVertexExtensions,
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
      ].join("\n") + "\n" + prefixVertex;
      prefixFragment = [
        "#define varying in",
        parameters.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
      ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    const glVertexShader = WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    if (parameters.index0AttributeName !== void 0) {
      gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    } else if (parameters.morphTargets === true) {
      gl.bindAttribLocation(program, 0, "position");
    }
    gl.linkProgram(program);
    function onFirstUse(self2) {
      if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
          runnable = false;
          if (typeof renderer.debug.onShaderError === "function") {
            renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
          } else {
            const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
            const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
            console.error(
              "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\nMaterial Name: " + self2.name + "\nMaterial Type: " + self2.type + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
            );
          }
        } else if (programLog !== "") {
          console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        } else if (vertexLog === "" || fragmentLog === "") {
          haveDiagnostics = false;
        }
        if (haveDiagnostics) {
          self2.diagnostics = {
            runnable,
            programLog,
            vertexShader: {
              log: vertexLog,
              prefix: prefixVertex
            },
            fragmentShader: {
              log: fragmentLog,
              prefix: prefixFragment
            }
          };
        }
      }
      gl.deleteShader(glVertexShader);
      gl.deleteShader(glFragmentShader);
      cachedUniforms = new WebGLUniforms(gl, program);
      cachedAttributes = fetchAttributeLocations(gl, program);
    }
    let cachedUniforms;
    this.getUniforms = function() {
      if (cachedUniforms === void 0) {
        onFirstUse(this);
      }
      return cachedUniforms;
    };
    let cachedAttributes;
    this.getAttributes = function() {
      if (cachedAttributes === void 0) {
        onFirstUse(this);
      }
      return cachedAttributes;
    };
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
      if (programReady === false) {
        programReady = gl.getProgramParameter(program, COMPLETION_STATUS_KHR);
      }
      return programReady;
    };
    this.destroy = function() {
      bindingStates.releaseStatesOfProgram(this);
      gl.deleteProgram(program);
      this.program = void 0;
    };
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
  }
  let _id = 0;
  class WebGLShaderCache {
    constructor() {
      this.shaderCache = /* @__PURE__ */ new Map();
      this.materialCache = /* @__PURE__ */ new Map();
    }
    update(material) {
      const vertexShader = material.vertexShader;
      const fragmentShader = material.fragmentShader;
      const vertexShaderStage = this._getShaderStage(vertexShader);
      const fragmentShaderStage = this._getShaderStage(fragmentShader);
      const materialShaders = this._getShaderCacheForMaterial(material);
      if (materialShaders.has(vertexShaderStage) === false) {
        materialShaders.add(vertexShaderStage);
        vertexShaderStage.usedTimes++;
      }
      if (materialShaders.has(fragmentShaderStage) === false) {
        materialShaders.add(fragmentShaderStage);
        fragmentShaderStage.usedTimes++;
      }
      return this;
    }
    remove(material) {
      const materialShaders = this.materialCache.get(material);
      for (const shaderStage of materialShaders) {
        shaderStage.usedTimes--;
        if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
      }
      this.materialCache.delete(material);
      return this;
    }
    getVertexShaderID(material) {
      return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
      return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
      this.shaderCache.clear();
      this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
      const cache = this.materialCache;
      let set = cache.get(material);
      if (set === void 0) {
        set = /* @__PURE__ */ new Set();
        cache.set(material, set);
      }
      return set;
    }
    _getShaderStage(code) {
      const cache = this.shaderCache;
      let stage = cache.get(code);
      if (stage === void 0) {
        stage = new WebGLShaderStage(code);
        cache.set(code, stage);
      }
      return stage;
    }
  }
  class WebGLShaderStage {
    constructor(code) {
      this.id = _id++;
      this.code = code;
      this.usedTimes = 0;
    }
  }
  function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new Layers();
    const _customShaders = new WebGLShaderCache();
    const _activeChannels = /* @__PURE__ */ new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
      MeshDepthMaterial: "depth",
      MeshDistanceMaterial: "distanceRGBA",
      MeshNormalMaterial: "normal",
      MeshBasicMaterial: "basic",
      MeshLambertMaterial: "lambert",
      MeshPhongMaterial: "phong",
      MeshToonMaterial: "toon",
      MeshStandardMaterial: "physical",
      MeshPhysicalMaterial: "physical",
      MeshMatcapMaterial: "matcap",
      LineBasicMaterial: "basic",
      LineDashedMaterial: "dashed",
      PointsMaterial: "points",
      ShadowMaterial: "shadow",
      SpriteMaterial: "sprite"
    };
    function getChannel(value) {
      _activeChannels.add(value);
      if (value === 0) return "uv";
      return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
      const fog = scene.fog;
      const geometry = object.geometry;
      const environment = material.isMeshStandardMaterial ? scene.environment : null;
      const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
      const envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;
      const shaderID = shaderIDs[material.type];
      if (material.precision !== null) {
        precision = capabilities.getMaxPrecision(material.precision);
        if (precision !== material.precision) {
          console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
      }
      const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
      const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
      let morphTextureStride = 0;
      if (geometry.morphAttributes.position !== void 0) morphTextureStride = 1;
      if (geometry.morphAttributes.normal !== void 0) morphTextureStride = 2;
      if (geometry.morphAttributes.color !== void 0) morphTextureStride = 3;
      let vertexShader, fragmentShader;
      let customVertexShaderID, customFragmentShaderID;
      if (shaderID) {
        const shader = ShaderLib[shaderID];
        vertexShader = shader.vertexShader;
        fragmentShader = shader.fragmentShader;
      } else {
        vertexShader = material.vertexShader;
        fragmentShader = material.fragmentShader;
        _customShaders.update(material);
        customVertexShaderID = _customShaders.getVertexShaderID(material);
        customFragmentShaderID = _customShaders.getFragmentShaderID(material);
      }
      const currentRenderTarget = renderer.getRenderTarget();
      const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
      const IS_INSTANCEDMESH = object.isInstancedMesh === true;
      const IS_BATCHEDMESH = object.isBatchedMesh === true;
      const HAS_MAP = !!material.map;
      const HAS_MATCAP = !!material.matcap;
      const HAS_ENVMAP = !!envMap;
      const HAS_AOMAP = !!material.aoMap;
      const HAS_LIGHTMAP = !!material.lightMap;
      const HAS_BUMPMAP = !!material.bumpMap;
      const HAS_NORMALMAP = !!material.normalMap;
      const HAS_DISPLACEMENTMAP = !!material.displacementMap;
      const HAS_EMISSIVEMAP = !!material.emissiveMap;
      const HAS_METALNESSMAP = !!material.metalnessMap;
      const HAS_ROUGHNESSMAP = !!material.roughnessMap;
      const HAS_ANISOTROPY = material.anisotropy > 0;
      const HAS_CLEARCOAT = material.clearcoat > 0;
      const HAS_DISPERSION = material.dispersion > 0;
      const HAS_IRIDESCENCE = material.iridescence > 0;
      const HAS_SHEEN = material.sheen > 0;
      const HAS_TRANSMISSION = material.transmission > 0;
      const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
      const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
      const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
      const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
      const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
      const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
      const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
      const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
      const HAS_SPECULARMAP = !!material.specularMap;
      const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
      const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
      const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
      const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
      const HAS_GRADIENTMAP = !!material.gradientMap;
      const HAS_ALPHAMAP = !!material.alphaMap;
      const HAS_ALPHATEST = material.alphaTest > 0;
      const HAS_ALPHAHASH = !!material.alphaHash;
      const HAS_EXTENSIONS = !!material.extensions;
      let toneMapping = NoToneMapping;
      if (material.toneMapped) {
        if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) {
          toneMapping = renderer.toneMapping;
        }
      }
      const parameters = {
        shaderID,
        shaderType: material.type,
        shaderName: material.name,
        vertexShader,
        fragmentShader,
        defines: material.defines,
        customVertexShaderID,
        customFragmentShaderID,
        isRawShaderMaterial: material.isRawShaderMaterial === true,
        glslVersion: material.glslVersion,
        precision,
        batching: IS_BATCHEDMESH,
        batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
        instancing: IS_INSTANCEDMESH,
        instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
        instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
        supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
        outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace,
        alphaToCoverage: !!material.alphaToCoverage,
        map: HAS_MAP,
        matcap: HAS_MATCAP,
        envMap: HAS_ENVMAP,
        envMapMode: HAS_ENVMAP && envMap.mapping,
        envMapCubeUVHeight,
        aoMap: HAS_AOMAP,
        lightMap: HAS_LIGHTMAP,
        bumpMap: HAS_BUMPMAP,
        normalMap: HAS_NORMALMAP,
        displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
        emissiveMap: HAS_EMISSIVEMAP,
        normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
        normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,
        metalnessMap: HAS_METALNESSMAP,
        roughnessMap: HAS_ROUGHNESSMAP,
        anisotropy: HAS_ANISOTROPY,
        anisotropyMap: HAS_ANISOTROPYMAP,
        clearcoat: HAS_CLEARCOAT,
        clearcoatMap: HAS_CLEARCOATMAP,
        clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
        clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
        dispersion: HAS_DISPERSION,
        iridescence: HAS_IRIDESCENCE,
        iridescenceMap: HAS_IRIDESCENCEMAP,
        iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
        sheen: HAS_SHEEN,
        sheenColorMap: HAS_SHEEN_COLORMAP,
        sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
        specularMap: HAS_SPECULARMAP,
        specularColorMap: HAS_SPECULAR_COLORMAP,
        specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
        transmission: HAS_TRANSMISSION,
        transmissionMap: HAS_TRANSMISSIONMAP,
        thicknessMap: HAS_THICKNESSMAP,
        gradientMap: HAS_GRADIENTMAP,
        opaque: material.transparent === false && material.blending === NormalBlending && material.alphaToCoverage === false,
        alphaMap: HAS_ALPHAMAP,
        alphaTest: HAS_ALPHATEST,
        alphaHash: HAS_ALPHAHASH,
        combine: material.combine,
        //
        mapUv: HAS_MAP && getChannel(material.map.channel),
        aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
        lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
        bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
        normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
        displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
        emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
        metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
        roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
        anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
        clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
        clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
        clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
        iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
        iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
        sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
        sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
        specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
        specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
        specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
        transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
        thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
        alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
        //
        vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
        vertexColors: material.vertexColors,
        vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
        pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
        fog: !!fog,
        useFog: material.fog === true,
        fogExp2: !!fog && fog.isFogExp2,
        flatShading: material.flatShading === true && material.wireframe === false,
        sizeAttenuation: material.sizeAttenuation === true,
        logarithmicDepthBuffer,
        reverseDepthBuffer,
        skinning: object.isSkinnedMesh === true,
        morphTargets: geometry.morphAttributes.position !== void 0,
        morphNormals: geometry.morphAttributes.normal !== void 0,
        morphColors: geometry.morphAttributes.color !== void 0,
        morphTargetsCount,
        morphTextureStride,
        numDirLights: lights.directional.length,
        numPointLights: lights.point.length,
        numSpotLights: lights.spot.length,
        numSpotLightMaps: lights.spotLightMap.length,
        numRectAreaLights: lights.rectArea.length,
        numHemiLights: lights.hemi.length,
        numDirLightShadows: lights.directionalShadowMap.length,
        numPointLightShadows: lights.pointShadowMap.length,
        numSpotLightShadows: lights.spotShadowMap.length,
        numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
        numLightProbes: lights.numLightProbes,
        numClippingPlanes: clipping.numPlanes,
        numClipIntersection: clipping.numIntersection,
        dithering: material.dithering,
        shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
        shadowMapType: renderer.shadowMap.type,
        toneMapping,
        decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && ColorManagement.getTransfer(material.map.colorSpace) === SRGBTransfer,
        decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && ColorManagement.getTransfer(material.emissiveMap.colorSpace) === SRGBTransfer,
        premultipliedAlpha: material.premultipliedAlpha,
        doubleSided: material.side === DoubleSide,
        flipSided: material.side === BackSide,
        useDepthPacking: material.depthPacking >= 0,
        depthPacking: material.depthPacking || 0,
        index0AttributeName: material.index0AttributeName,
        extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has("WEBGL_clip_cull_distance"),
        extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has("WEBGL_multi_draw"),
        rendererExtensionParallelShaderCompile: extensions.has("KHR_parallel_shader_compile"),
        customProgramCacheKey: material.customProgramCacheKey()
      };
      parameters.vertexUv1s = _activeChannels.has(1);
      parameters.vertexUv2s = _activeChannels.has(2);
      parameters.vertexUv3s = _activeChannels.has(3);
      _activeChannels.clear();
      return parameters;
    }
    function getProgramCacheKey(parameters) {
      const array = [];
      if (parameters.shaderID) {
        array.push(parameters.shaderID);
      } else {
        array.push(parameters.customVertexShaderID);
        array.push(parameters.customFragmentShaderID);
      }
      if (parameters.defines !== void 0) {
        for (const name in parameters.defines) {
          array.push(name);
          array.push(parameters.defines[name]);
        }
      }
      if (parameters.isRawShaderMaterial === false) {
        getProgramCacheKeyParameters(array, parameters);
        getProgramCacheKeyBooleans(array, parameters);
        array.push(renderer.outputColorSpace);
      }
      array.push(parameters.customProgramCacheKey);
      return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
      array.push(parameters.precision);
      array.push(parameters.outputColorSpace);
      array.push(parameters.envMapMode);
      array.push(parameters.envMapCubeUVHeight);
      array.push(parameters.mapUv);
      array.push(parameters.alphaMapUv);
      array.push(parameters.lightMapUv);
      array.push(parameters.aoMapUv);
      array.push(parameters.bumpMapUv);
      array.push(parameters.normalMapUv);
      array.push(parameters.displacementMapUv);
      array.push(parameters.emissiveMapUv);
      array.push(parameters.metalnessMapUv);
      array.push(parameters.roughnessMapUv);
      array.push(parameters.anisotropyMapUv);
      array.push(parameters.clearcoatMapUv);
      array.push(parameters.clearcoatNormalMapUv);
      array.push(parameters.clearcoatRoughnessMapUv);
      array.push(parameters.iridescenceMapUv);
      array.push(parameters.iridescenceThicknessMapUv);
      array.push(parameters.sheenColorMapUv);
      array.push(parameters.sheenRoughnessMapUv);
      array.push(parameters.specularMapUv);
      array.push(parameters.specularColorMapUv);
      array.push(parameters.specularIntensityMapUv);
      array.push(parameters.transmissionMapUv);
      array.push(parameters.thicknessMapUv);
      array.push(parameters.combine);
      array.push(parameters.fogExp2);
      array.push(parameters.sizeAttenuation);
      array.push(parameters.morphTargetsCount);
      array.push(parameters.morphAttributeCount);
      array.push(parameters.numDirLights);
      array.push(parameters.numPointLights);
      array.push(parameters.numSpotLights);
      array.push(parameters.numSpotLightMaps);
      array.push(parameters.numHemiLights);
      array.push(parameters.numRectAreaLights);
      array.push(parameters.numDirLightShadows);
      array.push(parameters.numPointLightShadows);
      array.push(parameters.numSpotLightShadows);
      array.push(parameters.numSpotLightShadowsWithMaps);
      array.push(parameters.numLightProbes);
      array.push(parameters.shadowMapType);
      array.push(parameters.toneMapping);
      array.push(parameters.numClippingPlanes);
      array.push(parameters.numClipIntersection);
      array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
      _programLayers.disableAll();
      if (parameters.supportsVertexTextures)
        _programLayers.enable(0);
      if (parameters.instancing)
        _programLayers.enable(1);
      if (parameters.instancingColor)
        _programLayers.enable(2);
      if (parameters.instancingMorph)
        _programLayers.enable(3);
      if (parameters.matcap)
        _programLayers.enable(4);
      if (parameters.envMap)
        _programLayers.enable(5);
      if (parameters.normalMapObjectSpace)
        _programLayers.enable(6);
      if (parameters.normalMapTangentSpace)
        _programLayers.enable(7);
      if (parameters.clearcoat)
        _programLayers.enable(8);
      if (parameters.iridescence)
        _programLayers.enable(9);
      if (parameters.alphaTest)
        _programLayers.enable(10);
      if (parameters.vertexColors)
        _programLayers.enable(11);
      if (parameters.vertexAlphas)
        _programLayers.enable(12);
      if (parameters.vertexUv1s)
        _programLayers.enable(13);
      if (parameters.vertexUv2s)
        _programLayers.enable(14);
      if (parameters.vertexUv3s)
        _programLayers.enable(15);
      if (parameters.vertexTangents)
        _programLayers.enable(16);
      if (parameters.anisotropy)
        _programLayers.enable(17);
      if (parameters.alphaHash)
        _programLayers.enable(18);
      if (parameters.batching)
        _programLayers.enable(19);
      if (parameters.dispersion)
        _programLayers.enable(20);
      if (parameters.batchingColor)
        _programLayers.enable(21);
      if (parameters.gradientMap)
        _programLayers.enable(22);
      array.push(_programLayers.mask);
      _programLayers.disableAll();
      if (parameters.fog)
        _programLayers.enable(0);
      if (parameters.useFog)
        _programLayers.enable(1);
      if (parameters.flatShading)
        _programLayers.enable(2);
      if (parameters.logarithmicDepthBuffer)
        _programLayers.enable(3);
      if (parameters.reverseDepthBuffer)
        _programLayers.enable(4);
      if (parameters.skinning)
        _programLayers.enable(5);
      if (parameters.morphTargets)
        _programLayers.enable(6);
      if (parameters.morphNormals)
        _programLayers.enable(7);
      if (parameters.morphColors)
        _programLayers.enable(8);
      if (parameters.premultipliedAlpha)
        _programLayers.enable(9);
      if (parameters.shadowMapEnabled)
        _programLayers.enable(10);
      if (parameters.doubleSided)
        _programLayers.enable(11);
      if (parameters.flipSided)
        _programLayers.enable(12);
      if (parameters.useDepthPacking)
        _programLayers.enable(13);
      if (parameters.dithering)
        _programLayers.enable(14);
      if (parameters.transmission)
        _programLayers.enable(15);
      if (parameters.sheen)
        _programLayers.enable(16);
      if (parameters.opaque)
        _programLayers.enable(17);
      if (parameters.pointsUvs)
        _programLayers.enable(18);
      if (parameters.decodeVideoTexture)
        _programLayers.enable(19);
      if (parameters.decodeVideoTextureEmissive)
        _programLayers.enable(20);
      if (parameters.alphaToCoverage)
        _programLayers.enable(21);
      array.push(_programLayers.mask);
    }
    function getUniforms(material) {
      const shaderID = shaderIDs[material.type];
      let uniforms;
      if (shaderID) {
        const shader = ShaderLib[shaderID];
        uniforms = UniformsUtils.clone(shader.uniforms);
      } else {
        uniforms = material.uniforms;
      }
      return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
      let program;
      for (let p2 = 0, pl = programs.length; p2 < pl; p2++) {
        const preexistingProgram = programs[p2];
        if (preexistingProgram.cacheKey === cacheKey) {
          program = preexistingProgram;
          ++program.usedTimes;
          break;
        }
      }
      if (program === void 0) {
        program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
        programs.push(program);
      }
      return program;
    }
    function releaseProgram(program) {
      if (--program.usedTimes === 0) {
        const i2 = programs.indexOf(program);
        programs[i2] = programs[programs.length - 1];
        programs.pop();
        program.destroy();
      }
    }
    function releaseShaderCache(material) {
      _customShaders.remove(material);
    }
    function dispose() {
      _customShaders.dispose();
    }
    return {
      getParameters,
      getProgramCacheKey,
      getUniforms,
      acquireProgram,
      releaseProgram,
      releaseShaderCache,
      // Exposed for resource monitoring & error feedback via renderer.info:
      programs,
      dispose
    };
  }
  function WebGLProperties() {
    let properties = /* @__PURE__ */ new WeakMap();
    function has(object) {
      return properties.has(object);
    }
    function get(object) {
      let map = properties.get(object);
      if (map === void 0) {
        map = {};
        properties.set(object, map);
      }
      return map;
    }
    function remove(object) {
      properties.delete(object);
    }
    function update(object, key, value) {
      properties.get(object)[key] = value;
    }
    function dispose() {
      properties = /* @__PURE__ */ new WeakMap();
    }
    return {
      has,
      get,
      remove,
      update,
      dispose
    };
  }
  function painterSortStable(a2, b2) {
    if (a2.groupOrder !== b2.groupOrder) {
      return a2.groupOrder - b2.groupOrder;
    } else if (a2.renderOrder !== b2.renderOrder) {
      return a2.renderOrder - b2.renderOrder;
    } else if (a2.material.id !== b2.material.id) {
      return a2.material.id - b2.material.id;
    } else if (a2.z !== b2.z) {
      return a2.z - b2.z;
    } else {
      return a2.id - b2.id;
    }
  }
  function reversePainterSortStable(a2, b2) {
    if (a2.groupOrder !== b2.groupOrder) {
      return a2.groupOrder - b2.groupOrder;
    } else if (a2.renderOrder !== b2.renderOrder) {
      return a2.renderOrder - b2.renderOrder;
    } else if (a2.z !== b2.z) {
      return b2.z - a2.z;
    } else {
      return a2.id - b2.id;
    }
  }
  function WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
      renderItemsIndex = 0;
      opaque.length = 0;
      transmissive.length = 0;
      transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z2, group) {
      let renderItem = renderItems[renderItemsIndex];
      if (renderItem === void 0) {
        renderItem = {
          id: object.id,
          object,
          geometry,
          material,
          groupOrder,
          renderOrder: object.renderOrder,
          z: z2,
          group
        };
        renderItems[renderItemsIndex] = renderItem;
      } else {
        renderItem.id = object.id;
        renderItem.object = object;
        renderItem.geometry = geometry;
        renderItem.material = material;
        renderItem.groupOrder = groupOrder;
        renderItem.renderOrder = object.renderOrder;
        renderItem.z = z2;
        renderItem.group = group;
      }
      renderItemsIndex++;
      return renderItem;
    }
    function push(object, geometry, material, groupOrder, z2, group) {
      const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
      if (material.transmission > 0) {
        transmissive.push(renderItem);
      } else if (material.transparent === true) {
        transparent.push(renderItem);
      } else {
        opaque.push(renderItem);
      }
    }
    function unshift(object, geometry, material, groupOrder, z2, group) {
      const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z2, group);
      if (material.transmission > 0) {
        transmissive.unshift(renderItem);
      } else if (material.transparent === true) {
        transparent.unshift(renderItem);
      } else {
        opaque.unshift(renderItem);
      }
    }
    function sort(customOpaqueSort, customTransparentSort) {
      if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
      if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
      if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
    }
    function finish() {
      for (let i2 = renderItemsIndex, il = renderItems.length; i2 < il; i2++) {
        const renderItem = renderItems[i2];
        if (renderItem.id === null) break;
        renderItem.id = null;
        renderItem.object = null;
        renderItem.geometry = null;
        renderItem.material = null;
        renderItem.group = null;
      }
    }
    return {
      opaque,
      transmissive,
      transparent,
      init,
      push,
      unshift,
      finish,
      sort
    };
  }
  function WebGLRenderLists() {
    let lists = /* @__PURE__ */ new WeakMap();
    function get(scene, renderCallDepth) {
      const listArray = lists.get(scene);
      let list;
      if (listArray === void 0) {
        list = new WebGLRenderList();
        lists.set(scene, [list]);
      } else {
        if (renderCallDepth >= listArray.length) {
          list = new WebGLRenderList();
          listArray.push(list);
        } else {
          list = listArray[renderCallDepth];
        }
      }
      return list;
    }
    function dispose() {
      lists = /* @__PURE__ */ new WeakMap();
    }
    return {
      get,
      dispose
    };
  }
  function UniformsCache() {
    const lights = {};
    return {
      get: function(light) {
        if (lights[light.id] !== void 0) {
          return lights[light.id];
        }
        let uniforms;
        switch (light.type) {
          case "DirectionalLight":
            uniforms = {
              direction: new Vector3(),
              color: new Color()
            };
            break;
          case "SpotLight":
            uniforms = {
              position: new Vector3(),
              direction: new Vector3(),
              color: new Color(),
              distance: 0,
              coneCos: 0,
              penumbraCos: 0,
              decay: 0
            };
            break;
          case "PointLight":
            uniforms = {
              position: new Vector3(),
              color: new Color(),
              distance: 0,
              decay: 0
            };
            break;
          case "HemisphereLight":
            uniforms = {
              direction: new Vector3(),
              skyColor: new Color(),
              groundColor: new Color()
            };
            break;
          case "RectAreaLight":
            uniforms = {
              color: new Color(),
              position: new Vector3(),
              halfWidth: new Vector3(),
              halfHeight: new Vector3()
            };
            break;
        }
        lights[light.id] = uniforms;
        return uniforms;
      }
    };
  }
  function ShadowUniformsCache() {
    const lights = {};
    return {
      get: function(light) {
        if (lights[light.id] !== void 0) {
          return lights[light.id];
        }
        let uniforms;
        switch (light.type) {
          case "DirectionalLight":
            uniforms = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new Vector2()
            };
            break;
          case "SpotLight":
            uniforms = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new Vector2()
            };
            break;
          case "PointLight":
            uniforms = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new Vector2(),
              shadowCameraNear: 1,
              shadowCameraFar: 1e3
            };
            break;
        }
        lights[light.id] = uniforms;
        return uniforms;
      }
    };
  }
  let nextVersion = 0;
  function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
  }
  function WebGLLights(extensions) {
    const cache = new UniformsCache();
    const shadowCache = ShadowUniformsCache();
    const state = {
      version: 0,
      hash: {
        directionalLength: -1,
        pointLength: -1,
        spotLength: -1,
        rectAreaLength: -1,
        hemiLength: -1,
        numDirectionalShadows: -1,
        numPointShadows: -1,
        numSpotShadows: -1,
        numSpotMaps: -1,
        numLightProbes: -1
      },
      ambient: [0, 0, 0],
      probe: [],
      directional: [],
      directionalShadow: [],
      directionalShadowMap: [],
      directionalShadowMatrix: [],
      spot: [],
      spotLightMap: [],
      spotShadow: [],
      spotShadowMap: [],
      spotLightMatrix: [],
      rectArea: [],
      rectAreaLTC1: null,
      rectAreaLTC2: null,
      point: [],
      pointShadow: [],
      pointShadowMap: [],
      pointShadowMatrix: [],
      hemi: [],
      numSpotLightShadowsWithMaps: 0,
      numLightProbes: 0
    };
    for (let i2 = 0; i2 < 9; i2++) state.probe.push(new Vector3());
    const vector3 = new Vector3();
    const matrix4 = new Matrix4();
    const matrix42 = new Matrix4();
    function setup(lights) {
      let r2 = 0, g2 = 0, b2 = 0;
      for (let i2 = 0; i2 < 9; i2++) state.probe[i2].set(0, 0, 0);
      let directionalLength = 0;
      let pointLength = 0;
      let spotLength = 0;
      let rectAreaLength = 0;
      let hemiLength = 0;
      let numDirectionalShadows = 0;
      let numPointShadows = 0;
      let numSpotShadows = 0;
      let numSpotMaps = 0;
      let numSpotShadowsWithMaps = 0;
      let numLightProbes = 0;
      lights.sort(shadowCastingAndTexturingLightsFirst);
      for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
        const light = lights[i2];
        const color = light.color;
        const intensity = light.intensity;
        const distance = light.distance;
        const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
        if (light.isAmbientLight) {
          r2 += color.r * intensity;
          g2 += color.g * intensity;
          b2 += color.b * intensity;
        } else if (light.isLightProbe) {
          for (let j2 = 0; j2 < 9; j2++) {
            state.probe[j2].addScaledVector(light.sh.coefficients[j2], intensity);
          }
          numLightProbes++;
        } else if (light.isDirectionalLight) {
          const uniforms = cache.get(light);
          uniforms.color.copy(light.color).multiplyScalar(light.intensity);
          if (light.castShadow) {
            const shadow = light.shadow;
            const shadowUniforms = shadowCache.get(light);
            shadowUniforms.shadowIntensity = shadow.intensity;
            shadowUniforms.shadowBias = shadow.bias;
            shadowUniforms.shadowNormalBias = shadow.normalBias;
            shadowUniforms.shadowRadius = shadow.radius;
            shadowUniforms.shadowMapSize = shadow.mapSize;
            state.directionalShadow[directionalLength] = shadowUniforms;
            state.directionalShadowMap[directionalLength] = shadowMap;
            state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
            numDirectionalShadows++;
          }
          state.directional[directionalLength] = uniforms;
          directionalLength++;
        } else if (light.isSpotLight) {
          const uniforms = cache.get(light);
          uniforms.position.setFromMatrixPosition(light.matrixWorld);
          uniforms.color.copy(color).multiplyScalar(intensity);
          uniforms.distance = distance;
          uniforms.coneCos = Math.cos(light.angle);
          uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
          uniforms.decay = light.decay;
          state.spot[spotLength] = uniforms;
          const shadow = light.shadow;
          if (light.map) {
            state.spotLightMap[numSpotMaps] = light.map;
            numSpotMaps++;
            shadow.updateMatrices(light);
            if (light.castShadow) numSpotShadowsWithMaps++;
          }
          state.spotLightMatrix[spotLength] = shadow.matrix;
          if (light.castShadow) {
            const shadowUniforms = shadowCache.get(light);
            shadowUniforms.shadowIntensity = shadow.intensity;
            shadowUniforms.shadowBias = shadow.bias;
            shadowUniforms.shadowNormalBias = shadow.normalBias;
            shadowUniforms.shadowRadius = shadow.radius;
            shadowUniforms.shadowMapSize = shadow.mapSize;
            state.spotShadow[spotLength] = shadowUniforms;
            state.spotShadowMap[spotLength] = shadowMap;
            numSpotShadows++;
          }
          spotLength++;
        } else if (light.isRectAreaLight) {
          const uniforms = cache.get(light);
          uniforms.color.copy(color).multiplyScalar(intensity);
          uniforms.halfWidth.set(light.width * 0.5, 0, 0);
          uniforms.halfHeight.set(0, light.height * 0.5, 0);
          state.rectArea[rectAreaLength] = uniforms;
          rectAreaLength++;
        } else if (light.isPointLight) {
          const uniforms = cache.get(light);
          uniforms.color.copy(light.color).multiplyScalar(light.intensity);
          uniforms.distance = light.distance;
          uniforms.decay = light.decay;
          if (light.castShadow) {
            const shadow = light.shadow;
            const shadowUniforms = shadowCache.get(light);
            shadowUniforms.shadowIntensity = shadow.intensity;
            shadowUniforms.shadowBias = shadow.bias;
            shadowUniforms.shadowNormalBias = shadow.normalBias;
            shadowUniforms.shadowRadius = shadow.radius;
            shadowUniforms.shadowMapSize = shadow.mapSize;
            shadowUniforms.shadowCameraNear = shadow.camera.near;
            shadowUniforms.shadowCameraFar = shadow.camera.far;
            state.pointShadow[pointLength] = shadowUniforms;
            state.pointShadowMap[pointLength] = shadowMap;
            state.pointShadowMatrix[pointLength] = light.shadow.matrix;
            numPointShadows++;
          }
          state.point[pointLength] = uniforms;
          pointLength++;
        } else if (light.isHemisphereLight) {
          const uniforms = cache.get(light);
          uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
          uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
          state.hemi[hemiLength] = uniforms;
          hemiLength++;
        }
      }
      if (rectAreaLength > 0) {
        if (extensions.has("OES_texture_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
          state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
        } else {
          state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
          state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
        }
      }
      state.ambient[0] = r2;
      state.ambient[1] = g2;
      state.ambient[2] = b2;
      const hash = state.hash;
      if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
        state.directional.length = directionalLength;
        state.spot.length = spotLength;
        state.rectArea.length = rectAreaLength;
        state.point.length = pointLength;
        state.hemi.length = hemiLength;
        state.directionalShadow.length = numDirectionalShadows;
        state.directionalShadowMap.length = numDirectionalShadows;
        state.pointShadow.length = numPointShadows;
        state.pointShadowMap.length = numPointShadows;
        state.spotShadow.length = numSpotShadows;
        state.spotShadowMap.length = numSpotShadows;
        state.directionalShadowMatrix.length = numDirectionalShadows;
        state.pointShadowMatrix.length = numPointShadows;
        state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
        state.spotLightMap.length = numSpotMaps;
        state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
        state.numLightProbes = numLightProbes;
        hash.directionalLength = directionalLength;
        hash.pointLength = pointLength;
        hash.spotLength = spotLength;
        hash.rectAreaLength = rectAreaLength;
        hash.hemiLength = hemiLength;
        hash.numDirectionalShadows = numDirectionalShadows;
        hash.numPointShadows = numPointShadows;
        hash.numSpotShadows = numSpotShadows;
        hash.numSpotMaps = numSpotMaps;
        hash.numLightProbes = numLightProbes;
        state.version = nextVersion++;
      }
    }
    function setupView(lights, camera) {
      let directionalLength = 0;
      let pointLength = 0;
      let spotLength = 0;
      let rectAreaLength = 0;
      let hemiLength = 0;
      const viewMatrix = camera.matrixWorldInverse;
      for (let i2 = 0, l2 = lights.length; i2 < l2; i2++) {
        const light = lights[i2];
        if (light.isDirectionalLight) {
          const uniforms = state.directional[directionalLength];
          uniforms.direction.setFromMatrixPosition(light.matrixWorld);
          vector3.setFromMatrixPosition(light.target.matrixWorld);
          uniforms.direction.sub(vector3);
          uniforms.direction.transformDirection(viewMatrix);
          directionalLength++;
        } else if (light.isSpotLight) {
          const uniforms = state.spot[spotLength];
          uniforms.position.setFromMatrixPosition(light.matrixWorld);
          uniforms.position.applyMatrix4(viewMatrix);
          uniforms.direction.setFromMatrixPosition(light.matrixWorld);
          vector3.setFromMatrixPosition(light.target.matrixWorld);
          uniforms.direction.sub(vector3);
          uniforms.direction.transformDirection(viewMatrix);
          spotLength++;
        } else if (light.isRectAreaLight) {
          const uniforms = state.rectArea[rectAreaLength];
          uniforms.position.setFromMatrixPosition(light.matrixWorld);
          uniforms.position.applyMatrix4(viewMatrix);
          matrix42.identity();
          matrix4.copy(light.matrixWorld);
          matrix4.premultiply(viewMatrix);
          matrix42.extractRotation(matrix4);
          uniforms.halfWidth.set(light.width * 0.5, 0, 0);
          uniforms.halfHeight.set(0, light.height * 0.5, 0);
          uniforms.halfWidth.applyMatrix4(matrix42);
          uniforms.halfHeight.applyMatrix4(matrix42);
          rectAreaLength++;
        } else if (light.isPointLight) {
          const uniforms = state.point[pointLength];
          uniforms.position.setFromMatrixPosition(light.matrixWorld);
          uniforms.position.applyMatrix4(viewMatrix);
          pointLength++;
        } else if (light.isHemisphereLight) {
          const uniforms = state.hemi[hemiLength];
          uniforms.direction.setFromMatrixPosition(light.matrixWorld);
          uniforms.direction.transformDirection(viewMatrix);
          hemiLength++;
        }
      }
    }
    return {
      setup,
      setupView,
      state
    };
  }
  function WebGLRenderState(extensions) {
    const lights = new WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
      state.camera = camera;
      lightsArray.length = 0;
      shadowsArray.length = 0;
    }
    function pushLight(light) {
      lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
      shadowsArray.push(shadowLight);
    }
    function setupLights() {
      lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
      lights.setupView(lightsArray, camera);
    }
    const state = {
      lightsArray,
      shadowsArray,
      camera: null,
      lights,
      transmissionRenderTarget: {}
    };
    return {
      init,
      state,
      setupLights,
      setupLightsView,
      pushLight,
      pushShadow
    };
  }
  function WebGLRenderStates(extensions) {
    let renderStates = /* @__PURE__ */ new WeakMap();
    function get(scene, renderCallDepth = 0) {
      const renderStateArray = renderStates.get(scene);
      let renderState;
      if (renderStateArray === void 0) {
        renderState = new WebGLRenderState(extensions);
        renderStates.set(scene, [renderState]);
      } else {
        if (renderCallDepth >= renderStateArray.length) {
          renderState = new WebGLRenderState(extensions);
          renderStateArray.push(renderState);
        } else {
          renderState = renderStateArray[renderCallDepth];
        }
      }
      return renderState;
    }
    function dispose() {
      renderStates = /* @__PURE__ */ new WeakMap();
    }
    return {
      get,
      dispose
    };
  }
  const vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
  const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
  function WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new Frustum();
    const _shadowMapSize = new Vector2(), _viewportSize = new Vector2(), _viewport = new Vector4(), _depthMaterial = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), _distanceMaterial = new MeshDistanceMaterial(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = { [FrontSide]: BackSide, [BackSide]: FrontSide, [DoubleSide]: DoubleSide };
    const shadowMaterialVertical = new ShaderMaterial({
      defines: {
        VSM_SAMPLES: 8
      },
      uniforms: {
        shadow_pass: { value: null },
        resolution: { value: new Vector2() },
        radius: { value: 4 }
      },
      vertexShader: vertex,
      fragmentShader: fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new BufferGeometry();
    fullScreenTri.setAttribute(
      "position",
      new BufferAttribute(
        new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
        3
      )
    );
    const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = PCFShadowMap;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
      if (scope.enabled === false) return;
      if (scope.autoUpdate === false && scope.needsUpdate === false) return;
      if (lights.length === 0) return;
      const currentRenderTarget = renderer.getRenderTarget();
      const activeCubeFace = renderer.getActiveCubeFace();
      const activeMipmapLevel = renderer.getActiveMipmapLevel();
      const _state = renderer.state;
      _state.setBlending(NoBlending);
      _state.buffers.color.setClear(1, 1, 1, 1);
      _state.buffers.depth.setTest(true);
      _state.setScissorTest(false);
      const toVSM = _previousType !== VSMShadowMap && this.type === VSMShadowMap;
      const fromVSM = _previousType === VSMShadowMap && this.type !== VSMShadowMap;
      for (let i2 = 0, il = lights.length; i2 < il; i2++) {
        const light = lights[i2];
        const shadow = light.shadow;
        if (shadow === void 0) {
          console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
          continue;
        }
        if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
        _shadowMapSize.copy(shadow.mapSize);
        const shadowFrameExtents = shadow.getFrameExtents();
        _shadowMapSize.multiply(shadowFrameExtents);
        _viewportSize.copy(shadow.mapSize);
        if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
          if (_shadowMapSize.x > _maxTextureSize) {
            _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
            _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
            shadow.mapSize.x = _viewportSize.x;
          }
          if (_shadowMapSize.y > _maxTextureSize) {
            _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
            _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
            shadow.mapSize.y = _viewportSize.y;
          }
        }
        if (shadow.map === null || toVSM === true || fromVSM === true) {
          const pars = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};
          if (shadow.map !== null) {
            shadow.map.dispose();
          }
          shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
          shadow.map.texture.name = light.name + ".shadowMap";
          shadow.camera.updateProjectionMatrix();
        }
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        const viewportCount = shadow.getViewportCount();
        for (let vp = 0; vp < viewportCount; vp++) {
          const viewport = shadow.getViewport(vp);
          _viewport.set(
            _viewportSize.x * viewport.x,
            _viewportSize.y * viewport.y,
            _viewportSize.x * viewport.z,
            _viewportSize.y * viewport.w
          );
          _state.viewport(_viewport);
          shadow.updateMatrices(light, vp);
          _frustum = shadow.getFrustum();
          renderObject(scene, camera, shadow.camera, light, this.type);
        }
        if (shadow.isPointLightShadow !== true && this.type === VSMShadowMap) {
          VSMPass(shadow, camera);
        }
        shadow.needsUpdate = false;
      }
      _previousType = this.type;
      scope.needsUpdate = false;
      renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
      const geometry = objects.update(fullScreenMesh);
      if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
        shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
        shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
        shadowMaterialVertical.needsUpdate = true;
        shadowMaterialHorizontal.needsUpdate = true;
      }
      if (shadow.mapPass === null) {
        shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
      }
      shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
      shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
      shadowMaterialVertical.uniforms.radius.value = shadow.radius;
      renderer.setRenderTarget(shadow.mapPass);
      renderer.clear();
      renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
      shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
      shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
      shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
      renderer.setRenderTarget(shadow.map);
      renderer.clear();
      renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
      let result = null;
      const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
      if (customMaterial !== void 0) {
        result = customMaterial;
      } else {
        result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
          const keyA = result.uuid, keyB = material.uuid;
          let materialsForVariant = _materialCache[keyA];
          if (materialsForVariant === void 0) {
            materialsForVariant = {};
            _materialCache[keyA] = materialsForVariant;
          }
          let cachedMaterial = materialsForVariant[keyB];
          if (cachedMaterial === void 0) {
            cachedMaterial = result.clone();
            materialsForVariant[keyB] = cachedMaterial;
            material.addEventListener("dispose", onMaterialDispose);
          }
          result = cachedMaterial;
        }
      }
      result.visible = material.visible;
      result.wireframe = material.wireframe;
      if (type === VSMShadowMap) {
        result.side = material.shadowSide !== null ? material.shadowSide : material.side;
      } else {
        result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
      }
      result.alphaMap = material.alphaMap;
      result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest;
      result.map = material.map;
      result.clipShadows = material.clipShadows;
      result.clippingPlanes = material.clippingPlanes;
      result.clipIntersection = material.clipIntersection;
      result.displacementMap = material.displacementMap;
      result.displacementScale = material.displacementScale;
      result.displacementBias = material.displacementBias;
      result.wireframeLinewidth = material.wireframeLinewidth;
      result.linewidth = material.linewidth;
      if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
        const materialProperties = renderer.properties.get(result);
        materialProperties.light = light;
      }
      return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
      if (object.visible === false) return;
      const visible = object.layers.test(camera.layers);
      if (visible && (object.isMesh || object.isLine || object.isPoints)) {
        if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
          object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
          const geometry = objects.update(object);
          const material = object.material;
          if (Array.isArray(material)) {
            const groups = geometry.groups;
            for (let k2 = 0, kl = groups.length; k2 < kl; k2++) {
              const group = groups[k2];
              const groupMaterial = material[group.materialIndex];
              if (groupMaterial && groupMaterial.visible) {
                const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
              }
            }
          } else if (material.visible) {
            const depthMaterial = getDepthMaterial(object, material, light, type);
            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
          }
        }
      }
      const children = object.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        renderObject(children[i2], camera, shadowCamera, light, type);
      }
    }
    function onMaterialDispose(event) {
      const material = event.target;
      material.removeEventListener("dispose", onMaterialDispose);
      for (const id in _materialCache) {
        const cache = _materialCache[id];
        const uuid = event.target.uuid;
        if (uuid in cache) {
          const shadowMaterial = cache[uuid];
          shadowMaterial.dispose();
          delete cache[uuid];
        }
      }
    }
  }
  const reversedFuncs = {
    [NeverDepth]: AlwaysDepth,
    [LessDepth]: GreaterDepth,
    [EqualDepth]: NotEqualDepth,
    [LessEqualDepth]: GreaterEqualDepth,
    [AlwaysDepth]: NeverDepth,
    [GreaterDepth]: LessDepth,
    [NotEqualDepth]: EqualDepth,
    [GreaterEqualDepth]: LessEqualDepth
  };
  function WebGLState(gl, extensions) {
    function ColorBuffer() {
      let locked = false;
      const color = new Vector4();
      let currentColorMask = null;
      const currentColorClear = new Vector4(0, 0, 0, 0);
      return {
        setMask: function(colorMask) {
          if (currentColorMask !== colorMask && !locked) {
            gl.colorMask(colorMask, colorMask, colorMask, colorMask);
            currentColorMask = colorMask;
          }
        },
        setLocked: function(lock) {
          locked = lock;
        },
        setClear: function(r2, g2, b2, a2, premultipliedAlpha) {
          if (premultipliedAlpha === true) {
            r2 *= a2;
            g2 *= a2;
            b2 *= a2;
          }
          color.set(r2, g2, b2, a2);
          if (currentColorClear.equals(color) === false) {
            gl.clearColor(r2, g2, b2, a2);
            currentColorClear.copy(color);
          }
        },
        reset: function() {
          locked = false;
          currentColorMask = null;
          currentColorClear.set(-1, 0, 0, 0);
        }
      };
    }
    function DepthBuffer() {
      let locked = false;
      let currentReversed = false;
      let currentDepthMask = null;
      let currentDepthFunc = null;
      let currentDepthClear = null;
      return {
        setReversed: function(reversed) {
          if (currentReversed !== reversed) {
            const ext = extensions.get("EXT_clip_control");
            if (reversed) {
              ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
            } else {
              ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
            }
            currentReversed = reversed;
            const oldDepth = currentDepthClear;
            currentDepthClear = null;
            this.setClear(oldDepth);
          }
        },
        getReversed: function() {
          return currentReversed;
        },
        setTest: function(depthTest) {
          if (depthTest) {
            enable(gl.DEPTH_TEST);
          } else {
            disable(gl.DEPTH_TEST);
          }
        },
        setMask: function(depthMask) {
          if (currentDepthMask !== depthMask && !locked) {
            gl.depthMask(depthMask);
            currentDepthMask = depthMask;
          }
        },
        setFunc: function(depthFunc) {
          if (currentReversed) depthFunc = reversedFuncs[depthFunc];
          if (currentDepthFunc !== depthFunc) {
            switch (depthFunc) {
              case NeverDepth:
                gl.depthFunc(gl.NEVER);
                break;
              case AlwaysDepth:
                gl.depthFunc(gl.ALWAYS);
                break;
              case LessDepth:
                gl.depthFunc(gl.LESS);
                break;
              case LessEqualDepth:
                gl.depthFunc(gl.LEQUAL);
                break;
              case EqualDepth:
                gl.depthFunc(gl.EQUAL);
                break;
              case GreaterEqualDepth:
                gl.depthFunc(gl.GEQUAL);
                break;
              case GreaterDepth:
                gl.depthFunc(gl.GREATER);
                break;
              case NotEqualDepth:
                gl.depthFunc(gl.NOTEQUAL);
                break;
              default:
                gl.depthFunc(gl.LEQUAL);
            }
            currentDepthFunc = depthFunc;
          }
        },
        setLocked: function(lock) {
          locked = lock;
        },
        setClear: function(depth) {
          if (currentDepthClear !== depth) {
            if (currentReversed) {
              depth = 1 - depth;
            }
            gl.clearDepth(depth);
            currentDepthClear = depth;
          }
        },
        reset: function() {
          locked = false;
          currentDepthMask = null;
          currentDepthFunc = null;
          currentDepthClear = null;
          currentReversed = false;
        }
      };
    }
    function StencilBuffer() {
      let locked = false;
      let currentStencilMask = null;
      let currentStencilFunc = null;
      let currentStencilRef = null;
      let currentStencilFuncMask = null;
      let currentStencilFail = null;
      let currentStencilZFail = null;
      let currentStencilZPass = null;
      let currentStencilClear = null;
      return {
        setTest: function(stencilTest) {
          if (!locked) {
            if (stencilTest) {
              enable(gl.STENCIL_TEST);
            } else {
              disable(gl.STENCIL_TEST);
            }
          }
        },
        setMask: function(stencilMask) {
          if (currentStencilMask !== stencilMask && !locked) {
            gl.stencilMask(stencilMask);
            currentStencilMask = stencilMask;
          }
        },
        setFunc: function(stencilFunc, stencilRef, stencilMask) {
          if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
            gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
            currentStencilFunc = stencilFunc;
            currentStencilRef = stencilRef;
            currentStencilFuncMask = stencilMask;
          }
        },
        setOp: function(stencilFail, stencilZFail, stencilZPass) {
          if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
            gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
            currentStencilFail = stencilFail;
            currentStencilZFail = stencilZFail;
            currentStencilZPass = stencilZPass;
          }
        },
        setLocked: function(lock) {
          locked = lock;
        },
        setClear: function(stencil) {
          if (currentStencilClear !== stencil) {
            gl.clearStencil(stencil);
            currentStencilClear = stencil;
          }
        },
        reset: function() {
          locked = false;
          currentStencilMask = null;
          currentStencilFunc = null;
          currentStencilRef = null;
          currentStencilFuncMask = null;
          currentStencilFail = null;
          currentStencilZFail = null;
          currentStencilZPass = null;
          currentStencilClear = null;
        }
      };
    }
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = /* @__PURE__ */ new WeakMap();
    const uboProgramMap = /* @__PURE__ */ new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = /* @__PURE__ */ new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new Color(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
      version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
      lineWidthAvailable = version >= 1;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
      version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
      lineWidthAvailable = version >= 2;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new Vector4().fromArray(scissorParam);
    const currentViewport = new Vector4().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
      const data = new Uint8Array(4);
      const texture = gl.createTexture();
      gl.bindTexture(type, texture);
      gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      for (let i2 = 0; i2 < count; i2++) {
        if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) {
          gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        } else {
          gl.texImage2D(target + i2, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        }
      }
      return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc(LessEqualDepth);
    setFlipSided(false);
    setCullFace(CullFaceBack);
    enable(gl.CULL_FACE);
    setBlending(NoBlending);
    function enable(id) {
      if (enabledCapabilities[id] !== true) {
        gl.enable(id);
        enabledCapabilities[id] = true;
      }
    }
    function disable(id) {
      if (enabledCapabilities[id] !== false) {
        gl.disable(id);
        enabledCapabilities[id] = false;
      }
    }
    function bindFramebuffer(target, framebuffer) {
      if (currentBoundFramebuffers[target] !== framebuffer) {
        gl.bindFramebuffer(target, framebuffer);
        currentBoundFramebuffers[target] = framebuffer;
        if (target === gl.DRAW_FRAMEBUFFER) {
          currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
        }
        if (target === gl.FRAMEBUFFER) {
          currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
        }
        return true;
      }
      return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
      let drawBuffers2 = defaultDrawbuffers;
      let needsUpdate = false;
      if (renderTarget) {
        drawBuffers2 = currentDrawbuffers.get(framebuffer);
        if (drawBuffers2 === void 0) {
          drawBuffers2 = [];
          currentDrawbuffers.set(framebuffer, drawBuffers2);
        }
        const textures = renderTarget.textures;
        if (drawBuffers2.length !== textures.length || drawBuffers2[0] !== gl.COLOR_ATTACHMENT0) {
          for (let i2 = 0, il = textures.length; i2 < il; i2++) {
            drawBuffers2[i2] = gl.COLOR_ATTACHMENT0 + i2;
          }
          drawBuffers2.length = textures.length;
          needsUpdate = true;
        }
      } else {
        if (drawBuffers2[0] !== gl.BACK) {
          drawBuffers2[0] = gl.BACK;
          needsUpdate = true;
        }
      }
      if (needsUpdate) {
        gl.drawBuffers(drawBuffers2);
      }
    }
    function useProgram(program) {
      if (currentProgram !== program) {
        gl.useProgram(program);
        currentProgram = program;
        return true;
      }
      return false;
    }
    const equationToGL = {
      [AddEquation]: gl.FUNC_ADD,
      [SubtractEquation]: gl.FUNC_SUBTRACT,
      [ReverseSubtractEquation]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[MinEquation] = gl.MIN;
    equationToGL[MaxEquation] = gl.MAX;
    const factorToGL = {
      [ZeroFactor]: gl.ZERO,
      [OneFactor]: gl.ONE,
      [SrcColorFactor]: gl.SRC_COLOR,
      [SrcAlphaFactor]: gl.SRC_ALPHA,
      [SrcAlphaSaturateFactor]: gl.SRC_ALPHA_SATURATE,
      [DstColorFactor]: gl.DST_COLOR,
      [DstAlphaFactor]: gl.DST_ALPHA,
      [OneMinusSrcColorFactor]: gl.ONE_MINUS_SRC_COLOR,
      [OneMinusSrcAlphaFactor]: gl.ONE_MINUS_SRC_ALPHA,
      [OneMinusDstColorFactor]: gl.ONE_MINUS_DST_COLOR,
      [OneMinusDstAlphaFactor]: gl.ONE_MINUS_DST_ALPHA,
      [ConstantColorFactor]: gl.CONSTANT_COLOR,
      [OneMinusConstantColorFactor]: gl.ONE_MINUS_CONSTANT_COLOR,
      [ConstantAlphaFactor]: gl.CONSTANT_ALPHA,
      [OneMinusConstantAlphaFactor]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
      if (blending === NoBlending) {
        if (currentBlendingEnabled === true) {
          disable(gl.BLEND);
          currentBlendingEnabled = false;
        }
        return;
      }
      if (currentBlendingEnabled === false) {
        enable(gl.BLEND);
        currentBlendingEnabled = true;
      }
      if (blending !== CustomBlending) {
        if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
          if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
            gl.blendEquation(gl.FUNC_ADD);
            currentBlendEquation = AddEquation;
            currentBlendEquationAlpha = AddEquation;
          }
          if (premultipliedAlpha) {
            switch (blending) {
              case NormalBlending:
                gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                break;
              case AdditiveBlending:
                gl.blendFunc(gl.ONE, gl.ONE);
                break;
              case SubtractiveBlending:
                gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                break;
              case MultiplyBlending:
                gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                break;
              default:
                console.error("THREE.WebGLState: Invalid blending: ", blending);
                break;
            }
          } else {
            switch (blending) {
              case NormalBlending:
                gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                break;
              case AdditiveBlending:
                gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                break;
              case SubtractiveBlending:
                console.error("THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                break;
              case MultiplyBlending:
                console.error("THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                break;
              default:
                console.error("THREE.WebGLState: Invalid blending: ", blending);
                break;
            }
          }
          currentBlendSrc = null;
          currentBlendDst = null;
          currentBlendSrcAlpha = null;
          currentBlendDstAlpha = null;
          currentBlendColor.set(0, 0, 0);
          currentBlendAlpha = 0;
          currentBlending = blending;
          currentPremultipledAlpha = premultipliedAlpha;
        }
        return;
      }
      blendEquationAlpha = blendEquationAlpha || blendEquation;
      blendSrcAlpha = blendSrcAlpha || blendSrc;
      blendDstAlpha = blendDstAlpha || blendDst;
      if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
        gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
        currentBlendEquation = blendEquation;
        currentBlendEquationAlpha = blendEquationAlpha;
      }
      if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
        gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
        currentBlendSrc = blendSrc;
        currentBlendDst = blendDst;
        currentBlendSrcAlpha = blendSrcAlpha;
        currentBlendDstAlpha = blendDstAlpha;
      }
      if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
        gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
        currentBlendColor.copy(blendColor);
        currentBlendAlpha = blendAlpha;
      }
      currentBlending = blending;
      currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
      material.side === DoubleSide ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
      let flipSided = material.side === BackSide;
      if (frontFaceCW) flipSided = !flipSided;
      setFlipSided(flipSided);
      material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
      depthBuffer.setFunc(material.depthFunc);
      depthBuffer.setTest(material.depthTest);
      depthBuffer.setMask(material.depthWrite);
      colorBuffer.setMask(material.colorWrite);
      const stencilWrite = material.stencilWrite;
      stencilBuffer.setTest(stencilWrite);
      if (stencilWrite) {
        stencilBuffer.setMask(material.stencilWriteMask);
        stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
        stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
      }
      setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
      material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    function setFlipSided(flipSided) {
      if (currentFlipSided !== flipSided) {
        if (flipSided) {
          gl.frontFace(gl.CW);
        } else {
          gl.frontFace(gl.CCW);
        }
        currentFlipSided = flipSided;
      }
    }
    function setCullFace(cullFace) {
      if (cullFace !== CullFaceNone) {
        enable(gl.CULL_FACE);
        if (cullFace !== currentCullFace) {
          if (cullFace === CullFaceBack) {
            gl.cullFace(gl.BACK);
          } else if (cullFace === CullFaceFront) {
            gl.cullFace(gl.FRONT);
          } else {
            gl.cullFace(gl.FRONT_AND_BACK);
          }
        }
      } else {
        disable(gl.CULL_FACE);
      }
      currentCullFace = cullFace;
    }
    function setLineWidth(width) {
      if (width !== currentLineWidth) {
        if (lineWidthAvailable) gl.lineWidth(width);
        currentLineWidth = width;
      }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
      if (polygonOffset) {
        enable(gl.POLYGON_OFFSET_FILL);
        if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
          gl.polygonOffset(factor, units);
          currentPolygonOffsetFactor = factor;
          currentPolygonOffsetUnits = units;
        }
      } else {
        disable(gl.POLYGON_OFFSET_FILL);
      }
    }
    function setScissorTest(scissorTest) {
      if (scissorTest) {
        enable(gl.SCISSOR_TEST);
      } else {
        disable(gl.SCISSOR_TEST);
      }
    }
    function activeTexture(webglSlot) {
      if (webglSlot === void 0) webglSlot = gl.TEXTURE0 + maxTextures - 1;
      if (currentTextureSlot !== webglSlot) {
        gl.activeTexture(webglSlot);
        currentTextureSlot = webglSlot;
      }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
      if (webglSlot === void 0) {
        if (currentTextureSlot === null) {
          webglSlot = gl.TEXTURE0 + maxTextures - 1;
        } else {
          webglSlot = currentTextureSlot;
        }
      }
      let boundTexture = currentBoundTextures[webglSlot];
      if (boundTexture === void 0) {
        boundTexture = { type: void 0, texture: void 0 };
        currentBoundTextures[webglSlot] = boundTexture;
      }
      if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
        if (currentTextureSlot !== webglSlot) {
          gl.activeTexture(webglSlot);
          currentTextureSlot = webglSlot;
        }
        gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
        boundTexture.type = webglType;
        boundTexture.texture = webglTexture;
      }
    }
    function unbindTexture() {
      const boundTexture = currentBoundTextures[currentTextureSlot];
      if (boundTexture !== void 0 && boundTexture.type !== void 0) {
        gl.bindTexture(boundTexture.type, null);
        boundTexture.type = void 0;
        boundTexture.texture = void 0;
      }
    }
    function compressedTexImage2D() {
      try {
        gl.compressedTexImage2D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function compressedTexImage3D() {
      try {
        gl.compressedTexImage3D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texSubImage2D() {
      try {
        gl.texSubImage2D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texSubImage3D() {
      try {
        gl.texSubImage3D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function compressedTexSubImage2D() {
      try {
        gl.compressedTexSubImage2D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function compressedTexSubImage3D() {
      try {
        gl.compressedTexSubImage3D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texStorage2D() {
      try {
        gl.texStorage2D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texStorage3D() {
      try {
        gl.texStorage3D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texImage2D() {
      try {
        gl.texImage2D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function texImage3D() {
      try {
        gl.texImage3D(...arguments);
      } catch (error) {
        console.error("THREE.WebGLState:", error);
      }
    }
    function scissor(scissor2) {
      if (currentScissor.equals(scissor2) === false) {
        gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
        currentScissor.copy(scissor2);
      }
    }
    function viewport(viewport2) {
      if (currentViewport.equals(viewport2) === false) {
        gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
        currentViewport.copy(viewport2);
      }
    }
    function updateUBOMapping(uniformsGroup, program) {
      let mapping = uboProgramMap.get(program);
      if (mapping === void 0) {
        mapping = /* @__PURE__ */ new WeakMap();
        uboProgramMap.set(program, mapping);
      }
      let blockIndex = mapping.get(uniformsGroup);
      if (blockIndex === void 0) {
        blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
        mapping.set(uniformsGroup, blockIndex);
      }
    }
    function uniformBlockBinding(uniformsGroup, program) {
      const mapping = uboProgramMap.get(program);
      const blockIndex = mapping.get(uniformsGroup);
      if (uboBindings.get(program) !== blockIndex) {
        gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
        uboBindings.set(program, blockIndex);
      }
    }
    function reset() {
      gl.disable(gl.BLEND);
      gl.disable(gl.CULL_FACE);
      gl.disable(gl.DEPTH_TEST);
      gl.disable(gl.POLYGON_OFFSET_FILL);
      gl.disable(gl.SCISSOR_TEST);
      gl.disable(gl.STENCIL_TEST);
      gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
      gl.blendEquation(gl.FUNC_ADD);
      gl.blendFunc(gl.ONE, gl.ZERO);
      gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
      gl.blendColor(0, 0, 0, 0);
      gl.colorMask(true, true, true, true);
      gl.clearColor(0, 0, 0, 0);
      gl.depthMask(true);
      gl.depthFunc(gl.LESS);
      depthBuffer.setReversed(false);
      gl.clearDepth(1);
      gl.stencilMask(4294967295);
      gl.stencilFunc(gl.ALWAYS, 0, 4294967295);
      gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
      gl.clearStencil(0);
      gl.cullFace(gl.BACK);
      gl.frontFace(gl.CCW);
      gl.polygonOffset(0, 0);
      gl.activeTexture(gl.TEXTURE0);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
      gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
      gl.useProgram(null);
      gl.lineWidth(1);
      gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
      gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
      enabledCapabilities = {};
      currentTextureSlot = null;
      currentBoundTextures = {};
      currentBoundFramebuffers = {};
      currentDrawbuffers = /* @__PURE__ */ new WeakMap();
      defaultDrawbuffers = [];
      currentProgram = null;
      currentBlendingEnabled = false;
      currentBlending = null;
      currentBlendEquation = null;
      currentBlendSrc = null;
      currentBlendDst = null;
      currentBlendEquationAlpha = null;
      currentBlendSrcAlpha = null;
      currentBlendDstAlpha = null;
      currentBlendColor = new Color(0, 0, 0);
      currentBlendAlpha = 0;
      currentPremultipledAlpha = false;
      currentFlipSided = null;
      currentCullFace = null;
      currentLineWidth = null;
      currentPolygonOffsetFactor = null;
      currentPolygonOffsetUnits = null;
      currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
      currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
      colorBuffer.reset();
      depthBuffer.reset();
      stencilBuffer.reset();
    }
    return {
      buffers: {
        color: colorBuffer,
        depth: depthBuffer,
        stencil: stencilBuffer
      },
      enable,
      disable,
      bindFramebuffer,
      drawBuffers,
      useProgram,
      setBlending,
      setMaterial,
      setFlipSided,
      setCullFace,
      setLineWidth,
      setPolygonOffset,
      setScissorTest,
      activeTexture,
      bindTexture,
      unbindTexture,
      compressedTexImage2D,
      compressedTexImage3D,
      texImage2D,
      texImage3D,
      updateUBOMapping,
      uniformBlockBinding,
      texStorage2D,
      texStorage3D,
      texSubImage2D,
      texSubImage3D,
      compressedTexSubImage2D,
      compressedTexSubImage3D,
      scissor,
      viewport,
      reset
    };
  }
  function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new Vector2();
    const _videoTextures = /* @__PURE__ */ new WeakMap();
    let _canvas2;
    const _sources = /* @__PURE__ */ new WeakMap();
    let useOffscreenCanvas = false;
    try {
      useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    }
    function createCanvas(width, height) {
      return useOffscreenCanvas ? (
        // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height)
      ) : createElementNS("canvas");
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
      let scale = 1;
      const dimensions = getDimensions(image);
      if (dimensions.width > maxSize || dimensions.height > maxSize) {
        scale = maxSize / Math.max(dimensions.width, dimensions.height);
      }
      if (scale < 1) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap || typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
          const width = Math.floor(scale * dimensions.width);
          const height = Math.floor(scale * dimensions.height);
          if (_canvas2 === void 0) _canvas2 = createCanvas(width, height);
          const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas2;
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, width, height);
          console.warn("THREE.WebGLRenderer: Texture has been resized from (" + dimensions.width + "x" + dimensions.height + ") to (" + width + "x" + height + ").");
          return canvas;
        } else {
          if ("data" in image) {
            console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + dimensions.width + "x" + dimensions.height + ").");
          }
          return image;
        }
      }
      return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
      return texture.generateMipmaps;
    }
    function generateMipmap(target) {
      _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
      if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
      if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
      if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
      return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
      if (internalFormatName !== null) {
        if (_gl[internalFormatName] !== void 0) return _gl[internalFormatName];
        console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
      }
      let internalFormat = glFormat;
      if (glFormat === _gl.RED) {
        if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
        if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
      }
      if (glFormat === _gl.RED_INTEGER) {
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
        if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
        if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
        if (glType === _gl.BYTE) internalFormat = _gl.R8I;
        if (glType === _gl.SHORT) internalFormat = _gl.R16I;
        if (glType === _gl.INT) internalFormat = _gl.R32I;
      }
      if (glFormat === _gl.RG) {
        if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
        if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
      }
      if (glFormat === _gl.RG_INTEGER) {
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
        if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
        if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
        if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
        if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
        if (glType === _gl.INT) internalFormat = _gl.RG32I;
      }
      if (glFormat === _gl.RGB_INTEGER) {
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
        if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
        if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
        if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
        if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
        if (glType === _gl.INT) internalFormat = _gl.RGB32I;
      }
      if (glFormat === _gl.RGBA_INTEGER) {
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
        if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
        if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
        if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
        if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
        if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
      }
      if (glFormat === _gl.RGB) {
        if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
      }
      if (glFormat === _gl.RGBA) {
        const transfer = forceLinearTransfer ? LinearTransfer : ColorManagement.getTransfer(colorSpace);
        if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
        if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
        if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === SRGBTransfer ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
        if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
        if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
      }
      if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) {
        extensions.get("EXT_color_buffer_float");
      }
      return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
      let glInternalFormat;
      if (useStencil) {
        if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
          glInternalFormat = _gl.DEPTH24_STENCIL8;
        } else if (depthType === FloatType) {
          glInternalFormat = _gl.DEPTH32F_STENCIL8;
        } else if (depthType === UnsignedShortType) {
          glInternalFormat = _gl.DEPTH24_STENCIL8;
          console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.");
        }
      } else {
        if (depthType === null || depthType === UnsignedIntType || depthType === UnsignedInt248Type) {
          glInternalFormat = _gl.DEPTH_COMPONENT24;
        } else if (depthType === FloatType) {
          glInternalFormat = _gl.DEPTH_COMPONENT32F;
        } else if (depthType === UnsignedShortType) {
          glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
      }
      return glInternalFormat;
    }
    function getMipLevels(texture, image) {
      if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
        return Math.log2(Math.max(image.width, image.height)) + 1;
      } else if (texture.mipmaps !== void 0 && texture.mipmaps.length > 0) {
        return texture.mipmaps.length;
      } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
        return image.mipmaps.length;
      } else {
        return 1;
      }
    }
    function onTextureDispose(event) {
      const texture = event.target;
      texture.removeEventListener("dispose", onTextureDispose);
      deallocateTexture(texture);
      if (texture.isVideoTexture) {
        _videoTextures.delete(texture);
      }
    }
    function onRenderTargetDispose(event) {
      const renderTarget = event.target;
      renderTarget.removeEventListener("dispose", onRenderTargetDispose);
      deallocateRenderTarget(renderTarget);
    }
    function deallocateTexture(texture) {
      const textureProperties = properties.get(texture);
      if (textureProperties.__webglInit === void 0) return;
      const source = texture.source;
      const webglTextures = _sources.get(source);
      if (webglTextures) {
        const webglTexture = webglTextures[textureProperties.__cacheKey];
        webglTexture.usedTimes--;
        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
        if (Object.keys(webglTextures).length === 0) {
          _sources.delete(source);
        }
      }
      properties.remove(texture);
    }
    function deleteTexture(texture) {
      const textureProperties = properties.get(texture);
      _gl.deleteTexture(textureProperties.__webglTexture);
      const source = texture.source;
      const webglTextures = _sources.get(source);
      delete webglTextures[textureProperties.__cacheKey];
      info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
      const renderTargetProperties = properties.get(renderTarget);
      if (renderTarget.depthTexture) {
        renderTarget.depthTexture.dispose();
        properties.remove(renderTarget.depthTexture);
      }
      if (renderTarget.isWebGLCubeRenderTarget) {
        for (let i2 = 0; i2 < 6; i2++) {
          if (Array.isArray(renderTargetProperties.__webglFramebuffer[i2])) {
            for (let level = 0; level < renderTargetProperties.__webglFramebuffer[i2].length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2][level]);
          } else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2]);
          }
          if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i2]);
        }
      } else {
        if (Array.isArray(renderTargetProperties.__webglFramebuffer)) {
          for (let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++) _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
        } else {
          _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
        }
        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
        if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
        if (renderTargetProperties.__webglColorRenderbuffer) {
          for (let i2 = 0; i2 < renderTargetProperties.__webglColorRenderbuffer.length; i2++) {
            if (renderTargetProperties.__webglColorRenderbuffer[i2]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i2]);
          }
        }
        if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
      }
      const textures = renderTarget.textures;
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const attachmentProperties = properties.get(textures[i2]);
        if (attachmentProperties.__webglTexture) {
          _gl.deleteTexture(attachmentProperties.__webglTexture);
          info.memory.textures--;
        }
        properties.remove(textures[i2]);
      }
      properties.remove(renderTarget);
    }
    let textureUnits = 0;
    function resetTextureUnits() {
      textureUnits = 0;
    }
    function allocateTextureUnit() {
      const textureUnit = textureUnits;
      if (textureUnit >= capabilities.maxTextures) {
        console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + capabilities.maxTextures);
      }
      textureUnits += 1;
      return textureUnit;
    }
    function getTextureCacheKey(texture) {
      const array = [];
      array.push(texture.wrapS);
      array.push(texture.wrapT);
      array.push(texture.wrapR || 0);
      array.push(texture.magFilter);
      array.push(texture.minFilter);
      array.push(texture.anisotropy);
      array.push(texture.internalFormat);
      array.push(texture.format);
      array.push(texture.type);
      array.push(texture.generateMipmaps);
      array.push(texture.premultiplyAlpha);
      array.push(texture.flipY);
      array.push(texture.unpackAlignment);
      array.push(texture.colorSpace);
      return array.join();
    }
    function setTexture2D(texture, slot) {
      const textureProperties = properties.get(texture);
      if (texture.isVideoTexture) updateVideoTexture(texture);
      if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
        const image = texture.image;
        if (image === null) {
          console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
        } else if (image.complete === false) {
          console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
        } else {
          uploadTexture(textureProperties, texture, slot);
          return;
        }
      }
      state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
      const textureProperties = properties.get(texture);
      if (texture.version > 0 && textureProperties.__version !== texture.version) {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
      state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
      const textureProperties = properties.get(texture);
      if (texture.version > 0 && textureProperties.__version !== texture.version) {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
      state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
      const textureProperties = properties.get(texture);
      if (texture.version > 0 && textureProperties.__version !== texture.version) {
        uploadCubeTexture(textureProperties, texture, slot);
        return;
      }
      state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
      [RepeatWrapping]: _gl.REPEAT,
      [ClampToEdgeWrapping]: _gl.CLAMP_TO_EDGE,
      [MirroredRepeatWrapping]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
      [NearestFilter]: _gl.NEAREST,
      [NearestMipmapNearestFilter]: _gl.NEAREST_MIPMAP_NEAREST,
      [NearestMipmapLinearFilter]: _gl.NEAREST_MIPMAP_LINEAR,
      [LinearFilter]: _gl.LINEAR,
      [LinearMipmapNearestFilter]: _gl.LINEAR_MIPMAP_NEAREST,
      [LinearMipmapLinearFilter]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
      [NeverCompare]: _gl.NEVER,
      [AlwaysCompare]: _gl.ALWAYS,
      [LessCompare]: _gl.LESS,
      [LessEqualCompare]: _gl.LEQUAL,
      [EqualCompare]: _gl.EQUAL,
      [GreaterEqualCompare]: _gl.GEQUAL,
      [GreaterCompare]: _gl.GREATER,
      [NotEqualCompare]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
      if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false && (texture.magFilter === LinearFilter || texture.magFilter === LinearMipmapNearestFilter || texture.magFilter === NearestMipmapLinearFilter || texture.magFilter === LinearMipmapLinearFilter || texture.minFilter === LinearFilter || texture.minFilter === LinearMipmapNearestFilter || texture.minFilter === NearestMipmapLinearFilter || texture.minFilter === LinearMipmapLinearFilter)) {
        console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.");
      }
      _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
      _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
      if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) {
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
      }
      _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
      _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
      if (texture.compareFunction) {
        _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
        _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
      }
      if (extensions.has("EXT_texture_filter_anisotropic") === true) {
        if (texture.magFilter === NearestFilter) return;
        if (texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter) return;
        if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false) return;
        if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
          const extension = extensions.get("EXT_texture_filter_anisotropic");
          _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
          properties.get(texture).__currentAnisotropy = texture.anisotropy;
        }
      }
    }
    function initTexture(textureProperties, texture) {
      let forceUpload = false;
      if (textureProperties.__webglInit === void 0) {
        textureProperties.__webglInit = true;
        texture.addEventListener("dispose", onTextureDispose);
      }
      const source = texture.source;
      let webglTextures = _sources.get(source);
      if (webglTextures === void 0) {
        webglTextures = {};
        _sources.set(source, webglTextures);
      }
      const textureCacheKey = getTextureCacheKey(texture);
      if (textureCacheKey !== textureProperties.__cacheKey) {
        if (webglTextures[textureCacheKey] === void 0) {
          webglTextures[textureCacheKey] = {
            texture: _gl.createTexture(),
            usedTimes: 0
          };
          info.memory.textures++;
          forceUpload = true;
        }
        webglTextures[textureCacheKey].usedTimes++;
        const webglTexture = webglTextures[textureProperties.__cacheKey];
        if (webglTexture !== void 0) {
          webglTextures[textureProperties.__cacheKey].usedTimes--;
          if (webglTexture.usedTimes === 0) {
            deleteTexture(texture);
          }
        }
        textureProperties.__cacheKey = textureCacheKey;
        textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
      }
      return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
      return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
      const componentStride = 4;
      const updateRanges = texture.updateRanges;
      if (updateRanges.length === 0) {
        state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
      } else {
        updateRanges.sort((a2, b2) => a2.start - b2.start);
        let mergeIndex = 0;
        for (let i2 = 1; i2 < updateRanges.length; i2++) {
          const previousRange = updateRanges[mergeIndex];
          const range = updateRanges[i2];
          const previousEnd = previousRange.start + previousRange.count;
          const currentRow = getRow(range.start, image.width, componentStride);
          const previousRow = getRow(previousRange.start, image.width, componentStride);
          if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow) {
            previousRange.count = Math.max(
              previousRange.count,
              range.start + range.count - previousRange.start
            );
          } else {
            ++mergeIndex;
            updateRanges[mergeIndex] = range;
          }
        }
        updateRanges.length = mergeIndex + 1;
        const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
        const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
        const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
        _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
        for (let i2 = 0, l2 = updateRanges.length; i2 < l2; i2++) {
          const range = updateRanges[i2];
          const pixelStart = Math.floor(range.start / componentStride);
          const pixelCount = Math.ceil(range.count / componentStride);
          const x2 = pixelStart % image.width;
          const y2 = Math.floor(pixelStart / image.width);
          const width = pixelCount;
          const height = 1;
          _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x2);
          _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y2);
          state.texSubImage2D(_gl.TEXTURE_2D, 0, x2, y2, width, height, glFormat, glType, image.data);
        }
        texture.clearUpdateRanges();
        _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
        _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
        _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
      }
    }
    function uploadTexture(textureProperties, texture, slot) {
      let textureType = _gl.TEXTURE_2D;
      if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
      if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
      const forceUpload = initTexture(textureProperties, texture);
      const source = texture.source;
      state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
      const sourceProperties = properties.get(source);
      if (source.version !== sourceProperties.__version || forceUpload === true) {
        state.activeTexture(_gl.TEXTURE0 + slot);
        const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
        const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
        const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
        _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
        _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
        _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
        _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
        let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
        image = verifyColorSpace(texture, image);
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
        setTextureParameters(textureType, texture);
        let mipmap;
        const mipmaps = texture.mipmaps;
        const useTexStorage = texture.isVideoTexture !== true;
        const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
        const dataReady = source.dataReady;
        const levels = getMipLevels(texture, image);
        if (texture.isDepthTexture) {
          glInternalFormat = getInternalDepthFormat(texture.format === DepthStencilFormat, texture.type);
          if (allocateMemory) {
            if (useTexStorage) {
              state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
            } else {
              state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
            }
          }
        } else if (texture.isDataTexture) {
          if (mipmaps.length > 0) {
            if (useTexStorage && allocateMemory) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
            }
            for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
              mipmap = mipmaps[i2];
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
            texture.generateMipmaps = false;
          } else {
            if (useTexStorage) {
              if (allocateMemory) {
                state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
              }
              if (dataReady) {
                updateTexture(texture, image, glFormat, glType);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            }
          }
        } else if (texture.isCompressedTexture) {
          if (texture.isCompressedArrayTexture) {
            if (useTexStorage && allocateMemory) {
              state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
            }
            for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
              mipmap = mipmaps[i2];
              if (texture.format !== RGBAFormat) {
                if (glFormat !== null) {
                  if (useTexStorage) {
                    if (dataReady) {
                      if (texture.layerUpdates.size > 0) {
                        const layerByteLength = getByteLength(mipmap.width, mipmap.height, texture.format, texture.type);
                        for (const layerIndex of texture.layerUpdates) {
                          const layerData = mipmap.data.subarray(
                            layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT,
                            (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT
                          );
                          state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                        }
                        texture.clearLayerUpdates();
                      } else {
                        state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                      }
                    }
                  } else {
                    state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                  }
                } else {
                  console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                }
              } else {
                if (useTexStorage) {
                  if (dataReady) {
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i2, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                  }
                } else {
                  state.texImage3D(_gl.TEXTURE_2D_ARRAY, i2, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                }
              }
            }
          } else {
            if (useTexStorage && allocateMemory) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
            }
            for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
              mipmap = mipmaps[i2];
              if (texture.format !== RGBAFormat) {
                if (glFormat !== null) {
                  if (useTexStorage) {
                    if (dataReady) {
                      state.compressedTexSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                    }
                  } else {
                    state.compressedTexImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                  }
                } else {
                  console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                }
              } else {
                if (useTexStorage) {
                  if (dataReady) {
                    state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                  }
                } else {
                  state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
              }
            }
          }
        } else if (texture.isDataArrayTexture) {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
            }
            if (dataReady) {
              if (texture.layerUpdates.size > 0) {
                const layerByteLength = getByteLength(image.width, image.height, texture.format, texture.type);
                for (const layerIndex of texture.layerUpdates) {
                  const layerData = image.data.subarray(
                    layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT,
                    (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT
                  );
                  state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                }
                texture.clearLayerUpdates();
              } else {
                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
              }
            }
          } else {
            state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
          }
        } else if (texture.isData3DTexture) {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
            }
            if (dataReady) {
              state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
            }
          } else {
            state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
          }
        } else if (texture.isFramebufferTexture) {
          if (allocateMemory) {
            if (useTexStorage) {
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
            } else {
              let width = image.width, height = image.height;
              for (let i2 = 0; i2 < levels; i2++) {
                state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, width, height, 0, glFormat, glType, null);
                width >>= 1;
                height >>= 1;
              }
            }
          }
        } else {
          if (mipmaps.length > 0) {
            if (useTexStorage && allocateMemory) {
              const dimensions = getDimensions(mipmaps[0]);
              state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
            }
            for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
              mipmap = mipmaps[i2];
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, glFormat, glType, mipmap);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, glFormat, glType, mipmap);
              }
            }
            texture.generateMipmaps = false;
          } else {
            if (useTexStorage) {
              if (allocateMemory) {
                const dimensions = getDimensions(image);
                state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
              }
              if (dataReady) {
                state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
              }
            } else {
              state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
          }
        }
        if (textureNeedsGenerateMipmaps(texture)) {
          generateMipmap(textureType);
        }
        sourceProperties.__version = source.version;
        if (texture.onUpdate) texture.onUpdate(texture);
      }
      textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
      if (texture.image.length !== 6) return;
      const forceUpload = initTexture(textureProperties, texture);
      const source = texture.source;
      state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
      const sourceProperties = properties.get(source);
      if (source.version !== sourceProperties.__version || forceUpload === true) {
        state.activeTexture(_gl.TEXTURE0 + slot);
        const workingPrimaries = ColorManagement.getPrimaries(ColorManagement.workingColorSpace);
        const texturePrimaries = texture.colorSpace === NoColorSpace ? null : ColorManagement.getPrimaries(texture.colorSpace);
        const unpackConversion = texture.colorSpace === NoColorSpace || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
        _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
        _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
        _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
        _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
        const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for (let i2 = 0; i2 < 6; i2++) {
          if (!isCompressed && !isDataTexture) {
            cubeImage[i2] = resizeImage(texture.image[i2], true, capabilities.maxCubemapSize);
          } else {
            cubeImage[i2] = isDataTexture ? texture.image[i2].image : texture.image[i2];
          }
          cubeImage[i2] = verifyColorSpace(texture, cubeImage[i2]);
        }
        const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const useTexStorage = texture.isVideoTexture !== true;
        const allocateMemory = sourceProperties.__version === void 0 || forceUpload === true;
        const dataReady = source.dataReady;
        let levels = getMipLevels(texture, image);
        setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
        let mipmaps;
        if (isCompressed) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
          }
          for (let i2 = 0; i2 < 6; i2++) {
            mipmaps = cubeImage[i2].mipmaps;
            for (let j2 = 0; j2 < mipmaps.length; j2++) {
              const mipmap = mipmaps[j2];
              if (texture.format !== RGBAFormat) {
                if (glFormat !== null) {
                  if (useTexStorage) {
                    if (dataReady) {
                      state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                    }
                  } else {
                    state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                  }
                } else {
                  console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                }
              } else {
                if (useTexStorage) {
                  if (dataReady) {
                    state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                  }
                } else {
                  state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
              }
            }
          }
        } else {
          mipmaps = texture.mipmaps;
          if (useTexStorage && allocateMemory) {
            if (mipmaps.length > 0) levels++;
            const dimensions = getDimensions(cubeImage[0]);
            state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
          }
          for (let i2 = 0; i2 < 6; i2++) {
            if (isDataTexture) {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
              }
              for (let j2 = 0; j2 < mipmaps.length; j2++) {
                const mipmap = mipmaps[j2];
                const mipmapImage = mipmap.image[i2].image;
                if (useTexStorage) {
                  if (dataReady) {
                    state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                  }
                } else {
                  state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
              }
            } else {
              if (useTexStorage) {
                if (dataReady) {
                  state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
                }
              } else {
                state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
              }
              for (let j2 = 0; j2 < mipmaps.length; j2++) {
                const mipmap = mipmaps[j2];
                if (useTexStorage) {
                  if (dataReady) {
                    state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, 0, 0, glFormat, glType, mipmap.image[i2]);
                  }
                } else {
                  state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, glInternalFormat, glFormat, glType, mipmap.image[i2]);
                }
              }
            }
          }
        }
        if (textureNeedsGenerateMipmaps(texture)) {
          generateMipmap(_gl.TEXTURE_CUBE_MAP);
        }
        sourceProperties.__version = source.version;
        if (texture.onUpdate) texture.onUpdate(texture);
      }
      textureProperties.__version = texture.version;
    }
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
      const glFormat = utils.convert(texture.format, texture.colorSpace);
      const glType = utils.convert(texture.type);
      const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
      const renderTargetProperties = properties.get(renderTarget);
      const textureProperties = properties.get(texture);
      textureProperties.__renderTarget = renderTarget;
      if (!renderTargetProperties.__hasExternalTextures) {
        const width = Math.max(1, renderTarget.width >> level);
        const height = Math.max(1, renderTarget.height >> level);
        if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) {
          state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
        } else {
          state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
      }
      state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
      } else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) {
        _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
      }
      state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
      _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
      if (renderTarget.depthBuffer) {
        const depthTexture = renderTarget.depthTexture;
        const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
        const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
        const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        const samples = getRenderTargetSamples(renderTarget);
        const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
        if (isUseMultisampledRTT) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else if (isMultisample) {
          _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
      } else {
        const textures = renderTarget.textures;
        for (let i2 = 0; i2 < textures.length; i2++) {
          const texture = textures[i2];
          const glFormat = utils.convert(texture.format, texture.colorSpace);
          const glType = utils.convert(texture.type);
          const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
          const samples = getRenderTargetSamples(renderTarget);
          if (isMultisample && useMultisampledRTT(renderTarget) === false) {
            _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          } else if (useMultisampledRTT(renderTarget)) {
            multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
          } else {
            _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
          }
        }
      }
      _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    function setupDepthTexture(framebuffer, renderTarget) {
      const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
      if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
      state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
      if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
        throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
      }
      const textureProperties = properties.get(renderTarget.depthTexture);
      textureProperties.__renderTarget = renderTarget;
      if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
        renderTarget.depthTexture.image.width = renderTarget.width;
        renderTarget.depthTexture.image.height = renderTarget.height;
        renderTarget.depthTexture.needsUpdate = true;
      }
      setTexture2D(renderTarget.depthTexture, 0);
      const webglDepthTexture = textureProperties.__webglTexture;
      const samples = getRenderTargetSamples(renderTarget);
      if (renderTarget.depthTexture.format === DepthFormat) {
        if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
        } else {
          _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        }
      } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
        if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
        } else {
          _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        }
      } else {
        throw new Error("Unknown depthTexture format");
      }
    }
    function setupDepthRenderbuffer(renderTarget) {
      const renderTargetProperties = properties.get(renderTarget);
      const isCube = renderTarget.isWebGLCubeRenderTarget === true;
      if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
        const depthTexture = renderTarget.depthTexture;
        if (renderTargetProperties.__depthDisposeCallback) {
          renderTargetProperties.__depthDisposeCallback();
        }
        if (depthTexture) {
          const disposeEvent = () => {
            delete renderTargetProperties.__boundDepthTexture;
            delete renderTargetProperties.__depthDisposeCallback;
            depthTexture.removeEventListener("dispose", disposeEvent);
          };
          depthTexture.addEventListener("dispose", disposeEvent);
          renderTargetProperties.__depthDisposeCallback = disposeEvent;
        }
        renderTargetProperties.__boundDepthTexture = depthTexture;
      }
      if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
        if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
        const mipmaps = renderTarget.texture.mipmaps;
        if (mipmaps && mipmaps.length > 0) {
          setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget);
        } else {
          setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        }
      } else {
        if (isCube) {
          renderTargetProperties.__webglDepthbuffer = [];
          for (let i2 = 0; i2 < 6; i2++) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i2]);
            if (renderTargetProperties.__webglDepthbuffer[i2] === void 0) {
              renderTargetProperties.__webglDepthbuffer[i2] = _gl.createRenderbuffer();
              setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i2], renderTarget, false);
            } else {
              const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
              const renderbuffer = renderTargetProperties.__webglDepthbuffer[i2];
              _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
              _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
          }
        } else {
          const mipmaps = renderTarget.texture.mipmaps;
          if (mipmaps && mipmaps.length > 0) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
          } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
          }
          if (renderTargetProperties.__webglDepthbuffer === void 0) {
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
          } else {
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderbuffer = renderTargetProperties.__webglDepthbuffer;
            _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
          }
        }
      }
      state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
      const renderTargetProperties = properties.get(renderTarget);
      if (colorTexture !== void 0) {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
      }
      if (depthTexture !== void 0) {
        setupDepthRenderbuffer(renderTarget);
      }
    }
    function setupRenderTarget(renderTarget) {
      const texture = renderTarget.texture;
      const renderTargetProperties = properties.get(renderTarget);
      const textureProperties = properties.get(texture);
      renderTarget.addEventListener("dispose", onRenderTargetDispose);
      const textures = renderTarget.textures;
      const isCube = renderTarget.isWebGLCubeRenderTarget === true;
      const isMultipleRenderTargets = textures.length > 1;
      if (!isMultipleRenderTargets) {
        if (textureProperties.__webglTexture === void 0) {
          textureProperties.__webglTexture = _gl.createTexture();
        }
        textureProperties.__version = texture.version;
        info.memory.textures++;
      }
      if (isCube) {
        renderTargetProperties.__webglFramebuffer = [];
        for (let i2 = 0; i2 < 6; i2++) {
          if (texture.mipmaps && texture.mipmaps.length > 0) {
            renderTargetProperties.__webglFramebuffer[i2] = [];
            for (let level = 0; level < texture.mipmaps.length; level++) {
              renderTargetProperties.__webglFramebuffer[i2][level] = _gl.createFramebuffer();
            }
          } else {
            renderTargetProperties.__webglFramebuffer[i2] = _gl.createFramebuffer();
          }
        }
      } else {
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          renderTargetProperties.__webglFramebuffer = [];
          for (let level = 0; level < texture.mipmaps.length; level++) {
            renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
          }
        } else {
          renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
        }
        if (isMultipleRenderTargets) {
          for (let i2 = 0, il = textures.length; i2 < il; i2++) {
            const attachmentProperties = properties.get(textures[i2]);
            if (attachmentProperties.__webglTexture === void 0) {
              attachmentProperties.__webglTexture = _gl.createTexture();
              info.memory.textures++;
            }
          }
        }
        if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
          renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
          renderTargetProperties.__webglColorRenderbuffer = [];
          state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
          for (let i2 = 0; i2 < textures.length; i2++) {
            const texture2 = textures[i2];
            renderTargetProperties.__webglColorRenderbuffer[i2] = _gl.createRenderbuffer();
            _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
            const glFormat = utils.convert(texture2.format, texture2.colorSpace);
            const glType = utils.convert(texture2.type);
            const glInternalFormat = getInternalFormat(texture2.internalFormat, glFormat, glType, texture2.colorSpace, renderTarget.isXRRenderTarget === true);
            const samples = getRenderTargetSamples(renderTarget);
            _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
          }
          _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
          if (renderTarget.depthBuffer) {
            renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
          }
          state.bindFramebuffer(_gl.FRAMEBUFFER, null);
        }
      }
      if (isCube) {
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
        setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
        for (let i2 = 0; i2 < 6; i2++) {
          if (texture.mipmaps && texture.mipmaps.length > 0) {
            for (let level = 0; level < texture.mipmaps.length; level++) {
              setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, level);
            }
          } else {
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0);
          }
        }
        if (textureNeedsGenerateMipmaps(texture)) {
          generateMipmap(_gl.TEXTURE_CUBE_MAP);
        }
        state.unbindTexture();
      } else if (isMultipleRenderTargets) {
        for (let i2 = 0, il = textures.length; i2 < il; i2++) {
          const attachment = textures[i2];
          const attachmentProperties = properties.get(attachment);
          state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
          setTextureParameters(_gl.TEXTURE_2D, attachment);
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, 0);
          if (textureNeedsGenerateMipmaps(attachment)) {
            generateMipmap(_gl.TEXTURE_2D);
          }
        }
        state.unbindTexture();
      } else {
        let glTextureType = _gl.TEXTURE_2D;
        if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
          glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
        }
        state.bindTexture(glTextureType, textureProperties.__webglTexture);
        setTextureParameters(glTextureType, texture);
        if (texture.mipmaps && texture.mipmaps.length > 0) {
          for (let level = 0; level < texture.mipmaps.length; level++) {
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
          }
        } else {
          setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
        }
        if (textureNeedsGenerateMipmaps(texture)) {
          generateMipmap(glTextureType);
        }
        state.unbindTexture();
      }
      if (renderTarget.depthBuffer) {
        setupDepthRenderbuffer(renderTarget);
      }
    }
    function updateRenderTargetMipmap(renderTarget) {
      const textures = renderTarget.textures;
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const texture = textures[i2];
        if (textureNeedsGenerateMipmaps(texture)) {
          const targetType = getTargetType(renderTarget);
          const webglTexture = properties.get(texture).__webglTexture;
          state.bindTexture(targetType, webglTexture);
          generateMipmap(targetType);
          state.unbindTexture();
        }
      }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
      if (renderTarget.samples > 0) {
        if (useMultisampledRTT(renderTarget) === false) {
          const textures = renderTarget.textures;
          const width = renderTarget.width;
          const height = renderTarget.height;
          let mask = _gl.COLOR_BUFFER_BIT;
          const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
          const renderTargetProperties = properties.get(renderTarget);
          const isMultipleRenderTargets = textures.length > 1;
          if (isMultipleRenderTargets) {
            for (let i2 = 0; i2 < textures.length; i2++) {
              state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
              _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, null);
              state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
              _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, null, 0);
            }
          }
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
          const mipmaps = renderTarget.texture.mipmaps;
          if (mipmaps && mipmaps.length > 0) {
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
          } else {
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
          }
          for (let i2 = 0; i2 < textures.length; i2++) {
            if (renderTarget.resolveDepthBuffer) {
              if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
              if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
            }
            if (isMultipleRenderTargets) {
              _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
              const webglTexture = properties.get(textures[i2]).__webglTexture;
              _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
            }
            _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
            if (supportsInvalidateFramebuffer === true) {
              invalidationArrayRead.length = 0;
              invalidationArrayDraw.length = 0;
              invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i2);
              if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                invalidationArrayRead.push(depthStyle);
                invalidationArrayDraw.push(depthStyle);
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
              }
              _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
            }
          }
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
          if (isMultipleRenderTargets) {
            for (let i2 = 0; i2 < textures.length; i2++) {
              state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
              _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
              const webglTexture = properties.get(textures[i2]).__webglTexture;
              state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
              _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, webglTexture, 0);
            }
          }
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        } else {
          if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [depthStyle]);
          }
        }
      }
    }
    function getRenderTargetSamples(renderTarget) {
      return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
      const renderTargetProperties = properties.get(renderTarget);
      return renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
      const frame = info.render.frame;
      if (_videoTextures.get(texture) !== frame) {
        _videoTextures.set(texture, frame);
        texture.update();
      }
    }
    function verifyColorSpace(texture, image) {
      const colorSpace = texture.colorSpace;
      const format = texture.format;
      const type = texture.type;
      if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
      if (colorSpace !== LinearSRGBColorSpace && colorSpace !== NoColorSpace) {
        if (ColorManagement.getTransfer(colorSpace) === SRGBTransfer) {
          if (format !== RGBAFormat || type !== UnsignedByteType) {
            console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
          }
        } else {
          console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace);
        }
      }
      return image;
    }
    function getDimensions(image) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement) {
        _imageDimensions.width = image.naturalWidth || image.width;
        _imageDimensions.height = image.naturalHeight || image.height;
      } else if (typeof VideoFrame !== "undefined" && image instanceof VideoFrame) {
        _imageDimensions.width = image.displayWidth;
        _imageDimensions.height = image.displayHeight;
      } else {
        _imageDimensions.width = image.width;
        _imageDimensions.height = image.height;
      }
      return _imageDimensions;
    }
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
  }
  function WebGLUtils(gl, extensions) {
    function convert(p2, colorSpace = NoColorSpace) {
      let extension;
      const transfer = ColorManagement.getTransfer(colorSpace);
      if (p2 === UnsignedByteType) return gl.UNSIGNED_BYTE;
      if (p2 === UnsignedShort4444Type) return gl.UNSIGNED_SHORT_4_4_4_4;
      if (p2 === UnsignedShort5551Type) return gl.UNSIGNED_SHORT_5_5_5_1;
      if (p2 === UnsignedInt5999Type) return gl.UNSIGNED_INT_5_9_9_9_REV;
      if (p2 === ByteType) return gl.BYTE;
      if (p2 === ShortType) return gl.SHORT;
      if (p2 === UnsignedShortType) return gl.UNSIGNED_SHORT;
      if (p2 === IntType) return gl.INT;
      if (p2 === UnsignedIntType) return gl.UNSIGNED_INT;
      if (p2 === FloatType) return gl.FLOAT;
      if (p2 === HalfFloatType) return gl.HALF_FLOAT;
      if (p2 === AlphaFormat) return gl.ALPHA;
      if (p2 === RGBFormat) return gl.RGB;
      if (p2 === RGBAFormat) return gl.RGBA;
      if (p2 === DepthFormat) return gl.DEPTH_COMPONENT;
      if (p2 === DepthStencilFormat) return gl.DEPTH_STENCIL;
      if (p2 === RedFormat) return gl.RED;
      if (p2 === RedIntegerFormat) return gl.RED_INTEGER;
      if (p2 === RGFormat) return gl.RG;
      if (p2 === RGIntegerFormat) return gl.RG_INTEGER;
      if (p2 === RGBAIntegerFormat) return gl.RGBA_INTEGER;
      if (p2 === RGB_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT3_Format || p2 === RGBA_S3TC_DXT5_Format) {
        if (transfer === SRGBTransfer) {
          extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
          if (extension !== null) {
            if (p2 === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
            if (p2 === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
            if (p2 === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
            if (p2 === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
          } else {
            return null;
          }
        } else {
          extension = extensions.get("WEBGL_compressed_texture_s3tc");
          if (extension !== null) {
            if (p2 === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
            if (p2 === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
            if (p2 === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
            if (p2 === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
          } else {
            return null;
          }
        }
      }
      if (p2 === RGB_PVRTC_4BPPV1_Format || p2 === RGB_PVRTC_2BPPV1_Format || p2 === RGBA_PVRTC_4BPPV1_Format || p2 === RGBA_PVRTC_2BPPV1_Format) {
        extension = extensions.get("WEBGL_compressed_texture_pvrtc");
        if (extension !== null) {
          if (p2 === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
          if (p2 === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
          if (p2 === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
          if (p2 === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        } else {
          return null;
        }
      }
      if (p2 === RGB_ETC1_Format || p2 === RGB_ETC2_Format || p2 === RGBA_ETC2_EAC_Format) {
        extension = extensions.get("WEBGL_compressed_texture_etc");
        if (extension !== null) {
          if (p2 === RGB_ETC1_Format || p2 === RGB_ETC2_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
          if (p2 === RGBA_ETC2_EAC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
        } else {
          return null;
        }
      }
      if (p2 === RGBA_ASTC_4x4_Format || p2 === RGBA_ASTC_5x4_Format || p2 === RGBA_ASTC_5x5_Format || p2 === RGBA_ASTC_6x5_Format || p2 === RGBA_ASTC_6x6_Format || p2 === RGBA_ASTC_8x5_Format || p2 === RGBA_ASTC_8x6_Format || p2 === RGBA_ASTC_8x8_Format || p2 === RGBA_ASTC_10x5_Format || p2 === RGBA_ASTC_10x6_Format || p2 === RGBA_ASTC_10x8_Format || p2 === RGBA_ASTC_10x10_Format || p2 === RGBA_ASTC_12x10_Format || p2 === RGBA_ASTC_12x12_Format) {
        extension = extensions.get("WEBGL_compressed_texture_astc");
        if (extension !== null) {
          if (p2 === RGBA_ASTC_4x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
          if (p2 === RGBA_ASTC_5x4_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
          if (p2 === RGBA_ASTC_5x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
          if (p2 === RGBA_ASTC_6x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
          if (p2 === RGBA_ASTC_6x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
          if (p2 === RGBA_ASTC_8x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
          if (p2 === RGBA_ASTC_8x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
          if (p2 === RGBA_ASTC_8x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
          if (p2 === RGBA_ASTC_10x5_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
          if (p2 === RGBA_ASTC_10x6_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
          if (p2 === RGBA_ASTC_10x8_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
          if (p2 === RGBA_ASTC_10x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
          if (p2 === RGBA_ASTC_12x10_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
          if (p2 === RGBA_ASTC_12x12_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
        } else {
          return null;
        }
      }
      if (p2 === RGBA_BPTC_Format || p2 === RGB_BPTC_SIGNED_Format || p2 === RGB_BPTC_UNSIGNED_Format) {
        extension = extensions.get("EXT_texture_compression_bptc");
        if (extension !== null) {
          if (p2 === RGBA_BPTC_Format) return transfer === SRGBTransfer ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
          if (p2 === RGB_BPTC_SIGNED_Format) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
          if (p2 === RGB_BPTC_UNSIGNED_Format) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
        } else {
          return null;
        }
      }
      if (p2 === RED_RGTC1_Format || p2 === SIGNED_RED_RGTC1_Format || p2 === RED_GREEN_RGTC2_Format || p2 === SIGNED_RED_GREEN_RGTC2_Format) {
        extension = extensions.get("EXT_texture_compression_rgtc");
        if (extension !== null) {
          if (p2 === RGBA_BPTC_Format) return extension.COMPRESSED_RED_RGTC1_EXT;
          if (p2 === SIGNED_RED_RGTC1_Format) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
          if (p2 === RED_GREEN_RGTC2_Format) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
          if (p2 === SIGNED_RED_GREEN_RGTC2_Format) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
        } else {
          return null;
        }
      }
      if (p2 === UnsignedInt248Type) return gl.UNSIGNED_INT_24_8;
      return gl[p2] !== void 0 ? gl[p2] : null;
    }
    return { convert };
  }
  const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
  const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
  class WebXRDepthSensing {
    /**
     * Constructs a new depth sensing module.
     */
    constructor() {
      this.texture = null;
      this.mesh = null;
      this.depthNear = 0;
      this.depthFar = 0;
    }
    /**
     * Inits the depth sensing module
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {XRWebGLDepthInformation} depthData - The XR depth data.
     * @param {XRRenderState} renderState - The XR render state.
     */
    init(renderer, depthData, renderState) {
      if (this.texture === null) {
        const texture = new Texture();
        const texProps = renderer.properties.get(texture);
        texProps.__webglTexture = depthData.texture;
        if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
          this.depthNear = depthData.depthNear;
          this.depthFar = depthData.depthFar;
        }
        this.texture = texture;
      }
    }
    /**
     * Returns a plane mesh that visualizes the depth texture.
     *
     * @param {ArrayCamera} cameraXR - The XR camera.
     * @return {?Mesh} The plane mesh.
     */
    getMesh(cameraXR) {
      if (this.texture !== null) {
        if (this.mesh === null) {
          const viewport = cameraXR.cameras[0].viewport;
          const material = new ShaderMaterial({
            vertexShader: _occlusion_vertex,
            fragmentShader: _occlusion_fragment,
            uniforms: {
              depthColor: { value: this.texture },
              depthWidth: { value: viewport.z },
              depthHeight: { value: viewport.w }
            }
          });
          this.mesh = new Mesh(new PlaneGeometry(20, 20), material);
        }
      }
      return this.mesh;
    }
    /**
     * Resets the module
     */
    reset() {
      this.texture = null;
      this.mesh = null;
    }
    /**
     * Returns a texture representing the depth of the user's environment.
     *
     * @return {?Texture} The depth texture.
     */
    getDepthTexture() {
      return this.texture;
    }
  }
  class WebXRManager extends EventDispatcher {
    /**
     * Constructs a new WebGL renderer.
     *
     * @param {WebGLRenderer} renderer - The renderer.
     * @param {WebGL2RenderingContext} gl - The rendering context.
     */
    constructor(renderer, gl) {
      super();
      const scope = this;
      let session = null;
      let framebufferScaleFactor = 1;
      let referenceSpace = null;
      let referenceSpaceType = "local-floor";
      let foveation = 1;
      let customReferenceSpace = null;
      let pose = null;
      let glBinding = null;
      let glProjLayer = null;
      let glBaseLayer = null;
      let xrFrame = null;
      const depthSensing = new WebXRDepthSensing();
      const attributes = gl.getContextAttributes();
      let initialRenderTarget = null;
      let newRenderTarget = null;
      const controllers = [];
      const controllerInputSources = [];
      const currentSize = new Vector2();
      let currentPixelRatio = null;
      const cameraL = new PerspectiveCamera();
      cameraL.viewport = new Vector4();
      const cameraR = new PerspectiveCamera();
      cameraR.viewport = new Vector4();
      const cameras = [cameraL, cameraR];
      const cameraXR = new ArrayCamera();
      let _currentDepthNear = null;
      let _currentDepthFar = null;
      this.cameraAutoUpdate = true;
      this.enabled = false;
      this.isPresenting = false;
      this.getController = function(index) {
        let controller = controllers[index];
        if (controller === void 0) {
          controller = new WebXRController();
          controllers[index] = controller;
        }
        return controller.getTargetRaySpace();
      };
      this.getControllerGrip = function(index) {
        let controller = controllers[index];
        if (controller === void 0) {
          controller = new WebXRController();
          controllers[index] = controller;
        }
        return controller.getGripSpace();
      };
      this.getHand = function(index) {
        let controller = controllers[index];
        if (controller === void 0) {
          controller = new WebXRController();
          controllers[index] = controller;
        }
        return controller.getHandSpace();
      };
      function onSessionEvent(event) {
        const controllerIndex = controllerInputSources.indexOf(event.inputSource);
        if (controllerIndex === -1) {
          return;
        }
        const controller = controllers[controllerIndex];
        if (controller !== void 0) {
          controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
          controller.dispatchEvent({ type: event.type, data: event.inputSource });
        }
      }
      function onSessionEnd() {
        session.removeEventListener("select", onSessionEvent);
        session.removeEventListener("selectstart", onSessionEvent);
        session.removeEventListener("selectend", onSessionEvent);
        session.removeEventListener("squeeze", onSessionEvent);
        session.removeEventListener("squeezestart", onSessionEvent);
        session.removeEventListener("squeezeend", onSessionEvent);
        session.removeEventListener("end", onSessionEnd);
        session.removeEventListener("inputsourceschange", onInputSourcesChange);
        for (let i2 = 0; i2 < controllers.length; i2++) {
          const inputSource = controllerInputSources[i2];
          if (inputSource === null) continue;
          controllerInputSources[i2] = null;
          controllers[i2].disconnect(inputSource);
        }
        _currentDepthNear = null;
        _currentDepthFar = null;
        depthSensing.reset();
        renderer.setRenderTarget(initialRenderTarget);
        glBaseLayer = null;
        glProjLayer = null;
        glBinding = null;
        session = null;
        newRenderTarget = null;
        animation.stop();
        scope.isPresenting = false;
        renderer.setPixelRatio(currentPixelRatio);
        renderer.setSize(currentSize.width, currentSize.height, false);
        scope.dispatchEvent({ type: "sessionend" });
      }
      this.setFramebufferScaleFactor = function(value) {
        framebufferScaleFactor = value;
        if (scope.isPresenting === true) {
          console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }
      };
      this.setReferenceSpaceType = function(value) {
        referenceSpaceType = value;
        if (scope.isPresenting === true) {
          console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }
      };
      this.getReferenceSpace = function() {
        return customReferenceSpace || referenceSpace;
      };
      this.setReferenceSpace = function(space) {
        customReferenceSpace = space;
      };
      this.getBaseLayer = function() {
        return glProjLayer !== null ? glProjLayer : glBaseLayer;
      };
      this.getBinding = function() {
        return glBinding;
      };
      this.getFrame = function() {
        return xrFrame;
      };
      this.getSession = function() {
        return session;
      };
      this.setSession = async function(value) {
        session = value;
        if (session !== null) {
          initialRenderTarget = renderer.getRenderTarget();
          session.addEventListener("select", onSessionEvent);
          session.addEventListener("selectstart", onSessionEvent);
          session.addEventListener("selectend", onSessionEvent);
          session.addEventListener("squeeze", onSessionEvent);
          session.addEventListener("squeezestart", onSessionEvent);
          session.addEventListener("squeezeend", onSessionEvent);
          session.addEventListener("end", onSessionEnd);
          session.addEventListener("inputsourceschange", onInputSourcesChange);
          if (attributes.xrCompatible !== true) {
            await gl.makeXRCompatible();
          }
          currentPixelRatio = renderer.getPixelRatio();
          renderer.getSize(currentSize);
          const useLayers = typeof XRWebGLBinding !== "undefined" && "createProjectionLayer" in XRWebGLBinding.prototype;
          if (!useLayers) {
            const layerInit = {
              antialias: attributes.antialias,
              alpha: true,
              depth: attributes.depth,
              stencil: attributes.stencil,
              framebufferScaleFactor
            };
            glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
            session.updateRenderState({ baseLayer: glBaseLayer });
            renderer.setPixelRatio(1);
            renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
            newRenderTarget = new WebGLRenderTarget(
              glBaseLayer.framebufferWidth,
              glBaseLayer.framebufferHeight,
              {
                format: RGBAFormat,
                type: UnsignedByteType,
                colorSpace: renderer.outputColorSpace,
                stencilBuffer: attributes.stencil,
                resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
              }
            );
          } else {
            let depthFormat = null;
            let depthType = null;
            let glDepthFormat = null;
            if (attributes.depth) {
              glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
              depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
              depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;
            }
            const projectionlayerInit = {
              colorFormat: gl.RGBA8,
              depthFormat: glDepthFormat,
              scaleFactor: framebufferScaleFactor
            };
            glBinding = new XRWebGLBinding(session, gl);
            glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
            session.updateRenderState({ layers: [glProjLayer] });
            renderer.setPixelRatio(1);
            renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
            newRenderTarget = new WebGLRenderTarget(
              glProjLayer.textureWidth,
              glProjLayer.textureHeight,
              {
                format: RGBAFormat,
                type: UnsignedByteType,
                depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, void 0, void 0, void 0, void 0, void 0, void 0, depthFormat),
                stencilBuffer: attributes.stencil,
                colorSpace: renderer.outputColorSpace,
                samples: attributes.antialias ? 4 : 0,
                resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
              }
            );
          }
          newRenderTarget.isXRRenderTarget = true;
          this.setFoveation(foveation);
          customReferenceSpace = null;
          referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
          animation.setContext(session);
          animation.start();
          scope.isPresenting = true;
          scope.dispatchEvent({ type: "sessionstart" });
        }
      };
      this.getEnvironmentBlendMode = function() {
        if (session !== null) {
          return session.environmentBlendMode;
        }
      };
      this.getDepthTexture = function() {
        return depthSensing.getDepthTexture();
      };
      function onInputSourcesChange(event) {
        for (let i2 = 0; i2 < event.removed.length; i2++) {
          const inputSource = event.removed[i2];
          const index = controllerInputSources.indexOf(inputSource);
          if (index >= 0) {
            controllerInputSources[index] = null;
            controllers[index].disconnect(inputSource);
          }
        }
        for (let i2 = 0; i2 < event.added.length; i2++) {
          const inputSource = event.added[i2];
          let controllerIndex = controllerInputSources.indexOf(inputSource);
          if (controllerIndex === -1) {
            for (let i3 = 0; i3 < controllers.length; i3++) {
              if (i3 >= controllerInputSources.length) {
                controllerInputSources.push(inputSource);
                controllerIndex = i3;
                break;
              } else if (controllerInputSources[i3] === null) {
                controllerInputSources[i3] = inputSource;
                controllerIndex = i3;
                break;
              }
            }
            if (controllerIndex === -1) break;
          }
          const controller = controllers[controllerIndex];
          if (controller) {
            controller.connect(inputSource);
          }
        }
      }
      const cameraLPos = new Vector3();
      const cameraRPos = new Vector3();
      function setProjectionFromUnion(camera, cameraL2, cameraR2) {
        cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
        cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
        const ipd = cameraLPos.distanceTo(cameraRPos);
        const projL = cameraL2.projectionMatrix.elements;
        const projR = cameraR2.projectionMatrix.elements;
        const near = projL[14] / (projL[10] - 1);
        const far = projL[14] / (projL[10] + 1);
        const topFov = (projL[9] + 1) / projL[5];
        const bottomFov = (projL[9] - 1) / projL[5];
        const leftFov = (projL[8] - 1) / projL[0];
        const rightFov = (projR[8] + 1) / projR[0];
        const left = near * leftFov;
        const right = near * rightFov;
        const zOffset = ipd / (-leftFov + rightFov);
        const xOffset = zOffset * -leftFov;
        cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
        camera.translateX(xOffset);
        camera.translateZ(zOffset);
        camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        if (projL[10] === -1) {
          camera.projectionMatrix.copy(cameraL2.projectionMatrix);
          camera.projectionMatrixInverse.copy(cameraL2.projectionMatrixInverse);
        } else {
          const near2 = near + zOffset;
          const far2 = far + zOffset;
          const left2 = left - xOffset;
          const right2 = right + (ipd - xOffset);
          const top2 = topFov * far / far2 * near2;
          const bottom2 = bottomFov * far / far2 * near2;
          camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
          camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
      }
      function updateCamera(camera, parent) {
        if (parent === null) {
          camera.matrixWorld.copy(camera.matrix);
        } else {
          camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
        }
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      }
      this.updateCamera = function(camera) {
        if (session === null) return;
        let depthNear = camera.near;
        let depthFar = camera.far;
        if (depthSensing.texture !== null) {
          if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
          if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
        }
        cameraXR.near = cameraR.near = cameraL.near = depthNear;
        cameraXR.far = cameraR.far = cameraL.far = depthFar;
        if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
          session.updateRenderState({
            depthNear: cameraXR.near,
            depthFar: cameraXR.far
          });
          _currentDepthNear = cameraXR.near;
          _currentDepthFar = cameraXR.far;
        }
        cameraL.layers.mask = camera.layers.mask | 2;
        cameraR.layers.mask = camera.layers.mask | 4;
        cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
        const parent = camera.parent;
        const cameras2 = cameraXR.cameras;
        updateCamera(cameraXR, parent);
        for (let i2 = 0; i2 < cameras2.length; i2++) {
          updateCamera(cameras2[i2], parent);
        }
        if (cameras2.length === 2) {
          setProjectionFromUnion(cameraXR, cameraL, cameraR);
        } else {
          cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
        }
        updateUserCamera(camera, cameraXR, parent);
      };
      function updateUserCamera(camera, cameraXR2, parent) {
        if (parent === null) {
          camera.matrix.copy(cameraXR2.matrixWorld);
        } else {
          camera.matrix.copy(parent.matrixWorld);
          camera.matrix.invert();
          camera.matrix.multiply(cameraXR2.matrixWorld);
        }
        camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
        camera.updateMatrixWorld(true);
        camera.projectionMatrix.copy(cameraXR2.projectionMatrix);
        camera.projectionMatrixInverse.copy(cameraXR2.projectionMatrixInverse);
        if (camera.isPerspectiveCamera) {
          camera.fov = RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
          camera.zoom = 1;
        }
      }
      this.getCamera = function() {
        return cameraXR;
      };
      this.getFoveation = function() {
        if (glProjLayer === null && glBaseLayer === null) {
          return void 0;
        }
        return foveation;
      };
      this.setFoveation = function(value) {
        foveation = value;
        if (glProjLayer !== null) {
          glProjLayer.fixedFoveation = value;
        }
        if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
          glBaseLayer.fixedFoveation = value;
        }
      };
      this.hasDepthSensing = function() {
        return depthSensing.texture !== null;
      };
      this.getDepthSensingMesh = function() {
        return depthSensing.getMesh(cameraXR);
      };
      let onAnimationFrameCallback = null;
      function onAnimationFrame(time, frame) {
        pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
        xrFrame = frame;
        if (pose !== null) {
          const views = pose.views;
          if (glBaseLayer !== null) {
            renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
            renderer.setRenderTarget(newRenderTarget);
          }
          let cameraXRNeedsUpdate = false;
          if (views.length !== cameraXR.cameras.length) {
            cameraXR.cameras.length = 0;
            cameraXRNeedsUpdate = true;
          }
          for (let i2 = 0; i2 < views.length; i2++) {
            const view = views[i2];
            let viewport = null;
            if (glBaseLayer !== null) {
              viewport = glBaseLayer.getViewport(view);
            } else {
              const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
              viewport = glSubImage.viewport;
              if (i2 === 0) {
                renderer.setRenderTargetTextures(
                  newRenderTarget,
                  glSubImage.colorTexture,
                  glSubImage.depthStencilTexture
                );
                renderer.setRenderTarget(newRenderTarget);
              }
            }
            let camera = cameras[i2];
            if (camera === void 0) {
              camera = new PerspectiveCamera();
              camera.layers.enable(i2);
              camera.viewport = new Vector4();
              cameras[i2] = camera;
            }
            camera.matrix.fromArray(view.transform.matrix);
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.projectionMatrix.fromArray(view.projectionMatrix);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
            if (i2 === 0) {
              cameraXR.matrix.copy(camera.matrix);
              cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
            }
            if (cameraXRNeedsUpdate === true) {
              cameraXR.cameras.push(camera);
            }
          }
          const enabledFeatures = session.enabledFeatures;
          const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes("depth-sensing") && session.depthUsage == "gpu-optimized";
          if (gpuDepthSensingEnabled && glBinding) {
            const depthData = glBinding.getDepthInformation(views[0]);
            if (depthData && depthData.isValid && depthData.texture) {
              depthSensing.init(renderer, depthData, session.renderState);
            }
          }
        }
        for (let i2 = 0; i2 < controllers.length; i2++) {
          const inputSource = controllerInputSources[i2];
          const controller = controllers[i2];
          if (inputSource !== null && controller !== void 0) {
            controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
          }
        }
        if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
        if (frame.detectedPlanes) {
          scope.dispatchEvent({ type: "planesdetected", data: frame });
        }
        xrFrame = null;
      }
      const animation = new WebGLAnimation();
      animation.setAnimationLoop(onAnimationFrame);
      this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
      };
      this.dispose = function() {
      };
    }
  }
  const _e1 = /* @__PURE__ */ new Euler();
  const _m1 = /* @__PURE__ */ new Matrix4();
  function WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
      if (map.matrixAutoUpdate === true) {
        map.updateMatrix();
      }
      uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
      fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));
      if (fog.isFog) {
        uniforms.fogNear.value = fog.near;
        uniforms.fogFar.value = fog.far;
      } else if (fog.isFogExp2) {
        uniforms.fogDensity.value = fog.density;
      }
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
      if (material.isMeshBasicMaterial) {
        refreshUniformsCommon(uniforms, material);
      } else if (material.isMeshLambertMaterial) {
        refreshUniformsCommon(uniforms, material);
      } else if (material.isMeshToonMaterial) {
        refreshUniformsCommon(uniforms, material);
        refreshUniformsToon(uniforms, material);
      } else if (material.isMeshPhongMaterial) {
        refreshUniformsCommon(uniforms, material);
        refreshUniformsPhong(uniforms, material);
      } else if (material.isMeshStandardMaterial) {
        refreshUniformsCommon(uniforms, material);
        refreshUniformsStandard(uniforms, material);
        if (material.isMeshPhysicalMaterial) {
          refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        }
      } else if (material.isMeshMatcapMaterial) {
        refreshUniformsCommon(uniforms, material);
        refreshUniformsMatcap(uniforms, material);
      } else if (material.isMeshDepthMaterial) {
        refreshUniformsCommon(uniforms, material);
      } else if (material.isMeshDistanceMaterial) {
        refreshUniformsCommon(uniforms, material);
        refreshUniformsDistance(uniforms, material);
      } else if (material.isMeshNormalMaterial) {
        refreshUniformsCommon(uniforms, material);
      } else if (material.isLineBasicMaterial) {
        refreshUniformsLine(uniforms, material);
        if (material.isLineDashedMaterial) {
          refreshUniformsDash(uniforms, material);
        }
      } else if (material.isPointsMaterial) {
        refreshUniformsPoints(uniforms, material, pixelRatio, height);
      } else if (material.isSpriteMaterial) {
        refreshUniformsSprites(uniforms, material);
      } else if (material.isShadowMaterial) {
        uniforms.color.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
      } else if (material.isShaderMaterial) {
        material.uniformsNeedUpdate = false;
      }
    }
    function refreshUniformsCommon(uniforms, material) {
      uniforms.opacity.value = material.opacity;
      if (material.color) {
        uniforms.diffuse.value.copy(material.color);
      }
      if (material.emissive) {
        uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
      }
      if (material.map) {
        uniforms.map.value = material.map;
        refreshTransformUniform(material.map, uniforms.mapTransform);
      }
      if (material.alphaMap) {
        uniforms.alphaMap.value = material.alphaMap;
        refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
      }
      if (material.bumpMap) {
        uniforms.bumpMap.value = material.bumpMap;
        refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
        uniforms.bumpScale.value = material.bumpScale;
        if (material.side === BackSide) {
          uniforms.bumpScale.value *= -1;
        }
      }
      if (material.normalMap) {
        uniforms.normalMap.value = material.normalMap;
        refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
        uniforms.normalScale.value.copy(material.normalScale);
        if (material.side === BackSide) {
          uniforms.normalScale.value.negate();
        }
      }
      if (material.displacementMap) {
        uniforms.displacementMap.value = material.displacementMap;
        refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
        uniforms.displacementScale.value = material.displacementScale;
        uniforms.displacementBias.value = material.displacementBias;
      }
      if (material.emissiveMap) {
        uniforms.emissiveMap.value = material.emissiveMap;
        refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
      }
      if (material.specularMap) {
        uniforms.specularMap.value = material.specularMap;
        refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
      }
      if (material.alphaTest > 0) {
        uniforms.alphaTest.value = material.alphaTest;
      }
      const materialProperties = properties.get(material);
      const envMap = materialProperties.envMap;
      const envMapRotation = materialProperties.envMapRotation;
      if (envMap) {
        uniforms.envMap.value = envMap;
        _e1.copy(envMapRotation);
        _e1.x *= -1;
        _e1.y *= -1;
        _e1.z *= -1;
        if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
          _e1.y *= -1;
          _e1.z *= -1;
        }
        uniforms.envMapRotation.value.setFromMatrix4(_m1.makeRotationFromEuler(_e1));
        uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
        uniforms.reflectivity.value = material.reflectivity;
        uniforms.ior.value = material.ior;
        uniforms.refractionRatio.value = material.refractionRatio;
      }
      if (material.lightMap) {
        uniforms.lightMap.value = material.lightMap;
        uniforms.lightMapIntensity.value = material.lightMapIntensity;
        refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
      }
      if (material.aoMap) {
        uniforms.aoMap.value = material.aoMap;
        uniforms.aoMapIntensity.value = material.aoMapIntensity;
        refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
      }
    }
    function refreshUniformsLine(uniforms, material) {
      uniforms.diffuse.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
      if (material.map) {
        uniforms.map.value = material.map;
        refreshTransformUniform(material.map, uniforms.mapTransform);
      }
    }
    function refreshUniformsDash(uniforms, material) {
      uniforms.dashSize.value = material.dashSize;
      uniforms.totalSize.value = material.dashSize + material.gapSize;
      uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
      uniforms.diffuse.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
      uniforms.size.value = material.size * pixelRatio;
      uniforms.scale.value = height * 0.5;
      if (material.map) {
        uniforms.map.value = material.map;
        refreshTransformUniform(material.map, uniforms.uvTransform);
      }
      if (material.alphaMap) {
        uniforms.alphaMap.value = material.alphaMap;
        refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
      }
      if (material.alphaTest > 0) {
        uniforms.alphaTest.value = material.alphaTest;
      }
    }
    function refreshUniformsSprites(uniforms, material) {
      uniforms.diffuse.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
      uniforms.rotation.value = material.rotation;
      if (material.map) {
        uniforms.map.value = material.map;
        refreshTransformUniform(material.map, uniforms.mapTransform);
      }
      if (material.alphaMap) {
        uniforms.alphaMap.value = material.alphaMap;
        refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
      }
      if (material.alphaTest > 0) {
        uniforms.alphaTest.value = material.alphaTest;
      }
    }
    function refreshUniformsPhong(uniforms, material) {
      uniforms.specular.value.copy(material.specular);
      uniforms.shininess.value = Math.max(material.shininess, 1e-4);
    }
    function refreshUniformsToon(uniforms, material) {
      if (material.gradientMap) {
        uniforms.gradientMap.value = material.gradientMap;
      }
    }
    function refreshUniformsStandard(uniforms, material) {
      uniforms.metalness.value = material.metalness;
      if (material.metalnessMap) {
        uniforms.metalnessMap.value = material.metalnessMap;
        refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
      }
      uniforms.roughness.value = material.roughness;
      if (material.roughnessMap) {
        uniforms.roughnessMap.value = material.roughnessMap;
        refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
      }
      if (material.envMap) {
        uniforms.envMapIntensity.value = material.envMapIntensity;
      }
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
      uniforms.ior.value = material.ior;
      if (material.sheen > 0) {
        uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
        uniforms.sheenRoughness.value = material.sheenRoughness;
        if (material.sheenColorMap) {
          uniforms.sheenColorMap.value = material.sheenColorMap;
          refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
        }
        if (material.sheenRoughnessMap) {
          uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
          refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
        }
      }
      if (material.clearcoat > 0) {
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.clearcoatMap) {
          uniforms.clearcoatMap.value = material.clearcoatMap;
          refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
        }
        if (material.clearcoatRoughnessMap) {
          uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
          refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
        }
        if (material.clearcoatNormalMap) {
          uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
          refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
          uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
          if (material.side === BackSide) {
            uniforms.clearcoatNormalScale.value.negate();
          }
        }
      }
      if (material.dispersion > 0) {
        uniforms.dispersion.value = material.dispersion;
      }
      if (material.iridescence > 0) {
        uniforms.iridescence.value = material.iridescence;
        uniforms.iridescenceIOR.value = material.iridescenceIOR;
        uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
        uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
        if (material.iridescenceMap) {
          uniforms.iridescenceMap.value = material.iridescenceMap;
          refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
        }
        if (material.iridescenceThicknessMap) {
          uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
          refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
        }
      }
      if (material.transmission > 0) {
        uniforms.transmission.value = material.transmission;
        uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
        uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
        if (material.transmissionMap) {
          uniforms.transmissionMap.value = material.transmissionMap;
          refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
        }
        uniforms.thickness.value = material.thickness;
        if (material.thicknessMap) {
          uniforms.thicknessMap.value = material.thicknessMap;
          refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
        }
        uniforms.attenuationDistance.value = material.attenuationDistance;
        uniforms.attenuationColor.value.copy(material.attenuationColor);
      }
      if (material.anisotropy > 0) {
        uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
        if (material.anisotropyMap) {
          uniforms.anisotropyMap.value = material.anisotropyMap;
          refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
        }
      }
      uniforms.specularIntensity.value = material.specularIntensity;
      uniforms.specularColor.value.copy(material.specularColor);
      if (material.specularColorMap) {
        uniforms.specularColorMap.value = material.specularColorMap;
        refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
      }
      if (material.specularIntensityMap) {
        uniforms.specularIntensityMap.value = material.specularIntensityMap;
        refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
      }
    }
    function refreshUniformsMatcap(uniforms, material) {
      if (material.matcap) {
        uniforms.matcap.value = material.matcap;
      }
    }
    function refreshUniformsDistance(uniforms, material) {
      const light = properties.get(material).light;
      uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
      uniforms.nearDistance.value = light.shadow.camera.near;
      uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
      refreshFogUniforms,
      refreshMaterialUniforms
    };
  }
  function WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS);
    function bind(uniformsGroup, program) {
      const webglProgram = program.program;
      state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
      let buffer = buffers[uniformsGroup.id];
      if (buffer === void 0) {
        prepareUniformsGroup(uniformsGroup);
        buffer = createBuffer(uniformsGroup);
        buffers[uniformsGroup.id] = buffer;
        uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
      }
      const webglProgram = program.program;
      state.updateUBOMapping(uniformsGroup, webglProgram);
      const frame = info.render.frame;
      if (updateList[uniformsGroup.id] !== frame) {
        updateBufferData(uniformsGroup);
        updateList[uniformsGroup.id] = frame;
      }
    }
    function createBuffer(uniformsGroup) {
      const bindingPointIndex = allocateBindingPointIndex();
      uniformsGroup.__bindingPointIndex = bindingPointIndex;
      const buffer = gl.createBuffer();
      const size = uniformsGroup.__size;
      const usage = uniformsGroup.usage;
      gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
      gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
      gl.bindBuffer(gl.UNIFORM_BUFFER, null);
      gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
      return buffer;
    }
    function allocateBindingPointIndex() {
      for (let i2 = 0; i2 < maxBindingPoints; i2++) {
        if (allocatedBindingPoints.indexOf(i2) === -1) {
          allocatedBindingPoints.push(i2);
          return i2;
        }
      }
      console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
      return 0;
    }
    function updateBufferData(uniformsGroup) {
      const buffer = buffers[uniformsGroup.id];
      const uniforms = uniformsGroup.uniforms;
      const cache = uniformsGroup.__cache;
      gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
      for (let i2 = 0, il = uniforms.length; i2 < il; i2++) {
        const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
        for (let j2 = 0, jl = uniformArray.length; j2 < jl; j2++) {
          const uniform = uniformArray[j2];
          if (hasUniformChanged(uniform, i2, j2, cache) === true) {
            const offset = uniform.__offset;
            const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
            let arrayOffset = 0;
            for (let k2 = 0; k2 < values.length; k2++) {
              const value = values[k2];
              const info2 = getUniformSize(value);
              if (typeof value === "number" || typeof value === "boolean") {
                uniform.__data[0] = value;
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
              } else if (value.isMatrix3) {
                uniform.__data[0] = value.elements[0];
                uniform.__data[1] = value.elements[1];
                uniform.__data[2] = value.elements[2];
                uniform.__data[3] = 0;
                uniform.__data[4] = value.elements[3];
                uniform.__data[5] = value.elements[4];
                uniform.__data[6] = value.elements[5];
                uniform.__data[7] = 0;
                uniform.__data[8] = value.elements[6];
                uniform.__data[9] = value.elements[7];
                uniform.__data[10] = value.elements[8];
                uniform.__data[11] = 0;
              } else {
                value.toArray(uniform.__data, arrayOffset);
                arrayOffset += info2.storage / Float32Array.BYTES_PER_ELEMENT;
              }
            }
            gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
          }
        }
      }
      gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
      const value = uniform.value;
      const indexString = index + "_" + indexArray;
      if (cache[indexString] === void 0) {
        if (typeof value === "number" || typeof value === "boolean") {
          cache[indexString] = value;
        } else {
          cache[indexString] = value.clone();
        }
        return true;
      } else {
        const cachedObject = cache[indexString];
        if (typeof value === "number" || typeof value === "boolean") {
          if (cachedObject !== value) {
            cache[indexString] = value;
            return true;
          }
        } else {
          if (cachedObject.equals(value) === false) {
            cachedObject.copy(value);
            return true;
          }
        }
      }
      return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
      const uniforms = uniformsGroup.uniforms;
      let offset = 0;
      const chunkSize = 16;
      for (let i2 = 0, l2 = uniforms.length; i2 < l2; i2++) {
        const uniformArray = Array.isArray(uniforms[i2]) ? uniforms[i2] : [uniforms[i2]];
        for (let j2 = 0, jl = uniformArray.length; j2 < jl; j2++) {
          const uniform = uniformArray[j2];
          const values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];
          for (let k2 = 0, kl = values.length; k2 < kl; k2++) {
            const value = values[k2];
            const info2 = getUniformSize(value);
            const chunkOffset2 = offset % chunkSize;
            const chunkPadding = chunkOffset2 % info2.boundary;
            const chunkStart = chunkOffset2 + chunkPadding;
            offset += chunkPadding;
            if (chunkStart !== 0 && chunkSize - chunkStart < info2.storage) {
              offset += chunkSize - chunkStart;
            }
            uniform.__data = new Float32Array(info2.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            offset += info2.storage;
          }
        }
      }
      const chunkOffset = offset % chunkSize;
      if (chunkOffset > 0) offset += chunkSize - chunkOffset;
      uniformsGroup.__size = offset;
      uniformsGroup.__cache = {};
      return this;
    }
    function getUniformSize(value) {
      const info2 = {
        boundary: 0,
        // bytes
        storage: 0
        // bytes
      };
      if (typeof value === "number" || typeof value === "boolean") {
        info2.boundary = 4;
        info2.storage = 4;
      } else if (value.isVector2) {
        info2.boundary = 8;
        info2.storage = 8;
      } else if (value.isVector3 || value.isColor) {
        info2.boundary = 16;
        info2.storage = 12;
      } else if (value.isVector4) {
        info2.boundary = 16;
        info2.storage = 16;
      } else if (value.isMatrix3) {
        info2.boundary = 48;
        info2.storage = 48;
      } else if (value.isMatrix4) {
        info2.boundary = 64;
        info2.storage = 64;
      } else if (value.isTexture) {
        console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
      } else {
        console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
      }
      return info2;
    }
    function onUniformsGroupsDispose(event) {
      const uniformsGroup = event.target;
      uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
      const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
      allocatedBindingPoints.splice(index, 1);
      gl.deleteBuffer(buffers[uniformsGroup.id]);
      delete buffers[uniformsGroup.id];
      delete updateList[uniformsGroup.id];
    }
    function dispose() {
      for (const id in buffers) {
        gl.deleteBuffer(buffers[id]);
      }
      allocatedBindingPoints = [];
      buffers = {};
      updateList = {};
    }
    return {
      bind,
      update,
      dispose
    };
  }
  class WebGLRenderer {
    /**
     * Constructs a new WebGL renderer.
     *
     * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
     */
    constructor(parameters = {}) {
      const {
        canvas = createCanvasElement(),
        context = null,
        depth = true,
        stencil = false,
        alpha = false,
        antialias = false,
        premultipliedAlpha = true,
        preserveDrawingBuffer = false,
        powerPreference = "default",
        failIfMajorPerformanceCaveat = false,
        reverseDepthBuffer = false
      } = parameters;
      this.isWebGLRenderer = true;
      let _alpha;
      if (context !== null) {
        if (typeof WebGLRenderingContext !== "undefined" && context instanceof WebGLRenderingContext) {
          throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
        }
        _alpha = context.getContextAttributes().alpha;
      } else {
        _alpha = alpha;
      }
      const uintClearColor = new Uint32Array(4);
      const intClearColor = new Int32Array(4);
      let currentRenderList = null;
      let currentRenderState = null;
      const renderListStack = [];
      const renderStateStack = [];
      this.domElement = canvas;
      this.debug = {
        /**
         * Enables error checking and reporting when shader programs are being compiled.
         * @type {boolean}
         */
        checkShaderErrors: true,
        /**
         * Callback for custom error reporting.
         * @type {?Function}
         */
        onShaderError: null
      };
      this.autoClear = true;
      this.autoClearColor = true;
      this.autoClearDepth = true;
      this.autoClearStencil = true;
      this.sortObjects = true;
      this.clippingPlanes = [];
      this.localClippingEnabled = false;
      this.toneMapping = NoToneMapping;
      this.toneMappingExposure = 1;
      this.transmissionResolutionScale = 1;
      const _this = this;
      let _isContextLost = false;
      this._outputColorSpace = SRGBColorSpace;
      let _currentActiveCubeFace = 0;
      let _currentActiveMipmapLevel = 0;
      let _currentRenderTarget = null;
      let _currentMaterialId = -1;
      let _currentCamera = null;
      const _currentViewport = new Vector4();
      const _currentScissor = new Vector4();
      let _currentScissorTest = null;
      const _currentClearColor = new Color(0);
      let _currentClearAlpha = 0;
      let _width = canvas.width;
      let _height = canvas.height;
      let _pixelRatio = 1;
      let _opaqueSort = null;
      let _transparentSort = null;
      const _viewport = new Vector4(0, 0, _width, _height);
      const _scissor = new Vector4(0, 0, _width, _height);
      let _scissorTest = false;
      const _frustum = new Frustum();
      let _clippingEnabled = false;
      let _localClippingEnabled = false;
      const _currentProjectionMatrix = new Matrix4();
      const _projScreenMatrix2 = new Matrix4();
      const _vector32 = new Vector3();
      const _vector4 = new Vector4();
      const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
      let _renderBackground = false;
      function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
      }
      let _gl = context;
      function getContext(contextName, contextAttributes) {
        return canvas.getContext(contextName, contextAttributes);
      }
      try {
        const contextAttributes = {
          alpha: true,
          depth,
          stencil,
          antialias,
          premultipliedAlpha,
          preserveDrawingBuffer,
          powerPreference,
          failIfMajorPerformanceCaveat
        };
        if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${REVISION}`);
        canvas.addEventListener("webglcontextlost", onContextLost, false);
        canvas.addEventListener("webglcontextrestored", onContextRestore, false);
        canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
        if (_gl === null) {
          const contextName = "webgl2";
          _gl = getContext(contextName, contextAttributes);
          if (_gl === null) {
            if (getContext(contextName)) {
              throw new Error("Error creating WebGL context with your selected attributes.");
            } else {
              throw new Error("Error creating WebGL context.");
            }
          }
        }
      } catch (error) {
        console.error("THREE.WebGLRenderer: " + error.message);
        throw error;
      }
      let extensions, capabilities, state, info;
      let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
      let programCache, materials, renderLists, renderStates, clipping, shadowMap;
      let background, morphtargets, bufferRenderer, indexedBufferRenderer;
      let utils, bindingStates, uniformsGroups;
      function initGLContext() {
        extensions = new WebGLExtensions(_gl);
        extensions.init();
        utils = new WebGLUtils(_gl, extensions);
        capabilities = new WebGLCapabilities(_gl, extensions, parameters, utils);
        state = new WebGLState(_gl, extensions);
        if (capabilities.reverseDepthBuffer && reverseDepthBuffer) {
          state.buffers.depth.setReversed(true);
        }
        info = new WebGLInfo(_gl);
        properties = new WebGLProperties();
        textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new WebGLCubeMaps(_this);
        cubeuvmaps = new WebGLCubeUVMaps(_this);
        attributes = new WebGLAttributes(_gl);
        bindingStates = new WebGLBindingStates(_gl, attributes);
        geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new WebGLClipping(properties);
        programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new WebGLMaterials(_this, properties);
        renderLists = new WebGLRenderLists();
        renderStates = new WebGLRenderStates(extensions);
        background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
        shadowMap = new WebGLShadowMap(_this, objects, capabilities);
        uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
        bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info);
        indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
      }
      initGLContext();
      const xr2 = new WebXRManager(_this, _gl);
      this.xr = xr2;
      this.getContext = function() {
        return _gl;
      };
      this.getContextAttributes = function() {
        return _gl.getContextAttributes();
      };
      this.forceContextLoss = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.loseContext();
      };
      this.forceContextRestore = function() {
        const extension = extensions.get("WEBGL_lose_context");
        if (extension) extension.restoreContext();
      };
      this.getPixelRatio = function() {
        return _pixelRatio;
      };
      this.setPixelRatio = function(value) {
        if (value === void 0) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
      };
      this.getSize = function(target) {
        return target.set(_width, _height);
      };
      this.setSize = function(width, height, updateStyle = true) {
        if (xr2.isPresenting) {
          console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
          return;
        }
        _width = width;
        _height = height;
        canvas.width = Math.floor(width * _pixelRatio);
        canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle === true) {
          canvas.style.width = width + "px";
          canvas.style.height = height + "px";
        }
        this.setViewport(0, 0, width, height);
      };
      this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
      };
      this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        canvas.width = Math.floor(width * pixelRatio);
        canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
      };
      this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
      };
      this.getViewport = function(target) {
        return target.copy(_viewport);
      };
      this.setViewport = function(x2, y2, width, height) {
        if (x2.isVector4) {
          _viewport.set(x2.x, x2.y, x2.z, x2.w);
        } else {
          _viewport.set(x2, y2, width, height);
        }
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
      };
      this.getScissor = function(target) {
        return target.copy(_scissor);
      };
      this.setScissor = function(x2, y2, width, height) {
        if (x2.isVector4) {
          _scissor.set(x2.x, x2.y, x2.z, x2.w);
        } else {
          _scissor.set(x2, y2, width, height);
        }
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
      };
      this.getScissorTest = function() {
        return _scissorTest;
      };
      this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
      };
      this.setOpaqueSort = function(method) {
        _opaqueSort = method;
      };
      this.setTransparentSort = function(method) {
        _transparentSort = method;
      };
      this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
      };
      this.setClearColor = function() {
        background.setClearColor(...arguments);
      };
      this.getClearAlpha = function() {
        return background.getClearAlpha();
      };
      this.setClearAlpha = function() {
        background.setClearAlpha(...arguments);
      };
      this.clear = function(color = true, depth2 = true, stencil2 = true) {
        let bits = 0;
        if (color) {
          let isIntegerFormat = false;
          if (_currentRenderTarget !== null) {
            const targetFormat = _currentRenderTarget.texture.format;
            isIntegerFormat = targetFormat === RGBAIntegerFormat || targetFormat === RGIntegerFormat || targetFormat === RedIntegerFormat;
          }
          if (isIntegerFormat) {
            const targetType = _currentRenderTarget.texture.type;
            const isUnsignedType = targetType === UnsignedByteType || targetType === UnsignedIntType || targetType === UnsignedShortType || targetType === UnsignedInt248Type || targetType === UnsignedShort4444Type || targetType === UnsignedShort5551Type;
            const clearColor = background.getClearColor();
            const a2 = background.getClearAlpha();
            const r2 = clearColor.r;
            const g2 = clearColor.g;
            const b2 = clearColor.b;
            if (isUnsignedType) {
              uintClearColor[0] = r2;
              uintClearColor[1] = g2;
              uintClearColor[2] = b2;
              uintClearColor[3] = a2;
              _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
            } else {
              intClearColor[0] = r2;
              intClearColor[1] = g2;
              intClearColor[2] = b2;
              intClearColor[3] = a2;
              _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
            }
          } else {
            bits |= _gl.COLOR_BUFFER_BIT;
          }
        }
        if (depth2) {
          bits |= _gl.DEPTH_BUFFER_BIT;
        }
        if (stencil2) {
          bits |= _gl.STENCIL_BUFFER_BIT;
          this.state.buffers.stencil.setMask(4294967295);
        }
        _gl.clear(bits);
      };
      this.clearColor = function() {
        this.clear(true, false, false);
      };
      this.clearDepth = function() {
        this.clear(false, true, false);
      };
      this.clearStencil = function() {
        this.clear(false, false, true);
      };
      this.dispose = function() {
        canvas.removeEventListener("webglcontextlost", onContextLost, false);
        canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
        canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
        background.dispose();
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        uniformsGroups.dispose();
        programCache.dispose();
        xr2.dispose();
        xr2.removeEventListener("sessionstart", onXRSessionStart);
        xr2.removeEventListener("sessionend", onXRSessionEnd);
        animation.stop();
      };
      function onContextLost(event) {
        event.preventDefault();
        console.log("THREE.WebGLRenderer: Context Lost.");
        _isContextLost = true;
      }
      function onContextRestore() {
        console.log("THREE.WebGLRenderer: Context Restored.");
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
      }
      function onContextCreationError(event) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
      }
      function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener("dispose", onMaterialDispose);
        deallocateMaterial(material);
      }
      function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
      }
      function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== void 0) {
          programs.forEach(function(program) {
            programCache.releaseProgram(program);
          });
          if (material.isShaderMaterial) {
            programCache.releaseShaderCache(material);
          }
        }
      }
      this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene;
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        let index = geometry.index;
        let rangeFactor = 1;
        if (material.wireframe === true) {
          index = geometries.getWireframeAttribute(geometry);
          if (index === void 0) return;
          rangeFactor = 2;
        }
        const drawRange = geometry.drawRange;
        const position = geometry.attributes.position;
        let drawStart = drawRange.start * rangeFactor;
        let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
        if (group !== null) {
          drawStart = Math.max(drawStart, group.start * rangeFactor);
          drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
        }
        if (index !== null) {
          drawStart = Math.max(drawStart, 0);
          drawEnd = Math.min(drawEnd, index.count);
        } else if (position !== void 0 && position !== null) {
          drawStart = Math.max(drawStart, 0);
          drawEnd = Math.min(drawEnd, position.count);
        }
        const drawCount = drawEnd - drawStart;
        if (drawCount < 0 || drawCount === Infinity) return;
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
          attribute = attributes.get(index);
          renderer = indexedBufferRenderer;
          renderer.setIndex(attribute);
        }
        if (object.isMesh) {
          if (material.wireframe === true) {
            state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
            renderer.setMode(_gl.LINES);
          } else {
            renderer.setMode(_gl.TRIANGLES);
          }
        } else if (object.isLine) {
          let lineWidth = material.linewidth;
          if (lineWidth === void 0) lineWidth = 1;
          state.setLineWidth(lineWidth * getTargetPixelRatio());
          if (object.isLineSegments) {
            renderer.setMode(_gl.LINES);
          } else if (object.isLineLoop) {
            renderer.setMode(_gl.LINE_LOOP);
          } else {
            renderer.setMode(_gl.LINE_STRIP);
          }
        } else if (object.isPoints) {
          renderer.setMode(_gl.POINTS);
        } else if (object.isSprite) {
          renderer.setMode(_gl.TRIANGLES);
        }
        if (object.isBatchedMesh) {
          if (object._multiDrawInstances !== null) {
            warnOnce("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.");
            renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
          } else {
            if (!extensions.get("WEBGL_multi_draw")) {
              const starts = object._multiDrawStarts;
              const counts = object._multiDrawCounts;
              const drawCount2 = object._multiDrawCount;
              const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
              const uniforms = properties.get(material).currentProgram.getUniforms();
              for (let i2 = 0; i2 < drawCount2; i2++) {
                uniforms.setValue(_gl, "_gl_DrawID", i2);
                renderer.render(starts[i2] / bytesPerElement, counts[i2]);
              }
            } else {
              renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            }
          }
        } else if (object.isInstancedMesh) {
          renderer.renderInstances(drawStart, drawCount, object.count);
        } else if (geometry.isInstancedBufferGeometry) {
          const maxInstanceCount = geometry._maxInstanceCount !== void 0 ? geometry._maxInstanceCount : Infinity;
          const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
          renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else {
          renderer.render(drawStart, drawCount);
        }
      };
      function prepareMaterial(material, scene, object) {
        if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
          material.side = BackSide;
          material.needsUpdate = true;
          getProgram(material, scene, object);
          material.side = FrontSide;
          material.needsUpdate = true;
          getProgram(material, scene, object);
          material.side = DoubleSide;
        } else {
          getProgram(material, scene, object);
        }
      }
      this.compile = function(scene, camera, targetScene = null) {
        if (targetScene === null) targetScene = scene;
        currentRenderState = renderStates.get(targetScene);
        currentRenderState.init(camera);
        renderStateStack.push(currentRenderState);
        targetScene.traverseVisible(function(object) {
          if (object.isLight && object.layers.test(camera.layers)) {
            currentRenderState.pushLight(object);
            if (object.castShadow) {
              currentRenderState.pushShadow(object);
            }
          }
        });
        if (scene !== targetScene) {
          scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
              currentRenderState.pushLight(object);
              if (object.castShadow) {
                currentRenderState.pushShadow(object);
              }
            }
          });
        }
        currentRenderState.setupLights();
        const materials2 = /* @__PURE__ */ new Set();
        scene.traverse(function(object) {
          if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) {
            return;
          }
          const material = object.material;
          if (material) {
            if (Array.isArray(material)) {
              for (let i2 = 0; i2 < material.length; i2++) {
                const material2 = material[i2];
                prepareMaterial(material2, targetScene, object);
                materials2.add(material2);
              }
            } else {
              prepareMaterial(material, targetScene, object);
              materials2.add(material);
            }
          }
        });
        currentRenderState = renderStateStack.pop();
        return materials2;
      };
      this.compileAsync = function(scene, camera, targetScene = null) {
        const materials2 = this.compile(scene, camera, targetScene);
        return new Promise((resolve) => {
          function checkMaterialsReady() {
            materials2.forEach(function(material) {
              const materialProperties = properties.get(material);
              const program = materialProperties.currentProgram;
              if (program.isReady()) {
                materials2.delete(material);
              }
            });
            if (materials2.size === 0) {
              resolve(scene);
              return;
            }
            setTimeout(checkMaterialsReady, 10);
          }
          if (extensions.get("KHR_parallel_shader_compile") !== null) {
            checkMaterialsReady();
          } else {
            setTimeout(checkMaterialsReady, 10);
          }
        });
      };
      let onAnimationFrameCallback = null;
      function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
      }
      function onXRSessionStart() {
        animation.stop();
      }
      function onXRSessionEnd() {
        animation.start();
      }
      const animation = new WebGLAnimation();
      animation.setAnimationLoop(onAnimationFrame);
      if (typeof self !== "undefined") animation.setContext(self);
      this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr2.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
      };
      xr2.addEventListener("sessionstart", onXRSessionStart);
      xr2.addEventListener("sessionend", onXRSessionEnd);
      this.render = function(scene, camera) {
        if (camera !== void 0 && camera.isCamera !== true) {
          console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
          return;
        }
        if (_isContextLost === true) return;
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        if (xr2.enabled === true && xr2.isPresenting === true) {
          if (xr2.cameraAutoUpdate === true) xr2.updateCamera(camera);
          camera = xr2.getCamera();
        }
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init(camera);
        renderStateStack.push(currentRenderState);
        _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix2);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        if (xr2.enabled === true && xr2.isPresenting === true) {
          const depthSensingMesh = _this.xr.getDepthSensingMesh();
          if (depthSensingMesh !== null) {
            projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
          }
        }
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) {
          currentRenderList.sort(_opaqueSort, _transparentSort);
        }
        _renderBackground = xr2.enabled === false || xr2.isPresenting === false || xr2.hasDepthSensing() === false;
        if (_renderBackground) {
          background.addToRenderList(currentRenderList, scene);
        }
        this.info.render.frame++;
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        if (this.info.autoReset === true) this.info.reset();
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        currentRenderState.setupLights();
        if (camera.isArrayCamera) {
          const cameras = camera.cameras;
          if (transmissiveObjects.length > 0) {
            for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
              const camera2 = cameras[i2];
              renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
            }
          }
          if (_renderBackground) background.render(scene);
          for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
            const camera2 = cameras[i2];
            renderScene(currentRenderList, scene, camera2, camera2.viewport);
          }
        } else {
          if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
          if (_renderBackground) background.render(scene);
          renderScene(currentRenderList, scene, camera);
        }
        if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
          textures.updateMultisampleRenderTarget(_currentRenderTarget);
          textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) {
          currentRenderState = renderStateStack[renderStateStack.length - 1];
          if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
        } else {
          currentRenderState = null;
        }
        renderListStack.pop();
        if (renderListStack.length > 0) {
          currentRenderList = renderListStack[renderListStack.length - 1];
        } else {
          currentRenderList = null;
        }
      };
      function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
          if (object.isGroup) {
            groupOrder = object.renderOrder;
          } else if (object.isLOD) {
            if (object.autoUpdate === true) object.update(camera);
          } else if (object.isLight) {
            currentRenderState.pushLight(object);
            if (object.castShadow) {
              currentRenderState.pushShadow(object);
            }
          } else if (object.isSprite) {
            if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
              if (sortObjects) {
                _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
              }
              const geometry = objects.update(object);
              const material = object.material;
              if (material.visible) {
                currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
              }
            }
          } else if (object.isMesh || object.isLine || object.isPoints) {
            if (!object.frustumCulled || _frustum.intersectsObject(object)) {
              const geometry = objects.update(object);
              const material = object.material;
              if (sortObjects) {
                if (object.boundingSphere !== void 0) {
                  if (object.boundingSphere === null) object.computeBoundingSphere();
                  _vector4.copy(object.boundingSphere.center);
                } else {
                  if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                  _vector4.copy(geometry.boundingSphere.center);
                }
                _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix2);
              }
              if (Array.isArray(material)) {
                const groups = geometry.groups;
                for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
                  const group = groups[i2];
                  const groupMaterial = material[group.materialIndex];
                  if (groupMaterial && groupMaterial.visible) {
                    currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                  }
                }
              } else if (material.visible) {
                currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
              }
            }
          }
        }
        const children = object.children;
        for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
          projectObject(children[i2], camera, groupOrder, sortObjects);
        }
      }
      function renderScene(currentRenderList2, scene, camera, viewport) {
        const opaqueObjects = currentRenderList2.opaque;
        const transmissiveObjects = currentRenderList2.transmissive;
        const transparentObjects = currentRenderList2.transparent;
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
      }
      function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        if (overrideMaterial !== null) {
          return;
        }
        if (currentRenderState.state.transmissionRenderTarget[camera.id] === void 0) {
          currentRenderState.state.transmissionRenderTarget[camera.id] = new WebGLRenderTarget(1, 1, {
            generateMipmaps: true,
            type: extensions.has("EXT_color_buffer_half_float") || extensions.has("EXT_color_buffer_float") ? HalfFloatType : UnsignedByteType,
            minFilter: LinearMipmapLinearFilter,
            samples: 4,
            stencilBuffer: stencil,
            resolveDepthBuffer: false,
            resolveStencilBuffer: false,
            colorSpace: ColorManagement.workingColorSpace
          });
        }
        const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
        const activeViewport = camera.viewport || _currentViewport;
        transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
        const currentRenderTarget = _this.getRenderTarget();
        const currentActiveCubeFace = _this.getActiveCubeFace();
        const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
        _this.setRenderTarget(transmissionRenderTarget);
        _this.getClearColor(_currentClearColor);
        _currentClearAlpha = _this.getClearAlpha();
        if (_currentClearAlpha < 1) _this.setClearColor(16777215, 0.5);
        _this.clear();
        if (_renderBackground) background.render(scene);
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = NoToneMapping;
        const currentCameraViewport = camera.viewport;
        if (camera.viewport !== void 0) camera.viewport = void 0;
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
        renderObjects(opaqueObjects, scene, camera);
        textures.updateMultisampleRenderTarget(transmissionRenderTarget);
        textures.updateRenderTargetMipmap(transmissionRenderTarget);
        if (extensions.has("WEBGL_multisampled_render_to_texture") === false) {
          let renderTargetNeedsUpdate = false;
          for (let i2 = 0, l2 = transmissiveObjects.length; i2 < l2; i2++) {
            const renderItem = transmissiveObjects[i2];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = renderItem.material;
            const group = renderItem.group;
            if (material.side === DoubleSide && object.layers.test(camera.layers)) {
              const currentSide = material.side;
              material.side = BackSide;
              material.needsUpdate = true;
              renderObject(object, scene, camera, geometry, material, group);
              material.side = currentSide;
              material.needsUpdate = true;
              renderTargetNeedsUpdate = true;
            }
          }
          if (renderTargetNeedsUpdate === true) {
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
          }
        }
        _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        _this.setClearColor(_currentClearColor, _currentClearAlpha);
        if (currentCameraViewport !== void 0) camera.viewport = currentCameraViewport;
        _this.toneMapping = currentToneMapping;
      }
      function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for (let i2 = 0, l2 = renderList.length; i2 < l2; i2++) {
          const renderItem = renderList[i2];
          const object = renderItem.object;
          const geometry = renderItem.geometry;
          const group = renderItem.group;
          let material = renderItem.material;
          if (material.allowOverride === true && overrideMaterial !== null) {
            material = overrideMaterial;
          }
          if (object.layers.test(camera.layers)) {
            renderObject(object, scene, camera, geometry, material, group);
          }
        }
      }
      function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {
          material.side = BackSide;
          material.needsUpdate = true;
          _this.renderBufferDirect(camera, scene, geometry, material, object, group);
          material.side = FrontSide;
          material.needsUpdate = true;
          _this.renderBufferDirect(camera, scene, geometry, material, object, group);
          material.side = DoubleSide;
        } else {
          _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        }
        object.onAfterRender(_this, scene, camera, geometry, material, group);
      }
      function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters2 = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters2);
        let programs = materialProperties.programs;
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
        if (programs === void 0) {
          material.addEventListener("dispose", onMaterialDispose);
          programs = /* @__PURE__ */ new Map();
          materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== void 0) {
          if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
            updateCommonMaterialProperties(material, parameters2);
            return program;
          }
        } else {
          parameters2.uniforms = programCache.getUniforms(material);
          material.onBeforeCompile(parameters2, _this);
          program = programCache.acquireProgram(parameters2, programCacheKey);
          programs.set(programCacheKey, program);
          materialProperties.uniforms = parameters2.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
          uniforms.clippingPlanes = clipping.uniform;
        }
        updateCommonMaterialProperties(material, parameters2);
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
          uniforms.ambientLightColor.value = lights.state.ambient;
          uniforms.lightProbe.value = lights.state.probe;
          uniforms.directionalLights.value = lights.state.directional;
          uniforms.directionalLightShadows.value = lights.state.directionalShadow;
          uniforms.spotLights.value = lights.state.spot;
          uniforms.spotLightShadows.value = lights.state.spotShadow;
          uniforms.rectAreaLights.value = lights.state.rectArea;
          uniforms.ltc_1.value = lights.state.rectAreaLTC1;
          uniforms.ltc_2.value = lights.state.rectAreaLTC2;
          uniforms.pointLights.value = lights.state.point;
          uniforms.pointLightShadows.value = lights.state.pointShadow;
          uniforms.hemisphereLights.value = lights.state.hemi;
          uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
          uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
          uniforms.spotShadowMap.value = lights.state.spotShadowMap;
          uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
          uniforms.spotLightMap.value = lights.state.spotLightMap;
          uniforms.pointShadowMap.value = lights.state.pointShadowMap;
          uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        }
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = null;
        return program;
      }
      function getUniformList(materialProperties) {
        if (materialProperties.uniformsList === null) {
          const progUniforms = materialProperties.currentProgram.getUniforms();
          materialProperties.uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
        }
        return materialProperties.uniformsList;
      }
      function updateCommonMaterialProperties(material, parameters2) {
        const materialProperties = properties.get(material);
        materialProperties.outputColorSpace = parameters2.outputColorSpace;
        materialProperties.batching = parameters2.batching;
        materialProperties.batchingColor = parameters2.batchingColor;
        materialProperties.instancing = parameters2.instancing;
        materialProperties.instancingColor = parameters2.instancingColor;
        materialProperties.instancingMorph = parameters2.instancingMorph;
        materialProperties.skinning = parameters2.skinning;
        materialProperties.morphTargets = parameters2.morphTargets;
        materialProperties.morphNormals = parameters2.morphNormals;
        materialProperties.morphColors = parameters2.morphColors;
        materialProperties.morphTargetsCount = parameters2.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
        materialProperties.numIntersection = parameters2.numClipIntersection;
        materialProperties.vertexAlphas = parameters2.vertexAlphas;
        materialProperties.vertexTangents = parameters2.vertexTangents;
        materialProperties.toneMapping = parameters2.toneMapping;
      }
      function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene;
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : LinearSRGBColorSpace;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphColors = !!geometry.morphAttributes.color;
        let toneMapping = NoToneMapping;
        if (material.toneMapped) {
          if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) {
            toneMapping = _this.toneMapping;
          }
        }
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
          if (_localClippingEnabled === true || camera !== _currentCamera) {
            const useCache = camera === _currentCamera && material.id === _currentMaterialId;
            clipping.setState(material, camera, useCache);
          }
        }
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
          if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
            needsProgramChange = true;
          } else if (materialProperties.outputColorSpace !== colorSpace) {
            needsProgramChange = true;
          } else if (object.isBatchedMesh && materialProperties.batching === false) {
            needsProgramChange = true;
          } else if (!object.isBatchedMesh && materialProperties.batching === true) {
            needsProgramChange = true;
          } else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) {
            needsProgramChange = true;
          } else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) {
            needsProgramChange = true;
          } else if (object.isInstancedMesh && materialProperties.instancing === false) {
            needsProgramChange = true;
          } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
            needsProgramChange = true;
          } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
            needsProgramChange = true;
          } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
            needsProgramChange = true;
          } else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) {
            needsProgramChange = true;
          } else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) {
            needsProgramChange = true;
          } else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) {
            needsProgramChange = true;
          } else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) {
            needsProgramChange = true;
          } else if (materialProperties.envMap !== envMap) {
            needsProgramChange = true;
          } else if (material.fog === true && materialProperties.fog !== fog) {
            needsProgramChange = true;
          } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
            needsProgramChange = true;
          } else if (materialProperties.vertexAlphas !== vertexAlphas) {
            needsProgramChange = true;
          } else if (materialProperties.vertexTangents !== vertexTangents) {
            needsProgramChange = true;
          } else if (materialProperties.morphTargets !== morphTargets) {
            needsProgramChange = true;
          } else if (materialProperties.morphNormals !== morphNormals) {
            needsProgramChange = true;
          } else if (materialProperties.morphColors !== morphColors) {
            needsProgramChange = true;
          } else if (materialProperties.toneMapping !== toneMapping) {
            needsProgramChange = true;
          } else if (materialProperties.morphTargetsCount !== morphTargetsCount) {
            needsProgramChange = true;
          }
        } else {
          needsProgramChange = true;
          materialProperties.__version = material.version;
        }
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) {
          program = getProgram(material, scene, object);
        }
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
          refreshProgram = true;
          refreshMaterial = true;
          refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
          _currentMaterialId = material.id;
          refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
          const reverseDepthBuffer2 = state.buffers.depth.getReversed();
          if (reverseDepthBuffer2) {
            _currentProjectionMatrix.copy(camera.projectionMatrix);
            toNormalizedProjectionMatrix(_currentProjectionMatrix);
            toReversedProjectionMatrix(_currentProjectionMatrix);
            p_uniforms.setValue(_gl, "projectionMatrix", _currentProjectionMatrix);
          } else {
            p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
          }
          p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
          const uCamPos = p_uniforms.map.cameraPosition;
          if (uCamPos !== void 0) {
            uCamPos.setValue(_gl, _vector32.setFromMatrixPosition(camera.matrixWorld));
          }
          if (capabilities.logarithmicDepthBuffer) {
            p_uniforms.setValue(
              _gl,
              "logDepthBufFC",
              2 / (Math.log(camera.far + 1) / Math.LN2)
            );
          }
          if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
            p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
          }
          if (_currentCamera !== camera) {
            _currentCamera = camera;
            refreshMaterial = true;
            refreshLights = true;
          }
        }
        if (object.isSkinnedMesh) {
          p_uniforms.setOptional(_gl, object, "bindMatrix");
          p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
          const skeleton = object.skeleton;
          if (skeleton) {
            if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
            p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
          }
        }
        if (object.isBatchedMesh) {
          p_uniforms.setOptional(_gl, object, "batchingTexture");
          p_uniforms.setValue(_gl, "batchingTexture", object._matricesTexture, textures);
          p_uniforms.setOptional(_gl, object, "batchingIdTexture");
          p_uniforms.setValue(_gl, "batchingIdTexture", object._indirectTexture, textures);
          p_uniforms.setOptional(_gl, object, "batchingColorTexture");
          if (object._colorsTexture !== null) {
            p_uniforms.setValue(_gl, "batchingColorTexture", object._colorsTexture, textures);
          }
        }
        const morphAttributes = geometry.morphAttributes;
        if (morphAttributes.position !== void 0 || morphAttributes.normal !== void 0 || morphAttributes.color !== void 0) {
          morphtargets.update(object, geometry, program);
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
          materialProperties.receiveShadow = object.receiveShadow;
          p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
        }
        if (material.isMeshGouraudMaterial && material.envMap !== null) {
          m_uniforms.envMap.value = envMap;
          m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
        }
        if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) {
          m_uniforms.envMapIntensity.value = scene.environmentIntensity;
        }
        if (refreshMaterial) {
          p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
          if (materialProperties.needsLights) {
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
          }
          if (fog && material.fog === true) {
            materials.refreshFogUniforms(m_uniforms, fog);
          }
          materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
          WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
          WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
          material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) {
          p_uniforms.setValue(_gl, "center", object.center);
        }
        p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
        p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
        p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
        if (material.isShaderMaterial || material.isRawShaderMaterial) {
          const groups = material.uniformsGroups;
          for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
            const group = groups[i2];
            uniformsGroups.update(group, program);
            uniformsGroups.bind(group, program);
          }
        }
        return program;
      }
      function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
      }
      function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
      }
      this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
      };
      this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
      };
      this.getRenderTarget = function() {
        return _currentRenderTarget;
      };
      this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
        if (renderTargetProperties.__autoAllocateDepthBuffer === false) {
          renderTargetProperties.__useRenderToTexture = false;
        }
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? void 0 : depthTexture;
        renderTargetProperties.__hasExternalTextures = true;
      };
      this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === void 0;
      };
      const _scratchFrameBuffer = _gl.createFramebuffer();
      this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
          const renderTargetProperties = properties.get(renderTarget);
          if (renderTargetProperties.__useDefaultFramebuffer !== void 0) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            useDefaultFramebuffer = false;
          } else if (renderTargetProperties.__webglFramebuffer === void 0) {
            textures.setupRenderTarget(renderTarget);
          } else if (renderTargetProperties.__hasExternalTextures) {
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
          } else if (renderTarget.depthBuffer) {
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
              if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) {
                throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
              }
              textures.setupDepthRenderbuffer(renderTarget);
            }
          }
          const texture = renderTarget.texture;
          if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
            isRenderTarget3D = true;
          }
          const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
          if (renderTarget.isWebGLCubeRenderTarget) {
            if (Array.isArray(__webglFramebuffer[activeCubeFace])) {
              framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
            } else {
              framebuffer = __webglFramebuffer[activeCubeFace];
            }
            isCube = true;
          } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
            framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
          } else {
            if (Array.isArray(__webglFramebuffer)) {
              framebuffer = __webglFramebuffer[activeMipmapLevel];
            } else {
              framebuffer = __webglFramebuffer;
            }
          }
          _currentViewport.copy(renderTarget.viewport);
          _currentScissor.copy(renderTarget.scissor);
          _currentScissorTest = renderTarget.scissorTest;
        } else {
          _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
          _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
          _currentScissorTest = _scissorTest;
        }
        if (activeMipmapLevel !== 0) {
          framebuffer = _scratchFrameBuffer;
        }
        const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (framebufferBound && useDefaultFramebuffer) {
          state.drawBuffers(renderTarget, framebuffer);
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
          const textureProperties = properties.get(renderTarget.texture);
          _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
          const textureProperties = properties.get(renderTarget.texture);
          const layer = activeCubeFace;
          _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
        } else if (renderTarget !== null && activeMipmapLevel !== 0) {
          const textureProperties = properties.get(renderTarget.texture);
          _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
        }
        _currentMaterialId = -1;
      };
      this.readRenderTargetPixels = function(renderTarget, x2, y2, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
          return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
          framebuffer = framebuffer[activeCubeFaceIndex];
        }
        if (framebuffer) {
          state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
          try {
            const texture = renderTarget.textures[textureIndex];
            const textureFormat = texture.format;
            const textureType = texture.type;
            if (!capabilities.textureFormatReadable(textureFormat)) {
              console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
              return;
            }
            if (!capabilities.textureTypeReadable(textureType)) {
              console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
              return;
            }
            if (x2 >= 0 && x2 <= renderTarget.width - width && (y2 >= 0 && y2 <= renderTarget.height - height)) {
              if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
              _gl.readPixels(x2, y2, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
            }
          } finally {
            const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
            state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer2);
          }
        }
      };
      this.readRenderTargetPixelsAsync = async function(renderTarget, x2, y2, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
          throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
          framebuffer = framebuffer[activeCubeFaceIndex];
        }
        if (framebuffer) {
          if (x2 >= 0 && x2 <= renderTarget.width - width && (y2 >= 0 && y2 <= renderTarget.height - height)) {
            state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            const texture = renderTarget.textures[textureIndex];
            const textureFormat = texture.format;
            const textureType = texture.type;
            if (!capabilities.textureFormatReadable(textureFormat)) {
              throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
            }
            if (!capabilities.textureTypeReadable(textureType)) {
              throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
            }
            const glBuffer = _gl.createBuffer();
            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
            _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
            if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
            _gl.readPixels(x2, y2, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
            const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
            state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
            const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
            _gl.flush();
            await probeAsync(_gl, sync, 4);
            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
            _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
            _gl.deleteBuffer(glBuffer);
            _gl.deleteSync(sync);
            return buffer;
          } else {
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
          }
        }
      };
      this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        const x2 = position !== null ? position.x : 0;
        const y2 = position !== null ? position.y : 0;
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x2, y2, width, height);
        state.unbindTexture();
      };
      const _srcFramebuffer = _gl.createFramebuffer();
      const _dstFramebuffer = _gl.createFramebuffer();
      this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
        if (dstLevel === null) {
          if (srcLevel !== 0) {
            warnOnce("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.");
            dstLevel = srcLevel;
            srcLevel = 0;
          } else {
            dstLevel = 0;
          }
        }
        let width, height, depth2, minX, minY, minZ;
        let dstX, dstY, dstZ;
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
        if (srcRegion !== null) {
          width = srcRegion.max.x - srcRegion.min.x;
          height = srcRegion.max.y - srcRegion.min.y;
          depth2 = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
          minX = srcRegion.min.x;
          minY = srcRegion.min.y;
          minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
        } else {
          const levelScale = Math.pow(2, -srcLevel);
          width = Math.floor(image.width * levelScale);
          height = Math.floor(image.height * levelScale);
          if (srcTexture.isDataArrayTexture) {
            depth2 = image.depth;
          } else if (srcTexture.isData3DTexture) {
            depth2 = Math.floor(image.depth * levelScale);
          } else {
            depth2 = 1;
          }
          minX = 0;
          minY = 0;
          minZ = 0;
        }
        if (dstPosition !== null) {
          dstX = dstPosition.x;
          dstY = dstPosition.y;
          dstZ = dstPosition.z;
        } else {
          dstX = 0;
          dstY = 0;
          dstZ = 0;
        }
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isData3DTexture) {
          textures.setTexture3D(dstTexture, 0);
          glTarget = _gl.TEXTURE_3D;
        } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
          textures.setTexture2DArray(dstTexture, 0);
          glTarget = _gl.TEXTURE_2D_ARRAY;
        } else {
          textures.setTexture2D(dstTexture, 0);
          glTarget = _gl.TEXTURE_2D;
        }
        _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
        _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
        const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
        const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
        const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
        const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
        const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
        _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
        _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
        _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
        _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
        _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
        const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
        const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
        if (srcTexture.isDepthTexture) {
          const srcTextureProperties = properties.get(srcTexture);
          const dstTextureProperties = properties.get(dstTexture);
          const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
          const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
          for (let i2 = 0; i2 < depth2; i2++) {
            if (isSrc3D) {
              _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i2);
              _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i2);
            }
            _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
          }
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
        } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
          const srcTextureProperties = properties.get(srcTexture);
          const dstTextureProperties = properties.get(dstTexture);
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
          for (let i2 = 0; i2 < depth2; i2++) {
            if (isSrc3D) {
              _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i2);
            } else {
              _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
            }
            if (isDst3D) {
              _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i2);
            } else {
              _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
            }
            if (srcLevel !== 0) {
              _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
            } else if (isDst3D) {
              _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i2, minX, minY, width, height);
            } else {
              _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
            }
          }
          state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
          state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
        } else {
          if (isDst3D) {
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
              _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image.data);
            } else if (dstTexture.isCompressedArrayTexture) {
              _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, image.data);
            } else {
              _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth2, glFormat, glType, image);
            }
          } else {
            if (srcTexture.isDataTexture) {
              _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
            } else if (srcTexture.isCompressedTexture) {
              _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
            } else {
              _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
          }
        }
        _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
        _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
        _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
        _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
        if (dstLevel === 0 && dstTexture.generateMipmaps) {
          _gl.generateMipmap(glTarget);
        }
        state.unbindTexture();
      };
      this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
        warnOnce('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
        return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
      };
      this.initRenderTarget = function(target) {
        if (properties.get(target).__webglFramebuffer === void 0) {
          textures.setupRenderTarget(target);
        }
      };
      this.initTexture = function(texture) {
        if (texture.isCubeTexture) {
          textures.setTextureCube(texture, 0);
        } else if (texture.isData3DTexture) {
          textures.setTexture3D(texture, 0);
        } else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {
          textures.setTexture2DArray(texture, 0);
        } else {
          textures.setTexture2D(texture, 0);
        }
        state.unbindTexture();
      };
      this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
      };
      if (typeof __THREE_DEVTOOLS__ !== "undefined") {
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
      }
    }
    /**
     * Defines the coordinate system of the renderer.
     *
     * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
     *
     * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
     * @default WebGLCoordinateSystem
     * @readonly
     */
    get coordinateSystem() {
      return WebGLCoordinateSystem;
    }
    /**
     * Defines the output color space of the renderer.
     *
     * @type {SRGBColorSpace|LinearSRGBColorSpace}
     * @default SRGBColorSpace
     */
    get outputColorSpace() {
      return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
      this._outputColorSpace = colorSpace;
      const gl = this.getContext();
      gl.drawingBufferColorSpace = ColorManagement._getDrawingBufferColorSpace(colorSpace);
      gl.unpackColorSpace = ColorManagement._getUnpackColorSpace();
    }
  }
  const _changeEvent = { type: "change" };
  const _startEvent = { type: "start" };
  const _endEvent = { type: "end" };
  const _ray = new Ray();
  const _plane = new Plane();
  const _TILT_LIMIT = Math.cos(70 * MathUtils.DEG2RAD);
  const _v = new Vector3();
  const _twoPI = 2 * Math.PI;
  const _STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
  };
  const _EPS = 1e-6;
  class OrbitControls extends Controls {
    /**
     * Constructs a new controls instance.
     *
     * @param {Object3D} object - The object that is managed by the controls.
     * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
     */
    constructor(object, domElement = null) {
      super(object, domElement);
      this.state = _STATE.NONE;
      this.target = new Vector3();
      this.cursor = new Vector3();
      this.minDistance = 0;
      this.maxDistance = Infinity;
      this.minZoom = 0;
      this.maxZoom = Infinity;
      this.minTargetRadius = 0;
      this.maxTargetRadius = Infinity;
      this.minPolarAngle = 0;
      this.maxPolarAngle = Math.PI;
      this.minAzimuthAngle = -Infinity;
      this.maxAzimuthAngle = Infinity;
      this.enableDamping = false;
      this.dampingFactor = 0.05;
      this.enableZoom = true;
      this.zoomSpeed = 1;
      this.enableRotate = true;
      this.rotateSpeed = 1;
      this.keyRotateSpeed = 1;
      this.enablePan = true;
      this.panSpeed = 1;
      this.screenSpacePanning = true;
      this.keyPanSpeed = 7;
      this.zoomToCursor = false;
      this.autoRotate = false;
      this.autoRotateSpeed = 2;
      this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" };
      this.mouseButtons = { LEFT: MOUSE.ROTATE, MIDDLE: MOUSE.DOLLY, RIGHT: MOUSE.PAN };
      this.touches = { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN };
      this.target0 = this.target.clone();
      this.position0 = this.object.position.clone();
      this.zoom0 = this.object.zoom;
      this._domElementKeyEvents = null;
      this._lastPosition = new Vector3();
      this._lastQuaternion = new Quaternion();
      this._lastTargetPosition = new Vector3();
      this._quat = new Quaternion().setFromUnitVectors(object.up, new Vector3(0, 1, 0));
      this._quatInverse = this._quat.clone().invert();
      this._spherical = new Spherical();
      this._sphericalDelta = new Spherical();
      this._scale = 1;
      this._panOffset = new Vector3();
      this._rotateStart = new Vector2();
      this._rotateEnd = new Vector2();
      this._rotateDelta = new Vector2();
      this._panStart = new Vector2();
      this._panEnd = new Vector2();
      this._panDelta = new Vector2();
      this._dollyStart = new Vector2();
      this._dollyEnd = new Vector2();
      this._dollyDelta = new Vector2();
      this._dollyDirection = new Vector3();
      this._mouse = new Vector2();
      this._performCursorZoom = false;
      this._pointers = [];
      this._pointerPositions = {};
      this._controlActive = false;
      this._onPointerMove = onPointerMove.bind(this);
      this._onPointerDown = onPointerDown.bind(this);
      this._onPointerUp = onPointerUp.bind(this);
      this._onContextMenu = onContextMenu.bind(this);
      this._onMouseWheel = onMouseWheel.bind(this);
      this._onKeyDown = onKeyDown.bind(this);
      this._onTouchStart = onTouchStart.bind(this);
      this._onTouchMove = onTouchMove.bind(this);
      this._onMouseDown = onMouseDown.bind(this);
      this._onMouseMove = onMouseMove.bind(this);
      this._interceptControlDown = interceptControlDown.bind(this);
      this._interceptControlUp = interceptControlUp.bind(this);
      if (this.domElement !== null) {
        this.connect(this.domElement);
      }
      this.update();
    }
    connect(element) {
      super.connect(element);
      this.domElement.addEventListener("pointerdown", this._onPointerDown);
      this.domElement.addEventListener("pointercancel", this._onPointerUp);
      this.domElement.addEventListener("contextmenu", this._onContextMenu);
      this.domElement.addEventListener("wheel", this._onMouseWheel, { passive: false });
      const document2 = this.domElement.getRootNode();
      document2.addEventListener("keydown", this._interceptControlDown, { passive: true, capture: true });
      this.domElement.style.touchAction = "none";
    }
    disconnect() {
      this.domElement.removeEventListener("pointerdown", this._onPointerDown);
      this.domElement.removeEventListener("pointermove", this._onPointerMove);
      this.domElement.removeEventListener("pointerup", this._onPointerUp);
      this.domElement.removeEventListener("pointercancel", this._onPointerUp);
      this.domElement.removeEventListener("wheel", this._onMouseWheel);
      this.domElement.removeEventListener("contextmenu", this._onContextMenu);
      this.stopListenToKeyEvents();
      const document2 = this.domElement.getRootNode();
      document2.removeEventListener("keydown", this._interceptControlDown, { capture: true });
      this.domElement.style.touchAction = "auto";
    }
    dispose() {
      this.disconnect();
    }
    /**
     * Get the current vertical rotation, in radians.
     *
     * @return {number} The current vertical rotation, in radians.
     */
    getPolarAngle() {
      return this._spherical.phi;
    }
    /**
     * Get the current horizontal rotation, in radians.
     *
     * @return {number} The current horizontal rotation, in radians.
     */
    getAzimuthalAngle() {
      return this._spherical.theta;
    }
    /**
     * Returns the distance from the camera to the target.
     *
     * @return {number} The distance from the camera to the target.
     */
    getDistance() {
      return this.object.position.distanceTo(this.target);
    }
    /**
     * Adds key event listeners to the given DOM element.
     * `window` is a recommended argument for using this method.
     *
     * @param {HTMLDOMElement} domElement - The DOM element
     */
    listenToKeyEvents(domElement) {
      domElement.addEventListener("keydown", this._onKeyDown);
      this._domElementKeyEvents = domElement;
    }
    /**
     * Removes the key event listener previously defined with `listenToKeyEvents()`.
     */
    stopListenToKeyEvents() {
      if (this._domElementKeyEvents !== null) {
        this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown);
        this._domElementKeyEvents = null;
      }
    }
    /**
     * Save the current state of the controls. This can later be recovered with `reset()`.
     */
    saveState() {
      this.target0.copy(this.target);
      this.position0.copy(this.object.position);
      this.zoom0 = this.object.zoom;
    }
    /**
     * Reset the controls to their state from either the last time the `saveState()`
     * was called, or the initial state.
     */
    reset() {
      this.target.copy(this.target0);
      this.object.position.copy(this.position0);
      this.object.zoom = this.zoom0;
      this.object.updateProjectionMatrix();
      this.dispatchEvent(_changeEvent);
      this.update();
      this.state = _STATE.NONE;
    }
    update(deltaTime = null) {
      const position = this.object.position;
      _v.copy(position).sub(this.target);
      _v.applyQuaternion(this._quat);
      this._spherical.setFromVector3(_v);
      if (this.autoRotate && this.state === _STATE.NONE) {
        this._rotateLeft(this._getAutoRotationAngle(deltaTime));
      }
      if (this.enableDamping) {
        this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
        this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
      } else {
        this._spherical.theta += this._sphericalDelta.theta;
        this._spherical.phi += this._sphericalDelta.phi;
      }
      let min = this.minAzimuthAngle;
      let max = this.maxAzimuthAngle;
      if (isFinite(min) && isFinite(max)) {
        if (min < -Math.PI) min += _twoPI;
        else if (min > Math.PI) min -= _twoPI;
        if (max < -Math.PI) max += _twoPI;
        else if (max > Math.PI) max -= _twoPI;
        if (min <= max) {
          this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
        } else {
          this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
      }
      this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
      this._spherical.makeSafe();
      if (this.enableDamping === true) {
        this.target.addScaledVector(this._panOffset, this.dampingFactor);
      } else {
        this.target.add(this._panOffset);
      }
      this.target.sub(this.cursor);
      this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
      this.target.add(this.cursor);
      let zoomChanged = false;
      if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) {
        this._spherical.radius = this._clampDistance(this._spherical.radius);
      } else {
        const prevRadius = this._spherical.radius;
        this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
        zoomChanged = prevRadius != this._spherical.radius;
      }
      _v.setFromSpherical(this._spherical);
      _v.applyQuaternion(this._quatInverse);
      position.copy(this.target).add(_v);
      this.object.lookAt(this.target);
      if (this.enableDamping === true) {
        this._sphericalDelta.theta *= 1 - this.dampingFactor;
        this._sphericalDelta.phi *= 1 - this.dampingFactor;
        this._panOffset.multiplyScalar(1 - this.dampingFactor);
      } else {
        this._sphericalDelta.set(0, 0, 0);
        this._panOffset.set(0, 0, 0);
      }
      if (this.zoomToCursor && this._performCursorZoom) {
        let newRadius = null;
        if (this.object.isPerspectiveCamera) {
          const prevRadius = _v.length();
          newRadius = this._clampDistance(prevRadius * this._scale);
          const radiusDelta = prevRadius - newRadius;
          this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
          this.object.updateMatrixWorld();
          zoomChanged = !!radiusDelta;
        } else if (this.object.isOrthographicCamera) {
          const mouseBefore = new Vector3(this._mouse.x, this._mouse.y, 0);
          mouseBefore.unproject(this.object);
          const prevZoom = this.object.zoom;
          this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
          this.object.updateProjectionMatrix();
          zoomChanged = prevZoom !== this.object.zoom;
          const mouseAfter = new Vector3(this._mouse.x, this._mouse.y, 0);
          mouseAfter.unproject(this.object);
          this.object.position.sub(mouseAfter).add(mouseBefore);
          this.object.updateMatrixWorld();
          newRadius = _v.length();
        } else {
          console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.");
          this.zoomToCursor = false;
        }
        if (newRadius !== null) {
          if (this.screenSpacePanning) {
            this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
          } else {
            _ray.origin.copy(this.object.position);
            _ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
            if (Math.abs(this.object.up.dot(_ray.direction)) < _TILT_LIMIT) {
              this.object.lookAt(this.target);
            } else {
              _plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
              _ray.intersectPlane(_plane, this.target);
            }
          }
        }
      } else if (this.object.isOrthographicCamera) {
        const prevZoom = this.object.zoom;
        this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
        if (prevZoom !== this.object.zoom) {
          this.object.updateProjectionMatrix();
          zoomChanged = true;
        }
      }
      this._scale = 1;
      this._performCursorZoom = false;
      if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > _EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > _EPS || this._lastTargetPosition.distanceToSquared(this.target) > _EPS) {
        this.dispatchEvent(_changeEvent);
        this._lastPosition.copy(this.object.position);
        this._lastQuaternion.copy(this.object.quaternion);
        this._lastTargetPosition.copy(this.target);
        return true;
      }
      return false;
    }
    _getAutoRotationAngle(deltaTime) {
      if (deltaTime !== null) {
        return _twoPI / 60 * this.autoRotateSpeed * deltaTime;
      } else {
        return _twoPI / 60 / 60 * this.autoRotateSpeed;
      }
    }
    _getZoomScale(delta) {
      const normalizedDelta = Math.abs(delta * 0.01);
      return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
      this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
      this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
      _v.setFromMatrixColumn(objectMatrix, 0);
      _v.multiplyScalar(-distance);
      this._panOffset.add(_v);
    }
    _panUp(distance, objectMatrix) {
      if (this.screenSpacePanning === true) {
        _v.setFromMatrixColumn(objectMatrix, 1);
      } else {
        _v.setFromMatrixColumn(objectMatrix, 0);
        _v.crossVectors(this.object.up, _v);
      }
      _v.multiplyScalar(distance);
      this._panOffset.add(_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
      const element = this.domElement;
      if (this.object.isPerspectiveCamera) {
        const position = this.object.position;
        _v.copy(position).sub(this.target);
        let targetDistance = _v.length();
        targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180);
        this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
        this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
      } else if (this.object.isOrthographicCamera) {
        this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
        this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
      } else {
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
        this.enablePan = false;
      }
    }
    _dollyOut(dollyScale) {
      if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
        this._scale /= dollyScale;
      } else {
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
        this.enableZoom = false;
      }
    }
    _dollyIn(dollyScale) {
      if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) {
        this._scale *= dollyScale;
      } else {
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
        this.enableZoom = false;
      }
    }
    _updateZoomParameters(x2, y2) {
      if (!this.zoomToCursor) {
        return;
      }
      this._performCursorZoom = true;
      const rect = this.domElement.getBoundingClientRect();
      const dx = x2 - rect.left;
      const dy = y2 - rect.top;
      const w2 = rect.width;
      const h2 = rect.height;
      this._mouse.x = dx / w2 * 2 - 1;
      this._mouse.y = -(dy / h2) * 2 + 1;
      this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
      return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
      this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
      this._updateZoomParameters(event.clientX, event.clientX);
      this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
      this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
      this._rotateEnd.set(event.clientX, event.clientY);
      this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
      const element = this.domElement;
      this._rotateLeft(_twoPI * this._rotateDelta.x / element.clientHeight);
      this._rotateUp(_twoPI * this._rotateDelta.y / element.clientHeight);
      this._rotateStart.copy(this._rotateEnd);
      this.update();
    }
    _handleMouseMoveDolly(event) {
      this._dollyEnd.set(event.clientX, event.clientY);
      this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
      if (this._dollyDelta.y > 0) {
        this._dollyOut(this._getZoomScale(this._dollyDelta.y));
      } else if (this._dollyDelta.y < 0) {
        this._dollyIn(this._getZoomScale(this._dollyDelta.y));
      }
      this._dollyStart.copy(this._dollyEnd);
      this.update();
    }
    _handleMouseMovePan(event) {
      this._panEnd.set(event.clientX, event.clientY);
      this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
      this._pan(this._panDelta.x, this._panDelta.y);
      this._panStart.copy(this._panEnd);
      this.update();
    }
    _handleMouseWheel(event) {
      this._updateZoomParameters(event.clientX, event.clientY);
      if (event.deltaY < 0) {
        this._dollyIn(this._getZoomScale(event.deltaY));
      } else if (event.deltaY > 0) {
        this._dollyOut(this._getZoomScale(event.deltaY));
      }
      this.update();
    }
    _handleKeyDown(event) {
      let needsUpdate = false;
      switch (event.code) {
        case this.keys.UP:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (this.enableRotate) {
              this._rotateUp(_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
            }
          } else {
            if (this.enablePan) {
              this._pan(0, this.keyPanSpeed);
            }
          }
          needsUpdate = true;
          break;
        case this.keys.BOTTOM:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (this.enableRotate) {
              this._rotateUp(-_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
            }
          } else {
            if (this.enablePan) {
              this._pan(0, -this.keyPanSpeed);
            }
          }
          needsUpdate = true;
          break;
        case this.keys.LEFT:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (this.enableRotate) {
              this._rotateLeft(_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
            }
          } else {
            if (this.enablePan) {
              this._pan(this.keyPanSpeed, 0);
            }
          }
          needsUpdate = true;
          break;
        case this.keys.RIGHT:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (this.enableRotate) {
              this._rotateLeft(-_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
            }
          } else {
            if (this.enablePan) {
              this._pan(-this.keyPanSpeed, 0);
            }
          }
          needsUpdate = true;
          break;
      }
      if (needsUpdate) {
        event.preventDefault();
        this.update();
      }
    }
    _handleTouchStartRotate(event) {
      if (this._pointers.length === 1) {
        this._rotateStart.set(event.pageX, event.pageY);
      } else {
        const position = this._getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        this._rotateStart.set(x2, y2);
      }
    }
    _handleTouchStartPan(event) {
      if (this._pointers.length === 1) {
        this._panStart.set(event.pageX, event.pageY);
      } else {
        const position = this._getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        this._panStart.set(x2, y2);
      }
    }
    _handleTouchStartDolly(event) {
      const position = this._getSecondPointerPosition(event);
      const dx = event.pageX - position.x;
      const dy = event.pageY - position.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
      if (this.enableZoom) this._handleTouchStartDolly(event);
      if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
      if (this.enableZoom) this._handleTouchStartDolly(event);
      if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
      if (this._pointers.length == 1) {
        this._rotateEnd.set(event.pageX, event.pageY);
      } else {
        const position = this._getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        this._rotateEnd.set(x2, y2);
      }
      this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
      const element = this.domElement;
      this._rotateLeft(_twoPI * this._rotateDelta.x / element.clientHeight);
      this._rotateUp(_twoPI * this._rotateDelta.y / element.clientHeight);
      this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
      if (this._pointers.length === 1) {
        this._panEnd.set(event.pageX, event.pageY);
      } else {
        const position = this._getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        this._panEnd.set(x2, y2);
      }
      this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
      this._pan(this._panDelta.x, this._panDelta.y);
      this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
      const position = this._getSecondPointerPosition(event);
      const dx = event.pageX - position.x;
      const dy = event.pageY - position.y;
      const distance = Math.sqrt(dx * dx + dy * dy);
      this._dollyEnd.set(0, distance);
      this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
      this._dollyOut(this._dollyDelta.y);
      this._dollyStart.copy(this._dollyEnd);
      const centerX = (event.pageX + position.x) * 0.5;
      const centerY = (event.pageY + position.y) * 0.5;
      this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
      if (this.enableZoom) this._handleTouchMoveDolly(event);
      if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
      if (this.enableZoom) this._handleTouchMoveDolly(event);
      if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
      this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
      delete this._pointerPositions[event.pointerId];
      for (let i2 = 0; i2 < this._pointers.length; i2++) {
        if (this._pointers[i2] == event.pointerId) {
          this._pointers.splice(i2, 1);
          return;
        }
      }
    }
    _isTrackingPointer(event) {
      for (let i2 = 0; i2 < this._pointers.length; i2++) {
        if (this._pointers[i2] == event.pointerId) return true;
      }
      return false;
    }
    _trackPointer(event) {
      let position = this._pointerPositions[event.pointerId];
      if (position === void 0) {
        position = new Vector2();
        this._pointerPositions[event.pointerId] = position;
      }
      position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
      const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
      return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
      const mode = event.deltaMode;
      const newEvent = {
        clientX: event.clientX,
        clientY: event.clientY,
        deltaY: event.deltaY
      };
      switch (mode) {
        case 1:
          newEvent.deltaY *= 16;
          break;
        case 2:
          newEvent.deltaY *= 100;
          break;
      }
      if (event.ctrlKey && !this._controlActive) {
        newEvent.deltaY *= 10;
      }
      return newEvent;
    }
  }
  function onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
      this.domElement.setPointerCapture(event.pointerId);
      this.domElement.addEventListener("pointermove", this._onPointerMove);
      this.domElement.addEventListener("pointerup", this._onPointerUp);
    }
    if (this._isTrackingPointer(event)) return;
    this._addPointer(event);
    if (event.pointerType === "touch") {
      this._onTouchStart(event);
    } else {
      this._onMouseDown(event);
    }
  }
  function onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === "touch") {
      this._onTouchMove(event);
    } else {
      this._onMouseMove(event);
    }
  }
  function onPointerUp(event) {
    this._removePointer(event);
    switch (this._pointers.length) {
      case 0:
        this.domElement.releasePointerCapture(event.pointerId);
        this.domElement.removeEventListener("pointermove", this._onPointerMove);
        this.domElement.removeEventListener("pointerup", this._onPointerUp);
        this.dispatchEvent(_endEvent);
        this.state = _STATE.NONE;
        break;
      case 1:
        const pointerId = this._pointers[0];
        const position = this._pointerPositions[pointerId];
        this._onTouchStart({ pointerId, pageX: position.x, pageY: position.y });
        break;
    }
  }
  function onMouseDown(event) {
    let mouseAction;
    switch (event.button) {
      case 0:
        mouseAction = this.mouseButtons.LEFT;
        break;
      case 1:
        mouseAction = this.mouseButtons.MIDDLE;
        break;
      case 2:
        mouseAction = this.mouseButtons.RIGHT;
        break;
      default:
        mouseAction = -1;
    }
    switch (mouseAction) {
      case MOUSE.DOLLY:
        if (this.enableZoom === false) return;
        this._handleMouseDownDolly(event);
        this.state = _STATE.DOLLY;
        break;
      case MOUSE.ROTATE:
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          if (this.enablePan === false) return;
          this._handleMouseDownPan(event);
          this.state = _STATE.PAN;
        } else {
          if (this.enableRotate === false) return;
          this._handleMouseDownRotate(event);
          this.state = _STATE.ROTATE;
        }
        break;
      case MOUSE.PAN:
        if (event.ctrlKey || event.metaKey || event.shiftKey) {
          if (this.enableRotate === false) return;
          this._handleMouseDownRotate(event);
          this.state = _STATE.ROTATE;
        } else {
          if (this.enablePan === false) return;
          this._handleMouseDownPan(event);
          this.state = _STATE.PAN;
        }
        break;
      default:
        this.state = _STATE.NONE;
    }
    if (this.state !== _STATE.NONE) {
      this.dispatchEvent(_startEvent);
    }
  }
  function onMouseMove(event) {
    switch (this.state) {
      case _STATE.ROTATE:
        if (this.enableRotate === false) return;
        this._handleMouseMoveRotate(event);
        break;
      case _STATE.DOLLY:
        if (this.enableZoom === false) return;
        this._handleMouseMoveDolly(event);
        break;
      case _STATE.PAN:
        if (this.enablePan === false) return;
        this._handleMouseMovePan(event);
        break;
    }
  }
  function onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== _STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent(_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent(_endEvent);
  }
  function onKeyDown(event) {
    if (this.enabled === false) return;
    this._handleKeyDown(event);
  }
  function onTouchStart(event) {
    this._trackPointer(event);
    switch (this._pointers.length) {
      case 1:
        switch (this.touches.ONE) {
          case TOUCH.ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchStartRotate(event);
            this.state = _STATE.TOUCH_ROTATE;
            break;
          case TOUCH.PAN:
            if (this.enablePan === false) return;
            this._handleTouchStartPan(event);
            this.state = _STATE.TOUCH_PAN;
            break;
          default:
            this.state = _STATE.NONE;
        }
        break;
      case 2:
        switch (this.touches.TWO) {
          case TOUCH.DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchStartDollyPan(event);
            this.state = _STATE.TOUCH_DOLLY_PAN;
            break;
          case TOUCH.DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchStartDollyRotate(event);
            this.state = _STATE.TOUCH_DOLLY_ROTATE;
            break;
          default:
            this.state = _STATE.NONE;
        }
        break;
      default:
        this.state = _STATE.NONE;
    }
    if (this.state !== _STATE.NONE) {
      this.dispatchEvent(_startEvent);
    }
  }
  function onTouchMove(event) {
    this._trackPointer(event);
    switch (this.state) {
      case _STATE.TOUCH_ROTATE:
        if (this.enableRotate === false) return;
        this._handleTouchMoveRotate(event);
        this.update();
        break;
      case _STATE.TOUCH_PAN:
        if (this.enablePan === false) return;
        this._handleTouchMovePan(event);
        this.update();
        break;
      case _STATE.TOUCH_DOLLY_PAN:
        if (this.enableZoom === false && this.enablePan === false) return;
        this._handleTouchMoveDollyPan(event);
        this.update();
        break;
      case _STATE.TOUCH_DOLLY_ROTATE:
        if (this.enableZoom === false && this.enableRotate === false) return;
        this._handleTouchMoveDollyRotate(event);
        this.update();
        break;
      default:
        this.state = _STATE.NONE;
    }
  }
  function onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
  }
  function interceptControlDown(event) {
    if (event.key === "Control") {
      this._controlActive = true;
      const document2 = this.domElement.getRootNode();
      document2.addEventListener("keyup", this._interceptControlUp, { passive: true, capture: true });
    }
  }
  function interceptControlUp(event) {
    if (event.key === "Control") {
      this._controlActive = false;
      const document2 = this.domElement.getRootNode();
      document2.removeEventListener("keyup", this._interceptControlUp, { passive: true, capture: true });
    }
  }
  function toTrianglesDrawMode(geometry, drawMode) {
    if (drawMode === TrianglesDrawMode) {
      console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
      return geometry;
    }
    if (drawMode === TriangleFanDrawMode || drawMode === TriangleStripDrawMode) {
      let index = geometry.getIndex();
      if (index === null) {
        const indices = [];
        const position = geometry.getAttribute("position");
        if (position !== void 0) {
          for (let i2 = 0; i2 < position.count; i2++) {
            indices.push(i2);
          }
          geometry.setIndex(indices);
          index = geometry.getIndex();
        } else {
          console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
          return geometry;
        }
      }
      const numberOfTriangles = index.count - 2;
      const newIndices = [];
      if (drawMode === TriangleFanDrawMode) {
        for (let i2 = 1; i2 <= numberOfTriangles; i2++) {
          newIndices.push(index.getX(0));
          newIndices.push(index.getX(i2));
          newIndices.push(index.getX(i2 + 1));
        }
      } else {
        for (let i2 = 0; i2 < numberOfTriangles; i2++) {
          if (i2 % 2 === 0) {
            newIndices.push(index.getX(i2));
            newIndices.push(index.getX(i2 + 1));
            newIndices.push(index.getX(i2 + 2));
          } else {
            newIndices.push(index.getX(i2 + 2));
            newIndices.push(index.getX(i2 + 1));
            newIndices.push(index.getX(i2));
          }
        }
      }
      if (newIndices.length / 3 !== numberOfTriangles) {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
      }
      const newGeometry = geometry.clone();
      newGeometry.setIndex(newIndices);
      newGeometry.clearGroups();
      return newGeometry;
    } else {
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
      return geometry;
    }
  }
  class GLTFLoader extends Loader {
    /**
     * Constructs a new glTF loader.
     *
     * @param {LoadingManager} [manager] - The loading manager.
     */
    constructor(manager) {
      super(manager);
      this.dracoLoader = null;
      this.ktx2Loader = null;
      this.meshoptDecoder = null;
      this.pluginCallbacks = [];
      this.register(function(parser) {
        return new GLTFMaterialsClearcoatExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsDispersionExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFTextureBasisUExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFTextureWebPExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFTextureAVIFExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsSheenExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsTransmissionExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsVolumeExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsIorExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsEmissiveStrengthExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsSpecularExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsIridescenceExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsAnisotropyExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMaterialsBumpExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFLightsExtension(parser);
      });
      this.register(function(parser) {
        return new GLTFMeshoptCompression(parser);
      });
      this.register(function(parser) {
        return new GLTFMeshGpuInstancing(parser);
      });
    }
    /**
     * Starts loading from the given URL and passes the loaded glTF asset
     * to the `onLoad()` callback.
     *
     * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
     * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
     * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
     * @param {onErrorCallback} onError - Executed when errors occur.
     */
    load(url, onLoad, onProgress, onError) {
      const scope = this;
      let resourcePath;
      if (this.resourcePath !== "") {
        resourcePath = this.resourcePath;
      } else if (this.path !== "") {
        const relativeUrl = LoaderUtils.extractUrlBase(url);
        resourcePath = LoaderUtils.resolveURL(relativeUrl, this.path);
      } else {
        resourcePath = LoaderUtils.extractUrlBase(url);
      }
      this.manager.itemStart(url);
      const _onError = function(e2) {
        if (onError) {
          onError(e2);
        } else {
          console.error(e2);
        }
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      };
      const loader = new FileLoader(this.manager);
      loader.setPath(this.path);
      loader.setResponseType("arraybuffer");
      loader.setRequestHeader(this.requestHeader);
      loader.setWithCredentials(this.withCredentials);
      loader.load(url, function(data) {
        try {
          scope.parse(data, resourcePath, function(gltf) {
            onLoad(gltf);
            scope.manager.itemEnd(url);
          }, _onError);
        } catch (e2) {
          _onError(e2);
        }
      }, onProgress, _onError);
    }
    /**
     * Sets the given Draco loader to this loader. Required for decoding assets
     * compressed with the `KHR_draco_mesh_compression` extension.
     *
     * @param {DRACOLoader} dracoLoader - The Draco loader to set.
     * @return {GLTFLoader} A reference to this loader.
     */
    setDRACOLoader(dracoLoader) {
      this.dracoLoader = dracoLoader;
      return this;
    }
    /**
     * Sets the given KTX2 loader to this loader. Required for loading KTX2
     * compressed textures.
     *
     * @param {KTX2Loader} ktx2Loader - The KTX2 loader to set.
     * @return {GLTFLoader} A reference to this loader.
     */
    setKTX2Loader(ktx2Loader) {
      this.ktx2Loader = ktx2Loader;
      return this;
    }
    /**
     * Sets the given meshopt decoder. Required for decoding assets
     * compressed with the `EXT_meshopt_compression` extension.
     *
     * @param {Object} meshoptDecoder - The meshopt decoder to set.
     * @return {GLTFLoader} A reference to this loader.
     */
    setMeshoptDecoder(meshoptDecoder) {
      this.meshoptDecoder = meshoptDecoder;
      return this;
    }
    /**
     * Registers a plugin callback. This API is internally used to implement the various
     * glTF extensions but can also used by third-party code to add additional logic
     * to the loader.
     *
     * @param {function(parser:GLTFParser)} callback - The callback function to register.
     * @return {GLTFLoader} A reference to this loader.
     */
    register(callback) {
      if (this.pluginCallbacks.indexOf(callback) === -1) {
        this.pluginCallbacks.push(callback);
      }
      return this;
    }
    /**
     * Unregisters a plugin callback.
     *
     * @param {Function} callback - The callback function to unregister.
     * @return {GLTFLoader} A reference to this loader.
     */
    unregister(callback) {
      if (this.pluginCallbacks.indexOf(callback) !== -1) {
        this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
      }
      return this;
    }
    /**
     * Parses the given FBX data and returns the resulting group.
     *
     * @param {string|ArrayBuffer} data - The raw glTF data.
     * @param {string} path - The URL base path.
     * @param {function(GLTFLoader~LoadObject)} onLoad - Executed when the loading process has been finished.
     * @param {onErrorCallback} onError - Executed when errors occur.
     */
    parse(data, path, onLoad, onError) {
      let json;
      const extensions = {};
      const plugins = {};
      const textDecoder = new TextDecoder();
      if (typeof data === "string") {
        json = JSON.parse(data);
      } else if (data instanceof ArrayBuffer) {
        const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
        if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
          try {
            extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
          } catch (error) {
            if (onError) onError(error);
            return;
          }
          json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
        } else {
          json = JSON.parse(textDecoder.decode(data));
        }
      } else {
        json = data;
      }
      if (json.asset === void 0 || json.asset.version[0] < 2) {
        if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
        return;
      }
      const parser = new GLTFParser(json, {
        path: path || this.resourcePath || "",
        crossOrigin: this.crossOrigin,
        requestHeader: this.requestHeader,
        manager: this.manager,
        ktx2Loader: this.ktx2Loader,
        meshoptDecoder: this.meshoptDecoder
      });
      parser.fileLoader.setRequestHeader(this.requestHeader);
      for (let i2 = 0; i2 < this.pluginCallbacks.length; i2++) {
        const plugin = this.pluginCallbacks[i2](parser);
        if (!plugin.name) console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
        plugins[plugin.name] = plugin;
        extensions[plugin.name] = true;
      }
      if (json.extensionsUsed) {
        for (let i2 = 0; i2 < json.extensionsUsed.length; ++i2) {
          const extensionName = json.extensionsUsed[i2];
          const extensionsRequired = json.extensionsRequired || [];
          switch (extensionName) {
            case EXTENSIONS.KHR_MATERIALS_UNLIT:
              extensions[extensionName] = new GLTFMaterialsUnlitExtension();
              break;
            case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
              extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
              break;
            case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
              extensions[extensionName] = new GLTFTextureTransformExtension();
              break;
            case EXTENSIONS.KHR_MESH_QUANTIZATION:
              extensions[extensionName] = new GLTFMeshQuantizationExtension();
              break;
            default:
              if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) {
                console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
              }
          }
        }
      }
      parser.setExtensions(extensions);
      parser.setPlugins(plugins);
      parser.parse(onLoad, onError);
    }
    /**
     * Async version of {@link GLTFLoader#parse}.
     *
     * @async
     * @param {string|ArrayBuffer} data - The raw glTF data.
     * @param {string} path - The URL base path.
     * @return {Promise<GLTFLoader~LoadObject>} A Promise that resolves with the loaded glTF when the parsing has been finished.
     */
    parseAsync(data, path) {
      const scope = this;
      return new Promise(function(resolve, reject) {
        scope.parse(data, path, resolve, reject);
      });
    }
  }
  function GLTFRegistry() {
    let objects = {};
    return {
      get: function(key) {
        return objects[key];
      },
      add: function(key, object) {
        objects[key] = object;
      },
      remove: function(key) {
        delete objects[key];
      },
      removeAll: function() {
        objects = {};
      }
    };
  }
  const EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
  };
  class GLTFLightsExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
      this.cache = { refs: {}, uses: {} };
    }
    _markDefs() {
      const parser = this.parser;
      const nodeDefs = this.parser.json.nodes || [];
      for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
        const nodeDef = nodeDefs[nodeIndex];
        if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) {
          parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
      }
    }
    _loadLight(lightIndex) {
      const parser = this.parser;
      const cacheKey = "light:" + lightIndex;
      let dependency = parser.cache.get(cacheKey);
      if (dependency) return dependency;
      const json = parser.json;
      const extensions = json.extensions && json.extensions[this.name] || {};
      const lightDefs = extensions.lights || [];
      const lightDef = lightDefs[lightIndex];
      let lightNode;
      const color = new Color(16777215);
      if (lightDef.color !== void 0) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], LinearSRGBColorSpace);
      const range = lightDef.range !== void 0 ? lightDef.range : 0;
      switch (lightDef.type) {
        case "directional":
          lightNode = new DirectionalLight(color);
          lightNode.target.position.set(0, 0, -1);
          lightNode.add(lightNode.target);
          break;
        case "point":
          lightNode = new PointLight(color);
          lightNode.distance = range;
          break;
        case "spot":
          lightNode = new SpotLight(color);
          lightNode.distance = range;
          lightDef.spot = lightDef.spot || {};
          lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
          lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
          lightNode.angle = lightDef.spot.outerConeAngle;
          lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
          lightNode.target.position.set(0, 0, -1);
          lightNode.add(lightNode.target);
          break;
        default:
          throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
      }
      lightNode.position.set(0, 0, 0);
      assignExtrasToUserData(lightNode, lightDef);
      if (lightDef.intensity !== void 0) lightNode.intensity = lightDef.intensity;
      lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
      dependency = Promise.resolve(lightNode);
      parser.cache.add(cacheKey, dependency);
      return dependency;
    }
    getDependency(type, index) {
      if (type !== "light") return;
      return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
      const self2 = this;
      const parser = this.parser;
      const json = parser.json;
      const nodeDef = json.nodes[nodeIndex];
      const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
      const lightIndex = lightDef.light;
      if (lightIndex === void 0) return null;
      return this._loadLight(lightIndex).then(function(light) {
        return parser._getNodeRef(self2.cache, lightIndex, light);
      });
    }
  }
  class GLTFMaterialsUnlitExtension {
    constructor() {
      this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
      return MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
      const pending = [];
      materialParams.color = new Color(1, 1, 1);
      materialParams.opacity = 1;
      const metallicRoughness = materialDef.pbrMetallicRoughness;
      if (metallicRoughness) {
        if (Array.isArray(metallicRoughness.baseColorFactor)) {
          const array = metallicRoughness.baseColorFactor;
          materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
          materialParams.opacity = array[3];
        }
        if (metallicRoughness.baseColorTexture !== void 0) {
          pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
        }
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
      if (emissiveStrength !== void 0) {
        materialParams.emissiveIntensity = emissiveStrength;
      }
      return Promise.resolve();
    }
  }
  class GLTFMaterialsClearcoatExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      if (extension.clearcoatFactor !== void 0) {
        materialParams.clearcoat = extension.clearcoatFactor;
      }
      if (extension.clearcoatTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
      }
      if (extension.clearcoatRoughnessFactor !== void 0) {
        materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
      }
      if (extension.clearcoatRoughnessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
      }
      if (extension.clearcoatNormalTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
        if (extension.clearcoatNormalTexture.scale !== void 0) {
          const scale = extension.clearcoatNormalTexture.scale;
          materialParams.clearcoatNormalScale = new Vector2(scale, scale);
        }
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsDispersionExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const extension = materialDef.extensions[this.name];
      materialParams.dispersion = extension.dispersion !== void 0 ? extension.dispersion : 0;
      return Promise.resolve();
    }
  }
  class GLTFMaterialsIridescenceExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      if (extension.iridescenceFactor !== void 0) {
        materialParams.iridescence = extension.iridescenceFactor;
      }
      if (extension.iridescenceTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
      }
      if (extension.iridescenceIor !== void 0) {
        materialParams.iridescenceIOR = extension.iridescenceIor;
      }
      if (materialParams.iridescenceThicknessRange === void 0) {
        materialParams.iridescenceThicknessRange = [100, 400];
      }
      if (extension.iridescenceThicknessMinimum !== void 0) {
        materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
      }
      if (extension.iridescenceThicknessMaximum !== void 0) {
        materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
      }
      if (extension.iridescenceThicknessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsSheenExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      materialParams.sheenColor = new Color(0, 0, 0);
      materialParams.sheenRoughness = 0;
      materialParams.sheen = 1;
      const extension = materialDef.extensions[this.name];
      if (extension.sheenColorFactor !== void 0) {
        const colorFactor = extension.sheenColorFactor;
        materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], LinearSRGBColorSpace);
      }
      if (extension.sheenRoughnessFactor !== void 0) {
        materialParams.sheenRoughness = extension.sheenRoughnessFactor;
      }
      if (extension.sheenColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, SRGBColorSpace));
      }
      if (extension.sheenRoughnessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsTransmissionExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      if (extension.transmissionFactor !== void 0) {
        materialParams.transmission = extension.transmissionFactor;
      }
      if (extension.transmissionTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsVolumeExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
      if (extension.thicknessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
      }
      materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
      const colorArray = extension.attenuationColor || [1, 1, 1];
      materialParams.attenuationColor = new Color().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsIorExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const extension = materialDef.extensions[this.name];
      materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
      return Promise.resolve();
    }
  }
  class GLTFMaterialsSpecularExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
      if (extension.specularTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
      }
      const colorArray = extension.specularColorFactor || [1, 1, 1];
      materialParams.specularColor = new Color().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
      if (extension.specularColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, SRGBColorSpace));
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsBumpExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      materialParams.bumpScale = extension.bumpFactor !== void 0 ? extension.bumpFactor : 1;
      if (extension.bumpTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
      }
      return Promise.all(pending);
    }
  }
  class GLTFMaterialsAnisotropyExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
      return MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
      const parser = this.parser;
      const materialDef = parser.json.materials[materialIndex];
      if (!materialDef.extensions || !materialDef.extensions[this.name]) {
        return Promise.resolve();
      }
      const pending = [];
      const extension = materialDef.extensions[this.name];
      if (extension.anisotropyStrength !== void 0) {
        materialParams.anisotropy = extension.anisotropyStrength;
      }
      if (extension.anisotropyRotation !== void 0) {
        materialParams.anisotropyRotation = extension.anisotropyRotation;
      }
      if (extension.anisotropyTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
      }
      return Promise.all(pending);
    }
  }
  class GLTFTextureBasisUExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
      const parser = this.parser;
      const json = parser.json;
      const textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[this.name]) {
        return null;
      }
      const extension = textureDef.extensions[this.name];
      const loader = parser.options.ktx2Loader;
      if (!loader) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
        } else {
          return null;
        }
      }
      return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
  }
  class GLTFTextureWebPExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
    }
    loadTexture(textureIndex) {
      const name = this.name;
      const parser = this.parser;
      const json = parser.json;
      const textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[name]) {
        return null;
      }
      const extension = textureDef.extensions[name];
      const source = json.images[extension.source];
      let loader = parser.textureLoader;
      if (source.uri) {
        const handler = parser.options.manager.getHandler(source.uri);
        if (handler !== null) loader = handler;
      }
      return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
  }
  class GLTFTextureAVIFExtension {
    constructor(parser) {
      this.parser = parser;
      this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
    }
    loadTexture(textureIndex) {
      const name = this.name;
      const parser = this.parser;
      const json = parser.json;
      const textureDef = json.textures[textureIndex];
      if (!textureDef.extensions || !textureDef.extensions[name]) {
        return null;
      }
      const extension = textureDef.extensions[name];
      const source = json.images[extension.source];
      let loader = parser.textureLoader;
      if (source.uri) {
        const handler = parser.options.manager.getHandler(source.uri);
        if (handler !== null) loader = handler;
      }
      return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
  }
  class GLTFMeshoptCompression {
    constructor(parser) {
      this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
      this.parser = parser;
    }
    loadBufferView(index) {
      const json = this.parser.json;
      const bufferView = json.bufferViews[index];
      if (bufferView.extensions && bufferView.extensions[this.name]) {
        const extensionDef = bufferView.extensions[this.name];
        const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
        const decoder = this.parser.options.meshoptDecoder;
        if (!decoder || !decoder.supported) {
          if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
            throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
          } else {
            return null;
          }
        }
        return buffer.then(function(res) {
          const byteOffset = extensionDef.byteOffset || 0;
          const byteLength = extensionDef.byteLength || 0;
          const count = extensionDef.count;
          const stride = extensionDef.byteStride;
          const source = new Uint8Array(res, byteOffset, byteLength);
          if (decoder.decodeGltfBufferAsync) {
            return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
              return res2.buffer;
            });
          } else {
            return decoder.ready.then(function() {
              const result = new ArrayBuffer(count * stride);
              decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
              return result;
            });
          }
        });
      } else {
        return null;
      }
    }
  }
  class GLTFMeshGpuInstancing {
    constructor(parser) {
      this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
      this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
      const json = this.parser.json;
      const nodeDef = json.nodes[nodeIndex];
      if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) {
        return null;
      }
      const meshDef = json.meshes[nodeDef.mesh];
      for (const primitive of meshDef.primitives) {
        if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) {
          return null;
        }
      }
      const extensionDef = nodeDef.extensions[this.name];
      const attributesDef = extensionDef.attributes;
      const pending = [];
      const attributes = {};
      for (const key in attributesDef) {
        pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor) => {
          attributes[key] = accessor;
          return attributes[key];
        }));
      }
      if (pending.length < 1) {
        return null;
      }
      pending.push(this.parser.createNodeMesh(nodeIndex));
      return Promise.all(pending).then((results) => {
        const nodeObject = results.pop();
        const meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
        const count = results[0].count;
        const instancedMeshes = [];
        for (const mesh of meshes) {
          const m = new Matrix4();
          const p2 = new Vector3();
          const q2 = new Quaternion();
          const s2 = new Vector3(1, 1, 1);
          const instancedMesh = new InstancedMesh(mesh.geometry, mesh.material, count);
          for (let i2 = 0; i2 < count; i2++) {
            if (attributes.TRANSLATION) {
              p2.fromBufferAttribute(attributes.TRANSLATION, i2);
            }
            if (attributes.ROTATION) {
              q2.fromBufferAttribute(attributes.ROTATION, i2);
            }
            if (attributes.SCALE) {
              s2.fromBufferAttribute(attributes.SCALE, i2);
            }
            instancedMesh.setMatrixAt(i2, m.compose(p2, q2, s2));
          }
          for (const attributeName in attributes) {
            if (attributeName === "_COLOR_0") {
              const attr = attributes[attributeName];
              instancedMesh.instanceColor = new InstancedBufferAttribute(attr.array, attr.itemSize, attr.normalized);
            } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") {
              mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
            }
          }
          Object3D.prototype.copy.call(instancedMesh, mesh);
          this.parser.assignFinalMaterial(instancedMesh);
          instancedMeshes.push(instancedMesh);
        }
        if (nodeObject.isGroup) {
          nodeObject.clear();
          nodeObject.add(...instancedMeshes);
          return nodeObject;
        }
        return instancedMeshes[0];
      });
    }
  }
  const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
  const BINARY_EXTENSION_HEADER_LENGTH = 12;
  const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
  class GLTFBinaryExtension {
    constructor(data) {
      this.name = EXTENSIONS.KHR_BINARY_GLTF;
      this.content = null;
      this.body = null;
      const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
      const textDecoder = new TextDecoder();
      this.header = {
        magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
        version: headerView.getUint32(4, true),
        length: headerView.getUint32(8, true)
      };
      if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
        throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
      } else if (this.header.version < 2) {
        throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
      }
      const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
      const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
      let chunkIndex = 0;
      while (chunkIndex < chunkContentsLength) {
        const chunkLength = chunkView.getUint32(chunkIndex, true);
        chunkIndex += 4;
        const chunkType = chunkView.getUint32(chunkIndex, true);
        chunkIndex += 4;
        if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
          const contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
          this.content = textDecoder.decode(contentArray);
        } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
          const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
          this.body = data.slice(byteOffset, byteOffset + chunkLength);
        }
        chunkIndex += chunkLength;
      }
      if (this.content === null) {
        throw new Error("THREE.GLTFLoader: JSON content not found.");
      }
    }
  }
  class GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader) {
      if (!dracoLoader) {
        throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
      }
      this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
      this.json = json;
      this.dracoLoader = dracoLoader;
      this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
      const json = this.json;
      const dracoLoader = this.dracoLoader;
      const bufferViewIndex = primitive.extensions[this.name].bufferView;
      const gltfAttributeMap = primitive.extensions[this.name].attributes;
      const threeAttributeMap = {};
      const attributeNormalizedMap = {};
      const attributeTypeMap = {};
      for (const attributeName in gltfAttributeMap) {
        const threeAttributeName = ATTRIBUTES$1[attributeName] || attributeName.toLowerCase();
        threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
      }
      for (const attributeName in primitive.attributes) {
        const threeAttributeName = ATTRIBUTES$1[attributeName] || attributeName.toLowerCase();
        if (gltfAttributeMap[attributeName] !== void 0) {
          const accessorDef = json.accessors[primitive.attributes[attributeName]];
          const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
          attributeTypeMap[threeAttributeName] = componentType.name;
          attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
        }
      }
      return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
        return new Promise(function(resolve, reject) {
          dracoLoader.decodeDracoFile(bufferView, function(geometry) {
            for (const attributeName in geometry.attributes) {
              const attribute = geometry.attributes[attributeName];
              const normalized = attributeNormalizedMap[attributeName];
              if (normalized !== void 0) attribute.normalized = normalized;
            }
            resolve(geometry);
          }, threeAttributeMap, attributeTypeMap, LinearSRGBColorSpace, reject);
        });
      });
    }
  }
  class GLTFTextureTransformExtension {
    constructor() {
      this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
      if ((transform.texCoord === void 0 || transform.texCoord === texture.channel) && transform.offset === void 0 && transform.rotation === void 0 && transform.scale === void 0) {
        return texture;
      }
      texture = texture.clone();
      if (transform.texCoord !== void 0) {
        texture.channel = transform.texCoord;
      }
      if (transform.offset !== void 0) {
        texture.offset.fromArray(transform.offset);
      }
      if (transform.rotation !== void 0) {
        texture.rotation = transform.rotation;
      }
      if (transform.scale !== void 0) {
        texture.repeat.fromArray(transform.scale);
      }
      texture.needsUpdate = true;
      return texture;
    }
  }
  class GLTFMeshQuantizationExtension {
    constructor() {
      this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
  }
  class GLTFCubicSplineInterpolant extends Interpolant {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
      super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
      const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
      for (let i2 = 0; i2 !== valueSize; i2++) {
        result[i2] = values[offset + i2];
      }
      return result;
    }
    interpolate_(i1, t0, t2, t1) {
      const result = this.resultBuffer;
      const values = this.sampleValues;
      const stride = this.valueSize;
      const stride2 = stride * 2;
      const stride3 = stride * 3;
      const td = t1 - t0;
      const p2 = (t2 - t0) / td;
      const pp = p2 * p2;
      const ppp = pp * p2;
      const offset1 = i1 * stride3;
      const offset0 = offset1 - stride3;
      const s2 = -2 * ppp + 3 * pp;
      const s3 = ppp - pp;
      const s0 = 1 - s2;
      const s1 = s3 - pp + p2;
      for (let i2 = 0; i2 !== stride; i2++) {
        const p0 = values[offset0 + i2 + stride];
        const m0 = values[offset0 + i2 + stride2] * td;
        const p1 = values[offset1 + i2 + stride];
        const m1 = values[offset1 + i2] * td;
        result[i2] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
      }
      return result;
    }
  }
  const _quaternion = new Quaternion();
  class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t2, t1) {
      const result = super.interpolate_(i1, t0, t2, t1);
      _quaternion.fromArray(result).normalize().toArray(result);
      return result;
    }
  }
  const WEBGL_CONSTANTS = {
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6
  };
  const WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
  };
  const WEBGL_FILTERS = {
    9728: NearestFilter,
    9729: LinearFilter,
    9984: NearestMipmapNearestFilter,
    9985: LinearMipmapNearestFilter,
    9986: NearestMipmapLinearFilter,
    9987: LinearMipmapLinearFilter
  };
  const WEBGL_WRAPPINGS = {
    33071: ClampToEdgeWrapping,
    33648: MirroredRepeatWrapping,
    10497: RepeatWrapping
  };
  const WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
  };
  const ATTRIBUTES$1 = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
  };
  const PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
  };
  const INTERPOLATION = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: InterpolateLinear,
    STEP: InterpolateDiscrete
  };
  const ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
  };
  function createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === void 0) {
      cache["DefaultMaterial"] = new MeshStandardMaterial({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: FrontSide
      });
    }
    return cache["DefaultMaterial"];
  }
  function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    for (const name in objectDef.extensions) {
      if (knownExtensions[name] === void 0) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
      }
    }
  }
  function assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== void 0) {
      if (typeof gltfDef.extras === "object") {
        Object.assign(object.userData, gltfDef.extras);
      } else {
        console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
      }
    }
  }
  function addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for (let i2 = 0, il = targets.length; i2 < il; i2++) {
      const target = targets[i2];
      if (target.POSITION !== void 0) hasMorphPosition = true;
      if (target.NORMAL !== void 0) hasMorphNormal = true;
      if (target.COLOR_0 !== void 0) hasMorphColor = true;
      if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for (let i2 = 0, il = targets.length; i2 < il; i2++) {
      const target = targets[i2];
      if (hasMorphPosition) {
        const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
        pendingPositionAccessors.push(pendingAccessor);
      }
      if (hasMorphNormal) {
        const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
        pendingNormalAccessors.push(pendingAccessor);
      }
      if (hasMorphColor) {
        const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
        pendingColorAccessors.push(pendingAccessor);
      }
    }
    return Promise.all([
      Promise.all(pendingPositionAccessors),
      Promise.all(pendingNormalAccessors),
      Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
      const morphPositions = accessors[0];
      const morphNormals = accessors[1];
      const morphColors = accessors[2];
      if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
      if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
      if (hasMorphColor) geometry.morphAttributes.color = morphColors;
      geometry.morphTargetsRelative = true;
      return geometry;
    });
  }
  function updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== void 0) {
      for (let i2 = 0, il = meshDef.weights.length; i2 < il; i2++) {
        mesh.morphTargetInfluences[i2] = meshDef.weights[i2];
      }
    }
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
      const targetNames = meshDef.extras.targetNames;
      if (mesh.morphTargetInfluences.length === targetNames.length) {
        mesh.morphTargetDictionary = {};
        for (let i2 = 0, il = targetNames.length; i2 < il; i2++) {
          mesh.morphTargetDictionary[targetNames[i2]] = i2;
        }
      } else {
        console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
      }
    }
  }
  function createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) {
      geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
    } else {
      geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    }
    if (primitiveDef.targets !== void 0) {
      for (let i2 = 0, il = primitiveDef.targets.length; i2 < il; i2++) {
        geometryKey += ":" + createAttributesKey(primitiveDef.targets[i2]);
      }
    }
    return geometryKey;
  }
  function createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for (let i2 = 0, il = keys.length; i2 < il; i2++) {
      attributesKey += keys[i2] + ":" + attributes[keys[i2]] + ";";
    }
    return attributesKey;
  }
  function getNormalizedComponentScale(constructor) {
    switch (constructor) {
      case Int8Array:
        return 1 / 127;
      case Uint8Array:
        return 1 / 255;
      case Int16Array:
        return 1 / 32767;
      case Uint16Array:
        return 1 / 65535;
      default:
        throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
  }
  function getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    if (uri.search(/\.ktx2($|\?)/i) > 0 || uri.search(/^data\:image\/ktx2/) === 0) return "image/ktx2";
    return "image/png";
  }
  const _identityMatrix = new Matrix4();
  class GLTFParser {
    constructor(json = {}, options = {}) {
      this.json = json;
      this.extensions = {};
      this.plugins = {};
      this.options = options;
      this.cache = new GLTFRegistry();
      this.associations = /* @__PURE__ */ new Map();
      this.primitiveCache = {};
      this.nodeCache = {};
      this.meshCache = { refs: {}, uses: {} };
      this.cameraCache = { refs: {}, uses: {} };
      this.lightCache = { refs: {}, uses: {} };
      this.sourceCache = {};
      this.textureCache = {};
      this.nodeNamesUsed = {};
      let isSafari = false;
      let safariVersion = -1;
      let isFirefox = false;
      let firefoxVersion = -1;
      if (typeof navigator !== "undefined") {
        const userAgent = navigator.userAgent;
        isSafari = /^((?!chrome|android).)*safari/i.test(userAgent) === true;
        const safariMatch = userAgent.match(/Version\/(\d+)/);
        safariVersion = isSafari && safariMatch ? parseInt(safariMatch[1], 10) : -1;
        isFirefox = userAgent.indexOf("Firefox") > -1;
        firefoxVersion = isFirefox ? userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
      }
      if (typeof createImageBitmap === "undefined" || isSafari && safariVersion < 17 || isFirefox && firefoxVersion < 98) {
        this.textureLoader = new TextureLoader(this.options.manager);
      } else {
        this.textureLoader = new ImageBitmapLoader(this.options.manager);
      }
      this.textureLoader.setCrossOrigin(this.options.crossOrigin);
      this.textureLoader.setRequestHeader(this.options.requestHeader);
      this.fileLoader = new FileLoader(this.options.manager);
      this.fileLoader.setResponseType("arraybuffer");
      if (this.options.crossOrigin === "use-credentials") {
        this.fileLoader.setWithCredentials(true);
      }
    }
    setExtensions(extensions) {
      this.extensions = extensions;
    }
    setPlugins(plugins) {
      this.plugins = plugins;
    }
    parse(onLoad, onError) {
      const parser = this;
      const json = this.json;
      const extensions = this.extensions;
      this.cache.removeAll();
      this.nodeCache = {};
      this._invokeAll(function(ext) {
        return ext._markDefs && ext._markDefs();
      });
      Promise.all(this._invokeAll(function(ext) {
        return ext.beforeRoot && ext.beforeRoot();
      })).then(function() {
        return Promise.all([
          parser.getDependencies("scene"),
          parser.getDependencies("animation"),
          parser.getDependencies("camera")
        ]);
      }).then(function(dependencies) {
        const result = {
          scene: dependencies[0][json.scene || 0],
          scenes: dependencies[0],
          animations: dependencies[1],
          cameras: dependencies[2],
          asset: json.asset,
          parser,
          userData: {}
        };
        addUnknownExtensionsToUserData(extensions, result, json);
        assignExtrasToUserData(result, json);
        return Promise.all(parser._invokeAll(function(ext) {
          return ext.afterRoot && ext.afterRoot(result);
        })).then(function() {
          for (const scene of result.scenes) {
            scene.updateMatrixWorld();
          }
          onLoad(result);
        });
      }).catch(onError);
    }
    /**
     * Marks the special nodes/meshes in json for efficient parse.
     *
     * @private
     */
    _markDefs() {
      const nodeDefs = this.json.nodes || [];
      const skinDefs = this.json.skins || [];
      const meshDefs = this.json.meshes || [];
      for (let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
        const joints = skinDefs[skinIndex].joints;
        for (let i2 = 0, il = joints.length; i2 < il; i2++) {
          nodeDefs[joints[i2]].isBone = true;
        }
      }
      for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
        const nodeDef = nodeDefs[nodeIndex];
        if (nodeDef.mesh !== void 0) {
          this._addNodeRef(this.meshCache, nodeDef.mesh);
          if (nodeDef.skin !== void 0) {
            meshDefs[nodeDef.mesh].isSkinnedMesh = true;
          }
        }
        if (nodeDef.camera !== void 0) {
          this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
      }
    }
    /**
     * Counts references to shared node / Object3D resources. These resources
     * can be reused, or "instantiated", at multiple nodes in the scene
     * hierarchy. Mesh, Camera, and Light instances are instantiated and must
     * be marked. Non-scenegraph resources (like Materials, Geometries, and
     * Textures) can be reused directly and are not marked here.
     *
     * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
     *
     * @private
     * @param {Object} cache
     * @param {Object3D} index
     */
    _addNodeRef(cache, index) {
      if (index === void 0) return;
      if (cache.refs[index] === void 0) {
        cache.refs[index] = cache.uses[index] = 0;
      }
      cache.refs[index]++;
    }
    /**
     * Returns a reference to a shared resource, cloning it if necessary.
     *
     * @private
     * @param {Object} cache
     * @param {number} index
     * @param {Object} object
     * @return {Object}
     */
    _getNodeRef(cache, index, object) {
      if (cache.refs[index] <= 1) return object;
      const ref = object.clone();
      const updateMappings = (original, clone) => {
        const mappings = this.associations.get(original);
        if (mappings != null) {
          this.associations.set(clone, mappings);
        }
        for (const [i2, child] of original.children.entries()) {
          updateMappings(child, clone.children[i2]);
        }
      };
      updateMappings(object, ref);
      ref.name += "_instance_" + cache.uses[index]++;
      return ref;
    }
    _invokeOne(func) {
      const extensions = Object.values(this.plugins);
      extensions.push(this);
      for (let i2 = 0; i2 < extensions.length; i2++) {
        const result = func(extensions[i2]);
        if (result) return result;
      }
      return null;
    }
    _invokeAll(func) {
      const extensions = Object.values(this.plugins);
      extensions.unshift(this);
      const pending = [];
      for (let i2 = 0; i2 < extensions.length; i2++) {
        const result = func(extensions[i2]);
        if (result) pending.push(result);
      }
      return pending;
    }
    /**
     * Requests the specified dependency asynchronously, with caching.
     *
     * @private
     * @param {string} type
     * @param {number} index
     * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
     */
    getDependency(type, index) {
      const cacheKey = type + ":" + index;
      let dependency = this.cache.get(cacheKey);
      if (!dependency) {
        switch (type) {
          case "scene":
            dependency = this.loadScene(index);
            break;
          case "node":
            dependency = this._invokeOne(function(ext) {
              return ext.loadNode && ext.loadNode(index);
            });
            break;
          case "mesh":
            dependency = this._invokeOne(function(ext) {
              return ext.loadMesh && ext.loadMesh(index);
            });
            break;
          case "accessor":
            dependency = this.loadAccessor(index);
            break;
          case "bufferView":
            dependency = this._invokeOne(function(ext) {
              return ext.loadBufferView && ext.loadBufferView(index);
            });
            break;
          case "buffer":
            dependency = this.loadBuffer(index);
            break;
          case "material":
            dependency = this._invokeOne(function(ext) {
              return ext.loadMaterial && ext.loadMaterial(index);
            });
            break;
          case "texture":
            dependency = this._invokeOne(function(ext) {
              return ext.loadTexture && ext.loadTexture(index);
            });
            break;
          case "skin":
            dependency = this.loadSkin(index);
            break;
          case "animation":
            dependency = this._invokeOne(function(ext) {
              return ext.loadAnimation && ext.loadAnimation(index);
            });
            break;
          case "camera":
            dependency = this.loadCamera(index);
            break;
          default:
            dependency = this._invokeOne(function(ext) {
              return ext != this && ext.getDependency && ext.getDependency(type, index);
            });
            if (!dependency) {
              throw new Error("Unknown type: " + type);
            }
            break;
        }
        this.cache.add(cacheKey, dependency);
      }
      return dependency;
    }
    /**
     * Requests all dependencies of the specified type asynchronously, with caching.
     *
     * @private
     * @param {string} type
     * @return {Promise<Array<Object>>}
     */
    getDependencies(type) {
      let dependencies = this.cache.get(type);
      if (!dependencies) {
        const parser = this;
        const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
        dependencies = Promise.all(defs.map(function(def, index) {
          return parser.getDependency(type, index);
        }));
        this.cache.add(type, dependencies);
      }
      return dependencies;
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
     *
     * @private
     * @param {number} bufferIndex
     * @return {Promise<ArrayBuffer>}
     */
    loadBuffer(bufferIndex) {
      const bufferDef = this.json.buffers[bufferIndex];
      const loader = this.fileLoader;
      if (bufferDef.type && bufferDef.type !== "arraybuffer") {
        throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
      }
      if (bufferDef.uri === void 0 && bufferIndex === 0) {
        return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
      }
      const options = this.options;
      return new Promise(function(resolve, reject) {
        loader.load(LoaderUtils.resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
          reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
        });
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
     *
     * @private
     * @param {number} bufferViewIndex
     * @return {Promise<ArrayBuffer>}
     */
    loadBufferView(bufferViewIndex) {
      const bufferViewDef = this.json.bufferViews[bufferViewIndex];
      return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
        const byteLength = bufferViewDef.byteLength || 0;
        const byteOffset = bufferViewDef.byteOffset || 0;
        return buffer.slice(byteOffset, byteOffset + byteLength);
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
     *
     * @private
     * @param {number} accessorIndex
     * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
     */
    loadAccessor(accessorIndex) {
      const parser = this;
      const json = this.json;
      const accessorDef = this.json.accessors[accessorIndex];
      if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
        const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
        const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        const normalized = accessorDef.normalized === true;
        const array = new TypedArray(accessorDef.count * itemSize);
        return Promise.resolve(new BufferAttribute(array, itemSize, normalized));
      }
      const pendingBufferViews = [];
      if (accessorDef.bufferView !== void 0) {
        pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
      } else {
        pendingBufferViews.push(null);
      }
      if (accessorDef.sparse !== void 0) {
        pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
        pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
      }
      return Promise.all(pendingBufferViews).then(function(bufferViews) {
        const bufferView = bufferViews[0];
        const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
        const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        const elementBytes = TypedArray.BYTES_PER_ELEMENT;
        const itemBytes = elementBytes * itemSize;
        const byteOffset = accessorDef.byteOffset || 0;
        const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
        const normalized = accessorDef.normalized === true;
        let array, bufferAttribute;
        if (byteStride && byteStride !== itemBytes) {
          const ibSlice = Math.floor(byteOffset / byteStride);
          const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
          let ib = parser.cache.get(ibCacheKey);
          if (!ib) {
            array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
            ib = new InterleavedBuffer(array, byteStride / elementBytes);
            parser.cache.add(ibCacheKey, ib);
          }
          bufferAttribute = new InterleavedBufferAttribute(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
        } else {
          if (bufferView === null) {
            array = new TypedArray(accessorDef.count * itemSize);
          } else {
            array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
          }
          bufferAttribute = new BufferAttribute(array, itemSize, normalized);
        }
        if (accessorDef.sparse !== void 0) {
          const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
          const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
          const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
          const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
          const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
          const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
          if (bufferView !== null) {
            bufferAttribute = new BufferAttribute(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
          }
          bufferAttribute.normalized = false;
          for (let i2 = 0, il = sparseIndices.length; i2 < il; i2++) {
            const index = sparseIndices[i2];
            bufferAttribute.setX(index, sparseValues[i2 * itemSize]);
            if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i2 * itemSize + 1]);
            if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i2 * itemSize + 2]);
            if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i2 * itemSize + 3]);
            if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
          }
          bufferAttribute.normalized = normalized;
        }
        return bufferAttribute;
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
     *
     * @private
     * @param {number} textureIndex
     * @return {Promise<THREE.Texture|null>}
     */
    loadTexture(textureIndex) {
      const json = this.json;
      const options = this.options;
      const textureDef = json.textures[textureIndex];
      const sourceIndex = textureDef.source;
      const sourceDef = json.images[sourceIndex];
      let loader = this.textureLoader;
      if (sourceDef.uri) {
        const handler = options.manager.getHandler(sourceDef.uri);
        if (handler !== null) loader = handler;
      }
      return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
      const parser = this;
      const json = this.json;
      const textureDef = json.textures[textureIndex];
      const sourceDef = json.images[sourceIndex];
      const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
      if (this.textureCache[cacheKey]) {
        return this.textureCache[cacheKey];
      }
      const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
        texture.flipY = false;
        texture.name = textureDef.name || sourceDef.name || "";
        if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) {
          texture.name = sourceDef.uri;
        }
        const samplers = json.samplers || {};
        const sampler = samplers[textureDef.sampler] || {};
        texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter;
        texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter;
        texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping;
        texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping;
        texture.generateMipmaps = !texture.isCompressedTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
        parser.associations.set(texture, { textures: textureIndex });
        return texture;
      }).catch(function() {
        return null;
      });
      this.textureCache[cacheKey] = promise;
      return promise;
    }
    loadImageSource(sourceIndex, loader) {
      const parser = this;
      const json = this.json;
      const options = this.options;
      if (this.sourceCache[sourceIndex] !== void 0) {
        return this.sourceCache[sourceIndex].then((texture) => texture.clone());
      }
      const sourceDef = json.images[sourceIndex];
      const URL2 = self.URL || self.webkitURL;
      let sourceURI = sourceDef.uri || "";
      let isObjectURL = false;
      if (sourceDef.bufferView !== void 0) {
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
          isObjectURL = true;
          const blob = new Blob([bufferView], { type: sourceDef.mimeType });
          sourceURI = URL2.createObjectURL(blob);
          return sourceURI;
        });
      } else if (sourceDef.uri === void 0) {
        throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
      }
      const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
        return new Promise(function(resolve, reject) {
          let onLoad = resolve;
          if (loader.isImageBitmapLoader === true) {
            onLoad = function(imageBitmap) {
              const texture = new Texture(imageBitmap);
              texture.needsUpdate = true;
              resolve(texture);
            };
          }
          loader.load(LoaderUtils.resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
        });
      }).then(function(texture) {
        if (isObjectURL === true) {
          URL2.revokeObjectURL(sourceURI);
        }
        assignExtrasToUserData(texture, sourceDef);
        texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
        return texture;
      }).catch(function(error) {
        console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
        throw error;
      });
      this.sourceCache[sourceIndex] = promise;
      return promise;
    }
    /**
     * Asynchronously assigns a texture to the given material parameters.
     *
     * @private
     * @param {Object} materialParams
     * @param {string} mapName
     * @param {Object} mapDef
     * @param {string} [colorSpace]
     * @return {Promise<Texture>}
     */
    assignTexture(materialParams, mapName, mapDef, colorSpace) {
      const parser = this;
      return this.getDependency("texture", mapDef.index).then(function(texture) {
        if (!texture) return null;
        if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
          texture = texture.clone();
          texture.channel = mapDef.texCoord;
        }
        if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
          const transform = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
          if (transform) {
            const gltfReference = parser.associations.get(texture);
            texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
            parser.associations.set(texture, gltfReference);
          }
        }
        if (colorSpace !== void 0) {
          texture.colorSpace = colorSpace;
        }
        materialParams[mapName] = texture;
        return texture;
      });
    }
    /**
     * Assigns final material to a Mesh, Line, or Points instance. The instance
     * already has a material (generated from the glTF material options alone)
     * but reuse of the same glTF material may require multiple threejs materials
     * to accommodate different primitive types, defines, etc. New materials will
     * be created if necessary, and reused from a cache.
     *
     * @private
     * @param {Object3D} mesh Mesh, Line, or Points instance.
     */
    assignFinalMaterial(mesh) {
      const geometry = mesh.geometry;
      let material = mesh.material;
      const useDerivativeTangents = geometry.attributes.tangent === void 0;
      const useVertexColors = geometry.attributes.color !== void 0;
      const useFlatShading = geometry.attributes.normal === void 0;
      if (mesh.isPoints) {
        const cacheKey = "PointsMaterial:" + material.uuid;
        let pointsMaterial = this.cache.get(cacheKey);
        if (!pointsMaterial) {
          pointsMaterial = new PointsMaterial();
          Material.prototype.copy.call(pointsMaterial, material);
          pointsMaterial.color.copy(material.color);
          pointsMaterial.map = material.map;
          pointsMaterial.sizeAttenuation = false;
          this.cache.add(cacheKey, pointsMaterial);
        }
        material = pointsMaterial;
      } else if (mesh.isLine) {
        const cacheKey = "LineBasicMaterial:" + material.uuid;
        let lineMaterial = this.cache.get(cacheKey);
        if (!lineMaterial) {
          lineMaterial = new LineBasicMaterial();
          Material.prototype.copy.call(lineMaterial, material);
          lineMaterial.color.copy(material.color);
          lineMaterial.map = material.map;
          this.cache.add(cacheKey, lineMaterial);
        }
        material = lineMaterial;
      }
      if (useDerivativeTangents || useVertexColors || useFlatShading) {
        let cacheKey = "ClonedMaterial:" + material.uuid + ":";
        if (useDerivativeTangents) cacheKey += "derivative-tangents:";
        if (useVertexColors) cacheKey += "vertex-colors:";
        if (useFlatShading) cacheKey += "flat-shading:";
        let cachedMaterial = this.cache.get(cacheKey);
        if (!cachedMaterial) {
          cachedMaterial = material.clone();
          if (useVertexColors) cachedMaterial.vertexColors = true;
          if (useFlatShading) cachedMaterial.flatShading = true;
          if (useDerivativeTangents) {
            if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
            if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
          }
          this.cache.add(cacheKey, cachedMaterial);
          this.associations.set(cachedMaterial, this.associations.get(material));
        }
        material = cachedMaterial;
      }
      mesh.material = material;
    }
    getMaterialType() {
      return MeshStandardMaterial;
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
     *
     * @private
     * @param {number} materialIndex
     * @return {Promise<Material>}
     */
    loadMaterial(materialIndex) {
      const parser = this;
      const json = this.json;
      const extensions = this.extensions;
      const materialDef = json.materials[materialIndex];
      let materialType;
      const materialParams = {};
      const materialExtensions = materialDef.extensions || {};
      const pending = [];
      if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
        const kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
        materialType = kmuExtension.getMaterialType();
        pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
      } else {
        const metallicRoughness = materialDef.pbrMetallicRoughness || {};
        materialParams.color = new Color(1, 1, 1);
        materialParams.opacity = 1;
        if (Array.isArray(metallicRoughness.baseColorFactor)) {
          const array = metallicRoughness.baseColorFactor;
          materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
          materialParams.opacity = array[3];
        }
        if (metallicRoughness.baseColorTexture !== void 0) {
          pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
        }
        materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
        materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
        if (metallicRoughness.metallicRoughnessTexture !== void 0) {
          pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
          pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
        }
        materialType = this._invokeOne(function(ext) {
          return ext.getMaterialType && ext.getMaterialType(materialIndex);
        });
        pending.push(Promise.all(this._invokeAll(function(ext) {
          return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
        })));
      }
      if (materialDef.doubleSided === true) {
        materialParams.side = DoubleSide;
      }
      const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
      if (alphaMode === ALPHA_MODES.BLEND) {
        materialParams.transparent = true;
        materialParams.depthWrite = false;
      } else {
        materialParams.transparent = false;
        if (alphaMode === ALPHA_MODES.MASK) {
          materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
        }
      }
      if (materialDef.normalTexture !== void 0 && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
        materialParams.normalScale = new Vector2(1, 1);
        if (materialDef.normalTexture.scale !== void 0) {
          const scale = materialDef.normalTexture.scale;
          materialParams.normalScale.set(scale, scale);
        }
      }
      if (materialDef.occlusionTexture !== void 0 && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
        if (materialDef.occlusionTexture.strength !== void 0) {
          materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
      }
      if (materialDef.emissiveFactor !== void 0 && materialType !== MeshBasicMaterial) {
        const emissiveFactor = materialDef.emissiveFactor;
        materialParams.emissive = new Color().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], LinearSRGBColorSpace);
      }
      if (materialDef.emissiveTexture !== void 0 && materialType !== MeshBasicMaterial) {
        pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, SRGBColorSpace));
      }
      return Promise.all(pending).then(function() {
        const material = new materialType(materialParams);
        if (materialDef.name) material.name = materialDef.name;
        assignExtrasToUserData(material, materialDef);
        parser.associations.set(material, { materials: materialIndex });
        if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);
        return material;
      });
    }
    /**
     * When Object3D instances are targeted by animation, they need unique names.
     *
     * @private
     * @param {string} originalName
     * @return {string}
     */
    createUniqueName(originalName) {
      const sanitizedName = PropertyBinding.sanitizeNodeName(originalName || "");
      if (sanitizedName in this.nodeNamesUsed) {
        return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
      } else {
        this.nodeNamesUsed[sanitizedName] = 0;
        return sanitizedName;
      }
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
     *
     * Creates BufferGeometries from primitives.
     *
     * @private
     * @param {Array<GLTF.Primitive>} primitives
     * @return {Promise<Array<BufferGeometry>>}
     */
    loadGeometries(primitives) {
      const parser = this;
      const extensions = this.extensions;
      const cache = this.primitiveCache;
      function createDracoPrimitive(primitive) {
        return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
          return addPrimitiveAttributes(geometry, primitive, parser);
        });
      }
      const pending = [];
      for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
        const primitive = primitives[i2];
        const cacheKey = createPrimitiveKey(primitive);
        const cached = cache[cacheKey];
        if (cached) {
          pending.push(cached.promise);
        } else {
          let geometryPromise;
          if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {
            geometryPromise = createDracoPrimitive(primitive);
          } else {
            geometryPromise = addPrimitiveAttributes(new BufferGeometry(), primitive, parser);
          }
          cache[cacheKey] = { primitive, promise: geometryPromise };
          pending.push(geometryPromise);
        }
      }
      return Promise.all(pending);
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
     *
     * @private
     * @param {number} meshIndex
     * @return {Promise<Group|Mesh|SkinnedMesh|Line|Points>}
     */
    loadMesh(meshIndex) {
      const parser = this;
      const json = this.json;
      const extensions = this.extensions;
      const meshDef = json.meshes[meshIndex];
      const primitives = meshDef.primitives;
      const pending = [];
      for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
        const material = primitives[i2].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i2].material);
        pending.push(material);
      }
      pending.push(parser.loadGeometries(primitives));
      return Promise.all(pending).then(function(results) {
        const materials = results.slice(0, results.length - 1);
        const geometries = results[results.length - 1];
        const meshes = [];
        for (let i2 = 0, il = geometries.length; i2 < il; i2++) {
          const geometry = geometries[i2];
          const primitive = primitives[i2];
          let mesh;
          const material = materials[i2];
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
            mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh(geometry, material) : new Mesh(geometry, material);
            if (mesh.isSkinnedMesh === true) {
              mesh.normalizeSkinWeights();
            }
            if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
              mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
            } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
              mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
            }
          } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
            mesh = new LineSegments(geometry, material);
          } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
            mesh = new Line(geometry, material);
          } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
            mesh = new LineLoop(geometry, material);
          } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
            mesh = new Points(geometry, material);
          } else {
            throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
          }
          if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
            updateMorphTargets(mesh, meshDef);
          }
          mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
          assignExtrasToUserData(mesh, meshDef);
          if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);
          parser.assignFinalMaterial(mesh);
          meshes.push(mesh);
        }
        for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
          parser.associations.set(meshes[i2], {
            meshes: meshIndex,
            primitives: i2
          });
        }
        if (meshes.length === 1) {
          if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
          return meshes[0];
        }
        const group = new Group();
        if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, group, meshDef);
        parser.associations.set(group, { meshes: meshIndex });
        for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
          group.add(meshes[i2]);
        }
        return group;
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
     *
     * @private
     * @param {number} cameraIndex
     * @return {Promise<THREE.Camera>}
     */
    loadCamera(cameraIndex) {
      let camera;
      const cameraDef = this.json.cameras[cameraIndex];
      const params = cameraDef[cameraDef.type];
      if (!params) {
        console.warn("THREE.GLTFLoader: Missing camera parameters.");
        return;
      }
      if (cameraDef.type === "perspective") {
        camera = new PerspectiveCamera(MathUtils.radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
      } else if (cameraDef.type === "orthographic") {
        camera = new OrthographicCamera(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
      }
      if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
      assignExtrasToUserData(camera, cameraDef);
      return Promise.resolve(camera);
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
     *
     * @private
     * @param {number} skinIndex
     * @return {Promise<Skeleton>}
     */
    loadSkin(skinIndex) {
      const skinDef = this.json.skins[skinIndex];
      const pending = [];
      for (let i2 = 0, il = skinDef.joints.length; i2 < il; i2++) {
        pending.push(this._loadNodeShallow(skinDef.joints[i2]));
      }
      if (skinDef.inverseBindMatrices !== void 0) {
        pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
      } else {
        pending.push(null);
      }
      return Promise.all(pending).then(function(results) {
        const inverseBindMatrices = results.pop();
        const jointNodes = results;
        const bones = [];
        const boneInverses = [];
        for (let i2 = 0, il = jointNodes.length; i2 < il; i2++) {
          const jointNode = jointNodes[i2];
          if (jointNode) {
            bones.push(jointNode);
            const mat = new Matrix4();
            if (inverseBindMatrices !== null) {
              mat.fromArray(inverseBindMatrices.array, i2 * 16);
            }
            boneInverses.push(mat);
          } else {
            console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i2]);
          }
        }
        return new Skeleton(bones, boneInverses);
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
     *
     * @private
     * @param {number} animationIndex
     * @return {Promise<AnimationClip>}
     */
    loadAnimation(animationIndex) {
      const json = this.json;
      const parser = this;
      const animationDef = json.animations[animationIndex];
      const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
      const pendingNodes = [];
      const pendingInputAccessors = [];
      const pendingOutputAccessors = [];
      const pendingSamplers = [];
      const pendingTargets = [];
      for (let i2 = 0, il = animationDef.channels.length; i2 < il; i2++) {
        const channel = animationDef.channels[i2];
        const sampler = animationDef.samplers[channel.sampler];
        const target = channel.target;
        const name = target.node;
        const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
        const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
        if (target.node === void 0) continue;
        pendingNodes.push(this.getDependency("node", name));
        pendingInputAccessors.push(this.getDependency("accessor", input));
        pendingOutputAccessors.push(this.getDependency("accessor", output));
        pendingSamplers.push(sampler);
        pendingTargets.push(target);
      }
      return Promise.all([
        Promise.all(pendingNodes),
        Promise.all(pendingInputAccessors),
        Promise.all(pendingOutputAccessors),
        Promise.all(pendingSamplers),
        Promise.all(pendingTargets)
      ]).then(function(dependencies) {
        const nodes = dependencies[0];
        const inputAccessors = dependencies[1];
        const outputAccessors = dependencies[2];
        const samplers = dependencies[3];
        const targets = dependencies[4];
        const tracks = [];
        for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
          const node = nodes[i2];
          const inputAccessor = inputAccessors[i2];
          const outputAccessor = outputAccessors[i2];
          const sampler = samplers[i2];
          const target = targets[i2];
          if (node === void 0) continue;
          if (node.updateMatrix) {
            node.updateMatrix();
          }
          const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
          if (createdTracks) {
            for (let k2 = 0; k2 < createdTracks.length; k2++) {
              tracks.push(createdTracks[k2]);
            }
          }
        }
        return new AnimationClip(animationName, void 0, tracks);
      });
    }
    createNodeMesh(nodeIndex) {
      const json = this.json;
      const parser = this;
      const nodeDef = json.nodes[nodeIndex];
      if (nodeDef.mesh === void 0) return null;
      return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
        const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
        if (nodeDef.weights !== void 0) {
          node.traverse(function(o2) {
            if (!o2.isMesh) return;
            for (let i2 = 0, il = nodeDef.weights.length; i2 < il; i2++) {
              o2.morphTargetInfluences[i2] = nodeDef.weights[i2];
            }
          });
        }
        return node;
      });
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
     *
     * @private
     * @param {number} nodeIndex
     * @return {Promise<Object3D>}
     */
    loadNode(nodeIndex) {
      const json = this.json;
      const parser = this;
      const nodeDef = json.nodes[nodeIndex];
      const nodePending = parser._loadNodeShallow(nodeIndex);
      const childPending = [];
      const childrenDef = nodeDef.children || [];
      for (let i2 = 0, il = childrenDef.length; i2 < il; i2++) {
        childPending.push(parser.getDependency("node", childrenDef[i2]));
      }
      const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
      return Promise.all([
        nodePending,
        Promise.all(childPending),
        skeletonPending
      ]).then(function(results) {
        const node = results[0];
        const children = results[1];
        const skeleton = results[2];
        if (skeleton !== null) {
          node.traverse(function(mesh) {
            if (!mesh.isSkinnedMesh) return;
            mesh.bind(skeleton, _identityMatrix);
          });
        }
        for (let i2 = 0, il = children.length; i2 < il; i2++) {
          node.add(children[i2]);
        }
        return node;
      });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
      const json = this.json;
      const extensions = this.extensions;
      const parser = this;
      if (this.nodeCache[nodeIndex] !== void 0) {
        return this.nodeCache[nodeIndex];
      }
      const nodeDef = json.nodes[nodeIndex];
      const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
      const pending = [];
      const meshPromise = parser._invokeOne(function(ext) {
        return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
      });
      if (meshPromise) {
        pending.push(meshPromise);
      }
      if (nodeDef.camera !== void 0) {
        pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
          return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
      }
      parser._invokeAll(function(ext) {
        return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
      }).forEach(function(promise) {
        pending.push(promise);
      });
      this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
        let node;
        if (nodeDef.isBone === true) {
          node = new Bone();
        } else if (objects.length > 1) {
          node = new Group();
        } else if (objects.length === 1) {
          node = objects[0];
        } else {
          node = new Object3D();
        }
        if (node !== objects[0]) {
          for (let i2 = 0, il = objects.length; i2 < il; i2++) {
            node.add(objects[i2]);
          }
        }
        if (nodeDef.name) {
          node.userData.name = nodeDef.name;
          node.name = nodeName;
        }
        assignExtrasToUserData(node, nodeDef);
        if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);
        if (nodeDef.matrix !== void 0) {
          const matrix = new Matrix4();
          matrix.fromArray(nodeDef.matrix);
          node.applyMatrix4(matrix);
        } else {
          if (nodeDef.translation !== void 0) {
            node.position.fromArray(nodeDef.translation);
          }
          if (nodeDef.rotation !== void 0) {
            node.quaternion.fromArray(nodeDef.rotation);
          }
          if (nodeDef.scale !== void 0) {
            node.scale.fromArray(nodeDef.scale);
          }
        }
        if (!parser.associations.has(node)) {
          parser.associations.set(node, {});
        } else if (nodeDef.mesh !== void 0 && parser.meshCache.refs[nodeDef.mesh] > 1) {
          const mapping = parser.associations.get(node);
          parser.associations.set(node, { ...mapping });
        }
        parser.associations.get(node).nodes = nodeIndex;
        return node;
      });
      return this.nodeCache[nodeIndex];
    }
    /**
     * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
     *
     * @private
     * @param {number} sceneIndex
     * @return {Promise<Group>}
     */
    loadScene(sceneIndex) {
      const extensions = this.extensions;
      const sceneDef = this.json.scenes[sceneIndex];
      const parser = this;
      const scene = new Group();
      if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
      assignExtrasToUserData(scene, sceneDef);
      if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);
      const nodeIds = sceneDef.nodes || [];
      const pending = [];
      for (let i2 = 0, il = nodeIds.length; i2 < il; i2++) {
        pending.push(parser.getDependency("node", nodeIds[i2]));
      }
      return Promise.all(pending).then(function(nodes) {
        for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
          scene.add(nodes[i2]);
        }
        const reduceAssociations = (node) => {
          const reducedAssociations = /* @__PURE__ */ new Map();
          for (const [key, value] of parser.associations) {
            if (key instanceof Material || key instanceof Texture) {
              reducedAssociations.set(key, value);
            }
          }
          node.traverse((node2) => {
            const mappings = parser.associations.get(node2);
            if (mappings != null) {
              reducedAssociations.set(node2, mappings);
            }
          });
          return reducedAssociations;
        };
        parser.associations = reduceAssociations(scene);
        return scene;
      });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
      const tracks = [];
      const targetName = node.name ? node.name : node.uuid;
      const targetNames = [];
      if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
        node.traverse(function(object) {
          if (object.morphTargetInfluences) {
            targetNames.push(object.name ? object.name : object.uuid);
          }
        });
      } else {
        targetNames.push(targetName);
      }
      let TypedKeyframeTrack;
      switch (PATH_PROPERTIES[target.path]) {
        case PATH_PROPERTIES.weights:
          TypedKeyframeTrack = NumberKeyframeTrack;
          break;
        case PATH_PROPERTIES.rotation:
          TypedKeyframeTrack = QuaternionKeyframeTrack;
          break;
        case PATH_PROPERTIES.translation:
        case PATH_PROPERTIES.scale:
          TypedKeyframeTrack = VectorKeyframeTrack;
          break;
        default:
          switch (outputAccessor.itemSize) {
            case 1:
              TypedKeyframeTrack = NumberKeyframeTrack;
              break;
            case 2:
            case 3:
            default:
              TypedKeyframeTrack = VectorKeyframeTrack;
              break;
          }
          break;
      }
      const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : InterpolateLinear;
      const outputArray = this._getArrayFromAccessor(outputAccessor);
      for (let j2 = 0, jl = targetNames.length; j2 < jl; j2++) {
        const track = new TypedKeyframeTrack(
          targetNames[j2] + "." + PATH_PROPERTIES[target.path],
          inputAccessor.array,
          outputArray,
          interpolation
        );
        if (sampler.interpolation === "CUBICSPLINE") {
          this._createCubicSplineTrackInterpolant(track);
        }
        tracks.push(track);
      }
      return tracks;
    }
    _getArrayFromAccessor(accessor) {
      let outputArray = accessor.array;
      if (accessor.normalized) {
        const scale = getNormalizedComponentScale(outputArray.constructor);
        const scaled = new Float32Array(outputArray.length);
        for (let j2 = 0, jl = outputArray.length; j2 < jl; j2++) {
          scaled[j2] = outputArray[j2] * scale;
        }
        outputArray = scaled;
      }
      return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
      track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
        const interpolantType = this instanceof QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
        return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
      };
      track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
  }
  function computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new Box3();
    if (attributes.POSITION !== void 0) {
      const accessor = parser.json.accessors[attributes.POSITION];
      const min = accessor.min;
      const max = accessor.max;
      if (min !== void 0 && max !== void 0) {
        box.set(
          new Vector3(min[0], min[1], min[2]),
          new Vector3(max[0], max[1], max[2])
        );
        if (accessor.normalized) {
          const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
          box.min.multiplyScalar(boxScale);
          box.max.multiplyScalar(boxScale);
        }
      } else {
        console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        return;
      }
    } else {
      return;
    }
    const targets = primitiveDef.targets;
    if (targets !== void 0) {
      const maxDisplacement = new Vector3();
      const vector = new Vector3();
      for (let i2 = 0, il = targets.length; i2 < il; i2++) {
        const target = targets[i2];
        if (target.POSITION !== void 0) {
          const accessor = parser.json.accessors[target.POSITION];
          const min = accessor.min;
          const max = accessor.max;
          if (min !== void 0 && max !== void 0) {
            vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
            vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
            vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
            if (accessor.normalized) {
              const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
              vector.multiplyScalar(boxScale);
            }
            maxDisplacement.max(vector);
          } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
          }
        }
      }
      box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new Sphere();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
  }
  function addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
      return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
        geometry.setAttribute(attributeName, accessor);
      });
    }
    for (const gltfAttributeName in attributes) {
      const threeAttributeName = ATTRIBUTES$1[gltfAttributeName] || gltfAttributeName.toLowerCase();
      if (threeAttributeName in geometry.attributes) continue;
      pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== void 0 && !geometry.index) {
      const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
        geometry.setIndex(accessor2);
      });
      pending.push(accessor);
    }
    if (ColorManagement.workingColorSpace !== LinearSRGBColorSpace && "COLOR_0" in attributes) {
      console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${ColorManagement.workingColorSpace}" not supported.`);
    }
    assignExtrasToUserData(geometry, primitiveDef);
    computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
      return primitiveDef.targets !== void 0 ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
  }
  class RoomEnvironment extends Scene {
    constructor() {
      super();
      const geometry = new BoxGeometry();
      geometry.deleteAttribute("uv");
      const roomMaterial = new MeshStandardMaterial({ side: BackSide });
      const boxMaterial = new MeshStandardMaterial();
      const mainLight = new PointLight(16777215, 900, 28, 2);
      mainLight.position.set(0.418, 16.199, 0.3);
      this.add(mainLight);
      const room = new Mesh(geometry, roomMaterial);
      room.position.set(-0.757, 13.219, 0.717);
      room.scale.set(31.713, 28.305, 28.591);
      this.add(room);
      const boxes = new InstancedMesh(geometry, boxMaterial, 6);
      const transform = new Object3D();
      transform.position.set(-10.906, 2.009, 1.846);
      transform.rotation.set(0, -0.195, 0);
      transform.scale.set(2.328, 7.905, 4.651);
      transform.updateMatrix();
      boxes.setMatrixAt(0, transform.matrix);
      transform.position.set(-5.607, -0.754, -0.758);
      transform.rotation.set(0, 0.994, 0);
      transform.scale.set(1.97, 1.534, 3.955);
      transform.updateMatrix();
      boxes.setMatrixAt(1, transform.matrix);
      transform.position.set(6.167, 0.857, 7.803);
      transform.rotation.set(0, 0.561, 0);
      transform.scale.set(3.927, 6.285, 3.687);
      transform.updateMatrix();
      boxes.setMatrixAt(2, transform.matrix);
      transform.position.set(-2.017, 0.018, 6.124);
      transform.rotation.set(0, 0.333, 0);
      transform.scale.set(2.002, 4.566, 2.064);
      transform.updateMatrix();
      boxes.setMatrixAt(3, transform.matrix);
      transform.position.set(2.291, -0.756, -2.621);
      transform.rotation.set(0, -0.286, 0);
      transform.scale.set(1.546, 1.552, 1.496);
      transform.updateMatrix();
      boxes.setMatrixAt(4, transform.matrix);
      transform.position.set(-2.193, -0.369, -5.547);
      transform.rotation.set(0, 0.516, 0);
      transform.scale.set(3.875, 3.487, 2.986);
      transform.updateMatrix();
      boxes.setMatrixAt(5, transform.matrix);
      this.add(boxes);
      const light1 = new Mesh(geometry, createAreaLightMaterial(50));
      light1.position.set(-16.116, 14.37, 8.208);
      light1.scale.set(0.1, 2.428, 2.739);
      this.add(light1);
      const light2 = new Mesh(geometry, createAreaLightMaterial(50));
      light2.position.set(-16.109, 18.021, -8.207);
      light2.scale.set(0.1, 2.425, 2.751);
      this.add(light2);
      const light3 = new Mesh(geometry, createAreaLightMaterial(17));
      light3.position.set(14.904, 12.198, -1.832);
      light3.scale.set(0.15, 4.265, 6.331);
      this.add(light3);
      const light4 = new Mesh(geometry, createAreaLightMaterial(43));
      light4.position.set(-0.462, 8.89, 14.52);
      light4.scale.set(4.38, 5.441, 0.088);
      this.add(light4);
      const light5 = new Mesh(geometry, createAreaLightMaterial(20));
      light5.position.set(3.235, 11.486, -12.541);
      light5.scale.set(2.5, 2, 0.1);
      this.add(light5);
      const light6 = new Mesh(geometry, createAreaLightMaterial(100));
      light6.position.set(0, 20, 0);
      light6.scale.set(1, 0.1, 1);
      this.add(light6);
    }
    /**
     * Frees internal resources. This method should be called
     * when the environment is no longer required.
     */
    dispose() {
      const resources = /* @__PURE__ */ new Set();
      this.traverse((object) => {
        if (object.isMesh) {
          resources.add(object.geometry);
          resources.add(object.material);
        }
      });
      for (const resource of resources) {
        resource.dispose();
      }
    }
  }
  function createAreaLightMaterial(intensity) {
    const material = new MeshBasicMaterial();
    material.color.setScalar(intensity);
    return material;
  }
  const _tempNormal = new Vector3();
  function getUv(faceDirVector, normal, uvAxis, projectionAxis, radius, sideLength) {
    const totArcLength = 2 * Math.PI * radius / 4;
    const centerLength = Math.max(sideLength - 2 * radius, 0);
    const halfArc = Math.PI / 4;
    _tempNormal.copy(normal);
    _tempNormal[projectionAxis] = 0;
    _tempNormal.normalize();
    const arcUvRatio = 0.5 * totArcLength / (totArcLength + centerLength);
    const arcAngleRatio = 1 - _tempNormal.angleTo(faceDirVector) / halfArc;
    if (Math.sign(_tempNormal[uvAxis]) === 1) {
      return arcAngleRatio * arcUvRatio;
    } else {
      const lenUv = centerLength / (totArcLength + centerLength);
      return lenUv + arcUvRatio + arcUvRatio * (1 - arcAngleRatio);
    }
  }
  class RoundedBoxGeometry extends BoxGeometry {
    /**
     * Constructs a new rounded box geometry.
     *
     * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
     * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
     * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
     * @param {number} [segments=2] - Number of segmented that form the rounded corners.
     * @param {number} [radius=0.1] - The radius of the rounded corners.
     */
    constructor(width = 1, height = 1, depth = 1, segments = 2, radius = 0.1) {
      segments = segments * 2 + 1;
      radius = Math.min(width / 2, height / 2, depth / 2, radius);
      super(width, height, depth, segments, segments, segments);
      if (segments === 1) return;
      const geometry2 = this.toNonIndexed();
      this.index = null;
      this.attributes.position = geometry2.attributes.position;
      this.attributes.normal = geometry2.attributes.normal;
      this.attributes.uv = geometry2.attributes.uv;
      const position = new Vector3();
      const normal = new Vector3();
      const box = new Vector3(width, height, depth).divideScalar(2).subScalar(radius);
      const positions = this.attributes.position.array;
      const normals = this.attributes.normal.array;
      const uvs = this.attributes.uv.array;
      const faceTris = positions.length / 6;
      const faceDirVector = new Vector3();
      const halfSegmentSize = 0.5 / segments;
      for (let i2 = 0, j2 = 0; i2 < positions.length; i2 += 3, j2 += 2) {
        position.fromArray(positions, i2);
        normal.copy(position);
        normal.x -= Math.sign(normal.x) * halfSegmentSize;
        normal.y -= Math.sign(normal.y) * halfSegmentSize;
        normal.z -= Math.sign(normal.z) * halfSegmentSize;
        normal.normalize();
        positions[i2 + 0] = box.x * Math.sign(position.x) + normal.x * radius;
        positions[i2 + 1] = box.y * Math.sign(position.y) + normal.y * radius;
        positions[i2 + 2] = box.z * Math.sign(position.z) + normal.z * radius;
        normals[i2 + 0] = normal.x;
        normals[i2 + 1] = normal.y;
        normals[i2 + 2] = normal.z;
        const side = Math.floor(i2 / faceTris);
        switch (side) {
          case 0:
            faceDirVector.set(1, 0, 0);
            uvs[j2 + 0] = getUv(faceDirVector, normal, "z", "y", radius, depth);
            uvs[j2 + 1] = 1 - getUv(faceDirVector, normal, "y", "z", radius, height);
            break;
          case 1:
            faceDirVector.set(-1, 0, 0);
            uvs[j2 + 0] = 1 - getUv(faceDirVector, normal, "z", "y", radius, depth);
            uvs[j2 + 1] = 1 - getUv(faceDirVector, normal, "y", "z", radius, height);
            break;
          case 2:
            faceDirVector.set(0, 1, 0);
            uvs[j2 + 0] = 1 - getUv(faceDirVector, normal, "x", "z", radius, width);
            uvs[j2 + 1] = getUv(faceDirVector, normal, "z", "x", radius, depth);
            break;
          case 3:
            faceDirVector.set(0, -1, 0);
            uvs[j2 + 0] = 1 - getUv(faceDirVector, normal, "x", "z", radius, width);
            uvs[j2 + 1] = 1 - getUv(faceDirVector, normal, "z", "x", radius, depth);
            break;
          case 4:
            faceDirVector.set(0, 0, 1);
            uvs[j2 + 0] = 1 - getUv(faceDirVector, normal, "x", "y", radius, width);
            uvs[j2 + 1] = 1 - getUv(faceDirVector, normal, "y", "x", radius, height);
            break;
          case 5:
            faceDirVector.set(0, 0, -1);
            uvs[j2 + 0] = getUv(faceDirVector, normal, "x", "y", radius, width);
            uvs[j2 + 1] = 1 - getUv(faceDirVector, normal, "y", "x", radius, height);
            break;
        }
      }
    }
  }
  class DecalGeometry extends BufferGeometry {
    /**
     * Constructs a new decal geometry.
     *
     * @param {Mesh} [mesh] - The base mesh the decal should be projected on.
     * @param {Vector3} [position] - The position of the decal projector.
     * @param {Euler} [orientation] - The orientation of the decal projector.
     * @param {Vector3} [size] - Tje scale of the decal projector.
     */
    constructor(mesh = new Mesh(), position = new Vector3(), orientation = new Euler(), size = new Vector3(1, 1, 1)) {
      super();
      const vertices = [];
      const normals = [];
      const uvs = [];
      const plane = new Vector3();
      const normalMatrix = new Matrix3().getNormalMatrix(mesh.matrixWorld);
      const projectorMatrix = new Matrix4();
      projectorMatrix.makeRotationFromEuler(orientation);
      projectorMatrix.setPosition(position);
      const projectorMatrixInverse = new Matrix4();
      projectorMatrixInverse.copy(projectorMatrix).invert();
      generate();
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
      this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
      if (normals.length > 0) {
        this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
      }
      function generate() {
        let decalVertices = [];
        const vertex2 = new Vector3();
        const normal = new Vector3();
        const geometry = mesh.geometry;
        const positionAttribute = geometry.attributes.position;
        const normalAttribute = geometry.attributes.normal;
        if (geometry.index !== null) {
          const index = geometry.index;
          for (let i2 = 0; i2 < index.count; i2++) {
            vertex2.fromBufferAttribute(positionAttribute, index.getX(i2));
            if (normalAttribute) {
              normal.fromBufferAttribute(normalAttribute, index.getX(i2));
              pushDecalVertex(decalVertices, vertex2, normal);
            } else {
              pushDecalVertex(decalVertices, vertex2);
            }
          }
        } else {
          if (positionAttribute === void 0) return;
          for (let i2 = 0; i2 < positionAttribute.count; i2++) {
            vertex2.fromBufferAttribute(positionAttribute, i2);
            if (normalAttribute) {
              normal.fromBufferAttribute(normalAttribute, i2);
              pushDecalVertex(decalVertices, vertex2, normal);
            } else {
              pushDecalVertex(decalVertices, vertex2);
            }
          }
        }
        decalVertices = clipGeometry(decalVertices, plane.set(1, 0, 0));
        decalVertices = clipGeometry(decalVertices, plane.set(-1, 0, 0));
        decalVertices = clipGeometry(decalVertices, plane.set(0, 1, 0));
        decalVertices = clipGeometry(decalVertices, plane.set(0, -1, 0));
        decalVertices = clipGeometry(decalVertices, plane.set(0, 0, 1));
        decalVertices = clipGeometry(decalVertices, plane.set(0, 0, -1));
        for (let i2 = 0; i2 < decalVertices.length; i2++) {
          const decalVertex = decalVertices[i2];
          uvs.push(
            0.5 + decalVertex.position.x / size.x,
            0.5 + decalVertex.position.y / size.y
          );
          decalVertex.position.applyMatrix4(projectorMatrix);
          vertices.push(decalVertex.position.x, decalVertex.position.y, decalVertex.position.z);
          if (decalVertex.normal !== null) {
            normals.push(decalVertex.normal.x, decalVertex.normal.y, decalVertex.normal.z);
          }
        }
      }
      function pushDecalVertex(decalVertices, vertex2, normal = null) {
        vertex2.applyMatrix4(mesh.matrixWorld);
        vertex2.applyMatrix4(projectorMatrixInverse);
        if (normal) {
          normal.applyNormalMatrix(normalMatrix);
          decalVertices.push(new DecalVertex(vertex2.clone(), normal.clone()));
        } else {
          decalVertices.push(new DecalVertex(vertex2.clone()));
        }
      }
      function clipGeometry(inVertices, plane2) {
        const outVertices = [];
        const s2 = 0.5 * Math.abs(size.dot(plane2));
        for (let i2 = 0; i2 < inVertices.length; i2 += 3) {
          let total = 0;
          let nV1;
          let nV2;
          let nV3;
          let nV4;
          const d1 = inVertices[i2 + 0].position.dot(plane2) - s2;
          const d2 = inVertices[i2 + 1].position.dot(plane2) - s2;
          const d3 = inVertices[i2 + 2].position.dot(plane2) - s2;
          const v1Out = d1 > 0;
          const v2Out = d2 > 0;
          const v3Out = d3 > 0;
          total = (v1Out ? 1 : 0) + (v2Out ? 1 : 0) + (v3Out ? 1 : 0);
          switch (total) {
            case 0: {
              outVertices.push(inVertices[i2]);
              outVertices.push(inVertices[i2 + 1]);
              outVertices.push(inVertices[i2 + 2]);
              break;
            }
            case 1: {
              if (v1Out) {
                nV1 = inVertices[i2 + 1];
                nV2 = inVertices[i2 + 2];
                nV3 = clip(inVertices[i2], nV1, plane2, s2);
                nV4 = clip(inVertices[i2], nV2, plane2, s2);
              }
              if (v2Out) {
                nV1 = inVertices[i2];
                nV2 = inVertices[i2 + 2];
                nV3 = clip(inVertices[i2 + 1], nV1, plane2, s2);
                nV4 = clip(inVertices[i2 + 1], nV2, plane2, s2);
                outVertices.push(nV3);
                outVertices.push(nV2.clone());
                outVertices.push(nV1.clone());
                outVertices.push(nV2.clone());
                outVertices.push(nV3.clone());
                outVertices.push(nV4);
                break;
              }
              if (v3Out) {
                nV1 = inVertices[i2];
                nV2 = inVertices[i2 + 1];
                nV3 = clip(inVertices[i2 + 2], nV1, plane2, s2);
                nV4 = clip(inVertices[i2 + 2], nV2, plane2, s2);
              }
              outVertices.push(nV1.clone());
              outVertices.push(nV2.clone());
              outVertices.push(nV3);
              outVertices.push(nV4);
              outVertices.push(nV3.clone());
              outVertices.push(nV2.clone());
              break;
            }
            case 2: {
              if (!v1Out) {
                nV1 = inVertices[i2].clone();
                nV2 = clip(nV1, inVertices[i2 + 1], plane2, s2);
                nV3 = clip(nV1, inVertices[i2 + 2], plane2, s2);
                outVertices.push(nV1);
                outVertices.push(nV2);
                outVertices.push(nV3);
              }
              if (!v2Out) {
                nV1 = inVertices[i2 + 1].clone();
                nV2 = clip(nV1, inVertices[i2 + 2], plane2, s2);
                nV3 = clip(nV1, inVertices[i2], plane2, s2);
                outVertices.push(nV1);
                outVertices.push(nV2);
                outVertices.push(nV3);
              }
              if (!v3Out) {
                nV1 = inVertices[i2 + 2].clone();
                nV2 = clip(nV1, inVertices[i2], plane2, s2);
                nV3 = clip(nV1, inVertices[i2 + 1], plane2, s2);
                outVertices.push(nV1);
                outVertices.push(nV2);
                outVertices.push(nV3);
              }
              break;
            }
          }
        }
        return outVertices;
      }
      function clip(v0, v1, p2, s2) {
        const d0 = v0.position.dot(p2) - s2;
        const d1 = v1.position.dot(p2) - s2;
        const s0 = d0 / (d0 - d1);
        const position2 = new Vector3(
          v0.position.x + s0 * (v1.position.x - v0.position.x),
          v0.position.y + s0 * (v1.position.y - v0.position.y),
          v0.position.z + s0 * (v1.position.z - v0.position.z)
        );
        let normal = null;
        if (v0.normal !== null && v1.normal !== null) {
          normal = new Vector3(
            v0.normal.x + s0 * (v1.normal.x - v0.normal.x),
            v0.normal.y + s0 * (v1.normal.y - v0.normal.y),
            v0.normal.z + s0 * (v1.normal.z - v0.normal.z)
          );
        }
        const v2 = new DecalVertex(position2, normal);
        return v2;
      }
    }
  }
  class DecalVertex {
    constructor(position, normal = null) {
      this.position = position;
      this.normal = normal;
    }
    clone() {
      const position = this.position.clone();
      const normal = this.normal !== null ? this.normal.clone() : null;
      return new this.constructor(position, normal);
    }
  }
  class Product3DPreview {
    constructor(container) {
      __privateAdd(this, _Product3DPreview_instances);
      this.container = container;
      this.scene = new Scene();
      this.scene.background = new Color(14933459);
      this.camera = new PerspectiveCamera(31, 1, 0.05, 200);
      this.camera.position.set(0, 0.25, 7);
      this.renderer = new WebGLRenderer({ antialias: true, alpha: false, powerPreference: "high-performance" });
      this.renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
      this.renderer.outputColorSpace = SRGBColorSpace;
      this.renderer.toneMapping = ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 0.76;
      this.renderer.shadowMap.enabled = true;
      this.renderer.shadowMap.type = PCFSoftShadowMap;
      this.container.append(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;
      this.controls.enablePan = false;
      this.controls.minDistance = 1;
      this.controls.maxDistance = 40;
      this.controls.autoRotate = true;
      this.controls.autoRotateSpeed = 0.55;
      this.loader = new GLTFLoader();
      const pmrem = new PMREMGenerator(this.renderer);
      const room = new RoomEnvironment();
      this.environment = pmrem.fromScene(room, 0.04).texture;
      room.dispose();
      pmrem.dispose();
      this.scene.environment = this.environment;
      __privateMethod(this, _Product3DPreview_instances, lights_fn).call(this);
      __privateMethod(this, _Product3DPreview_instances, ground_fn).call(this);
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(container);
      this.resize();
      this.animate();
    }
    async setProduct(product, color, designCanvas, face = "front") {
      const loadId = ++this.loadId || (this.loadId = 1);
      this.product = product;
      this.color = color;
      this.face = face;
      this.sourceCanvas = designCanvas;
      this.printMaterials = [];
      __privateMethod(this, _Product3DPreview_instances, clearProduct_fn).call(this);
      this.ownedTextures = [];
      this.container.classList.add("model-loading");
      try {
        if (product.model3d?.url) {
          try {
            await __privateMethod(this, _Product3DPreview_instances, loadGLTFProduct_fn).call(this, product, color, loadId);
          } catch (error) {
            console.warn("[3D] GLB load failed:", error.message);
            if (loadId !== this.loadId) return;
            this.container.dispatchEvent(new CustomEvent("modelwarning", { detail: { message: "3D 模型加载中，请稍候重试…" } }));
            return;
          }
        } else __privateMethod(this, _Product3DPreview_instances, createProceduralProduct_fn).call(this, product, color);
        if (loadId !== this.loadId) return;
        this.updateDesign(designCanvas, face);
        __privateMethod(this, _Product3DPreview_instances, applyCamera_fn).call(this, product.model3d?.camera || (product.type === "apparel" ? { x: 0, y: -0.04, z: 9.45, targetX: 0, targetY: -0.1, targetZ: 0 } : void 0));
        __privateMethod(this, _Product3DPreview_instances, positionGround_fn).call(this);
      } finally {
        if (loadId === this.loadId) this.container.classList.remove("model-loading");
      }
    }
    updateDesign(sourceCanvas, face = this.face) {
      if (!sourceCanvas || !this.printMaterials.length) return;
      this.sourceCanvas = sourceCanvas;
      this.face = face;
      this.texture?.dispose();
      this.textureCanvas = createMappedDesignCanvas(sourceCanvas, this.product);
      const context = this.textureCanvas.getContext("2d", { willReadFrequently: true });
      const imageData = context.getImageData(0, 0, this.textureCanvas.width, this.textureCanvas.height);
      bleedTransparentPixels(imageData);
      this.texture = new DataTexture(imageData.data, this.textureCanvas.width, this.textureCanvas.height, RGBAFormat);
      this.texture.colorSpace = SRGBColorSpace;
      const config = this.product?.model3d?.texture;
      if (this.product?.model3d?.url) {
        this.texture.flipY = Boolean(config?.flipY);
        this.texture.wrapS = ClampToEdgeWrapping;
        this.texture.wrapT = ClampToEdgeWrapping;
        this.texture.repeat.set((config?.flipX ? -1 : 1) * (config?.repeatX ?? 1), config?.repeatY ?? 1);
        this.texture.offset.set(config?.offsetX ?? 0, config?.offsetY ?? 0);
        this.texture.center.set(config?.centerX ?? 0.5, config?.centerY ?? 0.5);
        this.texture.rotation = config?.rotation ?? 0;
      } else {
        this.texture.flipY = true;
      }
      this.texture.generateMipmaps = false;
      this.texture.minFilter = LinearFilter;
      this.texture.magFilter = LinearFilter;
      this.texture.anisotropy = Math.min(8, this.renderer.capabilities.getMaxAnisotropy());
      this.texture.needsUpdate = true;
      for (const material of this.printMaterials) {
        material.map = this.texture;
        material.needsUpdate = true;
      }
    }
    captureDataURL({ width = 1e3, height = 1e3 } = {}) {
      const safeWidth = Math.max(320, Math.min(1600, Math.round(width)));
      const safeHeight = Math.max(320, Math.min(1600, Math.round(height)));
      const target = new WebGLRenderTarget(safeWidth, safeHeight, {
        format: RGBAFormat,
        type: UnsignedByteType,
        depthBuffer: true,
        stencilBuffer: false,
        samples: this.renderer.capabilities.isWebGL2 ? 4 : 0
      });
      target.texture.colorSpace = SRGBColorSpace;
      const previousTarget = this.renderer.getRenderTarget();
      const previousAspect = this.camera.aspect;
      const pixels = new Uint8Array(safeWidth * safeHeight * 4);
      try {
        this.camera.aspect = safeWidth / safeHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setRenderTarget(target);
        this.renderer.render(this.scene, this.camera);
        this.renderer.readRenderTargetPixels(target, 0, 0, safeWidth, safeHeight, pixels);
      } finally {
        this.renderer.setRenderTarget(previousTarget);
        this.camera.aspect = previousAspect;
        this.camera.updateProjectionMatrix();
        target.dispose();
      }
      const canvas = document.createElement("canvas");
      canvas.width = safeWidth;
      canvas.height = safeHeight;
      const context = canvas.getContext("2d");
      const output = context.createImageData(safeWidth, safeHeight);
      const rowSize = safeWidth * 4;
      for (let row = 0; row < safeHeight; row += 1) {
        output.data.set(pixels.subarray((safeHeight - row - 1) * rowSize, (safeHeight - row) * rowSize), row * rowSize);
      }
      context.putImageData(output, 0, 0);
      return canvas.toDataURL("image/png");
    }
    resize() {
      const width = Math.max(1, this.container.clientWidth);
      const height = Math.max(1, this.container.clientHeight);
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(width, height, false);
    }
    animate() {
      if (this.disposed) return;
      this.animation = requestAnimationFrame(() => this.animate());
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    }
    dispose() {
      this.disposed = true;
      cancelAnimationFrame(this.animation);
      this.resizeObserver.disconnect();
      this.controls.dispose();
      __privateMethod(this, _Product3DPreview_instances, clearProduct_fn).call(this);
      this.ground?.geometry.dispose();
      this.ground?.material.dispose();
      this.environment?.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  }
  _Product3DPreview_instances = new WeakSet();
  loadGLTFProduct_fn = async function(product, color, loadId) {
    const gltf = await this.loader.loadAsync(product.model3d.url);
    if (loadId !== this.loadId) {
      __privateMethod(this, _Product3DPreview_instances, disposeObject_fn).call(this, gltf.scene);
      return;
    }
    const root = gltf.scene;
    const transform = product.model3d.transform || {};
    root.scale.setScalar(product.model3d.autoFit ? 1 : transform.scale ?? 1);
    root.position.set(product.model3d.autoFit ? 0 : transform.x ?? 0, product.model3d.autoFit ? 0 : transform.y ?? 0, product.model3d.autoFit ? 0 : transform.z ?? 0);
    root.rotation.set(transform.rotationX ?? 0, transform.rotationY ?? 0, transform.rotationZ ?? 0);
    if (product.model3d.autoFit) {
      root.updateMatrixWorld(true);
      let bounds = new Box3().setFromObject(root);
      const size = bounds.getSize(new Vector3());
      const longest = Math.max(size.x, size.y, size.z);
      if (Number.isFinite(longest) && longest > 0) root.scale.multiplyScalar(4.2 / longest * (transform.scale ?? 1));
      root.updateMatrixWorld(true);
      bounds = new Box3().setFromObject(root);
      const center = bounds.getCenter(new Vector3());
      root.position.sub(center);
      root.position.x += transform.x ?? 0;
      root.position.y += transform.y ?? 0;
      root.position.z += transform.z ?? 0;
      root.updateMatrixWorld(true);
    }
    const faceMeshNames = product.model3d.printMeshesByFace?.[this.face] || [];
    const faceMaterialNames = product.model3d.printMaterialsByFace?.[this.face] || [];
    const hasFaceTargets = faceMeshNames.length > 0 || faceMaterialNames.length > 0;
    const meshNames = new Set(hasFaceTargets ? faceMeshNames : product.model3d.printMeshNames || []);
    const materialNames = new Set(hasFaceTargets ? faceMaterialNames : product.model3d.printMaterialNames || []);
    const candidates = [];
    const allMeshes = [];
    const diagnostics = [];
    this.modelSurfaceTexture = product.type === "apparel" ? __privateMethod(this, _Product3DPreview_instances, surfaceTexture_fn).call(this, "fabric") : null;
    root.traverse((object) => {
      if (!object.isMesh) return;
      allMeshes.push(object);
      object.castShadow = true;
      object.receiveShadow = true;
      const materials = Array.isArray(object.material) ? object.material : [object.material];
      object.material = Array.isArray(object.material) ? materials.map((material) => __privateMethod(this, _Product3DPreview_instances, cloneBaseMaterial_fn).call(this, material, product)) : __privateMethod(this, _Product3DPreview_instances, cloneBaseMaterial_fn).call(this, materials[0], product);
      const names = materials.map((material) => material?.name || "").filter(Boolean);
      const hasUV = Boolean(object.geometry?.attributes?.uv);
      diagnostics.push({ name: object.name || "(unnamed)", materials: names, hasUV });
      const explicitMeshes = meshNames.size > 0 || materialNames.size > 0;
      const meshMatch = meshNames.has(object.name);
      const materialMatch = names.some((name) => materialNames.has(name));
      if (hasUV && (explicitMeshes ? meshMatch || materialMatch : true)) candidates.push(object);
    });
    this.productGroup = new Group();
    this.productGroup.add(root);
    this.productGroup.rotation.y = product.model3d.faceRotationY?.[this.face] ?? (this.face === "back" ? Math.PI : 0);
    this.scene.add(this.productGroup);
    this.productGroup.updateMatrixWorld(true);
    let printTargets;
    if (product.model3d.projection?.mode === "decal") {
      const target = __privateMethod(this, _Product3DPreview_instances, selectDecalTarget_fn).call(this, allMeshes, meshNames, materialNames);
      if (!target) throw new Error("模型没有可用于表面投射的 Mesh");
      const useContinuousFit = product.model3d.projection?.surfaceFit === "continuous";
      const smartOverlay = useContinuousFit ? __privateMethod(this, _Product3DPreview_instances, addFittedApparelOverlay_fn).call(this, target, product) || __privateMethod(this, _Product3DPreview_instances, addSmartSurfaceOverlay_fn).call(this, target, product) : __privateMethod(this, _Product3DPreview_instances, addSmartSurfaceOverlay_fn).call(this, target, product) || __privateMethod(this, _Product3DPreview_instances, addFittedApparelOverlay_fn).call(this, target, product);
      if (!smartOverlay) __privateMethod(this, _Product3DPreview_instances, addDecalOverlay_fn).call(this, target, product);
      printTargets = [`${target.name || "(unnamed)"} · ${smartOverlay ? "SMART SURFACE" : "SURFACE DECAL"}`];
    } else {
      for (const mesh of candidates) __privateMethod(this, _Product3DPreview_instances, addPrintOverlay_fn).call(this, mesh, product);
      printTargets = candidates.map((mesh) => mesh.name || "(unnamed)");
      if (!candidates.length) throw new Error("模型未找到可印刷 UV Mesh；请检查 Mesh/Material 名称和 UV 数据");
    }
    this.container.dispatchEvent(new CustomEvent("modelinfo", { detail: { meshes: diagnostics, printTargets } }));
  };
  selectDecalTarget_fn = function(meshes, meshNames, materialNames) {
    const explicit = meshNames.size > 0 || materialNames.size > 0;
    const eligible = meshes.filter((mesh) => {
      if (!explicit) return true;
      const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
      return meshNames.has(mesh.name) || materials.some((material) => materialNames.has(material?.name || ""));
    });
    return eligible.map((mesh) => {
      const size = new Box3().setFromObject(mesh).getSize(new Vector3());
      return { mesh, score: size.x * size.y };
    }).sort((a2, b2) => b2.score - a2.score)[0]?.mesh;
  };
  addDecalOverlay_fn = function(mesh, product) {
    mesh.updateMatrixWorld(true);
    const bounds = new Box3().setFromObject(mesh);
    const size = bounds.getSize(new Vector3());
    const center = bounds.getCenter(new Vector3());
    const config = product.model3d.projection || {};
    const designAspect2 = (product.physical?.widthIn || 1) / (product.physical?.heightIn || 1);
    let width = Math.max(0.01, size.x * (config.width ?? 0.72));
    let height = Math.max(0.01, size.y * (config.height ?? 0.72));
    if (designAspect2 > width / height) height = width / designAspect2;
    else width = height * designAspect2;
    const sourceMaterial = Array.isArray(mesh.material) ? mesh.material[0] : mesh.material;
    const material = new MeshPhysicalMaterial({
      color: 16777215,
      transparent: true,
      alphaTest: 4e-3,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -4,
      polygonOffsetUnits: -4,
      roughness: sourceMaterial?.roughness ?? 0.7,
      metalness: Math.min(sourceMaterial?.metalness ?? 0, 0.18),
      clearcoat: sourceMaterial?.clearcoat ?? 0,
      clearcoatRoughness: sourceMaterial?.clearcoatRoughness ?? 0.45,
      normalMap: sourceMaterial?.normalMap || null,
      normalScale: sourceMaterial?.normalScale?.clone?.() || new Vector2(1, 1),
      roughnessMap: sourceMaterial?.roughnessMap || null,
      bumpMap: sourceMaterial?.bumpMap || this.modelSurfaceTexture || null,
      bumpScale: sourceMaterial?.bumpScale ?? (this.product?.id === "hoodie" ? 0.026 : 0.018),
      envMapIntensity: product.model3d?.environmentIntensity ?? 1
    });
    const anchorX = center.x + size.x * (config.offsetX ?? 0);
    const anchorY = center.y + size.y * (config.offsetY ?? 0);
    const depth = Math.max(0.04, size.z * (config.depth ?? 0.28));
    const projectorPosition = new Vector3(anchorX, anchorY, bounds.max.z - depth * 0.18);
    const projectorRotation = new Euler(config.rotationX ?? 0, config.rotationY ?? 0, config.rotationZ ?? 0);
    const projectorSize = new Vector3(width, height, depth);
    let geometry;
    try {
      geometry = new DecalGeometry(mesh, projectorPosition, projectorRotation, projectorSize);
      if (!geometry.attributes.position?.count) throw new Error("empty decal geometry");
    } catch (error) {
      console.warn("[3D] Decal projection fell back to preview plane:", error.message);
      geometry = new PlaneGeometry(width, height, 32, 40);
      material.userData.coloroutinePlanarFallback = true;
    }
    this.decalMesh = new Mesh(geometry, material);
    this.decalMesh.name = `${mesh.name || "mesh"}__coloroutine_decal`;
    this.decalMesh.renderOrder = 20;
    this.decalMesh.castShadow = false;
    this.decalMesh.receiveShadow = true;
    if (material.userData.coloroutinePlanarFallback) this.decalMesh.position.copy(projectorPosition);
    this.scene.add(this.decalMesh);
    this.printMaterials.push(material);
  };
  addSmartSurfaceOverlay_fn = function(mesh, product) {
    if (product.type !== "apparel") return null;
    const sourceGeometry = mesh.geometry;
    if (!sourceGeometry?.attributes?.position) return null;
    mesh.updateMatrixWorld(true);
    const bounds = new Box3().setFromObject(mesh);
    const size = bounds.getSize(new Vector3());
    const center = bounds.getCenter(new Vector3());
    const config = product.model3d.projection || {};
    const designAspect2 = (product.physical?.widthIn || 1) / (product.physical?.heightIn || 1);
    let width = Math.max(0.01, size.x * (config.width ?? 0.72));
    let height = Math.max(0.01, size.y * (config.height ?? 0.72));
    if (designAspect2 > width / height) height = width / designAspect2;
    else width = height * designAspect2;
    const anchorX = center.x + size.x * (config.offsetX ?? 0);
    const anchorY = center.y + size.y * (config.offsetY ?? 0);
    const minX = anchorX - width / 2;
    const maxX = anchorX + width / 2;
    const minY = anchorY - height / 2;
    const maxY = anchorY + height / 2;
    const positions = [];
    const uvs = [];
    const indices = [];
    const sourcePositions = sourceGeometry.attributes.position;
    const sourceIndex = sourceGeometry.index;
    const a2 = new Vector3();
    const b2 = new Vector3();
    const c2 = new Vector3();
    const aw = new Vector3();
    const bw = new Vector3();
    const cw = new Vector3();
    const normal = new Vector3();
    const worldToLocalNormalMatrix = new Matrix3().getNormalMatrix(mesh.matrixWorld.clone().invert());
    const localOffset = new Vector3();
    const addVertex = (local, world) => {
      const { u: u2, v: v2 } = apparelSurfaceUV(world, minX, minY, width, height);
      positions.push(local.x, local.y, local.z);
      uvs.push(u2, v2);
    };
    const triangleCount = sourceIndex ? sourceIndex.count / 3 : sourcePositions.count / 3;
    for (let triangle = 0; triangle < triangleCount; triangle += 1) {
      const ia2 = sourceIndex ? sourceIndex.getX(triangle * 3) : triangle * 3;
      const ib = sourceIndex ? sourceIndex.getX(triangle * 3 + 1) : triangle * 3 + 1;
      const ic2 = sourceIndex ? sourceIndex.getX(triangle * 3 + 2) : triangle * 3 + 2;
      a2.fromBufferAttribute(sourcePositions, ia2);
      b2.fromBufferAttribute(sourcePositions, ib);
      c2.fromBufferAttribute(sourcePositions, ic2);
      aw.copy(a2).applyMatrix4(mesh.matrixWorld);
      bw.copy(b2).applyMatrix4(mesh.matrixWorld);
      cw.copy(c2).applyMatrix4(mesh.matrixWorld);
      const centerX = (aw.x + bw.x + cw.x) / 3;
      const centerY = (aw.y + bw.y + cw.y) / 3;
      const centerZ = (aw.z + bw.z + cw.z) / 3;
      if (centerX < minX || centerX > maxX || centerY < minY || centerY > maxY) continue;
      normal.subVectors(bw, aw).cross(new Vector3().subVectors(cw, aw)).normalize();
      if (normal.z < 0.18) continue;
      if (centerZ < bounds.max.z - size.z * 0.46) continue;
      const base = positions.length / 3;
      localOffset.copy(normal).applyMatrix3(worldToLocalNormalMatrix).normalize().multiplyScalar(4e-3);
      addVertex(a2.clone().add(localOffset), aw);
      addVertex(b2.clone().add(localOffset), bw);
      addVertex(c2.clone().add(localOffset), cw);
      indices.push(base, base + 1, base + 2);
    }
    if (indices.length < 90) return null;
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    geometry.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    const sourceMaterial = Array.isArray(mesh.material) ? mesh.material[0] : mesh.material;
    const material = __privateMethod(this, _Product3DPreview_instances, printMaterial_fn).call(this, sourceMaterial, product, -5);
    const overlay = mesh.isSkinnedMesh ? new SkinnedMesh(geometry, material) : new Mesh(geometry, material);
    if (mesh.isSkinnedMesh) overlay.bind(mesh.skeleton, mesh.bindMatrix);
    overlay.name = `${mesh.name || "mesh"}__coloroutine_smart_print`;
    overlay.position.copy(mesh.position);
    overlay.quaternion.copy(mesh.quaternion);
    overlay.scale.copy(mesh.scale);
    overlay.renderOrder = (mesh.renderOrder || 0) + 5;
    overlay.frustumCulled = mesh.frustumCulled;
    overlay.userData.coloroutineOverlay = true;
    mesh.parent.add(overlay);
    this.printMaterials.push(material);
    return overlay;
  };
  addFittedApparelOverlay_fn = function(mesh, product) {
    const sourceGeometry = mesh.geometry;
    if (!sourceGeometry?.attributes?.position) return null;
    mesh.updateMatrixWorld(true);
    const bounds = new Box3().setFromObject(mesh);
    const size = bounds.getSize(new Vector3());
    const center = bounds.getCenter(new Vector3());
    const config = product.model3d.projection || {};
    const designAspect2 = (product.physical?.widthIn || 1) / (product.physical?.heightIn || 1);
    let width = Math.max(0.01, size.x * (config.width ?? 0.72));
    let height = Math.max(0.01, size.y * (config.height ?? 0.72));
    if (designAspect2 > width / height) height = width / designAspect2;
    else width = height * designAspect2;
    const anchorX = center.x + size.x * (config.offsetX ?? 0);
    const anchorY = center.y + size.y * (config.offsetY ?? 0);
    const minX = anchorX - width / 2;
    const maxX = anchorX + width / 2;
    const minY = anchorY - height / 2;
    const maxY = anchorY + height / 2;
    const expandedX = width * 0.12;
    const expandedY = height * 0.12;
    const sourcePositions = sourceGeometry.attributes.position;
    const world = new Vector3();
    const samples = [];
    const frontCutoff = bounds.max.z - size.z * 0.5;
    for (let index = 0; index < sourcePositions.count; index += 1) {
      world.fromBufferAttribute(sourcePositions, index).applyMatrix4(mesh.matrixWorld);
      if (world.x < minX - expandedX || world.x > maxX + expandedX || world.y < minY - expandedY || world.y > maxY + expandedY) continue;
      if (world.z < frontCutoff) continue;
      samples.push({ x: world.x, y: world.y, z: world.z });
    }
    const minimumSamples = product.type === "mug" ? 80 : 120;
    if (samples.length < minimumSamples) return null;
    const columns = product.id === "hoodie" ? 52 : product.type === "mug" ? 56 : 44;
    const rows = product.id === "hoodie" ? 64 : product.type === "mug" ? 34 : 52;
    const surfaceStrength = MathUtils.clamp(config.surfaceStrength ?? 1, 0, 1);
    const reliefClamp = Math.max(0.01, size.z * (config.reliefClamp ?? 0.12));
    const frontPlaneZ = bounds.max.z - size.z * 0.18;
    const radiusMultiplier = product.id === "hoodie" ? 5.2 : product.type === "mug" ? 4.2 : 4;
    const smoothing = product.id === "hoodie" ? 0.65 : product.type === "mug" ? 0.35 : 0.45;
    const zLift = product.id === "hoodie" ? 9e-3 : product.type === "mug" ? 6e-3 : 7e-3;
    const searchRadius = Math.max(width / columns, height / rows) * radiusMultiplier;
    const searchRadiusSq = searchRadius * searchRadius;
    const raycaster = new Raycaster();
    const rayOrigin = new Vector3();
    const rayDirection = new Vector3(0, 0, -1);
    const rayNormal = new Vector3(0, 0, 1);
    const normalMatrix = new Matrix3().getNormalMatrix(mesh.matrixWorld);
    const positions = [];
    const uvs = [];
    const indices = [];
    const worldPoint = new Vector3();
    const localPoint = new Vector3();
    const sampleSurface = (x2, y2) => {
      rayOrigin.set(x2, y2, bounds.max.z + size.z * 0.3);
      raycaster.set(rayOrigin, rayDirection);
      raycaster.near = 0;
      raycaster.far = Math.max(size.z * 1.8, 0.5);
      const hit = raycaster.intersectObject(mesh, false)[0];
      if (!hit) return null;
      if (hit.face?.normal) rayNormal.copy(hit.face.normal).applyMatrix3(normalMatrix).normalize();
      else rayNormal.set(0, 0, 1);
      if (rayNormal.z < 0.08) return null;
      return { point: hit.point, normal: rayNormal.clone() };
    };
    const estimateZ = (x2, y2) => {
      let weightedZ = 0;
      let totalWeight = 0;
      let nearestZ = bounds.max.z;
      let nearestDistanceSq = Infinity;
      const localZ = [];
      for (const sample of samples) {
        const dx = sample.x - x2;
        const dy = sample.y - y2;
        const distanceSq = dx * dx + dy * dy;
        if (distanceSq < nearestDistanceSq) {
          nearestDistanceSq = distanceSq;
          nearestZ = sample.z;
        }
        if (distanceSq > searchRadiusSq) continue;
        const weight = 1 / Math.max(distanceSq, 1e-4);
        weightedZ += sample.z * weight;
        totalWeight += weight;
        localZ.push(sample.z);
      }
      const sampledZ = totalWeight ? weightedZ / totalWeight : nearestZ;
      const medianZ = localZ.length ? quantile(localZ, 0.55) : sampledZ;
      const smoothZ = sampledZ * (1 - smoothing) + medianZ * smoothing;
      return MathUtils.clamp(
        frontPlaneZ + (smoothZ - frontPlaneZ) * surfaceStrength,
        frontPlaneZ - reliefClamp,
        frontPlaneZ + reliefClamp
      );
    };
    for (let row = 0; row <= rows; row += 1) {
      const v2 = row / rows;
      const y2 = maxY - v2 * height;
      for (let column = 0; column <= columns; column += 1) {
        const x2 = minX + column / columns * width;
        const surface = sampleSurface(x2, y2);
        if (surface) {
          worldPoint.copy(surface.point).addScaledVector(surface.normal, zLift);
        } else {
          const z2 = estimateZ(x2, y2) + zLift;
          worldPoint.set(x2, y2, z2);
        }
        localPoint.copy(worldPoint);
        mesh.worldToLocal(localPoint);
        const uv = apparelSurfaceUV(worldPoint, minX, minY, width, height);
        positions.push(localPoint.x, localPoint.y, localPoint.z);
        uvs.push(uv.u, uv.v);
      }
    }
    for (let row = 0; row < rows; row += 1) {
      for (let column = 0; column < columns; column += 1) {
        const a2 = row * (columns + 1) + column;
        const b2 = a2 + 1;
        const c2 = a2 + columns + 1;
        const d2 = c2 + 1;
        indices.push(a2, c2, b2, b2, c2, d2);
      }
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    geometry.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    const sourceMaterial = Array.isArray(mesh.material) ? mesh.material[0] : mesh.material;
    const material = __privateMethod(this, _Product3DPreview_instances, printMaterial_fn).call(this, sourceMaterial, product, -5);
    const overlay = new Mesh(geometry, material);
    overlay.name = `${mesh.name || "mesh"}__coloroutine_continuous_print`;
    overlay.position.copy(mesh.position);
    overlay.quaternion.copy(mesh.quaternion);
    overlay.scale.copy(mesh.scale);
    overlay.renderOrder = (mesh.renderOrder || 0) + 6;
    overlay.frustumCulled = false;
    overlay.userData.coloroutineOverlay = true;
    mesh.parent.add(overlay);
    this.printMaterials.push(material);
    return overlay;
  };
  cloneBaseMaterial_fn = function(material, product) {
    if (!material) return new MeshStandardMaterial({ color: this.color?.[1] || "#e9e4da", roughness: 0.72 });
    const clone = material.clone();
    const colorable = product.model3d?.tintBaseMaterial === true || /GARMENT|RIB|PRINT_SURFACE/i.test(material.name || "");
    clone.envMapIntensity = product.model3d?.environmentIntensity ?? 1;
    if (clone.color && colorable) clone.color.multiply(new Color(this.color?.[1] || "#ffffff"));
    if (!clone.bumpMap && this.modelSurfaceTexture && colorable) {
      clone.bumpMap = this.modelSurfaceTexture;
      clone.bumpScale = this.product?.id === "hoodie" ? 0.026 : 0.018;
    }
    clone.needsUpdate = true;
    return clone;
  };
  addPrintOverlay_fn = function(mesh, product) {
    const sourceMaterial = Array.isArray(mesh.material) ? mesh.material[0] : mesh.material;
    const material = __privateMethod(this, _Product3DPreview_instances, printMaterial_fn).call(this, sourceMaterial, product, -2);
    let overlay;
    if (mesh.isSkinnedMesh) {
      overlay = new SkinnedMesh(mesh.geometry, material);
      overlay.bind(mesh.skeleton, mesh.bindMatrix);
    } else overlay = new Mesh(mesh.geometry, material);
    overlay.name = `${mesh.name || "mesh"}__coloroutine_print`;
    overlay.position.copy(mesh.position);
    overlay.quaternion.copy(mesh.quaternion);
    overlay.scale.copy(mesh.scale);
    overlay.renderOrder = (mesh.renderOrder || 0) + 2;
    overlay.frustumCulled = mesh.frustumCulled;
    overlay.userData.coloroutineOverlay = true;
    mesh.parent.add(overlay);
    this.printMaterials.push(material);
  };
  printMaterial_fn = function(sourceMaterial, product, polygonOffsetFactor = -2) {
    return new MeshPhysicalMaterial({
      color: 16777215,
      transparent: true,
      alphaTest: 4e-3,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor,
      polygonOffsetUnits: polygonOffsetFactor,
      roughness: sourceMaterial?.roughness ?? 0.68,
      metalness: Math.min(sourceMaterial?.metalness ?? 0, 0.18),
      clearcoat: sourceMaterial?.clearcoat ?? 0,
      clearcoatRoughness: sourceMaterial?.clearcoatRoughness ?? 0.4,
      normalMap: sourceMaterial?.normalMap || null,
      normalScale: sourceMaterial?.normalScale?.clone?.() || new Vector2(1, 1),
      roughnessMap: sourceMaterial?.roughnessMap || null,
      bumpMap: sourceMaterial?.bumpMap || this.modelSurfaceTexture || null,
      bumpScale: sourceMaterial?.bumpScale ?? (this.product?.id === "hoodie" ? 0.026 : 0.018),
      side: DoubleSide,
      envMapIntensity: product.model3d?.environmentIntensity ?? 1
    });
  };
  createProceduralProduct_fn = function(product, color) {
    this.productGroup = new Group();
    const isGlossy = product.type === "mug" || product.type === "phone";
    const surface = __privateMethod(this, _Product3DPreview_instances, surfaceTexture_fn).call(this, isGlossy ? "ceramic" : product.type === "magnet" ? "paper" : "fabric");
    const material = new MeshPhysicalMaterial({
      color: new Color(color?.[1] || "#e9e4da"),
      roughness: isGlossy ? 0.32 : 0.84,
      metalness: 0.01,
      clearcoat: isGlossy ? 0.34 : 0,
      clearcoatRoughness: isGlossy ? 0.28 : 0.65,
      bumpMap: surface,
      bumpScale: isGlossy ? 0.012 : 0.035
    });
    let base;
    let printGeometry;
    let printPosition = [0, 0, 0.2];
    if (product.type === "apparel") {
      base = __privateMethod(this, _Product3DPreview_instances, apparel_fn).call(this, product.id === "hoodie", material);
      const panel = mappedSurfaceSize(product, product.id === "hoodie" ? 1.4 : 1.8);
      printGeometry = __privateMethod(this, _Product3DPreview_instances, curvedPanel_fn).call(this, panel.width, panel.height, "apparel");
      printPosition = [0, product.id === "hoodie" ? 0.25 : -0.12, product.id === "hoodie" ? 0.335 : 0.285];
    } else if (product.type === "mug") {
      const mug = new Mesh(new CylinderGeometry(1.25, 1.08, 2.6, 64, 1, true), material);
      this.productGroup.add(mug);
      const handle = new Mesh(new TorusGeometry(0.68, 0.17, 16, 48), material);
      handle.position.set(1.23, 0, 0);
      this.productGroup.add(handle);
      base = this.productGroup;
      printGeometry = __privateMethod(this, _Product3DPreview_instances, wrapPanel_fn).call(this, 1.265, 1.095, 2.15, product);
      printPosition = [0, -0.05, 0];
    } else if (product.type === "phone") {
      base = new Mesh(new BoxGeometry(1.85, 3.7, 0.3, 4, 8, 1), material);
      const panel = mappedSurfaceSize(product, 2.72);
      printGeometry = __privateMethod(this, _Product3DPreview_instances, curvedPanel_fn).call(this, panel.width, panel.height, "convex");
      printPosition = [0, -0.25, 0.16];
    } else if (product.type === "tote") {
      base = new Mesh(new BoxGeometry(3.2, 3.35, 0.28), material);
      base.position.y = -0.35;
      const curve = new CatmullRomCurve3([new Vector3(-1, 1.2, 0), new Vector3(-1, 2.55, 0), new Vector3(1, 2.55, 0), new Vector3(1, 1.2, 0)]);
      const handle = new Mesh(new TubeGeometry(curve, 40, 0.09, 10, false), material);
      this.productGroup.add(handle);
      const panel = mappedSurfaceSize(product, 1.98);
      printGeometry = __privateMethod(this, _Product3DPreview_instances, curvedPanel_fn).call(this, panel.width, panel.height, "fabric");
      printPosition = [0, -0.35, 0.151];
    } else {
      base = new Mesh(new CylinderGeometry(1.8, 1.8, 0.18, 72), material);
      base.rotation.x = Math.PI / 2;
      printGeometry = new CircleGeometry(1.48, 64);
      printPosition = [0, 0, 0.101];
    }
    if (base !== this.productGroup) this.productGroup.add(base);
    this.productGroup.traverse((object) => {
      if (object.isMesh) {
        object.castShadow = true;
        object.receiveShadow = true;
      }
    });
    this.printMesh = new Mesh(printGeometry, new MeshPhysicalMaterial({
      transparent: true,
      alphaTest: 0.01,
      roughness: material.roughness,
      clearcoat: material.clearcoat,
      clearcoatRoughness: material.clearcoatRoughness,
      depthWrite: false,
      polygonOffset: true,
      polygonOffsetFactor: -2,
      bumpMap: surface,
      bumpScale: material.bumpScale,
      envMapIntensity: 1
    }));
    this.printMesh.position.set(...printPosition);
    if (this.face === "back" && product.faces.includes("back")) {
      this.printMesh.position.z *= -1;
      this.printMesh.rotation.y = Math.PI;
    }
    this.productGroup.add(this.printMesh);
    this.productGroup.rotation.y = this.face === "back" ? Math.PI : -0.12;
    this.printMaterials = [this.printMesh.material];
    this.scene.add(this.productGroup);
  };
  applyCamera_fn = function(camera) {
    this.camera.position.set(camera?.x ?? 0, camera?.y ?? 0.25, camera?.z ?? 7);
    this.controls.target.set(camera?.targetX ?? 0, camera?.targetY ?? 0, camera?.targetZ ?? 0);
    this.controls.minDistance = Math.max(0.2, (camera?.z ?? 7) * 0.3);
    this.controls.maxDistance = Math.max(8, (camera?.z ?? 7) * 3.5);
    this.controls.update();
  };
  positionGround_fn = function() {
    if (!this.productGroup) return;
    const box = new Box3().setFromObject(this.productGroup);
    this.ground.position.y = Number.isFinite(box.min.y) ? box.min.y - 0.035 : -2.25;
    const size = box.getSize(new Vector3()).length();
    this.ground.scale.setScalar(Math.max(1, size / 6));
    this.ground.visible = this.product?.model3d?.shadow !== false;
  };
  apparel_fn = function(hoodie, material) {
    const width = hoodie ? 2.52 : 2.38;
    const height = hoodie ? 3.62 : 3.72;
    const depth = hoodie ? 0.58 : 0.48;
    const torsoGeometry = __privateMethod(this, _Product3DPreview_instances, garmentBodyGeometry_fn).call(this, width, height, depth, hoodie);
    const torso = new Mesh(torsoGeometry, material);
    torso.position.y = -0.08;
    const ribMaterial = material.clone();
    ribMaterial.roughness = 0.92;
    if (hoodie) {
      const hem = new Mesh(new RoundedBoxGeometry(width * 0.99, 0.18, depth * 0.97, 4, 0.045), ribMaterial);
      hem.position.set(0, -height / 2 - 0.025, 0);
      this.productGroup.add(hem);
    }
    const collar = new Mesh(new TorusGeometry(hoodie ? 0.37 : 0.33, hoodie ? 0.038 : 0.028, 12, 64), ribMaterial);
    collar.scale.set(1.18, hoodie ? 0.66 : 0.72, 0.66);
    collar.position.set(0, height / 2 - (hoodie ? 0.12 : 0.13), depth / 2 + 0.035);
    this.productGroup.add(collar);
    if (hoodie) {
      const hoodMaterial = material.clone();
      hoodMaterial.color.multiplyScalar(0.92);
      const hood = new Mesh(new TorusGeometry(0.56, 0.17, 20, 72), hoodMaterial);
      hood.scale.set(1, 1.08, 0.62);
      hood.position.set(0, 1.56, -0.075);
      this.productGroup.add(hood);
      const pocketShape = new Shape();
      pocketShape.moveTo(-0.68, -0.38);
      pocketShape.lineTo(0.68, -0.38);
      pocketShape.lineTo(0.56, 0.38);
      pocketShape.lineTo(-0.56, 0.38);
      pocketShape.closePath();
      const pocket = new Mesh(new ExtrudeGeometry(pocketShape, { depth: 0.035, bevelEnabled: true, bevelSize: 0.035, bevelThickness: 0.018, bevelSegments: 3 }), hoodMaterial);
      pocket.position.set(0, -1.04, depth / 2 + 0.11);
      this.productGroup.add(pocket);
      const cordMaterial = new MeshStandardMaterial({ color: 14144200, roughness: 0.48, metalness: 0.03 });
      for (const x2 of [-0.25, 0.25]) {
        const cordCurve = new CatmullRomCurve3([new Vector3(x2, 1.56, depth / 2 + 0.19), new Vector3(x2 * 1.04, 1.05, depth / 2 + 0.22), new Vector3(x2 * 1.08, 0.55, depth / 2 + 0.2)]);
        this.productGroup.add(new Mesh(new TubeGeometry(cordCurve, 24, 0.018, 8, false), cordMaterial));
      }
    }
    return torso;
  };
  garmentBodyGeometry_fn = function(width, height, depth, hoodie) {
    const halfWidth = width / 2;
    const top = height / 2;
    const bottom = -height / 2;
    const shoulder = halfWidth * (hoodie ? 0.91 : 0.93);
    const bodySide = halfWidth * (hoodie ? 0.98 : 0.91);
    const shape = new Shape();
    if (hoodie) {
      shape.moveTo(-0.46, top - 0.04);
      shape.quadraticCurveTo(-0.78, top - 0.02, -shoulder, top - 0.22);
      shape.quadraticCurveTo(-1.34, top - 0.38, -1.55, top - 0.82);
      shape.lineTo(-1.73, bottom + 0.52);
      shape.quadraticCurveTo(-1.71, bottom + 0.28, -1.49, bottom + 0.23);
      shape.lineTo(-1.18, bottom + 1.26);
      shape.quadraticCurveTo(-bodySide, bottom + 1.2, -bodySide, bottom + 0.76);
      shape.lineTo(-bodySide * 0.96, bottom);
      shape.quadraticCurveTo(0, bottom - 0.08, bodySide * 0.96, bottom);
      shape.lineTo(bodySide, bottom + 0.76);
      shape.quadraticCurveTo(bodySide, bottom + 1.2, 1.18, bottom + 1.26);
      shape.lineTo(1.49, bottom + 0.23);
      shape.quadraticCurveTo(1.71, bottom + 0.28, 1.73, bottom + 0.52);
      shape.lineTo(1.55, top - 0.82);
      shape.quadraticCurveTo(1.34, top - 0.38, shoulder, top - 0.22);
      shape.quadraticCurveTo(0.78, top - 0.02, 0.46, top - 0.04);
    } else {
      shape.moveTo(-0.4, top - 0.04);
      shape.quadraticCurveTo(-0.72, top - 0.02, -shoulder, top - 0.2);
      shape.lineTo(-1.78, top - 0.78);
      shape.quadraticCurveTo(-1.82, top - 1.03, -1.66, top - 1.22);
      shape.lineTo(-1.12, top - 0.89);
      shape.quadraticCurveTo(-bodySide, top - 1.04, -bodySide, top - 1.4);
      shape.lineTo(-bodySide * 0.94, bottom);
      shape.quadraticCurveTo(0, bottom - 0.08, bodySide * 0.94, bottom);
      shape.lineTo(bodySide, top - 1.4);
      shape.quadraticCurveTo(bodySide, top - 1.04, 1.12, top - 0.89);
      shape.lineTo(1.66, top - 1.22);
      shape.quadraticCurveTo(1.82, top - 1.03, 1.78, top - 0.78);
      shape.lineTo(shoulder, top - 0.2);
      shape.quadraticCurveTo(0.72, top - 0.02, 0.4, top - 0.04);
    }
    shape.quadraticCurveTo(0, top - (hoodie ? 0.48 : 0.42), hoodie ? -0.46 : -0.4, top - 0.04);
    shape.closePath();
    const geometry = new ExtrudeGeometry(shape, {
      depth,
      steps: 3,
      curveSegments: 20,
      bevelEnabled: true,
      bevelSegments: 5,
      bevelSize: hoodie ? 0.075 : 0.06,
      bevelThickness: hoodie ? 0.055 : 0.045
    });
    geometry.translate(0, 0, -depth / 2);
    const position = geometry.attributes.position;
    for (let index = 0; index < position.count; index += 1) {
      const x2 = position.getX(index);
      const y2 = position.getY(index);
      const z2 = position.getZ(index);
      if (z2 > depth * 0.12) {
        const normalizedY = MathUtils.clamp((y2 - bottom) / height, 0, 1);
        const normalizedX = MathUtils.clamp(x2 / (halfWidth * 1.8), -1, 1);
        const bodyMask = Math.max(0, 1 - Math.pow(Math.abs(normalizedX), 3));
        const drape = (hoodie ? 0.035 : 0.027) * bodyMask * Math.sin(normalizedY * Math.PI);
        const folds = Math.sin(x2 * 8.4 + y2 * 2.1) * (hoodie ? 0.01 : 0.014) * bodyMask;
        position.setZ(index, z2 + drape + folds);
      }
    }
    position.needsUpdate = true;
    geometry.computeVertexNormals();
    return geometry;
  };
  curvedPanel_fn = function(width, height, kind) {
    const geometry = new PlaneGeometry(width, height, 34, 48);
    const position = geometry.attributes.position;
    for (let index = 0; index < position.count; index += 1) {
      const x2 = position.getX(index) / (width / 2);
      const y2 = position.getY(index) / (height / 2);
      let z2 = kind === "convex" ? 0.045 * (1 - x2 * x2) : (kind === "apparel" ? 0.024 : 0.075) * (1 - x2 * x2) * (0.75 + 0.25 * Math.cos(y2 * Math.PI));
      if (kind === "fabric") z2 += Math.sin((x2 + y2) * 11) * 9e-3 + Math.sin(y2 * 19) * 5e-3;
      if (kind === "apparel") z2 += Math.sin(x2 * 8 + y2 * 3) * 6e-3;
      position.setZ(index, z2);
    }
    position.needsUpdate = true;
    geometry.computeVertexNormals();
    return geometry;
  };
  wrapPanel_fn = function(radiusTop, radiusBottom, height, product) {
    const widthSegments = 96;
    const heightSegments = 24;
    const averageRadius = (radiusTop + radiusBottom) / 2;
    const arc = mappedWrapAngle(product, height, averageRadius);
    const positions = [];
    const uvs = [];
    const indices = [];
    for (let row = 0; row <= heightSegments; row += 1) {
      const v2 = row / heightSegments;
      const radius = radiusBottom + (radiusTop - radiusBottom) * v2;
      const y2 = (v2 - 0.5) * height;
      for (let column = 0; column <= widthSegments; column += 1) {
        const u2 = column / widthSegments;
        const angle = (u2 - 0.5) * arc;
        positions.push(Math.sin(angle) * radius, y2, Math.cos(angle) * radius);
        uvs.push(u2, v2);
      }
    }
    const rowLength = widthSegments + 1;
    for (let row = 0; row < heightSegments; row += 1) {
      for (let column = 0; column < widthSegments; column += 1) {
        const lowerLeft = row * rowLength + column;
        const lowerRight = lowerLeft + 1;
        const upperLeft = lowerLeft + rowLength;
        const upperRight = upperLeft + 1;
        indices.push(lowerLeft, lowerRight, upperLeft, lowerRight, upperRight, upperLeft);
      }
    }
    const geometry = new BufferGeometry();
    geometry.setAttribute("position", new Float32BufferAttribute(positions, 3));
    geometry.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    return geometry;
  };
  surfaceTexture_fn = function(kind) {
    const canvas = document.createElement("canvas");
    canvas.width = 256;
    canvas.height = 256;
    const context = canvas.getContext("2d");
    context.fillStyle = "#808080";
    context.fillRect(0, 0, 256, 256);
    if (kind === "fabric") {
      context.globalAlpha = 0.55;
      for (let value = -256; value < 512; value += 6) {
        context.strokeStyle = "#a2a2a2";
        context.lineWidth = 1;
        context.beginPath();
        context.moveTo(value, 0);
        context.lineTo(value - 256, 256);
        context.stroke();
      }
      for (let value = -256; value < 512; value += 7) {
        context.strokeStyle = "#646464";
        context.lineWidth = 1;
        context.beginPath();
        context.moveTo(value, 0);
        context.lineTo(value + 256, 256);
        context.stroke();
      }
    } else {
      for (let index = 0; index < 900; index += 1) {
        const shade2 = 112 + index * 37 % 34;
        context.fillStyle = `rgb(${shade2},${shade2},${shade2})`;
        context.fillRect(index * 83 % 256, index * 47 % 256, kind === "ceramic" ? 1 : 2, kind === "ceramic" ? 1 : 2);
      }
    }
    const texture = new CanvasTexture(canvas);
    texture.colorSpace = NoColorSpace;
    texture.wrapS = texture.wrapT = RepeatWrapping;
    texture.repeat.set(kind === "fabric" ? 4 : 2, kind === "fabric" ? 4 : 2);
    texture.anisotropy = Math.min(8, this.renderer.capabilities.getMaxAnisotropy());
    this.ownedTextures.push(texture);
    return texture;
  };
  lights_fn = function() {
    this.scene.add(new HemisphereLight(16777215, 7432803, 0.92));
    const key = new DirectionalLight(16776181, 2.05);
    key.position.set(4.5, 7, 6);
    key.castShadow = true;
    key.shadow.mapSize.set(1024, 1024);
    key.shadow.bias = -4e-4;
    this.scene.add(key);
    const rim = new DirectionalLight(16752534, 0.55);
    rim.position.set(-5, 2, -3);
    this.scene.add(rim);
  };
  ground_fn = function() {
    const material = new ShadowMaterial({ color: 7103065, opacity: 0.18, transparent: true });
    this.ground = new Mesh(new PlaneGeometry(12, 12), material);
    this.ground.rotation.x = -Math.PI / 2;
    this.ground.position.y = -2.25;
    this.ground.receiveShadow = true;
    this.scene.add(this.ground);
  };
  clearProduct_fn = function() {
    if (this.decalMesh) {
      this.scene.remove(this.decalMesh);
      this.decalMesh.geometry.dispose();
      this.decalMesh.material.dispose();
      this.decalMesh = null;
    }
    if (this.productGroup) {
      this.scene.remove(this.productGroup);
      __privateMethod(this, _Product3DPreview_instances, disposeObject_fn).call(this, this.productGroup);
      this.productGroup = null;
    }
    this.texture?.dispose();
    this.texture = null;
    this.ownedTextures?.forEach((texture) => texture.dispose());
    this.ownedTextures = [];
  };
  disposeObject_fn = function(object) {
    const geometries = /* @__PURE__ */ new Set();
    const materials = /* @__PURE__ */ new Set();
    object.traverse?.((child) => {
      if (child.geometry) geometries.add(child.geometry);
      const list = Array.isArray(child.material) ? child.material : child.material ? [child.material] : [];
      list.forEach((material) => materials.add(material));
    });
    geometries.forEach((geometry) => geometry.dispose());
    materials.forEach((material) => material.dispose());
  };
  function bleedTransparentPixels(imageData) {
    const { data, width, height } = imageData;
    const alphaThreshold = 8;
    for (let pass = 0; pass < 10; pass += 1) {
      let changed = false;
      const copy = new Uint8ClampedArray(data);
      for (let y2 = 0; y2 < height; y2 += 1) {
        for (let x2 = 0; x2 < width; x2 += 1) {
          const offset = (y2 * width + x2) * 4;
          if (copy[offset + 3] >= alphaThreshold) continue;
          let r2 = 0;
          let g2 = 0;
          let b2 = 0;
          let count = 0;
          for (let dy = -1; dy <= 1; dy += 1) {
            const ny = y2 + dy;
            if (ny < 0 || ny >= height) continue;
            for (let dx = -1; dx <= 1; dx += 1) {
              if (dx === 0 && dy === 0) continue;
              const nx = x2 + dx;
              if (nx < 0 || nx >= width) continue;
              const neighbor = (ny * width + nx) * 4;
              if (copy[neighbor + 3] < alphaThreshold) continue;
              r2 += copy[neighbor];
              g2 += copy[neighbor + 1];
              b2 += copy[neighbor + 2];
              count += 1;
            }
          }
          if (!count) continue;
          data[offset] = Math.round(r2 / count);
          data[offset + 1] = Math.round(g2 / count);
          data[offset + 2] = Math.round(b2 / count);
          changed = true;
        }
      }
      if (!changed) break;
    }
  }
  function apparelSurfaceUV(world, minX, minY, width, height) {
    const x2 = MathUtils.clamp((world.x - minX) / width, 0, 1);
    const y2 = MathUtils.clamp((world.y - minY) / height, 0, 1);
    return { u: x2, v: y2 };
  }
  function quantile(values, percentile) {
    const sorted = [...values].sort((a2, b2) => a2 - b2);
    const index = MathUtils.clamp(Math.round((sorted.length - 1) * percentile), 0, sorted.length - 1);
    return sorted[index] ?? 0;
  }
  const STORAGE_KEY$1 = "coloroutine.studio.v1";
  const MAX_PROJECTS = 12;
  class ProjectStore {
    constructor() {
      __privateAdd(this, _ProjectStore_instances);
      this.state = __privateMethod(this, _ProjectStore_instances, read_fn).call(this);
    }
    get current() {
      return this.state.projects.find((project) => project.id === this.state.currentId) || this.state.projects[0];
    }
    list() {
      return [...this.state.projects].sort((a2, b2) => b2.updatedAt.localeCompare(a2.updatedAt));
    }
    create(name = "未命名设计") {
      const now = (/* @__PURE__ */ new Date()).toISOString();
      const project = {
        id: crypto.randomUUID(),
        name,
        productId: "tshirt",
        colorId: "bone",
        size: "M",
        face: "front",
        quantity: 1,
        scenes: {},
        revision: 0,
        createdAt: now,
        updatedAt: now
      };
      this.state.projects.unshift(project);
      this.state.projects = this.state.projects.slice(0, MAX_PROJECTS);
      this.state.currentId = project.id;
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
      return project;
    }
    select(id) {
      if (!this.state.projects.some((project) => project.id === id)) return this.current;
      this.state.currentId = id;
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
      return this.current;
    }
    update(patch) {
      const project = this.current;
      Object.assign(project, patch, { updatedAt: (/* @__PURE__ */ new Date()).toISOString() });
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
      return project;
    }
    saveScene(key, canvasJSON, preview = "") {
      const project = this.current;
      project.scenes[key] = { canvasJSON, preview, updatedAt: (/* @__PURE__ */ new Date()).toISOString() };
      project.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
    }
    getScene(key) {
      return this.current.scenes[key] || null;
    }
    markFinalized(design) {
      this.update({ designId: design.designId, revision: design.revision, cartToken: design.cartToken, finalizedAt: design.finalizedAt });
    }
    invalidateFinalized() {
      const project = this.current;
      if (!project.finalizedAt && !project.designId) return;
      delete project.designId;
      delete project.cartToken;
      delete project.finalizedAt;
      project.updatedAt = (/* @__PURE__ */ new Date()).toISOString();
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
    }
    incrementGeneration() {
      this.state.usage.generations += 1;
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
      return this.state.usage.generations;
    }
    addLocalCart(item) {
      this.state.localCart.push(item);
      __privateMethod(this, _ProjectStore_instances, write_fn).call(this);
    }
  }
  _ProjectStore_instances = new WeakSet();
  read_fn = function() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY$1));
      if (stored?.projects?.length) return stored;
    } catch {
    }
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const id = crypto.randomUUID();
    return {
      currentId: id,
      projects: [{ id, name: "我的首个设计", productId: "tshirt", colorId: "bone", size: "M", face: "front", quantity: 1, scenes: {}, revision: 0, createdAt: now, updatedAt: now }],
      usage: { generations: 0 },
      localCart: []
    };
  };
  write_fn = function() {
    try {
      localStorage.setItem(STORAGE_KEY$1, JSON.stringify(this.state));
    } catch {
    }
  };
  class StudioAPI {
    constructor(base = "/api") {
      __privateAdd(this, _StudioAPI_instances);
      this.base = base.replace(/\/$/, "");
    }
    async health() {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/health", { timeout: 3500 });
    }
    async generate(payload) {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/generate", { method: "POST", body: payload, timeout: 6e4 });
    }
    async inspirations(payload = {}) {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/inspiration", { method: "POST", body: payload, timeout: 1e4 });
    }
    async finalize(payload) {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/projects/finalize", { method: "POST", body: payload, timeout: 2e4 });
    }
    async catalog() {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/catalog/products", { timeout: 1e4 });
    }
    async createShare(payload) {
      return __privateMethod(this, _StudioAPI_instances, request_fn).call(this, "/shares", { method: "POST", body: payload, timeout: 3e4 });
    }
  }
  _StudioAPI_instances = new WeakSet();
  request_fn = async function(path, { method = "GET", body, timeout = 12e3 } = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(`${this.base}${path}`, {
        method,
        headers: body ? { "Content-Type": "application/json" } : void 0,
        body: body ? JSON.stringify(body) : void 0,
        signal: controller.signal,
        credentials: "same-origin"
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || `请求失败 (${response.status})`);
      return result;
    } catch (error) {
      if (error.name === "AbortError") throw new Error("服务响应超时，请稍后重试");
      throw error;
    } finally {
      clearTimeout(timer);
    }
  };
  class ShopifyBridge {
    constructor(variantMap) {
      this.variantMap = normalizeVariantMap(variantMap || globalThis.ColoroutineVariantMap);
      this.isShopify = Boolean(globalThis.Shopify?.routes?.root || document.documentElement.classList.contains("shopify-design-mode"));
    }
    resolveVariant(product, colorId, size) {
      const mapping = product.shopify?.variantMap || this.variantMap[product.id];
      if (!mapping) return null;
      return mapping[`${colorId}|${size}`] || mapping[colorId]?.[size] || mapping.default || null;
    }
    async addToCart({ product, colorId, colorName, size, quantity, design, previewUrl }) {
      const variantId = this.resolveVariant(product, colorId, size);
      if (!this.isShopify) {
        return { mode: "preview", item: { product: product.name, color: colorName, size, quantity, designId: design.designId, revision: design.revision } };
      }
      if (!variantId) {
        throw new Error("此商品组合尚未配置 Shopify Variant ID，请在区块设置中完成映射。");
      }
      const root = globalThis.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity,
            properties: {
              "定制设计": `${design.designId} · R${design.revision}`,
              "定制面": design.face,
              "Coloroutine proof": design.proofId || "",
              "Coloroutine status": design.preflightStatus || "",
              "Coloroutine product spec": [product.name, colorName, size, design.productSpec?.faceLabel || design.face].filter(Boolean).join(" / "),
              "Coloroutine quality": design.productSpec?.quality?.dpi ? `${design.productSpec.quality.dpi} DPI` : "",
              "_coloroutine_design_id": design.designId,
              "_coloroutine_proof_id": design.proofId || "",
              "_coloroutine_preflight_status": design.preflightStatus || "",
              "_coloroutine_product_id": product.id,
              "_coloroutine_color_id": colorId,
              "_coloroutine_size": size,
              "_coloroutine_face": design.face,
              "_coloroutine_revision": String(design.revision),
              "_coloroutine_cart_token": design.cartToken,
              "_coloroutine_preview": previewUrl || ""
            }
          }]
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.description || "加入购物车失败");
      return { mode: "shopify", item: result };
    }
  }
  const STORAGE_KEY = "coloroutine-studio-locale";
  const DEFAULT_LOCALE = "en";
  const PHRASES = [
    ["上传设计", "Upload design"],
    ["AI 文生图", "Text to image"],
    ["描述你的创意", "Describe your idea"],
    ["参考图生图", "Reference image"],
    ["用图片定义风格", "Use an image to define the style"],
    ["灵感推荐", "AI inspiration"],
    ["探索策展灵感", "Explore curated ideas"],
    ["文字与图形", "Text & shapes"],
    ["添加可编辑元素", "Add editable elements"],
    ["复古丝网印刷", "Vintage screen print"],
    ["极简瑞士风", "Minimal Swiss"],
    ["可爱手绘", "Playful hand-drawn"],
    ["水彩植物", "Botanical watercolor"],
    ["日系浮世绘", "Japanese ukiyo-e"],
    ["品牌流线艺术字", "Signature flowing display"],
    ["圆润大众印花", "Friendly rounded print"],
    ["复古手写曲线", "Retro handwritten curves"],
    ["街头海报粗体", "Bold street poster"],
    ["可爱厚实标题", "Playful chunky headline"],
    ["清爽免费中文", "Clean multilingual sans"],
    ["优雅免费衬线", "Elegant multilingual serif"],
    ["中文文艺标题", "Editorial Chinese display"],
    ["高冲击海报字", "High-impact poster"],
    ["自然手作感", "Natural handmade feel"],
    ["文艺", "Editorial"],
    ["印花", "Print outline"],
    ["清晰描边", "Crisp outline"],
    ["重影", "Offset shadow"],
    ["柔和错位", "Soft offset"],
    ["立体厚度", "Dimensional depth"],
    ["叠放", "Stacked"],
    ["海报层次", "Poster layers"],
    ["纯文字", "Plain text"],
    ["尚未添加图片", "No artwork yet"],
    ["打开菜单", "Open menu"],
    ["关闭菜单", "Close menu"],
    ["已保存", "Saved"],
    ["保存中", "Saving"],
    ["本地项目", "Local projects"],
    ["AI 生成次数", "AI generations"],
    ["当前商品", "Current product"],
    ["语言", "Language"],
    ["切换主题", "Switch theme"],
    ["打开商品设置", "Open product settings"],
    ["关闭商品设置", "Close product settings"],
    ["当前项目", "Current project"],
    ["新建项目", "New project"],
    ["选择项目", "Select project"],
    ["正在连接设计服务", "Connecting to design service"],
    ["本地预览", "Local preview"],
    ["创作方式", "Create with"],
    ["创作工具", "Creation tools"],
    ["工作区", "Workspace"],
    ["图层管理", "Layers"],
    ["排序 / 显隐 / 锁定", "Order / visibility / lock"],
    ["品牌分享图", "Brand share image"],
    ["生成预览 / 分享链接", "Preview / share link"],
    ["导出预览", "Export preview"],
    ["下载当前合成图", "Download current mockup"],
    ["自动保存至此浏览器", "Autosaved in this browser"],
    ["快速开始", "Quick start"],
    ["AI 生成设计", "AI Create"],
    ["给你一个可直接印花的透明图案提示词", "Create transparent, print-ready artwork"],
    ["上传图片", "Upload"],
    ["Logo、照片或贴纸图，自动进入编辑", "Add a logo, photo, or sticker artwork"],
    ["添加艺术字", "Add text"],
    ["使用 Coloroutine Ribbon 品牌字体", "Use the Coloroutine Ribbon typeface"],
    ["把灵感变成可下单的产品", "Turn an idea into an order-ready product"],
    ["选择商品、完成设计、检查真实预览，再把定制信息直接带入 Shopify 订单。", "Choose a product, create the artwork, review the real preview, and send every customization detail to Shopify checkout."],
    ["定制流程", "Customization workflow"],
    ["选择商品", "Choose product"],
    ["款式、颜色与印刷面", "Style, color, and print side"],
    ["添加设计", "Add design"],
    ["上传、生成或编辑", "Upload, generate, or edit"],
    ["检查预览", "Review preview"],
    ["2D / 3D 与印刷质量", "2D / 3D and print quality"],
    ["确认下单", "Confirm order"],
    ["绑定设计与 Shopify 订单", "Attach the design to the Shopify order"],
    ["创作面板", "Creation panel"],
    ["清空画布", "Clear canvas"],
    ["产品设计画布", "Product design canvas"],
    ["撤销", "Undo"],
    ["重做", "Redo"],
    ["复制图层", "Duplicate layer"],
    ["删除图层", "Delete layer"],
    ["居中", "Center"],
    ["适应印刷区", "Fit to print area"],
    ["预览模式", "Preview mode"],
    ["AI 生成", "AI generate"],
    ["上传", "Upload"],
    ["艺术字", "Display text"],
    ["可拖拽旋转", "Drag to rotate"],
    ["实时渲染", "live rendering"],
    ["从上方添加第一个设计", "Add your first design above"],
    ["上传图片、AI 生成或添加文字后，可直接拖拽缩放。", "Upload an image, generate with AI, or add text, then drag and resize it directly."],
    ["缩小", "Zoom out"],
    ["放大", "Zoom in"],
    ["虚线区域为可印刷范围", "Dashed area is the printable zone"],
    ["拖拽控制点缩放与旋转", "Drag handles to resize and rotate"],
    ["商品设置", "Product settings"],
    ["确认设计并加入购物车", "Approve design & add to cart"],
    ["商品/文字", "Product/Text"],
    ["加入购物车", "Add to cart"],
    [" 个", " layers"],
    ["创作", "Create"],
    ["上传你的设计", "Upload your design"],
    ["AI 创作指令", "AI art direction"],
    ["今日灵感策展", "Today's inspiration"],
    ["文字与基础图形", "Text & basic shapes"],
    ["点击上传或拖入设计文件", "Click to upload or drop a design file"],
    ["支持 PNG、JPG、WEBP", "PNG, JPG, and WEBP supported"],
    ["最大 20 MB", "20 MB maximum"],
    ["推荐透明 PNG", "Transparent PNG recommended"],
    ["例如：一只穿宇航服的复古柯基，粗颗粒丝网印刷，奶油白与珊瑚红配色，透明背景…", "Example: a corgi in a spacesuit, vintage grainy screen print, cream and coral palette, transparent background..."],
    ["描述主体、风格、色彩与构图", "Describe the subject, style, colors, and composition"],
    ["生成有背景的设计", "Generate with a background"],
    ["默认透明背景，更适合直接印在产品上", "Transparent by default for direct product printing"],
    ["生成 4 个方案", "Generate 4 concepts"],
    ["参考图片", "Reference image"],
    ["添加参考图", "Add reference image"],
    ["用于风格与构图参考", "Use it as a style and composition reference"],
    ["说明要保留和改变的内容，例如：保留角色姿势，改成复古旅行海报风格…", "Describe what to keep and change, for example: keep the pose and use a vintage travel-poster style..."],
    ["不会覆盖原参考图", "The original reference will not be overwritten"],
    ["默认透明背景，仅保留主体印花", "Transparent by default, preserving only the print subject"],
    ["生成参考方案", "Generate reference concepts"],
    ["精选", "curated for"],
    ["换一组", "Refresh ideas"],
    ["灵感", "Inspiration"],
    ["点击后生成可编辑方案", "Select to create an editable concept"],
    ["正在获取灵感…", "Loading inspiration..."],
    ["生成 Coloroutine 品牌预览", "Create a Coloroutine brand preview"],
    ["把当前商品效果制作成可下载、可转发的品牌图片。", "Turn the current product mockup into a downloadable, shareable brand visual."],
    ["商品视图", "Product view"],
    ["2D 商品底图", "2D product mockup"],
    ["高清底图", "High-resolution mockup"],
    ["当前模型角度", "Current model angle"],
    ["画面比例", "Aspect ratio"],
    ["方形动态", "Square post"],
    ["社交动态", "Social post"],
    ["竖版 Story", "Vertical Story"],
    ["横版提案", "Landscape proposal"],
    ["提案预览", "Proposal preview"],
    ["自动品牌化", "Automatic branding"],
    ["Coloroutine 标识、商品名称、设计项目和官网入口会自动排版。", "Coloroutine branding, product name, project, and store link are arranged automatically."],
    ["2D / 3D 所见即所得", "WYSIWYG 2D / 3D"],
    ["可使用高清商品底图，或捕捉当前带 UV 印花的 3D 模型角度。", "Use a high-resolution product mockup or capture the current 3D model with its UV-mapped print."],
    ["生成公开预览链接", "Create public preview link"],
    ["复制", "Copy"],
    ["下载 PNG", "Download PNG"],
    ["系统分享", "Share"],
    ["公开链接只包含生成后的品牌预览图，不公开可编辑画布或原始上传文件。", "The public link includes only the generated brand preview, never the editable canvas or original upload."],
    ["正在合成品牌预览…", "Rendering brand preview..."],
    ["请先描述你想创作的设计。", "Describe the design you want to create first."],
    ["请先添加一张参考图片。", "Add a reference image first."],
    ["已用本地创意引擎生成示例；配置 AI Provider 后可切换真实模型。", "A sample was created with the local engine. Configure an AI provider to use the production model."],
    ["已生成 4 个设计方案。", "Four design concepts generated."],
    ["AI 生成暂时没有响应，请稍后重试，或先上传图片/添加文字继续设计。", "AI generation is not responding. Try again shortly, or continue by uploading an image or adding text."],
    ["灵感服务暂时没有响应，可以先使用 AI 生成或添加文字开始设计。", "Inspiration is temporarily unavailable. Start with AI generation or add text instead."],
    ["请先选中文字或色块图层。", "Select a text or shape layer first."],
    ["请输入正确的 HEX 颜色，例如 #C84F3D。", "Enter a valid HEX color, such as #C84F3D."],
    ["请先选中文字图层。", "Select a text layer first."],
    ["已添加 Coloroutine Ribbon 艺术字，可在右侧继续改颜色和特效。", "Coloroutine Ribbon text added. Continue editing its color and effects in the side panel."],
    ["请先选中一个图片图层。", "Select an image layer first."],
    ["背景已去除，可继续在 2D / 3D 中预览。", "Background removed. Continue reviewing the artwork in 2D or 3D."],
    ["抠图失败，请重新上传图片。", "Background removal failed. Upload the image again."],
    ["设计已添加到画布，可继续缩放与编辑。", "Design added to the canvas. You can now resize and edit it."],
    ["无法加载此设计，请重新生成。", "This design could not be loaded. Generate it again."],
    ["灵感已转为提示词，你可以调整后生成。", "The inspiration was converted into a prompt. Edit it before generating."],
    ["设计文件已添加，可在画布中拖拽缩放。", "Design file added. Drag it on the canvas to move or resize it."],
    ["已创建新的设计项目。", "New design project created."],
    ["请先添加至少一个设计元素。", "Add at least one design element first."],
    ["定制设计已绑定并加入 Shopify 购物车。", "The custom design was attached and added to the Shopify cart."],
    ["确定清空当前印刷面的全部设计吗？", "Clear every design element from the current print side?"],
    ["画布为空，暂无可导出的设计。", "The canvas is empty. There is no design to export."],
    ["已导出透明背景设计 PNG。", "Transparent design PNG exported."],
    ["请先完成至少一个设计元素，再生成分享图。", "Complete at least one design element before creating a share image."],
    ["分享图生成失败：", "Share image creation failed: "],
    ["品牌预览链接已生成，可以发送给好友或同事。", "Brand preview link created. It is ready to share with friends or colleagues."],
    ["请先生成公开预览链接。", "Create a public preview link first."],
    ["分享链接已复制。", "Share link copied."],
    ["浏览器未允许复制，请手动选择链接。", "The browser blocked copying. Select the link manually."],
    ["当前浏览器不支持文件分享，可先下载 PNG。", "This browser cannot share files. Download the PNG instead."],
    ["系统分享未完成。", "System sharing did not complete."],
    ["网络或服务连接不稳定，请稍后重试；画布编辑、上传图片和文字设计仍可继续使用。", "The network or service is unstable. Try again shortly; canvas editing, uploads, and text tools remain available."],
    ["3D 模型加载失败：", "3D model failed to load: "],
    ["圆润流线", "Rounded flow"],
    ["厚描边", "bold outline"],
    ["适合印花", "print-ready"],
    ["文字内容", "Text content"],
    ["添加 Coloroutine Flow 艺术字", "Add Coloroutine Flow text"],
    ["添加普通文字", "Add standard text"],
    ["添加色块", "Add shape"],
    ["添加后选中文字图层，即可在右侧调整字体、字号、字距、描边和对齐；2D 与 3D 预览会同步更新。", "After adding text, select its layer to edit the font, size, spacing, outline, and alignment. The 2D and 3D previews update together."],
    ["AI 生成方案", "AI concept"],
    ["应用方案", "Apply concept"],
    ["商品与印刷面", "Product & print side"],
    ["商品", "Product"],
    ["颜色", "Color"],
    ["尺码 / 型号", "Size / model"],
    ["定制面", "Print side"],
    ["印刷质量检查", "Print quality check"],
    ["有效分辨率约", "Estimated effective resolution:"],
    ["目标文件", "Target file"],
    ["图层", "Layers"],
    ["添加图片、文字或图形后将在这里显示", "Images, text, and shapes will appear here"],
    ["数量", "Quantity"],
    ["同一设计", "Same design"],
    ["商品小计", "Product subtotal"],
    ["设计将生成不可变版本并与订单行项目绑定。税费与运费在结账时计算。", "An immutable design version will be attached to the order line. Taxes and shipping are calculated at checkout."],
    ["取色器 / 一键抠图", "Color picker / background removal"],
    ["已选中图层", "Layer selected"],
    ["先选中图层", "Select a layer first"],
    ["选中画布上的图片、文字或色块后使用", "Select an image, text, or shape on the canvas"],
    ["取色改颜色，抠图去白底，修改会同步到 2D 和 3D 预览。", "Adjust colors or remove a background; changes sync to both 2D and 3D."],
    ["文字设计", "Text design"],
    ["正在编辑文字图层", "Editing text layer"],
    ["请选择或添加文字", "Select or add text"],
    ["编辑文字内容", "Edit text content"],
    ["填充 HEX", "Fill HEX"],
    ["描边 HEX", "Outline HEX"],
    ["字号", "Font size"],
    ["字距", "Letter spacing"],
    ["行高", "Line height"],
    ["描边粗细", "Outline width"],
    ["取色器", "Color picker"],
    ["文字 / 色块可编辑", "Text / shape editable"],
    ["请选择文字或色块", "Select text or a shape"],
    ["点击选择颜色", "Choose a color"],
    ["快速调整文字、色块和基础图形", "Quickly recolor text and basic shapes"],
    ["图片抠图", "Background removal"],
    ["当前图片可处理", "Current image is ready"],
    ["请选择图片图层", "Select an image layer"],
    ["一键去白底 / 去近似背景", "Remove white / similar background"],
    ["适合 Logo、贴纸图、AI 图残留白底；复杂照片建议保留背景或重新生成透明版本。", "Best for logos, stickers, and AI artwork with a residual white background. Keep complex photo backgrounds or regenerate a transparent version."],
    ["设计图片", "Design image"],
    ["文字图层", "Text layer"],
    ["色块", "Shape"],
    ["副本", "copy"],
    ["印刷质量优秀", "Excellent print quality"],
    ["印刷质量合格", "Acceptable print quality"],
    ["分辨率偏低", "Low resolution"],
    ["正面", "Front"],
    ["背面", "Back"],
    ["环绕面", "Wrap"],
    ["服饰", "Apparel"],
    ["家居", "Home"],
    ["配件", "Accessories"],
    ["骨白", "Bone"],
    ["黑色", "Black"],
    ["海军蓝", "Navy"],
    ["烟粉", "Dusty rose"],
    ["燕麦", "Oat"],
    ["森林绿", "Forest green"],
    ["薰衣草", "Lavender"],
    ["白色", "White"],
    ["珊瑚红", "Coral"],
    ["透明", "Clear"],
    ["砂岩", "Sandstone"],
    ["原色", "Natural"],
    ["橄榄绿", "Olive"],
    ["白底", "White base"],
    ["标准款", "Standard"],
    ["圆形", "Round"],
    ["方形", "Square"],
    ["Canvas Tee 270 重磅 T 恤", "Canvas Tee 270 Heavyweight T-Shirt"],
    ["T 恤", "T-Shirt"],
    ["450g 重磅落肩连帽卫衣", "450g Heavyweight Drop-Shoulder Hoodie"],
    ["400ml 弧形陶瓷杯", "400ml Curved Ceramic Mug"],
    ["马克杯", "Mug"],
    ["防摔手机壳", "Protective Phone Case"],
    ["手机壳", "Phone Case"],
    ["杜邦纸质感托特包", "Textured Paper Tote Bag"],
    ["托特包", "Tote Bag"],
    ["定制冰箱贴", "Custom Fridge Magnet"],
    ["冰箱贴", "Fridge Magnet"],
    ["未命名设计", "Untitled design"],
    ["我的首个设计", "My first design"],
    ["我的设计", "My design"],
    ["2D ↔ 3D 已校准", "2D ↔ 3D calibrated"],
    ["2D / 3D 印刷比例待校准", "2D / 3D print ratio needs calibration"],
    ["本地创意引擎已连接", "Local creative engine connected"],
    ["AI 设计服务已连接", "AI design service connected"],
    ["无需密钥", "No API key required"],
    ["可完整测试流程", "Full workflow available"],
    ["离线编辑模式", "Offline editing mode"],
    ["画布可用", "Canvas available"],
    ["AI 服务未连接", "AI service disconnected"],
    ["设计检查", "Design Check"],
    ["需要处理", "Needs attention"],
    ["可投入生产", "Production ready"],
    ["下单前检查", "Review before order"],
    ["专业校样", "Professional Proof"],
    ["导出校样包", "Export proof pack"],
    ["申请校样 / 报价", "Request proof / quote"],
    ["左", "Left"],
    ["中", "Center"],
    ["右", "Right"],
    ["无", "None"]
  ];
  const ATTRIBUTES = ["aria-label", "title", "placeholder"];
  const SKIP_ELEMENT_SELECTOR = "style,script,[data-i18n-ignore]";
  const SKIP_TEXT_SELECTOR = "style,script,textarea,[data-i18n-ignore],.inspiration-copy";
  function normalizeLocale(value) {
    return String(value || "").toLowerCase().startsWith("zh") ? "zh-CN" : "en";
  }
  function resolveStudioLocale(explicitLocale = "") {
    const queryLocale = new URLSearchParams(location.search).get("studio_locale");
    if (queryLocale) return normalizeLocale(queryLocale);
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return normalizeLocale(stored);
    } catch {
    }
    if (explicitLocale) return normalizeLocale(explicitLocale);
    return DEFAULT_LOCALE;
  }
  function persistStudioLocale(locale) {
    try {
      localStorage.setItem(STORAGE_KEY, normalizeLocale(locale));
    } catch {
    }
  }
  function translateStudioText(value, locale = DEFAULT_LOCALE) {
    if (!value) return value;
    const targetLocale = normalizeLocale(locale);
    const pairs = [...PHRASES].sort((a2, b2) => {
      const aSource = targetLocale === "en" ? a2[0] : a2[1];
      const bSource = targetLocale === "en" ? b2[0] : b2[1];
      return bSource.length - aSource.length;
    });
    let output = String(value);
    for (const [zh, en2] of pairs) {
      const source = targetLocale === "en" ? zh : en2;
      const target = targetLocale === "en" ? en2 : zh;
      if (!source || source === target) continue;
      if (output.trim() === source) {
        const leading = output.match(/^\s*/)?.[0] || "";
        const trailing = output.match(/\s*$/)?.[0] || "";
        output = `${leading}${target}${trailing}`;
        continue;
      }
      const canReplaceInside = targetLocale === "en" ? source.length > 1 : source.length >= 8 && (/\s/.test(source) || /[:/·]/.test(source));
      if (canReplaceInside && output.includes(source)) output = output.split(source).join(target);
    }
    return output;
  }
  class StudioLocalizer {
    constructor(root, locale = DEFAULT_LOCALE) {
      __privateAdd(this, _StudioLocalizer_instances);
      this.root = root;
      this.locale = normalizeLocale(locale);
      this.textOriginals = /* @__PURE__ */ new WeakMap();
      this.attributeOriginals = /* @__PURE__ */ new WeakMap();
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) this.apply(node);
        }
      });
    }
    start() {
      this.apply(this.root);
      this.observer.observe(this.root, { childList: true, subtree: true });
    }
    stop() {
      this.observer.disconnect();
    }
    setLocale(locale) {
      this.locale = normalizeLocale(locale);
      persistStudioLocale(this.locale);
      this.apply(this.root);
    }
    apply(scope) {
      if (!scope) return;
      if (scope.nodeType === Node.TEXT_NODE) {
        __privateMethod(this, _StudioLocalizer_instances, translateTextNode_fn).call(this, scope);
        return;
      }
      if (scope.nodeType !== Node.ELEMENT_NODE && scope.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
      if (scope.nodeType === Node.ELEMENT_NODE && scope.matches(SKIP_ELEMENT_SELECTOR)) return;
      if (scope.nodeType === Node.ELEMENT_NODE) __privateMethod(this, _StudioLocalizer_instances, translateElement_fn).call(this, scope);
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
      let node = walker.nextNode();
      while (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches(SKIP_ELEMENT_SELECTOR)) {
            node = walker.nextSibling();
            continue;
          }
          __privateMethod(this, _StudioLocalizer_instances, translateElement_fn).call(this, node);
        } else if (!node.parentElement?.closest(SKIP_TEXT_SELECTOR)) {
          __privateMethod(this, _StudioLocalizer_instances, translateTextNode_fn).call(this, node);
        }
        node = walker.nextNode();
      }
    }
  }
  _StudioLocalizer_instances = new WeakSet();
  translateTextNode_fn = function(node) {
    if (!this.textOriginals.has(node)) this.textOriginals.set(node, node.data);
    node.data = translateStudioText(this.textOriginals.get(node), this.locale);
  };
  translateElement_fn = function(element) {
    let originals = this.attributeOriginals.get(element);
    if (!originals) {
      originals = {};
      this.attributeOriginals.set(element, originals);
    }
    for (const name of ATTRIBUTES) {
      if (!element.hasAttribute(name)) continue;
      if (!(name in originals)) originals[name] = element.getAttribute(name);
      element.setAttribute(name, translateStudioText(originals[name], this.locale));
    }
  };
  const MODES = [
    ["upload", "upload", "上传设计", "PNG / JPG / WEBP"],
    ["generate", "sparkles", "AI 文生图", "描述你的创意"],
    ["reference", "image", "参考图生图", "用图片定义风格"],
    ["inspire", "bulb", "灵感推荐", "探索策展灵感"],
    ["edit", "type", "文字与图形", "添加可编辑元素"]
  ];
  const STYLES = ["复古丝网印刷", "极简瑞士风", "可爱手绘", "Y2K", "水彩植物", "日系浮世绘"];
  const TEXT_PRESETS = [
    { id: "coloroutine-bloom", label: "Coloroutine Ribbon", note: "品牌流线艺术字", preview: "Ribbon", style: { fontPreset: "coloroutine-bloom", fontFamily: '"Lily Script One", "Pacifico", "Baloo 2", "Noto Sans SC", cursive', fontWeight: 400, fill: "#c84f3d", stroke: "#fff2d8", strokeWidth: 4.6, charSpacing: 18, lineHeight: 0.9, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(48,70,60,.18) 4px 4px 0, rgba(184,74,58,.20) -3px 6px 0" } },
    { id: "coloroutine-soft", label: "Coloroutine Soft", note: "圆润大众印花", preview: "Soft", style: { fontPreset: "coloroutine-soft", fontFamily: '"Fredoka", "Baloo 2", "Arial Rounded MT Bold", "Noto Sans SC", sans-serif', fontWeight: 700, fill: "#17181c", stroke: "#ffffff", strokeWidth: 2.4, charSpacing: 22, lineHeight: 0.96, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(184,74,58,.18) 3px 3px 0" } },
    { id: "pacifico", label: "Pacifico", note: "复古手写曲线", preview: "Retro", style: { fontPreset: "pacifico", fontFamily: '"Pacifico", "Lily Script One", "Noto Sans SC", cursive', fontWeight: 400, fill: "#2f5f53", stroke: "#fff7e7", strokeWidth: 2.8, charSpacing: 8, lineHeight: 0.95, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(18,18,18,.20) 4px 4px 0" } },
    { id: "bungee", label: "Bungee", note: "街头海报粗体", preview: "Urban", style: { fontPreset: "bungee", fontFamily: '"Bungee", "Arial Black", "Noto Sans SC", sans-serif', fontWeight: 400, fill: "#121212", stroke: "#f6d56f", strokeWidth: 2.2, charSpacing: 16, lineHeight: 0.9, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(184,74,58,.34) 6px 6px 0" } },
    { id: "lilita", label: "Lilita One", note: "可爱厚实标题", preview: "Pop", style: { fontPreset: "lilita", fontFamily: '"Lilita One", "Fredoka", "Noto Sans SC", sans-serif', fontWeight: 400, fill: "#7aa6ff", stroke: "#ffffff", strokeWidth: 3, charSpacing: 12, lineHeight: 0.92, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(48,70,60,.20) 4px 5px 0" } },
    { id: "noto-sans", label: "Noto Sans", note: "清爽免费中文", preview: "Sans", style: { fontPreset: "noto-sans", fontFamily: '"Noto Sans SC", "PingFang SC", system-ui, sans-serif', fontWeight: 800, fill: "#17181c", stroke: "", strokeWidth: 0, charSpacing: 12, lineHeight: 1.05, textAlign: "center" } },
    { id: "noto-serif", label: "Noto Serif", note: "优雅免费衬线", preview: "Serif", style: { fontPreset: "noto-serif", fontFamily: '"Noto Serif SC", Georgia, serif', fontWeight: 700, fill: "#17181c", stroke: "", strokeWidth: 0, charSpacing: 18, lineHeight: 1.08, textAlign: "center" } },
    { id: "zcool", label: "ZCOOL XiaoWei", note: "中文文艺标题", preview: "文艺", style: { fontPreset: "zcool", fontFamily: '"ZCOOL XiaoWei", "Noto Serif SC", serif', fontWeight: 400, fill: "#30463c", stroke: "#fff7e7", strokeWidth: 1.2, charSpacing: 10, lineHeight: 1.08, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(18,18,18,.12) 2px 3px 0" } },
    { id: "poster", label: "Poster Bold", note: "高冲击海报字", preview: "Poster", style: { fontPreset: "poster", fontFamily: 'Impact, "Arial Black", "Bungee", "Noto Sans SC", sans-serif', fontWeight: 900, fill: "#121212", stroke: "#ffffff", strokeWidth: 1.6, charSpacing: 30, lineHeight: 0.92, textAlign: "center", paintFirst: "stroke", strokeLineJoin: "round" } },
    { id: "handmade", label: "Handmade", note: "自然手作感", preview: "Hand", style: { fontPreset: "handmade", fontFamily: '"Comic Sans MS", "Kaiti SC", "Noto Sans SC", cursive', fontWeight: 700, fill: "#30463c", stroke: "", strokeWidth: 0, charSpacing: 4, lineHeight: 1.12, textAlign: "center" } }
  ];
  const TEXT_ALIGNMENTS = [
    ["left", "左"],
    ["center", "中"],
    ["right", "右"]
  ];
  const TEXT_EFFECTS = [
    { id: "print-outline", label: "印花", note: "清晰描边", style: { textEffect: "print-outline", stroke: "#fff1dc", strokeWidth: 3.4, paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(48,70,60,.16) 3px 3px 0" } },
    { id: "shadow", label: "重影", note: "柔和错位", style: { textEffect: "shadow", stroke: "#ffffff", strokeWidth: 1.2, paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(18,18,18,.28) 7px 7px 0" } },
    { id: "three-d", label: "3D", note: "立体厚度", style: { textEffect: "three-d", stroke: "#fff4e6", strokeWidth: 2.4, paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(42,55,49,.38) 9px 9px 0" } },
    { id: "stacked", label: "叠放", note: "海报层次", style: { textEffect: "stacked", stroke: "#f4d9a8", strokeWidth: 2.8, paintFirst: "stroke", strokeLineJoin: "round", shadow: "rgba(184,74,58,.34) -5px 5px 0" } },
    { id: "none", label: "无", note: "纯文字", style: { textEffect: "none", stroke: "", strokeWidth: 0, paintFirst: "fill", strokeLineJoin: "round", shadow: "" } }
  ];
  class ColoroutineAIStudio extends HTMLElement {
    constructor() {
      super();
      __privateAdd(this, _ColoroutineAIStudio_instances);
      this.attachShadow({ mode: "open" });
      this.store = new ProjectStore();
      this.locale = resolveStudioLocale(this.getAttribute("locale"));
      this.state = {
        mode: "generate",
        view: "2d",
        zoom: 100,
        service: "checking",
        busy: false,
        previewed3d: false,
        generated: [],
        inspirations: [],
        reference: null,
        includeBackground: false,
        mobileSidebar: false,
        mobileInspector: false,
        quality: { level: "empty", dpi: null, label: "尚未添加图片" },
        layers: [],
        activeKind: "",
        activeColor: "#121212",
        activeText: null,
        shareFormat: "square",
        shareView: "2d",
        shareTheme: "cream",
        shareImage: "",
        shareResult: null,
        proofId: "",
        debugMapping: new URLSearchParams(location.search).has("debugMapping")
      };
    }
    connectedCallback() {
      const project = this.store.current;
      const mockupAssets = parseJSONAttribute(this.getAttribute("mockup-assets"));
      const modelAssets = parseJSONAttribute(this.getAttribute("model-assets"));
      this.products = hydrateProductAssets(PRODUCTS, mockupAssets, "/product-mockups/", modelAssets);
      this.product = this.products.find((product) => product.id === project.productId) || this.products[0];
      this.color = getProductColor(this.product, project.colorId);
      this.api = new StudioAPI(this.getAttribute("api-base") || "/api");
      this.shopify = new ShopifyBridge(this.getAttribute("variant-map"));
      __privateMethod(this, _ColoroutineAIStudio_instances, render_fn).call(this);
      this.localizer = new StudioLocalizer(this.shadowRoot, this.locale);
      this.localizer.start();
      this.setAttribute("lang", this.locale);
      this.editor = new DesignCanvas(this.shadowRoot.querySelector("#design-canvas"), this.product);
      __privateMethod(this, _ColoroutineAIStudio_instances, bind_fn2).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, loadCurrentScene_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, checkService_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, loadCatalog_fn).call(this);
      document.fonts?.ready.then(() => {
        this.editor?.canvas?.requestRenderAll();
        if (this.state.view === "3d") __privateMethod(this, _ColoroutineAIStudio_instances, update3DDesignSnapshot_fn).call(this);
      });
    }
    disconnectedCallback() {
      this.editor?.dispose();
      this.preview3d?.dispose();
      this.localizer?.stop();
    }
  }
  _ColoroutineAIStudio_instances = new WeakSet();
  render_fn = function() {
    const project = this.store.current;
    this.shadowRoot.innerHTML = `
      <style>${styles}</style>
      <div class="studio">
        <header class="topbar">
          <div class="brand">
            <button class="icon-button mobile-menu" data-action="toggle-sidebar" aria-label="打开菜单">${icon("menu")}</button>
            <span class="brand-mark">${icon("sparkles", 21)}</span>
            <div><div class="brand-title">Coloroutine AI Studio</div><div class="brand-subtitle">DESIGN · PREVIEW · ORDER</div></div>
          </div>
          <div class="project-title">
            <small>POD DESIGN WORKSPACE</small>
            <div class="project-name-row"><span class="project-name" id="top-project-name">${escapeHTML(project.name)}</span><span class="save-state" id="save-state">已保存</span></div>
          </div>
          <div style="display:flex;height:100%;align-items:center">
            <div class="metrics">
              <div class="metric"><span class="metric-label">本地项目</span><span class="metric-value" id="project-count">${this.store.list().length}</span></div>
              <div class="metric"><span class="metric-label">AI 生成次数</span><span class="metric-value" id="generation-count">${this.store.state.usage.generations}</span></div>
              <div class="metric"><span class="metric-label">当前商品</span><span class="metric-value accent" id="top-product">${this.product.shortName}</span></div>
            </div>
            <div class="top-actions">
              <label class="locale-control"><span>Language</span><select id="studio-locale" aria-label="Language"><option value="en" ${this.locale === "en" ? "selected" : ""}>EN</option><option value="zh-CN" ${this.locale === "zh-CN" ? "selected" : ""}>中文</option></select></label>
              <button class="icon-button theme-toggle" data-action="toggle-theme" aria-label="切换主题">${icon("monitor")}</button>
              <button class="icon-button mobile-inspector" data-action="toggle-inspector" aria-label="打开商品设置">${icon("settings")}</button>
            </div>
          </div>
        </header>

        <div class="layout">
          <aside class="sidebar" id="sidebar">
            <div class="project-box">
              <div class="section-eyebrow"><span>当前项目</span><span style="display:flex;gap:5px"><button class="icon-button" data-action="new-project" aria-label="新建项目">${icon("plus", 15)}</button><button class="icon-button sidebar-close" data-action="toggle-sidebar" aria-label="关闭菜单">${icon("close", 15)}</button></span></div>
              <select class="project-select" id="project-select" aria-label="选择项目">${__privateMethod(this, _ColoroutineAIStudio_instances, projectOptions_fn).call(this)}</select>
            </div>
            <div class="connection"><i class="status-dot" id="service-dot"></i><div><strong id="service-title">正在连接设计服务</strong><span id="service-copy">本地预览 / Shopify Ready</span></div></div>
            <div class="nav-label">创作方式</div>
            <nav class="nav" aria-label="创作工具">${__privateMethod(this, _ColoroutineAIStudio_instances, modeNav_fn).call(this)}</nav>
            <div class="nav-secondary">
              <div class="nav-label">工作区</div>
              <nav class="nav">
                <button class="nav-item" data-action="focus-preflight" aria-label="Design Check"><span class="nav-index">${icon("check", 16)}</span><span class="nav-copy"><strong>Design Check</strong><small>DPI / 3D / cart readiness</small></span></button>
                <button class="nav-item" data-action="toggle-debug-mapping" aria-label="Mapping Debug"><span class="nav-index">${icon("cube", 16)}</span><span class="nav-copy"><strong>Mapping Debug</strong><small>Print area diagnostics</small></span></button>
                <button class="nav-item" data-action="export-proof" aria-label="Export Proof"><span class="nav-index">${icon("check", 16)}</span><span class="nav-copy"><strong>Export Proof</strong><small>PNG + production JSON</small></span></button>
                <button class="nav-item" data-action="export-project" aria-label="Save Project"><span class="nav-index">${icon("save", 16)}</span><span class="nav-copy"><strong>Save Project</strong><small>.coloroutine-design.json</small></span></button>
                <button class="nav-item" data-action="focus-layers" aria-label="图层管理"><span class="nav-index">${icon("layers", 16)}</span><span class="nav-copy"><strong>图层管理</strong><small>排序 / 显隐 / 锁定</small></span></button>
                <button class="nav-item" data-action="create-share" aria-label="品牌分享图"><span class="nav-index">${icon("external", 16)}</span><span class="nav-copy"><strong>品牌分享图</strong><small>生成预览 / 分享链接</small></span></button>
                <button class="nav-item" data-action="download" aria-label="导出预览"><span class="nav-index">${icon("download", 16)}</span><span class="nav-copy"><strong>导出预览</strong><small>下载当前合成图</small></span></button>
              </nav>
            </div>
            <div class="sidebar-foot">${icon("save", 14)} 自动保存至此浏览器</div>
          </aside>

          <main class="main">
            <section class="quick-start" id="quick-start" aria-label="快速开始">
              <button class="quick-card quick-card-ai" data-action="quick-generate">${icon("sparkles", 16)}<span><strong>AI 生成设计</strong><small>给你一个可直接印花的透明图案提示词</small></span></button>
              <button class="quick-card" data-action="quick-upload">${icon("upload", 16)}<span><strong>上传图片</strong><small>Logo、照片或贴纸图，自动进入编辑</small></span></button>
              <button class="quick-card" data-action="quick-text">${icon("type", 16)}<span><strong>添加艺术字</strong><small>使用 Coloroutine Ribbon 品牌字体</small></span></button>
            </section>
            <section class="workbench-shell" aria-label="Professional Studio workflow">
              <div class="workbench-title"><span>Professional POD Workbench</span><strong>Inspire -> Design -> Preview -> Order</strong></div>
              <div class="workbench-steps">${__privateMethod(this, _ColoroutineAIStudio_instances, workbenchHTML_fn).call(this)}</div>
            </section>
            <div class="main-head">
              <div><div class="kicker" id="product-kicker">DESIGN TO PRODUCT · ${this.product.category}</div><h1>把灵感变成可下单的产品</h1><p>选择商品、完成设计、检查真实预览，再把定制信息直接带入 Shopify 订单。</p></div>
              <div class="main-head-actions"><button class="product-chip" data-action="focus-product">${icon("shirt", 16)}<span><strong id="product-chip-title">${escapeHTML(this.product.shortName)}</strong><small id="product-chip-meta">${escapeHTML(this.color[2])} · ${escapeHTML(project.size)} · ${FACE_LABELS[project.face]}</small></span></button><span class="mode-badge" id="mode-badge">${__privateMethod(this, _ColoroutineAIStudio_instances, modeLabel_fn).call(this)}</span></div>
            </div>

            <nav class="workflow" aria-label="定制流程">
              <button class="workflow-step done" id="workflow-product" data-action="focus-product"><span>01</span><div><strong>选择商品</strong><small>款式、颜色与印刷面</small></div></button>
              <i aria-hidden="true">→</i>
              <button class="workflow-step active" id="workflow-design" data-action="focus-create"><span>02</span><div><strong>添加设计</strong><small>上传、生成或编辑</small></div></button>
              <i aria-hidden="true">→</i>
              <button class="workflow-step" id="workflow-preview" data-view="3d"><span>03</span><div><strong>检查预览</strong><small>2D / 3D 与印刷质量</small></div></button>
              <i aria-hidden="true">→</i>
              <button class="workflow-step" id="workflow-order" data-action="focus-order"><span>04</span><div><strong>确认下单</strong><small>绑定设计与 Shopify 订单</small></div></button>
            </nav>

            <section class="creative-panel" aria-label="创作面板">
              <div class="creative-title"><strong id="creative-title">${__privateMethod(this, _ColoroutineAIStudio_instances, creativeTitle_fn).call(this)}</strong><button class="icon-button" data-action="clear-design" aria-label="清空画布">${icon("trash", 15)}</button></div>
              <div class="creative-body" id="creative-body">${__privateMethod(this, _ColoroutineAIStudio_instances, creativeBody_fn).call(this)}</div>
            </section>

            <section class="stage-card" aria-label="产品设计画布">
              <div class="toolbar">
                <div class="toolbar-group">
                  <button class="tool-button" data-action="undo" aria-label="撤销" disabled>${icon("undo")}</button>
                  <button class="tool-button" data-action="redo" aria-label="重做" disabled>${icon("redo")}</button>
                  <span class="toolbar-divider"></span>
                  <button class="tool-button" data-action="duplicate" aria-label="复制图层">${icon("copy")}</button>
                  <button class="tool-button" data-action="remove" aria-label="删除图层">${icon("trash")}</button>
                  <button class="tool-button" data-action="center" aria-label="居中">${icon("center")}</button>
                  <button class="tool-button" data-action="fit" aria-label="适应印刷区">${icon("fit")}</button>
                </div>
                <div class="segmented" aria-label="预览模式">
                  <button class="active" data-view="2d">${icon("monitor", 14)}2D</button>
                  <button data-view="3d">${icon("cube", 14)}3D</button>
                </div>
              </div>
              <div class="stage" id="stage">
                <div class="empty-stage-actions" id="empty-stage-actions"><button data-action="quick-generate">${icon("sparkles", 14)} AI 生成</button><button data-action="quick-upload">${icon("upload", 14)} 上传</button><button data-action="quick-text">${icon("type", 14)} 艺术字</button></div>
                <div class="product-stage ${this.state.debugMapping ? "debug-mapping" : ""}" id="product-stage">
                  <div class="product-art" id="product-art">${productSvg(this.product, this.color, project.face)}</div>
                  <div class="print-area" id="print-area"><canvas id="design-canvas"></canvas></div>
                </div>
                <div class="three-stage" id="three-stage"><span class="beta-tag">可拖拽旋转 · UV / PBR 实时渲染</span></div>
                <div class="stage-helper" id="stage-helper">${icon("sparkles", 16)}<div><strong>从上方添加第一个设计</strong><span>上传图片、AI 生成或添加文字后，可直接拖拽缩放。</span></div></div>
                <div class="zoom-controls"><button data-action="zoom-out" aria-label="缩小">${icon("minus", 14)}</button><span id="zoom-value">100%</span><button data-action="zoom-in" aria-label="放大">${icon("plus", 14)}</button></div>
              </div>
              <div class="stage-foot"><div class="stage-status"><span class="quality-pill empty" id="stage-quality">尚未添加图片</span><span class="mapping-pill" id="stage-mapping"></span></div><span>虚线区域为可印刷范围 · 拖拽控制点缩放与旋转</span></div>
            </section>
          </main>

          <aside class="inspector" id="inspector">${__privateMethod(this, _ColoroutineAIStudio_instances, inspectorHTML_fn).call(this)}</aside>
        </div>

        <div class="mobile-bar"><button class="button button-secondary" data-action="toggle-inspector">${icon("settings", 16)} 商品设置</button><button class="button button-primary" data-action="add-cart">${icon("cart", 17)} <span class="button-label">确认设计并加入购物车</span></button></div>
        <div class="mobile-bar mobile-bar-modern"><button class="button button-secondary" data-action="focus-create">${icon("sparkles", 16)} <span>创作</span></button><button class="button button-secondary" data-action="toggle-inspector">${icon("settings", 16)} <span>商品/文字</span></button><button class="button button-primary" data-action="add-cart">${icon("cart", 17)} <span class="button-label">加入购物车</span></button></div>
        ${__privateMethod(this, _ColoroutineAIStudio_instances, shareModalHTML_fn).call(this)}
        <input id="file-input" type="file" accept="image/png,image/jpeg,image/webp" hidden />
        <input id="reference-input" type="file" accept="image/png,image/jpeg,image/webp" hidden />
        <div class="toast-stack" id="toasts" aria-live="polite"></div>
      </div>`;
    __privateMethod(this, _ColoroutineAIStudio_instances, updatePrintArea_fn).call(this);
  };
  bind_fn2 = function() {
    this.shadowRoot.addEventListener("click", (event) => __privateMethod(this, _ColoroutineAIStudio_instances, onClick_fn).call(this, event));
    this.shadowRoot.addEventListener("change", (event) => __privateMethod(this, _ColoroutineAIStudio_instances, onChange_fn).call(this, event));
    this.shadowRoot.addEventListener("input", (event) => __privateMethod(this, _ColoroutineAIStudio_instances, onInput_fn).call(this, event));
    this.editor.addEventListener("change", (event) => {
      this.state.layers = event.detail.layers;
      this.state.quality = event.detail.quality;
      if (event.detail.reason === "edit") {
        this.state.previewed3d = this.state.view === "3d";
        this.store.invalidateFinalized();
      }
      __privateMethod(this, _ColoroutineAIStudio_instances, scheduleSave_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, updateQuality_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, renderLayers_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
      if (this.state.view === "3d") __privateMethod(this, _ColoroutineAIStudio_instances, update3DDesignSnapshot_fn).call(this);
    });
    this.editor.addEventListener("selection", (event) => {
      this.state.layers = event.detail.layers;
      this.state.activeKind = event.detail.activeKind || "";
      this.state.activeColor = event.detail.activeColor || "#121212";
      this.state.activeText = event.detail.activeText || null;
      __privateMethod(this, _ColoroutineAIStudio_instances, renderLayers_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, renderEditTools_fn).call(this);
    });
    this.editor.addEventListener("history", (event) => {
      const undo = this.shadowRoot.querySelector('[data-action="undo"]');
      const redo = this.shadowRoot.querySelector('[data-action="redo"]');
      if (undo) undo.disabled = !event.detail.canUndo;
      if (redo) redo.disabled = !event.detail.canRedo;
    });
    const stage = this.shadowRoot.querySelector("#stage");
    stage.addEventListener("dragover", (event) => {
      event.preventDefault();
    });
    stage.addEventListener("drop", (event) => {
      event.preventDefault();
      const file = event.dataTransfer?.files?.[0];
      if (file) __privateMethod(this, _ColoroutineAIStudio_instances, addUploadedFile_fn).call(this, file);
    });
  };
  onClick_fn = async function(event) {
    const target = event.target.closest("button,[data-color],[data-size],[data-face],[data-layer-index]");
    if (!target) return;
    if (target.dataset.mode) return __privateMethod(this, _ColoroutineAIStudio_instances, setMode_fn).call(this, target.dataset.mode);
    if (target.dataset.view) return __privateMethod(this, _ColoroutineAIStudio_instances, setView_fn).call(this, target.dataset.view);
    if (target.dataset.style) {
      const prompt = this.shadowRoot.querySelector("#prompt");
      if (prompt) {
        prompt.value = `${prompt.value.trim()}${prompt.value.trim() ? this.locale === "zh-CN" ? "，" : ", " : ""}${translateStudioText(target.dataset.style, this.locale)}`;
        prompt.dispatchEvent(new Event("input", { bubbles: true }));
      }
      return;
    }
    if (target.dataset.shareFormat) {
      this.state.shareFormat = target.dataset.shareFormat;
      __privateMethod(this, _ColoroutineAIStudio_instances, updateShareFormat_fn).call(this);
      return;
    }
    if (target.dataset.shareView) {
      this.state.shareView = target.dataset.shareView;
      __privateMethod(this, _ColoroutineAIStudio_instances, updateShareView_fn).call(this);
      return;
    }
    if (target.dataset.result) return __privateMethod(this, _ColoroutineAIStudio_instances, useGenerated_fn).call(this, Number(target.dataset.result));
    if (target.dataset.inspiration) return __privateMethod(this, _ColoroutineAIStudio_instances, useInspiration_fn).call(this, Number(target.dataset.inspiration));
    if (target.dataset.color) return __privateMethod(this, _ColoroutineAIStudio_instances, setColor_fn).call(this, target.dataset.color);
    if (target.dataset.size) return __privateMethod(this, _ColoroutineAIStudio_instances, setSize_fn).call(this, target.dataset.size);
    if (target.dataset.face) return __privateMethod(this, _ColoroutineAIStudio_instances, setFace_fn).call(this, target.dataset.face);
    if (target.dataset.layerIndex !== void 0 && !target.dataset.layerAction) return this.editor.selectLayer(Number(target.dataset.layerIndex));
    if (target.dataset.layerAction) return this.editor.toggleLayer(Number(target.dataset.layerIndex), target.dataset.layerAction);
    const actions = {
      "toggle-sidebar": () => __privateMethod(this, _ColoroutineAIStudio_instances, togglePanel_fn).call(this, "sidebar"),
      "toggle-inspector": () => __privateMethod(this, _ColoroutineAIStudio_instances, togglePanel_fn).call(this, "inspector"),
      "toggle-theme": () => __privateMethod(this, _ColoroutineAIStudio_instances, toggleTheme_fn).call(this),
      "new-project": () => __privateMethod(this, _ColoroutineAIStudio_instances, newProject_fn).call(this),
      "browse-upload": () => this.shadowRoot.querySelector("#file-input").click(),
      "browse-reference": () => this.shadowRoot.querySelector("#reference-input").click(),
      "quick-generate": () => __privateMethod(this, _ColoroutineAIStudio_instances, quickGenerateStart_fn).call(this),
      "quick-upload": () => __privateMethod(this, _ColoroutineAIStudio_instances, quickUploadStart_fn).call(this),
      "quick-text": () => __privateMethod(this, _ColoroutineAIStudio_instances, quickTextStart_fn).call(this),
      "generate": () => __privateMethod(this, _ColoroutineAIStudio_instances, generate_fn).call(this, false),
      "generate-reference": () => __privateMethod(this, _ColoroutineAIStudio_instances, generate_fn).call(this, true),
      "refresh-inspiration": () => __privateMethod(this, _ColoroutineAIStudio_instances, loadInspirations_fn).call(this, true),
      "add-text": () => __privateMethod(this, _ColoroutineAIStudio_instances, addTextFromInput_fn).call(this, "noto-sans"),
      "add-brand-text": () => __privateMethod(this, _ColoroutineAIStudio_instances, addTextFromInput_fn).call(this, "coloroutine-bloom"),
      "add-shape": () => this.editor.addShape(),
      "set-text-preset": () => __privateMethod(this, _ColoroutineAIStudio_instances, applyTextPreset_fn).call(this, target.dataset.value),
      "set-text-align": () => __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { textAlign: target.dataset.value }),
      "set-text-effect": () => __privateMethod(this, _ColoroutineAIStudio_instances, applyTextEffect_fn).call(this, target.dataset.value),
      "set-active-color": () => __privateMethod(this, _ColoroutineAIStudio_instances, setActiveObjectColor_fn).call(this, target.dataset.value),
      "remove-bg": () => __privateMethod(this, _ColoroutineAIStudio_instances, removeSelectedBackground_fn).call(this, target),
      "undo": () => this.editor.undo(),
      "redo": () => this.editor.redo(),
      "duplicate": () => this.editor.duplicate(),
      "remove": () => this.editor.remove(),
      "center": () => this.editor.center(),
      "fit": () => this.editor.fit(),
      "clear-design": () => __privateMethod(this, _ColoroutineAIStudio_instances, clearDesign_fn).call(this),
      "zoom-in": () => __privateMethod(this, _ColoroutineAIStudio_instances, setZoom_fn).call(this, this.state.zoom + 10),
      "zoom-out": () => __privateMethod(this, _ColoroutineAIStudio_instances, setZoom_fn).call(this, this.state.zoom - 10),
      "quantity-down": () => __privateMethod(this, _ColoroutineAIStudio_instances, setQuantity_fn).call(this, this.store.current.quantity - 1),
      "quantity-up": () => __privateMethod(this, _ColoroutineAIStudio_instances, setQuantity_fn).call(this, this.store.current.quantity + 1),
      "add-cart": () => __privateMethod(this, _ColoroutineAIStudio_instances, addToCart_fn).call(this, target),
      "download": () => __privateMethod(this, _ColoroutineAIStudio_instances, download_fn).call(this),
      "export-proof": () => __privateMethod(this, _ColoroutineAIStudio_instances, exportProofPackage_fn).call(this, target),
      "request-proof": () => __privateMethod(this, _ColoroutineAIStudio_instances, requestProof_fn).call(this, target),
      "export-project": () => __privateMethod(this, _ColoroutineAIStudio_instances, exportProject_fn).call(this),
      "focus-layers": () => __privateMethod(this, _ColoroutineAIStudio_instances, focusLayers_fn).call(this),
      "focus-preflight": () => __privateMethod(this, _ColoroutineAIStudio_instances, focusPreflight_fn).call(this),
      "toggle-debug-mapping": () => __privateMethod(this, _ColoroutineAIStudio_instances, toggleDebugMapping_fn).call(this),
      "focus-product": () => __privateMethod(this, _ColoroutineAIStudio_instances, focusWorkflowTarget_fn).call(this, "#product-select", "inspector"),
      "focus-create": () => __privateMethod(this, _ColoroutineAIStudio_instances, focusWorkflowTarget_fn).call(this, ".creative-panel"),
      "focus-order": () => __privateMethod(this, _ColoroutineAIStudio_instances, focusWorkflowTarget_fn).call(this, ".order-summary", "inspector"),
      "create-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, openShare_fn).call(this),
      "close-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, closeShare_fn).call(this),
      "publish-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, publishShare_fn).call(this, target),
      "download-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, downloadShare_fn).call(this),
      "copy-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, copyShare_fn).call(this),
      "native-share": () => __privateMethod(this, _ColoroutineAIStudio_instances, nativeShare_fn).call(this)
    };
    if (actions[target.dataset.action]) await actions[target.dataset.action]();
  };
  onChange_fn = function(event) {
    if (event.target.id === "studio-locale") {
      __privateMethod(this, _ColoroutineAIStudio_instances, setLocale_fn).call(this, event.target.value);
      return;
    }
    if (event.target.id === "file-input" && event.target.files[0]) __privateMethod(this, _ColoroutineAIStudio_instances, addUploadedFile_fn).call(this, event.target.files[0]);
    if (event.target.id === "reference-input" && event.target.files[0]) __privateMethod(this, _ColoroutineAIStudio_instances, setReference_fn).call(this, event.target.files[0]);
    if (event.target.id === "product-select") __privateMethod(this, _ColoroutineAIStudio_instances, setProduct_fn).call(this, event.target.value);
    if (event.target.id === "project-select") __privateMethod(this, _ColoroutineAIStudio_instances, selectProject_fn).call(this, event.target.value);
    if (event.target.id === "text-fill-hex") __privateMethod(this, _ColoroutineAIStudio_instances, setTextHexColor_fn).call(this, "fill", event.target.value, true);
    if (event.target.id === "text-stroke-hex") __privateMethod(this, _ColoroutineAIStudio_instances, setTextHexColor_fn).call(this, "stroke", event.target.value, true);
  };
  onInput_fn = function(event) {
    if (event.target.id === "prompt") {
      this.state.prompt = event.target.value;
      const count = this.shadowRoot.querySelector("#prompt-count");
      if (count) count.textContent = `${event.target.value.length} / 600`;
    }
    if (event.target.id === "include-background") this.state.includeBackground = event.target.checked;
    if (event.target.id === "active-color") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveObjectColor_fn).call(this, event.target.value);
    if (event.target.id === "text-content") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { text: event.target.value });
    if (event.target.id === "text-fill") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { fill: event.target.value });
    if (event.target.id === "text-stroke") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { stroke: event.target.value });
    if (event.target.id === "text-fill-hex") __privateMethod(this, _ColoroutineAIStudio_instances, setTextHexColor_fn).call(this, "fill", event.target.value, false);
    if (event.target.id === "text-stroke-hex") __privateMethod(this, _ColoroutineAIStudio_instances, setTextHexColor_fn).call(this, "stroke", event.target.value, false);
    if (event.target.id === "text-size") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { fontSize: event.target.value });
    if (event.target.id === "text-spacing") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { charSpacing: event.target.value });
    if (event.target.id === "text-line-height") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { lineHeight: event.target.value });
    if (event.target.id === "text-stroke-width") __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { strokeWidth: event.target.value });
  };
  modeNav_fn = function() {
    return MODES.map(([id, iconName, title, subtitle], index) => `<button class="nav-item ${this.state.mode === id ? "active" : ""}" data-mode="${id}"><span class="nav-index">0${index + 1}</span><span class="nav-copy"><strong>${title}</strong><small>${subtitle}</small></span></button>`).join("");
  };
  modeLabel_fn = function() {
    return MODES.find(([id]) => id === this.state.mode)?.[2] || "创作";
  };
  creativeTitle_fn = function() {
    const names = {
      upload: `${icon("upload", 16)} 上传你的设计`,
      generate: `${icon("sparkles", 16)} AI 创作指令`,
      reference: `${icon("image", 16)} 参考图生图`,
      inspire: `${icon("bulb", 16)} 今日灵感策展`,
      edit: `${icon("type", 16)} 文字与基础图形`
    };
    return names[this.state.mode];
  };
  creativeBody_fn = function() {
    if (this.state.mode === "upload") return `<label class="upload-zone" for="file-input">${icon("upload", 24)}<div><strong>点击上传或拖入设计文件</strong><span>支持 PNG、JPG、WEBP · 最大 20 MB · 推荐透明 PNG</span></div></label>`;
    if (this.state.mode === "generate") return `
      <div class="prompt-row"><div><div class="prompt-wrap"><textarea id="prompt" maxlength="600" placeholder="例如：一只穿宇航服的复古柯基，粗颗粒丝网印刷，奶油白与珊瑚红配色，透明背景…">${escapeHTML(this.state.prompt || "")}</textarea><div class="prompt-meta"><span>描述主体、风格、色彩与构图</span><span id="prompt-count">${(this.state.prompt || "").length} / 600</span></div></div><label class="background-toggle"><input id="include-background" type="checkbox" ${this.state.includeBackground ? "checked" : ""} /><span><strong>生成有背景的设计</strong><small>默认透明背景，更适合直接印在产品上</small></span></label><div class="quick-styles">${STYLES.map((style) => `<button class="style-chip" data-style="${style}">${style}</button>`).join("")}</div></div><button class="button button-primary" data-action="generate"><span class="button-label">${icon("sparkles", 16)} 生成 4 个方案</span></button></div>
      ${__privateMethod(this, _ColoroutineAIStudio_instances, resultsHTML_fn).call(this)}`;
    if (this.state.mode === "reference") return `
      <div class="reference-grid"><label class="upload-zone" for="reference-input">${this.state.reference ? `<img class="reference-thumb" src="${this.state.reference.dataUrl}" alt="参考图片" />` : `${icon("image", 22)}<div><strong>添加参考图</strong><span>用于风格与构图参考</span></div>`}</label><div><div class="prompt-wrap"><textarea id="prompt" maxlength="600" placeholder="说明要保留和改变的内容，例如：保留角色姿势，改成复古旅行海报风格…">${escapeHTML(this.state.prompt || "")}</textarea><div class="prompt-meta"><span>不会覆盖原参考图</span><span id="prompt-count">${(this.state.prompt || "").length} / 600</span></div></div><label class="background-toggle"><input id="include-background" type="checkbox" ${this.state.includeBackground ? "checked" : ""} /><span><strong>生成有背景的设计</strong><small>默认透明背景，仅保留主体印花</small></span></label><button class="button button-primary" style="margin-top:10px" data-action="generate-reference"><span class="button-label">${icon("sparkles", 16)} 生成参考方案</span></button></div></div>${__privateMethod(this, _ColoroutineAIStudio_instances, resultsHTML_fn).call(this)}`;
    if (this.state.mode === "inspire") {
      const productName = translateStudioText(this.product.shortName, this.locale);
      const curatedFor = this.locale === "zh-CN" ? `为 ${productName} 精选` : `Curated for ${productName}`;
      return `<div class="section-eyebrow"><span>${curatedFor}</span><button class="button button-ghost" data-action="refresh-inspiration">${icon("refresh", 13)} 换一组</button></div><div class="inspiration-grid inspiration-grid-rich">${this.state.inspirations.length ? this.state.inspirations.map((item, index) => `<button class="inspiration-card inspiration-card-rich" data-inspiration="${index}"><img src="${item.url}" alt="${escapeHTML(item.label)}" /><span class="inspiration-copy"><strong>${escapeHTML(item.label || `灵感 ${index + 1}`)}</strong><small>${escapeHTML(item.reason || item.prompt || "点击后生成可编辑方案")}</small></span></button>`).join("") : '<span class="creative-empty">正在获取灵感…</span>'}</div>`;
    }
    return `<div class="brand-type-sample"><span>Coloroutine Flow</span><small>圆润流线 · 厚描边 · 适合印花</small></div><div class="editor-add-row text-add-row"><input class="text-field" id="text-value" value="COLOROUTINE" maxlength="80" aria-label="文字内容" /><button class="button button-primary" data-action="add-brand-text">${icon("sparkles", 15)} 添加 Coloroutine Flow 艺术字</button><button class="button button-secondary" data-action="add-text">${icon("type", 15)} 添加普通文字</button><button class="button button-secondary" data-action="add-shape">${icon("plus", 15)} 添加色块</button></div><p class="fine-print">添加后选中文字图层，即可在右侧调整字体、字号、字距、描边和对齐；2D 与 3D 预览会同步更新。</p>`;
  };
  resultsHTML_fn = function() {
    if (!this.state.generated.length) return "";
    return `<div class="results-grid" style="margin-top:13px">${this.state.generated.map((item, index) => {
      const score = Number(item.quality?.score || 0);
      const quality = score ? ` · ${score}` : "";
      return `<button class="result-card" data-result="${index}"><img src="${item.url}" alt="AI 生成方案 ${index + 1}" /><span>应用方案 ${index + 1}${quality}</span></button>`;
    }).join("")}</div>`;
  };
  inspectorHTML_fn = function() {
    const project = this.store.current;
    const quality = this.state.quality;
    return `
      <section class="inspector-card">
        <div class="inspector-title"><strong>${icon("shirt", 16)} 商品与印刷面</strong><button class="icon-button mobile-inspector" data-action="toggle-inspector" aria-label="关闭商品设置">${icon("close", 14)}</button></div>
        <div class="inspector-body">
          <div class="field"><div class="field-label"><span>商品</span><strong>${this.product.category}</strong></div><select class="select" id="product-select">${this.products.map((product) => `<option value="${product.id}" ${product.id === this.product.id ? "selected" : ""}>${product.name}</option>`).join("")}</select></div>
          <div class="field"><div class="field-label"><span>颜色</span><strong>${this.color[2]}</strong></div><div class="swatches">${this.product.colors.map(([id, hex, name]) => `<button class="swatch ${id === this.color[0] ? "active" : ""}" style="--swatch:${hex}" data-color="${id}" aria-label="${name}" title="${name}"></button>`).join("")}</div></div>
          <div class="field"><div class="field-label"><span>尺码 / 型号</span><strong>${escapeHTML(project.size)}</strong></div><div class="options">${this.product.sizes.map((size) => `<button class="option ${size === project.size ? "active" : ""}" data-size="${escapeHTML(size)}">${escapeHTML(size)}</button>`).join("")}</div></div>
          <div class="field"><div class="field-label"><span>定制面</span><strong>${FACE_LABELS[project.face]}</strong></div><div class="options">${this.product.faces.map((face) => `<button class="option ${face === project.face ? "active" : ""}" data-face="${face}">${FACE_LABELS[face]}</button>`).join("")}</div></div>
        </div>
      </section>
      <section class="inspector-card" id="quality-card"><div class="inspector-title"><strong>${icon("check", 16)} 印刷质量检查</strong></div><div class="inspector-body"><div class="quality-panel"><div class="quality-score ${quality.level}" id="quality-score">${quality.dpi ? quality.dpi : "—"}</div><div class="quality-copy"><strong id="quality-label">${quality.label}</strong><span id="quality-detail">${quality.dpi ? `有效分辨率约 ${quality.dpi} DPI` : `目标文件 ${this.product.target.width} × ${this.product.target.height} px`}</span></div></div></div></section>
      <section class="inspector-card preflight-card" id="preflight-card">${__privateMethod(this, _ColoroutineAIStudio_instances, preflightHTML_fn).call(this)}</section>
      <section class="inspector-card high-ticket-card" id="high-ticket-card">${__privateMethod(this, _ColoroutineAIStudio_instances, highTicketHTML_fn).call(this)}</section>
      <section class="inspector-card edit-tools-card" id="edit-tools-card">${__privateMethod(this, _ColoroutineAIStudio_instances, prominentEditToolsHTML_fn).call(this)}</section>
      <section class="inspector-card" id="layers-card"><div class="inspector-title"><strong>${icon("layers", 16)} 图层</strong><span style="color:var(--muted);font-size:9px" id="layer-count">${this.state.layers.length} 个</span></div><div class="inspector-body"><div class="layers" id="layers-list">${__privateMethod(this, _ColoroutineAIStudio_instances, layersHTML_fn).call(this)}</div></div></section>
      <section class="inspector-card">
        <div class="inspector-body"><div class="field"><div class="field-label"><span>数量</span><strong>同一设计</strong></div><div class="stepper"><button data-action="quantity-down">${icon("minus", 13)}</button><output id="quantity">${project.quantity}</output><button data-action="quantity-up">${icon("plus", 13)}</button></div></div></div>
        <div class="order-summary"><div class="price-row"><span>商品小计</span><strong id="price">${formatMoney(this.product.price * project.quantity)}</strong></div><button class="button button-primary button-wide" data-action="add-cart">${icon("cart", 17)} <span class="button-label">确认设计并加入购物车</span></button><div class="fine-print">设计将生成不可变版本并与订单行项目绑定。税费与运费在结账时计算。</div></div>
      </section>`;
  };
  layersHTML_fn = function() {
    if (!this.state.layers.length) return '<div class="empty-layers">添加图片、文字或图形后将在这里显示</div>';
    return this.state.layers.map((layer, index) => `<div class="layer ${layer.selected ? "selected" : ""}" data-layer-index="${index}"><span class="layer-type">${layer.type === "text" ? "T" : icon(layer.type === "shape" ? "center" : "image", 13)}</span><span class="layer-name">${escapeHTML(layer.name)}</span><button data-layer-action="visible" data-layer-index="${index}" aria-label="切换可见">${icon("eye", 13)}</button><button data-layer-action="locked" data-layer-index="${index}" aria-label="切换锁定">${icon(layer.locked ? "lock" : "unlock", 13)}</button></div>`).join("");
  };
  prominentEditToolsHTML_fn = function() {
    const activeKind = this.state.activeKind;
    const canColor = ["text", "textbox", "shape", "rect"].includes(activeKind);
    const canRemoveBackground = activeKind === "image";
    const swatches = ["#121212", "#ffffff", "#b84a3a", "#7aa6ff", "#f4d9a8", "#30463c"];
    return `<div class="inspector-title edit-tools-title"><strong>${icon("settings", 16)} 取色器 / 一键抠图</strong><span class="edit-tools-state">${activeKind ? "已选中图层" : "先选中图层"}</span></div>
      <div class="inspector-body edit-tools">
        <div class="edit-tool-hero">
          <span class="edit-tool-hero-icon">${icon("sparkles", 18)}</span>
          <div><strong>选中画布上的图片、文字或色块后使用</strong><small>取色改颜色，抠图去白底，修改会同步到 2D 和 3D 预览。</small></div>
        </div>
        ${__privateMethod(this, _ColoroutineAIStudio_instances, textToolsHTML_fn).call(this)}
        <div class="tool-block tool-block-featured ${canColor ? "" : "disabled"}">
          <div class="field-label"><span>取色器</span><strong>${canColor ? "文字 / 色块可编辑" : "请选择文字或色块"}</strong></div>
          <label class="color-picker-cta ${canColor ? "" : "disabled"}" for="active-color">
            <input id="active-color" type="color" value="${escapeHTML(this.state.activeColor || "#121212")}" ${canColor ? "" : "disabled"} />
            <span class="color-picker-preview" style="--picked:${escapeHTML(this.state.activeColor || "#121212")}"></span>
            <span><strong>点击选择颜色</strong><small>快速调整文字、色块和基础图形</small></span>
          </label>
          <div class="color-tool-row prominent-swatches">${swatches.map((color) => `<button class="mini-swatch" style="--swatch:${color}" data-action="set-active-color" data-value="${color}" aria-label="设置颜色 ${color}" ${canColor ? "" : "disabled"}></button>`).join("")}</div>
        </div>
        <div class="tool-block tool-block-featured ${canRemoveBackground ? "" : "disabled"}">
          <div class="field-label"><span>图片抠图</span><strong>${canRemoveBackground ? "当前图片可处理" : "请选择图片图层"}</strong></div>
          <button class="button button-primary button-wide remove-bg-cta" data-action="remove-bg" ${canRemoveBackground ? "" : "disabled"}>${icon("sparkles", 16)} <span class="button-label">一键去白底 / 去近似背景</span></button>
          <p class="fine-print">适合 Logo、贴纸图、AI 图残留白底；复杂照片建议保留背景或重新生成透明版本。</p>
        </div>
      </div>`;
  };
  textToolsHTML_fn = function() {
    const active = this.state.activeText;
    const selectedPreset = active?.fontPreset || "";
    const disabled = active ? "" : "disabled";
    const fill = active?.fill || "#17181c";
    const stroke = active?.stroke || "#ffffff";
    const selectedEffect = active?.textEffect || (Number(active?.strokeWidth) > 0 || active?.shadow ? "print-outline" : "none");
    return `<div class="tool-block tool-block-featured text-tool-block ${active ? "" : "disabled"}">
          <div class="field-label"><span>文字设计</span><strong>${active ? "正在编辑文字图层" : "请选择或添加文字"}</strong></div>
          <textarea class="text-editor-input" id="text-content" maxlength="120" ${disabled} aria-label="编辑文字内容">${escapeHTML(active?.text || "")}</textarea>
          <div class="font-preset-grid">${TEXT_PRESETS.map((preset) => `<button class="font-preset ${selectedPreset === preset.id ? "active" : ""}" data-action="set-text-preset" data-value="${preset.id}" ${disabled}><span style="font-family:${escapeHTML(preset.style.fontFamily)}">${escapeHTML(preset.preview)}</span><strong>${escapeHTML(preset.label)}</strong><small>${escapeHTML(preset.note)}</small></button>`).join("")}</div>
          <div class="text-effect-grid">${TEXT_EFFECTS.map((effect) => `<button class="text-effect ${selectedEffect === effect.id ? "active" : ""}" data-action="set-text-effect" data-value="${effect.id}" ${disabled}><span>${escapeHTML(effect.label)}</span><small>${escapeHTML(effect.note)}</small></button>`).join("")}</div>
          <div class="text-control-grid">
            <label class="hex-color-field"><span>填充 HEX</span><input id="text-fill" type="color" value="${escapeHTML(fill)}" ${disabled}><input id="text-fill-hex" type="text" value="${escapeHTML(fill)}" maxlength="7" placeholder="#C84F3D" ${disabled}></label>
            <label class="hex-color-field"><span>描边 HEX</span><input id="text-stroke" type="color" value="${escapeHTML(stroke)}" ${disabled}><input id="text-stroke-hex" type="text" value="${escapeHTML(stroke)}" maxlength="7" placeholder="#FFF1DC" ${disabled}></label>
            <label><span>字号 <b>${active?.fontSize || 64}</b></span><input id="text-size" type="range" min="14" max="180" value="${active?.fontSize || 64}" ${disabled}></label>
            <label><span>字距 <b>${active?.charSpacing || 0}</b></span><input id="text-spacing" type="range" min="-80" max="280" value="${active?.charSpacing || 0}" ${disabled}></label>
            <label><span>行高 <b>${Number(active?.lineHeight || 1.08).toFixed(2)}</b></span><input id="text-line-height" type="range" min="0.75" max="2.4" step="0.01" value="${active?.lineHeight || 1.08}" ${disabled}></label>
            <label><span>描边粗细 <b>${active?.strokeWidth || 0}</b></span><input id="text-stroke-width" type="range" min="0" max="8" step="0.1" value="${active?.strokeWidth || 0}" ${disabled}></label>
          </div>
          <div class="text-align-row">${TEXT_ALIGNMENTS.map(([value, label]) => `<button class="option ${active?.textAlign === value ? "active" : ""}" data-action="set-text-align" data-value="${value}" ${disabled}>${label}</button>`).join("")}</div>
          <p class="fine-print">Coloroutine Flow 使用更厚的圆角描边和柔和投影，即使外部字体未加载，也会明显呈现印花艺术字效果。</p>
        </div>`;
  };
  editToolsHTML_fn = function() {
    const activeKind = this.state.activeKind;
    const canColor = ["text", "textbox", "shape", "rect"].includes(activeKind);
    const canRemoveBackground = activeKind === "image";
    const swatches = ["#121212", "#ffffff", "#b84a3a", "#7aa6ff", "#f4d9a8", "#30463c"];
    return `<div class="inspector-title"><strong>${icon("settings", 16)} 快速修图</strong><span style="color:var(--muted);font-size:9px">${activeKind ? "已选中图层" : "未选中图层"}</span></div>
      <div class="inspector-body edit-tools">
        <div class="tool-block ${canColor ? "" : "disabled"}">
          <div class="field-label"><span>图层颜色</span><strong>${canColor ? "文字 / 色块" : "请选择文字或色块"}</strong></div>
          <div class="color-tool-row"><input id="active-color" type="color" value="${escapeHTML(this.state.activeColor || "#121212")}" ${canColor ? "" : "disabled"} />${swatches.map((color) => `<button class="mini-swatch" style="--swatch:${color}" data-action="set-active-color" data-value="${color}" aria-label="设置颜色 ${color}" ${canColor ? "" : "disabled"}></button>`).join("")}</div>
          <p class="fine-print">用于快速调整文字和基础图形颜色，适合匹配商品或品牌色。</p>
        </div>
        <div class="tool-block ${canRemoveBackground ? "" : "disabled"}">
          <div class="field-label"><span>图片抠图</span><strong>${canRemoveBackground ? "一键去背景" : "请选择图片图层"}</strong></div>
          <button class="button button-secondary button-wide" data-action="remove-bg" ${canRemoveBackground ? "" : "disabled"}>${icon("sparkles", 15)} 去除白底 / 近似背景</button>
          <p class="fine-print">适合 Logo、贴纸图、AI 图中残留白底；复杂照片建议保留背景或重新生成透明版本。</p>
        </div>
      </div>`;
  };
  shareModalHTML_fn = function() {
    return `<div class="share-modal" id="share-modal" role="dialog" aria-modal="true" aria-label="生成品牌分享图">
      <div class="share-dialog">
        <div class="share-head"><div><span class="kicker">COLOR WITH LOVE</span><h2>生成 Coloroutine 品牌预览</h2><p>把当前商品效果制作成可下载、可转发的品牌图片。</p></div><button class="icon-button" data-action="close-share" aria-label="关闭分享图">${icon("close", 17)}</button></div>
        <div class="share-layout">
          <div class="share-controls">
            <div class="field"><div class="field-label"><span>商品视图</span><strong id="share-view-label">2D 商品底图</strong></div><div class="share-view-options"><button class="share-view active" data-share-view="2d">${icon("monitor", 15)}<span>2D<small>高清底图</small></span></button><button class="share-view" data-share-view="3d">${icon("cube", 15)}<span>3D<small>当前模型角度</small></span></button></div></div>
            <div class="field"><div class="field-label"><span>画面比例</span><strong id="share-format-label">方形动态</strong></div><div class="share-format-options"><button class="share-format active" data-share-format="square">1:1<br><small>社交动态</small></button><button class="share-format" data-share-format="story">9:16<br><small>Story</small></button><button class="share-format" data-share-format="landscape">16:10<br><small>提案预览</small></button></div></div>
            <div class="share-feature">${icon("sparkles", 17)}<div><strong>自动品牌化</strong><span>Coloroutine 标识、商品名称、设计项目和官网入口会自动排版。</span></div></div>
            <div class="share-feature">${icon("eye", 17)}<div><strong>2D / 3D 所见即所得</strong><span>可使用高清商品底图，或捕捉当前带 UV 印花的 3D 模型角度。</span></div></div>
            <button class="button button-primary button-wide" data-action="publish-share"><span class="button-label">${icon("external", 16)} 生成公开预览链接</span></button>
            <div class="share-link-box" id="share-link-box"><input id="share-link" readonly aria-label="分享链接"><button class="button button-secondary" data-action="copy-share">复制</button></div>
            <div class="share-actions"><button class="button button-secondary" data-action="download-share">${icon("download", 15)} 下载 PNG</button><button class="button button-ghost" data-action="native-share">${icon("external", 15)} 系统分享</button></div>
            <p class="fine-print">公开链接只包含生成后的品牌预览图，不公开可编辑画布或原始上传文件。</p>
          </div>
          <div class="share-preview-wrap"><div class="share-preview-loading" id="share-preview-loading">正在合成品牌预览…</div><img id="share-preview" alt="Coloroutine 品牌化商品预览"></div>
        </div>
      </div>
    </div>`;
  };
  projectOptions_fn = function() {
    return this.store.list().map((project) => `<option value="${project.id}" ${project.id === this.store.current.id ? "selected" : ""}>${escapeHTML(project.name)}</option>`).join("");
  };
  workbenchHTML_fn = function() {
    const checks = __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this);
    const hasDesign = this.state.layers.length > 0;
    const steps = [
      ["01", "Inspire", this.state.mode === "inspire" || this.state.mode === "generate", "AI ideas, prompts, styles"],
      ["02", "Design", hasDesign, "2D canvas, text, upload, cutout"],
      ["03", "Preview", this.state.previewed3d, "2D to 3D mapped product view"],
      ["04", "Preflight", checks.ready, "DPI, print area, cart readiness"]
    ];
    return steps.map(([num, title, done, note]) => `<button class="workbench-step ${done ? "done" : ""}" data-action="${title === "Preflight" ? "focus-preflight" : title === "Preview" ? "" : "focus-create"}" ${title === "Preview" ? 'data-view="3d"' : ""}><span>${num}</span><strong>${title}</strong><small>${note}</small></button>`).join("");
  };
  preflightChecks_fn = function() {
    const quality = this.state.quality || {};
    const area2 = productPrintArea(this.product, this.store.current.face);
    const mappingOk = mappingError(this.product, area2) < 2e-3;
    const hasDesign = this.state.layers.length > 0;
    const qualityOk = ["great", "ok"].includes(quality.level);
    const previewOk = this.state.previewed3d;
    const finalized = Boolean(this.store.current.finalizedAt || this.store.current.designId);
    const items = [
      { id: "design", ok: hasDesign, label: "Design exists", detail: hasDesign ? `${this.state.layers.length} layer(s) on canvas` : "Add AI art, upload, text, or shape first" },
      { id: "quality", ok: qualityOk, warn: quality.level === "empty", label: "Print quality", detail: quality.dpi ? `${quality.dpi} DPI estimated` : "Target canvas is ready for print art" },
      { id: "mapping", ok: mappingOk, label: "2D -> 3D mapping", detail: mappingOk ? `${this.product.physical.widthIn} x ${this.product.physical.heightIn} in calibrated` : "Print area ratio needs calibration" },
      { id: "preview", ok: previewOk, label: "3D preview checked", detail: previewOk ? "Current design has been previewed in 3D" : "Open 3D once before checkout" },
      { id: "cart", ok: finalized, warn: !finalized && hasDesign, label: "Order proof", detail: finalized ? `Design ${this.store.current.designId || ""} bound` : "Cart binding happens when you add to cart" }
    ];
    const blockers = items.filter((item) => !item.ok && !item.warn).length;
    return { items, ready: hasDesign && qualityOk && mappingOk && previewOk, blockers };
  };
  preflightHTML_fn = function() {
    const checks = __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this);
    const status = checks.ready ? "ready" : checks.blockers ? "blocked" : "review";
    const title = checks.ready ? "Production ready" : checks.blockers ? "Needs attention" : "Review before order";
    return `<div class="inspector-title"><strong>${icon("check", 16)} Design Check</strong><span class="preflight-status ${status}">${title}</span></div>
      <div class="inspector-body">
        <div class="preflight-summary">
          <b>${checks.ready ? "Ready to add to cart" : `${checks.blockers} blocker(s) before checkout`}</b>
          <span>Inspired by packaging preflight: confirm design, print quality, mapping, 3D preview, and order proof.</span>
        </div>
        <div class="preflight-list">
          ${checks.items.map((item) => `<div class="preflight-item ${item.ok ? "ok" : item.warn ? "warn" : "bad"}"><i>${item.ok ? icon("check", 13) : icon("warning", 13)}</i><span><strong>${item.label}</strong><small>${item.detail}</small></span></div>`).join("")}
        </div>
        <div class="preflight-actions">
          <button class="button button-secondary" data-view="3d">${icon("cube", 15)} Check 3D</button>
          <button class="button button-ghost" data-action="toggle-debug-mapping">${icon("settings", 15)} Mapping debug</button>
          <button class="button button-ghost" data-action="export-project">${icon("save", 15)} Save JSON</button>
        </div>
      </div>`;
  };
  highTicketHTML_fn = function() {
    const checks = __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this);
    const project = this.store.current;
    const proofId = this.state.proofId || project.proofId || "Not exported yet";
    const status = checks.ready ? "Proof-ready" : checks.blockers ? "Needs review" : "Draft proof";
    return `<div class="inspector-title"><strong>${icon("external", 16)} Professional Proof</strong><span class="preflight-status ${checks.ready ? "ready" : checks.blockers ? "blocked" : "review"}">${status}</span></div>
      <div class="inspector-body high-ticket-body">
        <div class="proof-summary">
          <b>${escapeHTML(proofId)}</b>
          <span>${escapeHTML(this.product.shortName)} · ${escapeHTML(this.color[2])} · ${escapeHTML(project.size)} · ${escapeHTML(FACE_LABELS[project.face])}</span>
        </div>
        <div class="proof-grid">
          <span><strong>Use case</strong><small>artist drop / brand merch / team order</small></span>
          <span><strong>Handoff</strong><small>PNG preview + production JSON</small></span>
          <span><strong>Approval</strong><small>share proof before checkout or bulk quote</small></span>
        </div>
        <div class="preflight-actions">
          <button class="button button-primary" data-action="export-proof">${icon("download", 15)} <span class="button-label">Export proof pack</span></button>
          <button class="button button-secondary" data-action="request-proof">${icon("external", 15)} Request proof / quote</button>
        </div>
        <p class="fine-print">For high-ticket customers: proof files include design id, product specs, quality check, print area, and selected product side for review.</p>
      </div>`;
  };
  updatePreflight_fn = function() {
    const card = this.shadowRoot.querySelector("#preflight-card");
    if (card) card.innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, preflightHTML_fn).call(this);
    const highTicket = this.shadowRoot.querySelector("#high-ticket-card");
    if (highTicket) highTicket.innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, highTicketHTML_fn).call(this);
    const steps = this.shadowRoot.querySelector(".workbench-steps");
    if (steps) steps.innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, workbenchHTML_fn).call(this);
  };
  setMode_fn = function(mode) {
    this.state.mode = mode;
    this.shadowRoot.querySelectorAll("[data-mode]").forEach((button) => button.classList.toggle("active", button.dataset.mode === mode));
    this.shadowRoot.querySelector("#mode-badge").textContent = __privateMethod(this, _ColoroutineAIStudio_instances, modeLabel_fn).call(this);
    this.shadowRoot.querySelector("#creative-title").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, creativeTitle_fn).call(this);
    this.shadowRoot.querySelector("#creative-body").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, creativeBody_fn).call(this);
    if (mode === "inspire" && !this.state.inspirations.length) __privateMethod(this, _ColoroutineAIStudio_instances, loadInspirations_fn).call(this);
  };
  setProduct_fn = async function(id) {
    if (id === this.product.id) return;
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    const previousJSON = this.editor.serialize();
    this.product = this.products.find((product) => product.id === id) || this.products[0];
    this.state.previewed3d = false;
    this.color = this.product.colors[0];
    const size = this.product.sizes.includes(this.store.current.size) ? this.store.current.size : this.product.sizes[Math.min(2, this.product.sizes.length - 1)];
    const face = this.product.faces[0];
    this.store.invalidateFinalized();
    this.store.update({ productId: id, colorId: this.color[0], size, face });
    this.editor.setProduct(this.product);
    const scene = this.store.getScene(__privateMethod(this, _ColoroutineAIStudio_instances, sceneKey_fn).call(this));
    await this.editor.load(scene?.canvasJSON || previousJSON);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
    this.shadowRoot.querySelector("#top-product").textContent = this.product.shortName;
    this.shadowRoot.querySelector("#product-kicker").textContent = `DESIGN TO PRODUCT · ${this.product.category}`;
    if (this.state.view === "3d") __privateMethod(this, _ColoroutineAIStudio_instances, refresh3D_fn).call(this);
    if (this.state.mode === "inspire") __privateMethod(this, _ColoroutineAIStudio_instances, loadInspirations_fn).call(this, true);
  };
  setColor_fn = function(id) {
    this.color = getProductColor(this.product, id);
    this.state.previewed3d = false;
    this.store.invalidateFinalized();
    this.store.update({ colorId: id });
    __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
    if (this.state.view === "3d") __privateMethod(this, _ColoroutineAIStudio_instances, refresh3D_fn).call(this);
  };
  setSize_fn = function(size) {
    this.store.invalidateFinalized();
    this.store.update({ size });
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
  };
  setFace_fn = async function(face) {
    if (face === this.store.current.face) return;
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    this.state.previewed3d = false;
    this.store.invalidateFinalized();
    this.store.update({ face });
    const scene = this.store.getScene(__privateMethod(this, _ColoroutineAIStudio_instances, sceneKey_fn).call(this));
    await this.editor.load(scene?.canvasJSON || { objects: [] });
    __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
    if (this.state.view === "3d") await __privateMethod(this, _ColoroutineAIStudio_instances, refresh3D_fn).call(this);
  };
  setView_fn = async function(view) {
    this.state.view = view;
    this.shadowRoot.querySelectorAll("[data-view]").forEach((button) => button.classList.toggle("active", button.dataset.view === view));
    this.shadowRoot.querySelector("#product-stage").style.display = view === "2d" ? "grid" : "none";
    this.shadowRoot.querySelector("#three-stage").classList.toggle("active", view === "3d");
    __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
    if (view === "3d") await __privateMethod(this, _ColoroutineAIStudio_instances, refresh3D_fn).call(this);
  };
  refresh3D_fn = async function() {
    const container = this.shadowRoot.querySelector("#three-stage");
    if (!this.preview3d) this.preview3d = new Product3DPreview(container);
    try {
      await this.preview3d.setProduct(this.product, this.color, await __privateMethod(this, _ColoroutineAIStudio_instances, designSnapshotCanvas_fn).call(this), this.store.current.face);
      this.state.previewed3d = true;
      __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
    } catch (error) {
      this.state.previewed3d = false;
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `3D 模型加载失败：${error.message}`, "error");
      __privateMethod(this, _ColoroutineAIStudio_instances, setView_fn).call(this, "2d");
      throw error;
    }
  };
  updateProductStage_fn = function() {
    this.shadowRoot.querySelector("#product-art").innerHTML = productSvg(this.product, this.color, this.store.current.face);
    __privateMethod(this, _ColoroutineAIStudio_instances, updatePrintArea_fn).call(this);
  };
  updatePrintArea_fn = function() {
    const area2 = productPrintArea(this.product, this.store.current.face);
    const element = this.shadowRoot.querySelector("#print-area");
    if (!element) return;
    element.style.setProperty("--pa-l", `${area2.left}%`);
    element.style.setProperty("--pa-t", `${area2.top}%`);
    element.style.setProperty("--pa-w", `${area2.width}%`);
    element.style.setProperty("--pa-h", `${area2.height}%`);
    const stage = this.shadowRoot.querySelector("#product-stage");
    if (stage) stage.style.aspectRatio = String(this.product.previewAspect || 360 / 540);
    const mapping = this.shadowRoot.querySelector("#stage-mapping");
    if (mapping) {
      const calibrated = mappingError(this.product, area2) < 2e-3;
      mapping.classList.toggle("mapping-error", !calibrated);
      mapping.textContent = calibrated ? `2D ↔ 3D 已校准 · ${this.product.physical.widthIn} × ${this.product.physical.heightIn} in` : "2D / 3D 印刷比例待校准";
    }
  };
  refreshInspector_fn = function() {
    this.shadowRoot.querySelector("#inspector").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, inspectorHTML_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateQuality_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, syncProductContext_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
  };
  renderLayers_fn = function() {
    const list = this.shadowRoot.querySelector("#layers-list");
    if (list) list.innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, layersHTML_fn).call(this);
    const count = this.shadowRoot.querySelector("#layer-count");
    if (count) count.textContent = `${this.state.layers.length} 个`;
  };
  renderEditTools_fn = function() {
    const card = this.shadowRoot.querySelector("#edit-tools-card");
    if (card) card.innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, prominentEditToolsHTML_fn).call(this);
  };
  updateQuality_fn = function() {
    const quality = this.state.quality;
    const pill = this.shadowRoot.querySelector("#stage-quality");
    if (pill) {
      pill.className = `quality-pill ${quality.level}`;
      pill.textContent = quality.dpi ? `${quality.label} · ${quality.dpi} DPI` : quality.label;
    }
    const score = this.shadowRoot.querySelector("#quality-score");
    if (score) {
      score.className = `quality-score ${quality.level}`;
      score.textContent = quality.dpi || "—";
    }
    const label = this.shadowRoot.querySelector("#quality-label");
    const detail = this.shadowRoot.querySelector("#quality-detail");
    if (label) label.textContent = quality.label;
    if (detail) detail.textContent = quality.dpi ? `有效分辨率约 ${quality.dpi} DPI` : `目标文件 ${this.product.target.width} × ${this.product.target.height} px`;
  };
  generate_fn = async function(withReference) {
    const prompt = this.shadowRoot.querySelector("#prompt")?.value.trim();
    if (!prompt) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先描述你想创作的设计。", "error");
    if (withReference && !this.state.reference) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先添加一张参考图片。", "error");
    const button = this.shadowRoot.querySelector(`[data-action="${withReference ? "generate-reference" : "generate"}"]`);
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      const result = await this.api.generate({
        prompt,
        productId: this.product.id,
        style: "pod-print-premium",
        count: 4,
        includeBackground: this.state.includeBackground,
        garmentColor: this.color?.[1],
        garmentColorName: this.color?.[2],
        printSide: this.store.current.face,
        reference: withReference ? this.state.reference.dataUrl : void 0
      });
      this.state.generated = result.images || [];
      this.store.incrementGeneration();
      this.shadowRoot.querySelector("#generation-count").textContent = this.store.state.usage.generations;
      this.shadowRoot.querySelector("#creative-body").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, creativeBody_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, result.mock ? "已用本地创意引擎生成示例；配置 AI Provider 后可切换真实模型。" : "已生成 4 个设计方案。", "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, __privateMethod(this, _ColoroutineAIStudio_instances, friendlyError_fn).call(this, error, "AI 生成暂时没有响应，请稍后重试，或先上传图片/添加文字继续设计。"), "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
    }
  };
  loadInspirations_fn = async function(refresh = false) {
    if (this.state.inspirations.length && !refresh) return;
    try {
      const result = await this.api.inspirations({ productId: this.product.id, seed: refresh ? Date.now() : 1 });
      this.state.inspirations = result.items || [];
      if (this.state.mode === "inspire") this.shadowRoot.querySelector("#creative-body").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, creativeBody_fn).call(this);
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, __privateMethod(this, _ColoroutineAIStudio_instances, friendlyError_fn).call(this, error, "灵感服务暂时没有响应，可以先使用 AI 生成或添加文字开始设计。"), "error");
    }
  };
  setActiveObjectColor_fn = function(color) {
    if (!this.editor.setActiveColor(color)) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先选中文字或色块图层。", "error");
    this.state.activeColor = color;
    this.state.activeText = this.editor.getActiveTextStyle();
    __privateMethod(this, _ColoroutineAIStudio_instances, renderEditTools_fn).call(this);
  };
  addTextFromInput_fn = function(presetId = "noto-sans") {
    const value = this.shadowRoot.querySelector("#text-value")?.value.trim() || "COLOROUTINE";
    const preset = findTextPreset(presetId);
    this.editor.addText(value, preset.style);
    this.state.activeText = this.editor.getActiveTextStyle();
    this.state.activeKind = this.editor.getActiveKind();
    this.state.activeColor = this.editor.getActiveColor();
    __privateMethod(this, _ColoroutineAIStudio_instances, renderEditTools_fn).call(this);
  };
  applyTextPreset_fn = function(presetId) {
    const preset = findTextPreset(presetId);
    __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, preset.style);
  };
  applyTextEffect_fn = function(effectId) {
    const effect = findTextEffect(effectId);
    __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, effect.style);
  };
  setTextHexColor_fn = function(key, value, reportError = false) {
    const color = normalizeHexColor(value);
    if (!color) {
      if (reportError) __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请输入正确的 HEX 颜色，例如 #C84F3D。", "error");
      return;
    }
    __privateMethod(this, _ColoroutineAIStudio_instances, setActiveTextStyle_fn).call(this, { [key]: color });
  };
  setActiveTextStyle_fn = function(style) {
    if (!this.editor.setActiveTextStyle(style)) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先选中文字图层。", "error");
    this.state.activeText = this.editor.getActiveTextStyle();
    this.state.activeKind = this.editor.getActiveKind();
    this.state.activeColor = this.editor.getActiveColor();
    __privateMethod(this, _ColoroutineAIStudio_instances, renderEditTools_fn).call(this);
  };
  quickGenerateStart_fn = function() {
    __privateMethod(this, _ColoroutineAIStudio_instances, setMode_fn).call(this, "generate");
    requestAnimationFrame(() => {
      const prompt = this.shadowRoot.querySelector("#prompt");
      if (prompt && !prompt.value.trim()) {
        prompt.value = `为 ${this.product.shortName} 设计一个适合印花的透明背景图案：主体醒目、线条干净、色彩有品牌感、适合大众穿搭`;
        prompt.dispatchEvent(new Event("input", { bubbles: true }));
      }
      prompt?.focus();
      __privateMethod(this, _ColoroutineAIStudio_instances, focusWorkflowTarget_fn).call(this, ".creative-panel");
    });
  };
  quickUploadStart_fn = function() {
    __privateMethod(this, _ColoroutineAIStudio_instances, setMode_fn).call(this, "upload");
    requestAnimationFrame(() => {
      this.shadowRoot.querySelector("#file-input")?.click();
      __privateMethod(this, _ColoroutineAIStudio_instances, focusWorkflowTarget_fn).call(this, ".creative-panel");
    });
  };
  quickTextStart_fn = function() {
    __privateMethod(this, _ColoroutineAIStudio_instances, setMode_fn).call(this, "edit");
    requestAnimationFrame(() => {
      __privateMethod(this, _ColoroutineAIStudio_instances, addTextFromInput_fn).call(this, "coloroutine-bloom");
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "已添加 Coloroutine Ribbon 艺术字，可在右侧继续改颜色和特效。", "success");
    });
  };
  removeSelectedBackground_fn = async function(button) {
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      const ok = await this.editor.removeBackgroundFromActive({ tolerance: 34 });
      if (!ok) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先选中一个图片图层。", "error");
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "背景已去除，可继续在 2D / 3D 中预览。", "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, error.message || "抠图失败，请重新上传图片。", "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
      this.state.activeKind = this.editor.getActiveKind();
      this.state.activeColor = this.editor.getActiveColor();
      __privateMethod(this, _ColoroutineAIStudio_instances, renderEditTools_fn).call(this);
    }
  };
  useGenerated_fn = async function(index) {
    const item = this.state.generated[index];
    if (!item) return;
    try {
      const asset = await prepareGeneratedDesign(item);
      await this.editor.addImage(asset.dataUrl, { assetName: item.label || `AI 设计方案 ${index + 1}`, sourceWidth: asset.sourceWidth, sourceHeight: asset.sourceHeight, kind: "image" });
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "设计已添加到画布，可继续缩放与编辑。", "success");
    } catch {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "无法加载此设计，请重新生成。", "error");
    }
  };
  useInspiration_fn = async function(index) {
    const item = this.state.inspirations[index];
    if (!item) return;
    this.state.mode = "generate";
    __privateMethod(this, _ColoroutineAIStudio_instances, setMode_fn).call(this, "generate");
    const prompt = this.shadowRoot.querySelector("#prompt");
    prompt.value = item.prompt;
    prompt.dispatchEvent(new Event("input", { bubbles: true }));
    __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "灵感已转为提示词，你可以调整后生成。", "success");
  };
  addUploadedFile_fn = async function(file) {
    try {
      const asset = await prepareImage(file);
      await this.editor.addImage(asset.dataUrl, { assetName: file.name, sourceWidth: asset.sourceWidth, sourceHeight: asset.sourceHeight, kind: "image" });
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "设计文件已添加，可在画布中拖拽缩放。", "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, error.message, "error");
    }
  };
  setReference_fn = async function(file) {
    try {
      this.state.reference = await prepareImage(file, 1600);
      this.shadowRoot.querySelector("#creative-body").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, creativeBody_fn).call(this);
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, error.message, "error");
    }
  };
  sceneKey_fn = function() {
    return `${this.product.id}:${this.store.current.face}`;
  };
  saveCurrentScene_fn = async function() {
    if (!this.editor) return;
    this.store.saveScene(__privateMethod(this, _ColoroutineAIStudio_instances, sceneKey_fn).call(this), this.editor.serialize());
    const state = this.shadowRoot.querySelector("#save-state");
    if (state) state.textContent = "已保存";
  };
  scheduleSave_fn = function() {
    const state = this.shadowRoot.querySelector("#save-state");
    if (state) state.textContent = "保存中";
    clearTimeout(this.autosaveTimer);
    this.autosaveTimer = setTimeout(() => __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this), 450);
  };
  loadCurrentScene_fn = async function() {
    const scene = this.store.getScene(__privateMethod(this, _ColoroutineAIStudio_instances, sceneKey_fn).call(this));
    await this.editor.load(scene?.canvasJSON || { objects: [] });
    this.state.layers = this.editor.getLayers();
    this.state.quality = this.editor.getQuality();
    __privateMethod(this, _ColoroutineAIStudio_instances, renderLayers_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateQuality_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
  };
  selectProject_fn = async function(id) {
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    this.store.select(id);
    this.state.previewed3d = false;
    const project = this.store.current;
    this.product = this.products.find((product) => product.id === project.productId) || this.products[0];
    this.color = getProductColor(this.product, project.colorId);
    this.editor.setProduct(this.product);
    await __privateMethod(this, _ColoroutineAIStudio_instances, loadCurrentScene_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
    this.shadowRoot.querySelector("#top-project-name").textContent = project.name;
    this.shadowRoot.querySelector("#top-product").textContent = this.product.shortName;
    this.shadowRoot.querySelector("#product-kicker").textContent = `DESIGN TO PRODUCT · ${this.product.category}`;
  };
  newProject_fn = async function() {
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    const number = this.store.list().length + 1;
    this.store.create(`我的设计 ${number}`);
    this.product = this.products.find((product) => product.id === "tshirt") || this.products[0];
    this.color = this.product.colors[0];
    this.editor.setProduct(this.product);
    await this.editor.load({ objects: [] });
    this.state.layers = [];
    this.state.quality = this.editor.getQuality();
    this.state.previewed3d = false;
    __privateMethod(this, _ColoroutineAIStudio_instances, renderLayers_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateQuality_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
    __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
    this.shadowRoot.querySelector("#project-select").innerHTML = __privateMethod(this, _ColoroutineAIStudio_instances, projectOptions_fn).call(this);
    this.shadowRoot.querySelector("#project-count").textContent = this.store.list().length;
    this.shadowRoot.querySelector("#top-project-name").textContent = this.store.current.name;
    this.shadowRoot.querySelector("#top-product").textContent = this.product.shortName;
    this.shadowRoot.querySelector("#product-kicker").textContent = `DESIGN TO PRODUCT · ${this.product.category}`;
    __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "已创建新的设计项目。", "success");
  };
  addToCart_fn = async function(button) {
    if (!this.editor.canvas.getObjects().length) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先添加至少一个设计元素。", "error");
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
      const preview = this.editor.dataURL(0.45);
      const payload = {
        projectId: this.store.current.id,
        productId: this.product.id,
        colorId: this.color[0],
        size: this.store.current.size,
        face: this.store.current.face,
        canvas: this.editor.serialize(),
        preview,
        quality: this.editor.getQuality()
      };
      let design;
      try {
        design = await this.api.finalize(payload);
      } catch (error) {
        if (this.shopify.isShopify) throw error;
        design = { designId: `LOCAL-${crypto.randomUUID().slice(0, 8).toUpperCase()}`, revision: (this.store.current.revision || 0) + 1, cartToken: crypto.randomUUID(), finalizedAt: (/* @__PURE__ */ new Date()).toISOString(), face: this.store.current.face };
      }
      design.face || (design.face = this.store.current.face);
      design.proofId || (design.proofId = this.store.current.proofId || this.state.proofId || "");
      design.preflightStatus = __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this).ready ? "proof_ready" : "needs_review";
      design.productSpec = {
        productId: this.product.id,
        productName: this.product.name,
        colorId: this.color[0],
        colorName: this.color[2],
        size: this.store.current.size,
        face: this.store.current.face,
        faceLabel: FACE_LABELS[this.store.current.face],
        quality: this.editor.getQuality()
      };
      this.store.markFinalized(design);
      __privateMethod(this, _ColoroutineAIStudio_instances, updateWorkflow_fn).call(this);
      const result = await this.shopify.addToCart({ product: this.product, colorId: this.color[0], colorName: this.color[2], size: this.store.current.size, quantity: this.store.current.quantity, design, previewUrl: design.previewUrl });
      if (result.mode === "preview") {
        this.store.addLocalCart(result.item);
        __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `本地测试成功：${design.designId} 已加入模拟购物车。`, "success");
      } else {
        __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "定制设计已绑定并加入 Shopify 购物车。", "success");
        document.dispatchEvent(new CustomEvent("coloroutine:cart-updated", { detail: result.item }));
      }
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, error.message, "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
    }
  };
  setQuantity_fn = function(value) {
    const quantity = Math.max(1, Math.min(99, value));
    this.store.update({ quantity });
    const output = this.shadowRoot.querySelector("#quantity");
    const price = this.shadowRoot.querySelector("#price");
    if (output) output.textContent = quantity;
    if (price) price.textContent = formatMoney(this.product.price * quantity);
  };
  setZoom_fn = function(value) {
    this.state.zoom = Math.max(70, Math.min(140, value));
    const stage = this.shadowRoot.querySelector("#product-stage");
    stage.style.transform = `scale(${this.state.zoom / 100})`;
    this.shadowRoot.querySelector("#zoom-value").textContent = `${this.state.zoom}%`;
  };
  clearDesign_fn = function() {
    if (!this.editor.canvas.getObjects().length || confirm(translateStudioText("确定清空当前印刷面的全部设计吗？", this.locale))) this.editor.clear();
  };
  download_fn = function() {
    if (!this.editor.canvas.getObjects().length) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "画布为空，暂无可导出的设计。", "error");
    const link = document.createElement("a");
    link.download = `coloroutine-${this.product.id}-${Date.now()}.png`;
    link.href = this.editor.dataURL(2);
    link.click();
    __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "已导出透明背景设计 PNG。", "success");
  };
  exportProofPackage_fn = async function(button) {
    if (!this.editor.canvas.getObjects().length) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "Please add a design before exporting a professional proof.", "error");
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      const proof = await __privateMethod(this, _ColoroutineAIStudio_instances, buildProofPackage_fn).call(this);
      __privateMethod(this, _ColoroutineAIStudio_instances, downloadDataUrl_fn).call(this, proof.imageDataUrl, `${proof.proofId}-preview.png`);
      __privateMethod(this, _ColoroutineAIStudio_instances, downloadJSON_fn).call(this, proof.metadata, `${proof.proofId}-production-proof.json`);
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `Professional proof exported: ${proof.proofId}`, "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `Proof export failed: ${error.message}`, "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
    }
  };
  requestProof_fn = async function(button) {
    if (!this.editor.canvas.getObjects().length) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "Please create or upload a design before requesting a proof.", "error");
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      const proof = await __privateMethod(this, _ColoroutineAIStudio_instances, buildProofPackage_fn).call(this, { imageOnly: true });
      const subject = encodeURIComponent(`Coloroutine proof / quote request · ${proof.proofId}`);
      const body = encodeURIComponent([
        `Proof ID: ${proof.proofId}`,
        `Project: ${this.store.current.name}`,
        `Product: ${this.product.name}`,
        `Color: ${this.color[2]}`,
        `Size / model: ${this.store.current.size}`,
        `Side: ${FACE_LABELS[this.store.current.face]}`,
        `Quantity: ${this.store.current.quantity}`,
        "",
        "I would like a production proof or high-ticket quote for this design.",
        "Please attach the exported proof PNG/JSON if you have downloaded it."
      ].join("\n"));
      window.open(`mailto:support@coloroutine.com?subject=${subject}&body=${body}`, "_blank", "noopener");
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `Proof request draft opened: ${proof.proofId}`, "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `Proof request failed: ${error.message}`, "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
    }
  };
  buildProofPackage_fn = async function({ imageOnly = false } = {}) {
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    const project = this.store.current;
    const proofId = project.proofId || this.state.proofId || `CR-PROOF-${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10).replaceAll("-", "")}-${crypto.randomUUID().slice(0, 6).toUpperCase()}`;
    this.state.proofId = proofId;
    this.store.update({ proofId, proofedAt: (/* @__PURE__ */ new Date()).toISOString() });
    const imageDataUrl = await __privateMethod(this, _ColoroutineAIStudio_instances, renderProofImage_fn).call(this, proofId);
    const metadata = imageOnly ? null : __privateMethod(this, _ColoroutineAIStudio_instances, proofMetadata_fn).call(this, proofId, imageDataUrl);
    __privateMethod(this, _ColoroutineAIStudio_instances, updatePreflight_fn).call(this);
    return { proofId, imageDataUrl, metadata };
  };
  renderProofImage_fn = async function(proofId) {
    let productVisual = "";
    const visualMode = this.state.previewed3d || this.state.view === "3d" ? "3d" : "2d";
    if (visualMode === "3d") {
      const container = this.shadowRoot.querySelector("#three-stage");
      if (!this.preview3d) this.preview3d = new Product3DPreview(container);
      const snapshot = await __privateMethod(this, _ColoroutineAIStudio_instances, designSnapshotCanvas_fn).call(this);
      const sameProduct = this.preview3d.product?.id === this.product.id && this.preview3d.color?.[0] === this.color?.[0] && this.preview3d.face === this.store.current.face;
      if (sameProduct) this.preview3d.updateDesign(snapshot, this.store.current.face);
      else await this.preview3d.setProduct(this.product, this.color, snapshot, this.store.current.face);
      productVisual = this.preview3d.captureDataURL({ width: 1200, height: 900 });
    }
    return createBrandedPreview({
      format: "landscape",
      visualMode,
      productVisual,
      product: this.product,
      color: this.color,
      face: this.store.current.face,
      designCanvas: this.editor.canvas.lowerCanvasEl,
      projectName: `${this.store.current.name} · ${proofId}`,
      designId: proofId
    });
  };
  proofMetadata_fn = function(proofId, imageDataUrl) {
    const project = this.store.current;
    const printArea = productPrintArea(this.product, project.face);
    const quality = this.editor.getQuality();
    const checks = __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this);
    return {
      schema: "coloroutine-production-proof-v1",
      proofId,
      designId: project.designId || proofId,
      exportedAt: (/* @__PURE__ */ new Date()).toISOString(),
      status: checks.ready ? "proof_ready" : "needs_review",
      project: {
        id: project.id,
        name: project.name,
        quantity: project.quantity,
        revision: project.revision || 0
      },
      selected: {
        productId: this.product.id,
        productName: this.product.name,
        category: this.product.category,
        colorId: this.color[0],
        colorHex: this.color[1],
        colorName: this.color[2],
        size: project.size,
        face: project.face,
        faceLabel: FACE_LABELS[project.face]
      },
      print: {
        physical: this.product.physical,
        target: this.product.target,
        printArea,
        mappingCalibrated: mappingError(this.product, printArea) < 2e-3,
        quality
      },
      preflight: checks.items.map(({ id, ok, warn, label, detail }) => ({ id, ok, warn: Boolean(warn), label, detail })),
      assets: {
        proofPreviewIncluded: Boolean(imageDataUrl),
        designCanvas: this.editor.serialize()
      },
      handoff: {
        intendedUse: "proof / quote / production review",
        nextStep: checks.ready ? "approve proof or add to cart" : "review blockers before production"
      }
    };
  };
  downloadJSON_fn = function(payload, filename) {
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };
  downloadDataUrl_fn = function(dataUrl, filename) {
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = filename;
    link.click();
  };
  focusLayers_fn = function() {
    if (matchMedia("(max-width:930px)").matches) __privateMethod(this, _ColoroutineAIStudio_instances, togglePanel_fn).call(this, "inspector", true);
    this.shadowRoot.querySelector("#layers-card")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  focusPreflight_fn = function() {
    if (matchMedia("(max-width:930px)").matches) __privateMethod(this, _ColoroutineAIStudio_instances, togglePanel_fn).call(this, "inspector", true);
    this.shadowRoot.querySelector("#preflight-card")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  toggleDebugMapping_fn = function() {
    this.state.debugMapping = !this.state.debugMapping;
    this.shadowRoot.querySelector("#product-stage")?.classList.toggle("debug-mapping", this.state.debugMapping);
    __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, this.state.debugMapping ? "Mapping debug is on: print area and center guides are highlighted." : "Mapping debug is off.", "success");
  };
  exportProject_fn = async function() {
    await __privateMethod(this, _ColoroutineAIStudio_instances, saveCurrentScene_fn).call(this);
    const project = this.store.current;
    const payload = {
      schema: "coloroutine-design-v1",
      exportedAt: (/* @__PURE__ */ new Date()).toISOString(),
      project,
      product: {
        id: this.product.id,
        name: this.product.name,
        category: this.product.category,
        physical: this.product.physical,
        target: this.product.target
      },
      selected: {
        colorId: this.color[0],
        colorHex: this.color[1],
        colorName: this.color[2],
        size: project.size,
        face: project.face
      },
      quality: this.editor.getQuality(),
      preflight: __privateMethod(this, _ColoroutineAIStudio_instances, preflightChecks_fn).call(this),
      mapping: {
        printArea: productPrintArea(this.product, project.face),
        calibrated: mappingError(this.product, productPrintArea(this.product, project.face)) < 2e-3
      }
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `coloroutine-${this.product.id}-${Date.now()}.coloroutine-design.json`;
    link.click();
    URL.revokeObjectURL(link.href);
    __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "Project JSON exported. It can be used for support, production review, or future editing.", "success");
  };
  focusWorkflowTarget_fn = function(selector, panel = "") {
    if (panel && matchMedia("(max-width:930px)").matches) __privateMethod(this, _ColoroutineAIStudio_instances, togglePanel_fn).call(this, panel, true);
    this.shadowRoot.querySelector(selector)?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  syncProductContext_fn = function() {
    const project = this.store.current;
    const title = this.shadowRoot.querySelector("#product-chip-title");
    const meta = this.shadowRoot.querySelector("#product-chip-meta");
    if (title) title.textContent = this.product.shortName;
    if (meta) meta.textContent = `${this.color[2]} · ${project.size} · ${FACE_LABELS[project.face]}`;
  };
  updateWorkflow_fn = function() {
    const hasDesign = this.state.layers.length > 0;
    const ordered = Boolean(this.store.current.finalizedAt);
    const steps = [
      ["#workflow-product", true],
      ["#workflow-design", hasDesign],
      ["#workflow-preview", this.state.previewed3d],
      ["#workflow-order", ordered]
    ];
    const activeIndex = ordered ? 3 : !hasDesign ? 1 : !this.state.previewed3d ? 2 : 3;
    steps.forEach(([selector, done], index) => {
      const element = this.shadowRoot.querySelector(selector);
      element?.classList.toggle("done", done);
      element?.classList.toggle("active", index === activeIndex);
    });
    this.shadowRoot.querySelector("#stage-helper")?.classList.toggle("hidden", hasDesign || this.state.view === "3d");
    this.shadowRoot.querySelector("#quick-start")?.classList.toggle("hidden", hasDesign);
    this.shadowRoot.querySelector("#empty-stage-actions")?.classList.toggle("hidden", hasDesign || this.state.view === "3d");
    __privateMethod(this, _ColoroutineAIStudio_instances, updatePreflight_fn).call(this);
  };
  friendlyError_fn = function(error, fallback) {
    const message = String(error?.message || "").trim();
    if (!message) return fallback;
    if (/timeout|timed out|abort|504|超时/i.test(message)) return fallback;
    if (/failed to fetch|network|ECONN|ENOTFOUND/i.test(message)) return "网络或服务连接不稳定，请稍后重试；画布编辑、上传图片和文字设计仍可继续使用。";
    return message;
  };
  openShare_fn = async function() {
    if (!this.editor.canvas.getObjects().length) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先完成至少一个设计元素，再生成分享图。", "error");
    this.state.shareView = this.state.view;
    this.shadowRoot.querySelector("#share-modal").classList.add("open");
    __privateMethod(this, _ColoroutineAIStudio_instances, syncShareViewControls_fn).call(this);
    await __privateMethod(this, _ColoroutineAIStudio_instances, renderShareImage_fn).call(this);
  };
  closeShare_fn = function() {
    this.shadowRoot.querySelector("#share-modal").classList.remove("open");
  };
  updateShareFormat_fn = async function() {
    const labels = { square: "方形动态", story: "竖版 Story", landscape: "横版提案" };
    this.shadowRoot.querySelectorAll("[data-share-format]").forEach((button) => button.classList.toggle("active", button.dataset.shareFormat === this.state.shareFormat));
    this.shadowRoot.querySelector("#share-format-label").textContent = labels[this.state.shareFormat];
    await __privateMethod(this, _ColoroutineAIStudio_instances, renderShareImage_fn).call(this);
  };
  updateShareView_fn = async function() {
    __privateMethod(this, _ColoroutineAIStudio_instances, syncShareViewControls_fn).call(this);
    await __privateMethod(this, _ColoroutineAIStudio_instances, renderShareImage_fn).call(this);
  };
  syncShareViewControls_fn = function() {
    const labels = { "2d": "2D 商品底图", "3d": "3D 实时模型" };
    this.shadowRoot.querySelectorAll("[data-share-view]").forEach((button) => button.classList.toggle("active", button.dataset.shareView === this.state.shareView));
    this.shadowRoot.querySelector("#share-view-label").textContent = labels[this.state.shareView];
  };
  renderShareImage_fn = async function() {
    const loading2 = this.shadowRoot.querySelector("#share-preview-loading");
    const preview = this.shadowRoot.querySelector("#share-preview");
    loading2.hidden = false;
    preview.removeAttribute("src");
    try {
      let productVisual = "";
      if (this.state.shareView === "3d") {
        const container = this.shadowRoot.querySelector("#three-stage");
        if (!this.preview3d) this.preview3d = new Product3DPreview(container);
        const sameProduct = this.preview3d.product?.id === this.product.id && this.preview3d.color?.[0] === this.color?.[0] && this.preview3d.face === this.store.current.face;
        if (sameProduct) this.preview3d.updateDesign(await __privateMethod(this, _ColoroutineAIStudio_instances, designSnapshotCanvas_fn).call(this), this.store.current.face);
        else await this.preview3d.setProduct(this.product, this.color, await __privateMethod(this, _ColoroutineAIStudio_instances, designSnapshotCanvas_fn).call(this), this.store.current.face);
        productVisual = this.preview3d.captureDataURL({ width: 1100, height: 1100 });
      }
      this.state.shareImage = await createBrandedPreview({
        format: this.state.shareFormat,
        visualMode: this.state.shareView,
        productVisual,
        product: this.product,
        color: this.color,
        face: this.store.current.face,
        designCanvas: this.editor.canvas.lowerCanvasEl,
        projectName: this.store.current.name,
        designId: this.store.current.designId
      });
      preview.src = this.state.shareImage;
      this.state.shareResult = null;
      this.shadowRoot.querySelector("#share-link-box").classList.remove("active");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, `分享图生成失败：${error.message}`, "error");
    } finally {
      loading2.hidden = true;
    }
  };
  update3DDesignSnapshot_fn = async function() {
    try {
      this.preview3d?.updateDesign(await __privateMethod(this, _ColoroutineAIStudio_instances, designSnapshotCanvas_fn).call(this), this.store.current.face);
    } catch (error) {
      console.warn("[Studio] 3D design snapshot failed:", error);
    }
  };
  designSnapshotCanvas_fn = async function() {
    const dataUrl = this.editor.dataURL(1);
    const image = await loadImage(dataUrl);
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, image.naturalWidth || image.width || this.editor.canvas.width);
    canvas.height = Math.max(1, image.naturalHeight || image.height || this.editor.canvas.height);
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas;
  };
  publishShare_fn = async function(button) {
    if (!this.state.shareImage) await __privateMethod(this, _ColoroutineAIStudio_instances, renderShareImage_fn).call(this);
    if (!this.state.shareImage) return;
    __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, true);
    try {
      const result = await this.api.createShare({ imageDataUrl: this.state.shareImage, productName: this.product.name, projectName: this.store.current.name });
      this.state.shareResult = result;
      const box = this.shadowRoot.querySelector("#share-link-box");
      box.classList.add("active");
      box.querySelector("input").value = result.shareUrl;
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "品牌预览链接已生成，可以发送给好友或同事。", "success");
    } catch (error) {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, error.message, "error");
    } finally {
      __privateMethod(this, _ColoroutineAIStudio_instances, setBusy_fn).call(this, button, false);
    }
  };
  downloadShare_fn = function() {
    if (!this.state.shareImage) return;
    const link = document.createElement("a");
    link.download = `coloroutine-${this.product.id}-${this.state.shareFormat}.png`;
    link.href = this.state.shareImage;
    link.click();
  };
  copyShare_fn = async function() {
    if (!this.state.shareResult?.shareUrl) return __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "请先生成公开预览链接。", "error");
    try {
      await navigator.clipboard.writeText(this.state.shareResult.shareUrl);
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "分享链接已复制。", "success");
    } catch {
      __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "浏览器未允许复制，请手动选择链接。", "error");
    }
  };
  nativeShare_fn = async function() {
    if (!this.state.shareImage) return;
    try {
      const blob = await (await fetch(this.state.shareImage)).blob();
      const file = new File([blob], `coloroutine-${this.product.id}.png`, { type: "image/png" });
      if (navigator.canShare?.({ files: [file] })) await navigator.share({ title: `${this.store.current.name} · Coloroutine`, text: "看看我在 Coloroutine 制作的定制产品", files: [file], url: this.state.shareResult?.shareUrl });
      else if (this.state.shareResult?.shareUrl) await navigator.share?.({ title: `${this.store.current.name} · Coloroutine`, url: this.state.shareResult.shareUrl });
      else __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "当前浏览器不支持文件分享，可先下载 PNG。", "error");
    } catch (error) {
      if (error.name !== "AbortError") __privateMethod(this, _ColoroutineAIStudio_instances, toast_fn).call(this, "系统分享未完成。", "error");
    }
  };
  togglePanel_fn = function(panel, force) {
    const element = this.shadowRoot.querySelector(`#${panel}`);
    const shouldOpen = force ?? !element.classList.contains("open");
    element.classList.toggle("open", shouldOpen);
  };
  toggleTheme_fn = function() {
    if (this.getAttribute("theme") === "dark") this.setAttribute("theme", "brand");
    else this.setAttribute("theme", "dark");
  };
  setLocale_fn = function(locale) {
    this.locale = normalizeLocale(locale);
    this.setAttribute("lang", this.locale);
    this.localizer?.setLocale(this.locale);
    const select = this.shadowRoot.querySelector("#studio-locale");
    if (select) select.value = this.locale;
  };
  checkService_fn = async function() {
    try {
      const result = await this.api.health();
      this.state.service = "online";
      this.shadowRoot.querySelector("#service-dot").classList.add("online");
      this.shadowRoot.querySelector("#service-title").textContent = result.mode === "mock" ? "本地创意引擎已连接" : "AI 设计服务已连接";
      this.shadowRoot.querySelector("#service-copy").textContent = result.mode === "mock" ? "无需密钥 · 可完整测试流程" : "Cloud AI · Secure";
    } catch {
      this.state.service = "offline";
      this.shadowRoot.querySelector("#service-title").textContent = "离线编辑模式";
      this.shadowRoot.querySelector("#service-copy").textContent = "画布可用 · AI 服务未连接";
    }
  };
  loadCatalog_fn = async function() {
    try {
      const result = await this.api.catalog();
      const merged = new Map(this.products.map((product) => [product.id, product]));
      for (const product of result.products || []) merged.set(product.id, product);
      this.products = [...merged.values()];
      const configured = this.products.find((product) => product.id === this.store.current.productId);
      if (configured) {
        this.product = configured;
        this.color = getProductColor(this.product, this.store.current.colorId);
        this.editor.setProduct(this.product);
        await __privateMethod(this, _ColoroutineAIStudio_instances, loadCurrentScene_fn).call(this);
        __privateMethod(this, _ColoroutineAIStudio_instances, updateProductStage_fn).call(this);
        this.shadowRoot.querySelector("#top-product").textContent = this.product.shortName;
        this.shadowRoot.querySelector("#product-kicker").textContent = `DESIGN TO PRODUCT · ${this.product.category}`;
      }
      __privateMethod(this, _ColoroutineAIStudio_instances, refreshInspector_fn).call(this);
      this.dispatchEvent(new CustomEvent("coloroutine:catalog-ready", { detail: { count: this.products.length } }));
    } catch {
    }
  };
  setBusy_fn = function(button, busy) {
    if (!button?.isConnected) return;
    button.disabled = busy;
    button.classList.toggle("loading", busy);
  };
  toast_fn = function(message, type = "") {
    const stack = this.shadowRoot.querySelector("#toasts");
    if (!stack) return;
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.innerHTML = `${icon(type === "error" ? "warning" : "check", 16)}<span>${escapeHTML(translateStudioText(message, this.locale))}</span>`;
    stack.append(toast);
    setTimeout(() => toast.remove(), 4200);
  };
  async function createBrandedPreview({ format, visualMode = "2d", productVisual = "", product, color, face, designCanvas, projectName, designId }) {
    const formats = {
      square: { width: 1200, height: 1200, art: { x: 180, y: 135, width: 840, height: 850 }, textAlign: "center" },
      story: { width: 1080, height: 1920, art: { x: 90, y: 330, width: 900, height: 1180 }, textAlign: "center" },
      landscape: { width: 1600, height: 1e3, art: { x: 90, y: 90, width: 880, height: 820 }, textAlign: "right" }
    };
    const config = formats[format] || formats.square;
    const canvas = document.createElement("canvas");
    canvas.width = config.width;
    canvas.height = config.height;
    const context = canvas.getContext("2d");
    const gradient = context.createLinearGradient(0, 0, config.width, config.height);
    gradient.addColorStop(0, "#f6f0e7");
    gradient.addColorStop(0.58, "#e9e1d7");
    gradient.addColorStop(1, "#d8ccc2");
    context.fillStyle = gradient;
    context.fillRect(0, 0, config.width, config.height);
    context.fillStyle = "rgba(18,18,18,.055)";
    context.beginPath();
    context.arc(config.width * 0.88, config.height * 0.12, config.width * 0.22, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = "rgba(105,99,94,.07)";
    context.beginPath();
    context.arc(config.width * 0.08, config.height * 0.84, config.width * 0.19, 0, Math.PI * 2);
    context.fill();
    const art = config.art;
    context.save();
    context.shadowColor = "rgba(54,43,37,.20)";
    context.shadowBlur = 52;
    context.shadowOffsetY = 24;
    context.fillStyle = "rgba(255,255,255,.48)";
    roundRect(context, art.x - 22, art.y - 22, art.width + 44, art.height + 44, 34);
    context.fill();
    context.restore();
    const aspect2 = visualMode === "3d" ? 1 : product.previewAspect || 360 / 540;
    const productRect = containRect(art, aspect2);
    const markup = visualMode === "2d" ? productSvg(product, color, face) : "";
    const customSource = productVisual || productMockupURL(product, color, face);
    const artLayer = document.createElement("canvas");
    artLayer.width = config.width;
    artLayer.height = config.height;
    const artContext = artLayer.getContext("2d");
    let objectURL = "";
    try {
      objectURL = customSource ? "" : URL.createObjectURL(new Blob([markup], { type: "image/svg+xml;charset=utf-8" }));
      const productImage = await loadImage(customSource || objectURL, true);
      artContext.drawImage(productImage, productRect.x, productRect.y, productRect.width, productRect.height);
      artLayer.toDataURL("image/png");
      context.drawImage(artLayer, 0, 0);
    } catch {
      drawShareProductFallback(context, productRect, product, color);
    } finally {
      if (objectURL) URL.revokeObjectURL(objectURL);
    }
    if (visualMode === "2d") {
      const area2 = productPrintArea(product, face);
      const printX = productRect.x + productRect.width * area2.left / 100;
      const printY = productRect.y + productRect.height * area2.top / 100;
      const printWidth = productRect.width * area2.width / 100;
      const printHeight = productRect.height * area2.height / 100;
      context.save();
      context.beginPath();
      context.rect(printX, printY, printWidth, printHeight);
      context.clip();
      context.drawImage(designCanvas, printX, printY, printWidth, printHeight);
      context.restore();
    }
    const dark = "#202127";
    context.fillStyle = "#121212";
    context.font = `700 ${Math.round(config.width * 0.011)}px Arial, sans-serif`;
    context.letterSpacing = `${Math.round(config.width * 3e-3)}px`;
    if (format === "landscape") {
      const textX = 1050;
      context.textAlign = "left";
      context.fillText("COLOROUTINE · COLOR WITH LOVE", textX, 250);
      context.fillStyle = dark;
      context.font = "700 62px Arial, sans-serif";
      wrapText(context, projectName || "MY CUSTOM DESIGN", textX, 338, 450, 72, 3);
      context.fillStyle = "#69635e";
      context.font = "500 25px Arial, sans-serif";
      context.fillText(product.name, textX, 520);
      context.fillStyle = dark;
      context.font = "700 19px Arial, sans-serif";
      context.fillText("DESIGNED WITH COLOROUTINE AI STUDIO", textX, 768);
      context.fillStyle = "#121212";
      context.fillRect(textX, 805, 72, 5);
      context.fillStyle = "#69635e";
      context.font = "500 20px Arial, sans-serif";
      context.fillText("coloroutine.com", textX, 858);
    } else {
      context.textAlign = "center";
      const top = format === "story" ? 155 : 62;
      context.fillText("COLOROUTINE · COLOR WITH LOVE", config.width / 2, top);
      const titleY = format === "story" ? 1640 : 1040;
      context.fillStyle = dark;
      context.font = `700 ${format === "story" ? 58 : 48}px Arial, sans-serif`;
      context.fillText(projectName || "MY CUSTOM DESIGN", config.width / 2, titleY);
      context.fillStyle = "#69635e";
      context.font = `500 ${format === "story" ? 28 : 20}px Arial, sans-serif`;
      context.fillText(product.name, config.width / 2, titleY + (format === "story" ? 55 : 40));
      context.fillStyle = "#121212";
      context.fillRect(config.width / 2 - 34, titleY + (format === "story" ? 88 : 67), 68, 5);
      context.fillStyle = "#69635e";
      context.font = `500 ${format === "story" ? 21 : 16}px Arial, sans-serif`;
      context.fillText("DESIGNED AT COLOROUTINE.COM", config.width / 2, titleY + (format === "story" ? 142 : 104));
    }
    if (designId) {
      context.textAlign = "right";
      context.fillStyle = "rgba(32,33,39,.42)";
      context.font = "500 13px monospace";
      context.fillText(`${designId} · ${face.toUpperCase()}`, config.width - 30, config.height - 25);
    }
    context.textAlign = "left";
    context.fillStyle = "rgba(32,33,39,.56)";
    context.font = "700 13px Arial, sans-serif";
    context.fillText(visualMode === "3d" ? "3D · UV SURFACE RENDER" : "2D · PRODUCT MOCKUP", 28, config.height - 24);
    return canvas.toDataURL("image/png", 0.96);
  }
  function containRect(rect, aspect2) {
    let width = rect.width;
    let height = width / aspect2;
    if (height > rect.height) {
      height = rect.height;
      width = height * aspect2;
    }
    return { x: rect.x + (rect.width - width) / 2, y: rect.y + (rect.height - height) / 2, width, height };
  }
  function drawShareProductFallback(context, rect, product, color) {
    const fill = color?.[1] || "#e9e4da";
    context.save();
    context.translate(rect.x, rect.y);
    context.fillStyle = fill;
    context.strokeStyle = "rgba(32,33,39,.25)";
    context.lineWidth = Math.max(2, rect.width * 6e-3);
    if (product.type === "mug") {
      roundRect(context, rect.width * 0.18, rect.height * 0.18, rect.width * 0.58, rect.height * 0.66, rect.width * 0.07);
      context.fill();
      context.stroke();
      context.beginPath();
      context.arc(rect.width * 0.75, rect.height * 0.46, rect.width * 0.18, -Math.PI / 2, Math.PI / 2);
      context.strokeStyle = fill;
      context.lineWidth = rect.width * 0.1;
      context.stroke();
    } else if (product.type === "phone") {
      roundRect(context, rect.width * 0.24, rect.height * 0.05, rect.width * 0.52, rect.height * 0.9, rect.width * 0.1);
      context.fill();
      context.stroke();
    } else if (product.type === "tote") {
      context.beginPath();
      context.moveTo(rect.width * 0.2, rect.height * 0.27);
      context.lineTo(rect.width * 0.8, rect.height * 0.27);
      context.lineTo(rect.width * 0.9, rect.height * 0.92);
      context.lineTo(rect.width * 0.1, rect.height * 0.92);
      context.closePath();
      context.fill();
      context.stroke();
      context.beginPath();
      context.arc(rect.width * 0.5, rect.height * 0.28, rect.width * 0.2, Math.PI, 0);
      context.strokeStyle = fill;
      context.lineWidth = rect.width * 0.06;
      context.stroke();
    } else if (product.type === "magnet") {
      context.beginPath();
      context.arc(rect.width / 2, rect.height / 2, Math.min(rect.width, rect.height) * 0.36, 0, Math.PI * 2);
      context.fill();
      context.stroke();
    } else {
      context.beginPath();
      context.moveTo(rect.width * 0.32, rect.height * 0.08);
      context.lineTo(rect.width * 0.43, rect.height * 0.14);
      context.quadraticCurveTo(rect.width * 0.5, rect.height * 0.22, rect.width * 0.57, rect.height * 0.14);
      context.lineTo(rect.width * 0.68, rect.height * 0.08);
      context.lineTo(rect.width * 0.93, rect.height * 0.26);
      context.lineTo(rect.width * 0.78, rect.height * 0.42);
      context.lineTo(rect.width * 0.68, rect.height * 0.34);
      context.lineTo(rect.width * 0.68, rect.height * 0.94);
      context.lineTo(rect.width * 0.32, rect.height * 0.94);
      context.lineTo(rect.width * 0.32, rect.height * 0.34);
      context.lineTo(rect.width * 0.22, rect.height * 0.42);
      context.lineTo(rect.width * 0.07, rect.height * 0.26);
      context.closePath();
      context.fill();
      context.stroke();
    }
    context.restore();
  }
  function roundRect(context, x2, y2, width, height, radius) {
    context.beginPath();
    context.roundRect(x2, y2, width, height, radius);
  }
  function wrapText(context, text, x2, y2, maxWidth, lineHeight, maxLines) {
    const words = String(text).split(/\s+/);
    let line = "";
    let lineIndex = 0;
    for (const word of words) {
      const test = line ? `${line} ${word}` : word;
      if (context.measureText(test).width > maxWidth && line) {
        context.fillText(line, x2, y2 + lineIndex * lineHeight);
        line = word;
        lineIndex += 1;
        if (lineIndex >= maxLines - 1) break;
      } else line = test;
    }
    if (lineIndex < maxLines) context.fillText(line, x2, y2 + lineIndex * lineHeight);
  }
  async function prepareImage(file, maxDimension = 2400) {
    const validTypes = ["image/png", "image/jpeg", "image/webp"];
    if (!validTypes.includes(file.type)) throw new Error("仅支持 PNG、JPG 与 WEBP 图片。");
    if (file.size > 20 * 1024 * 1024) throw new Error("图片不能超过 20 MB。");
    const source = await fileToDataURL(file);
    const image = await loadImage(source);
    const sourceWidth = image.naturalWidth;
    const sourceHeight = image.naturalHeight;
    if (Math.max(sourceWidth, sourceHeight) <= maxDimension) return { dataUrl: source, sourceWidth, sourceHeight };
    const scale = maxDimension / Math.max(sourceWidth, sourceHeight);
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(sourceWidth * scale);
    canvas.height = Math.round(sourceHeight * scale);
    canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
    return { dataUrl: canvas.toDataURL(file.type === "image/jpeg" ? "image/jpeg" : "image/png", 0.92), sourceWidth, sourceHeight };
  }
  async function prepareGeneratedDesign(item, maxDimension = 2400) {
    const source = String(item?.url || "");
    if (!source) throw new Error("AI 生成图片不完整。");
    if (!source.startsWith("data:image/svg+xml") && !item.autoRemoveBackground) {
      return {
        dataUrl: source,
        sourceWidth: Number(item.width) || 2400,
        sourceHeight: Number(item.height) || 2400
      };
    }
    const image = await loadImage(source);
    const sourceWidth = Math.max(1, image.naturalWidth || Number(item.width) || 1e3);
    const sourceHeight = Math.max(1, image.naturalHeight || Number(item.height) || 1e3);
    const scale = Math.min(1, maxDimension / Math.max(sourceWidth, sourceHeight));
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(sourceWidth * scale));
    canvas.height = Math.max(1, Math.round(sourceHeight * scale));
    const context = canvas.getContext("2d", { willReadFrequently: true });
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    if (item.autoRemoveBackground) removeGeneratedCornerBackground(context, canvas.width, canvas.height, 42);
    if (!hasVisiblePixels(context, canvas.width, canvas.height)) throw new Error("AI 生成图片为空。");
    return { dataUrl: canvas.toDataURL("image/png"), sourceWidth, sourceHeight };
  }
  function removeGeneratedCornerBackground(context, width, height, tolerance = 42) {
    const imageData = context.getImageData(0, 0, width, height);
    const { data } = imageData;
    const corners = [[0, 0], [width - 1, 0], [0, height - 1], [width - 1, height - 1]];
    const background = corners.reduce((sum, [x2, y2]) => {
      const offset = (y2 * width + x2) * 4;
      sum.r += data[offset];
      sum.g += data[offset + 1];
      sum.b += data[offset + 2];
      return sum;
    }, { r: 0, g: 0, b: 0 });
    background.r /= 4;
    background.g /= 4;
    background.b /= 4;
    const visited = new Uint8Array(width * height);
    const queue = new Int32Array(width * height);
    let head = 0;
    let tail = 0;
    const enqueue = (pixel) => {
      if (visited[pixel]) return;
      visited[pixel] = 1;
      queue[tail++] = pixel;
    };
    for (const [x2, y2] of corners) enqueue(y2 * width + x2);
    while (head < tail) {
      const pixel = queue[head++];
      const offset = pixel * 4;
      const distance = Math.hypot(data[offset] - background.r, data[offset + 1] - background.g, data[offset + 2] - background.b);
      if (distance > tolerance) continue;
      data[offset + 3] = Math.round(data[offset + 3] * Math.max(0, Math.min(1, distance / tolerance)));
      const x2 = pixel % width;
      const y2 = Math.floor(pixel / width);
      if (x2 > 0) enqueue(pixel - 1);
      if (x2 + 1 < width) enqueue(pixel + 1);
      if (y2 > 0) enqueue(pixel - width);
      if (y2 + 1 < height) enqueue(pixel + width);
    }
    context.putImageData(imageData, 0, 0);
  }
  function hasVisiblePixels(context, width, height) {
    const stepX = Math.max(1, Math.floor(width / 96));
    const stepY = Math.max(1, Math.floor(height / 96));
    const pixels = context.getImageData(0, 0, width, height).data;
    let visible = 0;
    for (let y2 = 0; y2 < height; y2 += stepY) {
      for (let x2 = 0; x2 < width; x2 += stepX) {
        if (pixels[(y2 * width + x2) * 4 + 3] > 8) visible += 1;
        if (visible > 8) return true;
      }
    }
    return false;
  }
  function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("无法读取图片文件。"));
      reader.readAsDataURL(file);
    });
  }
  function loadImage(source, crossOrigin = false) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      if (crossOrigin && !String(source).startsWith("data:")) image.crossOrigin = "anonymous";
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("图片格式无效或已损坏。"));
      image.src = source;
    });
  }
  function parseJSONAttribute(value) {
    if (!value) return {};
    try {
      return JSON.parse(value);
    } catch {
      return {};
    }
  }
  function findTextPreset(id) {
    return TEXT_PRESETS.find((preset) => preset.id === id) || TEXT_PRESETS[0];
  }
  function findTextEffect(id) {
    return TEXT_EFFECTS.find((effect) => effect.id === id) || TEXT_EFFECTS[0];
  }
  function normalizeHexColor(value) {
    const raw = String(value || "").trim();
    const hex = raw.startsWith("#") ? raw : `#${raw}`;
    return /^#[0-9a-f]{6}$/i.test(hex) ? hex.toUpperCase() : "";
  }
  function escapeHTML(value = "") {
    return String(value).replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
  }
  if (!customElements.get("coloroutine-ai-studio")) {
    customElements.define("coloroutine-ai-studio", ColoroutineAIStudio);
  }
  if (!customElements.get("ai-design-studio")) {
    customElements.define("ai-design-studio", class extends ColoroutineAIStudio {
    });
  }
  exports.ColoroutineAIStudio = ColoroutineAIStudio;
  Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
  return exports;
})({});
//# sourceMappingURL=coloroutine-studio.js.map
